var _2 = Object.defineProperty;
var k2 = (t, e, i) => e in t ? _2(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i;
var ze = (t, e, i) => k2(t, typeof e != "symbol" ? e + "" : e, i);
import { createElementBlock as U, openBlock as k, defineComponent as qe, normalizeClass as we, createBlock as Ce, createCommentVNode as ie, createElementVNode as re, unref as Y, computed as J, resolveDynamicComponent as Ft, withCtx as De, renderSlot as Se, createTextVNode as Wi, toDisplayString as _e, mergeProps as Ut, createVNode as ke, Transition as Ri, ref as pe, watch as mt, Fragment as Xe, renderList as ut, withModifiers as $t, shallowRef as Tt, readonly as e0, onMounted as It, nextTick as li, toRef as Ha, customRef as P2, getCurrentScope as t0, onScopeDispose as i0, isRef as mr, toValue as kt, getCurrentInstance as Id, hasInjectionContext as n0, inject as s0, reactive as Jr, watchEffect as Vs, onUnmounted as Nn, Teleport as br, normalizeStyle as Nt, withDirectives as Ci, vModelText as Kn, useSlots as Yi, onBeforeUnmount as Ol, withKeys as Yu, vModelDynamic as I2, toRefs as jh, useCssVars as Md, createSlots as wi, TransitionGroup as r0, normalizeProps as _i, guardReactiveProps as ln, h as M2, render as $f, useAttrs as O2, onBeforeUpdate as B2, vShow as al, onBeforeMount as L2, provide as N2 } from "vue";
const We = (t, e) => {
  const i = t.__vccOpts || t;
  for (const [n, s] of e)
    i[n] = s;
  return i;
}, R2 = {}, F2 = { class: "icon-app-gallery color-icon" };
function z2(t, e) {
  return k(), U("span", F2);
}
const U2 = /* @__PURE__ */ We(R2, [["render", z2]]), V2 = {}, q2 = { class: "icon-app-store color-icon" };
function H2(t, e) {
  return k(), U("span", q2);
}
const W2 = /* @__PURE__ */ We(V2, [["render", H2]]), Y2 = {}, X2 = { class: "icon-google-play color-icon" };
function j2(t, e) {
  return k(), U("span", X2);
}
const G2 = /* @__PURE__ */ We(Y2, [["render", j2]]), Q2 = {}, Z2 = { class: "icon-ru-store color-icon" };
function K2(t, e) {
  return k(), U("span", Z2);
}
const J2 = /* @__PURE__ */ We(Q2, [["render", K2]]), $2 = {}, ex = { class: "icon icon-arrow_left-regular" };
function tx(t, e) {
  return k(), U("span", ex);
}
const Xu = /* @__PURE__ */ We($2, [["render", tx]]), ix = {}, nx = { class: "icon icon-arrow_right-regular" };
function sx(t, e) {
  return k(), U("span", nx);
}
const ju = /* @__PURE__ */ We(ix, [["render", sx]]), rx = {}, ax = { class: "icon icon-chevron_double_right-regular" };
function ox(t, e) {
  return k(), U("span", ax);
}
const lx = /* @__PURE__ */ We(rx, [["render", ox]]), ux = {}, dx = { class: "icon icon-chevron_down-regular" };
function cx(t, e) {
  return k(), U("span", dx);
}
const Od = /* @__PURE__ */ We(ux, [["render", cx]]), fx = {}, hx = { class: "icon icon-chevron_left-regular" };
function px(t, e) {
  return k(), U("span", hx);
}
const Bd = /* @__PURE__ */ We(fx, [["render", px]]), mx = {}, Ax = { class: "icon icon-chevron_right-regular" };
function gx(t, e) {
  return k(), U("span", Ax);
}
const Bl = /* @__PURE__ */ We(mx, [["render", gx]]), vx = {}, yx = { class: "icon icon-expand-regular" };
function bx(t, e) {
  return k(), U("span", yx);
}
const wx = /* @__PURE__ */ We(vx, [["render", bx]]), Tx = {}, xx = { class: "icon icon-refresh-regular" };
function Sx(t, e) {
  return k(), U("span", xx);
}
const Cx = /* @__PURE__ */ We(Tx, [["render", Sx]]), Ex = {}, Dx = { class: "icon icon-reply-regular" };
function _x(t, e) {
  return k(), U("span", Dx);
}
const a0 = /* @__PURE__ */ We(Ex, [["render", _x]]), kx = {}, Px = { class: "icon-kz country-icon" };
function Ix(t, e) {
  return k(), U("span", Px);
}
const Mx = /* @__PURE__ */ We(kx, [["render", Ix]]), Ox = {}, Bx = { class: "icon-md country-icon" };
function Lx(t, e) {
  return k(), U("span", Bx);
}
const Nx = /* @__PURE__ */ We(Ox, [["render", Lx]]), Rx = {}, Fx = { class: "icon-ru country-icon" };
function zx(t, e) {
  return k(), U("span", Fx);
}
const Ux = /* @__PURE__ */ We(Rx, [["render", zx]]), Vx = {}, qx = { class: "icon icon-calendar_today-regular" };
function Hx(t, e) {
  return k(), U("span", qx);
}
const eh = /* @__PURE__ */ We(Vx, [["render", Hx]]), Wx = {}, Yx = { class: "icon icon-user-regular" };
function Xx(t, e) {
  return k(), U("span", Yx);
}
const jx = /* @__PURE__ */ We(Wx, [["render", Xx]]), Gx = {}, Qx = { class: "icon icon-cloud_upload-fill" };
function Zx(t, e) {
  return k(), U("span", Qx);
}
const Kx = /* @__PURE__ */ We(Gx, [["render", Zx]]), Jx = {}, $x = { class: "icon icon-file-regular" };
function eS(t, e) {
  return k(), U("span", $x);
}
const th = /* @__PURE__ */ We(Jx, [["render", eS]]), tS = {}, iS = { class: "icon icon-file-thin" };
function nS(t, e) {
  return k(), U("span", iS);
}
const cA = /* @__PURE__ */ We(tS, [["render", nS]]), sS = {}, rS = { class: "icon icon-download-regular" };
function aS(t, e) {
  return k(), U("span", rS);
}
const o0 = /* @__PURE__ */ We(sS, [["render", aS]]), oS = {}, lS = { class: "icon icon-upload-regular" };
function uS(t, e) {
  return k(), U("span", lS);
}
const dS = /* @__PURE__ */ We(oS, [["render", uS]]), cS = {}, fS = { class: "icon icon-close-regular" };
function hS(t, e) {
  return k(), U("span", fS);
}
const na = /* @__PURE__ */ We(cS, [["render", hS]]), pS = {}, mS = { class: "icon icon-circle_close-fill" };
function AS(t, e) {
  return k(), U("span", mS);
}
const po = /* @__PURE__ */ We(pS, [["render", AS]]), gS = {}, vS = { class: "icon icon-circle_info-fill" };
function yS(t, e) {
  return k(), U("span", vS);
}
const is = /* @__PURE__ */ We(gS, [["render", yS]]), bS = {}, wS = { class: "icon icon-circle_info-regular" };
function TS(t, e) {
  return k(), U("span", wS);
}
const fA = /* @__PURE__ */ We(bS, [["render", TS]]), xS = {}, SS = { class: "icon icon-circle_error-fill" };
function CS(t, e) {
  return k(), U("span", SS);
}
const ES = /* @__PURE__ */ We(xS, [["render", CS]]), DS = {}, _S = { class: "icon icon-circle_done-fill" };
function kS(t, e) {
  return k(), U("span", _S);
}
const l0 = /* @__PURE__ */ We(DS, [["render", kS]]), PS = {}, IS = { class: "icon icon-done-regular" };
function MS(t, e) {
  return k(), U("span", IS);
}
const hA = /* @__PURE__ */ We(PS, [["render", MS]]), OS = {}, BS = { class: "icon icon-subtract-regular" };
function LS(t, e) {
  return k(), U("span", BS);
}
const u0 = /* @__PURE__ */ We(OS, [["render", LS]]), NS = {}, RS = { class: "icon icon-add-regular" };
function FS(t, e) {
  return k(), U("span", RS);
}
const zS = /* @__PURE__ */ We(NS, [["render", FS]]), US = {}, VS = { class: "icon icon-warning-fill" };
function qS(t, e) {
  return k(), U("span", VS);
}
const d0 = /* @__PURE__ */ We(US, [["render", qS]]), HS = {}, WS = { class: "icon icon-hide_2-regular" };
function YS(t, e) {
  return k(), U("span", WS);
}
const XS = /* @__PURE__ */ We(HS, [["render", YS]]), jS = {}, GS = { class: "icon icon-search-regular" };
function QS(t, e) {
  return k(), U("span", GS);
}
const ZS = /* @__PURE__ */ We(jS, [["render", QS]]), KS = {}, JS = { class: "icon icon-show-regular" };
function $S(t, e) {
  return k(), U("span", JS);
}
const eC = /* @__PURE__ */ We(KS, [["render", $S]]), tC = {}, iC = { class: "icon icon-play-fill" };
function nC(t, e) {
  return k(), U("span", iC);
}
const sC = /* @__PURE__ */ We(tC, [["render", nC]]), rC = {}, aC = { class: "icon icon-camera-fill" };
function oC(t, e) {
  return k(), U("span", aC);
}
const lC = /* @__PURE__ */ We(rC, [["render", oC]]), uC = {}, dC = { class: "type-file-icon icon-image-jpg-regular" };
function cC(t, e) {
  return k(), U("span", dC);
}
const fC = /* @__PURE__ */ We(uC, [["render", cC]]), hC = {}, pC = { class: "type-file-icon icon-image-jpg-thin" };
function mC(t, e) {
  return k(), U("span", pC);
}
const pA = /* @__PURE__ */ We(hC, [["render", mC]]), AC = {}, gC = { class: "type-file-icon icon-archive-zip-regular" };
function vC(t, e) {
  return k(), U("span", gC);
}
const yC = /* @__PURE__ */ We(AC, [["render", vC]]), bC = {}, wC = { class: "type-file-icon icon-archive-zip-thin" };
function TC(t, e) {
  return k(), U("span", wC);
}
const xC = /* @__PURE__ */ We(bC, [["render", TC]]), SC = {}, CC = { class: "type-file-icon icon-archive-rar-regular" };
function EC(t, e) {
  return k(), U("span", CC);
}
const DC = /* @__PURE__ */ We(SC, [["render", EC]]), _C = {}, kC = { class: "type-file-icon icon-archive-rar-thin" };
function PC(t, e) {
  return k(), U("span", kC);
}
const IC = /* @__PURE__ */ We(_C, [["render", PC]]), MC = {}, OC = { class: "type-file-icon icon-image-png-regular" };
function BC(t, e) {
  return k(), U("span", OC);
}
const LC = /* @__PURE__ */ We(MC, [["render", BC]]), NC = {}, RC = { class: "type-file-icon icon-image-png-thin" };
function FC(t, e) {
  return k(), U("span", RC);
}
const zC = /* @__PURE__ */ We(NC, [["render", FC]]), UC = {}, VC = { class: "type-file-icon icon-image-gif-regular" };
function qC(t, e) {
  return k(), U("span", VC);
}
const HC = /* @__PURE__ */ We(UC, [["render", qC]]), WC = {}, YC = { class: "type-file-icon icon-image-gif-thin" };
function XC(t, e) {
  return k(), U("span", YC);
}
const jC = /* @__PURE__ */ We(WC, [["render", XC]]), GC = {}, QC = { class: "type-file-icon icon-image-svg-regular" };
function ZC(t, e) {
  return k(), U("span", QC);
}
const KC = /* @__PURE__ */ We(GC, [["render", ZC]]), JC = {}, $C = { class: "type-file-icon icon-image-svg-thin" };
function eE(t, e) {
  return k(), U("span", $C);
}
const tE = /* @__PURE__ */ We(JC, [["render", eE]]), iE = {}, nE = { class: "type-file-icon icon-image-img-regular" };
function sE(t, e) {
  return k(), U("span", nE);
}
const rE = /* @__PURE__ */ We(iE, [["render", sE]]), aE = {}, oE = { class: "type-file-icon icon-image-img-thin" };
function lE(t, e) {
  return k(), U("span", oE);
}
const uE = /* @__PURE__ */ We(aE, [["render", lE]]), dE = {}, cE = { class: "type-file-icon icon-media-avi-regular" };
function fE(t, e) {
  return k(), U("span", cE);
}
const hE = /* @__PURE__ */ We(dE, [["render", fE]]), pE = {}, mE = { class: "type-file-icon icon-media-wav-thin" };
function AE(t, e) {
  return k(), U("span", mE);
}
const gE = /* @__PURE__ */ We(pE, [["render", AE]]), vE = {}, yE = { class: "type-file-icon icon-media-wav-regular" };
function bE(t, e) {
  return k(), U("span", yE);
}
const wE = /* @__PURE__ */ We(vE, [["render", bE]]), TE = {}, xE = { class: "type-file-icon icon-media-wav-thin" };
function SE(t, e) {
  return k(), U("span", xE);
}
const CE = /* @__PURE__ */ We(TE, [["render", SE]]), EE = {}, DE = { class: "type-file-icon icon-media-mp4-regular" };
function _E(t, e) {
  return k(), U("span", DE);
}
const kE = /* @__PURE__ */ We(EE, [["render", _E]]), PE = {}, IE = { class: "type-file-icon icon-media-wav-thin" };
function ME(t, e) {
  return k(), U("span", IE);
}
const OE = /* @__PURE__ */ We(PE, [["render", ME]]), BE = {}, LE = { class: "type-file-icon icon-media-mp3-regular" };
function NE(t, e) {
  return k(), U("span", LE);
}
const RE = /* @__PURE__ */ We(BE, [["render", NE]]), FE = {}, zE = { class: "type-file-icon icon-media-wav-thin" };
function UE(t, e) {
  return k(), U("span", zE);
}
const VE = /* @__PURE__ */ We(FE, [["render", UE]]), qE = {}, HE = { class: "type-file-icon icon-document-pptx-regular" };
function WE(t, e) {
  return k(), U("span", HE);
}
const YE = /* @__PURE__ */ We(qE, [["render", WE]]), XE = {}, jE = { class: "type-file-icon icon-document-pptx-thin" };
function GE(t, e) {
  return k(), U("span", jE);
}
const QE = /* @__PURE__ */ We(XE, [["render", GE]]), ZE = {}, KE = { class: "type-file-icon icon-document-ppt-regular" };
function JE(t, e) {
  return k(), U("span", KE);
}
const $E = /* @__PURE__ */ We(ZE, [["render", JE]]), eD = {}, tD = { class: "type-file-icon icon-document-ppt-thin" };
function iD(t, e) {
  return k(), U("span", tD);
}
const nD = /* @__PURE__ */ We(eD, [["render", iD]]), sD = {}, rD = { class: "type-file-icon icon-document-xlsx-regular" };
function aD(t, e) {
  return k(), U("span", rD);
}
const oD = /* @__PURE__ */ We(sD, [["render", aD]]), lD = {}, uD = { class: "type-file-icon icon-document-xlsx-thin" };
function dD(t, e) {
  return k(), U("span", uD);
}
const cD = /* @__PURE__ */ We(lD, [["render", dD]]), fD = {}, hD = { class: "type-file-icon icon-document-xls-regular" };
function pD(t, e) {
  return k(), U("span", hD);
}
const mD = /* @__PURE__ */ We(fD, [["render", pD]]), AD = {}, gD = { class: "type-file-icon icon-document-xls-thin" };
function vD(t, e) {
  return k(), U("span", gD);
}
const yD = /* @__PURE__ */ We(AD, [["render", vD]]), bD = {}, wD = { class: "type-file-icon icon-document-csv-regular" };
function TD(t, e) {
  return k(), U("span", wD);
}
const xD = /* @__PURE__ */ We(bD, [["render", TD]]), SD = {}, CD = { class: "type-file-icon icon-document-csv-thin" };
function ED(t, e) {
  return k(), U("span", CD);
}
const DD = /* @__PURE__ */ We(SD, [["render", ED]]), _D = {}, kD = { class: "type-file-icon icon-document-txt-regular" };
function PD(t, e) {
  return k(), U("span", kD);
}
const ID = /* @__PURE__ */ We(_D, [["render", PD]]), MD = {}, OD = { class: "type-file-icon icon-document-txt-thin" };
function BD(t, e) {
  return k(), U("span", OD);
}
const LD = /* @__PURE__ */ We(MD, [["render", BD]]), ND = {}, RD = { class: "type-file-icon icon-document-docx-regular" };
function FD(t, e) {
  return k(), U("span", RD);
}
const zD = /* @__PURE__ */ We(ND, [["render", FD]]), UD = {}, VD = { class: "type-file-icon icon-document-docx-thin" };
function qD(t, e) {
  return k(), U("span", VD);
}
const HD = /* @__PURE__ */ We(UD, [["render", qD]]), WD = {}, YD = { class: "type-file-icon icon-document-doc-regular" };
function XD(t, e) {
  return k(), U("span", YD);
}
const jD = /* @__PURE__ */ We(WD, [["render", XD]]), GD = {}, QD = { class: "type-file-icon icon-document-doc-thin" };
function ZD(t, e) {
  return k(), U("span", QD);
}
const KD = /* @__PURE__ */ We(GD, [["render", ZD]]), JD = {}, $D = { class: "type-file-icon icon-document-pdf-regular" };
function e_(t, e) {
  return k(), U("span", $D);
}
const t_ = /* @__PURE__ */ We(JD, [["render", e_]]), i_ = {}, n_ = { class: "type-file-icon icon-document-pdf-thin" };
function s_(t, e) {
  return k(), U("span", n_);
}
const r_ = /* @__PURE__ */ We(i_, [["render", s_]]), a_ = {}, o_ = { class: "icon icon-check-indicator-regular" };
function l_(t, e) {
  return k(), U("span", o_);
}
const Gh = /* @__PURE__ */ We(a_, [["render", l_]]), u_ = ["href", "data-test-id"], d_ = /* @__PURE__ */ qe({
  name: "UiAppButton",
  __name: "UiAppButton",
  props: {
    color: {
      type: String,
      default: "light"
    },
    language: {
      type: String,
      default: "ru"
    },
    store: {
      type: String,
      default: "android"
    },
    size: {
      type: String,
      default: "large"
    },
    link: {
      type: String,
      required: !0
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (e, i) => (k(), U("a", {
      href: t.link,
      target: "_blank",
      class: we(["ui-app-button", [
        `ui-app-button_${t.color}
       ui-app-button_${t.size}`
      ]]),
      "data-test-id": t.dataTestId
    }, [
      t.store === "android" ? (k(), Ce(Y(G2), { key: 0 })) : ie("", !0),
      t.store === "ios" ? (k(), Ce(Y(W2), { key: 1 })) : ie("", !0),
      t.store === "app-gallery" ? (k(), Ce(Y(U2), { key: 2 })) : ie("", !0),
      t.store === "ru-store" ? (k(), Ce(Y(J2), { key: 3 })) : ie("", !0),
      re("span", {
        class: we(`icon_${t.store}_${t.language}_${t.color}`)
      }, null, 2)
    ], 10, u_));
  }
}), tt = (t, e) => {
  const i = t.__vccOpts || t;
  for (const [n, s] of e)
    i[n] = s;
  return i;
}, Iq = /* @__PURE__ */ tt(d_, [["__scopeId", "data-v-24744973"]]), c_ = /* @__PURE__ */ qe({
  name: "UiBadge",
  __name: "UiBadge",
  props: {
    color: {
      type: String,
      default: "yellow"
    },
    type: {
      type: String,
      default: "bright"
    },
    label: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "l"
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    to: {
      type: Object,
      default: null
    }
  },
  setup(t) {
    const e = t, i = J(() => e.size === "xs"), n = J(() => {
      if (!i.value) {
        if (e.clickable)
          return "button";
        if (e.to)
          return "router-link";
      }
      return "span";
    });
    return (s, r) => (k(), Ce(Ft(n.value), {
      type: "button",
      class: we(["ui-badge", [
        `ui-badge_${t.type}`,
        `ui-badge_${t.type}_${t.color}`,
        `ui-badge_size_${t.size}`,
        { "ui-badge_clickable": t.clickable }
      ]]),
      to: t.to
    }, {
      default: De(() => [
        t.size !== "xs" ? Se(s.$slots, "default", { key: 0 }, void 0, !0) : ie("", !0),
        Wi(" " + _e(t.label) + " ", 1),
        t.clickable && !i.value ? (k(), Ce(Y(Bl), {
          key: 1,
          class: "arrow"
        })) : ie("", !0)
      ]),
      _: 3
    }, 8, ["class", "to"]));
  }
}), f_ = /* @__PURE__ */ tt(c_, [["__scopeId", "data-v-1bf4b70f"]]), h_ = { class: "ui-button__label" }, p_ = {
  key: 0,
  class: "ui-button__icon-loading icon-loader"
}, m_ = /* @__PURE__ */ qe({
  name: "UiButton",
  __name: "UiButton",
  props: {
    color: {
      type: String,
      default: "accent"
    },
    label: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "button"
    },
    size: {
      type: String,
      default: "m"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      default: ""
    },
    to: {
      type: Object,
      default: null
    },
    target: {
      type: String,
      default: ""
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, i = J(() => e.href && !e.to ? "a" : !e.href && e.to ? "router-link" : "button"), n = J(() => ({
      ...i.value === "button" && {
        type: e.type,
        disabled: e.disabled || e.loading
      },
      ...i.value !== "button" && {
        target: e.target
      },
      ...i.value === "router-link" && {
        to: e.to
      },
      ...i.value === "a" && {
        href: e.href
      }
    }));
    return (s, r) => (k(), Ce(Ft(i.value), Ut({
      class: ["ui-button", [
        `ui-button_color_${t.color}`,
        `ui-button_size_${t.size}`,
        {
          "ui-button_loading": t.loading
        },
        {
          "ui-button_full-width": t.fullWidth
        }
      ]],
      "data-test-id": t.dataTestId
    }, n.value), {
      default: De(() => [
        Se(s.$slots, "default", {}, void 0, !0),
        re("span", h_, _e(t.label), 1),
        t.loading ? (k(), U("span", p_)) : ie("", !0)
      ]),
      _: 3
    }, 16, ["class", "data-test-id"]));
  }
}), $r = /* @__PURE__ */ tt(m_, [["__scopeId", "data-v-dba149f1"]]), A_ = ["checked", "disabled", "value", "data-test-id"], g_ = {
  key: 0,
  class: "ui-checkbox__label-text"
}, v_ = {
  key: 0,
  class: "label__counter"
}, y_ = {
  key: 0,
  class: "ui-checkbox__error-message"
}, b_ = /* @__PURE__ */ qe({
  name: "UiCheckbox",
  __name: "UiCheckbox",
  props: {
    label: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    value: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [Boolean, Array],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    },
    counter: {
      type: [Number, null],
      default: null
    },
    isIndeterminateState: {
      type: Boolean,
      default: !1
    },
    isLonely: {
      type: Boolean,
      default: !0
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e;
    function s(o) {
      if (typeof i.modelValue == "boolean")
        n("update:modelValue", o);
      else {
        const l = new Set(i.modelValue);
        o ? l.add(i.value) : l.delete(i.value), n("update:modelValue", Array.from(l));
      }
    }
    const r = J({
      get() {
        return typeof i.modelValue == "boolean" ? i.modelValue : i.modelValue.includes(i.value);
      },
      set(o) {
        typeof i.modelValue == "boolean" ? n("update:modelValue", o) : s(o);
      }
    }), a = (o) => {
      const l = o.target;
      s(l.checked);
    };
    return (o, l) => (k(), U("div", {
      class: we(["ui-checkbox", `ui-checkbox_size_${t.size}`])
    }, [
      re("label", {
        class: we(["ui-checkbox__label label", [
          {
            label_disabled: t.disabled,
            label_error: t.error || t.errorMessage,
            label_multiple: t.isIndeterminateState
          }
        ]])
      }, [
        re("input", {
          type: "checkbox",
          checked: r.value,
          disabled: t.disabled,
          value: t.value,
          "data-test-id": t.dataTestId,
          onChange: a
        }, null, 40, A_),
        l[0] || (l[0] = re("span", null, null, -1)),
        ke(Ri, { name: "checkmark" }, {
          default: De(() => [
            r.value ? (k(), Ce(Y(Gh), {
              key: 0,
              class: "done"
            })) : ie("", !0)
          ]),
          _: 1
        }),
        ke(Ri, { name: "checkmark" }, {
          default: De(() => [
            t.isIndeterminateState ? (k(), Ce(Y(u0), {
              key: 0,
              class: "done"
            })) : ie("", !0)
          ]),
          _: 1
        }),
        Se(o.$slots, "default", {}, () => [
          t.label ? (k(), U("span", g_, _e(t.label), 1)) : ie("", !0)
        ], !0),
        typeof t.counter == "number" ? (k(), U("span", v_, _e(t.counter), 1)) : ie("", !0)
      ], 2),
      t.errorMessage && t.isLonely ? (k(), U("p", y_, _e(t.errorMessage), 1)) : ie("", !0)
    ], 2));
  }
}), mA = /* @__PURE__ */ tt(b_, [["__scopeId", "data-v-cc04e933"]]), w_ = { class: "ui-checkbox__multiple multiple" }, T_ = {
  key: 0,
  class: "ui-checkbox__error-message"
}, x_ = /* @__PURE__ */ qe({
  name: "UiMultipleCheckbox",
  __name: "UiMultipleCheckbox",
  props: {
    label: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    },
    counter: {
      type: [Number, null],
      default: null
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = J({
      get: () => i.modelValue,
      set: (d) => n("update:modelValue", d)
    }), r = pe(!1), a = J(() => s.value.every((d) => d.isChecked)), o = J(() => s.value.filter((d) => d.isChecked)), l = J(
      () => o.value.length === s.value.length
    ), u = J(() => l.value && o.value ? !1 : !!o.value.length);
    return mt(
      s,
      () => {
        r.value = a.value;
      },
      {
        deep: !0,
        immediate: !0
      }
    ), mt(r, () => {
      r.value && s.value.map((d) => d.isChecked = !0), !r.value && l.value && s.value.map((d) => d.isChecked = !1);
    }), (d, c) => (k(), U("div", {
      class: we(["ui-checkbox", `ui-checkbox_size_${t.size}`])
    }, [
      ke(mA, {
        modelValue: r.value,
        "onUpdate:modelValue": c[0] || (c[0] = (A) => r.value = A),
        "is-indeterminate-state": u.value,
        size: t.size,
        "data-test-id": t.dataTestId,
        disabled: t.disabled,
        error: t.error,
        "error-message": t.errorMessage,
        "is-lonely": !1,
        counter: t.counter,
        label: t.label
      }, null, 8, ["modelValue", "is-indeterminate-state", "size", "data-test-id", "disabled", "error", "error-message", "counter", "label"]),
      re("div", w_, [
        (k(!0), U(Xe, null, ut(t.modelValue, (A, m) => (k(), Ce(mA, {
          key: m,
          modelValue: A.isChecked,
          "onUpdate:modelValue": (p) => A.isChecked = p,
          label: A.label,
          size: t.size,
          disabled: t.disabled,
          error: t.error,
          "error-message": t.errorMessage,
          "is-lonely": !1
        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "size", "disabled", "error", "error-message"]))), 128))
      ]),
      t.errorMessage ? (k(), U("p", T_, _e(t.errorMessage), 1)) : ie("", !0)
    ], 2));
  }
}), Mq = /* @__PURE__ */ tt(x_, [["__scopeId", "data-v-e8394202"]]), S_ = { class: "label" }, C_ = /* @__PURE__ */ qe({
  __name: "UiChip",
  props: {
    label: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "l"
    },
    isClosed: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "stroke"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  emits: ["remove", "select"],
  setup(t, { emit: e }) {
    const i = t, n = e;
    qe({
      name: "UiChip"
    });
    const s = J(() => ({
      ...!i.isClosed && {
        type: "button"
      }
    }));
    return (r, a) => (k(), Ce(Ft(t.isClosed ? "div" : "button"), Ut({ class: "ui-chip" }, s.value, {
      "data-test-id": t.dataTestId,
      class: [
        `ui-chip_${t.variant}`,
        `ui-chip_size_${t.size}`,
        {
          "ui-chip_closed": t.isClosed,
          "ui-chip_active": t.active
        }
      ],
      disabled: t.disabled,
      onClick: a[1] || (a[1] = (o) => n("select"))
    }), {
      default: De(() => [
        Se(r.$slots, "default", {}, void 0, !0),
        re("span", S_, _e(t.label), 1),
        t.active && t.isClosed ? (k(), U("button", {
          key: 0,
          type: "button",
          onClick: a[0] || (a[0] = $t((o) => n("remove"), ["stop"]))
        }, [
          ke(Y(po))
        ])) : ie("", !0)
      ]),
      _: 3
    }, 16, ["data-test-id", "class", "disabled"]));
  }
}), c0 = /* @__PURE__ */ tt(C_, [["__scopeId", "data-v-3cb4aa76"]]);
function sa(t) {
  return t0() ? (i0(t), !0) : !1;
}
const Bc = /* @__PURE__ */ new WeakMap(), E_ = (...t) => {
  var e;
  const i = t[0], n = (e = Id()) == null ? void 0 : e.proxy;
  if (n == null && !n0())
    throw new Error("injectLocal must be called in setup");
  return n && Bc.has(n) && i in Bc.get(n) ? Bc.get(n)[i] : s0(...t);
}, Ll = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const D_ = Object.prototype.toString, f0 = (t) => D_.call(t) === "[object Object]", Li = () => {
}, Wa = /* @__PURE__ */ __();
function __() {
  var t, e;
  return Ll && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function h0(t, e) {
  function i(...n) {
    return new Promise((s, r) => {
      Promise.resolve(t(() => e.apply(this, n), { fn: e, thisArg: this, args: n })).then(s).catch(r);
    });
  }
  return i;
}
function k_(t, e = {}) {
  let i, n, s = Li;
  const r = (l) => {
    clearTimeout(l), s(), s = Li;
  };
  let a;
  return (l) => {
    const u = kt(t), d = kt(e.maxWait);
    return i && r(i), u <= 0 || d !== void 0 && d <= 0 ? (n && (r(n), n = null), Promise.resolve(l())) : new Promise((c, A) => {
      s = e.rejectOnCancel ? A : c, a = l, d && !n && (n = setTimeout(() => {
        i && r(i), n = null, c(a());
      }, d)), i = setTimeout(() => {
        n && r(n), n = null, c(l());
      }, u);
    });
  };
}
function P_(...t) {
  let e = 0, i, n = !0, s = Li, r, a, o, l, u;
  !mr(t[0]) && typeof t[0] == "object" ? { delay: a, trailing: o = !0, leading: l = !0, rejectOnCancel: u = !1 } = t[0] : [a, o = !0, l = !0, u = !1] = t;
  const d = () => {
    i && (clearTimeout(i), i = void 0, s(), s = Li);
  };
  return (A) => {
    const m = kt(a), p = Date.now() - e, h = () => r = A();
    return d(), m <= 0 ? (e = Date.now(), h()) : (p > m && (l || !n) ? (e = Date.now(), h()) : o && (r = new Promise((g, w) => {
      s = u ? w : g, i = setTimeout(() => {
        e = Date.now(), n = !0, g(h()), d();
      }, Math.max(0, m - p));
    })), !l && !i && (i = setTimeout(() => n = !0, m)), n = !1, r);
  };
}
function AA(t) {
  return t.endsWith("rem") ? Number.parseFloat(t) * 16 : Number.parseFloat(t);
}
function I_(t) {
  return Id();
}
function Hr(t) {
  return Array.isArray(t) ? t : [t];
}
function p0(...t) {
  if (t.length !== 1)
    return Ha(...t);
  const e = t[0];
  return typeof e == "function" ? e0(P2(() => ({ get: e, set: Li }))) : pe(e);
}
function M_(t, e = 200, i = {}) {
  return h0(
    k_(e, i),
    t
  );
}
function O_(t, e = 200, i = !1, n = !0, s = !1) {
  return h0(
    P_(e, i, n, s),
    t
  );
}
function Qh(t, e = !0, i) {
  I_() ? It(t, i) : e ? t() : li(t);
}
function B_(t, e, i = {}) {
  const {
    immediate: n = !0,
    immediateCallback: s = !1
  } = i, r = Tt(!1);
  let a = null;
  function o() {
    a && (clearTimeout(a), a = null);
  }
  function l() {
    r.value = !1, o();
  }
  function u(...d) {
    s && t(), o(), r.value = !0, a = setTimeout(() => {
      r.value = !1, a = null, t(...d);
    }, kt(e));
  }
  return n && (r.value = !0, Ll && u()), sa(l), {
    isPending: e0(r),
    start: u,
    stop: l
  };
}
function m0(t, e, i) {
  return mt(
    t,
    e,
    {
      ...i,
      immediate: !0
    }
  );
}
const wr = Ll ? window : void 0, L_ = Ll ? window.document : void 0;
function vn(t) {
  var e;
  const i = kt(t);
  return (e = i == null ? void 0 : i.$el) != null ? e : i;
}
function Ei(...t) {
  const e = [], i = () => {
    e.forEach((o) => o()), e.length = 0;
  }, n = (o, l, u, d) => (o.addEventListener(l, u, d), () => o.removeEventListener(l, u, d)), s = J(() => {
    const o = Hr(kt(t[0])).filter((l) => l != null);
    return o.every((l) => typeof l != "string") ? o : void 0;
  }), r = m0(
    () => {
      var o, l;
      return [
        (l = (o = s.value) == null ? void 0 : o.map((u) => vn(u))) != null ? l : [wr].filter((u) => u != null),
        Hr(kt(s.value ? t[1] : t[0])),
        Hr(Y(s.value ? t[2] : t[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        kt(s.value ? t[3] : t[2])
      ];
    },
    ([o, l, u, d]) => {
      if (i(), !(o != null && o.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const c = f0(d) ? { ...d } : d;
      e.push(
        ...o.flatMap(
          (A) => l.flatMap(
            (m) => u.map((p) => n(A, m, p, c))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    r(), i();
  };
  return sa(i), a;
}
let gA = !1;
function N_(t, e, i = {}) {
  const { window: n = wr, ignore: s = [], capture: r = !0, detectIframe: a = !1, controls: o = !1 } = i;
  if (!n)
    return o ? { stop: Li, cancel: Li, trigger: Li } : Li;
  if (Wa && !gA) {
    gA = !0;
    const g = { passive: !0 };
    Array.from(n.document.body.children).forEach((w) => Ei(w, "click", Li, g)), Ei(n.document.documentElement, "click", Li, g);
  }
  let l = !0;
  const u = (g) => kt(s).some((w) => {
    if (typeof w == "string")
      return Array.from(n.document.querySelectorAll(w)).some((b) => b === g.target || g.composedPath().includes(b));
    {
      const b = vn(w);
      return b && (g.target === b || g.composedPath().includes(b));
    }
  });
  function d(g) {
    const w = kt(g);
    return w && w.$.subTree.shapeFlag === 16;
  }
  function c(g, w) {
    const b = kt(g), y = b.$.subTree && b.$.subTree.children;
    return y == null || !Array.isArray(y) ? !1 : y.some((D) => D.el === w.target || w.composedPath().includes(D.el));
  }
  const A = (g) => {
    const w = vn(t);
    if (g.target != null && !(!(w instanceof Element) && d(t) && c(t, g)) && !(!w || w === g.target || g.composedPath().includes(w))) {
      if ("detail" in g && g.detail === 0 && (l = !u(g)), !l) {
        l = !0;
        return;
      }
      e(g);
    }
  };
  let m = !1;
  const p = [
    Ei(n, "click", (g) => {
      m || (m = !0, setTimeout(() => {
        m = !1;
      }, 0), A(g));
    }, { passive: !0, capture: r }),
    Ei(n, "pointerdown", (g) => {
      const w = vn(t);
      l = !u(g) && !!(w && !g.composedPath().includes(w));
    }, { passive: !0 }),
    a && Ei(n, "blur", (g) => {
      setTimeout(() => {
        var w;
        const b = vn(t);
        ((w = n.document.activeElement) == null ? void 0 : w.tagName) === "IFRAME" && !(b != null && b.contains(n.document.activeElement)) && e(g);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), h = () => p.forEach((g) => g());
  return o ? {
    stop: h,
    cancel: () => {
      l = !1;
    },
    trigger: (g) => {
      l = !0, A(g), l = !1;
    }
  } : h;
}
function R_() {
  const t = Tt(!1), e = Id();
  return e && It(() => {
    t.value = !0;
  }, e), t;
}
function A0(t) {
  const e = R_();
  return J(() => (e.value, !!t()));
}
const F_ = Symbol("vueuse-ssr-width");
function z_() {
  const t = n0() ? E_(F_, null) : null;
  return typeof t == "number" ? t : void 0;
}
function U_(t, e = {}) {
  const { window: i = wr, ssrWidth: n = z_() } = e, s = A0(() => i && "matchMedia" in i && typeof i.matchMedia == "function"), r = Tt(typeof n == "number"), a = Tt(), o = Tt(!1), l = (u) => {
    o.value = u.matches;
  };
  return Vs(() => {
    if (r.value) {
      r.value = !s.value;
      const u = kt(t).split(",");
      o.value = u.some((d) => {
        const c = d.includes("not all"), A = d.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), m = d.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let p = !!(A || m);
        return A && p && (p = n >= AA(A[1])), m && p && (p = n <= AA(m[1])), c ? !p : p;
      });
      return;
    }
    s.value && (a.value = i.matchMedia(kt(t)), o.value = a.value.matches);
  }), Ei(a, "change", l, { passive: !0 }), J(() => o.value);
}
function V_(t, e, i = {}) {
  const { window: n = wr, ...s } = i;
  let r;
  const a = A0(() => n && "ResizeObserver" in n), o = () => {
    r && (r.disconnect(), r = void 0);
  }, l = J(() => {
    const c = kt(t);
    return Array.isArray(c) ? c.map((A) => vn(A)) : [vn(c)];
  }), u = mt(
    l,
    (c) => {
      if (o(), a.value && n) {
        r = new ResizeObserver(e);
        for (const A of c)
          A && r.observe(A, s);
      }
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    o(), u();
  };
  return sa(d), {
    isSupported: a,
    stop: d
  };
}
function q_(t, e = { width: 0, height: 0 }, i = {}) {
  const { window: n = wr, box: s = "content-box" } = i, r = J(() => {
    var c, A;
    return (A = (c = vn(t)) == null ? void 0 : c.namespaceURI) == null ? void 0 : A.includes("svg");
  }), a = Tt(e.width), o = Tt(e.height), { stop: l } = V_(
    t,
    ([c]) => {
      const A = s === "border-box" ? c.borderBoxSize : s === "content-box" ? c.contentBoxSize : c.devicePixelContentBoxSize;
      if (n && r.value) {
        const m = vn(t);
        if (m) {
          const p = m.getBoundingClientRect();
          a.value = p.width, o.value = p.height;
        }
      } else if (A) {
        const m = Hr(A);
        a.value = m.reduce((p, { inlineSize: h }) => p + h, 0), o.value = m.reduce((p, { blockSize: h }) => p + h, 0);
      } else
        a.value = c.contentRect.width, o.value = c.contentRect.height;
    },
    i
  );
  Qh(() => {
    const c = vn(t);
    c && (a.value = "offsetWidth" in c ? c.offsetWidth : e.width, o.value = "offsetHeight" in c ? c.offsetHeight : e.height);
  });
  const u = mt(
    () => vn(t),
    (c) => {
      a.value = c ? e.width : 0, o.value = c ? e.height : 0;
    }
  );
  function d() {
    l(), u();
  }
  return {
    width: a,
    height: o,
    stop: d
  };
}
function Lc(t) {
  return typeof Window < "u" && t instanceof Window ? t.document.documentElement : typeof Document < "u" && t instanceof Document ? t.documentElement : t;
}
const H_ = {
  page: (t) => [t.pageX, t.pageY],
  client: (t) => [t.clientX, t.clientY],
  screen: (t) => [t.screenX, t.screenY],
  movement: (t) => t instanceof MouseEvent ? [t.movementX, t.movementY] : null
};
function W_(t = {}) {
  const {
    type: e = "page",
    touch: i = !0,
    resetOnTouchEnds: n = !1,
    initialValue: s = { x: 0, y: 0 },
    window: r = wr,
    target: a = r,
    scroll: o = !0,
    eventFilter: l
  } = t;
  let u = null, d = 0, c = 0;
  const A = Tt(s.x), m = Tt(s.y), p = Tt(null), h = typeof e == "function" ? e : H_[e], g = (_) => {
    const N = h(_);
    u = _, N && ([A.value, m.value] = N, p.value = "mouse"), r && (d = r.scrollX, c = r.scrollY);
  }, w = (_) => {
    if (_.touches.length > 0) {
      const N = h(_.touches[0]);
      N && ([A.value, m.value] = N, p.value = "touch");
    }
  }, b = () => {
    if (!u || !r)
      return;
    const _ = h(u);
    u instanceof MouseEvent && _ && (A.value = _[0] + r.scrollX - d, m.value = _[1] + r.scrollY - c);
  }, y = () => {
    A.value = s.x, m.value = s.y;
  }, D = l ? (_) => l(() => g(_), {}) : (_) => g(_), I = l ? (_) => l(() => w(_), {}) : (_) => w(_), M = l ? () => l(() => b(), {}) : () => b();
  if (a) {
    const _ = { passive: !0 };
    Ei(a, ["mousemove", "dragover"], D, _), i && e !== "movement" && (Ei(a, ["touchstart", "touchmove"], I, _), n && Ei(a, "touchend", y, _)), o && e === "page" && Ei(r, "scroll", M, _);
  }
  return {
    x: A,
    y: m,
    sourceType: p
  };
}
function Y_(t, e = {}) {
  const {
    handleOutside: i = !0,
    window: n = wr
  } = e, s = e.type || "page", { x: r, y: a, sourceType: o } = W_(e), l = Tt(t ?? (n == null ? void 0 : n.document.body)), u = Tt(0), d = Tt(0), c = Tt(0), A = Tt(0), m = Tt(0), p = Tt(0), h = Tt(!0);
  let g = () => {
  };
  return n && (g = mt(
    [l, r, a],
    () => {
      const w = vn(l);
      if (!w || !(w instanceof Element))
        return;
      const {
        left: b,
        top: y,
        width: D,
        height: I
      } = w.getBoundingClientRect();
      c.value = b + (s === "page" ? n.pageXOffset : 0), A.value = y + (s === "page" ? n.pageYOffset : 0), m.value = I, p.value = D;
      const M = r.value - c.value, _ = a.value - A.value;
      h.value = D === 0 || I === 0 || M < 0 || _ < 0 || M > D || _ > I, (i || !h.value) && (u.value = M, d.value = _);
    },
    { immediate: !0 }
  ), Ei(
    document,
    "mouseleave",
    () => h.value = !0,
    { passive: !0 }
  )), {
    x: r,
    y: a,
    sourceType: o,
    elementX: u,
    elementY: d,
    elementPositionX: c,
    elementPositionY: A,
    elementHeight: m,
    elementWidth: p,
    isOutside: h,
    stop: g
  };
}
function g0(t) {
  const e = window.getComputedStyle(t);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && t.clientWidth < t.scrollWidth || e.overflowY === "auto" && t.clientHeight < t.scrollHeight)
    return !0;
  {
    const i = t.parentNode;
    return !i || i.tagName === "BODY" ? !1 : g0(i);
  }
}
function X_(t) {
  const e = t || window.event, i = e.target;
  return g0(i) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}
const Nc = /* @__PURE__ */ new WeakMap();
function Zh(t, e = !1) {
  const i = Tt(e);
  let n = null, s = "";
  mt(p0(t), (o) => {
    const l = Lc(kt(o));
    if (l) {
      const u = l;
      if (Nc.get(u) || Nc.set(u, u.style.overflow), u.style.overflow !== "hidden" && (s = u.style.overflow), u.style.overflow === "hidden")
        return i.value = !0;
      if (i.value)
        return u.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const o = Lc(kt(t));
    !o || i.value || (Wa && (n = Ei(
      o,
      "touchmove",
      (l) => {
        X_(l);
      },
      { passive: !1 }
    )), o.style.overflow = "hidden", i.value = !0);
  }, a = () => {
    const o = Lc(kt(t));
    !o || !i.value || (Wa && (n == null || n()), o.style.overflow = s, Nc.delete(o), i.value = !1);
  };
  return sa(a), J({
    get() {
      return i.value;
    },
    set(o) {
      o ? r() : a();
    }
  });
}
function vA(t, e = {}) {
  const {
    threshold: i = 50,
    onSwipe: n,
    onSwipeEnd: s,
    onSwipeStart: r,
    passive: a = !0
  } = e, o = Jr({ x: 0, y: 0 }), l = Jr({ x: 0, y: 0 }), u = J(() => o.x - l.x), d = J(() => o.y - l.y), { max: c, abs: A } = Math, m = J(() => c(A(u.value), A(d.value)) >= i), p = Tt(!1), h = J(() => m.value ? A(u.value) > A(d.value) ? u.value > 0 ? "left" : "right" : d.value > 0 ? "up" : "down" : "none"), g = (_) => [_.touches[0].clientX, _.touches[0].clientY], w = (_, N) => {
    o.x = _, o.y = N;
  }, b = (_, N) => {
    l.x = _, l.y = N;
  }, y = { passive: a, capture: !a }, D = (_) => {
    p.value && (s == null || s(_, h.value)), p.value = !1;
  }, I = [
    Ei(t, "touchstart", (_) => {
      if (_.touches.length !== 1)
        return;
      const [N, x] = g(_);
      w(N, x), b(N, x), r == null || r(_);
    }, y),
    Ei(t, "touchmove", (_) => {
      if (_.touches.length !== 1)
        return;
      const [N, x] = g(_);
      b(N, x), y.capture && !y.passive && Math.abs(u.value) > Math.abs(d.value) && _.preventDefault(), !p.value && m.value && (p.value = !0), p.value && (n == null || n(_));
    }, y),
    Ei(t, ["touchend", "touchcancel"], D, y)
  ];
  return {
    isSwiping: p,
    direction: h,
    coordsStart: o,
    coordsEnd: l,
    lengthX: u,
    lengthY: d,
    stop: () => I.forEach((_) => _()),
    // TODO: Remove in the next major version
    isPassiveEventSupported: !0
  };
}
function Rn(t = {}) {
  const {
    window: e = wr,
    initialWidth: i = Number.POSITIVE_INFINITY,
    initialHeight: n = Number.POSITIVE_INFINITY,
    listenOrientation: s = !0,
    includeScrollbar: r = !0,
    type: a = "inner"
  } = t, o = Tt(i), l = Tt(n), u = () => {
    if (e)
      if (a === "outer")
        o.value = e.outerWidth, l.value = e.outerHeight;
      else if (a === "visual" && e.visualViewport) {
        const { width: c, height: A, scale: m } = e.visualViewport;
        o.value = Math.round(c * m), l.value = Math.round(A * m);
      } else r ? (o.value = e.innerWidth, l.value = e.innerHeight) : (o.value = e.document.documentElement.clientWidth, l.value = e.document.documentElement.clientHeight);
  };
  u(), Qh(u);
  const d = { passive: !0 };
  if (Ei("resize", u, d), e && a === "visual" && e.visualViewport && Ei(e.visualViewport, "resize", u, d), s) {
    const c = U_("(orientation: portrait)");
    mt(c, () => u());
  }
  return { width: o, height: l };
}
const j_ = ["top", "right", "bottom", "left"], yA = ["start", "end"], bA = /* @__PURE__ */ j_.reduce((t, e) => t.concat(e, e + "-" + yA[0], e + "-" + yA[1]), []), Tl = Math.min, _a = Math.max, Gu = Math.round, Ts = (t) => ({
  x: t,
  y: t
}), G_ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Q_ = {
  start: "end",
  end: "start"
};
function ih(t, e, i) {
  return _a(t, Tl(e, i));
}
function mo(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function qs(t) {
  return t.split("-")[0];
}
function xs(t) {
  return t.split("-")[1];
}
function v0(t) {
  return t === "x" ? "y" : "x";
}
function Kh(t) {
  return t === "y" ? "height" : "width";
}
function Ya(t) {
  return ["top", "bottom"].includes(qs(t)) ? "y" : "x";
}
function Jh(t) {
  return v0(Ya(t));
}
function y0(t, e, i) {
  i === void 0 && (i = !1);
  const n = xs(t), s = Jh(t), r = Kh(s);
  let a = s === "x" ? n === (i ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (a = Zu(a)), [a, Zu(a)];
}
function Z_(t) {
  const e = Zu(t);
  return [Qu(t), e, Qu(e)];
}
function Qu(t) {
  return t.replace(/start|end/g, (e) => Q_[e]);
}
function K_(t, e, i) {
  const n = ["left", "right"], s = ["right", "left"], r = ["top", "bottom"], a = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return i ? e ? s : n : e ? n : s;
    case "left":
    case "right":
      return e ? r : a;
    default:
      return [];
  }
}
function J_(t, e, i, n) {
  const s = xs(t);
  let r = K_(qs(t), i === "start", n);
  return s && (r = r.map((a) => a + "-" + s), e && (r = r.concat(r.map(Qu)))), r;
}
function Zu(t) {
  return t.replace(/left|right|bottom|top/g, (e) => G_[e]);
}
function $_(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function b0(t) {
  return typeof t != "number" ? $_(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Ku(t) {
  const {
    x: e,
    y: i,
    width: n,
    height: s
  } = t;
  return {
    width: n,
    height: s,
    top: i,
    left: e,
    right: e + n,
    bottom: i + s,
    x: e,
    y: i
  };
}
function wA(t, e, i) {
  let {
    reference: n,
    floating: s
  } = t;
  const r = Ya(e), a = Jh(e), o = Kh(a), l = qs(e), u = r === "y", d = n.x + n.width / 2 - s.width / 2, c = n.y + n.height / 2 - s.height / 2, A = n[o] / 2 - s[o] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: d,
        y: n.y - s.height
      };
      break;
    case "bottom":
      m = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      m = {
        x: n.x + n.width,
        y: c
      };
      break;
    case "left":
      m = {
        x: n.x - s.width,
        y: c
      };
      break;
    default:
      m = {
        x: n.x,
        y: n.y
      };
  }
  switch (xs(e)) {
    case "start":
      m[a] -= A * (i && u ? -1 : 1);
      break;
    case "end":
      m[a] += A * (i && u ? -1 : 1);
      break;
  }
  return m;
}
const ek = async (t, e, i) => {
  const {
    placement: n = "bottom",
    strategy: s = "absolute",
    middleware: r = [],
    platform: a
  } = i, o = r.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let u = await a.getElementRects({
    reference: t,
    floating: e,
    strategy: s
  }), {
    x: d,
    y: c
  } = wA(u, n, l), A = n, m = {}, p = 0;
  for (let h = 0; h < o.length; h++) {
    const {
      name: g,
      fn: w
    } = o[h], {
      x: b,
      y,
      data: D,
      reset: I
    } = await w({
      x: d,
      y: c,
      initialPlacement: n,
      placement: A,
      strategy: s,
      middlewareData: m,
      rects: u,
      platform: a,
      elements: {
        reference: t,
        floating: e
      }
    });
    d = b ?? d, c = y ?? c, m = {
      ...m,
      [g]: {
        ...m[g],
        ...D
      }
    }, I && p <= 50 && (p++, typeof I == "object" && (I.placement && (A = I.placement), I.rects && (u = I.rects === !0 ? await a.getElementRects({
      reference: t,
      floating: e,
      strategy: s
    }) : I.rects), {
      x: d,
      y: c
    } = wA(u, A, l)), h = -1);
  }
  return {
    x: d,
    y: c,
    placement: A,
    strategy: s,
    middlewareData: m
  };
};
async function $h(t, e) {
  var i;
  e === void 0 && (e = {});
  const {
    x: n,
    y: s,
    platform: r,
    rects: a,
    elements: o,
    strategy: l
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: c = "floating",
    altBoundary: A = !1,
    padding: m = 0
  } = mo(e, t), p = b0(m), g = o[A ? c === "floating" ? "reference" : "floating" : c], w = Ku(await r.getClippingRect({
    element: (i = await (r.isElement == null ? void 0 : r.isElement(g))) == null || i ? g : g.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(o.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), b = c === "floating" ? {
    x: n,
    y: s,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, y = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(o.floating)), D = await (r.isElement == null ? void 0 : r.isElement(y)) ? await (r.getScale == null ? void 0 : r.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, I = Ku(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: b,
    offsetParent: y,
    strategy: l
  }) : b);
  return {
    top: (w.top - I.top + p.top) / D.y,
    bottom: (I.bottom - w.bottom + p.bottom) / D.y,
    left: (w.left - I.left + p.left) / D.x,
    right: (I.right - w.right + p.right) / D.x
  };
}
const tk = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: i,
      y: n,
      placement: s,
      rects: r,
      platform: a,
      elements: o,
      middlewareData: l
    } = e, {
      element: u,
      padding: d = 0
    } = mo(t, e) || {};
    if (u == null)
      return {};
    const c = b0(d), A = {
      x: i,
      y: n
    }, m = Jh(s), p = Kh(m), h = await a.getDimensions(u), g = m === "y", w = g ? "top" : "left", b = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", D = r.reference[p] + r.reference[m] - A[m] - r.floating[p], I = A[m] - r.reference[m], M = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let _ = M ? M[y] : 0;
    (!_ || !await (a.isElement == null ? void 0 : a.isElement(M))) && (_ = o.floating[y] || r.floating[p]);
    const N = D / 2 - I / 2, x = _ / 2 - h[p] / 2 - 1, C = Tl(c[w], x), L = Tl(c[b], x), V = C, H = _ - h[p] - L, O = _ / 2 - h[p] / 2 + N, X = ih(V, O, H), q = !l.arrow && xs(s) != null && O !== X && r.reference[p] / 2 - (O < V ? C : L) - h[p] / 2 < 0, F = q ? O < V ? O - V : O - H : 0;
    return {
      [m]: A[m] + F,
      data: {
        [m]: X,
        centerOffset: O - X - F,
        ...q && {
          alignmentOffset: F
        }
      },
      reset: q
    };
  }
});
function ik(t, e, i) {
  return (t ? [...i.filter((s) => xs(s) === t), ...i.filter((s) => xs(s) !== t)] : i.filter((s) => qs(s) === s)).filter((s) => t ? xs(s) === t || (e ? Qu(s) !== s : !1) : !0);
}
const nk = function(t) {
  return t === void 0 && (t = {}), {
    name: "autoPlacement",
    options: t,
    async fn(e) {
      var i, n, s;
      const {
        rects: r,
        middlewareData: a,
        placement: o,
        platform: l,
        elements: u
      } = e, {
        crossAxis: d = !1,
        alignment: c,
        allowedPlacements: A = bA,
        autoAlignment: m = !0,
        ...p
      } = mo(t, e), h = c !== void 0 || A === bA ? ik(c || null, m, A) : A, g = await $h(e, p), w = ((i = a.autoPlacement) == null ? void 0 : i.index) || 0, b = h[w];
      if (b == null)
        return {};
      const y = y0(b, r, await (l.isRTL == null ? void 0 : l.isRTL(u.floating)));
      if (o !== b)
        return {
          reset: {
            placement: h[0]
          }
        };
      const D = [g[qs(b)], g[y[0]], g[y[1]]], I = [...((n = a.autoPlacement) == null ? void 0 : n.overflows) || [], {
        placement: b,
        overflows: D
      }], M = h[w + 1];
      if (M)
        return {
          data: {
            index: w + 1,
            overflows: I
          },
          reset: {
            placement: M
          }
        };
      const _ = I.map((C) => {
        const L = xs(C.placement);
        return [C.placement, L && d ? (
          // Check along the mainAxis and main crossAxis side.
          C.overflows.slice(0, 2).reduce((V, H) => V + H, 0)
        ) : (
          // Check only the mainAxis.
          C.overflows[0]
        ), C.overflows];
      }).sort((C, L) => C[1] - L[1]), x = ((s = _.filter((C) => C[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        xs(C[0]) ? 2 : 3
      ).every((L) => L <= 0))[0]) == null ? void 0 : s[0]) || _[0][0];
      return x !== o ? {
        data: {
          index: w + 1,
          overflows: I
        },
        reset: {
          placement: x
        }
      } : {};
    }
  };
}, sk = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var i, n;
      const {
        placement: s,
        middlewareData: r,
        rects: a,
        initialPlacement: o,
        platform: l,
        elements: u
      } = e, {
        mainAxis: d = !0,
        crossAxis: c = !0,
        fallbackPlacements: A,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: h = !0,
        ...g
      } = mo(t, e);
      if ((i = r.arrow) != null && i.alignmentOffset)
        return {};
      const w = qs(s), b = Ya(o), y = qs(o) === o, D = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), I = A || (y || !h ? [Zu(o)] : Z_(o)), M = p !== "none";
      !A && M && I.push(...J_(o, h, p, D));
      const _ = [o, ...I], N = await $h(e, g), x = [];
      let C = ((n = r.flip) == null ? void 0 : n.overflows) || [];
      if (d && x.push(N[w]), c) {
        const O = y0(s, a, D);
        x.push(N[O[0]], N[O[1]]);
      }
      if (C = [...C, {
        placement: s,
        overflows: x
      }], !x.every((O) => O <= 0)) {
        var L, V;
        const O = (((L = r.flip) == null ? void 0 : L.index) || 0) + 1, X = _[O];
        if (X)
          return {
            data: {
              index: O,
              overflows: C
            },
            reset: {
              placement: X
            }
          };
        let q = (V = C.filter((F) => F.overflows[0] <= 0).sort((F, W) => F.overflows[1] - W.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!q)
          switch (m) {
            case "bestFit": {
              var H;
              const F = (H = C.filter((W) => {
                if (M) {
                  const j = Ya(W.placement);
                  return j === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  j === "y";
                }
                return !0;
              }).map((W) => [W.placement, W.overflows.filter((j) => j > 0).reduce((j, oe) => j + oe, 0)]).sort((W, j) => W[1] - j[1])[0]) == null ? void 0 : H[0];
              F && (q = F);
              break;
            }
            case "initialPlacement":
              q = o;
              break;
          }
        if (s !== q)
          return {
            reset: {
              placement: q
            }
          };
      }
      return {};
    }
  };
};
async function rk(t, e) {
  const {
    placement: i,
    platform: n,
    elements: s
  } = t, r = await (n.isRTL == null ? void 0 : n.isRTL(s.floating)), a = qs(i), o = xs(i), l = Ya(i) === "y", u = ["left", "top"].includes(a) ? -1 : 1, d = r && l ? -1 : 1, c = mo(e, t);
  let {
    mainAxis: A,
    crossAxis: m,
    alignmentAxis: p
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: c.mainAxis || 0,
    crossAxis: c.crossAxis || 0,
    alignmentAxis: c.alignmentAxis
  };
  return o && typeof p == "number" && (m = o === "end" ? p * -1 : p), l ? {
    x: m * d,
    y: A * u
  } : {
    x: A * u,
    y: m * d
  };
}
const ak = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var i, n;
      const {
        x: s,
        y: r,
        placement: a,
        middlewareData: o
      } = e, l = await rk(e, t);
      return a === ((i = o.offset) == null ? void 0 : i.placement) && (n = o.arrow) != null && n.alignmentOffset ? {} : {
        x: s + l.x,
        y: r + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, ok = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: i,
        y: n,
        placement: s
      } = e, {
        mainAxis: r = !0,
        crossAxis: a = !1,
        limiter: o = {
          fn: (g) => {
            let {
              x: w,
              y: b
            } = g;
            return {
              x: w,
              y: b
            };
          }
        },
        ...l
      } = mo(t, e), u = {
        x: i,
        y: n
      }, d = await $h(e, l), c = Ya(qs(s)), A = v0(c);
      let m = u[A], p = u[c];
      if (r) {
        const g = A === "y" ? "top" : "left", w = A === "y" ? "bottom" : "right", b = m + d[g], y = m - d[w];
        m = ih(b, m, y);
      }
      if (a) {
        const g = c === "y" ? "top" : "left", w = c === "y" ? "bottom" : "right", b = p + d[g], y = p - d[w];
        p = ih(b, p, y);
      }
      const h = o.fn({
        ...e,
        [A]: m,
        [c]: p
      });
      return {
        ...h,
        data: {
          x: h.x - i,
          y: h.y - n,
          enabled: {
            [A]: r,
            [c]: a
          }
        }
      };
    }
  };
};
function Ld() {
  return typeof window < "u";
}
function ra(t) {
  return ep(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function wn(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Xs(t) {
  var e;
  return (e = (ep(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function ep(t) {
  return Ld() ? t instanceof Node || t instanceof wn(t).Node : !1;
}
function ns(t) {
  return Ld() ? t instanceof Element || t instanceof wn(t).Element : !1;
}
function Cs(t) {
  return Ld() ? t instanceof HTMLElement || t instanceof wn(t).HTMLElement : !1;
}
function TA(t) {
  return !Ld() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof wn(t).ShadowRoot;
}
function Nl(t) {
  const {
    overflow: e,
    overflowX: i,
    overflowY: n,
    display: s
  } = ss(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + i) && !["inline", "contents"].includes(s);
}
function lk(t) {
  return ["table", "td", "th"].includes(ra(t));
}
function Nd(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function tp(t) {
  const e = ip(), i = ns(t) ? ss(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => i[n] ? i[n] !== "none" : !1) || (i.containerType ? i.containerType !== "normal" : !1) || !e && (i.backdropFilter ? i.backdropFilter !== "none" : !1) || !e && (i.filter ? i.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (i.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (i.contain || "").includes(n));
}
function uk(t) {
  let e = Ar(t);
  for (; Cs(e) && !Xa(e); ) {
    if (tp(e))
      return e;
    if (Nd(e))
      return null;
    e = Ar(e);
  }
  return null;
}
function ip() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Xa(t) {
  return ["html", "body", "#document"].includes(ra(t));
}
function ss(t) {
  return wn(t).getComputedStyle(t);
}
function Rd(t) {
  return ns(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function Ar(t) {
  if (ra(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    TA(t) && t.host || // Fallback.
    Xs(t)
  );
  return TA(e) ? e.host : e;
}
function w0(t) {
  const e = Ar(t);
  return Xa(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Cs(e) && Nl(e) ? e : w0(e);
}
function T0(t, e, i) {
  var n;
  e === void 0 && (e = []);
  const s = w0(t), r = s === ((n = t.ownerDocument) == null ? void 0 : n.body), a = wn(s);
  return r ? (nh(a), e.concat(a, a.visualViewport || [], Nl(s) ? s : [], [])) : e.concat(s, T0(s, []));
}
function nh(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function x0(t) {
  const e = ss(t);
  let i = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const s = Cs(t), r = s ? t.offsetWidth : i, a = s ? t.offsetHeight : n, o = Gu(i) !== r || Gu(n) !== a;
  return o && (i = r, n = a), {
    width: i,
    height: n,
    $: o
  };
}
function S0(t) {
  return ns(t) ? t : t.contextElement;
}
function ka(t) {
  const e = S0(t);
  if (!Cs(e))
    return Ts(1);
  const i = e.getBoundingClientRect(), {
    width: n,
    height: s,
    $: r
  } = x0(e);
  let a = (r ? Gu(i.width) : i.width) / n, o = (r ? Gu(i.height) : i.height) / s;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const dk = /* @__PURE__ */ Ts(0);
function C0(t) {
  const e = wn(t);
  return !ip() || !e.visualViewport ? dk : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function ck(t, e, i) {
  return e === void 0 && (e = !1), !i || e && i !== wn(t) ? !1 : e;
}
function xl(t, e, i, n) {
  e === void 0 && (e = !1), i === void 0 && (i = !1);
  const s = t.getBoundingClientRect(), r = S0(t);
  let a = Ts(1);
  e && (n ? ns(n) && (a = ka(n)) : a = ka(t));
  const o = ck(r, i, n) ? C0(r) : Ts(0);
  let l = (s.left + o.x) / a.x, u = (s.top + o.y) / a.y, d = s.width / a.x, c = s.height / a.y;
  if (r) {
    const A = wn(r), m = n && ns(n) ? wn(n) : n;
    let p = A, h = nh(p);
    for (; h && n && m !== p; ) {
      const g = ka(h), w = h.getBoundingClientRect(), b = ss(h), y = w.left + (h.clientLeft + parseFloat(b.paddingLeft)) * g.x, D = w.top + (h.clientTop + parseFloat(b.paddingTop)) * g.y;
      l *= g.x, u *= g.y, d *= g.x, c *= g.y, l += y, u += D, p = wn(h), h = nh(p);
    }
  }
  return Ku({
    width: d,
    height: c,
    x: l,
    y: u
  });
}
function np(t, e) {
  const i = Rd(t).scrollLeft;
  return e ? e.left + i : xl(Xs(t)).left + i;
}
function E0(t, e, i) {
  i === void 0 && (i = !1);
  const n = t.getBoundingClientRect(), s = n.left + e.scrollLeft - (i ? 0 : (
    // RTL <body> scrollbar.
    np(t, n)
  )), r = n.top + e.scrollTop;
  return {
    x: s,
    y: r
  };
}
function fk(t) {
  let {
    elements: e,
    rect: i,
    offsetParent: n,
    strategy: s
  } = t;
  const r = s === "fixed", a = Xs(n), o = e ? Nd(e.floating) : !1;
  if (n === a || o && r)
    return i;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Ts(1);
  const d = Ts(0), c = Cs(n);
  if ((c || !c && !r) && ((ra(n) !== "body" || Nl(a)) && (l = Rd(n)), Cs(n))) {
    const m = xl(n);
    u = ka(n), d.x = m.x + n.clientLeft, d.y = m.y + n.clientTop;
  }
  const A = a && !c && !r ? E0(a, l, !0) : Ts(0);
  return {
    width: i.width * u.x,
    height: i.height * u.y,
    x: i.x * u.x - l.scrollLeft * u.x + d.x + A.x,
    y: i.y * u.y - l.scrollTop * u.y + d.y + A.y
  };
}
function hk(t) {
  return Array.from(t.getClientRects());
}
function pk(t) {
  const e = Xs(t), i = Rd(t), n = t.ownerDocument.body, s = _a(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), r = _a(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let a = -i.scrollLeft + np(t);
  const o = -i.scrollTop;
  return ss(n).direction === "rtl" && (a += _a(e.clientWidth, n.clientWidth) - s), {
    width: s,
    height: r,
    x: a,
    y: o
  };
}
function mk(t, e) {
  const i = wn(t), n = Xs(t), s = i.visualViewport;
  let r = n.clientWidth, a = n.clientHeight, o = 0, l = 0;
  if (s) {
    r = s.width, a = s.height;
    const u = ip();
    (!u || u && e === "fixed") && (o = s.offsetLeft, l = s.offsetTop);
  }
  return {
    width: r,
    height: a,
    x: o,
    y: l
  };
}
function Ak(t, e) {
  const i = xl(t, !0, e === "fixed"), n = i.top + t.clientTop, s = i.left + t.clientLeft, r = Cs(t) ? ka(t) : Ts(1), a = t.clientWidth * r.x, o = t.clientHeight * r.y, l = s * r.x, u = n * r.y;
  return {
    width: a,
    height: o,
    x: l,
    y: u
  };
}
function xA(t, e, i) {
  let n;
  if (e === "viewport")
    n = mk(t, i);
  else if (e === "document")
    n = pk(Xs(t));
  else if (ns(e))
    n = Ak(e, i);
  else {
    const s = C0(t);
    n = {
      x: e.x - s.x,
      y: e.y - s.y,
      width: e.width,
      height: e.height
    };
  }
  return Ku(n);
}
function D0(t, e) {
  const i = Ar(t);
  return i === e || !ns(i) || Xa(i) ? !1 : ss(i).position === "fixed" || D0(i, e);
}
function gk(t, e) {
  const i = e.get(t);
  if (i)
    return i;
  let n = T0(t, []).filter((o) => ns(o) && ra(o) !== "body"), s = null;
  const r = ss(t).position === "fixed";
  let a = r ? Ar(t) : t;
  for (; ns(a) && !Xa(a); ) {
    const o = ss(a), l = tp(a);
    !l && o.position === "fixed" && (s = null), (r ? !l && !s : !l && o.position === "static" && !!s && ["absolute", "fixed"].includes(s.position) || Nl(a) && !l && D0(t, a)) ? n = n.filter((d) => d !== a) : s = o, a = Ar(a);
  }
  return e.set(t, n), n;
}
function vk(t) {
  let {
    element: e,
    boundary: i,
    rootBoundary: n,
    strategy: s
  } = t;
  const a = [...i === "clippingAncestors" ? Nd(e) ? [] : gk(e, this._c) : [].concat(i), n], o = a[0], l = a.reduce((u, d) => {
    const c = xA(e, d, s);
    return u.top = _a(c.top, u.top), u.right = Tl(c.right, u.right), u.bottom = Tl(c.bottom, u.bottom), u.left = _a(c.left, u.left), u;
  }, xA(e, o, s));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function yk(t) {
  const {
    width: e,
    height: i
  } = x0(t);
  return {
    width: e,
    height: i
  };
}
function bk(t, e, i) {
  const n = Cs(e), s = Xs(e), r = i === "fixed", a = xl(t, !0, r, e);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Ts(0);
  if (n || !n && !r)
    if ((ra(e) !== "body" || Nl(s)) && (o = Rd(e)), n) {
      const A = xl(e, !0, r, e);
      l.x = A.x + e.clientLeft, l.y = A.y + e.clientTop;
    } else s && (l.x = np(s));
  const u = s && !n && !r ? E0(s, o) : Ts(0), d = a.left + o.scrollLeft - l.x - u.x, c = a.top + o.scrollTop - l.y - u.y;
  return {
    x: d,
    y: c,
    width: a.width,
    height: a.height
  };
}
function Rc(t) {
  return ss(t).position === "static";
}
function SA(t, e) {
  if (!Cs(t) || ss(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let i = t.offsetParent;
  return Xs(t) === i && (i = i.ownerDocument.body), i;
}
function _0(t, e) {
  const i = wn(t);
  if (Nd(t))
    return i;
  if (!Cs(t)) {
    let s = Ar(t);
    for (; s && !Xa(s); ) {
      if (ns(s) && !Rc(s))
        return s;
      s = Ar(s);
    }
    return i;
  }
  let n = SA(t, e);
  for (; n && lk(n) && Rc(n); )
    n = SA(n, e);
  return n && Xa(n) && Rc(n) && !tp(n) ? i : n || uk(t) || i;
}
const wk = async function(t) {
  const e = this.getOffsetParent || _0, i = this.getDimensions, n = await i(t.floating);
  return {
    reference: bk(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Tk(t) {
  return ss(t).direction === "rtl";
}
const xk = {
  convertOffsetParentRelativeRectToViewportRelativeRect: fk,
  getDocumentElement: Xs,
  getClippingRect: vk,
  getOffsetParent: _0,
  getElementRects: wk,
  getClientRects: hk,
  getDimensions: yk,
  getScale: ka,
  isElement: ns,
  isRTL: Tk
}, sp = ak, k0 = nk, rp = ok, Sk = sk, Ck = tk, ap = (t, e, i) => {
  const n = /* @__PURE__ */ new Map(), s = {
    platform: xk,
    ...i
  }, r = {
    ...s.platform,
    _c: n
  };
  return ek(t, e, {
    ...s,
    platform: r
  });
};
function Ek(t) {
  return t != null && typeof t == "object" && "$el" in t;
}
function Dk(t) {
  if (Ek(t)) {
    const e = t.$el;
    return ep(e) && ra(e) === "#comment" ? null : e;
  }
  return t;
}
function _k(t) {
  return typeof t == "function" ? t() : Y(t);
}
function P0(t) {
  return {
    name: "arrow",
    options: t,
    fn(e) {
      const i = Dk(_k(t.element));
      return i == null ? {} : Ck({
        element: i,
        padding: t.padding
      }).fn(e);
    }
  };
}
const kk = ["id"], Pk = /* @__PURE__ */ qe({
  name: "UiTooltip",
  __name: "UiTooltip",
  props: {
    size: {
      type: String,
      default: "m"
    },
    tooltipId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    tooltipMessage: {
      type: String,
      default: ""
    },
    zIndex: {
      type: Number,
      default: 999
    },
    position: {
      type: String,
      default: "top"
    },
    scrollContainerId: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, { width: i } = Rn(), n = pe(!1), s = Tt(null), r = Tt(null), a = Tt(null), o = () => {
      ap(s.value, r.value, {
        placement: e.position,
        middleware: [
          sp(i.value > 767 ? 16 : 12),
          k0(),
          rp({ padding: 8 }),
          P0({ element: a.value })
        ]
      }).then(({ x: A, y: m, placement: p, middlewareData: h }) => {
        Object.assign(r.value.style, {
          left: `${A}px`,
          top: `${m}px`
        });
        const { x: g, y: w } = h.arrow, b = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[p.split("-")[0]];
        Object.assign(a.value.style, {
          left: g != null ? `${g}px` : "",
          top: w != null ? `${w}px` : "",
          right: "",
          bottom: "",
          //@ts-ignore
          [b]: "-3px"
        });
      });
    }, l = async () => {
      n.value = !n.value, n.value && (await li(), o());
    }, u = () => {
      if (!e.scrollContainerId)
        return;
      const A = document.getElementById(e.scrollContainerId);
      A == null || A.addEventListener("scroll", function() {
        o();
      });
    }, d = () => {
      if (!e.scrollContainerId)
        return;
      const A = document.getElementById(e.scrollContainerId);
      A == null || A.removeEventListener("scroll", function() {
        o();
      });
    };
    It(() => {
      document.addEventListener("keyup", function(A) {
        A.keyCode === 27 && (n.value = !1);
      }), u();
    }), Nn(() => {
      document.removeEventListener("keyup", function(A) {
        A.keyCode === 27 && (n.value = !1);
      }), d();
    }), N_(s, () => n.value = !1);
    const c = J(() => ({
      zIndex: e.zIndex
    }));
    return (A, m) => (k(), U("div", {
      id: t.tooltipId,
      class: we(["ui-tooltip", `ui-tooltip__size_${t.size}`])
    }, [
      re("div", {
        ref_key: "tooltipParent",
        ref: s,
        class: "ui-tooltip__parent",
        onClick: $t(l, ["stop"])
      }, [
        Se(A.$slots, "icon", {}, () => [
          ke(Y(is))
        ], !0)
      ], 512),
      (k(), Ce(br, { to: "body" }, [
        ke(Ri, {
          name: "ui-tooltip",
          mode: "out-in"
        }, {
          default: De(() => [
            n.value ? (k(), U("div", {
              key: 0,
              ref_key: "tooltipContentRef",
              ref: r,
              style: Nt(c.value),
              class: "ui-tooltip__content elevation-shadow-high"
            }, [
              re("div", {
                ref_key: "arrowRef",
                ref: a,
                class: "arrow"
              }, null, 512),
              Se(A.$slots, "default", {}, () => [
                re("p", null, _e(t.tooltipMessage), 1)
              ], !0)
            ], 4)) : ie("", !0)
          ]),
          _: 3
        })
      ]))
    ], 10, kk));
  }
}), aa = /* @__PURE__ */ tt(Pk, [["__scopeId", "data-v-abe9a207"]]), Ik = {
  key: 0,
  class: "ui-counter__hint hint"
}, Mk = {
  key: 0,
  class: "ui-counter__label"
}, Ok = ["disabled"], Bk = { class: "ui-counter__container counter-container" }, Lk = ["min", "max"], Nk = ["disabled"], Rk = {
  key: 1,
  class: "ui-counter__hint-message"
}, Fk = /* @__PURE__ */ qe({
  name: "UiCounter",
  __name: "UiCounter",
  props: {
    size: {
      type: String,
      default: "l"
    },
    fill: {
      type: Boolean,
      default: !1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    label: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Number,
      required: !0
    },
    tooltipMessage: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:modelValue",
    "increment",
    "decrement",
    "update"
  ],
  setup(t, { emit: e }) {
    const i = t, n = e, { width: s } = Rn(), r = pe(0), a = J(() => r.value <= i.min), o = J(() => r.value >= i.max), l = J(() => i.label || i.tooltipMessage), u = J(() => s.value >= 1023 ? "m" : "s");
    mt(
      () => r.value,
      (m) => {
        const p = Math.max(i.min, Math.min(i.max, m));
        r.value !== p && (r.value = p, n("update:modelValue", p), n("update", p));
      }
    );
    const d = () => {
      r.value < i.max && r.value++, n("increment");
    }, c = () => {
      r.value > i.min && r.value--, n("decrement");
    }, A = (m) => {
      const p = m.target;
      p.value = p.value.replace(/^0+/, "") || "0", r.value = +p.value, n("update:modelValue", r.value), n("update", r.value);
    };
    return Vs(() => {
      i.modelValue && (r.value = i.modelValue);
    }), (m, p) => (k(), U("div", {
      class: we(`ui-counter__wrapper_size_${t.size}`)
    }, [
      l.value ? (k(), U("span", Ik, [
        t.label ? (k(), U("span", Mk, _e(t.label), 1)) : ie("", !0),
        t.tooltipMessage ? (k(), Ce(aa, {
          key: 1,
          class: "ui-counter-tooltip",
          size: u.value,
          "tooltip-message": t.tooltipMessage
        }, {
          icon: De(() => [
            Se(m.$slots, "tooltip-icon", {}, () => [
              ke(Y(is), { class: "ui-counter-tooltip__icon" })
            ], !0)
          ]),
          _: 3
        }, 8, ["size", "tooltip-message"])) : ie("", !0)
      ])) : ie("", !0),
      re("div", {
        class: we(["ui-counter", { "ui-counter_fill": t.fill }])
      }, [
        re("button", {
          type: "button",
          disabled: a.value,
          class: we([{ "ui-counter-button_disabled": a.value }, "ui-counter-button"]),
          onClick: c
        }, [
          ke(Y(u0), { class: "ui-counter-button__icon" })
        ], 10, Ok),
        re("label", Bk, [
          Ci(re("input", {
            "onUpdate:modelValue": p[0] || (p[0] = (h) => r.value = h),
            type: "number",
            class: "counter-container__input",
            inputmode: "numeric",
            min: t.min,
            max: t.max,
            onChange: A
          }, null, 40, Lk), [
            [
              Kn,
              r.value,
              void 0,
              { number: !0 }
            ]
          ])
        ]),
        re("button", {
          type: "button",
          class: we(["ui-counter-button", { "ui-counter-button_disabled": o.value }]),
          disabled: o.value,
          onClick: d
        }, [
          ke(Y(zS), { class: "ui-counter-button__icon" })
        ], 10, Nk)
      ], 2),
      t.hintMessage ? (k(), U("p", Rk, _e(t.hintMessage), 1)) : ie("", !0)
    ], 2));
  }
}), Oq = /* @__PURE__ */ tt(Fk, [["__scopeId", "data-v-1b402594"]]), zk = { class: "ui-hint" }, CA = 200, Uk = /* @__PURE__ */ qe({
  name: "UiHint",
  __name: "UiHint",
  props: {
    hintContent: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    zIndex: {
      type: Number,
      default: 999
    },
    position: {
      type: String,
      default: "top"
    },
    scrollContainerId: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, { width: i } = Rn(), n = pe(!1), s = J(() => ({
      zIndex: e.zIndex
    })), r = J(() => n.value && !e.disabled), a = Tt(null), o = Tt(null), l = Tt(null), u = () => {
      ap(a.value, o.value, {
        placement: e.position,
        middleware: [
          sp(i.value > 767 ? 16 : 12),
          k0(),
          rp({ padding: 8 }),
          P0({ element: l.value })
        ]
      }).then(({ x: g, y: w, placement: b, middlewareData: y }) => {
        Object.assign(o.value.style, {
          left: `${g}px`,
          top: `${w}px`
        });
        const { x: D, y: I } = y.arrow, M = {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[b.split("-")[0]];
        Object.assign(l.value.style, {
          left: D != null ? `${D}px` : "",
          top: I != null ? `${I}px` : "",
          right: "",
          bottom: "",
          //@ts-ignore
          [M]: "-3px"
        });
      });
    }, d = pe(null), c = pe(null), A = async () => {
      c.value && clearTimeout(c.value), c.value = setTimeout(async () => {
        n.value = !0, await li(), u();
      }, CA);
    };
    function m() {
      d.value && clearTimeout(d.value), d.value = setTimeout(() => {
        n.value = !1;
      }, CA);
    }
    const p = () => {
      if (!e.scrollContainerId)
        return;
      const g = document.getElementById(e.scrollContainerId);
      g == null || g.addEventListener("scroll", function() {
        u();
      });
    }, h = () => {
      if (!e.scrollContainerId)
        return;
      const g = document.getElementById(e.scrollContainerId);
      g == null || g.removeEventListener("scroll", function() {
        u();
      });
    };
    return It(() => {
      p();
    }), Nn(() => {
      h();
    }), (g, w) => (k(), U("div", zk, [
      re("div", {
        ref_key: "hintParent",
        ref: a,
        tabindex: "-1",
        class: we(["ui-hint__label-text", { "ui-hint__label-text_disabled": t.disabled }]),
        onMouseenter: A,
        onMouseleave: m,
        onFocus: A,
        onBlur: m
      }, [
        Se(g.$slots, "default", {}, () => [
          ke(Y(is))
        ], !0)
      ], 34),
      (k(), Ce(br, { to: "body" }, [
        ke(Ri, {
          name: "ui-hint",
          mode: "out-in"
        }, {
          default: De(() => [
            r.value ? (k(), U("div", {
              key: 0,
              ref_key: "hintContentRef",
              ref: o,
              style: Nt(s.value),
              class: "ui-hint__content elevation-shadow-low"
            }, [
              re("div", {
                ref_key: "arrowRef",
                ref: l,
                class: "arrow"
              }, null, 512),
              Se(g.$slots, "content", {}, () => [
                re("p", null, _e(t.hintContent), 1)
              ], !0)
            ], 4)) : ie("", !0)
          ]),
          _: 3
        })
      ]))
    ]));
  }
}), Fd = /* @__PURE__ */ tt(Uk, [["__scopeId", "data-v-86497b7b"]]), Vk = /* @__PURE__ */ qe({
  name: "UiIconButton",
  __name: "UiIconButton",
  props: {
    color: {
      type: String,
      default: "accent"
    },
    type: {
      type: String,
      default: "button"
    },
    size: {
      type: String,
      default: "l"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      default: ""
    },
    to: {
      type: Object,
      default: null
    },
    target: {
      type: String,
      default: ""
    },
    ariaLabel: {
      type: String,
      default: "icon-button"
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, i = J(() => e.href && !e.to && !e.disabled ? "a" : !e.href && e.to && !e.disabled ? "router-link" : "button");
    return (n, s) => (k(), Ce(Ft(i.value), {
      class: we(["ui-icon-button", [
        `ui-icon-button_color_${t.color}`,
        `ui-icon-button_size_${t.size}`,
        {
          "ui-icon-button_loading": t.loading
        }
      ]]),
      href: t.href,
      to: t.to,
      target: t.target,
      "data-test-id": t.dataTestId,
      type: t.type,
      disabled: t.disabled || t.loading,
      "aria-label": t.ariaLabel
    }, {
      default: De(() => [
        Se(n.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "href", "to", "target", "data-test-id", "type", "disabled", "aria-label"]));
  }
}), EA = /* @__PURE__ */ tt(Vk, [["__scopeId", "data-v-0e3a9096"]]);
var qk = Object.defineProperty, Hk = (t, e, i) => e in t ? qk(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i, ol = (t, e, i) => Hk(t, typeof e != "symbol" ? e + "" : e, i);
const DA = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, _A = (t, e, i) => t.replaceAll(e, "").replace(i, ".").replace("..", ".").replace(/[^.\d]/g, ""), kA = (t, e, i) => {
  var n;
  return new Intl.NumberFormat(((n = i.number) == null ? void 0 : n.locale) ?? "en", {
    minimumFractionDigits: t,
    maximumFractionDigits: e,
    roundingMode: "trunc"
  });
}, Wk = (t, e = !0, i) => {
  var n, s, r, a;
  const o = ((n = i.number) == null ? void 0 : n.unsigned) !== !0 && t.startsWith("-") ? "-" : "", l = ((s = i.number) == null ? void 0 : s.fraction) ?? 0;
  let u = kA(0, l, i);
  const d = u.formatToParts(1000.12), c = ((r = d.find((g) => g.type === "group")) == null ? void 0 : r.value) ?? " ", A = ((a = d.find((g) => g.type === "decimal")) == null ? void 0 : a.value) ?? ".", m = _A(t, c, A);
  if (Number.isNaN(parseFloat(m))) return o;
  const p = m.split(".");
  if (p[1] != null && p[1].length >= 1) {
    const g = p[1].length <= l ? p[1].length : l;
    u = kA(g, l, i);
  }
  let h = u.format(parseFloat(m));
  return e ? l > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (h += A) : h = _A(h, c, A), o + h;
};
class Yk {
  constructor(e = {}) {
    ol(this, "opts", {}), ol(this, "memo", /* @__PURE__ */ new Map());
    const i = { ...e };
    if (i.tokens != null) {
      i.tokens = i.tokensReplace ? { ...i.tokens } : { ...DA, ...i.tokens };
      for (const n of Object.values(i.tokens))
        typeof n.pattern == "string" && (n.pattern = new RegExp(n.pattern));
    } else
      i.tokens = DA;
    Array.isArray(i.mask) && (i.mask.length > 1 ? i.mask = [...i.mask].sort((n, s) => n.length - s.length) : i.mask = i.mask[0] ?? ""), i.mask === "" && (i.mask = null), this.opts = i;
  }
  masked(e) {
    return this.process(String(e), this.findMask(String(e)));
  }
  unmasked(e) {
    return this.process(String(e), this.findMask(String(e)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(e) {
    const i = this.findMask(String(e));
    if (this.opts.mask == null || i == null) return !1;
    const n = this.process(String(e), i).length;
    return typeof this.opts.mask == "string" ? n >= this.opts.mask.length : n >= i.length;
  }
  findMask(e) {
    const i = this.opts.mask;
    if (i == null)
      return null;
    if (typeof i == "string")
      return i;
    if (typeof i == "function")
      return i(e);
    const n = this.process(e, i.slice(-1).pop() ?? "", !1);
    return i.find((s) => this.process(e, s, !1).length >= n.length) ?? "";
  }
  escapeMask(e) {
    const i = [], n = [];
    return e.split("").forEach((s, r) => {
      s === "!" && e[r - 1] !== "!" ? n.push(r - n.length) : i.push(s);
    }), { mask: i.join(""), escaped: n };
  }
  process(e, i, n = !0) {
    if (this.opts.number != null) return Wk(e, n, this.opts);
    if (i == null) return e;
    const s = `v=${e},mr=${i},m=${n ? 1 : 0}`;
    if (this.memo.has(s)) return this.memo.get(s);
    const { mask: r, escaped: a } = this.escapeMask(i), o = [], l = this.opts.tokens != null ? this.opts.tokens : {}, u = this.isReversed() ? -1 : 1, d = this.isReversed() ? "unshift" : "push", c = this.isReversed() ? 0 : r.length - 1, A = this.isReversed() ? () => g > -1 && w > -1 : () => g < r.length && w < e.length, m = (y) => !this.isReversed() && y <= c || this.isReversed() && y >= c;
    let p, h = -1, g = this.isReversed() ? r.length - 1 : 0, w = this.isReversed() ? e.length - 1 : 0, b = !1;
    for (; A(); ) {
      const y = r.charAt(g), D = l[y], I = (D == null ? void 0 : D.transform) != null ? D.transform(e.charAt(w)) : e.charAt(w);
      if (!a.includes(g) && D != null ? (I.match(D.pattern) != null ? (o[d](I), D.repeated ? (h === -1 ? h = g : g === c && g !== h && (g = h - u), c === h && (g -= u)) : D.multiple && (b = !0, g -= u), g += u) : D.multiple ? b && (g += u, w -= u, b = !1) : I === p ? p = void 0 : D.optional && (g += u, w -= u), w += u) : (n && !this.isEager() && o[d](y), I === y && !this.isEager() ? w += u : p = y, this.isEager() || (g += u)), this.isEager())
        for (; m(g) && (l[r.charAt(g)] == null || a.includes(g)); ) {
          if (n) {
            if (o[d](r.charAt(g)), e.charAt(w) === r.charAt(g)) {
              g += u, w += u;
              continue;
            }
          } else r.charAt(g) === e.charAt(w) && (w += u);
          g += u;
        }
    }
    return this.memo.set(s, o.join("")), this.memo.get(s);
  }
}
const I0 = (t) => JSON.parse(t.replaceAll("'", '"')), Xk = (t, e = {}) => {
  const i = { ...e };
  t.dataset.maska != null && t.dataset.maska !== "" && (i.mask = jk(t.dataset.maska)), t.dataset.maskaEager != null && (i.eager = bu(t.dataset.maskaEager)), t.dataset.maskaReversed != null && (i.reversed = bu(t.dataset.maskaReversed)), t.dataset.maskaTokensReplace != null && (i.tokensReplace = bu(t.dataset.maskaTokensReplace)), t.dataset.maskaTokens != null && (i.tokens = Gk(t.dataset.maskaTokens));
  const n = {};
  return t.dataset.maskaNumberLocale != null && (n.locale = t.dataset.maskaNumberLocale), t.dataset.maskaNumberFraction != null && (n.fraction = parseInt(t.dataset.maskaNumberFraction)), t.dataset.maskaNumberUnsigned != null && (n.unsigned = bu(t.dataset.maskaNumberUnsigned)), (t.dataset.maskaNumber != null || Object.values(n).length > 0) && (i.number = n), i;
}, bu = (t) => t !== "" ? !!JSON.parse(t) : !0, jk = (t) => t.startsWith("[") && t.endsWith("]") ? I0(t) : t, Gk = (t) => {
  if (t.startsWith("{") && t.endsWith("}"))
    return I0(t);
  const e = {};
  return t.split("|").forEach((i) => {
    const n = i.split(":");
    e[n[0]] = {
      pattern: new RegExp(n[1]),
      optional: n[2] === "optional",
      multiple: n[2] === "multiple",
      repeated: n[2] === "repeated"
    };
  }), e;
};
class Qk {
  constructor(e, i = {}) {
    ol(this, "items", /* @__PURE__ */ new Map()), ol(this, "eventAbortController"), ol(this, "onInput", (n) => {
      if (n instanceof CustomEvent && n.type === "input" && !n.isTrusted && !n.bubbles)
        return;
      const s = n.target, r = this.items.get(s), a = "inputType" in n && n.inputType.startsWith("delete"), o = r.isEager(), l = a && o && r.unmasked(s.value) === "" ? "" : s.value;
      this.fixCursor(s, a, () => this.setValue(s, l));
    }), this.options = i, this.eventAbortController = new AbortController(), this.init(this.getInputs(e));
  }
  update(e = {}) {
    this.options = { ...e }, this.init(Array.from(this.items.keys()));
  }
  updateValue(e) {
    e.value !== "" && e.value !== this.processInput(e).masked && this.setValue(e, e.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(e) {
    const i = this.getOptions(this.options);
    for (const n of e) {
      if (!this.items.has(n)) {
        const { signal: r } = this.eventAbortController;
        n.addEventListener("input", this.onInput, { capture: !0, signal: r });
      }
      const s = new Yk(Xk(n, i));
      this.items.set(n, s), queueMicrotask(() => this.updateValue(n)), n.selectionStart === null && s.isEager() && console.warn("Maska: input of `%s` type is not supported", n.type);
    }
  }
  getInputs(e) {
    return typeof e == "string" ? Array.from(document.querySelectorAll(e)) : "length" in e ? Array.from(e) : [e];
  }
  getOptions(e) {
    const { onMaska: i, preProcess: n, postProcess: s, ...r } = e;
    return r;
  }
  fixCursor(e, i, n) {
    const s = e.selectionStart, r = e.value;
    if (n(), s === null || s === r.length && !i) return;
    const a = e.value, o = r.slice(0, s), l = a.slice(0, s), u = this.processInput(e, o).unmasked, d = this.processInput(e, l).unmasked;
    let c = s;
    o !== l && (c += i ? a.length - r.length : u.length - d.length), e.setSelectionRange(c, c);
  }
  setValue(e, i) {
    const n = this.processInput(e, i);
    e.value = n.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((s) => s(n)) : this.options.onMaska(n)), e.dispatchEvent(new CustomEvent("maska", { detail: n })), e.dispatchEvent(new CustomEvent("input", { detail: n.masked }));
  }
  processInput(e, i) {
    const n = this.items.get(e);
    let s = i ?? e.value;
    this.options.preProcess != null && (s = this.options.preProcess(s));
    let r = n.masked(s);
    return this.options.postProcess != null && (r = this.options.postProcess(r)), {
      masked: r,
      unmasked: n.unmasked(s),
      completed: n.completed(s)
    };
  }
}
const Fc = /* @__PURE__ */ new WeakMap(), Zk = (t, e) => {
  if (t.arg == null || t.instance == null) return;
  const i = "setup" in t.instance.$.type;
  t.arg in t.instance ? t.instance[t.arg] = e : i && console.warn("Maska: please expose `%s` using defineExpose", t.arg);
}, ll = (t, e) => {
  var i;
  const n = t instanceof HTMLInputElement ? t : t.querySelector("input");
  if (n == null || (n == null ? void 0 : n.type) === "file") return;
  let s = {};
  if (e.value != null && (s = typeof e.value == "string" ? { mask: e.value } : { ...e.value }), e.arg != null) {
    const r = (a) => {
      const o = e.modifiers.unmasked ? a.unmasked : e.modifiers.completed ? a.completed : a.masked;
      Zk(e, o);
    };
    s.onMaska = s.onMaska == null ? r : Array.isArray(s.onMaska) ? [...s.onMaska, r] : [s.onMaska, r];
  }
  Fc.has(n) ? (i = Fc.get(n)) == null || i.update(s) : Fc.set(n, new Qk(n, s));
}, Kk = ["for"], Jk = {
  key: 0,
  class: "container__hint hint"
}, $k = {
  key: 0,
  class: "hint__label"
}, eP = {
  key: 2,
  class: "hint__icon-required icon-required"
}, tP = {
  key: 3,
  class: "hint__counter"
}, iP = {
  key: 0,
  class: "input-block__icon-left"
}, nP = ["id", "data-maska", "data-maska-tokens", "data-maska-reversed", "type", "placeholder", "data-test-id", "disabled", "maxlength", "enterkeyhint", "inputmode", "name", "readonly"], sP = {
  key: 0,
  class: "input-block__unit"
}, rP = {
  key: 1,
  class: "input-block__wrapper"
}, aP = {
  key: 2,
  class: "input-block__wrapper"
}, oP = {
  key: 0,
  class: "ui-input__error-message"
}, lP = {
  key: 1,
  class: "ui-input__hint-message"
}, uP = /* @__PURE__ */ qe({
  name: "UiInput",
  __name: "UiInput",
  props: {
    size: {
      type: String,
      default: "m"
    },
    modelValue: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    resetButton: {
      type: Boolean,
      required: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    counter: {
      type: Boolean,
      default: !1
    },
    maxLength: {
      type: Number,
      default: 255
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    unit: {
      type: String,
      default: ""
    },
    tooltipMessage: {
      type: String,
      default: ""
    },
    mask: {
      type: [String, Array, Object, null, Array, void 0],
      default: null
    },
    maskTokens: {
      type: [String, Array, Object, null, Array, void 0],
      default: ""
    },
    dataMaskaReversed: {
      type: Boolean,
      default: !1
    },
    maskaOptions: {
      type: [String, Array, Object, null, Array, void 0],
      default: ""
    },
    enterKeyHint: {
      type: String,
      default: "enter"
    },
    inputMode: {
      type: String,
      default: "text"
    },
    name: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    variant: {
      type: String,
      default: "stroke"
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:modelValue",
    "blur",
    "input",
    "focus",
    "enter"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = t, s = i, r = Yi(), { width: a } = Rn(), o = pe(0), l = pe(null), u = pe(null), d = pe(null), c = pe(!1), A = {
      s: 14,
      m: 16,
      l: 18
    }, m = J(() => `${a.value <= 1023 ? A[n.size] - 2 : A[n.size]}px`), p = J(() => n.resetButton && n.modelValue.trim() !== ""), h = J(() => n.unit && b.value), g = J(() => n.error || n.errorMessage.length > 0), w = J(() => p.value && n.modelValue !== ""), b = J({
      get() {
        return n.modelValue;
      },
      set(H) {
        s("update:modelValue", H);
      }
    }), y = J(() => b.value && n.unit ? { maxWidth: o.value } : { maxWidth: "100%" }), D = J(
      () => `${b.value.length}/${n.maxLength}`
    ), I = (H) => {
      const O = H.target;
      s("input", O.value);
    }, M = () => {
      document.getElementById(n.inputId).focus();
    }, _ = J(() => n.label || n.tooltipMessage || n.required || n.counter), N = J(() => n.type === "password" ? c.value ? "text" : "password" : n.type), x = J(
      () => c.value ? eC : XS
    ), C = () => {
      if (n.unit && d.value) {
        const H = getComputedStyle(d.value), O = document.createElement("span");
        O.style.position = "absolute", O.style.visibility = "hidden", O.style.whiteSpace = "pre", O.style.fontFamily = H.fontFamily, O.style.fontSize = m.value, O.style.fontVariantNumeric = "lining-nums proportional-nums", O.textContent = b.value || " ", document.body.appendChild(O), o.value = `${O.offsetWidth + 1}px`, document.body.removeChild(O);
      }
    }, L = () => {
      n.type === "password" && (c.value = !c.value);
    }, V = () => {
      s("enter");
    };
    return Vs(() => {
      (b.value || n.unit) && C();
    }), Ol(() => {
      u.value && document.body.removeChild(u.value);
    }), e({
      focus: M
    }), (H, O) => (k(), U("div", {
      class: we(["ui-input", [
        `ui-input_size_${t.size}`,
        { "ui-input_disabled": t.disabled },
        { "ui-input_readonly": t.readonly },
        { "ui-input_error": g.value }
      ]])
    }, [
      re("label", {
        class: "ui-input__container",
        for: t.inputId
      }, [
        _.value ? (k(), U("span", Jk, [
          t.label ? (k(), U("span", $k, _e(t.label), 1)) : ie("", !0),
          t.tooltipMessage ? (k(), Ce(aa, {
            key: 1,
            class: "ui-tooltip",
            size: "m",
            "tooltip-message": t.tooltipMessage
          }, null, 8, ["tooltip-message"])) : ie("", !0),
          t.required ? (k(), U("span", eP)) : ie("", !0),
          t.counter ? (k(), U("span", tP, _e(D.value), 1)) : ie("", !0)
        ])) : ie("", !0),
        re("span", {
          ref_key: "textArea",
          ref: l,
          class: we(["ui-input__input-block input-block", `input-block_${t.variant}`])
        }, [
          Y(r).hasOwnProperty("icon-left") ? (k(), U("span", iP, [
            Se(H.$slots, "icon-left", {}, void 0, !0)
          ])) : ie("", !0),
          re("span", {
            ref_key: "textArea",
            ref: l,
            class: "ui-input__input-wrapper input-wrapper"
          }, [
            Ci(re("input", {
              id: t.inputId,
              ref_key: "inputElement",
              ref: d,
              "onUpdate:modelValue": O[0] || (O[0] = (X) => b.value = X),
              class: "input-block__input input",
              "data-maska": t.mask,
              "data-maska-tokens": t.maskTokens,
              "data-maska-reversed": t.dataMaskaReversed,
              type: N.value,
              placeholder: t.placeholder,
              "data-test-id": t.dataTestId,
              disabled: t.disabled,
              maxlength: t.maxLength,
              style: Nt(y.value),
              enterkeyhint: t.enterKeyHint,
              inputmode: t.inputMode,
              name: t.name,
              readonly: t.readonly,
              onBlur: O[1] || (O[1] = (X) => s("blur")),
              onInput: I,
              onKeyup: Yu(V, ["enter"])
            }, null, 44, nP), [
              [I2, b.value],
              [Y(ll), t.maskaOptions]
            ]),
            h.value ? (k(), U("span", sP, _e(t.unit), 1)) : ie("", !0)
          ], 512),
          t.type === "password" ? (k(), U("span", rP, [
            re("button", {
              type: "button",
              class: "input-block__button button",
              onClick: L
            }, [
              (k(), Ce(Ft(x.value), { class: "button__show" }))
            ])
          ])) : (k(), U("span", aP, [
            w.value ? (k(), U("button", {
              key: 0,
              type: "button",
              class: "input-block__button button",
              onClick: O[2] || (O[2] = (X) => b.value = "")
            }, [
              ke(Y(po), { class: "button__icon" })
            ])) : ie("", !0)
          ]))
        ], 2)
      ], 8, Kk),
      g.value ? (k(), U("p", oP, _e(t.errorMessage), 1)) : ie("", !0),
      t.hintMessage && !g.value ? (k(), U("p", lP, _e(t.hintMessage), 1)) : ie("", !0)
    ], 2));
  }
}), zd = /* @__PURE__ */ tt(uP, [["__scopeId", "data-v-1b058c2b"]]), dP = ["target", "href", "data-test-id"], cP = /* @__PURE__ */ qe({
  __name: "UiLink",
  props: {
    link: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    target: {
      type: String,
      default: "_blank"
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (e, i) => (k(), U("a", {
      class: "ui-link",
      target: t.target,
      href: t.link,
      "data-test-id": t.dataTestId
    }, _e(t.label), 9, dP));
  }
}), Bq = /* @__PURE__ */ tt(cP, [["__scopeId", "data-v-4bc0ed59"]]), fP = { class: "ui-text-button__label label" }, hP = /* @__PURE__ */ qe({
  name: "UiTextButton",
  __name: "UiTextButton",
  props: {
    color: {
      type: String,
      default: "primary"
    },
    label: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "button"
    },
    size: {
      type: String,
      default: "l"
    },
    href: {
      type: String,
      default: ""
    },
    to: {
      type: Object,
      default: null
    },
    target: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    download: {
      type: Boolean,
      default: !1
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const e = t, i = J(() => e.href && !e.to && !e.disabled ? "a" : !e.href && e.to && !e.disabled ? "router-link" : "button");
    return (n, s) => (k(), Ce(Ft(i.value), {
      href: t.href,
      download: t.download && t.href,
      disabled: t.disabled,
      to: t.to,
      target: t.target,
      "data-test-id": t.dataTestId,
      class: we(["ui-text-button", [`ui-text-button_color_${t.color}`, `ui-text-button_size_${t.size}`]]),
      type: t.type
    }, {
      default: De(() => [
        Se(n.$slots, "left", {}, void 0, !0),
        Se(n.$slots, "default", {}, () => [
          re("span", fP, _e(t.label), 1)
        ], !0),
        Se(n.$slots, "right", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["href", "download", "disabled", "to", "target", "data-test-id", "class", "type"]));
  }
}), ja = /* @__PURE__ */ tt(hP, [["__scopeId", "data-v-5f01b98c"]]), pP = ["id"], mP = { class: "ui-notification__info" }, AP = { key: 0 }, gP = { key: 1 }, vP = /* @__PURE__ */ qe({
  name: "UiNotification",
  __name: "UiNotification",
  props: {
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    size: {
      type: String,
      default: "m"
    },
    type: {
      type: String,
      default: "neutral"
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    showClose: {
      type: Boolean,
      default: !0
    },
    mainButton: {
      type: String,
      default: ""
    },
    secondaryButton: {
      type: String,
      default: ""
    }
  },
  emits: ["close"],
  setup(t) {
    const e = t, i = {
      neutral: is,
      info: is,
      warning: d0,
      success: l0,
      error: po
    }, n = J(() => i[e.type]);
    return (s, r) => (k(), U("div", {
      id: t.id,
      class: we(["ui-notification", [`ui-notification_${t.type}`, `ui-notification_size_${t.size}`]])
    }, [
      (k(), Ce(Ft(n.value))),
      re("div", mP, [
        t.title ? (k(), U("h5", AP, _e(t.title), 1)) : ie("", !0),
        t.text ? (k(), U("p", gP, _e(t.text), 1)) : ie("", !0),
        Se(s.$slots, "default", {}, () => [
          t.mainButton ? (k(), Ce(ja, {
            key: 0,
            label: t.mainButton,
            size: t.size
          }, null, 8, ["label", "size"])) : ie("", !0),
          t.secondaryButton ? (k(), Ce(ja, {
            key: 1,
            label: t.secondaryButton,
            size: t.size,
            color: "secondary"
          }, null, 8, ["label", "size"])) : ie("", !0)
        ], !0)
      ]),
      t.showClose ? (k(), U("button", {
        key: 0,
        type: "button",
        "aria-label": "close",
        onClick: r[0] || (r[0] = (a) => s.$emit("close"))
      }, [
        ke(Y(na))
      ])) : ie("", !0)
    ], 10, pP));
  }
}), Lq = /* @__PURE__ */ tt(vP, [["__scopeId", "data-v-577e2953"]]), yP = ["name", "value", "data-test-id", "checked", "disabled"], bP = {
  key: 0,
  class: "ui-radio__error-message"
}, wP = /* @__PURE__ */ qe({
  name: "UiRadioButton",
  __name: "UiRadioButton",
  props: {
    label: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    modelValue: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    resizeTextType: {
      type: String,
      default: "hug"
    },
    name: {
      type: String,
      default: ""
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = (r) => {
      if (r && "target" in r) {
        const a = r.target;
        n("update:modelValue", i.value ? a.value : i.label);
      } else
        console.error("Event или event.target равны null или undefined");
    };
    return (r, a) => (k(), U(Xe, null, [
      re("div", {
        class: we(["ui-radio", `ui-radio_size_${t.size}`])
      }, [
        re("label", {
          class: we(["ui-radio__label label", [
            {
              label_disabled: t.disabled,
              label_error: t.error || t.errorMessage
            }
          ]])
        }, [
          re("input", {
            type: "radio",
            name: t.name,
            value: t.value,
            "data-test-id": t.dataTestId,
            checked: t.modelValue === t.value,
            disabled: t.disabled,
            onChange: s
          }, null, 40, yP),
          a[0] || (a[0] = re("span", { class: "label__checkmark" }, null, -1)),
          t.label ? (k(), U("span", {
            key: 0,
            class: we([`label__resize-text_${t.resizeTextType}`, "label__text"])
          }, _e(t.label), 3)) : ie("", !0)
        ], 2)
      ], 2),
      t.errorMessage ? (k(), U("p", bP, _e(t.errorMessage), 1)) : ie("", !0)
    ], 64));
  }
}), Nq = /* @__PURE__ */ tt(wP, [["__scopeId", "data-v-25501fa7"]]), TP = {
  key: 0,
  class: "ui-segments__header header"
}, xP = {
  key: 0,
  class: "header__label"
}, SP = { class: "ui-segments__segments segments" }, CP = ["onClick"], EP = { class: "segment__title" }, DP = /* @__PURE__ */ qe({
  name: "UiSegmentedControl",
  __name: "UiSegmentedControl",
  props: {
    segments: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "m"
    },
    label: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = (a) => {
      n("update:modelValue", a);
    }, r = J(() => i.label !== "" || i.hint !== "");
    return (a, o) => (k(), U("div", {
      class: we(["ui-segments", `ui-segments__size_${i.size}`])
    }, [
      r.value ? (k(), U("div", TP, [
        t.label ? (k(), U("span", xP, _e(t.label), 1)) : ie("", !0),
        t.hint ? (k(), Ce(Fd, {
          key: 1,
          class: "header__hint",
          "hint-content": t.hint
        }, {
          default: De(() => [
            ke(Y(is), {
              size: t.size,
              class: "info"
            }, null, 8, ["size"])
          ]),
          _: 1
        }, 8, ["hint-content"])) : ie("", !0)
      ])) : ie("", !0),
      re("div", SP, [
        (k(!0), U(Xe, null, ut(t.segments, (l) => (k(), U("button", {
          key: l.id,
          type: "button",
          class: we(["segments__segment segment", {
            segment_selected: l.id === t.modelValue
          }]),
          onClick: (u) => s(l.id)
        }, [
          l.icon ? (k(), Ce(Ft(l.icon), { key: 0 })) : ie("", !0),
          re("span", EP, _e(l.title), 1)
        ], 10, CP))), 128))
      ])
    ], 2));
  }
}), Rq = /* @__PURE__ */ tt(DP, [["__scopeId", "data-v-c53b699c"]]), _P = ["checked", "disabled", "value", "data-test-id"], kP = /* @__PURE__ */ qe({
  name: "UiSwitch",
  __name: "UiSwitch",
  props: {
    label: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    value: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [Array, String, Number, Boolean],
      default: ""
    },
    trueValue: {
      type: [String, Boolean, Number],
      default: !0
    },
    falseValue: {
      type: [String, Boolean, Number],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    textPosition: {
      type: String,
      default: "left"
    },
    resizeTextType: {
      type: String,
      default: "hug"
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "change"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = J(() => Array.isArray(i.modelValue) ? i.modelValue.includes(i.value) : i.modelValue === i.trueValue), r = (a) => {
      const o = a.target.checked;
      if (Array.isArray(i.modelValue)) {
        const l = [...i.modelValue];
        o ? l.push(i.value) : l.splice(l.indexOf(i.value), 1), n("update:modelValue", l);
      } else
        n("update:modelValue", o ? i.trueValue : i.falseValue);
      n("change", o ? i.trueValue : i.falseValue);
    };
    return (a, o) => (k(), U("div", {
      class: we(["ui-switch", `ui-switch_size_${t.size}`])
    }, [
      re("label", {
        class: we(["ui-switch__label label", [
          {
            label_disabled: t.disabled
          },
          `label_text-position_${t.textPosition}`
        ]])
      }, [
        re("input", {
          type: "checkbox",
          checked: s.value,
          disabled: t.disabled,
          value: t.value,
          "data-test-id": t.dataTestId,
          onChange: r
        }, null, 40, _P),
        o[0] || (o[0] = re("span", { class: "ui-switch__switch switch" }, [
          re("span", { class: "switch__circle circle" })
        ], -1)),
        Se(a.$slots, "default", {}, () => [
          t.label ? (k(), U("span", {
            key: 0,
            class: we(`ui-switch__text ui-switch__text_${t.resizeTextType}`)
          }, _e(t.label), 3)) : ie("", !0)
        ], !0)
      ], 2)
    ], 2));
  }
}), Fq = /* @__PURE__ */ tt(kP, [["__scopeId", "data-v-0d5bc303"]]), PP = /* @__PURE__ */ qe({
  name: "UiTabs",
  __name: "UiTab",
  props: {
    label: {
      type: String,
      required: !0
    },
    selected: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "l"
    }
  },
  setup(t) {
    return (e, i) => (k(), U("button", {
      type: "button",
      class: we(["ui-tab", [
        `ui-tab_${t.size}`,
        {
          "ui-tab_selected": t.selected
        }
      ]])
    }, [
      Se(e.$slots, "default", {}, void 0, !0),
      re("p", null, _e(t.label), 1)
    ], 2));
  }
}), IP = /* @__PURE__ */ tt(PP, [["__scopeId", "data-v-7cd6c495"]]), MP = 6, OP = 0.5, M0 = Ll ? window : void 0;
function Ko(t) {
  var e;
  const i = kt(t);
  return (e = i == null ? void 0 : i.$el) != null ? e : i;
}
function ya(...t) {
  const e = [], i = () => {
    e.forEach((o) => o()), e.length = 0;
  }, n = (o, l, u, d) => (o.addEventListener(l, u, d), () => o.removeEventListener(l, u, d)), s = J(() => {
    const o = Hr(kt(t[0])).filter((l) => l != null);
    return o.every((l) => typeof l != "string") ? o : void 0;
  }), r = m0(
    () => {
      var o, l;
      return [
        (l = (o = s.value) == null ? void 0 : o.map((u) => Ko(u))) != null ? l : [M0].filter((u) => u != null),
        Hr(kt(s.value ? t[1] : t[0])),
        Hr(Y(s.value ? t[2] : t[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        kt(s.value ? t[3] : t[2])
      ];
    },
    ([o, l, u, d]) => {
      if (i(), !(o != null && o.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const c = f0(d) ? { ...d } : d;
      e.push(
        ...o.flatMap(
          (A) => l.flatMap(
            (m) => u.map((p) => n(A, m, p, c))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    r(), i();
  };
  return sa(i), a;
}
let PA = !1;
function IA(t, e, i = {}) {
  const { window: n = M0, ignore: s = [], capture: r = !0, detectIframe: a = !1, controls: o = !1 } = i;
  if (!n)
    return o ? { stop: Li, cancel: Li, trigger: Li } : Li;
  if (Wa && !PA) {
    PA = !0;
    const g = { passive: !0 };
    Array.from(n.document.body.children).forEach((w) => ya(w, "click", Li, g)), ya(n.document.documentElement, "click", Li, g);
  }
  let l = !0;
  const u = (g) => kt(s).some((w) => {
    if (typeof w == "string")
      return Array.from(n.document.querySelectorAll(w)).some((b) => b === g.target || g.composedPath().includes(b));
    {
      const b = Ko(w);
      return b && (g.target === b || g.composedPath().includes(b));
    }
  });
  function d(g) {
    const w = kt(g);
    return w && w.$.subTree.shapeFlag === 16;
  }
  function c(g, w) {
    const b = kt(g), y = b.$.subTree && b.$.subTree.children;
    return y == null || !Array.isArray(y) ? !1 : y.some((D) => D.el === w.target || w.composedPath().includes(D.el));
  }
  const A = (g) => {
    const w = Ko(t);
    if (g.target != null && !(!(w instanceof Element) && d(t) && c(t, g)) && !(!w || w === g.target || g.composedPath().includes(w))) {
      if ("detail" in g && g.detail === 0 && (l = !u(g)), !l) {
        l = !0;
        return;
      }
      e(g);
    }
  };
  let m = !1;
  const p = [
    ya(n, "click", (g) => {
      m || (m = !0, setTimeout(() => {
        m = !1;
      }, 0), A(g));
    }, { passive: !0, capture: r }),
    ya(n, "pointerdown", (g) => {
      const w = Ko(t);
      l = !u(g) && !!(w && !g.composedPath().includes(w));
    }, { passive: !0 }),
    a && ya(n, "blur", (g) => {
      setTimeout(() => {
        var w;
        const b = Ko(t);
        ((w = n.document.activeElement) == null ? void 0 : w.tagName) === "IFRAME" && !(b != null && b.contains(n.document.activeElement)) && e(g);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), h = () => p.forEach((g) => g());
  return o ? {
    stop: h,
    cancel: () => {
      l = !1;
    },
    trigger: (g) => {
      l = !0, A(g), l = !1;
    }
  } : h;
}
const BP = {
  mounted(t, e) {
    const i = !e.modifiers.bubble;
    if (typeof e.value == "function")
      t.__onClickOutside_stop = IA(t, e.value, { capture: i });
    else {
      const [n, s] = e.value;
      t.__onClickOutside_stop = IA(t, n, Object.assign({ capture: i }, s));
    }
  },
  unmounted(t) {
    t.__onClickOutside_stop();
  }
};
function zc(t) {
  return typeof Window < "u" && t instanceof Window ? t.document.documentElement : typeof Document < "u" && t instanceof Document ? t.documentElement : t;
}
function O0(t) {
  const e = window.getComputedStyle(t);
  if (e.overflowX === "scroll" || e.overflowY === "scroll" || e.overflowX === "auto" && t.clientWidth < t.scrollWidth || e.overflowY === "auto" && t.clientHeight < t.scrollHeight)
    return !0;
  {
    const i = t.parentNode;
    return !i || i.tagName === "BODY" ? !1 : O0(i);
  }
}
function LP(t) {
  const e = t || window.event, i = e.target;
  return O0(i) ? !1 : e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}
const Uc = /* @__PURE__ */ new WeakMap();
function NP(t, e = !1) {
  const i = Tt(e);
  let n = null, s = "";
  mt(p0(t), (o) => {
    const l = zc(kt(o));
    if (l) {
      const u = l;
      if (Uc.get(u) || Uc.set(u, u.style.overflow), u.style.overflow !== "hidden" && (s = u.style.overflow), u.style.overflow === "hidden")
        return i.value = !0;
      if (i.value)
        return u.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const o = zc(kt(t));
    !o || i.value || (Wa && (n = ya(
      o,
      "touchmove",
      (l) => {
        LP(l);
      },
      { passive: !1 }
    )), o.style.overflow = "hidden", i.value = !0);
  }, a = () => {
    const o = zc(kt(t));
    !o || !i.value || (Wa && (n == null || n()), o.style.overflow = s, Uc.delete(o), i.value = !1);
  };
  return sa(a), J({
    get() {
      return i.value;
    },
    set(o) {
      o ? r() : a();
    }
  });
}
function RP() {
  let t = !1;
  const e = Tt(!1);
  return (i, n) => {
    if (e.value = n.value, t)
      return;
    t = !0;
    const s = NP(i, n.value);
    mt(e, (r) => s.value = r);
  };
}
RP();
const FP = { class: "dropdown-checkbox" }, zP = { class: "dropdown-checkbox__label label" }, UP = ["checked", "value"], VP = /* @__PURE__ */ qe({
  name: "DropdownCheckbox",
  __name: "DropdownCheckbox",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = J(() => i.modelValue.includes(i.value)), r = (a) => {
      const l = a.target.checked, u = [...i.modelValue];
      l ? u.push(i.value) : u.splice(u.indexOf(i.value), 1), n("update:modelValue", u);
    };
    return (a, o) => (k(), U("div", FP, [
      re("label", zP, [
        re("input", {
          type: "checkbox",
          checked: s.value,
          value: t.value,
          onChange: r
        }, null, 40, UP),
        o[0] || (o[0] = re("span", null, null, -1)),
        ke(Ri, { name: "checkmark" }, {
          default: De(() => [
            s.value ? (k(), Ce(Y(Gh), {
              key: 0,
              class: "done"
            })) : ie("", !0)
          ]),
          _: 1
        })
      ])
    ]));
  }
}), qP = /* @__PURE__ */ tt(VP, [["__scopeId", "data-v-a206a426"]]), HP = { class: "ui-dropdown-item-label" }, WP = {
  key: 0,
  class: "ui-dropdown-item-label__counter"
}, YP = /* @__PURE__ */ qe({
  __name: "DropdownText",
  props: {
    label: {
      type: String,
      default: ""
    },
    counter: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (e, i) => (k(), U("div", HP, [
      re("p", null, _e(t.label), 1),
      t.counter ? (k(), U("p", WP, _e(t.counter), 1)) : ie("", !0)
    ]));
  }
}), MA = /* @__PURE__ */ tt(YP, [["__scopeId", "data-v-a0ce0be4"]]), XP = {
  key: 0,
  class: "ui-dropdown-item__header"
}, jP = { class: "ui-dropdown-item-text short" }, GP = {
  key: 0,
  class: "ui-dropdown-item-text__description"
}, QP = {
  key: 2,
  class: "ui-dropdown-item__checked"
}, ZP = {
  key: 1,
  class: "ui-dropdown-item-multiple"
}, KP = { class: "intermediate-container" }, JP = { class: "ui-dropdown-item-text" }, $P = { class: "ui-dropdown-item-text__description" }, e3 = {
  key: 1,
  class: "ui-dropdown-item__hr"
}, t3 = /* @__PURE__ */ qe({
  name: "UiDropdownItem",
  __name: "UiDropdownItem",
  props: {
    modelValue: {
      type: [String, Number, Array],
      default: ""
    },
    option: {
      type: Object,
      default: () => {
      }
    },
    type: {
      type: String,
      default: "single"
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = J({
      get() {
        return i.modelValue;
      },
      set(l) {
        n("update:modelValue", l);
      }
    }), r = () => {
      if (!Array.isArray(i.modelValue))
        return;
      const l = i.modelValue.includes(i.option.id), u = [...i.modelValue];
      l ? u.splice(u.indexOf(i.option.id), 1) : u.push(i.option.id), s.value = u;
    }, a = () => {
      switch (i.type) {
        case "single":
          s.value = i.option.id;
          break;
        case "multiple":
          r();
          break;
      }
    }, o = J(() => i.option.color ? {
      backgroundColor: i.option.color
    } : {});
    return (l, u) => (k(), U("div", {
      class: we(["ui-dropdown-item", `ui-dropdown-item__type_${t.type}`])
    }, [
      t.option.optionTitle ? (k(), U("p", XP, _e(t.option.optionTitle), 1)) : ie("", !0),
      re("div", {
        class: "ui-dropdown-item__container",
        onClick: a
      }, [
        t.type === "single" ? (k(), U(Xe, { key: 0 }, [
          t.option.optionIcon ? (k(), Ce(Ft(t.option.optionIcon), {
            key: 0,
            class: "ui-dropdown-item__icon"
          })) : ie("", !0),
          t.option.color ? (k(), U("div", {
            key: 1,
            class: "ui-dropdown-item__color",
            style: Nt(o.value)
          }, null, 4)) : ie("", !0),
          re("div", jP, [
            ke(MA, {
              label: t.option.label,
              counter: t.option.counter
            }, null, 8, ["label", "counter"]),
            t.option.description ? (k(), U("div", GP, [
              re("p", null, _e(t.option.description), 1)
            ])) : ie("", !0)
          ]),
          s.value === t.option.id ? (k(), U("span", QP, [
            ke(Y(Gh))
          ])) : ie("", !0)
        ], 64)) : t.type === "multiple" ? (k(), U("div", ZP, [
          ke(qP, {
            modelValue: s.value,
            "onUpdate:modelValue": u[0] || (u[0] = (d) => s.value = d),
            value: t.option.id,
            class: "ui-dropdown-item-multiple__checkbox",
            onClick: u[1] || (u[1] = $t(() => {
            }, ["stop"]))
          }, null, 8, ["modelValue", "value"]),
          re("div", KP, [
            t.option.color ? (k(), U("div", {
              key: 0,
              class: "ui-dropdown-item__color",
              style: Nt(o.value)
            }, null, 4)) : ie("", !0),
            re("div", JP, [
              ke(MA, {
                label: t.option.label,
                counter: t.option.counter
              }, null, 8, ["label", "counter"])
            ])
          ]),
          re("div", $P, [
            re("p", null, _e(t.option.description), 1)
          ])
        ])) : ie("", !0)
      ]),
      t.option.borderBottom ? (k(), U("div", e3)) : ie("", !0)
    ], 2));
  }
}), OA = /* @__PURE__ */ tt(t3, [["__scopeId", "data-v-2550ba2e"]]), i3 = ["disabled", "data-test-id"], n3 = /* @__PURE__ */ qe({
  name: "UiLocalButton",
  __name: "UiLocalButton",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (e, i) => (k(), U("button", {
      class: "ui-local-button",
      type: "button",
      disabled: t.disabled,
      "data-test-id": t.dataTestId
    }, [
      Se(e.$slots, "default", {}, void 0, !0)
    ], 8, i3));
  }
}), Ud = /* @__PURE__ */ tt(n3, [["__scopeId", "data-v-2ee861af"]]), s3 = /* @__PURE__ */ qe({
  name: "UiCloseButton",
  __name: "UiCloseButton",
  props: {
    dataTestId: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    return (e, i) => (k(), Ce(Ud, {
      class: "ui-close-button",
      "data-test-id": t.dataTestId
    }, {
      default: De(() => [
        ke(Y(na))
      ]),
      _: 1
    }, 8, ["data-test-id"]));
  }
}), B0 = /* @__PURE__ */ tt(s3, [["__scopeId", "data-v-7de6d99c"]]), r3 = { class: "main-container__animation-block animation-block" }, a3 = { key: 1 }, o3 = { key: 2 }, l3 = {
  key: 0,
  class: "input-container"
}, u3 = {
  key: 1,
  class: "empty-search"
}, d3 = {
  key: 2,
  class: "slot-container"
}, c3 = {
  key: 1,
  class: "animation-block__footer"
}, f3 = /* @__PURE__ */ qe({
  name: "UiBottomSheet",
  __name: "UiBottomSheet",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    isShowSearch: {
      type: Boolean,
      default: !1
    },
    hideHeader: {
      type: Boolean,
      default: !1
    },
    isEmptySearch: {
      type: Boolean,
      default: !1
    },
    search: {
      type: String,
      default: ""
    },
    zIndex: {
      type: Number,
      default: 999
    },
    isResetButton: {
      type: Boolean,
      default: !1
    },
    isShowResetButton: {
      type: Boolean,
      default: !1
    },
    isSelect: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "setRef",
    "update:search",
    "reset"
  ],
  setup(t, { emit: e }) {
    const i = t, n = e, s = J({
      get() {
        return i.modelValue;
      },
      set(D) {
        n("update:modelValue", D);
      }
    }), r = J({
      get() {
        return i.search;
      },
      set(D) {
        n("update:search", D);
      }
    }), a = (D) => {
      n("setRef", D);
    }, o = J(() => ({
      zIndex: i.zIndex
    })), l = Yi(), u = document.body, d = Zh(u);
    mt(s, (D) => {
      d.value = D, D || c();
    });
    function c() {
      g.value = "0", w.value = 1;
    }
    const A = Tt(null), m = Tt(null), p = Tt(null), h = J(() => {
      var D;
      return (D = p.value) == null ? void 0 : D.offsetWidth;
    }), g = Tt("0"), w = Tt(1), { lengthY: b } = vA(A, {
      passive: !1,
      onSwipe() {
        if (h.value)
          if (b.value < 0) {
            const D = Math.abs(b.value);
            g.value = `-${D}px`, w.value = 1.25 - D / h.value;
          } else
            g.value = "0", w.value = 1;
      },
      onSwipeEnd() {
        b.value < 0 && h.value && Math.abs(b.value) / h.value >= 0.2 ? (g.value = "0", w.value = 0, s.value = !1) : (g.value = "0", w.value = 1);
      }
    }), { lengthY: y } = vA(m, {
      passive: !1,
      onSwipe() {
        if (h.value)
          if (y.value < 0) {
            const D = Math.abs(y.value);
            g.value = `-${D}px`, w.value = 1.25 - D / h.value;
          } else
            g.value = "0", w.value = 1;
      },
      onSwipeEnd() {
        y.value < 0 && h.value && Math.abs(y.value) / h.value >= 0.2 ? (g.value = "0", w.value = 0, s.value = !1) : (g.value = "0", w.value = 1);
      }
    });
    return (D, I) => (k(), Ce(br, { to: "body" }, [
      ke(Ri, {
        name: "ui-bottom-sheet",
        mode: "out-in"
      }, {
        default: De(() => [
          s.value ? (k(), U("div", {
            key: 0,
            ref: (M) => a(M),
            style: Nt(o.value),
            class: "ui-bottom-sheet",
            onClick: I[4] || (I[4] = $t((M) => s.value = !1, ["stop"]))
          }, [
            re("div", {
              ref_key: "mainContainerRef",
              ref: p,
              style: Nt({ bottom: g.value, opacity: w.value }),
              class: we(["ui-bottom-sheet__main-container main-container", { "main-container_full-height": t.isShowSearch }]),
              onClick: I[3] || (I[3] = $t(() => {
              }, ["stop"]))
            }, [
              re("div", {
                ref_key: "swipingContainer2",
                ref: m,
                class: "main-container__indicator-container"
              }, I[5] || (I[5] = [
                re("div", null, null, -1)
              ]), 512),
              re("div", r3, [
                re("div", {
                  ref_key: "swipingContainer",
                  ref: A,
                  class: we(["animation-block__header", { "animation-block__header_reset-button": t.isResetButton }])
                }, [
                  t.isShowResetButton ? (k(), Ce(ja, {
                    key: 0,
                    disabled: !t.isShowResetButton,
                    class: we({ "not-show": !t.isShowResetButton }),
                    label: "Сбросить",
                    size: "m",
                    onClick: I[0] || (I[0] = $t((M) => n("reset"), ["stop"]))
                  }, null, 8, ["disabled", "class"])) : ie("", !0),
                  t.label ? (k(), U("h4", a3, _e(t.label), 1)) : ie("", !0),
                  t.subTitle ? (k(), U("p", o3, _e(t.subTitle), 1)) : ie("", !0),
                  Se(D.$slots, "content-header", {}, void 0, !0),
                  t.hideHeader ? ie("", !0) : (k(), Ce(B0, {
                    key: 3,
                    class: "close-button",
                    onClick: I[1] || (I[1] = (M) => s.value = !1)
                  }))
                ], 2),
                Y(l).default ? (k(), U("div", {
                  key: 0,
                  class: we(["animation-block__body", { "animation-block__body_select": t.isSelect }])
                }, [
                  t.isShowSearch ? (k(), U("div", l3, [
                    ke(zd, {
                      modelValue: r.value,
                      "onUpdate:modelValue": I[2] || (I[2] = (M) => r.value = M),
                      size: "m",
                      "reset-button": "",
                      placeholder: "Поиск"
                    }, {
                      "icon-left": De(() => [
                        ke(Y(ZS))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])) : ie("", !0),
                  t.isEmptySearch ? (k(), U("p", u3, "Ничего не найдено")) : ie("", !0),
                  Y(l).default ? (k(), U("div", d3, [
                    Se(D.$slots, "default", {}, void 0, !0)
                  ])) : ie("", !0)
                ], 2)) : ie("", !0),
                Y(l).footer ? (k(), U("div", c3, [
                  Se(D.$slots, "footer", {}, void 0, !0)
                ])) : ie("", !0)
              ])
            ], 6)
          ], 4)) : ie("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), op = /* @__PURE__ */ tt(f3, [["__scopeId", "data-v-89ba562c"]]), h3 = { key: 1 }, p3 = /* @__PURE__ */ qe({
  name: "SelectItem",
  __name: "SelectItem",
  props: {
    optionItem: {
      type: Object,
      default: () => {
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    styleType: {
      type: String,
      default: "light"
    },
    size: {
      type: String,
      default: "m"
    },
    counter: {
      type: Number,
      default: -1
    }
  },
  emits: ["removeItem"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = () => {
      n("removeItem", i.optionItem.id);
    };
    return (r, a) => (k(), U("div", {
      class: we(["select-item", [
        `select-item__style-type_${t.styleType}`,
        `select-item__size_${t.size}`,
        { "select-item_disabled": t.disabled },
        { "select-item_counter": t.counter !== -1 }
      ]])
    }, [
      t.counter === -1 ? (k(), U(Xe, { key: 0 }, [
        re("span", null, _e(t.optionItem.label), 1),
        ke(Ud, {
          disabled: t.disabled,
          onClick: $t(s, ["stop"])
        }, {
          default: De(() => [
            ke(Y(na))
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 64)) : (k(), U("span", h3, "+" + _e(t.counter), 1))
    ], 2));
  }
}), sh = /* @__PURE__ */ tt(p3, [["__scopeId", "data-v-b60738c7"]]), m3 = ["id"], A3 = {
  key: 0,
  class: "checked-items"
}, g3 = {
  key: 1,
  class: "empty-search"
}, v3 = /* @__PURE__ */ qe({
  name: "UiDropdown",
  __name: "UiDropdown",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: [String, Number, Array],
      default: ""
    },
    open: {
      type: Boolean,
      default: !1
    },
    parentId: {
      type: String,
      required: !0
    },
    dropdownId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    type: {
      type: String,
      default: "single"
    },
    scrollContainerId: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    bottomSheetSubTitle: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "bottom-start"
    },
    selectedOption: {
      type: Array,
      default: () => []
    },
    isSelect: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "update:open", "initRef"],
  setup(t, { expose: e, emit: i }) {
    const n = t, s = i, { width: r } = Rn(), a = pe(""), o = J({
      get() {
        return n.open;
      },
      set(C) {
        s("update:open", C);
      }
    }), l = pe(null), u = J(() => n.parentId ?? ""), d = J(() => {
      var C, L;
      return (L = (C = l.value) == null ? void 0 : C.getBoundingClientRect()) == null ? void 0 : L.width;
    });
    Vs(async () => {
      await li(), l.value = document.getElementById(u.value) ?? null;
    });
    const c = pe(null), A = J({
      get() {
        return n.modelValue;
      },
      set(C) {
        s("update:modelValue", C);
      }
    });
    Vs(async () => {
      o.value ? (await li(), w()) : a.value = "";
    });
    const m = J(() => r.value <= 767), p = () => {
      o.value = !1;
    }, h = () => {
      n.type === "single" && (o.value = !1);
    }, g = (C) => {
      c.value = C, s("initRef", C);
    }, w = () => {
      !o.value || m.value || ap(l.value, c.value, {
        placement: n.position,
        middleware: [sp(8), rp({ padding: 5 }), Sk()]
      }).then(({ x: C, y: L }) => {
        Object.assign(c.value.style, {
          left: `${C}px`,
          top: `${L}px`,
          width: `${d.value}px`
        });
      });
    }, b = () => {
      if (!n.scrollContainerId)
        return;
      const C = document.getElementById(n.scrollContainerId);
      C == null || C.addEventListener("scroll", function() {
        w();
      });
    }, y = () => {
      if (!n.scrollContainerId)
        return;
      const C = document.getElementById(n.scrollContainerId);
      C == null || C.removeEventListener("scroll", function() {
        w();
      });
    }, D = J(() => n.options.filter((C) => C.label.toLowerCase().includes(a.value.toLowerCase()))), I = J(() => n.options.length > 15), M = J(
      () => I.value && a.value.trim().length !== 0 && D.value.length === 0
    );
    mt(A, () => {
      n.type === "multiple" && w();
    }), e({
      calculatePosition: w
    });
    const _ = J(() => n.type === "multiple"), N = J(
      () => Array.isArray(A.value) && _.value && A.value.length > 0
    ), x = (C) => {
      Array.isArray(A.value) && (A.value = A.value.filter(
        (L) => L !== C
      ));
    };
    return It(() => {
      document.addEventListener("keyup", function(C) {
        C.keyCode === 27 && (o.value = !1);
      }), b();
    }), Nn(() => {
      document.removeEventListener("keyup", function(C) {
        C.keyCode === 27 && (o.value = !1);
      }), y();
    }), (C, L) => m.value ? (k(), Ce(op, {
      key: 1,
      modelValue: o.value,
      "onUpdate:modelValue": L[2] || (L[2] = (V) => o.value = V),
      search: a.value,
      "onUpdate:search": L[3] || (L[3] = (V) => a.value = V),
      label: t.label,
      "is-reset-button": _.value,
      "is-select": t.isSelect,
      "sub-title": t.bottomSheetSubTitle,
      "is-empty-search": M.value,
      "is-show-search": I.value,
      "is-show-reset-button": N.value,
      onReset: L[4] || (L[4] = (V) => A.value = [])
    }, {
      default: De(() => [
        N.value ? (k(), U("div", A3, [
          (k(!0), U(Xe, null, ut(t.selectedOption, (V) => (k(), Ce(sh, {
            key: V,
            "option-item": V,
            onRemoveItem: x
          }, null, 8, ["option-item"]))), 128))
        ])) : ie("", !0),
        (k(!0), U(Xe, null, ut(D.value, (V) => (k(), Ce(OA, {
          key: V.id,
          modelValue: A.value,
          "onUpdate:modelValue": [
            L[1] || (L[1] = (H) => A.value = H),
            h
          ],
          type: t.type,
          option: V
        }, null, 8, ["modelValue", "type", "option"]))), 128)),
        Se(C.$slots, "loading", {}, void 0, !0),
        Se(C.$slots, "error", {}, void 0, !0),
        M.value ? (k(), U("p", g3, "Ничего не найдено")) : ie("", !0)
      ]),
      _: 3
    }, 8, ["modelValue", "search", "label", "is-reset-button", "is-select", "sub-title", "is-empty-search", "is-show-search", "is-show-reset-button"])) : (k(), Ce(br, {
      key: 0,
      to: "body"
    }, [
      ke(Ri, {
        name: "ui-dropdown",
        mode: "out-in"
      }, {
        default: De(() => [
          o.value ? Ci((k(), U("div", {
            key: 0,
            id: t.dropdownId,
            ref: (V) => g(V),
            class: "ui-dropdown elevation-shadow-high"
          }, [
            Se(C.$slots, "default", {}, () => [
              (k(!0), U(Xe, null, ut(t.options, (V) => (k(), Ce(OA, {
                key: V.id,
                modelValue: A.value,
                "onUpdate:modelValue": [
                  L[0] || (L[0] = (H) => A.value = H),
                  h
                ],
                type: t.type,
                option: V
              }, null, 8, ["modelValue", "type", "option"]))), 128))
            ], !0),
            Se(C.$slots, "loading", {}, void 0, !0),
            Se(C.$slots, "error", {}, void 0, !0)
          ], 8, m3)), [
            [
              Y(BP),
              p,
              void 0,
              { bubble: !0 }
            ]
          ]) : ie("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Rl = /* @__PURE__ */ tt(v3, [["__scopeId", "data-v-ccd53e45"]]), y3 = ["id"], b3 = /* @__PURE__ */ qe({
  __name: "UiTabs",
  props: {
    isScrollable: {
      type: Boolean,
      default: !1
    },
    labelSelector: {
      type: String,
      default: "Ещё"
    },
    tabs: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      default: "m"
    },
    selectorId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    bottomSheetTitle: {
      type: String,
      default: "bottomSheetTitle"
    },
    bottomSheetSubTitle: {
      type: String,
      default: "bottomSheetSubTitle"
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = J({
      get() {
        return i.modelValue;
      },
      set(x) {
        n("update:modelValue", x);
      }
    }), { width: r } = Rn(), { tabs: a, size: o } = jh(i), l = pe(!1), u = pe(!1), d = pe(!1), c = pe(!1), A = pe(null), m = pe(null), p = pe(null), h = J(
      () => i.isScrollable ? i.tabs.length : Math.min(i.tabs.length, MP)
    ), g = J(() => i.tabs.slice(0, h.value)), w = J(() => {
      if (i.tabs.length <= h.value)
        return [];
      const x = i.tabs.slice(h.value).map((C) => ({
        id: C.id,
        label: C.title,
        optionIcon: C.icon
      }));
      return [
        {
          id: performance.now(),
          options: x
        }
      ];
    }), b = J(
      () => i.tabs.length > h.value && !i.isScrollable
    ), y = J(
      () => {
        var x;
        return (x = w.value[0]) == null ? void 0 : x.options.some(
          (C) => C.id === i.modelValue
        );
      }
    ), D = (x) => x * OP, I = O_(() => {
      const x = A.value;
      if (!x)
        return;
      const L = x.scrollWidth > x.clientWidth && r.value >= 768;
      l.value = L;
      const { scrollLeft: V, scrollWidth: H, clientWidth: O } = x;
      u.value = L && V < H - O, d.value = L && V > 0;
    }, 100), M = (x) => {
      const C = A.value;
      if (!C)
        return;
      const { clientWidth: L, scrollLeft: V, scrollWidth: H } = C, O = D(L) * (x === "left" ? -1 : 1), X = H - L, q = V + O;
      d.value = q > 0, u.value = q < X, C.scrollBy({
        left: O,
        behavior: "smooth"
      });
    }, _ = () => {
      c.value = !c.value;
    };
    mt([a, o], I, { deep: !0 });
    const N = J(() => {
      var x;
      return (x = w.value[0]) == null ? void 0 : x.options;
    });
    return It(() => {
      I(), Ei(window, "resize", I);
    }), (x, C) => (k(), U("div", {
      ref_key: "wrapperRef",
      ref: m,
      class: we(["ui-tabs__wrapper", `ui-tabs__wrapper_${Y(o)}`])
    }, [
      d.value ? (k(), U("button", {
        key: 0,
        type: "button",
        class: "ui-tabs-arrow",
        onClick: C[0] || (C[0] = (L) => M("left"))
      }, [
        ke(Y(Bd), { class: "ui-tabs-arrow__icon" })
      ])) : ie("", !0),
      re("div", {
        ref_key: "tabsRef",
        ref: A,
        class: we(["ui-tabs", [`ui-tabs_size_${Y(o)}`, { "ui-tabs_scroll": t.isScrollable }]])
      }, [
        (k(!0), U(Xe, null, ut(g.value, (L) => (k(), Ce(IP, {
          key: L.id,
          label: L.title,
          size: Y(o),
          selected: L.id === t.modelValue,
          onClick: (V) => s.value = L.id
        }, {
          default: De(() => [
            L.icon ? (k(), Ce(Ft(L.icon), { key: 0 })) : ie("", !0)
          ]),
          _: 2
        }, 1032, ["label", "size", "selected", "onClick"]))), 128)),
        re("div", {
          id: t.selectorId,
          class: "ui-tabs__selector selector"
        }, [
          b.value ? (k(), U("button", {
            key: 0,
            type: "button",
            class: we(["selector__label label", { label_selected: y.value }]),
            onClick: $t(_, ["stop"])
          }, [
            Wi(_e(t.labelSelector) + " ", 1),
            re("span", {
              class: we(["label__icon icon-arrow-up", { label__icon_rotated: c.value }])
            }, null, 2)
          ], 2)) : ie("", !0),
          ke(Rl, {
            ref_key: "target",
            ref: p,
            modelValue: s.value,
            "onUpdate:modelValue": C[1] || (C[1] = (L) => s.value = L),
            open: c.value,
            "onUpdate:open": C[2] || (C[2] = (L) => c.value = L),
            options: N.value,
            "parent-id": t.selectorId,
            "is-select": "",
            label: t.bottomSheetTitle,
            "bottom-sheet-sub-title": t.bottomSheetSubTitle
          }, null, 8, ["modelValue", "open", "options", "parent-id", "label", "bottom-sheet-sub-title"])
        ], 8, y3)
      ], 2),
      u.value ? (k(), U("button", {
        key: 1,
        type: "button",
        class: "ui-tabs-arrow",
        onClick: C[3] || (C[3] = (L) => M("right"))
      }, [
        ke(Y(Bl), { class: "ui-tabs-arrow__icon" })
      ])) : ie("", !0)
    ], 2));
  }
}), zq = /* @__PURE__ */ tt(b3, [["__scopeId", "data-v-ec6609fe"]]), w3 = ["for"], T3 = { class: "container__hint hint" }, x3 = {
  key: 0,
  class: "hint__label"
}, S3 = {
  key: 2,
  class: "hint__icon-required icon-required"
}, C3 = {
  key: 3,
  class: "hint__counter"
}, E3 = ["id", "placeholder", "disabled", "data-test-id", "rows", "required", "maxlength", "minlength"], D3 = {
  key: 0,
  class: "ui-textarea__error-message"
}, _3 = {
  key: 1,
  class: "ui-textarea__hint-message"
}, k3 = /* @__PURE__ */ qe({
  name: "UiTextarea",
  __name: "UiTextarea",
  props: {
    size: {
      type: String,
      default: "l"
    },
    modelValue: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    counter: {
      type: Boolean,
      default: !1
    },
    maxLength: {
      type: Number,
      default: 255
    },
    minLength: {
      type: Number,
      default: 0
    },
    rows: {
      type: Number,
      default: 3
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    textareaId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    tooltipMessage: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: "stroke"
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = J(() => i.error && !i.disabled), r = J({
      get() {
        return i.modelValue;
      },
      set(l) {
        n("update:modelValue", l);
      }
    }), a = J(() => `${r.value.length}/${i.maxLength}`);
    function o(l) {
      const u = l.target;
      u.style.height = "auto", u.style.height = `${u.scrollHeight + 4}px`;
    }
    return It(() => {
      const l = document.getElementById(i.textareaId);
      i.modelValue !== "" && (l.style.overflow = "auto");
    }), (l, u) => (k(), U("div", {
      class: we(["ui-textarea", [
        `ui-textarea_size_${t.size}`,
        { "ui-textarea_disabled": t.disabled },
        { "ui-textarea_error": s.value }
      ]])
    }, [
      re("label", {
        for: t.textareaId,
        class: we(["ui-textarea__container", `ui-textarea__container_${t.variant}`])
      }, [
        re("span", T3, [
          t.label ? (k(), U("span", x3, _e(t.label), 1)) : ie("", !0),
          t.tooltipMessage ? (k(), Ce(aa, {
            key: 1,
            class: "ui-tooltip",
            size: "m",
            "tooltip-message": t.tooltipMessage
          }, null, 8, ["tooltip-message"])) : ie("", !0),
          t.required ? (k(), U("span", S3)) : ie("", !0),
          t.counter ? (k(), U("span", C3, _e(a.value), 1)) : ie("", !0)
        ]),
        Ci(re("textarea", {
          id: t.textareaId,
          "onUpdate:modelValue": u[0] || (u[0] = (d) => r.value = d),
          placeholder: t.placeholder,
          disabled: t.disabled,
          "data-test-id": t.dataTestId,
          rows: t.rows,
          required: t.required,
          maxlength: t.maxLength,
          minlength: t.minLength,
          onInput: u[1] || (u[1] = (d) => o(d))
        }, null, 40, E3), [
          [Kn, r.value]
        ])
      ], 10, w3),
      s.value ? (k(), U("p", D3, _e(t.errorMessage), 1)) : ie("", !0),
      t.hintMessage && !s.value ? (k(), U("p", _3, _e(t.hintMessage), 1)) : ie("", !0)
    ], 2));
  }
}), Uq = /* @__PURE__ */ tt(k3, [["__scopeId", "data-v-4bcb2376"]]), P3 = ["for"], I3 = {
  key: 1,
  class: "ui-slider__single-slider single-slider"
}, M3 = {
  key: 0,
  class: "single-slider__input-number input-number"
}, O3 = ["id", "data-maska", "min", "max"], B3 = { class: "single-slider__input-range input-range" }, L3 = {
  key: 0,
  class: "input-range__ui-hint ui-hint"
}, N3 = {
  key: 0,
  class: "ui-hint__container ui-hint-container"
}, R3 = { class: "ui-hint-container__hint" }, F3 = ["min", "max", "step"], z3 = {
  key: 1,
  class: "ui-slider__hint-message"
}, U3 = {
  key: 2,
  class: "ui-slider__double-slider double-slider"
}, V3 = { class: "double-slider__input-number input-number" }, q3 = ["id", "data-maska", "min", "max"], H3 = ["data-maska", "min", "max"], W3 = { class: "double-slider__input-range input-range" }, Y3 = ["min", "max", "step"], X3 = ["min", "max", "step"], j3 = {
  key: 0,
  class: "ui-slider__hint-message"
}, G3 = /* @__PURE__ */ qe({
  name: "UiSlider",
  __name: "UiSlider",
  props: {
    size: {
      type: String,
      default: "l"
    },
    maxValue: {
      type: Number,
      default: 100
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    type: {
      type: String,
      default: "single"
    },
    label: {
      type: String,
      default: ""
    },
    minValue: {
      type: Number,
      default: 0
    },
    stepNumber: {
      type: Number,
      default: 5
    },
    minCurrentValue: {
      type: Number,
      default: 10
    },
    maxCurrentValue: {
      type: Number,
      default: 50
    },
    singleCurrentValue: {
      type: Number,
      default: 50
    },
    zIndex: {
      type: Number,
      default: 1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "stroke"
    },
    labelTooltip: {
      type: String,
      default: ""
    },
    rangeValues: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    "update:minCurrentValue",
    "update:maxCurrentValue",
    "update:singleCurrentValue"
  ],
  setup(t, { emit: e }) {
    Md((x) => ({
      de7004f2: y.value,
      "61c030e0": b.value,
      "3b050834": m.value,
      "2c57560a": I.value,
      "7ff5b8cd": D.value,
      "3b063bac": A.value
    }));
    const i = t, n = e, s = pe(0), r = pe(0), a = pe(0), o = pe(!1), l = pe(0), u = pe(0), d = pe(0), c = J(() => i.type !== "volume"), A = J(() => i.zIndex - 1), m = J(() => i.zIndex + 1), p = J(() => i.maxValue.toString().length), h = J(() => "#".repeat(p.value)), g = pe(null), { width: w } = q_(g), b = J(() => `${(w.value - 20) / (i.maxValue - i.minValue) * (d.value - i.minValue)}px`), y = J(() => `${w.value / (i.maxValue - i.minValue) * (i.maxValue - d.value)}px`), D = J(() => `${w.value / (i.maxValue - i.minValue) * (l.value - i.minValue)}px`), I = J(() => `${w.value / (i.maxValue - i.minValue) * (i.maxValue - u.value)}px`);
    mt(a, (x) => {
      if (x === "") {
        d.value = i.minValue, a.value = i.minValue;
        return;
      }
      x > i.maxValue ? a.value = i.maxValue : x < i.minValue ? a.value = i.minValue : a.value = x, d.value = +x;
    }), mt(s, (x) => {
      if (x === "") {
        u.value = i.maxValue, s.value = i.maxValue, x = +x;
        return;
      }
      x > i.maxValue ? s.value = i.maxValue : x < i.minValue ? (s.value = i.minValue, u.value = i.minValue) : s.value = x, n("update:maxCurrentValue", s.value), !(typeof s.value == "string" || typeof r.value == "string") && (s.value > r.value ? (u.value = x, l.value = r.value) : r.value > s.value ? (u.value = r.value, l.value = s.value) : (u.value = s.value, l.value = r.value));
    }), mt(r, (x) => {
      const L = x.toString().replace(/(^|\s)0/g, "$1"), V = isNaN(parseInt(L)) ? i.minValue : parseInt(L);
      if (x === "") {
        l.value = i.minValue, r.value = i.minValue;
        return;
      }
      x > i.maxValue ? r.value = i.maxValue : x < i.minValue ? (l.value = i.minValue, r.value = i.minValue) : r.value = V, n("update:minCurrentValue", r.value), typeof s.value != "string" && (l.value = x, r.value > s.value ? (u.value = r.value, l.value = s.value) : (u.value = s.value, l.value = r.value));
    });
    const M = () => {
      if (r.value > s.value) {
        const x = s.value;
        s.value = r.value, r.value = x;
      }
    }, _ = () => {
      o.value = !0;
    }, N = () => {
      o.value = !1;
    };
    return Vs(() => {
      s.value = i.maxCurrentValue, r.value = i.minCurrentValue, u.value = s.value, a.value = i.singleCurrentValue, l.value = i.singleCurrentValue, d.value = a.value;
    }), (x, C) => (k(), U("div", {
      ref_key: "componentWidth",
      ref: g,
      class: we(["ui-slider", [`ui-slider_size_${t.size}`, { "ui-slider_full-width": t.fullWidth }]])
    }, [
      c.value ? (k(), U("label", {
        key: 0,
        for: t.inputId,
        class: "ui-slider__label"
      }, [
        Wi(_e(t.label) + " ", 1),
        t.labelTooltip ? (k(), Ce(aa, {
          key: 0,
          class: "ui-slider-tooltip",
          size: t.size,
          "tooltip-message": t.labelTooltip
        }, {
          icon: De(() => [
            Se(x.$slots, "tooltip-icon", {}, () => [
              ke(Y(is), { class: "ui-slider-tooltip__icon" })
            ], !0)
          ]),
          _: 3
        }, 8, ["size", "tooltip-message"])) : ie("", !0)
      ], 8, P3)) : ie("", !0),
      t.type !== "double" ? (k(), U("div", I3, [
        c.value ? (k(), U("span", M3, [
          Ci(re("input", {
            id: t.inputId,
            "onUpdate:modelValue": C[0] || (C[0] = (L) => a.value = L),
            class: we(`input-number_${t.variant}`),
            "data-maska": h.value,
            min: t.minValue,
            max: t.maxValue,
            type: "number"
          }, null, 10, O3), [
            [
              Kn,
              a.value,
              void 0,
              { number: !0 }
            ],
            [Y(ll)]
          ])
        ])) : ie("", !0),
        re("div", B3, [
          C[7] || (C[7] = re("span", { class: "input-range__value" }, null, -1)),
          t.type === "volume" ? (k(), U("div", L3, [
            ke(Ri, {
              name: "hint-fade",
              mode: "out-in"
            }, {
              default: De(() => [
                o.value ? (k(), U("div", N3, [
                  re("div", R3, [
                    re("span", null, _e(a.value), 1)
                  ]),
                  C[6] || (C[6] = re("span", { class: "ui-hint-container__triangle" }, null, -1))
                ])) : ie("", !0)
              ]),
              _: 1
            })
          ])) : ie("", !0),
          Ci(re("input", {
            "onUpdate:modelValue": C[1] || (C[1] = (L) => a.value = L),
            min: t.minValue,
            max: t.maxValue,
            step: t.stepNumber,
            type: "range",
            onMousedown: _,
            onMouseup: N
          }, null, 40, F3), [
            [Kn, a.value]
          ])
        ]),
        t.rangeValues.length ? (k(), U("div", z3, [
          (k(!0), U(Xe, null, ut(t.rangeValues, (L, V) => (k(), U("div", {
            key: V,
            class: "ui-slider__hint-message-value",
            style: Nt({
              transform: `translateX(-${L.point}%)`,
              left: `${L.point}%`
            })
          }, _e(L.value), 5))), 128))
        ])) : ie("", !0)
      ])) : (k(), U("div", U3, [
        re("span", V3, [
          Ci(re("input", {
            id: t.inputId,
            "onUpdate:modelValue": C[2] || (C[2] = (L) => r.value = L),
            class: we(`input-number_${t.variant}`),
            "data-maska": h.value,
            min: t.minValue,
            max: t.maxValue,
            type: "number",
            onChange: M
          }, null, 42, q3), [
            [Kn, r.value],
            [Y(ll)]
          ]),
          Ci(re("input", {
            "onUpdate:modelValue": C[3] || (C[3] = (L) => s.value = L),
            class: we(`input-number_${t.variant}`),
            "data-maska": h.value,
            min: t.minValue,
            max: t.maxValue,
            type: "number"
          }, null, 10, H3), [
            [Kn, s.value],
            [Y(ll)]
          ])
        ]),
        re("span", W3, [
          C[8] || (C[8] = re("span", { class: "input-range__value-min" }, null, -1)),
          C[9] || (C[9] = re("span", { class: "input-range__line" }, null, -1)),
          C[10] || (C[10] = re("span", { class: "input-range__value-max" }, null, -1)),
          Ci(re("input", {
            "onUpdate:modelValue": C[4] || (C[4] = (L) => r.value = L),
            min: t.minValue,
            max: t.maxValue,
            step: t.stepNumber,
            type: "range",
            onChange: M
          }, null, 40, Y3), [
            [Kn, r.value]
          ]),
          Ci(re("input", {
            "onUpdate:modelValue": C[5] || (C[5] = (L) => s.value = L),
            min: t.minValue,
            max: t.maxValue,
            step: t.stepNumber,
            type: "range",
            onChange: M
          }, null, 40, X3), [
            [
              Kn,
              s.value,
              void 0,
              { number: !0 }
            ]
          ])
        ]),
        t.rangeValues.length ? (k(), U("div", j3, [
          (k(!0), U(Xe, null, ut(t.rangeValues, (L, V) => (k(), U("div", {
            key: V,
            class: "ui-slider__hint-message-value",
            style: Nt({
              transform: `translateX(-${L.point}%)`,
              left: `${L.point}%`
            })
          }, _e(L.value), 5))), 128))
        ])) : ie("", !0)
      ]))
    ], 2));
  }
}), Vq = /* @__PURE__ */ tt(G3, [["__scopeId", "data-v-305fc558"]]), Q3 = {
  key: 0,
  class: "ui-avatar__online-circle online-circle"
}, Z3 = { class: "avatar-letters__title" }, K3 = { class: "counter__text" }, J3 = /* @__PURE__ */ qe({
  name: "UiAvatar",
  __name: "UiAvatar",
  props: {
    size: {
      type: String,
      default: "xs"
    },
    borderAvatar: {
      type: Boolean,
      default: !1
    },
    isOnline: {
      type: Boolean,
      default: !1
    },
    avatarList: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const e = t, i = J(() => {
      var r;
      return `+${((r = e.avatarList) == null ? void 0 : r.length) - 3}`;
    }), n = J(() => {
      var r;
      return ((r = e.avatarList) == null ? void 0 : r.length) <= 4 ? e.avatarList : e.avatarList.slice(0, 3);
    }), s = (r) => {
      if (typeof r < "u") {
        if (r.length > 2)
          return r == null ? void 0 : r.slice(0, 2);
      } else
        return "";
    };
    return (r, a) => (k(), U("div", {
      class: we(["ui-avatar-group", `ui-avatar-group_size_${t.size}`])
    }, [
      (k(!0), U(Xe, null, ut(n.value, (o, l) => (k(), U("div", {
        key: l,
        class: we(["ui-avatar-group__ui-avatar ui-avatar", [
          `ui-avatar_avatar-${l}`,
          {
            "ui-avatar_yellow": (o == null ? void 0 : o.colorIcon) === "yellow" && (o == null ? void 0 : o.backgroundColor) === "yellow",
            "ui-avatar_orange": (o == null ? void 0 : o.colorIcon) === "orange" && (o == null ? void 0 : o.backgroundColor) === "orange",
            "ui-avatar_pink": (o == null ? void 0 : o.colorIcon) === "pink" && (o == null ? void 0 : o.backgroundColor) === "pink",
            "ui-avatar_teal": (o == null ? void 0 : o.colorIcon) === "teal" && (o == null ? void 0 : o.backgroundColor) === "teal"
          }
        ]])
      }, [
        t.isOnline ? (k(), U("span", Q3)) : ie("", !0),
        o != null && o.link ? (k(), U("div", {
          key: 1,
          class: we([{ avatar_border: t.borderAvatar }, "ui-avatar__avatar avatar"]),
          style: Nt({
            backgroundImage: `url(${o.link})`
          })
        }, null, 6)) : !(o != null && o.link) && typeof o.lettersInitials < "u" ? (k(), U("div", {
          key: 2,
          class: we([{ "avatar-letters_border": t.borderAvatar }, "ui-avatar__avatar-letters avatar-letters"])
        }, [
          re("span", Z3, _e(s(o.lettersInitials)), 1)
        ], 2)) : (k(), U("div", {
          key: 3,
          class: we([{ "avatar-icon_border": t.borderAvatar }, "ui-avatar__avatar-icon avatar-icon"])
        }, [
          ke(Y(jx), { class: "avatar-icon__icon icon" })
        ], 2))
      ], 2))), 128)),
      t.avatarList.length > 4 ? (k(), U("div", {
        key: 0,
        class: we(["ui-avatar-group__counter counter", { counter_border: t.borderAvatar }])
      }, [
        re("span", K3, _e(i.value), 1)
      ], 2)) : ie("", !0)
    ], 2));
  }
}), qq = /* @__PURE__ */ tt(J3, [["__scopeId", "data-v-ab4c995a"]]), $3 = { class: "ui-input-phone__container phone-container" }, eI = ["for"], tI = {
  key: 0,
  class: "hint__label"
}, iI = {
  key: 1,
  class: "hint__icon-required icon-required"
}, nI = ["id"], sI = ["disabled"], rI = ["id", "data-maska", "placeholder", "data-test-id", "disabled", "maxlength"], aI = {
  key: 0,
  class: "ui-input-phone__error-message"
}, oI = /* @__PURE__ */ qe({
  name: "UiInputPhone",
  __name: "UiInputPhone",
  props: {
    size: {
      type: String,
      default: "l"
    },
    modelValue: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    maxLength: {
      type: Number,
      default: 255
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    options: {
      type: Array,
      default: () => [
        {
          id: "ru",
          title: "Россия (+7)",
          icon: Ux,
          placeholder: "+7 (999) 000-00-00",
          mask: "+7 (###) ###-##-##"
        },
        {
          id: "kz",
          title: "Казахстан (+7)",
          icon: Mx,
          placeholder: "+7 (999) 000-00-00",
          mask: "+7 (###) ###-##-##"
        },
        {
          id: "md",
          title: "Молдова (+373)",
          icon: Nx,
          placeholder: "+(373) 000-00-00",
          mask: "+(373) ###-##-##"
        }
      ]
    },
    showCountry: {
      type: Boolean,
      default: !0
    },
    variant: {
      type: String,
      default: "stroke"
    },
    bottomSheetTitle: {
      type: String,
      default: "Код страны"
    },
    bottomSheetSubTitle: {
      type: String,
      default: ""
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "blur", "updateCountry"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = pe("ru"), r = pe(null), a = pe(null), o = pe(!1), l = J(() => (i.error || i.errorMessage) && !i.disabled), u = J(() => ({
      "grid-template-columns": "fit-content(20px) 1fr"
    })), d = J({
      get() {
        return i.modelValue;
      },
      set(h) {
        n("update:modelValue", h);
      }
    }), c = J(() => i.options.map((h) => ({
      id: h.id,
      label: h.title
    }))), A = J(() => i.options.find((h) => h.id === s.value)), m = () => {
      o.value = !o.value;
    }, p = (h) => {
      n("updateCountry", h);
    };
    return (h, g) => (k(), U(Xe, null, [
      re("div", {
        class: we(["ui-input-phone", [
          `ui-input-phone_size_${t.size}`,
          { "ui-input-phone_disabled": t.disabled },
          { "ui-input-phone_error": l.value }
        ]])
      }, [
        re("div", $3, [
          re("label", {
            for: `label-${t.inputId}`,
            class: "phone-container__hint hint"
          }, [
            t.label ? (k(), U("span", tI, _e(t.label), 1)) : ie("", !0),
            t.required ? (k(), U("span", iI)) : ie("", !0)
          ], 8, eI),
          re("span", {
            id: t.inputId,
            class: we(["ui-input-phone__input-block input-block", [
              { "input-block_without-country": !t.showCountry },
              `input-block_${t.variant}`
            ]]),
            style: Nt(u.value)
          }, [
            t.showCountry ? (k(), U("button", {
              key: 0,
              ref_key: "countryButton",
              ref: a,
              type: "button",
              class: "ui-input-phone__button-country button-country",
              disabled: t.disabled,
              onClick: $t(m, ["stop"])
            }, [
              A.value.icon ? (k(), Ce(Ft(A.value.icon), {
                key: 0,
                class: "button-country__icon-country"
              })) : ie("", !0),
              ke(Y(Od), {
                class: we(["button-country__chevron", { "button-country__chevron_rotated": o.value }])
              }, null, 8, ["class"])
            ], 8, sI)) : ie("", !0),
            Ci(re("input", {
              id: `label-${t.inputId}`,
              "onUpdate:modelValue": g[0] || (g[0] = (w) => d.value = w),
              class: "input-block__input input",
              "data-maska": A.value.mask,
              type: "tel",
              placeholder: A.value.placeholder,
              "data-test-id": t.dataTestId,
              disabled: t.disabled,
              maxlength: t.maxLength,
              name: "phone",
              onBlur: g[1] || (g[1] = (w) => n("blur"))
            }, null, 40, rI), [
              [Kn, d.value],
              [Y(ll)]
            ])
          ], 14, nI)
        ]),
        t.errorMessage ? (k(), U("p", aI, _e(t.errorMessage), 1)) : ie("", !0)
      ], 2),
      ke(Rl, {
        ref_key: "target",
        ref: r,
        modelValue: s.value,
        "onUpdate:modelValue": [
          g[2] || (g[2] = (w) => s.value = w),
          p
        ],
        open: o.value,
        "onUpdate:open": g[3] || (g[3] = (w) => o.value = w),
        type: "single",
        "is-select": "",
        options: c.value,
        "parent-id": t.inputId,
        label: t.bottomSheetTitle,
        "bottom-sheet-sub-title": t.bottomSheetSubTitle
      }, null, 8, ["modelValue", "open", "options", "parent-id", "label", "bottom-sheet-sub-title"])
    ], 64));
  }
}), Hq = /* @__PURE__ */ tt(oI, [["__scopeId", "data-v-30db4475"]]), lI = ["id"], uI = /* @__PURE__ */ qe({
  name: "UiInputSearch",
  __name: "UiInputSearch",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    selectedItem: {
      type: String,
      default: ""
    },
    searchOptions: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "l"
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    required: {
      type: Boolean,
      default: !1
    },
    counter: {
      type: Boolean,
      default: !1
    },
    maxLength: {
      type: Number,
      default: 255
    },
    error: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    inputSearchId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    unit: {
      type: String,
      default: ""
    },
    tooltipMessage: {
      type: String,
      default: ""
    },
    mask: {
      type: [String, Array, Object, null, Array, void 0],
      default: null
    },
    maskTokens: {
      type: [String, Array, Object, null, Array, void 0],
      default: ""
    },
    dataMaskaReversed: {
      type: Boolean,
      default: !1
    },
    maskaOptions: {
      type: [String, Array, Object, null, Array, void 0],
      default: ""
    },
    enterKeyHint: {
      type: String,
      default: "enter"
    },
    inputMode: {
      type: String,
      default: "text"
    },
    variant: {
      type: String,
      default: "stroke"
    },
    dataTestId: {
      type: String,
      default: ""
    },
    bottomSheetTitle: {
      type: String,
      default: ""
    },
    bottomSheetSubTitle: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      required: !1
    }
  },
  emits: ["update:modelValue", "blur", "input", "selectItem"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = Yi(), r = pe(!1), a = J({
      get() {
        return i.selectedItem;
      },
      set(A) {
        n("selectItem", A);
      }
    }), o = J({
      get() {
        return i.modelValue;
      },
      set(A) {
        n("update:modelValue", A);
      }
    }), l = (A) => {
      A !== i.selectedItem && (r.value = !!A.length, n("input", A));
    }, u = J(
      () => Object.prototype.hasOwnProperty.call(s, "icon-left")
    ), d = J(
      () => Object.prototype.hasOwnProperty.call(s, "tooltip-icon")
    ), c = J(
      () => !i.searchOptions.length && !i.loading
    );
    return (A, m) => (k(), U("div", {
      id: t.inputSearchId,
      class: "ui-input-search"
    }, [
      ke(zd, {
        modelValue: o.value,
        "onUpdate:modelValue": m[0] || (m[0] = (p) => o.value = p),
        "input-id": t.inputId,
        "maska-options": t.maskaOptions,
        mask: t.mask,
        "mask-tokens": t.maskTokens,
        counter: t.counter,
        "tooltip-message": t.tooltipMessage,
        "data-maska-reversed": t.dataMaskaReversed,
        type: t.type,
        unit: t.unit,
        variant: t.variant,
        required: t.required,
        "data-test-id": t.dataTestId,
        error: t.error,
        "hint-message": t.hintMessage,
        "error-message": t.errorMessage,
        placeholder: t.placeholder,
        size: t.size,
        disabled: t.disabled,
        "reset-button": "",
        label: t.label,
        maxlength: t.maxLength,
        enterkeyhint: t.enterKeyHint,
        inputmode: t.inputMode,
        onBlur: m[1] || (m[1] = (p) => n("blur")),
        onInput: l
      }, wi({ _: 2 }, [
        d.value ? {
          name: "tooltip-icon",
          fn: De(() => [
            Se(A.$slots, "tooltip-icon", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0,
        u.value ? {
          name: "icon-left",
          fn: De(() => [
            Se(A.$slots, "icon-left", {}, void 0, !0)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["modelValue", "input-id", "maska-options", "mask", "mask-tokens", "counter", "tooltip-message", "data-maska-reversed", "type", "unit", "variant", "required", "data-test-id", "error", "hint-message", "error-message", "placeholder", "size", "disabled", "label", "maxlength", "enterkeyhint", "inputmode"]),
      ke(Rl, {
        modelValue: a.value,
        "onUpdate:modelValue": m[2] || (m[2] = (p) => a.value = p),
        open: r.value,
        "onUpdate:open": m[3] || (m[3] = (p) => r.value = p),
        options: t.searchOptions,
        "parent-id": t.inputSearchId,
        "is-select": "",
        label: t.bottomSheetTitle,
        "bottom-sheet-sub-title": t.bottomSheetSubTitle
      }, wi({ _: 2 }, [
        t.loading ? {
          name: "loading",
          fn: De(() => [
            m[4] || (m[4] = re("div", { class: "ui-input-search_loading" }, [
              re("span", { class: "ui-input-search__icon-loading icon-loader" })
            ], -1))
          ]),
          key: "0"
        } : void 0,
        c.value ? {
          name: "error",
          fn: De(() => [
            m[5] || (m[5] = re("div", { class: "ui-input-search__error-search" }, [
              re("p", null, "Ничего не найдено")
            ], -1))
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["modelValue", "open", "options", "parent-id", "label", "bottom-sheet-sub-title"])
    ], 8, lI));
  }
}), Wq = /* @__PURE__ */ tt(uI, [["__scopeId", "data-v-5941ef2c"]]), dI = 1023, cI = 9, fI = 8, BA = 2;
var Or = /* @__PURE__ */ ((t) => (t[t.Three = 3] = "Three", t[t.Four = 4] = "Four", t[t.Five = 5] = "Five", t[t.Six = 6] = "Six", t))(Or || {}), Br = /* @__PURE__ */ ((t) => (t[t.Four = 4] = "Four", t[t.Five = 5] = "Five", t[t.Six = 6] = "Six", t[t.Seven = 7] = "Seven", t))(Br || {});
const hI = { class: "ui-pagination" }, pI = ["disabled"], mI = { class: "ui-pagination__items" }, AI = { key: 1 }, gI = ["onClick"], vI = { key: 2 }, yI = ["disabled"], bI = /* @__PURE__ */ qe({
  name: "UiPagination",
  __name: "UiPagination",
  props: {
    totalPages: {
      type: Number,
      required: !0
    },
    currentPage: {
      type: Number,
      required: !0
    }
  },
  emits: ["select", "prev", "next"],
  setup(t, { emit: e }) {
    const i = t, n = e, { width: s } = Rn(), r = J(() => s.value > dI), a = J(
      () => r.value ? BA : BA - 1
    ), o = J(() => i.totalPages >= cI), l = J(() => i.totalPages >= fI), u = J(() => {
      let y = null;
      return i.currentPage < Or.Six && r.value && o.value ? y = 1 : i.currentPage > i.totalPages - Or.Five && r.value && o.value ? y = i.totalPages - Or.Six : i.currentPage < Or.Five && !r.value && l.value ? y = 1 : i.currentPage > i.totalPages - Or.Three && !r.value && l.value ? y = i.totalPages - Or.Four : !o.value && r.value || !l.value && !r.value ? y = 1 : (y = i.currentPage - a.value, y > 0 ? y : 1);
    }), d = J(() => {
      let y = null;
      return i.currentPage < Br.Six && r.value && o.value ? y = Br.Seven : i.currentPage > i.totalPages - Br.Five && r.value && o.value ? y = i.totalPages : i.currentPage < Br.Five && !r.value && l.value ? y = Br.Five : i.currentPage > i.totalPages - Br.Four && !r.value && l.value || !o.value && r.value || !l.value && !r.value ? y = i.totalPages : (y = i.currentPage + a.value, y < i.totalPages ? y : i.totalPages);
    }), c = J(() => u.value !== 1), A = J(() => d.value < i.totalPages), m = J(() => {
      const y = [];
      for (let D = u.value; D <= d.value; D++)
        y.push(D);
      return y;
    }), p = J(() => i.currentPage > 1), h = J(() => i.currentPage < i.totalPages), g = () => p.value && n("prev"), w = () => h.value && n("next"), b = (y) => {
      n("select", y);
    };
    return (y, D) => (k(), U("div", hI, [
      re("button", {
        type: "button",
        disabled: !p.value,
        "aria-label": "prev",
        onClick: g
      }, [
        ke(Y(Bd))
      ], 8, pI),
      re("div", mI, [
        c.value ? (k(), U("button", {
          key: 0,
          type: "button",
          class: "ui-pagination__item",
          onClick: D[0] || (D[0] = (I) => b(1))
        }, " 1 ")) : ie("", !0),
        c.value ? (k(), U("span", AI, "...")) : ie("", !0),
        (k(!0), U(Xe, null, ut(m.value, (I) => (k(), U("button", {
          key: I,
          type: "button",
          class: we([{ "ui-pagination__item_active": i.currentPage === I }, "ui-pagination__item"]),
          onClick: (M) => b(I)
        }, _e(I), 11, gI))), 128)),
        A.value ? (k(), U("span", vI, "...")) : ie("", !0),
        A.value ? (k(), U("button", {
          key: 3,
          type: "button",
          class: "ui-pagination__item",
          onClick: D[1] || (D[1] = (I) => b(t.totalPages))
        }, _e(t.totalPages), 1)) : ie("", !0)
      ]),
      re("button", {
        type: "button",
        disabled: !h.value,
        "aria-label": "next",
        onClick: w
      }, [
        ke(Y(Bl))
      ], 8, yI)
    ]));
  }
}), Yq = /* @__PURE__ */ tt(bI, [["__scopeId", "data-v-5a9c1c93"]]), wI = {
  info: is,
  success: l0,
  error: ES,
  warning: d0
}, TI = ["id"], xI = { class: "ui-snackbar__info" }, SI = { key: 0 }, CI = { key: 1 }, EI = /* @__PURE__ */ qe({
  name: "UiSnackbar",
  __name: "UiSnackbar",
  props: {
    type: {
      type: String,
      default: "info"
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    showClose: {
      type: Boolean,
      default: !0
    },
    zIndex: {
      type: String,
      default: "10000000"
    },
    position: {
      type: String,
      default: "fixed"
    },
    duration: {
      type: Number,
      default: 4500
    }
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const i = t, n = e, { duration: s } = jh(i), r = pe(null), { isOutside: a } = Y_(r), { start: o, stop: l } = B_(() => {
      n("close");
    }, s), u = J(() => wI[i.type] || is);
    return Vs(() => {
      if (!a.value) {
        l();
        return;
      }
      o();
    }), (d, c) => (k(), U("div", {
      id: t.id,
      ref_key: "snackbarRef",
      ref: r,
      class: "ui-snackbar elevation-shadow-high",
      style: Nt({ zIndex: t.zIndex, position: t.position })
    }, [
      re("div", {
        class: we(["ui-snackbar__icon", `ui-snackbar__icon_${t.type}`])
      }, [
        (k(), Ce(Ft(u.value)))
      ], 2),
      re("div", xI, [
        t.title ? (k(), U("h5", SI, _e(t.title), 1)) : ie("", !0),
        t.text ? (k(), U("p", CI, _e(t.text), 1)) : ie("", !0),
        Se(d.$slots, "default", {}, void 0, !0)
      ]),
      t.showClose ? (k(), U("button", {
        key: 0,
        type: "button",
        "aria-label": "close",
        onClick: c[0] || (c[0] = (A) => d.$emit("close"))
      }, [
        ke(Y(na))
      ])) : ie("", !0)
    ], 12, TI));
  }
}), DI = /* @__PURE__ */ tt(EI, [["__scopeId", "data-v-04075fa9"]]), _I = ["data-position"], kI = /* @__PURE__ */ qe({
  name: "UiSnackbarGroup",
  __name: "UiSnackbarGroup",
  props: {
    position: {
      type: String,
      default: "right"
    },
    modelValue: {
      type: Array,
      required: !0
    },
    duration: {
      type: Number,
      default: 4500
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = Yi(), r = (a) => {
      n(
        "update:modelValue",
        i.modelValue.filter((o) => o.id !== a)
      );
    };
    return (a, o) => (k(), U("div", {
      class: we(["ui-snackbar-group", `ui-snackbar-group-position_${t.position}`])
    }, [
      ke(r0, {
        appear: "",
        name: `ui-snackbar-animate-${t.position}`,
        tag: "ul",
        class: "ui-snackbar-group-list"
      }, {
        default: De(() => [
          (k(!0), U(Xe, null, ut(t.modelValue, (l) => (k(), U("li", {
            key: l.id,
            class: "ui-snackbar-group-list__item",
            "data-position": t.position
          }, [
            ke(DI, {
              class: "elevation-shadow-high",
              position: "static",
              "z-index": "0",
              type: l.type,
              title: l.title,
              text: l.text,
              label: l.label,
              "show-close": l == null ? void 0 : l.showClose,
              onClose: (u) => r(l.id)
            }, {
              default: De(() => [
                Y(s).default ? Se(a.$slots, "default", { key: 0 }, void 0, !0) : ie("", !0)
              ]),
              _: 2
            }, 1032, ["type", "title", "text", "label", "show-close", "onClose"])
          ], 8, _I))), 128))
        ]),
        _: 3
      }, 8, ["name"])
    ], 2));
  }
}), Xq = /* @__PURE__ */ tt(kI, [["__scopeId", "data-v-86495d12"]]), PI = /* @__PURE__ */ qe({
  name: "UiProgressBar",
  __name: "UiProgressBar",
  props: {
    value: {
      type: Number,
      default: 100
    },
    size: {
      type: String,
      default: "m"
    }
  },
  setup(t) {
    return (e, i) => (k(), U("div", {
      class: we(["ui-progress-bar", [`ui-progress-bar_size_${t.size}`]])
    }, [
      re("span", {
        style: Nt({ width: `${t.value}%` })
      }, null, 4)
    ], 2));
  }
}), II = /* @__PURE__ */ tt(PI, [["__scopeId", "data-v-4ef55ee6"]]);
var Yt = /* @__PURE__ */ ((t) => (t.PDF = "pdf", t.DOC = "doc", t.DOCX = "docx", t.TXT = "txt", t.CSV = "csv", t.XLS = "xls", t.XLSX = "xlsx", t.PPT = "ppt", t.PPTX = "pptx", t.ZIP = "zip", t.RAR = "rar", t.MP3 = "mp3", t.WAV = "wav", t.MP4 = "mp4", t.AVI = "avi", t.IMG = "img", t.JPG = "jpg", t.JPEG = "jpeg", t.PNG = "png", t.GIF = "gif", t.SVG = "svg", t.OTHER = "other", t))(Yt || {});
const L0 = 6048e5, MI = 864e5, lp = 6e4, Vd = 36e5, OI = 1e3, LA = Symbol.for("constructDateFrom");
function Pt(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && LA in t ? t[LA](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function et(t, e) {
  return Pt(e || t, t);
}
function In(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in);
  return isNaN(e) ? Pt((i == null ? void 0 : i.in) || t, NaN) : (e && n.setDate(n.getDate() + e), n);
}
function $n(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in);
  if (isNaN(e)) return Pt(t, NaN);
  if (!e)
    return n;
  const s = n.getDate(), r = Pt(t, n.getTime());
  r.setMonth(n.getMonth() + e + 1, 0);
  const a = r.getDate();
  return s >= a ? r : (n.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    s
  ), n);
}
function N0(t, e, i) {
  const {
    years: n = 0,
    months: s = 0,
    weeks: r = 0,
    days: a = 0,
    hours: o = 0,
    minutes: l = 0,
    seconds: u = 0
  } = e, d = et(t, i == null ? void 0 : i.in), c = s || n ? $n(d, s + n * 12) : d, A = a || r ? In(c, a + r * 7) : c, m = l + o * 60, h = (u + m * 60) * 1e3;
  return Pt(t, +A + h);
}
function BI(t, e, i) {
  return Pt(t, +et(t) + e);
}
function LI(t, e, i) {
  return BI(t, e * Vd);
}
let NI = {};
function oa() {
  return NI;
}
function Tn(t, e) {
  var o, l, u, d;
  const i = oa(), n = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? i.weekStartsOn ?? ((d = (u = i.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, s = et(t, e == null ? void 0 : e.in), r = s.getDay(), a = (r < n ? 7 : 0) + r - n;
  return s.setDate(s.getDate() - a), s.setHours(0, 0, 0, 0), s;
}
function Ga(t, e) {
  return Tn(t, { ...e, weekStartsOn: 1 });
}
function R0(t, e) {
  const i = et(t, e == null ? void 0 : e.in), n = i.getFullYear(), s = Pt(i, 0);
  s.setFullYear(n + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const r = Ga(s), a = Pt(i, 0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  const o = Ga(a);
  return i.getTime() >= r.getTime() ? n + 1 : i.getTime() >= o.getTime() ? n : n - 1;
}
function Ju(t) {
  const e = et(t), i = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return i.setUTCFullYear(e.getFullYear()), +t - +i;
}
function Ao(t, ...e) {
  const i = Pt.bind(
    null,
    t || e.find((n) => typeof n == "object")
  );
  return e.map(i);
}
function Fr(t, e) {
  const i = et(t, e == null ? void 0 : e.in);
  return i.setHours(0, 0, 0, 0), i;
}
function F0(t, e, i) {
  const [n, s] = Ao(
    i == null ? void 0 : i.in,
    t,
    e
  ), r = Fr(n), a = Fr(s), o = +r - Ju(r), l = +a - Ju(a);
  return Math.round((o - l) / MI);
}
function RI(t, e) {
  const i = R0(t, e), n = Pt(t, 0);
  return n.setFullYear(i, 0, 4), n.setHours(0, 0, 0, 0), Ga(n);
}
function FI(t, e, i) {
  return $n(t, e * 3, i);
}
function up(t, e, i) {
  return $n(t, e * 12, i);
}
function NA(t, e) {
  const i = +et(t) - +et(e);
  return i < 0 ? -1 : i > 0 ? 1 : i;
}
function z0(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Pa(t) {
  return !(!z0(t) && typeof t != "number" || isNaN(+et(t)));
}
function RA(t, e) {
  const i = et(t, e == null ? void 0 : e.in);
  return Math.trunc(i.getMonth() / 3) + 1;
}
function zI(t, e, i) {
  const [n, s] = Ao(
    i == null ? void 0 : i.in,
    t,
    e
  );
  return n.getFullYear() - s.getFullYear();
}
function qo(t, e) {
  const i = et(t, e == null ? void 0 : e.in);
  return i.setHours(23, 59, 59, 999), i;
}
function UI(t, e, i) {
  const [n, s] = Ao(
    i == null ? void 0 : i.in,
    t,
    e
  ), r = NA(n, s), a = Math.abs(zI(n, s));
  n.setFullYear(1584), s.setFullYear(1584);
  const o = NA(n, s) === -r, l = r * (a - +o);
  return l === 0 ? 0 : l;
}
function U0(t, e) {
  const [i, n] = Ao(t, e.start, e.end);
  return { start: i, end: n };
}
function V0(t, e) {
  const { start: i, end: n } = U0(e == null ? void 0 : e.in, t);
  let s = +i > +n;
  const r = s ? +i : +n, a = s ? n : i;
  a.setHours(0, 0, 0, 0);
  let o = 1;
  const l = [];
  for (; +a <= r; )
    l.push(Pt(i, a)), a.setDate(a.getDate() + o), a.setHours(0, 0, 0, 0);
  return s ? l.reverse() : l;
}
function Ur(t, e) {
  const i = et(t, e == null ? void 0 : e.in), n = i.getMonth(), s = n - n % 3;
  return i.setMonth(s, 1), i.setHours(0, 0, 0, 0), i;
}
function VI(t, e) {
  const { start: i, end: n } = U0(e == null ? void 0 : e.in, t);
  let s = +i > +n;
  const r = s ? +Ur(i) : +Ur(n);
  let a = Ur(s ? n : i), o = 1;
  const l = [];
  for (; +a <= r; )
    l.push(Pt(i, a)), a = FI(a, o);
  return s ? l.reverse() : l;
}
function qI(t, e) {
  const i = et(t, e == null ? void 0 : e.in);
  return i.setDate(1), i.setHours(0, 0, 0, 0), i;
}
function q0(t, e) {
  const i = et(t, e == null ? void 0 : e.in), n = i.getFullYear();
  return i.setFullYear(n + 1, 0, 0), i.setHours(23, 59, 59, 999), i;
}
function Sl(t, e) {
  const i = et(t, e == null ? void 0 : e.in);
  return i.setFullYear(i.getFullYear(), 0, 1), i.setHours(0, 0, 0, 0), i;
}
function H0(t, e) {
  var o, l, u, d;
  const i = oa(), n = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? i.weekStartsOn ?? ((d = (u = i.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, s = et(t, e == null ? void 0 : e.in), r = s.getDay(), a = (r < n ? -7 : 0) + 6 - (r - n);
  return s.setDate(s.getDate() + a), s.setHours(23, 59, 59, 999), s;
}
function FA(t, e) {
  const i = et(t, e == null ? void 0 : e.in), n = i.getMonth(), s = n - n % 3 + 3;
  return i.setMonth(s, 0), i.setHours(23, 59, 59, 999), i;
}
const HI = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, WI = (t, e, i) => {
  let n;
  const s = HI[t];
  return typeof s == "string" ? n = s : e === 1 ? n = s.one : n = s.other.replace("{{count}}", e.toString()), i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Ia(t) {
  return (e = {}) => {
    const i = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[i] || t.formats[t.defaultWidth];
  };
}
const YI = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, XI = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, jI = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, GI = {
  date: Ia({
    formats: YI,
    defaultWidth: "full"
  }),
  time: Ia({
    formats: XI,
    defaultWidth: "full"
  }),
  dateTime: Ia({
    formats: jI,
    defaultWidth: "full"
  })
}, QI = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ZI = (t, e, i, n) => QI[t];
function hs(t) {
  return (e, i) => {
    const n = i != null && i.context ? String(i.context) : "standalone";
    let s;
    if (n === "formatting" && t.formattingValues) {
      const a = t.defaultFormattingWidth || t.defaultWidth, o = i != null && i.width ? String(i.width) : a;
      s = t.formattingValues[o] || t.formattingValues[a];
    } else {
      const a = t.defaultWidth, o = i != null && i.width ? String(i.width) : t.defaultWidth;
      s = t.values[o] || t.values[a];
    }
    const r = t.argumentCallback ? t.argumentCallback(e) : e;
    return s[r];
  };
}
const KI = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, JI = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, $I = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, eM = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, tM = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, iM = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, nM = (t, e) => {
  const i = Number(t), n = i % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return i + "st";
      case 2:
        return i + "nd";
      case 3:
        return i + "rd";
    }
  return i + "th";
}, sM = {
  ordinalNumber: nM,
  era: hs({
    values: KI,
    defaultWidth: "wide"
  }),
  quarter: hs({
    values: JI,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: hs({
    values: $I,
    defaultWidth: "wide"
  }),
  day: hs({
    values: eM,
    defaultWidth: "wide"
  }),
  dayPeriod: hs({
    values: tM,
    defaultWidth: "wide",
    formattingValues: iM,
    defaultFormattingWidth: "wide"
  })
};
function ps(t) {
  return (e, i = {}) => {
    const n = i.width, s = n && t.matchPatterns[n] || t.matchPatterns[t.defaultMatchWidth], r = e.match(s);
    if (!r)
      return null;
    const a = r[0], o = n && t.parsePatterns[n] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(o) ? aM(o, (c) => c.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      rM(o, (c) => c.test(a))
    );
    let u;
    u = t.valueCallback ? t.valueCallback(l) : l, u = i.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      i.valueCallback(u)
    ) : u;
    const d = e.slice(a.length);
    return { value: u, rest: d };
  };
}
function rM(t, e) {
  for (const i in t)
    if (Object.prototype.hasOwnProperty.call(t, i) && e(t[i]))
      return i;
}
function aM(t, e) {
  for (let i = 0; i < t.length; i++)
    if (e(t[i]))
      return i;
}
function W0(t) {
  return (e, i = {}) => {
    const n = e.match(t.matchPattern);
    if (!n) return null;
    const s = n[0], r = e.match(t.parsePattern);
    if (!r) return null;
    let a = t.valueCallback ? t.valueCallback(r[0]) : r[0];
    a = i.valueCallback ? i.valueCallback(a) : a;
    const o = e.slice(s.length);
    return { value: a, rest: o };
  };
}
const oM = /^(\d+)(th|st|nd|rd)?/i, lM = /\d+/i, uM = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, dM = {
  any: [/^b/i, /^(a|c)/i]
}, cM = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, fM = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hM = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, pM = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, mM = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, AM = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, gM = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, vM = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, yM = {
  ordinalNumber: W0({
    matchPattern: oM,
    parsePattern: lM,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: ps({
    matchPatterns: uM,
    defaultMatchWidth: "wide",
    parsePatterns: dM,
    defaultParseWidth: "any"
  }),
  quarter: ps({
    matchPatterns: cM,
    defaultMatchWidth: "wide",
    parsePatterns: fM,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: ps({
    matchPatterns: hM,
    defaultMatchWidth: "wide",
    parsePatterns: pM,
    defaultParseWidth: "any"
  }),
  day: ps({
    matchPatterns: mM,
    defaultMatchWidth: "wide",
    parsePatterns: AM,
    defaultParseWidth: "any"
  }),
  dayPeriod: ps({
    matchPatterns: gM,
    defaultMatchWidth: "any",
    parsePatterns: vM,
    defaultParseWidth: "any"
  })
}, Y0 = {
  code: "en-US",
  formatDistance: WI,
  formatLong: GI,
  formatRelative: ZI,
  localize: sM,
  match: yM,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function bM(t, e) {
  const i = et(t, e == null ? void 0 : e.in);
  return F0(i, Sl(i)) + 1;
}
function dp(t, e) {
  const i = et(t, e == null ? void 0 : e.in), n = +Ga(i) - +RI(i);
  return Math.round(n / L0) + 1;
}
function cp(t, e) {
  var d, c, A, m;
  const i = et(t, e == null ? void 0 : e.in), n = i.getFullYear(), s = oa(), r = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((c = (d = e == null ? void 0 : e.locale) == null ? void 0 : d.options) == null ? void 0 : c.firstWeekContainsDate) ?? s.firstWeekContainsDate ?? ((m = (A = s.locale) == null ? void 0 : A.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, a = Pt((e == null ? void 0 : e.in) || t, 0);
  a.setFullYear(n + 1, 0, r), a.setHours(0, 0, 0, 0);
  const o = Tn(a, e), l = Pt((e == null ? void 0 : e.in) || t, 0);
  l.setFullYear(n, 0, r), l.setHours(0, 0, 0, 0);
  const u = Tn(l, e);
  return +i >= +o ? n + 1 : +i >= +u ? n : n - 1;
}
function wM(t, e) {
  var o, l, u, d;
  const i = oa(), n = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (o = e == null ? void 0 : e.locale) == null ? void 0 : o.options) == null ? void 0 : l.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((d = (u = i.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, s = cp(t, e), r = Pt((e == null ? void 0 : e.in) || t, 0);
  return r.setFullYear(s, 0, n), r.setHours(0, 0, 0, 0), Tn(r, e);
}
function fp(t, e) {
  const i = et(t, e == null ? void 0 : e.in), n = +Tn(i, e) - +wM(i, e);
  return Math.round(n / L0) + 1;
}
function Ot(t, e) {
  const i = t < 0 ? "-" : "", n = Math.abs(t).toString().padStart(e, "0");
  return i + n;
}
const $s = {
  // Year
  y(t, e) {
    const i = t.getFullYear(), n = i > 0 ? i : 1 - i;
    return Ot(e === "yy" ? n % 100 : n, e.length);
  },
  // Month
  M(t, e) {
    const i = t.getMonth();
    return e === "M" ? String(i + 1) : Ot(i + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return Ot(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const i = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return i.toUpperCase();
      case "aaa":
        return i;
      case "aaaaa":
        return i[0];
      case "aaaa":
      default:
        return i === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return Ot(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return Ot(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return Ot(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return Ot(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const i = e.length, n = t.getMilliseconds(), s = Math.trunc(
      n * Math.pow(10, i - 3)
    );
    return Ot(s, e.length);
  }
}, fa = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, zA = {
  // Era
  G: function(t, e, i) {
    const n = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return i.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return i.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return i.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, i) {
    if (e === "yo") {
      const n = t.getFullYear(), s = n > 0 ? n : 1 - n;
      return i.ordinalNumber(s, { unit: "year" });
    }
    return $s.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, i, n) {
    const s = cp(t, n), r = s > 0 ? s : 1 - s;
    if (e === "YY") {
      const a = r % 100;
      return Ot(a, 2);
    }
    return e === "Yo" ? i.ordinalNumber(r, { unit: "year" }) : Ot(r, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const i = R0(t);
    return Ot(i, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const i = t.getFullYear();
    return Ot(i, e.length);
  },
  // Quarter
  Q: function(t, e, i) {
    const n = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return Ot(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return i.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return i.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, i) {
    const n = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return Ot(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return i.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return i.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return i.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return i.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, i) {
    const n = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return $s.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return i.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return i.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return i.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return i.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, i) {
    const n = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return Ot(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return i.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return i.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return i.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return i.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, i, n) {
    const s = fp(t, n);
    return e === "wo" ? i.ordinalNumber(s, { unit: "week" }) : Ot(s, e.length);
  },
  // ISO week of year
  I: function(t, e, i) {
    const n = dp(t);
    return e === "Io" ? i.ordinalNumber(n, { unit: "week" }) : Ot(n, e.length);
  },
  // Day of the month
  d: function(t, e, i) {
    return e === "do" ? i.ordinalNumber(t.getDate(), { unit: "date" }) : $s.d(t, e);
  },
  // Day of year
  D: function(t, e, i) {
    const n = bM(t);
    return e === "Do" ? i.ordinalNumber(n, { unit: "dayOfYear" }) : Ot(n, e.length);
  },
  // Day of week
  E: function(t, e, i) {
    const n = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return i.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return i.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, i, n) {
    const s = t.getDay(), r = (s - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(r);
      // Padded numerical value
      case "ee":
        return Ot(r, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return i.ordinalNumber(r, { unit: "day" });
      case "eee":
        return i.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return i.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return i.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return i.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, i, n) {
    const s = t.getDay(), r = (s - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(r);
      // Padded numerical value
      case "cc":
        return Ot(r, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return i.ordinalNumber(r, { unit: "day" });
      case "ccc":
        return i.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return i.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return i.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return i.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, i) {
    const n = t.getDay(), s = n === 0 ? 7 : n;
    switch (e) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return Ot(s, e.length);
      // 2nd
      case "io":
        return i.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return i.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return i.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return i.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return i.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, i) {
    const s = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return i.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return i.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return i.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, i) {
    const n = t.getHours();
    let s;
    switch (n === 12 ? s = fa.noon : n === 0 ? s = fa.midnight : s = n / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return i.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return i.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return i.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, i) {
    const n = t.getHours();
    let s;
    switch (n >= 17 ? s = fa.evening : n >= 12 ? s = fa.afternoon : n >= 4 ? s = fa.morning : s = fa.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, i) {
    if (e === "ho") {
      let n = t.getHours() % 12;
      return n === 0 && (n = 12), i.ordinalNumber(n, { unit: "hour" });
    }
    return $s.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, i) {
    return e === "Ho" ? i.ordinalNumber(t.getHours(), { unit: "hour" }) : $s.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, i) {
    const n = t.getHours() % 12;
    return e === "Ko" ? i.ordinalNumber(n, { unit: "hour" }) : Ot(n, e.length);
  },
  // Hour [1-24]
  k: function(t, e, i) {
    let n = t.getHours();
    return n === 0 && (n = 24), e === "ko" ? i.ordinalNumber(n, { unit: "hour" }) : Ot(n, e.length);
  },
  // Minute
  m: function(t, e, i) {
    return e === "mo" ? i.ordinalNumber(t.getMinutes(), { unit: "minute" }) : $s.m(t, e);
  },
  // Second
  s: function(t, e, i) {
    return e === "so" ? i.ordinalNumber(t.getSeconds(), { unit: "second" }) : $s.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return $s.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, i) {
    const n = t.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return VA(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Lr(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Lr(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, i) {
    const n = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return VA(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Lr(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Lr(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, i) {
    const n = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + UA(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Lr(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, i) {
    const n = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + UA(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Lr(n, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, i) {
    const n = Math.trunc(+t / 1e3);
    return Ot(n, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, i) {
    return Ot(+t, e.length);
  }
};
function UA(t, e = "") {
  const i = t > 0 ? "-" : "+", n = Math.abs(t), s = Math.trunc(n / 60), r = n % 60;
  return r === 0 ? i + String(s) : i + String(s) + e + Ot(r, 2);
}
function VA(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Ot(Math.abs(t) / 60, 2) : Lr(t, e);
}
function Lr(t, e = "") {
  const i = t > 0 ? "-" : "+", n = Math.abs(t), s = Ot(Math.trunc(n / 60), 2), r = Ot(n % 60, 2);
  return i + s + e + r;
}
const qA = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, X0 = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, TM = (t, e) => {
  const i = t.match(/(P+)(p+)?/) || [], n = i[1], s = i[2];
  if (!s)
    return qA(t, e);
  let r;
  switch (n) {
    case "P":
      r = e.dateTime({ width: "short" });
      break;
    case "PP":
      r = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r = e.dateTime({ width: "full" });
      break;
  }
  return r.replace("{{date}}", qA(n, e)).replace("{{time}}", X0(s, e));
}, rh = {
  p: X0,
  P: TM
}, xM = /^D+$/, SM = /^Y+$/, CM = ["D", "DD", "YY", "YYYY"];
function j0(t) {
  return xM.test(t);
}
function G0(t) {
  return SM.test(t);
}
function ah(t, e, i) {
  const n = EM(t, e, i);
  if (console.warn(n), CM.includes(t)) throw new RangeError(n);
}
function EM(t, e, i) {
  const n = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${n} to the input \`${i}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const DM = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, _M = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, kM = /^'([^]*?)'?$/, PM = /''/g, IM = /[a-zA-Z]/;
function es(t, e, i) {
  var d, c, A, m, p, h, g, w;
  const n = oa(), s = (i == null ? void 0 : i.locale) ?? n.locale ?? Y0, r = (i == null ? void 0 : i.firstWeekContainsDate) ?? ((c = (d = i == null ? void 0 : i.locale) == null ? void 0 : d.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((m = (A = n.locale) == null ? void 0 : A.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, a = (i == null ? void 0 : i.weekStartsOn) ?? ((h = (p = i == null ? void 0 : i.locale) == null ? void 0 : p.options) == null ? void 0 : h.weekStartsOn) ?? n.weekStartsOn ?? ((w = (g = n.locale) == null ? void 0 : g.options) == null ? void 0 : w.weekStartsOn) ?? 0, o = et(t, i == null ? void 0 : i.in);
  if (!Pa(o))
    throw new RangeError("Invalid time value");
  let l = e.match(_M).map((b) => {
    const y = b[0];
    if (y === "p" || y === "P") {
      const D = rh[y];
      return D(b, s.formatLong);
    }
    return b;
  }).join("").match(DM).map((b) => {
    if (b === "''")
      return { isToken: !1, value: "'" };
    const y = b[0];
    if (y === "'")
      return { isToken: !1, value: MM(b) };
    if (zA[y])
      return { isToken: !0, value: b };
    if (y.match(IM))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + y + "`"
      );
    return { isToken: !1, value: b };
  });
  s.localize.preprocessor && (l = s.localize.preprocessor(o, l));
  const u = {
    firstWeekContainsDate: r,
    weekStartsOn: a,
    locale: s
  };
  return l.map((b) => {
    if (!b.isToken) return b.value;
    const y = b.value;
    (!(i != null && i.useAdditionalWeekYearTokens) && G0(y) || !(i != null && i.useAdditionalDayOfYearTokens) && j0(y)) && ah(y, e, String(t));
    const D = zA[y[0]];
    return D(o, y, s.localize, u);
  }).join("");
}
function MM(t) {
  const e = t.match(kM);
  return e ? e[1].replace(PM, "'") : t;
}
function OM(t, e) {
  return et(t, e == null ? void 0 : e.in).getDay();
}
function BM(t, e) {
  const i = et(t, e == null ? void 0 : e.in), n = i.getFullYear(), s = i.getMonth(), r = Pt(i, 0);
  return r.setFullYear(n, s + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function LM() {
  return Object.assign({}, oa());
}
function Hs(t, e) {
  return et(t, e == null ? void 0 : e.in).getHours();
}
function NM(t, e) {
  const i = et(t, e == null ? void 0 : e.in).getDay();
  return i === 0 ? 7 : i;
}
function gr(t, e) {
  return et(t, e == null ? void 0 : e.in).getMinutes();
}
function vt(t, e) {
  return et(t, e == null ? void 0 : e.in).getMonth();
}
function Qa(t) {
  return et(t).getSeconds();
}
function lt(t, e) {
  return et(t, e == null ? void 0 : e.in).getFullYear();
}
function ea(t, e) {
  return +et(t) > +et(e);
}
function Za(t, e) {
  return +et(t) < +et(e);
}
function Ta(t, e) {
  return +et(t) == +et(e);
}
function RM(t, e) {
  const i = FM(e) ? new e(0) : Pt(e, 0);
  return i.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), i.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), i;
}
function FM(t) {
  var e;
  return typeof t == "function" && ((e = t.prototype) == null ? void 0 : e.constructor) === t;
}
const zM = 10;
class Q0 {
  constructor() {
    ze(this, "subPriority", 0);
  }
  validate(e, i) {
    return !0;
  }
}
class UM extends Q0 {
  constructor(e, i, n, s, r) {
    super(), this.value = e, this.validateValue = i, this.setValue = n, this.priority = s, r && (this.subPriority = r);
  }
  validate(e, i) {
    return this.validateValue(e, this.value, i);
  }
  set(e, i, n) {
    return this.setValue(e, i, this.value, n);
  }
}
class VM extends Q0 {
  constructor(i, n) {
    super();
    ze(this, "priority", zM);
    ze(this, "subPriority", -1);
    this.context = i || ((s) => Pt(n, s));
  }
  set(i, n) {
    return n.timestampIsSet ? i : Pt(i, RM(i, this.context));
  }
}
let Ct = class {
  run(e, i, n, s) {
    const r = this.parse(e, i, n, s);
    return r ? {
      setter: new UM(
        r.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: r.rest
    } : null;
  }
  validate(e, i, n) {
    return !0;
  }
};
class qM extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 140);
    ze(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return s.era(i, { width: "abbreviated" }) || s.era(i, { width: "narrow" });
      // A, B
      case "GGGGG":
        return s.era(i, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return s.era(i, { width: "wide" }) || s.era(i, { width: "abbreviated" }) || s.era(i, { width: "narrow" });
    }
  }
  set(i, n, s) {
    return n.era = s, i.setFullYear(s, 0, 1), i.setHours(0, 0, 0, 0), i;
  }
}
const mi = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, ms = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Ai(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function ii(t, e) {
  const i = e.match(t);
  return i ? {
    value: parseInt(i[0], 10),
    rest: e.slice(i[0].length)
  } : null;
}
function As(t, e) {
  const i = e.match(t);
  if (!i)
    return null;
  if (i[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const n = i[1] === "+" ? 1 : -1, s = i[2] ? parseInt(i[2], 10) : 0, r = i[3] ? parseInt(i[3], 10) : 0, a = i[5] ? parseInt(i[5], 10) : 0;
  return {
    value: n * (s * Vd + r * lp + a * OI),
    rest: e.slice(i[0].length)
  };
}
function Z0(t) {
  return ii(mi.anyDigitsSigned, t);
}
function ui(t, e) {
  switch (t) {
    case 1:
      return ii(mi.singleDigit, e);
    case 2:
      return ii(mi.twoDigits, e);
    case 3:
      return ii(mi.threeDigits, e);
    case 4:
      return ii(mi.fourDigits, e);
    default:
      return ii(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function $u(t, e) {
  switch (t) {
    case 1:
      return ii(mi.singleDigitSigned, e);
    case 2:
      return ii(mi.twoDigitsSigned, e);
    case 3:
      return ii(mi.threeDigitsSigned, e);
    case 4:
      return ii(mi.fourDigitsSigned, e);
    default:
      return ii(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function hp(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function K0(t, e) {
  const i = e > 0, n = i ? e : 1 - e;
  let s;
  if (n <= 50)
    s = t || 100;
  else {
    const r = n + 50, a = Math.trunc(r / 100) * 100, o = t >= r % 100;
    s = t + a - (o ? 100 : 0);
  }
  return i ? s : 1 - s;
}
function J0(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class HM extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 130);
    ze(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(i, n, s) {
    const r = (a) => ({
      year: a,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return Ai(ui(4, i), r);
      case "yo":
        return Ai(
          s.ordinalNumber(i, {
            unit: "year"
          }),
          r
        );
      default:
        return Ai(ui(n.length, i), r);
    }
  }
  validate(i, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(i, n, s) {
    const r = i.getFullYear();
    if (s.isTwoDigitYear) {
      const o = K0(
        s.year,
        r
      );
      return i.setFullYear(o, 0, 1), i.setHours(0, 0, 0, 0), i;
    }
    const a = !("era" in n) || n.era === 1 ? s.year : 1 - s.year;
    return i.setFullYear(a, 0, 1), i.setHours(0, 0, 0, 0), i;
  }
}
class WM extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 130);
    ze(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(i, n, s) {
    const r = (a) => ({
      year: a,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return Ai(ui(4, i), r);
      case "Yo":
        return Ai(
          s.ordinalNumber(i, {
            unit: "year"
          }),
          r
        );
      default:
        return Ai(ui(n.length, i), r);
    }
  }
  validate(i, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(i, n, s, r) {
    const a = cp(i, r);
    if (s.isTwoDigitYear) {
      const l = K0(
        s.year,
        a
      );
      return i.setFullYear(
        l,
        0,
        r.firstWeekContainsDate
      ), i.setHours(0, 0, 0, 0), Tn(i, r);
    }
    const o = !("era" in n) || n.era === 1 ? s.year : 1 - s.year;
    return i.setFullYear(o, 0, r.firstWeekContainsDate), i.setHours(0, 0, 0, 0), Tn(i, r);
  }
}
class YM extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 130);
    ze(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(i, n) {
    return $u(n === "R" ? 4 : n.length, i);
  }
  set(i, n, s) {
    const r = Pt(i, 0);
    return r.setFullYear(s, 0, 4), r.setHours(0, 0, 0, 0), Ga(r);
  }
}
class XM extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 130);
    ze(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(i, n) {
    return $u(n === "u" ? 4 : n.length, i);
  }
  set(i, n, s) {
    return i.setFullYear(s, 0, 1), i.setHours(0, 0, 0, 0), i;
  }
}
class jM extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 120);
    ze(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(i, n, s) {
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return ui(n.length, i);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return s.ordinalNumber(i, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return s.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return s.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return s.quarter(i, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(i, n) {
    return n >= 1 && n <= 4;
  }
  set(i, n, s) {
    return i.setMonth((s - 1) * 3, 1), i.setHours(0, 0, 0, 0), i;
  }
}
class GM extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 120);
    ze(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(i, n, s) {
    switch (n) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return ui(n.length, i);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return s.ordinalNumber(i, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return s.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return s.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return s.quarter(i, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(i, n) {
    return n >= 1 && n <= 4;
  }
  set(i, n, s) {
    return i.setMonth((s - 1) * 3, 1), i.setHours(0, 0, 0, 0), i;
  }
}
class QM extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    ze(this, "priority", 110);
  }
  parse(i, n, s) {
    const r = (a) => a - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "M":
        return Ai(
          ii(mi.month, i),
          r
        );
      // 01, 02, ..., 12
      case "MM":
        return Ai(ui(2, i), r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return Ai(
          s.ordinalNumber(i, {
            unit: "month"
          }),
          r
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return s.month(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(i, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return s.month(i, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return s.month(i, { width: "wide", context: "formatting" }) || s.month(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(i, { width: "narrow", context: "formatting" });
    }
  }
  validate(i, n) {
    return n >= 0 && n <= 11;
  }
  set(i, n, s) {
    return i.setMonth(s, 1), i.setHours(0, 0, 0, 0), i;
  }
}
class ZM extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 110);
    ze(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(i, n, s) {
    const r = (a) => a - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return Ai(
          ii(mi.month, i),
          r
        );
      // 01, 02, ..., 12
      case "LL":
        return Ai(ui(2, i), r);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return Ai(
          s.ordinalNumber(i, {
            unit: "month"
          }),
          r
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return s.month(i, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(i, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return s.month(i, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return s.month(i, { width: "wide", context: "standalone" }) || s.month(i, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(i, { width: "narrow", context: "standalone" });
    }
  }
  validate(i, n) {
    return n >= 0 && n <= 11;
  }
  set(i, n, s) {
    return i.setMonth(s, 1), i.setHours(0, 0, 0, 0), i;
  }
}
function KM(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in), s = fp(n, i) - e;
  return n.setDate(n.getDate() - s * 7), et(n, i == null ? void 0 : i.in);
}
class JM extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 100);
    ze(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(i, n, s) {
    switch (n) {
      case "w":
        return ii(mi.week, i);
      case "wo":
        return s.ordinalNumber(i, { unit: "week" });
      default:
        return ui(n.length, i);
    }
  }
  validate(i, n) {
    return n >= 1 && n <= 53;
  }
  set(i, n, s, r) {
    return Tn(KM(i, s, r), r);
  }
}
function $M(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in), s = dp(n, i) - e;
  return n.setDate(n.getDate() - s * 7), n;
}
class eO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 100);
    ze(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(i, n, s) {
    switch (n) {
      case "I":
        return ii(mi.week, i);
      case "Io":
        return s.ordinalNumber(i, { unit: "week" });
      default:
        return ui(n.length, i);
    }
  }
  validate(i, n) {
    return n >= 1 && n <= 53;
  }
  set(i, n, s) {
    return Ga($M(i, s));
  }
}
const tO = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], iO = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class nO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 90);
    ze(this, "subPriority", 1);
    ze(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(i, n, s) {
    switch (n) {
      case "d":
        return ii(mi.date, i);
      case "do":
        return s.ordinalNumber(i, { unit: "date" });
      default:
        return ui(n.length, i);
    }
  }
  validate(i, n) {
    const s = i.getFullYear(), r = J0(s), a = i.getMonth();
    return r ? n >= 1 && n <= iO[a] : n >= 1 && n <= tO[a];
  }
  set(i, n, s) {
    return i.setDate(s), i.setHours(0, 0, 0, 0), i;
  }
}
class sO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 90);
    ze(this, "subpriority", 1);
    ze(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(i, n, s) {
    switch (n) {
      case "D":
      case "DD":
        return ii(mi.dayOfYear, i);
      case "Do":
        return s.ordinalNumber(i, { unit: "date" });
      default:
        return ui(n.length, i);
    }
  }
  validate(i, n) {
    const s = i.getFullYear();
    return J0(s) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(i, n, s) {
    return i.setMonth(0, s), i.setHours(0, 0, 0, 0), i;
  }
}
function pp(t, e, i) {
  var c, A, m, p;
  const n = oa(), s = (i == null ? void 0 : i.weekStartsOn) ?? ((A = (c = i == null ? void 0 : i.locale) == null ? void 0 : c.options) == null ? void 0 : A.weekStartsOn) ?? n.weekStartsOn ?? ((p = (m = n.locale) == null ? void 0 : m.options) == null ? void 0 : p.weekStartsOn) ?? 0, r = et(t, i == null ? void 0 : i.in), a = r.getDay(), l = (e % 7 + 7) % 7, u = 7 - s, d = e < 0 || e > 6 ? e - (a + u) % 7 : (l + u) % 7 - (a + u) % 7;
  return In(r, d, i);
}
class rO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 90);
    ze(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return s.day(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(i, { width: "short", context: "formatting" }) || s.day(i, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return s.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return s.day(i, { width: "short", context: "formatting" }) || s.day(i, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return s.day(i, { width: "wide", context: "formatting" }) || s.day(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(i, { width: "short", context: "formatting" }) || s.day(i, { width: "narrow", context: "formatting" });
    }
  }
  validate(i, n) {
    return n >= 0 && n <= 6;
  }
  set(i, n, s, r) {
    return i = pp(i, s, r), i.setHours(0, 0, 0, 0), i;
  }
}
class aO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 90);
    ze(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(i, n, s, r) {
    const a = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      // 3
      case "e":
      case "ee":
        return Ai(ui(n.length, i), a);
      // 3rd
      case "eo":
        return Ai(
          s.ordinalNumber(i, {
            unit: "day"
          }),
          a
        );
      // Tue
      case "eee":
        return s.day(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(i, { width: "short", context: "formatting" }) || s.day(i, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return s.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return s.day(i, { width: "short", context: "formatting" }) || s.day(i, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return s.day(i, { width: "wide", context: "formatting" }) || s.day(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(i, { width: "short", context: "formatting" }) || s.day(i, { width: "narrow", context: "formatting" });
    }
  }
  validate(i, n) {
    return n >= 0 && n <= 6;
  }
  set(i, n, s, r) {
    return i = pp(i, s, r), i.setHours(0, 0, 0, 0), i;
  }
}
class oO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 90);
    ze(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(i, n, s, r) {
    const a = (o) => {
      const l = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      // 3
      case "c":
      case "cc":
        return Ai(ui(n.length, i), a);
      // 3rd
      case "co":
        return Ai(
          s.ordinalNumber(i, {
            unit: "day"
          }),
          a
        );
      // Tue
      case "ccc":
        return s.day(i, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(i, { width: "short", context: "standalone" }) || s.day(i, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return s.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return s.day(i, { width: "short", context: "standalone" }) || s.day(i, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return s.day(i, { width: "wide", context: "standalone" }) || s.day(i, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(i, { width: "short", context: "standalone" }) || s.day(i, { width: "narrow", context: "standalone" });
    }
  }
  validate(i, n) {
    return n >= 0 && n <= 6;
  }
  set(i, n, s, r) {
    return i = pp(i, s, r), i.setHours(0, 0, 0, 0), i;
  }
}
function lO(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in), s = NM(n, i), r = e - s;
  return In(n, r, i);
}
class uO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 90);
    ze(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(i, n, s) {
    const r = (a) => a === 0 ? 7 : a;
    switch (n) {
      // 2
      case "i":
      case "ii":
        return ui(n.length, i);
      // 2nd
      case "io":
        return s.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return Ai(
          s.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // T
      case "iiiii":
        return Ai(
          s.day(i, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // Tu
      case "iiiiii":
        return Ai(
          s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // Tuesday
      case "iiii":
      default:
        return Ai(
          s.day(i, {
            width: "wide",
            context: "formatting"
          }) || s.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
    }
  }
  validate(i, n) {
    return n >= 1 && n <= 7;
  }
  set(i, n, s) {
    return i = lO(i, s), i.setHours(0, 0, 0, 0), i;
  }
}
class dO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 80);
    ze(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(i, n, s) {
    return i.setHours(hp(s), 0, 0, 0), i;
  }
}
class cO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 80);
    ze(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(i, n, s) {
    return i.setHours(hp(s), 0, 0, 0), i;
  }
}
class fO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 80);
    ze(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(i, n, s) {
    return i.setHours(hp(s), 0, 0, 0), i;
  }
}
class hO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 70);
    ze(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      case "h":
        return ii(mi.hour12h, i);
      case "ho":
        return s.ordinalNumber(i, { unit: "hour" });
      default:
        return ui(n.length, i);
    }
  }
  validate(i, n) {
    return n >= 1 && n <= 12;
  }
  set(i, n, s) {
    const r = i.getHours() >= 12;
    return r && s < 12 ? i.setHours(s + 12, 0, 0, 0) : !r && s === 12 ? i.setHours(0, 0, 0, 0) : i.setHours(s, 0, 0, 0), i;
  }
}
class pO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 70);
    ze(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      case "H":
        return ii(mi.hour23h, i);
      case "Ho":
        return s.ordinalNumber(i, { unit: "hour" });
      default:
        return ui(n.length, i);
    }
  }
  validate(i, n) {
    return n >= 0 && n <= 23;
  }
  set(i, n, s) {
    return i.setHours(s, 0, 0, 0), i;
  }
}
class mO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 70);
    ze(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      case "K":
        return ii(mi.hour11h, i);
      case "Ko":
        return s.ordinalNumber(i, { unit: "hour" });
      default:
        return ui(n.length, i);
    }
  }
  validate(i, n) {
    return n >= 0 && n <= 11;
  }
  set(i, n, s) {
    return i.getHours() >= 12 && s < 12 ? i.setHours(s + 12, 0, 0, 0) : i.setHours(s, 0, 0, 0), i;
  }
}
class AO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 70);
    ze(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      case "k":
        return ii(mi.hour24h, i);
      case "ko":
        return s.ordinalNumber(i, { unit: "hour" });
      default:
        return ui(n.length, i);
    }
  }
  validate(i, n) {
    return n >= 1 && n <= 24;
  }
  set(i, n, s) {
    const r = s <= 24 ? s % 24 : s;
    return i.setHours(r, 0, 0, 0), i;
  }
}
class gO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 60);
    ze(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      case "m":
        return ii(mi.minute, i);
      case "mo":
        return s.ordinalNumber(i, { unit: "minute" });
      default:
        return ui(n.length, i);
    }
  }
  validate(i, n) {
    return n >= 0 && n <= 59;
  }
  set(i, n, s) {
    return i.setMinutes(s, 0, 0), i;
  }
}
class vO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 50);
    ze(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(i, n, s) {
    switch (n) {
      case "s":
        return ii(mi.second, i);
      case "so":
        return s.ordinalNumber(i, { unit: "second" });
      default:
        return ui(n.length, i);
    }
  }
  validate(i, n) {
    return n >= 0 && n <= 59;
  }
  set(i, n, s) {
    return i.setSeconds(s, 0), i;
  }
}
class yO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 30);
    ze(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(i, n) {
    const s = (r) => Math.trunc(r * Math.pow(10, -n.length + 3));
    return Ai(ui(n.length, i), s);
  }
  set(i, n, s) {
    return i.setMilliseconds(s), i;
  }
}
class bO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 10);
    ze(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(i, n) {
    switch (n) {
      case "X":
        return As(
          ms.basicOptionalMinutes,
          i
        );
      case "XX":
        return As(ms.basic, i);
      case "XXXX":
        return As(
          ms.basicOptionalSeconds,
          i
        );
      case "XXXXX":
        return As(
          ms.extendedOptionalSeconds,
          i
        );
      case "XXX":
      default:
        return As(ms.extended, i);
    }
  }
  set(i, n, s) {
    return n.timestampIsSet ? i : Pt(
      i,
      i.getTime() - Ju(i) - s
    );
  }
}
class wO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 10);
    ze(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(i, n) {
    switch (n) {
      case "x":
        return As(
          ms.basicOptionalMinutes,
          i
        );
      case "xx":
        return As(ms.basic, i);
      case "xxxx":
        return As(
          ms.basicOptionalSeconds,
          i
        );
      case "xxxxx":
        return As(
          ms.extendedOptionalSeconds,
          i
        );
      case "xxx":
      default:
        return As(ms.extended, i);
    }
  }
  set(i, n, s) {
    return n.timestampIsSet ? i : Pt(
      i,
      i.getTime() - Ju(i) - s
    );
  }
}
class TO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 40);
    ze(this, "incompatibleTokens", "*");
  }
  parse(i) {
    return Z0(i);
  }
  set(i, n, s) {
    return [Pt(i, s * 1e3), { timestampIsSet: !0 }];
  }
}
class xO extends Ct {
  constructor() {
    super(...arguments);
    ze(this, "priority", 20);
    ze(this, "incompatibleTokens", "*");
  }
  parse(i) {
    return Z0(i);
  }
  set(i, n, s) {
    return [Pt(i, s), { timestampIsSet: !0 }];
  }
}
const SO = {
  G: new qM(),
  y: new HM(),
  Y: new WM(),
  R: new YM(),
  u: new XM(),
  Q: new jM(),
  q: new GM(),
  M: new QM(),
  L: new ZM(),
  w: new JM(),
  I: new eO(),
  d: new nO(),
  D: new sO(),
  E: new rO(),
  e: new aO(),
  c: new oO(),
  i: new uO(),
  a: new dO(),
  b: new cO(),
  B: new fO(),
  h: new hO(),
  H: new pO(),
  K: new mO(),
  k: new AO(),
  m: new gO(),
  s: new vO(),
  S: new yO(),
  X: new bO(),
  x: new wO(),
  t: new TO(),
  T: new xO()
}, CO = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, EO = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, DO = /^'([^]*?)'?$/, _O = /''/g, kO = /\S/, PO = /[a-zA-Z]/;
function oh(t, e, i, n) {
  var g, w, b, y, D, I, M, _;
  const s = () => Pt((n == null ? void 0 : n.in) || i, NaN), r = LM(), a = (n == null ? void 0 : n.locale) ?? r.locale ?? Y0, o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((w = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : w.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((y = (b = r.locale) == null ? void 0 : b.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, l = (n == null ? void 0 : n.weekStartsOn) ?? ((I = (D = n == null ? void 0 : n.locale) == null ? void 0 : D.options) == null ? void 0 : I.weekStartsOn) ?? r.weekStartsOn ?? ((_ = (M = r.locale) == null ? void 0 : M.options) == null ? void 0 : _.weekStartsOn) ?? 0;
  if (!e)
    return t ? s() : et(i, n == null ? void 0 : n.in);
  const u = {
    firstWeekContainsDate: o,
    weekStartsOn: l,
    locale: a
  }, d = [new VM(n == null ? void 0 : n.in, i)], c = e.match(EO).map((N) => {
    const x = N[0];
    if (x in rh) {
      const C = rh[x];
      return C(N, a.formatLong);
    }
    return N;
  }).join("").match(CO), A = [];
  for (let N of c) {
    !(n != null && n.useAdditionalWeekYearTokens) && G0(N) && ah(N, e, t), !(n != null && n.useAdditionalDayOfYearTokens) && j0(N) && ah(N, e, t);
    const x = N[0], C = SO[x];
    if (C) {
      const { incompatibleTokens: L } = C;
      if (Array.isArray(L)) {
        const H = A.find(
          (O) => L.includes(O.token) || O.token === x
        );
        if (H)
          throw new RangeError(
            `The format string mustn't contain \`${H.fullToken}\` and \`${N}\` at the same time`
          );
      } else if (C.incompatibleTokens === "*" && A.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${N}\` and any other token at the same time`
        );
      A.push({ token: x, fullToken: N });
      const V = C.run(
        t,
        N,
        a.match,
        u
      );
      if (!V)
        return s();
      d.push(V.setter), t = V.rest;
    } else {
      if (x.match(PO))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + x + "`"
        );
      if (N === "''" ? N = "'" : x === "'" && (N = IO(N)), t.indexOf(N) === 0)
        t = t.slice(N.length);
      else
        return s();
    }
  }
  if (t.length > 0 && kO.test(t))
    return s();
  const m = d.map((N) => N.priority).sort((N, x) => x - N).filter((N, x, C) => C.indexOf(N) === x).map(
    (N) => d.filter((x) => x.priority === N).sort((x, C) => C.subPriority - x.subPriority)
  ).map((N) => N[0]);
  let p = et(i, n == null ? void 0 : n.in);
  if (isNaN(+p)) return s();
  const h = {};
  for (const N of m) {
    if (!N.validate(p, u))
      return s();
    const x = N.set(p, h, u);
    Array.isArray(x) ? (p = x[0], Object.assign(h, x[1])) : p = x;
  }
  return p;
}
function IO(t) {
  return t.match(DO)[1].replace(_O, "'");
}
function HA(t, e, i) {
  const [n, s] = Ao(
    i == null ? void 0 : i.in,
    t,
    e
  );
  return +Tn(n, i) == +Tn(s, i);
}
function WA(t, e, i) {
  const [n, s] = Ao(
    i == null ? void 0 : i.in,
    t,
    e
  );
  return +Ur(n) == +Ur(s);
}
function xa(t, e, i) {
  return In(t, -e, i);
}
function Vc(t, e) {
  const i = () => Pt(e == null ? void 0 : e.in, NaN), s = LO(t);
  let r;
  if (s.date) {
    const u = NO(s.date, 2);
    r = RO(u.restDateString, u.year);
  }
  if (!r || isNaN(+r)) return i();
  const a = +r;
  let o = 0, l;
  if (s.time && (o = FO(s.time), isNaN(o)))
    return i();
  if (s.timezone) {
    if (l = zO(s.timezone), isNaN(l)) return i();
  } else {
    const u = new Date(a + o), d = et(0, e == null ? void 0 : e.in);
    return d.setFullYear(
      u.getUTCFullYear(),
      u.getUTCMonth(),
      u.getUTCDate()
    ), d.setHours(
      u.getUTCHours(),
      u.getUTCMinutes(),
      u.getUTCSeconds(),
      u.getUTCMilliseconds()
    ), d;
  }
  return et(a + o + l, e == null ? void 0 : e.in);
}
const wu = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, MO = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, OO = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, BO = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function LO(t) {
  const e = {}, i = t.split(wu.dateTimeDelimiter);
  let n;
  if (i.length > 2)
    return e;
  if (/:/.test(i[0]) ? n = i[0] : (e.date = i[0], n = i[1], wu.timeZoneDelimiter.test(e.date) && (e.date = t.split(wu.timeZoneDelimiter)[0], n = t.substr(
    e.date.length,
    t.length
  ))), n) {
    const s = wu.timezone.exec(n);
    s ? (e.time = n.replace(s[1], ""), e.timezone = s[1]) : e.time = n;
  }
  return e;
}
function NO(t, e) {
  const i = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), n = t.match(i);
  if (!n) return { year: NaN, restDateString: "" };
  const s = n[1] ? parseInt(n[1]) : null, r = n[2] ? parseInt(n[2]) : null;
  return {
    year: r === null ? s : r * 100,
    restDateString: t.slice((n[1] || n[2]).length)
  };
}
function RO(t, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  const i = t.match(MO);
  if (!i) return /* @__PURE__ */ new Date(NaN);
  const n = !!i[4], s = Ho(i[1]), r = Ho(i[2]) - 1, a = Ho(i[3]), o = Ho(i[4]), l = Ho(i[5]) - 1;
  if (n)
    return WO(e, o, l) ? UO(e, o, l) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !qO(e, r, a) || !HO(e, s) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(e, r, Math.max(s, a)), u);
  }
}
function Ho(t) {
  return t ? parseInt(t) : 1;
}
function FO(t) {
  const e = t.match(OO);
  if (!e) return NaN;
  const i = qc(e[1]), n = qc(e[2]), s = qc(e[3]);
  return YO(i, n, s) ? i * Vd + n * lp + s * 1e3 : NaN;
}
function qc(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function zO(t) {
  if (t === "Z") return 0;
  const e = t.match(BO);
  if (!e) return 0;
  const i = e[1] === "+" ? -1 : 1, n = parseInt(e[2]), s = e[3] && parseInt(e[3]) || 0;
  return XO(n, s) ? i * (n * Vd + s * lp) : NaN;
}
function UO(t, e, i) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4);
  const s = n.getUTCDay() || 7, r = (e - 1) * 7 + i + 1 - s;
  return n.setUTCDate(n.getUTCDate() + r), n;
}
const VO = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function $0(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function qO(t, e, i) {
  return e >= 0 && e <= 11 && i >= 1 && i <= (VO[e] || ($0(t) ? 29 : 28));
}
function HO(t, e) {
  return e >= 1 && e <= ($0(t) ? 366 : 365);
}
function WO(t, e, i) {
  return e >= 1 && e <= 53 && i >= 0 && i <= 6;
}
function YO(t, e, i) {
  return t === 24 ? e === 0 && i === 0 : i >= 0 && i < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function XO(t, e) {
  return e >= 0 && e <= 59;
}
function ey(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in), s = n.getFullYear(), r = n.getDate(), a = Pt(t, 0);
  a.setFullYear(s, e, 15), a.setHours(0, 0, 0, 0);
  const o = BM(a);
  return n.setMonth(e, Math.min(r, o)), n;
}
function Lt(t, e, i) {
  let n = et(t, i == null ? void 0 : i.in);
  return isNaN(+n) ? Pt(t, NaN) : (e.year != null && n.setFullYear(e.year), e.month != null && (n = ey(n, e.month)), e.date != null && n.setDate(e.date), e.hours != null && n.setHours(e.hours), e.minutes != null && n.setMinutes(e.minutes), e.seconds != null && n.setSeconds(e.seconds), e.milliseconds != null && n.setMilliseconds(e.milliseconds), n);
}
function jO(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in);
  return n.setHours(e), n;
}
function ty(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in);
  return n.setMilliseconds(e), n;
}
function GO(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in);
  return n.setMinutes(e), n;
}
function iy(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in);
  return n.setSeconds(e), n;
}
function gs(t, e, i) {
  const n = et(t, i == null ? void 0 : i.in);
  return isNaN(+n) ? Pt(t, NaN) : (n.setFullYear(e), n);
}
function Ka(t, e, i) {
  return $n(t, -e, i);
}
function QO(t, e, i) {
  const {
    years: n = 0,
    months: s = 0,
    weeks: r = 0,
    days: a = 0,
    hours: o = 0,
    minutes: l = 0,
    seconds: u = 0
  } = e, d = Ka(t, s + n * 12, i), c = xa(d, a + r * 7, i), A = l + o * 60, p = (u + A * 60) * 1e3;
  return Pt(t, +c - p);
}
function mp(t, e, i) {
  return up(t, -e, i);
}
function Wo(t, e) {
  if (t.one !== void 0 && e === 1)
    return t.one;
  const i = e % 10, n = e % 100;
  return i === 1 && n !== 11 ? t.singularNominative.replace("{{count}}", String(e)) : i >= 2 && i <= 4 && (n < 10 || n > 20) ? t.singularGenitive.replace("{{count}}", String(e)) : t.pluralGenitive.replace("{{count}}", String(e));
}
function Gi(t) {
  return (e, i) => i != null && i.addSuffix ? i.comparison && i.comparison > 0 ? t.future ? Wo(t.future, e) : "через " + Wo(t.regular, e) : t.past ? Wo(t.past, e) : Wo(t.regular, e) + " назад" : Wo(t.regular, e);
}
const ZO = {
  lessThanXSeconds: Gi({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: Gi({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: (t, e) => e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты",
  lessThanXMinutes: Gi({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: Gi({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: Gi({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: Gi({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: Gi({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: Gi({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: Gi({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: Gi({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: Gi({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: Gi({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: Gi({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: Gi({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: Gi({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, KO = (t, e, i) => ZO[t](e, i), JO = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, $O = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, eB = {
  any: "{{date}}, {{time}}"
}, tB = {
  date: Ia({
    formats: JO,
    defaultWidth: "full"
  }),
  time: Ia({
    formats: $O,
    defaultWidth: "full"
  }),
  dateTime: Ia({
    formats: eB,
    defaultWidth: "any"
  })
}, Ap = [
  "воскресенье",
  "понедельник",
  "вторник",
  "среду",
  "четверг",
  "пятницу",
  "субботу"
];
function iB(t) {
  const e = Ap[t];
  switch (t) {
    case 0:
      return "'в прошлое " + e + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + e + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + e + " в' p";
  }
}
function YA(t) {
  const e = Ap[t];
  return t === 2 ? "'во " + e + " в' p" : "'в " + e + " в' p";
}
function nB(t) {
  const e = Ap[t];
  switch (t) {
    case 0:
      return "'в следующее " + e + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + e + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + e + " в' p";
  }
}
const sB = {
  lastWeek: (t, e, i) => {
    const n = t.getDay();
    return HA(t, e, i) ? YA(n) : iB(n);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: (t, e, i) => {
    const n = t.getDay();
    return HA(t, e, i) ? YA(n) : nB(n);
  },
  other: "P"
}, rB = (t, e, i, n) => {
  const s = sB[t];
  return typeof s == "function" ? s(e, i, n) : s;
}, aB = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, oB = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, lB = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "март",
    "апр.",
    "май",
    "июнь",
    "июль",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь"
  ]
}, uB = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря"
  ]
}, dB = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота"
  ]
}, cB = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, fB = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, hB = (t, e) => {
  const i = Number(t), n = e == null ? void 0 : e.unit;
  let s;
  return n === "date" ? s = "-е" : n === "week" || n === "minute" || n === "second" ? s = "-я" : s = "-й", i + s;
}, pB = {
  ordinalNumber: hB,
  era: hs({
    values: aB,
    defaultWidth: "wide"
  }),
  quarter: hs({
    values: oB,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: hs({
    values: lB,
    defaultWidth: "wide",
    formattingValues: uB,
    defaultFormattingWidth: "wide"
  }),
  day: hs({
    values: dB,
    defaultWidth: "wide"
  }),
  dayPeriod: hs({
    values: cB,
    defaultWidth: "any",
    formattingValues: fB,
    defaultFormattingWidth: "wide"
  })
}, mB = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, AB = /\d+/i, gB = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, vB = {
  any: [/^д/i, /^н/i]
}, yB = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, bB = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wB = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, TB = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^я/i
  ],
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^ма[йя]/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, xB = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, SB = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, CB = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, EB = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, DB = {
  ordinalNumber: W0({
    matchPattern: mB,
    parsePattern: AB,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: ps({
    matchPatterns: gB,
    defaultMatchWidth: "wide",
    parsePatterns: vB,
    defaultParseWidth: "any"
  }),
  quarter: ps({
    matchPatterns: yB,
    defaultMatchWidth: "wide",
    parsePatterns: bB,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: ps({
    matchPatterns: wB,
    defaultMatchWidth: "wide",
    parsePatterns: TB,
    defaultParseWidth: "any"
  }),
  day: ps({
    matchPatterns: xB,
    defaultMatchWidth: "wide",
    parsePatterns: SB,
    defaultParseWidth: "any"
  }),
  dayPeriod: ps({
    matchPatterns: CB,
    defaultMatchWidth: "wide",
    parsePatterns: EB,
    defaultParseWidth: "any"
  })
}, _B = {
  code: "ru",
  formatDistance: KO,
  formatLong: tB,
  formatRelative: rB,
  localize: pB,
  match: DB,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, kB = { class: "ui-file-card__info" }, PB = { key: 0 }, IB = { key: 0 }, MB = { key: 1 }, OB = ["datetime"], BB = { key: 2 }, LB = /* @__PURE__ */ qe({
  name: "UiFileCard",
  __name: "UiFileCard",
  props: {
    color: {
      type: String,
      default: "outline"
    },
    fileType: {
      type: String,
      default: Yt.OTHER
    },
    title: {
      type: String,
      default: ""
    },
    fileSize: {
      // In bytes
      type: Number,
      default: 0
    },
    date: {
      //only iso 8601 format
      type: String,
      default: ""
    },
    author: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    downloadButton: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["download"],
  setup(t) {
    const e = t, i = J(() => e.link ? "a" : "div"), n = J(() => {
      switch (e.fileType) {
        case Yt.PDF:
          return r_;
        case Yt.DOC:
          return KD;
        case Yt.DOCX:
          return HD;
        case Yt.TXT:
          return LD;
        case Yt.CSV:
          return DD;
        case Yt.XLS:
          return yD;
        case Yt.XLSX:
          return cD;
        case Yt.PPT:
          return nD;
        case Yt.PPTX:
          return QE;
        case Yt.ZIP:
          return xC;
        case Yt.RAR:
          return IC;
        case Yt.MP3:
          return VE;
        case Yt.WAV:
          return CE;
        case Yt.MP4:
          return OE;
        case Yt.AVI:
          return gE;
        case Yt.IMG:
          return uE;
        case Yt.JPG:
          return pA;
        case Yt.JPEG:
          return pA;
        case Yt.PNG:
          return zC;
        case Yt.GIF:
          return jC;
        case Yt.SVG:
          return tE;
        case Yt.OTHER:
          return cA;
        default:
          return cA;
      }
    }), s = J(() => ({
      ...i.value === "a" && {
        download: c.value,
        href: e.link,
        target: "_blank"
      }
    })), r = J(() => e.fileSize || e.date || e.author), a = J(() => {
      if (!e.date)
        return !1;
      try {
        return Pa(Vc(e.date));
      } catch {
        return !1;
      }
    }), o = J(() => a.value ? Vc(e.date).toISOString() : null), l = J(() => a.value), u = J(() => {
      if (!a.value)
        return "";
      const A = Vc(e.date);
      return `Дата публикации: ${es(A, "dd.MM.yyyy HH:mm", { locale: _B })}`;
    }), d = J(() => {
      if (!e.fileSize || e.fileSize === 0)
        return 0;
      const A = e.fileSize / 1024;
      return A > 1024 ? `${(A / 1024).toFixed(2)} MB` : `${Math.round(A)} KB`;
    }), c = J(() => `${e.title}${e.fileType !== Yt.OTHER ? `.${e.fileType}` : ""}`);
    return (A, m) => (k(), Ce(Ft(i.value), Ut({
      class: ["ui-file-card", [`ui-file-card_color_${t.color}`]]
    }, s.value), {
      default: De(() => [
        Se(A.$slots, "icon", {}, () => [
          (k(), Ce(Ft(n.value)))
        ], !0),
        re("div", kB, [
          re("h6", null, _e(c.value), 1),
          r.value ? (k(), U("p", PB, [
            t.fileSize ? (k(), U("span", IB, _e(d.value), 1)) : ie("", !0),
            l.value ? (k(), U("span", MB, [
              re("time", { datetime: o.value }, _e(u.value), 9, OB)
            ])) : ie("", !0),
            t.author ? (k(), U("span", BB, "Автор: " + _e(t.author), 1)) : ie("", !0)
          ])) : ie("", !0)
        ]),
        t.downloadButton ? (k(), U("button", {
          key: 0,
          type: "button",
          onClick: m[0] || (m[0] = (p) => A.$emit("download"))
        }, [
          ke(Y(o0))
        ])) : ie("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), Gq = /* @__PURE__ */ tt(LB, [["__scopeId", "data-v-df744aa2"]]), NB = /* @__PURE__ */ qe({
  name: "UiSkeleton",
  __name: "UiSkeleton",
  props: {
    type: {
      type: String,
      default: "text"
    }
  },
  setup(t) {
    return (e, i) => (k(), U("span", {
      class: we(["ui-skeleton", [`ui-skeleton_type_${t.type}`]])
    }, null, 2));
  }
}), RB = /* @__PURE__ */ tt(NB, [["__scopeId", "data-v-b2486620"]]), FB = ["id"], zB = {
  key: 1,
  class: "ui-modal__header"
}, UB = { key: 0 }, VB = { key: 1 }, qB = { class: "ui-modal__content" }, HB = { class: "ui-modal__footer" }, WB = /* @__PURE__ */ qe({
  name: "UiModal",
  __name: "UiModal",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "s"
    },
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    hideHeader: {
      type: Boolean,
      default: !1
    },
    hideClose: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    zIndex: {
      type: Number,
      default: 999
    }
  },
  emits: ["update:modelValue", "initRef"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = J({
      get() {
        return i.modelValue;
      },
      set(c) {
        n("update:modelValue", c);
      }
    }), r = Yi(), a = document.body, o = Zh(a), { width: l } = Rn();
    mt(s, (c) => {
      o.value = c;
    });
    const u = J(() => ({
      zIndex: i.zIndex
    })), d = (c) => {
      c.key === "Escape" && s.value && (s.value = !1);
    };
    return It(() => {
      document.addEventListener("keyup", d);
    }), Nn(() => {
      document.removeEventListener("keyup", d);
    }), (c, A) => Y(l) > 768 ? (k(), Ce(br, {
      key: 0,
      to: "body"
    }, [
      ke(Ri, { name: "modal" }, {
        default: De(() => [
          s.value ? (k(), U("div", {
            key: 0,
            id: t.id,
            ref: (m) => {
              c.$emit("initRef", m);
            },
            style: Nt(u.value),
            class: "ui-modal elevation-shadow-low",
            onClick: A[2] || (A[2] = (m) => s.value = !1)
          }, [
            re("div", {
              class: we(["ui-modal__container", [`ui-modal__size_${t.size}`]]),
              onClick: A[1] || (A[1] = $t(() => {
              }, ["stop"]))
            }, [
              t.hideClose ? ie("", !0) : (k(), Ce(B0, {
                key: 0,
                onClick: A[0] || (A[0] = (m) => s.value = !1)
              }, {
                default: De(() => [
                  ke(Y(na))
                ]),
                _: 1
              })),
              t.hideHeader ? ie("", !0) : (k(), U("div", zB, [
                t.title ? (k(), U("h4", UB, _e(t.title), 1)) : ie("", !0),
                t.subTitle ? (k(), U("p", VB, _e(t.subTitle), 1)) : ie("", !0),
                Se(c.$slots, "content-header", {}, void 0, !0)
              ])),
              re("div", qB, [
                Se(c.$slots, "default", {}, void 0, !0)
              ]),
              re("div", HB, [
                Se(c.$slots, "footer", {}, void 0, !0)
              ])
            ], 2)
          ], 12, FB)) : ie("", !0)
        ]),
        _: 3
      })
    ])) : (k(), Ce(op, {
      key: 1,
      id: t.id,
      modelValue: s.value,
      "onUpdate:modelValue": A[3] || (A[3] = (m) => s.value = m),
      "hide-header": t.hideHeader || t.hideClose,
      label: t.title,
      "sub-title": t.subTitle,
      onClose: c.close,
      onInitRef: A[4] || (A[4] = (m) => n("initRef", m))
    }, wi({ _: 2 }, [
      Y(r)["content-header"] ? {
        name: "content-header",
        fn: De(() => [
          Se(c.$slots, "content-header", {}, void 0, !0)
        ]),
        key: "0"
      } : void 0,
      Y(r).default ? {
        name: "default",
        fn: De(() => [
          Se(c.$slots, "default", {}, void 0, !0)
        ]),
        key: "1"
      } : void 0,
      Y(r).footer ? {
        name: "footer",
        fn: De(() => [
          Se(c.$slots, "footer", {}, void 0, !0)
        ]),
        key: "2"
      } : void 0
    ]), 1032, ["id", "modelValue", "hide-header", "label", "sub-title", "onClose"]));
  }
}), Qq = /* @__PURE__ */ tt(WB, [["__scopeId", "data-v-52a4d7ef"]]), YB = {
  key: 0,
  class: "ui-stepper"
}, XB = { key: 0 }, jB = { class: "ui-stepper__horizontally" }, GB = { key: 3 }, QB = { key: 0 }, ZB = {
  key: 1,
  class: "ui-stepper__content"
}, KB = {
  key: 1,
  class: "ui-stepper"
}, JB = { key: 3 }, $B = { class: "step-vertically__info" }, eL = { class: "step-description" }, tL = { key: 0 }, iL = {
  key: 0,
  class: "ui-stepper__content_vertically"
}, nL = /* @__PURE__ */ qe({
  name: "UiStepper",
  __name: "UiStepper",
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "horizontally"
    },
    activeStep: {
      type: Number,
      default: 0
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const i = t, n = e, { width: s } = Rn(), r = Yi(), a = J(() => i.steps[i.activeStep]), o = J(() => i.clickable ? "button" : "div"), l = (u, d) => {
      i.clickable && u.status !== "waiting" && n("select", d);
    };
    return (u, d) => t.type === "horizontally" ? (k(), U("div", YB, [
      Y(s) < 1024 ? (k(), U("div", {
        key: 0,
        class: we(["step-description", [`step-description_${t.type}`]])
      }, [
        re("h5", null, _e(a.value.title), 1),
        a.value.subTitle ? (k(), U("p", XB, _e(a.value.subTitle), 1)) : ie("", !0)
      ], 2)) : ie("", !0),
      re("div", jB, [
        (k(!0), U(Xe, null, ut(t.steps, (c, A) => (k(), U("div", {
          key: A,
          class: we(["step_horizontally", [`step_${c.status}`]])
        }, [
          (k(), Ce(Ft(o.value), {
            class: we(["step-status", [
              `step-status_${t.type}`,
              `${c.status ? `step-status_${c.status}` : ""}`,
              { clickable: t.clickable }
            ]]),
            disabled: t.clickable && c.status === "waiting",
            onClick: (m) => l(c, A)
          }, {
            default: De(() => [
              c.status === "finished" ? (k(), Ce(Y(hA), { key: 0 })) : c.status === "error" ? (k(), Ce(Y(fA), { key: 1 })) : c.icon ? (k(), Ce(Ft(c.icon), { key: 2 })) : (k(), U("p", GB, _e(A + 1), 1))
            ]),
            _: 2
          }, 1032, ["disabled", "class", "onClick"])),
          Y(s) > 1023 ? (k(), U("div", {
            key: 0,
            class: we(["step-description", [`step-description_${t.type}`]])
          }, [
            re("h5", null, _e(c.title), 1),
            c.subTitle ? (k(), U("p", QB, _e(c.subTitle), 1)) : ie("", !0)
          ], 2)) : ie("", !0)
        ], 2))), 128))
      ]),
      Y(r).content ? (k(), U("div", ZB, [
        Se(u.$slots, "content", {}, void 0, !0)
      ])) : ie("", !0)
    ])) : (k(), U("div", KB, [
      (k(!0), U(Xe, null, ut(t.steps, (c, A) => (k(), U("div", {
        key: A,
        class: "ui-stepper__vertically"
      }, [
        (k(), Ce(Ft(o.value), {
          class: we(["step-status", [
            `step-status_${t.type}`,
            `${c.status ? `step-status_${c.status}` : ""}`,
            { clickable: t.clickable }
          ]]),
          disabled: t.clickable && c.status === "waiting",
          onClick: (m) => l(c, A)
        }, {
          default: De(() => [
            c.status === "finished" ? (k(), Ce(Y(hA), { key: 0 })) : c.status === "error" ? (k(), Ce(Y(fA), { key: 1 })) : c.icon ? (k(), Ce(Ft(c.icon), { key: 2 })) : (k(), U("p", JB, _e(A + 1), 1))
          ]),
          _: 2
        }, 1032, ["disabled", "class", "onClick"])),
        re("div", $B, [
          re("div", eL, [
            re("h5", null, _e(c.title), 1),
            c.subTitle ? (k(), U("p", tL, _e(c.subTitle), 1)) : ie("", !0)
          ]),
          t.activeStep === A && Y(r).content ? (k(), U("div", iL, [
            Se(u.$slots, "content", {}, void 0, !0)
          ])) : ie("", !0)
        ])
      ]))), 128))
    ]));
  }
}), Zq = /* @__PURE__ */ tt(nL, [["__scopeId", "data-v-72fbd231"]]), XA = "data:image/png;base64,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", sL = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAoAAAAHgCAYAAAA10dzkAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAADkoSURBVHgB7d1NjCTnfd/xHynKomyJu5QCWy8W+TAxZB+ocBkFsGAaYG0usRjbHN2kBMkWL5YPDri6GLltEbCDmHKwy8gBIl+mVwJC+xAsCRuylcv0AqZfgDi7jHmwjQBbJG3LL5J2l5IjSlG06f889bCqe3qmq6rrrau+H6C2emarp3t6urt+/X/eJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA1NwlAJgml21TcWuxXRcAAMCEnF5sFxbbwWK7M+HtYLGd17TCL4AVVAABjJ1bbPuLLQrfOP3ue+Te/065D7xzcfntGrv0r751uL/+52/o1je+W/yv2WJ7xg4RgEkhAAIYM6t0XVhspy30xT/9w3oy+kFFH32vpmr+x1/T5d/6y8X+60q/8q3w7UQ+CAKYCAIggDGy5t6Liy22Ly783I/o/KceOqz8wbOq4Oy3/0LP/Pr/Dt96YbE9Jd9XEMDIEQABjNG1xXbGmniv/Oo/0ZkP3yesZ0Hw7Kf/KFQDbZDIWRECgdG7WwAwLlb5Owx/B5//ccLfBuFxsj6RC2fkHz8AI0cFEMCYxIttfyXUoASrBD76r34vDBL5zGK7JACjRQUQwFg4+QEfSn7uRwh/Ffnm8o+GLw8HzgjAaBEAAYzFucXm4p/5oM799A8L1UUffc/hJh/+zgvAaNEEDGAsbiw2d+O3Iqp/W7DpYWxQiPxAkPsFYJSoAAIYg2ixOateEf62s1IFjARglAiAAMZg7/Cf6IeE7e1FP/jWRbUvFsvSAZ1jVlQAY/DI4T8ffrewvUc+fCpcdGqXTTuzn122OQivyk9IPReAVlEBBDAGhyNWz+TBBVs4kwfpR9Qu62d4WX4tYguDTy+2g8V2Uz4YWgWS0chACwiAAMbgcLACS7014/S7366OpPJNwA8ttkfl5x+0KuDp7PtX5MPglexrwiDQEAIgAGAIrAnYJp+O5AOhrUv8YvZ/Vgm0imCxMghgCwRAAMDQpIttJh/0rLpbDIOxfEXQpv2xMHhGACojAAIAhsz6Cc7kw2CoDFozsZMPg9eyzS7TRAyURAAEAOyKVD4MRvJh8BnlA0isGhiqgk4ATkQABADsonSxJfJB8Kx8E3EYPGJB0EYTRwKwFgEQALDr5sqbiMO0MpF8CLQwGAvAEuZMAIAV1//8DT33fKqu7F/4x0IjUuVhz/YX5JuD97PL1mQ8EwDdJQDYfelie/DO//i4mnD1j7+u6NN/pK40db+bdNc//R3bpfJVtV0WZ9vj2depCIIAFUAAWGVLyu1f+IgwCjPlA0cS+SBIRRCTRwUQwBikarACiFFVAFdFyoOgSUUQxAQxCAQAMCVz+RBo8wmmyvsIXhHTx2BCCIAAgCmaKZ9YOpUfRcw8gpgMAiAAYMpmyieVNrH89DGxgBEjAAIAkE8qbfMIOvlK4IGoBmKkCIAAAHipfOUvNAtH8s3CFwSMDAEQAIBlMy03CyfyQdAJGAkCIAAA6yXyQTCVD3/XFtt5ASNAAAQA4Hip8mrg6cV2UYwUxgiwEggArLCl4OLkf2mM5r/+43rw/e8UKkvk5xC08BfL9w/8xGK7LmAHEQABjMarX/lWY+EmXfwsHFa8kJsvtrPyVUCbN9CahBPlfQWBnUEABDAGVoV58MZfNRMAH//oe3Tjtx7XGFV8fAiAR6Xylb9EfnSw7e1xshB4S8COIAACGIPU/nn5z99QtAhvTXDv/35NmVsExawKauGGYHNUsthekF9CzgaGWEXQqoOpgB3AIBAAY/DC4T/zvxGaceZH3/3WReE4VnkOoc/JTxzN44WdQAAEMAbzxXZr/sdfl23Y3pkP3xcuRsJJ0sX26GJ7TnkIPCdg4N4mABgH69wW2UCQ+Gd+WNjWXbr8239pF5x8uMHx3lxsvyt70KSfkm8ONlcFDBQBEMBYWHPcz6df+da9Zz58Sj/mfkCoz33gnYfT4SweT+sDaEEmFTaZL7bb8iEwyr5HCMQgEQABjIVVYf5ssX3yy3/wVX3yn79fp9/9dmE7L179W9tZv7bPC2X84WJ7VT4A/lT2PUIgBocACGBM/nSx3f/md773sRev/o32oh8iBG7hzI/eF6qA75MfDfxloQyrRttj9UkRAjFQBEAAY2N9saJb3/iusxAYffS9et973yHUYyHwN//7V2ShWr4Z+GWhjL8WIRADRgAEMEaXF9v9ixD4sc//t9d0+xvf1Y899C6qgTVYeL73HXfLmtXlBzekIgSWRQjEYBEAAYxVGJUZ/eErt3T5t/9Cf/bq3+v+RQi0AQ4o72Mfuf9wf9VPscMI12oIgRikuwQA4+bkV21YmpvN5rk7/W4WQ6piZY7FRKyBW4UNpLE5Aq0vZSIeOwAAOuHkl+yaL7Y7bI1sF4QqIuWP3TkBPaICCGCqXLZhOzbilbWCy4sX23522ZaRmwsAAACjl8hXAW+KDyEAAACTcUk+BN6Q7xcIAACACTiQD4EHAgAAwCRY5c8qgAyoAQBMUiRgmmx6GOsLaCFwTwAATEQsf/J7QcA02fREDAoBAEyGU179iAVMVxgUQn9AAMCoFfs/JQKmrfh6OC8AAEbqovJpMAD4/oBhpZAzAgBgZGLl4c8JQBD6AzI/IABgVJzypq5YAFaF+QETAQAwEjP5k9u+AKxDUzAAYFSKzVtOAI6TiFHBAIARcMqnfIkE4CSMCkar7hKAXXX6mC1wa66Trrl8K9tStWu22M5l+6cEYJNIvgJor8+Hsj3QCAIgMFwW5px8HyDbP5jtnY6GvaaEIBj2ry6269nXYV9HLN/nL11sZ9V+2ATGwgJgtNieEYNC0CACIDAMZwrbI9l+U8B7Ndunyqt44etN3MrebutBbb7NEARfXmzz7Laua/NtHWR7q/zNBKAst9iuyb82rQqYCmgAARDonr2RR9l2UtgL1bdUecgLVbhU7XHKq4xnCl8/ovX3M9yvq/KhcLVSaBM+nxdNv0BdyWK7IP/6OiugAQRAoH0hSO0ttid1tG+ehSULe3P58BRC3xD7+4TfxbZIeTBcNZcPhPa7XMm+R/UCqCcMCLG9BcC5AACD5OSrXmFC1+JmI2Fn2f+PYY6vUNFM5E9MYaTv6u8ci6lfgLoSMS0MAAySk2+mWQ19Fn7m8oHPaRoi5YFwNQza4xOLMAhUYR+0mEYJAAbC3pSPC32X5N+o2xitu0ucfOB7QUergyEMAtgsEVVAAOhVpJNDH45nfSFnWg6DdnlfLHsFnIQqIBrDIBCgPHvzfVq+KTdU9WygxmX56tZc3XHK5wlcnQT6wQ3XfbVwOdXyRNCpuhVn2+OF79nAkefEdDHAOokYEQwAnYh0tNo3lw8ubTbvOvnbSOSrYzYX2A0d7VPX9GYVBvt9r2S3bRW7SN38rsXfzy7vi76CQFGxCugE1EQFEDheJP9JO8q+brPaF6ZVCfMCntQUavfjtpYrdqmWJ4PWmq9d4fLq8nFO5SaDDlPUhImgt1kd5DgWOGP5KXOCmfxKCKkAJPLvTawOAgANirVc8bNP24maq4CFaVPC4JHjpk2xcDWTb3KOVW51kKaEQGq3fUnHT+9i27XsmL2G75+T//2Lt0VFEPCvs/A+0dV7AgCMVqzlJsi5mhuh6pTPC7gapMI0MZc0/OlRysz5FwJhpGa47PaKfxuCIKYufEg9LwBALZGWK35zNRNeIvkqXzG4FANfonFME2PVwljrp3kJ/fgibc/paEgnCGKqIjElDADUEqn54Od0fOibyryAkXy4tSbsNsLgaVERBMxYVhMCgE5YgLio5WASqz77eeuWfUuVV/mmysk/tnMdDYPbrozi5EP16s8EAABYYgEhNFNuO7gjkg8gqxMaJ2KS1nWcjjbhhupdpPqclgeL2M+nKgIAAI4091ro2Cb4rVb75iL0VWEBbabl8LxtJfaMaBYGAAA62txrI1Qj1RNn129repgpsscu1tEJoG3FFad64sLP2zZUAgCAHRMpDwIhrNURa/30MAS/ZkVa7itoj/kF1QuCTsvNwlQDAQAYudWq31z1Tv6xjga/SGib09E+fRdUTyyqgQAAjJ5T3kxrVb86o0IjLTf1zkXw64PT0SAYqzqno9VAqrcAAIxEcYSvBTinamwQwYEIfkPjdDQI7qm6WMvVQCcAALCzrJpjVZ0QEC6pmqbnBUQ7LPRtO8rXaTnk121aBgAAPXJaHugRqZo9NTcvILoRa/lvXifEJaJJGACAnVQMb3NVqwbZsavNvU7YFU5Hm4WdqolEkzAAYMCctpu/boys6lO3ybfYV7BufzIMg9Nys3DVaqDTcgiMBADAQFhgCc1dTtNW7O9XdZSvXbdY9bskmv7GItF21cDimsKsJwwAGIxwgrKT21RDi1M+PYs9DlXWe41EpWfsnJb7BlYNcokYHAIAGKBQvTrQ9DjV769VHOF7RVT9xi5R/QEexX6l+wJykfwHA3sPKXY7YNtuu5Y9pvaBzQnAWnYiuyH/ormo6XDKf297syh7QrfrHah+RQi7qzhlTNUPDE71nm8Yp1jLE8OztbsdiBaaTtwl7Bqn/KT0GVUfALFrwuTM9vteVvn5+ex69qnSLbZ0sX1isV0XpsTJPwfsuXBrsT2j8q8Xu+5BtrfnjT1/UmFKIhXmmvyJxx7TY9n28MMf0alTp4Tt3b59Wy+99Hv6nS99abF/Sa+//nr4r5n8azYVWkEAbEYkP41Il7d3kF0+2/Ftd6kY/p5T+QqeHRcqpJezr28JU5Uo79Nnl58peT2nPASm8q+1VJiCt95DLPj94i/+4iL4/aTQvueff16fffZXQhBMxYf31rxN2JaFlD+Qr0y9utj+VO1LF9vtxfZT8k1dv6nxBZxi+LMT9r8reT070f+H7LJdz97I3xSmbC7/evmY/GvGnltf1ubnhb2mLmfX+TH519qL4sPE2L31HvJLv/zL+tVf/Y964IEHhG585CMf0cefeEJvLCqDr7zyir3/f3Kx/Zm6ObdOChXA7RWbGs1M3ZWtrTnr6ey2HtV4Tkyr4S8pcZ2wnFss/zg8tdheEJBzqlfRC9MHnRGVwLGz8Jfcd999+sIXv0jVr2fPLiqBn332Wbto7+n2uqMS2CACYHNi+TcPl32dyDdbth3KQofZufwLZNfVCX9OeV+vVDQZ4HhOhECs5+QH/+jyF76oJxZVKPSvEAJTjavQ0TuagJtjgcOahyxUW1NTJF+6vq12w8iL2e3YiclOUl/W7qob/uw61kSXyp+YaSrAcUKzrj1f7HVqzbpXF9tfb7ieNRdbV4vQHBxlX9O9YDwOB9dZf784fkoYBqvCZoND7Lxwr3b7HDcoVADb4eTDy7ns61TtVgycdn9ksFNemaka/mxvIdseYz4doqzQhaJK81KxEshzbjzixbb/oQ99SP/zGo0HQ/Paa6/pn52NDkcMLzwkqu+NoALYDjshWP8zGxRiJwqnfJLLl9X8CcN+nnWStUqgVSeswrFLlQmnPMhZs3mZAR/F69jv+ylxIkY1vyv/IdiqevbasSrgyxuuY68rq0BY5dBea++Tr8Jjtx1OEP9Lv/zvDwchYFhsyp03v/2mfn9RCZRvVZsLW6MC2A0Lf1ZpcPIhxSoPZaeiqHo7FjxT7Q6rqFj10qn8PH927EHF6wDHSZRPExPLP6c2ccqfg/Z6/oywq+xD+jWqf8Nm1b8f+Uf/0C7aOfR+YWt3C12wE4Q1FdmJxQJPIt/ZOFaz7HZS7ZZiE26Zef6cCH9oVqL8A9lMedeNk6TKm3/teXtB2FVWzWXQx8BZFdDmZJQ/h0bC1giA3Unlw4r1X7Cw4+RnmS9OITM1Nm1LceTupiZcJ8If2pEoD4H2QepMieuk8s/bcP0ywRHD87j983EC4OA9/PDD4WKZ1yc2IAB2L5Ufyv5UdjmsWfrWkkMTYRUTq5ykKjdAxonwh3Yl8iGwONBjk7ny5l8Ljk7YNfb3ZrLnHWBL8GUeEbZGAOzPTL4aGKoOsfxJJ9b4RcpH+YYgfJJwQnby1dNYQDsSLYdAV+I6FvyeK1zntLBLnP3zoQ8RAIeOkN4sAmD/EvkgaFUtJ18JtIrgnsbJyf+Oxk608xLXWZ3qBWhTouVA50pcx6rZc+WTkmN3ENgxSQTAYUjlq1qPZped/ElkjM3CxelekhLHV+0nCDQhjKh3yqYIKXEde36m8hVuBoUAGDQC4LBYhcuqgaFZNJavBtrJZAyfUsNSeanKhb+q/QSBJtnr0F6T9gFkv8Tx9uEkfEhJxEhFAANGABymmXzgeS77OpGfKy/W7orlf4+w6sKmSt6e8pAYKitAl0KgS+Wfj2WqehYYQ7/eKY/wBzBwBMDhSuWrX+v6BzrtFqf85GkjJtMSx+8Xjmd2VvQl1XJVr8xULzYoJMz5WaZyCACdIwAOXypfPQvNwk67N21MuK9W0ZxtOLY4ktIqKbu4rjHGxT6AVJ3qJXRdiFRugnMA6BQBcHfM5KuBoYIWyzcLD72zud2/SOX7/YUT7PWSxwNdmKnaVC9WMXwqu2yvASauBTAoBMDds7qsXKzhVgKd8hBXpt+fVUqsiS1VvsICMBTFqV4uljjejg2hkaZgAINCANxNqfJl5cr0qevLQba3ptx0w7FO+Um1zOTQQB/suWkfZGKVa9q1Y8JI4kQAMBAEwN2Wys9VNkRVp3wphsW5gGFKlVenw3N8k6cqHg8ArSMAog1OeXWkzModVcMi0Ke5qjXtFqeGoSkYwCAQANGGRP7kaCfJdMOxkZbnBwR2QaJqo3wviVHBAAbkHgHNipUP5Ng0hUuxglKmnyAwFGGUr3VdsAq2dcVIKxw/E8sa7rTXX39dzz//X7VrnnjiX+jhhx8WQABE08K0NGUCXWj6vSrm+8PumctXuZ+W/yCzqYJtx1tQ3JN/7n9G2FmvvfaaPvvss9o1DzzwAAEQhwiAaFIIdNbnabbhWDsuNIXFAnZTstieVN60u+mDzGcKx74oBjztLAtR/+lzn9Ou+YmfeEyAIQCiKU55oCszh1+VKWKAoaratJvKVw0vZNtc2EmnTp3Spz71LwXsKgaBoCmJfJ++mTYHuliM+sV4zJWPCi4zQXRxQEgkAOgBFcBmOfnl2VL5KoBtr2b7VHkwKl4eAyc/8MM8U+LY0E+Q1T4wFon8ayCWX6VnfsKx9n5gr5P9bHtIANAxAmCznHwVoOy6nyEYHhcWbxW+HrIk25dpzrVjnXyl8LqAcQihziqAZZp2Z/KBMZIPjTMBQIfuEtrglM/4Hy6fLuxte1CbF5Qvsg7jexoet9huyAe/szo5AIZjzUOi7x/Gx57fTr5f4GzDsZF838FUVAH7dMf++buvfk0Ytpdeekl7T/6sXZwpX2EHNVEBbEeq8uHGqVxYHKok21uzV1ryWAZ+YKxW5wY8aUDIPNsi+ddGIgDoCAGwf6l2Nww55ZM+JxWOnQkYp7nyUGej4pMNxz+THfu0CIAAOsQoYGwjyfabBn4YVvzAVITXg4W6Td085tlmx8UCgI4QAFGXU17Rm284Nso2O3YmYNzmykNdmXV/Q2C8IADoCAEQdSXZftMaqKa4PBwwBXWqgE7MCwigIwRA1OGUz/v3XIljI1H9w7TMVa0KeDnbUwUE0AkCIOp4OtvPVG3kLzAl4Tl/rsSxM/kRw5GoAgLoAKOAUUeYj7DMqh9l+wkCYzNXPiI40ubXQFgj+Jx4vQzeK6+8os9//r8IuYcfflif/vTPC7uBAIiqYvlgd1Xlq39zMfIX02ShLlK51UFsjWCrrtsHrM/o5DkE0bPbt2/rN55/Xsg99thjBMAdQgBEVaE5a7bhOOv79GR2meZfTFWYDDrS5iqgHWd9AS0ElplDED2yatcLL74o5E6dOiXsDgIgqnAqP6DDqhinVa6fIDBmoWnXXhPzDcdaYLQAaB+eEmGwLOw89thPCthVDAJBFUm2n5c4NoxmvCxg2i5le6uel50S5owYDAKgRQRAVPF4tt/UpBvJVwtT0ZkdsKbducqv9nE12+8JbTsM5Naci+F77bXXwsXbwtYIgCgrUvnBH3G2p+8f4IXXwpMljq1SMcR2rNJK37Ud8corfxIupsLWCIAoK872sxLHhkrhXADMXOXn+StWDDcdi+0cVlk//sQTwvD9/ksvhYtzYWsEQJQVKhfzDcfFKl8pBKYkrJoTlTg29J19WmjT4fvaxz9OABy6119//XDuRfnzynVhawRAlBFG9JYJdaHf0kwAiubZvszKIGH6GGuipBm4HfFic9b/74EHHhCG7dlnfyVcZGBhQwiAKKNsqCvO/feCABTNF9uryqdTOomFP6ty2GuKwSDtOJyp4OeYuHjwrPpXmHR7JjSCAIgyyjb/RtneZkdlFQPgqFm2j0ocGyodjwtNs/B3WP371Kc+JQzb3pM/Gy7aYKpUaAQBEJtEqt78S/UPWG+e7cs2AxsqgM2y8Jfcd999uvyFLwrD9m9/4RfC9C+pmBy9UQRAbBJn+zKhrmylEJtZ6LYT1Y1sO1C5OeR27TanZq68GdhtOJbRwM07ryxEfO7X/jN9/wbOwt9v/MZh02+62M4KjWIpOGxSdkqXSOUrhTiZkw9fbuV70WJ7UO3Mr+h6uM2pCsu9WWXv0oZjrTtFpHLLyOFkh5U/u/C5X/s1PcHUL4Nlff7O/Zt/rT/5k8N5/1L58JcKjaICiJM45St6bBp2T/Nvcw6D2Dveca/e9/4P6IEHH9J73vsPdNfdhy/XRL6K0aTT4Tbf+c7v1wc++KHD2zx9/3uKt0kzZHPCa6TMpNDzbE8/wO281exr4e+Tn6Tf3xC98cYb+uyzz+ps9DjhrwN3CThevNj25TuuP7Xh2GvyU1Y8KuZo2ka82Pbfds89+uAiiBW9+eab+tu/+YpdtKbBh9TcQJvDk6MFzh963/uX/uOb3/ymvv61v2vjNqfMAveN7HKZx/Rmdp37xeNfh72HxXbhC1/8oh5++CPCcFj/Plvh43e+9CW9lE/0bGzezEQ854FeWKXijjZXf05nx90UtmXB4M773v/BO4sq3JFtEdLscbatySrg4W0uKn+bbjMWmmIVV3tMoxLHzsTjX0eobN9h25nNziHWLcIJraMPIE7ySLbfVNGLsv1VYRtWQXVv/77v0/cttnVOnb4/VAGt+XBT/7EyIrvNe++9V/fcs/7t4F3vepe+/e037eLjYg6upthrJcq2+YZj7fV3Ttm6tSjFwt++fIX1VWGorLqXZpsVHK6Lil9nCIA4zmEYkX9BphuOjbL9XNhGZP9YGDtOIRg2FQYOf441/x7nnd//A9LXvioxErVJc/mm98dLHGsnxovyob/p/p9jZSHiEwJwLAaB4DghYJTpzxcqhXNhG1a10D1vO/5z2d133x0qdU0tD+YOb/Oek2+zeCwaESodZYJ8mh3rxLJwABpCAMRxomxfplnXjg1LV2FLhcDVhVKB4q67eatoWHGptzIhMLwOIwFAA3hXx3Gq9v97WdjWYd+X7373uyce9P++9z01KLV/vrfhZ97x/0/fnGaF10xU4th5hWMBYCMCII5jVYkyVb0qTcU42cYA+J3vfDuEsaYe79T/3O/opNssHovGhL/hIxWOdQKABhAAsU6U7ctU9UIAnAvbss7++ta3/s+xFbn/mwe1pgLgPNzmcWz+wQyjvJs1z/ZlmoDD37vMoBEA2IgAiHWqVPUezPapsK3DtV8t/H3jG7fXHnD79lutsJfVjDTc5t9/85tH/tO+/81vvBG+nAlNSlV+IIgdZ9OZnBYDQQA0gACIdVy2T0scSxNwsw7X3P3GG28caQq+detW+J491nM15/A2b9782pHbLHxvJv7GbUizvStxbHj8IwHHa2qKKAATdKByqxScyY67JjQpWWx37r777js/8K533bn//vfcuffee4sz5Ts179IJt3lD9D1ry0zlV/m4pOZXgcG4hPfkAwFADRYy7E1kU1NTlB33gtC0REeXSbIg1uan+0vH3KYT2mJhrmyoi7Nj9wWsF55PPEewESuBYFXoY3RLm6f9oPm3PYl8dWhP/u+RygftTX+TbdjJ41LhNq+LcN+28PesMhL4fgHrPZntm+ojDGBCIvlPkPMSx9IkBWynSjeK08qrssAqp7ybCLARg0CwKjT7ljnJuGxPBRCoJ832ZUb2hqq8EyOBcVSU7anaoxQCIFa5bP9qiWNPZfs2myWBMSuGujLSbE8AxKq9bP+igBIIgFjlsn1a4tiHKhwLYL0w6aMrcWz4YMZUHyhyyvv/zQWUQADEKpft0xLH2iTQZQaLADhe6G5RpqqXVjgW0xFl+5l4P0ZJBECsKtuse7rkcQBOFqp6rsSxtyoci+k4l+1p/kVpBECsKtusGwJgmb6CADajAog6nHwFMBUDQFABARCrylYAnQA0Ic32ZUcCm1MCvDjbzwVUQADEqjAJdFnMSQZsJ7zeqgTAhwR4ofn3OQEVEABRVKVfH01QQDOqfOBKBeQi+daY62I+VlREAERRlX59BECgWQ+2dCzGK872VP9QGQEQRXVCHYNAgO4w6h6Bk2/+TcXgD9RAAEQRVT2ge1VCHQEQQZLt5+J5gRoIgFiHNxOgO3Veb06Yusez/TMCaiAAYp2bAgAMVSz/IWAmBgahJgIgAAC75UK2vyygJgIgAPSLvreoIpav/l0Vkz9jCwRAbIuTF7AdXkOoIlT/ZgK2QADEtliSCmjGbQEni+Wrf6kIgNgSARDr3F/iGEYKL3NiZGYZVu1ywjq8prBJqP4x8hdbIwBinSprkpYJi1OwL78ushNOckn+cYqEwKk6wuL0xKL6hwYRAFGU1jiW/kvLeDxOxuNzvLTCsQTA6aH6h0YRALFOlX59rEnqhSXxnHCS8NwiwORcti/zmDhhis4rH/k7E9AAAiDWKVOlSSscOwXh5M3jcbKHsn0qBOFDVJVQzBrc0+EW29PZ5VhAQwiAKEqzfdkQc0sEniDN9meEk1jYuSUqgOtQAcQ6iVj1A0AHbBm4OyWPTbNjnRDJPxYHwnEi+cdoLhSl8o9LmQ9TUXbsC8IUOPm/N++zaBwVQKwKc5G5Esdez/ZUAfPHggrg8cJjc10oqlIVddk+FabgSra3gR+pgAYRALHqRoVjwwmL0OMfi7l8GI6EdaJsPxcCl+3TkseHD1s0oY9fLP/emso3AwONIgBiVehcXibUhUqOE8zVbB8J6zye7edC4LJ92VVAwvGpMGZOTPuClhEAsarKaNZwLFPBePNsf05YFcs/pywkU73KuWxftlk8HJ8KY5YoH/gxE9ACAiBWpdnelTiWfm/L5vKPiRNVwFV72X4mFIXXTlryeOZRHL9Y/kNkKqp/ADoUy4842y9x7Ons2JtCkIjRwKuc/GNSpX/pVNjzxB6bqOTxYZQ+A6/Gycm/TuxvHAsAOmQVCXvzuVby+FRMUVBkJ+ZwknaCman8h4qpsddZlUDHB65xm4nXCoCehKpe2WrNC9nxe0KQiDfxwIl5zI5TtYIePpzNhTGKlb/3OgFAD1KVr0qcz449LwTFKmCkaZvJPw6XhFWRqgW6PTEJ9Fg50fSLjjEIBOuE6p8rcWya7SMhsA76z2WXL2q6YuWd2QmAR1WdGJuJtMfLWgucGPULoGd2si77SbRqk/GUhP5dUwyBTlQ0NqnafYLuFuN0Qfl7KIN7APQqVrVmu1T08Von9NmaYlOwLWFFP8iThYDsSh4fPlAw7dJ4RKKPLIABCcHloOTxM1HpOU7oIzmljt3FioYT1nGqXjlnBPC4OOUfAhIBwABUHZ0YQg79vNabaTpNPOG5QKXqZFUHdERiBPDYhIouVXIAgxLenFyJY53oB3gSC33h8bym8YbAc8rDH6PCTzZTtao5H7LGxfoF0+8PwCDNVO0ExQoFJ3PKm3vGGAKL4S8RNgnPhbJVUgaAjAddJAAMWqxqFYeZ6Ae4iVN+4h/Tm3+x2TcRNnGqXjGvOmAEwxSa/qc4MAzAjnCqdpKKRX+WMpzy5mB7bHe9n1xoyqLZt7xY1V4rTnSxGAOnvKUkEQAMWJVm3aoDR6bMHqsw16JtF7R7nPIga3/zSCjrQNWac1kBZPc5MeIXwA6ZqVqzbjixRUIZifIQuEtNwlbpCx8OLAQ6oazwQalKf9mZ6F6xy5zy8DcTAOyAqiMPGalYnVN+cgjVQKdhipSH/PB3ZtBPNXWqefT/212rMwAAwE5wqtb3KBxPM3B1iZargUMKgpGWg981UeWta6Zq1Twn+v/tqmL4Y7oXADsnVbXqA83A9TnlASGcNPbVXxCMtBz8LNgz0GM7oenclTw+FoOrdtFq+HMCgB0TBiuUPfEnohl4W07LQdA2C2Kx2j+RRPJ/u5taDn6JqGBsK1b15t+qA0bQP3udhLWwCX8AdlakPICUwWjg5jj5IFjsIxiaYC2k7Wn7k4tNQ2Ph3ipMN1duZ57dBsGvGWEy57jk8XUGjKBfVP6wM+4ScDJ7Qwv9V+5fbLdKXMfCYrTYzoq1S5uyl22P6+hJxf4m17P9y9n30pVjTmfbg9n+jNafnK7K/81ma34G6nPyryP7G91f8jr297ZKkv1NImHo7HVl73322krl3/9SAcAOm6neuqVlq4aoJlTtrKJkwe9Oze1mdn2rJsaiytSmWNX78s1U7XWH/lD5w86hAogyYvkT11z+U+0mdaqGqM8eZ5dt4XL4vm1p9vWtbEsLG7oRQkGVqrgFdPv7PST+VkPm5D/s2j4VlT8AI2InoZvKT0hlhMEjiYBpi1R9KpcwX+BcGDKnvI+uVQCpogMYndCBvexo4EgMBgHMTNWbcmei+XfoIuUDp2Yi/AEYqUjV+/UxhQWmzqn6RMDhOlXmC0S3Qj9nprwCMAnh027ZE1kkBoNg2maqPvgjrnEddOei8vCXCAAmoE6/vtA/JhIwLU71KnlUzocpTPMSurbw9wEwGZGq9+tLRBUQ03RB1St5TtUHjKB9NvVS+DDLNC8AJil8Ao5KHh9GEFMFxJQ45YHBVbjeTDT/Do319wvvYXMx2APARNWZ5DkRVUBMS53qX5g/k8Efw1Bc05f+fgAmr1jRczWuEwkYN6d6QS4W1b+hiLTc5BsJAPBWRS+pcR2qgBi7OtU/w4CpYSiO8p2LaiwAvMUqemEwSNn+MFQBMQVO9Ub+xmLwR99soEdYz9feq8pOeg8AkxJWBkkqXKdO/0Fgl8xUr/oXBlfFQtfsw2mo2oYl3ZwAAGtFql4FNOETNp+uMTZO9ap/kaj+9SVS3vTOQA8AKClULZIK14lULzgCQ1fn9VC8Xix0xd57ZqKvHwDUEqlemAsnvIsCxiFWvSpeJKp/XbPm3tAfmb5+AFBTnaqHU/4GfEbAbnPKmxFjVVP3eqgu0nJzry1tSSsEANQUqV4VMBEDQjAOYdqQfVUTi+pfFyLlH1RDc28kAMDW6lQBi6se0ASDXeWUfwByFa9H9a9dkZaDnz3eewIANCZSvSpgpHonT2Ao6n6IqVs1xGaRloOfvb8kAgC0IqyZmaiaS6IpGLvpguo14TrVmy4GJ4u0PvjRzw8AWuRUfY1gQ1MwdlGk+tXr8HxPhG3Z+4e9bxD8AKBHiepV8yLlb96MCsbQOdX/0FK3aohlYfWO8KEzPKbnRfADgM5ts95vWCbuhngDx7DNVK//3hnR9LsNe1+ItFztY1QvAAxErPpBjgmiMXTFCp6rcD0nmn7riuT7CherfTez79FiAAADUmdaGOOUv8nTHxBDU6zgRapmll3vilBGJB+2ixM3h2ofzbwAMFBO9Vf6iER/QAyPU/0K3mrV0DYLgrFoCg5C8+5qpc+2a2JQBwDsjET5m3fd61ZtZgPaYs/jOhW8SEc/0MQ6GnAuaXr92OzxCCN4V0NfKv8+EAkAsHPCSbNOc26YV9B+Bp/80acwaXPVfq1O66uG9jNsRYqZjjZxhlH0IRCO5bkfKnz2XmCv7dXAV2zedQIA7LRin6mqzbnF+QH3BfRjtfm2rOLz99KGYyP54DPX0VAUPgRZaEqyY4feNcJ+91Dds9/d7v+6wJdqfEEXAJBJVL+S55SfRC8I6NY51R/0UaxgVxXJh6cXtL5CGEbBHigPhnF2PaduOPmQF2f3dT+7Lyfd37l84LPqJ4EP6NldAtpnJ0E7Wdib/2dUjV3PTnSns+tuqqYATdjmeWcfVhL5CtfZbL8Nl92fsNnXj2y4zq3sdm9lX9vl24WvwzG31txWYL/7qcL3T2eb0+bbfnmxXV/ZAAAT41R/gmgTK68knBPQLqftR/zWWSKuKguDVk0LTa1z+aC1rrm1yc1+fprd3kx5BdLuD5U9YEdQAURX7CRlnemtOvCoqldFwvVNvNguC2iek6/82f4ZVQuA9uFkll22yt9c/XLKq3ZhC9/fJF25fGtlAwCgNKtS1O0XZRLlFYihd4TH7nHKK38zVVMc8FRn1DsAAKNVHBlZd7m3RIRANM+pfvhzyptdEwEAgCOctl/uLREhEM1xysNf1eq0E2v8AgBQSqztA1wiBoZge055gJur/kTPMwEAgI0S1Ztgd93PoN8V6nCqH+CK3Rnq9mkFAGCSZtp+ubdEeQi8IKAcqzyHrggzVReWObQQyNQnAABUYCfOcCI9UH3nRQhEedZlIDxfEtUTRrRvU8EGAGCynLYfGWwi5RUdW5KKqgzWsQ8I24a/4EDbV7ABAJgsp2bW/HWFn0NlBkUW0PaVh79Y2yv2A9wXAACorNgna9sQWOyfFQlT57T8nGhy6iCnZj68AAAwWZGa68t3SfQLxHLXAAuBTs0rfnhhNDoAADXEai64JYWfZf0CnTAlxf5+9oGgzX56kZiXEgCArcRqLgRadabYLzASxs4pH6BhlbmuqnLnxQo1AABsJVZzIdApn3OQJuFxs+pbaI5tur9fGYkYhAQAwFZiNRvaivMFcoIeF2vetWb+rpp8TzITk0QDALCVPTUzOjhwypuEqQaOQ/E5cjP7um9h1DFzBAIAUFNxlOW+mpFouRo4hNCAapzyvn5DmwCcOQIBAGiAU35CbWo6D6flauC+aBbeBRaurHJb7OsXqT77WdusQnMcJ+YIBABga07trPQRF36uhQpO1sNlldpiaN+mr9/q6iBtjBZmjkAAABpgJ+3Q7Ndkfy+n5ZHCFjJiYSgiLTf3zrXdCF+n5dAffm6k5sWFn09XAwAAtpConYEcTj5cEASHIdJy8Nu2udec09HVQYpz+Dk1jzkCAQBoSHFal6b778VabmokCHYr0nLws+CUaDtWPb6o5ebjorB8YFsjdxMxBREAAI1YXenDqVmxCIJdirQ++G0byIrPk+O6DththOlb9tWO4sAVpocBAGALTsuh4YKaF2t9EHTCtiwIxWon+JkLWu476E441v6vrZG7xfth24EAAMDWEi3PCefUvFjLfQRDtSgSqlqdziUE6/NqJvhZ1e+aqo/yPaPmB20Uf2Yk5ggEAKBRq03CsdphtzPTchCkKriZBTsLYsVqX6jMRWpGCJbhZ1sIrDrwoslBIU75czJZ8702KtYAAEyO03I421d7oczpaPNwaN6z79PPyz8GkfzfoVjtC828TY6KjbT8t0hUXxgUsk1/vZNWBGGOQAAAWhCrm2pgEMkHz2LIKYZBp+kI/fpWQ1+x2tdkOHbyzf5l+/qVFSqVdfvrhSbo40JkrOWmYQAA0ACn5WrggboJYvFie0HLwSc0R1plKdL4RPLNmavNuyGQNdW3r2i1H+FNNVtNc6rfVLuvcqPTEzXX3AwAAApiLTcN2sm8q+ZZG0gw09Fm4hBIQyDcpebi0Kwb+vOtVvnsawvAsdr7vWI1tyzcSYpNtedKHF+cTmZT+AsuVTweAABUkOjooI0uWZiw0DTX0TAYKoRXsvu5p2GsGuHk74vdb6tqrQuyocrXRXUz0tFl4SK1K1a5lTyc6s9LOdP2fQ4BAMAxnI6u+9vUdB9VRfLB6gUdH6xCMAzVwkQ+kNh1LYw41eeyLcp+5vnsNq5k9+fmMffHvj/P7otdt4vAEmk5+F1Tt03piU4OaPbYrS4xV0Wxcli3zyEAANgg1nLospNupH45+fuQyIfC6zo+hB0XzG6U2O5U2FL5wGz3aU/dN1FGOroecKx+hPsRApqFtj0t379Lqs8p//tcFAAAaE2s5VC0r+EN0nDy98nCRiIfMiwgzuVDYqpqoS4EuzT7GfazZlquLjr1K9Zwgl9QnNZltUI6VzPPG1f4uRcEAABaFWt4FcG63DHb0B23Okis4XBqJ/gVFVcOOScAANC6WOvX/UV7IvmqZtvBqilWiQ33s62BOnHhNiIBAIBOxDoaBJ8W03Q05bhl4aw5OtLwJao32rfObTBHIAAAHYt1dNqWffU3cniXhfkDLfStWxZu16Y/mSkf9dvWfWeOQAAAeuR0dKk3OylbGBzCfH1DddJawLtS7TtOcVBIm6N2wzJ3bQZNAABwgrDO7VzLVUELAmNd5q2qTWsBt7EsXF+c8t+xyWXoiopzBF4RAADolZNvuiz2FSxWBq2ZeAoVm1Dlu6Bu1wIeikjtD9hwYo5AAAAGJyzzZvPyrQYgq95YdXAsgTBMgGy/02p/vtC8O1O7awEPjf3t2x6w4cQcgQAADJaTDz/Wx23dSh5hzV8LDZGGHZKcNq8FvLo03FQVB2y09TeNxByBALZ0lwB0waqDUbY9ovUVolvy1cOXla/SEb53S+1y8oElrC38YOHyuiBj9+eq8pVIuriPu8AeK6uI2mM3W2xPqR2xfBi3x/ys/OMPAKURAIF+OPmQEILhg9rcbJhmmwr7V9ccs3o7gYWTU4Xvu+x7mypVdhvXV7ZUOI6TD4G2TxbbM2pHIt8MbCHwUfE3AVABARAYjlCBK1biwvag2mMB4rbyKl7Yz7M9lb3q7O93Lbv8CfmuAG2wJmebnDyVrwSmAoASCIDA7gjVOpd97Va+f5J05XIIdqnQlvPyo3XbrtCFNastuJ8VgR0AAKBXXQwKKU5GvS8AAAD0LsyLeKD2OOUhkOlhAAAAeubUTThzYo5AAACAwbBBISGctTl3XyTmCAQAABiMWPmk2WfUnvMd3Q4AAABKSJQPCnFqT9LR7QAAAKCELgaFmJnaH4EMAACAEorTtlxUu0LYvCZCIAAAQK+c8kEh59Ue5ggEAAAYkD3lI3bbHKzhxByBAAAAg5Gom8EaxWlo2qw4AgAAoISZuumnV6w47gkAAAC9sdBn4a+LQSHMEQgAADAQTt010SZijkAAAIBBiJQ30UZq10zMEQgAADAIxSZap/YUm52ZIxAAAKBnl9RNdY45AgEAAAaiWJ1rO5g5EQIBAAAGwam7yZudmCgaAABgEGyalq7m7StOFE0IBAAA6FFXg0JMpDxwsloIAABAj7oaFGJi5SHwnAAAANCbA/lQdqD2JWK1EAAAgN4Vp2zpoo9eou6angEAAHCM4kCNLppni03PTgAAAOhFrG6bZ2ciBAIAAPQuUbehjCXjAAAABuCKuhsUsrpuMAAAAHpQHBRyUe1zYsk4AACA3jnlg0K6mLjZqdvQCQAAgDUi5RM3dzEoxIkl4wAAAHqXqNtBIawbDAAAMAAzdTtSNxZLxgEAAPSqOFK3q0EasfIQGAkAAACdc+p2UIhJxLrBAAAAvYrUfVUuEauFAAAA9Mqqf6Eq59QN1g0GAADoWTGQdbV820yEQAAAgF51PShkdck41g0GAADomFO+ckdX8/UVl6g7EAAAADpXnLR5T91wYt1gAACAXvUxKMSp++ojAAAACvoYFMKScQAAAD2zPnld9807o3xewq4mpwYAAECmOEDjoroTi3WDAQAAeuOUN8t2GcZCP0TbWDIOAACgY7H6Wb836el2AQAAoP7W7016ul0AAAAsXFG+akeXZiIEAgAA9KKvQSEmjEjucloaAAAAaHlQSJfTtLBuMAAAQI8i5SN0I3WnWIFkyTgAAICOJeqnX55Tf83QAAAAkzdTP02yTqwbDAAA0Itiv7yum2RZNxgAAKAnTnk1ruu1eyOxbjAAAEAvIvUzKMTEYt1gAACAXoS1e61Z1qlbiVgyDgAAoBeX1N9kzYn6C6AAAACTFgaFXFH3igHUCQAAAJ1w6neKlpkIgQAAAJ0rTtHSx8AMlowDAADoQZ+DQlbXDQYAAEBH+hwU4sS6wQAAAL04kA9hB+qeE+sGAwAAdM4qf32GMCeWjAMAAOicUx7C+liyjXWDAQAAehCr39U6YrFkHAAAQOcS9TtHXxiZ3MeaxQAAAJNlK4T0OT1LItYNBgAA6FTfg0JMIlYLAQAA6JRTv4NCDOsGAwAAdCxS//3xZupvomoAAIBJStRvFW51yThCIAAAQAdm6jeAFfsk9rFaCQAAwOQUq3B9rdnrxLrBAAAAnXLKA1hfK3W4AdwHAACASYnU/6AQlowDAADoWFipw0KYUz/OKA+ifU1RAwAAMCnF+fn6GpUbi3WDAQAAOhUGhVxRf4rrBrNkHAAAQMuchjEgIxHrBgMAAHSmOCCjz2bYRCwZBwAA0JlY/Q8KMTMRAgEAADozhEEh5mAg9wMAAGASQvjqc6k21g0GAADoUHG93ovqjxNLxgEAAHTGKR8U0ucEzU7DCKMAAACTEGsY07I4sWQcAABAZxINY0Qu6wYDAAB0yFYICYMx+hSJJeMAAAA6MZRBISYWIRAAAKATTsMYFGISsWQcAABAJyLl1bdI/Uo0jFVLAAAARs+qf0NZpu3SgO4LAADAqM00nBU6ZiIEAgAAtK64TNsQVuhgyTgAAIAOOA1nZHAxkB4IAAAArXEazuTMe8oDad+jlAEAAEZtSCt0RMpHBtMUDAAA0KJYw5mcOaxakggAAACtijWMOQIj5VVAAAAAtCzRMFboCANCWCUEAACgA4n6X6EjTBDNYBAAAICO9L1CR5zd/iUBAACgMzP1FwL3NJxJqgEAACajODlz1yt0RCIAYgTuFgAAu+XWYju72FL5wRhX1B2X7W8L2GEEQADALiqGwEjdVeTC6N9UAAAA6IVTvkxbF6uFHKj/+QgBAAAmr6sl45zywScAAADomYXAsFpIW3P0zcQAEAAAgEGJ1d66wa7ws50AAAAwGFb9C0GtyeXaQj/DRAAAABicRM2uG7wv+v4BAAAMXqI8BMaqxyaYDqN++1p6DgAAABUkypuDrYrnyl/1MDSGkcWEPwAAgB0SK++/F4Kgree7bvm4SH4amZuF46+o26XmAAAA0ACnfAqX4mZB74aWA2LY5mKyZ4zYXQIAYBqcfKjbyy4/Uvg/W1ru5cV2fbG9IB8AAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAevX/AYj6BcvrplC+AAAAAElFTkSuQmCC", rL = "data:image/png;base64,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", aL = "data:image/png;base64,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", oL = "data:image/png;base64,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", jA = "data:image/png;base64,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", lL = "data:image/png;base64,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", uL = "data:image/png;base64,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", dL = "data:image/png;base64,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", cL = "data:image/png;base64,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", fL = { class: "ui-not-found-page" }, hL = { class: "ui-not-found-page__left-section left-section" }, pL = {
  key: 0,
  class: "illustration"
}, mL = { class: "left-section__info" }, AL = { class: "left-section__buttons" }, gL = {
  key: 0,
  class: "illustration"
}, Kq = /* @__PURE__ */ qe({
  name: "UiNotFoundPage",
  __name: "UiNotFoundPage",
  props: {
    errorCode: {
      type: Number,
      default: 404
    },
    mainPageLink: {
      type: String,
      default: "/"
    },
    supportLink: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    Md((d) => ({
      "46c3eefb": a.value,
      "550e5d11": r.value
    }));
    const e = t, { width: i } = Rn(), n = pe(1);
    function s(d, c) {
      return d = Math.ceil(d), c = Math.floor(c), Math.floor(Math.random() * (c - d + 1)) + d;
    }
    const r = J(() => {
      switch (n.value) {
        case 1:
          return `url(${jA}) center/cover no-repeat`;
        case 2:
          return `url(${lL}) center/cover no-repeat`;
        case 3:
          return `url(${uL}) center/cover no-repeat`;
        case 4:
          return `url(${dL}) center/cover no-repeat`;
        case 5:
          return `url(${cL}) center/cover no-repeat`;
        default:
          return `url(${jA}) center/cover no-repeat`;
      }
    }), a = J(() => {
      switch (n.value) {
        case 1:
          return `url(${XA}) center/cover no-repeat`;
        case 2:
          return `url(${sL}) center/cover no-repeat`;
        case 3:
          return `url(${rL}) center/cover no-repeat`;
        case 4:
          return `url(${aL}) center/cover no-repeat`;
        case 5:
          return `url(${oL}) center/cover no-repeat`;
        default:
          return `url(${XA}) center/cover no-repeat`;
      }
    }), o = J(() => e.errorCode === 403 ? {
      title: "Доступ к странице запрещен",
      message: "Попробуйте обновить страницу или свяжитесь с нами, если вы считаете, что это ошибка"
    } : e.errorCode === 404 ? {
      title: "Страница не найдена",
      message: "Попробуйте обновить страницу или вернуться на главную"
    } : e.errorCode >= 500 ? {
      title: "Возникла проблема на сервере",
      message: "Мы делаем все возможное, чтобы вернуться в рабочий режим"
    } : {
      title: "Что-то пошло не так",
      message: "Попробуйте обновить страницу или вернуться на главную"
    }), l = J(() => i.value <= 1023), u = J(() => i.value <= 767 ? "m" : "l");
    return It(() => {
      n.value = s(1, 5);
    }), (d, c) => (k(), U("div", fL, [
      re("div", hL, [
        ke(f_, {
          label: t.errorCode.toString(),
          type: "soft",
          color: "neutral",
          size: "l"
        }, null, 8, ["label"]),
        l.value ? (k(), U("div", pL)) : ie("", !0),
        re("div", mL, [
          re("h2", null, _e(o.value.title), 1),
          re("p", null, _e(o.value.message), 1)
        ]),
        re("div", AL, [
          ke($r, {
            "full-width": l.value,
            label: "На главную",
            size: u.value,
            color: "accent",
            href: t.mainPageLink
          }, null, 8, ["full-width", "size", "href"]),
          t.supportLink ? (k(), Ce($r, {
            key: 0,
            "full-width": l.value,
            label: "Поддержка",
            size: u.value,
            color: "secondary",
            href: t.supportLink
          }, null, 8, ["full-width", "size", "href"])) : ie("", !0)
        ])
      ]),
      l.value ? ie("", !0) : (k(), U("div", gL))
    ]));
  }
}), vL = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M16.5%2011.2969V12.7031H7.5V11.2969H16.5Z'%20fill='%23717378'/%3e%3c/svg%3e", yL = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='3'%20fill='%23717378'/%3e%3c/svg%3e", bL = { class: "item__title title" }, wL = /* @__PURE__ */ qe({
  __name: "UiList",
  props: {
    type: {
      type: String,
      default: "dot"
    },
    listOptions: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "l"
    }
  },
  setup(t) {
    const e = t, i = (r) => {
      switch (e.type) {
        case "icon":
          return r.icon;
        default:
          return "img";
      }
    }, n = J(() => e.type === "number" ? "ol" : "ul"), s = J(() => ({
      ...e.type === "dot" && {
        src: yL,
        alt: "icon"
      },
      ...e.type === "line" && {
        src: vL,
        alt: "icon"
      }
    }));
    return (r, a) => (k(), Ce(Ft(n.value), {
      class: we(["ui-list", [`ui-list__type_${t.type}`, `ui-list__size_${t.size}`]])
    }, {
      default: De(() => [
        (k(!0), U(Xe, null, ut(t.listOptions, (o) => (k(), U("li", {
          key: o.id,
          class: "ui-list__item item"
        }, [
          e.type !== "number" ? (k(), Ce(Ft(i(o)), Ut({
            key: 0,
            class: "item__icon"
          }, { ref_for: !0 }, s.value), null, 16)) : ie("", !0),
          re("span", bL, _e(o.label), 1)
        ]))), 128))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Jq = /* @__PURE__ */ tt(wL, [["__scopeId", "data-v-9d1c7f6d"]]), TL = ["id"], xL = { class: "ui-drawer__header-title" }, SL = { class: "ui-drawer-body body" }, CL = {
  key: 0,
  class: "body__title"
}, EL = { class: "ui-drawer__footer" }, DL = /* @__PURE__ */ qe({
  __name: "UiDrawer",
  props: {
    modelValue: {
      type: Boolean,
      required: !1
    },
    overlay: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "m"
    },
    closeButton: {
      type: Boolean,
      default: !0
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    zIndex: {
      type: Number,
      default: 999
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = Yi(), r = Zh(document.body), a = () => n("update:modelValue", !1), o = J(() => ({
      zIndex: i.zIndex
    })), l = J(
      () => i.overlay ? "var(--color-semantic-background-normal-overlay)" : "transparent"
    );
    return mt(
      () => i.modelValue,
      (u) => {
        r.value = u;
      }
    ), (u, d) => (k(), Ce(br, { to: "body" }, [
      t.modelValue ? (k(), U("div", {
        key: 0,
        id: t.id,
        class: "ui-drawer__overlay",
        style: Nt({ background: l.value }),
        onClick: a
      }, null, 12, TL)) : ie("", !0),
      ke(Ri, { name: "slide" }, {
        default: De(() => [
          t.modelValue ? (k(), U("div", {
            key: 0,
            class: we(["ui-drawer elevation-shadow-low", `ui-drawer_size_${t.size}`]),
            style: Nt(o.value),
            onClick: d[0] || (d[0] = $t(() => {
            }, ["stop"]))
          }, [
            re("header", {
              class: we(["ui-drawer__header", { "ui-drawer__header_compact": t.closeButton }])
            }, [
              t.closeButton ? (k(), U("button", {
                key: 0,
                type: "button",
                class: "ui-drawer__close",
                onClick: $t(a, ["prevent"])
              }, [
                ke(Y(lx), { class: "ui-drawer__icon" })
              ])) : ie("", !0),
              re("div", xL, [
                Se(u.$slots, "header", {}, void 0, !0)
              ])
            ], 2),
            re("div", SL, [
              s.title ? (k(), U("div", CL, [
                Se(u.$slots, "title", {}, void 0, !0)
              ])) : ie("", !0),
              Se(u.$slots, "body", {}, void 0, !0)
            ]),
            re("footer", EL, [
              Se(u.$slots, "footer", {}, void 0, !0)
            ])
          ], 6)) : ie("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), $q = /* @__PURE__ */ tt(DL, [["__scopeId", "data-v-e1e1a52c"]]), _L = {
  key: 0,
  class: "ui-dropzone-input__label label"
}, kL = {
  key: 1,
  class: "symbol-required"
}, PL = ["for"], IL = ["id", "multiple", "accept", "disabled"], ML = {
  key: 0,
  class: "main__info"
}, OL = {
  key: 1,
  class: "ui-dropzone-input__caption caption"
}, BL = /* @__PURE__ */ qe({
  name: "UiDropzoneInput",
  __name: "UiDropzoneInput",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "l"
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !0
    },
    filesAcceptTypes: {
      type: String,
      default: "*"
    },
    label: {
      type: String,
      default: ""
    },
    hint: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    info: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    }
  },
  emits: ["error", "update:modelValue", "addFiles"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = pe(!1), r = M_(() => s.value = !1, 100, {
      maxWait: 1e3
    }), a = (A) => {
      s.value = A, A && r();
    }, o = J(() => i.error || i.caption || ""), l = J(() => !!o.value), u = pe(null), d = (A) => {
      const m = A.target;
      m.files && (n("addFiles", m.files), m.value = "");
    }, c = () => {
      var A;
      (A = u.value) == null || A.click();
    };
    return (A, m) => (k(), U("div", {
      class: we(["ui-dropzone-input", {
        [`ui-dropzone-input__size_${t.size}`]: t.size != null,
        "ui-dropzone-input_dragging": s.value,
        "ui-dropzone-input_error": t.error,
        "ui-dropzone-input_disabled": t.disabled
      }])
    }, [
      t.label || t.hint || t.required ? (k(), U("div", _L, [
        re("p", null, _e(t.label), 1),
        t.hint ? (k(), Ce(Fd, {
          key: 0,
          "hint-content": t.hint
        }, {
          default: De(() => [
            ke(Y(is))
          ]),
          _: 1
        }, 8, ["hint-content"])) : ie("", !0),
        t.required ? (k(), U("span", kL, "*")) : ie("", !0)
      ])) : ie("", !0),
      re("div", {
        class: "ui-dropzone-input__main main",
        onDragenter: m[0] || (m[0] = (p) => a(!0)),
        onDragover: m[1] || (m[1] = (p) => a(!0)),
        onDragexit: m[2] || (m[2] = (p) => a(!1)),
        onDragleave: m[3] || (m[3] = (p) => a(!1)),
        onDragend: m[4] || (m[4] = (p) => a(!1)),
        onDrop: m[5] || (m[5] = (p) => a(!1)),
        onDrag: m[6] || (m[6] = (p) => a(!1))
      }, [
        ke(Y(Kx), { class: "main__icon" }),
        re("label", { for: t.id }, [
          re("input", {
            id: t.id,
            ref_key: "dropzoneInput",
            ref: u,
            type: "file",
            multiple: t.multiple,
            accept: t.filesAcceptTypes,
            class: "main__input",
            disabled: t.disabled,
            title: "dropzone",
            name: "dropzone",
            "aria-label": "dropzone",
            onChange: d
          }, null, 40, IL)
        ], 8, PL),
        m[7] || (m[7] = re("div", { class: "main__action" }, [
          re("span", { class: "link__style" }, "Выберите файлы"),
          re("span", null, " или перетащите сюда")
        ], -1)),
        t.info ? (k(), U("p", ML, _e(t.info), 1)) : ie("", !0),
        ke($r, {
          size: "m",
          label: "Загрузить файл",
          color: "secondary",
          class: "main__action-open",
          disabled: t.disabled,
          "full-width": t.size === "s",
          onClick: c
        }, {
          default: De(() => [
            ke(Y(dS), { class: "local-icon" })
          ]),
          _: 1
        }, 8, ["disabled", "full-width"])
      ], 32),
      l.value ? (k(), U("p", OL, _e(o.value), 1)) : ie("", !0)
    ], 2));
  }
}), LL = /* @__PURE__ */ tt(BL, [["__scopeId", "data-v-14492ca2"]]), NL = { class: "file-preview" }, RL = /* @__PURE__ */ qe({
  name: "FilePreview",
  __name: "FilePreview",
  props: {
    filePath: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    Md((n) => ({
      "4826c7d6": i.value
    }));
    const e = t, i = J(() => `url(${e.filePath}) lightgray 50% / cover no-repeat`);
    return (n, s) => (k(), U("div", NL));
  }
}), FL = /* @__PURE__ */ tt(RL, [["__scopeId", "data-v-c37689cc"]]), zL = { class: "ui-dropzone-file" }, UL = { class: "ui-dropzone-file__body body" }, VL = { class: "body__title" }, qL = { class: "body__name" }, HL = { class: "body__ext" }, WL = { class: "body__name" }, YL = { class: "body__ext" }, XL = { class: "body__size" }, jL = {
  key: 0,
  class: "body__error"
}, GL = { class: "ui-dropzone-file_actions actions" }, QL = /* @__PURE__ */ qe({
  name: "UiDropzoneFile",
  __name: "UiDropzoneFile",
  props: {
    file: {
      type: Object,
      required: !0
    },
    fileIcon: {
      type: Boolean,
      default: !0
    },
    fileAction: {
      type: Boolean,
      default: !0
    },
    fileDisabledDownload: {
      type: Boolean,
      default: !1
    },
    fileDisabledAction: {
      type: Boolean,
      default: !1
    },
    fileReload: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "l"
    },
    fileError: {
      type: String,
      default: ""
    }
  },
  emits: ["deleteFile", "downloadFile", "resendFile"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = J(() => i.file.progress ?? 0), r = J(() => s.value > 0 && s.value < 100), a = () => {
      n("deleteFile", i.file.id);
    }, o = () => {
      n("downloadFile", i.file.id);
    }, l = () => {
      n("resendFile", i.file);
    }, u = () => {
      i.fileReload || i.file.resend ? l() : o();
    }, d = J(() => m(i.file)), c = J(() => i.fileError || i.file.error), A = J(() => i.fileReload || i.file.resend), m = (p) => {
      var b, y;
      const h = ((y = (b = p.ext) == null ? void 0 : b.toLowerCase()) == null ? void 0 : y.replace(".", "")) || "";
      if ({
        gif: HC,
        img: rE,
        jpg: fC,
        png: LC,
        svg: KC
      }[h])
        return FL;
      const w = {
        avi: hE,
        mp3: RE,
        mp4: kE,
        wav: wE,
        rar: DC,
        zip: yC,
        csv: xD,
        doc: jD,
        docx: zD,
        pdf: t_,
        ppt: $E,
        txt: ID,
        xls: mD,
        pptx: YE,
        xlsx: oD,
        default: th
      };
      return w[h] || w.default;
    };
    return (p, h) => (k(), U("div", zL, [
      d.value ? (k(), Ce(Ft(d.value), {
        key: 0,
        "file-path": t.file.url,
        class: "ui-dropzone-file__icon"
      }, null, 8, ["file-path"])) : ie("", !0),
      re("div", UL, [
        re("div", VL, [
          t.size === "l" ? (k(), Ce(Fd, {
            key: 0,
            "hint-content": t.file.name,
            class: "body__hint"
          }, {
            default: De(() => [
              ke(ja, {
                label: t.file.name,
                disabled: t.fileDisabledDownload,
                class: "body__link",
                onClick: o
              }, {
                default: De(() => [
                  re("span", qL, _e(t.file.title), 1),
                  re("span", HL, _e(t.file.ext), 1)
                ]),
                _: 1
              }, 8, ["label", "disabled"])
            ]),
            _: 1
          }, 8, ["hint-content"])) : (k(), Ce(ja, {
            key: 1,
            label: t.file.name,
            disabled: t.fileDisabledDownload,
            class: "body__link",
            onClick: o
          }, {
            default: De(() => [
              re("span", WL, _e(t.file.title), 1),
              re("span", YL, _e(t.file.ext), 1)
            ]),
            _: 1
          }, 8, ["label", "disabled"])),
          re("span", XL, _e(t.file.size), 1)
        ]),
        c.value ? (k(), U("p", jL, _e(c.value), 1)) : ie("", !0),
        r.value ? (k(), Ce(II, {
          key: 1,
          value: s.value,
          size: "s",
          class: "body__progress"
        }, null, 8, ["value"])) : ie("", !0)
      ]),
      re("div", GL, [
        t.fileAction ? (k(), Ce(EA, {
          key: 0,
          size: "m",
          disabled: t.fileDisabledAction,
          class: "reset_button",
          color: "ghost",
          onClick: u
        }, {
          default: De(() => [
            A.value ? (k(), Ce(Y(Cx), { key: 0 })) : (k(), Ce(Y(o0), { key: 1 }))
          ]),
          _: 1
        }, 8, ["disabled"])) : ie("", !0),
        ke(EA, {
          size: "m",
          class: "reset_button",
          color: "ghost",
          onClick: a
        }, {
          default: De(() => [
            ke(Y(po))
          ]),
          _: 1
        })
      ])
    ]));
  }
}), ZL = /* @__PURE__ */ tt(QL, [["__scopeId", "data-v-4c355d1c"]]), ed = (t, e = 1) => {
  if (!+t)
    return "0 Bytes";
  const i = 1024, n = Math.max(0, e), s = ["Бит", "КБ", "МБ", "ГБ", "ТБ", "ПБ"], r = Math.floor(Math.log(t) / Math.log(i));
  return `${parseFloat((t / Math.pow(i, r)).toFixed(n))} ${s[r]}`;
}, KL = (t) => {
  var e;
  return ((e = t.match(/\.\w+$/)) == null ? void 0 : e[0]) || null;
}, JL = (t) => gp(t).split(", "), gp = (t) => typeof t == "string" ? t : Array.isArray(t) ? t.join(", ") : "", $L = (t, e, i) => {
  const n = [];
  t && t > 1 && n.push(`Загрузите не более ${t} файлов`), e > 0 && (n.length ? n.push(`до ${ed(e)}`) : n.push(`До ${ed(e)}`));
  const s = gp(i);
  if (s) {
    const r = s.replaceAll(".", "").toUpperCase();
    n.length ? n.push(`— ${r}`) : n.push(r);
  }
  return n.join(" ");
}, ny = (t, e) => (t.isNew && e && t.file.size > e && (t.error = "Превышен максимальный размер файла"), t), e9 = (t, e) => (t.isNew && Array.isArray(e) && e.length && e.every((i) => i !== "*") && e.every((i) => i && t.ext !== i) && (t.error = "Неподдерживаемый формат файла"), t), t9 = (t, e, i) => {
  const n = t.reduce((a, o) => a + o.file.size, 0), s = e.filter((a) => t.some((o) => o.id === a.id)).reduce((a, o) => a + o.file.size, 0), r = n !== s ? n + s : s;
  return i && r > i;
}, i9 = (t, e, i, n, s) => {
  const r = JL(s), a = t.map((c) => ny(c, i)).map((c) => e9(c, r)), o = t9(
    a,
    e,
    i
  ), l = e.length + a.length, u = n > 0 && l > n, d = a.filter((c) => r.every(
    (A) => A && A !== "*" && c.ext !== A
  ));
  return {
    filesSizeError: o,
    fileCountError: u,
    fileExtError: d,
    files: a,
    valid: !o && !u && !d.length
  };
};
class GA {
  constructor(e, i) {
    ze(this, "file");
    ze(this, "id");
    ze(this, "url");
    ze(this, "downloadPath");
    ze(this, "size");
    ze(this, "name");
    ze(this, "progress", null);
    ze(this, "error", null);
    ze(this, "errorCode", null);
    ze(this, "ext", null);
    ze(this, "title", null);
    ze(this, "isNew", !1);
    ze(this, "resend", !1);
    this.file = e, this.size = ed(e.size), this.id = `${e.name}-${e.size}-${e.lastModified}-${e.type}`, this.url = URL.createObjectURL(e), this.name = e.name, this.ext = KL(e.name), i && (this.isNew = i), this.ext && (this.title = e.name.replace(this.ext, ""));
  }
}
const n9 = /* @__PURE__ */ qe({
  name: "UiDropzone",
  __name: "UiDropzone",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "l"
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    hint: {
      type: String,
      default: ""
    },
    caption: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    filled: {
      type: Boolean,
      default: !1
    },
    filesMaxSize: {
      type: Number,
      default: 10485760
      // 10mb
    },
    filesMaxCount: {
      type: Number,
      default: 1
    },
    filesAcceptTypes: {
      type: [Array, String],
      default: () => [".png", ".jpeg", ".jpg"]
    },
    fileIcon: {
      type: Boolean,
      default: !0
    },
    fileAction: {
      type: Boolean,
      default: !1
    },
    fileDisabledAction: {
      type: Boolean,
      default: !1
    },
    fileReload: {
      type: Boolean,
      default: !1
    },
    fileError: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:modelValue",
    "addFiles",
    "resendFile",
    "deleteFile",
    "downloadFile"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = t, s = i, r = J(
      () => gp(n.filesAcceptTypes) || "*"
    ), a = J(
      () => $L(
        n.filesMaxCount,
        n.filesMaxSize,
        n.filesAcceptTypes
      )
    ), o = J({
      get: () => n.modelValue,
      set: (b) => s("update:modelValue", b)
    }), l = J(
      () => n.disabled || d.value
    ), u = pe(""), d = pe(!1), c = (b) => o.value.some(({ id: y }) => y === b), A = (b) => {
      const y = [...b].map((I) => new GA(I, !0)).map((I) => ny(I, n.filesMaxSize)).filter((I) => !c(I.id));
      g(y).hasErrors || (m(y), s("addFiles"));
    }, m = (b) => {
      o.value = [
        ...b,
        ...o.value.filter(
          (y) => !b.some((D) => D.id === y.id)
        )
      ];
    }, p = (b) => {
      const y = o.value.findIndex(
        (D) => D.id === b
      );
      y !== -1 ? (s("deleteFile", y), o.value.splice(y, 1)) : console.warn(`deleteFile error, file with id ${b} not found`);
    }, h = (b) => {
      const y = o.value.indexOf(b);
      y >= 0 && (o.value[y].progress = null, o.value[y].error = null, o.value[y].errorCode = null), s("resendFile", b);
    }, g = (b) => {
      var D;
      const y = i9(
        b,
        o.value || [],
        n.filesMaxSize,
        n.filesMaxCount,
        n.filesAcceptTypes
      );
      return (D = y.fileExtError) != null && D.length ? (w("Добавлены неподдерживаемые файлы"), { hasErrors: !0 }) : y.filesSizeError ? (w(
        `Суммарный размер файлов не должен превышать ${ed(n.filesMaxSize)}`
      ), { hasErrors: !0 }) : y.fileCountError ? (w("Превышено ограничение по количеству загружаемых файлов"), { hasErrors: !0 }) : (w(""), { hasErrors: !1 });
    }, w = (b) => {
      u.value = b, b && setTimeout(() => u.value = "", 3e3);
    };
    return e({
      validation: g,
      FileToUpload: GA
    }), (b, y) => (k(), U("div", {
      class: we(["ui-dropzone", {
        "ui-dropzone_required": n.required,
        "ui-dropzone_disabled": n.disabled,
        [`ui-dropzone__size_${n.size}`]: n.size,
        "ui-dropzone_error": n.error
      }])
    }, [
      ke(LL, {
        modelValue: o.value,
        "onUpdate:modelValue": y[0] || (y[0] = (D) => o.value = D),
        size: t.size,
        disabled: l.value,
        required: t.required,
        label: t.label,
        hint: t.hint,
        caption: t.caption,
        info: a.value,
        error: t.error || u.value,
        multiple: t.filesMaxCount > 1,
        "files-accept-types": r.value,
        onAddFiles: A
      }, null, 8, ["modelValue", "size", "disabled", "required", "label", "hint", "caption", "info", "error", "multiple", "files-accept-types"]),
      t.filled ? (k(), U(Xe, { key: 0 }, [
        o.value.length ? (k(), Ce(r0, {
          key: 0,
          tag: "div",
          name: "fade",
          class: "list_container"
        }, {
          default: De(() => [
            (k(!0), U(Xe, null, ut(o.value, (D) => (k(), Ce(ZL, {
              key: D.id,
              file: D,
              size: t.size,
              "file-icon": t.fileIcon,
              "file-action": t.fileAction,
              "file-disabled-action": t.fileDisabledAction,
              "file-reload": t.fileReload,
              "file-error": t.fileError,
              onDeleteFile: p,
              onResendFile: h
            }, null, 8, ["file", "size", "file-icon", "file-action", "file-disabled-action", "file-reload", "file-error"]))), 128))
          ]),
          _: 1
        })) : ie("", !0)
      ], 64)) : ie("", !0)
    ], 2));
  }
}), eH = /* @__PURE__ */ tt(n9, [["__scopeId", "data-v-d894f0a5"]]), s9 = (t, e = 1) => {
  if (!+t)
    return "0 Bytes";
  const i = 1024, n = e < 0 ? 0 : e, s = ["Бит", "КБ", "МБ", "ГБ", "ТБ", "ПБ", "EB", "ZB", "YB"], r = Math.floor(Math.log(t) / Math.log(i));
  return `${parseFloat((t / Math.pow(i, r)).toFixed(n))} ${(s == null ? void 0 : s[r]) || ""}`;
}, r9 = (t) => {
  const e = Math.round(t.length / 2), i = 3, n = 3, s = t.substring(0, e - i).trim(), r = t.substring(e + n, t.length).trim();
  return `${s} ... ${r}`.replaceAll(/\s+/g, " ").trim();
}, a9 = () => ({
  width: 0,
  maxWidth: 0
}), sy = (t, e, i = a9) => {
  if (t) {
    t.innerText = e;
    const { width: n, maxWidth: s } = i();
    if (n === 0 || s === 0)
      return;
    n < s && n < 244 ? t.innerText = e : sy(t, r9(e.trim()), i);
  }
}, o9 = { class: "ui-file__size" }, l9 = 320, QA = 252, u9 = /* @__PURE__ */ qe({
  name: "UiFile",
  __name: "UiFile",
  props: {
    fileIcon: {
      type: Object,
      default: th
    },
    fileId: {
      type: [String, Number],
      default: () => Math.random().toString(36).substring(2, 8)
    },
    fileTitle: {
      type: String,
      default: ""
    },
    fileSize: {
      type: Number,
      default: 10485760
    },
    fileDisabledDownload: {
      type: Boolean,
      default: !1
    },
    hint: {
      type: String,
      default: ""
    }
  },
  emits: ["downloadFile"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = pe(!0), r = pe(void 0), a = pe(void 0), o = J(() => i.fileIcon || th), l = J(() => i.hint || i.fileTitle), u = () => {
      n("downloadFile", i.fileId);
    }, d = () => {
      var h, g, w, b, y;
      const { width: A } = ((h = a.value) == null ? void 0 : h.getBoundingClientRect()) || {
        width: 0
      }, m = ((w = (g = a.value) == null ? void 0 : g.parentElement) == null ? void 0 : w.clientWidth) || 0, p = m < QA && (((b = r.value) == null ? void 0 : b.clientWidth) || 0) === l9 ? QA : m;
      return i.fileTitle === ((y = a.value) == null ? void 0 : y.innerText) ? s.value = !0 : s.value = !1, {
        width: A,
        maxWidth: p
      };
    }, c = () => {
      (a.value || window.innerWidth) && sy(a.value, i.fileTitle, d);
    };
    return Vs(() => {
      c();
    }), It(() => {
      window.addEventListener("resize", c);
    }), Nn(() => {
      window.removeEventListener("resize", c);
    }), (A, m) => (k(), U("div", {
      ref_key: "uiFile",
      ref: r,
      class: "ui-file"
    }, [
      o.value ? (k(), Ce(Ft(o.value), {
        key: 0,
        class: "ui-file__icon"
      })) : ie("", !0),
      ke(Fd, {
        "hint-content": l.value,
        disabled: s.value,
        class: "ui-file__hint hint_item"
      }, {
        default: De(() => [
          ke(ja, {
            disabled: i.fileDisabledDownload,
            class: "ui-file__link link",
            onClick: u
          }, {
            default: De(() => [
              re("span", {
                ref_key: "truncateMiddle",
                ref: a,
                class: "link__name"
              }, null, 512)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["hint-content", "disabled"]),
      re("span", o9, _e(Y(s9)(i.fileSize)), 1)
    ], 512));
  }
}), tH = /* @__PURE__ */ tt(u9, [["__scopeId", "data-v-1463aa5c"]]);
/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ZA(t, e) {
  var i = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function Es(t) {
  for (var e = 1; e < arguments.length; e++) {
    var i = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ZA(Object(i), !0).forEach(function(n) {
      d9(t, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : ZA(Object(i)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return t;
}
function Lu(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Lu = function(e) {
    return typeof e;
  } : Lu = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Lu(t);
}
function d9(t, e, i) {
  return e in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}
function Ws() {
  return Ws = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
    }
    return t;
  }, Ws.apply(this, arguments);
}
function c9(t, e) {
  if (t == null) return {};
  var i = {}, n = Object.keys(t), s, r;
  for (r = 0; r < n.length; r++)
    s = n[r], !(e.indexOf(s) >= 0) && (i[s] = t[s]);
  return i;
}
function f9(t, e) {
  if (t == null) return {};
  var i = c9(t, e), n, s;
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    for (s = 0; s < r.length; s++)
      n = r[s], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (i[n] = t[n]);
  }
  return i;
}
var h9 = "1.15.6";
function zs(t) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(t);
}
var js = zs(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Fl = zs(/Edge/i), KA = zs(/firefox/i), ul = zs(/safari/i) && !zs(/chrome/i) && !zs(/android/i), vp = zs(/iP(ad|od|hone)/i), ry = zs(/chrome/i) && zs(/android/i), ay = {
  capture: !1,
  passive: !1
};
function wt(t, e, i) {
  t.addEventListener(e, i, !js && ay);
}
function gt(t, e, i) {
  t.removeEventListener(e, i, !js && ay);
}
function td(t, e) {
  if (e) {
    if (e[0] === ">" && (e = e.substring(1)), t)
      try {
        if (t.matches)
          return t.matches(e);
        if (t.msMatchesSelector)
          return t.msMatchesSelector(e);
        if (t.webkitMatchesSelector)
          return t.webkitMatchesSelector(e);
      } catch {
        return !1;
      }
    return !1;
  }
}
function oy(t) {
  return t.host && t !== document && t.host.nodeType ? t.host : t.parentNode;
}
function Zn(t, e, i, n) {
  if (t) {
    i = i || document;
    do {
      if (e != null && (e[0] === ">" ? t.parentNode === i && td(t, e) : td(t, e)) || n && t === i)
        return t;
      if (t === i) break;
    } while (t = oy(t));
  }
  return null;
}
var JA = /\s+/g;
function pn(t, e, i) {
  if (t && e)
    if (t.classList)
      t.classList[i ? "add" : "remove"](e);
    else {
      var n = (" " + t.className + " ").replace(JA, " ").replace(" " + e + " ", " ");
      t.className = (n + (i ? " " + e : "")).replace(JA, " ");
    }
}
function rt(t, e, i) {
  var n = t && t.style;
  if (n) {
    if (i === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? i = document.defaultView.getComputedStyle(t, "") : t.currentStyle && (i = t.currentStyle), e === void 0 ? i : i[e];
    !(e in n) && e.indexOf("webkit") === -1 && (e = "-webkit-" + e), n[e] = i + (typeof i == "string" ? "" : "px");
  }
}
function Ma(t, e) {
  var i = "";
  if (typeof t == "string")
    i = t;
  else
    do {
      var n = rt(t, "transform");
      n && n !== "none" && (i = n + " " + i);
    } while (!e && (t = t.parentNode));
  var s = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return s && new s(i);
}
function ly(t, e, i) {
  if (t) {
    var n = t.getElementsByTagName(e), s = 0, r = n.length;
    if (i)
      for (; s < r; s++)
        i(n[s], s);
    return n;
  }
  return [];
}
function Ss() {
  var t = document.scrollingElement;
  return t || document.documentElement;
}
function vi(t, e, i, n, s) {
  if (!(!t.getBoundingClientRect && t !== window)) {
    var r, a, o, l, u, d, c;
    if (t !== window && t.parentNode && t !== Ss() ? (r = t.getBoundingClientRect(), a = r.top, o = r.left, l = r.bottom, u = r.right, d = r.height, c = r.width) : (a = 0, o = 0, l = window.innerHeight, u = window.innerWidth, d = window.innerHeight, c = window.innerWidth), (e || i) && t !== window && (s = s || t.parentNode, !js))
      do
        if (s && s.getBoundingClientRect && (rt(s, "transform") !== "none" || i && rt(s, "position") !== "static")) {
          var A = s.getBoundingClientRect();
          a -= A.top + parseInt(rt(s, "border-top-width")), o -= A.left + parseInt(rt(s, "border-left-width")), l = a + r.height, u = o + r.width;
          break;
        }
      while (s = s.parentNode);
    if (n && t !== window) {
      var m = Ma(s || t), p = m && m.a, h = m && m.d;
      m && (a /= h, o /= p, c /= p, d /= h, l = a + d, u = o + c);
    }
    return {
      top: a,
      left: o,
      bottom: l,
      right: u,
      width: c,
      height: d
    };
  }
}
function $A(t, e, i) {
  for (var n = dr(t, !0), s = vi(t)[e]; n; ) {
    var r = vi(n)[i], a = void 0;
    if (a = s >= r, !a) return n;
    if (n === Ss()) break;
    n = dr(n, !1);
  }
  return !1;
}
function Ja(t, e, i, n) {
  for (var s = 0, r = 0, a = t.children; r < a.length; ) {
    if (a[r].style.display !== "none" && a[r] !== at.ghost && (n || a[r] !== at.dragged) && Zn(a[r], i.draggable, t, !1)) {
      if (s === e)
        return a[r];
      s++;
    }
    r++;
  }
  return null;
}
function yp(t, e) {
  for (var i = t.lastElementChild; i && (i === at.ghost || rt(i, "display") === "none" || e && !td(i, e)); )
    i = i.previousElementSibling;
  return i || null;
}
function Pn(t, e) {
  var i = 0;
  if (!t || !t.parentNode)
    return -1;
  for (; t = t.previousElementSibling; )
    t.nodeName.toUpperCase() !== "TEMPLATE" && t !== at.clone && (!e || td(t, e)) && i++;
  return i;
}
function eg(t) {
  var e = 0, i = 0, n = Ss();
  if (t)
    do {
      var s = Ma(t), r = s.a, a = s.d;
      e += t.scrollLeft * r, i += t.scrollTop * a;
    } while (t !== n && (t = t.parentNode));
  return [e, i];
}
function p9(t, e) {
  for (var i in t)
    if (t.hasOwnProperty(i)) {
      for (var n in e)
        if (e.hasOwnProperty(n) && e[n] === t[i][n]) return Number(i);
    }
  return -1;
}
function dr(t, e) {
  if (!t || !t.getBoundingClientRect) return Ss();
  var i = t, n = !1;
  do
    if (i.clientWidth < i.scrollWidth || i.clientHeight < i.scrollHeight) {
      var s = rt(i);
      if (i.clientWidth < i.scrollWidth && (s.overflowX == "auto" || s.overflowX == "scroll") || i.clientHeight < i.scrollHeight && (s.overflowY == "auto" || s.overflowY == "scroll")) {
        if (!i.getBoundingClientRect || i === document.body) return Ss();
        if (n || e) return i;
        n = !0;
      }
    }
  while (i = i.parentNode);
  return Ss();
}
function m9(t, e) {
  if (t && e)
    for (var i in e)
      e.hasOwnProperty(i) && (t[i] = e[i]);
  return t;
}
function Hc(t, e) {
  return Math.round(t.top) === Math.round(e.top) && Math.round(t.left) === Math.round(e.left) && Math.round(t.height) === Math.round(e.height) && Math.round(t.width) === Math.round(e.width);
}
var dl;
function uy(t, e) {
  return function() {
    if (!dl) {
      var i = arguments, n = this;
      i.length === 1 ? t.call(n, i[0]) : t.apply(n, i), dl = setTimeout(function() {
        dl = void 0;
      }, e);
    }
  };
}
function A9() {
  clearTimeout(dl), dl = void 0;
}
function dy(t, e, i) {
  t.scrollLeft += e, t.scrollTop += i;
}
function cy(t) {
  var e = window.Polymer, i = window.jQuery || window.Zepto;
  return e && e.dom ? e.dom(t).cloneNode(!0) : i ? i(t).clone(!0)[0] : t.cloneNode(!0);
}
function fy(t, e, i) {
  var n = {};
  return Array.from(t.children).forEach(function(s) {
    var r, a, o, l;
    if (!(!Zn(s, e.draggable, t, !1) || s.animated || s === i)) {
      var u = vi(s);
      n.left = Math.min((r = n.left) !== null && r !== void 0 ? r : 1 / 0, u.left), n.top = Math.min((a = n.top) !== null && a !== void 0 ? a : 1 / 0, u.top), n.right = Math.max((o = n.right) !== null && o !== void 0 ? o : -1 / 0, u.right), n.bottom = Math.max((l = n.bottom) !== null && l !== void 0 ? l : -1 / 0, u.bottom);
    }
  }), n.width = n.right - n.left, n.height = n.bottom - n.top, n.x = n.left, n.y = n.top, n;
}
var an = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function g9() {
  var t = [], e;
  return {
    captureAnimationState: function() {
      if (t = [], !!this.options.animation) {
        var n = [].slice.call(this.el.children);
        n.forEach(function(s) {
          if (!(rt(s, "display") === "none" || s === at.ghost)) {
            t.push({
              target: s,
              rect: vi(s)
            });
            var r = Es({}, t[t.length - 1].rect);
            if (s.thisAnimationDuration) {
              var a = Ma(s, !0);
              a && (r.top -= a.f, r.left -= a.e);
            }
            s.fromRect = r;
          }
        });
      }
    },
    addAnimationState: function(n) {
      t.push(n);
    },
    removeAnimationState: function(n) {
      t.splice(p9(t, {
        target: n
      }), 1);
    },
    animateAll: function(n) {
      var s = this;
      if (!this.options.animation) {
        clearTimeout(e), typeof n == "function" && n();
        return;
      }
      var r = !1, a = 0;
      t.forEach(function(o) {
        var l = 0, u = o.target, d = u.fromRect, c = vi(u), A = u.prevFromRect, m = u.prevToRect, p = o.rect, h = Ma(u, !0);
        h && (c.top -= h.f, c.left -= h.e), u.toRect = c, u.thisAnimationDuration && Hc(A, c) && !Hc(d, c) && // Make sure animatingRect is on line between toRect & fromRect
        (p.top - c.top) / (p.left - c.left) === (d.top - c.top) / (d.left - c.left) && (l = y9(p, A, m, s.options)), Hc(c, d) || (u.prevFromRect = d, u.prevToRect = c, l || (l = s.options.animation), s.animate(u, p, c, l)), l && (r = !0, a = Math.max(a, l), clearTimeout(u.animationResetTimer), u.animationResetTimer = setTimeout(function() {
          u.animationTime = 0, u.prevFromRect = null, u.fromRect = null, u.prevToRect = null, u.thisAnimationDuration = null;
        }, l), u.thisAnimationDuration = l);
      }), clearTimeout(e), r ? e = setTimeout(function() {
        typeof n == "function" && n();
      }, a) : typeof n == "function" && n(), t = [];
    },
    animate: function(n, s, r, a) {
      if (a) {
        rt(n, "transition", ""), rt(n, "transform", "");
        var o = Ma(this.el), l = o && o.a, u = o && o.d, d = (s.left - r.left) / (l || 1), c = (s.top - r.top) / (u || 1);
        n.animatingX = !!d, n.animatingY = !!c, rt(n, "transform", "translate3d(" + d + "px," + c + "px,0)"), this.forRepaintDummy = v9(n), rt(n, "transition", "transform " + a + "ms" + (this.options.easing ? " " + this.options.easing : "")), rt(n, "transform", "translate3d(0,0,0)"), typeof n.animated == "number" && clearTimeout(n.animated), n.animated = setTimeout(function() {
          rt(n, "transition", ""), rt(n, "transform", ""), n.animated = !1, n.animatingX = !1, n.animatingY = !1;
        }, a);
      }
    }
  };
}
function v9(t) {
  return t.offsetWidth;
}
function y9(t, e, i, n) {
  return Math.sqrt(Math.pow(e.top - t.top, 2) + Math.pow(e.left - t.left, 2)) / Math.sqrt(Math.pow(e.top - i.top, 2) + Math.pow(e.left - i.left, 2)) * n.animation;
}
var ha = [], Wc = {
  initializeByDefault: !0
}, zl = {
  mount: function(e) {
    for (var i in Wc)
      Wc.hasOwnProperty(i) && !(i in e) && (e[i] = Wc[i]);
    ha.forEach(function(n) {
      if (n.pluginName === e.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(e.pluginName, " more than once");
    }), ha.push(e);
  },
  pluginEvent: function(e, i, n) {
    var s = this;
    this.eventCanceled = !1, n.cancel = function() {
      s.eventCanceled = !0;
    };
    var r = e + "Global";
    ha.forEach(function(a) {
      i[a.pluginName] && (i[a.pluginName][r] && i[a.pluginName][r](Es({
        sortable: i
      }, n)), i.options[a.pluginName] && i[a.pluginName][e] && i[a.pluginName][e](Es({
        sortable: i
      }, n)));
    });
  },
  initializePlugins: function(e, i, n, s) {
    ha.forEach(function(o) {
      var l = o.pluginName;
      if (!(!e.options[l] && !o.initializeByDefault)) {
        var u = new o(e, i, e.options);
        u.sortable = e, u.options = e.options, e[l] = u, Ws(n, u.defaults);
      }
    });
    for (var r in e.options)
      if (e.options.hasOwnProperty(r)) {
        var a = this.modifyOption(e, r, e.options[r]);
        typeof a < "u" && (e.options[r] = a);
      }
  },
  getEventProperties: function(e, i) {
    var n = {};
    return ha.forEach(function(s) {
      typeof s.eventProperties == "function" && Ws(n, s.eventProperties.call(i[s.pluginName], e));
    }), n;
  },
  modifyOption: function(e, i, n) {
    var s;
    return ha.forEach(function(r) {
      e[r.pluginName] && r.optionListeners && typeof r.optionListeners[i] == "function" && (s = r.optionListeners[i].call(e[r.pluginName], n));
    }), s;
  }
};
function b9(t) {
  var e = t.sortable, i = t.rootEl, n = t.name, s = t.targetEl, r = t.cloneEl, a = t.toEl, o = t.fromEl, l = t.oldIndex, u = t.newIndex, d = t.oldDraggableIndex, c = t.newDraggableIndex, A = t.originalEvent, m = t.putSortable, p = t.extraEventProperties;
  if (e = e || i && i[an], !!e) {
    var h, g = e.options, w = "on" + n.charAt(0).toUpperCase() + n.substr(1);
    window.CustomEvent && !js && !Fl ? h = new CustomEvent(n, {
      bubbles: !0,
      cancelable: !0
    }) : (h = document.createEvent("Event"), h.initEvent(n, !0, !0)), h.to = a || i, h.from = o || i, h.item = s || i, h.clone = r, h.oldIndex = l, h.newIndex = u, h.oldDraggableIndex = d, h.newDraggableIndex = c, h.originalEvent = A, h.pullMode = m ? m.lastPutMode : void 0;
    var b = Es(Es({}, p), zl.getEventProperties(n, e));
    for (var y in b)
      h[y] = b[y];
    i && i.dispatchEvent(h), g[w] && g[w].call(e, h);
  }
}
var w9 = ["evt"], nn = function(e, i) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = n.evt, r = f9(n, w9);
  zl.pluginEvent.bind(at)(e, i, Es({
    dragEl: Ue,
    parentEl: ri,
    ghostEl: ct,
    rootEl: Qt,
    nextEl: Nr,
    lastDownEl: Nu,
    cloneEl: ti,
    cloneHidden: ur,
    dragStarted: Jo,
    putSortable: Oi,
    activeSortable: at.active,
    originalEvent: s,
    oldIndex: Sa,
    oldDraggableIndex: cl,
    newIndex: mn,
    newDraggableIndex: ar,
    hideGhostForTarget: Ay,
    unhideGhostForTarget: gy,
    cloneNowHidden: function() {
      ur = !0;
    },
    cloneNowShown: function() {
      ur = !1;
    },
    dispatchSortableEvent: function(o) {
      Ki({
        sortable: i,
        name: o,
        originalEvent: s
      });
    }
  }, r));
};
function Ki(t) {
  b9(Es({
    putSortable: Oi,
    cloneEl: ti,
    targetEl: Ue,
    rootEl: Qt,
    oldIndex: Sa,
    oldDraggableIndex: cl,
    newIndex: mn,
    newDraggableIndex: ar
  }, t));
}
var Ue, ri, ct, Qt, Nr, Nu, ti, ur, Sa, mn, cl, ar, Tu, Oi, ba = !1, id = !1, nd = [], kr, jn, Yc, Xc, tg, ig, Jo, pa, fl, hl = !1, xu = !1, Ru, Fi, jc = [], lh = !1, sd = [], qd = typeof document < "u", Su = vp, ng = Fl || js ? "cssFloat" : "float", T9 = qd && !ry && !vp && "draggable" in document.createElement("div"), hy = function() {
  if (qd) {
    if (js)
      return !1;
    var t = document.createElement("x");
    return t.style.cssText = "pointer-events:auto", t.style.pointerEvents === "auto";
  }
}(), py = function(e, i) {
  var n = rt(e), s = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth), r = Ja(e, 0, i), a = Ja(e, 1, i), o = r && rt(r), l = a && rt(a), u = o && parseInt(o.marginLeft) + parseInt(o.marginRight) + vi(r).width, d = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + vi(a).width;
  if (n.display === "flex")
    return n.flexDirection === "column" || n.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (n.display === "grid")
    return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (r && o.float && o.float !== "none") {
    var c = o.float === "left" ? "left" : "right";
    return a && (l.clear === "both" || l.clear === c) ? "vertical" : "horizontal";
  }
  return r && (o.display === "block" || o.display === "flex" || o.display === "table" || o.display === "grid" || u >= s && n[ng] === "none" || a && n[ng] === "none" && u + d > s) ? "vertical" : "horizontal";
}, x9 = function(e, i, n) {
  var s = n ? e.left : e.top, r = n ? e.right : e.bottom, a = n ? e.width : e.height, o = n ? i.left : i.top, l = n ? i.right : i.bottom, u = n ? i.width : i.height;
  return s === o || r === l || s + a / 2 === o + u / 2;
}, S9 = function(e, i) {
  var n;
  return nd.some(function(s) {
    var r = s[an].options.emptyInsertThreshold;
    if (!(!r || yp(s))) {
      var a = vi(s), o = e >= a.left - r && e <= a.right + r, l = i >= a.top - r && i <= a.bottom + r;
      if (o && l)
        return n = s;
    }
  }), n;
}, my = function(e) {
  function i(r, a) {
    return function(o, l, u, d) {
      var c = o.options.group.name && l.options.group.name && o.options.group.name === l.options.group.name;
      if (r == null && (a || c))
        return !0;
      if (r == null || r === !1)
        return !1;
      if (a && r === "clone")
        return r;
      if (typeof r == "function")
        return i(r(o, l, u, d), a)(o, l, u, d);
      var A = (a ? o : l).options.group.name;
      return r === !0 || typeof r == "string" && r === A || r.join && r.indexOf(A) > -1;
    };
  }
  var n = {}, s = e.group;
  (!s || Lu(s) != "object") && (s = {
    name: s
  }), n.name = s.name, n.checkPull = i(s.pull, !0), n.checkPut = i(s.put), n.revertClone = s.revertClone, e.group = n;
}, Ay = function() {
  !hy && ct && rt(ct, "display", "none");
}, gy = function() {
  !hy && ct && rt(ct, "display", "");
};
qd && !ry && document.addEventListener("click", function(t) {
  if (id)
    return t.preventDefault(), t.stopPropagation && t.stopPropagation(), t.stopImmediatePropagation && t.stopImmediatePropagation(), id = !1, !1;
}, !0);
var Pr = function(e) {
  if (Ue) {
    e = e.touches ? e.touches[0] : e;
    var i = S9(e.clientX, e.clientY);
    if (i) {
      var n = {};
      for (var s in e)
        e.hasOwnProperty(s) && (n[s] = e[s]);
      n.target = n.rootEl = i, n.preventDefault = void 0, n.stopPropagation = void 0, i[an]._onDragOver(n);
    }
  }
}, C9 = function(e) {
  Ue && Ue.parentNode[an]._isOutsideThisEl(e.target);
};
function at(t, e) {
  if (!(t && t.nodeType && t.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(t));
  this.el = t, this.options = e = Ws({}, e), t[an] = this;
  var i = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(t.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return py(t, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(a, o) {
      a.setData("Text", o.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
    supportPointer: at.supportPointer !== !1 && "PointerEvent" in window && (!ul || vp),
    emptyInsertThreshold: 5
  };
  zl.initializePlugins(this, t, i);
  for (var n in i)
    !(n in e) && (e[n] = i[n]);
  my(e);
  for (var s in this)
    s.charAt(0) === "_" && typeof this[s] == "function" && (this[s] = this[s].bind(this));
  this.nativeDraggable = e.forceFallback ? !1 : T9, this.nativeDraggable && (this.options.touchStartThreshold = 1), e.supportPointer ? wt(t, "pointerdown", this._onTapStart) : (wt(t, "mousedown", this._onTapStart), wt(t, "touchstart", this._onTapStart)), this.nativeDraggable && (wt(t, "dragover", this), wt(t, "dragenter", this)), nd.push(this.el), e.store && e.store.get && this.sort(e.store.get(this) || []), Ws(this, g9());
}
at.prototype = /** @lends Sortable.prototype */
{
  constructor: at,
  _isOutsideThisEl: function(e) {
    !this.el.contains(e) && e !== this.el && (pa = null);
  },
  _getDirection: function(e, i) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, e, i, Ue) : this.options.direction;
  },
  _onTapStart: function(e) {
    if (e.cancelable) {
      var i = this, n = this.el, s = this.options, r = s.preventOnFilter, a = e.type, o = e.touches && e.touches[0] || e.pointerType && e.pointerType === "touch" && e, l = (o || e).target, u = e.target.shadowRoot && (e.path && e.path[0] || e.composedPath && e.composedPath()[0]) || l, d = s.filter;
      if (O9(n), !Ue && !(/mousedown|pointerdown/.test(a) && e.button !== 0 || s.disabled) && !u.isContentEditable && !(!this.nativeDraggable && ul && l && l.tagName.toUpperCase() === "SELECT") && (l = Zn(l, s.draggable, n, !1), !(l && l.animated) && Nu !== l)) {
        if (Sa = Pn(l), cl = Pn(l, s.draggable), typeof d == "function") {
          if (d.call(this, e, l, this)) {
            Ki({
              sortable: i,
              rootEl: u,
              name: "filter",
              targetEl: l,
              toEl: n,
              fromEl: n
            }), nn("filter", i, {
              evt: e
            }), r && e.preventDefault();
            return;
          }
        } else if (d && (d = d.split(",").some(function(c) {
          if (c = Zn(u, c.trim(), n, !1), c)
            return Ki({
              sortable: i,
              rootEl: c,
              name: "filter",
              targetEl: l,
              fromEl: n,
              toEl: n
            }), nn("filter", i, {
              evt: e
            }), !0;
        }), d)) {
          r && e.preventDefault();
          return;
        }
        s.handle && !Zn(u, s.handle, n, !1) || this._prepareDragStart(e, o, l);
      }
    }
  },
  _prepareDragStart: function(e, i, n) {
    var s = this, r = s.el, a = s.options, o = r.ownerDocument, l;
    if (n && !Ue && n.parentNode === r) {
      var u = vi(n);
      if (Qt = r, Ue = n, ri = Ue.parentNode, Nr = Ue.nextSibling, Nu = n, Tu = a.group, at.dragged = Ue, kr = {
        target: Ue,
        clientX: (i || e).clientX,
        clientY: (i || e).clientY
      }, tg = kr.clientX - u.left, ig = kr.clientY - u.top, this._lastX = (i || e).clientX, this._lastY = (i || e).clientY, Ue.style["will-change"] = "all", l = function() {
        if (nn("delayEnded", s, {
          evt: e
        }), at.eventCanceled) {
          s._onDrop();
          return;
        }
        s._disableDelayedDragEvents(), !KA && s.nativeDraggable && (Ue.draggable = !0), s._triggerDragStart(e, i), Ki({
          sortable: s,
          name: "choose",
          originalEvent: e
        }), pn(Ue, a.chosenClass, !0);
      }, a.ignore.split(",").forEach(function(d) {
        ly(Ue, d.trim(), Gc);
      }), wt(o, "dragover", Pr), wt(o, "mousemove", Pr), wt(o, "touchmove", Pr), a.supportPointer ? (wt(o, "pointerup", s._onDrop), !this.nativeDraggable && wt(o, "pointercancel", s._onDrop)) : (wt(o, "mouseup", s._onDrop), wt(o, "touchend", s._onDrop), wt(o, "touchcancel", s._onDrop)), KA && this.nativeDraggable && (this.options.touchStartThreshold = 4, Ue.draggable = !0), nn("delayStart", this, {
        evt: e
      }), a.delay && (!a.delayOnTouchOnly || i) && (!this.nativeDraggable || !(Fl || js))) {
        if (at.eventCanceled) {
          this._onDrop();
          return;
        }
        a.supportPointer ? (wt(o, "pointerup", s._disableDelayedDrag), wt(o, "pointercancel", s._disableDelayedDrag)) : (wt(o, "mouseup", s._disableDelayedDrag), wt(o, "touchend", s._disableDelayedDrag), wt(o, "touchcancel", s._disableDelayedDrag)), wt(o, "mousemove", s._delayedDragTouchMoveHandler), wt(o, "touchmove", s._delayedDragTouchMoveHandler), a.supportPointer && wt(o, "pointermove", s._delayedDragTouchMoveHandler), s._dragStartTimer = setTimeout(l, a.delay);
      } else
        l();
    }
  },
  _delayedDragTouchMoveHandler: function(e) {
    var i = e.touches ? e.touches[0] : e;
    Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    Ue && Gc(Ue), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var e = this.el.ownerDocument;
    gt(e, "mouseup", this._disableDelayedDrag), gt(e, "touchend", this._disableDelayedDrag), gt(e, "touchcancel", this._disableDelayedDrag), gt(e, "pointerup", this._disableDelayedDrag), gt(e, "pointercancel", this._disableDelayedDrag), gt(e, "mousemove", this._delayedDragTouchMoveHandler), gt(e, "touchmove", this._delayedDragTouchMoveHandler), gt(e, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(e, i) {
    i = i || e.pointerType == "touch" && e, !this.nativeDraggable || i ? this.options.supportPointer ? wt(document, "pointermove", this._onTouchMove) : i ? wt(document, "touchmove", this._onTouchMove) : wt(document, "mousemove", this._onTouchMove) : (wt(Ue, "dragend", this), wt(Qt, "dragstart", this._onDragStart));
    try {
      document.selection ? Fu(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(e, i) {
    if (ba = !1, Qt && Ue) {
      nn("dragStarted", this, {
        evt: i
      }), this.nativeDraggable && wt(document, "dragover", C9);
      var n = this.options;
      !e && pn(Ue, n.dragClass, !1), pn(Ue, n.ghostClass, !0), at.active = this, e && this._appendGhost(), Ki({
        sortable: this,
        name: "start",
        originalEvent: i
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (jn) {
      this._lastX = jn.clientX, this._lastY = jn.clientY, Ay();
      for (var e = document.elementFromPoint(jn.clientX, jn.clientY), i = e; e && e.shadowRoot && (e = e.shadowRoot.elementFromPoint(jn.clientX, jn.clientY), e !== i); )
        i = e;
      if (Ue.parentNode[an]._isOutsideThisEl(e), i)
        do {
          if (i[an]) {
            var n = void 0;
            if (n = i[an]._onDragOver({
              clientX: jn.clientX,
              clientY: jn.clientY,
              target: e,
              rootEl: i
            }), n && !this.options.dragoverBubble)
              break;
          }
          e = i;
        } while (i = oy(i));
      gy();
    }
  },
  _onTouchMove: function(e) {
    if (kr) {
      var i = this.options, n = i.fallbackTolerance, s = i.fallbackOffset, r = e.touches ? e.touches[0] : e, a = ct && Ma(ct, !0), o = ct && a && a.a, l = ct && a && a.d, u = Su && Fi && eg(Fi), d = (r.clientX - kr.clientX + s.x) / (o || 1) + (u ? u[0] - jc[0] : 0) / (o || 1), c = (r.clientY - kr.clientY + s.y) / (l || 1) + (u ? u[1] - jc[1] : 0) / (l || 1);
      if (!at.active && !ba) {
        if (n && Math.max(Math.abs(r.clientX - this._lastX), Math.abs(r.clientY - this._lastY)) < n)
          return;
        this._onDragStart(e, !0);
      }
      if (ct) {
        a ? (a.e += d - (Yc || 0), a.f += c - (Xc || 0)) : a = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: d,
          f: c
        };
        var A = "matrix(".concat(a.a, ",").concat(a.b, ",").concat(a.c, ",").concat(a.d, ",").concat(a.e, ",").concat(a.f, ")");
        rt(ct, "webkitTransform", A), rt(ct, "mozTransform", A), rt(ct, "msTransform", A), rt(ct, "transform", A), Yc = d, Xc = c, jn = r;
      }
      e.cancelable && e.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!ct) {
      var e = this.options.fallbackOnBody ? document.body : Qt, i = vi(Ue, !0, Su, !0, e), n = this.options;
      if (Su) {
        for (Fi = e; rt(Fi, "position") === "static" && rt(Fi, "transform") === "none" && Fi !== document; )
          Fi = Fi.parentNode;
        Fi !== document.body && Fi !== document.documentElement ? (Fi === document && (Fi = Ss()), i.top += Fi.scrollTop, i.left += Fi.scrollLeft) : Fi = Ss(), jc = eg(Fi);
      }
      ct = Ue.cloneNode(!0), pn(ct, n.ghostClass, !1), pn(ct, n.fallbackClass, !0), pn(ct, n.dragClass, !0), rt(ct, "transition", ""), rt(ct, "transform", ""), rt(ct, "box-sizing", "border-box"), rt(ct, "margin", 0), rt(ct, "top", i.top), rt(ct, "left", i.left), rt(ct, "width", i.width), rt(ct, "height", i.height), rt(ct, "opacity", "0.8"), rt(ct, "position", Su ? "absolute" : "fixed"), rt(ct, "zIndex", "100000"), rt(ct, "pointerEvents", "none"), at.ghost = ct, e.appendChild(ct), rt(ct, "transform-origin", tg / parseInt(ct.style.width) * 100 + "% " + ig / parseInt(ct.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(e, i) {
    var n = this, s = e.dataTransfer, r = n.options;
    if (nn("dragStart", this, {
      evt: e
    }), at.eventCanceled) {
      this._onDrop();
      return;
    }
    nn("setupClone", this), at.eventCanceled || (ti = cy(Ue), ti.removeAttribute("id"), ti.draggable = !1, ti.style["will-change"] = "", this._hideClone(), pn(ti, this.options.chosenClass, !1), at.clone = ti), n.cloneId = Fu(function() {
      nn("clone", n), !at.eventCanceled && (n.options.removeCloneOnHide || Qt.insertBefore(ti, Ue), n._hideClone(), Ki({
        sortable: n,
        name: "clone"
      }));
    }), !i && pn(Ue, r.dragClass, !0), i ? (id = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (gt(document, "mouseup", n._onDrop), gt(document, "touchend", n._onDrop), gt(document, "touchcancel", n._onDrop), s && (s.effectAllowed = "move", r.setData && r.setData.call(n, s, Ue)), wt(document, "drop", n), rt(Ue, "transform", "translateZ(0)")), ba = !0, n._dragStartId = Fu(n._dragStarted.bind(n, i, e)), wt(document, "selectstart", n), Jo = !0, window.getSelection().removeAllRanges(), ul && rt(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(e) {
    var i = this.el, n = e.target, s, r, a, o = this.options, l = o.group, u = at.active, d = Tu === l, c = o.sort, A = Oi || u, m, p = this, h = !1;
    if (lh) return;
    function g(W, j) {
      nn(W, p, Es({
        evt: e,
        isOwner: d,
        axis: m ? "vertical" : "horizontal",
        revert: a,
        dragRect: s,
        targetRect: r,
        canSort: c,
        fromSortable: A,
        target: n,
        completed: b,
        onMove: function($, ye) {
          return Cu(Qt, i, Ue, s, $, vi($), e, ye);
        },
        changed: y
      }, j));
    }
    function w() {
      g("dragOverAnimationCapture"), p.captureAnimationState(), p !== A && A.captureAnimationState();
    }
    function b(W) {
      return g("dragOverCompleted", {
        insertion: W
      }), W && (d ? u._hideClone() : u._showClone(p), p !== A && (pn(Ue, Oi ? Oi.options.ghostClass : u.options.ghostClass, !1), pn(Ue, o.ghostClass, !0)), Oi !== p && p !== at.active ? Oi = p : p === at.active && Oi && (Oi = null), A === p && (p._ignoreWhileAnimating = n), p.animateAll(function() {
        g("dragOverAnimationComplete"), p._ignoreWhileAnimating = null;
      }), p !== A && (A.animateAll(), A._ignoreWhileAnimating = null)), (n === Ue && !Ue.animated || n === i && !n.animated) && (pa = null), !o.dragoverBubble && !e.rootEl && n !== document && (Ue.parentNode[an]._isOutsideThisEl(e.target), !W && Pr(e)), !o.dragoverBubble && e.stopPropagation && e.stopPropagation(), h = !0;
    }
    function y() {
      mn = Pn(Ue), ar = Pn(Ue, o.draggable), Ki({
        sortable: p,
        name: "change",
        toEl: i,
        newIndex: mn,
        newDraggableIndex: ar,
        originalEvent: e
      });
    }
    if (e.preventDefault !== void 0 && e.cancelable && e.preventDefault(), n = Zn(n, o.draggable, i, !0), g("dragOver"), at.eventCanceled) return h;
    if (Ue.contains(e.target) || n.animated && n.animatingX && n.animatingY || p._ignoreWhileAnimating === n)
      return b(!1);
    if (id = !1, u && !o.disabled && (d ? c || (a = ri !== Qt) : Oi === this || (this.lastPutMode = Tu.checkPull(this, u, Ue, e)) && l.checkPut(this, u, Ue, e))) {
      if (m = this._getDirection(e, n) === "vertical", s = vi(Ue), g("dragOverValid"), at.eventCanceled) return h;
      if (a)
        return ri = Qt, w(), this._hideClone(), g("revert"), at.eventCanceled || (Nr ? Qt.insertBefore(Ue, Nr) : Qt.appendChild(Ue)), b(!0);
      var D = yp(i, o.draggable);
      if (!D || k9(e, m, this) && !D.animated) {
        if (D === Ue)
          return b(!1);
        if (D && i === e.target && (n = D), n && (r = vi(n)), Cu(Qt, i, Ue, s, n, r, e, !!n) !== !1)
          return w(), D && D.nextSibling ? i.insertBefore(Ue, D.nextSibling) : i.appendChild(Ue), ri = i, y(), b(!0);
      } else if (D && _9(e, m, this)) {
        var I = Ja(i, 0, o, !0);
        if (I === Ue)
          return b(!1);
        if (n = I, r = vi(n), Cu(Qt, i, Ue, s, n, r, e, !1) !== !1)
          return w(), i.insertBefore(Ue, I), ri = i, y(), b(!0);
      } else if (n.parentNode === i) {
        r = vi(n);
        var M = 0, _, N = Ue.parentNode !== i, x = !x9(Ue.animated && Ue.toRect || s, n.animated && n.toRect || r, m), C = m ? "top" : "left", L = $A(n, "top", "top") || $A(Ue, "top", "top"), V = L ? L.scrollTop : void 0;
        pa !== n && (_ = r[C], hl = !1, xu = !x && o.invertSwap || N), M = P9(e, n, r, m, x ? 1 : o.swapThreshold, o.invertedSwapThreshold == null ? o.swapThreshold : o.invertedSwapThreshold, xu, pa === n);
        var H;
        if (M !== 0) {
          var O = Pn(Ue);
          do
            O -= M, H = ri.children[O];
          while (H && (rt(H, "display") === "none" || H === ct));
        }
        if (M === 0 || H === n)
          return b(!1);
        pa = n, fl = M;
        var X = n.nextElementSibling, q = !1;
        q = M === 1;
        var F = Cu(Qt, i, Ue, s, n, r, e, q);
        if (F !== !1)
          return (F === 1 || F === -1) && (q = F === 1), lh = !0, setTimeout(D9, 30), w(), q && !X ? i.appendChild(Ue) : n.parentNode.insertBefore(Ue, q ? X : n), L && dy(L, 0, V - L.scrollTop), ri = Ue.parentNode, _ !== void 0 && !xu && (Ru = Math.abs(_ - vi(n)[C])), y(), b(!0);
      }
      if (i.contains(Ue))
        return b(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    gt(document, "mousemove", this._onTouchMove), gt(document, "touchmove", this._onTouchMove), gt(document, "pointermove", this._onTouchMove), gt(document, "dragover", Pr), gt(document, "mousemove", Pr), gt(document, "touchmove", Pr);
  },
  _offUpEvents: function() {
    var e = this.el.ownerDocument;
    gt(e, "mouseup", this._onDrop), gt(e, "touchend", this._onDrop), gt(e, "pointerup", this._onDrop), gt(e, "pointercancel", this._onDrop), gt(e, "touchcancel", this._onDrop), gt(document, "selectstart", this);
  },
  _onDrop: function(e) {
    var i = this.el, n = this.options;
    if (mn = Pn(Ue), ar = Pn(Ue, n.draggable), nn("drop", this, {
      evt: e
    }), ri = Ue && Ue.parentNode, mn = Pn(Ue), ar = Pn(Ue, n.draggable), at.eventCanceled) {
      this._nulling();
      return;
    }
    ba = !1, xu = !1, hl = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), uh(this.cloneId), uh(this._dragStartId), this.nativeDraggable && (gt(document, "drop", this), gt(i, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), ul && rt(document.body, "user-select", ""), rt(Ue, "transform", ""), e && (Jo && (e.cancelable && e.preventDefault(), !n.dropBubble && e.stopPropagation()), ct && ct.parentNode && ct.parentNode.removeChild(ct), (Qt === ri || Oi && Oi.lastPutMode !== "clone") && ti && ti.parentNode && ti.parentNode.removeChild(ti), Ue && (this.nativeDraggable && gt(Ue, "dragend", this), Gc(Ue), Ue.style["will-change"] = "", Jo && !ba && pn(Ue, Oi ? Oi.options.ghostClass : this.options.ghostClass, !1), pn(Ue, this.options.chosenClass, !1), Ki({
      sortable: this,
      name: "unchoose",
      toEl: ri,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: e
    }), Qt !== ri ? (mn >= 0 && (Ki({
      rootEl: ri,
      name: "add",
      toEl: ri,
      fromEl: Qt,
      originalEvent: e
    }), Ki({
      sortable: this,
      name: "remove",
      toEl: ri,
      originalEvent: e
    }), Ki({
      rootEl: ri,
      name: "sort",
      toEl: ri,
      fromEl: Qt,
      originalEvent: e
    }), Ki({
      sortable: this,
      name: "sort",
      toEl: ri,
      originalEvent: e
    })), Oi && Oi.save()) : mn !== Sa && mn >= 0 && (Ki({
      sortable: this,
      name: "update",
      toEl: ri,
      originalEvent: e
    }), Ki({
      sortable: this,
      name: "sort",
      toEl: ri,
      originalEvent: e
    })), at.active && ((mn == null || mn === -1) && (mn = Sa, ar = cl), Ki({
      sortable: this,
      name: "end",
      toEl: ri,
      originalEvent: e
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    nn("nulling", this), Qt = Ue = ri = ct = Nr = ti = Nu = ur = kr = jn = Jo = mn = ar = Sa = cl = pa = fl = Oi = Tu = at.dragged = at.ghost = at.clone = at.active = null, sd.forEach(function(e) {
      e.checked = !0;
    }), sd.length = Yc = Xc = 0;
  },
  handleEvent: function(e) {
    switch (e.type) {
      case "drop":
      case "dragend":
        this._onDrop(e);
        break;
      case "dragenter":
      case "dragover":
        Ue && (this._onDragOver(e), E9(e));
        break;
      case "selectstart":
        e.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var e = [], i, n = this.el.children, s = 0, r = n.length, a = this.options; s < r; s++)
      i = n[s], Zn(i, a.draggable, this.el, !1) && e.push(i.getAttribute(a.dataIdAttr) || M9(i));
    return e;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(e, i) {
    var n = {}, s = this.el;
    this.toArray().forEach(function(r, a) {
      var o = s.children[a];
      Zn(o, this.options.draggable, s, !1) && (n[r] = o);
    }, this), i && this.captureAnimationState(), e.forEach(function(r) {
      n[r] && (s.removeChild(n[r]), s.appendChild(n[r]));
    }), i && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var e = this.options.store;
    e && e.set && e.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(e, i) {
    return Zn(e, i || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(e, i) {
    var n = this.options;
    if (i === void 0)
      return n[e];
    var s = zl.modifyOption(this, e, i);
    typeof s < "u" ? n[e] = s : n[e] = i, e === "group" && my(n);
  },
  /**
   * Destroy
   */
  destroy: function() {
    nn("destroy", this);
    var e = this.el;
    e[an] = null, gt(e, "mousedown", this._onTapStart), gt(e, "touchstart", this._onTapStart), gt(e, "pointerdown", this._onTapStart), this.nativeDraggable && (gt(e, "dragover", this), gt(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function(i) {
      i.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), nd.splice(nd.indexOf(this.el), 1), this.el = e = null;
  },
  _hideClone: function() {
    if (!ur) {
      if (nn("hideClone", this), at.eventCanceled) return;
      rt(ti, "display", "none"), this.options.removeCloneOnHide && ti.parentNode && ti.parentNode.removeChild(ti), ur = !0;
    }
  },
  _showClone: function(e) {
    if (e.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (ur) {
      if (nn("showClone", this), at.eventCanceled) return;
      Ue.parentNode == Qt && !this.options.group.revertClone ? Qt.insertBefore(ti, Ue) : Nr ? Qt.insertBefore(ti, Nr) : Qt.appendChild(ti), this.options.group.revertClone && this.animate(Ue, ti), rt(ti, "display", ""), ur = !1;
    }
  }
};
function E9(t) {
  t.dataTransfer && (t.dataTransfer.dropEffect = "move"), t.cancelable && t.preventDefault();
}
function Cu(t, e, i, n, s, r, a, o) {
  var l, u = t[an], d = u.options.onMove, c;
  return window.CustomEvent && !js && !Fl ? l = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (l = document.createEvent("Event"), l.initEvent("move", !0, !0)), l.to = e, l.from = t, l.dragged = i, l.draggedRect = n, l.related = s || e, l.relatedRect = r || vi(e), l.willInsertAfter = o, l.originalEvent = a, t.dispatchEvent(l), d && (c = d.call(u, l, a)), c;
}
function Gc(t) {
  t.draggable = !1;
}
function D9() {
  lh = !1;
}
function _9(t, e, i) {
  var n = vi(Ja(i.el, 0, i.options, !0)), s = fy(i.el, i.options, ct), r = 10;
  return e ? t.clientX < s.left - r || t.clientY < n.top && t.clientX < n.right : t.clientY < s.top - r || t.clientY < n.bottom && t.clientX < n.left;
}
function k9(t, e, i) {
  var n = vi(yp(i.el, i.options.draggable)), s = fy(i.el, i.options, ct), r = 10;
  return e ? t.clientX > s.right + r || t.clientY > n.bottom && t.clientX > n.left : t.clientY > s.bottom + r || t.clientX > n.right && t.clientY > n.top;
}
function P9(t, e, i, n, s, r, a, o) {
  var l = n ? t.clientY : t.clientX, u = n ? i.height : i.width, d = n ? i.top : i.left, c = n ? i.bottom : i.right, A = !1;
  if (!a) {
    if (o && Ru < u * s) {
      if (!hl && (fl === 1 ? l > d + u * r / 2 : l < c - u * r / 2) && (hl = !0), hl)
        A = !0;
      else if (fl === 1 ? l < d + Ru : l > c - Ru)
        return -fl;
    } else if (l > d + u * (1 - s) / 2 && l < c - u * (1 - s) / 2)
      return I9(e);
  }
  return A = A || a, A && (l < d + u * r / 2 || l > c - u * r / 2) ? l > d + u / 2 ? 1 : -1 : 0;
}
function I9(t) {
  return Pn(Ue) < Pn(t) ? 1 : -1;
}
function M9(t) {
  for (var e = t.tagName + t.className + t.src + t.href + t.textContent, i = e.length, n = 0; i--; )
    n += e.charCodeAt(i);
  return n.toString(36);
}
function O9(t) {
  sd.length = 0;
  for (var e = t.getElementsByTagName("input"), i = e.length; i--; ) {
    var n = e[i];
    n.checked && sd.push(n);
  }
}
function Fu(t) {
  return setTimeout(t, 0);
}
function uh(t) {
  return clearTimeout(t);
}
qd && wt(document, "touchmove", function(t) {
  (at.active || ba) && t.cancelable && t.preventDefault();
});
at.utils = {
  on: wt,
  off: gt,
  css: rt,
  find: ly,
  is: function(e, i) {
    return !!Zn(e, i, e, !1);
  },
  extend: m9,
  throttle: uy,
  closest: Zn,
  toggleClass: pn,
  clone: cy,
  index: Pn,
  nextTick: Fu,
  cancelNextTick: uh,
  detectDirection: py,
  getChild: Ja,
  expando: an
};
at.get = function(t) {
  return t[an];
};
at.mount = function() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
    e[i] = arguments[i];
  e[0].constructor === Array && (e = e[0]), e.forEach(function(n) {
    if (!n.prototype || !n.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(n));
    n.utils && (at.utils = Es(Es({}, at.utils), n.utils)), zl.mount(n);
  });
};
at.create = function(t, e) {
  return new at(t, e);
};
at.version = h9;
var gi = [], $o, dh, ch = !1, Qc, Zc, rd, el;
function B9() {
  function t() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var e in this)
      e.charAt(0) === "_" && typeof this[e] == "function" && (this[e] = this[e].bind(this));
  }
  return t.prototype = {
    dragStarted: function(i) {
      var n = i.originalEvent;
      this.sortable.nativeDraggable ? wt(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? wt(document, "pointermove", this._handleFallbackAutoScroll) : n.touches ? wt(document, "touchmove", this._handleFallbackAutoScroll) : wt(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(i) {
      var n = i.originalEvent;
      !this.options.dragOverBubble && !n.rootEl && this._handleAutoScroll(n);
    },
    drop: function() {
      this.sortable.nativeDraggable ? gt(document, "dragover", this._handleAutoScroll) : (gt(document, "pointermove", this._handleFallbackAutoScroll), gt(document, "touchmove", this._handleFallbackAutoScroll), gt(document, "mousemove", this._handleFallbackAutoScroll)), sg(), zu(), A9();
    },
    nulling: function() {
      rd = dh = $o = ch = el = Qc = Zc = null, gi.length = 0;
    },
    _handleFallbackAutoScroll: function(i) {
      this._handleAutoScroll(i, !0);
    },
    _handleAutoScroll: function(i, n) {
      var s = this, r = (i.touches ? i.touches[0] : i).clientX, a = (i.touches ? i.touches[0] : i).clientY, o = document.elementFromPoint(r, a);
      if (rd = i, n || this.options.forceAutoScrollFallback || Fl || js || ul) {
        Kc(i, this.options, o, n);
        var l = dr(o, !0);
        ch && (!el || r !== Qc || a !== Zc) && (el && sg(), el = setInterval(function() {
          var u = dr(document.elementFromPoint(r, a), !0);
          u !== l && (l = u, zu()), Kc(i, s.options, u, n);
        }, 10), Qc = r, Zc = a);
      } else {
        if (!this.options.bubbleScroll || dr(o, !0) === Ss()) {
          zu();
          return;
        }
        Kc(i, this.options, dr(o, !1), !1);
      }
    }
  }, Ws(t, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function zu() {
  gi.forEach(function(t) {
    clearInterval(t.pid);
  }), gi = [];
}
function sg() {
  clearInterval(el);
}
var Kc = uy(function(t, e, i, n) {
  if (e.scroll) {
    var s = (t.touches ? t.touches[0] : t).clientX, r = (t.touches ? t.touches[0] : t).clientY, a = e.scrollSensitivity, o = e.scrollSpeed, l = Ss(), u = !1, d;
    dh !== i && (dh = i, zu(), $o = e.scroll, d = e.scrollFn, $o === !0 && ($o = dr(i, !0)));
    var c = 0, A = $o;
    do {
      var m = A, p = vi(m), h = p.top, g = p.bottom, w = p.left, b = p.right, y = p.width, D = p.height, I = void 0, M = void 0, _ = m.scrollWidth, N = m.scrollHeight, x = rt(m), C = m.scrollLeft, L = m.scrollTop;
      m === l ? (I = y < _ && (x.overflowX === "auto" || x.overflowX === "scroll" || x.overflowX === "visible"), M = D < N && (x.overflowY === "auto" || x.overflowY === "scroll" || x.overflowY === "visible")) : (I = y < _ && (x.overflowX === "auto" || x.overflowX === "scroll"), M = D < N && (x.overflowY === "auto" || x.overflowY === "scroll"));
      var V = I && (Math.abs(b - s) <= a && C + y < _) - (Math.abs(w - s) <= a && !!C), H = M && (Math.abs(g - r) <= a && L + D < N) - (Math.abs(h - r) <= a && !!L);
      if (!gi[c])
        for (var O = 0; O <= c; O++)
          gi[O] || (gi[O] = {});
      (gi[c].vx != V || gi[c].vy != H || gi[c].el !== m) && (gi[c].el = m, gi[c].vx = V, gi[c].vy = H, clearInterval(gi[c].pid), (V != 0 || H != 0) && (u = !0, gi[c].pid = setInterval((function() {
        n && this.layer === 0 && at.active._onTouchMove(rd);
        var X = gi[this.layer].vy ? gi[this.layer].vy * o : 0, q = gi[this.layer].vx ? gi[this.layer].vx * o : 0;
        typeof d == "function" && d.call(at.dragged.parentNode[an], q, X, t, rd, gi[this.layer].el) !== "continue" || dy(gi[this.layer].el, q, X);
      }).bind({
        layer: c
      }), 24))), c++;
    } while (e.bubbleScroll && A !== l && (A = dr(A, !1)));
    ch = u;
  }
}, 30), vy = function(e) {
  var i = e.originalEvent, n = e.putSortable, s = e.dragEl, r = e.activeSortable, a = e.dispatchSortableEvent, o = e.hideGhostForTarget, l = e.unhideGhostForTarget;
  if (i) {
    var u = n || r;
    o();
    var d = i.changedTouches && i.changedTouches.length ? i.changedTouches[0] : i, c = document.elementFromPoint(d.clientX, d.clientY);
    l(), u && !u.el.contains(c) && (a("spill"), this.onSpill({
      dragEl: s,
      putSortable: n
    }));
  }
};
function bp() {
}
bp.prototype = {
  startIndex: null,
  dragStart: function(e) {
    var i = e.oldDraggableIndex;
    this.startIndex = i;
  },
  onSpill: function(e) {
    var i = e.dragEl, n = e.putSortable;
    this.sortable.captureAnimationState(), n && n.captureAnimationState();
    var s = Ja(this.sortable.el, this.startIndex, this.options);
    s ? this.sortable.el.insertBefore(i, s) : this.sortable.el.appendChild(i), this.sortable.animateAll(), n && n.animateAll();
  },
  drop: vy
};
Ws(bp, {
  pluginName: "revertOnSpill"
});
function wp() {
}
wp.prototype = {
  onSpill: function(e) {
    var i = e.dragEl, n = e.putSortable, s = n || this.sortable;
    s.captureAnimationState(), i.parentNode && i.parentNode.removeChild(i), s.animateAll();
  },
  drop: vy
};
Ws(wp, {
  pluginName: "removeOnSpill"
});
at.mount(new B9());
at.mount(wp, bp);
function L9(t, e, i = {}) {
  let n;
  const { document: s = L_, ...r } = i, a = {
    onUpdate: (d) => {
      F9(e, d.oldIndex, d.newIndex, d);
    }
  }, o = () => {
    const d = typeof t == "string" ? s == null ? void 0 : s.querySelector(t) : vn(t);
    !d || n !== void 0 || (n = new at(d, { ...a, ...r }));
  }, l = () => {
    n == null || n.destroy(), n = void 0;
  }, u = (d, c) => {
    if (c !== void 0)
      n == null || n.option(d, c);
    else
      return n == null ? void 0 : n.option(d);
  };
  return Qh(o), sa(l), {
    stop: l,
    start: o,
    option: u
  };
}
function N9(t, e, i) {
  const n = t.children[i];
  t.insertBefore(e, n);
}
function R9(t) {
  t.parentNode && t.parentNode.removeChild(t);
}
function F9(t, e, i, n = null) {
  n != null && (R9(n.item), N9(n.from, n.item, e));
  const s = mr(t), r = s ? [...kt(t)] : kt(t);
  if (i >= 0 && i < r.length) {
    const a = r.splice(e, 1)[0];
    li(() => {
      r.splice(i, 0, a), s && (t.value = r);
    });
  }
}
const z9 = { class: "ui-image-uploader" }, U9 = { class: "ui-image-uploader__label" }, V9 = {
  key: 0,
  class: "symbol-required"
}, q9 = { class: "ui-image-uploader__item" }, H9 = ["src"], W9 = ["onClick"], Y9 = ["id", "accept", "required"], X9 = /* @__PURE__ */ qe({
  name: "UiImageUploader",
  __name: "UiImageUploader",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "Label"
    },
    caption: {
      type: String,
      default: ""
    },
    acceptTypes: {
      type: String,
      default: ".png, .jpeg, .jpg"
    },
    inputId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    tooltipContent: {
      type: String,
      default: ""
    },
    maxFilesCount: {
      type: Number,
      default: 5
    },
    maxFileSize: {
      type: Number,
      // 5 Мб
      default: 5242880
    },
    errorMessage: {
      type: String,
      default: ""
    },
    isShowMainImage: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["error", "update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = pe(!1);
    class r {
      constructor(h) {
        ze(this, "file");
        ze(this, "id");
        ze(this, "url");
        ze(this, "status");
        this.file = h, this.id = `${h.name}-${h.size}-${h.lastModified}-${h.type}`, this.url = URL.createObjectURL(h), this.status = null;
      }
    }
    const a = pe(null), o = pe([]), l = pe("");
    L9(a, o, {
      animation: 150,
      draggable: ".ui-image-uploader__item-wrapper",
      dragClass: "ui-image-uploader__item-wrapper_draggable"
    }), mt(o, () => {
      n("update:modelValue", o.value);
    });
    function u(p) {
      const h = [...p].map((g) => new r(g)).filter((g) => !d(g.id)).filter((g) => g.file.size < i.maxFileSize ? !0 : (l.value = "Превышен максимальный размер файла", setTimeout(() => {
        l.value = "";
      }, 5e3), !1));
      o.value = o.value.concat(h).slice(0, i.maxFilesCount), n("update:modelValue", o.value);
    }
    function d(p) {
      return o.value.some(({ id: h }) => h === p);
    }
    function c(p) {
      const h = o.value.indexOf(p);
      h > -1 && (o.value.splice(h, 1), n("update:modelValue", o.value));
    }
    function A(p) {
      const h = p.target;
      h.files && (u(h.files), h.value = "");
    }
    function m() {
      document.getElementById(i.inputId).click();
    }
    return (p, h) => (k(), U("div", z9, [
      re("div", U9, [
        re("p", null, _e(t.label), 1),
        ke(aa, {
          class: "ui-image-uploader__tooltip",
          "tooltip-message": t.tooltipContent
        }, {
          icon: De(() => [
            ke(Y(is), { class: "ui-image-uploader__icon-info" })
          ]),
          _: 1
        }, 8, ["tooltip-message"]),
        t.required ? (k(), U("span", V9, "*")) : ie("", !0)
      ]),
      re("div", {
        ref_key: "imageUploaderList",
        ref: a,
        class: we(["ui-image-uploader__list", {
          "ui-image-uploader__list_margin": t.isShowMainImage && o.value.length
        }])
      }, [
        (k(!0), U(Xe, null, ut(o.value, (g) => (k(), U("div", {
          key: g.id,
          class: we(["ui-image-uploader__item-wrapper", {
            "ui-image-uploader__item-wrapper_main-image": t.isShowMainImage
          }])
        }, [
          re("div", q9, [
            re("img", {
              src: g.url,
              alt: ""
            }, null, 8, H9),
            re("button", {
              class: we(["ui-image-uploader__button-delete", { "elevation-shadow-low": s.value }]),
              type: "button",
              onClick: $t((w) => c(g), ["stop"]),
              onMouseenter: h[0] || (h[0] = (w) => s.value = !0),
              onMouseleave: h[1] || (h[1] = (w) => s.value = !1)
            }, [
              ke(Y(na), { class: "icon-close-regular" })
            ], 42, W9)
          ])
        ], 2))), 128)),
        o.value.length < t.maxFilesCount ? (k(), U("button", {
          key: 0,
          class: "ui-image-uploader__button-add",
          type: "button",
          onClick: m
        }, [
          ke(Y(lC), { class: "icon-camera-fill" })
        ])) : ie("", !0)
      ], 2),
      re("p", {
        class: we(["ui-image-uploader__caption", { "ui-image-uploader__caption_error": t.errorMessage || l.value }])
      }, _e(t.errorMessage || l.value ? t.errorMessage || l.value : t.caption), 3),
      re("input", {
        id: t.inputId,
        type: "file",
        multiple: "",
        accept: t.acceptTypes,
        required: t.required,
        onChange: A
      }, null, 40, Y9)
    ]));
  }
}), iH = /* @__PURE__ */ tt(X9, [["__scopeId", "data-v-37a13fe3"]]), j9 = ["data-test-id"], G9 = {
  key: 0,
  class: "ui-accordion__custom-icon custom-icon"
}, Q9 = { class: "ui-accordion__content content" }, Z9 = /* @__PURE__ */ qe({
  name: "UiAccordion",
  __name: "UiAccordion",
  props: {
    type: {
      type: String,
      default: "stroke"
    },
    size: {
      type: String,
      default: "m"
    },
    title: {
      type: String,
      required: !0
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    dataTestId: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = Yi(), r = J({
      get: () => i.modelValue,
      set: (a) => n("update:modelValue", a)
    });
    return (a, o) => (k(), U("div", {
      class: we(["ui-accordion", [`ui-accordion_${t.type}`, `ui-accordion__size_${t.size}`]])
    }, [
      re("button", {
        type: "button",
        class: we(["ui-accordion__button button", { button_open: r.value }]),
        "data-test-id": t.dataTestId,
        onClick: o[0] || (o[0] = (l) => r.value = !r.value)
      }, [
        s.icon ? (k(), U("span", G9, [
          Se(a.$slots, "icon", {}, void 0, !0)
        ])) : ie("", !0),
        re("sub", null, _e(t.title), 1),
        ke(Y(Od), {
          class: we(["ui-accordion__close", { "icon-chevron_down-regular_rotate": r.value }])
        }, null, 8, ["class"])
      ], 10, j9),
      re("div", {
        class: we(["ui-accordion__content-wrapper content-wrapper", { "content-wrapper_open": r.value }])
      }, [
        re("div", Q9, [
          Se(a.$slots, "default", {}, void 0, !0)
        ])
      ], 2)
    ], 2));
  }
}), nH = /* @__PURE__ */ tt(Z9, [["__scopeId", "data-v-3dc49a12"]]);
function go() {
  const t = O2();
  return k(), U(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...t
    },
    [
      re("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      re("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      re("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      re("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
go.compatConfig = {
  MODE: 3
};
function yy() {
  return k(), U(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      re("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      re("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
yy.compatConfig = {
  MODE: 3
};
function Tp() {
  return k(), U(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      re("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Tp.compatConfig = {
  MODE: 3
};
function xp() {
  return k(), U(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      re("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
xp.compatConfig = {
  MODE: 3
};
function Sp() {
  return k(), U(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      re("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      re("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
Sp.compatConfig = {
  MODE: 3
};
function Cp() {
  return k(), U(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      re("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Cp.compatConfig = {
  MODE: 3
};
function Ep() {
  return k(), U(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      re("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Ep.compatConfig = {
  MODE: 3
};
const un = (t, e) => e ? new Date(t.toLocaleString("en-US", { timeZone: e })) : new Date(t), Dp = (t, e, i) => fh(t, e, i) || Oe(), K9 = (t, e, i) => {
  const n = e.dateInTz ? un(new Date(t), e.dateInTz) : Oe(t);
  return i ? Ii(n, !0) : n;
}, fh = (t, e, i) => {
  if (!t) return null;
  const n = i ? Ii(Oe(t), !0) : Oe(t);
  return e ? e.exactMatch ? K9(t, e, i) : un(n, e.timezone) : n;
}, J9 = (t) => {
  const e = new Date(t.getFullYear(), 0, 1).getTimezoneOffset();
  return t.getTimezoneOffset() < e;
}, $9 = (t, e) => {
  if (!t) return 0;
  const i = /* @__PURE__ */ new Date(), n = new Date(i.toLocaleString("en-US", { timeZone: "UTC" })), s = new Date(i.toLocaleString("en-US", { timeZone: t })), r = (J9(e ?? s) ? s : e ?? s).getTimezoneOffset() / 60;
  return (+n - +s) / (1e3 * 60 * 60) - r;
};
var Gn = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t))(Gn || {}), Qn = /* @__PURE__ */ ((t) => (t.top = "top", t.bottom = "bottom", t))(Qn || {}), Wr = /* @__PURE__ */ ((t) => (t.header = "header", t.calendar = "calendar", t.timePicker = "timePicker", t))(Wr || {}), Ui = /* @__PURE__ */ ((t) => (t.month = "month", t.year = "year", t.calendar = "calendar", t.time = "time", t.minutes = "minutes", t.hours = "hours", t.seconds = "seconds", t))(Ui || {});
const e7 = ["timestamp", "date", "iso"];
var Ji = /* @__PURE__ */ ((t) => (t.up = "up", t.down = "down", t.left = "left", t.right = "right", t))(Ji || {}), Xt = /* @__PURE__ */ ((t) => (t.arrowUp = "ArrowUp", t.arrowDown = "ArrowDown", t.arrowLeft = "ArrowLeft", t.arrowRight = "ArrowRight", t.enter = "Enter", t.space = " ", t.esc = "Escape", t.tab = "Tab", t.home = "Home", t.end = "End", t.pageUp = "PageUp", t.pageDown = "PageDown", t))(Xt || {}), Oa = /* @__PURE__ */ ((t) => (t.MONTH_AND_YEAR = "MM-yyyy", t.YEAR = "yyyy", t.DATE = "dd-MM-yyyy", t))(Oa || {});
function rg(t) {
  return (e) => {
    const i = new Intl.DateTimeFormat(t, {
      weekday: "short",
      timeZone: "UTC"
    }).format(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`));
    return t === "ar" ? i.slice(2, 5) : i.slice(0, 2);
  };
}
function t7(t) {
  return (e) => es(un(/* @__PURE__ */ new Date(`2017-01-0${e}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: t });
}
const i7 = (t, e, i) => {
  const n = [1, 2, 3, 4, 5, 6, 7];
  let s;
  if (t !== null)
    try {
      s = n.map(t7(t));
    } catch {
      s = n.map(rg(e));
    }
  else
    s = n.map(rg(e));
  const r = s.slice(0, i), a = s.slice(i + 1, s.length);
  return [s[i]].concat(...a).concat(...r);
}, _p = (t, e, i) => {
  const n = [];
  for (let s = +t[0]; s <= +t[1]; s++)
    n.push({ value: +s, text: xy(s, e) });
  return i ? n.reverse() : n;
}, by = (t, e, i) => {
  const n = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((r) => {
    const a = r < 10 ? `0${r}` : r;
    return /* @__PURE__ */ new Date(`2017-${a}-01T00:00:00+00:00`);
  });
  if (t !== null)
    try {
      const r = i === "long" ? "LLLL" : "LLL";
      return n.map((a, o) => {
        const l = es(un(a, "UTC"), r, { locale: t });
        return {
          text: l.charAt(0).toUpperCase() + l.substring(1),
          value: o
        };
      });
    } catch {
    }
  const s = new Intl.DateTimeFormat(e, { month: i, timeZone: "UTC" });
  return n.map((r, a) => {
    const o = s.format(r);
    return {
      text: o.charAt(0).toUpperCase() + o.substring(1),
      value: a
    };
  });
}, n7 = (t) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][t], bi = (t) => {
  const e = Y(t);
  return e != null && e.$el ? e == null ? void 0 : e.$el : e;
}, s7 = (t) => ({ type: "dot", ...t ?? {} }), wy = (t) => Array.isArray(t) ? !!t[0] && !!t[1] : !1, kp = {
  prop: (t) => `"${t}" prop must be enabled!`,
  dateArr: (t) => `You need to use array as "model-value" binding in order to support "${t}"`
}, xi = (t) => t, ag = (t) => t === 0 ? t : !t || isNaN(+t) ? null : +t, og = (t) => t === null, Ty = (t) => {
  if (t)
    return [...t.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, r7 = (t) => {
  const e = [], i = (n) => n.filter((s) => s);
  for (let n = 0; n < t.length; n += 3) {
    const s = [t[n], t[n + 1], t[n + 2]];
    e.push(i(s));
  }
  return e;
}, Cl = (t, e, i) => {
  const n = i != null, s = e != null;
  if (!n && !s) return !1;
  const r = +i, a = +e;
  return n && s ? +t > r || +t < a : n ? +t > r : s ? +t < a : !1;
}, $a = (t, e) => r7(t).map((i) => i.map((n) => {
  const { active: s, disabled: r, isBetween: a, highlighted: o } = e(n);
  return {
    ...n,
    active: s,
    disabled: r,
    className: {
      dp__overlay_cell_active: s,
      dp__overlay_cell: !s,
      dp__overlay_cell_disabled: r,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: r && s,
      dp__cell_in_between: a,
      "dp--highlighted": o
    }
  };
})), hr = (t, e, i = !1) => {
  t && e.allowStopPropagation && (i && t.stopImmediatePropagation(), t.stopPropagation());
}, a7 = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function o7(t, e) {
  let i = [...document.querySelectorAll(a7())];
  i = i.filter((s) => !t.contains(s) || s.hasAttribute("data-datepicker-instance"));
  const n = i.indexOf(t);
  if (n >= 0 && (e ? n - 1 >= 0 : n + 1 <= i.length))
    return i[n + (e ? -1 : 1)];
}
const hh = (t, e) => t == null ? void 0 : t.querySelector(`[data-dp-element="${e}"]`), xy = (t, e) => new Intl.NumberFormat(e, { useGrouping: !1, style: "decimal" }).format(t), Pp = (t, e) => es(t, e ?? Oa.DATE), Jc = (t) => Array.isArray(t), ad = (t, e, i) => e.get(Pp(t, i)), l7 = (t, e) => t ? e ? e instanceof Map ? !!ad(t, e) : e(Oe(t)) : !1 : !0, tn = (t, e, i = !1, n) => {
  if (t.key === Xt.enter || t.key === Xt.space)
    return i && t.preventDefault(), e();
  if (n) return n(t);
}, u7 = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, Sy = (t, e) => t ? Oa.MONTH_AND_YEAR : e ? Oa.YEAR : Oa.DATE, Cy = (t) => t < 10 ? `0${t}` : t, lg = (t, e, i, n, s, r) => {
  const a = oh(t, e.slice(0, t.length), /* @__PURE__ */ new Date(), { locale: r });
  return Pa(a) && z0(a) ? n || s ? a : Lt(a, {
    hours: +i.hours,
    minutes: +(i == null ? void 0 : i.minutes),
    seconds: +(i == null ? void 0 : i.seconds),
    milliseconds: 0
  }) : null;
}, d7 = (t, e, i, n, s, r) => {
  const a = Array.isArray(i) ? i[0] : i;
  if (typeof e == "string")
    return lg(t, e, a, n, s, r);
  if (Array.isArray(e)) {
    let o = null;
    for (const l of e)
      if (o = lg(t, l, a, n, s, r), o)
        break;
    return o;
  }
  return typeof e == "function" ? e(t) : null;
}, Oe = (t) => t ? new Date(t) : /* @__PURE__ */ new Date(), c7 = (t, e, i) => {
  if (e) {
    const s = (t.getMonth() + 1).toString().padStart(2, "0"), r = t.getDate().toString().padStart(2, "0"), a = t.getHours().toString().padStart(2, "0"), o = t.getMinutes().toString().padStart(2, "0"), l = i ? t.getSeconds().toString().padStart(2, "0") : "00";
    return `${t.getFullYear()}-${s}-${r}T${a}:${o}:${l}.000Z`;
  }
  const n = Date.UTC(
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate(),
    t.getUTCHours(),
    t.getUTCMinutes(),
    t.getUTCSeconds()
  );
  return new Date(n).toISOString();
}, Ii = (t, e) => {
  const i = Oe(JSON.parse(JSON.stringify(t))), n = Lt(i, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return e ? qI(n) : n;
}, pr = (t, e, i, n) => {
  let s = t ? Oe(t) : Oe();
  return (e || e === 0) && (s = jO(s, +e)), (i || i === 0) && (s = GO(s, +i)), (n || n === 0) && (s = iy(s, +n)), ty(s, 0);
}, ai = (t, e) => !t || !e ? !1 : Za(Ii(t), Ii(e)), yt = (t, e) => !t || !e ? !1 : Ta(Ii(t), Ii(e)), hi = (t, e) => !t || !e ? !1 : ea(Ii(t), Ii(e)), El = (t, e, i) => t != null && t[0] && t != null && t[1] ? hi(i, t[0]) && ai(i, t[1]) : t != null && t[0] && e ? hi(i, t[0]) && ai(i, e) || ai(i, t[0]) && hi(i, e) : !1, Jn = (t) => {
  const e = Lt(new Date(t), { date: 1 });
  return Ii(e);
}, $c = (t, e, i) => e && (i || i === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((n) => n === e ? [n, i] : [n, isNaN(+t[n]) ? void 0 : +t[n]])
) : {
  hours: isNaN(+t.hours) ? void 0 : +t.hours,
  minutes: isNaN(+t.minutes) ? void 0 : +t.minutes,
  seconds: isNaN(+t.seconds) ? void 0 : +t.seconds
}, Yr = (t) => ({
  hours: Hs(t),
  minutes: gr(t),
  seconds: Qa(t)
}), Ey = (t, e) => {
  if (e) {
    const i = lt(Oe(e));
    if (i > t) return 12;
    if (i === t) return vt(Oe(e));
  }
}, Dy = (t, e) => {
  if (e) {
    const i = lt(Oe(e));
    return i < t ? -1 : i === t ? vt(Oe(e)) : void 0;
  }
}, eo = (t) => {
  if (t) return lt(Oe(t));
}, _y = (t, e) => {
  const i = hi(t, e) ? e : t, n = hi(e, t) ? e : t;
  return V0({ start: i, end: n });
}, f7 = (t) => {
  const e = $n(t, 1);
  return { month: vt(e), year: lt(e) };
}, Bs = (t, e) => {
  const i = Tn(t, { weekStartsOn: +e }), n = H0(t, { weekStartsOn: +e });
  return [i, n];
}, ky = (t, e) => {
  const i = {
    hours: Hs(Oe()),
    minutes: gr(Oe()),
    seconds: e ? Qa(Oe()) : 0
  };
  return Object.assign(i, t);
}, cr = (t, e, i) => [Lt(Oe(t), { date: 1 }), Lt(Oe(), { month: e, year: i, date: 1 })], Fs = (t, e, i) => {
  let n = t ? Oe(t) : Oe();
  return (e || e === 0) && (n = ey(n, e)), i && (n = gs(n, i)), n;
}, Py = (t, e, i, n, s) => {
  if (!n || s && !e || !s && !i) return !1;
  const r = s ? $n(t, 1) : Ka(t, 1), a = [vt(r), lt(r)];
  return s ? !p7(...a, e) : !h7(...a, i);
}, h7 = (t, e, i) => ai(...cr(i, t, e)) || yt(...cr(i, t, e)), p7 = (t, e, i) => hi(...cr(i, t, e)) || yt(...cr(i, t, e)), Iy = (t, e, i, n, s, r, a) => {
  if (typeof e == "function" && !a) return e(t);
  const o = i ? { locale: i } : void 0;
  return Array.isArray(t) ? `${es(t[0], r, o)}${s && !t[1] ? "" : n}${t[1] ? es(t[1], r, o) : ""}` : es(t, r, o);
}, ma = (t) => {
  if (t) return null;
  throw new Error(kp.prop("partial-range"));
}, Eu = (t, e) => {
  if (e) return t();
  throw new Error(kp.prop("range"));
}, ph = (t) => Array.isArray(t) ? Pa(t[0]) && (t[1] ? Pa(t[1]) : !0) : t ? Pa(t) : !1, m7 = (t, e) => Lt(e ?? Oe(), {
  hours: +t.hours || 0,
  minutes: +t.minutes || 0,
  seconds: +t.seconds || 0
}), ef = (t, e, i, n) => {
  if (!t) return !0;
  if (n) {
    const s = i === "max" ? Za(t, e) : ea(t, e), r = { seconds: 0, milliseconds: 0 };
    return s || Ta(Lt(t, r), Lt(e, r));
  }
  return i === "max" ? t.getTime() <= e.getTime() : t.getTime() >= e.getTime();
}, tf = (t, e, i) => t ? m7(t, e) : Oe(i ?? e), ug = (t, e, i, n, s) => {
  if (Array.isArray(n)) {
    const a = tf(t, n[0], e), o = tf(t, n[1], e);
    return ef(n[0], a, i, !!e) && ef(n[1], o, i, !!e) && s;
  }
  const r = tf(t, n, e);
  return ef(n, r, i, !!e) && s;
}, nf = (t) => Lt(Oe(), Yr(t)), A7 = (t, e, i) => {
  if (t instanceof Map) {
    const n = `${Cy(i + 1)}-${e}`;
    return t.size ? t.has(n) : !1;
  }
  return typeof t == "function" ? t(Ii(Lt(Oe(), { month: i, year: e }), !0)) : !1;
}, g7 = (t, e, i) => {
  if (t instanceof Map) {
    const n = `${Cy(i + 1)}-${e}`;
    return t.size ? t.has(n) : !0;
  }
  return !0;
}, My = (t, e, i) => typeof t == "function" ? t({ month: e, year: i }) : !!t.months.find((n) => n.month === e && n.year === i), Ip = (t, e) => typeof t == "function" ? t(e) : t.years.includes(e), mh = (t) => `dp-${es(t, "yyyy-MM-dd")}`, dg = (t, e) => {
  const i = xa(Ii(e), t), n = In(Ii(e), t);
  return { before: i, after: n };
}, Yo = Jr({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Oy = () => {
  const t = (i) => {
    Yo.menuFocused = i;
  }, e = (i) => {
    Yo.shiftKeyInMenu !== i && (Yo.shiftKeyInMenu = i);
  };
  return {
    control: J(() => ({ shiftKeyInMenu: Yo.shiftKeyInMenu, menuFocused: Yo.menuFocused })),
    setMenuFocused: t,
    setShiftKey: e
  };
}, Wt = Jr({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), sf = pe(null), Du = pe(!1), rf = pe(!1), af = pe(!1), of = pe(!1), zi = pe(0), fi = pe(0), Tr = () => {
  const t = J(() => Du.value ? [...Wt.selectionGrid, Wt.actionRow].filter((c) => c.length) : rf.value ? [
    ...Wt.timePicker[0],
    ...Wt.timePicker[1],
    of.value ? [] : [sf.value],
    Wt.actionRow
  ].filter((c) => c.length) : af.value ? [...Wt.monthPicker, Wt.actionRow] : [Wt.monthYear, ...Wt.calendar, Wt.time, Wt.actionRow].filter((c) => c.length)), e = (c) => {
    zi.value = c ? zi.value + 1 : zi.value - 1;
    let A = null;
    t.value[fi.value] && (A = t.value[fi.value][zi.value]), !A && t.value[fi.value + (c ? 1 : -1)] ? (fi.value = fi.value + (c ? 1 : -1), zi.value = c ? 0 : t.value[fi.value].length - 1) : A || (zi.value = c ? zi.value - 1 : zi.value + 1);
  }, i = (c) => {
    fi.value === 0 && !c || fi.value === t.value.length && c || (fi.value = c ? fi.value + 1 : fi.value - 1, t.value[fi.value] ? t.value[fi.value] && !t.value[fi.value][zi.value] && zi.value !== 0 && (zi.value = t.value[fi.value].length - 1) : fi.value = c ? fi.value - 1 : fi.value + 1);
  }, n = (c) => {
    let A = null;
    t.value[fi.value] && (A = t.value[fi.value][zi.value]), A ? A.focus({ preventScroll: !Du.value }) : zi.value = c ? zi.value - 1 : zi.value + 1;
  }, s = () => {
    e(!0), n(!0);
  }, r = () => {
    e(!1), n(!1);
  }, a = () => {
    i(!1), n(!0);
  }, o = () => {
    i(!0), n(!0);
  }, l = (c, A) => {
    Wt[A] = c;
  }, u = (c, A) => {
    Wt[A] = c;
  }, d = () => {
    zi.value = 0, fi.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: u,
    setTimePickerBackRef: (c) => {
      sf.value = c;
    },
    setSelectionGrid: (c) => {
      Du.value = c, d(), c || (Wt.selectionGrid = []);
    },
    setTimePicker: (c, A = !1) => {
      rf.value = c, of.value = A, d(), c || (Wt.timePicker[0] = [], Wt.timePicker[1] = []);
    },
    setTimePickerElements: (c, A = 0) => {
      Wt.timePicker[A] = c;
    },
    arrowRight: s,
    arrowLeft: r,
    arrowUp: a,
    arrowDown: o,
    clearArrowNav: () => {
      Wt.monthYear = [], Wt.calendar = [], Wt.time = [], Wt.actionRow = [], Wt.selectionGrid = [], Wt.timePicker[0] = [], Wt.timePicker[1] = [], Du.value = !1, rf.value = !1, of.value = !1, af.value = !1, d(), sf.value = null;
    },
    setMonthPicker: (c) => {
      af.value = c, d();
    },
    refSets: Wt
    // exposed for testing
  };
}, cg = (t) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...t ?? {}
}), v7 = (t) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (e) => `Increment ${e}`,
  decrementValue: (e) => `Decrement ${e}`,
  openTpOverlay: (e) => `Open ${e} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
  yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
  timeOverlay: (e) => `${e} overlay`,
  ...t ?? {}
}), fg = (t) => t ? typeof t == "boolean" ? t ? 2 : 0 : +t >= 2 ? +t : 2 : 0, y7 = (t) => {
  const e = typeof t == "object" && t, i = {
    static: !0,
    solo: !1
  };
  if (!t) return { ...i, count: fg(!1) };
  const n = e ? t : {}, s = e ? n.count ?? !0 : t, r = fg(s);
  return Object.assign(i, n, { count: r });
}, b7 = (t, e, i) => t || (typeof i == "string" ? i : e), w7 = (t) => typeof t == "boolean" ? t ? cg({}) : !1 : cg(t), T7 = (t) => {
  const e = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - ",
    escClose: !0
  };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : { ...e, enabled: t };
}, x7 = (t) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...t ?? {}
}), S7 = (t) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...t ?? {}
}), C7 = (t) => {
  const e = { input: !1 };
  return typeof t == "object" ? { ...e, ...t ?? {}, enabled: !0 } : {
    enabled: t,
    ...e
  };
}, E7 = (t) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, mobileBreakpoint: 600, setDateOnMenuClose: !1, ...t ?? {} }), D7 = (t) => {
  const e = {
    dates: Array.isArray(t) ? t.map((i) => Oe(i)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof t == "function" ? t : { ...e, ...t ?? {} };
}, _7 = (t) => typeof t == "object" ? {
  type: (t == null ? void 0 : t.type) ?? "local",
  hideOnOffsetDates: (t == null ? void 0 : t.hideOnOffsetDates) ?? !1
} : {
  type: t,
  hideOnOffsetDates: !1
}, k7 = (t) => {
  const e = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof t == "object" ? { enabled: !0, ...e, ...t } : {
    enabled: t,
    ...e
  };
}, P7 = (t) => t ? typeof t == "string" ? {
  timezone: t,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: t.timezone,
  exactMatch: t.exactMatch ?? !1,
  dateInTz: t.dateInTz ?? void 0,
  emitTimezone: t.emitTimezone ?? void 0,
  convertModel: t.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, lf = (t, e, i, n) => new Map(
  t.map((s) => {
    const r = Dp(s, e, n);
    return [Pp(r, i), r];
  })
), I7 = (t, e) => t.length ? new Map(
  t.map((i) => {
    const n = Dp(i.date, e);
    return [Pp(n, Oa.DATE), i];
  })
) : null, M7 = (t) => {
  var e;
  const i = Sy(t.isMonthPicker, t.isYearPicker);
  return {
    minDate: fh(t.minDate, t.timezone, t.isSpecific),
    maxDate: fh(t.maxDate, t.timezone, t.isSpecific),
    disabledDates: Jc(t.disabledDates) ? lf(t.disabledDates, t.timezone, i, t.isSpecific) : t.disabledDates,
    allowedDates: Jc(t.allowedDates) ? lf(t.allowedDates, t.timezone, i, t.isSpecific) : null,
    highlight: typeof t.highlight == "object" && Jc((e = t.highlight) == null ? void 0 : e.dates) ? lf(t.highlight.dates, t.timezone, i) : t.highlight,
    markers: I7(t.markers, t.timezone)
  };
}, O7 = (t) => typeof t == "boolean" ? { enabled: t, dragSelect: !0, limit: null } : {
  enabled: !!t,
  limit: t.limit ? +t.limit : null,
  dragSelect: t.dragSelect ?? !0
}, B7 = (t) => ({
  ...Object.fromEntries(
    Object.keys(t).map((e) => {
      const i = e, n = t[i], s = typeof t[i] == "string" ? { [n]: !0 } : Object.fromEntries(n.map((r) => [r, !0]));
      return [e, s];
    })
  )
}), ei = (t) => {
  const e = () => {
    const M = t.enableSeconds ? ":ss" : "", _ = t.enableMinutes ? ":mm" : "";
    return t.is24 ? `HH${_}${M}` : `hh${_}${M} aa`;
  }, i = () => {
    var M;
    return t.format ? t.format : t.monthPicker ? "MM/yyyy" : t.timePicker ? e() : t.weekPicker ? `${((M = g.value) == null ? void 0 : M.type) === "iso" ? "II" : "ww"}-RR` : t.yearPicker ? "yyyy" : t.quarterPicker ? "QQQ/yyyy" : t.enableTimePicker ? `MM/dd/yyyy, ${e()}` : "MM/dd/yyyy";
  }, n = (M) => ky(M, t.enableSeconds), s = () => D.value.enabled ? t.startTime && Array.isArray(t.startTime) ? [n(t.startTime[0]), n(t.startTime[1])] : null : t.startTime && !Array.isArray(t.startTime) ? n(t.startTime) : null, r = J(() => y7(t.multiCalendars)), a = J(() => s()), o = J(() => v7(t.ariaLabels)), l = J(() => x7(t.filters)), u = J(() => w7(t.transitions)), d = J(() => S7(t.actionRow)), c = J(
    () => b7(t.previewFormat, t.format, i())
  ), A = J(() => T7(t.textInput)), m = J(() => C7(t.inline)), p = J(() => E7(t.config)), h = J(() => D7(t.highlight)), g = J(() => _7(t.weekNumbers)), w = J(() => P7(t.timezone)), b = J(() => O7(t.multiDates)), y = J(
    () => M7({
      minDate: t.minDate,
      maxDate: t.maxDate,
      disabledDates: t.disabledDates,
      allowedDates: t.allowedDates,
      highlight: h.value,
      markers: t.markers,
      timezone: w.value,
      isSpecific: t.monthPicker || t.yearPicker || t.quarterPicker,
      isMonthPicker: t.monthPicker,
      isYearPicker: t.yearPicker
    })
  ), D = J(() => k7(t.range)), I = J(() => B7(t.ui));
  return {
    defaultedTransitions: u,
    defaultedMultiCalendars: r,
    defaultedStartTime: a,
    defaultedAriaLabels: o,
    defaultedFilters: l,
    defaultedActionRow: d,
    defaultedPreviewFormat: c,
    defaultedTextInput: A,
    defaultedInline: m,
    defaultedConfig: p,
    defaultedHighlight: h,
    defaultedWeekNumbers: g,
    defaultedRange: D,
    propDates: y,
    defaultedTz: w,
    defaultedMultiDates: b,
    defaultedUI: I,
    getDefaultPattern: i,
    getDefaultStartTime: s,
    handleEventPropagation: (M) => {
      p.value.allowStopPropagation && M.stopPropagation(), p.value.allowPreventDefault && M.preventDefault();
    }
  };
}, L7 = (t, e, i) => {
  const n = pe(), { defaultedTextInput: s, defaultedRange: r, defaultedTz: a, defaultedMultiDates: o, getDefaultPattern: l } = ei(e), u = pe(""), d = Ha(e, "format"), c = Ha(e, "formatLocale");
  mt(
    n,
    () => {
      typeof e.onInternalModelChange == "function" && t("internal-model-change", n.value, le(!0));
    },
    { deep: !0 }
  ), mt(r, (B, ue) => {
    B.enabled !== ue.enabled && (n.value = null);
  }), mt(d, () => {
    W();
  });
  const A = (B) => a.value.timezone && a.value.convertModel ? un(B, a.value.timezone) : B, m = (B) => {
    if (a.value.timezone && a.value.convertModel) {
      const ue = $9(a.value.timezone, B);
      return LI(B, ue);
    }
    return B;
  }, p = (B, ue, Pe = !1) => Iy(
    B,
    e.format,
    e.formatLocale,
    s.value.rangeSeparator,
    e.modelAuto,
    ue ?? l(),
    Pe
  ), h = (B) => B ? e.modelType ? oe(B) : {
    hours: Hs(B),
    minutes: gr(B),
    seconds: e.enableSeconds ? Qa(B) : 0
  } : null, g = (B) => e.modelType ? oe(B) : { month: vt(B), year: lt(B) }, w = (B) => Array.isArray(B) ? o.value.enabled ? B.map((ue) => b(ue, gs(Oe(), ue))) : Eu(
    () => [
      gs(Oe(), B[0]),
      B[1] ? gs(Oe(), B[1]) : ma(r.value.partialRange)
    ],
    r.value.enabled
  ) : gs(Oe(), +B), b = (B, ue) => (typeof B == "string" || typeof B == "number") && e.modelType ? j(B) : ue, y = (B) => Array.isArray(B) ? [
    b(
      B[0],
      pr(null, +B[0].hours, +B[0].minutes, B[0].seconds)
    ),
    b(
      B[1],
      pr(null, +B[1].hours, +B[1].minutes, B[1].seconds)
    )
  ] : b(B, pr(null, B.hours, B.minutes, B.seconds)), D = (B) => {
    const ue = Lt(Oe(), { date: 1 });
    return Array.isArray(B) ? o.value.enabled ? B.map((Pe) => b(Pe, Fs(ue, +Pe.month, +Pe.year))) : Eu(
      () => [
        b(B[0], Fs(ue, +B[0].month, +B[0].year)),
        b(
          B[1],
          B[1] ? Fs(ue, +B[1].month, +B[1].year) : ma(r.value.partialRange)
        )
      ],
      r.value.enabled
    ) : b(B, Fs(ue, +B.month, +B.year));
  }, I = (B) => {
    if (Array.isArray(B))
      return B.map((ue) => j(ue));
    throw new Error(kp.dateArr("multi-dates"));
  }, M = (B) => {
    if (Array.isArray(B) && r.value.enabled) {
      const ue = B[0], Pe = B[1];
      return [
        Oe(Array.isArray(ue) ? ue[0] : null),
        Array.isArray(Pe) && Pe.length ? Oe(Pe[0]) : null
      ];
    }
    return Oe(B[0]);
  }, _ = (B) => e.modelAuto ? Array.isArray(B) ? [j(B[0]), j(B[1])] : e.autoApply ? [j(B)] : [j(B), null] : Array.isArray(B) ? Eu(
    () => B[1] ? [
      j(B[0]),
      B[1] ? j(B[1]) : ma(r.value.partialRange)
    ] : [j(B[0])],
    r.value.enabled
  ) : j(B), N = () => {
    Array.isArray(n.value) && r.value.enabled && n.value.length === 1 && n.value.push(ma(r.value.partialRange));
  }, x = () => {
    const B = n.value;
    return [
      oe(B[0]),
      B[1] ? oe(B[1]) : ma(r.value.partialRange)
    ];
  }, C = () => Array.isArray(n.value) ? n.value[1] ? x() : oe(xi(n.value[0])) : [], L = () => (n.value || []).map((B) => oe(B)), V = (B = !1) => (B || N(), e.modelAuto ? C() : o.value.enabled ? L() : Array.isArray(n.value) ? Eu(() => x(), r.value.enabled) : oe(xi(n.value))), H = (B) => !B || Array.isArray(B) && !B.length ? null : e.timePicker ? y(xi(B)) : e.monthPicker ? D(xi(B)) : e.yearPicker ? w(xi(B)) : o.value.enabled ? I(xi(B)) : e.weekPicker ? M(xi(B)) : _(xi(B)), O = (B) => {
    const ue = H(B);
    ph(xi(ue)) ? (n.value = xi(ue), W()) : (n.value = null, u.value = "");
  }, X = () => {
    const B = (ue) => es(ue, s.value.format);
    return `${B(n.value[0])} ${s.value.rangeSeparator} ${n.value[1] ? B(n.value[1]) : ""}`;
  }, q = () => i.value && n.value ? Array.isArray(n.value) ? X() : es(n.value, s.value.format) : p(n.value), F = () => n.value ? o.value.enabled ? n.value.map((B) => p(B)).join("; ") : s.value.enabled && typeof s.value.format == "string" ? q() : p(n.value) : "", W = () => {
    !e.format || typeof e.format == "string" || s.value.enabled && typeof s.value.format == "string" ? u.value = F() : u.value = e.format(n.value);
  }, j = (B) => {
    if (e.utc) {
      const ue = new Date(B);
      return e.utc === "preserve" ? new Date(ue.getTime() + ue.getTimezoneOffset() * 6e4) : ue;
    }
    return e.modelType ? e7.includes(e.modelType) ? A(new Date(B)) : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? A(
      oh(B, l(), /* @__PURE__ */ new Date(), { locale: c.value })
    ) : A(
      oh(B, e.modelType, /* @__PURE__ */ new Date(), { locale: c.value })
    ) : A(new Date(B));
  }, oe = (B) => B ? e.utc ? c7(B, e.utc === "preserve", e.enableSeconds) : e.modelType ? e.modelType === "timestamp" ? +m(B) : e.modelType === "iso" ? m(B).toISOString() : e.modelType === "format" && (typeof e.format == "string" || !e.format) ? p(m(B)) : p(m(B), e.modelType, !0) : m(B) : "", $ = (B, ue = !1, Pe = !1) => {
    if (Pe) return B;
    if (t("update:model-value", B), a.value.emitTimezone && ue) {
      const nt = Array.isArray(B) ? B.map((ge) => un(xi(ge), a.value.emitTimezone)) : un(xi(B), a.value.emitTimezone);
      t("update:model-timezone-value", nt);
    }
  }, ye = (B) => Array.isArray(n.value) ? o.value.enabled ? n.value.map((ue) => B(ue)) : [
    B(n.value[0]),
    n.value[1] ? B(n.value[1]) : ma(r.value.partialRange)
  ] : B(xi(n.value)), ae = () => {
    if (Array.isArray(n.value)) {
      const B = Bs(n.value[0], e.weekStart), ue = n.value[1] ? Bs(n.value[1], e.weekStart) : [];
      return [B.map((Pe) => Oe(Pe)), ue.map((Pe) => Oe(Pe))];
    }
    return Bs(n.value, e.weekStart).map((B) => Oe(B));
  }, ce = (B, ue) => $(xi(ye(B)), !1, ue), te = (B) => {
    const ue = ae();
    return B ? ue : t("update:model-value", ae());
  }, le = (B = !1) => (B || W(), e.monthPicker ? ce(g, B) : e.timePicker ? ce(h, B) : e.yearPicker ? ce(lt, B) : e.weekPicker ? te(B) : $(V(B), !0, B));
  return {
    inputValue: u,
    internalModelValue: n,
    checkBeforeEmit: () => n.value ? r.value.enabled ? r.value.partialRange ? n.value.length >= 1 : n.value.length === 2 : !!n.value : !1,
    parseExternalModelValue: O,
    formatInputValue: W,
    emitModelValue: le
  };
}, N7 = (t, e) => {
  const { defaultedFilters: i, propDates: n } = ei(t), { validateMonthYearInRange: s } = xr(t), r = (d, c) => {
    let A = d;
    return i.value.months.includes(vt(A)) ? (A = c ? $n(d, 1) : Ka(d, 1), r(A, c)) : A;
  }, a = (d, c) => {
    let A = d;
    return i.value.years.includes(lt(A)) ? (A = c ? up(d, 1) : mp(d, 1), a(A, c)) : A;
  }, o = (d, c = !1) => {
    const A = Lt(Oe(), { month: t.month, year: t.year });
    let m = d ? $n(A, 1) : Ka(A, 1);
    t.disableYearSelect && (m = gs(m, t.year));
    let p = vt(m), h = lt(m);
    i.value.months.includes(p) && (m = r(m, d), p = vt(m), h = lt(m)), i.value.years.includes(h) && (m = a(m, d), h = lt(m)), s(p, h, d, t.preventMinMaxNavigation) && l(p, h, c);
  }, l = (d, c, A) => {
    e("update-month-year", { month: d, year: c, fromNav: A });
  }, u = J(() => (d) => Py(
    Lt(Oe(), { month: t.month, year: t.year }),
    n.value.maxDate,
    n.value.minDate,
    t.preventMinMaxNavigation,
    d
  ));
  return { handleMonthYearChange: o, isDisabled: u, updateMonthYear: l };
}, Hd = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: [Boolean, String], default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  alwaysClearable: { type: Boolean, default: !1 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, as = {
  ...Hd,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 },
  isMobile: { type: Boolean, default: void 0 }
}, R7 = ["title"], F7 = ["disabled"], z7 = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...as
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(t, { emit: e }) {
    const i = e, n = t, {
      defaultedActionRow: s,
      defaultedPreviewFormat: r,
      defaultedMultiCalendars: a,
      defaultedTextInput: o,
      defaultedInline: l,
      defaultedRange: u,
      defaultedMultiDates: d
    } = ei(n), { isTimeValid: c, isMonthValid: A } = xr(n), { buildMatrix: m } = Tr(), p = pe(null), h = pe(null), g = pe(!1), w = pe({}), b = pe(null), y = pe(null);
    It(() => {
      n.arrowNavigation && m([bi(p), bi(h)], "actionRow"), D(), window.addEventListener("resize", D);
    }), Nn(() => {
      window.removeEventListener("resize", D);
    });
    const D = () => {
      g.value = !1, setTimeout(() => {
        var O, X;
        const q = (O = b.value) == null ? void 0 : O.getBoundingClientRect(), F = (X = y.value) == null ? void 0 : X.getBoundingClientRect();
        q && F && (w.value.maxWidth = `${F.width - q.width - 20}px`), g.value = !0;
      }, 0);
    }, I = J(() => u.value.enabled && !u.value.partialRange && n.internalModelValue ? n.internalModelValue.length === 2 : !0), M = J(
      () => !c.value(n.internalModelValue) || !A.value(n.internalModelValue) || !I.value
    ), _ = () => {
      const O = r.value;
      return n.timePicker || n.monthPicker, O(xi(n.internalModelValue));
    }, N = () => {
      const O = n.internalModelValue;
      return a.value.count > 0 ? `${x(O[0])} - ${x(O[1])}` : [x(O[0]), x(O[1])];
    }, x = (O) => Iy(
      O,
      r.value,
      n.formatLocale,
      o.value.rangeSeparator,
      n.modelAuto,
      r.value
    ), C = J(() => !n.internalModelValue || !n.menuMount ? "" : typeof r.value == "string" ? Array.isArray(n.internalModelValue) ? n.internalModelValue.length === 2 && n.internalModelValue[1] ? N() : d.value.enabled ? n.internalModelValue.map((O) => `${x(O)}`) : n.modelAuto ? `${x(n.internalModelValue[0])}` : `${x(n.internalModelValue[0])} -` : x(n.internalModelValue) : _()), L = () => d.value.enabled ? "; " : " - ", V = J(
      () => Array.isArray(C.value) ? C.value.join(L()) : C.value
    ), H = () => {
      c.value(n.internalModelValue) && A.value(n.internalModelValue) && I.value ? i("select-date") : i("invalid-select");
    };
    return (O, X) => (k(), U("div", {
      ref_key: "actionRowRef",
      ref: y,
      class: "dp__action_row"
    }, [
      O.$slots["action-row"] ? Se(O.$slots, "action-row", _i(Ut({ key: 0 }, {
        internalModelValue: O.internalModelValue,
        disabled: M.value,
        selectDate: () => O.$emit("select-date"),
        closePicker: () => O.$emit("close-picker")
      }))) : (k(), U(Xe, { key: 1 }, [
        Y(s).showPreview ? (k(), U("div", {
          key: 0,
          class: "dp__selection_preview",
          title: V.value,
          style: Nt(w.value)
        }, [
          O.$slots["action-preview"] && g.value ? Se(O.$slots, "action-preview", {
            key: 0,
            value: O.internalModelValue
          }) : ie("", !0),
          !O.$slots["action-preview"] && g.value ? (k(), U(Xe, { key: 1 }, [
            Wi(_e(V.value), 1)
          ], 64)) : ie("", !0)
        ], 12, R7)) : ie("", !0),
        re("div", {
          ref_key: "actionBtnContainer",
          ref: b,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          O.$slots["action-buttons"] ? Se(O.$slots, "action-buttons", {
            key: 0,
            value: O.internalModelValue
          }) : ie("", !0),
          O.$slots["action-buttons"] ? ie("", !0) : (k(), U(Xe, { key: 1 }, [
            !Y(l).enabled && Y(s).showCancel ? (k(), U("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: p,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: X[0] || (X[0] = (q) => O.$emit("close-picker")),
              onKeydown: X[1] || (X[1] = (q) => Y(tn)(q, () => O.$emit("close-picker")))
            }, _e(O.cancelText), 545)) : ie("", !0),
            Y(s).showNow ? (k(), U("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: X[2] || (X[2] = (q) => O.$emit("select-now")),
              onKeydown: X[3] || (X[3] = (q) => Y(tn)(q, () => O.$emit("select-now")))
            }, _e(O.nowButtonLabel), 33)) : ie("", !0),
            Y(s).showSelect ? (k(), U("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: h,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: M.value,
              "data-test-id": "select-button",
              onKeydown: X[4] || (X[4] = (q) => Y(tn)(q, () => H())),
              onClick: H
            }, _e(O.selectText), 41, F7)) : ie("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), U7 = ["role", "aria-label", "tabindex"], V7 = { class: "dp__selection_grid_header" }, q7 = ["aria-selected", "aria-disabled", "data-test-id", "onClick", "onKeydown", "onMouseover"], H7 = ["aria-label"], Ul = /* @__PURE__ */ qe({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(t, { expose: e, emit: i }) {
    const { setSelectionGrid: n, buildMultiLevelMatrix: s, setMonthPicker: r } = Tr(), a = i, o = t, { defaultedAriaLabels: l, defaultedTextInput: u, defaultedConfig: d, handleEventPropagation: c } = ei(
      o
    ), { hideNavigationButtons: A } = Xd(), m = pe(!1), p = pe(null), h = pe(null), g = pe([]), w = pe(), b = pe(null), y = pe(0), D = pe(null);
    B2(() => {
      p.value = null;
    }), It(() => {
      li().then(() => V()), o.noOverlayFocus || M(), I(!0);
    }), Nn(() => I(!1));
    const I = (ae) => {
      var ce;
      o.arrowNavigation && ((ce = o.headerRefs) != null && ce.length ? r(ae) : n(ae));
    }, M = () => {
      var ae;
      const ce = bi(h);
      ce && (u.value.enabled || (p.value ? (ae = p.value) == null || ae.focus({ preventScroll: !0 }) : ce.focus({ preventScroll: !0 })), m.value = ce.clientHeight < ce.scrollHeight);
    }, _ = J(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !o.useRelative,
        "dp--overlay-relative": o.useRelative
      })
    ), N = J(
      () => o.useRelative ? { height: `${o.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), x = J(() => ({
      dp__overlay_col: !0
    })), C = J(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: m.value,
        dp__button_bottom: o.isLast
      })
    ), L = J(() => {
      var ae, ce;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((ae = o.items) == null ? void 0 : ae.length) <= 6,
        dp__container_block: ((ce = o.items) == null ? void 0 : ce.length) > 6
      };
    });
    mt(
      () => o.items,
      () => V(!1),
      { deep: !0 }
    );
    const V = (ae = !0) => {
      li().then(() => {
        const ce = bi(p), te = bi(h), le = bi(b), B = bi(D), ue = le ? le.getBoundingClientRect().height : 0;
        te && (te.getBoundingClientRect().height ? y.value = te.getBoundingClientRect().height - ue : y.value = d.value.modeHeight - ue), ce && B && ae && (B.scrollTop = ce.offsetTop - B.offsetTop - (y.value / 2 - ce.getBoundingClientRect().height) - ue);
      });
    }, H = (ae) => {
      ae.disabled || a("selected", ae.value);
    }, O = () => {
      a("toggle"), a("reset-flow");
    }, X = (ae) => {
      o.escClose && (O(), c(ae));
    }, q = (ae, ce, te, le) => {
      ae && ((ce.active || ce.value === o.focusValue) && (p.value = ae), o.arrowNavigation && (Array.isArray(g.value[te]) ? g.value[te][le] = ae : g.value[te] = [ae], F()));
    }, F = () => {
      var ae, ce;
      const te = (ae = o.headerRefs) != null && ae.length ? [o.headerRefs].concat(g.value) : g.value.concat([o.skipButtonRef ? [] : [b.value]]);
      s(xi(te), (ce = o.headerRefs) != null && ce.length ? "monthPicker" : "selectionGrid");
    }, W = (ae) => {
      o.arrowNavigation || hr(ae, d.value, !0);
    }, j = (ae) => {
      w.value = ae, a("hover-value", ae);
    }, oe = () => {
      if (O(), !o.isLast) {
        const ae = hh(o.menuWrapRef ?? null, "action-row");
        if (ae) {
          const ce = Ty(ae);
          ce == null || ce.focus();
        }
      }
    }, $ = (ae) => {
      switch (ae.key) {
        case Xt.esc:
          return X(ae);
        case Xt.arrowLeft:
          return W(ae);
        case Xt.arrowRight:
          return W(ae);
        case Xt.arrowUp:
          return W(ae);
        case Xt.arrowDown:
          return W(ae);
        default:
          return;
      }
    }, ye = (ae) => {
      if (ae.key === Xt.enter) return O();
      if (ae.key === Xt.tab) return oe();
    };
    return e({ focusGrid: M }), (ae, ce) => {
      var te;
      return k(), U("div", {
        ref_key: "gridWrapRef",
        ref: h,
        class: we(_.value),
        style: Nt(N.value),
        role: ae.useRelative ? void 0 : "dialog",
        "aria-label": ae.overlayLabel,
        tabindex: ae.useRelative ? void 0 : "0",
        onKeydown: $,
        onClick: ce[0] || (ce[0] = $t(() => {
        }, ["prevent"]))
      }, [
        re("div", {
          ref_key: "containerRef",
          ref: D,
          class: we(L.value),
          style: Nt({ "--dp-overlay-height": `${y.value}px` }),
          role: "grid"
        }, [
          re("div", V7, [
            Se(ae.$slots, "header")
          ]),
          ae.$slots.overlay ? Se(ae.$slots, "overlay", { key: 0 }) : (k(!0), U(Xe, { key: 1 }, ut(ae.items, (le, B) => (k(), U("div", {
            key: B,
            class: we(["dp__overlay_row", { dp__flex_row: ae.items.length >= 3 }]),
            role: "row"
          }, [
            (k(!0), U(Xe, null, ut(le, (ue, Pe) => (k(), U("div", {
              key: ue.value,
              ref_for: !0,
              ref: (nt) => q(nt, ue, B, Pe),
              role: "gridcell",
              class: we(x.value),
              "aria-selected": ue.active || void 0,
              "aria-disabled": ue.disabled || void 0,
              tabindex: "0",
              "data-test-id": ue.text,
              onClick: $t((nt) => H(ue), ["prevent"]),
              onKeydown: (nt) => Y(tn)(nt, () => H(ue), !0),
              onMouseover: (nt) => j(ue.value)
            }, [
              re("div", {
                class: we(ue.className)
              }, [
                ae.$slots.item ? Se(ae.$slots, "item", {
                  key: 0,
                  item: ue
                }) : ie("", !0),
                ae.$slots.item ? ie("", !0) : (k(), U(Xe, { key: 1 }, [
                  Wi(_e(ue.text), 1)
                ], 64))
              ], 2)
            ], 42, q7))), 128))
          ], 2))), 128))
        ], 6),
        ae.$slots["button-icon"] ? Ci((k(), U("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: b,
          type: "button",
          "aria-label": (te = Y(l)) == null ? void 0 : te.toggleOverlay,
          class: we(C.value),
          tabindex: "0",
          onClick: O,
          onKeydown: ye
        }, [
          Se(ae.$slots, "button-icon")
        ], 42, H7)), [
          [al, !Y(A)(ae.hideNavigation, ae.type)]
        ]) : ie("", !0)
      ], 46, U7);
    };
  }
}), W7 = ["data-dp-mobile"], Wd = /* @__PURE__ */ qe({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean },
    isMobile: { type: Boolean }
  },
  setup(t) {
    const e = t, i = J(
      () => e.multiCalendars > 0 ? [...Array(e.multiCalendars).keys()] : [0]
    ), n = J(() => ({
      dp__instance_calendar: e.multiCalendars > 0
    }));
    return (s, r) => (k(), U("div", {
      class: we({
        dp__menu_inner: !s.stretch,
        "dp--menu--inner-stretched": s.stretch,
        dp__flex_display: s.multiCalendars > 0,
        "dp--flex-display-collapsed": s.collapse
      }),
      "data-dp-mobile": s.isMobile
    }, [
      (k(!0), U(Xe, null, ut(i.value, (a, o) => (k(), U("div", {
        key: a,
        class: we(n.value)
      }, [
        Se(s.$slots, "default", {
          instance: a,
          index: o
        })
      ], 2))), 128))
    ], 10, W7));
  }
}), Y7 = ["data-dp-element", "aria-label", "aria-disabled"], pl = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(t, { emit: e }) {
    const i = e, n = pe(null);
    return It(() => i("set-ref", n)), (s, r) => (k(), U("button", {
      ref_key: "elRef",
      ref: n,
      type: "button",
      "data-dp-element": s.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": s.ariaLabel,
      "aria-disabled": s.disabled || void 0,
      onClick: r[0] || (r[0] = (a) => s.$emit("activate")),
      onKeydown: r[1] || (r[1] = (a) => Y(tn)(a, () => s.$emit("activate"), !0))
    }, [
      re("span", {
        class: we(["dp__inner_nav", { dp__inner_nav_disabled: s.disabled }])
      }, [
        Se(s.$slots, "default")
      ], 2)
    ], 40, Y7));
  }
}), X7 = ["aria-label", "data-test-id"], By = /* @__PURE__ */ qe({
  __name: "YearModePicker",
  props: {
    ...as,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(t, { emit: e }) {
    const i = e, n = t, { showRightIcon: s, showLeftIcon: r } = Xd(), { defaultedConfig: a, defaultedMultiCalendars: o, defaultedAriaLabels: l, defaultedTransitions: u, defaultedUI: d } = ei(n), { showTransition: c, transitionName: A } = Vl(u), m = pe(!1), p = (w = !1, b) => {
      m.value = !m.value, i("toggle-year-picker", { flow: w, show: b });
    }, h = (w) => {
      m.value = !1, i("year-select", w);
    }, g = (w = !1) => {
      i("handle-year", w);
    };
    return (w, b) => {
      var y, D, I, M, _;
      return k(), U(Xe, null, [
        re("div", {
          class: we(["dp--year-mode-picker", { "dp--hidden-el": m.value }])
        }, [
          Y(r)(Y(o), t.instance) ? (k(), Ce(pl, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (y = Y(l)) == null ? void 0 : y.prevYear,
            disabled: t.isDisabled(!1),
            class: we((D = Y(d)) == null ? void 0 : D.navBtnPrev),
            onActivate: b[0] || (b[0] = (N) => g(!1))
          }, {
            default: De(() => [
              w.$slots["arrow-left"] ? Se(w.$slots, "arrow-left", { key: 0 }) : ie("", !0),
              w.$slots["arrow-left"] ? ie("", !0) : (k(), Ce(Y(Tp), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : ie("", !0),
          re("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${t.year}-${(I = Y(l)) == null ? void 0 : I.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${t.instance}`,
            onClick: b[1] || (b[1] = () => p(!1)),
            onKeydown: b[2] || (b[2] = Yu(() => p(!1), ["enter"]))
          }, [
            w.$slots.year ? Se(w.$slots, "year", {
              key: 0,
              year: t.year
            }) : ie("", !0),
            w.$slots.year ? ie("", !0) : (k(), U(Xe, { key: 1 }, [
              Wi(_e(t.year), 1)
            ], 64))
          ], 40, X7),
          Y(s)(Y(o), t.instance) ? (k(), Ce(pl, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (M = Y(l)) == null ? void 0 : M.nextYear,
            disabled: t.isDisabled(!0),
            class: we((_ = Y(d)) == null ? void 0 : _.navBtnNext),
            onActivate: b[3] || (b[3] = (N) => g(!0))
          }, {
            default: De(() => [
              w.$slots["arrow-right"] ? Se(w.$slots, "arrow-right", { key: 0 }) : ie("", !0),
              w.$slots["arrow-right"] ? ie("", !0) : (k(), Ce(Y(xp), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : ie("", !0)
        ], 2),
        ke(Ri, {
          name: Y(A)(t.showYearPicker),
          css: Y(c)
        }, {
          default: De(() => {
            var N, x;
            return [
              t.showYearPicker ? (k(), Ce(Ul, {
                key: 0,
                items: t.items,
                "text-input": w.textInput,
                "esc-close": w.escClose,
                config: w.config,
                "is-last": w.autoApply && !Y(a).keepActionRow,
                "hide-navigation": w.hideNavigation,
                "aria-labels": w.ariaLabels,
                "overlay-label": (x = (N = Y(l)) == null ? void 0 : N.yearPicker) == null ? void 0 : x.call(N, !0),
                type: "year",
                onToggle: p,
                onSelected: b[4] || (b[4] = (C) => h(C))
              }, wi({
                "button-icon": De(() => [
                  w.$slots["calendar-icon"] ? Se(w.$slots, "calendar-icon", { key: 0 }) : ie("", !0),
                  w.$slots["calendar-icon"] ? ie("", !0) : (k(), Ce(Y(go), { key: 1 }))
                ]),
                _: 2
              }, [
                w.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: De(({ item: C }) => [
                    Se(w.$slots, "year-overlay-value", {
                      text: C.text,
                      value: C.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : ie("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), Mp = (t, e, i) => {
  if (e.value && Array.isArray(e.value))
    if (e.value.some((n) => yt(t, n))) {
      const n = e.value.filter((s) => !yt(s, t));
      e.value = n.length ? n : null;
    } else (i && +i > e.value.length || !i) && e.value.push(t);
  else
    e.value = [t];
}, Op = (t, e, i) => {
  let n = t.value ? t.value.slice() : [];
  return n.length === 2 && n[1] !== null && (n = []), n.length ? (ai(e, n[0]) ? n.unshift(e) : n[1] = e, i("range-end", e)) : (n = [e], i("range-start", e)), n;
}, Yd = (t, e, i, n) => {
  t && (t[0] && t[1] && i && e("auto-apply"), t[0] && !t[1] && n && i && e("auto-apply"));
}, Ly = (t) => {
  Array.isArray(t.value) && t.value.length <= 2 && t.range ? t.modelValue.value = t.value.map((e) => un(Oe(e), t.timezone)) : Array.isArray(t.value) || (t.modelValue.value = un(Oe(t.value), t.timezone));
}, Ny = (t, e, i, n) => Array.isArray(e.value) && (e.value.length === 2 || e.value.length === 1 && n.value.partialRange) ? n.value.fixedStart && (hi(t, e.value[0]) || yt(t, e.value[0])) ? [e.value[0], t] : n.value.fixedEnd && (ai(t, e.value[1]) || yt(t, e.value[1])) ? [t, e.value[1]] : (i("invalid-fixed-range", t), e.value) : [], Ry = ({
  multiCalendars: t,
  range: e,
  highlight: i,
  propDates: n,
  calendars: s,
  modelValue: r,
  props: a,
  filters: o,
  year: l,
  month: u,
  emit: d
}) => {
  const c = J(() => _p(a.yearRange, a.locale, a.reverseYears)), A = pe([!1]), m = J(() => (C, L) => {
    const V = Lt(Jn(/* @__PURE__ */ new Date()), {
      month: u.value(C),
      year: l.value(C)
    }), H = L ? q0(V) : Sl(V);
    return Py(
      H,
      n.value.maxDate,
      n.value.minDate,
      a.preventMinMaxNavigation,
      L
    );
  }), p = () => Array.isArray(r.value) && t.value.solo && r.value[1], h = () => {
    for (let C = 0; C < t.value.count; C++)
      if (C === 0)
        s.value[C] = s.value[0];
      else if (C === t.value.count - 1 && p())
        s.value[C] = {
          month: vt(r.value[1]),
          year: lt(r.value[1])
        };
      else {
        const L = Lt(Oe(), s.value[C - 1]);
        s.value[C] = { month: vt(L), year: lt(up(L, 1)) };
      }
  }, g = (C) => {
    if (!C) return h();
    const L = Lt(Oe(), s.value[C]);
    return s.value[0].year = lt(mp(L, t.value.count - 1)), h();
  }, w = (C, L) => {
    const V = UI(L, C);
    return e.value.showLastInRange && V > 1 ? L : C;
  }, b = (C) => a.focusStartDate || t.value.solo ? C[0] : C[1] ? w(C[0], C[1]) : C[0], y = () => {
    if (r.value) {
      const C = Array.isArray(r.value) ? b(r.value) : r.value;
      s.value[0] = { month: vt(C), year: lt(C) };
    }
  }, D = () => {
    y(), t.value.count && h();
  };
  mt(r, (C, L) => {
    a.isTextInputDate && JSON.stringify(C ?? {}) !== JSON.stringify(L ?? {}) && D();
  }), It(() => {
    D();
  });
  const I = (C, L) => {
    s.value[L].year = C, d("update-month-year", { instance: L, year: C, month: s.value[L].month }), t.value.count && !t.value.solo && g(L);
  }, M = J(() => (C) => $a(c.value, (L) => {
    var V;
    const H = l.value(C) === L.value, O = Cl(
      L.value,
      eo(n.value.minDate),
      eo(n.value.maxDate)
    ) || ((V = o.value.years) == null ? void 0 : V.includes(l.value(C))), X = Ip(i.value, L.value);
    return { active: H, disabled: O, highlighted: X };
  })), _ = (C, L) => {
    I(C, L), x(L);
  }, N = (C, L = !1) => {
    if (!m.value(C, L)) {
      const V = L ? l.value(C) + 1 : l.value(C) - 1;
      I(V, C);
    }
  }, x = (C, L = !1, V) => {
    L || d("reset-flow"), V !== void 0 ? A.value[C] = V : A.value[C] = !A.value[C], A.value[C] ? d("overlay-toggle", { open: !0, overlay: Ui.year }) : (d("overlay-closed"), d("overlay-toggle", { open: !1, overlay: Ui.year }));
  };
  return {
    isDisabled: m,
    groupedYears: M,
    showYearPicker: A,
    selectYear: I,
    toggleYearPicker: x,
    handleYearSelect: _,
    handleYear: N
  };
}, j7 = (t, e) => {
  const {
    defaultedMultiCalendars: i,
    defaultedAriaLabels: n,
    defaultedTransitions: s,
    defaultedConfig: r,
    defaultedRange: a,
    defaultedHighlight: o,
    propDates: l,
    defaultedTz: u,
    defaultedFilters: d,
    defaultedMultiDates: c
  } = ei(t), A = () => {
    t.isTextInputDate && D(lt(Oe(t.startDate)), 0);
  }, { modelValue: m, year: p, month: h, calendars: g } = ql(t, e, A), w = J(() => by(t.formatLocale, t.locale, t.monthNameFormat)), b = pe(null), { checkMinMaxRange: y } = xr(t), {
    selectYear: D,
    groupedYears: I,
    showYearPicker: M,
    toggleYearPicker: _,
    handleYearSelect: N,
    handleYear: x,
    isDisabled: C
  } = Ry({
    modelValue: m,
    multiCalendars: i,
    range: a,
    highlight: o,
    calendars: g,
    year: p,
    propDates: l,
    month: h,
    filters: d,
    props: t,
    emit: e
  });
  It(() => {
    t.startDate && (m.value && t.focusStartDate || !m.value) && D(lt(Oe(t.startDate)), 0);
  });
  const L = (ce) => ce ? { month: vt(ce), year: lt(ce) } : { month: null, year: null }, V = () => m.value ? Array.isArray(m.value) ? m.value.map((ce) => L(ce)) : L(m.value) : L(), H = (ce, te) => {
    const le = g.value[ce], B = V();
    return Array.isArray(B) ? B.some((ue) => ue.year === (le == null ? void 0 : le.year) && ue.month === te) : (le == null ? void 0 : le.year) === B.year && te === B.month;
  }, O = (ce, te, le) => {
    var B, ue;
    const Pe = V();
    return Array.isArray(Pe) ? p.value(te) === ((B = Pe[le]) == null ? void 0 : B.year) && ce === ((ue = Pe[le]) == null ? void 0 : ue.month) : !1;
  }, X = (ce, te) => {
    if (a.value.enabled) {
      const le = V();
      if (Array.isArray(m.value) && Array.isArray(le)) {
        const B = O(ce, te, 0) || O(ce, te, 1), ue = Fs(Jn(Oe()), ce, p.value(te));
        return El(m.value, b.value, ue) && !B;
      }
      return !1;
    }
    return !1;
  }, q = J(() => (ce) => $a(w.value, (te) => {
    var le;
    const B = H(ce, te.value), ue = Cl(
      te.value,
      Ey(p.value(ce), l.value.minDate),
      Dy(p.value(ce), l.value.maxDate)
    ) || A7(l.value.disabledDates, p.value(ce), te.value) || ((le = d.value.months) == null ? void 0 : le.includes(te.value)) || !g7(l.value.allowedDates, p.value(ce), te.value), Pe = X(te.value, ce), nt = My(o.value, te.value, p.value(ce));
    return { active: B, disabled: ue, isBetween: Pe, highlighted: nt };
  })), F = (ce, te) => Fs(Jn(Oe()), ce, p.value(te)), W = (ce, te) => {
    const le = m.value ? m.value : Jn(/* @__PURE__ */ new Date());
    m.value = Fs(le, ce, p.value(te)), e("auto-apply"), e("update-flow-step");
  }, j = (ce, te) => {
    const le = F(ce, te);
    a.value.fixedEnd || a.value.fixedStart ? m.value = Ny(le, m, e, a) : m.value ? y(le, m.value) && (m.value = Op(m, F(ce, te), e)) : m.value = [F(ce, te)], li().then(() => {
      Yd(m.value, e, t.autoApply, t.modelAuto);
    });
  }, oe = (ce, te) => {
    Mp(F(ce, te), m, c.value.limit), e("auto-apply", !0);
  }, $ = (ce, te) => (g.value[te].month = ce, ae(te, g.value[te].year, ce), c.value.enabled ? oe(ce, te) : a.value.enabled ? j(ce, te) : W(ce, te)), ye = (ce, te) => {
    D(ce, te), ae(te, ce, null);
  }, ae = (ce, te, le) => {
    let B = le;
    if (!B && B !== 0) {
      const ue = V();
      B = Array.isArray(ue) ? ue[ce].month : ue.month;
    }
    e("update-month-year", { instance: ce, year: te, month: B });
  };
  return {
    groupedMonths: q,
    groupedYears: I,
    year: p,
    isDisabled: C,
    defaultedMultiCalendars: i,
    defaultedAriaLabels: n,
    defaultedTransitions: s,
    defaultedConfig: r,
    showYearPicker: M,
    modelValue: m,
    presetDate: (ce, te) => {
      Ly({
        value: ce,
        modelValue: m,
        range: a.value.enabled,
        timezone: te ? void 0 : u.value.timezone
      }), e("auto-apply");
    },
    setHoverDate: (ce, te) => {
      b.value = F(ce, te);
    },
    selectMonth: $,
    selectYear: ye,
    toggleYearPicker: _,
    handleYearSelect: N,
    handleYear: x,
    getModelMonthYear: V
  };
}, G7 = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...as
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = Yi(), r = yn(s, "yearMode"), a = t;
    It(() => {
      a.shadow || n("mount", null);
    });
    const {
      groupedMonths: o,
      groupedYears: l,
      year: u,
      isDisabled: d,
      defaultedMultiCalendars: c,
      defaultedConfig: A,
      showYearPicker: m,
      modelValue: p,
      presetDate: h,
      setHoverDate: g,
      selectMonth: w,
      selectYear: b,
      toggleYearPicker: y,
      handleYearSelect: D,
      handleYear: I,
      getModelMonthYear: M
    } = j7(a, n);
    return e({ getSidebarProps: () => ({
      modelValue: p,
      year: u,
      getModelMonthYear: M,
      selectMonth: w,
      selectYear: b,
      handleYear: I
    }), presetDate: h, toggleYearPicker: (_) => y(0, _) }), (_, N) => (k(), Ce(Wd, {
      "multi-calendars": Y(c).count,
      collapse: _.collapse,
      stretch: "",
      "is-mobile": _.isMobile
    }, {
      default: De(({ instance: x }) => [
        _.$slots["top-extra"] ? Se(_.$slots, "top-extra", {
          key: 0,
          value: _.internalModelValue
        }) : ie("", !0),
        _.$slots["month-year"] ? Se(_.$slots, "month-year", _i(Ut({ key: 1 }, {
          year: Y(u),
          months: Y(o)(x),
          years: Y(l)(x),
          selectMonth: Y(w),
          selectYear: Y(b),
          instance: x
        }))) : (k(), Ce(Ul, {
          key: 2,
          items: Y(o)(x),
          "arrow-navigation": _.arrowNavigation,
          "is-last": _.autoApply && !Y(A).keepActionRow,
          "esc-close": _.escClose,
          height: Y(A).modeHeight,
          config: _.config,
          "no-overlay-focus": !!(_.noOverlayFocus || _.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (C) => Y(w)(C, x),
          onHoverValue: (C) => Y(g)(C, x)
        }, wi({
          header: De(() => [
            ke(By, Ut(_.$props, {
              items: Y(l)(x),
              instance: x,
              "show-year-picker": Y(m)[x],
              year: Y(u)(x),
              "is-disabled": (C) => Y(d)(x, C),
              onHandleYear: (C) => Y(I)(x, C),
              onYearSelect: (C) => Y(D)(C, x),
              onToggleYearPicker: (C) => Y(y)(x, C == null ? void 0 : C.flow, C == null ? void 0 : C.show)
            }), wi({ _: 2 }, [
              ut(Y(r), (C, L) => ({
                name: C,
                fn: De((V) => [
                  Se(_.$slots, C, _i(ln(V)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          _.$slots["month-overlay-value"] ? {
            name: "item",
            fn: De(({ item: C }) => [
              Se(_.$slots, "month-overlay-value", {
                text: C.text,
                value: C.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), Q7 = (t, e) => {
  const i = () => {
    t.isTextInputDate && (d.value = lt(Oe(t.startDate)));
  }, { modelValue: n } = ql(t, e, i), s = pe(null), { defaultedHighlight: r, defaultedMultiDates: a, defaultedFilters: o, defaultedRange: l, propDates: u } = ei(t), d = pe();
  It(() => {
    t.startDate && (n.value && t.focusStartDate || !n.value) && (d.value = lt(Oe(t.startDate)));
  });
  const c = (w) => Array.isArray(n.value) ? n.value.some((b) => lt(b) === w) : n.value ? lt(n.value) === w : !1, A = (w) => l.value.enabled && Array.isArray(n.value) ? El(n.value, s.value, g(w)) : !1, m = (w) => u.value.allowedDates instanceof Map ? u.value.allowedDates.size ? u.value.allowedDates.has(`${w}`) : !1 : !0, p = (w) => u.value.disabledDates instanceof Map ? u.value.disabledDates.size ? u.value.disabledDates.has(`${w}`) : !1 : !0, h = J(() => $a(_p(t.yearRange, t.locale, t.reverseYears), (w) => {
    const b = c(w.value), y = Cl(
      w.value,
      eo(u.value.minDate),
      eo(u.value.maxDate)
    ) || o.value.years.includes(w.value) || !m(w.value) || p(w.value), D = A(w.value) && !b, I = Ip(r.value, w.value);
    return { active: b, disabled: y, isBetween: D, highlighted: I };
  })), g = (w) => gs(Jn(Sl(/* @__PURE__ */ new Date())), w);
  return {
    groupedYears: h,
    modelValue: n,
    focusYear: d,
    setHoverValue: (w) => {
      s.value = gs(Jn(/* @__PURE__ */ new Date()), w);
    },
    selectYear: (w) => {
      var b;
      if (e("update-month-year", { instance: 0, year: w }), a.value.enabled)
        return n.value ? Array.isArray(n.value) && (((b = n.value) == null ? void 0 : b.map((y) => lt(y))).includes(w) ? n.value = n.value.filter((y) => lt(y) !== w) : n.value.push(gs(Ii(Oe()), w))) : n.value = [gs(Ii(Sl(Oe())), w)], e("auto-apply", !0);
      l.value.enabled ? (n.value = Op(n, g(w), e), li().then(() => {
        Yd(n.value, e, t.autoApply, t.modelAuto);
      })) : (n.value = g(w), e("auto-apply"));
    }
  };
}, Z7 = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...as
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, { groupedYears: r, modelValue: a, focusYear: o, selectYear: l, setHoverValue: u } = Q7(s, n), { defaultedConfig: d } = ei(s);
    return e({ getSidebarProps: () => ({
      modelValue: a,
      selectYear: l
    }) }), (c, A) => (k(), U("div", null, [
      c.$slots["top-extra"] ? Se(c.$slots, "top-extra", {
        key: 0,
        value: c.internalModelValue
      }) : ie("", !0),
      c.$slots["month-year"] ? Se(c.$slots, "month-year", _i(Ut({ key: 1 }, {
        years: Y(r),
        selectYear: Y(l)
      }))) : (k(), Ce(Ul, {
        key: 2,
        items: Y(r),
        "is-last": c.autoApply && !Y(d).keepActionRow,
        height: Y(d).modeHeight,
        config: c.config,
        "no-overlay-focus": !!(c.noOverlayFocus || c.textInput),
        "focus-value": Y(o),
        type: "year",
        "use-relative": "",
        onSelected: Y(l),
        onHoverValue: Y(u)
      }, wi({ _: 2 }, [
        c.$slots["year-overlay-value"] ? {
          name: "item",
          fn: De(({ item: m }) => [
            Se(c.$slots, "year-overlay-value", {
              text: m.text,
              value: m.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), K7 = {
  key: 0,
  class: "dp__time_input"
}, J7 = ["data-compact", "data-collapsed"], $7 = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], e4 = ["aria-label", "disabled", "data-test-id", "onKeydown", "onClick"], t4 = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], i4 = { key: 0 }, n4 = ["aria-label", "data-compact"], s4 = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...as
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, { setTimePickerElements: r, setTimePickerBackRef: a } = Tr(), {
      defaultedAriaLabels: o,
      defaultedTransitions: l,
      defaultedFilters: u,
      defaultedConfig: d,
      defaultedRange: c,
      defaultedMultiCalendars: A
    } = ei(s), { transitionName: m, showTransition: p } = Vl(l), h = Jr({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), g = pe("AM"), w = pe(null), b = pe([]), y = pe(), D = pe(!1);
    It(() => {
      n("mounted");
    });
    const I = (K) => Lt(/* @__PURE__ */ new Date(), {
      hours: K.hours,
      minutes: K.minutes,
      seconds: s.enableSeconds ? K.seconds : 0,
      milliseconds: 0
    }), M = J(
      () => (K) => j(K, s[K]) || N(K, s[K])
    ), _ = J(() => ({ hours: s.hours, minutes: s.minutes, seconds: s.seconds })), N = (K, Ie) => c.value.enabled && !c.value.disableTimeRangeValidation ? !s.validateTime(K, Ie) : !1, x = (K, Ie) => {
      if (c.value.enabled && !c.value.disableTimeRangeValidation) {
        const Be = Ie ? +s[`${K}Increment`] : -+s[`${K}Increment`], Me = s[K] + Be;
        return !s.validateTime(K, Me);
      }
      return !1;
    }, C = J(() => (K) => !ce(+s[K] + +s[`${K}Increment`], K) || x(K, !0)), L = J(() => (K) => !ce(+s[K] - +s[`${K}Increment`], K) || x(K, !1)), V = (K, Ie) => N0(Lt(Oe(), K), Ie), H = (K, Ie) => QO(Lt(Oe(), K), Ie), O = J(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !s.timePickerInline,
        dp__time_col_reg_block: !s.enableSeconds && s.is24 && !s.timePickerInline,
        dp__time_col_reg_inline: !s.enableSeconds && s.is24 && s.timePickerInline,
        dp__time_col_reg_with_button: !s.enableSeconds && !s.is24,
        dp__time_col_sec: s.enableSeconds && s.is24,
        dp__time_col_sec_with_button: s.enableSeconds && !s.is24
      })
    ), X = J(
      () => s.timePickerInline && c.value.enabled && !A.value.count
    ), q = J(() => {
      const K = [{ type: "hours" }];
      return s.enableMinutes && K.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), s.enableSeconds && K.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), K;
    }), F = J(() => q.value.filter((K) => !K.separator)), W = J(() => (K) => {
      if (K === "hours") {
        const Ie = nt(+s.hours);
        return { text: Ie < 10 ? `0${Ie}` : `${Ie}`, value: Ie };
      }
      return { text: s[K] < 10 ? `0${s[K]}` : `${s[K]}`, value: s[K] };
    }), j = (K, Ie) => {
      var Be;
      if (!s.disabledTimesConfig) return !1;
      const Me = s.disabledTimesConfig(s.order, K === "hours" ? Ie : void 0);
      return Me[K] ? !!((Be = Me[K]) != null && Be.includes(Ie)) : !0;
    }, oe = (K, Ie) => Ie !== "hours" || g.value === "AM" ? K : K + 12, $ = (K) => {
      const Ie = s.is24 ? 24 : 12, Be = K === "hours" ? Ie : 60, Me = +s[`${K}GridIncrement`], Ke = K === "hours" && !s.is24 ? Me : 0, He = [];
      for (let Ge = Ke; Ge < Be; Ge += Me)
        He.push({ value: s.is24 ? Ge : oe(Ge, K), text: Ge < 10 ? `0${Ge}` : `${Ge}` });
      return K === "hours" && !s.is24 && He.unshift({ value: g.value === "PM" ? 12 : 0, text: "12" }), $a(He, (Ge) => ({ active: !1, disabled: u.value.times[K].includes(Ge.value) || !ce(Ge.value, K) || j(K, Ge.value) || N(K, Ge.value) }));
    }, ye = (K) => K >= 0 ? K : 59, ae = (K) => K >= 0 ? K : 23, ce = (K, Ie) => {
      const Be = s.minTime ? I($c(s.minTime)) : null, Me = s.maxTime ? I($c(s.maxTime)) : null, Ke = I(
        $c(
          _.value,
          Ie,
          Ie === "minutes" || Ie === "seconds" ? ye(K) : ae(K)
        )
      );
      return Be && Me ? (Za(Ke, Me) || Ta(Ke, Me)) && (ea(Ke, Be) || Ta(Ke, Be)) : Be ? ea(Ke, Be) || Ta(Ke, Be) : Me ? Za(Ke, Me) || Ta(Ke, Me) : !0;
    }, te = (K) => s[`no${K[0].toUpperCase() + K.slice(1)}Overlay`], le = (K) => {
      te(K) || (h[K] = !h[K], h[K] ? (D.value = !0, n("overlay-opened", K)) : (D.value = !1, n("overlay-closed", K)));
    }, B = (K) => K === "hours" ? Hs : K === "minutes" ? gr : Qa, ue = () => {
      y.value && clearTimeout(y.value);
    }, Pe = (K, Ie = !0, Be) => {
      const Me = Ie ? V : H, Ke = Ie ? +s[`${K}Increment`] : -+s[`${K}Increment`];
      ce(+s[K] + Ke, K) && n(
        `update:${K}`,
        B(K)(Me({ [K]: +s[K] }, { [K]: +s[`${K}Increment`] }))
      ), !(Be != null && Be.keyboard) && d.value.timeArrowHoldThreshold && (y.value = setTimeout(() => {
        Pe(K, Ie);
      }, d.value.timeArrowHoldThreshold));
    }, nt = (K) => s.is24 ? K : (K >= 12 ? g.value = "PM" : g.value = "AM", n7(K)), ge = () => {
      g.value === "PM" ? (g.value = "AM", n("update:hours", s.hours - 12)) : (g.value = "PM", n("update:hours", s.hours + 12)), n("am-pm-change", g.value);
    }, Qe = (K) => {
      h[K] = !0;
    }, Ee = (K, Ie, Be) => {
      if (K && s.arrowNavigation) {
        Array.isArray(b.value[Ie]) ? b.value[Ie][Be] = K : b.value[Ie] = [K];
        const Me = b.value.reduce(
          (Ke, He) => He.map((Ge, ot) => [...Ke[ot] || [], He[ot]]),
          []
        );
        a(s.closeTimePickerBtn), w.value && (Me[1] = Me[1].concat(w.value)), r(Me, s.order);
      }
    }, xe = (K, Ie) => (le(K), n(`update:${K}`, Ie));
    return e({ openChildCmp: Qe }), (K, Ie) => {
      var Be;
      return K.disabled ? ie("", !0) : (k(), U("div", K7, [
        (k(!0), U(Xe, null, ut(q.value, (Me, Ke) => {
          var He, Ge, ot;
          return k(), U("div", {
            key: Ke,
            class: we(O.value),
            "data-compact": X.value && !K.enableSeconds,
            "data-collapsed": X.value && K.enableSeconds
          }, [
            Me.separator ? (k(), U(Xe, { key: 0 }, [
              D.value ? ie("", !0) : (k(), U(Xe, { key: 0 }, [
                Wi(":")
              ], 64))
            ], 64)) : (k(), U(Xe, { key: 1 }, [
              re("button", {
                ref_for: !0,
                ref: (he) => Ee(he, Ke, 0),
                type: "button",
                class: we({
                  dp__btn: !0,
                  dp__inc_dec_button: !K.timePickerInline,
                  dp__inc_dec_button_inline: K.timePickerInline,
                  dp__tp_inline_btn_top: K.timePickerInline,
                  dp__inc_dec_button_disabled: C.value(Me.type),
                  "dp--hidden-el": D.value
                }),
                "data-test-id": `${Me.type}-time-inc-btn-${s.order}`,
                "aria-label": (He = Y(o)) == null ? void 0 : He.incrementValue(Me.type),
                tabindex: "0",
                onKeydown: (he) => Y(tn)(he, () => Pe(Me.type, !0, { keyboard: !0 }), !0),
                onClick: (he) => Y(d).timeArrowHoldThreshold ? void 0 : Pe(Me.type, !0),
                onMousedown: (he) => Y(d).timeArrowHoldThreshold ? Pe(Me.type, !0) : void 0,
                onMouseup: ue
              }, [
                s.timePickerInline ? (k(), U(Xe, { key: 1 }, [
                  K.$slots["tp-inline-arrow-up"] ? Se(K.$slots, "tp-inline-arrow-up", { key: 0 }) : (k(), U(Xe, { key: 1 }, [
                    Ie[2] || (Ie[2] = re("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    Ie[3] || (Ie[3] = re("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (k(), U(Xe, { key: 0 }, [
                  K.$slots["arrow-up"] ? Se(K.$slots, "arrow-up", { key: 0 }) : ie("", !0),
                  K.$slots["arrow-up"] ? ie("", !0) : (k(), Ce(Y(Cp), { key: 1 }))
                ], 64))
              ], 42, $7),
              re("button", {
                ref_for: !0,
                ref: (he) => Ee(he, Ke, 1),
                type: "button",
                "aria-label": `${W.value(Me.type).text}-${(Ge = Y(o)) == null ? void 0 : Ge.openTpOverlay(Me.type)}`,
                class: we({
                  dp__time_display: !0,
                  dp__time_display_block: !K.timePickerInline,
                  dp__time_display_inline: K.timePickerInline,
                  "dp--time-invalid": M.value(Me.type),
                  "dp--time-overlay-btn": !M.value(Me.type),
                  "dp--hidden-el": D.value
                }),
                disabled: te(Me.type),
                tabindex: "0",
                "data-test-id": `${Me.type}-toggle-overlay-btn-${s.order}`,
                onKeydown: (he) => Y(tn)(he, () => le(Me.type), !0),
                onClick: (he) => le(Me.type)
              }, [
                K.$slots[Me.type] ? Se(K.$slots, Me.type, {
                  key: 0,
                  text: W.value(Me.type).text,
                  value: W.value(Me.type).value
                }) : ie("", !0),
                K.$slots[Me.type] ? ie("", !0) : (k(), U(Xe, { key: 1 }, [
                  Wi(_e(W.value(Me.type).text), 1)
                ], 64))
              ], 42, e4),
              re("button", {
                ref_for: !0,
                ref: (he) => Ee(he, Ke, 2),
                type: "button",
                class: we({
                  dp__btn: !0,
                  dp__inc_dec_button: !K.timePickerInline,
                  dp__inc_dec_button_inline: K.timePickerInline,
                  dp__tp_inline_btn_bottom: K.timePickerInline,
                  dp__inc_dec_button_disabled: L.value(Me.type),
                  "dp--hidden-el": D.value
                }),
                "data-test-id": `${Me.type}-time-dec-btn-${s.order}`,
                "aria-label": (ot = Y(o)) == null ? void 0 : ot.decrementValue(Me.type),
                tabindex: "0",
                onKeydown: (he) => Y(tn)(he, () => Pe(Me.type, !1, { keyboard: !0 }), !0),
                onClick: (he) => Y(d).timeArrowHoldThreshold ? void 0 : Pe(Me.type, !1),
                onMousedown: (he) => Y(d).timeArrowHoldThreshold ? Pe(Me.type, !1) : void 0,
                onMouseup: ue
              }, [
                s.timePickerInline ? (k(), U(Xe, { key: 1 }, [
                  K.$slots["tp-inline-arrow-down"] ? Se(K.$slots, "tp-inline-arrow-down", { key: 0 }) : (k(), U(Xe, { key: 1 }, [
                    Ie[4] || (Ie[4] = re("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    Ie[5] || (Ie[5] = re("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (k(), U(Xe, { key: 0 }, [
                  K.$slots["arrow-down"] ? Se(K.$slots, "arrow-down", { key: 0 }) : ie("", !0),
                  K.$slots["arrow-down"] ? ie("", !0) : (k(), Ce(Y(Ep), { key: 1 }))
                ], 64))
              ], 42, t4)
            ], 64))
          ], 10, J7);
        }), 128)),
        K.is24 ? ie("", !0) : (k(), U("div", i4, [
          K.$slots["am-pm-button"] ? Se(K.$slots, "am-pm-button", {
            key: 0,
            toggle: ge,
            value: g.value
          }) : ie("", !0),
          K.$slots["am-pm-button"] ? ie("", !0) : (k(), U("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: w,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (Be = Y(o)) == null ? void 0 : Be.amPmButton,
            tabindex: "0",
            "data-compact": X.value,
            onClick: ge,
            onKeydown: Ie[0] || (Ie[0] = (Me) => Y(tn)(Me, () => ge(), !0))
          }, _e(g.value), 41, n4))
        ])),
        (k(!0), U(Xe, null, ut(F.value, (Me, Ke) => (k(), Ce(Ri, {
          key: Ke,
          name: Y(m)(h[Me.type]),
          css: Y(p)
        }, {
          default: De(() => {
            var He, Ge;
            return [
              h[Me.type] ? (k(), Ce(Ul, {
                key: 0,
                items: $(Me.type),
                "is-last": K.autoApply && !Y(d).keepActionRow,
                "esc-close": K.escClose,
                type: Me.type,
                "text-input": K.textInput,
                config: K.config,
                "arrow-navigation": K.arrowNavigation,
                "aria-labels": K.ariaLabels,
                "overlay-label": (Ge = (He = Y(o)).timeOverlay) == null ? void 0 : Ge.call(He, Me.type),
                onSelected: (ot) => xe(Me.type, ot),
                onToggle: (ot) => le(Me.type),
                onResetFlow: Ie[1] || (Ie[1] = (ot) => K.$emit("reset-flow"))
              }, wi({
                "button-icon": De(() => [
                  K.$slots["clock-icon"] ? Se(K.$slots, "clock-icon", { key: 0 }) : ie("", !0),
                  K.$slots["clock-icon"] ? ie("", !0) : (k(), Ce(Ft(K.timePickerInline ? Y(go) : Y(Sp)), { key: 1 }))
                ]),
                _: 2
              }, [
                K.$slots[`${Me.type}-overlay-value`] ? {
                  name: "item",
                  fn: De(({ item: ot }) => [
                    Se(K.$slots, `${Me.type}-overlay-value`, {
                      text: ot.text,
                      value: ot.value
                    })
                  ]),
                  key: "0"
                } : void 0,
                K.$slots[`${Me.type}-overlay-header`] ? {
                  name: "header",
                  fn: De(() => [
                    Se(K.$slots, `${Me.type}-overlay-header`, {
                      toggle: () => le(Me.type)
                    })
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : ie("", !0)
            ];
          }),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), r4 = ["data-dp-mobile"], a4 = ["aria-label", "tabindex"], o4 = ["role", "aria-label", "tabindex"], l4 = ["aria-label"], Fy = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...as
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, { buildMatrix: r, setTimePicker: a } = Tr(), o = Yi(), { defaultedTransitions: l, defaultedAriaLabels: u, defaultedTextInput: d, defaultedConfig: c, defaultedRange: A } = ei(s), { transitionName: m, showTransition: p } = Vl(l), { hideNavigationButtons: h } = Xd(), g = pe(null), w = pe(null), b = pe([]), y = pe(null), D = pe(!1);
    It(() => {
      n("mount"), !s.timePicker && s.arrowNavigation ? r([bi(g.value)], "time") : a(!0, s.timePicker);
    });
    const I = J(() => A.value.enabled && s.modelAuto ? wy(s.internalModelValue) : !0), M = pe(!1), _ = (j) => ({
      hours: Array.isArray(s.hours) ? s.hours[j] : s.hours,
      minutes: Array.isArray(s.minutes) ? s.minutes[j] : s.minutes,
      seconds: Array.isArray(s.seconds) ? s.seconds[j] : s.seconds
    }), N = J(() => {
      const j = [];
      if (A.value.enabled)
        for (let oe = 0; oe < 2; oe++)
          j.push(_(oe));
      else
        j.push(_(0));
      return j;
    }), x = (j, oe = !1, $ = "") => {
      oe || n("reset-flow"), M.value = j, n(j ? "overlay-opened" : "overlay-closed", Ui.time), s.arrowNavigation && a(j), li(() => {
        $ !== "" && b.value[0] && b.value[0].openChildCmp($);
      });
    }, C = J(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: s.autoApply && !c.value.keepActionRow
    })), L = yn(o, "timePicker"), V = (j, oe, $) => A.value.enabled ? oe === 0 ? [j, N.value[1][$]] : [N.value[0][$], j] : j, H = (j) => {
      n("update:hours", j);
    }, O = (j) => {
      n("update:minutes", j);
    }, X = (j) => {
      n("update:seconds", j);
    }, q = () => {
      if (y.value && !d.value.enabled && !s.noOverlayFocus) {
        const j = Ty(y.value);
        j && j.focus({ preventScroll: !0 });
      }
    }, F = (j) => {
      D.value = !1, n("overlay-closed", j);
    }, W = (j) => {
      D.value = !0, n("overlay-opened", j);
    };
    return e({ toggleTimePicker: x }), (j, oe) => {
      var $;
      return k(), U("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": j.isMobile
      }, [
        !j.timePicker && !j.timePickerInline ? Ci((k(), U("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: g,
          type: "button",
          class: we({ ...C.value, "dp--hidden-el": M.value }),
          "aria-label": ($ = Y(u)) == null ? void 0 : $.openTimePicker,
          tabindex: j.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: oe[0] || (oe[0] = (ye) => Y(tn)(ye, () => x(!0))),
          onClick: oe[1] || (oe[1] = (ye) => x(!0))
        }, [
          j.$slots["clock-icon"] ? Se(j.$slots, "clock-icon", { key: 0 }) : ie("", !0),
          j.$slots["clock-icon"] ? ie("", !0) : (k(), Ce(Y(Sp), { key: 1 }))
        ], 42, a4)), [
          [al, !Y(h)(j.hideNavigation, "time")]
        ]) : ie("", !0),
        ke(Ri, {
          name: Y(m)(M.value),
          css: Y(p) && !j.timePickerInline
        }, {
          default: De(() => {
            var ye, ae;
            return [
              M.value || j.timePicker || j.timePickerInline ? (k(), U("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: y,
                role: j.timePickerInline ? void 0 : "dialog",
                class: we({
                  dp__overlay: !j.timePickerInline,
                  "dp--overlay-absolute": !s.timePicker && !j.timePickerInline,
                  "dp--overlay-relative": s.timePicker
                }),
                style: Nt(j.timePicker ? { height: `${Y(c).modeHeight}px` } : void 0),
                "aria-label": (ye = Y(u)) == null ? void 0 : ye.timePicker,
                tabindex: j.timePickerInline ? void 0 : 0
              }, [
                re("div", {
                  class: we(
                    j.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  j.$slots["time-picker-overlay"] ? Se(j.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: t.hours,
                    minutes: t.minutes,
                    seconds: t.seconds,
                    setHours: H,
                    setMinutes: O,
                    setSeconds: X
                  }) : ie("", !0),
                  j.$slots["time-picker-overlay"] ? ie("", !0) : (k(), U("div", {
                    key: 1,
                    class: we(j.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (k(!0), U(Xe, null, ut(N.value, (ce, te) => Ci((k(), Ce(s4, Ut({
                      key: te,
                      ref_for: !0
                    }, {
                      ...j.$props,
                      order: te,
                      hours: ce.hours,
                      minutes: ce.minutes,
                      seconds: ce.seconds,
                      closeTimePickerBtn: w.value,
                      disabledTimesConfig: t.disabledTimesConfig,
                      disabled: te === 0 ? Y(A).fixedStart : Y(A).fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: b,
                      "validate-time": (le, B) => t.validateTime(le, V(B, te, le)),
                      "onUpdate:hours": (le) => H(V(le, te, "hours")),
                      "onUpdate:minutes": (le) => O(V(le, te, "minutes")),
                      "onUpdate:seconds": (le) => X(V(le, te, "seconds")),
                      onMounted: q,
                      onOverlayClosed: F,
                      onOverlayOpened: W,
                      onAmPmChange: oe[2] || (oe[2] = (le) => j.$emit("am-pm-change", le))
                    }), wi({ _: 2 }, [
                      ut(Y(L), (le, B) => ({
                        name: le,
                        fn: De((ue) => [
                          Se(j.$slots, le, Ut({ ref_for: !0 }, ue))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [al, te === 0 ? !0 : I.value]
                    ])), 128))
                  ], 2)),
                  !j.timePicker && !j.timePickerInline ? Ci((k(), U("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: w,
                    type: "button",
                    class: we({ ...C.value, "dp--hidden-el": D.value }),
                    "aria-label": (ae = Y(u)) == null ? void 0 : ae.closeTimePicker,
                    tabindex: "0",
                    onKeydown: oe[3] || (oe[3] = (ce) => Y(tn)(ce, () => x(!1))),
                    onClick: oe[4] || (oe[4] = (ce) => x(!1))
                  }, [
                    j.$slots["calendar-icon"] ? Se(j.$slots, "calendar-icon", { key: 0 }) : ie("", !0),
                    j.$slots["calendar-icon"] ? ie("", !0) : (k(), Ce(Y(go), { key: 1 }))
                  ], 42, l4)), [
                    [al, !Y(h)(j.hideNavigation, "time")]
                  ]) : ie("", !0)
                ], 2)
              ], 14, o4)) : ie("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, r4);
    };
  }
}), zy = (t, e, i, n) => {
  const { defaultedRange: s } = ei(t), r = (y, D) => Array.isArray(e[y]) ? e[y][D] : e[y], a = (y) => t.enableSeconds ? Array.isArray(e.seconds) ? e.seconds[y] : e.seconds : 0, o = (y, D) => y ? D !== void 0 ? pr(y, r("hours", D), r("minutes", D), a(D)) : pr(y, e.hours, e.minutes, a()) : iy(Oe(), a(D)), l = (y, D) => {
    e[y] = D;
  }, u = J(() => t.modelAuto && s.value.enabled ? Array.isArray(i.value) ? i.value.length > 1 : !1 : s.value.enabled), d = (y, D) => {
    const I = Object.fromEntries(
      Object.keys(e).map((M) => M === y ? [M, D] : [M, e[M]].slice())
    );
    if (u.value && !s.value.disableTimeRangeValidation) {
      const M = (N) => i.value ? pr(
        i.value[N],
        I.hours[N],
        I.minutes[N],
        I.seconds[N]
      ) : null, _ = (N) => ty(i.value[N], 0);
      return !(yt(M(0), M(1)) && (ea(M(0), _(1)) || Za(M(1), _(0))));
    }
    return !0;
  }, c = (y, D) => {
    d(y, D) && (l(y, D), n && n());
  }, A = (y) => {
    c("hours", y);
  }, m = (y) => {
    c("minutes", y);
  }, p = (y) => {
    c("seconds", y);
  }, h = (y, D, I, M) => {
    D && A(y), !D && !I && m(y), I && p(y), i.value && M(i.value);
  }, g = (y) => {
    if (y) {
      const D = Array.isArray(y), I = D ? [+y[0].hours, +y[1].hours] : +y.hours, M = D ? [+y[0].minutes, +y[1].minutes] : +y.minutes, _ = D ? [+y[0].seconds, +y[1].seconds] : +y.seconds;
      l("hours", I), l("minutes", M), t.enableSeconds && l("seconds", _);
    }
  }, w = (y, D) => {
    const I = {
      hours: Array.isArray(e.hours) ? e.hours[y] : e.hours,
      disabledArr: []
    };
    return (D || D === 0) && (I.hours = D), Array.isArray(t.disabledTimes) && (I.disabledArr = s.value.enabled && Array.isArray(t.disabledTimes[y]) ? t.disabledTimes[y] : t.disabledTimes), I;
  }, b = J(() => (y, D) => {
    var I;
    if (Array.isArray(t.disabledTimes)) {
      const { disabledArr: M, hours: _ } = w(y, D), N = M.filter((x) => +x.hours === _);
      return ((I = N[0]) == null ? void 0 : I.minutes) === "*" ? { hours: [_], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (N == null ? void 0 : N.map((x) => +x.minutes)) ?? [],
        seconds: (N == null ? void 0 : N.map((x) => x.seconds ? +x.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: l,
    updateHours: A,
    updateMinutes: m,
    updateSeconds: p,
    getSetDateTime: o,
    updateTimeValues: h,
    getSecondsValue: a,
    assignStartTime: g,
    validateTime: d,
    disabledTimesConfig: b
  };
}, u4 = (t, e) => {
  const i = () => {
    t.isTextInputDate && D();
  }, { modelValue: n, time: s } = ql(t, e, i), { defaultedStartTime: r, defaultedRange: a, defaultedTz: o } = ei(t), { updateTimeValues: l, getSetDateTime: u, setTime: d, assignStartTime: c, disabledTimesConfig: A, validateTime: m } = zy(t, s, n, p);
  function p() {
    e("update-flow-step");
  }
  const h = (M) => {
    const { hours: _, minutes: N, seconds: x } = M;
    return { hours: +_, minutes: +N, seconds: x ? +x : 0 };
  }, g = () => {
    if (t.startTime) {
      if (Array.isArray(t.startTime)) {
        const _ = h(t.startTime[0]), N = h(t.startTime[1]);
        return [Lt(Oe(), _), Lt(Oe(), N)];
      }
      const M = h(t.startTime);
      return Lt(Oe(), M);
    }
    return a.value.enabled ? [null, null] : null;
  }, w = () => {
    if (a.value.enabled) {
      const [M, _] = g();
      n.value = [
        un(u(M, 0), o.value.timezone),
        un(u(_, 1), o.value.timezone)
      ];
    } else
      n.value = un(u(g()), o.value.timezone);
  }, b = (M) => Array.isArray(M) ? [Yr(Oe(M[0])), Yr(Oe(M[1]))] : [Yr(M ?? Oe())], y = (M, _, N) => {
    d("hours", M), d("minutes", _), d("seconds", t.enableSeconds ? N : 0);
  }, D = () => {
    const [M, _] = b(n.value);
    return a.value.enabled ? y(
      [M.hours, _.hours],
      [M.minutes, _.minutes],
      [M.seconds, _.seconds]
    ) : y(M.hours, M.minutes, M.seconds);
  };
  It(() => {
    if (!t.shadow)
      return c(r.value), n.value ? D() : w();
  });
  const I = () => {
    Array.isArray(n.value) ? n.value = n.value.map((M, _) => M && u(M, _)) : n.value = u(n.value), e("time-update");
  };
  return {
    modelValue: n,
    time: s,
    disabledTimesConfig: A,
    updateTime: (M, _ = !0, N = !1) => {
      l(M, _, N, I);
    },
    validateTime: m
  };
}, d4 = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...as
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, r = Yi(), a = yn(r, "timePicker"), o = pe(null), { time: l, modelValue: u, disabledTimesConfig: d, updateTime: c, validateTime: A } = u4(s, n);
    return It(() => {
      s.shadow || n("mount", null);
    }), e({ getSidebarProps: () => ({
      modelValue: u,
      time: l,
      updateTime: c
    }), toggleTimePicker: (m, p = !1, h = "") => {
      var g;
      (g = o.value) == null || g.toggleTimePicker(m, p, h);
    } }), (m, p) => (k(), Ce(Wd, {
      "multi-calendars": 0,
      stretch: "",
      "is-mobile": m.isMobile
    }, {
      default: De(() => [
        ke(Fy, Ut({
          ref_key: "tpRef",
          ref: o
        }, m.$props, {
          hours: Y(l).hours,
          minutes: Y(l).minutes,
          seconds: Y(l).seconds,
          "internal-model-value": m.internalModelValue,
          "disabled-times-config": Y(d),
          "validate-time": Y(A),
          "onUpdate:hours": p[0] || (p[0] = (h) => Y(c)(h)),
          "onUpdate:minutes": p[1] || (p[1] = (h) => Y(c)(h, !1)),
          "onUpdate:seconds": p[2] || (p[2] = (h) => Y(c)(h, !1, !0)),
          onAmPmChange: p[3] || (p[3] = (h) => m.$emit("am-pm-change", h)),
          onResetFlow: p[4] || (p[4] = (h) => m.$emit("reset-flow")),
          onOverlayClosed: p[5] || (p[5] = (h) => m.$emit("overlay-toggle", { open: !1, overlay: h })),
          onOverlayOpened: p[6] || (p[6] = (h) => m.$emit("overlay-toggle", { open: !0, overlay: h }))
        }), wi({ _: 2 }, [
          ut(Y(a), (h, g) => ({
            name: h,
            fn: De((w) => [
              Se(m.$slots, h, _i(ln(w)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }, 8, ["is-mobile"]));
  }
}), c4 = { class: "dp--header-wrap" }, f4 = {
  key: 0,
  class: "dp__month_year_wrap"
}, h4 = { key: 0 }, p4 = { class: "dp__month_year_wrap" }, m4 = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], A4 = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...as
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, {
      defaultedTransitions: r,
      defaultedAriaLabels: a,
      defaultedMultiCalendars: o,
      defaultedFilters: l,
      defaultedConfig: u,
      defaultedHighlight: d,
      propDates: c,
      defaultedUI: A
    } = ei(s), { transitionName: m, showTransition: p } = Vl(r), { buildMatrix: h } = Tr(), { handleMonthYearChange: g, isDisabled: w, updateMonthYear: b } = N7(s, n), { showLeftIcon: y, showRightIcon: D } = Xd(), I = pe(!1), M = pe(!1), _ = pe(!1), N = pe([null, null, null, null]);
    It(() => {
      n("mount");
    });
    const x = (ae) => ({
      get: () => s[ae],
      set: (ce) => {
        const te = ae === Gn.month ? Gn.year : Gn.month;
        n("update-month-year", { [ae]: ce, [te]: s[te] }), ae === Gn.month ? F(!0) : W(!0);
      }
    }), C = J(x(Gn.month)), L = J(x(Gn.year)), V = J(() => (ae) => ({
      month: s.month,
      year: s.year,
      items: ae === Gn.month ? s.months : s.years,
      instance: s.instance,
      updateMonthYear: b,
      toggle: ae === Gn.month ? F : W
    })), H = J(() => s.months.find((ce) => ce.value === s.month) || { text: "", value: 0 }), O = J(() => $a(s.months, (ae) => {
      const ce = s.month === ae.value, te = Cl(
        ae.value,
        Ey(s.year, c.value.minDate),
        Dy(s.year, c.value.maxDate)
      ) || l.value.months.includes(ae.value), le = My(d.value, ae.value, s.year);
      return { active: ce, disabled: te, highlighted: le };
    })), X = J(() => $a(s.years, (ae) => {
      const ce = s.year === ae.value, te = Cl(
        ae.value,
        eo(c.value.minDate),
        eo(c.value.maxDate)
      ) || l.value.years.includes(ae.value), le = Ip(d.value, ae.value);
      return { active: ce, disabled: te, highlighted: le };
    })), q = (ae, ce, te) => {
      te !== void 0 ? ae.value = te : ae.value = !ae.value, ae.value ? (_.value = !0, n("overlay-opened", ce)) : (_.value = !1, n("overlay-closed", ce));
    }, F = (ae = !1, ce) => {
      j(ae), q(I, Ui.month, ce);
    }, W = (ae = !1, ce) => {
      j(ae), q(M, Ui.year, ce);
    }, j = (ae) => {
      ae || n("reset-flow");
    }, oe = (ae, ce) => {
      s.arrowNavigation && (N.value[ce] = bi(ae), h(N.value, "monthYear"));
    }, $ = J(() => {
      var ae, ce, te, le, B, ue;
      return [
        {
          type: Gn.month,
          index: 1,
          toggle: F,
          modelValue: C.value,
          updateModelValue: (Pe) => C.value = Pe,
          text: H.value.text,
          showSelectionGrid: I.value,
          items: O.value,
          ariaLabel: (ae = a.value) == null ? void 0 : ae.openMonthsOverlay,
          overlayLabel: ((te = (ce = a.value).monthPicker) == null ? void 0 : te.call(ce, !0)) ?? void 0
        },
        {
          type: Gn.year,
          index: 2,
          toggle: W,
          modelValue: L.value,
          updateModelValue: (Pe) => L.value = Pe,
          text: xy(s.year, s.locale),
          showSelectionGrid: M.value,
          items: X.value,
          ariaLabel: (le = a.value) == null ? void 0 : le.openYearsOverlay,
          overlayLabel: ((ue = (B = a.value).yearPicker) == null ? void 0 : ue.call(B, !0)) ?? void 0
        }
      ];
    }), ye = J(() => s.disableYearSelect ? [$.value[0]] : s.yearFirst ? [...$.value].reverse() : $.value);
    return e({
      toggleMonthPicker: F,
      toggleYearPicker: W,
      handleMonthYearChange: g
    }), (ae, ce) => {
      var te, le, B, ue, Pe, nt;
      return k(), U("div", c4, [
        ae.$slots["month-year"] ? (k(), U("div", f4, [
          Se(ae.$slots, "month-year", _i(ln({
            month: t.month,
            year: t.year,
            months: t.months,
            years: t.years,
            updateMonthYear: Y(b),
            handleMonthYearChange: Y(g),
            instance: t.instance,
            isDisabled: Y(w)
          })))
        ])) : (k(), U(Xe, { key: 1 }, [
          ae.$slots["top-extra"] ? (k(), U("div", h4, [
            Se(ae.$slots, "top-extra", { value: ae.internalModelValue })
          ])) : ie("", !0),
          re("div", p4, [
            Y(y)(Y(o), t.instance) && !ae.vertical ? (k(), Ce(pl, {
              key: 0,
              "aria-label": (te = Y(a)) == null ? void 0 : te.prevMonth,
              disabled: Y(w)(!1),
              class: we((le = Y(A)) == null ? void 0 : le.navBtnPrev),
              "el-name": "action-prev",
              onActivate: ce[0] || (ce[0] = (ge) => Y(g)(!1, !0)),
              onSetRef: ce[1] || (ce[1] = (ge) => oe(ge, 0))
            }, {
              default: De(() => [
                ae.$slots["arrow-left"] ? Se(ae.$slots, "arrow-left", { key: 0 }) : ie("", !0),
                ae.$slots["arrow-left"] ? ie("", !0) : (k(), Ce(Y(Tp), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : ie("", !0),
            re("div", {
              class: we(["dp__month_year_wrap", {
                dp__year_disable_select: ae.disableYearSelect
              }])
            }, [
              (k(!0), U(Xe, null, ut(ye.value, (ge, Qe) => (k(), U(Xe, {
                key: ge.type
              }, [
                re("button", {
                  ref_for: !0,
                  ref: (Ee) => oe(Ee, Qe + 1),
                  type: "button",
                  "data-dp-element": `overlay-${ge.type}`,
                  class: we(["dp__btn dp__month_year_select", { "dp--hidden-el": _.value }]),
                  "aria-label": `${ge.text}-${ge.ariaLabel}`,
                  "data-test-id": `${ge.type}-toggle-overlay-${t.instance}`,
                  onClick: ge.toggle,
                  onKeydown: (Ee) => Y(tn)(Ee, () => ge.toggle(), !0)
                }, [
                  ae.$slots[ge.type] ? Se(ae.$slots, ge.type, {
                    key: 0,
                    text: ge.text,
                    value: s[ge.type]
                  }) : ie("", !0),
                  ae.$slots[ge.type] ? ie("", !0) : (k(), U(Xe, { key: 1 }, [
                    Wi(_e(ge.text), 1)
                  ], 64))
                ], 42, m4),
                ke(Ri, {
                  name: Y(m)(ge.showSelectionGrid),
                  css: Y(p)
                }, {
                  default: De(() => [
                    ge.showSelectionGrid ? (k(), Ce(Ul, {
                      key: 0,
                      items: ge.items,
                      "arrow-navigation": ae.arrowNavigation,
                      "hide-navigation": ae.hideNavigation,
                      "is-last": ae.autoApply && !Y(u).keepActionRow,
                      "skip-button-ref": !1,
                      config: ae.config,
                      type: ge.type,
                      "header-refs": [],
                      "esc-close": ae.escClose,
                      "menu-wrap-ref": ae.menuWrapRef,
                      "text-input": ae.textInput,
                      "aria-labels": ae.ariaLabels,
                      "overlay-label": ge.overlayLabel,
                      onSelected: ge.updateModelValue,
                      onToggle: ge.toggle
                    }, wi({
                      "button-icon": De(() => [
                        ae.$slots["calendar-icon"] ? Se(ae.$slots, "calendar-icon", { key: 0 }) : ie("", !0),
                        ae.$slots["calendar-icon"] ? ie("", !0) : (k(), Ce(Y(go), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      ae.$slots[`${ge.type}-overlay-value`] ? {
                        name: "item",
                        fn: De(({ item: Ee }) => [
                          Se(ae.$slots, `${ge.type}-overlay-value`, {
                            text: Ee.text,
                            value: Ee.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      ae.$slots[`${ge.type}-overlay`] ? {
                        name: "overlay",
                        fn: De(() => [
                          Se(ae.$slots, `${ge.type}-overlay`, Ut({ ref_for: !0 }, V.value(ge.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      ae.$slots[`${ge.type}-overlay-header`] ? {
                        name: "header",
                        fn: De(() => [
                          Se(ae.$slots, `${ge.type}-overlay-header`, {
                            toggle: ge.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : ie("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            Y(y)(Y(o), t.instance) && ae.vertical ? (k(), Ce(pl, {
              key: 1,
              "aria-label": (B = Y(a)) == null ? void 0 : B.prevMonth,
              "el-name": "action-prev",
              disabled: Y(w)(!1),
              class: we((ue = Y(A)) == null ? void 0 : ue.navBtnPrev),
              onActivate: ce[2] || (ce[2] = (ge) => Y(g)(!1, !0))
            }, {
              default: De(() => [
                ae.$slots["arrow-up"] ? Se(ae.$slots, "arrow-up", { key: 0 }) : ie("", !0),
                ae.$slots["arrow-up"] ? ie("", !0) : (k(), Ce(Y(Cp), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : ie("", !0),
            Y(D)(Y(o), t.instance) ? (k(), Ce(pl, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: Y(w)(!0),
              "aria-label": (Pe = Y(a)) == null ? void 0 : Pe.nextMonth,
              class: we((nt = Y(A)) == null ? void 0 : nt.navBtnNext),
              onActivate: ce[3] || (ce[3] = (ge) => Y(g)(!0, !0)),
              onSetRef: ce[4] || (ce[4] = (ge) => oe(ge, ae.disableYearSelect ? 2 : 3))
            }, {
              default: De(() => [
                ae.$slots[ae.vertical ? "arrow-down" : "arrow-right"] ? Se(ae.$slots, ae.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : ie("", !0),
                ae.$slots[ae.vertical ? "arrow-down" : "arrow-right"] ? ie("", !0) : (k(), Ce(Ft(ae.vertical ? Y(Ep) : Y(xp)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : ie("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), g4 = {
  class: "dp__calendar_header",
  role: "row"
}, v4 = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, y4 = ["aria-label"], b4 = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, w4 = { class: "dp__cell_inner" }, T4 = ["id", "aria-pressed", "aria-disabled", "aria-label", "tabindex", "data-test-id", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], x4 = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...as
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, { buildMultiLevelMatrix: r } = Tr(), {
      defaultedTransitions: a,
      defaultedConfig: o,
      defaultedAriaLabels: l,
      defaultedMultiCalendars: u,
      defaultedWeekNumbers: d,
      defaultedMultiDates: c,
      defaultedUI: A
    } = ei(s), m = pe(null), p = pe({
      bottom: "",
      left: "",
      transform: ""
    }), h = pe([]), g = pe(null), w = pe(!0), b = pe(""), y = pe({ startX: 0, endX: 0, startY: 0, endY: 0 }), D = pe([]), I = pe({ left: "50%" }), M = pe(!1), _ = J(() => s.calendar ? s.calendar(s.mappedDates) : s.mappedDates), N = J(() => s.dayNames ? Array.isArray(s.dayNames) ? s.dayNames : s.dayNames(s.locale, +s.weekStart) : i7(s.formatLocale, s.locale, +s.weekStart));
    It(() => {
      n("mount", { cmp: "calendar", refs: h }), o.value.noSwipe || g.value && (g.value.addEventListener("touchstart", oe, { passive: !1 }), g.value.addEventListener("touchend", $, { passive: !1 }), g.value.addEventListener("touchmove", ye, { passive: !1 })), s.monthChangeOnScroll && g.value && g.value.addEventListener("wheel", te, { passive: !1 });
    }), Nn(() => {
      o.value.noSwipe || g.value && (g.value.removeEventListener("touchstart", oe), g.value.removeEventListener("touchend", $), g.value.removeEventListener("touchmove", ye)), s.monthChangeOnScroll && g.value && g.value.removeEventListener("wheel", te);
    });
    const x = (ge) => ge ? s.vertical ? "vNext" : "next" : s.vertical ? "vPrevious" : "previous", C = (ge, Qe) => {
      if (s.transitions) {
        const Ee = Ii(Fs(Oe(), s.month, s.year));
        b.value = hi(Ii(Fs(Oe(), ge, Qe)), Ee) ? a.value[x(!0)] : a.value[x(!1)], w.value = !1, li(() => {
          w.value = !0;
        });
      }
    }, L = J(
      () => ({
        ...A.value.calendar ?? {}
      })
    ), V = J(() => (ge) => {
      const Qe = s7(ge);
      return {
        dp__marker_dot: Qe.type === "dot",
        dp__marker_line: Qe.type === "line"
      };
    }), H = J(() => (ge) => yt(ge, m.value)), O = J(() => ({
      dp__calendar: !0,
      dp__calendar_next: u.value.count > 0 && s.instance !== 0
    })), X = J(() => (ge) => s.hideOffsetDates ? ge.current : !0), q = async (ge, Qe) => {
      const { width: Ee, height: xe } = ge.getBoundingClientRect();
      m.value = Qe.value;
      let K = { left: `${Ee / 2}px` }, Ie = -50;
      if (await li(), D.value[0]) {
        const { left: Be, width: Me } = D.value[0].getBoundingClientRect();
        Be < 0 && (K = { left: "0" }, Ie = 0, I.value.left = `${Ee / 2}px`), window.innerWidth < Be + Me && (K = { right: "0" }, Ie = 0, I.value.left = `${Me - Ee / 2}px`);
      }
      p.value = {
        bottom: `${xe}px`,
        ...K,
        transform: `translateX(${Ie}%)`
      };
    }, F = async (ge, Qe, Ee) => {
      var xe, K, Ie;
      const Be = bi(h.value[Qe][Ee]);
      Be && ((xe = ge.marker) != null && xe.customPosition && (Ie = (K = ge.marker) == null ? void 0 : K.tooltip) != null && Ie.length ? p.value = ge.marker.customPosition(Be) : await q(Be, ge), n("tooltip-open", ge.marker));
    }, W = async (ge, Qe, Ee) => {
      var xe, K;
      if (M.value && c.value.enabled && c.value.dragSelect)
        return n("select-date", ge);
      if (n("set-hover-date", ge), (K = (xe = ge.marker) == null ? void 0 : xe.tooltip) != null && K.length) {
        if (s.hideOffsetDates && !ge.current) return;
        await F(ge, Qe, Ee);
      }
    }, j = (ge) => {
      m.value && (m.value = null, p.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), n("tooltip-close", ge.marker));
    }, oe = (ge) => {
      y.value.startX = ge.changedTouches[0].screenX, y.value.startY = ge.changedTouches[0].screenY;
    }, $ = (ge) => {
      y.value.endX = ge.changedTouches[0].screenX, y.value.endY = ge.changedTouches[0].screenY, ae();
    }, ye = (ge) => {
      s.vertical && !s.inline && ge.preventDefault();
    }, ae = () => {
      const ge = s.vertical ? "Y" : "X";
      Math.abs(y.value[`start${ge}`] - y.value[`end${ge}`]) > 10 && n("handle-swipe", y.value[`start${ge}`] > y.value[`end${ge}`] ? "right" : "left");
    }, ce = (ge, Qe, Ee) => {
      ge && (Array.isArray(h.value[Qe]) ? h.value[Qe][Ee] = ge : h.value[Qe] = [ge]), s.arrowNavigation && r(h.value, "calendar");
    }, te = (ge) => {
      s.monthChangeOnScroll && (ge.preventDefault(), n("handle-scroll", ge));
    }, le = (ge) => d.value.type === "local" ? fp(ge.value, { weekStartsOn: +s.weekStart }) : d.value.type === "iso" ? dp(ge.value) : typeof d.value.type == "function" ? d.value.type(ge.value) : "", B = (ge) => {
      const Qe = ge[0];
      return d.value.hideOnOffsetDates ? ge.some((Ee) => Ee.current) ? le(Qe) : "" : le(Qe);
    }, ue = (ge, Qe, Ee = !0) => {
      !Ee && u7() || (!c.value.enabled || o.value.allowPreventDefault) && (hr(ge, o.value), n("select-date", Qe));
    }, Pe = (ge) => {
      hr(ge, o.value);
    }, nt = (ge) => {
      c.value.enabled && c.value.dragSelect ? (M.value = !0, n("select-date", ge)) : c.value.enabled && n("select-date", ge);
    };
    return e({ triggerTransition: C }), (ge, Qe) => (k(), U("div", {
      class: we(O.value)
    }, [
      re("div", {
        ref_key: "calendarWrapRef",
        ref: g,
        class: we(L.value),
        role: "grid"
      }, [
        re("div", g4, [
          ge.weekNumbers ? (k(), U("div", v4, _e(ge.weekNumName), 1)) : ie("", !0),
          (k(!0), U(Xe, null, ut(N.value, (Ee, xe) => {
            var K, Ie;
            return k(), U("div", {
              key: xe,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (Ie = (K = Y(l)) == null ? void 0 : K.weekDay) == null ? void 0 : Ie.call(K, xe)
            }, [
              ge.$slots["calendar-header"] ? Se(ge.$slots, "calendar-header", {
                key: 0,
                day: Ee,
                index: xe
              }) : ie("", !0),
              ge.$slots["calendar-header"] ? ie("", !0) : (k(), U(Xe, { key: 1 }, [
                Wi(_e(Ee), 1)
              ], 64))
            ], 8, y4);
          }), 128))
        ]),
        Qe[2] || (Qe[2] = re("div", { class: "dp__calendar_header_separator" }, null, -1)),
        ke(Ri, {
          name: b.value,
          css: !!ge.transitions
        }, {
          default: De(() => [
            w.value ? (k(), U("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: Qe[1] || (Qe[1] = (Ee) => M.value = !1)
            }, [
              (k(!0), U(Xe, null, ut(_.value, (Ee, xe) => (k(), U("div", {
                key: xe,
                class: "dp__calendar_row",
                role: "row"
              }, [
                ge.weekNumbers ? (k(), U("div", b4, [
                  re("div", w4, _e(B(Ee.days)), 1)
                ])) : ie("", !0),
                (k(!0), U(Xe, null, ut(Ee.days, (K, Ie) => {
                  var Be, Me, Ke;
                  return k(), U("div", {
                    id: Y(mh)(K.value),
                    ref_for: !0,
                    ref: (He) => ce(He, xe, Ie),
                    key: Ie + xe,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-pressed": (K.classData.dp__active_date || K.classData.dp__range_start || K.classData.dp__range_start) ?? void 0,
                    "aria-disabled": K.classData.dp__cell_disabled || void 0,
                    "aria-label": (Me = (Be = Y(l)) == null ? void 0 : Be.day) == null ? void 0 : Me.call(Be, K),
                    tabindex: !K.current && ge.hideOffsetDates ? void 0 : 0,
                    "data-test-id": Y(mh)(K.value),
                    onClick: $t((He) => ue(He, K), ["prevent"]),
                    onTouchend: (He) => ue(He, K, !1),
                    onKeydown: (He) => Y(tn)(He, () => ge.$emit("select-date", K)),
                    onMouseenter: (He) => W(K, xe, Ie),
                    onMouseleave: (He) => j(K),
                    onMousedown: (He) => nt(K),
                    onMouseup: Qe[0] || (Qe[0] = (He) => M.value = !1)
                  }, [
                    re("div", {
                      class: we(["dp__cell_inner", K.classData])
                    }, [
                      ge.$slots.day && X.value(K) ? Se(ge.$slots, "day", {
                        key: 0,
                        day: +K.text,
                        date: K.value
                      }) : ie("", !0),
                      ge.$slots.day ? ie("", !0) : (k(), U(Xe, { key: 1 }, [
                        Wi(_e(K.text), 1)
                      ], 64)),
                      K.marker && X.value(K) ? (k(), U(Xe, { key: 2 }, [
                        ge.$slots.marker ? Se(ge.$slots, "marker", {
                          key: 0,
                          marker: K.marker,
                          day: +K.text,
                          date: K.value
                        }) : (k(), U("div", {
                          key: 1,
                          class: we(V.value(K.marker)),
                          style: Nt(K.marker.color ? { backgroundColor: K.marker.color } : {})
                        }, null, 6))
                      ], 64)) : ie("", !0),
                      H.value(K.value) ? (k(), U("div", {
                        key: 3,
                        ref_for: !0,
                        ref_key: "activeTooltip",
                        ref: D,
                        class: "dp__marker_tooltip",
                        style: Nt(p.value)
                      }, [
                        (Ke = K.marker) != null && Ke.tooltip ? (k(), U("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: Pe
                        }, [
                          (k(!0), U(Xe, null, ut(K.marker.tooltip, (He, Ge) => (k(), U("div", {
                            key: Ge,
                            class: "dp__tooltip_text"
                          }, [
                            ge.$slots["marker-tooltip"] ? Se(ge.$slots, "marker-tooltip", {
                              key: 0,
                              tooltip: He,
                              day: K.value
                            }) : ie("", !0),
                            ge.$slots["marker-tooltip"] ? ie("", !0) : (k(), U(Xe, { key: 1 }, [
                              re("div", {
                                class: "dp__tooltip_mark",
                                style: Nt(He.color ? { backgroundColor: He.color } : {})
                              }, null, 4),
                              re("div", null, _e(He.text), 1)
                            ], 64))
                          ]))), 128)),
                          re("div", {
                            class: "dp__arrow_bottom_tp",
                            style: Nt(I.value)
                          }, null, 4)
                        ])) : ie("", !0)
                      ], 4)) : ie("", !0)
                    ], 2)
                  ], 40, T4);
                }), 128))
              ]))), 128))
            ], 32)) : ie("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), hg = (t) => Array.isArray(t), S4 = (t, e, i, n) => {
  const s = pe([]), r = pe(/* @__PURE__ */ new Date()), a = pe(), o = () => $(t.isTextInputDate), { modelValue: l, calendars: u, time: d, today: c } = ql(t, e, o), {
    defaultedMultiCalendars: A,
    defaultedStartTime: m,
    defaultedRange: p,
    defaultedConfig: h,
    defaultedTz: g,
    propDates: w,
    defaultedMultiDates: b
  } = ei(t), { validateMonthYearInRange: y, isDisabled: D, isDateRangeAllowed: I, checkMinMaxRange: M } = xr(t), { updateTimeValues: _, getSetDateTime: N, setTime: x, assignStartTime: C, validateTime: L, disabledTimesConfig: V } = zy(t, d, l, n), H = J(
    () => (me) => u.value[me] ? u.value[me].month : 0
  ), O = J(
    () => (me) => u.value[me] ? u.value[me].year : 0
  ), X = (me) => !h.value.keepViewOnOffsetClick || me ? !0 : !a.value, q = (me, Le, Je, z = !1) => {
    var R, Q;
    X(z) && (u.value[me] || (u.value[me] = { month: 0, year: 0 }), u.value[me].month = og(Le) ? (R = u.value[me]) == null ? void 0 : R.month : Le, u.value[me].year = og(Je) ? (Q = u.value[me]) == null ? void 0 : Q.year : Je);
  }, F = () => {
    t.autoApply && e("select-date");
  }, W = () => {
    m.value && C(m.value);
  };
  It(() => {
    t.shadow || (l.value || (Qe(), W()), $(!0), t.focusStartDate && t.startDate && Qe());
  });
  const j = J(() => {
    var me;
    return (me = t.flow) != null && me.length && !t.partialFlow ? t.flowStep === t.flow.length : !0;
  }), oe = () => {
    t.autoApply && j.value && e("auto-apply", t.partialFlow ? t.flowStep !== t.flow.length : !1);
  }, $ = (me = !1) => {
    if (l.value)
      return Array.isArray(l.value) ? (s.value = l.value, ue(me)) : ce(l.value, me);
    if (A.value.count && me && !t.startDate)
      return ae(Oe(), me);
  }, ye = () => Array.isArray(l.value) && p.value.enabled ? vt(l.value[0]) === vt(l.value[1] ?? l.value[0]) : !1, ae = (me = /* @__PURE__ */ new Date(), Le = !1) => {
    if ((!A.value.count || !A.value.static || Le) && q(0, vt(me), lt(me)), A.value.count && (!l.value || ye() || !A.value.solo) && (!A.value.solo || Le))
      for (let Je = 1; Je < A.value.count; Je++) {
        const z = Lt(Oe(), { month: H.value(Je - 1), year: O.value(Je - 1) }), R = N0(z, { months: 1 });
        u.value[Je] = { month: vt(R), year: lt(R) };
      }
  }, ce = (me, Le) => {
    ae(me), x("hours", Hs(me)), x("minutes", gr(me)), x("seconds", Qa(me)), A.value.count && Le && ge();
  }, te = (me) => {
    if (A.value.count) {
      if (A.value.solo) return 0;
      const Le = vt(me[0]), Je = vt(me[1]);
      return Math.abs(Je - Le) < A.value.count ? 0 : 1;
    }
    return 1;
  }, le = (me, Le) => {
    me[1] && p.value.showLastInRange ? ae(me[te(me)], Le) : ae(me[0], Le);
    const Je = (z, R) => [
      z(me[0]),
      me[1] ? z(me[1]) : d[R][1]
    ];
    x("hours", Je(Hs, "hours")), x("minutes", Je(gr, "minutes")), x("seconds", Je(Qa, "seconds"));
  }, B = (me, Le) => {
    if ((p.value.enabled || t.weekPicker) && !b.value.enabled)
      return le(me, Le);
    if (b.value.enabled && Le) {
      const Je = me[me.length - 1];
      return ce(Je, Le);
    }
  }, ue = (me) => {
    const Le = l.value;
    B(Le, me), A.value.count && A.value.solo && ge();
  }, Pe = (me, Le) => {
    const Je = Lt(Oe(), { month: H.value(Le), year: O.value(Le) }), z = me < 0 ? $n(Je, 1) : Ka(Je, 1);
    y(vt(z), lt(z), me < 0, t.preventMinMaxNavigation) && (q(Le, vt(z), lt(z)), e("update-month-year", { instance: Le, month: vt(z), year: lt(z) }), A.value.count && !A.value.solo && nt(Le), i());
  }, nt = (me) => {
    for (let Le = me - 1; Le >= 0; Le--) {
      const Je = Ka(Lt(Oe(), { month: H.value(Le + 1), year: O.value(Le + 1) }), 1);
      q(Le, vt(Je), lt(Je));
    }
    for (let Le = me + 1; Le <= A.value.count - 1; Le++) {
      const Je = $n(Lt(Oe(), { month: H.value(Le - 1), year: O.value(Le - 1) }), 1);
      q(Le, vt(Je), lt(Je));
    }
  }, ge = () => {
    if (Array.isArray(l.value) && l.value.length === 2) {
      const me = Oe(
        Oe(l.value[1] ? l.value[1] : $n(l.value[0], 1))
      ), [Le, Je] = [vt(l.value[0]), lt(l.value[0])], [z, R] = [vt(l.value[1]), lt(l.value[1])];
      (Le !== z || Le === z && Je !== R) && A.value.solo && q(1, vt(me), lt(me));
    } else l.value && !Array.isArray(l.value) && (q(0, vt(l.value), lt(l.value)), ae(Oe()));
  }, Qe = () => {
    t.startDate && (q(0, vt(Oe(t.startDate)), lt(Oe(t.startDate))), A.value.count && nt(0));
  }, Ee = (me, Le) => {
    if (t.monthChangeOnScroll) {
      const Je = (/* @__PURE__ */ new Date()).getTime() - r.value.getTime(), z = Math.abs(me.deltaY);
      let R = 500;
      z > 1 && (R = 100), z > 100 && (R = 0), Je > R && (r.value = /* @__PURE__ */ new Date(), Pe(t.monthChangeOnScroll !== "inverse" ? -me.deltaY : me.deltaY, Le));
    }
  }, xe = (me, Le, Je = !1) => {
    t.monthChangeOnArrows && t.vertical === Je && K(me, Le);
  }, K = (me, Le) => {
    Pe(me === "right" ? -1 : 1, Le);
  }, Ie = (me) => {
    if (w.value.markers)
      return ad(me.value, w.value.markers);
  }, Be = (me, Le) => {
    switch (t.sixWeeks === !0 ? "append" : t.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [me == 0, !0];
      case "fair":
        return [me == 0 || Le > me, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Me = (me, Le, Je, z) => {
    if (t.sixWeeks && me.length < 6) {
      const R = 6 - me.length, Q = (Le.getDay() + 7 - z) % 7, de = 6 - (Je.getDay() + 7 - z) % 7, [Fe, Ze] = Be(Q, de);
      for (let bt = 1; bt <= R; bt++)
        if (Ze ? !!(bt % 2) == Fe : Fe) {
          const Vt = me[0].days[0], Xi = Ke(In(Vt.value, -7), vt(Le));
          me.unshift({ days: Xi });
        } else {
          const Vt = me[me.length - 1], Xi = Vt.days[Vt.days.length - 1], En = Ke(In(Xi.value, 1), vt(Le));
          me.push({ days: En });
        }
    }
    return me;
  }, Ke = (me, Le) => {
    const Je = Oe(me), z = [];
    for (let R = 0; R < 7; R++) {
      const Q = In(Je, R), de = vt(Q) !== Le;
      z.push({
        text: t.hideOffsetDates && de ? "" : Q.getDate(),
        value: Q,
        current: !de,
        classData: {}
      });
    }
    return z;
  }, He = (me, Le) => {
    const Je = [], z = new Date(Le, me), R = new Date(Le, me + 1, 0), Q = t.weekStart, de = Tn(z, { weekStartsOn: Q }), Fe = (Ze) => {
      const bt = Ke(Ze, me);
      if (Je.push({ days: bt }), !Je[Je.length - 1].days.some(
        (Vt) => yt(Ii(Vt.value), Ii(R))
      )) {
        const Vt = In(Ze, 7);
        Fe(Vt);
      }
    };
    return Fe(de), Me(Je, z, R, Q);
  }, Ge = (me) => {
    const Le = pr(Oe(me.value), d.hours, d.minutes, je());
    e("date-update", Le), b.value.enabled ? Mp(Le, l, b.value.limit) : l.value = Le, n(), li().then(() => {
      oe();
    });
  }, ot = (me) => p.value.noDisabledRange ? _y(s.value[0], me).some((Le) => D(Le)) : !1, he = () => {
    s.value = l.value ? l.value.slice() : [], s.value.length === 2 && !(p.value.fixedStart || p.value.fixedEnd) && (s.value = []);
  }, Re = (me, Le) => {
    const Je = [
      Oe(me.value),
      In(Oe(me.value), +p.value.autoRange)
    ];
    I(Je) ? (Le && dt(me.value), s.value = Je) : e("invalid-date", me.value);
  }, dt = (me) => {
    const Le = vt(Oe(me)), Je = lt(Oe(me));
    if (q(0, Le, Je), A.value.count > 0)
      for (let z = 1; z < A.value.count; z++) {
        const R = f7(
          Lt(Oe(me), { year: O.value(z - 1), month: H.value(z - 1) })
        );
        q(z, R.month, R.year);
      }
  }, St = (me) => {
    if (ot(me.value) || !M(me.value, l.value, p.value.fixedStart ? 0 : 1))
      return e("invalid-date", me.value);
    s.value = Ny(Oe(me.value), l, e, p);
  }, Rt = (me, Le) => {
    if (he(), p.value.autoRange) return Re(me, Le);
    if (p.value.fixedStart || p.value.fixedEnd) return St(me);
    s.value[0] ? M(Oe(me.value), l.value) && !ot(me.value) ? ai(Oe(me.value), Oe(s.value[0])) ? (s.value.unshift(Oe(me.value)), e("range-end", s.value[0])) : (s.value[1] = Oe(me.value), e("range-end", s.value[1])) : (t.autoApply && e("auto-apply-invalid", me.value), e("invalid-date", me.value)) : (s.value[0] = Oe(me.value), e("range-start", s.value[0]));
  }, je = (me = !0) => t.enableSeconds ? Array.isArray(d.seconds) ? me ? d.seconds[0] : d.seconds[1] : d.seconds : 0, Et = (me) => {
    s.value[me] = pr(
      s.value[me],
      d.hours[me],
      d.minutes[me],
      je(me !== 1)
    );
  }, Mi = () => {
    var me, Le;
    s.value[0] && s.value[1] && +((me = s.value) == null ? void 0 : me[0]) > +((Le = s.value) == null ? void 0 : Le[1]) && (s.value.reverse(), e("range-start", s.value[0]), e("range-end", s.value[1]));
  }, zn = () => {
    s.value.length && (s.value[0] && !s.value[1] ? Et(0) : (Et(0), Et(1), n()), Mi(), l.value = s.value.slice(), Yd(s.value, e, t.autoApply, t.modelAuto));
  }, xt = (me, Le = !1) => {
    if (D(me.value) || !me.current && t.hideOffsetDates) return e("invalid-date", me.value);
    if (a.value = JSON.parse(JSON.stringify(me)), !p.value.enabled) return Ge(me);
    hg(d.hours) && hg(d.minutes) && !b.value.enabled && (Rt(me, Le), zn());
  }, Gs = (me, Le) => {
    var Je;
    q(me, Le.month, Le.year, !0), A.value.count && !A.value.solo && nt(me), e("update-month-year", { instance: me, month: Le.month, year: Le.year }), i(A.value.solo ? me : void 0);
    const z = (Je = t.flow) != null && Je.length ? t.flow[t.flowStep] : void 0;
    !Le.fromNav && (z === Ui.month || z === Ui.year) && n();
  }, Un = (me, Le) => {
    Ly({
      value: me,
      modelValue: l,
      range: p.value.enabled,
      timezone: Le ? void 0 : g.value.timezone
    }), F(), t.multiCalendars && li().then(() => $(!0));
  }, Qs = () => {
    const me = Dp(Oe(), g.value);
    !p.value.enabled && !b.value.enabled ? l.value = me : l.value && Array.isArray(l.value) && l.value[0] ? b.value.enabled ? l.value = [...l.value, me] : l.value = ai(me, l.value[0]) ? [me, l.value[0]] : [l.value[0], me] : l.value = [me], F();
  }, Ps = () => {
    if (Array.isArray(l.value))
      if (b.value.enabled) {
        const me = Cn();
        l.value[l.value.length - 1] = N(me);
      } else
        l.value = l.value.map((me, Le) => me && N(me, Le));
    else
      l.value = N(l.value);
    e("time-update");
  }, Cn = () => Array.isArray(l.value) && l.value.length ? l.value[l.value.length - 1] : null;
  return {
    calendars: u,
    modelValue: l,
    month: H,
    year: O,
    time: d,
    disabledTimesConfig: V,
    today: c,
    validateTime: L,
    getCalendarDays: He,
    getMarker: Ie,
    handleScroll: Ee,
    handleSwipe: K,
    handleArrow: xe,
    selectDate: xt,
    updateMonthYear: Gs,
    presetDate: Un,
    selectCurrentDate: Qs,
    updateTime: (me, Le = !0, Je = !1) => {
      _(me, Le, Je, Ps);
    },
    assignMonthAndYear: ae,
    setStartTime: W
  };
}, C4 = { key: 0 }, E4 = /* @__PURE__ */ qe({
  __name: "DatePicker",
  props: {
    ...as
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, {
      calendars: r,
      month: a,
      year: o,
      modelValue: l,
      time: u,
      disabledTimesConfig: d,
      today: c,
      validateTime: A,
      getCalendarDays: m,
      getMarker: p,
      handleArrow: h,
      handleScroll: g,
      handleSwipe: w,
      selectDate: b,
      updateMonthYear: y,
      presetDate: D,
      selectCurrentDate: I,
      updateTime: M,
      assignMonthAndYear: _,
      setStartTime: N
    } = S4(s, n, ye, ae), x = Yi(), { setHoverDate: C, getDayClassData: L, clearHoverDate: V } = H4(l, s), { defaultedMultiCalendars: H } = ei(s), O = pe([]), X = pe([]), q = pe(null), F = yn(x, "calendar"), W = yn(x, "monthYear"), j = yn(x, "timePicker"), oe = (Ee) => {
      s.shadow || n("mount", Ee);
    };
    mt(
      r,
      () => {
        s.shadow || setTimeout(() => {
          n("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), mt(
      H,
      (Ee, xe) => {
        Ee.count - xe.count > 0 && _();
      },
      { deep: !0 }
    );
    const $ = J(() => (Ee) => m(a.value(Ee), o.value(Ee)).map((xe) => ({
      ...xe,
      days: xe.days.map((K) => (K.marker = p(K), K.classData = L(K), K))
    })));
    function ye(Ee) {
      var xe;
      Ee || Ee === 0 ? (xe = X.value[Ee]) == null || xe.triggerTransition(a.value(Ee), o.value(Ee)) : X.value.forEach((K, Ie) => K.triggerTransition(a.value(Ie), o.value(Ie)));
    }
    function ae() {
      n("update-flow-step");
    }
    const ce = (Ee, xe = !1) => {
      b(Ee, xe), s.spaceConfirm && n("select-date");
    }, te = (Ee, xe, K = 0) => {
      var Ie;
      (Ie = O.value[K]) == null || Ie.toggleMonthPicker(Ee, xe);
    }, le = (Ee, xe, K = 0) => {
      var Ie;
      (Ie = O.value[K]) == null || Ie.toggleYearPicker(Ee, xe);
    }, B = (Ee, xe, K) => {
      var Ie;
      (Ie = q.value) == null || Ie.toggleTimePicker(Ee, xe, K);
    }, ue = (Ee, xe) => {
      var K;
      if (!s.range) {
        const Ie = l.value ? l.value : c, Be = xe ? new Date(xe) : Ie, Me = Ee ? Tn(Be, { weekStartsOn: 1 }) : H0(Be, { weekStartsOn: 1 });
        b({
          value: Me,
          current: vt(Be) === a.value(0),
          text: "",
          classData: {}
        }), (K = document.getElementById(mh(Me))) == null || K.focus();
      }
    }, Pe = (Ee) => {
      var xe;
      (xe = O.value[0]) == null || xe.handleMonthYearChange(Ee, !0);
    }, nt = (Ee) => {
      y(0, { month: a.value(0), year: o.value(0) + (Ee ? 1 : -1), fromNav: !0 });
    }, ge = (Ee, xe) => {
      Ee === Ui.time && n(`time-picker-${xe ? "open" : "close"}`), n("overlay-toggle", { open: xe, overlay: Ee });
    }, Qe = (Ee) => {
      n("overlay-toggle", { open: !1, overlay: Ee }), n("focus-menu");
    };
    return e({
      clearHoverDate: V,
      presetDate: D,
      selectCurrentDate: I,
      toggleMonthPicker: te,
      toggleYearPicker: le,
      toggleTimePicker: B,
      handleArrow: h,
      updateMonthYear: y,
      getSidebarProps: () => ({
        modelValue: l,
        month: a,
        year: o,
        time: u,
        updateTime: M,
        updateMonthYear: y,
        selectDate: b,
        presetDate: D
      }),
      changeMonth: Pe,
      changeYear: nt,
      selectWeekDate: ue,
      setStartTime: N
    }), (Ee, xe) => (k(), U(Xe, null, [
      ke(Wd, {
        "multi-calendars": Y(H).count,
        collapse: Ee.collapse,
        "is-mobile": Ee.isMobile
      }, {
        default: De(({ instance: K, index: Ie }) => [
          Ee.disableMonthYearSelect ? ie("", !0) : (k(), Ce(A4, Ut({
            key: 0,
            ref: (Be) => {
              Be && (O.value[Ie] = Be);
            },
            months: Y(by)(Ee.formatLocale, Ee.locale, Ee.monthNameFormat),
            years: Y(_p)(Ee.yearRange, Ee.locale, Ee.reverseYears),
            month: Y(a)(K),
            year: Y(o)(K),
            instance: K
          }, Ee.$props, {
            onMount: xe[0] || (xe[0] = (Be) => oe(Y(Wr).header)),
            onResetFlow: xe[1] || (xe[1] = (Be) => Ee.$emit("reset-flow")),
            onUpdateMonthYear: (Be) => Y(y)(K, Be),
            onOverlayClosed: Qe,
            onOverlayOpened: xe[2] || (xe[2] = (Be) => Ee.$emit("overlay-toggle", { open: !0, overlay: Be }))
          }), wi({ _: 2 }, [
            ut(Y(W), (Be, Me) => ({
              name: Be,
              fn: De((Ke) => [
                Se(Ee.$slots, Be, _i(ln(Ke)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          ke(x4, Ut({
            ref: (Be) => {
              Be && (X.value[Ie] = Be);
            },
            "mapped-dates": $.value(K),
            month: Y(a)(K),
            year: Y(o)(K),
            instance: K
          }, Ee.$props, {
            onSelectDate: (Be) => Y(b)(Be, K !== 1),
            onHandleSpace: (Be) => ce(Be, K !== 1),
            onSetHoverDate: xe[3] || (xe[3] = (Be) => Y(C)(Be)),
            onHandleScroll: (Be) => Y(g)(Be, K),
            onHandleSwipe: (Be) => Y(w)(Be, K),
            onMount: xe[4] || (xe[4] = (Be) => oe(Y(Wr).calendar)),
            onResetFlow: xe[5] || (xe[5] = (Be) => Ee.$emit("reset-flow")),
            onTooltipOpen: xe[6] || (xe[6] = (Be) => Ee.$emit("tooltip-open", Be)),
            onTooltipClose: xe[7] || (xe[7] = (Be) => Ee.$emit("tooltip-close", Be))
          }), wi({ _: 2 }, [
            ut(Y(F), (Be, Me) => ({
              name: Be,
              fn: De((Ke) => [
                Se(Ee.$slots, Be, _i(ln({ ...Ke })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse", "is-mobile"]),
      Ee.enableTimePicker ? (k(), U("div", C4, [
        Ee.$slots["time-picker"] ? Se(Ee.$slots, "time-picker", _i(Ut({ key: 0 }, { time: Y(u), updateTime: Y(M) }))) : (k(), Ce(Fy, Ut({
          key: 1,
          ref_key: "timePickerRef",
          ref: q
        }, Ee.$props, {
          hours: Y(u).hours,
          minutes: Y(u).minutes,
          seconds: Y(u).seconds,
          "internal-model-value": Ee.internalModelValue,
          "disabled-times-config": Y(d),
          "validate-time": Y(A),
          onMount: xe[8] || (xe[8] = (K) => oe(Y(Wr).timePicker)),
          "onUpdate:hours": xe[9] || (xe[9] = (K) => Y(M)(K)),
          "onUpdate:minutes": xe[10] || (xe[10] = (K) => Y(M)(K, !1)),
          "onUpdate:seconds": xe[11] || (xe[11] = (K) => Y(M)(K, !1, !0)),
          onResetFlow: xe[12] || (xe[12] = (K) => Ee.$emit("reset-flow")),
          onOverlayClosed: xe[13] || (xe[13] = (K) => ge(K, !1)),
          onOverlayOpened: xe[14] || (xe[14] = (K) => ge(K, !0)),
          onAmPmChange: xe[15] || (xe[15] = (K) => Ee.$emit("am-pm-change", K))
        }), wi({ _: 2 }, [
          ut(Y(j), (K, Ie) => ({
            name: K,
            fn: De((Be) => [
              Se(Ee.$slots, K, _i(ln(Be)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : ie("", !0)
    ], 64));
  }
}), D4 = (t, e) => {
  const i = pe(), {
    defaultedMultiCalendars: n,
    defaultedConfig: s,
    defaultedHighlight: r,
    defaultedRange: a,
    propDates: o,
    defaultedFilters: l,
    defaultedMultiDates: u
  } = ei(t), { modelValue: d, year: c, month: A, calendars: m } = ql(t, e), { isDisabled: p } = xr(t), { selectYear: h, groupedYears: g, showYearPicker: w, isDisabled: b, toggleYearPicker: y, handleYearSelect: D, handleYear: I } = Ry({
    modelValue: d,
    multiCalendars: n,
    range: a,
    highlight: r,
    calendars: m,
    propDates: o,
    month: A,
    year: c,
    filters: l,
    props: t,
    emit: e
  }), M = (X, q) => [X, q].map((F) => es(F, "MMMM", { locale: t.formatLocale })).join("-"), _ = J(() => (X) => d.value ? Array.isArray(d.value) ? d.value.some((q) => WA(X, q)) : WA(d.value, X) : !1), N = (X) => {
    if (a.value.enabled) {
      if (Array.isArray(d.value)) {
        const q = yt(X, d.value[0]) || yt(X, d.value[1]);
        return El(d.value, i.value, X) && !q;
      }
      return !1;
    }
    return !1;
  }, x = (X, q) => X.quarter === RA(q) && X.year === lt(q), C = (X) => typeof r.value == "function" ? r.value({ quarter: RA(X), year: lt(X) }) : !!r.value.quarters.find((q) => x(q, X)), L = J(() => (X) => {
    const q = Lt(/* @__PURE__ */ new Date(), { year: c.value(X) });
    return VI({
      start: Sl(q),
      end: q0(q)
    }).map((F) => {
      const W = Ur(F), j = FA(F), oe = p(F), $ = N(W), ye = C(W);
      return {
        text: M(W, j),
        value: W,
        active: _.value(W),
        highlighted: ye,
        disabled: oe,
        isBetween: $
      };
    });
  }), V = (X) => {
    Mp(X, d, u.value.limit), e("auto-apply", !0);
  }, H = (X) => {
    d.value = Op(d, X, e), Yd(d.value, e, t.autoApply, t.modelAuto);
  }, O = (X) => {
    d.value = X, e("auto-apply");
  };
  return {
    defaultedConfig: s,
    defaultedMultiCalendars: n,
    groupedYears: g,
    year: c,
    isDisabled: b,
    quarters: L,
    showYearPicker: w,
    modelValue: d,
    setHoverDate: (X) => {
      i.value = X;
    },
    selectYear: h,
    selectQuarter: (X, q, F) => {
      if (!F)
        return m.value[q].month = vt(FA(X)), u.value.enabled ? V(X) : a.value.enabled ? H(X) : O(X);
    },
    toggleYearPicker: y,
    handleYearSelect: D,
    handleYear: I
  };
}, _4 = { class: "dp--quarter-items" }, k4 = ["data-test-id", "disabled", "onClick", "onMouseover"], P4 = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...as
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, r = Yi(), a = yn(r, "yearMode"), {
      defaultedMultiCalendars: o,
      defaultedConfig: l,
      groupedYears: u,
      year: d,
      isDisabled: c,
      quarters: A,
      modelValue: m,
      showYearPicker: p,
      setHoverDate: h,
      selectQuarter: g,
      toggleYearPicker: w,
      handleYearSelect: b,
      handleYear: y
    } = D4(s, n);
    return e({ getSidebarProps: () => ({
      modelValue: m,
      year: d,
      selectQuarter: g,
      handleYearSelect: b,
      handleYear: y
    }) }), (D, I) => (k(), Ce(Wd, {
      "multi-calendars": Y(o).count,
      collapse: D.collapse,
      stretch: "",
      "is-mobile": D.isMobile
    }, {
      default: De(({ instance: M }) => [
        re("div", {
          class: "dp-quarter-picker-wrap",
          style: Nt({ minHeight: `${Y(l).modeHeight}px` })
        }, [
          D.$slots["top-extra"] ? Se(D.$slots, "top-extra", {
            key: 0,
            value: D.internalModelValue
          }) : ie("", !0),
          re("div", null, [
            ke(By, Ut(D.$props, {
              items: Y(u)(M),
              instance: M,
              "show-year-picker": Y(p)[M],
              year: Y(d)(M),
              "is-disabled": (_) => Y(c)(M, _),
              onHandleYear: (_) => Y(y)(M, _),
              onYearSelect: (_) => Y(b)(_, M),
              onToggleYearPicker: (_) => Y(w)(M, _ == null ? void 0 : _.flow, _ == null ? void 0 : _.show)
            }), wi({ _: 2 }, [
              ut(Y(a), (_, N) => ({
                name: _,
                fn: De((x) => [
                  Se(D.$slots, _, _i(ln(x)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          re("div", _4, [
            (k(!0), U(Xe, null, ut(Y(A)(M), (_, N) => (k(), U("div", { key: N }, [
              re("button", {
                type: "button",
                class: we(["dp--qr-btn", {
                  "dp--qr-btn-active": _.active,
                  "dp--qr-btn-between": _.isBetween,
                  "dp--qr-btn-disabled": _.disabled,
                  "dp--highlighted": _.highlighted
                }]),
                "data-test-id": _.value,
                disabled: _.disabled,
                onClick: (x) => Y(g)(_.value, M, _.disabled),
                onMouseover: (x) => Y(h)(_.value)
              }, [
                D.$slots.quarter ? Se(D.$slots, "quarter", {
                  key: 0,
                  value: _.value,
                  text: _.text
                }) : (k(), U(Xe, { key: 1 }, [
                  Wi(_e(_.text), 1)
                ], 64))
              ], 42, k4)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), Uy = (t, e) => {
  const i = pe(0);
  It(() => {
    n(), window.addEventListener("resize", n, { passive: !0 });
  }), Nn(() => {
    window.removeEventListener("resize", n);
  });
  const n = () => {
    i.value = window.document.documentElement.clientWidth;
  };
  return {
    isMobile: J(
      () => i.value <= t.value.mobileBreakpoint && !e ? !0 : void 0
    )
  };
}, I4 = ["id", "tabindex", "role", "aria-label"], M4 = {
  key: 0,
  class: "dp--menu-load-container"
}, O4 = {
  key: 1,
  class: "dp--menu-header"
}, B4 = ["data-dp-mobile"], L4 = {
  key: 0,
  class: "dp__sidebar_left"
}, N4 = ["data-dp-mobile"], R4 = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], F4 = {
  key: 2,
  class: "dp__sidebar_right"
}, z4 = {
  key: 3,
  class: "dp__action_extra"
}, pg = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Hd,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "menu-blur"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, r = pe(null), a = J(() => {
      const { openOnTop: he, ...Re } = s;
      return {
        ...Re,
        isMobile: g.value,
        flowStep: H.value,
        menuWrapRef: r.value
      };
    }), { setMenuFocused: o, setShiftKey: l, control: u } = Oy(), d = Yi(), { defaultedTextInput: c, defaultedInline: A, defaultedConfig: m, defaultedUI: p, handleEventPropagation: h } = ei(s), { isMobile: g } = Uy(m, s.shadow), w = pe(null), b = pe(0), y = pe(null), D = pe(!1), I = pe(null), M = pe(!1), _ = (he) => {
      M.value = !0, m.value.allowPreventDefault && he.preventDefault(), hr(he, m.value, !0);
    };
    It(() => {
      if (!s.shadow) {
        D.value = !0, N(), window.addEventListener("resize", N);
        const he = bi(r);
        he && !c.value.enabled && !A.value.enabled && (o(!0), oe()), he && (he.addEventListener("pointerdown", _), he.addEventListener("mousedown", _));
      }
      document.addEventListener("mousedown", ot);
    }), Nn(() => {
      window.removeEventListener("resize", N), document.removeEventListener("mousedown", ot);
      const he = bi(r);
      he && (he.removeEventListener("pointerdown", _), he.removeEventListener("mousedown", _));
    });
    const N = () => {
      const he = bi(y);
      he && (b.value = he.getBoundingClientRect().width);
    }, { arrowRight: x, arrowLeft: C, arrowDown: L, arrowUp: V } = Tr(), { flowStep: H, updateFlowStep: O, childMount: X, resetFlow: q, handleFlow: F } = W4(s, n, I), W = J(() => s.monthPicker ? G7 : s.yearPicker ? Z7 : s.timePicker ? d4 : s.quarterPicker ? P4 : E4), j = J(() => {
      var he;
      if (m.value.arrowLeft) return m.value.arrowLeft;
      const Re = (he = r.value) == null ? void 0 : he.getBoundingClientRect(), dt = s.getInputRect();
      return (dt == null ? void 0 : dt.width) < (b == null ? void 0 : b.value) && (dt == null ? void 0 : dt.left) <= ((Re == null ? void 0 : Re.left) ?? 0) ? `${(dt == null ? void 0 : dt.width) / 2}px` : (dt == null ? void 0 : dt.right) >= ((Re == null ? void 0 : Re.right) ?? 0) && (dt == null ? void 0 : dt.width) < (b == null ? void 0 : b.value) ? `${(b == null ? void 0 : b.value) - (dt == null ? void 0 : dt.width) / 2}px` : "50%";
    }), oe = () => {
      const he = bi(r);
      he && he.focus({ preventScroll: !0 });
    }, $ = J(() => {
      var he;
      return ((he = I.value) == null ? void 0 : he.getSidebarProps()) || {};
    }), ye = () => {
      s.openOnTop && n("recalculate-position");
    }, ae = yn(d, "action"), ce = J(() => s.monthPicker || s.yearPicker ? yn(d, "monthYear") : s.timePicker ? yn(d, "timePicker") : yn(d, "shared")), te = J(() => s.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), le = J(() => ({
      dp__menu_disabled: s.disabled,
      dp__menu_readonly: s.readonly,
      "dp-menu-loading": s.loading
    })), B = J(
      () => ({
        dp__menu: !0,
        dp__menu_index: !A.value.enabled,
        dp__relative: A.value.enabled,
        ...p.value.menu ?? {}
      })
    ), ue = (he) => {
      hr(he, m.value, !0);
    }, Pe = (he) => {
      s.escClose && (n("close-picker"), h(he));
    }, nt = (he) => {
      if (s.arrowNavigation) {
        if (he === Ji.up) return V();
        if (he === Ji.down) return L();
        if (he === Ji.left) return C();
        if (he === Ji.right) return x();
      } else he === Ji.left || he === Ji.up ? K("handleArrow", Ji.left, 0, he === Ji.up) : K("handleArrow", Ji.right, 0, he === Ji.down);
    }, ge = (he) => {
      l(he.shiftKey), !s.disableMonthYearSelect && he.code === Xt.tab && he.target.classList.contains("dp__menu") && u.value.shiftKeyInMenu && (he.preventDefault(), hr(he, m.value, !0), n("close-picker"));
    }, Qe = () => {
      oe(), n("time-picker-close");
    }, Ee = (he) => {
      var Re, dt, St;
      (Re = I.value) == null || Re.toggleTimePicker(!1, !1), (dt = I.value) == null || dt.toggleMonthPicker(!1, !1, he), (St = I.value) == null || St.toggleYearPicker(!1, !1, he);
    }, xe = (he, Re = 0) => {
      var dt, St, Rt;
      return he === "month" ? (dt = I.value) == null ? void 0 : dt.toggleMonthPicker(!1, !0, Re) : he === "year" ? (St = I.value) == null ? void 0 : St.toggleYearPicker(!1, !0, Re) : he === "time" ? (Rt = I.value) == null ? void 0 : Rt.toggleTimePicker(!0, !1) : Ee(Re);
    }, K = (he, ...Re) => {
      var dt, St;
      (dt = I.value) != null && dt[he] && ((St = I.value) == null || St[he](...Re));
    }, Ie = () => {
      K("selectCurrentDate");
    }, Be = (he, Re) => {
      K("presetDate", kt(he), Re);
    }, Me = () => {
      K("clearHoverDate");
    }, Ke = (he, Re) => {
      K("updateMonthYear", he, Re);
    }, He = (he, Re) => {
      he.preventDefault(), nt(Re);
    }, Ge = (he) => {
      var Re, dt, St;
      if (ge(he), he.key === Xt.home || he.key === Xt.end)
        return K(
          "selectWeekDate",
          he.key === Xt.home,
          he.target.getAttribute("id")
        );
      switch ((he.key === Xt.pageUp || he.key === Xt.pageDown) && (he.shiftKey ? (K("changeYear", he.key === Xt.pageUp), (Re = hh(r.value, "overlay-year")) == null || Re.focus()) : (K("changeMonth", he.key === Xt.pageUp), (dt = hh(r.value, he.key === Xt.pageUp ? "action-prev" : "action-next")) == null || dt.focus()), he.target.getAttribute("id") && ((St = r.value) == null || St.focus({ preventScroll: !0 }))), he.key) {
        case Xt.esc:
          return Pe(he);
        case Xt.arrowLeft:
          return He(he, Ji.left);
        case Xt.arrowRight:
          return He(he, Ji.right);
        case Xt.arrowUp:
          return He(he, Ji.up);
        case Xt.arrowDown:
          return He(he, Ji.down);
        default:
          return;
      }
    }, ot = (he) => {
      var Re;
      A.value.enabled && !A.value.input && !((Re = r.value) != null && Re.contains(he.target)) && M.value && (M.value = !1, n("menu-blur"));
    };
    return e({
      updateMonthYear: Ke,
      switchView: xe,
      handleFlow: F,
      onValueCleared: () => {
        var he, Re;
        (Re = (he = I.value) == null ? void 0 : he.setStartTime) == null || Re.call(he);
      }
    }), (he, Re) => {
      var dt, St, Rt;
      return k(), U("div", {
        id: he.uid ? `dp-menu-${he.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: r,
        tabindex: Y(A).enabled ? void 0 : "0",
        role: Y(A).enabled ? void 0 : "dialog",
        "aria-label": (dt = he.ariaLabels) == null ? void 0 : dt.menu,
        class: we(B.value),
        style: Nt({ "--dp-arrow-left": j.value }),
        onMouseleave: Me,
        onClick: ue,
        onKeydown: Ge
      }, [
        (he.disabled || he.readonly) && Y(A).enabled || he.loading ? (k(), U("div", {
          key: 0,
          class: we(le.value)
        }, [
          he.loading ? (k(), U("div", M4, Re[19] || (Re[19] = [
            re("span", { class: "dp--menu-loader" }, null, -1)
          ]))) : ie("", !0)
        ], 2)) : ie("", !0),
        he.$slots["menu-header"] ? (k(), U("div", O4, [
          Se(he.$slots, "menu-header")
        ])) : ie("", !0),
        !Y(A).enabled && !he.teleportCenter ? (k(), U("div", {
          key: 2,
          class: we(te.value)
        }, null, 2)) : ie("", !0),
        re("div", {
          ref_key: "innerMenuRef",
          ref: y,
          class: we({
            dp__menu_content_wrapper: ((St = he.presetDates) == null ? void 0 : St.length) || !!he.$slots["left-sidebar"] || !!he.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": t.collapse && (((Rt = he.presetDates) == null ? void 0 : Rt.length) || !!he.$slots["left-sidebar"] || !!he.$slots["right-sidebar"])
          }),
          "data-dp-mobile": Y(g),
          style: Nt({ "--dp-menu-width": `${b.value}px` })
        }, [
          he.$slots["left-sidebar"] ? (k(), U("div", L4, [
            Se(he.$slots, "left-sidebar", _i(ln($.value)))
          ])) : ie("", !0),
          he.presetDates.length ? (k(), U("div", {
            key: 1,
            class: we({ "dp--preset-dates-collapsed": t.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": Y(g)
          }, [
            (k(!0), U(Xe, null, ut(he.presetDates, (je, Et) => (k(), U(Xe, { key: Et }, [
              je.slot ? Se(he.$slots, je.slot, {
                key: 0,
                presetDate: Be,
                label: je.label,
                value: je.value
              }) : (k(), U("button", {
                key: 1,
                type: "button",
                style: Nt(je.style || {}),
                class: we(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": t.collapse }]),
                "data-test-id": je.testId ?? void 0,
                "data-dp-mobile": Y(g),
                onClick: $t((Mi) => Be(je.value, je.noTz), ["prevent"]),
                onKeydown: (Mi) => Y(tn)(Mi, () => Be(je.value, je.noTz), !0)
              }, _e(je.label), 47, R4))
            ], 64))), 128))
          ], 10, N4)) : ie("", !0),
          re("div", {
            ref_key: "calendarWrapperRef",
            ref: w,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (k(), Ce(Ft(W.value), Ut({
              ref_key: "dynCmpRef",
              ref: I
            }, a.value, {
              "flow-step": Y(H),
              onMount: Y(X),
              onUpdateFlowStep: Y(O),
              onResetFlow: Y(q),
              onFocusMenu: oe,
              onSelectDate: Re[0] || (Re[0] = (je) => he.$emit("select-date")),
              onDateUpdate: Re[1] || (Re[1] = (je) => he.$emit("date-update", je)),
              onTooltipOpen: Re[2] || (Re[2] = (je) => he.$emit("tooltip-open", je)),
              onTooltipClose: Re[3] || (Re[3] = (je) => he.$emit("tooltip-close", je)),
              onAutoApply: Re[4] || (Re[4] = (je) => he.$emit("auto-apply", je)),
              onRangeStart: Re[5] || (Re[5] = (je) => he.$emit("range-start", je)),
              onRangeEnd: Re[6] || (Re[6] = (je) => he.$emit("range-end", je)),
              onInvalidFixedRange: Re[7] || (Re[7] = (je) => he.$emit("invalid-fixed-range", je)),
              onTimeUpdate: Re[8] || (Re[8] = (je) => he.$emit("time-update")),
              onAmPmChange: Re[9] || (Re[9] = (je) => he.$emit("am-pm-change", je)),
              onTimePickerOpen: Re[10] || (Re[10] = (je) => he.$emit("time-picker-open", je)),
              onTimePickerClose: Qe,
              onRecalculatePosition: ye,
              onUpdateMonthYear: Re[11] || (Re[11] = (je) => he.$emit("update-month-year", je)),
              onAutoApplyInvalid: Re[12] || (Re[12] = (je) => he.$emit("auto-apply-invalid", je)),
              onInvalidDate: Re[13] || (Re[13] = (je) => he.$emit("invalid-date", je)),
              onOverlayToggle: Re[14] || (Re[14] = (je) => he.$emit("overlay-toggle", je)),
              "onUpdate:internalModelValue": Re[15] || (Re[15] = (je) => he.$emit("update:internal-model-value", je))
            }), wi({ _: 2 }, [
              ut(ce.value, (je, Et) => ({
                name: je,
                fn: De((Mi) => [
                  Se(he.$slots, je, _i(ln({ ...Mi })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          he.$slots["right-sidebar"] ? (k(), U("div", F4, [
            Se(he.$slots, "right-sidebar", _i(ln($.value)))
          ])) : ie("", !0),
          he.$slots["action-extra"] ? (k(), U("div", z4, [
            he.$slots["action-extra"] ? Se(he.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: Ie
            }) : ie("", !0)
          ])) : ie("", !0)
        ], 14, B4),
        !he.autoApply || Y(m).keepActionRow ? (k(), Ce(z7, Ut({
          key: 3,
          "menu-mount": D.value
        }, a.value, {
          "calendar-width": b.value,
          onClosePicker: Re[16] || (Re[16] = (je) => he.$emit("close-picker")),
          onSelectDate: Re[17] || (Re[17] = (je) => he.$emit("select-date")),
          onInvalidSelect: Re[18] || (Re[18] = (je) => he.$emit("invalid-select")),
          onSelectNow: Ie
        }), wi({ _: 2 }, [
          ut(Y(ae), (je, Et) => ({
            name: je,
            fn: De((Mi) => [
              Se(he.$slots, je, _i(ln({ ...Mi })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : ie("", !0)
      ], 46, I4);
    };
  }
});
var wa = /* @__PURE__ */ ((t) => (t.center = "center", t.left = "left", t.right = "right", t))(wa || {});
const U4 = ({
  menuRef: t,
  menuRefInner: e,
  inputRef: i,
  pickerWrapperRef: n,
  inline: s,
  emit: r,
  props: a,
  slots: o
}) => {
  const { defaultedConfig: l } = ei(a), u = pe({}), d = pe(!1), c = pe({
    top: "0",
    left: "0"
  }), A = pe(!1), m = Ha(a, "teleportCenter");
  mt(m, () => {
    c.value = JSON.parse(JSON.stringify({})), I();
  });
  const p = (q) => {
    if (a.teleport) {
      const F = q.getBoundingClientRect();
      return {
        left: F.left + window.scrollX,
        top: F.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, h = (q, F) => {
    c.value.left = `${q + F - u.value.width}px`;
  }, g = (q) => {
    c.value.left = `${q}px`;
  }, w = (q, F) => {
    a.position === wa.left && g(q), a.position === wa.right && h(q, F), a.position === wa.center && (c.value.left = `${q + F / 2 - u.value.width / 2}px`);
  }, b = (q) => {
    const { width: F, height: W } = q.getBoundingClientRect(), { top: j, left: oe } = p(q);
    return { top: +j, left: +oe, width: F, height: W };
  }, y = () => {
    c.value.left = "50%", c.value.top = "50%", c.value.transform = "translate(-50%, -50%)", c.value.position = "fixed", delete c.value.opacity;
  }, D = () => {
    const q = bi(i);
    c.value = a.altPosition(q);
  }, I = (q = !0) => {
    var F;
    if (!s.value.enabled) {
      if (m.value) return y();
      if (a.altPosition !== null) return D();
      if (q) {
        const W = a.teleport ? (F = e.value) == null ? void 0 : F.$el : t.value;
        W && (u.value = W.getBoundingClientRect()), r("recalculate-position");
      }
      return V();
    }
  }, M = ({ inputEl: q, left: F, width: W }) => {
    window.screen.width > 768 && !d.value && w(F, W), x(q);
  }, _ = (q) => {
    const { top: F, left: W, height: j, width: oe } = b(q);
    c.value.top = `${j + F + +a.offset}px`, A.value = !1, d.value || (c.value.left = `${W + oe / 2 - u.value.width / 2}px`), M({ inputEl: q, left: W, width: oe });
  }, N = (q) => {
    const { top: F, left: W, width: j } = b(q);
    c.value.top = `${F - +a.offset - u.value.height}px`, A.value = !0, M({ inputEl: q, left: W, width: j });
  }, x = (q) => {
    if (a.autoPosition) {
      const { left: F, width: W } = b(q), { left: j, right: oe } = u.value;
      if (!d.value) {
        if (Math.abs(j) !== Math.abs(oe)) {
          if (j <= 0)
            return d.value = !0, g(F);
          if (oe >= document.documentElement.clientWidth)
            return d.value = !0, h(F, W);
        }
        return w(F, W);
      }
    }
  }, C = () => {
    const q = bi(i);
    if (q) {
      if (a.autoPosition === Qn.top) return Qn.top;
      if (a.autoPosition === Qn.bottom) return Qn.bottom;
      const { height: F } = u.value, { top: W, height: j } = q.getBoundingClientRect(), oe = window.innerHeight - W - j, $ = W;
      return F <= oe ? Qn.bottom : F > oe && F <= $ ? Qn.top : oe >= $ ? Qn.bottom : Qn.top;
    }
    return Qn.bottom;
  }, L = (q) => C() === Qn.bottom ? _(q) : N(q), V = () => {
    const q = bi(i);
    if (q)
      return a.autoPosition ? L(q) : _(q);
  }, H = function(q) {
    if (q) {
      const F = q.scrollHeight > q.clientHeight, W = window.getComputedStyle(q).overflowY.indexOf("hidden") !== -1;
      return F && !W;
    }
    return !0;
  }, O = function(q) {
    return !q || q === document.body || q.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : H(q) ? q : O(
      q.assignedSlot && l.value.shadowDom ? q.assignedSlot.parentNode : q.parentNode
    );
  }, X = (q) => {
    if (q)
      switch (a.position) {
        case wa.left:
          return { left: 0, transform: "translateX(0)" };
        case wa.right:
          return { left: `${q.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${q.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: A,
    menuStyle: c,
    xCorrect: d,
    setMenuPosition: I,
    getScrollableParent: O,
    shadowRender: (q, F, W) => {
      var j, oe, $;
      const ye = document.createElement("div"), ae = (j = bi(i)) == null ? void 0 : j.getBoundingClientRect();
      ye.setAttribute("id", "dp--temp-container");
      const ce = (oe = n.value) != null && oe.clientWidth ? n.value : document.body;
      ce.append(ye);
      const te = X(ae), le = l.value.shadowDom ? Object.keys(o).filter(
        (ue) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(ue)
      ) : Object.keys(o), B = M2(
        F,
        {
          ...W,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...te }
        },
        Object.fromEntries(le.map((ue) => [ue, o[ue]]))
      );
      q != null && (B.appContext = q.appContext), $f(B, ye), u.value = ($ = B.el) == null ? void 0 : $.getBoundingClientRect(), $f(null, ye), ce.removeChild(ye);
    }
  };
}, er = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], V4 = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], q4 = {
  all: () => er,
  monthYear: () => er.filter((t) => t.use.includes("month-year")),
  input: () => V4,
  timePicker: () => er.filter((t) => t.use.includes("time")),
  action: () => er.filter((t) => t.use.includes("action")),
  calendar: () => er.filter((t) => t.use.includes("calendar")),
  menu: () => er.filter((t) => t.use.includes("menu")),
  shared: () => er.filter((t) => t.use.includes("shared")),
  yearMode: () => er.filter((t) => t.use.includes("year-mode"))
}, yn = (t, e, i) => {
  const n = [];
  return q4[e]().forEach((s) => {
    t[s.name] && n.push(s.name);
  }), i != null && i.length && i.forEach((s) => {
    s.slot && n.push(s.slot);
  }), n;
}, Vl = (t) => {
  const e = J(() => (n) => t.value ? n ? t.value.open : t.value.close : ""), i = J(() => (n) => t.value ? n ? t.value.menuAppearTop : t.value.menuAppearBottom : "");
  return { transitionName: e, showTransition: !!t.value, menuTransition: i };
}, ql = (t, e, i) => {
  const { defaultedRange: n, defaultedTz: s } = ei(t), r = Oe(un(Oe(), s.value.timezone)), a = pe([{ month: vt(r), year: lt(r) }]), o = (A) => {
    const m = {
      hours: Hs(r),
      minutes: gr(r),
      seconds: 0
    };
    return n.value.enabled ? [m[A], m[A]] : m[A];
  }, l = Jr({
    hours: o("hours"),
    minutes: o("minutes"),
    seconds: o("seconds")
  });
  mt(
    n,
    (A, m) => {
      A.enabled !== m.enabled && (l.hours = o("hours"), l.minutes = o("minutes"), l.seconds = o("seconds"));
    },
    { deep: !0 }
  );
  const u = J({
    get: () => t.internalModelValue,
    set: (A) => {
      !t.readonly && !t.disabled && e("update:internal-model-value", A);
    }
  }), d = J(
    () => (A) => a.value[A] ? a.value[A].month : 0
  ), c = J(
    () => (A) => a.value[A] ? a.value[A].year : 0
  );
  return mt(
    u,
    (A, m) => {
      i && JSON.stringify(A ?? {}) !== JSON.stringify(m ?? {}) && i();
    },
    { deep: !0 }
  ), {
    calendars: a,
    time: l,
    modelValue: u,
    month: d,
    year: c,
    today: r
  };
}, H4 = (t, e) => {
  const {
    defaultedMultiCalendars: i,
    defaultedMultiDates: n,
    defaultedUI: s,
    defaultedHighlight: r,
    defaultedTz: a,
    propDates: o,
    defaultedRange: l
  } = ei(e), { isDisabled: u } = xr(e), d = pe(null), c = pe(un(/* @__PURE__ */ new Date(), a.value.timezone)), A = (B) => {
    !B.current && e.hideOffsetDates || (d.value = B.value);
  }, m = () => {
    d.value = null;
  }, p = (B) => Array.isArray(t.value) && l.value.enabled && t.value[0] && d.value ? B ? hi(d.value, t.value[0]) : ai(d.value, t.value[0]) : !0, h = (B, ue) => {
    const Pe = () => t.value ? ue ? t.value[0] || null : t.value[1] : null, nt = t.value && Array.isArray(t.value) ? Pe() : null;
    return yt(Oe(B.value), nt);
  }, g = (B) => {
    const ue = Array.isArray(t.value) ? t.value[0] : null;
    return B ? !ai(d.value ?? null, ue) : !0;
  }, w = (B, ue = !0) => (l.value.enabled || e.weekPicker) && Array.isArray(t.value) && t.value.length === 2 ? e.hideOffsetDates && !B.current ? !1 : yt(Oe(B.value), t.value[ue ? 0 : 1]) : l.value.enabled ? h(B, ue) && g(ue) || yt(B.value, Array.isArray(t.value) ? t.value[0] : null) && p(ue) : !1, b = (B, ue) => {
    if (Array.isArray(t.value) && t.value[0] && t.value.length === 1) {
      const Pe = yt(B.value, d.value);
      return ue ? hi(t.value[0], B.value) && Pe : ai(t.value[0], B.value) && Pe;
    }
    return !1;
  }, y = (B) => !t.value || e.hideOffsetDates && !B.current ? !1 : l.value.enabled ? e.modelAuto && Array.isArray(t.value) ? yt(B.value, t.value[0] ? t.value[0] : c.value) : !1 : n.value.enabled && Array.isArray(t.value) ? t.value.some((ue) => yt(ue, B.value)) : yt(B.value, t.value ? t.value : c.value), D = (B) => {
    if (l.value.autoRange || e.weekPicker) {
      if (d.value) {
        if (e.hideOffsetDates && !B.current) return !1;
        const ue = In(d.value, +l.value.autoRange), Pe = Bs(Oe(d.value), e.weekStart);
        return e.weekPicker ? yt(Pe[1], Oe(B.value)) : yt(ue, Oe(B.value));
      }
      return !1;
    }
    return !1;
  }, I = (B) => {
    if (l.value.autoRange || e.weekPicker) {
      if (d.value) {
        const ue = In(d.value, +l.value.autoRange);
        if (e.hideOffsetDates && !B.current) return !1;
        const Pe = Bs(Oe(d.value), e.weekStart);
        return e.weekPicker ? hi(B.value, Pe[0]) && ai(B.value, Pe[1]) : hi(B.value, d.value) && ai(B.value, ue);
      }
      return !1;
    }
    return !1;
  }, M = (B) => {
    if (l.value.autoRange || e.weekPicker) {
      if (d.value) {
        if (e.hideOffsetDates && !B.current) return !1;
        const ue = Bs(Oe(d.value), e.weekStart);
        return e.weekPicker ? yt(ue[0], B.value) : yt(d.value, B.value);
      }
      return !1;
    }
    return !1;
  }, _ = (B) => El(t.value, d.value, B.value), N = () => e.modelAuto && Array.isArray(e.internalModelValue) ? !!e.internalModelValue[0] : !1, x = () => e.modelAuto ? wy(e.internalModelValue) : !0, C = (B) => {
    if (e.weekPicker) return !1;
    const ue = l.value.enabled ? !w(B) && !w(B, !1) : !0;
    return !u(B.value) && !y(B) && !(!B.current && e.hideOffsetDates) && ue;
  }, L = (B) => l.value.enabled ? e.modelAuto ? N() && y(B) : !1 : y(B), V = (B) => r.value ? l7(B.value, o.value.highlight) : !1, H = (B) => {
    const ue = u(B.value);
    return ue && (typeof r.value == "function" ? !r.value(B.value, ue) : !r.value.options.highlightDisabled);
  }, O = (B) => {
    var ue;
    return typeof r.value == "function" ? r.value(B.value) : (ue = r.value.weekdays) == null ? void 0 : ue.includes(B.value.getDay());
  }, X = (B) => (l.value.enabled || e.weekPicker) && (!(i.value.count > 0) || B.current) && x() && !(!B.current && e.hideOffsetDates) && !y(B) ? _(B) : !1, q = (B) => {
    if (Array.isArray(t.value) && t.value.length === 1) {
      const { before: ue, after: Pe } = dg(+l.value.maxRange, t.value[0]);
      return Za(B.value, ue) || ea(B.value, Pe);
    }
    return !1;
  }, F = (B) => {
    if (Array.isArray(t.value) && t.value.length === 1) {
      const { before: ue, after: Pe } = dg(+l.value.minRange, t.value[0]);
      return El([ue, Pe], t.value[0], B.value);
    }
    return !1;
  }, W = (B) => l.value.enabled && (l.value.maxRange || l.value.minRange) ? l.value.maxRange && l.value.minRange ? q(B) || F(B) : l.value.maxRange ? q(B) : F(B) : !1, j = (B) => {
    const { isRangeStart: ue, isRangeEnd: Pe } = ae(B), nt = l.value.enabled ? ue || Pe : !1;
    return {
      dp__cell_offset: !B.current,
      dp__pointer: !e.disabled && !(!B.current && e.hideOffsetDates) && !u(B.value) && !W(B),
      dp__cell_disabled: u(B.value) || W(B),
      dp__cell_highlight: !H(B) && (V(B) || O(B)) && !L(B) && !nt && !M(B) && !(X(B) && e.weekPicker) && !Pe,
      dp__cell_highlight_active: !H(B) && (V(B) || O(B)) && L(B),
      dp__today: !e.noToday && yt(B.value, c.value) && B.current,
      "dp--past": ai(B.value, c.value),
      "dp--future": hi(B.value, c.value)
    };
  }, oe = (B) => ({
    dp__active_date: L(B),
    dp__date_hover: C(B)
  }), $ = (B) => {
    if (t.value && !Array.isArray(t.value)) {
      const ue = Bs(t.value, e.weekStart);
      return {
        ...te(B),
        dp__range_start: yt(ue[0], B.value),
        dp__range_end: yt(ue[1], B.value),
        dp__range_between_week: hi(B.value, ue[0]) && ai(B.value, ue[1])
      };
    }
    return {
      ...te(B)
    };
  }, ye = (B) => {
    if (t.value && Array.isArray(t.value)) {
      const ue = Bs(t.value[0], e.weekStart), Pe = t.value[1] ? Bs(t.value[1], e.weekStart) : [];
      return {
        ...te(B),
        dp__range_start: yt(ue[0], B.value) || yt(Pe[0], B.value),
        dp__range_end: yt(ue[1], B.value) || yt(Pe[1], B.value),
        dp__range_between_week: hi(B.value, ue[0]) && ai(B.value, ue[1]) || hi(B.value, Pe[0]) && ai(B.value, Pe[1]),
        dp__range_between: hi(B.value, ue[1]) && ai(B.value, Pe[0])
      };
    }
    return {
      ...te(B)
    };
  }, ae = (B) => {
    const ue = i.value.count > 0 ? B.current && w(B) && x() : w(B) && x(), Pe = i.value.count > 0 ? B.current && w(B, !1) && x() : w(B, !1) && x();
    return { isRangeStart: ue, isRangeEnd: Pe };
  }, ce = (B) => {
    const { isRangeStart: ue, isRangeEnd: Pe } = ae(B);
    return {
      dp__range_start: ue,
      dp__range_end: Pe,
      dp__range_between: X(B),
      dp__date_hover: yt(B.value, d.value) && !ue && !Pe && !e.weekPicker,
      dp__date_hover_start: b(B, !0),
      dp__date_hover_end: b(B, !1)
    };
  }, te = (B) => ({
    ...ce(B),
    dp__cell_auto_range: I(B),
    dp__cell_auto_range_start: M(B),
    dp__cell_auto_range_end: D(B)
  }), le = (B) => l.value.enabled ? l.value.autoRange ? te(B) : e.modelAuto ? { ...oe(B), ...ce(B) } : e.weekPicker ? ye(B) : ce(B) : e.weekPicker ? $(B) : oe(B);
  return {
    setHoverDate: A,
    clearHoverDate: m,
    getDayClassData: (B) => e.hideOffsetDates && !B.current ? {} : {
      ...j(B),
      ...le(B),
      [e.dayClass ? e.dayClass(B.value, e.internalModelValue) : ""]: !0,
      ...s.value.calendarCell ?? {}
    }
  };
}, xr = (t) => {
  const { defaultedFilters: e, defaultedRange: i, propDates: n, defaultedMultiDates: s } = ei(t), r = (O) => n.value.disabledDates ? typeof n.value.disabledDates == "function" ? n.value.disabledDates(Oe(O)) : !!ad(O, n.value.disabledDates) : !1, a = (O) => n.value.maxDate ? t.yearPicker ? lt(O) > lt(n.value.maxDate) : hi(O, n.value.maxDate) : !1, o = (O) => n.value.minDate ? t.yearPicker ? lt(O) < lt(n.value.minDate) : ai(O, n.value.minDate) : !1, l = (O) => {
    const X = a(O), q = o(O), F = r(O), W = e.value.months.map((ae) => +ae).includes(vt(O)), j = t.disabledWeekDays.length ? t.disabledWeekDays.some((ae) => +ae === OM(O)) : !1, oe = m(O), $ = lt(O), ye = $ < +t.yearRange[0] || $ > +t.yearRange[1];
    return !(X || q || F || W || ye || j || oe);
  }, u = (O, X) => ai(...cr(n.value.minDate, O, X)) || yt(...cr(n.value.minDate, O, X)), d = (O, X) => hi(...cr(n.value.maxDate, O, X)) || yt(...cr(n.value.maxDate, O, X)), c = (O, X, q) => {
    let F = !1;
    return n.value.maxDate && q && d(O, X) && (F = !0), n.value.minDate && !q && u(O, X) && (F = !0), F;
  }, A = (O, X, q, F) => {
    let W = !1;
    return F && (n.value.minDate || n.value.maxDate) ? n.value.minDate && n.value.maxDate ? W = c(O, X, q) : (n.value.minDate && u(O, X) || n.value.maxDate && d(O, X)) && (W = !0) : W = !0, W;
  }, m = (O) => Array.isArray(n.value.allowedDates) && !n.value.allowedDates.length ? !0 : n.value.allowedDates ? !ad(O, n.value.allowedDates, Sy(t.monthPicker, t.yearPicker)) : !1, p = (O) => !l(O), h = (O) => i.value.noDisabledRange ? !V0({ start: O[0], end: O[1] }).some((X) => p(X)) : !0, g = (O) => {
    if (O) {
      const X = lt(O);
      return X >= +t.yearRange[0] && X <= t.yearRange[1];
    }
    return !0;
  }, w = (O, X) => !!(Array.isArray(O) && O[X] && (i.value.maxRange || i.value.minRange) && g(O[X])), b = (O, X, q = 0) => {
    if (w(X, q) && g(O)) {
      const F = F0(O, X[q]), W = _y(X[q], O), j = W.length === 1 ? 0 : W.filter(($) => p($)).length, oe = Math.abs(F) - (i.value.minMaxRawRange ? 0 : j);
      if (i.value.minRange && i.value.maxRange)
        return oe >= +i.value.minRange && oe <= +i.value.maxRange;
      if (i.value.minRange) return oe >= +i.value.minRange;
      if (i.value.maxRange) return oe <= +i.value.maxRange;
    }
    return !0;
  }, y = () => !t.enableTimePicker || t.monthPicker || t.yearPicker || t.ignoreTimeValidation, D = (O) => Array.isArray(O) ? [O[0] ? nf(O[0]) : null, O[1] ? nf(O[1]) : null] : nf(O), I = (O, X, q) => O.find(
    (F) => +F.hours === Hs(X) && F.minutes === "*" ? !0 : +F.minutes === gr(X) && +F.hours === Hs(X)
  ) && q, M = (O, X, q) => {
    const [F, W] = O, [j, oe] = X;
    return !I(F, j, q) && !I(W, oe, q) && q;
  }, _ = (O, X) => {
    const q = Array.isArray(X) ? X : [X];
    return Array.isArray(t.disabledTimes) ? Array.isArray(t.disabledTimes[0]) ? M(t.disabledTimes, q, O) : !q.some((F) => I(t.disabledTimes, F, O)) : O;
  }, N = (O, X) => {
    const q = Array.isArray(X) ? [Yr(X[0]), X[1] ? Yr(X[1]) : void 0] : Yr(X), F = !t.disabledTimes(q);
    return O && F;
  }, x = (O, X) => t.disabledTimes ? Array.isArray(t.disabledTimes) ? _(X, O) : N(X, O) : X, C = (O) => {
    let X = !0;
    if (!O || y()) return !0;
    const q = !n.value.minDate && !n.value.maxDate ? D(O) : O;
    return (t.maxTime || n.value.maxDate) && (X = ug(
      t.maxTime,
      n.value.maxDate,
      "max",
      xi(q),
      X
    )), (t.minTime || n.value.minDate) && (X = ug(
      t.minTime,
      n.value.minDate,
      "min",
      xi(q),
      X
    )), x(O, X);
  }, L = (O) => {
    if (!t.monthPicker) return !0;
    let X = !0;
    const q = Oe(Jn(O));
    if (n.value.minDate && n.value.maxDate) {
      const F = Oe(Jn(n.value.minDate)), W = Oe(Jn(n.value.maxDate));
      return hi(q, F) && ai(q, W) || yt(q, F) || yt(q, W);
    }
    if (n.value.minDate) {
      const F = Oe(Jn(n.value.minDate));
      X = hi(q, F) || yt(q, F);
    }
    if (n.value.maxDate) {
      const F = Oe(Jn(n.value.maxDate));
      X = ai(q, F) || yt(q, F);
    }
    return X;
  }, V = J(() => (O) => !t.enableTimePicker || t.ignoreTimeValidation ? !0 : C(O)), H = J(() => (O) => t.monthPicker ? Array.isArray(O) && (i.value.enabled || s.value.enabled) ? !O.filter((X) => !L(X)).length : L(O) : !0);
  return {
    isDisabled: p,
    validateDate: l,
    validateMonthYearInRange: A,
    isDateRangeAllowed: h,
    checkMinMaxRange: b,
    isValidTime: C,
    isTimeValid: V,
    isMonthValid: H
  };
}, Xd = () => {
  const t = J(() => (n, s) => n == null ? void 0 : n.includes(s)), e = J(() => (n, s) => n.count ? n.solo ? !0 : s === 0 : !0), i = J(() => (n, s) => n.count ? n.solo ? !0 : s === n.count - 1 : !0);
  return { hideNavigationButtons: t, showLeftIcon: e, showRightIcon: i };
}, W4 = (t, e, i) => {
  const n = pe(0), s = Jr({
    [Wr.timePicker]: !t.enableTimePicker || t.timePicker || t.monthPicker,
    [Wr.calendar]: !1,
    [Wr.header]: !1
  }), r = J(() => t.monthPicker || t.timePicker), a = (c) => {
    var A;
    if ((A = t.flow) != null && A.length) {
      if (!c && r.value) return d();
      s[c] = !0, Object.keys(s).filter((m) => !s[m]).length || d();
    }
  }, o = () => {
    var c, A;
    (c = t.flow) != null && c.length && n.value !== -1 && (n.value += 1, e("flow-step", n.value), d()), ((A = t.flow) == null ? void 0 : A.length) === n.value && li().then(() => l());
  }, l = () => {
    n.value = -1;
  }, u = (c, A, ...m) => {
    var p, h;
    t.flow[n.value] === c && i.value && ((h = (p = i.value)[A]) == null || h.call(p, ...m));
  }, d = (c = 0) => {
    c && (n.value += c), u(Ui.month, "toggleMonthPicker", !0), u(Ui.year, "toggleYearPicker", !0), u(Ui.calendar, "toggleTimePicker", !1, !0), u(Ui.time, "toggleTimePicker", !0, !0);
    const A = t.flow[n.value];
    (A === Ui.hours || A === Ui.minutes || A === Ui.seconds) && u(A, "toggleTimePicker", !0, !0, A);
  };
  return { childMount: a, updateFlowStep: o, resetFlow: l, handleFlow: d, flowStep: n };
}, Y4 = {
  key: 1,
  class: "dp__input_wrap"
}, X4 = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], j4 = {
  key: 2,
  class: "dp--clear-btn"
}, G4 = ["aria-label"], Q4 = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Hd
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, {
      defaultedTextInput: r,
      defaultedAriaLabels: a,
      defaultedInline: o,
      defaultedConfig: l,
      defaultedRange: u,
      defaultedMultiDates: d,
      defaultedUI: c,
      getDefaultPattern: A,
      getDefaultStartTime: m
    } = ei(s), { checkMinMaxRange: p } = xr(s), h = pe(), g = pe(null), w = pe(!1), b = pe(!1), y = J(
      () => ({
        dp__pointer: !s.disabled && !s.readonly && !r.value.enabled,
        dp__disabled: s.disabled,
        dp__input_readonly: !r.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !s.hideInputIcon,
        dp__input_valid: typeof s.state == "boolean" ? s.state : !1,
        dp__input_invalid: typeof s.state == "boolean" ? !s.state : !1,
        dp__input_focus: w.value || s.isMenuOpen,
        dp__input_reg: !r.value.enabled,
        ...c.value.input ?? {}
      })
    ), D = () => {
      n("set-input-date", null), s.clearable && s.autoApply && (n("set-empty-date"), h.value = null);
    }, I = ($) => {
      const ye = m();
      return d7(
        $,
        r.value.format ?? A(),
        ye ?? ky({}, s.enableSeconds),
        s.inputValue,
        b.value,
        s.formatLocale
      );
    }, M = ($) => {
      const { rangeSeparator: ye } = r.value, [ae, ce] = $.split(`${ye}`);
      if (ae) {
        const te = I(ae.trim()), le = ce ? I(ce.trim()) : void 0;
        if (ea(te, le)) return;
        const B = te && le ? [te, le] : [te];
        p(le, B, 0) && (h.value = te ? B : null);
      }
    }, _ = () => {
      b.value = !0;
    }, N = ($) => {
      if (u.value.enabled)
        M($);
      else if (d.value.enabled) {
        const ye = $.split(";");
        h.value = ye.map((ae) => I(ae.trim())).filter((ae) => ae);
      } else
        h.value = I($);
    }, x = ($) => {
      var ye;
      const ae = typeof $ == "string" ? $ : (ye = $.target) == null ? void 0 : ye.value;
      ae !== "" ? (r.value.openMenu && !s.isMenuOpen && n("open"), N(ae), n("set-input-date", h.value)) : D(), b.value = !1, n("update:input-value", ae), n("text-input", $, h.value);
    }, C = ($) => {
      r.value.enabled ? (N($.target.value), r.value.enterSubmit && ph(h.value) && s.inputValue !== "" ? (n("set-input-date", h.value, !0), h.value = null) : r.value.enterSubmit && s.inputValue === "" && (h.value = null, n("clear"))) : H($);
    }, L = ($, ye) => {
      r.value.enabled && r.value.tabSubmit && !ye && N($.target.value), r.value.tabSubmit && ph(h.value) && s.inputValue !== "" ? (n("set-input-date", h.value, !0, !0), h.value = null) : r.value.tabSubmit && s.inputValue === "" && (h.value = null, n("clear", !0));
    }, V = () => {
      w.value = !0, n("focus"), li().then(() => {
        var $;
        r.value.enabled && r.value.selectOnFocus && (($ = g.value) == null || $.select());
      });
    }, H = ($) => {
      if (hr($, l.value, !0), r.value.enabled && r.value.openMenu && !o.value.input) {
        if (r.value.openMenu === "open" && !s.isMenuOpen) return n("open");
        if (r.value.openMenu === "toggle") return n("toggle");
      } else r.value.enabled || n("toggle");
    }, O = () => {
      n("real-blur"), w.value = !1, (!s.isMenuOpen || o.value.enabled && o.value.input) && n("blur"), s.autoApply && r.value.enabled && h.value && !s.isMenuOpen && (n("set-input-date", h.value), n("select-date"), h.value = null);
    }, X = ($) => {
      hr($, l.value, !0), n("clear");
    }, q = () => {
      n("close");
    }, F = ($) => {
      if ($.key === "Tab" && L($), $.key === "Enter" && C($), $.key === "Escape" && r.value.escClose && q(), !r.value.enabled) {
        if ($.code === "Tab") return;
        $.preventDefault();
      }
    }, W = () => {
      var $;
      ($ = g.value) == null || $.focus({ preventScroll: !0 });
    }, j = ($) => {
      h.value = $;
    }, oe = ($) => {
      $.key === Xt.tab && L($, !0);
    };
    return e({
      focusInput: W,
      setParsedDate: j
    }), ($, ye) => {
      var ae, ce, te;
      return k(), U("div", { onClick: H }, [
        $.$slots.trigger && !$.$slots["dp-input"] && !Y(o).enabled ? Se($.$slots, "trigger", { key: 0 }) : ie("", !0),
        !$.$slots.trigger && (!Y(o).enabled || Y(o).input) ? (k(), U("div", Y4, [
          $.$slots["dp-input"] && !$.$slots.trigger && (!Y(o).enabled || Y(o).enabled && Y(o).input) ? Se($.$slots, "dp-input", {
            key: 0,
            value: t.inputValue,
            isMenuOpen: t.isMenuOpen,
            onInput: x,
            onEnter: C,
            onTab: L,
            onClear: X,
            onBlur: O,
            onKeypress: F,
            onPaste: _,
            onFocus: V,
            openMenu: () => $.$emit("open"),
            closeMenu: () => $.$emit("close"),
            toggleMenu: () => $.$emit("toggle")
          }) : ie("", !0),
          $.$slots["dp-input"] ? ie("", !0) : (k(), U("input", {
            key: 1,
            id: $.uid ? `dp-input-${$.uid}` : void 0,
            ref_key: "inputRef",
            ref: g,
            "data-test-id": "dp-input",
            name: $.name,
            class: we(y.value),
            inputmode: Y(r).enabled ? "text" : "none",
            placeholder: $.placeholder,
            disabled: $.disabled,
            readonly: $.readonly,
            required: $.required,
            value: t.inputValue,
            autocomplete: $.autocomplete,
            "aria-label": (ae = Y(a)) == null ? void 0 : ae.input,
            "aria-disabled": $.disabled || void 0,
            "aria-invalid": $.state === !1 ? !0 : void 0,
            onInput: x,
            onBlur: O,
            onFocus: V,
            onKeypress: F,
            onKeydown: ye[0] || (ye[0] = (le) => F(le)),
            onPaste: _
          }, null, 42, X4)),
          re("div", {
            onClick: ye[3] || (ye[3] = (le) => n("toggle"))
          }, [
            $.$slots["input-icon"] && !$.hideInputIcon ? (k(), U("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: ye[1] || (ye[1] = (le) => n("toggle"))
            }, [
              Se($.$slots, "input-icon")
            ])) : ie("", !0),
            !$.$slots["input-icon"] && !$.hideInputIcon && !$.$slots["dp-input"] ? (k(), Ce(Y(go), {
              key: 1,
              "aria-label": (ce = Y(a)) == null ? void 0 : ce.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: ye[2] || (ye[2] = (le) => n("toggle"))
            }, null, 8, ["aria-label"])) : ie("", !0)
          ]),
          $.$slots["clear-icon"] && ($.alwaysClearable || t.inputValue && $.clearable && !$.disabled && !$.readonly) ? (k(), U("span", j4, [
            Se($.$slots, "clear-icon", { clear: X })
          ])) : ie("", !0),
          !$.$slots["clear-icon"] && ($.alwaysClearable || $.clearable && t.inputValue && !$.disabled && !$.readonly) ? (k(), U("button", {
            key: 3,
            "aria-label": (te = Y(a)) == null ? void 0 : te.clearInput,
            class: "dp--clear-btn",
            type: "button",
            onKeydown: ye[4] || (ye[4] = (le) => Y(tn)(le, () => X(le), !0, oe)),
            onClick: ye[5] || (ye[5] = $t((le) => X(le), ["prevent"]))
          }, [
            ke(Y(yy), {
              class: "dp__input_icons",
              "data-test-id": "clear-icon"
            })
          ], 40, G4)) : ie("", !0)
        ])) : ie("", !0)
      ]);
    };
  }
}), Z4 = typeof window < "u" ? window : void 0, uf = () => {
}, K4 = (t) => t0() ? (i0(t), !0) : !1, J4 = (t, e, i, n) => {
  if (!t) return uf;
  let s = uf;
  const r = mt(
    () => Y(t),
    (o) => {
      s(), o && (o.removeEventListener(e, i), o.addEventListener(e, i, n), s = () => {
        o.removeEventListener(e, i, n), s = uf;
      });
    },
    { immediate: !0, flush: "post" }
  ), a = () => {
    r(), s();
  };
  return K4(a), a;
}, $4 = (t, e, i, n = {}) => {
  const { window: s = Z4, event: r = "pointerdown" } = n;
  return s ? J4(s, r, (a) => {
    const o = bi(t), l = bi(e);
    !o || !l || o === a.target || a.composedPath().includes(o) || a.composedPath().includes(l) || i(a);
  }, { passive: !0 }) : void 0;
}, e8 = ["data-dp-mobile"], t8 = /* @__PURE__ */ qe({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Hd
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(t, { expose: e, emit: i }) {
    const n = i, s = t, r = Yi(), a = pe(!1), o = Ha(s, "modelValue"), l = Ha(s, "timezone"), u = pe(null), d = pe(null), c = pe(null), A = pe(!1), m = pe(null), p = pe(!1), h = pe(!1), g = pe(!1), w = pe(!1), { setMenuFocused: b, setShiftKey: y } = Oy(), { clearArrowNav: D } = Tr(), { validateDate: I, isValidTime: M } = xr(s), {
      defaultedTransitions: _,
      defaultedTextInput: N,
      defaultedInline: x,
      defaultedConfig: C,
      defaultedRange: L,
      defaultedMultiDates: V
    } = ei(s), { menuTransition: H, showTransition: O } = Vl(_), { isMobile: X } = Uy(C), q = Id();
    It(() => {
      B(s.modelValue), li().then(() => {
        if (!x.value.enabled) {
          const R = ae(m.value);
          R == null || R.addEventListener("scroll", Be), window == null || window.addEventListener("resize", Me);
        }
      }), x.value.enabled && (a.value = !0), window == null || window.addEventListener("keyup", Ke), window == null || window.addEventListener("keydown", He);
    }), Nn(() => {
      if (!x.value.enabled) {
        const R = ae(m.value);
        R == null || R.removeEventListener("scroll", Be), window == null || window.removeEventListener("resize", Me);
      }
      window == null || window.removeEventListener("keyup", Ke), window == null || window.removeEventListener("keydown", He);
    });
    const F = yn(r, "all", s.presetDates), W = yn(r, "input");
    mt(
      [o, l],
      () => {
        B(o.value);
      },
      { deep: !0 }
    );
    const { openOnTop: j, menuStyle: oe, xCorrect: $, setMenuPosition: ye, getScrollableParent: ae, shadowRender: ce } = U4({
      menuRef: u,
      menuRefInner: d,
      inputRef: c,
      pickerWrapperRef: m,
      inline: x,
      emit: n,
      props: s,
      slots: r
    }), {
      inputValue: te,
      internalModelValue: le,
      parseExternalModelValue: B,
      emitModelValue: ue,
      formatInputValue: Pe,
      checkBeforeEmit: nt
    } = L7(n, s, A), ge = J(
      () => ({
        dp__main: !0,
        dp__theme_dark: s.dark,
        dp__theme_light: !s.dark,
        dp__flex_display: x.value.enabled,
        "dp--flex-display-collapsed": g.value,
        dp__flex_display_with_input: x.value.input
      })
    ), Qe = J(() => s.dark ? "dp__theme_dark" : "dp__theme_light"), Ee = J(() => s.teleport ? {
      to: typeof s.teleport == "boolean" ? "body" : s.teleport,
      disabled: !s.teleport || x.value.enabled
    } : {}), xe = J(() => ({ class: "dp__outer_menu_wrap" })), K = J(() => x.value.enabled && (s.timePicker || s.monthPicker || s.yearPicker || s.quarterPicker)), Ie = () => {
      var R, Q;
      return ((Q = (R = c.value) == null ? void 0 : R.$el) == null ? void 0 : Q.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, Be = () => {
      a.value && (C.value.closeOnScroll ? Et() : ye());
    }, Me = () => {
      var R;
      a.value && ye();
      const Q = ((R = d.value) == null ? void 0 : R.$el.getBoundingClientRect().width) ?? 0;
      g.value = document.body.offsetWidth <= Q;
    }, Ke = (R) => {
      R.key === "Tab" && !x.value.enabled && !s.teleport && C.value.tabOutClosesMenu && (m.value.contains(document.activeElement) || Et()), h.value = R.shiftKey;
    }, He = (R) => {
      h.value = R.shiftKey;
    }, Ge = () => {
      !s.disabled && !s.readonly && (ce(q, pg, s), ye(!1), a.value = !0, a.value && n("open"), a.value || je(), B(s.modelValue));
    }, ot = () => {
      var R, Q;
      te.value = "", je(), (R = d.value) == null || R.onValueCleared(), (Q = c.value) == null || Q.setParsedDate(null), n("update:model-value", null), n("update:model-timezone-value", null), n("cleared"), C.value.closeOnClearValue && Et();
    }, he = () => {
      const R = le.value;
      return !R || !Array.isArray(R) && I(R) ? !0 : Array.isArray(R) ? V.value.enabled || R.length === 2 && I(R[0]) && I(R[1]) ? !0 : L.value.partialRange && !s.timePicker ? I(R[0]) : !1 : !1;
    }, Re = () => {
      nt() && he() ? (ue(), Et()) : n("invalid-select", le.value);
    }, dt = (R) => {
      St(), ue(), C.value.closeOnAutoApply && !R && Et();
    }, St = () => {
      c.value && N.value.enabled && c.value.setParsedDate(le.value);
    }, Rt = (R = !1) => {
      s.autoApply && M(le.value) && he() && (L.value.enabled && Array.isArray(le.value) ? (L.value.partialRange || le.value.length === 2) && dt(R) : dt(R));
    }, je = () => {
      N.value.enabled || (le.value = null);
    }, Et = (R = !1) => {
      var Q, de;
      R && le.value && C.value.setDateOnMenuClose && Re(), x.value.enabled || (a.value && (a.value = !1, $.value = !1, b(!1), y(!1), D(), n("closed"), te.value && B(o.value)), je(), n("blur"), (de = (Q = d.value) == null ? void 0 : Q.$el) == null || de.remove());
    }, Mi = (R, Q, de = !1) => {
      if (!R) {
        le.value = null;
        return;
      }
      const Fe = Array.isArray(R) ? !R.some((bt) => !I(bt)) : I(R), Ze = M(R);
      Fe && Ze ? (w.value = !0, le.value = R, Q ? (p.value = de, Re(), n("text-submit")) : s.autoApply && Rt(), li().then(() => {
        w.value = !1;
      })) : n("invalid-date", R);
    }, zn = () => {
      s.autoApply && M(le.value) && ue(), St();
    }, xt = () => a.value ? Et() : Ge(), Gs = (R) => {
      le.value = R;
    }, Un = () => {
      N.value.enabled && (A.value = !0, Pe()), n("focus");
    }, Qs = () => {
      if (N.value.enabled && (A.value = !1, B(s.modelValue), p.value)) {
        const R = o7(m.value, h.value);
        R == null || R.focus();
      }
      n("blur");
    }, Ps = (R) => {
      d.value && d.value.updateMonthYear(0, {
        month: ag(R.month),
        year: ag(R.year)
      });
    }, Cn = (R) => {
      B(R ?? s.modelValue);
    }, me = (R, Q) => {
      var de;
      (de = d.value) == null || de.switchView(R, Q);
    }, Le = (R, Q) => C.value.onClickOutside ? C.value.onClickOutside(R, Q) : Et(!0), Je = (R = 0) => {
      var Q;
      (Q = d.value) == null || Q.handleFlow(R);
    }, z = () => u;
    return $4(
      u,
      c,
      (R) => Le(he, R)
    ), e({
      closeMenu: Et,
      selectDate: Re,
      clearValue: ot,
      openMenu: Ge,
      onScroll: Be,
      formatInputValue: Pe,
      // exposed for testing purposes
      updateInternalModelValue: Gs,
      // modify internal modelValue
      setMonthYear: Ps,
      parseModel: Cn,
      switchView: me,
      toggleMenu: xt,
      handleFlow: Je,
      getDpWrapMenuRef: z
    }), (R, Q) => (k(), U("div", {
      ref_key: "pickerWrapperRef",
      ref: m,
      class: we(ge.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": Y(X)
    }, [
      ke(Q4, Ut({
        ref_key: "inputRef",
        ref: c,
        "input-value": Y(te),
        "onUpdate:inputValue": Q[0] || (Q[0] = (de) => mr(te) ? te.value = de : null),
        "is-menu-open": a.value
      }, R.$props, {
        onClear: ot,
        onOpen: Ge,
        onSetInputDate: Mi,
        onSetEmptyDate: Y(ue),
        onSelectDate: Re,
        onToggle: xt,
        onClose: Et,
        onFocus: Un,
        onBlur: Qs,
        onRealBlur: Q[1] || (Q[1] = (de) => A.value = !1),
        onTextInput: Q[2] || (Q[2] = (de) => R.$emit("text-input", de))
      }), wi({ _: 2 }, [
        ut(Y(W), (de, Fe) => ({
          name: de,
          fn: De((Ze) => [
            Se(R.$slots, de, _i(ln(Ze)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (k(), Ce(Ft(R.teleport ? br : "div"), _i(ln(Ee.value)), {
        default: De(() => [
          ke(Ri, {
            name: Y(H)(Y(j)),
            css: Y(O) && !Y(x).enabled
          }, {
            default: De(() => [
              a.value ? (k(), U("div", Ut({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: u
              }, xe.value, {
                class: { "dp--menu-wrapper": !Y(x).enabled },
                style: Y(x).enabled ? void 0 : Y(oe)
              }), [
                ke(pg, Ut({
                  ref_key: "dpMenuRef",
                  ref: d
                }, R.$props, {
                  "internal-model-value": Y(le),
                  "onUpdate:internalModelValue": Q[3] || (Q[3] = (de) => mr(le) ? le.value = de : null),
                  class: { [Qe.value]: !0, "dp--menu-wrapper": R.teleport },
                  "open-on-top": Y(j),
                  "no-overlay-focus": K.value,
                  collapse: g.value,
                  "get-input-rect": Ie,
                  "is-text-input-date": w.value,
                  onClosePicker: Et,
                  onSelectDate: Re,
                  onAutoApply: Rt,
                  onTimeUpdate: zn,
                  onFlowStep: Q[4] || (Q[4] = (de) => R.$emit("flow-step", de)),
                  onUpdateMonthYear: Q[5] || (Q[5] = (de) => R.$emit("update-month-year", de)),
                  onInvalidSelect: Q[6] || (Q[6] = (de) => R.$emit("invalid-select", Y(le))),
                  onAutoApplyInvalid: Q[7] || (Q[7] = (de) => R.$emit("invalid-select", de)),
                  onInvalidFixedRange: Q[8] || (Q[8] = (de) => R.$emit("invalid-fixed-range", de)),
                  onRecalculatePosition: Y(ye),
                  onTooltipOpen: Q[9] || (Q[9] = (de) => R.$emit("tooltip-open", de)),
                  onTooltipClose: Q[10] || (Q[10] = (de) => R.$emit("tooltip-close", de)),
                  onTimePickerOpen: Q[11] || (Q[11] = (de) => R.$emit("time-picker-open", de)),
                  onTimePickerClose: Q[12] || (Q[12] = (de) => R.$emit("time-picker-close", de)),
                  onAmPmChange: Q[13] || (Q[13] = (de) => R.$emit("am-pm-change", de)),
                  onRangeStart: Q[14] || (Q[14] = (de) => R.$emit("range-start", de)),
                  onRangeEnd: Q[15] || (Q[15] = (de) => R.$emit("range-end", de)),
                  onDateUpdate: Q[16] || (Q[16] = (de) => R.$emit("date-update", de)),
                  onInvalidDate: Q[17] || (Q[17] = (de) => R.$emit("invalid-date", de)),
                  onOverlayToggle: Q[18] || (Q[18] = (de) => R.$emit("overlay-toggle", de)),
                  onMenuBlur: Q[19] || (Q[19] = (de) => R.$emit("blur"))
                }), wi({ _: 2 }, [
                  ut(Y(F), (de, Fe) => ({
                    name: de,
                    fn: De((Ze) => [
                      Se(R.$slots, de, _i(ln({ ...Ze })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : ie("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 10, e8));
  }
}), jd = /* @__PURE__ */ (() => {
  const t = t8;
  return t.install = (e) => {
    e.component("Vue3DatePicker", t);
  }, t;
})(), i8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jd
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(i8).forEach(([t, e]) => {
  t !== "default" && (jd[t] = e);
});
function od(t) {
  return t.length >= 3 ? t.substring(0, 3) : t;
}
function n8() {
  const t = /* @__PURE__ */ new Date();
  return [
    { label: "Сегодня", value: [Fr(t), qo(t)] },
    {
      label: "Вчера",
      value: [Fr(xa(t, 1)), qo(xa(t, 1))]
    },
    {
      label: "Последние 7 дней",
      value: [Fr(xa(t, 7)), qo(t)]
    },
    {
      label: "Последние 30 дней",
      value: [Fr(xa(t, 30)), qo(t)]
    },
    {
      label: "Последний год",
      value: [Fr(mp(t, 1)), qo(t)]
    }
  ];
}
function s8(t) {
  if (!t)
    return "";
  const e = (n) => {
    const s = String(n.getDate()).padStart(2, "0"), r = String(n.getMonth() + 1).padStart(2, "0"), a = n.getFullYear();
    return `${s}.${r}.${a}`;
  }, i = (n) => n instanceof Date ? n : new Date(n);
  if (Array.isArray(t)) {
    const [n, s] = t.map(i);
    return `${e(n)} - ${e(s)}`;
  }
  return e(i(t));
}
function df(t) {
  const e = t.split(".").map(Number).slice(0, 3);
  if (e.some((r) => !r))
    return null;
  const [i, n, s] = e;
  return new Date(s, n - 1, i);
}
function r8(t, e) {
  return t + e;
}
function Vy(t, e) {
  const i = pe(null), n = pe(n8()), s = pe((/* @__PURE__ */ new Date()).getFullYear()), r = pe(null), a = pe(null), o = pe(""), l = J(() => {
    if (t.range && Array.isArray(t.modelValue)) {
      const M = t.modelValue[0];
      if (M instanceof Date)
        return M.getFullYear();
    }
    return s.value;
  }), u = () => {
    if (!r.value || (r.value.selectDate(), !i.value))
      return;
    const M = d(i.value);
    e("update:modelValue", M), y();
  };
  function d(M) {
    return Array.isArray(M) ? M.map(c) : c(M);
  }
  function c(M) {
    return M instanceof Date ? M.toISOString() : String(M);
  }
  const A = () => {
    r.value && r.value.switchView("year");
  }, m = (M) => {
    i.value = M, y();
  }, p = J(() => t.placeholder || (t.range ? "дд.мм.гггг - дд.мм.гггг" : "дд.мм.гггг")), h = J(() => t.range ? "##.##.#### - ##.##.####" : "##.##.####"), g = () => {
    var M;
    (M = r == null ? void 0 : r.value) == null || M.closeMenu();
  }, w = (M) => {
    const _ = r8(l.value, M);
    r.value && (r.value.setMonthYear({ year: _ }), s.value = _);
  }, b = (M, _) => {
    i.value = M, a.value = _;
  }, y = () => {
    o.value = s8(i.value);
  }, D = (M) => {
    M ? i.value = o.value.split(" - ").map((_) => {
      const N = df(_);
      return N instanceof Date && N ? N : new Date(o.value);
    }) : i.value = df(o.value);
  }, I = (M) => {
    i.value === "" && (i.value = df(o.value)), D(M);
  };
  return Vs(() => {
    (t.range && Array.isArray(t.modelValue) || t.modelValue) && (i.value = t.modelValue), setTimeout(() => {
      y();
    });
  }), {
    date: i,
    presetDates: n,
    currentYear: s,
    selectedYear: l,
    datePickerRef: r,
    selectDate: u,
    toggleYearPicker: A,
    inputPlaceholder: p,
    formattedDateMask: h,
    close: g,
    inputDate: o,
    toggleYear: w,
    activePresetIndex: a,
    applyPreset: b,
    handleDate: y,
    updateDate: m,
    convertToLongDate: I
  };
}
const a8 = { class: "ui-date-picker-navigation__wrapper" }, o8 = {
  key: 0,
  class: "ui-date-picker-navigation"
}, l8 = { class: "ui-date-picker-navigation__list" }, u8 = { class: "ui-date-picker" }, d8 = { class: "ui-date-picker-year dp__month_year_wrap" }, c8 = { class: "dp__inner_nav" }, f8 = { class: "dp__inner_nav" }, h8 = {
  type: "button",
  class: "ui-date-picker-header__button"
}, p8 = {
  type: "button",
  class: "ui-date-picker-header__button"
}, m8 = /* @__PURE__ */ qe({
  __name: "MobileDatePicker",
  props: {
    modelValue: {
      type: [Date, Array, String],
      default: /* @__PURE__ */ new Date()
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputLabel: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    tooltipMessage: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    error: {
      type: Boolean,
      default: !1
    },
    range: {
      type: Boolean,
      default: !1
    },
    isOpenDatepicker: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "update:isOpenDatepicker"],
  setup(t, { emit: e }) {
    const i = t, n = e, {
      date: s,
      presetDates: r,
      selectedYear: a,
      datePickerRef: o,
      toggleYearPicker: l,
      inputPlaceholder: u,
      formattedDateMask: d,
      inputDate: c,
      toggleYear: A,
      handleDate: m,
      activePresetIndex: p,
      applyPreset: h,
      selectDate: g,
      convertToLongDate: w
    } = Vy(i, n), b = J({
      get: () => i.isOpenDatepicker,
      set: (I) => n("update:isOpenDatepicker", I)
    }), y = (I) => {
      b.value = I ?? !1;
    }, D = () => {
      g(), m(), y(!1);
    };
    return (I, M) => (k(), U("div", Ut(I.$attrs, { class: "ui-date-picker-mobile" }), [
      ke(zd, {
        modelValue: Y(c),
        "onUpdate:modelValue": [
          M[0] || (M[0] = (_) => mr(c) ? c.value = _ : null),
          Y(w)
        ],
        size: t.size,
        disabled: t.disabled,
        error: t.error,
        mask: Y(d),
        label: t.inputLabel,
        required: t.required,
        "error-message": t.errorMessage,
        "tooltip-message": t.tooltipMessage,
        "hint-message": t.hintMessage,
        "reset-button": "",
        placeholder: Y(u),
        onClick: M[1] || (M[1] = (_) => y(!0))
      }, {
        "icon-left": De(() => [
          ke(Y(eh))
        ]),
        _: 1
      }, 8, ["modelValue", "size", "disabled", "error", "mask", "label", "required", "error-message", "tooltip-message", "hint-message", "placeholder", "onUpdate:modelValue"]),
      ke(op, {
        modelValue: b.value,
        "onUpdate:modelValue": M[7] || (M[7] = (_) => b.value = _),
        label: t.inputLabel,
        "sub-title": t.hintMessage
      }, {
        default: De(() => [
          re("div", a8, [
            t.range ? (k(), U("div", o8, [
              re("ul", l8, [
                (k(!0), U(Xe, null, ut(Y(r), (_, N) => (k(), U("li", {
                  key: N,
                  class: "ui-date-picker-navigation__item"
                }, [
                  ke(c0, {
                    active: Y(p) === N,
                    label: _.label,
                    size: "s",
                    onClick: (x) => Y(h)(_.value, N)
                  }, null, 8, ["active", "label", "onClick"])
                ]))), 128))
              ])
            ])) : ie("", !0)
          ]),
          re("div", u8, [
            ke(Y(jd), {
              ref_key: "datePickerRef",
              ref: o,
              modelValue: Y(s),
              "onUpdate:modelValue": M[5] || (M[5] = (_) => mr(s) ? s.value = _ : null),
              "enable-time-picker": "",
              "month-change-on-scroll": !1,
              range: t.range,
              format: "dd.MM.yyyy",
              locale: "ru",
              class: "ui-date-picker-calendar",
              inline: "",
              "select-year": ""
            }, {
              month: De(({ text: _ }) => [
                Wi(_e(Y(od)(_)), 1)
              ]),
              "month-overlay-value": De(({ text: _ }) => [
                Wi(_e(Y(od)(_)), 1)
              ]),
              "month-overlay-header": De(() => [
                re("div", d8, [
                  re("div", c8, [
                    re("button", {
                      type: "button",
                      class: "ui-date-picker-header__button",
                      onClick: M[2] || (M[2] = (_) => Y(A)(-1))
                    }, [
                      ke(Y(Xu), { class: "ui-date-picker-header__icon" })
                    ])
                  ]),
                  re("button", {
                    type: "button",
                    class: "dp__btn dp__month_year_select",
                    onClick: M[3] || (M[3] = //@ts-ignore
                    (..._) => Y(l) && Y(l)(..._))
                  }, _e(Y(a)), 1),
                  re("div", f8, [
                    re("button", {
                      type: "button",
                      class: "ui-date-picker-header__button",
                      onClick: M[4] || (M[4] = (_) => Y(A)(1))
                    }, [
                      ke(Y(ju), { class: "ui-date-picker-header__icon" })
                    ])
                  ])
                ])
              ]),
              "input-icon": De(() => [
                ke(Y(eh), { class: "ui-date-picker-input__icon" })
              ]),
              "calendar-icon": De(() => [
                ke(Y(a0), { class: "ui-date-picker-month__icon" })
              ]),
              "arrow-left": De(() => [
                re("button", h8, [
                  ke(Y(Xu), { class: "ui-date-picker-header__icon" })
                ])
              ]),
              "arrow-right": De(() => [
                re("button", p8, [
                  ke(Y(ju), { class: "ui-date-picker-header__icon" })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "range"])
          ])
        ]),
        footer: De(() => [
          ke($r, {
            label: "Применить",
            size: "m",
            style: { width: "100%", "margin-bottom": "8px" },
            onClick: D
          }),
          ke($r, {
            label: "Отменить",
            size: "m",
            color: "secondary",
            style: { width: "100%" },
            onClick: M[6] || (M[6] = (_) => y(!1))
          })
        ]),
        _: 1
      }, 8, ["modelValue", "label", "sub-title"])
    ], 16));
  }
}), A8 = /* @__PURE__ */ tt(m8, [["__scopeId", "data-v-858cf6f8"]]), cf = ".dp--menu-wrapper", g8 = { class: "ui-date-picker-navigation" }, v8 = { class: "ui-date-picker-navigation__list" }, y8 = { class: "ui-date-picker-year dp__month_year_wrap" }, b8 = { class: "dp__inner_nav" }, w8 = { class: "dp__inner_nav" }, T8 = {
  type: "button",
  class: "ui-date-picker-header__button"
}, x8 = {
  type: "button",
  class: "ui-date-picker-header__button"
}, S8 = ["onClick", "onKeyup"], C8 = { class: "ui-date-picker-buttons" }, E8 = /* @__PURE__ */ qe({
  __name: "DasktopDatePicker",
  props: {
    modelValue: {
      type: [Date, Array, String],
      default: /* @__PURE__ */ new Date()
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    inputLabel: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    tooltipMessage: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "l"
    },
    error: {
      type: Boolean,
      default: !1
    },
    range: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, {
      date: s,
      presetDates: r,
      selectedYear: a,
      datePickerRef: o,
      selectDate: l,
      toggleYearPicker: u,
      inputPlaceholder: d,
      formattedDateMask: c,
      close: A,
      inputDate: m,
      toggleYear: p,
      updateDate: h,
      activePresetIndex: g,
      applyPreset: w,
      convertToLongDate: b
    } = Vy(i, n), y = (_) => {
      i.disabled && _ && _.stopPropagation();
      const N = document.querySelector(cf);
      N && N.classList.add("elevation-shadow-low");
    }, D = new MutationObserver((_) => {
      for (const N of _)
        if (N.type === "childList" && document.querySelector(cf)) {
          y(), M();
          break;
        }
    }), I = () => {
      const _ = document.querySelector(cf);
      _ && _.parentNode && D.observe(_.parentNode, {
        childList: !0,
        subtree: !1
      });
    }, M = () => {
      D.disconnect();
    };
    return It(() => {
      I();
    }), Ol(() => {
      M();
    }), (_, N) => (k(), U("div", {
      class: we(["ui-date-picker", { "ui-date-picker_disabled": t.disabled }])
    }, [
      ke(Y(jd), {
        ref_key: "datePickerRef",
        ref: o,
        modelValue: Y(s),
        "onUpdate:modelValue": [
          N[5] || (N[5] = (x) => mr(s) ? s.value = x : null),
          Y(h)
        ],
        format: "dd.MM.yyyy",
        locale: "ru",
        "text-input": "",
        "enable-time-picker": "",
        "month-change-on-scroll": !1,
        range: t.range
      }, wi({
        "action-preview": De(() => []),
        month: De(({ text: x }) => [
          Wi(_e(Y(od)(x)), 1)
        ]),
        "month-overlay-value": De(({ text: x }) => [
          Wi(_e(Y(od)(x)), 1)
        ]),
        day: De(({ day: x }) => [
          re("span", null, _e(x), 1)
        ]),
        "dp-input": De(({ onBlur: x, onInput: C }) => [
          ke(zd, {
            modelValue: Y(m),
            "onUpdate:modelValue": [
              N[0] || (N[0] = (L) => mr(m) ? m.value = L : null),
              N[1] || (N[1] = (L) => Y(b)(t.range))
            ],
            "reset-button": !t.disabled,
            mask: Y(c),
            placeholder: Y(d),
            label: t.inputLabel,
            disabled: t.disabled,
            error: t.error,
            required: t.required,
            "error-message": t.errorMessage,
            "tooltip-message": t.tooltipMessage,
            "hint-message": t.hintMessage,
            size: t.size,
            onClick: y,
            onInputDebounced: C,
            onBlur: x
          }, {
            "icon-left": De(() => [
              ke(Y(eh))
            ]),
            _: 2
          }, 1032, ["modelValue", "reset-button", "mask", "placeholder", "label", "disabled", "error", "required", "error-message", "tooltip-message", "hint-message", "size", "onInputDebounced", "onBlur"])
        ]),
        "month-overlay-header": De(() => [
          re("div", y8, [
            re("div", b8, [
              re("button", {
                type: "button",
                class: "ui-date-picker-header__button",
                onClick: N[2] || (N[2] = (x) => Y(p)(-1))
              }, [
                ke(Y(Xu), { class: "ui-date-picker-header__icon" })
              ])
            ]),
            re("button", {
              type: "button",
              class: "dp__btn dp__month_year_select",
              onClick: N[3] || (N[3] = //@ts-ignore
              (...x) => Y(u) && Y(u)(...x))
            }, _e(Y(a)), 1),
            re("div", w8, [
              re("button", {
                type: "button",
                class: "ui-date-picker-header__button",
                onClick: N[4] || (N[4] = (x) => Y(p)(1))
              }, [
                ke(Y(ju), { class: "ui-date-picker-header__icon" })
              ])
            ])
          ])
        ]),
        "calendar-icon": De(() => [
          ke(Y(a0), { class: "ui-date-picker-month__icon" })
        ]),
        "arrow-left": De(() => [
          re("button", T8, [
            ke(Y(Xu), { class: "ui-date-picker-header__icon" })
          ])
        ]),
        "arrow-right": De(() => [
          re("button", x8, [
            ke(Y(ju), { class: "ui-date-picker-header__icon" })
          ])
        ]),
        "action-buttons": De(() => [
          re("div", C8, [
            ke($r, {
              color: "secondary",
              label: "Отмена",
              size: "s",
              onClick: Y(A)
            }, null, 8, ["onClick"]),
            ke($r, {
              label: "Применить",
              size: "s",
              onClick: Y(l)
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 2
      }, [
        t.range ? {
          name: "left-sidebar",
          fn: De(() => [
            re("div", g8, [
              re("ul", v8, [
                (k(!0), U(Xe, null, ut(Y(r), (x, C) => (k(), U("li", {
                  key: C,
                  class: "ui-date-picker-navigation__item"
                }, [
                  ke(c0, {
                    label: x.label,
                    size: "m",
                    active: Y(g) === C,
                    onClick: (L) => Y(w)(x.value, C)
                  }, null, 8, ["label", "active", "onClick"])
                ]))), 128))
              ])
            ])
          ]),
          key: "0"
        } : void 0,
        t.range ? {
          name: "preset-date-range-button",
          fn: De(({ label: x, value: C, presetDate: L }) => [
            re("button", {
              type: "button",
              tabindex: "0",
              role: "button",
              onClick: (V) => L(C),
              onKeyup: [
                Yu($t((V) => L(C), ["prevent"]), ["enter"]),
                Yu($t((V) => L(C), ["prevent"]), ["space"])
              ]
            }, _e(x), 41, S8)
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["modelValue", "range", "onUpdate:modelValue"])
    ], 2));
  }
}), D8 = /* @__PURE__ */ tt(E8, [["__scopeId", "data-v-eda9a9ac"]]), sH = /* @__PURE__ */ qe({
  name: "UiDatePicker",
  __name: "UiDatePicker",
  props: {
    modelValue: {
      type: [Date, Array, String],
      default: /* @__PURE__ */ new Date()
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "l"
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: ""
    },
    tooltipMessage: {
      type: String,
      default: ""
    },
    hintMessage: {
      type: String,
      default: ""
    },
    error: {
      type: Boolean,
      default: !1
    },
    range: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = pe(!1), { width: r } = Rn(), a = J(() => r.value >= 768 ? D8 : A8), o = J({
      get: () => i.modelValue,
      set: (l) => n("update:modelValue", l)
    });
    return (l, u) => (k(), Ce(Ft(a.value), Ut({
      modelValue: o.value,
      "onUpdate:modelValue": u[0] || (u[0] = (d) => o.value = d),
      "is-open-datepicker": s.value,
      "onUpdate:isOpenDatepicker": u[1] || (u[1] = (d) => s.value = d),
      range: t.range,
      size: t.size,
      "input-label": t.label,
      placeholder: t.placeholder,
      required: t.required,
      "error-message": t.errorMessage,
      "tooltip-message": t.tooltipMessage,
      "hint-message": t.hintMessage,
      error: t.error,
      disabled: t.disabled
    }, l.$attrs), null, 16, ["modelValue", "is-open-datepicker", "range", "size", "input-label", "placeholder", "required", "error-message", "tooltip-message", "hint-message", "error", "disabled"]));
  }
}), _8 = {
  key: 0,
  class: "ui-select__header"
}, k8 = {
  key: 0,
  class: "ui-select__label"
}, P8 = {
  key: 2,
  class: "icon-asterisk"
}, I8 = ["id"], M8 = {
  key: 1,
  class: "error-message"
}, O8 = {
  key: 0,
  class: "empty-search"
}, B8 = /* @__PURE__ */ qe({
  name: "UiSelect",
  __name: "UiSelect",
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    size: {
      type: String,
      default: "m"
    },
    label: {
      type: String,
      default: ""
    },
    bottomSheetSubTitle: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    selectId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    errorMessage: {
      type: String,
      default: ""
    },
    tooltipMessage: {
      type: String,
      default: ""
    },
    scrollContainerId: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = J({
      get() {
        return i.modelValue;
      },
      set(y) {
        n("update:modelValue", y);
      }
    }), r = pe(!1), a = J(() => {
      var y;
      return s.value === "" ? i.placeholder : ((y = i.options.find((D) => D.id === s.value)) == null ? void 0 : y.label) ?? "";
    }), o = () => {
      i.disabled || i.readOnly || (r.value = !r.value);
    }, l = pe(null), u = pe(null), d = pe(null), c = pe(""), A = pe(null), m = J(
      () => d.value && u.value && l.value && A.value
    );
    async function p() {
      if (m.value) {
        const y = d.value.offsetWidth, D = u.value.offsetWidth, I = Math.min(D, y);
        l.value.style.width = `${I}px`;
      }
    }
    function h() {
      l.value && l.value.focus();
    }
    function g() {
      l.value && l.value.blur();
    }
    mt(r, async (y) => {
      i.options.length < 15 || (y ? h() : (g(), c.value = ""));
    });
    const w = J(() => i.options.filter(
      (y) => y.label.toLowerCase().includes(c.value.toLowerCase())
    )), b = J(
      () => w.value.length === 0 && c.value !== ""
    );
    return (y, D) => (k(), U("div", {
      class: we(["ui-select", [
        `ui-select__size_${t.size}`,
        {
          "ui-select_disabled": t.disabled,
          "ui-select_open": r.value,
          "ui-select_checked": s.value,
          "ui-select_error": t.errorMessage
        }
      ]])
    }, [
      t.label ? (k(), U("div", _8, [
        t.label ? (k(), U("p", k8, _e(t.label), 1)) : ie("", !0),
        t.tooltipMessage ? (k(), Ce(aa, {
          key: 1,
          size: t.size,
          "tooltip-message": t.tooltipMessage
        }, null, 8, ["size", "tooltip-message"])) : ie("", !0),
        t.required ? (k(), U("p", P8)) : ie("", !0)
      ])) : ie("", !0),
      re("div", {
        id: t.selectId,
        ref_key: "inputContainerRef",
        ref: d,
        class: "ui-select__input-container input-container",
        onClick: $t(o, ["stop"])
      }, [
        c.value === "" ? (k(), U("span", {
          key: 0,
          class: we(["placeholder", { placeholder_active: s.value !== "" }])
        }, _e(a.value), 3)) : ie("", !0),
        Ci(re("input", {
          ref_key: "inputRef",
          ref: l,
          "onUpdate:modelValue": D[0] || (D[0] = (I) => c.value = I),
          type: "text",
          class: "search-input",
          onInput: p
        }, null, 544), [
          [Kn, c.value]
        ]),
        re("span", {
          ref_key: "hiddenSpan",
          ref: u,
          class: "hidden-span"
        }, _e(c.value || " "), 513),
        s.value === "" ? (k(), Ce(Y(Od), {
          key: 1,
          class: "input-container__chevron"
        })) : ie("", !0),
        s.value && !t.disabled && !t.readOnly ? (k(), Ce(Ud, {
          key: 2,
          class: "reset-button",
          onClick: D[1] || (D[1] = $t((I) => s.value = "", ["stop"]))
        }, {
          default: De(() => [
            ke(Y(po))
          ]),
          _: 1
        })) : ie("", !0)
      ], 8, I8),
      t.errorMessage ? (k(), U("p", M8, _e(t.errorMessage), 1)) : ie("", !0),
      ke(Rl, {
        ref_key: "dropdownRef",
        ref: A,
        modelValue: s.value,
        "onUpdate:modelValue": D[2] || (D[2] = (I) => s.value = I),
        open: r.value,
        "onUpdate:open": D[3] || (D[3] = (I) => r.value = I),
        "is-select": "",
        type: "single",
        "scroll-container-id": t.scrollContainerId,
        label: t.label,
        "bottom-sheet-sub-title": t.bottomSheetSubTitle,
        "parent-id": t.selectId,
        options: w.value
      }, {
        default: De(() => [
          b.value ? (k(), U("p", O8, "Ничего не найдено")) : ie("", !0)
        ]),
        _: 1
      }, 8, ["modelValue", "open", "scroll-container-id", "label", "bottom-sheet-sub-title", "parent-id", "options"])
    ], 2));
  }
}), rH = /* @__PURE__ */ tt(B8, [["__scopeId", "data-v-623edf95"]]), L8 = {
  key: 0,
  class: "ui-multiple-select__header"
}, N8 = {
  key: 0,
  class: "ui-multiple-select__label"
}, R8 = {
  key: 2,
  class: "icon-asterisk"
}, F8 = ["id"], z8 = ["inputmode"], U8 = {
  key: 0,
  class: "search-placeholder"
}, V8 = { class: "button-container" }, q8 = {
  key: 1,
  class: "error-message"
}, H8 = {
  key: 0,
  class: "empty-search"
}, W8 = /* @__PURE__ */ qe({
  name: "UiMultipleSelect",
  __name: "UiMultipleSelect",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "m"
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    bottomSheetSubTitle: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Array,
      default: () => []
    },
    selectId: {
      type: String,
      default: () => Math.random().toString(36).substring(2, 8)
    },
    errorMessage: {
      type: String,
      default: ""
    },
    tooltipMessage: {
      type: String,
      default: ""
    },
    scrollContainerId: {
      type: String,
      default: ""
    },
    styleType: {
      type: String,
      default: "light"
    }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, n = e, { width: s } = Rn(), r = J({
      get() {
        return i.modelValue;
      },
      set(q) {
        n("update:modelValue", q);
      }
    }), a = pe(!1), o = () => {
      i.disabled || (a.value = !a.value);
    }, l = J(() => i.modelValue.map((q) => {
      var F;
      return {
        id: q,
        label: ((F = i.options.find((W) => W.id === q)) == null ? void 0 : F.label) ?? ""
      };
    })), u = (q) => {
      r.value = r.value.filter((F) => F !== q), N(A.value);
    }, d = () => {
      r.value = [];
    }, c = J(
      () => r.value.length > 0 && a.value
    ), A = pe(null), m = pe(null), p = pe(null), h = pe(""), g = pe(null), w = J(
      () => A.value && p.value && m.value && g.value
    );
    async function b() {
      if (a.value) {
        if (await li(), w.value) {
          const q = A.value.offsetWidth, F = p.value.offsetWidth, W = Math.min(F, q);
          m.value.style.width = `${W}px`, g.value.calculatePosition();
        }
        y();
      }
    }
    function y() {
      m.value && m.value.focus();
    }
    function D() {
      m.value && m.value.blur();
    }
    mt(a, async (q) => {
      q ? (_(A.value), s.value > 767 && y(), V.value = !1, M == null || M.disconnect()) : (h.value = "", V.value = !0, N(A.value), D()), await li(), A.value.scrollLeft = 0;
    });
    const I = pe(0);
    let M = null;
    function _(q) {
      if (!q)
        return;
      Array.from(q.children).slice(0, -3).forEach((W) => {
        const j = W;
        j.id !== "counter" && (j.style.display = "flex");
      });
    }
    function N(q) {
      q && (M && M.disconnect(), M = new ResizeObserver(() => {
        I.value = 0;
        const F = q.getBoundingClientRect(), W = V.value ? -3 : -2;
        Array.from(q.children).slice(0, W).forEach((oe) => {
          const $ = oe, ye = $.getBoundingClientRect(), ae = F.right - 28;
          ye.right > ae || ye.left < F.left ? $.id !== "counter" && (I.value += 1, $.style.display = "none") : $.id !== "counter" && ($.style.display = "flex");
        });
      }), M.observe(q));
    }
    mt(r, async () => {
      await b(), h.value = "", await li(), A.value.scrollLeft = 0, _(A.value);
    }), mt(h, () => {
      b();
    });
    const x = J(() => r.value.length === 0 && h.value === ""), C = J(() => i.options.filter((q) => q.label.toLowerCase().includes(h.value.toLowerCase()))), L = J(
      () => C.value.length === 0 && h.value !== ""
    ), V = pe(!1), H = J(
      () => V.value && I.value > 0
    ), O = J(() => s.value < 768 && a.value), X = J(() => O.value ? "none" : "text");
    return Nn(() => {
      M == null || M.disconnect();
    }), (q, F) => (k(), U("div", {
      class: we(["ui-multiple-select", [
        `ui-multiple-select__size_${t.size}`,
        `ui-multiple-select__style-type_${t.styleType}`,
        {
          "ui-multiple-select_disabled": t.disabled,
          "ui-multiple-select_open": a.value,
          "ui-multiple-select_checked": r.value,
          "ui-multiple-select_error": t.errorMessage
        }
      ]])
    }, [
      t.label ? (k(), U("div", L8, [
        t.label ? (k(), U("p", N8, _e(t.label), 1)) : ie("", !0),
        t.tooltipMessage ? (k(), Ce(aa, {
          key: 1,
          size: t.size,
          "tooltip-message": t.tooltipMessage
        }, null, 8, ["size", "tooltip-message"])) : ie("", !0),
        t.required ? (k(), U("p", R8)) : ie("", !0)
      ])) : ie("", !0),
      re("div", {
        id: t.selectId,
        class: we(["ui-multiple-select__input-container input-container", {
          "input-container_selected-list-active": l.value.length > 0
        }]),
        onClick: $t(o, ["stop"])
      }, [
        re("div", {
          ref_key: "checkedListRef",
          ref: A,
          class: "input-container__checked-list"
        }, [
          (k(!0), U(Xe, null, ut(l.value, (W) => (k(), Ce(sh, {
            key: W,
            size: t.size,
            disabled: t.disabled,
            "style-type": t.styleType,
            "option-item": W,
            onRemoveItem: u
          }, null, 8, ["size", "disabled", "style-type", "option-item"]))), 128)),
          Ci(ke(sh, {
            id: "counter",
            class: "counter",
            size: t.size,
            disabled: t.disabled,
            "style-type": t.styleType,
            counter: I.value
          }, null, 8, ["size", "disabled", "style-type", "counter"]), [
            [al, H.value]
          ]),
          Ci(re("input", {
            ref_key: "inputRef",
            ref: m,
            "onUpdate:modelValue": F[0] || (F[0] = (W) => h.value = W),
            inputmode: X.value,
            type: "text",
            class: we(["search-input", { search_dropdown: O.value }]),
            onInput: b
          }, null, 42, z8), [
            [Kn, h.value]
          ]),
          x.value ? (k(), U("p", U8, _e(t.placeholder), 1)) : ie("", !0),
          re("span", {
            ref_key: "hiddenSpan",
            ref: p,
            class: "hidden-span"
          }, _e(h.value || " "), 513)
        ], 512),
        re("div", V8, [
          c.value ? (k(), Ce(Ud, {
            key: 0,
            onClick: $t(d, ["stop"])
          }, {
            default: De(() => [
              ke(Y(po))
            ]),
            _: 1
          })) : ie("", !0),
          ke(Y(Od), { class: "input-container__chevron" })
        ])
      ], 10, F8),
      t.errorMessage ? (k(), U("p", q8, _e(t.errorMessage), 1)) : ie("", !0),
      ke(Rl, {
        ref_key: "dropdownRef",
        ref: g,
        modelValue: r.value,
        "onUpdate:modelValue": F[1] || (F[1] = (W) => r.value = W),
        open: a.value,
        "onUpdate:open": F[2] || (F[2] = (W) => a.value = W),
        "is-select": "",
        "selected-option": l.value,
        type: "multiple",
        "scroll-container-id": t.scrollContainerId,
        label: t.label,
        "is-empty-search": L.value,
        "bottom-sheet-sub-title": t.bottomSheetSubTitle,
        "parent-id": t.selectId,
        options: C.value
      }, {
        default: De(() => [
          L.value ? (k(), U("p", H8, "Ничего не найдено")) : ie("", !0)
        ]),
        _: 1
      }, 8, ["modelValue", "open", "selected-option", "scroll-container-id", "label", "is-empty-search", "bottom-sheet-sub-title", "parent-id", "options"])
    ], 2));
  }
}), aH = /* @__PURE__ */ tt(W8, [["__scopeId", "data-v-18df7f00"]]), Y8 = /* @__PURE__ */ qe({
  name: "TransitionOpacity",
  __name: "TransitionOpacity",
  setup(t) {
    return (e, i) => (k(), Ce(Ri, {
      name: "fade",
      mode: "out-in"
    }, {
      default: De(() => [
        Se(e.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
}), oH = /* @__PURE__ */ tt(Y8, [["__scopeId", "data-v-9a0ae870"]]);
function mg(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function Bp(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = {});
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => i.indexOf(n) < 0).forEach((n) => {
    typeof t[n] > "u" ? t[n] = e[n] : mg(e[n]) && mg(t[n]) && Object.keys(e[n]).length > 0 && Bp(t[n], e[n]);
  });
}
const qy = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function Pi() {
  const t = typeof document < "u" ? document : {};
  return Bp(t, qy), t;
}
const X8 = {
  document: qy,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function Jt() {
  const t = typeof window < "u" ? window : {};
  return Bp(t, X8), t;
}
function rr(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter((e) => !!e.trim());
}
function j8(t) {
  const e = t;
  Object.keys(e).forEach((i) => {
    try {
      e[i] = null;
    } catch {
    }
    try {
      delete e[i];
    } catch {
    }
  });
}
function ta(t, e) {
  return e === void 0 && (e = 0), setTimeout(t, e);
}
function Mn() {
  return Date.now();
}
function G8(t) {
  const e = Jt();
  let i;
  return e.getComputedStyle && (i = e.getComputedStyle(t, null)), !i && t.currentStyle && (i = t.currentStyle), i || (i = t.style), i;
}
function Ah(t, e) {
  e === void 0 && (e = "x");
  const i = Jt();
  let n, s, r;
  const a = G8(t);
  return i.WebKitCSSMatrix ? (s = a.transform || a.webkitTransform, s.split(",").length > 6 && (s = s.split(", ").map((o) => o.replace(",", ".")).join(", ")), r = new i.WebKitCSSMatrix(s === "none" ? "" : s)) : (r = a.MozTransform || a.OTransform || a.MsTransform || a.msTransform || a.transform || a.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = r.toString().split(",")), e === "x" && (i.WebKitCSSMatrix ? s = r.m41 : n.length === 16 ? s = parseFloat(n[12]) : s = parseFloat(n[4])), e === "y" && (i.WebKitCSSMatrix ? s = r.m42 : n.length === 16 ? s = parseFloat(n[13]) : s = parseFloat(n[5])), s || 0;
}
function tl(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function Q8(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function gn() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < arguments.length; i += 1) {
    const n = i < 0 || arguments.length <= i ? void 0 : arguments[i];
    if (n != null && !Q8(n)) {
      const s = Object.keys(Object(n)).filter((r) => e.indexOf(r) < 0);
      for (let r = 0, a = s.length; r < a; r += 1) {
        const o = s[r], l = Object.getOwnPropertyDescriptor(n, o);
        l !== void 0 && l.enumerable && (tl(t[o]) && tl(n[o]) ? n[o].__swiper__ ? t[o] = n[o] : gn(t[o], n[o]) : !tl(t[o]) && tl(n[o]) ? (t[o] = {}, n[o].__swiper__ ? t[o] = n[o] : gn(t[o], n[o])) : t[o] = n[o]);
      }
    }
  }
  return t;
}
function il(t, e, i) {
  t.style.setProperty(e, i);
}
function Hy(t) {
  let {
    swiper: e,
    targetPosition: i,
    side: n
  } = t;
  const s = Jt(), r = -e.translate;
  let a = null, o;
  const l = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", s.cancelAnimationFrame(e.cssModeFrameID);
  const u = i > r ? "next" : "prev", d = (A, m) => u === "next" && A >= m || u === "prev" && A <= m, c = () => {
    o = (/* @__PURE__ */ new Date()).getTime(), a === null && (a = o);
    const A = Math.max(Math.min((o - a) / l, 1), 0), m = 0.5 - Math.cos(A * Math.PI) / 2;
    let p = r + m * (i - r);
    if (d(p, i) && (p = i), e.wrapperEl.scrollTo({
      [n]: p
    }), d(p, i)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [n]: p
        });
      }), s.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = s.requestAnimationFrame(c);
  };
  c();
}
function la(t) {
  return t.querySelector(".swiper-slide-transform") || t.shadowRoot && t.shadowRoot.querySelector(".swiper-slide-transform") || t;
}
function Ni(t, e) {
  e === void 0 && (e = "");
  const i = Jt(), n = [...t.children];
  return i.HTMLSlotElement && t instanceof HTMLSlotElement && n.push(...t.assignedElements()), e ? n.filter((s) => s.matches(e)) : n;
}
function Z8(t, e) {
  const i = [e];
  for (; i.length > 0; ) {
    const n = i.shift();
    if (t === n)
      return !0;
    i.push(...n.children, ...n.shadowRoot ? n.shadowRoot.children : [], ...n.assignedElements ? n.assignedElements() : []);
  }
}
function K8(t, e) {
  const i = Jt();
  let n = e.contains(t);
  return !n && i.HTMLSlotElement && e instanceof HTMLSlotElement && (n = [...e.assignedElements()].includes(t), n || (n = Z8(t, e))), n;
}
function ld(t) {
  try {
    console.warn(t);
    return;
  } catch {
  }
}
function bn(t, e) {
  e === void 0 && (e = []);
  const i = document.createElement(t);
  return i.classList.add(...Array.isArray(e) ? e : rr(e)), i;
}
function ud(t) {
  const e = Jt(), i = Pi(), n = t.getBoundingClientRect(), s = i.body, r = t.clientTop || s.clientTop || 0, a = t.clientLeft || s.clientLeft || 0, o = t === e ? e.scrollY : t.scrollTop, l = t === e ? e.scrollX : t.scrollLeft;
  return {
    top: n.top + o - r,
    left: n.left + l - a
  };
}
function J8(t, e) {
  const i = [];
  for (; t.previousElementSibling; ) {
    const n = t.previousElementSibling;
    e ? n.matches(e) && i.push(n) : i.push(n), t = n;
  }
  return i;
}
function $8(t, e) {
  const i = [];
  for (; t.nextElementSibling; ) {
    const n = t.nextElementSibling;
    e ? n.matches(e) && i.push(n) : i.push(n), t = n;
  }
  return i;
}
function fr(t, e) {
  return Jt().getComputedStyle(t, null).getPropertyValue(e);
}
function Dl(t) {
  let e = t, i;
  if (e) {
    for (i = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (i += 1);
    return i;
  }
}
function Xr(t, e) {
  const i = [];
  let n = t.parentElement;
  for (; n; )
    e ? n.matches(e) && i.push(n) : i.push(n), n = n.parentElement;
  return i;
}
function ml(t, e) {
  function i(n) {
    n.target === t && (e.call(t, n), t.removeEventListener("transitionend", i));
  }
  e && t.addEventListener("transitionend", i);
}
function gh(t, e, i) {
  const n = Jt();
  return t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function At(t) {
  return (Array.isArray(t) ? t : [t]).filter((e) => !!e);
}
function Gd(t) {
  return (e) => Math.abs(e) > 0 && t.browser && t.browser.need3dFix && Math.abs(e) % 90 === 0 ? e + 1e-3 : e;
}
let ff;
function eN() {
  const t = Jt(), e = Pi();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
function Wy() {
  return ff || (ff = eN()), ff;
}
let hf;
function tN(t) {
  let {
    userAgent: e
  } = t === void 0 ? {} : t;
  const i = Wy(), n = Jt(), s = n.navigator.platform, r = e || n.navigator.userAgent, a = {
    ios: !1,
    android: !1
  }, o = n.screen.width, l = n.screen.height, u = r.match(/(Android);?[\s\/]+([\d.]+)?/);
  let d = r.match(/(iPad).*OS\s([\d_]+)/);
  const c = r.match(/(iPod)(.*OS\s([\d_]+))?/), A = !d && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/), m = s === "Win32";
  let p = s === "MacIntel";
  const h = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !d && p && i.touch && h.indexOf(`${o}x${l}`) >= 0 && (d = r.match(/(Version)\/([\d.]+)/), d || (d = [0, 1, "13_0_0"]), p = !1), u && !m && (a.os = "android", a.android = !0), (d || A || c) && (a.os = "ios", a.ios = !0), a;
}
function Yy(t) {
  return t === void 0 && (t = {}), hf || (hf = tN(t)), hf;
}
let pf;
function iN() {
  const t = Jt(), e = Yy();
  let i = !1;
  function n() {
    const o = t.navigator.userAgent.toLowerCase();
    return o.indexOf("safari") >= 0 && o.indexOf("chrome") < 0 && o.indexOf("android") < 0;
  }
  if (n()) {
    const o = String(t.navigator.userAgent);
    if (o.includes("Version/")) {
      const [l, u] = o.split("Version/")[1].split(" ")[0].split(".").map((d) => Number(d));
      i = l < 16 || l === 16 && u < 2;
    }
  }
  const s = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent), r = n(), a = r || s && e.ios;
  return {
    isSafari: i || r,
    needPerspectiveFix: i,
    need3dFix: a,
    isWebView: s
  };
}
function Xy() {
  return pf || (pf = iN()), pf;
}
function nN(t) {
  let {
    swiper: e,
    on: i,
    emit: n
  } = t;
  const s = Jt();
  let r = null, a = null;
  const o = () => {
    !e || e.destroyed || !e.initialized || (n("beforeResize"), n("resize"));
  }, l = () => {
    !e || e.destroyed || !e.initialized || (r = new ResizeObserver((c) => {
      a = s.requestAnimationFrame(() => {
        const {
          width: A,
          height: m
        } = e;
        let p = A, h = m;
        c.forEach((g) => {
          let {
            contentBoxSize: w,
            contentRect: b,
            target: y
          } = g;
          y && y !== e.el || (p = b ? b.width : (w[0] || w).inlineSize, h = b ? b.height : (w[0] || w).blockSize);
        }), (p !== A || h !== m) && o();
      });
    }), r.observe(e.el));
  }, u = () => {
    a && s.cancelAnimationFrame(a), r && r.unobserve && e.el && (r.unobserve(e.el), r = null);
  }, d = () => {
    !e || e.destroyed || !e.initialized || n("orientationchange");
  };
  i("init", () => {
    if (e.params.resizeObserver && typeof s.ResizeObserver < "u") {
      l();
      return;
    }
    s.addEventListener("resize", o), s.addEventListener("orientationchange", d);
  }), i("destroy", () => {
    u(), s.removeEventListener("resize", o), s.removeEventListener("orientationchange", d);
  });
}
function sN(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: s
  } = t;
  const r = [], a = Jt(), o = function(d, c) {
    c === void 0 && (c = {});
    const A = a.MutationObserver || a.WebkitMutationObserver, m = new A((p) => {
      if (e.__preventObserver__) return;
      if (p.length === 1) {
        s("observerUpdate", p[0]);
        return;
      }
      const h = function() {
        s("observerUpdate", p[0]);
      };
      a.requestAnimationFrame ? a.requestAnimationFrame(h) : a.setTimeout(h, 0);
    });
    m.observe(d, {
      attributes: typeof c.attributes > "u" ? !0 : c.attributes,
      childList: e.isElement || (typeof c.childList > "u" ? !0 : c).childList,
      characterData: typeof c.characterData > "u" ? !0 : c.characterData
    }), r.push(m);
  }, l = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const d = Xr(e.hostEl);
        for (let c = 0; c < d.length; c += 1)
          o(d[c]);
      }
      o(e.hostEl, {
        childList: e.params.observeSlideChildren
      }), o(e.wrapperEl, {
        attributes: !1
      });
    }
  }, u = () => {
    r.forEach((d) => {
      d.disconnect();
    }), r.splice(0, r.length);
  };
  i({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), n("init", l), n("destroy", u);
}
var rN = {
  on(t, e, i) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    const s = i ? "unshift" : "push";
    return t.split(" ").forEach((r) => {
      n.eventsListeners[r] || (n.eventsListeners[r] = []), n.eventsListeners[r][s](e);
    }), n;
  },
  once(t, e, i) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    function s() {
      n.off(t, s), s.__emitterProxy && delete s.__emitterProxy;
      for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++)
        a[o] = arguments[o];
      e.apply(n, a);
    }
    return s.__emitterProxy = e, n.on(t, s, i);
  },
  onAny(t, e) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof t != "function") return i;
    const n = e ? "unshift" : "push";
    return i.eventsAnyListeners.indexOf(t) < 0 && i.eventsAnyListeners[n](t), i;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const i = e.eventsAnyListeners.indexOf(t);
    return i >= 0 && e.eventsAnyListeners.splice(i, 1), e;
  },
  off(t, e) {
    const i = this;
    return !i.eventsListeners || i.destroyed || !i.eventsListeners || t.split(" ").forEach((n) => {
      typeof e > "u" ? i.eventsListeners[n] = [] : i.eventsListeners[n] && i.eventsListeners[n].forEach((s, r) => {
        (s === e || s.__emitterProxy && s.__emitterProxy === e) && i.eventsListeners[n].splice(r, 1);
      });
    }), i;
  },
  emit() {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let e, i, n;
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    return typeof r[0] == "string" || Array.isArray(r[0]) ? (e = r[0], i = r.slice(1, r.length), n = t) : (e = r[0].events, i = r[0].data, n = r[0].context || t), i.unshift(n), (Array.isArray(e) ? e : e.split(" ")).forEach((l) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((u) => {
        u.apply(n, [l, ...i]);
      }), t.eventsListeners && t.eventsListeners[l] && t.eventsListeners[l].forEach((u) => {
        u.apply(n, i);
      });
    }), t;
  }
};
function aN() {
  const t = this;
  let e, i;
  const n = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = n.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? i = t.params.height : i = n.clientHeight, !(e === 0 && t.isHorizontal() || i === 0 && t.isVertical()) && (e = e - parseInt(fr(n, "padding-left") || 0, 10) - parseInt(fr(n, "padding-right") || 0, 10), i = i - parseInt(fr(n, "padding-top") || 0, 10) - parseInt(fr(n, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(i) && (i = 0), Object.assign(t, {
    width: e,
    height: i,
    size: t.isHorizontal() ? e : i
  }));
}
function oN() {
  const t = this;
  function e(C, L) {
    return parseFloat(C.getPropertyValue(t.getDirectionLabel(L)) || 0);
  }
  const i = t.params, {
    wrapperEl: n,
    slidesEl: s,
    size: r,
    rtlTranslate: a,
    wrongRTL: o
  } = t, l = t.virtual && i.virtual.enabled, u = l ? t.virtual.slides.length : t.slides.length, d = Ni(s, `.${t.params.slideClass}, swiper-slide`), c = l ? t.virtual.slides.length : d.length;
  let A = [];
  const m = [], p = [];
  let h = i.slidesOffsetBefore;
  typeof h == "function" && (h = i.slidesOffsetBefore.call(t));
  let g = i.slidesOffsetAfter;
  typeof g == "function" && (g = i.slidesOffsetAfter.call(t));
  const w = t.snapGrid.length, b = t.slidesGrid.length;
  let y = i.spaceBetween, D = -h, I = 0, M = 0;
  if (typeof r > "u")
    return;
  typeof y == "string" && y.indexOf("%") >= 0 ? y = parseFloat(y.replace("%", "")) / 100 * r : typeof y == "string" && (y = parseFloat(y)), t.virtualSize = -y, d.forEach((C) => {
    a ? C.style.marginLeft = "" : C.style.marginRight = "", C.style.marginBottom = "", C.style.marginTop = "";
  }), i.centeredSlides && i.cssMode && (il(n, "--swiper-centered-offset-before", ""), il(n, "--swiper-centered-offset-after", ""));
  const _ = i.grid && i.grid.rows > 1 && t.grid;
  _ ? t.grid.initSlides(d) : t.grid && t.grid.unsetSlides();
  let N;
  const x = i.slidesPerView === "auto" && i.breakpoints && Object.keys(i.breakpoints).filter((C) => typeof i.breakpoints[C].slidesPerView < "u").length > 0;
  for (let C = 0; C < c; C += 1) {
    N = 0;
    let L;
    if (d[C] && (L = d[C]), _ && t.grid.updateSlide(C, L, d), !(d[C] && fr(L, "display") === "none")) {
      if (i.slidesPerView === "auto") {
        x && (d[C].style[t.getDirectionLabel("width")] = "");
        const V = getComputedStyle(L), H = L.style.transform, O = L.style.webkitTransform;
        if (H && (L.style.transform = "none"), O && (L.style.webkitTransform = "none"), i.roundLengths)
          N = t.isHorizontal() ? gh(L, "width") : gh(L, "height");
        else {
          const X = e(V, "width"), q = e(V, "padding-left"), F = e(V, "padding-right"), W = e(V, "margin-left"), j = e(V, "margin-right"), oe = V.getPropertyValue("box-sizing");
          if (oe && oe === "border-box")
            N = X + W + j;
          else {
            const {
              clientWidth: $,
              offsetWidth: ye
            } = L;
            N = X + q + F + W + j + (ye - $);
          }
        }
        H && (L.style.transform = H), O && (L.style.webkitTransform = O), i.roundLengths && (N = Math.floor(N));
      } else
        N = (r - (i.slidesPerView - 1) * y) / i.slidesPerView, i.roundLengths && (N = Math.floor(N)), d[C] && (d[C].style[t.getDirectionLabel("width")] = `${N}px`);
      d[C] && (d[C].swiperSlideSize = N), p.push(N), i.centeredSlides ? (D = D + N / 2 + I / 2 + y, I === 0 && C !== 0 && (D = D - r / 2 - y), C === 0 && (D = D - r / 2 - y), Math.abs(D) < 1 / 1e3 && (D = 0), i.roundLengths && (D = Math.floor(D)), M % i.slidesPerGroup === 0 && A.push(D), m.push(D)) : (i.roundLengths && (D = Math.floor(D)), (M - Math.min(t.params.slidesPerGroupSkip, M)) % t.params.slidesPerGroup === 0 && A.push(D), m.push(D), D = D + N + y), t.virtualSize += N + y, I = N, M += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, r) + g, a && o && (i.effect === "slide" || i.effect === "coverflow") && (n.style.width = `${t.virtualSize + y}px`), i.setWrapperSize && (n.style[t.getDirectionLabel("width")] = `${t.virtualSize + y}px`), _ && t.grid.updateWrapperSize(N, A), !i.centeredSlides) {
    const C = [];
    for (let L = 0; L < A.length; L += 1) {
      let V = A[L];
      i.roundLengths && (V = Math.floor(V)), A[L] <= t.virtualSize - r && C.push(V);
    }
    A = C, Math.floor(t.virtualSize - r) - Math.floor(A[A.length - 1]) > 1 && A.push(t.virtualSize - r);
  }
  if (l && i.loop) {
    const C = p[0] + y;
    if (i.slidesPerGroup > 1) {
      const L = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / i.slidesPerGroup), V = C * i.slidesPerGroup;
      for (let H = 0; H < L; H += 1)
        A.push(A[A.length - 1] + V);
    }
    for (let L = 0; L < t.virtual.slidesBefore + t.virtual.slidesAfter; L += 1)
      i.slidesPerGroup === 1 && A.push(A[A.length - 1] + C), m.push(m[m.length - 1] + C), t.virtualSize += C;
  }
  if (A.length === 0 && (A = [0]), y !== 0) {
    const C = t.isHorizontal() && a ? "marginLeft" : t.getDirectionLabel("marginRight");
    d.filter((L, V) => !i.cssMode || i.loop ? !0 : V !== d.length - 1).forEach((L) => {
      L.style[C] = `${y}px`;
    });
  }
  if (i.centeredSlides && i.centeredSlidesBounds) {
    let C = 0;
    p.forEach((V) => {
      C += V + (y || 0);
    }), C -= y;
    const L = C > r ? C - r : 0;
    A = A.map((V) => V <= 0 ? -h : V > L ? L + g : V);
  }
  if (i.centerInsufficientSlides) {
    let C = 0;
    p.forEach((V) => {
      C += V + (y || 0);
    }), C -= y;
    const L = (i.slidesOffsetBefore || 0) + (i.slidesOffsetAfter || 0);
    if (C + L < r) {
      const V = (r - C - L) / 2;
      A.forEach((H, O) => {
        A[O] = H - V;
      }), m.forEach((H, O) => {
        m[O] = H + V;
      });
    }
  }
  if (Object.assign(t, {
    slides: d,
    snapGrid: A,
    slidesGrid: m,
    slidesSizesGrid: p
  }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
    il(n, "--swiper-centered-offset-before", `${-A[0]}px`), il(n, "--swiper-centered-offset-after", `${t.size / 2 - p[p.length - 1] / 2}px`);
    const C = -t.snapGrid[0], L = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map((V) => V + C), t.slidesGrid = t.slidesGrid.map((V) => V + L);
  }
  if (c !== u && t.emit("slidesLengthChange"), A.length !== w && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), m.length !== b && t.emit("slidesGridLengthChange"), i.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !l && !i.cssMode && (i.effect === "slide" || i.effect === "fade")) {
    const C = `${i.containerModifierClass}backface-hidden`, L = t.el.classList.contains(C);
    c <= i.maxBackfaceHiddenSlides ? L || t.el.classList.add(C) : L && t.el.classList.remove(C);
  }
}
function lN(t) {
  const e = this, i = [], n = e.virtual && e.params.virtual.enabled;
  let s = 0, r;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const a = (o) => n ? e.slides[e.getSlideIndexByData(o)] : e.slides[o];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((o) => {
        i.push(o);
      });
    else
      for (r = 0; r < Math.ceil(e.params.slidesPerView); r += 1) {
        const o = e.activeIndex + r;
        if (o > e.slides.length && !n) break;
        i.push(a(o));
      }
  else
    i.push(a(e.activeIndex));
  for (r = 0; r < i.length; r += 1)
    if (typeof i[r] < "u") {
      const o = i[r].offsetHeight;
      s = o > s ? o : s;
    }
  (s || s === 0) && (e.wrapperEl.style.height = `${s}px`);
}
function uN() {
  const t = this, e = t.slides, i = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let n = 0; n < e.length; n += 1)
    e[n].swiperSlideOffset = (t.isHorizontal() ? e[n].offsetLeft : e[n].offsetTop) - i - t.cssOverflowAdjustment();
}
const Ag = (t, e, i) => {
  e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
};
function dN(t) {
  t === void 0 && (t = this && this.translate || 0);
  const e = this, i = e.params, {
    slides: n,
    rtlTranslate: s,
    snapGrid: r
  } = e;
  if (n.length === 0) return;
  typeof n[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let a = -t;
  s && (a = t), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let o = i.spaceBetween;
  typeof o == "string" && o.indexOf("%") >= 0 ? o = parseFloat(o.replace("%", "")) / 100 * e.size : typeof o == "string" && (o = parseFloat(o));
  for (let l = 0; l < n.length; l += 1) {
    const u = n[l];
    let d = u.swiperSlideOffset;
    i.cssMode && i.centeredSlides && (d -= n[0].swiperSlideOffset);
    const c = (a + (i.centeredSlides ? e.minTranslate() : 0) - d) / (u.swiperSlideSize + o), A = (a - r[0] + (i.centeredSlides ? e.minTranslate() : 0) - d) / (u.swiperSlideSize + o), m = -(a - d), p = m + e.slidesSizesGrid[l], h = m >= 0 && m <= e.size - e.slidesSizesGrid[l], g = m >= 0 && m < e.size - 1 || p > 1 && p <= e.size || m <= 0 && p >= e.size;
    g && (e.visibleSlides.push(u), e.visibleSlidesIndexes.push(l)), Ag(u, g, i.slideVisibleClass), Ag(u, h, i.slideFullyVisibleClass), u.progress = s ? -c : c, u.originalProgress = s ? -A : A;
  }
}
function cN(t) {
  const e = this;
  if (typeof t > "u") {
    const d = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * d || 0;
  }
  const i = e.params, n = e.maxTranslate() - e.minTranslate();
  let {
    progress: s,
    isBeginning: r,
    isEnd: a,
    progressLoop: o
  } = e;
  const l = r, u = a;
  if (n === 0)
    s = 0, r = !0, a = !0;
  else {
    s = (t - e.minTranslate()) / n;
    const d = Math.abs(t - e.minTranslate()) < 1, c = Math.abs(t - e.maxTranslate()) < 1;
    r = d || s <= 0, a = c || s >= 1, d && (s = 0), c && (s = 1);
  }
  if (i.loop) {
    const d = e.getSlideIndexByData(0), c = e.getSlideIndexByData(e.slides.length - 1), A = e.slidesGrid[d], m = e.slidesGrid[c], p = e.slidesGrid[e.slidesGrid.length - 1], h = Math.abs(t);
    h >= A ? o = (h - A) / p : o = (h + p - m) / p, o > 1 && (o -= 1);
  }
  Object.assign(e, {
    progress: s,
    progressLoop: o,
    isBeginning: r,
    isEnd: a
  }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && e.updateSlidesProgress(t), r && !l && e.emit("reachBeginning toEdge"), a && !u && e.emit("reachEnd toEdge"), (l && !r || u && !a) && e.emit("fromEdge"), e.emit("progress", s);
}
const mf = (t, e, i) => {
  e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
};
function fN() {
  const t = this, {
    slides: e,
    params: i,
    slidesEl: n,
    activeIndex: s
  } = t, r = t.virtual && i.virtual.enabled, a = t.grid && i.grid && i.grid.rows > 1, o = (c) => Ni(n, `.${i.slideClass}${c}, swiper-slide${c}`)[0];
  let l, u, d;
  if (r)
    if (i.loop) {
      let c = s - t.virtual.slidesBefore;
      c < 0 && (c = t.virtual.slides.length + c), c >= t.virtual.slides.length && (c -= t.virtual.slides.length), l = o(`[data-swiper-slide-index="${c}"]`);
    } else
      l = o(`[data-swiper-slide-index="${s}"]`);
  else
    a ? (l = e.find((c) => c.column === s), d = e.find((c) => c.column === s + 1), u = e.find((c) => c.column === s - 1)) : l = e[s];
  l && (a || (d = $8(l, `.${i.slideClass}, swiper-slide`)[0], i.loop && !d && (d = e[0]), u = J8(l, `.${i.slideClass}, swiper-slide`)[0], i.loop && !u === 0 && (u = e[e.length - 1]))), e.forEach((c) => {
    mf(c, c === l, i.slideActiveClass), mf(c, c === d, i.slideNextClass), mf(c, c === u, i.slidePrevClass);
  }), t.emitSlidesClasses();
}
const Uu = (t, e) => {
  if (!t || t.destroyed || !t.params) return;
  const i = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, n = e.closest(i());
  if (n) {
    let s = n.querySelector(`.${t.params.lazyPreloaderClass}`);
    !s && t.isElement && (n.shadowRoot ? s = n.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      n.shadowRoot && (s = n.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), s && s.remove());
    })), s && s.remove();
  }
}, Af = (t, e) => {
  if (!t.slides[e]) return;
  const i = t.slides[e].querySelector('[loading="lazy"]');
  i && i.removeAttribute("loading");
}, vh = (t) => {
  if (!t || t.destroyed || !t.params) return;
  let e = t.params.lazyPreloadPrevNext;
  const i = t.slides.length;
  if (!i || !e || e < 0) return;
  e = Math.min(e, i);
  const n = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView), s = t.activeIndex;
  if (t.params.grid && t.params.grid.rows > 1) {
    const a = s, o = [a - e];
    o.push(...Array.from({
      length: e
    }).map((l, u) => a + n + u)), t.slides.forEach((l, u) => {
      o.includes(l.column) && Af(t, u);
    });
    return;
  }
  const r = s + n - 1;
  if (t.params.rewind || t.params.loop)
    for (let a = s - e; a <= r + e; a += 1) {
      const o = (a % i + i) % i;
      (o < s || o > r) && Af(t, o);
    }
  else
    for (let a = Math.max(s - e, 0); a <= Math.min(r + e, i - 1); a += 1)
      a !== s && (a > r || a < s) && Af(t, a);
};
function hN(t) {
  const {
    slidesGrid: e,
    params: i
  } = t, n = t.rtlTranslate ? t.translate : -t.translate;
  let s;
  for (let r = 0; r < e.length; r += 1)
    typeof e[r + 1] < "u" ? n >= e[r] && n < e[r + 1] - (e[r + 1] - e[r]) / 2 ? s = r : n >= e[r] && n < e[r + 1] && (s = r + 1) : n >= e[r] && (s = r);
  return i.normalizeSlideIndex && (s < 0 || typeof s > "u") && (s = 0), s;
}
function pN(t) {
  const e = this, i = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: n,
    params: s,
    activeIndex: r,
    realIndex: a,
    snapIndex: o
  } = e;
  let l = t, u;
  const d = (m) => {
    let p = m - e.virtual.slidesBefore;
    return p < 0 && (p = e.virtual.slides.length + p), p >= e.virtual.slides.length && (p -= e.virtual.slides.length), p;
  };
  if (typeof l > "u" && (l = hN(e)), n.indexOf(i) >= 0)
    u = n.indexOf(i);
  else {
    const m = Math.min(s.slidesPerGroupSkip, l);
    u = m + Math.floor((l - m) / s.slidesPerGroup);
  }
  if (u >= n.length && (u = n.length - 1), l === r && !e.params.loop) {
    u !== o && (e.snapIndex = u, e.emit("snapIndexChange"));
    return;
  }
  if (l === r && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = d(l);
    return;
  }
  const c = e.grid && s.grid && s.grid.rows > 1;
  let A;
  if (e.virtual && s.virtual.enabled && s.loop)
    A = d(l);
  else if (c) {
    const m = e.slides.find((h) => h.column === l);
    let p = parseInt(m.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(p) && (p = Math.max(e.slides.indexOf(m), 0)), A = Math.floor(p / s.grid.rows);
  } else if (e.slides[l]) {
    const m = e.slides[l].getAttribute("data-swiper-slide-index");
    m ? A = parseInt(m, 10) : A = l;
  } else
    A = l;
  Object.assign(e, {
    previousSnapIndex: o,
    snapIndex: u,
    previousRealIndex: a,
    realIndex: A,
    previousIndex: r,
    activeIndex: l
  }), e.initialized && vh(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (a !== A && e.emit("realIndexChange"), e.emit("slideChange"));
}
function mN(t, e) {
  const i = this, n = i.params;
  let s = t.closest(`.${n.slideClass}, swiper-slide`);
  !s && i.isElement && e && e.length > 1 && e.includes(t) && [...e.slice(e.indexOf(t) + 1, e.length)].forEach((o) => {
    !s && o.matches && o.matches(`.${n.slideClass}, swiper-slide`) && (s = o);
  });
  let r = !1, a;
  if (s) {
    for (let o = 0; o < i.slides.length; o += 1)
      if (i.slides[o] === s) {
        r = !0, a = o;
        break;
      }
  }
  if (s && r)
    i.clickedSlide = s, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(s.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = a;
  else {
    i.clickedSlide = void 0, i.clickedIndex = void 0;
    return;
  }
  n.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
}
var AN = {
  updateSize: aN,
  updateSlides: oN,
  updateAutoHeight: lN,
  updateSlidesOffset: uN,
  updateSlidesProgress: dN,
  updateProgress: cN,
  updateSlidesClasses: fN,
  updateActiveIndex: pN,
  updateClickedSlide: mN
};
function gN(t) {
  t === void 0 && (t = this.isHorizontal() ? "x" : "y");
  const e = this, {
    params: i,
    rtlTranslate: n,
    translate: s,
    wrapperEl: r
  } = e;
  if (i.virtualTranslate)
    return n ? -s : s;
  if (i.cssMode)
    return s;
  let a = Ah(r, t);
  return a += e.cssOverflowAdjustment(), n && (a = -a), a || 0;
}
function vN(t, e) {
  const i = this, {
    rtlTranslate: n,
    params: s,
    wrapperEl: r,
    progress: a
  } = i;
  let o = 0, l = 0;
  const u = 0;
  i.isHorizontal() ? o = n ? -t : t : l = t, s.roundLengths && (o = Math.floor(o), l = Math.floor(l)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? o : l, s.cssMode ? r[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -o : -l : s.virtualTranslate || (i.isHorizontal() ? o -= i.cssOverflowAdjustment() : l -= i.cssOverflowAdjustment(), r.style.transform = `translate3d(${o}px, ${l}px, ${u}px)`);
  let d;
  const c = i.maxTranslate() - i.minTranslate();
  c === 0 ? d = 0 : d = (t - i.minTranslate()) / c, d !== a && i.updateProgress(t), i.emit("setTranslate", i.translate, e);
}
function yN() {
  return -this.snapGrid[0];
}
function bN() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function wN(t, e, i, n, s) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), i === void 0 && (i = !0), n === void 0 && (n = !0);
  const r = this, {
    params: a,
    wrapperEl: o
  } = r;
  if (r.animating && a.preventInteractionOnTransition)
    return !1;
  const l = r.minTranslate(), u = r.maxTranslate();
  let d;
  if (n && t > l ? d = l : n && t < u ? d = u : d = t, r.updateProgress(d), a.cssMode) {
    const c = r.isHorizontal();
    if (e === 0)
      o[c ? "scrollLeft" : "scrollTop"] = -d;
    else {
      if (!r.support.smoothScroll)
        return Hy({
          swiper: r,
          targetPosition: -d,
          side: c ? "left" : "top"
        }), !0;
      o.scrollTo({
        [c ? "left" : "top"]: -d,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (r.setTransition(0), r.setTranslate(d), i && (r.emit("beforeTransitionStart", e, s), r.emit("transitionEnd"))) : (r.setTransition(e), r.setTranslate(d), i && (r.emit("beforeTransitionStart", e, s), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function(A) {
    !r || r.destroyed || A.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, r.animating = !1, i && r.emit("transitionEnd"));
  }), r.wrapperEl.addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd))), !0;
}
var TN = {
  getTranslate: gN,
  setTranslate: vN,
  minTranslate: yN,
  maxTranslate: bN,
  translateTo: wN
};
function xN(t, e) {
  const i = this;
  i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${t}ms`, i.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), i.emit("setTransition", t, e);
}
function jy(t) {
  let {
    swiper: e,
    runCallbacks: i,
    direction: n,
    step: s
  } = t;
  const {
    activeIndex: r,
    previousIndex: a
  } = e;
  let o = n;
  if (o || (r > a ? o = "next" : r < a ? o = "prev" : o = "reset"), e.emit(`transition${s}`), i && r !== a) {
    if (o === "reset") {
      e.emit(`slideResetTransition${s}`);
      return;
    }
    e.emit(`slideChangeTransition${s}`), o === "next" ? e.emit(`slideNextTransition${s}`) : e.emit(`slidePrevTransition${s}`);
  }
}
function SN(t, e) {
  t === void 0 && (t = !0);
  const i = this, {
    params: n
  } = i;
  n.cssMode || (n.autoHeight && i.updateAutoHeight(), jy({
    swiper: i,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
function CN(t, e) {
  t === void 0 && (t = !0);
  const i = this, {
    params: n
  } = i;
  i.animating = !1, !n.cssMode && (i.setTransition(0), jy({
    swiper: i,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
var EN = {
  setTransition: xN,
  transitionStart: SN,
  transitionEnd: CN
};
function DN(t, e, i, n, s) {
  t === void 0 && (t = 0), i === void 0 && (i = !0), typeof t == "string" && (t = parseInt(t, 10));
  const r = this;
  let a = t;
  a < 0 && (a = 0);
  const {
    params: o,
    snapGrid: l,
    slidesGrid: u,
    previousIndex: d,
    activeIndex: c,
    rtlTranslate: A,
    wrapperEl: m,
    enabled: p
  } = r;
  if (!p && !n && !s || r.destroyed || r.animating && o.preventInteractionOnTransition)
    return !1;
  typeof e > "u" && (e = r.params.speed);
  const h = Math.min(r.params.slidesPerGroupSkip, a);
  let g = h + Math.floor((a - h) / r.params.slidesPerGroup);
  g >= l.length && (g = l.length - 1);
  const w = -l[g];
  if (o.normalizeSlideIndex)
    for (let _ = 0; _ < u.length; _ += 1) {
      const N = -Math.floor(w * 100), x = Math.floor(u[_] * 100), C = Math.floor(u[_ + 1] * 100);
      typeof u[_ + 1] < "u" ? N >= x && N < C - (C - x) / 2 ? a = _ : N >= x && N < C && (a = _ + 1) : N >= x && (a = _);
    }
  if (r.initialized && a !== c && (!r.allowSlideNext && (A ? w > r.translate && w > r.minTranslate() : w < r.translate && w < r.minTranslate()) || !r.allowSlidePrev && w > r.translate && w > r.maxTranslate() && (c || 0) !== a))
    return !1;
  a !== (d || 0) && i && r.emit("beforeSlideChangeStart"), r.updateProgress(w);
  let b;
  a > c ? b = "next" : a < c ? b = "prev" : b = "reset";
  const y = r.virtual && r.params.virtual.enabled;
  if (!(y && s) && (A && -w === r.translate || !A && w === r.translate))
    return r.updateActiveIndex(a), o.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), o.effect !== "slide" && r.setTranslate(w), b !== "reset" && (r.transitionStart(i, b), r.transitionEnd(i, b)), !1;
  if (o.cssMode) {
    const _ = r.isHorizontal(), N = A ? w : -w;
    if (e === 0)
      y && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), y && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0 ? (r._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        m[_ ? "scrollLeft" : "scrollTop"] = N;
      })) : m[_ ? "scrollLeft" : "scrollTop"] = N, y && requestAnimationFrame(() => {
        r.wrapperEl.style.scrollSnapType = "", r._immediateVirtual = !1;
      });
    else {
      if (!r.support.smoothScroll)
        return Hy({
          swiper: r,
          targetPosition: N,
          side: _ ? "left" : "top"
        }), !0;
      m.scrollTo({
        [_ ? "left" : "top"]: N,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const M = Xy().isSafari;
  return y && !s && M && r.isElement && r.virtual.update(!1, !1, a), r.setTransition(e), r.setTranslate(w), r.updateActiveIndex(a), r.updateSlidesClasses(), r.emit("beforeTransitionStart", e, n), r.transitionStart(i, b), e === 0 ? r.transitionEnd(i, b) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function(N) {
    !r || r.destroyed || N.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(i, b));
  }), r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)), !0;
}
function _N(t, e, i, n) {
  t === void 0 && (t = 0), i === void 0 && (i = !0), typeof t == "string" && (t = parseInt(t, 10));
  const s = this;
  if (s.destroyed) return;
  typeof e > "u" && (e = s.params.speed);
  const r = s.grid && s.params.grid && s.params.grid.rows > 1;
  let a = t;
  if (s.params.loop)
    if (s.virtual && s.params.virtual.enabled)
      a = a + s.virtual.slidesBefore;
    else {
      let o;
      if (r) {
        const A = a * s.params.grid.rows;
        o = s.slides.find((m) => m.getAttribute("data-swiper-slide-index") * 1 === A).column;
      } else
        o = s.getSlideIndexByData(a);
      const l = r ? Math.ceil(s.slides.length / s.params.grid.rows) : s.slides.length, {
        centeredSlides: u
      } = s.params;
      let d = s.params.slidesPerView;
      d === "auto" ? d = s.slidesPerViewDynamic() : (d = Math.ceil(parseFloat(s.params.slidesPerView, 10)), u && d % 2 === 0 && (d = d + 1));
      let c = l - o < d;
      if (u && (c = c || o < Math.ceil(d / 2)), n && u && s.params.slidesPerView !== "auto" && !r && (c = !1), c) {
        const A = u ? o < s.activeIndex ? "prev" : "next" : o - s.activeIndex - 1 < s.params.slidesPerView ? "next" : "prev";
        s.loopFix({
          direction: A,
          slideTo: !0,
          activeSlideIndex: A === "next" ? o + 1 : o - l + 1,
          slideRealIndex: A === "next" ? s.realIndex : void 0
        });
      }
      if (r) {
        const A = a * s.params.grid.rows;
        a = s.slides.find((m) => m.getAttribute("data-swiper-slide-index") * 1 === A).column;
      } else
        a = s.getSlideIndexByData(a);
    }
  return requestAnimationFrame(() => {
    s.slideTo(a, e, i, n);
  }), s;
}
function kN(t, e, i) {
  e === void 0 && (e = !0);
  const n = this, {
    enabled: s,
    params: r,
    animating: a
  } = n;
  if (!s || n.destroyed) return n;
  typeof t > "u" && (t = n.params.speed);
  let o = r.slidesPerGroup;
  r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (o = Math.max(n.slidesPerViewDynamic("current", !0), 1));
  const l = n.activeIndex < r.slidesPerGroupSkip ? 1 : o, u = n.virtual && r.virtual.enabled;
  if (r.loop) {
    if (a && !u && r.loopPreventsSliding) return !1;
    if (n.loopFix({
      direction: "next"
    }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && r.cssMode)
      return requestAnimationFrame(() => {
        n.slideTo(n.activeIndex + l, t, e, i);
      }), !0;
  }
  return r.rewind && n.isEnd ? n.slideTo(0, t, e, i) : n.slideTo(n.activeIndex + l, t, e, i);
}
function PN(t, e, i) {
  e === void 0 && (e = !0);
  const n = this, {
    params: s,
    snapGrid: r,
    slidesGrid: a,
    rtlTranslate: o,
    enabled: l,
    animating: u
  } = n;
  if (!l || n.destroyed) return n;
  typeof t > "u" && (t = n.params.speed);
  const d = n.virtual && s.virtual.enabled;
  if (s.loop) {
    if (u && !d && s.loopPreventsSliding) return !1;
    n.loopFix({
      direction: "prev"
    }), n._clientLeft = n.wrapperEl.clientLeft;
  }
  const c = o ? n.translate : -n.translate;
  function A(b) {
    return b < 0 ? -Math.floor(Math.abs(b)) : Math.floor(b);
  }
  const m = A(c), p = r.map((b) => A(b)), h = s.freeMode && s.freeMode.enabled;
  let g = r[p.indexOf(m) - 1];
  if (typeof g > "u" && (s.cssMode || h)) {
    let b;
    r.forEach((y, D) => {
      m >= y && (b = D);
    }), typeof b < "u" && (g = h ? r[b] : r[b > 0 ? b - 1 : b]);
  }
  let w = 0;
  if (typeof g < "u" && (w = a.indexOf(g), w < 0 && (w = n.activeIndex - 1), s.slidesPerView === "auto" && s.slidesPerGroup === 1 && s.slidesPerGroupAuto && (w = w - n.slidesPerViewDynamic("previous", !0) + 1, w = Math.max(w, 0))), s.rewind && n.isBeginning) {
    const b = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
    return n.slideTo(b, t, e, i);
  } else if (s.loop && n.activeIndex === 0 && s.cssMode)
    return requestAnimationFrame(() => {
      n.slideTo(w, t, e, i);
    }), !0;
  return n.slideTo(w, t, e, i);
}
function IN(t, e, i) {
  e === void 0 && (e = !0);
  const n = this;
  if (!n.destroyed)
    return typeof t > "u" && (t = n.params.speed), n.slideTo(n.activeIndex, t, e, i);
}
function MN(t, e, i, n) {
  e === void 0 && (e = !0), n === void 0 && (n = 0.5);
  const s = this;
  if (s.destroyed) return;
  typeof t > "u" && (t = s.params.speed);
  let r = s.activeIndex;
  const a = Math.min(s.params.slidesPerGroupSkip, r), o = a + Math.floor((r - a) / s.params.slidesPerGroup), l = s.rtlTranslate ? s.translate : -s.translate;
  if (l >= s.snapGrid[o]) {
    const u = s.snapGrid[o], d = s.snapGrid[o + 1];
    l - u > (d - u) * n && (r += s.params.slidesPerGroup);
  } else {
    const u = s.snapGrid[o - 1], d = s.snapGrid[o];
    l - u <= (d - u) * n && (r -= s.params.slidesPerGroup);
  }
  return r = Math.max(r, 0), r = Math.min(r, s.slidesGrid.length - 1), s.slideTo(r, t, e, i);
}
function ON() {
  const t = this;
  if (t.destroyed) return;
  const {
    params: e,
    slidesEl: i
  } = t, n = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let s = t.clickedIndex, r;
  const a = t.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (t.animating) return;
    r = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? s < t.loopedSlides - n / 2 || s > t.slides.length - t.loopedSlides + n / 2 ? (t.loopFix(), s = t.getSlideIndex(Ni(i, `${a}[data-swiper-slide-index="${r}"]`)[0]), ta(() => {
      t.slideTo(s);
    })) : t.slideTo(s) : s > t.slides.length - n ? (t.loopFix(), s = t.getSlideIndex(Ni(i, `${a}[data-swiper-slide-index="${r}"]`)[0]), ta(() => {
      t.slideTo(s);
    })) : t.slideTo(s);
  } else
    t.slideTo(s);
}
var BN = {
  slideTo: DN,
  slideToLoop: _N,
  slideNext: kN,
  slidePrev: PN,
  slideReset: IN,
  slideToClosest: MN,
  slideToClickedSlide: ON
};
function LN(t, e) {
  const i = this, {
    params: n,
    slidesEl: s
  } = i;
  if (!n.loop || i.virtual && i.params.virtual.enabled) return;
  const r = () => {
    Ni(s, `.${n.slideClass}, swiper-slide`).forEach((A, m) => {
      A.setAttribute("data-swiper-slide-index", m);
    });
  }, a = i.grid && n.grid && n.grid.rows > 1, o = n.slidesPerGroup * (a ? n.grid.rows : 1), l = i.slides.length % o !== 0, u = a && i.slides.length % n.grid.rows !== 0, d = (c) => {
    for (let A = 0; A < c; A += 1) {
      const m = i.isElement ? bn("swiper-slide", [n.slideBlankClass]) : bn("div", [n.slideClass, n.slideBlankClass]);
      i.slidesEl.append(m);
    }
  };
  if (l) {
    if (n.loopAddBlankSlides) {
      const c = o - i.slides.length % o;
      d(c), i.recalcSlides(), i.updateSlides();
    } else
      ld("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else if (u) {
    if (n.loopAddBlankSlides) {
      const c = n.grid.rows - i.slides.length % n.grid.rows;
      d(c), i.recalcSlides(), i.updateSlides();
    } else
      ld("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else
    r();
  i.loopFix({
    slideRealIndex: t,
    direction: n.centeredSlides ? void 0 : "next",
    initial: e
  });
}
function NN(t) {
  let {
    slideRealIndex: e,
    slideTo: i = !0,
    direction: n,
    setTranslate: s,
    activeSlideIndex: r,
    initial: a,
    byController: o,
    byMousewheel: l
  } = t === void 0 ? {} : t;
  const u = this;
  if (!u.params.loop) return;
  u.emit("beforeLoopFix");
  const {
    slides: d,
    allowSlidePrev: c,
    allowSlideNext: A,
    slidesEl: m,
    params: p
  } = u, {
    centeredSlides: h,
    initialSlide: g
  } = p;
  if (u.allowSlidePrev = !0, u.allowSlideNext = !0, u.virtual && p.virtual.enabled) {
    i && (!p.centeredSlides && u.snapIndex === 0 ? u.slideTo(u.virtual.slides.length, 0, !1, !0) : p.centeredSlides && u.snapIndex < p.slidesPerView ? u.slideTo(u.virtual.slides.length + u.snapIndex, 0, !1, !0) : u.snapIndex === u.snapGrid.length - 1 && u.slideTo(u.virtual.slidesBefore, 0, !1, !0)), u.allowSlidePrev = c, u.allowSlideNext = A, u.emit("loopFix");
    return;
  }
  let w = p.slidesPerView;
  w === "auto" ? w = u.slidesPerViewDynamic() : (w = Math.ceil(parseFloat(p.slidesPerView, 10)), h && w % 2 === 0 && (w = w + 1));
  const b = p.slidesPerGroupAuto ? w : p.slidesPerGroup;
  let y = b;
  y % b !== 0 && (y += b - y % b), y += p.loopAdditionalSlides, u.loopedSlides = y;
  const D = u.grid && p.grid && p.grid.rows > 1;
  d.length < w + y || u.params.effect === "cards" && d.length < w + y * 2 ? ld("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : D && p.grid.fill === "row" && ld("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const I = [], M = [], _ = D ? Math.ceil(d.length / p.grid.rows) : d.length, N = a && _ - g < w && !h;
  let x = N ? g : u.activeIndex;
  typeof r > "u" ? r = u.getSlideIndex(d.find((q) => q.classList.contains(p.slideActiveClass))) : x = r;
  const C = n === "next" || !n, L = n === "prev" || !n;
  let V = 0, H = 0;
  const X = (D ? d[r].column : r) + (h && typeof s > "u" ? -w / 2 + 0.5 : 0);
  if (X < y) {
    V = Math.max(y - X, b);
    for (let q = 0; q < y - X; q += 1) {
      const F = q - Math.floor(q / _) * _;
      if (D) {
        const W = _ - F - 1;
        for (let j = d.length - 1; j >= 0; j -= 1)
          d[j].column === W && I.push(j);
      } else
        I.push(_ - F - 1);
    }
  } else if (X + w > _ - y) {
    H = Math.max(X - (_ - y * 2), b), N && (H = Math.max(H, w - _ + g + 1));
    for (let q = 0; q < H; q += 1) {
      const F = q - Math.floor(q / _) * _;
      D ? d.forEach((W, j) => {
        W.column === F && M.push(j);
      }) : M.push(F);
    }
  }
  if (u.__preventObserver__ = !0, requestAnimationFrame(() => {
    u.__preventObserver__ = !1;
  }), u.params.effect === "cards" && d.length < w + y * 2 && (M.includes(r) && M.splice(M.indexOf(r), 1), I.includes(r) && I.splice(I.indexOf(r), 1)), L && I.forEach((q) => {
    d[q].swiperLoopMoveDOM = !0, m.prepend(d[q]), d[q].swiperLoopMoveDOM = !1;
  }), C && M.forEach((q) => {
    d[q].swiperLoopMoveDOM = !0, m.append(d[q]), d[q].swiperLoopMoveDOM = !1;
  }), u.recalcSlides(), p.slidesPerView === "auto" ? u.updateSlides() : D && (I.length > 0 && L || M.length > 0 && C) && u.slides.forEach((q, F) => {
    u.grid.updateSlide(F, q, u.slides);
  }), p.watchSlidesProgress && u.updateSlidesOffset(), i) {
    if (I.length > 0 && L) {
      if (typeof e > "u") {
        const q = u.slidesGrid[x], W = u.slidesGrid[x + V] - q;
        l ? u.setTranslate(u.translate - W) : (u.slideTo(x + Math.ceil(V), 0, !1, !0), s && (u.touchEventsData.startTranslate = u.touchEventsData.startTranslate - W, u.touchEventsData.currentTranslate = u.touchEventsData.currentTranslate - W));
      } else if (s) {
        const q = D ? I.length / p.grid.rows : I.length;
        u.slideTo(u.activeIndex + q, 0, !1, !0), u.touchEventsData.currentTranslate = u.translate;
      }
    } else if (M.length > 0 && C)
      if (typeof e > "u") {
        const q = u.slidesGrid[x], W = u.slidesGrid[x - H] - q;
        l ? u.setTranslate(u.translate - W) : (u.slideTo(x - H, 0, !1, !0), s && (u.touchEventsData.startTranslate = u.touchEventsData.startTranslate - W, u.touchEventsData.currentTranslate = u.touchEventsData.currentTranslate - W));
      } else {
        const q = D ? M.length / p.grid.rows : M.length;
        u.slideTo(u.activeIndex - q, 0, !1, !0);
      }
  }
  if (u.allowSlidePrev = c, u.allowSlideNext = A, u.controller && u.controller.control && !o) {
    const q = {
      slideRealIndex: e,
      direction: n,
      setTranslate: s,
      activeSlideIndex: r,
      byController: !0
    };
    Array.isArray(u.controller.control) ? u.controller.control.forEach((F) => {
      !F.destroyed && F.params.loop && F.loopFix({
        ...q,
        slideTo: F.params.slidesPerView === p.slidesPerView ? i : !1
      });
    }) : u.controller.control instanceof u.constructor && u.controller.control.params.loop && u.controller.control.loopFix({
      ...q,
      slideTo: u.controller.control.params.slidesPerView === p.slidesPerView ? i : !1
    });
  }
  u.emit("loopFix");
}
function RN() {
  const t = this, {
    params: e,
    slidesEl: i
  } = t;
  if (!e.loop || !i || t.virtual && t.params.virtual.enabled) return;
  t.recalcSlides();
  const n = [];
  t.slides.forEach((s) => {
    const r = typeof s.swiperSlideIndex > "u" ? s.getAttribute("data-swiper-slide-index") * 1 : s.swiperSlideIndex;
    n[r] = s;
  }), t.slides.forEach((s) => {
    s.removeAttribute("data-swiper-slide-index");
  }), n.forEach((s) => {
    i.append(s);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
var FN = {
  loopCreate: LN,
  loopFix: NN,
  loopDestroy: RN
};
function zN(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const i = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), i.style.cursor = "move", i.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function UN() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
var VN = {
  setGrabCursor: zN,
  unsetGrabCursor: UN
};
function qN(t, e) {
  e === void 0 && (e = this);
  function i(n) {
    if (!n || n === Pi() || n === Jt()) return null;
    n.assignedSlot && (n = n.assignedSlot);
    const s = n.closest(t);
    return !s && !n.getRootNode ? null : s || i(n.getRootNode().host);
  }
  return i(e);
}
function gg(t, e, i) {
  const n = Jt(), {
    params: s
  } = t, r = s.edgeSwipeDetection, a = s.edgeSwipeThreshold;
  return r && (i <= a || i >= n.innerWidth - a) ? r === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function HN(t) {
  const e = this, i = Pi();
  let n = t;
  n.originalEvent && (n = n.originalEvent);
  const s = e.touchEventsData;
  if (n.type === "pointerdown") {
    if (s.pointerId !== null && s.pointerId !== n.pointerId)
      return;
    s.pointerId = n.pointerId;
  } else n.type === "touchstart" && n.targetTouches.length === 1 && (s.touchId = n.targetTouches[0].identifier);
  if (n.type === "touchstart") {
    gg(e, n, n.targetTouches[0].pageX);
    return;
  }
  const {
    params: r,
    touches: a,
    enabled: o
  } = e;
  if (!o || !r.simulateTouch && n.pointerType === "mouse" || e.animating && r.preventInteractionOnTransition)
    return;
  !e.animating && r.cssMode && r.loop && e.loopFix();
  let l = n.target;
  if (r.touchEventsTarget === "wrapper" && !K8(l, e.wrapperEl) || "which" in n && n.which === 3 || "button" in n && n.button > 0 || s.isTouched && s.isMoved) return;
  const u = !!r.noSwipingClass && r.noSwipingClass !== "", d = n.composedPath ? n.composedPath() : n.path;
  u && n.target && n.target.shadowRoot && d && (l = d[0]);
  const c = r.noSwipingSelector ? r.noSwipingSelector : `.${r.noSwipingClass}`, A = !!(n.target && n.target.shadowRoot);
  if (r.noSwiping && (A ? qN(c, l) : l.closest(c))) {
    e.allowClick = !0;
    return;
  }
  if (r.swipeHandler && !l.closest(r.swipeHandler))
    return;
  a.currentX = n.pageX, a.currentY = n.pageY;
  const m = a.currentX, p = a.currentY;
  if (!gg(e, n, m))
    return;
  Object.assign(s, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), a.startX = m, a.startY = p, s.touchStartTime = Mn(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, r.threshold > 0 && (s.allowThresholdMove = !1);
  let h = !0;
  l.matches(s.focusableElements) && (h = !1, l.nodeName === "SELECT" && (s.isTouched = !1)), i.activeElement && i.activeElement.matches(s.focusableElements) && i.activeElement !== l && (n.pointerType === "mouse" || n.pointerType !== "mouse" && !l.matches(s.focusableElements)) && i.activeElement.blur();
  const g = h && e.allowTouchMove && r.touchStartPreventDefault;
  (r.touchStartForcePreventDefault || g) && !l.isContentEditable && n.preventDefault(), r.freeMode && r.freeMode.enabled && e.freeMode && e.animating && !r.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", n);
}
function WN(t) {
  const e = Pi(), i = this, n = i.touchEventsData, {
    params: s,
    touches: r,
    rtlTranslate: a,
    enabled: o
  } = i;
  if (!o || !s.simulateTouch && t.pointerType === "mouse") return;
  let l = t;
  if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (n.touchId !== null || l.pointerId !== n.pointerId))
    return;
  let u;
  if (l.type === "touchmove") {
    if (u = [...l.changedTouches].find((I) => I.identifier === n.touchId), !u || u.identifier !== n.touchId) return;
  } else
    u = l;
  if (!n.isTouched) {
    n.startMoving && n.isScrolling && i.emit("touchMoveOpposite", l);
    return;
  }
  const d = u.pageX, c = u.pageY;
  if (l.preventedByNestedSwiper) {
    r.startX = d, r.startY = c;
    return;
  }
  if (!i.allowTouchMove) {
    l.target.matches(n.focusableElements) || (i.allowClick = !1), n.isTouched && (Object.assign(r, {
      startX: d,
      startY: c,
      currentX: d,
      currentY: c
    }), n.touchStartTime = Mn());
    return;
  }
  if (s.touchReleaseOnEdges && !s.loop)
    if (i.isVertical()) {
      if (c < r.startY && i.translate <= i.maxTranslate() || c > r.startY && i.translate >= i.minTranslate()) {
        n.isTouched = !1, n.isMoved = !1;
        return;
      }
    } else {
      if (a && (d > r.startX && -i.translate <= i.maxTranslate() || d < r.startX && -i.translate >= i.minTranslate()))
        return;
      if (!a && (d < r.startX && i.translate <= i.maxTranslate() || d > r.startX && i.translate >= i.minTranslate()))
        return;
    }
  if (e.activeElement && e.activeElement.matches(n.focusableElements) && e.activeElement !== l.target && l.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && l.target === e.activeElement && l.target.matches(n.focusableElements)) {
    n.isMoved = !0, i.allowClick = !1;
    return;
  }
  n.allowTouchCallbacks && i.emit("touchMove", l), r.previousX = r.currentX, r.previousY = r.currentY, r.currentX = d, r.currentY = c;
  const A = r.currentX - r.startX, m = r.currentY - r.startY;
  if (i.params.threshold && Math.sqrt(A ** 2 + m ** 2) < i.params.threshold) return;
  if (typeof n.isScrolling > "u") {
    let I;
    i.isHorizontal() && r.currentY === r.startY || i.isVertical() && r.currentX === r.startX ? n.isScrolling = !1 : A * A + m * m >= 25 && (I = Math.atan2(Math.abs(m), Math.abs(A)) * 180 / Math.PI, n.isScrolling = i.isHorizontal() ? I > s.touchAngle : 90 - I > s.touchAngle);
  }
  if (n.isScrolling && i.emit("touchMoveOpposite", l), typeof n.startMoving > "u" && (r.currentX !== r.startX || r.currentY !== r.startY) && (n.startMoving = !0), n.isScrolling || l.type === "touchmove" && n.preventTouchMoveFromPointerMove) {
    n.isTouched = !1;
    return;
  }
  if (!n.startMoving)
    return;
  i.allowClick = !1, !s.cssMode && l.cancelable && l.preventDefault(), s.touchMoveStopPropagation && !s.nested && l.stopPropagation();
  let p = i.isHorizontal() ? A : m, h = i.isHorizontal() ? r.currentX - r.previousX : r.currentY - r.previousY;
  s.oneWayMovement && (p = Math.abs(p) * (a ? 1 : -1), h = Math.abs(h) * (a ? 1 : -1)), r.diff = p, p *= s.touchRatio, a && (p = -p, h = -h);
  const g = i.touchesDirection;
  i.swipeDirection = p > 0 ? "prev" : "next", i.touchesDirection = h > 0 ? "prev" : "next";
  const w = i.params.loop && !s.cssMode, b = i.touchesDirection === "next" && i.allowSlideNext || i.touchesDirection === "prev" && i.allowSlidePrev;
  if (!n.isMoved) {
    if (w && b && i.loopFix({
      direction: i.swipeDirection
    }), n.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
      const I = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      i.wrapperEl.dispatchEvent(I);
    }
    n.allowMomentumBounce = !1, s.grabCursor && (i.allowSlideNext === !0 || i.allowSlidePrev === !0) && i.setGrabCursor(!0), i.emit("sliderFirstMove", l);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), s._loopSwapReset !== !1 && n.isMoved && n.allowThresholdMove && g !== i.touchesDirection && w && b && Math.abs(p) >= 1) {
    Object.assign(r, {
      startX: d,
      startY: c,
      currentX: d,
      currentY: c,
      startTranslate: n.currentTranslate
    }), n.loopSwapReset = !0, n.startTranslate = n.currentTranslate;
    return;
  }
  i.emit("sliderMove", l), n.isMoved = !0, n.currentTranslate = p + n.startTranslate;
  let y = !0, D = s.resistanceRatio;
  if (s.touchReleaseOnEdges && (D = 0), p > 0 ? (w && b && n.allowThresholdMove && n.currentTranslate > (s.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] - (s.slidesPerView !== "auto" && i.slides.length - s.slidesPerView >= 2 ? i.slidesSizesGrid[i.activeIndex + 1] + i.params.spaceBetween : 0) - i.params.spaceBetween : i.minTranslate()) && i.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), n.currentTranslate > i.minTranslate() && (y = !1, s.resistance && (n.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + n.startTranslate + p) ** D))) : p < 0 && (w && b && n.allowThresholdMove && n.currentTranslate < (s.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween + (s.slidesPerView !== "auto" && i.slides.length - s.slidesPerView >= 2 ? i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween : 0) : i.maxTranslate()) && i.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: i.slides.length - (s.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(s.slidesPerView, 10)))
  }), n.currentTranslate < i.maxTranslate() && (y = !1, s.resistance && (n.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - n.startTranslate - p) ** D))), y && (l.preventedByNestedSwiper = !0), !i.allowSlideNext && i.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !i.allowSlidePrev && i.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !i.allowSlidePrev && !i.allowSlideNext && (n.currentTranslate = n.startTranslate), s.threshold > 0)
    if (Math.abs(p) > s.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = !0, r.startX = r.currentX, r.startY = r.currentY, n.currentTranslate = n.startTranslate, r.diff = i.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
  !s.followFinger || s.cssMode || ((s.freeMode && s.freeMode.enabled && i.freeMode || s.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), s.freeMode && s.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(n.currentTranslate), i.setTranslate(n.currentTranslate));
}
function YN(t) {
  const e = this, i = e.touchEventsData;
  let n = t;
  n.originalEvent && (n = n.originalEvent);
  let s;
  if (n.type === "touchend" || n.type === "touchcancel") {
    if (s = [...n.changedTouches].find((I) => I.identifier === i.touchId), !s || s.identifier !== i.touchId) return;
  } else {
    if (i.touchId !== null || n.pointerId !== i.pointerId) return;
    s = n;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  i.pointerId = null, i.touchId = null;
  const {
    params: a,
    touches: o,
    rtlTranslate: l,
    slidesGrid: u,
    enabled: d
  } = e;
  if (!d || !a.simulateTouch && n.pointerType === "mouse") return;
  if (i.allowTouchCallbacks && e.emit("touchEnd", n), i.allowTouchCallbacks = !1, !i.isTouched) {
    i.isMoved && a.grabCursor && e.setGrabCursor(!1), i.isMoved = !1, i.startMoving = !1;
    return;
  }
  a.grabCursor && i.isMoved && i.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const c = Mn(), A = c - i.touchStartTime;
  if (e.allowClick) {
    const I = n.path || n.composedPath && n.composedPath();
    e.updateClickedSlide(I && I[0] || n.target, I), e.emit("tap click", n), A < 300 && c - i.lastClickTime < 300 && e.emit("doubleTap doubleClick", n);
  }
  if (i.lastClickTime = Mn(), ta(() => {
    e.destroyed || (e.allowClick = !0);
  }), !i.isTouched || !i.isMoved || !e.swipeDirection || o.diff === 0 && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) {
    i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
    return;
  }
  i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
  let m;
  if (a.followFinger ? m = l ? e.translate : -e.translate : m = -i.currentTranslate, a.cssMode)
    return;
  if (a.freeMode && a.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: m
    });
    return;
  }
  const p = m >= -e.maxTranslate() && !e.params.loop;
  let h = 0, g = e.slidesSizesGrid[0];
  for (let I = 0; I < u.length; I += I < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
    const M = I < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
    typeof u[I + M] < "u" ? (p || m >= u[I] && m < u[I + M]) && (h = I, g = u[I + M] - u[I]) : (p || m >= u[I]) && (h = I, g = u[u.length - 1] - u[u.length - 2]);
  }
  let w = null, b = null;
  a.rewind && (e.isBeginning ? b = a.virtual && a.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (w = 0));
  const y = (m - u[h]) / g, D = h < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
  if (A > a.longSwipesMs) {
    if (!a.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (y >= a.longSwipesRatio ? e.slideTo(a.rewind && e.isEnd ? w : h + D) : e.slideTo(h)), e.swipeDirection === "prev" && (y > 1 - a.longSwipesRatio ? e.slideTo(h + D) : b !== null && y < 0 && Math.abs(y) > a.longSwipesRatio ? e.slideTo(b) : e.slideTo(h));
  } else {
    if (!a.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (n.target === e.navigation.nextEl || n.target === e.navigation.prevEl) ? n.target === e.navigation.nextEl ? e.slideTo(h + D) : e.slideTo(h) : (e.swipeDirection === "next" && e.slideTo(w !== null ? w : h + D), e.swipeDirection === "prev" && e.slideTo(b !== null ? b : h));
  }
}
function vg() {
  const t = this, {
    params: e,
    el: i
  } = t;
  if (i && i.offsetWidth === 0) return;
  e.breakpoints && t.setBreakpoint();
  const {
    allowSlideNext: n,
    allowSlidePrev: s,
    snapGrid: r
  } = t, a = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const o = a && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !o ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !a ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = s, t.allowSlideNext = n, t.params.watchOverflow && r !== t.snapGrid && t.checkOverflow();
}
function XN(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function jN() {
  const t = this, {
    wrapperEl: e,
    rtlTranslate: i,
    enabled: n
  } = t;
  if (!n) return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let s;
  const r = t.maxTranslate() - t.minTranslate();
  r === 0 ? s = 0 : s = (t.translate - t.minTranslate()) / r, s !== t.progress && t.updateProgress(i ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function GN(t) {
  const e = this;
  Uu(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function QN() {
  const t = this;
  t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = !0, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
}
const Gy = (t, e) => {
  const i = Pi(), {
    params: n,
    el: s,
    wrapperEl: r,
    device: a
  } = t, o = !!n.nested, l = e === "on" ? "addEventListener" : "removeEventListener", u = e;
  !s || typeof s == "string" || (i[l]("touchstart", t.onDocumentTouchStart, {
    passive: !1,
    capture: o
  }), s[l]("touchstart", t.onTouchStart, {
    passive: !1
  }), s[l]("pointerdown", t.onTouchStart, {
    passive: !1
  }), i[l]("touchmove", t.onTouchMove, {
    passive: !1,
    capture: o
  }), i[l]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: o
  }), i[l]("touchend", t.onTouchEnd, {
    passive: !0
  }), i[l]("pointerup", t.onTouchEnd, {
    passive: !0
  }), i[l]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), i[l]("touchcancel", t.onTouchEnd, {
    passive: !0
  }), i[l]("pointerout", t.onTouchEnd, {
    passive: !0
  }), i[l]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), i[l]("contextmenu", t.onTouchEnd, {
    passive: !0
  }), (n.preventClicks || n.preventClicksPropagation) && s[l]("click", t.onClick, !0), n.cssMode && r[l]("scroll", t.onScroll), n.updateOnWindowResize ? t[u](a.ios || a.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", vg, !0) : t[u]("observerUpdate", vg, !0), s[l]("load", t.onLoad, {
    capture: !0
  }));
};
function ZN() {
  const t = this, {
    params: e
  } = t;
  t.onTouchStart = HN.bind(t), t.onTouchMove = WN.bind(t), t.onTouchEnd = YN.bind(t), t.onDocumentTouchStart = QN.bind(t), e.cssMode && (t.onScroll = jN.bind(t)), t.onClick = XN.bind(t), t.onLoad = GN.bind(t), Gy(t, "on");
}
function KN() {
  Gy(this, "off");
}
var JN = {
  attachEvents: ZN,
  detachEvents: KN
};
const yg = (t, e) => t.grid && e.grid && e.grid.rows > 1;
function $N() {
  const t = this, {
    realIndex: e,
    initialized: i,
    params: n,
    el: s
  } = t, r = n.breakpoints;
  if (!r || r && Object.keys(r).length === 0) return;
  const a = Pi(), o = n.breakpointsBase === "window" || !n.breakpointsBase ? n.breakpointsBase : "container", l = ["window", "container"].includes(n.breakpointsBase) || !n.breakpointsBase ? t.el : a.querySelector(n.breakpointsBase), u = t.getBreakpoint(r, o, l);
  if (!u || t.currentBreakpoint === u) return;
  const c = (u in r ? r[u] : void 0) || t.originalParams, A = yg(t, n), m = yg(t, c), p = t.params.grabCursor, h = c.grabCursor, g = n.enabled;
  A && !m ? (s.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), t.emitContainerClasses()) : !A && m && (s.classList.add(`${n.containerModifierClass}grid`), (c.grid.fill && c.grid.fill === "column" || !c.grid.fill && n.grid.fill === "column") && s.classList.add(`${n.containerModifierClass}grid-column`), t.emitContainerClasses()), p && !h ? t.unsetGrabCursor() : !p && h && t.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((M) => {
    if (typeof c[M] > "u") return;
    const _ = n[M] && n[M].enabled, N = c[M] && c[M].enabled;
    _ && !N && t[M].disable(), !_ && N && t[M].enable();
  });
  const w = c.direction && c.direction !== n.direction, b = n.loop && (c.slidesPerView !== n.slidesPerView || w), y = n.loop;
  w && i && t.changeDirection(), gn(t.params, c);
  const D = t.params.enabled, I = t.params.loop;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), g && !D ? t.disable() : !g && D && t.enable(), t.currentBreakpoint = u, t.emit("_beforeBreakpoint", c), i && (b ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides()) : !y && I ? (t.loopCreate(e), t.updateSlides()) : y && !I && t.loopDestroy()), t.emit("breakpoint", c);
}
function e5(t, e, i) {
  if (e === void 0 && (e = "window"), !t || e === "container" && !i) return;
  let n = !1;
  const s = Jt(), r = e === "window" ? s.innerHeight : i.clientHeight, a = Object.keys(t).map((o) => {
    if (typeof o == "string" && o.indexOf("@") === 0) {
      const l = parseFloat(o.substr(1));
      return {
        value: r * l,
        point: o
      };
    }
    return {
      value: o,
      point: o
    };
  });
  a.sort((o, l) => parseInt(o.value, 10) - parseInt(l.value, 10));
  for (let o = 0; o < a.length; o += 1) {
    const {
      point: l,
      value: u
    } = a[o];
    e === "window" ? s.matchMedia(`(min-width: ${u}px)`).matches && (n = l) : u <= i.clientWidth && (n = l);
  }
  return n || "max";
}
var t5 = {
  setBreakpoint: $N,
  getBreakpoint: e5
};
function i5(t, e) {
  const i = [];
  return t.forEach((n) => {
    typeof n == "object" ? Object.keys(n).forEach((s) => {
      n[s] && i.push(e + s);
    }) : typeof n == "string" && i.push(e + n);
  }), i;
}
function n5() {
  const t = this, {
    classNames: e,
    params: i,
    rtl: n,
    el: s,
    device: r
  } = t, a = i5(["initialized", i.direction, {
    "free-mode": t.params.freeMode && i.freeMode.enabled
  }, {
    autoheight: i.autoHeight
  }, {
    rtl: n
  }, {
    grid: i.grid && i.grid.rows > 1
  }, {
    "grid-column": i.grid && i.grid.rows > 1 && i.grid.fill === "column"
  }, {
    android: r.android
  }, {
    ios: r.ios
  }, {
    "css-mode": i.cssMode
  }, {
    centered: i.cssMode && i.centeredSlides
  }, {
    "watch-progress": i.watchSlidesProgress
  }], i.containerModifierClass);
  e.push(...a), s.classList.add(...e), t.emitContainerClasses();
}
function s5() {
  const t = this, {
    el: e,
    classNames: i
  } = t;
  !e || typeof e == "string" || (e.classList.remove(...i), t.emitContainerClasses());
}
var r5 = {
  addClasses: n5,
  removeClasses: s5
};
function a5() {
  const t = this, {
    isLocked: e,
    params: i
  } = t, {
    slidesOffsetBefore: n
  } = i;
  if (n) {
    const s = t.slides.length - 1, r = t.slidesGrid[s] + t.slidesSizesGrid[s] + n * 2;
    t.isLocked = t.size > r;
  } else
    t.isLocked = t.snapGrid.length === 1;
  i.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), i.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
var o5 = {
  checkOverflow: a5
}, yh = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function l5(t, e) {
  return function(n) {
    n === void 0 && (n = {});
    const s = Object.keys(n)[0], r = n[s];
    if (typeof r != "object" || r === null) {
      gn(e, n);
      return;
    }
    if (t[s] === !0 && (t[s] = {
      enabled: !0
    }), s === "navigation" && t[s] && t[s].enabled && !t[s].prevEl && !t[s].nextEl && (t[s].auto = !0), ["pagination", "scrollbar"].indexOf(s) >= 0 && t[s] && t[s].enabled && !t[s].el && (t[s].auto = !0), !(s in t && "enabled" in r)) {
      gn(e, n);
      return;
    }
    typeof t[s] == "object" && !("enabled" in t[s]) && (t[s].enabled = !0), t[s] || (t[s] = {
      enabled: !1
    }), gn(e, n);
  };
}
const gf = {
  eventsEmitter: rN,
  update: AN,
  translate: TN,
  transition: EN,
  slide: BN,
  loop: FN,
  grabCursor: VN,
  events: JN,
  breakpoints: t5,
  checkOverflow: o5,
  classes: r5
}, vf = {};
class An {
  constructor() {
    let e, i;
    for (var n = arguments.length, s = new Array(n), r = 0; r < n; r++)
      s[r] = arguments[r];
    s.length === 1 && s[0].constructor && Object.prototype.toString.call(s[0]).slice(8, -1) === "Object" ? i = s[0] : [e, i] = s, i || (i = {}), i = gn({}, i), e && !i.el && (i.el = e);
    const a = Pi();
    if (i.el && typeof i.el == "string" && a.querySelectorAll(i.el).length > 1) {
      const d = [];
      return a.querySelectorAll(i.el).forEach((c) => {
        const A = gn({}, i, {
          el: c
        });
        d.push(new An(A));
      }), d;
    }
    const o = this;
    o.__swiper__ = !0, o.support = Wy(), o.device = Yy({
      userAgent: i.userAgent
    }), o.browser = Xy(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], i.modules && Array.isArray(i.modules) && o.modules.push(...i.modules);
    const l = {};
    o.modules.forEach((d) => {
      d({
        params: i,
        swiper: o,
        extendParams: l5(i, l),
        on: o.on.bind(o),
        once: o.once.bind(o),
        off: o.off.bind(o),
        emit: o.emit.bind(o)
      });
    });
    const u = gn({}, yh, l);
    return o.params = gn({}, u, vf, i), o.originalParams = gn({}, o.params), o.passedParams = gn({}, i), o.params && o.params.on && Object.keys(o.params.on).forEach((d) => {
      o.on(d, o.params.on[d]);
    }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, {
      enabled: o.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return o.params.direction === "horizontal";
      },
      isVertical() {
        return o.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: o.params.allowSlideNext,
      allowSlidePrev: o.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: o.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: o.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), o.emit("_swiper"), o.params.init && o.init(), o;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: i,
      params: n
    } = this, s = Ni(i, `.${n.slideClass}, swiper-slide`), r = Dl(s[0]);
    return Dl(e) - r;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.find((i) => i.getAttribute("data-swiper-slide-index") * 1 === e));
  }
  recalcSlides() {
    const e = this, {
      slidesEl: i,
      params: n
    } = e;
    e.slides = Ni(i, `.${n.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, i) {
    const n = this;
    e = Math.min(Math.max(e, 0), 1);
    const s = n.minTranslate(), a = (n.maxTranslate() - s) * e + s;
    n.translateTo(a, typeof i > "u" ? 0 : i), n.updateActiveIndex(), n.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const i = e.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", i.join(" "));
  }
  getSlideClasses(e) {
    const i = this;
    return i.destroyed ? "" : e.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(i.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const i = [];
    e.slides.forEach((n) => {
      const s = e.getSlideClasses(n);
      i.push({
        slideEl: n,
        classNames: s
      }), e.emit("_slideClass", n, s);
    }), e.emit("_slideClasses", i);
  }
  slidesPerViewDynamic(e, i) {
    e === void 0 && (e = "current"), i === void 0 && (i = !1);
    const n = this, {
      params: s,
      slides: r,
      slidesGrid: a,
      slidesSizesGrid: o,
      size: l,
      activeIndex: u
    } = n;
    let d = 1;
    if (typeof s.slidesPerView == "number") return s.slidesPerView;
    if (s.centeredSlides) {
      let c = r[u] ? Math.ceil(r[u].swiperSlideSize) : 0, A;
      for (let m = u + 1; m < r.length; m += 1)
        r[m] && !A && (c += Math.ceil(r[m].swiperSlideSize), d += 1, c > l && (A = !0));
      for (let m = u - 1; m >= 0; m -= 1)
        r[m] && !A && (c += r[m].swiperSlideSize, d += 1, c > l && (A = !0));
    } else if (e === "current")
      for (let c = u + 1; c < r.length; c += 1)
        (i ? a[c] + o[c] - a[u] < l : a[c] - a[u] < l) && (d += 1);
    else
      for (let c = u - 1; c >= 0; c -= 1)
        a[u] - a[c] < l && (d += 1);
    return d;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: i,
      params: n
    } = e;
    n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((a) => {
      a.complete && Uu(e, a);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function s() {
      const a = e.rtlTranslate ? e.translate * -1 : e.translate, o = Math.min(Math.max(a, e.maxTranslate()), e.minTranslate());
      e.setTranslate(o), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let r;
    if (n.freeMode && n.freeMode.enabled && !n.cssMode)
      s(), n.autoHeight && e.updateAutoHeight();
    else {
      if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
        const a = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
        r = e.slideTo(a.length - 1, 0, !1, !0);
      } else
        r = e.slideTo(e.activeIndex, 0, !1, !0);
      r || s();
    }
    n.watchOverflow && i !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, i) {
    i === void 0 && (i = !0);
    const n = this, s = n.params.direction;
    return e || (e = s === "horizontal" ? "vertical" : "horizontal"), e === s || e !== "horizontal" && e !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${s}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((r) => {
      e === "vertical" ? r.style.width = "" : r.style.height = "";
    }), n.emit("changeDirection"), i && n.update()), n;
  }
  changeLanguageDirection(e) {
    const i = this;
    i.rtl && e === "rtl" || !i.rtl && e === "ltr" || (i.rtl = e === "rtl", i.rtlTranslate = i.params.direction === "horizontal" && i.rtl, i.rtl ? (i.el.classList.add(`${i.params.containerModifierClass}rtl`), i.el.dir = "rtl") : (i.el.classList.remove(`${i.params.containerModifierClass}rtl`), i.el.dir = "ltr"), i.update());
  }
  mount(e) {
    const i = this;
    if (i.mounted) return !0;
    let n = e || i.params.el;
    if (typeof n == "string" && (n = document.querySelector(n)), !n)
      return !1;
    n.swiper = i, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === i.params.swiperElementNodeName.toUpperCase() && (i.isElement = !0);
    const s = () => `.${(i.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let a = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(s()) : Ni(n, s())[0];
    return !a && i.params.createElements && (a = bn("div", i.params.wrapperClass), n.append(a), Ni(n, `.${i.params.slideClass}`).forEach((o) => {
      a.append(o);
    })), Object.assign(i, {
      el: n,
      wrapperEl: a,
      slidesEl: i.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : a,
      hostEl: i.isElement ? n.parentNode.host : n,
      mounted: !0,
      // RTL
      rtl: n.dir.toLowerCase() === "rtl" || fr(n, "direction") === "rtl",
      rtlTranslate: i.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || fr(n, "direction") === "rtl"),
      wrongRTL: fr(a, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const i = this;
    if (i.initialized || i.mount(e) === !1) return i;
    i.emit("beforeInit"), i.params.breakpoints && i.setBreakpoint(), i.addClasses(), i.updateSize(), i.updateSlides(), i.params.watchOverflow && i.checkOverflow(), i.params.grabCursor && i.enabled && i.setGrabCursor(), i.params.loop && i.virtual && i.params.virtual.enabled ? i.slideTo(i.params.initialSlide + i.virtual.slidesBefore, 0, i.params.runCallbacksOnInit, !1, !0) : i.slideTo(i.params.initialSlide, 0, i.params.runCallbacksOnInit, !1, !0), i.params.loop && i.loopCreate(void 0, !0), i.attachEvents();
    const s = [...i.el.querySelectorAll('[loading="lazy"]')];
    return i.isElement && s.push(...i.hostEl.querySelectorAll('[loading="lazy"]')), s.forEach((r) => {
      r.complete ? Uu(i, r) : r.addEventListener("load", (a) => {
        Uu(i, a.target);
      });
    }), vh(i), i.initialized = !0, vh(i), i.emit("init"), i.emit("afterInit"), i;
  }
  destroy(e, i) {
    e === void 0 && (e = !0), i === void 0 && (i = !0);
    const n = this, {
      params: s,
      el: r,
      wrapperEl: a,
      slides: o
    } = n;
    return typeof n.params > "u" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), s.loop && n.loopDestroy(), i && (n.removeClasses(), r && typeof r != "string" && r.removeAttribute("style"), a && a.removeAttribute("style"), o && o.length && o.forEach((l) => {
      l.classList.remove(s.slideVisibleClass, s.slideFullyVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass), l.removeAttribute("style"), l.removeAttribute("data-swiper-slide-index");
    })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((l) => {
      n.off(l);
    }), e !== !1 && (n.el && typeof n.el != "string" && (n.el.swiper = null), j8(n)), n.destroyed = !0), null;
  }
  static extendDefaults(e) {
    gn(vf, e);
  }
  static get extendedDefaults() {
    return vf;
  }
  static get defaults() {
    return yh;
  }
  static installModule(e) {
    An.prototype.__modules__ || (An.prototype.__modules__ = []);
    const i = An.prototype.__modules__;
    typeof e == "function" && i.indexOf(e) < 0 && i.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((i) => An.installModule(i)), An) : (An.installModule(e), An);
  }
}
Object.keys(gf).forEach((t) => {
  Object.keys(gf[t]).forEach((e) => {
    An.prototype[e] = gf[t][e];
  });
});
An.use([nN, sN]);
function u5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: s
  } = t;
  i({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let r;
  const a = Pi();
  e.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const o = a.createElement("div");
  function l(p, h) {
    const g = e.params.virtual;
    if (g.cache && e.virtual.cache[h])
      return e.virtual.cache[h];
    let w;
    return g.renderSlide ? (w = g.renderSlide.call(e, p, h), typeof w == "string" && (o.innerHTML = w, w = o.children[0])) : e.isElement ? w = bn("swiper-slide") : w = bn("div", e.params.slideClass), w.setAttribute("data-swiper-slide-index", h), g.renderSlide || (w.innerHTML = p), g.cache && (e.virtual.cache[h] = w), w;
  }
  function u(p, h, g) {
    const {
      slidesPerView: w,
      slidesPerGroup: b,
      centeredSlides: y,
      loop: D,
      initialSlide: I
    } = e.params;
    if (h && !D && I > 0)
      return;
    const {
      addSlidesBefore: M,
      addSlidesAfter: _
    } = e.params.virtual, {
      from: N,
      to: x,
      slides: C,
      slidesGrid: L,
      offset: V
    } = e.virtual;
    e.params.cssMode || e.updateActiveIndex();
    const H = typeof g > "u" ? e.activeIndex || 0 : g;
    let O;
    e.rtlTranslate ? O = "right" : O = e.isHorizontal() ? "left" : "top";
    let X, q;
    y ? (X = Math.floor(w / 2) + b + _, q = Math.floor(w / 2) + b + M) : (X = w + (b - 1) + _, q = (D ? w : b) + M);
    let F = H - q, W = H + X;
    D || (F = Math.max(F, 0), W = Math.min(W, C.length - 1));
    let j = (e.slidesGrid[F] || 0) - (e.slidesGrid[0] || 0);
    D && H >= q ? (F -= q, y || (j += e.slidesGrid[0])) : D && H < q && (F = -q, y && (j += e.slidesGrid[0])), Object.assign(e.virtual, {
      from: F,
      to: W,
      offset: j,
      slidesGrid: e.slidesGrid,
      slidesBefore: q,
      slidesAfter: X
    });
    function oe() {
      e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), s("virtualUpdate");
    }
    if (N === F && x === W && !p) {
      e.slidesGrid !== L && j !== V && e.slides.forEach((le) => {
        le.style[O] = `${j - Math.abs(e.cssOverflowAdjustment())}px`;
      }), e.updateProgress(), s("virtualUpdate");
      return;
    }
    if (e.params.virtual.renderExternal) {
      e.params.virtual.renderExternal.call(e, {
        offset: j,
        from: F,
        to: W,
        slides: function() {
          const B = [];
          for (let ue = F; ue <= W; ue += 1)
            B.push(C[ue]);
          return B;
        }()
      }), e.params.virtual.renderExternalUpdate ? oe() : s("virtualUpdate");
      return;
    }
    const $ = [], ye = [], ae = (le) => {
      let B = le;
      return le < 0 ? B = C.length + le : B >= C.length && (B = B - C.length), B;
    };
    if (p)
      e.slides.filter((le) => le.matches(`.${e.params.slideClass}, swiper-slide`)).forEach((le) => {
        le.remove();
      });
    else
      for (let le = N; le <= x; le += 1)
        if (le < F || le > W) {
          const B = ae(le);
          e.slides.filter((ue) => ue.matches(`.${e.params.slideClass}[data-swiper-slide-index="${B}"], swiper-slide[data-swiper-slide-index="${B}"]`)).forEach((ue) => {
            ue.remove();
          });
        }
    const ce = D ? -C.length : 0, te = D ? C.length * 2 : C.length;
    for (let le = ce; le < te; le += 1)
      if (le >= F && le <= W) {
        const B = ae(le);
        typeof x > "u" || p ? ye.push(B) : (le > x && ye.push(B), le < N && $.push(B));
      }
    if (ye.forEach((le) => {
      e.slidesEl.append(l(C[le], le));
    }), D)
      for (let le = $.length - 1; le >= 0; le -= 1) {
        const B = $[le];
        e.slidesEl.prepend(l(C[B], B));
      }
    else
      $.sort((le, B) => B - le), $.forEach((le) => {
        e.slidesEl.prepend(l(C[le], le));
      });
    Ni(e.slidesEl, ".swiper-slide, swiper-slide").forEach((le) => {
      le.style[O] = `${j - Math.abs(e.cssOverflowAdjustment())}px`;
    }), oe();
  }
  function d(p) {
    if (typeof p == "object" && "length" in p)
      for (let h = 0; h < p.length; h += 1)
        p[h] && e.virtual.slides.push(p[h]);
    else
      e.virtual.slides.push(p);
    u(!0);
  }
  function c(p) {
    const h = e.activeIndex;
    let g = h + 1, w = 1;
    if (Array.isArray(p)) {
      for (let b = 0; b < p.length; b += 1)
        p[b] && e.virtual.slides.unshift(p[b]);
      g = h + p.length, w = p.length;
    } else
      e.virtual.slides.unshift(p);
    if (e.params.virtual.cache) {
      const b = e.virtual.cache, y = {};
      Object.keys(b).forEach((D) => {
        const I = b[D], M = I.getAttribute("data-swiper-slide-index");
        M && I.setAttribute("data-swiper-slide-index", parseInt(M, 10) + w), y[parseInt(D, 10) + w] = I;
      }), e.virtual.cache = y;
    }
    u(!0), e.slideTo(g, 0);
  }
  function A(p) {
    if (typeof p > "u" || p === null) return;
    let h = e.activeIndex;
    if (Array.isArray(p))
      for (let g = p.length - 1; g >= 0; g -= 1)
        e.params.virtual.cache && (delete e.virtual.cache[p[g]], Object.keys(e.virtual.cache).forEach((w) => {
          w > p && (e.virtual.cache[w - 1] = e.virtual.cache[w], e.virtual.cache[w - 1].setAttribute("data-swiper-slide-index", w - 1), delete e.virtual.cache[w]);
        })), e.virtual.slides.splice(p[g], 1), p[g] < h && (h -= 1), h = Math.max(h, 0);
    else
      e.params.virtual.cache && (delete e.virtual.cache[p], Object.keys(e.virtual.cache).forEach((g) => {
        g > p && (e.virtual.cache[g - 1] = e.virtual.cache[g], e.virtual.cache[g - 1].setAttribute("data-swiper-slide-index", g - 1), delete e.virtual.cache[g]);
      })), e.virtual.slides.splice(p, 1), p < h && (h -= 1), h = Math.max(h, 0);
    u(!0), e.slideTo(h, 0);
  }
  function m() {
    e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), u(!0), e.slideTo(0, 0);
  }
  n("beforeInit", () => {
    if (!e.params.virtual.enabled) return;
    let p;
    if (typeof e.passedParams.virtual.slides > "u") {
      const h = [...e.slidesEl.children].filter((g) => g.matches(`.${e.params.slideClass}, swiper-slide`));
      h && h.length && (e.virtual.slides = [...h], p = !0, h.forEach((g, w) => {
        g.setAttribute("data-swiper-slide-index", w), e.virtual.cache[w] = g, g.remove();
      }));
    }
    p || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, u(!1, !0);
  }), n("setTranslate", () => {
    e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(r), r = setTimeout(() => {
      u();
    }, 100)) : u());
  }), n("init update resize", () => {
    e.params.virtual.enabled && e.params.cssMode && il(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
  }), Object.assign(e.virtual, {
    appendSlide: d,
    prependSlide: c,
    removeSlide: A,
    removeAllSlides: m,
    update: u
  });
}
function d5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: s
  } = t;
  const r = Pi(), a = Jt();
  e.keyboard = {
    enabled: !1
  }, i({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function o(d) {
    if (!e.enabled) return;
    const {
      rtlTranslate: c
    } = e;
    let A = d;
    A.originalEvent && (A = A.originalEvent);
    const m = A.keyCode || A.charCode, p = e.params.keyboard.pageUpDown, h = p && m === 33, g = p && m === 34, w = m === 37, b = m === 39, y = m === 38, D = m === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && b || e.isVertical() && D || g) || !e.allowSlidePrev && (e.isHorizontal() && w || e.isVertical() && y || h))
      return !1;
    if (!(A.shiftKey || A.altKey || A.ctrlKey || A.metaKey) && !(r.activeElement && r.activeElement.nodeName && (r.activeElement.nodeName.toLowerCase() === "input" || r.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (e.params.keyboard.onlyInViewport && (h || g || w || b || y || D)) {
        let I = !1;
        if (Xr(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && Xr(e.el, `.${e.params.slideActiveClass}`).length === 0)
          return;
        const M = e.el, _ = M.clientWidth, N = M.clientHeight, x = a.innerWidth, C = a.innerHeight, L = ud(M);
        c && (L.left -= M.scrollLeft);
        const V = [[L.left, L.top], [L.left + _, L.top], [L.left, L.top + N], [L.left + _, L.top + N]];
        for (let H = 0; H < V.length; H += 1) {
          const O = V[H];
          if (O[0] >= 0 && O[0] <= x && O[1] >= 0 && O[1] <= C) {
            if (O[0] === 0 && O[1] === 0) continue;
            I = !0;
          }
        }
        if (!I) return;
      }
      e.isHorizontal() ? ((h || g || w || b) && (A.preventDefault ? A.preventDefault() : A.returnValue = !1), ((g || b) && !c || (h || w) && c) && e.slideNext(), ((h || w) && !c || (g || b) && c) && e.slidePrev()) : ((h || g || y || D) && (A.preventDefault ? A.preventDefault() : A.returnValue = !1), (g || D) && e.slideNext(), (h || y) && e.slidePrev()), s("keyPress", m);
    }
  }
  function l() {
    e.keyboard.enabled || (r.addEventListener("keydown", o), e.keyboard.enabled = !0);
  }
  function u() {
    e.keyboard.enabled && (r.removeEventListener("keydown", o), e.keyboard.enabled = !1);
  }
  n("init", () => {
    e.params.keyboard.enabled && l();
  }), n("destroy", () => {
    e.keyboard.enabled && u();
  }), Object.assign(e.keyboard, {
    enable: l,
    disable: u
  });
}
function c5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: s
  } = t;
  const r = Jt();
  i({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  }), e.mousewheel = {
    enabled: !1
  };
  let a, o = Mn(), l;
  const u = [];
  function d(y) {
    let _ = 0, N = 0, x = 0, C = 0;
    return "detail" in y && (N = y.detail), "wheelDelta" in y && (N = -y.wheelDelta / 120), "wheelDeltaY" in y && (N = -y.wheelDeltaY / 120), "wheelDeltaX" in y && (_ = -y.wheelDeltaX / 120), "axis" in y && y.axis === y.HORIZONTAL_AXIS && (_ = N, N = 0), x = _ * 10, C = N * 10, "deltaY" in y && (C = y.deltaY), "deltaX" in y && (x = y.deltaX), y.shiftKey && !x && (x = C, C = 0), (x || C) && y.deltaMode && (y.deltaMode === 1 ? (x *= 40, C *= 40) : (x *= 800, C *= 800)), x && !_ && (_ = x < 1 ? -1 : 1), C && !N && (N = C < 1 ? -1 : 1), {
      spinX: _,
      spinY: N,
      pixelX: x,
      pixelY: C
    };
  }
  function c() {
    e.enabled && (e.mouseEntered = !0);
  }
  function A() {
    e.enabled && (e.mouseEntered = !1);
  }
  function m(y) {
    return e.params.mousewheel.thresholdDelta && y.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && Mn() - o < e.params.mousewheel.thresholdTime ? !1 : y.delta >= 6 && Mn() - o < 60 ? !0 : (y.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), s("scroll", y.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), s("scroll", y.raw)), o = new r.Date().getTime(), !1);
  }
  function p(y) {
    const D = e.params.mousewheel;
    if (y.direction < 0) {
      if (e.isEnd && !e.params.loop && D.releaseOnEdges)
        return !0;
    } else if (e.isBeginning && !e.params.loop && D.releaseOnEdges)
      return !0;
    return !1;
  }
  function h(y) {
    let D = y, I = !0;
    if (!e.enabled || y.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
    const M = e.params.mousewheel;
    e.params.cssMode && D.preventDefault();
    let _ = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (_ = document.querySelector(e.params.mousewheel.eventsTarget));
    const N = _ && _.contains(D.target);
    if (!e.mouseEntered && !N && !M.releaseOnEdges) return !0;
    D.originalEvent && (D = D.originalEvent);
    let x = 0;
    const C = e.rtlTranslate ? -1 : 1, L = d(D);
    if (M.forceToAxis)
      if (e.isHorizontal())
        if (Math.abs(L.pixelX) > Math.abs(L.pixelY)) x = -L.pixelX * C;
        else return !0;
      else if (Math.abs(L.pixelY) > Math.abs(L.pixelX)) x = -L.pixelY;
      else return !0;
    else
      x = Math.abs(L.pixelX) > Math.abs(L.pixelY) ? -L.pixelX * C : -L.pixelY;
    if (x === 0) return !0;
    M.invert && (x = -x);
    let V = e.getTranslate() + x * M.sensitivity;
    if (V >= e.minTranslate() && (V = e.minTranslate()), V <= e.maxTranslate() && (V = e.maxTranslate()), I = e.params.loop ? !0 : !(V === e.minTranslate() || V === e.maxTranslate()), I && e.params.nested && D.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
      const H = {
        time: Mn(),
        delta: Math.abs(x),
        direction: Math.sign(x),
        raw: y
      };
      u.length >= 2 && u.shift();
      const O = u.length ? u[u.length - 1] : void 0;
      if (u.push(H), O ? (H.direction !== O.direction || H.delta > O.delta || H.time > O.time + 150) && m(H) : m(H), p(H))
        return !0;
    } else {
      const H = {
        time: Mn(),
        delta: Math.abs(x),
        direction: Math.sign(x)
      }, O = l && H.time < l.time + 500 && H.delta <= l.delta && H.direction === l.direction;
      if (!O) {
        l = void 0;
        let X = e.getTranslate() + x * M.sensitivity;
        const q = e.isBeginning, F = e.isEnd;
        if (X >= e.minTranslate() && (X = e.minTranslate()), X <= e.maxTranslate() && (X = e.maxTranslate()), e.setTransition(0), e.setTranslate(X), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!q && e.isBeginning || !F && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
          direction: H.direction < 0 ? "next" : "prev",
          byMousewheel: !0
        }), e.params.freeMode.sticky) {
          clearTimeout(a), a = void 0, u.length >= 15 && u.shift();
          const W = u.length ? u[u.length - 1] : void 0, j = u[0];
          if (u.push(H), W && (H.delta > W.delta || H.direction !== W.direction))
            u.splice(0);
          else if (u.length >= 15 && H.time - j.time < 500 && j.delta - H.delta >= 1 && H.delta <= 6) {
            const oe = x > 0 ? 0.8 : 0.2;
            l = H, u.splice(0), a = ta(() => {
              e.destroyed || !e.params || e.slideToClosest(e.params.speed, !0, void 0, oe);
            }, 0);
          }
          a || (a = ta(() => {
            if (e.destroyed || !e.params) return;
            const oe = 0.5;
            l = H, u.splice(0), e.slideToClosest(e.params.speed, !0, void 0, oe);
          }, 500));
        }
        if (O || s("scroll", D), e.params.autoplay && e.params.autoplay.disableOnInteraction && e.autoplay.stop(), M.releaseOnEdges && (X === e.minTranslate() || X === e.maxTranslate()))
          return !0;
      }
    }
    return D.preventDefault ? D.preventDefault() : D.returnValue = !1, !1;
  }
  function g(y) {
    let D = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (D = document.querySelector(e.params.mousewheel.eventsTarget)), D[y]("mouseenter", c), D[y]("mouseleave", A), D[y]("wheel", h);
  }
  function w() {
    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", h), !0) : e.mousewheel.enabled ? !1 : (g("addEventListener"), e.mousewheel.enabled = !0, !0);
  }
  function b() {
    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, h), !0) : e.mousewheel.enabled ? (g("removeEventListener"), e.mousewheel.enabled = !1, !0) : !1;
  }
  n("init", () => {
    !e.params.mousewheel.enabled && e.params.cssMode && b(), e.params.mousewheel.enabled && w();
  }), n("destroy", () => {
    e.params.cssMode && w(), e.mousewheel.enabled && b();
  }), Object.assign(e.mousewheel, {
    enable: w,
    disable: b
  });
}
function Lp(t, e, i, n) {
  return t.params.createElements && Object.keys(n).forEach((s) => {
    if (!i[s] && i.auto === !0) {
      let r = Ni(t.el, `.${n[s]}`)[0];
      r || (r = bn("div", n[s]), r.className = n[s], t.el.append(r)), i[s] = r, e[s] = r;
    }
  }), i;
}
function f5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: s
  } = t;
  i({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function r(p) {
    let h;
    return p && typeof p == "string" && e.isElement && (h = e.el.querySelector(p) || e.hostEl.querySelector(p), h) ? h : (p && (typeof p == "string" && (h = [...document.querySelectorAll(p)]), e.params.uniqueNavElements && typeof p == "string" && h && h.length > 1 && e.el.querySelectorAll(p).length === 1 ? h = e.el.querySelector(p) : h && h.length === 1 && (h = h[0])), p && !h ? p : h);
  }
  function a(p, h) {
    const g = e.params.navigation;
    p = At(p), p.forEach((w) => {
      w && (w.classList[h ? "add" : "remove"](...g.disabledClass.split(" ")), w.tagName === "BUTTON" && (w.disabled = h), e.params.watchOverflow && e.enabled && w.classList[e.isLocked ? "add" : "remove"](g.lockClass));
    });
  }
  function o() {
    const {
      nextEl: p,
      prevEl: h
    } = e.navigation;
    if (e.params.loop) {
      a(h, !1), a(p, !1);
      return;
    }
    a(h, e.isBeginning && !e.params.rewind), a(p, e.isEnd && !e.params.rewind);
  }
  function l(p) {
    p.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), s("navigationPrev"));
  }
  function u(p) {
    p.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), s("navigationNext"));
  }
  function d() {
    const p = e.params.navigation;
    if (e.params.navigation = Lp(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(p.nextEl || p.prevEl)) return;
    let h = r(p.nextEl), g = r(p.prevEl);
    Object.assign(e.navigation, {
      nextEl: h,
      prevEl: g
    }), h = At(h), g = At(g);
    const w = (b, y) => {
      b && b.addEventListener("click", y === "next" ? u : l), !e.enabled && b && b.classList.add(...p.lockClass.split(" "));
    };
    h.forEach((b) => w(b, "next")), g.forEach((b) => w(b, "prev"));
  }
  function c() {
    let {
      nextEl: p,
      prevEl: h
    } = e.navigation;
    p = At(p), h = At(h);
    const g = (w, b) => {
      w.removeEventListener("click", b === "next" ? u : l), w.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    p.forEach((w) => g(w, "next")), h.forEach((w) => g(w, "prev"));
  }
  n("init", () => {
    e.params.navigation.enabled === !1 ? m() : (d(), o());
  }), n("toEdge fromEdge lock unlock", () => {
    o();
  }), n("destroy", () => {
    c();
  }), n("enable disable", () => {
    let {
      nextEl: p,
      prevEl: h
    } = e.navigation;
    if (p = At(p), h = At(h), e.enabled) {
      o();
      return;
    }
    [...p, ...h].filter((g) => !!g).forEach((g) => g.classList.add(e.params.navigation.lockClass));
  }), n("click", (p, h) => {
    let {
      nextEl: g,
      prevEl: w
    } = e.navigation;
    g = At(g), w = At(w);
    const b = h.target;
    let y = w.includes(b) || g.includes(b);
    if (e.isElement && !y) {
      const D = h.path || h.composedPath && h.composedPath();
      D && (y = D.find((I) => g.includes(I) || w.includes(I)));
    }
    if (e.params.navigation.hideOnClick && !y) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === b || e.pagination.el.contains(b))) return;
      let D;
      g.length ? D = g[0].classList.contains(e.params.navigation.hiddenClass) : w.length && (D = w[0].classList.contains(e.params.navigation.hiddenClass)), s(D === !0 ? "navigationShow" : "navigationHide"), [...g, ...w].filter((I) => !!I).forEach((I) => I.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const A = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), d(), o();
  }, m = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), c();
  };
  Object.assign(e.navigation, {
    enable: A,
    disable: m,
    update: o,
    init: d,
    destroy: c
  });
}
function Ls(t) {
  return t === void 0 && (t = ""), `.${t.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function h5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: s
  } = t;
  const r = "swiper-pagination";
  i({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (b) => b,
      formatFractionTotal: (b) => b,
      bulletClass: `${r}-bullet`,
      bulletActiveClass: `${r}-bullet-active`,
      modifierClass: `${r}-`,
      currentClass: `${r}-current`,
      totalClass: `${r}-total`,
      hiddenClass: `${r}-hidden`,
      progressbarFillClass: `${r}-progressbar-fill`,
      progressbarOppositeClass: `${r}-progressbar-opposite`,
      clickableClass: `${r}-clickable`,
      lockClass: `${r}-lock`,
      horizontalClass: `${r}-horizontal`,
      verticalClass: `${r}-vertical`,
      paginationDisabledClass: `${r}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let a, o = 0;
  function l() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function u(b, y) {
    const {
      bulletActiveClass: D
    } = e.params.pagination;
    b && (b = b[`${y === "prev" ? "previous" : "next"}ElementSibling`], b && (b.classList.add(`${D}-${y}`), b = b[`${y === "prev" ? "previous" : "next"}ElementSibling`], b && b.classList.add(`${D}-${y}-${y}`)));
  }
  function d(b, y, D) {
    if (b = b % D, y = y % D, y === b + 1)
      return "next";
    if (y === b - 1)
      return "previous";
  }
  function c(b) {
    const y = b.target.closest(Ls(e.params.pagination.bulletClass));
    if (!y)
      return;
    b.preventDefault();
    const D = Dl(y) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === D) return;
      const I = d(e.realIndex, D, e.slides.length);
      I === "next" ? e.slideNext() : I === "previous" ? e.slidePrev() : e.slideToLoop(D);
    } else
      e.slideTo(D);
  }
  function A() {
    const b = e.rtl, y = e.params.pagination;
    if (l()) return;
    let D = e.pagination.el;
    D = At(D);
    let I, M;
    const _ = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, N = e.params.loop ? Math.ceil(_ / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (M = e.previousRealIndex || 0, I = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (I = e.snapIndex, M = e.previousSnapIndex) : (M = e.previousIndex || 0, I = e.activeIndex || 0), y.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const x = e.pagination.bullets;
      let C, L, V;
      if (y.dynamicBullets && (a = gh(x[0], e.isHorizontal() ? "width" : "height"), D.forEach((H) => {
        H.style[e.isHorizontal() ? "width" : "height"] = `${a * (y.dynamicMainBullets + 4)}px`;
      }), y.dynamicMainBullets > 1 && M !== void 0 && (o += I - (M || 0), o > y.dynamicMainBullets - 1 ? o = y.dynamicMainBullets - 1 : o < 0 && (o = 0)), C = Math.max(I - o, 0), L = C + (Math.min(x.length, y.dynamicMainBullets) - 1), V = (L + C) / 2), x.forEach((H) => {
        const O = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((X) => `${y.bulletActiveClass}${X}`)].map((X) => typeof X == "string" && X.includes(" ") ? X.split(" ") : X).flat();
        H.classList.remove(...O);
      }), D.length > 1)
        x.forEach((H) => {
          const O = Dl(H);
          O === I ? H.classList.add(...y.bulletActiveClass.split(" ")) : e.isElement && H.setAttribute("part", "bullet"), y.dynamicBullets && (O >= C && O <= L && H.classList.add(...`${y.bulletActiveClass}-main`.split(" ")), O === C && u(H, "prev"), O === L && u(H, "next"));
        });
      else {
        const H = x[I];
        if (H && H.classList.add(...y.bulletActiveClass.split(" ")), e.isElement && x.forEach((O, X) => {
          O.setAttribute("part", X === I ? "bullet-active" : "bullet");
        }), y.dynamicBullets) {
          const O = x[C], X = x[L];
          for (let q = C; q <= L; q += 1)
            x[q] && x[q].classList.add(...`${y.bulletActiveClass}-main`.split(" "));
          u(O, "prev"), u(X, "next");
        }
      }
      if (y.dynamicBullets) {
        const H = Math.min(x.length, y.dynamicMainBullets + 4), O = (a * H - a) / 2 - V * a, X = b ? "right" : "left";
        x.forEach((q) => {
          q.style[e.isHorizontal() ? X : "top"] = `${O}px`;
        });
      }
    }
    D.forEach((x, C) => {
      if (y.type === "fraction" && (x.querySelectorAll(Ls(y.currentClass)).forEach((L) => {
        L.textContent = y.formatFractionCurrent(I + 1);
      }), x.querySelectorAll(Ls(y.totalClass)).forEach((L) => {
        L.textContent = y.formatFractionTotal(N);
      })), y.type === "progressbar") {
        let L;
        y.progressbarOpposite ? L = e.isHorizontal() ? "vertical" : "horizontal" : L = e.isHorizontal() ? "horizontal" : "vertical";
        const V = (I + 1) / N;
        let H = 1, O = 1;
        L === "horizontal" ? H = V : O = V, x.querySelectorAll(Ls(y.progressbarFillClass)).forEach((X) => {
          X.style.transform = `translate3d(0,0,0) scaleX(${H}) scaleY(${O})`, X.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      y.type === "custom" && y.renderCustom ? (x.innerHTML = y.renderCustom(e, I + 1, N), C === 0 && s("paginationRender", x)) : (C === 0 && s("paginationRender", x), s("paginationUpdate", x)), e.params.watchOverflow && e.enabled && x.classList[e.isLocked ? "add" : "remove"](y.lockClass);
    });
  }
  function m() {
    const b = e.params.pagination;
    if (l()) return;
    const y = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let D = e.pagination.el;
    D = At(D);
    let I = "";
    if (b.type === "bullets") {
      let M = e.params.loop ? Math.ceil(y / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && M > y && (M = y);
      for (let _ = 0; _ < M; _ += 1)
        b.renderBullet ? I += b.renderBullet.call(e, _, b.bulletClass) : I += `<${b.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${b.bulletClass}"></${b.bulletElement}>`;
    }
    b.type === "fraction" && (b.renderFraction ? I = b.renderFraction.call(e, b.currentClass, b.totalClass) : I = `<span class="${b.currentClass}"></span> / <span class="${b.totalClass}"></span>`), b.type === "progressbar" && (b.renderProgressbar ? I = b.renderProgressbar.call(e, b.progressbarFillClass) : I = `<span class="${b.progressbarFillClass}"></span>`), e.pagination.bullets = [], D.forEach((M) => {
      b.type !== "custom" && (M.innerHTML = I || ""), b.type === "bullets" && e.pagination.bullets.push(...M.querySelectorAll(Ls(b.bulletClass)));
    }), b.type !== "custom" && s("paginationRender", D[0]);
  }
  function p() {
    e.params.pagination = Lp(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const b = e.params.pagination;
    if (!b.el) return;
    let y;
    typeof b.el == "string" && e.isElement && (y = e.el.querySelector(b.el)), !y && typeof b.el == "string" && (y = [...document.querySelectorAll(b.el)]), y || (y = b.el), !(!y || y.length === 0) && (e.params.uniqueNavElements && typeof b.el == "string" && Array.isArray(y) && y.length > 1 && (y = [...e.el.querySelectorAll(b.el)], y.length > 1 && (y = y.find((D) => Xr(D, ".swiper")[0] === e.el))), Array.isArray(y) && y.length === 1 && (y = y[0]), Object.assign(e.pagination, {
      el: y
    }), y = At(y), y.forEach((D) => {
      b.type === "bullets" && b.clickable && D.classList.add(...(b.clickableClass || "").split(" ")), D.classList.add(b.modifierClass + b.type), D.classList.add(e.isHorizontal() ? b.horizontalClass : b.verticalClass), b.type === "bullets" && b.dynamicBullets && (D.classList.add(`${b.modifierClass}${b.type}-dynamic`), o = 0, b.dynamicMainBullets < 1 && (b.dynamicMainBullets = 1)), b.type === "progressbar" && b.progressbarOpposite && D.classList.add(b.progressbarOppositeClass), b.clickable && D.addEventListener("click", c), e.enabled || D.classList.add(b.lockClass);
    }));
  }
  function h() {
    const b = e.params.pagination;
    if (l()) return;
    let y = e.pagination.el;
    y && (y = At(y), y.forEach((D) => {
      D.classList.remove(b.hiddenClass), D.classList.remove(b.modifierClass + b.type), D.classList.remove(e.isHorizontal() ? b.horizontalClass : b.verticalClass), b.clickable && (D.classList.remove(...(b.clickableClass || "").split(" ")), D.removeEventListener("click", c));
    })), e.pagination.bullets && e.pagination.bullets.forEach((D) => D.classList.remove(...b.bulletActiveClass.split(" ")));
  }
  n("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const b = e.params.pagination;
    let {
      el: y
    } = e.pagination;
    y = At(y), y.forEach((D) => {
      D.classList.remove(b.horizontalClass, b.verticalClass), D.classList.add(e.isHorizontal() ? b.horizontalClass : b.verticalClass);
    });
  }), n("init", () => {
    e.params.pagination.enabled === !1 ? w() : (p(), m(), A());
  }), n("activeIndexChange", () => {
    typeof e.snapIndex > "u" && A();
  }), n("snapIndexChange", () => {
    A();
  }), n("snapGridLengthChange", () => {
    m(), A();
  }), n("destroy", () => {
    h();
  }), n("enable disable", () => {
    let {
      el: b
    } = e.pagination;
    b && (b = At(b), b.forEach((y) => y.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), n("lock unlock", () => {
    A();
  }), n("click", (b, y) => {
    const D = y.target, I = At(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && I && I.length > 0 && !D.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && D === e.navigation.nextEl || e.navigation.prevEl && D === e.navigation.prevEl)) return;
      const M = I[0].classList.contains(e.params.pagination.hiddenClass);
      s(M === !0 ? "paginationShow" : "paginationHide"), I.forEach((_) => _.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const g = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: b
    } = e.pagination;
    b && (b = At(b), b.forEach((y) => y.classList.remove(e.params.pagination.paginationDisabledClass))), p(), m(), A();
  }, w = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: b
    } = e.pagination;
    b && (b = At(b), b.forEach((y) => y.classList.add(e.params.pagination.paginationDisabledClass))), h();
  };
  Object.assign(e.pagination, {
    enable: g,
    disable: w,
    render: m,
    update: A,
    init: p,
    destroy: h
  });
}
function p5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: s
  } = t;
  const r = Pi();
  let a = !1, o = null, l = null, u, d, c, A;
  i({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), e.scrollbar = {
    el: null,
    dragEl: null
  };
  function m() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: V,
      rtlTranslate: H
    } = e, {
      dragEl: O,
      el: X
    } = V, q = e.params.scrollbar, F = e.params.loop ? e.progressLoop : e.progress;
    let W = d, j = (c - d) * F;
    H ? (j = -j, j > 0 ? (W = d - j, j = 0) : -j + d > c && (W = c + j)) : j < 0 ? (W = d + j, j = 0) : j + d > c && (W = c - j), e.isHorizontal() ? (O.style.transform = `translate3d(${j}px, 0, 0)`, O.style.width = `${W}px`) : (O.style.transform = `translate3d(0px, ${j}px, 0)`, O.style.height = `${W}px`), q.hide && (clearTimeout(o), X.style.opacity = 1, o = setTimeout(() => {
      X.style.opacity = 0, X.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function p(V) {
    !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${V}ms`);
  }
  function h() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: V
    } = e, {
      dragEl: H,
      el: O
    } = V;
    H.style.width = "", H.style.height = "", c = e.isHorizontal() ? O.offsetWidth : O.offsetHeight, A = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? d = c * A : d = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? H.style.width = `${d}px` : H.style.height = `${d}px`, A >= 1 ? O.style.display = "none" : O.style.display = "", e.params.scrollbar.hide && (O.style.opacity = 0), e.params.watchOverflow && e.enabled && V.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
  }
  function g(V) {
    return e.isHorizontal() ? V.clientX : V.clientY;
  }
  function w(V) {
    const {
      scrollbar: H,
      rtlTranslate: O
    } = e, {
      el: X
    } = H;
    let q;
    q = (g(V) - ud(X)[e.isHorizontal() ? "left" : "top"] - (u !== null ? u : d / 2)) / (c - d), q = Math.max(Math.min(q, 1), 0), O && (q = 1 - q);
    const F = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * q;
    e.updateProgress(F), e.setTranslate(F), e.updateActiveIndex(), e.updateSlidesClasses();
  }
  function b(V) {
    const H = e.params.scrollbar, {
      scrollbar: O,
      wrapperEl: X
    } = e, {
      el: q,
      dragEl: F
    } = O;
    a = !0, u = V.target === F ? g(V) - V.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, V.preventDefault(), V.stopPropagation(), X.style.transitionDuration = "100ms", F.style.transitionDuration = "100ms", w(V), clearTimeout(l), q.style.transitionDuration = "0ms", H.hide && (q.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), s("scrollbarDragStart", V);
  }
  function y(V) {
    const {
      scrollbar: H,
      wrapperEl: O
    } = e, {
      el: X,
      dragEl: q
    } = H;
    a && (V.preventDefault && V.cancelable ? V.preventDefault() : V.returnValue = !1, w(V), O.style.transitionDuration = "0ms", X.style.transitionDuration = "0ms", q.style.transitionDuration = "0ms", s("scrollbarDragMove", V));
  }
  function D(V) {
    const H = e.params.scrollbar, {
      scrollbar: O,
      wrapperEl: X
    } = e, {
      el: q
    } = O;
    a && (a = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", X.style.transitionDuration = ""), H.hide && (clearTimeout(l), l = ta(() => {
      q.style.opacity = 0, q.style.transitionDuration = "400ms";
    }, 1e3)), s("scrollbarDragEnd", V), H.snapOnRelease && e.slideToClosest());
  }
  function I(V) {
    const {
      scrollbar: H,
      params: O
    } = e, X = H.el;
    if (!X) return;
    const q = X, F = O.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, W = O.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!q) return;
    const j = V === "on" ? "addEventListener" : "removeEventListener";
    q[j]("pointerdown", b, F), r[j]("pointermove", y, F), r[j]("pointerup", D, W);
  }
  function M() {
    !e.params.scrollbar.el || !e.scrollbar.el || I("on");
  }
  function _() {
    !e.params.scrollbar.el || !e.scrollbar.el || I("off");
  }
  function N() {
    const {
      scrollbar: V,
      el: H
    } = e;
    e.params.scrollbar = Lp(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const O = e.params.scrollbar;
    if (!O.el) return;
    let X;
    if (typeof O.el == "string" && e.isElement && (X = e.el.querySelector(O.el)), !X && typeof O.el == "string") {
      if (X = r.querySelectorAll(O.el), !X.length) return;
    } else X || (X = O.el);
    e.params.uniqueNavElements && typeof O.el == "string" && X.length > 1 && H.querySelectorAll(O.el).length === 1 && (X = H.querySelector(O.el)), X.length > 0 && (X = X[0]), X.classList.add(e.isHorizontal() ? O.horizontalClass : O.verticalClass);
    let q;
    X && (q = X.querySelector(Ls(e.params.scrollbar.dragClass)), q || (q = bn("div", e.params.scrollbar.dragClass), X.append(q))), Object.assign(V, {
      el: X,
      dragEl: q
    }), O.draggable && M(), X && X.classList[e.enabled ? "remove" : "add"](...rr(e.params.scrollbar.lockClass));
  }
  function x() {
    const V = e.params.scrollbar, H = e.scrollbar.el;
    H && H.classList.remove(...rr(e.isHorizontal() ? V.horizontalClass : V.verticalClass)), _();
  }
  n("changeDirection", () => {
    if (!e.scrollbar || !e.scrollbar.el) return;
    const V = e.params.scrollbar;
    let {
      el: H
    } = e.scrollbar;
    H = At(H), H.forEach((O) => {
      O.classList.remove(V.horizontalClass, V.verticalClass), O.classList.add(e.isHorizontal() ? V.horizontalClass : V.verticalClass);
    });
  }), n("init", () => {
    e.params.scrollbar.enabled === !1 ? L() : (N(), h(), m());
  }), n("update resize observerUpdate lock unlock changeDirection", () => {
    h();
  }), n("setTranslate", () => {
    m();
  }), n("setTransition", (V, H) => {
    p(H);
  }), n("enable disable", () => {
    const {
      el: V
    } = e.scrollbar;
    V && V.classList[e.enabled ? "remove" : "add"](...rr(e.params.scrollbar.lockClass));
  }), n("destroy", () => {
    x();
  });
  const C = () => {
    e.el.classList.remove(...rr(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...rr(e.params.scrollbar.scrollbarDisabledClass)), N(), h(), m();
  }, L = () => {
    e.el.classList.add(...rr(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...rr(e.params.scrollbar.scrollbarDisabledClass)), x();
  };
  Object.assign(e.scrollbar, {
    enable: C,
    disable: L,
    updateSize: h,
    setTranslate: m,
    init: N,
    destroy: x
  });
}
function m5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    parallax: {
      enabled: !1
    }
  });
  const s = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", r = (l, u) => {
    const {
      rtl: d
    } = e, c = d ? -1 : 1, A = l.getAttribute("data-swiper-parallax") || "0";
    let m = l.getAttribute("data-swiper-parallax-x"), p = l.getAttribute("data-swiper-parallax-y");
    const h = l.getAttribute("data-swiper-parallax-scale"), g = l.getAttribute("data-swiper-parallax-opacity"), w = l.getAttribute("data-swiper-parallax-rotate");
    if (m || p ? (m = m || "0", p = p || "0") : e.isHorizontal() ? (m = A, p = "0") : (p = A, m = "0"), m.indexOf("%") >= 0 ? m = `${parseInt(m, 10) * u * c}%` : m = `${m * u * c}px`, p.indexOf("%") >= 0 ? p = `${parseInt(p, 10) * u}%` : p = `${p * u}px`, typeof g < "u" && g !== null) {
      const y = g - (g - 1) * (1 - Math.abs(u));
      l.style.opacity = y;
    }
    let b = `translate3d(${m}, ${p}, 0px)`;
    if (typeof h < "u" && h !== null) {
      const y = h - (h - 1) * (1 - Math.abs(u));
      b += ` scale(${y})`;
    }
    if (w && typeof w < "u" && w !== null) {
      const y = w * u * -1;
      b += ` rotate(${y}deg)`;
    }
    l.style.transform = b;
  }, a = () => {
    const {
      el: l,
      slides: u,
      progress: d,
      snapGrid: c,
      isElement: A
    } = e, m = Ni(l, s);
    e.isElement && m.push(...Ni(e.hostEl, s)), m.forEach((p) => {
      r(p, d);
    }), u.forEach((p, h) => {
      let g = p.progress;
      e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (g += Math.ceil(h / 2) - d * (c.length - 1)), g = Math.min(Math.max(g, -1), 1), p.querySelectorAll(`${s}, [data-swiper-parallax-rotate]`).forEach((w) => {
        r(w, g);
      });
    });
  }, o = function(l) {
    l === void 0 && (l = e.params.speed);
    const {
      el: u,
      hostEl: d
    } = e, c = [...u.querySelectorAll(s)];
    e.isElement && c.push(...d.querySelectorAll(s)), c.forEach((A) => {
      let m = parseInt(A.getAttribute("data-swiper-parallax-duration"), 10) || l;
      l === 0 && (m = 0), A.style.transitionDuration = `${m}ms`;
    });
  };
  n("beforeInit", () => {
    e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
  }), n("init", () => {
    e.params.parallax.enabled && a();
  }), n("setTranslate", () => {
    e.params.parallax.enabled && a();
  }), n("setTransition", (l, u) => {
    e.params.parallax.enabled && o(u);
  });
}
function A5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: s
  } = t;
  const r = Jt();
  i({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      panOnMouseMove: !1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let a = 1, o = !1, l = !1, u = {
    x: 0,
    y: 0
  };
  const d = -3;
  let c, A;
  const m = [], p = {
    originX: 0,
    originY: 0,
    slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    imageEl: void 0,
    imageWrapEl: void 0,
    maxRatio: 3
  }, h = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, g = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let w = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return w;
    },
    set(te) {
      if (w !== te) {
        const le = p.imageEl, B = p.slideEl;
        s("zoomChange", te, le, B);
      }
      w = te;
    }
  });
  function b() {
    if (m.length < 2) return 1;
    const te = m[0].pageX, le = m[0].pageY, B = m[1].pageX, ue = m[1].pageY;
    return Math.sqrt((B - te) ** 2 + (ue - le) ** 2);
  }
  function y() {
    const te = e.params.zoom, le = p.imageWrapEl.getAttribute("data-swiper-zoom") || te.maxRatio;
    if (te.limitToOriginalSize && p.imageEl && p.imageEl.naturalWidth) {
      const B = p.imageEl.naturalWidth / p.imageEl.offsetWidth;
      return Math.min(B, le);
    }
    return le;
  }
  function D() {
    if (m.length < 2) return {
      x: null,
      y: null
    };
    const te = p.imageEl.getBoundingClientRect();
    return [(m[0].pageX + (m[1].pageX - m[0].pageX) / 2 - te.x - r.scrollX) / a, (m[0].pageY + (m[1].pageY - m[0].pageY) / 2 - te.y - r.scrollY) / a];
  }
  function I() {
    return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
  }
  function M(te) {
    const le = I();
    return !!(te.target.matches(le) || e.slides.filter((B) => B.contains(te.target)).length > 0);
  }
  function _(te) {
    const le = `.${e.params.zoom.containerClass}`;
    return !!(te.target.matches(le) || [...e.hostEl.querySelectorAll(le)].filter((B) => B.contains(te.target)).length > 0);
  }
  function N(te) {
    if (te.pointerType === "mouse" && m.splice(0, m.length), !M(te)) return;
    const le = e.params.zoom;
    if (c = !1, A = !1, m.push(te), !(m.length < 2)) {
      if (c = !0, p.scaleStart = b(), !p.slideEl) {
        p.slideEl = te.target.closest(`.${e.params.slideClass}, swiper-slide`), p.slideEl || (p.slideEl = e.slides[e.activeIndex]);
        let B = p.slideEl.querySelector(`.${le.containerClass}`);
        if (B && (B = B.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = B, B ? p.imageWrapEl = Xr(p.imageEl, `.${le.containerClass}`)[0] : p.imageWrapEl = void 0, !p.imageWrapEl) {
          p.imageEl = void 0;
          return;
        }
        p.maxRatio = y();
      }
      if (p.imageEl) {
        const [B, ue] = D();
        p.originX = B, p.originY = ue, p.imageEl.style.transitionDuration = "0ms";
      }
      o = !0;
    }
  }
  function x(te) {
    if (!M(te)) return;
    const le = e.params.zoom, B = e.zoom, ue = m.findIndex((Pe) => Pe.pointerId === te.pointerId);
    ue >= 0 && (m[ue] = te), !(m.length < 2) && (A = !0, p.scaleMove = b(), p.imageEl && (B.scale = p.scaleMove / p.scaleStart * a, B.scale > p.maxRatio && (B.scale = p.maxRatio - 1 + (B.scale - p.maxRatio + 1) ** 0.5), B.scale < le.minRatio && (B.scale = le.minRatio + 1 - (le.minRatio - B.scale + 1) ** 0.5), p.imageEl.style.transform = `translate3d(0,0,0) scale(${B.scale})`));
  }
  function C(te) {
    if (!M(te) || te.pointerType === "mouse" && te.type === "pointerout") return;
    const le = e.params.zoom, B = e.zoom, ue = m.findIndex((Pe) => Pe.pointerId === te.pointerId);
    ue >= 0 && m.splice(ue, 1), !(!c || !A) && (c = !1, A = !1, p.imageEl && (B.scale = Math.max(Math.min(B.scale, p.maxRatio), le.minRatio), p.imageEl.style.transitionDuration = `${e.params.speed}ms`, p.imageEl.style.transform = `translate3d(0,0,0) scale(${B.scale})`, a = B.scale, o = !1, B.scale > 1 && p.slideEl ? p.slideEl.classList.add(`${le.zoomedSlideClass}`) : B.scale <= 1 && p.slideEl && p.slideEl.classList.remove(`${le.zoomedSlideClass}`), B.scale === 1 && (p.originX = 0, p.originY = 0, p.slideEl = void 0)));
  }
  let L;
  function V() {
    e.touchEventsData.preventTouchMoveFromPointerMove = !1;
  }
  function H() {
    clearTimeout(L), e.touchEventsData.preventTouchMoveFromPointerMove = !0, L = setTimeout(() => {
      e.destroyed || V();
    });
  }
  function O(te) {
    const le = e.device;
    if (!p.imageEl || h.isTouched) return;
    le.android && te.cancelable && te.preventDefault(), h.isTouched = !0;
    const B = m.length > 0 ? m[0] : te;
    h.touchesStart.x = B.pageX, h.touchesStart.y = B.pageY;
  }
  function X(te) {
    const B = te.pointerType === "mouse" && e.params.zoom.panOnMouseMove;
    if (!M(te) || !_(te))
      return;
    const ue = e.zoom;
    if (!p.imageEl)
      return;
    if (!h.isTouched || !p.slideEl) {
      B && W(te);
      return;
    }
    if (B) {
      W(te);
      return;
    }
    h.isMoved || (h.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, h.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, h.startX = Ah(p.imageWrapEl, "x") || 0, h.startY = Ah(p.imageWrapEl, "y") || 0, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight, p.imageWrapEl.style.transitionDuration = "0ms");
    const Pe = h.width * ue.scale, nt = h.height * ue.scale;
    if (h.minX = Math.min(p.slideWidth / 2 - Pe / 2, 0), h.maxX = -h.minX, h.minY = Math.min(p.slideHeight / 2 - nt / 2, 0), h.maxY = -h.minY, h.touchesCurrent.x = m.length > 0 ? m[0].pageX : te.pageX, h.touchesCurrent.y = m.length > 0 ? m[0].pageY : te.pageY, Math.max(Math.abs(h.touchesCurrent.x - h.touchesStart.x), Math.abs(h.touchesCurrent.y - h.touchesStart.y)) > 5 && (e.allowClick = !1), !h.isMoved && !o) {
      if (e.isHorizontal() && (Math.floor(h.minX) === Math.floor(h.startX) && h.touchesCurrent.x < h.touchesStart.x || Math.floor(h.maxX) === Math.floor(h.startX) && h.touchesCurrent.x > h.touchesStart.x)) {
        h.isTouched = !1, V();
        return;
      }
      if (!e.isHorizontal() && (Math.floor(h.minY) === Math.floor(h.startY) && h.touchesCurrent.y < h.touchesStart.y || Math.floor(h.maxY) === Math.floor(h.startY) && h.touchesCurrent.y > h.touchesStart.y)) {
        h.isTouched = !1, V();
        return;
      }
    }
    te.cancelable && te.preventDefault(), te.stopPropagation(), H(), h.isMoved = !0;
    const Qe = (ue.scale - a) / (p.maxRatio - e.params.zoom.minRatio), {
      originX: Ee,
      originY: xe
    } = p;
    h.currentX = h.touchesCurrent.x - h.touchesStart.x + h.startX + Qe * (h.width - Ee * 2), h.currentY = h.touchesCurrent.y - h.touchesStart.y + h.startY + Qe * (h.height - xe * 2), h.currentX < h.minX && (h.currentX = h.minX + 1 - (h.minX - h.currentX + 1) ** 0.8), h.currentX > h.maxX && (h.currentX = h.maxX - 1 + (h.currentX - h.maxX + 1) ** 0.8), h.currentY < h.minY && (h.currentY = h.minY + 1 - (h.minY - h.currentY + 1) ** 0.8), h.currentY > h.maxY && (h.currentY = h.maxY - 1 + (h.currentY - h.maxY + 1) ** 0.8), g.prevPositionX || (g.prevPositionX = h.touchesCurrent.x), g.prevPositionY || (g.prevPositionY = h.touchesCurrent.y), g.prevTime || (g.prevTime = Date.now()), g.x = (h.touchesCurrent.x - g.prevPositionX) / (Date.now() - g.prevTime) / 2, g.y = (h.touchesCurrent.y - g.prevPositionY) / (Date.now() - g.prevTime) / 2, Math.abs(h.touchesCurrent.x - g.prevPositionX) < 2 && (g.x = 0), Math.abs(h.touchesCurrent.y - g.prevPositionY) < 2 && (g.y = 0), g.prevPositionX = h.touchesCurrent.x, g.prevPositionY = h.touchesCurrent.y, g.prevTime = Date.now(), p.imageWrapEl.style.transform = `translate3d(${h.currentX}px, ${h.currentY}px,0)`;
  }
  function q() {
    const te = e.zoom;
    if (m.length = 0, !p.imageEl) return;
    if (!h.isTouched || !h.isMoved) {
      h.isTouched = !1, h.isMoved = !1;
      return;
    }
    h.isTouched = !1, h.isMoved = !1;
    let le = 300, B = 300;
    const ue = g.x * le, Pe = h.currentX + ue, nt = g.y * B, ge = h.currentY + nt;
    g.x !== 0 && (le = Math.abs((Pe - h.currentX) / g.x)), g.y !== 0 && (B = Math.abs((ge - h.currentY) / g.y));
    const Qe = Math.max(le, B);
    h.currentX = Pe, h.currentY = ge;
    const Ee = h.width * te.scale, xe = h.height * te.scale;
    h.minX = Math.min(p.slideWidth / 2 - Ee / 2, 0), h.maxX = -h.minX, h.minY = Math.min(p.slideHeight / 2 - xe / 2, 0), h.maxY = -h.minY, h.currentX = Math.max(Math.min(h.currentX, h.maxX), h.minX), h.currentY = Math.max(Math.min(h.currentY, h.maxY), h.minY), p.imageWrapEl.style.transitionDuration = `${Qe}ms`, p.imageWrapEl.style.transform = `translate3d(${h.currentX}px, ${h.currentY}px,0)`;
  }
  function F() {
    const te = e.zoom;
    p.slideEl && e.activeIndex !== e.slides.indexOf(p.slideEl) && (p.imageEl && (p.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), p.imageWrapEl && (p.imageWrapEl.style.transform = "translate3d(0,0,0)"), p.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), te.scale = 1, a = 1, p.slideEl = void 0, p.imageEl = void 0, p.imageWrapEl = void 0, p.originX = 0, p.originY = 0);
  }
  function W(te) {
    if (a <= 1 || !p.imageWrapEl || !M(te) || !_(te)) return;
    const le = r.getComputedStyle(p.imageWrapEl).transform, B = new r.DOMMatrix(le);
    if (!l) {
      l = !0, u.x = te.clientX, u.y = te.clientY, h.startX = B.e, h.startY = B.f, h.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, h.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight;
      return;
    }
    const ue = (te.clientX - u.x) * d, Pe = (te.clientY - u.y) * d, nt = h.width * a, ge = h.height * a, Qe = p.slideWidth, Ee = p.slideHeight, xe = Math.min(Qe / 2 - nt / 2, 0), K = -xe, Ie = Math.min(Ee / 2 - ge / 2, 0), Be = -Ie, Me = Math.max(Math.min(h.startX + ue, K), xe), Ke = Math.max(Math.min(h.startY + Pe, Be), Ie);
    p.imageWrapEl.style.transitionDuration = "0ms", p.imageWrapEl.style.transform = `translate3d(${Me}px, ${Ke}px, 0)`, u.x = te.clientX, u.y = te.clientY, h.startX = Me, h.startY = Ke, h.currentX = Me, h.currentY = Ke;
  }
  function j(te) {
    const le = e.zoom, B = e.params.zoom;
    if (!p.slideEl) {
      te && te.target && (p.slideEl = te.target.closest(`.${e.params.slideClass}, swiper-slide`)), p.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = Ni(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex]);
      let Et = p.slideEl.querySelector(`.${B.containerClass}`);
      Et && (Et = Et.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = Et, Et ? p.imageWrapEl = Xr(p.imageEl, `.${B.containerClass}`)[0] : p.imageWrapEl = void 0;
    }
    if (!p.imageEl || !p.imageWrapEl) return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), p.slideEl.classList.add(`${B.zoomedSlideClass}`);
    let ue, Pe, nt, ge, Qe, Ee, xe, K, Ie, Be, Me, Ke, He, Ge, ot, he, Re, dt;
    typeof h.touchesStart.x > "u" && te ? (ue = te.pageX, Pe = te.pageY) : (ue = h.touchesStart.x, Pe = h.touchesStart.y);
    const St = a, Rt = typeof te == "number" ? te : null;
    a === 1 && Rt && (ue = void 0, Pe = void 0, h.touchesStart.x = void 0, h.touchesStart.y = void 0);
    const je = y();
    le.scale = Rt || je, a = Rt || je, te && !(a === 1 && Rt) ? (Re = p.slideEl.offsetWidth, dt = p.slideEl.offsetHeight, nt = ud(p.slideEl).left + r.scrollX, ge = ud(p.slideEl).top + r.scrollY, Qe = nt + Re / 2 - ue, Ee = ge + dt / 2 - Pe, Ie = p.imageEl.offsetWidth || p.imageEl.clientWidth, Be = p.imageEl.offsetHeight || p.imageEl.clientHeight, Me = Ie * le.scale, Ke = Be * le.scale, He = Math.min(Re / 2 - Me / 2, 0), Ge = Math.min(dt / 2 - Ke / 2, 0), ot = -He, he = -Ge, St > 0 && Rt && typeof h.currentX == "number" && typeof h.currentY == "number" ? (xe = h.currentX * le.scale / St, K = h.currentY * le.scale / St) : (xe = Qe * le.scale, K = Ee * le.scale), xe < He && (xe = He), xe > ot && (xe = ot), K < Ge && (K = Ge), K > he && (K = he)) : (xe = 0, K = 0), Rt && le.scale === 1 && (p.originX = 0, p.originY = 0), h.currentX = xe, h.currentY = K, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = `translate3d(${xe}px, ${K}px,0)`, p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = `translate3d(0,0,0) scale(${le.scale})`;
  }
  function oe() {
    const te = e.zoom, le = e.params.zoom;
    if (!p.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = Ni(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex];
      let B = p.slideEl.querySelector(`.${le.containerClass}`);
      B && (B = B.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = B, B ? p.imageWrapEl = Xr(p.imageEl, `.${le.containerClass}`)[0] : p.imageWrapEl = void 0;
    }
    !p.imageEl || !p.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), te.scale = 1, a = 1, h.currentX = void 0, h.currentY = void 0, h.touchesStart.x = void 0, h.touchesStart.y = void 0, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = "translate3d(0,0,0)", p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = "translate3d(0,0,0) scale(1)", p.slideEl.classList.remove(`${le.zoomedSlideClass}`), p.slideEl = void 0, p.originX = 0, p.originY = 0, e.params.zoom.panOnMouseMove && (u = {
      x: 0,
      y: 0
    }, l && (l = !1, h.startX = 0, h.startY = 0)));
  }
  function $(te) {
    const le = e.zoom;
    le.scale && le.scale !== 1 ? oe() : j(te);
  }
  function ye() {
    const te = e.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, le = e.params.passiveListeners ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener: te,
      activeListenerWithCapture: le
    };
  }
  function ae() {
    const te = e.zoom;
    if (te.enabled) return;
    te.enabled = !0;
    const {
      passiveListener: le,
      activeListenerWithCapture: B
    } = ye();
    e.wrapperEl.addEventListener("pointerdown", N, le), e.wrapperEl.addEventListener("pointermove", x, B), ["pointerup", "pointercancel", "pointerout"].forEach((ue) => {
      e.wrapperEl.addEventListener(ue, C, le);
    }), e.wrapperEl.addEventListener("pointermove", X, B);
  }
  function ce() {
    const te = e.zoom;
    if (!te.enabled) return;
    te.enabled = !1;
    const {
      passiveListener: le,
      activeListenerWithCapture: B
    } = ye();
    e.wrapperEl.removeEventListener("pointerdown", N, le), e.wrapperEl.removeEventListener("pointermove", x, B), ["pointerup", "pointercancel", "pointerout"].forEach((ue) => {
      e.wrapperEl.removeEventListener(ue, C, le);
    }), e.wrapperEl.removeEventListener("pointermove", X, B);
  }
  n("init", () => {
    e.params.zoom.enabled && ae();
  }), n("destroy", () => {
    ce();
  }), n("touchStart", (te, le) => {
    e.zoom.enabled && O(le);
  }), n("touchEnd", (te, le) => {
    e.zoom.enabled && q();
  }), n("doubleTap", (te, le) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && $(le);
  }), n("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && F();
  }), n("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && F();
  }), Object.assign(e.zoom, {
    enable: ae,
    disable: ce,
    in: j,
    out: oe,
    toggle: $
  });
}
function g5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), e.controller = {
    control: void 0
  };
  function s(u, d) {
    const c = /* @__PURE__ */ function() {
      let h, g, w;
      return (b, y) => {
        for (g = -1, h = b.length; h - g > 1; )
          w = h + g >> 1, b[w] <= y ? g = w : h = w;
        return h;
      };
    }();
    this.x = u, this.y = d, this.lastIndex = u.length - 1;
    let A, m;
    return this.interpolate = function(h) {
      return h ? (m = c(this.x, h), A = m - 1, (h - this.x[A]) * (this.y[m] - this.y[A]) / (this.x[m] - this.x[A]) + this.y[A]) : 0;
    }, this;
  }
  function r(u) {
    e.controller.spline = e.params.loop ? new s(e.slidesGrid, u.slidesGrid) : new s(e.snapGrid, u.snapGrid);
  }
  function a(u, d) {
    const c = e.controller.control;
    let A, m;
    const p = e.constructor;
    function h(g) {
      if (g.destroyed) return;
      const w = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (r(g), m = -e.controller.spline.interpolate(-w)), (!m || e.params.controller.by === "container") && (A = (g.maxTranslate() - g.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(A) || !Number.isFinite(A)) && (A = 1), m = (w - e.minTranslate()) * A + g.minTranslate()), e.params.controller.inverse && (m = g.maxTranslate() - m), g.updateProgress(m), g.setTranslate(m, e), g.updateActiveIndex(), g.updateSlidesClasses();
    }
    if (Array.isArray(c))
      for (let g = 0; g < c.length; g += 1)
        c[g] !== d && c[g] instanceof p && h(c[g]);
    else c instanceof p && d !== c && h(c);
  }
  function o(u, d) {
    const c = e.constructor, A = e.controller.control;
    let m;
    function p(h) {
      h.destroyed || (h.setTransition(u, e), u !== 0 && (h.transitionStart(), h.params.autoHeight && ta(() => {
        h.updateAutoHeight();
      }), ml(h.wrapperEl, () => {
        A && h.transitionEnd();
      })));
    }
    if (Array.isArray(A))
      for (m = 0; m < A.length; m += 1)
        A[m] !== d && A[m] instanceof c && p(A[m]);
    else A instanceof c && d !== A && p(A);
  }
  function l() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  n("beforeInit", () => {
    if (typeof window < "u" && // eslint-disable-line
    (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
      (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach((d) => {
        if (e.controller.control || (e.controller.control = []), d && d.swiper)
          e.controller.control.push(d.swiper);
        else if (d) {
          const c = `${e.params.eventsPrefix}init`, A = (m) => {
            e.controller.control.push(m.detail[0]), e.update(), d.removeEventListener(c, A);
          };
          d.addEventListener(c, A);
        }
      });
      return;
    }
    e.controller.control = e.params.controller.control;
  }), n("update", () => {
    l();
  }), n("resize", () => {
    l();
  }), n("observerUpdate", () => {
    l();
  }), n("setTranslate", (u, d, c) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(d, c);
  }), n("setTransition", (u, d, c) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(d, c);
  }), Object.assign(e.controller, {
    setTranslate: a,
    setTransition: o
  });
}
function v5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), e.a11y = {
    clicked: !1
  };
  let s = null, r, a, o = (/* @__PURE__ */ new Date()).getTime();
  function l(F) {
    const W = s;
    W.length !== 0 && (W.innerHTML = "", W.innerHTML = F);
  }
  function u(F) {
    const W = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(F).replace(/x/g, W);
  }
  function d(F) {
    F = At(F), F.forEach((W) => {
      W.setAttribute("tabIndex", "0");
    });
  }
  function c(F) {
    F = At(F), F.forEach((W) => {
      W.setAttribute("tabIndex", "-1");
    });
  }
  function A(F, W) {
    F = At(F), F.forEach((j) => {
      j.setAttribute("role", W);
    });
  }
  function m(F, W) {
    F = At(F), F.forEach((j) => {
      j.setAttribute("aria-roledescription", W);
    });
  }
  function p(F, W) {
    F = At(F), F.forEach((j) => {
      j.setAttribute("aria-controls", W);
    });
  }
  function h(F, W) {
    F = At(F), F.forEach((j) => {
      j.setAttribute("aria-label", W);
    });
  }
  function g(F, W) {
    F = At(F), F.forEach((j) => {
      j.setAttribute("id", W);
    });
  }
  function w(F, W) {
    F = At(F), F.forEach((j) => {
      j.setAttribute("aria-live", W);
    });
  }
  function b(F) {
    F = At(F), F.forEach((W) => {
      W.setAttribute("aria-disabled", !0);
    });
  }
  function y(F) {
    F = At(F), F.forEach((W) => {
      W.setAttribute("aria-disabled", !1);
    });
  }
  function D(F) {
    if (F.keyCode !== 13 && F.keyCode !== 32) return;
    const W = e.params.a11y, j = F.target;
    if (!(e.pagination && e.pagination.el && (j === e.pagination.el || e.pagination.el.contains(F.target)) && !F.target.matches(Ls(e.params.pagination.bulletClass)))) {
      if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
        const oe = At(e.navigation.prevEl);
        At(e.navigation.nextEl).includes(j) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? l(W.lastSlideMessage) : l(W.nextSlideMessage)), oe.includes(j) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? l(W.firstSlideMessage) : l(W.prevSlideMessage));
      }
      e.pagination && j.matches(Ls(e.params.pagination.bulletClass)) && j.click();
    }
  }
  function I() {
    if (e.params.loop || e.params.rewind || !e.navigation) return;
    const {
      nextEl: F,
      prevEl: W
    } = e.navigation;
    W && (e.isBeginning ? (b(W), c(W)) : (y(W), d(W))), F && (e.isEnd ? (b(F), c(F)) : (y(F), d(F)));
  }
  function M() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function _() {
    return M() && e.params.pagination.clickable;
  }
  function N() {
    const F = e.params.a11y;
    M() && e.pagination.bullets.forEach((W) => {
      e.params.pagination.clickable && (d(W), e.params.pagination.renderBullet || (A(W, "button"), h(W, F.paginationBulletMessage.replace(/\{\{index\}\}/, Dl(W) + 1)))), W.matches(Ls(e.params.pagination.bulletActiveClass)) ? W.setAttribute("aria-current", "true") : W.removeAttribute("aria-current");
    });
  }
  const x = (F, W, j) => {
    d(F), F.tagName !== "BUTTON" && (A(F, "button"), F.addEventListener("keydown", D)), h(F, j), p(F, W);
  }, C = (F) => {
    a && a !== F.target && !a.contains(F.target) && (r = !0), e.a11y.clicked = !0;
  }, L = () => {
    r = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        e.destroyed || (e.a11y.clicked = !1);
      });
    });
  }, V = (F) => {
    o = (/* @__PURE__ */ new Date()).getTime();
  }, H = (F) => {
    if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - o < 100) return;
    const W = F.target.closest(`.${e.params.slideClass}, swiper-slide`);
    if (!W || !e.slides.includes(W)) return;
    a = W;
    const j = e.slides.indexOf(W) === e.activeIndex, oe = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(W);
    j || oe || F.sourceCapabilities && F.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
      r || (e.params.loop ? e.slideToLoop(parseInt(W.getAttribute("data-swiper-slide-index")), 0) : e.slideTo(e.slides.indexOf(W), 0), r = !1);
    }));
  }, O = () => {
    const F = e.params.a11y;
    F.itemRoleDescriptionMessage && m(e.slides, F.itemRoleDescriptionMessage), F.slideRole && A(e.slides, F.slideRole);
    const W = e.slides.length;
    F.slideLabelMessage && e.slides.forEach((j, oe) => {
      const $ = e.params.loop ? parseInt(j.getAttribute("data-swiper-slide-index"), 10) : oe, ye = F.slideLabelMessage.replace(/\{\{index\}\}/, $ + 1).replace(/\{\{slidesLength\}\}/, W);
      h(j, ye);
    });
  }, X = () => {
    const F = e.params.a11y;
    e.el.append(s);
    const W = e.el;
    F.containerRoleDescriptionMessage && m(W, F.containerRoleDescriptionMessage), F.containerMessage && h(W, F.containerMessage), F.containerRole && A(W, F.containerRole);
    const j = e.wrapperEl, oe = F.id || j.getAttribute("id") || `swiper-wrapper-${u(16)}`, $ = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
    g(j, oe), w(j, $), O();
    let {
      nextEl: ye,
      prevEl: ae
    } = e.navigation ? e.navigation : {};
    ye = At(ye), ae = At(ae), ye && ye.forEach((te) => x(te, oe, F.nextSlideMessage)), ae && ae.forEach((te) => x(te, oe, F.prevSlideMessage)), _() && At(e.pagination.el).forEach((le) => {
      le.addEventListener("keydown", D);
    }), Pi().addEventListener("visibilitychange", V), e.el.addEventListener("focus", H, !0), e.el.addEventListener("focus", H, !0), e.el.addEventListener("pointerdown", C, !0), e.el.addEventListener("pointerup", L, !0);
  };
  function q() {
    s && s.remove();
    let {
      nextEl: F,
      prevEl: W
    } = e.navigation ? e.navigation : {};
    F = At(F), W = At(W), F && F.forEach((oe) => oe.removeEventListener("keydown", D)), W && W.forEach((oe) => oe.removeEventListener("keydown", D)), _() && At(e.pagination.el).forEach(($) => {
      $.removeEventListener("keydown", D);
    }), Pi().removeEventListener("visibilitychange", V), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", H, !0), e.el.removeEventListener("pointerdown", C, !0), e.el.removeEventListener("pointerup", L, !0));
  }
  n("beforeInit", () => {
    s = bn("span", e.params.a11y.notificationClass), s.setAttribute("aria-live", "assertive"), s.setAttribute("aria-atomic", "true");
  }), n("afterInit", () => {
    e.params.a11y.enabled && X();
  }), n("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && O();
  }), n("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && I();
  }), n("paginationUpdate", () => {
    e.params.a11y.enabled && N();
  }), n("destroy", () => {
    e.params.a11y.enabled && q();
  });
}
function y5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    history: {
      enabled: !1,
      root: "",
      replaceState: !1,
      key: "slides",
      keepQuery: !1
    }
  });
  let s = !1, r = {};
  const a = (m) => m.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), o = (m) => {
    const p = Jt();
    let h;
    m ? h = new URL(m) : h = p.location;
    const g = h.pathname.slice(1).split("/").filter((D) => D !== ""), w = g.length, b = g[w - 2], y = g[w - 1];
    return {
      key: b,
      value: y
    };
  }, l = (m, p) => {
    const h = Jt();
    if (!s || !e.params.history.enabled) return;
    let g;
    e.params.url ? g = new URL(e.params.url) : g = h.location;
    const w = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${p}"]`) : e.slides[p];
    let b = a(w.getAttribute("data-history"));
    if (e.params.history.root.length > 0) {
      let D = e.params.history.root;
      D[D.length - 1] === "/" && (D = D.slice(0, D.length - 1)), b = `${D}/${m ? `${m}/` : ""}${b}`;
    } else g.pathname.includes(m) || (b = `${m ? `${m}/` : ""}${b}`);
    e.params.history.keepQuery && (b += g.search);
    const y = h.history.state;
    y && y.value === b || (e.params.history.replaceState ? h.history.replaceState({
      value: b
    }, null, b) : h.history.pushState({
      value: b
    }, null, b));
  }, u = (m, p, h) => {
    if (p)
      for (let g = 0, w = e.slides.length; g < w; g += 1) {
        const b = e.slides[g];
        if (a(b.getAttribute("data-history")) === p) {
          const D = e.getSlideIndex(b);
          e.slideTo(D, m, h);
        }
      }
    else
      e.slideTo(0, m, h);
  }, d = () => {
    r = o(e.params.url), u(e.params.speed, r.value, !1);
  }, c = () => {
    const m = Jt();
    if (e.params.history) {
      if (!m.history || !m.history.pushState) {
        e.params.history.enabled = !1, e.params.hashNavigation.enabled = !0;
        return;
      }
      if (s = !0, r = o(e.params.url), !r.key && !r.value) {
        e.params.history.replaceState || m.addEventListener("popstate", d);
        return;
      }
      u(0, r.value, e.params.runCallbacksOnInit), e.params.history.replaceState || m.addEventListener("popstate", d);
    }
  }, A = () => {
    const m = Jt();
    e.params.history.replaceState || m.removeEventListener("popstate", d);
  };
  n("init", () => {
    e.params.history.enabled && c();
  }), n("destroy", () => {
    e.params.history.enabled && A();
  }), n("transitionEnd _freeModeNoMomentumRelease", () => {
    s && l(e.params.history.key, e.activeIndex);
  }), n("slideChange", () => {
    s && e.params.cssMode && l(e.params.history.key, e.activeIndex);
  });
}
function b5(t) {
  let {
    swiper: e,
    extendParams: i,
    emit: n,
    on: s
  } = t, r = !1;
  const a = Pi(), o = Jt();
  i({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(A, m) {
        if (e.virtual && e.params.virtual.enabled) {
          const p = e.slides.find((g) => g.getAttribute("data-hash") === m);
          return p ? parseInt(p.getAttribute("data-swiper-slide-index"), 10) : 0;
        }
        return e.getSlideIndex(Ni(e.slidesEl, `.${e.params.slideClass}[data-hash="${m}"], swiper-slide[data-hash="${m}"]`)[0]);
      }
    }
  });
  const l = () => {
    n("hashChange");
    const A = a.location.hash.replace("#", ""), m = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], p = m ? m.getAttribute("data-hash") : "";
    if (A !== p) {
      const h = e.params.hashNavigation.getSlideIndex(e, A);
      if (typeof h > "u" || Number.isNaN(h)) return;
      e.slideTo(h);
    }
  }, u = () => {
    if (!r || !e.params.hashNavigation.enabled) return;
    const A = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], m = A ? A.getAttribute("data-hash") || A.getAttribute("data-history") : "";
    e.params.hashNavigation.replaceState && o.history && o.history.replaceState ? (o.history.replaceState(null, null, `#${m}` || ""), n("hashSet")) : (a.location.hash = m || "", n("hashSet"));
  }, d = () => {
    if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
    r = !0;
    const A = a.location.hash.replace("#", "");
    if (A) {
      const p = e.params.hashNavigation.getSlideIndex(e, A);
      e.slideTo(p || 0, 0, e.params.runCallbacksOnInit, !0);
    }
    e.params.hashNavigation.watchState && o.addEventListener("hashchange", l);
  }, c = () => {
    e.params.hashNavigation.watchState && o.removeEventListener("hashchange", l);
  };
  s("init", () => {
    e.params.hashNavigation.enabled && d();
  }), s("destroy", () => {
    e.params.hashNavigation.enabled && c();
  }), s("transitionEnd _freeModeNoMomentumRelease", () => {
    r && u();
  }), s("slideChange", () => {
    r && e.params.cssMode && u();
  });
}
function w5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: s,
    params: r
  } = t;
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, i({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let a, o, l = r && r.autoplay ? r.autoplay.delay : 3e3, u = r && r.autoplay ? r.autoplay.delay : 3e3, d, c = (/* @__PURE__ */ new Date()).getTime(), A, m, p, h, g, w, b;
  function y(W) {
    !e || e.destroyed || !e.wrapperEl || W.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", y), !(b || W.detail && W.detail.bySwiperTouchMove) && C());
  }
  const D = () => {
    if (e.destroyed || !e.autoplay.running) return;
    e.autoplay.paused ? A = !0 : A && (u = d, A = !1);
    const W = e.autoplay.paused ? d : c + u - (/* @__PURE__ */ new Date()).getTime();
    e.autoplay.timeLeft = W, s("autoplayTimeLeft", W, W / l), o = requestAnimationFrame(() => {
      D();
    });
  }, I = () => {
    let W;
    return e.virtual && e.params.virtual.enabled ? W = e.slides.find((oe) => oe.classList.contains("swiper-slide-active")) : W = e.slides[e.activeIndex], W ? parseInt(W.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, M = (W) => {
    if (e.destroyed || !e.autoplay.running) return;
    cancelAnimationFrame(o), D();
    let j = typeof W > "u" ? e.params.autoplay.delay : W;
    l = e.params.autoplay.delay, u = e.params.autoplay.delay;
    const oe = I();
    !Number.isNaN(oe) && oe > 0 && typeof W > "u" && (j = oe, l = oe, u = oe), d = j;
    const $ = e.params.speed, ye = () => {
      !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev($, !0, !0), s("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, $, !0, !0), s("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext($, !0, !0), s("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, $, !0, !0), s("autoplay")), e.params.cssMode && (c = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        M();
      })));
    };
    return j > 0 ? (clearTimeout(a), a = setTimeout(() => {
      ye();
    }, j)) : requestAnimationFrame(() => {
      ye();
    }), j;
  }, _ = () => {
    c = (/* @__PURE__ */ new Date()).getTime(), e.autoplay.running = !0, M(), s("autoplayStart");
  }, N = () => {
    e.autoplay.running = !1, clearTimeout(a), cancelAnimationFrame(o), s("autoplayStop");
  }, x = (W, j) => {
    if (e.destroyed || !e.autoplay.running) return;
    clearTimeout(a), W || (w = !0);
    const oe = () => {
      s("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", y) : C();
    };
    if (e.autoplay.paused = !0, j) {
      g && (d = e.params.autoplay.delay), g = !1, oe();
      return;
    }
    d = (d || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - c), !(e.isEnd && d < 0 && !e.params.loop) && (d < 0 && (d = 0), oe());
  }, C = () => {
    e.isEnd && d < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (c = (/* @__PURE__ */ new Date()).getTime(), w ? (w = !1, M(d)) : M(), e.autoplay.paused = !1, s("autoplayResume"));
  }, L = () => {
    if (e.destroyed || !e.autoplay.running) return;
    const W = Pi();
    W.visibilityState === "hidden" && (w = !0, x(!0)), W.visibilityState === "visible" && C();
  }, V = (W) => {
    W.pointerType === "mouse" && (w = !0, b = !0, !(e.animating || e.autoplay.paused) && x(!0));
  }, H = (W) => {
    W.pointerType === "mouse" && (b = !1, e.autoplay.paused && C());
  }, O = () => {
    e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", V), e.el.addEventListener("pointerleave", H));
  }, X = () => {
    e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", V), e.el.removeEventListener("pointerleave", H));
  }, q = () => {
    Pi().addEventListener("visibilitychange", L);
  }, F = () => {
    Pi().removeEventListener("visibilitychange", L);
  };
  n("init", () => {
    e.params.autoplay.enabled && (O(), q(), _());
  }), n("destroy", () => {
    X(), F(), e.autoplay.running && N();
  }), n("_freeModeStaticRelease", () => {
    (p || w) && C();
  }), n("_freeModeNoMomentumRelease", () => {
    e.params.autoplay.disableOnInteraction ? N() : x(!0, !0);
  }), n("beforeTransitionStart", (W, j, oe) => {
    e.destroyed || !e.autoplay.running || (oe || !e.params.autoplay.disableOnInteraction ? x(!0, !0) : N());
  }), n("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        N();
        return;
      }
      m = !0, p = !1, w = !1, h = setTimeout(() => {
        w = !0, p = !0, x(!0);
      }, 200);
    }
  }), n("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !m)) {
      if (clearTimeout(h), clearTimeout(a), e.params.autoplay.disableOnInteraction) {
        p = !1, m = !1;
        return;
      }
      p && e.params.cssMode && C(), p = !1, m = !1;
    }
  }), n("slideChange", () => {
    e.destroyed || !e.autoplay.running || (g = !0);
  }), Object.assign(e.autoplay, {
    start: _,
    stop: N,
    pause: x,
    resume: C
  });
}
function T5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let s = !1, r = !1;
  e.thumbs = {
    swiper: null
  };
  function a() {
    const u = e.thumbs.swiper;
    if (!u || u.destroyed) return;
    const d = u.clickedIndex, c = u.clickedSlide;
    if (c && c.classList.contains(e.params.thumbs.slideThumbActiveClass) || typeof d > "u" || d === null) return;
    let A;
    u.params.loop ? A = parseInt(u.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : A = d, e.params.loop ? e.slideToLoop(A) : e.slideTo(A);
  }
  function o() {
    const {
      thumbs: u
    } = e.params;
    if (s) return !1;
    s = !0;
    const d = e.constructor;
    if (u.swiper instanceof d) {
      if (u.swiper.destroyed)
        return s = !1, !1;
      e.thumbs.swiper = u.swiper, Object.assign(e.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(e.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper.update();
    } else if (tl(u.swiper)) {
      const c = Object.assign({}, u.swiper);
      Object.assign(c, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper = new d(c), r = !0;
    }
    return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", a), !0;
  }
  function l(u) {
    const d = e.thumbs.swiper;
    if (!d || d.destroyed) return;
    const c = d.params.slidesPerView === "auto" ? d.slidesPerViewDynamic() : d.params.slidesPerView;
    let A = 1;
    const m = e.params.thumbs.slideThumbActiveClass;
    if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (A = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (A = 1), A = Math.floor(A), d.slides.forEach((g) => g.classList.remove(m)), d.params.loop || d.params.virtual && d.params.virtual.enabled)
      for (let g = 0; g < A; g += 1)
        Ni(d.slidesEl, `[data-swiper-slide-index="${e.realIndex + g}"]`).forEach((w) => {
          w.classList.add(m);
        });
    else
      for (let g = 0; g < A; g += 1)
        d.slides[e.realIndex + g] && d.slides[e.realIndex + g].classList.add(m);
    const p = e.params.thumbs.autoScrollOffset, h = p && !d.params.loop;
    if (e.realIndex !== d.realIndex || h) {
      const g = d.activeIndex;
      let w, b;
      if (d.params.loop) {
        const y = d.slides.find((D) => D.getAttribute("data-swiper-slide-index") === `${e.realIndex}`);
        w = d.slides.indexOf(y), b = e.activeIndex > e.previousIndex ? "next" : "prev";
      } else
        w = e.realIndex, b = w > e.previousIndex ? "next" : "prev";
      h && (w += b === "next" ? p : -1 * p), d.visibleSlidesIndexes && d.visibleSlidesIndexes.indexOf(w) < 0 && (d.params.centeredSlides ? w > g ? w = w - Math.floor(c / 2) + 1 : w = w + Math.floor(c / 2) - 1 : w > g && d.params.slidesPerGroup, d.slideTo(w, u ? 0 : void 0));
    }
  }
  n("beforeInit", () => {
    const {
      thumbs: u
    } = e.params;
    if (!(!u || !u.swiper))
      if (typeof u.swiper == "string" || u.swiper instanceof HTMLElement) {
        const d = Pi(), c = () => {
          const m = typeof u.swiper == "string" ? d.querySelector(u.swiper) : u.swiper;
          if (m && m.swiper)
            u.swiper = m.swiper, o(), l(!0);
          else if (m) {
            const p = `${e.params.eventsPrefix}init`, h = (g) => {
              u.swiper = g.detail[0], m.removeEventListener(p, h), o(), l(!0), u.swiper.update(), e.update();
            };
            m.addEventListener(p, h);
          }
          return m;
        }, A = () => {
          if (e.destroyed) return;
          c() || requestAnimationFrame(A);
        };
        requestAnimationFrame(A);
      } else
        o(), l(!0);
  }), n("slideChange update resize observerUpdate", () => {
    l();
  }), n("setTransition", (u, d) => {
    const c = e.thumbs.swiper;
    !c || c.destroyed || c.setTransition(d);
  }), n("beforeDestroy", () => {
    const u = e.thumbs.swiper;
    !u || u.destroyed || r && u.destroy();
  }), Object.assign(e.thumbs, {
    init: o,
    update: l
  });
}
function x5(t) {
  let {
    swiper: e,
    extendParams: i,
    emit: n,
    once: s
  } = t;
  i({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02
    }
  });
  function r() {
    if (e.params.cssMode) return;
    const l = e.getTranslate();
    e.setTranslate(l), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({
      currentPos: e.rtl ? e.translate : -e.translate
    });
  }
  function a() {
    if (e.params.cssMode) return;
    const {
      touchEventsData: l,
      touches: u
    } = e;
    l.velocities.length === 0 && l.velocities.push({
      position: u[e.isHorizontal() ? "startX" : "startY"],
      time: l.touchStartTime
    }), l.velocities.push({
      position: u[e.isHorizontal() ? "currentX" : "currentY"],
      time: Mn()
    });
  }
  function o(l) {
    let {
      currentPos: u
    } = l;
    if (e.params.cssMode) return;
    const {
      params: d,
      wrapperEl: c,
      rtlTranslate: A,
      snapGrid: m,
      touchEventsData: p
    } = e, g = Mn() - p.touchStartTime;
    if (u < -e.minTranslate()) {
      e.slideTo(e.activeIndex);
      return;
    }
    if (u > -e.maxTranslate()) {
      e.slides.length < m.length ? e.slideTo(m.length - 1) : e.slideTo(e.slides.length - 1);
      return;
    }
    if (d.freeMode.momentum) {
      if (p.velocities.length > 1) {
        const N = p.velocities.pop(), x = p.velocities.pop(), C = N.position - x.position, L = N.time - x.time;
        e.velocity = C / L, e.velocity /= 2, Math.abs(e.velocity) < d.freeMode.minimumVelocity && (e.velocity = 0), (L > 150 || Mn() - N.time > 300) && (e.velocity = 0);
      } else
        e.velocity = 0;
      e.velocity *= d.freeMode.momentumVelocityRatio, p.velocities.length = 0;
      let w = 1e3 * d.freeMode.momentumRatio;
      const b = e.velocity * w;
      let y = e.translate + b;
      A && (y = -y);
      let D = !1, I;
      const M = Math.abs(e.velocity) * 20 * d.freeMode.momentumBounceRatio;
      let _;
      if (y < e.maxTranslate())
        d.freeMode.momentumBounce ? (y + e.maxTranslate() < -M && (y = e.maxTranslate() - M), I = e.maxTranslate(), D = !0, p.allowMomentumBounce = !0) : y = e.maxTranslate(), d.loop && d.centeredSlides && (_ = !0);
      else if (y > e.minTranslate())
        d.freeMode.momentumBounce ? (y - e.minTranslate() > M && (y = e.minTranslate() + M), I = e.minTranslate(), D = !0, p.allowMomentumBounce = !0) : y = e.minTranslate(), d.loop && d.centeredSlides && (_ = !0);
      else if (d.freeMode.sticky) {
        let N;
        for (let x = 0; x < m.length; x += 1)
          if (m[x] > -y) {
            N = x;
            break;
          }
        Math.abs(m[N] - y) < Math.abs(m[N - 1] - y) || e.swipeDirection === "next" ? y = m[N] : y = m[N - 1], y = -y;
      }
      if (_ && s("transitionEnd", () => {
        e.loopFix();
      }), e.velocity !== 0) {
        if (A ? w = Math.abs((-y - e.translate) / e.velocity) : w = Math.abs((y - e.translate) / e.velocity), d.freeMode.sticky) {
          const N = Math.abs((A ? -y : y) - e.translate), x = e.slidesSizesGrid[e.activeIndex];
          N < x ? w = d.speed : N < 2 * x ? w = d.speed * 1.5 : w = d.speed * 2.5;
        }
      } else if (d.freeMode.sticky) {
        e.slideToClosest();
        return;
      }
      d.freeMode.momentumBounce && D ? (e.updateProgress(I), e.setTransition(w), e.setTranslate(y), e.transitionStart(!0, e.swipeDirection), e.animating = !0, ml(c, () => {
        !e || e.destroyed || !p.allowMomentumBounce || (n("momentumBounce"), e.setTransition(d.speed), setTimeout(() => {
          e.setTranslate(I), ml(c, () => {
            !e || e.destroyed || e.transitionEnd();
          });
        }, 0));
      })) : e.velocity ? (n("_freeModeNoMomentumRelease"), e.updateProgress(y), e.setTransition(w), e.setTranslate(y), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, ml(c, () => {
        !e || e.destroyed || e.transitionEnd();
      }))) : e.updateProgress(y), e.updateActiveIndex(), e.updateSlidesClasses();
    } else if (d.freeMode.sticky) {
      e.slideToClosest();
      return;
    } else d.freeMode && n("_freeModeNoMomentumRelease");
    (!d.freeMode.momentum || g >= d.longSwipesMs) && (n("_freeModeStaticRelease"), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
  }
  Object.assign(e, {
    freeMode: {
      onTouchStart: r,
      onTouchMove: a,
      onTouchEnd: o
    }
  });
}
function S5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    grid: {
      rows: 1,
      fill: "column"
    }
  });
  let s, r, a, o;
  const l = () => {
    let h = e.params.spaceBetween;
    return typeof h == "string" && h.indexOf("%") >= 0 ? h = parseFloat(h.replace("%", "")) / 100 * e.size : typeof h == "string" && (h = parseFloat(h)), h;
  }, u = (h) => {
    const {
      slidesPerView: g
    } = e.params, {
      rows: w,
      fill: b
    } = e.params.grid, y = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : h.length;
    a = Math.floor(y / w), Math.floor(y / w) === y / w ? s = y : s = Math.ceil(y / w) * w, g !== "auto" && b === "row" && (s = Math.max(s, g * w)), r = s / w;
  }, d = () => {
    e.slides && e.slides.forEach((h) => {
      h.swiperSlideGridSet && (h.style.height = "", h.style[e.getDirectionLabel("margin-top")] = "");
    });
  }, c = (h, g, w) => {
    const {
      slidesPerGroup: b
    } = e.params, y = l(), {
      rows: D,
      fill: I
    } = e.params.grid, M = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : w.length;
    let _, N, x;
    if (I === "row" && b > 1) {
      const C = Math.floor(h / (b * D)), L = h - D * b * C, V = C === 0 ? b : Math.min(Math.ceil((M - C * D * b) / D), b);
      x = Math.floor(L / V), N = L - x * V + C * b, _ = N + x * s / D, g.style.order = _;
    } else I === "column" ? (N = Math.floor(h / D), x = h - N * D, (N > a || N === a && x === D - 1) && (x += 1, x >= D && (x = 0, N += 1))) : (x = Math.floor(h / r), N = h - x * r);
    g.row = x, g.column = N, g.style.height = `calc((100% - ${(D - 1) * y}px) / ${D})`, g.style[e.getDirectionLabel("margin-top")] = x !== 0 ? y && `${y}px` : "", g.swiperSlideGridSet = !0;
  }, A = (h, g) => {
    const {
      centeredSlides: w,
      roundLengths: b
    } = e.params, y = l(), {
      rows: D
    } = e.params.grid;
    if (e.virtualSize = (h + y) * s, e.virtualSize = Math.ceil(e.virtualSize / D) - y, e.params.cssMode || (e.wrapperEl.style[e.getDirectionLabel("width")] = `${e.virtualSize + y}px`), w) {
      const I = [];
      for (let M = 0; M < g.length; M += 1) {
        let _ = g[M];
        b && (_ = Math.floor(_)), g[M] < e.virtualSize + g[0] && I.push(_);
      }
      g.splice(0, g.length), g.push(...I);
    }
  }, m = () => {
    o = e.params.grid && e.params.grid.rows > 1;
  }, p = () => {
    const {
      params: h,
      el: g
    } = e, w = h.grid && h.grid.rows > 1;
    o && !w ? (g.classList.remove(`${h.containerModifierClass}grid`, `${h.containerModifierClass}grid-column`), a = 1, e.emitContainerClasses()) : !o && w && (g.classList.add(`${h.containerModifierClass}grid`), h.grid.fill === "column" && g.classList.add(`${h.containerModifierClass}grid-column`), e.emitContainerClasses()), o = w;
  };
  n("init", m), n("update", p), e.grid = {
    initSlides: u,
    unsetSlides: d,
    updateSlide: c,
    updateWrapperSize: A
  };
}
function C5(t) {
  const e = this, {
    params: i,
    slidesEl: n
  } = e;
  i.loop && e.loopDestroy();
  const s = (r) => {
    if (typeof r == "string") {
      const a = document.createElement("div");
      a.innerHTML = r, n.append(a.children[0]), a.innerHTML = "";
    } else
      n.append(r);
  };
  if (typeof t == "object" && "length" in t)
    for (let r = 0; r < t.length; r += 1)
      t[r] && s(t[r]);
  else
    s(t);
  e.recalcSlides(), i.loop && e.loopCreate(), (!i.observer || e.isElement) && e.update();
}
function E5(t) {
  const e = this, {
    params: i,
    activeIndex: n,
    slidesEl: s
  } = e;
  i.loop && e.loopDestroy();
  let r = n + 1;
  const a = (o) => {
    if (typeof o == "string") {
      const l = document.createElement("div");
      l.innerHTML = o, s.prepend(l.children[0]), l.innerHTML = "";
    } else
      s.prepend(o);
  };
  if (typeof t == "object" && "length" in t) {
    for (let o = 0; o < t.length; o += 1)
      t[o] && a(t[o]);
    r = n + t.length;
  } else
    a(t);
  e.recalcSlides(), i.loop && e.loopCreate(), (!i.observer || e.isElement) && e.update(), e.slideTo(r, 0, !1);
}
function D5(t, e) {
  const i = this, {
    params: n,
    activeIndex: s,
    slidesEl: r
  } = i;
  let a = s;
  n.loop && (a -= i.loopedSlides, i.loopDestroy(), i.recalcSlides());
  const o = i.slides.length;
  if (t <= 0) {
    i.prependSlide(e);
    return;
  }
  if (t >= o) {
    i.appendSlide(e);
    return;
  }
  let l = a > t ? a + 1 : a;
  const u = [];
  for (let d = o - 1; d >= t; d -= 1) {
    const c = i.slides[d];
    c.remove(), u.unshift(c);
  }
  if (typeof e == "object" && "length" in e) {
    for (let d = 0; d < e.length; d += 1)
      e[d] && r.append(e[d]);
    l = a > t ? a + e.length : a;
  } else
    r.append(e);
  for (let d = 0; d < u.length; d += 1)
    r.append(u[d]);
  i.recalcSlides(), n.loop && i.loopCreate(), (!n.observer || i.isElement) && i.update(), n.loop ? i.slideTo(l + i.loopedSlides, 0, !1) : i.slideTo(l, 0, !1);
}
function _5(t) {
  const e = this, {
    params: i,
    activeIndex: n
  } = e;
  let s = n;
  i.loop && (s -= e.loopedSlides, e.loopDestroy());
  let r = s, a;
  if (typeof t == "object" && "length" in t) {
    for (let o = 0; o < t.length; o += 1)
      a = t[o], e.slides[a] && e.slides[a].remove(), a < r && (r -= 1);
    r = Math.max(r, 0);
  } else
    a = t, e.slides[a] && e.slides[a].remove(), a < r && (r -= 1), r = Math.max(r, 0);
  e.recalcSlides(), i.loop && e.loopCreate(), (!i.observer || e.isElement) && e.update(), i.loop ? e.slideTo(r + e.loopedSlides, 0, !1) : e.slideTo(r, 0, !1);
}
function k5() {
  const t = this, e = [];
  for (let i = 0; i < t.slides.length; i += 1)
    e.push(i);
  t.removeSlide(e);
}
function P5(t) {
  let {
    swiper: e
  } = t;
  Object.assign(e, {
    appendSlide: C5.bind(e),
    prependSlide: E5.bind(e),
    addSlide: D5.bind(e),
    removeSlide: _5.bind(e),
    removeAllSlides: k5.bind(e)
  });
}
function vo(t) {
  const {
    effect: e,
    swiper: i,
    on: n,
    setTranslate: s,
    setTransition: r,
    overwriteParams: a,
    perspective: o,
    recreateShadows: l,
    getEffectParams: u
  } = t;
  n("beforeInit", () => {
    if (i.params.effect !== e) return;
    i.classNames.push(`${i.params.containerModifierClass}${e}`), o && o() && i.classNames.push(`${i.params.containerModifierClass}3d`);
    const c = a ? a() : {};
    Object.assign(i.params, c), Object.assign(i.originalParams, c);
  }), n("setTranslate", () => {
    i.params.effect === e && s();
  }), n("setTransition", (c, A) => {
    i.params.effect === e && r(A);
  }), n("transitionEnd", () => {
    if (i.params.effect === e && l) {
      if (!u || !u().slideShadows) return;
      i.slides.forEach((c) => {
        c.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((A) => A.remove());
      }), l();
    }
  });
  let d;
  n("virtualUpdate", () => {
    i.params.effect === e && (i.slides.length || (d = !0), requestAnimationFrame(() => {
      d && i.slides && i.slides.length && (s(), d = !1);
    }));
  });
}
function Hl(t, e) {
  const i = la(e);
  return i !== e && (i.style.backfaceVisibility = "hidden", i.style["-webkit-backface-visibility"] = "hidden"), i;
}
function Qd(t) {
  let {
    swiper: e,
    duration: i,
    transformElements: n,
    allSlides: s
  } = t;
  const {
    activeIndex: r
  } = e, a = (o) => o.parentElement ? o.parentElement : e.slides.find((u) => u.shadowRoot && u.shadowRoot === o.parentNode);
  if (e.params.virtualTranslate && i !== 0) {
    let o = !1, l;
    s ? l = n : l = n.filter((u) => {
      const d = u.classList.contains("swiper-slide-transform") ? a(u) : u;
      return e.getSlideIndex(d) === r;
    }), l.forEach((u) => {
      ml(u, () => {
        if (o || !e || e.destroyed) return;
        o = !0, e.animating = !1;
        const d = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        e.wrapperEl.dispatchEvent(d);
      });
    });
  }
}
function I5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    fadeEffect: {
      crossFade: !1
    }
  }), vo({
    effect: "fade",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: a
      } = e, o = e.params.fadeEffect;
      for (let l = 0; l < a.length; l += 1) {
        const u = e.slides[l];
        let c = -u.swiperSlideOffset;
        e.params.virtualTranslate || (c -= e.translate);
        let A = 0;
        e.isHorizontal() || (A = c, c = 0);
        const m = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(u.progress), 0) : 1 + Math.min(Math.max(u.progress, -1), 0), p = Hl(o, u);
        p.style.opacity = m, p.style.transform = `translate3d(${c}px, ${A}px, 0px)`;
      }
    },
    setTransition: (a) => {
      const o = e.slides.map((l) => la(l));
      o.forEach((l) => {
        l.style.transitionDuration = `${a}ms`;
      }), Qd({
        swiper: e,
        duration: a,
        transformElements: o,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function M5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const s = (l, u, d) => {
    let c = d ? l.querySelector(".swiper-slide-shadow-left") : l.querySelector(".swiper-slide-shadow-top"), A = d ? l.querySelector(".swiper-slide-shadow-right") : l.querySelector(".swiper-slide-shadow-bottom");
    c || (c = bn("div", `swiper-slide-shadow-cube swiper-slide-shadow-${d ? "left" : "top"}`.split(" ")), l.append(c)), A || (A = bn("div", `swiper-slide-shadow-cube swiper-slide-shadow-${d ? "right" : "bottom"}`.split(" ")), l.append(A)), c && (c.style.opacity = Math.max(-u, 0)), A && (A.style.opacity = Math.max(u, 0));
  };
  vo({
    effect: "cube",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        el: l,
        wrapperEl: u,
        slides: d,
        width: c,
        height: A,
        rtlTranslate: m,
        size: p,
        browser: h
      } = e, g = Gd(e), w = e.params.cubeEffect, b = e.isHorizontal(), y = e.virtual && e.params.virtual.enabled;
      let D = 0, I;
      w.shadow && (b ? (I = e.wrapperEl.querySelector(".swiper-cube-shadow"), I || (I = bn("div", "swiper-cube-shadow"), e.wrapperEl.append(I)), I.style.height = `${c}px`) : (I = l.querySelector(".swiper-cube-shadow"), I || (I = bn("div", "swiper-cube-shadow"), l.append(I))));
      for (let _ = 0; _ < d.length; _ += 1) {
        const N = d[_];
        let x = _;
        y && (x = parseInt(N.getAttribute("data-swiper-slide-index"), 10));
        let C = x * 90, L = Math.floor(C / 360);
        m && (C = -C, L = Math.floor(-C / 360));
        const V = Math.max(Math.min(N.progress, 1), -1);
        let H = 0, O = 0, X = 0;
        x % 4 === 0 ? (H = -L * 4 * p, X = 0) : (x - 1) % 4 === 0 ? (H = 0, X = -L * 4 * p) : (x - 2) % 4 === 0 ? (H = p + L * 4 * p, X = p) : (x - 3) % 4 === 0 && (H = -p, X = 3 * p + p * 4 * L), m && (H = -H), b || (O = H, H = 0);
        const q = `rotateX(${g(b ? 0 : -C)}deg) rotateY(${g(b ? C : 0)}deg) translate3d(${H}px, ${O}px, ${X}px)`;
        V <= 1 && V > -1 && (D = x * 90 + V * 90, m && (D = -x * 90 - V * 90)), N.style.transform = q, w.slideShadows && s(N, V, b);
      }
      if (u.style.transformOrigin = `50% 50% -${p / 2}px`, u.style["-webkit-transform-origin"] = `50% 50% -${p / 2}px`, w.shadow)
        if (b)
          I.style.transform = `translate3d(0px, ${c / 2 + w.shadowOffset}px, ${-c / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${w.shadowScale})`;
        else {
          const _ = Math.abs(D) - Math.floor(Math.abs(D) / 90) * 90, N = 1.5 - (Math.sin(_ * 2 * Math.PI / 360) / 2 + Math.cos(_ * 2 * Math.PI / 360) / 2), x = w.shadowScale, C = w.shadowScale / N, L = w.shadowOffset;
          I.style.transform = `scale3d(${x}, 1, ${C}) translate3d(0px, ${A / 2 + L}px, ${-A / 2 / C}px) rotateX(-89.99deg)`;
        }
      const M = (h.isSafari || h.isWebView) && h.needPerspectiveFix ? -p / 2 : 0;
      u.style.transform = `translate3d(0px,0,${M}px) rotateX(${g(e.isHorizontal() ? 0 : D)}deg) rotateY(${g(e.isHorizontal() ? -D : 0)}deg)`, u.style.setProperty("--swiper-cube-translate-z", `${M}px`);
    },
    setTransition: (l) => {
      const {
        el: u,
        slides: d
      } = e;
      if (d.forEach((c) => {
        c.style.transitionDuration = `${l}ms`, c.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((A) => {
          A.style.transitionDuration = `${l}ms`;
        });
      }), e.params.cubeEffect.shadow && !e.isHorizontal()) {
        const c = u.querySelector(".swiper-cube-shadow");
        c && (c.style.transitionDuration = `${l}ms`);
      }
    },
    recreateShadows: () => {
      const l = e.isHorizontal();
      e.slides.forEach((u) => {
        const d = Math.max(Math.min(u.progress, 1), -1);
        s(u, d, l);
      });
    },
    getEffectParams: () => e.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0
    })
  });
}
function to(t, e, i) {
  const n = `swiper-slide-shadow${i ? `-${i}` : ""}${t ? ` swiper-slide-shadow-${t}` : ""}`, s = la(e);
  let r = s.querySelector(`.${n.split(" ").join(".")}`);
  return r || (r = bn("div", n.split(" ")), s.append(r)), r;
}
function O5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    flipEffect: {
      slideShadows: !0,
      limitRotation: !0
    }
  });
  const s = (l, u) => {
    let d = e.isHorizontal() ? l.querySelector(".swiper-slide-shadow-left") : l.querySelector(".swiper-slide-shadow-top"), c = e.isHorizontal() ? l.querySelector(".swiper-slide-shadow-right") : l.querySelector(".swiper-slide-shadow-bottom");
    d || (d = to("flip", l, e.isHorizontal() ? "left" : "top")), c || (c = to("flip", l, e.isHorizontal() ? "right" : "bottom")), d && (d.style.opacity = Math.max(-u, 0)), c && (c.style.opacity = Math.max(u, 0));
  };
  vo({
    effect: "flip",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: l,
        rtlTranslate: u
      } = e, d = e.params.flipEffect, c = Gd(e);
      for (let A = 0; A < l.length; A += 1) {
        const m = l[A];
        let p = m.progress;
        e.params.flipEffect.limitRotation && (p = Math.max(Math.min(m.progress, 1), -1));
        const h = m.swiperSlideOffset;
        let w = -180 * p, b = 0, y = e.params.cssMode ? -h - e.translate : -h, D = 0;
        e.isHorizontal() ? u && (w = -w) : (D = y, y = 0, b = -w, w = 0), m.style.zIndex = -Math.abs(Math.round(p)) + l.length, d.slideShadows && s(m, p);
        const I = `translate3d(${y}px, ${D}px, 0px) rotateX(${c(b)}deg) rotateY(${c(w)}deg)`, M = Hl(d, m);
        M.style.transform = I;
      }
    },
    setTransition: (l) => {
      const u = e.slides.map((d) => la(d));
      u.forEach((d) => {
        d.style.transitionDuration = `${l}ms`, d.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((c) => {
          c.style.transitionDuration = `${l}ms`;
        });
      }), Qd({
        swiper: e,
        duration: l,
        transformElements: u
      });
    },
    recreateShadows: () => {
      e.params.flipEffect, e.slides.forEach((l) => {
        let u = l.progress;
        e.params.flipEffect.limitRotation && (u = Math.max(Math.min(l.progress, 1), -1)), s(l, u);
      });
    },
    getEffectParams: () => e.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function B5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0
    }
  }), vo({
    effect: "coverflow",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        width: a,
        height: o,
        slides: l,
        slidesSizesGrid: u
      } = e, d = e.params.coverflowEffect, c = e.isHorizontal(), A = e.translate, m = c ? -A + a / 2 : -A + o / 2, p = c ? d.rotate : -d.rotate, h = d.depth, g = Gd(e);
      for (let w = 0, b = l.length; w < b; w += 1) {
        const y = l[w], D = u[w], I = y.swiperSlideOffset, M = (m - I - D / 2) / D, _ = typeof d.modifier == "function" ? d.modifier(M) : M * d.modifier;
        let N = c ? p * _ : 0, x = c ? 0 : p * _, C = -h * Math.abs(_), L = d.stretch;
        typeof L == "string" && L.indexOf("%") !== -1 && (L = parseFloat(d.stretch) / 100 * D);
        let V = c ? 0 : L * _, H = c ? L * _ : 0, O = 1 - (1 - d.scale) * Math.abs(_);
        Math.abs(H) < 1e-3 && (H = 0), Math.abs(V) < 1e-3 && (V = 0), Math.abs(C) < 1e-3 && (C = 0), Math.abs(N) < 1e-3 && (N = 0), Math.abs(x) < 1e-3 && (x = 0), Math.abs(O) < 1e-3 && (O = 0);
        const X = `translate3d(${H}px,${V}px,${C}px)  rotateX(${g(x)}deg) rotateY(${g(N)}deg) scale(${O})`, q = Hl(d, y);
        if (q.style.transform = X, y.style.zIndex = -Math.abs(Math.round(_)) + 1, d.slideShadows) {
          let F = c ? y.querySelector(".swiper-slide-shadow-left") : y.querySelector(".swiper-slide-shadow-top"), W = c ? y.querySelector(".swiper-slide-shadow-right") : y.querySelector(".swiper-slide-shadow-bottom");
          F || (F = to("coverflow", y, c ? "left" : "top")), W || (W = to("coverflow", y, c ? "right" : "bottom")), F && (F.style.opacity = _ > 0 ? _ : 0), W && (W.style.opacity = -_ > 0 ? -_ : 0);
        }
      }
    },
    setTransition: (a) => {
      e.slides.map((l) => la(l)).forEach((l) => {
        l.style.transitionDuration = `${a}ms`, l.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((u) => {
          u.style.transitionDuration = `${a}ms`;
        });
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0
    })
  });
}
function L5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const s = (o) => typeof o == "string" ? o : `${o}px`;
  vo({
    effect: "creative",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: o,
        wrapperEl: l,
        slidesSizesGrid: u
      } = e, d = e.params.creativeEffect, {
        progressMultiplier: c
      } = d, A = e.params.centeredSlides, m = Gd(e);
      if (A) {
        const p = u[0] / 2 - e.params.slidesOffsetBefore || 0;
        l.style.transform = `translateX(calc(50% - ${p}px))`;
      }
      for (let p = 0; p < o.length; p += 1) {
        const h = o[p], g = h.progress, w = Math.min(Math.max(h.progress, -d.limitProgress), d.limitProgress);
        let b = w;
        A || (b = Math.min(Math.max(h.originalProgress, -d.limitProgress), d.limitProgress));
        const y = h.swiperSlideOffset, D = [e.params.cssMode ? -y - e.translate : -y, 0, 0], I = [0, 0, 0];
        let M = !1;
        e.isHorizontal() || (D[1] = D[0], D[0] = 0);
        let _ = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1
        };
        w < 0 ? (_ = d.next, M = !0) : w > 0 && (_ = d.prev, M = !0), D.forEach((O, X) => {
          D[X] = `calc(${O}px + (${s(_.translate[X])} * ${Math.abs(w * c)}))`;
        }), I.forEach((O, X) => {
          let q = _.rotate[X] * Math.abs(w * c);
          I[X] = q;
        }), h.style.zIndex = -Math.abs(Math.round(g)) + o.length;
        const N = D.join(", "), x = `rotateX(${m(I[0])}deg) rotateY(${m(I[1])}deg) rotateZ(${m(I[2])}deg)`, C = b < 0 ? `scale(${1 + (1 - _.scale) * b * c})` : `scale(${1 - (1 - _.scale) * b * c})`, L = b < 0 ? 1 + (1 - _.opacity) * b * c : 1 - (1 - _.opacity) * b * c, V = `translate3d(${N}) ${x} ${C}`;
        if (M && _.shadow || !M) {
          let O = h.querySelector(".swiper-slide-shadow");
          if (!O && _.shadow && (O = to("creative", h)), O) {
            const X = d.shadowPerProgress ? w * (1 / d.limitProgress) : w;
            O.style.opacity = Math.min(Math.max(Math.abs(X), 0), 1);
          }
        }
        const H = Hl(d, h);
        H.style.transform = V, H.style.opacity = L, _.origin && (H.style.transformOrigin = _.origin);
      }
    },
    setTransition: (o) => {
      const l = e.slides.map((u) => la(u));
      l.forEach((u) => {
        u.style.transitionDuration = `${o}ms`, u.querySelectorAll(".swiper-slide-shadow").forEach((d) => {
          d.style.transitionDuration = `${o}ms`;
        });
      }), Qd({
        swiper: e,
        duration: o,
        transformElements: l,
        allSlides: !0
      });
    },
    perspective: () => e.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function N5(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n
  } = t;
  i({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  }), vo({
    effect: "cards",
    swiper: e,
    on: n,
    setTranslate: () => {
      const {
        slides: a,
        activeIndex: o,
        rtlTranslate: l
      } = e, u = e.params.cardsEffect, {
        startTranslate: d,
        isTouched: c
      } = e.touchEventsData, A = l ? -e.translate : e.translate;
      for (let m = 0; m < a.length; m += 1) {
        const p = a[m], h = p.progress, g = Math.min(Math.max(h, -4), 4);
        let w = p.swiperSlideOffset;
        e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (w -= a[0].swiperSlideOffset);
        let b = e.params.cssMode ? -w - e.translate : -w, y = 0;
        const D = -100 * Math.abs(g);
        let I = 1, M = -u.perSlideRotate * g, _ = u.perSlideOffset - Math.abs(g) * 0.75;
        const N = e.virtual && e.params.virtual.enabled ? e.virtual.from + m : m, x = (N === o || N === o - 1) && g > 0 && g < 1 && (c || e.params.cssMode) && A < d, C = (N === o || N === o + 1) && g < 0 && g > -1 && (c || e.params.cssMode) && A > d;
        if (x || C) {
          const O = (1 - Math.abs((Math.abs(g) - 0.5) / 0.5)) ** 0.5;
          M += -28 * g * O, I += -0.5 * O, _ += 96 * O, y = `${-25 * O * Math.abs(g)}%`;
        }
        if (g < 0 ? b = `calc(${b}px ${l ? "-" : "+"} (${_ * Math.abs(g)}%))` : g > 0 ? b = `calc(${b}px ${l ? "-" : "+"} (-${_ * Math.abs(g)}%))` : b = `${b}px`, !e.isHorizontal()) {
          const O = y;
          y = b, b = O;
        }
        const L = g < 0 ? `${1 + (1 - I) * g}` : `${1 - (1 - I) * g}`, V = `
        translate3d(${b}, ${y}, ${D}px)
        rotateZ(${u.rotate ? l ? -M : M : 0}deg)
        scale(${L})
      `;
        if (u.slideShadows) {
          let O = p.querySelector(".swiper-slide-shadow");
          O || (O = to("cards", p)), O && (O.style.opacity = Math.min(Math.max((Math.abs(g) - 0.5) / 0.5, 0), 1));
        }
        p.style.zIndex = -Math.abs(Math.round(h)) + a.length;
        const H = Hl(u, p);
        H.style.transform = V;
      }
    },
    setTransition: (a) => {
      const o = e.slides.map((l) => la(l));
      o.forEach((l) => {
        l.style.transitionDuration = `${a}ms`, l.querySelectorAll(".swiper-slide-shadow").forEach((u) => {
          u.style.transitionDuration = `${a}ms`;
        });
      }), Qd({
        swiper: e,
        duration: a,
        transformElements: o
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      _loopSwapReset: !1,
      watchSlidesProgress: !0,
      loopAdditionalSlides: e.params.cardsEffect.rotate ? 3 : 2,
      centeredSlides: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
const R5 = [u5, d5, c5, f5, h5, p5, m5, A5, g5, v5, y5, b5, w5, T5, x5, S5, P5, I5, M5, O5, B5, L5, N5];
An.use(R5);
const Zd = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function io(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object" && !t.__swiper__;
}
function bh(t, e) {
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => i.indexOf(n) < 0).forEach((n) => {
    typeof t[n] > "u" ? t[n] = e[n] : io(e[n]) && io(t[n]) && Object.keys(e[n]).length > 0 ? e[n].__swiper__ ? t[n] = e[n] : bh(t[n], e[n]) : t[n] = e[n];
  });
}
function F5(t) {
  return t === void 0 && (t = {}), t.navigation && typeof t.navigation.nextEl > "u" && typeof t.navigation.prevEl > "u";
}
function z5(t) {
  return t === void 0 && (t = {}), t.pagination && typeof t.pagination.el > "u";
}
function U5(t) {
  return t === void 0 && (t = {}), t.scrollbar && typeof t.scrollbar.el > "u";
}
function Vu(t) {
  return t === void 0 && (t = ""), t.replace(/-[a-z]/g, (e) => e.toUpperCase().replace("-", ""));
}
function V5(t) {
  let {
    swiper: e,
    slides: i,
    passedParams: n,
    changedParams: s,
    nextEl: r,
    prevEl: a,
    scrollbarEl: o,
    paginationEl: l
  } = t;
  const u = s.filter((x) => x !== "children" && x !== "direction" && x !== "wrapperClass"), {
    params: d,
    pagination: c,
    navigation: A,
    scrollbar: m,
    virtual: p,
    thumbs: h
  } = e;
  let g, w, b, y, D, I, M, _;
  s.includes("thumbs") && n.thumbs && n.thumbs.swiper && !n.thumbs.swiper.destroyed && d.thumbs && (!d.thumbs.swiper || d.thumbs.swiper.destroyed) && (g = !0), s.includes("controller") && n.controller && n.controller.control && d.controller && !d.controller.control && (w = !0), s.includes("pagination") && n.pagination && (n.pagination.el || l) && (d.pagination || d.pagination === !1) && c && !c.el && (b = !0), s.includes("scrollbar") && n.scrollbar && (n.scrollbar.el || o) && (d.scrollbar || d.scrollbar === !1) && m && !m.el && (y = !0), s.includes("navigation") && n.navigation && (n.navigation.prevEl || a) && (n.navigation.nextEl || r) && (d.navigation || d.navigation === !1) && A && !A.prevEl && !A.nextEl && (D = !0);
  const N = (x) => {
    e[x] && (e[x].destroy(), x === "navigation" ? (e.isElement && (e[x].prevEl.remove(), e[x].nextEl.remove()), d[x].prevEl = void 0, d[x].nextEl = void 0, e[x].prevEl = void 0, e[x].nextEl = void 0) : (e.isElement && e[x].el.remove(), d[x].el = void 0, e[x].el = void 0));
  };
  s.includes("loop") && e.isElement && (d.loop && !n.loop ? I = !0 : !d.loop && n.loop ? M = !0 : _ = !0), u.forEach((x) => {
    if (io(d[x]) && io(n[x]))
      Object.assign(d[x], n[x]), (x === "navigation" || x === "pagination" || x === "scrollbar") && "enabled" in n[x] && !n[x].enabled && N(x);
    else {
      const C = n[x];
      (C === !0 || C === !1) && (x === "navigation" || x === "pagination" || x === "scrollbar") ? C === !1 && N(x) : d[x] = n[x];
    }
  }), u.includes("controller") && !w && e.controller && e.controller.control && d.controller && d.controller.control && (e.controller.control = d.controller.control), s.includes("children") && i && p && d.virtual.enabled ? (p.slides = i, p.update(!0)) : s.includes("virtual") && p && d.virtual.enabled && (i && (p.slides = i), p.update(!0)), s.includes("children") && i && d.loop && (_ = !0), g && h.init() && h.update(!0), w && (e.controller.control = d.controller.control), b && (e.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-pagination"), l.part.add("pagination"), e.el.appendChild(l)), l && (d.pagination.el = l), c.init(), c.render(), c.update()), y && (e.isElement && (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-scrollbar"), o.part.add("scrollbar"), e.el.appendChild(o)), o && (d.scrollbar.el = o), m.init(), m.updateSize(), m.setTranslate()), D && (e.isElement && ((!r || typeof r == "string") && (r = document.createElement("div"), r.classList.add("swiper-button-next"), r.innerHTML = e.hostEl.constructor.nextButtonSvg, r.part.add("button-next"), e.el.appendChild(r)), (!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-button-prev"), a.innerHTML = e.hostEl.constructor.prevButtonSvg, a.part.add("button-prev"), e.el.appendChild(a))), r && (d.navigation.nextEl = r), a && (d.navigation.prevEl = a), A.init(), A.update()), s.includes("allowSlideNext") && (e.allowSlideNext = n.allowSlideNext), s.includes("allowSlidePrev") && (e.allowSlidePrev = n.allowSlidePrev), s.includes("direction") && e.changeDirection(n.direction, !1), (I || _) && e.loopDestroy(), (M || _) && e.loopCreate(), e.update();
}
const bg = (t) => {
  if (parseFloat(t) === Number(t)) return Number(t);
  if (t === "true" || t === "") return !0;
  if (t === "false") return !1;
  if (t === "null") return null;
  if (t !== "undefined") {
    if (typeof t == "string" && t.includes("{") && t.includes("}") && t.includes('"')) {
      let e;
      try {
        e = JSON.parse(t);
      } catch {
        e = t;
      }
      return e;
    }
    return t;
  }
}, wg = ["a11y", "autoplay", "controller", "cards-effect", "coverflow-effect", "creative-effect", "cube-effect", "fade-effect", "flip-effect", "free-mode", "grid", "hash-navigation", "history", "keyboard", "mousewheel", "navigation", "pagination", "parallax", "scrollbar", "thumbs", "virtual", "zoom"];
function Tg(t, e, i) {
  const n = {}, s = {};
  bh(n, yh);
  const r = [...Zd, "on"], a = r.map((l) => l.replace(/_/, ""));
  r.forEach((l) => {
    l = l.replace("_", ""), typeof t[l] < "u" && (s[l] = t[l]);
  });
  const o = [...t.attributes];
  return typeof e == "string" && typeof i < "u" && o.push({
    name: e,
    value: io(i) ? {
      ...i
    } : i
  }), o.forEach((l) => {
    const u = wg.find((d) => l.name.startsWith(`${d}-`));
    if (u) {
      const d = Vu(u), c = Vu(l.name.split(`${u}-`)[1]);
      typeof s[d] > "u" && (s[d] = {}), s[d] === !0 && (s[d] = {
        enabled: !0
      }), s[d][c] = bg(l.value);
    } else {
      const d = Vu(l.name);
      if (!a.includes(d)) return;
      const c = bg(l.value);
      s[d] && wg.includes(l.name) && !io(c) ? (s[d].constructor !== Object && (s[d] = {}), s[d].enabled = !!c) : s[d] = c;
    }
  }), bh(n, s), n.navigation ? n.navigation = {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
    ...n.navigation !== !0 ? n.navigation : {}
  } : n.navigation === !1 && delete n.navigation, n.scrollbar ? n.scrollbar = {
    el: ".swiper-scrollbar",
    ...n.scrollbar !== !0 ? n.scrollbar : {}
  } : n.scrollbar === !1 && delete n.scrollbar, n.pagination ? n.pagination = {
    el: ".swiper-pagination",
    ...n.pagination !== !0 ? n.pagination : {}
  } : n.pagination === !1 && delete n.pagination, {
    params: n,
    passedParams: s
  };
}
const q5 = ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}", H5 = "::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}";
class W5 {
}
const Qy = typeof window > "u" || typeof HTMLElement > "u" ? W5 : HTMLElement, xg = `<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
    `, Zy = (t, e) => {
  if (typeof CSSStyleSheet < "u" && t.adoptedStyleSheets) {
    const i = new CSSStyleSheet();
    i.replaceSync(e), t.adoptedStyleSheets = [i];
  } else {
    const i = document.createElement("style");
    i.rel = "stylesheet", i.textContent = e, t.appendChild(i);
  }
};
class Ky extends Qy {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  static get nextButtonSvg() {
    return xg;
  }
  static get prevButtonSvg() {
    return xg.replace("/></svg>", ' transform-origin="center" transform="rotate(180)"/></svg>');
  }
  cssStyles() {
    return [
      q5,
      // eslint-disable-line
      ...this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : []
    ].join(`
`);
  }
  cssLinks() {
    return this.injectStylesUrls || [];
  }
  calcSlideSlots() {
    const e = this.slideSlots || 0, i = [...this.querySelectorAll("[slot^=slide-]")].map((n) => parseInt(n.getAttribute("slot").split("slide-")[1], 10));
    if (this.slideSlots = i.length ? Math.max(...i) + 1 : 0, !!this.rendered) {
      if (this.slideSlots > e)
        for (let n = e; n < this.slideSlots; n += 1) {
          const s = document.createElement("swiper-slide");
          s.setAttribute("part", `slide slide-${n + 1}`);
          const r = document.createElement("slot");
          r.setAttribute("name", `slide-${n + 1}`), s.appendChild(r), this.shadowRoot.querySelector(".swiper-wrapper").appendChild(s);
        }
      else if (this.slideSlots < e) {
        const n = this.swiper.slides;
        for (let s = n.length - 1; s >= 0; s -= 1)
          s > this.slideSlots && n[s].remove();
      }
    }
  }
  render() {
    if (this.rendered) return;
    this.calcSlideSlots();
    let e = this.cssStyles();
    this.slideSlots > 0 && (e = e.replace(/::slotted\(([a-z-0-9.]*)\)/g, "$1")), e.length && Zy(this.shadowRoot, e), this.cssLinks().forEach((n) => {
      if (this.shadowRoot.querySelector(`link[href="${n}"]`)) return;
      const r = document.createElement("link");
      r.rel = "stylesheet", r.href = n, this.shadowRoot.appendChild(r);
    });
    const i = document.createElement("div");
    i.classList.add("swiper"), i.part = "container", i.innerHTML = `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper" part="wrapper">
        <slot></slot>
        ${Array.from({
      length: this.slideSlots
    }).map((n, s) => `
        <swiper-slide part="slide slide-${s}">
          <slot name="slide-${s}"></slot>
        </swiper-slide>
        `).join("")}
      </div>
      <slot name="container-end"></slot>
      ${F5(this.passedParams) ? `
        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>
        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>
      ` : ""}
      ${z5(this.passedParams) ? `
        <div part="pagination" class="swiper-pagination"></div>
      ` : ""}
      ${U5(this.passedParams) ? `
        <div part="scrollbar" class="swiper-scrollbar"></div>
      ` : ""}
    `, this.shadowRoot.appendChild(i), this.rendered = !0;
  }
  initialize() {
    var e = this;
    if (this.swiper && this.swiper.initialized) return;
    const {
      params: i,
      passedParams: n
    } = Tg(this);
    this.swiperParams = i, this.passedParams = n, delete this.swiperParams.init, this.render(), this.swiper = new An(this.shadowRoot.querySelector(".swiper"), {
      ...i.virtual ? {} : {
        observer: !0
      },
      ...i,
      touchEventsTarget: "container",
      onAny: function(s) {
        s === "observerUpdate" && e.calcSlideSlots();
        const r = i.eventsPrefix ? `${i.eventsPrefix}${s.toLowerCase()}` : s.toLowerCase();
        for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++)
          o[l - 1] = arguments[l];
        const u = new CustomEvent(r, {
          detail: o,
          bubbles: s !== "hashChange",
          cancelable: !0
        });
        e.dispatchEvent(u);
      }
    });
  }
  connectedCallback() {
    this.swiper && this.swiper.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.init === !1 || this.getAttribute("init") === "false" || this.initialize();
  }
  disconnectedCallback() {
    this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.swiper && this.swiper.destroy && this.swiper.destroy();
  }
  updateSwiperOnPropChange(e, i) {
    const {
      params: n,
      passedParams: s
    } = Tg(this, e, i);
    this.passedParams = s, this.swiperParams = n, !(this.swiper && this.swiper.params[e] === i) && V5({
      swiper: this.swiper,
      passedParams: this.passedParams,
      changedParams: [Vu(e)],
      ...e === "navigation" && s[e] ? {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next"
      } : {},
      ...e === "pagination" && s[e] ? {
        paginationEl: ".swiper-pagination"
      } : {},
      ...e === "scrollbar" && s[e] ? {
        scrollbarEl: ".swiper-scrollbar"
      } : {}
    });
  }
  attributeChangedCallback(e, i, n) {
    this.swiper && this.swiper.initialized && (i === "true" && n === null && (n = !1), this.updateSwiperOnPropChange(e, n));
  }
  static get observedAttributes() {
    return Zd.filter((i) => i.includes("_")).map((i) => i.replace(/[A-Z]/g, (n) => `-${n}`).replace("_", "").toLowerCase());
  }
}
Zd.forEach((t) => {
  t !== "init" && (t = t.replace("_", ""), Object.defineProperty(Ky.prototype, t, {
    configurable: !0,
    get() {
      return (this.passedParams || {})[t];
    },
    set(e) {
      this.passedParams || (this.passedParams = {}), this.passedParams[t] = e, this.swiper && this.swiper.initialized && this.updateSwiperOnPropChange(t, e);
    }
  }));
});
class Y5 extends Qy {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  render() {
    const e = this.lazy || this.getAttribute("lazy") === "" || this.getAttribute("lazy") === "true";
    if (Zy(this.shadowRoot, H5), this.shadowRoot.appendChild(document.createElement("slot")), e) {
      const i = document.createElement("div");
      i.classList.add("swiper-lazy-preloader"), i.part.add("preloader"), this.shadowRoot.appendChild(i);
    }
  }
  initialize() {
    this.render();
  }
  connectedCallback() {
    this.swiperLoopMoveDOM || this.initialize();
  }
}
const Jy = () => {
  typeof window > "u" || (window.customElements.get("swiper-container") || window.customElements.define("swiper-container", Ky), window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", Y5));
};
typeof window < "u" && (window.SwiperElementRegisterParams = (t) => {
  Zd.push(...t);
});
const $y = (t) => t.type === "image", Np = (t) => t.type === "iframe", Rp = (t) => t.type === "video", Fp = (t) => Rp(t) || Np(t), X5 = (t) => Fp(t) && !t.preview;
var dd = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Wl(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function j5(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var i = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    i.prototype = e.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(i, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), i;
}
var yf, Sg;
function Kd() {
  if (Sg) return yf;
  Sg = 1;
  var t;
  return typeof window < "u" ? t = window : typeof dd < "u" ? t = dd : typeof self < "u" ? t = self : t = {}, yf = t, yf;
}
var G5 = Kd();
const ne = /* @__PURE__ */ Wl(G5), Q5 = {}, Z5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Q5
}, Symbol.toStringTag, { value: "Module" })), K5 = /* @__PURE__ */ j5(Z5);
var bf, Cg;
function eb() {
  if (Cg) return bf;
  Cg = 1;
  var t = typeof dd < "u" ? dd : typeof window < "u" ? window : {}, e = K5, i;
  return typeof document < "u" ? i = document : (i = t["__GLOBAL_DOCUMENT_CACHE@4"], i || (i = t["__GLOBAL_DOCUMENT_CACHE@4"] = e)), bf = i, bf;
}
var J5 = eb();
const Ne = /* @__PURE__ */ Wl(J5);
var _u = { exports: {} }, wf = { exports: {} }, Eg;
function $5() {
  return Eg || (Eg = 1, function(t) {
    function e() {
      return t.exports = e = Object.assign ? Object.assign.bind() : function(i) {
        for (var n = 1; n < arguments.length; n++) {
          var s = arguments[n];
          for (var r in s) ({}).hasOwnProperty.call(s, r) && (i[r] = s[r]);
        }
        return i;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e.apply(null, arguments);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(wf)), wf.exports;
}
var Tf, Dg;
function e6() {
  if (Dg) return Tf;
  Dg = 1, Tf = e;
  var t = Object.prototype.toString;
  function e(i) {
    if (!i)
      return !1;
    var n = t.call(i);
    return n === "[object Function]" || typeof i == "function" && n !== "[object RegExp]" || typeof window < "u" && // IE8 and below
    (i === window.setTimeout || i === window.alert || i === window.confirm || i === window.prompt);
  }
  return Tf;
}
var xf, _g;
function t6() {
  if (_g) return xf;
  _g = 1;
  function t(s, r) {
    var a = typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
    if (a) return (a = a.call(s)).next.bind(a);
    if (Array.isArray(s) || (a = e(s)) || r) {
      a && (s = a);
      var o = 0;
      return function() {
        return o >= s.length ? { done: !0 } : { done: !1, value: s[o++] };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function e(s, r) {
    if (s) {
      if (typeof s == "string") return i(s, r);
      var a = Object.prototype.toString.call(s).slice(8, -1);
      if (a === "Object" && s.constructor && (a = s.constructor.name), a === "Map" || a === "Set") return Array.from(s);
      if (a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return i(s, r);
    }
  }
  function i(s, r) {
    (r == null || r > s.length) && (r = s.length);
    for (var a = 0, o = new Array(r); a < r; a++)
      o[a] = s[a];
    return o;
  }
  var n = /* @__PURE__ */ function() {
    function s() {
      this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
    }
    var r = s.prototype;
    return r.getIsEnabled = function() {
      return this.enabled_;
    }, r.enable = function() {
      this.enabled_ = !0;
    }, r.disable = function() {
      this.enabled_ = !1;
    }, r.reset = function() {
      this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
    }, r.addInterceptor = function(o, l) {
      this.typeToInterceptorsMap_.has(o) || this.typeToInterceptorsMap_.set(o, /* @__PURE__ */ new Set());
      var u = this.typeToInterceptorsMap_.get(o);
      return u.has(l) ? !1 : (u.add(l), !0);
    }, r.removeInterceptor = function(o, l) {
      var u = this.typeToInterceptorsMap_.get(o);
      return u && u.has(l) ? (u.delete(l), !0) : !1;
    }, r.clearInterceptorsByType = function(o) {
      var l = this.typeToInterceptorsMap_.get(o);
      return l ? (this.typeToInterceptorsMap_.delete(o), this.typeToInterceptorsMap_.set(o, /* @__PURE__ */ new Set()), !0) : !1;
    }, r.clear = function() {
      return this.typeToInterceptorsMap_.size ? (this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), !0) : !1;
    }, r.getForType = function(o) {
      return this.typeToInterceptorsMap_.get(o) || /* @__PURE__ */ new Set();
    }, r.execute = function(o, l) {
      for (var u = this.getForType(o), d = t(u), c; !(c = d()).done; ) {
        var A = c.value;
        try {
          l = A(l);
        } catch {
        }
      }
      return l;
    }, s;
  }();
  return xf = n, xf;
}
var Sf, kg;
function i6() {
  if (kg) return Sf;
  kg = 1;
  var t = /* @__PURE__ */ function() {
    function i() {
      this.maxAttempts_ = 1, this.delayFactor_ = 0.1, this.fuzzFactor_ = 0.1, this.initialDelay_ = 1e3, this.enabled_ = !1;
    }
    var n = i.prototype;
    return n.getIsEnabled = function() {
      return this.enabled_;
    }, n.enable = function() {
      this.enabled_ = !0;
    }, n.disable = function() {
      this.enabled_ = !1;
    }, n.reset = function() {
      this.maxAttempts_ = 1, this.delayFactor_ = 0.1, this.fuzzFactor_ = 0.1, this.initialDelay_ = 1e3, this.enabled_ = !1;
    }, n.getMaxAttempts = function() {
      return this.maxAttempts_;
    }, n.setMaxAttempts = function(r) {
      this.maxAttempts_ = r;
    }, n.getDelayFactor = function() {
      return this.delayFactor_;
    }, n.setDelayFactor = function(r) {
      this.delayFactor_ = r;
    }, n.getFuzzFactor = function() {
      return this.fuzzFactor_;
    }, n.setFuzzFactor = function(r) {
      this.fuzzFactor_ = r;
    }, n.getInitialDelay = function() {
      return this.initialDelay_;
    }, n.setInitialDelay = function(r) {
      this.initialDelay_ = r;
    }, n.createRetry = function(r) {
      var a = r === void 0 ? {} : r, o = a.maxAttempts, l = a.delayFactor, u = a.fuzzFactor, d = a.initialDelay;
      return new e({
        maxAttempts: o || this.maxAttempts_,
        delayFactor: l || this.delayFactor_,
        fuzzFactor: u || this.fuzzFactor_,
        initialDelay: d || this.initialDelay_
      });
    }, i;
  }(), e = /* @__PURE__ */ function() {
    function i(s) {
      this.maxAttempts_ = s.maxAttempts, this.delayFactor_ = s.delayFactor, this.fuzzFactor_ = s.fuzzFactor, this.currentDelay_ = s.initialDelay, this.currentAttempt_ = 1;
    }
    var n = i.prototype;
    return n.moveToNextAttempt = function() {
      this.currentAttempt_++;
      var r = this.currentDelay_ * this.delayFactor_;
      this.currentDelay_ = this.currentDelay_ + r;
    }, n.shouldRetry = function() {
      return this.currentAttempt_ < this.maxAttempts_;
    }, n.getCurrentDelay = function() {
      return this.currentDelay_;
    }, n.getCurrentMinPossibleDelay = function() {
      return (1 - this.fuzzFactor_) * this.currentDelay_;
    }, n.getCurrentMaxPossibleDelay = function() {
      return (1 + this.fuzzFactor_) * this.currentDelay_;
    }, n.getCurrentFuzzedDelay = function() {
      var r = this.getCurrentMinPossibleDelay(), a = this.getCurrentMaxPossibleDelay();
      return r + Math.random() * (a - r);
    }, i;
  }();
  return Sf = t, Sf;
}
var Cf, Pg;
function n6() {
  if (Pg) return Cf;
  Pg = 1;
  var t = Kd(), e = function(s, r) {
    return r === void 0 && (r = !1), function(a, o, l) {
      if (a) {
        s(a);
        return;
      }
      if (o.statusCode >= 400 && o.statusCode <= 599) {
        var u = l;
        if (r)
          if (t.TextDecoder) {
            var d = i(o.headers && o.headers["content-type"]);
            try {
              u = new TextDecoder(d).decode(l);
            } catch {
            }
          } else
            u = String.fromCharCode.apply(null, new Uint8Array(l));
        s({
          cause: u
        });
        return;
      }
      s(null, l);
    };
  };
  function i(n) {
    return n === void 0 && (n = ""), n.toLowerCase().split(";").reduce(function(s, r) {
      var a = r.split("="), o = a[0], l = a[1];
      return o.trim() === "charset" ? l.trim() : s;
    }, "utf-8");
  }
  return Cf = e, Cf;
}
var Ig;
function s6() {
  if (Ig) return _u.exports;
  Ig = 1;
  var t = Kd(), e = $5(), i = e6(), n = t6(), s = i6();
  u.httpHandler = n6(), u.requestInterceptorsStorage = new n(), u.responseInterceptorsStorage = new n(), u.retryManager = new s();
  /**
   * @license
   * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
   * Copyright (c) 2014 David Björklund
   * Available under the MIT license
   * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
   */
  var r = function(p) {
    var h = {};
    return p && p.trim().split(`
`).forEach(function(g) {
      var w = g.indexOf(":"), b = g.slice(0, w).trim().toLowerCase(), y = g.slice(w + 1).trim();
      typeof h[b] > "u" ? h[b] = y : Array.isArray(h[b]) ? h[b].push(y) : h[b] = [h[b], y];
    }), h;
  };
  _u.exports = u, _u.exports.default = u, u.XMLHttpRequest = t.XMLHttpRequest || A, u.XDomainRequest = "withCredentials" in new u.XMLHttpRequest() ? u.XMLHttpRequest : t.XDomainRequest, a(["get", "put", "post", "patch", "head", "delete"], function(m) {
    u[m === "delete" ? "del" : m] = function(p, h, g) {
      return h = l(p, h, g), h.method = m.toUpperCase(), d(h);
    };
  });
  function a(m, p) {
    for (var h = 0; h < m.length; h++)
      p(m[h]);
  }
  function o(m) {
    for (var p in m)
      if (m.hasOwnProperty(p)) return !1;
    return !0;
  }
  function l(m, p, h) {
    var g = m;
    return i(p) ? (h = p, typeof m == "string" && (g = {
      uri: m
    })) : g = e({}, p, {
      uri: m
    }), g.callback = h, g;
  }
  function u(m, p, h) {
    return p = l(m, p, h), d(p);
  }
  function d(m) {
    if (typeof m.callback > "u")
      throw new Error("callback argument missing");
    if (m.requestType && u.requestInterceptorsStorage.getIsEnabled()) {
      var p = {
        uri: m.uri || m.url,
        headers: m.headers || {},
        body: m.body,
        metadata: m.metadata || {},
        retry: m.retry,
        timeout: m.timeout
      }, h = u.requestInterceptorsStorage.execute(m.requestType, p);
      m.uri = h.uri, m.headers = h.headers, m.body = h.body, m.metadata = h.metadata, m.retry = h.retry, m.timeout = h.timeout;
    }
    var g = !1, w = function(W, j, oe) {
      g || (g = !0, m.callback(W, j, oe));
    };
    function b() {
      M.readyState === 4 && !u.responseInterceptorsStorage.getIsEnabled() && setTimeout(I, 0);
    }
    function y() {
      var F = void 0;
      if (M.response ? F = M.response : F = M.responseText || c(M), O)
        try {
          F = JSON.parse(F);
        } catch {
        }
      return F;
    }
    function D(F) {
      if (clearTimeout(X), clearTimeout(m.retryTimeout), F instanceof Error || (F = new Error("" + (F || "Unknown XMLHttpRequest Error"))), F.statusCode = 0, !N && u.retryManager.getIsEnabled() && m.retry && m.retry.shouldRetry()) {
        m.retryTimeout = setTimeout(function() {
          m.retry.moveToNextAttempt(), m.xhr = M, d(m);
        }, m.retry.getCurrentFuzzedDelay());
        return;
      }
      if (m.requestType && u.responseInterceptorsStorage.getIsEnabled()) {
        var W = {
          headers: q.headers || {},
          body: q.body,
          responseUrl: M.responseURL,
          responseType: M.responseType
        }, j = u.responseInterceptorsStorage.execute(m.requestType, W);
        q.body = j.body, q.headers = j.headers;
      }
      return w(F, q);
    }
    function I() {
      if (!N) {
        var F;
        clearTimeout(X), clearTimeout(m.retryTimeout), m.useXDR && M.status === void 0 ? F = 200 : F = M.status === 1223 ? 204 : M.status;
        var W = q, j = null;
        if (F !== 0 ? (W = {
          body: y(),
          statusCode: F,
          method: C,
          headers: {},
          url: x,
          rawRequest: M
        }, M.getAllResponseHeaders && (W.headers = r(M.getAllResponseHeaders()))) : j = new Error("Internal XMLHttpRequest Error"), m.requestType && u.responseInterceptorsStorage.getIsEnabled()) {
          var oe = {
            headers: W.headers || {},
            body: W.body,
            responseUrl: M.responseURL,
            responseType: M.responseType
          }, $ = u.responseInterceptorsStorage.execute(m.requestType, oe);
          W.body = $.body, W.headers = $.headers;
        }
        return w(j, W, W.body);
      }
    }
    var M = m.xhr || null;
    M || (m.cors || m.useXDR ? M = new u.XDomainRequest() : M = new u.XMLHttpRequest());
    var _, N, x = M.url = m.uri || m.url, C = M.method = m.method || "GET", L = m.body || m.data, V = M.headers = m.headers || {}, H = !!m.sync, O = !1, X, q = {
      body: void 0,
      headers: {},
      statusCode: 0,
      method: C,
      url: x,
      rawRequest: M
    };
    if ("json" in m && m.json !== !1 && (O = !0, V.accept || V.Accept || (V.Accept = "application/json"), C !== "GET" && C !== "HEAD" && (V["content-type"] || V["Content-Type"] || (V["Content-Type"] = "application/json"), L = JSON.stringify(m.json === !0 ? L : m.json))), M.onreadystatechange = b, M.onload = I, M.onerror = D, M.onprogress = function() {
    }, M.onabort = function() {
      N = !0, clearTimeout(m.retryTimeout);
    }, M.ontimeout = D, M.open(C, x, !H, m.username, m.password), H || (M.withCredentials = !!m.withCredentials), !H && m.timeout > 0 && (X = setTimeout(function() {
      if (!N) {
        N = !0, M.abort("timeout");
        var F = new Error("XMLHttpRequest timeout");
        F.code = "ETIMEDOUT", D(F);
      }
    }, m.timeout)), M.setRequestHeader)
      for (_ in V)
        V.hasOwnProperty(_) && M.setRequestHeader(_, V[_]);
    else if (m.headers && !o(m.headers))
      throw new Error("Headers cannot be set on an XDomainRequest object");
    return "responseType" in m && (M.responseType = m.responseType), "beforeSend" in m && typeof m.beforeSend == "function" && m.beforeSend(M), M.send(L || null), M;
  }
  function c(m) {
    try {
      if (m.responseType === "document")
        return m.responseXML;
      var p = m.responseXML && m.responseXML.documentElement.nodeName === "parsererror";
      if (m.responseType === "" && !p)
        return m.responseXML;
    } catch {
    }
    return null;
  }
  function A() {
  }
  return _u.exports;
}
var r6 = s6();
const tb = /* @__PURE__ */ Wl(r6);
var Ef = { exports: {} }, Df, Mg;
function a6() {
  if (Mg) return Df;
  Mg = 1;
  var t = eb(), e = Object.create || /* @__PURE__ */ function() {
    function x() {
    }
    return function(C) {
      if (arguments.length !== 1)
        throw new Error("Object.create shim only accepts one parameter.");
      return x.prototype = C, new x();
    };
  }();
  function i(x, C) {
    this.name = "ParsingError", this.code = x.code, this.message = C || x.message;
  }
  i.prototype = e(Error.prototype), i.prototype.constructor = i, i.Errors = {
    BadSignature: {
      code: 0,
      message: "Malformed WebVTT signature."
    },
    BadTimeStamp: {
      code: 1,
      message: "Malformed time stamp."
    }
  };
  function n(x) {
    function C(V, H, O, X) {
      return (V | 0) * 3600 + (H | 0) * 60 + (O | 0) + (X | 0) / 1e3;
    }
    var L = x.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
    return L ? L[3] ? C(L[1], L[2], L[3].replace(":", ""), L[4]) : L[1] > 59 ? C(L[1], L[2], 0, L[4]) : C(0, L[1], L[2], L[4]) : null;
  }
  function s() {
    this.values = e(null);
  }
  s.prototype = {
    // Only accept the first assignment to any key.
    set: function(x, C) {
      !this.get(x) && C !== "" && (this.values[x] = C);
    },
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get: function(x, C, L) {
      return L ? this.has(x) ? this.values[x] : C[L] : this.has(x) ? this.values[x] : C;
    },
    // Check whether we have a value for a key.
    has: function(x) {
      return x in this.values;
    },
    // Accept a setting if its one of the given alternatives.
    alt: function(x, C, L) {
      for (var V = 0; V < L.length; ++V)
        if (C === L[V]) {
          this.set(x, C);
          break;
        }
    },
    // Accept a setting if its a valid (signed) integer.
    integer: function(x, C) {
      /^-?\d+$/.test(C) && this.set(x, parseInt(C, 10));
    },
    // Accept a setting if its a valid percentage.
    percent: function(x, C) {
      return C.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (C = parseFloat(C), C >= 0 && C <= 100) ? (this.set(x, C), !0) : !1;
    }
  };
  function r(x, C, L, V) {
    var H = V ? x.split(V) : [x];
    for (var O in H)
      if (typeof H[O] == "string") {
        var X = H[O].split(L);
        if (X.length === 2) {
          var q = X[0].trim(), F = X[1].trim();
          C(q, F);
        }
      }
  }
  function a(x, C, L) {
    var V = x;
    function H() {
      var q = n(x);
      if (q === null)
        throw new i(
          i.Errors.BadTimeStamp,
          "Malformed timestamp: " + V
        );
      return x = x.replace(/^[^\sa-zA-Z-]+/, ""), q;
    }
    function O(q, F) {
      var W = new s();
      r(q, function(j, oe) {
        switch (j) {
          case "region":
            for (var $ = L.length - 1; $ >= 0; $--)
              if (L[$].id === oe) {
                W.set(j, L[$].region);
                break;
              }
            break;
          case "vertical":
            W.alt(j, oe, ["rl", "lr"]);
            break;
          case "line":
            var ye = oe.split(","), ae = ye[0];
            W.integer(j, ae), W.percent(j, ae) && W.set("snapToLines", !1), W.alt(j, ae, ["auto"]), ye.length === 2 && W.alt("lineAlign", ye[1], ["start", "center", "end"]);
            break;
          case "position":
            ye = oe.split(","), W.percent(j, ye[0]), ye.length === 2 && W.alt("positionAlign", ye[1], ["start", "center", "end"]);
            break;
          case "size":
            W.percent(j, oe);
            break;
          case "align":
            W.alt(j, oe, ["start", "center", "end", "left", "right"]);
            break;
        }
      }, /:/, /\s/), F.region = W.get("region", null), F.vertical = W.get("vertical", "");
      try {
        F.line = W.get("line", "auto");
      } catch {
      }
      F.lineAlign = W.get("lineAlign", "start"), F.snapToLines = W.get("snapToLines", !0), F.size = W.get("size", 100);
      try {
        F.align = W.get("align", "center");
      } catch {
        F.align = W.get("align", "middle");
      }
      try {
        F.position = W.get("position", "auto");
      } catch {
        F.position = W.get("position", {
          start: 0,
          left: 0,
          center: 50,
          middle: 50,
          end: 100,
          right: 100
        }, F.align);
      }
      F.positionAlign = W.get("positionAlign", {
        start: "start",
        left: "start",
        center: "center",
        middle: "center",
        end: "end",
        right: "end"
      }, F.align);
    }
    function X() {
      x = x.replace(/^\s+/, "");
    }
    if (X(), C.startTime = H(), X(), x.substr(0, 3) !== "-->")
      throw new i(
        i.Errors.BadTimeStamp,
        "Malformed time stamp (time stamps must be separated by '-->'): " + V
      );
    x = x.substr(3), X(), C.endTime = H(), X(), O(x, C);
  }
  var o = t.createElement && t.createElement("textarea"), l = {
    c: "span",
    i: "i",
    b: "b",
    u: "u",
    ruby: "ruby",
    rt: "rt",
    v: "span",
    lang: "span"
  }, u = {
    white: "rgba(255,255,255,1)",
    lime: "rgba(0,255,0,1)",
    cyan: "rgba(0,255,255,1)",
    red: "rgba(255,0,0,1)",
    yellow: "rgba(255,255,0,1)",
    magenta: "rgba(255,0,255,1)",
    blue: "rgba(0,0,255,1)",
    black: "rgba(0,0,0,1)"
  }, d = {
    v: "title",
    lang: "lang"
  }, c = {
    rt: "ruby"
  };
  function A(x, C) {
    function L() {
      if (!C)
        return null;
      function ae(te) {
        return C = C.substr(te.length), te;
      }
      var ce = C.match(/^([^<]*)(<[^>]*>?)?/);
      return ae(ce[1] ? ce[1] : ce[2]);
    }
    function V(ae) {
      return o.innerHTML = ae, ae = o.textContent, o.textContent = "", ae;
    }
    function H(ae, ce) {
      return !c[ce.localName] || c[ce.localName] === ae.localName;
    }
    function O(ae, ce) {
      var te = l[ae];
      if (!te)
        return null;
      var le = x.document.createElement(te), B = d[ae];
      return B && ce && (le[B] = ce.trim()), le;
    }
    for (var X = x.document.createElement("div"), q = X, F, W = []; (F = L()) !== null; ) {
      if (F[0] === "<") {
        if (F[1] === "/") {
          W.length && W[W.length - 1] === F.substr(2).replace(">", "") && (W.pop(), q = q.parentNode);
          continue;
        }
        var j = n(F.substr(1, F.length - 2)), oe;
        if (j) {
          oe = x.document.createProcessingInstruction("timestamp", j), q.appendChild(oe);
          continue;
        }
        var $ = F.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
        if (!$ || (oe = O($[1], $[3]), !oe) || !H(q, oe))
          continue;
        if ($[2]) {
          var ye = $[2].split(".");
          ye.forEach(function(ae) {
            var ce = /^bg_/.test(ae), te = ce ? ae.slice(3) : ae;
            if (u.hasOwnProperty(te)) {
              var le = ce ? "background-color" : "color", B = u[te];
              oe.style[le] = B;
            }
          }), oe.className = ye.join(" ");
        }
        W.push($[1]), q.appendChild(oe), q = oe;
        continue;
      }
      q.appendChild(x.document.createTextNode(V(F)));
    }
    return X;
  }
  var m = [
    [1470, 1470],
    [1472, 1472],
    [1475, 1475],
    [1478, 1478],
    [1488, 1514],
    [1520, 1524],
    [1544, 1544],
    [1547, 1547],
    [1549, 1549],
    [1563, 1563],
    [1566, 1610],
    [1645, 1647],
    [1649, 1749],
    [1765, 1766],
    [1774, 1775],
    [1786, 1805],
    [1807, 1808],
    [1810, 1839],
    [1869, 1957],
    [1969, 1969],
    [1984, 2026],
    [2036, 2037],
    [2042, 2042],
    [2048, 2069],
    [2074, 2074],
    [2084, 2084],
    [2088, 2088],
    [2096, 2110],
    [2112, 2136],
    [2142, 2142],
    [2208, 2208],
    [2210, 2220],
    [8207, 8207],
    [64285, 64285],
    [64287, 64296],
    [64298, 64310],
    [64312, 64316],
    [64318, 64318],
    [64320, 64321],
    [64323, 64324],
    [64326, 64449],
    [64467, 64829],
    [64848, 64911],
    [64914, 64967],
    [65008, 65020],
    [65136, 65140],
    [65142, 65276],
    [67584, 67589],
    [67592, 67592],
    [67594, 67637],
    [67639, 67640],
    [67644, 67644],
    [67647, 67669],
    [67671, 67679],
    [67840, 67867],
    [67872, 67897],
    [67903, 67903],
    [67968, 68023],
    [68030, 68031],
    [68096, 68096],
    [68112, 68115],
    [68117, 68119],
    [68121, 68147],
    [68160, 68167],
    [68176, 68184],
    [68192, 68223],
    [68352, 68405],
    [68416, 68437],
    [68440, 68466],
    [68472, 68479],
    [68608, 68680],
    [126464, 126467],
    [126469, 126495],
    [126497, 126498],
    [126500, 126500],
    [126503, 126503],
    [126505, 126514],
    [126516, 126519],
    [126521, 126521],
    [126523, 126523],
    [126530, 126530],
    [126535, 126535],
    [126537, 126537],
    [126539, 126539],
    [126541, 126543],
    [126545, 126546],
    [126548, 126548],
    [126551, 126551],
    [126553, 126553],
    [126555, 126555],
    [126557, 126557],
    [126559, 126559],
    [126561, 126562],
    [126564, 126564],
    [126567, 126570],
    [126572, 126578],
    [126580, 126583],
    [126585, 126588],
    [126590, 126590],
    [126592, 126601],
    [126603, 126619],
    [126625, 126627],
    [126629, 126633],
    [126635, 126651],
    [1114109, 1114109]
  ];
  function p(x) {
    for (var C = 0; C < m.length; C++) {
      var L = m[C];
      if (x >= L[0] && x <= L[1])
        return !0;
    }
    return !1;
  }
  function h(x) {
    var C = [], L = "", V;
    if (!x || !x.childNodes)
      return "ltr";
    function H(q, F) {
      for (var W = F.childNodes.length - 1; W >= 0; W--)
        q.push(F.childNodes[W]);
    }
    function O(q) {
      if (!q || !q.length)
        return null;
      var F = q.pop(), W = F.textContent || F.innerText;
      if (W) {
        var j = W.match(/^.*(\n|\r)/);
        return j ? (q.length = 0, j[0]) : W;
      }
      if (F.tagName === "ruby")
        return O(q);
      if (F.childNodes)
        return H(q, F), O(q);
    }
    for (H(C, x); L = O(C); )
      for (var X = 0; X < L.length; X++)
        if (V = L.charCodeAt(X), p(V))
          return "rtl";
    return "ltr";
  }
  function g(x) {
    if (typeof x.line == "number" && (x.snapToLines || x.line >= 0 && x.line <= 100))
      return x.line;
    if (!x.track || !x.track.textTrackList || !x.track.textTrackList.mediaElement)
      return -1;
    for (var C = x.track, L = C.textTrackList, V = 0, H = 0; H < L.length && L[H] !== C; H++)
      L[H].mode === "showing" && V++;
    return ++V * -1;
  }
  function w() {
  }
  w.prototype.applyStyles = function(x, C) {
    C = C || this.div;
    for (var L in x)
      x.hasOwnProperty(L) && (C.style[L] = x[L]);
  }, w.prototype.formatStyle = function(x, C) {
    return x === 0 ? 0 : x + C;
  };
  function b(x, C, L) {
    w.call(this), this.cue = C, this.cueDiv = A(x, C.text);
    var V = {
      color: "rgba(255, 255, 255, 1)",
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      position: "relative",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: "inline",
      writingMode: C.vertical === "" ? "horizontal-tb" : C.vertical === "lr" ? "vertical-lr" : "vertical-rl",
      unicodeBidi: "plaintext"
    };
    this.applyStyles(V, this.cueDiv), this.div = x.document.createElement("div"), V = {
      direction: h(this.cueDiv),
      writingMode: C.vertical === "" ? "horizontal-tb" : C.vertical === "lr" ? "vertical-lr" : "vertical-rl",
      unicodeBidi: "plaintext",
      textAlign: C.align === "middle" ? "center" : C.align,
      font: L.font,
      whiteSpace: "pre-line",
      position: "absolute"
    }, this.applyStyles(V), this.div.appendChild(this.cueDiv);
    var H = 0;
    switch (C.positionAlign) {
      case "start":
      case "line-left":
        H = C.position;
        break;
      case "center":
        H = C.position - C.size / 2;
        break;
      case "end":
      case "line-right":
        H = C.position - C.size;
        break;
    }
    C.vertical === "" ? this.applyStyles({
      left: this.formatStyle(H, "%"),
      width: this.formatStyle(C.size, "%")
    }) : this.applyStyles({
      top: this.formatStyle(H, "%"),
      height: this.formatStyle(C.size, "%")
    }), this.move = function(O) {
      this.applyStyles({
        top: this.formatStyle(O.top, "px"),
        bottom: this.formatStyle(O.bottom, "px"),
        left: this.formatStyle(O.left, "px"),
        right: this.formatStyle(O.right, "px"),
        height: this.formatStyle(O.height, "px"),
        width: this.formatStyle(O.width, "px")
      });
    };
  }
  b.prototype = e(w.prototype), b.prototype.constructor = b;
  function y(x) {
    var C, L, V, H;
    if (x.div) {
      L = x.div.offsetHeight, V = x.div.offsetWidth, H = x.div.offsetTop;
      var O = (O = x.div.childNodes) && (O = O[0]) && O.getClientRects && O.getClientRects();
      x = x.div.getBoundingClientRect(), C = O ? Math.max(O[0] && O[0].height || 0, x.height / O.length) : 0;
    }
    this.left = x.left, this.right = x.right, this.top = x.top || H, this.height = x.height || L, this.bottom = x.bottom || H + (x.height || L), this.width = x.width || V, this.lineHeight = C !== void 0 ? C : x.lineHeight;
  }
  y.prototype.move = function(x, C) {
    switch (C = C !== void 0 ? C : this.lineHeight, x) {
      case "+x":
        this.left += C, this.right += C;
        break;
      case "-x":
        this.left -= C, this.right -= C;
        break;
      case "+y":
        this.top += C, this.bottom += C;
        break;
      case "-y":
        this.top -= C, this.bottom -= C;
        break;
    }
  }, y.prototype.overlaps = function(x) {
    return this.left < x.right && this.right > x.left && this.top < x.bottom && this.bottom > x.top;
  }, y.prototype.overlapsAny = function(x) {
    for (var C = 0; C < x.length; C++)
      if (this.overlaps(x[C]))
        return !0;
    return !1;
  }, y.prototype.within = function(x) {
    return this.top >= x.top && this.bottom <= x.bottom && this.left >= x.left && this.right <= x.right;
  }, y.prototype.overlapsOppositeAxis = function(x, C) {
    switch (C) {
      case "+x":
        return this.left < x.left;
      case "-x":
        return this.right > x.right;
      case "+y":
        return this.top < x.top;
      case "-y":
        return this.bottom > x.bottom;
    }
  }, y.prototype.intersectPercentage = function(x) {
    var C = Math.max(0, Math.min(this.right, x.right) - Math.max(this.left, x.left)), L = Math.max(0, Math.min(this.bottom, x.bottom) - Math.max(this.top, x.top)), V = C * L;
    return V / (this.height * this.width);
  }, y.prototype.toCSSCompatValues = function(x) {
    return {
      top: this.top - x.top,
      bottom: x.bottom - this.bottom,
      left: this.left - x.left,
      right: x.right - this.right,
      height: this.height,
      width: this.width
    };
  }, y.getSimpleBoxPosition = function(x) {
    var C = x.div ? x.div.offsetHeight : x.tagName ? x.offsetHeight : 0, L = x.div ? x.div.offsetWidth : x.tagName ? x.offsetWidth : 0, V = x.div ? x.div.offsetTop : x.tagName ? x.offsetTop : 0;
    x = x.div ? x.div.getBoundingClientRect() : x.tagName ? x.getBoundingClientRect() : x;
    var H = {
      left: x.left,
      right: x.right,
      top: x.top || V,
      height: x.height || C,
      bottom: x.bottom || V + (x.height || C),
      width: x.width || L
    };
    return H;
  };
  function D(x, C, L, V) {
    function H(te, le) {
      for (var B, ue = new y(te), Pe = 1, nt = 0; nt < le.length; nt++) {
        for (; te.overlapsOppositeAxis(L, le[nt]) || te.within(L) && te.overlapsAny(V); )
          te.move(le[nt]);
        if (te.within(L))
          return te;
        var ge = te.intersectPercentage(L);
        Pe > ge && (B = new y(te), Pe = ge), te = new y(ue);
      }
      return B || ue;
    }
    var O = new y(C), X = C.cue, q = g(X), F = [];
    if (X.snapToLines) {
      var W;
      switch (X.vertical) {
        case "":
          F = ["+y", "-y"], W = "height";
          break;
        case "rl":
          F = ["+x", "-x"], W = "width";
          break;
        case "lr":
          F = ["-x", "+x"], W = "width";
          break;
      }
      var j = O.lineHeight, oe = j * Math.round(q), $ = L[W] + j, ye = F[0];
      Math.abs(oe) > $ && (oe = oe < 0 ? -1 : 1, oe *= Math.ceil($ / j) * j), q < 0 && (oe += X.vertical === "" ? L.height : L.width, F = F.reverse()), O.move(ye, oe);
    } else {
      var ae = O.lineHeight / L.height * 100;
      switch (X.lineAlign) {
        case "center":
          q -= ae / 2;
          break;
        case "end":
          q -= ae;
          break;
      }
      switch (X.vertical) {
        case "":
          C.applyStyles({
            top: C.formatStyle(q, "%")
          });
          break;
        case "rl":
          C.applyStyles({
            left: C.formatStyle(q, "%")
          });
          break;
        case "lr":
          C.applyStyles({
            right: C.formatStyle(q, "%")
          });
          break;
      }
      F = ["+y", "-x", "+x", "-y"], O = new y(C);
    }
    var ce = H(O, F);
    C.move(ce.toCSSCompatValues(L));
  }
  function I() {
  }
  I.StringDecoder = function() {
    return {
      decode: function(x) {
        if (!x)
          return "";
        if (typeof x != "string")
          throw new Error("Error - expected string data.");
        return decodeURIComponent(encodeURIComponent(x));
      }
    };
  }, I.convertCueToDOMTree = function(x, C) {
    return !x || !C ? null : A(x, C);
  };
  var M = 0.05, _ = "sans-serif", N = "1.5%";
  return I.processCues = function(x, C, L) {
    if (!x || !C || !L)
      return null;
    for (; L.firstChild; )
      L.removeChild(L.firstChild);
    var V = x.document.createElement("div");
    V.style.position = "absolute", V.style.left = "0", V.style.right = "0", V.style.top = "0", V.style.bottom = "0", V.style.margin = N, L.appendChild(V);
    function H(j) {
      for (var oe = 0; oe < j.length; oe++)
        if (j[oe].hasBeenReset || !j[oe].displayState)
          return !0;
      return !1;
    }
    if (!H(C)) {
      for (var O = 0; O < C.length; O++)
        V.appendChild(C[O].displayState);
      return;
    }
    var X = [], q = y.getSimpleBoxPosition(V), F = Math.round(q.height * M * 100) / 100, W = {
      font: F + "px " + _
    };
    (function() {
      for (var j, oe, $ = 0; $ < C.length; $++)
        oe = C[$], j = new b(x, oe, W), V.appendChild(j.div), D(x, j, q, X), oe.displayState = j.div, X.push(y.getSimpleBoxPosition(j));
    })();
  }, I.Parser = function(x, C, L) {
    L || (L = C, C = {}), C || (C = {}), this.window = x, this.vttjs = C, this.state = "INITIAL", this.buffer = "", this.decoder = L || new TextDecoder("utf8"), this.regionList = [];
  }, I.Parser.prototype = {
    // If the error is a ParsingError then report it to the consumer if
    // possible. If it's not a ParsingError then throw it like normal.
    reportOrThrowError: function(x) {
      if (x instanceof i)
        this.onparsingerror && this.onparsingerror(x);
      else
        throw x;
    },
    parse: function(x) {
      var C = this;
      x && (C.buffer += C.decoder.decode(x, { stream: !0 }));
      function L() {
        for (var j = C.buffer, oe = 0; oe < j.length && j[oe] !== "\r" && j[oe] !== `
`; )
          ++oe;
        var $ = j.substr(0, oe);
        return j[oe] === "\r" && ++oe, j[oe] === `
` && ++oe, C.buffer = j.substr(oe), $;
      }
      function V(j) {
        var oe = new s();
        if (r(j, function(ye, ae) {
          switch (ye) {
            case "id":
              oe.set(ye, ae);
              break;
            case "width":
              oe.percent(ye, ae);
              break;
            case "lines":
              oe.integer(ye, ae);
              break;
            case "regionanchor":
            case "viewportanchor":
              var ce = ae.split(",");
              if (ce.length !== 2)
                break;
              var te = new s();
              if (te.percent("x", ce[0]), te.percent("y", ce[1]), !te.has("x") || !te.has("y"))
                break;
              oe.set(ye + "X", te.get("x")), oe.set(ye + "Y", te.get("y"));
              break;
            case "scroll":
              oe.alt(ye, ae, ["up"]);
              break;
          }
        }, /=/, /\s/), oe.has("id")) {
          var $ = new (C.vttjs.VTTRegion || C.window.VTTRegion)();
          $.width = oe.get("width", 100), $.lines = oe.get("lines", 3), $.regionAnchorX = oe.get("regionanchorX", 0), $.regionAnchorY = oe.get("regionanchorY", 100), $.viewportAnchorX = oe.get("viewportanchorX", 0), $.viewportAnchorY = oe.get("viewportanchorY", 100), $.scroll = oe.get("scroll", ""), C.onregion && C.onregion($), C.regionList.push({
            id: oe.get("id"),
            region: $
          });
        }
      }
      function H(j) {
        var oe = new s();
        r(j, function($, ye) {
          switch ($) {
            case "MPEGT":
              oe.integer($ + "S", ye);
              break;
            case "LOCA":
              oe.set($ + "L", n(ye));
              break;
          }
        }, /[^\d]:/, /,/), C.ontimestampmap && C.ontimestampmap({
          MPEGTS: oe.get("MPEGTS"),
          LOCAL: oe.get("LOCAL")
        });
      }
      function O(j) {
        j.match(/X-TIMESTAMP-MAP/) ? r(j, function(oe, $) {
          switch (oe) {
            case "X-TIMESTAMP-MAP":
              H($);
              break;
          }
        }, /=/) : r(j, function(oe, $) {
          switch (oe) {
            case "Region":
              V($);
              break;
          }
        }, /:/);
      }
      try {
        var X;
        if (C.state === "INITIAL") {
          if (!/\r\n|\n/.test(C.buffer))
            return this;
          X = L();
          var q = X.match(/^WEBVTT([ \t].*)?$/);
          if (!q || !q[0])
            throw new i(i.Errors.BadSignature);
          C.state = "HEADER";
        }
        for (var F = !1; C.buffer; ) {
          if (!/\r\n|\n/.test(C.buffer))
            return this;
          switch (F ? F = !1 : X = L(), C.state) {
            case "HEADER":
              /:/.test(X) ? O(X) : X || (C.state = "ID");
              continue;
            case "NOTE":
              X || (C.state = "ID");
              continue;
            case "ID":
              if (/^NOTE($|[ \t])/.test(X)) {
                C.state = "NOTE";
                break;
              }
              if (!X)
                continue;
              C.cue = new (C.vttjs.VTTCue || C.window.VTTCue)(0, 0, "");
              try {
                C.cue.align = "center";
              } catch {
                C.cue.align = "middle";
              }
              if (C.state = "CUE", X.indexOf("-->") === -1) {
                C.cue.id = X;
                continue;
              }
            // Process line as start of a cue.
            /*falls through*/
            case "CUE":
              try {
                a(X, C.cue, C.regionList);
              } catch (j) {
                C.reportOrThrowError(j), C.cue = null, C.state = "BADCUE";
                continue;
              }
              C.state = "CUETEXT";
              continue;
            case "CUETEXT":
              var W = X.indexOf("-->") !== -1;
              if (!X || W && (F = !0)) {
                C.oncue && C.oncue(C.cue), C.cue = null, C.state = "ID";
                continue;
              }
              C.cue.text && (C.cue.text += `
`), C.cue.text += X.replace(/\u2028/g, `
`).replace(/u2029/g, `
`);
              continue;
            case "BADCUE":
              X || (C.state = "ID");
              continue;
          }
        }
      } catch (j) {
        C.reportOrThrowError(j), C.state === "CUETEXT" && C.cue && C.oncue && C.oncue(C.cue), C.cue = null, C.state = C.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
      }
      return this;
    },
    flush: function() {
      var x = this;
      try {
        if (x.buffer += x.decoder.decode(), (x.cue || x.state === "HEADER") && (x.buffer += `

`, x.parse()), x.state === "INITIAL")
          throw new i(i.Errors.BadSignature);
      } catch (C) {
        x.reportOrThrowError(C);
      }
      return x.onflush && x.onflush(), this;
    }
  }, Df = I, Df;
}
var _f, Og;
function o6() {
  if (Og) return _f;
  Og = 1;
  var t = "auto", e = {
    "": 1,
    lr: 1,
    rl: 1
  }, i = {
    start: 1,
    center: 1,
    end: 1,
    left: 1,
    right: 1,
    auto: 1,
    "line-left": 1,
    "line-right": 1
  };
  function n(a) {
    if (typeof a != "string")
      return !1;
    var o = e[a.toLowerCase()];
    return o ? a.toLowerCase() : !1;
  }
  function s(a) {
    if (typeof a != "string")
      return !1;
    var o = i[a.toLowerCase()];
    return o ? a.toLowerCase() : !1;
  }
  function r(a, o, l) {
    this.hasBeenReset = !1;
    var u = "", d = !1, c = a, A = o, m = l, p = null, h = "", g = !0, w = "auto", b = "start", y = "auto", D = "auto", I = 100, M = "center";
    Object.defineProperties(this, {
      id: {
        enumerable: !0,
        get: function() {
          return u;
        },
        set: function(_) {
          u = "" + _;
        }
      },
      pauseOnExit: {
        enumerable: !0,
        get: function() {
          return d;
        },
        set: function(_) {
          d = !!_;
        }
      },
      startTime: {
        enumerable: !0,
        get: function() {
          return c;
        },
        set: function(_) {
          if (typeof _ != "number")
            throw new TypeError("Start time must be set to a number.");
          c = _, this.hasBeenReset = !0;
        }
      },
      endTime: {
        enumerable: !0,
        get: function() {
          return A;
        },
        set: function(_) {
          if (typeof _ != "number")
            throw new TypeError("End time must be set to a number.");
          A = _, this.hasBeenReset = !0;
        }
      },
      text: {
        enumerable: !0,
        get: function() {
          return m;
        },
        set: function(_) {
          m = "" + _, this.hasBeenReset = !0;
        }
      },
      region: {
        enumerable: !0,
        get: function() {
          return p;
        },
        set: function(_) {
          p = _, this.hasBeenReset = !0;
        }
      },
      vertical: {
        enumerable: !0,
        get: function() {
          return h;
        },
        set: function(_) {
          var N = n(_);
          if (N === !1)
            throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
          h = N, this.hasBeenReset = !0;
        }
      },
      snapToLines: {
        enumerable: !0,
        get: function() {
          return g;
        },
        set: function(_) {
          g = !!_, this.hasBeenReset = !0;
        }
      },
      line: {
        enumerable: !0,
        get: function() {
          return w;
        },
        set: function(_) {
          if (typeof _ != "number" && _ !== t)
            throw new SyntaxError("Line: an invalid number or illegal string was specified.");
          w = _, this.hasBeenReset = !0;
        }
      },
      lineAlign: {
        enumerable: !0,
        get: function() {
          return b;
        },
        set: function(_) {
          var N = s(_);
          N ? (b = N, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
        }
      },
      position: {
        enumerable: !0,
        get: function() {
          return y;
        },
        set: function(_) {
          if (_ < 0 || _ > 100)
            throw new Error("Position must be between 0 and 100.");
          y = _, this.hasBeenReset = !0;
        }
      },
      positionAlign: {
        enumerable: !0,
        get: function() {
          return D;
        },
        set: function(_) {
          var N = s(_);
          N ? (D = N, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
        }
      },
      size: {
        enumerable: !0,
        get: function() {
          return I;
        },
        set: function(_) {
          if (_ < 0 || _ > 100)
            throw new Error("Size must be between 0 and 100.");
          I = _, this.hasBeenReset = !0;
        }
      },
      align: {
        enumerable: !0,
        get: function() {
          return M;
        },
        set: function(_) {
          var N = s(_);
          if (!N)
            throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
          M = N, this.hasBeenReset = !0;
        }
      }
    }), this.displayState = void 0;
  }
  return r.prototype.getCueAsHTML = function() {
    return WebVTT.convertCueToDOMTree(window, this.text);
  }, _f = r, _f;
}
var kf, Bg;
function l6() {
  if (Bg) return kf;
  Bg = 1;
  var t = {
    "": !0,
    up: !0
  };
  function e(s) {
    if (typeof s != "string")
      return !1;
    var r = t[s.toLowerCase()];
    return r ? s.toLowerCase() : !1;
  }
  function i(s) {
    return typeof s == "number" && s >= 0 && s <= 100;
  }
  function n() {
    var s = 100, r = 3, a = 0, o = 100, l = 0, u = 100, d = "";
    Object.defineProperties(this, {
      width: {
        enumerable: !0,
        get: function() {
          return s;
        },
        set: function(c) {
          if (!i(c))
            throw new Error("Width must be between 0 and 100.");
          s = c;
        }
      },
      lines: {
        enumerable: !0,
        get: function() {
          return r;
        },
        set: function(c) {
          if (typeof c != "number")
            throw new TypeError("Lines must be set to a number.");
          r = c;
        }
      },
      regionAnchorY: {
        enumerable: !0,
        get: function() {
          return o;
        },
        set: function(c) {
          if (!i(c))
            throw new Error("RegionAnchorX must be between 0 and 100.");
          o = c;
        }
      },
      regionAnchorX: {
        enumerable: !0,
        get: function() {
          return a;
        },
        set: function(c) {
          if (!i(c))
            throw new Error("RegionAnchorY must be between 0 and 100.");
          a = c;
        }
      },
      viewportAnchorY: {
        enumerable: !0,
        get: function() {
          return u;
        },
        set: function(c) {
          if (!i(c))
            throw new Error("ViewportAnchorY must be between 0 and 100.");
          u = c;
        }
      },
      viewportAnchorX: {
        enumerable: !0,
        get: function() {
          return l;
        },
        set: function(c) {
          if (!i(c))
            throw new Error("ViewportAnchorX must be between 0 and 100.");
          l = c;
        }
      },
      scroll: {
        enumerable: !0,
        get: function() {
          return d;
        },
        set: function(c) {
          var A = e(c);
          A === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : d = A;
        }
      }
    });
  }
  return kf = n, kf;
}
var Lg;
function u6() {
  if (Lg) return Ef.exports;
  Lg = 1;
  var t = Kd(), e = Ef.exports = {
    WebVTT: a6(),
    VTTCue: o6(),
    VTTRegion: l6()
  };
  t.vttjs = e, t.WebVTT = e.WebVTT;
  var i = e.VTTCue, n = e.VTTRegion, s = t.VTTCue, r = t.VTTRegion;
  return e.shim = function() {
    t.VTTCue = i, t.VTTRegion = n;
  }, e.restore = function() {
    t.VTTCue = s, t.VTTRegion = r;
  }, t.VTTCue || e.shim(), Ef.exports;
}
var d6 = u6();
const Ng = /* @__PURE__ */ Wl(d6);
function pi() {
  return pi = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var n in i) ({}).hasOwnProperty.call(i, n) && (t[n] = i[n]);
    }
    return t;
  }, pi.apply(null, arguments);
}
var Rg = "https://example.com", Jd = function(e, i) {
  if (/^[a-z]+:/i.test(i))
    return i;
  /^data:/.test(e) && (e = ne.location && ne.location.href || "");
  var n = /^\/\//.test(e), s = !ne.location && !/\/\//i.test(e);
  e = new ne.URL(e, ne.location || Rg);
  var r = new URL(i, e);
  return s ? r.href.slice(Rg.length) : n ? r.href.slice(r.protocol.length) : r.href;
}, zp = /* @__PURE__ */ function() {
  function t() {
    this.listeners = {};
  }
  var e = t.prototype;
  return e.on = function(n, s) {
    this.listeners[n] || (this.listeners[n] = []), this.listeners[n].push(s);
  }, e.off = function(n, s) {
    if (!this.listeners[n])
      return !1;
    var r = this.listeners[n].indexOf(s);
    return this.listeners[n] = this.listeners[n].slice(0), this.listeners[n].splice(r, 1), r > -1;
  }, e.trigger = function(n) {
    var s = this.listeners[n];
    if (s)
      if (arguments.length === 2)
        for (var r = s.length, a = 0; a < r; ++a)
          s[a].call(this, arguments[1]);
      else
        for (var o = Array.prototype.slice.call(arguments, 1), l = s.length, u = 0; u < l; ++u)
          s[u].apply(this, o);
  }, e.dispose = function() {
    this.listeners = {};
  }, e.pipe = function(n) {
    this.on("data", function(s) {
      n.push(s);
    });
  }, t;
}(), c6 = function(e) {
  return ne.atob ? ne.atob(e) : Buffer.from(e, "base64").toString("binary");
};
function ib(t) {
  for (var e = c6(t), i = new Uint8Array(e.length), n = 0; n < e.length; n++)
    i[n] = e.charCodeAt(n);
  return i;
}
/*! @name m3u8-parser @version 7.2.0 @license Apache-2.0 */
class f6 extends zp {
  constructor() {
    super(), this.buffer = "";
  }
  /**
   * Add new data to be parsed.
   *
   * @param {string} data the text to process
   */
  push(e) {
    let i;
    for (this.buffer += e, i = this.buffer.indexOf(`
`); i > -1; i = this.buffer.indexOf(`
`))
      this.trigger("data", this.buffer.substring(0, i)), this.buffer = this.buffer.substring(i + 1);
  }
}
const h6 = "	", Pf = function(t) {
  const e = /([0-9.]*)?@?([0-9.]*)?/.exec(t || ""), i = {};
  return e[1] && (i.length = parseInt(e[1], 10)), e[2] && (i.offset = parseInt(e[2], 10)), i;
}, p6 = function() {
  const i = "(?:" + "[^=]*" + ")=(?:" + '"[^"]*"|[^,]*' + ")";
  return new RegExp("(?:^|,)(" + i + ")");
}, Qi = function(t) {
  const e = {};
  if (!t)
    return e;
  const i = t.split(p6());
  let n = i.length, s;
  for (; n--; )
    i[n] !== "" && (s = /([^=]*)=(.*)/.exec(i[n]).slice(1), s[0] = s[0].replace(/^\s+|\s+$/g, ""), s[1] = s[1].replace(/^\s+|\s+$/g, ""), s[1] = s[1].replace(/^['"](.*)['"]$/g, "$1"), e[s[0]] = s[1]);
  return e;
}, Fg = (t) => {
  const e = t.split("x"), i = {};
  return e[0] && (i.width = parseInt(e[0], 10)), e[1] && (i.height = parseInt(e[1], 10)), i;
};
class m6 extends zp {
  constructor() {
    super(), this.customParsers = [], this.tagMappers = [];
  }
  /**
   * Parses an additional line of input.
   *
   * @param {string} line a single line of an M3U8 file to parse
   */
  push(e) {
    let i, n;
    if (e = e.trim(), e.length === 0)
      return;
    if (e[0] !== "#") {
      this.trigger("data", {
        type: "uri",
        uri: e
      });
      return;
    }
    this.tagMappers.reduce((r, a) => {
      const o = a(e);
      return o === e ? r : r.concat([o]);
    }, [e]).forEach((r) => {
      for (let a = 0; a < this.customParsers.length; a++)
        if (this.customParsers[a].call(this, r))
          return;
      if (r.indexOf("#EXT") !== 0) {
        this.trigger("data", {
          type: "comment",
          text: r.slice(1)
        });
        return;
      }
      if (r = r.replace("\r", ""), i = /^#EXTM3U/.exec(r), i) {
        this.trigger("data", {
          type: "tag",
          tagType: "m3u"
        });
        return;
      }
      if (i = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "inf"
        }, i[1] && (n.duration = parseFloat(i[1])), i[2] && (n.title = i[2]), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "targetduration"
        }, i[1] && (n.duration = parseInt(i[1], 10)), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-VERSION:([0-9.]*)?/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "version"
        }, i[1] && (n.version = parseInt(i[1], 10)), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "media-sequence"
        }, i[1] && (n.number = parseInt(i[1], 10)), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "discontinuity-sequence"
        }, i[1] && (n.number = parseInt(i[1], 10)), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "playlist-type"
        }, i[1] && (n.playlistType = i[1]), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-BYTERANGE:(.*)?$/.exec(r), i) {
        n = pi(Pf(i[1]), {
          type: "tag",
          tagType: "byterange"
        }), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "allow-cache"
        }, i[1] && (n.allowed = !/NO/.test(i[1])), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-MAP:(.*)$/.exec(r), i) {
        if (n = {
          type: "tag",
          tagType: "map"
        }, i[1]) {
          const a = Qi(i[1]);
          a.URI && (n.uri = a.URI), a.BYTERANGE && (n.byterange = Pf(a.BYTERANGE));
        }
        this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-STREAM-INF:(.*)$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "stream-inf"
        }, i[1] && (n.attributes = Qi(i[1]), n.attributes.RESOLUTION && (n.attributes.RESOLUTION = Fg(n.attributes.RESOLUTION)), n.attributes.BANDWIDTH && (n.attributes.BANDWIDTH = parseInt(n.attributes.BANDWIDTH, 10)), n.attributes["FRAME-RATE"] && (n.attributes["FRAME-RATE"] = parseFloat(n.attributes["FRAME-RATE"])), n.attributes["PROGRAM-ID"] && (n.attributes["PROGRAM-ID"] = parseInt(n.attributes["PROGRAM-ID"], 10))), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-MEDIA:(.*)$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "media"
        }, i[1] && (n.attributes = Qi(i[1])), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-ENDLIST/.exec(r), i) {
        this.trigger("data", {
          type: "tag",
          tagType: "endlist"
        });
        return;
      }
      if (i = /^#EXT-X-DISCONTINUITY/.exec(r), i) {
        this.trigger("data", {
          type: "tag",
          tagType: "discontinuity"
        });
        return;
      }
      if (i = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "program-date-time"
        }, i[1] && (n.dateTimeString = i[1], n.dateTimeObject = new Date(i[1])), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-KEY:(.*)$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "key"
        }, i[1] && (n.attributes = Qi(i[1]), n.attributes.IV && (n.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (n.attributes.IV = n.attributes.IV.substring(2)), n.attributes.IV = n.attributes.IV.match(/.{8}/g), n.attributes.IV[0] = parseInt(n.attributes.IV[0], 16), n.attributes.IV[1] = parseInt(n.attributes.IV[1], 16), n.attributes.IV[2] = parseInt(n.attributes.IV[2], 16), n.attributes.IV[3] = parseInt(n.attributes.IV[3], 16), n.attributes.IV = new Uint32Array(n.attributes.IV))), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-START:(.*)$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "start"
        }, i[1] && (n.attributes = Qi(i[1]), n.attributes["TIME-OFFSET"] = parseFloat(n.attributes["TIME-OFFSET"]), n.attributes.PRECISE = /YES/.test(n.attributes.PRECISE)), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "cue-out-cont"
        }, i[1] ? n.data = i[1] : n.data = "", this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-CUE-OUT:(.*)?$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "cue-out"
        }, i[1] ? n.data = i[1] : n.data = "", this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-CUE-IN:?(.*)?$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "cue-in"
        }, i[1] ? n.data = i[1] : n.data = "", this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-SKIP:(.*)$/.exec(r), i && i[1]) {
        n = {
          type: "tag",
          tagType: "skip"
        }, n.attributes = Qi(i[1]), n.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (n.attributes["SKIPPED-SEGMENTS"] = parseInt(n.attributes["SKIPPED-SEGMENTS"], 10)), n.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (n.attributes["RECENTLY-REMOVED-DATERANGES"] = n.attributes["RECENTLY-REMOVED-DATERANGES"].split(h6)), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-PART:(.*)$/.exec(r), i && i[1]) {
        n = {
          type: "tag",
          tagType: "part"
        }, n.attributes = Qi(i[1]), ["DURATION"].forEach(function(a) {
          n.attributes.hasOwnProperty(a) && (n.attributes[a] = parseFloat(n.attributes[a]));
        }), ["INDEPENDENT", "GAP"].forEach(function(a) {
          n.attributes.hasOwnProperty(a) && (n.attributes[a] = /YES/.test(n.attributes[a]));
        }), n.attributes.hasOwnProperty("BYTERANGE") && (n.attributes.byterange = Pf(n.attributes.BYTERANGE)), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(r), i && i[1]) {
        n = {
          type: "tag",
          tagType: "server-control"
        }, n.attributes = Qi(i[1]), ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function(a) {
          n.attributes.hasOwnProperty(a) && (n.attributes[a] = parseFloat(n.attributes[a]));
        }), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(a) {
          n.attributes.hasOwnProperty(a) && (n.attributes[a] = /YES/.test(n.attributes[a]));
        }), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-PART-INF:(.*)$/.exec(r), i && i[1]) {
        n = {
          type: "tag",
          tagType: "part-inf"
        }, n.attributes = Qi(i[1]), ["PART-TARGET"].forEach(function(a) {
          n.attributes.hasOwnProperty(a) && (n.attributes[a] = parseFloat(n.attributes[a]));
        }), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(r), i && i[1]) {
        n = {
          type: "tag",
          tagType: "preload-hint"
        }, n.attributes = Qi(i[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(a) {
          if (n.attributes.hasOwnProperty(a)) {
            n.attributes[a] = parseInt(n.attributes[a], 10);
            const o = a === "BYTERANGE-LENGTH" ? "length" : "offset";
            n.attributes.byterange = n.attributes.byterange || {}, n.attributes.byterange[o] = n.attributes[a], delete n.attributes[a];
          }
        }), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(r), i && i[1]) {
        n = {
          type: "tag",
          tagType: "rendition-report"
        }, n.attributes = Qi(i[1]), ["LAST-MSN", "LAST-PART"].forEach(function(a) {
          n.attributes.hasOwnProperty(a) && (n.attributes[a] = parseInt(n.attributes[a], 10));
        }), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-DATERANGE:(.*)$/.exec(r), i && i[1]) {
        n = {
          type: "tag",
          tagType: "daterange"
        }, n.attributes = Qi(i[1]), ["ID", "CLASS"].forEach(function(o) {
          n.attributes.hasOwnProperty(o) && (n.attributes[o] = String(n.attributes[o]));
        }), ["START-DATE", "END-DATE"].forEach(function(o) {
          n.attributes.hasOwnProperty(o) && (n.attributes[o] = new Date(n.attributes[o]));
        }), ["DURATION", "PLANNED-DURATION"].forEach(function(o) {
          n.attributes.hasOwnProperty(o) && (n.attributes[o] = parseFloat(n.attributes[o]));
        }), ["END-ON-NEXT"].forEach(function(o) {
          n.attributes.hasOwnProperty(o) && (n.attributes[o] = /YES/i.test(n.attributes[o]));
        }), ["SCTE35-CMD", " SCTE35-OUT", "SCTE35-IN"].forEach(function(o) {
          n.attributes.hasOwnProperty(o) && (n.attributes[o] = n.attributes[o].toString(16));
        });
        const a = /^X-([A-Z]+-)+[A-Z]+$/;
        for (const o in n.attributes) {
          if (!a.test(o))
            continue;
          const l = /[0-9A-Fa-f]{6}/g.test(n.attributes[o]), u = /^\d+(\.\d+)?$/.test(n.attributes[o]);
          n.attributes[o] = l ? n.attributes[o].toString(16) : u ? parseFloat(n.attributes[o]) : String(n.attributes[o]);
        }
        this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(r), i) {
        this.trigger("data", {
          type: "tag",
          tagType: "independent-segments"
        });
        return;
      }
      if (i = /^#EXT-X-I-FRAMES-ONLY/.exec(r), i) {
        this.trigger("data", {
          type: "tag",
          tagType: "i-frames-only"
        });
        return;
      }
      if (i = /^#EXT-X-CONTENT-STEERING:(.*)$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "content-steering"
        }, n.attributes = Qi(i[1]), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-I-FRAME-STREAM-INF:(.*)$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "i-frame-playlist"
        }, n.attributes = Qi(i[1]), n.attributes.URI && (n.uri = n.attributes.URI), n.attributes.BANDWIDTH && (n.attributes.BANDWIDTH = parseInt(n.attributes.BANDWIDTH, 10)), n.attributes.RESOLUTION && (n.attributes.RESOLUTION = Fg(n.attributes.RESOLUTION)), n.attributes["AVERAGE-BANDWIDTH"] && (n.attributes["AVERAGE-BANDWIDTH"] = parseInt(n.attributes["AVERAGE-BANDWIDTH"], 10)), n.attributes["FRAME-RATE"] && (n.attributes["FRAME-RATE"] = parseFloat(n.attributes["FRAME-RATE"])), this.trigger("data", n);
        return;
      }
      if (i = /^#EXT-X-DEFINE:(.*)$/.exec(r), i) {
        n = {
          type: "tag",
          tagType: "define"
        }, n.attributes = Qi(i[1]), this.trigger("data", n);
        return;
      }
      this.trigger("data", {
        type: "tag",
        data: r.slice(4)
      });
    });
  }
  /**
   * Add a parser for custom headers
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */
  addParser({
    expression: e,
    customType: i,
    dataParser: n,
    segment: s
  }) {
    typeof n != "function" && (n = (r) => r), this.customParsers.push((r) => {
      if (e.exec(r))
        return this.trigger("data", {
          type: "custom",
          data: n(r),
          customType: i,
          segment: s
        }), !0;
    });
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */
  addTagMapper({
    expression: e,
    map: i
  }) {
    const n = (s) => e.test(s) ? i(s) : s;
    this.tagMappers.push(n);
  }
}
const A6 = (t) => t.toLowerCase().replace(/-(\w)/g, (e) => e[1].toUpperCase()), tr = function(t) {
  const e = {};
  return Object.keys(t).forEach(function(i) {
    e[A6(i)] = t[i];
  }), e;
}, If = function(t) {
  const {
    serverControl: e,
    targetDuration: i,
    partTargetDuration: n
  } = t;
  if (!e)
    return;
  const s = "#EXT-X-SERVER-CONTROL", r = "holdBack", a = "partHoldBack", o = i && i * 3, l = n && n * 2;
  i && !e.hasOwnProperty(r) && (e[r] = o, this.trigger("info", {
    message: `${s} defaulting HOLD-BACK to targetDuration * 3 (${o}).`
  })), o && e[r] < o && (this.trigger("warn", {
    message: `${s} clamping HOLD-BACK (${e[r]}) to targetDuration * 3 (${o})`
  }), e[r] = o), n && !e.hasOwnProperty(a) && (e[a] = n * 3, this.trigger("info", {
    message: `${s} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${e[a]}).`
  })), n && e[a] < l && (this.trigger("warn", {
    message: `${s} clamping PART-HOLD-BACK (${e[a]}) to partTargetDuration * 2 (${l}).`
  }), e[a] = l);
};
class g6 extends zp {
  constructor(e = {}) {
    super(), this.lineStream = new f6(), this.parseStream = new m6(), this.lineStream.pipe(this.parseStream), this.mainDefinitions = e.mainDefinitions || {}, this.params = new URL(e.uri, "https://a.com").searchParams, this.lastProgramDateTime = null;
    const i = this, n = [];
    let s = {}, r, a, o = !1;
    const l = function() {
    }, u = {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    }, d = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed";
    let c = 0;
    this.manifest = {
      allowCache: !0,
      discontinuityStarts: [],
      dateRanges: [],
      iFramePlaylists: [],
      segments: []
    };
    let A = 0, m = 0;
    const p = {};
    this.on("end", () => {
      s.uri || !s.parts && !s.preloadHints || (!s.map && r && (s.map = r), !s.key && a && (s.key = a), !s.timeline && typeof c == "number" && (s.timeline = c), this.manifest.preloadSegment = s);
    }), this.parseStream.on("data", function(h) {
      let g, w;
      if (i.manifest.definitions) {
        for (const b in i.manifest.definitions)
          if (h.uri && (h.uri = h.uri.replace(`{$${b}}`, i.manifest.definitions[b])), h.attributes)
            for (const y in h.attributes)
              typeof h.attributes[y] == "string" && (h.attributes[y] = h.attributes[y].replace(`{$${b}}`, i.manifest.definitions[b]));
      }
      ({
        tag() {
          ({
            version() {
              h.version && (this.manifest.version = h.version);
            },
            "allow-cache"() {
              this.manifest.allowCache = h.allowed, "allowed" in h || (this.trigger("info", {
                message: "defaulting allowCache to YES"
              }), this.manifest.allowCache = !0);
            },
            byterange() {
              const b = {};
              "length" in h && (s.byterange = b, b.length = h.length, "offset" in h || (h.offset = A)), "offset" in h && (s.byterange = b, b.offset = h.offset), A = b.offset + b.length;
            },
            endlist() {
              this.manifest.endList = !0;
            },
            inf() {
              "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                message: "defaulting media sequence to zero"
              })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                message: "defaulting discontinuity sequence to zero"
              })), h.title && (s.title = h.title), h.duration > 0 && (s.duration = h.duration), h.duration === 0 && (s.duration = 0.01, this.trigger("info", {
                message: "updating zero segment duration to a small value"
              })), this.manifest.segments = n;
            },
            key() {
              if (!h.attributes) {
                this.trigger("warn", {
                  message: "ignoring key declaration without attribute list"
                });
                return;
              }
              if (h.attributes.METHOD === "NONE") {
                a = null;
                return;
              }
              if (!h.attributes.URI) {
                this.trigger("warn", {
                  message: "ignoring key declaration without URI"
                });
                return;
              }
              if (h.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = {
                  attributes: h.attributes
                };
                return;
              }
              if (h.attributes.KEYFORMAT === "com.microsoft.playready") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = {
                  uri: h.attributes.URI
                };
                return;
              }
              if (h.attributes.KEYFORMAT === d) {
                if (["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"].indexOf(h.attributes.METHOD) === -1) {
                  this.trigger("warn", {
                    message: "invalid key method provided for Widevine"
                  });
                  return;
                }
                if (h.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", {
                  message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                }), h.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                  this.trigger("warn", {
                    message: "invalid key URI provided for Widevine"
                  });
                  return;
                }
                if (!(h.attributes.KEYID && h.attributes.KEYID.substring(0, 2) === "0x")) {
                  this.trigger("warn", {
                    message: "invalid key ID provided for Widevine"
                  });
                  return;
                }
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
                  attributes: {
                    schemeIdUri: h.attributes.KEYFORMAT,
                    // remove '0x' from the key id string
                    keyId: h.attributes.KEYID.substring(2)
                  },
                  // decode the base64-encoded PSSH box
                  pssh: ib(h.attributes.URI.split(",")[1])
                };
                return;
              }
              h.attributes.METHOD || this.trigger("warn", {
                message: "defaulting key method to AES-128"
              }), a = {
                method: h.attributes.METHOD || "AES-128",
                uri: h.attributes.URI
              }, typeof h.attributes.IV < "u" && (a.iv = h.attributes.IV);
            },
            "media-sequence"() {
              if (!isFinite(h.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid media sequence: " + h.number
                });
                return;
              }
              this.manifest.mediaSequence = h.number;
            },
            "discontinuity-sequence"() {
              if (!isFinite(h.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid discontinuity sequence: " + h.number
                });
                return;
              }
              this.manifest.discontinuitySequence = h.number, c = h.number;
            },
            "playlist-type"() {
              if (!/VOD|EVENT/.test(h.playlistType)) {
                this.trigger("warn", {
                  message: "ignoring unknown playlist type: " + h.playlist
                });
                return;
              }
              this.manifest.playlistType = h.playlistType;
            },
            map() {
              r = {}, h.uri && (r.uri = h.uri), h.byterange && (r.byterange = h.byterange), a && (r.key = a);
            },
            "stream-inf"() {
              if (this.manifest.playlists = n, this.manifest.mediaGroups = this.manifest.mediaGroups || u, !h.attributes) {
                this.trigger("warn", {
                  message: "ignoring empty stream-inf attributes"
                });
                return;
              }
              s.attributes || (s.attributes = {}), pi(s.attributes, h.attributes);
            },
            media() {
              if (this.manifest.mediaGroups = this.manifest.mediaGroups || u, !(h.attributes && h.attributes.TYPE && h.attributes["GROUP-ID"] && h.attributes.NAME)) {
                this.trigger("warn", {
                  message: "ignoring incomplete or missing media group"
                });
                return;
              }
              const b = this.manifest.mediaGroups[h.attributes.TYPE];
              b[h.attributes["GROUP-ID"]] = b[h.attributes["GROUP-ID"]] || {}, g = b[h.attributes["GROUP-ID"]], w = {
                default: /yes/i.test(h.attributes.DEFAULT)
              }, w.default ? w.autoselect = !0 : w.autoselect = /yes/i.test(h.attributes.AUTOSELECT), h.attributes.LANGUAGE && (w.language = h.attributes.LANGUAGE), h.attributes.URI && (w.uri = h.attributes.URI), h.attributes["INSTREAM-ID"] && (w.instreamId = h.attributes["INSTREAM-ID"]), h.attributes.CHARACTERISTICS && (w.characteristics = h.attributes.CHARACTERISTICS), h.attributes.FORCED && (w.forced = /yes/i.test(h.attributes.FORCED)), g[h.attributes.NAME] = w;
            },
            discontinuity() {
              c += 1, s.discontinuity = !0, this.manifest.discontinuityStarts.push(n.length);
            },
            "program-date-time"() {
              typeof this.manifest.dateTimeString > "u" && (this.manifest.dateTimeString = h.dateTimeString, this.manifest.dateTimeObject = h.dateTimeObject), s.dateTimeString = h.dateTimeString, s.dateTimeObject = h.dateTimeObject;
              const {
                lastProgramDateTime: b
              } = this;
              this.lastProgramDateTime = new Date(h.dateTimeString).getTime(), b === null && this.manifest.segments.reduceRight((y, D) => (D.programDateTime = y - D.duration * 1e3, D.programDateTime), this.lastProgramDateTime);
            },
            targetduration() {
              if (!isFinite(h.duration) || h.duration < 0) {
                this.trigger("warn", {
                  message: "ignoring invalid target duration: " + h.duration
                });
                return;
              }
              this.manifest.targetDuration = h.duration, If.call(this, this.manifest);
            },
            start() {
              if (!h.attributes || isNaN(h.attributes["TIME-OFFSET"])) {
                this.trigger("warn", {
                  message: "ignoring start declaration without appropriate attribute list"
                });
                return;
              }
              this.manifest.start = {
                timeOffset: h.attributes["TIME-OFFSET"],
                precise: h.attributes.PRECISE
              };
            },
            "cue-out"() {
              s.cueOut = h.data;
            },
            "cue-out-cont"() {
              s.cueOutCont = h.data;
            },
            "cue-in"() {
              s.cueIn = h.data;
            },
            skip() {
              this.manifest.skip = tr(h.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", h.attributes, ["SKIPPED-SEGMENTS"]);
            },
            part() {
              o = !0;
              const b = this.manifest.segments.length, y = tr(h.attributes);
              s.parts = s.parts || [], s.parts.push(y), y.byterange && (y.byterange.hasOwnProperty("offset") || (y.byterange.offset = m), m = y.byterange.offset + y.byterange.length);
              const D = s.parts.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-PART #${D} for segment #${b}`, h.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach((I, M) => {
                I.hasOwnProperty("lastPart") || this.trigger("warn", {
                  message: `#EXT-X-RENDITION-REPORT #${M} lacks required attribute(s): LAST-PART`
                });
              });
            },
            "server-control"() {
              const b = this.manifest.serverControl = tr(h.attributes);
              b.hasOwnProperty("canBlockReload") || (b.canBlockReload = !1, this.trigger("info", {
                message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
              })), If.call(this, this.manifest), b.canSkipDateranges && !b.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
              });
            },
            "preload-hint"() {
              const b = this.manifest.segments.length, y = tr(h.attributes), D = y.type && y.type === "PART";
              s.preloadHints = s.preloadHints || [], s.preloadHints.push(y), y.byterange && (y.byterange.hasOwnProperty("offset") || (y.byterange.offset = D ? m : 0, D && (m = y.byterange.offset + y.byterange.length)));
              const I = s.preloadHints.length - 1;
              if (this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${I} for segment #${b}`, h.attributes, ["TYPE", "URI"]), !!y.type)
                for (let M = 0; M < s.preloadHints.length - 1; M++) {
                  const _ = s.preloadHints[M];
                  _.type && _.type === y.type && this.trigger("warn", {
                    message: `#EXT-X-PRELOAD-HINT #${I} for segment #${b} has the same TYPE ${y.type} as preload hint #${M}`
                  });
                }
            },
            "rendition-report"() {
              const b = tr(h.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(b);
              const y = this.manifest.renditionReports.length - 1, D = ["LAST-MSN", "URI"];
              o && D.push("LAST-PART"), this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${y}`, h.attributes, D);
            },
            "part-inf"() {
              this.manifest.partInf = tr(h.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", h.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), If.call(this, this.manifest);
            },
            daterange() {
              this.manifest.dateRanges.push(tr(h.attributes));
              const b = this.manifest.dateRanges.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${b}`, h.attributes, ["ID", "START-DATE"]);
              const y = this.manifest.dateRanges[b];
              y.endDate && y.startDate && new Date(y.endDate) < new Date(y.startDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE"
              }), y.duration && y.duration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE DURATION must not be negative"
              }), y.plannedDuration && y.plannedDuration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE PLANNED-DURATION must not be negative"
              });
              const D = !!y.endOnNext;
              if (D && !y.class && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute"
              }), D && (y.duration || y.endDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes"
              }), y.duration && y.endDate) {
                const M = y.startDate.getTime() + y.duration * 1e3;
                this.manifest.dateRanges[b].endDate = new Date(M);
              }
              if (!p[y.id])
                p[y.id] = y;
              else {
                for (const M in p[y.id])
                  if (y[M] && JSON.stringify(p[y.id][M]) !== JSON.stringify(y[M])) {
                    this.trigger("warn", {
                      message: "EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes values"
                    });
                    break;
                  }
                const I = this.manifest.dateRanges.findIndex((M) => M.id === y.id);
                this.manifest.dateRanges[I] = pi(this.manifest.dateRanges[I], y), p[y.id] = pi(p[y.id], y), this.manifest.dateRanges.pop();
              }
            },
            "independent-segments"() {
              this.manifest.independentSegments = !0;
            },
            "i-frames-only"() {
              this.manifest.iFramesOnly = !0, this.requiredCompatibilityversion(this.manifest.version, 4);
            },
            "content-steering"() {
              this.manifest.contentSteering = tr(h.attributes), this.warnOnMissingAttributes_("#EXT-X-CONTENT-STEERING", h.attributes, ["SERVER-URI"]);
            },
            /** @this {Parser} */
            define() {
              this.manifest.definitions = this.manifest.definitions || {};
              const b = (y, D) => {
                if (y in this.manifest.definitions) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: Duplicate name ${y}`
                  });
                  return;
                }
                this.manifest.definitions[y] = D;
              };
              if ("QUERYPARAM" in h.attributes) {
                if ("NAME" in h.attributes || "IMPORT" in h.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                const y = this.params.get(h.attributes.QUERYPARAM);
                if (!y) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No query param ${h.attributes.QUERYPARAM}`
                  });
                  return;
                }
                b(h.attributes.QUERYPARAM, decodeURIComponent(y));
                return;
              }
              if ("NAME" in h.attributes) {
                if ("IMPORT" in h.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                if (!("VALUE" in h.attributes) || typeof h.attributes.VALUE != "string") {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value for ${h.attributes.NAME}`
                  });
                  return;
                }
                b(h.attributes.NAME, h.attributes.VALUE);
                return;
              }
              if ("IMPORT" in h.attributes) {
                if (!this.mainDefinitions[h.attributes.IMPORT]) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value ${h.attributes.IMPORT} to import, or IMPORT used on main playlist`
                  });
                  return;
                }
                b(h.attributes.IMPORT, this.mainDefinitions[h.attributes.IMPORT]);
                return;
              }
              this.trigger("error", {
                message: "EXT-X-DEFINE: No attribute"
              });
            },
            "i-frame-playlist"() {
              this.manifest.iFramePlaylists.push({
                attributes: h.attributes,
                uri: h.uri,
                timeline: c
              }), this.warnOnMissingAttributes_("#EXT-X-I-FRAME-STREAM-INF", h.attributes, ["BANDWIDTH", "URI"]);
            }
          }[h.tagType] || l).call(i);
        },
        uri() {
          s.uri = h.uri, n.push(s), this.manifest.targetDuration && !("duration" in s) && (this.trigger("warn", {
            message: "defaulting segment duration to the target duration"
          }), s.duration = this.manifest.targetDuration), a && (s.key = a), s.timeline = c, r && (s.map = r), m = 0, this.lastProgramDateTime !== null && (s.programDateTime = this.lastProgramDateTime, this.lastProgramDateTime += s.duration * 1e3), s = {};
        },
        comment() {
        },
        custom() {
          h.segment ? (s.custom = s.custom || {}, s.custom[h.customType] = h.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[h.customType] = h.data);
        }
      })[h.type].call(i);
    });
  }
  requiredCompatibilityversion(e, i) {
    (e < i || !e) && this.trigger("warn", {
      message: `manifest must be at least version ${i}`
    });
  }
  warnOnMissingAttributes_(e, i, n) {
    const s = [];
    n.forEach(function(r) {
      i.hasOwnProperty(r) || s.push(r);
    }), s.length && this.trigger("warn", {
      message: `${e} lacks required attribute(s): ${s.join(", ")}`
    });
  }
  /**
   * Parse the input string and update the manifest object.
   *
   * @param {string} chunk a potentially incomplete portion of the manifest
   */
  push(e) {
    this.lineStream.push(e);
  }
  /**
   * Flush any remaining input. This can be handy if the last line of an M3U8
   * manifest did not contain a trailing newline but the file has been
   * completely received.
   */
  end() {
    this.lineStream.push(`
`), this.manifest.dateRanges.length && this.lastProgramDateTime === null && this.trigger("warn", {
      message: "A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag"
    }), this.lastProgramDateTime = null, this.trigger("end");
  }
  /**
   * Add an additional parser for non-standard tags
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */
  addParser(e) {
    this.parseStream.addParser(e);
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */
  addTagMapper(e) {
    this.parseStream.addTagMapper(e);
  }
}
var jr = {
  // to determine mime types
  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
  // to determine if a codec is audio or video
  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
  text: /^(stpp.ttml.im1t)/,
  // mux.js support regex
  muxerVideo: /^(avc0?1)/,
  muxerAudio: /^(mp4a)/,
  // match nothing as muxer does not support text right now.
  // there cannot never be a character before the start of a string
  // so this matches nothing.
  muxerText: /a^/
}, v6 = ["video", "audio", "text"], zg = ["Video", "Audio", "Text"], nb = function(e) {
  return e && e.replace(/avc1\.(\d+)\.(\d+)/i, function(i, n, s) {
    var r = ("00" + Number(n).toString(16)).slice(-2), a = ("00" + Number(s).toString(16)).slice(-2);
    return "avc1." + r + "00" + a;
  });
}, cs = function(e) {
  e === void 0 && (e = "");
  var i = e.split(","), n = [];
  return i.forEach(function(s) {
    s = s.trim();
    var r;
    v6.forEach(function(a) {
      var o = jr[a].exec(s.toLowerCase());
      if (!(!o || o.length <= 1)) {
        r = a;
        var l = s.substring(0, o[1].length), u = s.replace(l, "");
        n.push({
          type: l,
          details: u,
          mediaType: a
        });
      }
    }), r || n.push({
      type: s,
      details: "",
      mediaType: "unknown"
    });
  }), n;
}, y6 = function(e, i) {
  if (!e.mediaGroups.AUDIO || !i)
    return null;
  var n = e.mediaGroups.AUDIO[i];
  if (!n)
    return null;
  for (var s in n) {
    var r = n[s];
    if (r.default && r.playlists)
      return cs(r.playlists[0].attributes.CODECS);
  }
  return null;
}, sb = function(e) {
  return e === void 0 && (e = ""), jr.audio.test(e.trim().toLowerCase());
}, b6 = function(e) {
  return e === void 0 && (e = ""), jr.text.test(e.trim().toLowerCase());
}, no = function(e) {
  if (!(!e || typeof e != "string")) {
    var i = e.toLowerCase().split(",").map(function(r) {
      return nb(r.trim());
    }), n = "video";
    i.length === 1 && sb(i[0]) ? n = "audio" : i.length === 1 && b6(i[0]) && (n = "application");
    var s = "mp4";
    return i.every(function(r) {
      return jr.mp4.test(r);
    }) ? s = "mp4" : i.every(function(r) {
      return jr.webm.test(r);
    }) ? s = "webm" : i.every(function(r) {
      return jr.ogg.test(r);
    }) && (s = "ogg"), n + "/" + s + ';codecs="' + e + '"';
  }
}, Al = function(e, i) {
  return e === void 0 && (e = ""), i === void 0 && (i = !1), ne.MediaSource && ne.MediaSource.isTypeSupported && ne.MediaSource.isTypeSupported(no(e)) || i && ne.ManagedMediaSource && ne.ManagedMediaSource.isTypeSupported && ne.ManagedMediaSource.isTypeSupported(no(e)) || !1;
}, Mf = function(e) {
  return e === void 0 && (e = ""), e.toLowerCase().split(",").every(function(i) {
    i = i.trim();
    for (var n = 0; n < zg.length; n++) {
      var s = zg[n];
      if (jr["muxer" + s].test(i))
        return !0;
    }
    return !1;
  });
}, Ug = "mp4a.40.2", w6 = "avc1.4d400d", T6 = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i, x6 = /^application\/dash\+xml/i, rb = function(e) {
  return T6.test(e) ? "hls" : x6.test(e) ? "dash" : e === "application/vnd.videojs.vhs+json" ? "vhs-json" : null;
}, S6 = function(e) {
  return e.toString(2).length;
}, C6 = function(e) {
  return Math.ceil(S6(e) / 8);
}, ab = function(e) {
  return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer;
}, E6 = function(e) {
  return ab(e);
}, it = function(e) {
  return e instanceof Uint8Array ? e : (!Array.isArray(e) && !E6(e) && !(e instanceof ArrayBuffer) && (typeof e != "number" || typeof e == "number" && e !== e ? e = 0 : e = [e]), new Uint8Array(e && e.buffer || e, e && e.byteOffset || 0, e && e.byteLength || 0));
}, Bi = ne.BigInt || Number, wh = [Bi("0x1"), Bi("0x100"), Bi("0x10000"), Bi("0x1000000"), Bi("0x100000000"), Bi("0x10000000000"), Bi("0x1000000000000"), Bi("0x100000000000000"), Bi("0x10000000000000000")];
(function() {
  var t = new Uint16Array([65484]), e = new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  return e[0] === 255 ? "big" : e[0] === 204 ? "little" : "unknown";
})();
var D6 = function(e, i) {
  var n = i === void 0 ? {} : i, s = n.signed, r = s === void 0 ? !1 : s, a = n.le, o = a === void 0 ? !1 : a;
  e = it(e);
  var l = o ? "reduce" : "reduceRight", u = e[l] ? e[l] : Array.prototype[l], d = u.call(e, function(A, m, p) {
    var h = o ? p : Math.abs(p + 1 - e.length);
    return A + Bi(m) * wh[h];
  }, Bi(0));
  if (r) {
    var c = wh[e.length] / Bi(2) - Bi(1);
    d = Bi(d), d > c && (d -= c, d -= c, d -= Bi(2));
  }
  return Number(d);
}, _6 = function(e, i) {
  var n = {}, s = n.le, r = s === void 0 ? !1 : s;
  (typeof e != "bigint" && typeof e != "number" || typeof e == "number" && e !== e) && (e = 0), e = Bi(e);
  for (var a = C6(e), o = new Uint8Array(new ArrayBuffer(a)), l = 0; l < a; l++) {
    var u = r ? l : Math.abs(l + 1 - o.length);
    o[u] = Number(e / wh[l] & Bi(255)), e < 0 && (o[u] = Math.abs(~o[u]), o[u] -= l === 0 ? 1 : 2);
  }
  return o;
}, ob = function(e, i) {
  if (typeof e != "string" && e && typeof e.toString == "function" && (e = e.toString()), typeof e != "string")
    return new Uint8Array();
  i || (e = unescape(encodeURIComponent(e)));
  for (var n = new Uint8Array(e.length), s = 0; s < e.length; s++)
    n[s] = e.charCodeAt(s);
  return n;
}, k6 = function() {
  for (var e = arguments.length, i = new Array(e), n = 0; n < e; n++)
    i[n] = arguments[n];
  if (i = i.filter(function(o) {
    return o && (o.byteLength || o.length) && typeof o != "string";
  }), i.length <= 1)
    return it(i[0]);
  var s = i.reduce(function(o, l, u) {
    return o + (l.byteLength || l.length);
  }, 0), r = new Uint8Array(s), a = 0;
  return i.forEach(function(o) {
    o = it(o), r.set(o, a), a += o.byteLength;
  }), r;
}, Zt = function(e, i, n) {
  var s = n === void 0 ? {} : n, r = s.offset, a = r === void 0 ? 0 : r, o = s.mask, l = o === void 0 ? [] : o;
  e = it(e), i = it(i);
  var u = i.every ? i.every : Array.prototype.every;
  return i.length && e.length - a >= i.length && // ie 11 doesn't support every on uin8
  u.call(i, function(d, c) {
    var A = l[c] ? l[c] & e[a + c] : e[a + c];
    return d === A;
  });
}, P6 = function(e, i, n) {
  i.forEach(function(s) {
    for (var r in e.mediaGroups[s])
      for (var a in e.mediaGroups[s][r]) {
        var o = e.mediaGroups[s][r][a];
        n(o, s, r, a);
      }
  });
}, Xo = {}, Os = {}, Ir = {}, Vg;
function $d() {
  if (Vg) return Ir;
  Vg = 1;
  function t(r, a, o) {
    if (o === void 0 && (o = Array.prototype), r && typeof o.find == "function")
      return o.find.call(r, a);
    for (var l = 0; l < r.length; l++)
      if (Object.prototype.hasOwnProperty.call(r, l)) {
        var u = r[l];
        if (a.call(void 0, u, l, r))
          return u;
      }
  }
  function e(r, a) {
    return a === void 0 && (a = Object), a && typeof a.freeze == "function" ? a.freeze(r) : r;
  }
  function i(r, a) {
    if (r === null || typeof r != "object")
      throw new TypeError("target is not an object");
    for (var o in a)
      Object.prototype.hasOwnProperty.call(a, o) && (r[o] = a[o]);
    return r;
  }
  var n = e({
    /**
     * `text/html`, the only mime type that triggers treating an XML document as HTML.
     *
     * @see DOMParser.SupportedType.isHTML
     * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
     * @see https://en.wikipedia.org/wiki/HTML Wikipedia
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
     * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
     */
    HTML: "text/html",
    /**
     * Helper method to check a mime type if it indicates an HTML document
     *
     * @param {string} [value]
     * @returns {boolean}
     *
     * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
     * @see https://en.wikipedia.org/wiki/HTML Wikipedia
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
     * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
    isHTML: function(r) {
      return r === n.HTML;
    },
    /**
     * `application/xml`, the standard mime type for XML documents.
     *
     * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
     * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
     * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
     */
    XML_APPLICATION: "application/xml",
    /**
     * `text/html`, an alias for `application/xml`.
     *
     * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
     * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
     * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
     */
    XML_TEXT: "text/xml",
    /**
     * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
     * but is parsed as an XML document.
     *
     * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
     * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
     */
    XML_XHTML_APPLICATION: "application/xhtml+xml",
    /**
     * `image/svg+xml`,
     *
     * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
     * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
     * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
     */
    XML_SVG_IMAGE: "image/svg+xml"
  }), s = e({
    /**
     * The XHTML namespace.
     *
     * @see http://www.w3.org/1999/xhtml
     */
    HTML: "http://www.w3.org/1999/xhtml",
    /**
     * Checks if `uri` equals `NAMESPACE.HTML`.
     *
     * @param {string} [uri]
     *
     * @see NAMESPACE.HTML
     */
    isHTML: function(r) {
      return r === s.HTML;
    },
    /**
     * The SVG namespace.
     *
     * @see http://www.w3.org/2000/svg
     */
    SVG: "http://www.w3.org/2000/svg",
    /**
     * The `xml:` namespace.
     *
     * @see http://www.w3.org/XML/1998/namespace
     */
    XML: "http://www.w3.org/XML/1998/namespace",
    /**
     * The `xmlns:` namespace
     *
     * @see https://www.w3.org/2000/xmlns/
     */
    XMLNS: "http://www.w3.org/2000/xmlns/"
  });
  return Ir.assign = i, Ir.find = t, Ir.freeze = e, Ir.MIME_TYPE = n, Ir.NAMESPACE = s, Ir;
}
var qg;
function lb() {
  if (qg) return Os;
  qg = 1;
  var t = $d(), e = t.find, i = t.NAMESPACE;
  function n(z) {
    return z !== "";
  }
  function s(z) {
    return z ? z.split(/[\t\n\f\r ]+/).filter(n) : [];
  }
  function r(z, R) {
    return z.hasOwnProperty(R) || (z[R] = !0), z;
  }
  function a(z) {
    if (!z) return [];
    var R = s(z);
    return Object.keys(R.reduce(r, {}));
  }
  function o(z) {
    return function(R) {
      return z && z.indexOf(R) !== -1;
    };
  }
  function l(z, R) {
    for (var Q in z)
      Object.prototype.hasOwnProperty.call(z, Q) && (R[Q] = z[Q]);
  }
  function u(z, R) {
    var Q = z.prototype;
    if (!(Q instanceof R)) {
      let de = function() {
      };
      de.prototype = R.prototype, de = new de(), l(Q, de), z.prototype = Q = de;
    }
    Q.constructor != z && (typeof z != "function" && console.error("unknown Class:" + z), Q.constructor = z);
  }
  var d = {}, c = d.ELEMENT_NODE = 1, A = d.ATTRIBUTE_NODE = 2, m = d.TEXT_NODE = 3, p = d.CDATA_SECTION_NODE = 4, h = d.ENTITY_REFERENCE_NODE = 5, g = d.ENTITY_NODE = 6, w = d.PROCESSING_INSTRUCTION_NODE = 7, b = d.COMMENT_NODE = 8, y = d.DOCUMENT_NODE = 9, D = d.DOCUMENT_TYPE_NODE = 10, I = d.DOCUMENT_FRAGMENT_NODE = 11, M = d.NOTATION_NODE = 12, _ = {}, N = {};
  _.INDEX_SIZE_ERR = (N[1] = "Index size error", 1), _.DOMSTRING_SIZE_ERR = (N[2] = "DOMString size error", 2);
  var x = _.HIERARCHY_REQUEST_ERR = (N[3] = "Hierarchy request error", 3);
  _.WRONG_DOCUMENT_ERR = (N[4] = "Wrong document", 4), _.INVALID_CHARACTER_ERR = (N[5] = "Invalid character", 5), _.NO_DATA_ALLOWED_ERR = (N[6] = "No data allowed", 6), _.NO_MODIFICATION_ALLOWED_ERR = (N[7] = "No modification allowed", 7);
  var C = _.NOT_FOUND_ERR = (N[8] = "Not found", 8);
  _.NOT_SUPPORTED_ERR = (N[9] = "Not supported", 9);
  var L = _.INUSE_ATTRIBUTE_ERR = (N[10] = "Attribute in use", 10);
  _.INVALID_STATE_ERR = (N[11] = "Invalid state", 11), _.SYNTAX_ERR = (N[12] = "Syntax error", 12), _.INVALID_MODIFICATION_ERR = (N[13] = "Invalid modification", 13), _.NAMESPACE_ERR = (N[14] = "Invalid namespace", 14), _.INVALID_ACCESS_ERR = (N[15] = "Invalid access", 15);
  function V(z, R) {
    if (R instanceof Error)
      var Q = R;
    else
      Q = this, Error.call(this, N[z]), this.message = N[z], Error.captureStackTrace && Error.captureStackTrace(this, V);
    return Q.code = z, R && (this.message = this.message + ": " + R), Q;
  }
  V.prototype = Error.prototype, l(_, V);
  function H() {
  }
  H.prototype = {
    /**
     * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
     * @standard level1
     */
    length: 0,
    /**
     * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
     * @standard level1
     * @param index  unsigned long
     *   Index into the collection.
     * @return Node
     * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
     */
    item: function(z) {
      return z >= 0 && z < this.length ? this[z] : null;
    },
    toString: function(z, R) {
      for (var Q = [], de = 0; de < this.length; de++)
        Cn(this[de], Q, z, R);
      return Q.join("");
    },
    /**
     * @private
     * @param {function (Node):boolean} predicate
     * @returns {Node[]}
     */
    filter: function(z) {
      return Array.prototype.filter.call(this, z);
    },
    /**
     * @private
     * @param {Node} item
     * @returns {number}
     */
    indexOf: function(z) {
      return Array.prototype.indexOf.call(this, z);
    }
  };
  function O(z, R) {
    this._node = z, this._refresh = R, X(this);
  }
  function X(z) {
    var R = z._node._inc || z._node.ownerDocument._inc;
    if (z._inc !== R) {
      var Q = z._refresh(z._node);
      if (Je(z, "length", Q.length), !z.$$length || Q.length < z.$$length)
        for (var de = Q.length; de in z; de++)
          Object.prototype.hasOwnProperty.call(z, de) && delete z[de];
      l(Q, z), z._inc = R;
    }
  }
  O.prototype.item = function(z) {
    return X(this), this[z] || null;
  }, u(O, H);
  function q() {
  }
  function F(z, R) {
    for (var Q = z.length; Q--; )
      if (z[Q] === R)
        return Q;
  }
  function W(z, R, Q, de) {
    if (de ? R[F(R, de)] = Q : R[R.length++] = Q, z) {
      Q.ownerElement = z;
      var Fe = z.ownerDocument;
      Fe && (de && le(Fe, z, de), te(Fe, z, Q));
    }
  }
  function j(z, R, Q) {
    var de = F(R, Q);
    if (de >= 0) {
      for (var Fe = R.length - 1; de < Fe; )
        R[de] = R[++de];
      if (R.length = Fe, z) {
        var Ze = z.ownerDocument;
        Ze && (le(Ze, z, Q), Q.ownerElement = null);
      }
    } else
      throw new V(C, new Error(z.tagName + "@" + Q));
  }
  q.prototype = {
    length: 0,
    item: H.prototype.item,
    getNamedItem: function(z) {
      for (var R = this.length; R--; ) {
        var Q = this[R];
        if (Q.nodeName == z)
          return Q;
      }
    },
    setNamedItem: function(z) {
      var R = z.ownerElement;
      if (R && R != this._ownerElement)
        throw new V(L);
      var Q = this.getNamedItem(z.nodeName);
      return W(this._ownerElement, this, z, Q), Q;
    },
    /* returns Node */
    setNamedItemNS: function(z) {
      var R = z.ownerElement, Q;
      if (R && R != this._ownerElement)
        throw new V(L);
      return Q = this.getNamedItemNS(z.namespaceURI, z.localName), W(this._ownerElement, this, z, Q), Q;
    },
    /* returns Node */
    removeNamedItem: function(z) {
      var R = this.getNamedItem(z);
      return j(this._ownerElement, this, R), R;
    },
    // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
    //for level2
    removeNamedItemNS: function(z, R) {
      var Q = this.getNamedItemNS(z, R);
      return j(this._ownerElement, this, Q), Q;
    },
    getNamedItemNS: function(z, R) {
      for (var Q = this.length; Q--; ) {
        var de = this[Q];
        if (de.localName == R && de.namespaceURI == z)
          return de;
      }
      return null;
    }
  };
  function oe() {
  }
  oe.prototype = {
    /**
     * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
     * The different implementations fairly diverged in what kind of features were reported.
     * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
     *
     * @deprecated It is deprecated and modern browsers return true in all cases.
     *
     * @param {string} feature
     * @param {string} [version]
     * @returns {boolean} always true
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
     * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
     */
    hasFeature: function(z, R) {
      return !0;
    },
    /**
     * Creates an XML Document object of the specified type with its document element.
     *
     * __It behaves slightly different from the description in the living standard__:
     * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
     * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
     * - this implementation is not validating names or qualified names
     *   (when parsing XML strings, the SAX parser takes care of that)
     *
     * @param {string|null} namespaceURI
     * @param {string} qualifiedName
     * @param {DocumentType=null} doctype
     * @returns {Document}
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
     * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
     *
     * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
     * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
     * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
     */
    createDocument: function(z, R, Q) {
      var de = new ce();
      if (de.implementation = this, de.childNodes = new H(), de.doctype = Q || null, Q && de.appendChild(Q), R) {
        var Fe = de.createElementNS(z, R);
        de.appendChild(Fe);
      }
      return de;
    },
    /**
     * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
     *
     * __This behavior is slightly different from the in the specs__:
     * - this implementation is not validating names or qualified names
     *   (when parsing XML strings, the SAX parser takes care of that)
     *
     * @param {string} qualifiedName
     * @param {string} [publicId]
     * @param {string} [systemId]
     * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
     * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
     * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
     *
     * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
     * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
     * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
     */
    createDocumentType: function(z, R, Q) {
      var de = new Rt();
      return de.name = z, de.nodeName = z, de.publicId = R || "", de.systemId = Q || "", de;
    }
  };
  function $() {
  }
  $.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(z, R) {
      return Ke(this, z, R);
    },
    replaceChild: function(z, R) {
      Ke(this, z, R, Me), R && this.removeChild(R);
    },
    removeChild: function(z) {
      return ue(this, z);
    },
    appendChild: function(z) {
      return this.insertBefore(z, null);
    },
    hasChildNodes: function() {
      return this.firstChild != null;
    },
    cloneNode: function(z) {
      return Le(this.ownerDocument || this, this, z);
    },
    // Modified in DOM Level 2:
    normalize: function() {
      for (var z = this.firstChild; z; ) {
        var R = z.nextSibling;
        R && R.nodeType == m && z.nodeType == m ? (this.removeChild(R), z.appendData(R.data)) : (z.normalize(), z = R);
      }
    },
    // Introduced in DOM Level 2:
    isSupported: function(z, R) {
      return this.ownerDocument.implementation.hasFeature(z, R);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
      return this.attributes.length > 0;
    },
    /**
     * Look up the prefix associated to the given namespace URI, starting from this node.
     * **The default namespace declarations are ignored by this method.**
     * See Namespace Prefix Lookup for details on the algorithm used by this method.
     *
     * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
     *
     * @param {string | null} namespaceURI
     * @returns {string | null}
     * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
     * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
     * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
     * @see https://github.com/xmldom/xmldom/issues/322
     */
    lookupPrefix: function(z) {
      for (var R = this; R; ) {
        var Q = R._nsMap;
        if (Q) {
          for (var de in Q)
            if (Object.prototype.hasOwnProperty.call(Q, de) && Q[de] === z)
              return de;
        }
        R = R.nodeType == A ? R.ownerDocument : R.parentNode;
      }
      return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(z) {
      for (var R = this; R; ) {
        var Q = R._nsMap;
        if (Q && Object.prototype.hasOwnProperty.call(Q, z))
          return Q[z];
        R = R.nodeType == A ? R.ownerDocument : R.parentNode;
      }
      return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(z) {
      var R = this.lookupPrefix(z);
      return R == null;
    }
  };
  function ye(z) {
    return z == "<" && "&lt;" || z == ">" && "&gt;" || z == "&" && "&amp;" || z == '"' && "&quot;" || "&#" + z.charCodeAt() + ";";
  }
  l(d, $), l(d, $.prototype);
  function ae(z, R) {
    if (R(z))
      return !0;
    if (z = z.firstChild)
      do
        if (ae(z, R))
          return !0;
      while (z = z.nextSibling);
  }
  function ce() {
    this.ownerDocument = this;
  }
  function te(z, R, Q) {
    z && z._inc++;
    var de = Q.namespaceURI;
    de === i.XMLNS && (R._nsMap[Q.prefix ? Q.localName : ""] = Q.value);
  }
  function le(z, R, Q, de) {
    z && z._inc++;
    var Fe = Q.namespaceURI;
    Fe === i.XMLNS && delete R._nsMap[Q.prefix ? Q.localName : ""];
  }
  function B(z, R, Q) {
    if (z && z._inc) {
      z._inc++;
      var de = R.childNodes;
      if (Q)
        de[de.length++] = Q;
      else {
        for (var Fe = R.firstChild, Ze = 0; Fe; )
          de[Ze++] = Fe, Fe = Fe.nextSibling;
        de.length = Ze, delete de[de.length];
      }
    }
  }
  function ue(z, R) {
    var Q = R.previousSibling, de = R.nextSibling;
    return Q ? Q.nextSibling = de : z.firstChild = de, de ? de.previousSibling = Q : z.lastChild = Q, R.parentNode = null, R.previousSibling = null, R.nextSibling = null, B(z.ownerDocument, z), R;
  }
  function Pe(z) {
    return z && (z.nodeType === $.DOCUMENT_NODE || z.nodeType === $.DOCUMENT_FRAGMENT_NODE || z.nodeType === $.ELEMENT_NODE);
  }
  function nt(z) {
    return z && (Qe(z) || Ee(z) || ge(z) || z.nodeType === $.DOCUMENT_FRAGMENT_NODE || z.nodeType === $.COMMENT_NODE || z.nodeType === $.PROCESSING_INSTRUCTION_NODE);
  }
  function ge(z) {
    return z && z.nodeType === $.DOCUMENT_TYPE_NODE;
  }
  function Qe(z) {
    return z && z.nodeType === $.ELEMENT_NODE;
  }
  function Ee(z) {
    return z && z.nodeType === $.TEXT_NODE;
  }
  function xe(z, R) {
    var Q = z.childNodes || [];
    if (e(Q, Qe) || ge(R))
      return !1;
    var de = e(Q, ge);
    return !(R && de && Q.indexOf(de) > Q.indexOf(R));
  }
  function K(z, R) {
    var Q = z.childNodes || [];
    function de(Ze) {
      return Qe(Ze) && Ze !== R;
    }
    if (e(Q, de))
      return !1;
    var Fe = e(Q, ge);
    return !(R && Fe && Q.indexOf(Fe) > Q.indexOf(R));
  }
  function Ie(z, R, Q) {
    if (!Pe(z))
      throw new V(x, "Unexpected parent node type " + z.nodeType);
    if (Q && Q.parentNode !== z)
      throw new V(C, "child not in parent");
    if (
      // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
      !nt(R) || // 5. If either `node` is a Text node and `parent` is a document,
      // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
      // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
      // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
      ge(R) && z.nodeType !== $.DOCUMENT_NODE
    )
      throw new V(
        x,
        "Unexpected node type " + R.nodeType + " for parent node type " + z.nodeType
      );
  }
  function Be(z, R, Q) {
    var de = z.childNodes || [], Fe = R.childNodes || [];
    if (R.nodeType === $.DOCUMENT_FRAGMENT_NODE) {
      var Ze = Fe.filter(Qe);
      if (Ze.length > 1 || e(Fe, Ee))
        throw new V(x, "More than one element or text in fragment");
      if (Ze.length === 1 && !xe(z, Q))
        throw new V(x, "Element in fragment can not be inserted before doctype");
    }
    if (Qe(R) && !xe(z, Q))
      throw new V(x, "Only one element can be added and only after doctype");
    if (ge(R)) {
      if (e(de, ge))
        throw new V(x, "Only one doctype is allowed");
      var bt = e(de, Qe);
      if (Q && de.indexOf(bt) < de.indexOf(Q))
        throw new V(x, "Doctype can only be inserted before an element");
      if (!Q && bt)
        throw new V(x, "Doctype can not be appended since element is present");
    }
  }
  function Me(z, R, Q) {
    var de = z.childNodes || [], Fe = R.childNodes || [];
    if (R.nodeType === $.DOCUMENT_FRAGMENT_NODE) {
      var Ze = Fe.filter(Qe);
      if (Ze.length > 1 || e(Fe, Ee))
        throw new V(x, "More than one element or text in fragment");
      if (Ze.length === 1 && !K(z, Q))
        throw new V(x, "Element in fragment can not be inserted before doctype");
    }
    if (Qe(R) && !K(z, Q))
      throw new V(x, "Only one element can be added and only after doctype");
    if (ge(R)) {
      if (e(de, function(Xi) {
        return ge(Xi) && Xi !== Q;
      }))
        throw new V(x, "Only one doctype is allowed");
      var bt = e(de, Qe);
      if (Q && de.indexOf(bt) < de.indexOf(Q))
        throw new V(x, "Doctype can only be inserted before an element");
    }
  }
  function Ke(z, R, Q, de) {
    Ie(z, R, Q), z.nodeType === $.DOCUMENT_NODE && (de || Be)(z, R, Q);
    var Fe = R.parentNode;
    if (Fe && Fe.removeChild(R), R.nodeType === I) {
      var Ze = R.firstChild;
      if (Ze == null)
        return R;
      var bt = R.lastChild;
    } else
      Ze = bt = R;
    var Vt = Q ? Q.previousSibling : z.lastChild;
    Ze.previousSibling = Vt, bt.nextSibling = Q, Vt ? Vt.nextSibling = Ze : z.firstChild = Ze, Q == null ? z.lastChild = bt : Q.previousSibling = bt;
    do
      Ze.parentNode = z;
    while (Ze !== bt && (Ze = Ze.nextSibling));
    return B(z.ownerDocument || z, z), R.nodeType == I && (R.firstChild = R.lastChild = null), R;
  }
  function He(z, R) {
    return R.parentNode && R.parentNode.removeChild(R), R.parentNode = z, R.previousSibling = z.lastChild, R.nextSibling = null, R.previousSibling ? R.previousSibling.nextSibling = R : z.firstChild = R, z.lastChild = R, B(z.ownerDocument, z, R), R;
  }
  ce.prototype = {
    //implementation : null,
    nodeName: "#document",
    nodeType: y,
    /**
     * The DocumentType node of the document.
     *
     * @readonly
     * @type DocumentType
     */
    doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(z, R) {
      if (z.nodeType == I) {
        for (var Q = z.firstChild; Q; ) {
          var de = Q.nextSibling;
          this.insertBefore(Q, R), Q = de;
        }
        return z;
      }
      return Ke(this, z, R), z.ownerDocument = this, this.documentElement === null && z.nodeType === c && (this.documentElement = z), z;
    },
    removeChild: function(z) {
      return this.documentElement == z && (this.documentElement = null), ue(this, z);
    },
    replaceChild: function(z, R) {
      Ke(this, z, R, Me), z.ownerDocument = this, R && this.removeChild(R), Qe(z) && (this.documentElement = z);
    },
    // Introduced in DOM Level 2:
    importNode: function(z, R) {
      return me(this, z, R);
    },
    // Introduced in DOM Level 2:
    getElementById: function(z) {
      var R = null;
      return ae(this.documentElement, function(Q) {
        if (Q.nodeType == c && Q.getAttribute("id") == z)
          return R = Q, !0;
      }), R;
    },
    /**
     * The `getElementsByClassName` method of `Document` interface returns an array-like object
     * of all child elements which have **all** of the given class name(s).
     *
     * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
     *
     *
     * Warning: This is a live LiveNodeList.
     * Changes in the DOM will reflect in the array as the changes occur.
     * If an element selected by this array no longer qualifies for the selector,
     * it will automatically be removed. Be aware of this for iteration purposes.
     *
     * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
     * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
     */
    getElementsByClassName: function(z) {
      var R = a(z);
      return new O(this, function(Q) {
        var de = [];
        return R.length > 0 && ae(Q.documentElement, function(Fe) {
          if (Fe !== Q && Fe.nodeType === c) {
            var Ze = Fe.getAttribute("class");
            if (Ze) {
              var bt = z === Ze;
              if (!bt) {
                var Vt = a(Ze);
                bt = R.every(o(Vt));
              }
              bt && de.push(Fe);
            }
          }
        }), de;
      });
    },
    //document factory method:
    createElement: function(z) {
      var R = new Ge();
      R.ownerDocument = this, R.nodeName = z, R.tagName = z, R.localName = z, R.childNodes = new H();
      var Q = R.attributes = new q();
      return Q._ownerElement = R, R;
    },
    createDocumentFragment: function() {
      var z = new zn();
      return z.ownerDocument = this, z.childNodes = new H(), z;
    },
    createTextNode: function(z) {
      var R = new Re();
      return R.ownerDocument = this, R.appendData(z), R;
    },
    createComment: function(z) {
      var R = new dt();
      return R.ownerDocument = this, R.appendData(z), R;
    },
    createCDATASection: function(z) {
      var R = new St();
      return R.ownerDocument = this, R.appendData(z), R;
    },
    createProcessingInstruction: function(z, R) {
      var Q = new xt();
      return Q.ownerDocument = this, Q.tagName = Q.nodeName = Q.target = z, Q.nodeValue = Q.data = R, Q;
    },
    createAttribute: function(z) {
      var R = new ot();
      return R.ownerDocument = this, R.name = z, R.nodeName = z, R.localName = z, R.specified = !0, R;
    },
    createEntityReference: function(z) {
      var R = new Mi();
      return R.ownerDocument = this, R.nodeName = z, R;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(z, R) {
      var Q = new Ge(), de = R.split(":"), Fe = Q.attributes = new q();
      return Q.childNodes = new H(), Q.ownerDocument = this, Q.nodeName = R, Q.tagName = R, Q.namespaceURI = z, de.length == 2 ? (Q.prefix = de[0], Q.localName = de[1]) : Q.localName = R, Fe._ownerElement = Q, Q;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(z, R) {
      var Q = new ot(), de = R.split(":");
      return Q.ownerDocument = this, Q.nodeName = R, Q.name = R, Q.namespaceURI = z, Q.specified = !0, de.length == 2 ? (Q.prefix = de[0], Q.localName = de[1]) : Q.localName = R, Q;
    }
  }, u(ce, $);
  function Ge() {
    this._nsMap = {};
  }
  Ge.prototype = {
    nodeType: c,
    hasAttribute: function(z) {
      return this.getAttributeNode(z) != null;
    },
    getAttribute: function(z) {
      var R = this.getAttributeNode(z);
      return R && R.value || "";
    },
    getAttributeNode: function(z) {
      return this.attributes.getNamedItem(z);
    },
    setAttribute: function(z, R) {
      var Q = this.ownerDocument.createAttribute(z);
      Q.value = Q.nodeValue = "" + R, this.setAttributeNode(Q);
    },
    removeAttribute: function(z) {
      var R = this.getAttributeNode(z);
      R && this.removeAttributeNode(R);
    },
    //four real opeartion method
    appendChild: function(z) {
      return z.nodeType === I ? this.insertBefore(z, null) : He(this, z);
    },
    setAttributeNode: function(z) {
      return this.attributes.setNamedItem(z);
    },
    setAttributeNodeNS: function(z) {
      return this.attributes.setNamedItemNS(z);
    },
    removeAttributeNode: function(z) {
      return this.attributes.removeNamedItem(z.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(z, R) {
      var Q = this.getAttributeNodeNS(z, R);
      Q && this.removeAttributeNode(Q);
    },
    hasAttributeNS: function(z, R) {
      return this.getAttributeNodeNS(z, R) != null;
    },
    getAttributeNS: function(z, R) {
      var Q = this.getAttributeNodeNS(z, R);
      return Q && Q.value || "";
    },
    setAttributeNS: function(z, R, Q) {
      var de = this.ownerDocument.createAttributeNS(z, R);
      de.value = de.nodeValue = "" + Q, this.setAttributeNode(de);
    },
    getAttributeNodeNS: function(z, R) {
      return this.attributes.getNamedItemNS(z, R);
    },
    getElementsByTagName: function(z) {
      return new O(this, function(R) {
        var Q = [];
        return ae(R, function(de) {
          de !== R && de.nodeType == c && (z === "*" || de.tagName == z) && Q.push(de);
        }), Q;
      });
    },
    getElementsByTagNameNS: function(z, R) {
      return new O(this, function(Q) {
        var de = [];
        return ae(Q, function(Fe) {
          Fe !== Q && Fe.nodeType === c && (z === "*" || Fe.namespaceURI === z) && (R === "*" || Fe.localName == R) && de.push(Fe);
        }), de;
      });
    }
  }, ce.prototype.getElementsByTagName = Ge.prototype.getElementsByTagName, ce.prototype.getElementsByTagNameNS = Ge.prototype.getElementsByTagNameNS, u(Ge, $);
  function ot() {
  }
  ot.prototype.nodeType = A, u(ot, $);
  function he() {
  }
  he.prototype = {
    data: "",
    substringData: function(z, R) {
      return this.data.substring(z, z + R);
    },
    appendData: function(z) {
      z = this.data + z, this.nodeValue = this.data = z, this.length = z.length;
    },
    insertData: function(z, R) {
      this.replaceData(z, 0, R);
    },
    appendChild: function(z) {
      throw new Error(N[x]);
    },
    deleteData: function(z, R) {
      this.replaceData(z, R, "");
    },
    replaceData: function(z, R, Q) {
      var de = this.data.substring(0, z), Fe = this.data.substring(z + R);
      Q = de + Q + Fe, this.nodeValue = this.data = Q, this.length = Q.length;
    }
  }, u(he, $);
  function Re() {
  }
  Re.prototype = {
    nodeName: "#text",
    nodeType: m,
    splitText: function(z) {
      var R = this.data, Q = R.substring(z);
      R = R.substring(0, z), this.data = this.nodeValue = R, this.length = R.length;
      var de = this.ownerDocument.createTextNode(Q);
      return this.parentNode && this.parentNode.insertBefore(de, this.nextSibling), de;
    }
  }, u(Re, he);
  function dt() {
  }
  dt.prototype = {
    nodeName: "#comment",
    nodeType: b
  }, u(dt, he);
  function St() {
  }
  St.prototype = {
    nodeName: "#cdata-section",
    nodeType: p
  }, u(St, he);
  function Rt() {
  }
  Rt.prototype.nodeType = D, u(Rt, $);
  function je() {
  }
  je.prototype.nodeType = M, u(je, $);
  function Et() {
  }
  Et.prototype.nodeType = g, u(Et, $);
  function Mi() {
  }
  Mi.prototype.nodeType = h, u(Mi, $);
  function zn() {
  }
  zn.prototype.nodeName = "#document-fragment", zn.prototype.nodeType = I, u(zn, $);
  function xt() {
  }
  xt.prototype.nodeType = w, u(xt, $);
  function Gs() {
  }
  Gs.prototype.serializeToString = function(z, R, Q) {
    return Un.call(z, R, Q);
  }, $.prototype.toString = Un;
  function Un(z, R) {
    var Q = [], de = this.nodeType == 9 && this.documentElement || this, Fe = de.prefix, Ze = de.namespaceURI;
    if (Ze && Fe == null) {
      var Fe = de.lookupPrefix(Ze);
      if (Fe == null)
        var bt = [
          { namespace: Ze, prefix: null }
          //{namespace:uri,prefix:''}
        ];
    }
    return Cn(this, Q, z, R, bt), Q.join("");
  }
  function Qs(z, R, Q) {
    var de = z.prefix || "", Fe = z.namespaceURI;
    if (!Fe || de === "xml" && Fe === i.XML || Fe === i.XMLNS)
      return !1;
    for (var Ze = Q.length; Ze--; ) {
      var bt = Q[Ze];
      if (bt.prefix === de)
        return bt.namespace !== Fe;
    }
    return !0;
  }
  function Ps(z, R, Q) {
    z.push(" ", R, '="', Q.replace(/[<>&"\t\n\r]/g, ye), '"');
  }
  function Cn(z, R, Q, de, Fe) {
    if (Fe || (Fe = []), de)
      if (z = de(z), z) {
        if (typeof z == "string") {
          R.push(z);
          return;
        }
      } else
        return;
    switch (z.nodeType) {
      case c:
        var Ze = z.attributes, bt = Ze.length, di = z.firstChild, Vt = z.tagName;
        Q = i.isHTML(z.namespaceURI) || Q;
        var Xi = Vt;
        if (!Q && !z.prefix && z.namespaceURI) {
          for (var En, Vn = 0; Vn < Ze.length; Vn++)
            if (Ze.item(Vn).name === "xmlns") {
              En = Ze.item(Vn).value;
              break;
            }
          if (!En)
            for (var ls = Fe.length - 1; ls >= 0; ls--) {
              var qn = Fe[ls];
              if (qn.prefix === "" && qn.namespace === z.namespaceURI) {
                En = qn.namespace;
                break;
              }
            }
          if (En !== z.namespaceURI)
            for (var ls = Fe.length - 1; ls >= 0; ls--) {
              var qn = Fe[ls];
              if (qn.namespace === z.namespaceURI) {
                qn.prefix && (Xi = qn.prefix + ":" + Vt);
                break;
              }
            }
        }
        R.push("<", Xi);
        for (var Dn = 0; Dn < bt; Dn++) {
          var qt = Ze.item(Dn);
          qt.prefix == "xmlns" ? Fe.push({ prefix: qt.localName, namespace: qt.value }) : qt.nodeName == "xmlns" && Fe.push({ prefix: "", namespace: qt.value });
        }
        for (var Dn = 0; Dn < bt; Dn++) {
          var qt = Ze.item(Dn);
          if (Qs(qt, Q, Fe)) {
            var Is = qt.prefix || "", Cr = qt.namespaceURI;
            Ps(R, Is ? "xmlns:" + Is : "xmlns", Cr), Fe.push({ prefix: Is, namespace: Cr });
          }
          Cn(qt, R, Q, de, Fe);
        }
        if (Vt === Xi && Qs(z, Q, Fe)) {
          var Is = z.prefix || "", Cr = z.namespaceURI;
          Ps(R, Is ? "xmlns:" + Is : "xmlns", Cr), Fe.push({ prefix: Is, namespace: Cr });
        }
        if (di || Q && !/^(?:meta|link|img|br|hr|input)$/i.test(Vt)) {
          if (R.push(">"), Q && /^script$/i.test(Vt))
            for (; di; )
              di.data ? R.push(di.data) : Cn(di, R, Q, de, Fe.slice()), di = di.nextSibling;
          else
            for (; di; )
              Cn(di, R, Q, de, Fe.slice()), di = di.nextSibling;
          R.push("</", Xi, ">");
        } else
          R.push("/>");
        return;
      case y:
      case I:
        for (var di = z.firstChild; di; )
          Cn(di, R, Q, de, Fe.slice()), di = di.nextSibling;
        return;
      case A:
        return Ps(R, z.name, z.value);
      case m:
        return R.push(
          z.data.replace(/[<&>]/g, ye)
        );
      case p:
        return R.push("<![CDATA[", z.data, "]]>");
      case b:
        return R.push("<!--", z.data, "-->");
      case D:
        var _n = z.publicId, Hn = z.systemId;
        if (R.push("<!DOCTYPE ", z.name), _n)
          R.push(" PUBLIC ", _n), Hn && Hn != "." && R.push(" ", Hn), R.push(">");
        else if (Hn && Hn != ".")
          R.push(" SYSTEM ", Hn, ">");
        else {
          var Dt = z.internalSubset;
          Dt && R.push(" [", Dt, "]"), R.push(">");
        }
        return;
      case w:
        return R.push("<?", z.target, " ", z.data, "?>");
      case h:
        return R.push("&", z.nodeName, ";");
      //case ENTITY_NODE:
      //case NOTATION_NODE:
      default:
        R.push("??", z.nodeName);
    }
  }
  function me(z, R, Q) {
    var de;
    switch (R.nodeType) {
      case c:
        de = R.cloneNode(!1), de.ownerDocument = z;
      //var attrs = node2.attributes;
      //var len = attrs.length;
      //for(var i=0;i<len;i++){
      //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
      //}
      case I:
        break;
      case A:
        Q = !0;
        break;
    }
    if (de || (de = R.cloneNode(!1)), de.ownerDocument = z, de.parentNode = null, Q)
      for (var Fe = R.firstChild; Fe; )
        de.appendChild(me(z, Fe, Q)), Fe = Fe.nextSibling;
    return de;
  }
  function Le(z, R, Q) {
    var de = new R.constructor();
    for (var Fe in R)
      if (Object.prototype.hasOwnProperty.call(R, Fe)) {
        var Ze = R[Fe];
        typeof Ze != "object" && Ze != de[Fe] && (de[Fe] = Ze);
      }
    switch (R.childNodes && (de.childNodes = new H()), de.ownerDocument = z, de.nodeType) {
      case c:
        var bt = R.attributes, Vt = de.attributes = new q(), Xi = bt.length;
        Vt._ownerElement = de;
        for (var En = 0; En < Xi; En++)
          de.setAttributeNode(Le(z, bt.item(En), !0));
        break;
      case A:
        Q = !0;
    }
    if (Q)
      for (var Vn = R.firstChild; Vn; )
        de.appendChild(Le(z, Vn, Q)), Vn = Vn.nextSibling;
    return de;
  }
  function Je(z, R, Q) {
    z[R] = Q;
  }
  try {
    if (Object.defineProperty) {
      let z = function(R) {
        switch (R.nodeType) {
          case c:
          case I:
            var Q = [];
            for (R = R.firstChild; R; )
              R.nodeType !== 7 && R.nodeType !== 8 && Q.push(z(R)), R = R.nextSibling;
            return Q.join("");
          default:
            return R.nodeValue;
        }
      };
      Object.defineProperty(O.prototype, "length", {
        get: function() {
          return X(this), this.$$length;
        }
      }), Object.defineProperty($.prototype, "textContent", {
        get: function() {
          return z(this);
        },
        set: function(R) {
          switch (this.nodeType) {
            case c:
            case I:
              for (; this.firstChild; )
                this.removeChild(this.firstChild);
              (R || String(R)) && this.appendChild(this.ownerDocument.createTextNode(R));
              break;
            default:
              this.data = R, this.value = R, this.nodeValue = R;
          }
        }
      }), Je = function(R, Q, de) {
        R["$$" + Q] = de;
      };
    }
  } catch {
  }
  return Os.DocumentType = Rt, Os.DOMException = V, Os.DOMImplementation = oe, Os.Element = Ge, Os.Node = $, Os.NodeList = H, Os.XMLSerializer = Gs, Os;
}
var jo = {}, Of = {}, Hg;
function I6() {
  return Hg || (Hg = 1, function(t) {
    var e = $d().freeze;
    t.XML_ENTITIES = e({
      amp: "&",
      apos: "'",
      gt: ">",
      lt: "<",
      quot: '"'
    }), t.HTML_ENTITIES = e({
      Aacute: "Á",
      aacute: "á",
      Abreve: "Ă",
      abreve: "ă",
      ac: "∾",
      acd: "∿",
      acE: "∾̳",
      Acirc: "Â",
      acirc: "â",
      acute: "´",
      Acy: "А",
      acy: "а",
      AElig: "Æ",
      aelig: "æ",
      af: "⁡",
      Afr: "𝔄",
      afr: "𝔞",
      Agrave: "À",
      agrave: "à",
      alefsym: "ℵ",
      aleph: "ℵ",
      Alpha: "Α",
      alpha: "α",
      Amacr: "Ā",
      amacr: "ā",
      amalg: "⨿",
      AMP: "&",
      amp: "&",
      And: "⩓",
      and: "∧",
      andand: "⩕",
      andd: "⩜",
      andslope: "⩘",
      andv: "⩚",
      ang: "∠",
      ange: "⦤",
      angle: "∠",
      angmsd: "∡",
      angmsdaa: "⦨",
      angmsdab: "⦩",
      angmsdac: "⦪",
      angmsdad: "⦫",
      angmsdae: "⦬",
      angmsdaf: "⦭",
      angmsdag: "⦮",
      angmsdah: "⦯",
      angrt: "∟",
      angrtvb: "⊾",
      angrtvbd: "⦝",
      angsph: "∢",
      angst: "Å",
      angzarr: "⍼",
      Aogon: "Ą",
      aogon: "ą",
      Aopf: "𝔸",
      aopf: "𝕒",
      ap: "≈",
      apacir: "⩯",
      apE: "⩰",
      ape: "≊",
      apid: "≋",
      apos: "'",
      ApplyFunction: "⁡",
      approx: "≈",
      approxeq: "≊",
      Aring: "Å",
      aring: "å",
      Ascr: "𝒜",
      ascr: "𝒶",
      Assign: "≔",
      ast: "*",
      asymp: "≈",
      asympeq: "≍",
      Atilde: "Ã",
      atilde: "ã",
      Auml: "Ä",
      auml: "ä",
      awconint: "∳",
      awint: "⨑",
      backcong: "≌",
      backepsilon: "϶",
      backprime: "‵",
      backsim: "∽",
      backsimeq: "⋍",
      Backslash: "∖",
      Barv: "⫧",
      barvee: "⊽",
      Barwed: "⌆",
      barwed: "⌅",
      barwedge: "⌅",
      bbrk: "⎵",
      bbrktbrk: "⎶",
      bcong: "≌",
      Bcy: "Б",
      bcy: "б",
      bdquo: "„",
      becaus: "∵",
      Because: "∵",
      because: "∵",
      bemptyv: "⦰",
      bepsi: "϶",
      bernou: "ℬ",
      Bernoullis: "ℬ",
      Beta: "Β",
      beta: "β",
      beth: "ℶ",
      between: "≬",
      Bfr: "𝔅",
      bfr: "𝔟",
      bigcap: "⋂",
      bigcirc: "◯",
      bigcup: "⋃",
      bigodot: "⨀",
      bigoplus: "⨁",
      bigotimes: "⨂",
      bigsqcup: "⨆",
      bigstar: "★",
      bigtriangledown: "▽",
      bigtriangleup: "△",
      biguplus: "⨄",
      bigvee: "⋁",
      bigwedge: "⋀",
      bkarow: "⤍",
      blacklozenge: "⧫",
      blacksquare: "▪",
      blacktriangle: "▴",
      blacktriangledown: "▾",
      blacktriangleleft: "◂",
      blacktriangleright: "▸",
      blank: "␣",
      blk12: "▒",
      blk14: "░",
      blk34: "▓",
      block: "█",
      bne: "=⃥",
      bnequiv: "≡⃥",
      bNot: "⫭",
      bnot: "⌐",
      Bopf: "𝔹",
      bopf: "𝕓",
      bot: "⊥",
      bottom: "⊥",
      bowtie: "⋈",
      boxbox: "⧉",
      boxDL: "╗",
      boxDl: "╖",
      boxdL: "╕",
      boxdl: "┐",
      boxDR: "╔",
      boxDr: "╓",
      boxdR: "╒",
      boxdr: "┌",
      boxH: "═",
      boxh: "─",
      boxHD: "╦",
      boxHd: "╤",
      boxhD: "╥",
      boxhd: "┬",
      boxHU: "╩",
      boxHu: "╧",
      boxhU: "╨",
      boxhu: "┴",
      boxminus: "⊟",
      boxplus: "⊞",
      boxtimes: "⊠",
      boxUL: "╝",
      boxUl: "╜",
      boxuL: "╛",
      boxul: "┘",
      boxUR: "╚",
      boxUr: "╙",
      boxuR: "╘",
      boxur: "└",
      boxV: "║",
      boxv: "│",
      boxVH: "╬",
      boxVh: "╫",
      boxvH: "╪",
      boxvh: "┼",
      boxVL: "╣",
      boxVl: "╢",
      boxvL: "╡",
      boxvl: "┤",
      boxVR: "╠",
      boxVr: "╟",
      boxvR: "╞",
      boxvr: "├",
      bprime: "‵",
      Breve: "˘",
      breve: "˘",
      brvbar: "¦",
      Bscr: "ℬ",
      bscr: "𝒷",
      bsemi: "⁏",
      bsim: "∽",
      bsime: "⋍",
      bsol: "\\",
      bsolb: "⧅",
      bsolhsub: "⟈",
      bull: "•",
      bullet: "•",
      bump: "≎",
      bumpE: "⪮",
      bumpe: "≏",
      Bumpeq: "≎",
      bumpeq: "≏",
      Cacute: "Ć",
      cacute: "ć",
      Cap: "⋒",
      cap: "∩",
      capand: "⩄",
      capbrcup: "⩉",
      capcap: "⩋",
      capcup: "⩇",
      capdot: "⩀",
      CapitalDifferentialD: "ⅅ",
      caps: "∩︀",
      caret: "⁁",
      caron: "ˇ",
      Cayleys: "ℭ",
      ccaps: "⩍",
      Ccaron: "Č",
      ccaron: "č",
      Ccedil: "Ç",
      ccedil: "ç",
      Ccirc: "Ĉ",
      ccirc: "ĉ",
      Cconint: "∰",
      ccups: "⩌",
      ccupssm: "⩐",
      Cdot: "Ċ",
      cdot: "ċ",
      cedil: "¸",
      Cedilla: "¸",
      cemptyv: "⦲",
      cent: "¢",
      CenterDot: "·",
      centerdot: "·",
      Cfr: "ℭ",
      cfr: "𝔠",
      CHcy: "Ч",
      chcy: "ч",
      check: "✓",
      checkmark: "✓",
      Chi: "Χ",
      chi: "χ",
      cir: "○",
      circ: "ˆ",
      circeq: "≗",
      circlearrowleft: "↺",
      circlearrowright: "↻",
      circledast: "⊛",
      circledcirc: "⊚",
      circleddash: "⊝",
      CircleDot: "⊙",
      circledR: "®",
      circledS: "Ⓢ",
      CircleMinus: "⊖",
      CirclePlus: "⊕",
      CircleTimes: "⊗",
      cirE: "⧃",
      cire: "≗",
      cirfnint: "⨐",
      cirmid: "⫯",
      cirscir: "⧂",
      ClockwiseContourIntegral: "∲",
      CloseCurlyDoubleQuote: "”",
      CloseCurlyQuote: "’",
      clubs: "♣",
      clubsuit: "♣",
      Colon: "∷",
      colon: ":",
      Colone: "⩴",
      colone: "≔",
      coloneq: "≔",
      comma: ",",
      commat: "@",
      comp: "∁",
      compfn: "∘",
      complement: "∁",
      complexes: "ℂ",
      cong: "≅",
      congdot: "⩭",
      Congruent: "≡",
      Conint: "∯",
      conint: "∮",
      ContourIntegral: "∮",
      Copf: "ℂ",
      copf: "𝕔",
      coprod: "∐",
      Coproduct: "∐",
      COPY: "©",
      copy: "©",
      copysr: "℗",
      CounterClockwiseContourIntegral: "∳",
      crarr: "↵",
      Cross: "⨯",
      cross: "✗",
      Cscr: "𝒞",
      cscr: "𝒸",
      csub: "⫏",
      csube: "⫑",
      csup: "⫐",
      csupe: "⫒",
      ctdot: "⋯",
      cudarrl: "⤸",
      cudarrr: "⤵",
      cuepr: "⋞",
      cuesc: "⋟",
      cularr: "↶",
      cularrp: "⤽",
      Cup: "⋓",
      cup: "∪",
      cupbrcap: "⩈",
      CupCap: "≍",
      cupcap: "⩆",
      cupcup: "⩊",
      cupdot: "⊍",
      cupor: "⩅",
      cups: "∪︀",
      curarr: "↷",
      curarrm: "⤼",
      curlyeqprec: "⋞",
      curlyeqsucc: "⋟",
      curlyvee: "⋎",
      curlywedge: "⋏",
      curren: "¤",
      curvearrowleft: "↶",
      curvearrowright: "↷",
      cuvee: "⋎",
      cuwed: "⋏",
      cwconint: "∲",
      cwint: "∱",
      cylcty: "⌭",
      Dagger: "‡",
      dagger: "†",
      daleth: "ℸ",
      Darr: "↡",
      dArr: "⇓",
      darr: "↓",
      dash: "‐",
      Dashv: "⫤",
      dashv: "⊣",
      dbkarow: "⤏",
      dblac: "˝",
      Dcaron: "Ď",
      dcaron: "ď",
      Dcy: "Д",
      dcy: "д",
      DD: "ⅅ",
      dd: "ⅆ",
      ddagger: "‡",
      ddarr: "⇊",
      DDotrahd: "⤑",
      ddotseq: "⩷",
      deg: "°",
      Del: "∇",
      Delta: "Δ",
      delta: "δ",
      demptyv: "⦱",
      dfisht: "⥿",
      Dfr: "𝔇",
      dfr: "𝔡",
      dHar: "⥥",
      dharl: "⇃",
      dharr: "⇂",
      DiacriticalAcute: "´",
      DiacriticalDot: "˙",
      DiacriticalDoubleAcute: "˝",
      DiacriticalGrave: "`",
      DiacriticalTilde: "˜",
      diam: "⋄",
      Diamond: "⋄",
      diamond: "⋄",
      diamondsuit: "♦",
      diams: "♦",
      die: "¨",
      DifferentialD: "ⅆ",
      digamma: "ϝ",
      disin: "⋲",
      div: "÷",
      divide: "÷",
      divideontimes: "⋇",
      divonx: "⋇",
      DJcy: "Ђ",
      djcy: "ђ",
      dlcorn: "⌞",
      dlcrop: "⌍",
      dollar: "$",
      Dopf: "𝔻",
      dopf: "𝕕",
      Dot: "¨",
      dot: "˙",
      DotDot: "⃜",
      doteq: "≐",
      doteqdot: "≑",
      DotEqual: "≐",
      dotminus: "∸",
      dotplus: "∔",
      dotsquare: "⊡",
      doublebarwedge: "⌆",
      DoubleContourIntegral: "∯",
      DoubleDot: "¨",
      DoubleDownArrow: "⇓",
      DoubleLeftArrow: "⇐",
      DoubleLeftRightArrow: "⇔",
      DoubleLeftTee: "⫤",
      DoubleLongLeftArrow: "⟸",
      DoubleLongLeftRightArrow: "⟺",
      DoubleLongRightArrow: "⟹",
      DoubleRightArrow: "⇒",
      DoubleRightTee: "⊨",
      DoubleUpArrow: "⇑",
      DoubleUpDownArrow: "⇕",
      DoubleVerticalBar: "∥",
      DownArrow: "↓",
      Downarrow: "⇓",
      downarrow: "↓",
      DownArrowBar: "⤓",
      DownArrowUpArrow: "⇵",
      DownBreve: "̑",
      downdownarrows: "⇊",
      downharpoonleft: "⇃",
      downharpoonright: "⇂",
      DownLeftRightVector: "⥐",
      DownLeftTeeVector: "⥞",
      DownLeftVector: "↽",
      DownLeftVectorBar: "⥖",
      DownRightTeeVector: "⥟",
      DownRightVector: "⇁",
      DownRightVectorBar: "⥗",
      DownTee: "⊤",
      DownTeeArrow: "↧",
      drbkarow: "⤐",
      drcorn: "⌟",
      drcrop: "⌌",
      Dscr: "𝒟",
      dscr: "𝒹",
      DScy: "Ѕ",
      dscy: "ѕ",
      dsol: "⧶",
      Dstrok: "Đ",
      dstrok: "đ",
      dtdot: "⋱",
      dtri: "▿",
      dtrif: "▾",
      duarr: "⇵",
      duhar: "⥯",
      dwangle: "⦦",
      DZcy: "Џ",
      dzcy: "џ",
      dzigrarr: "⟿",
      Eacute: "É",
      eacute: "é",
      easter: "⩮",
      Ecaron: "Ě",
      ecaron: "ě",
      ecir: "≖",
      Ecirc: "Ê",
      ecirc: "ê",
      ecolon: "≕",
      Ecy: "Э",
      ecy: "э",
      eDDot: "⩷",
      Edot: "Ė",
      eDot: "≑",
      edot: "ė",
      ee: "ⅇ",
      efDot: "≒",
      Efr: "𝔈",
      efr: "𝔢",
      eg: "⪚",
      Egrave: "È",
      egrave: "è",
      egs: "⪖",
      egsdot: "⪘",
      el: "⪙",
      Element: "∈",
      elinters: "⏧",
      ell: "ℓ",
      els: "⪕",
      elsdot: "⪗",
      Emacr: "Ē",
      emacr: "ē",
      empty: "∅",
      emptyset: "∅",
      EmptySmallSquare: "◻",
      emptyv: "∅",
      EmptyVerySmallSquare: "▫",
      emsp: " ",
      emsp13: " ",
      emsp14: " ",
      ENG: "Ŋ",
      eng: "ŋ",
      ensp: " ",
      Eogon: "Ę",
      eogon: "ę",
      Eopf: "𝔼",
      eopf: "𝕖",
      epar: "⋕",
      eparsl: "⧣",
      eplus: "⩱",
      epsi: "ε",
      Epsilon: "Ε",
      epsilon: "ε",
      epsiv: "ϵ",
      eqcirc: "≖",
      eqcolon: "≕",
      eqsim: "≂",
      eqslantgtr: "⪖",
      eqslantless: "⪕",
      Equal: "⩵",
      equals: "=",
      EqualTilde: "≂",
      equest: "≟",
      Equilibrium: "⇌",
      equiv: "≡",
      equivDD: "⩸",
      eqvparsl: "⧥",
      erarr: "⥱",
      erDot: "≓",
      Escr: "ℰ",
      escr: "ℯ",
      esdot: "≐",
      Esim: "⩳",
      esim: "≂",
      Eta: "Η",
      eta: "η",
      ETH: "Ð",
      eth: "ð",
      Euml: "Ë",
      euml: "ë",
      euro: "€",
      excl: "!",
      exist: "∃",
      Exists: "∃",
      expectation: "ℰ",
      ExponentialE: "ⅇ",
      exponentiale: "ⅇ",
      fallingdotseq: "≒",
      Fcy: "Ф",
      fcy: "ф",
      female: "♀",
      ffilig: "ﬃ",
      fflig: "ﬀ",
      ffllig: "ﬄ",
      Ffr: "𝔉",
      ffr: "𝔣",
      filig: "ﬁ",
      FilledSmallSquare: "◼",
      FilledVerySmallSquare: "▪",
      fjlig: "fj",
      flat: "♭",
      fllig: "ﬂ",
      fltns: "▱",
      fnof: "ƒ",
      Fopf: "𝔽",
      fopf: "𝕗",
      ForAll: "∀",
      forall: "∀",
      fork: "⋔",
      forkv: "⫙",
      Fouriertrf: "ℱ",
      fpartint: "⨍",
      frac12: "½",
      frac13: "⅓",
      frac14: "¼",
      frac15: "⅕",
      frac16: "⅙",
      frac18: "⅛",
      frac23: "⅔",
      frac25: "⅖",
      frac34: "¾",
      frac35: "⅗",
      frac38: "⅜",
      frac45: "⅘",
      frac56: "⅚",
      frac58: "⅝",
      frac78: "⅞",
      frasl: "⁄",
      frown: "⌢",
      Fscr: "ℱ",
      fscr: "𝒻",
      gacute: "ǵ",
      Gamma: "Γ",
      gamma: "γ",
      Gammad: "Ϝ",
      gammad: "ϝ",
      gap: "⪆",
      Gbreve: "Ğ",
      gbreve: "ğ",
      Gcedil: "Ģ",
      Gcirc: "Ĝ",
      gcirc: "ĝ",
      Gcy: "Г",
      gcy: "г",
      Gdot: "Ġ",
      gdot: "ġ",
      gE: "≧",
      ge: "≥",
      gEl: "⪌",
      gel: "⋛",
      geq: "≥",
      geqq: "≧",
      geqslant: "⩾",
      ges: "⩾",
      gescc: "⪩",
      gesdot: "⪀",
      gesdoto: "⪂",
      gesdotol: "⪄",
      gesl: "⋛︀",
      gesles: "⪔",
      Gfr: "𝔊",
      gfr: "𝔤",
      Gg: "⋙",
      gg: "≫",
      ggg: "⋙",
      gimel: "ℷ",
      GJcy: "Ѓ",
      gjcy: "ѓ",
      gl: "≷",
      gla: "⪥",
      glE: "⪒",
      glj: "⪤",
      gnap: "⪊",
      gnapprox: "⪊",
      gnE: "≩",
      gne: "⪈",
      gneq: "⪈",
      gneqq: "≩",
      gnsim: "⋧",
      Gopf: "𝔾",
      gopf: "𝕘",
      grave: "`",
      GreaterEqual: "≥",
      GreaterEqualLess: "⋛",
      GreaterFullEqual: "≧",
      GreaterGreater: "⪢",
      GreaterLess: "≷",
      GreaterSlantEqual: "⩾",
      GreaterTilde: "≳",
      Gscr: "𝒢",
      gscr: "ℊ",
      gsim: "≳",
      gsime: "⪎",
      gsiml: "⪐",
      Gt: "≫",
      GT: ">",
      gt: ">",
      gtcc: "⪧",
      gtcir: "⩺",
      gtdot: "⋗",
      gtlPar: "⦕",
      gtquest: "⩼",
      gtrapprox: "⪆",
      gtrarr: "⥸",
      gtrdot: "⋗",
      gtreqless: "⋛",
      gtreqqless: "⪌",
      gtrless: "≷",
      gtrsim: "≳",
      gvertneqq: "≩︀",
      gvnE: "≩︀",
      Hacek: "ˇ",
      hairsp: " ",
      half: "½",
      hamilt: "ℋ",
      HARDcy: "Ъ",
      hardcy: "ъ",
      hArr: "⇔",
      harr: "↔",
      harrcir: "⥈",
      harrw: "↭",
      Hat: "^",
      hbar: "ℏ",
      Hcirc: "Ĥ",
      hcirc: "ĥ",
      hearts: "♥",
      heartsuit: "♥",
      hellip: "…",
      hercon: "⊹",
      Hfr: "ℌ",
      hfr: "𝔥",
      HilbertSpace: "ℋ",
      hksearow: "⤥",
      hkswarow: "⤦",
      hoarr: "⇿",
      homtht: "∻",
      hookleftarrow: "↩",
      hookrightarrow: "↪",
      Hopf: "ℍ",
      hopf: "𝕙",
      horbar: "―",
      HorizontalLine: "─",
      Hscr: "ℋ",
      hscr: "𝒽",
      hslash: "ℏ",
      Hstrok: "Ħ",
      hstrok: "ħ",
      HumpDownHump: "≎",
      HumpEqual: "≏",
      hybull: "⁃",
      hyphen: "‐",
      Iacute: "Í",
      iacute: "í",
      ic: "⁣",
      Icirc: "Î",
      icirc: "î",
      Icy: "И",
      icy: "и",
      Idot: "İ",
      IEcy: "Е",
      iecy: "е",
      iexcl: "¡",
      iff: "⇔",
      Ifr: "ℑ",
      ifr: "𝔦",
      Igrave: "Ì",
      igrave: "ì",
      ii: "ⅈ",
      iiiint: "⨌",
      iiint: "∭",
      iinfin: "⧜",
      iiota: "℩",
      IJlig: "Ĳ",
      ijlig: "ĳ",
      Im: "ℑ",
      Imacr: "Ī",
      imacr: "ī",
      image: "ℑ",
      ImaginaryI: "ⅈ",
      imagline: "ℐ",
      imagpart: "ℑ",
      imath: "ı",
      imof: "⊷",
      imped: "Ƶ",
      Implies: "⇒",
      in: "∈",
      incare: "℅",
      infin: "∞",
      infintie: "⧝",
      inodot: "ı",
      Int: "∬",
      int: "∫",
      intcal: "⊺",
      integers: "ℤ",
      Integral: "∫",
      intercal: "⊺",
      Intersection: "⋂",
      intlarhk: "⨗",
      intprod: "⨼",
      InvisibleComma: "⁣",
      InvisibleTimes: "⁢",
      IOcy: "Ё",
      iocy: "ё",
      Iogon: "Į",
      iogon: "į",
      Iopf: "𝕀",
      iopf: "𝕚",
      Iota: "Ι",
      iota: "ι",
      iprod: "⨼",
      iquest: "¿",
      Iscr: "ℐ",
      iscr: "𝒾",
      isin: "∈",
      isindot: "⋵",
      isinE: "⋹",
      isins: "⋴",
      isinsv: "⋳",
      isinv: "∈",
      it: "⁢",
      Itilde: "Ĩ",
      itilde: "ĩ",
      Iukcy: "І",
      iukcy: "і",
      Iuml: "Ï",
      iuml: "ï",
      Jcirc: "Ĵ",
      jcirc: "ĵ",
      Jcy: "Й",
      jcy: "й",
      Jfr: "𝔍",
      jfr: "𝔧",
      jmath: "ȷ",
      Jopf: "𝕁",
      jopf: "𝕛",
      Jscr: "𝒥",
      jscr: "𝒿",
      Jsercy: "Ј",
      jsercy: "ј",
      Jukcy: "Є",
      jukcy: "є",
      Kappa: "Κ",
      kappa: "κ",
      kappav: "ϰ",
      Kcedil: "Ķ",
      kcedil: "ķ",
      Kcy: "К",
      kcy: "к",
      Kfr: "𝔎",
      kfr: "𝔨",
      kgreen: "ĸ",
      KHcy: "Х",
      khcy: "х",
      KJcy: "Ќ",
      kjcy: "ќ",
      Kopf: "𝕂",
      kopf: "𝕜",
      Kscr: "𝒦",
      kscr: "𝓀",
      lAarr: "⇚",
      Lacute: "Ĺ",
      lacute: "ĺ",
      laemptyv: "⦴",
      lagran: "ℒ",
      Lambda: "Λ",
      lambda: "λ",
      Lang: "⟪",
      lang: "⟨",
      langd: "⦑",
      langle: "⟨",
      lap: "⪅",
      Laplacetrf: "ℒ",
      laquo: "«",
      Larr: "↞",
      lArr: "⇐",
      larr: "←",
      larrb: "⇤",
      larrbfs: "⤟",
      larrfs: "⤝",
      larrhk: "↩",
      larrlp: "↫",
      larrpl: "⤹",
      larrsim: "⥳",
      larrtl: "↢",
      lat: "⪫",
      lAtail: "⤛",
      latail: "⤙",
      late: "⪭",
      lates: "⪭︀",
      lBarr: "⤎",
      lbarr: "⤌",
      lbbrk: "❲",
      lbrace: "{",
      lbrack: "[",
      lbrke: "⦋",
      lbrksld: "⦏",
      lbrkslu: "⦍",
      Lcaron: "Ľ",
      lcaron: "ľ",
      Lcedil: "Ļ",
      lcedil: "ļ",
      lceil: "⌈",
      lcub: "{",
      Lcy: "Л",
      lcy: "л",
      ldca: "⤶",
      ldquo: "“",
      ldquor: "„",
      ldrdhar: "⥧",
      ldrushar: "⥋",
      ldsh: "↲",
      lE: "≦",
      le: "≤",
      LeftAngleBracket: "⟨",
      LeftArrow: "←",
      Leftarrow: "⇐",
      leftarrow: "←",
      LeftArrowBar: "⇤",
      LeftArrowRightArrow: "⇆",
      leftarrowtail: "↢",
      LeftCeiling: "⌈",
      LeftDoubleBracket: "⟦",
      LeftDownTeeVector: "⥡",
      LeftDownVector: "⇃",
      LeftDownVectorBar: "⥙",
      LeftFloor: "⌊",
      leftharpoondown: "↽",
      leftharpoonup: "↼",
      leftleftarrows: "⇇",
      LeftRightArrow: "↔",
      Leftrightarrow: "⇔",
      leftrightarrow: "↔",
      leftrightarrows: "⇆",
      leftrightharpoons: "⇋",
      leftrightsquigarrow: "↭",
      LeftRightVector: "⥎",
      LeftTee: "⊣",
      LeftTeeArrow: "↤",
      LeftTeeVector: "⥚",
      leftthreetimes: "⋋",
      LeftTriangle: "⊲",
      LeftTriangleBar: "⧏",
      LeftTriangleEqual: "⊴",
      LeftUpDownVector: "⥑",
      LeftUpTeeVector: "⥠",
      LeftUpVector: "↿",
      LeftUpVectorBar: "⥘",
      LeftVector: "↼",
      LeftVectorBar: "⥒",
      lEg: "⪋",
      leg: "⋚",
      leq: "≤",
      leqq: "≦",
      leqslant: "⩽",
      les: "⩽",
      lescc: "⪨",
      lesdot: "⩿",
      lesdoto: "⪁",
      lesdotor: "⪃",
      lesg: "⋚︀",
      lesges: "⪓",
      lessapprox: "⪅",
      lessdot: "⋖",
      lesseqgtr: "⋚",
      lesseqqgtr: "⪋",
      LessEqualGreater: "⋚",
      LessFullEqual: "≦",
      LessGreater: "≶",
      lessgtr: "≶",
      LessLess: "⪡",
      lesssim: "≲",
      LessSlantEqual: "⩽",
      LessTilde: "≲",
      lfisht: "⥼",
      lfloor: "⌊",
      Lfr: "𝔏",
      lfr: "𝔩",
      lg: "≶",
      lgE: "⪑",
      lHar: "⥢",
      lhard: "↽",
      lharu: "↼",
      lharul: "⥪",
      lhblk: "▄",
      LJcy: "Љ",
      ljcy: "љ",
      Ll: "⋘",
      ll: "≪",
      llarr: "⇇",
      llcorner: "⌞",
      Lleftarrow: "⇚",
      llhard: "⥫",
      lltri: "◺",
      Lmidot: "Ŀ",
      lmidot: "ŀ",
      lmoust: "⎰",
      lmoustache: "⎰",
      lnap: "⪉",
      lnapprox: "⪉",
      lnE: "≨",
      lne: "⪇",
      lneq: "⪇",
      lneqq: "≨",
      lnsim: "⋦",
      loang: "⟬",
      loarr: "⇽",
      lobrk: "⟦",
      LongLeftArrow: "⟵",
      Longleftarrow: "⟸",
      longleftarrow: "⟵",
      LongLeftRightArrow: "⟷",
      Longleftrightarrow: "⟺",
      longleftrightarrow: "⟷",
      longmapsto: "⟼",
      LongRightArrow: "⟶",
      Longrightarrow: "⟹",
      longrightarrow: "⟶",
      looparrowleft: "↫",
      looparrowright: "↬",
      lopar: "⦅",
      Lopf: "𝕃",
      lopf: "𝕝",
      loplus: "⨭",
      lotimes: "⨴",
      lowast: "∗",
      lowbar: "_",
      LowerLeftArrow: "↙",
      LowerRightArrow: "↘",
      loz: "◊",
      lozenge: "◊",
      lozf: "⧫",
      lpar: "(",
      lparlt: "⦓",
      lrarr: "⇆",
      lrcorner: "⌟",
      lrhar: "⇋",
      lrhard: "⥭",
      lrm: "‎",
      lrtri: "⊿",
      lsaquo: "‹",
      Lscr: "ℒ",
      lscr: "𝓁",
      Lsh: "↰",
      lsh: "↰",
      lsim: "≲",
      lsime: "⪍",
      lsimg: "⪏",
      lsqb: "[",
      lsquo: "‘",
      lsquor: "‚",
      Lstrok: "Ł",
      lstrok: "ł",
      Lt: "≪",
      LT: "<",
      lt: "<",
      ltcc: "⪦",
      ltcir: "⩹",
      ltdot: "⋖",
      lthree: "⋋",
      ltimes: "⋉",
      ltlarr: "⥶",
      ltquest: "⩻",
      ltri: "◃",
      ltrie: "⊴",
      ltrif: "◂",
      ltrPar: "⦖",
      lurdshar: "⥊",
      luruhar: "⥦",
      lvertneqq: "≨︀",
      lvnE: "≨︀",
      macr: "¯",
      male: "♂",
      malt: "✠",
      maltese: "✠",
      Map: "⤅",
      map: "↦",
      mapsto: "↦",
      mapstodown: "↧",
      mapstoleft: "↤",
      mapstoup: "↥",
      marker: "▮",
      mcomma: "⨩",
      Mcy: "М",
      mcy: "м",
      mdash: "—",
      mDDot: "∺",
      measuredangle: "∡",
      MediumSpace: " ",
      Mellintrf: "ℳ",
      Mfr: "𝔐",
      mfr: "𝔪",
      mho: "℧",
      micro: "µ",
      mid: "∣",
      midast: "*",
      midcir: "⫰",
      middot: "·",
      minus: "−",
      minusb: "⊟",
      minusd: "∸",
      minusdu: "⨪",
      MinusPlus: "∓",
      mlcp: "⫛",
      mldr: "…",
      mnplus: "∓",
      models: "⊧",
      Mopf: "𝕄",
      mopf: "𝕞",
      mp: "∓",
      Mscr: "ℳ",
      mscr: "𝓂",
      mstpos: "∾",
      Mu: "Μ",
      mu: "μ",
      multimap: "⊸",
      mumap: "⊸",
      nabla: "∇",
      Nacute: "Ń",
      nacute: "ń",
      nang: "∠⃒",
      nap: "≉",
      napE: "⩰̸",
      napid: "≋̸",
      napos: "ŉ",
      napprox: "≉",
      natur: "♮",
      natural: "♮",
      naturals: "ℕ",
      nbsp: " ",
      nbump: "≎̸",
      nbumpe: "≏̸",
      ncap: "⩃",
      Ncaron: "Ň",
      ncaron: "ň",
      Ncedil: "Ņ",
      ncedil: "ņ",
      ncong: "≇",
      ncongdot: "⩭̸",
      ncup: "⩂",
      Ncy: "Н",
      ncy: "н",
      ndash: "–",
      ne: "≠",
      nearhk: "⤤",
      neArr: "⇗",
      nearr: "↗",
      nearrow: "↗",
      nedot: "≐̸",
      NegativeMediumSpace: "​",
      NegativeThickSpace: "​",
      NegativeThinSpace: "​",
      NegativeVeryThinSpace: "​",
      nequiv: "≢",
      nesear: "⤨",
      nesim: "≂̸",
      NestedGreaterGreater: "≫",
      NestedLessLess: "≪",
      NewLine: `
`,
      nexist: "∄",
      nexists: "∄",
      Nfr: "𝔑",
      nfr: "𝔫",
      ngE: "≧̸",
      nge: "≱",
      ngeq: "≱",
      ngeqq: "≧̸",
      ngeqslant: "⩾̸",
      nges: "⩾̸",
      nGg: "⋙̸",
      ngsim: "≵",
      nGt: "≫⃒",
      ngt: "≯",
      ngtr: "≯",
      nGtv: "≫̸",
      nhArr: "⇎",
      nharr: "↮",
      nhpar: "⫲",
      ni: "∋",
      nis: "⋼",
      nisd: "⋺",
      niv: "∋",
      NJcy: "Њ",
      njcy: "њ",
      nlArr: "⇍",
      nlarr: "↚",
      nldr: "‥",
      nlE: "≦̸",
      nle: "≰",
      nLeftarrow: "⇍",
      nleftarrow: "↚",
      nLeftrightarrow: "⇎",
      nleftrightarrow: "↮",
      nleq: "≰",
      nleqq: "≦̸",
      nleqslant: "⩽̸",
      nles: "⩽̸",
      nless: "≮",
      nLl: "⋘̸",
      nlsim: "≴",
      nLt: "≪⃒",
      nlt: "≮",
      nltri: "⋪",
      nltrie: "⋬",
      nLtv: "≪̸",
      nmid: "∤",
      NoBreak: "⁠",
      NonBreakingSpace: " ",
      Nopf: "ℕ",
      nopf: "𝕟",
      Not: "⫬",
      not: "¬",
      NotCongruent: "≢",
      NotCupCap: "≭",
      NotDoubleVerticalBar: "∦",
      NotElement: "∉",
      NotEqual: "≠",
      NotEqualTilde: "≂̸",
      NotExists: "∄",
      NotGreater: "≯",
      NotGreaterEqual: "≱",
      NotGreaterFullEqual: "≧̸",
      NotGreaterGreater: "≫̸",
      NotGreaterLess: "≹",
      NotGreaterSlantEqual: "⩾̸",
      NotGreaterTilde: "≵",
      NotHumpDownHump: "≎̸",
      NotHumpEqual: "≏̸",
      notin: "∉",
      notindot: "⋵̸",
      notinE: "⋹̸",
      notinva: "∉",
      notinvb: "⋷",
      notinvc: "⋶",
      NotLeftTriangle: "⋪",
      NotLeftTriangleBar: "⧏̸",
      NotLeftTriangleEqual: "⋬",
      NotLess: "≮",
      NotLessEqual: "≰",
      NotLessGreater: "≸",
      NotLessLess: "≪̸",
      NotLessSlantEqual: "⩽̸",
      NotLessTilde: "≴",
      NotNestedGreaterGreater: "⪢̸",
      NotNestedLessLess: "⪡̸",
      notni: "∌",
      notniva: "∌",
      notnivb: "⋾",
      notnivc: "⋽",
      NotPrecedes: "⊀",
      NotPrecedesEqual: "⪯̸",
      NotPrecedesSlantEqual: "⋠",
      NotReverseElement: "∌",
      NotRightTriangle: "⋫",
      NotRightTriangleBar: "⧐̸",
      NotRightTriangleEqual: "⋭",
      NotSquareSubset: "⊏̸",
      NotSquareSubsetEqual: "⋢",
      NotSquareSuperset: "⊐̸",
      NotSquareSupersetEqual: "⋣",
      NotSubset: "⊂⃒",
      NotSubsetEqual: "⊈",
      NotSucceeds: "⊁",
      NotSucceedsEqual: "⪰̸",
      NotSucceedsSlantEqual: "⋡",
      NotSucceedsTilde: "≿̸",
      NotSuperset: "⊃⃒",
      NotSupersetEqual: "⊉",
      NotTilde: "≁",
      NotTildeEqual: "≄",
      NotTildeFullEqual: "≇",
      NotTildeTilde: "≉",
      NotVerticalBar: "∤",
      npar: "∦",
      nparallel: "∦",
      nparsl: "⫽⃥",
      npart: "∂̸",
      npolint: "⨔",
      npr: "⊀",
      nprcue: "⋠",
      npre: "⪯̸",
      nprec: "⊀",
      npreceq: "⪯̸",
      nrArr: "⇏",
      nrarr: "↛",
      nrarrc: "⤳̸",
      nrarrw: "↝̸",
      nRightarrow: "⇏",
      nrightarrow: "↛",
      nrtri: "⋫",
      nrtrie: "⋭",
      nsc: "⊁",
      nsccue: "⋡",
      nsce: "⪰̸",
      Nscr: "𝒩",
      nscr: "𝓃",
      nshortmid: "∤",
      nshortparallel: "∦",
      nsim: "≁",
      nsime: "≄",
      nsimeq: "≄",
      nsmid: "∤",
      nspar: "∦",
      nsqsube: "⋢",
      nsqsupe: "⋣",
      nsub: "⊄",
      nsubE: "⫅̸",
      nsube: "⊈",
      nsubset: "⊂⃒",
      nsubseteq: "⊈",
      nsubseteqq: "⫅̸",
      nsucc: "⊁",
      nsucceq: "⪰̸",
      nsup: "⊅",
      nsupE: "⫆̸",
      nsupe: "⊉",
      nsupset: "⊃⃒",
      nsupseteq: "⊉",
      nsupseteqq: "⫆̸",
      ntgl: "≹",
      Ntilde: "Ñ",
      ntilde: "ñ",
      ntlg: "≸",
      ntriangleleft: "⋪",
      ntrianglelefteq: "⋬",
      ntriangleright: "⋫",
      ntrianglerighteq: "⋭",
      Nu: "Ν",
      nu: "ν",
      num: "#",
      numero: "№",
      numsp: " ",
      nvap: "≍⃒",
      nVDash: "⊯",
      nVdash: "⊮",
      nvDash: "⊭",
      nvdash: "⊬",
      nvge: "≥⃒",
      nvgt: ">⃒",
      nvHarr: "⤄",
      nvinfin: "⧞",
      nvlArr: "⤂",
      nvle: "≤⃒",
      nvlt: "<⃒",
      nvltrie: "⊴⃒",
      nvrArr: "⤃",
      nvrtrie: "⊵⃒",
      nvsim: "∼⃒",
      nwarhk: "⤣",
      nwArr: "⇖",
      nwarr: "↖",
      nwarrow: "↖",
      nwnear: "⤧",
      Oacute: "Ó",
      oacute: "ó",
      oast: "⊛",
      ocir: "⊚",
      Ocirc: "Ô",
      ocirc: "ô",
      Ocy: "О",
      ocy: "о",
      odash: "⊝",
      Odblac: "Ő",
      odblac: "ő",
      odiv: "⨸",
      odot: "⊙",
      odsold: "⦼",
      OElig: "Œ",
      oelig: "œ",
      ofcir: "⦿",
      Ofr: "𝔒",
      ofr: "𝔬",
      ogon: "˛",
      Ograve: "Ò",
      ograve: "ò",
      ogt: "⧁",
      ohbar: "⦵",
      ohm: "Ω",
      oint: "∮",
      olarr: "↺",
      olcir: "⦾",
      olcross: "⦻",
      oline: "‾",
      olt: "⧀",
      Omacr: "Ō",
      omacr: "ō",
      Omega: "Ω",
      omega: "ω",
      Omicron: "Ο",
      omicron: "ο",
      omid: "⦶",
      ominus: "⊖",
      Oopf: "𝕆",
      oopf: "𝕠",
      opar: "⦷",
      OpenCurlyDoubleQuote: "“",
      OpenCurlyQuote: "‘",
      operp: "⦹",
      oplus: "⊕",
      Or: "⩔",
      or: "∨",
      orarr: "↻",
      ord: "⩝",
      order: "ℴ",
      orderof: "ℴ",
      ordf: "ª",
      ordm: "º",
      origof: "⊶",
      oror: "⩖",
      orslope: "⩗",
      orv: "⩛",
      oS: "Ⓢ",
      Oscr: "𝒪",
      oscr: "ℴ",
      Oslash: "Ø",
      oslash: "ø",
      osol: "⊘",
      Otilde: "Õ",
      otilde: "õ",
      Otimes: "⨷",
      otimes: "⊗",
      otimesas: "⨶",
      Ouml: "Ö",
      ouml: "ö",
      ovbar: "⌽",
      OverBar: "‾",
      OverBrace: "⏞",
      OverBracket: "⎴",
      OverParenthesis: "⏜",
      par: "∥",
      para: "¶",
      parallel: "∥",
      parsim: "⫳",
      parsl: "⫽",
      part: "∂",
      PartialD: "∂",
      Pcy: "П",
      pcy: "п",
      percnt: "%",
      period: ".",
      permil: "‰",
      perp: "⊥",
      pertenk: "‱",
      Pfr: "𝔓",
      pfr: "𝔭",
      Phi: "Φ",
      phi: "φ",
      phiv: "ϕ",
      phmmat: "ℳ",
      phone: "☎",
      Pi: "Π",
      pi: "π",
      pitchfork: "⋔",
      piv: "ϖ",
      planck: "ℏ",
      planckh: "ℎ",
      plankv: "ℏ",
      plus: "+",
      plusacir: "⨣",
      plusb: "⊞",
      pluscir: "⨢",
      plusdo: "∔",
      plusdu: "⨥",
      pluse: "⩲",
      PlusMinus: "±",
      plusmn: "±",
      plussim: "⨦",
      plustwo: "⨧",
      pm: "±",
      Poincareplane: "ℌ",
      pointint: "⨕",
      Popf: "ℙ",
      popf: "𝕡",
      pound: "£",
      Pr: "⪻",
      pr: "≺",
      prap: "⪷",
      prcue: "≼",
      prE: "⪳",
      pre: "⪯",
      prec: "≺",
      precapprox: "⪷",
      preccurlyeq: "≼",
      Precedes: "≺",
      PrecedesEqual: "⪯",
      PrecedesSlantEqual: "≼",
      PrecedesTilde: "≾",
      preceq: "⪯",
      precnapprox: "⪹",
      precneqq: "⪵",
      precnsim: "⋨",
      precsim: "≾",
      Prime: "″",
      prime: "′",
      primes: "ℙ",
      prnap: "⪹",
      prnE: "⪵",
      prnsim: "⋨",
      prod: "∏",
      Product: "∏",
      profalar: "⌮",
      profline: "⌒",
      profsurf: "⌓",
      prop: "∝",
      Proportion: "∷",
      Proportional: "∝",
      propto: "∝",
      prsim: "≾",
      prurel: "⊰",
      Pscr: "𝒫",
      pscr: "𝓅",
      Psi: "Ψ",
      psi: "ψ",
      puncsp: " ",
      Qfr: "𝔔",
      qfr: "𝔮",
      qint: "⨌",
      Qopf: "ℚ",
      qopf: "𝕢",
      qprime: "⁗",
      Qscr: "𝒬",
      qscr: "𝓆",
      quaternions: "ℍ",
      quatint: "⨖",
      quest: "?",
      questeq: "≟",
      QUOT: '"',
      quot: '"',
      rAarr: "⇛",
      race: "∽̱",
      Racute: "Ŕ",
      racute: "ŕ",
      radic: "√",
      raemptyv: "⦳",
      Rang: "⟫",
      rang: "⟩",
      rangd: "⦒",
      range: "⦥",
      rangle: "⟩",
      raquo: "»",
      Rarr: "↠",
      rArr: "⇒",
      rarr: "→",
      rarrap: "⥵",
      rarrb: "⇥",
      rarrbfs: "⤠",
      rarrc: "⤳",
      rarrfs: "⤞",
      rarrhk: "↪",
      rarrlp: "↬",
      rarrpl: "⥅",
      rarrsim: "⥴",
      Rarrtl: "⤖",
      rarrtl: "↣",
      rarrw: "↝",
      rAtail: "⤜",
      ratail: "⤚",
      ratio: "∶",
      rationals: "ℚ",
      RBarr: "⤐",
      rBarr: "⤏",
      rbarr: "⤍",
      rbbrk: "❳",
      rbrace: "}",
      rbrack: "]",
      rbrke: "⦌",
      rbrksld: "⦎",
      rbrkslu: "⦐",
      Rcaron: "Ř",
      rcaron: "ř",
      Rcedil: "Ŗ",
      rcedil: "ŗ",
      rceil: "⌉",
      rcub: "}",
      Rcy: "Р",
      rcy: "р",
      rdca: "⤷",
      rdldhar: "⥩",
      rdquo: "”",
      rdquor: "”",
      rdsh: "↳",
      Re: "ℜ",
      real: "ℜ",
      realine: "ℛ",
      realpart: "ℜ",
      reals: "ℝ",
      rect: "▭",
      REG: "®",
      reg: "®",
      ReverseElement: "∋",
      ReverseEquilibrium: "⇋",
      ReverseUpEquilibrium: "⥯",
      rfisht: "⥽",
      rfloor: "⌋",
      Rfr: "ℜ",
      rfr: "𝔯",
      rHar: "⥤",
      rhard: "⇁",
      rharu: "⇀",
      rharul: "⥬",
      Rho: "Ρ",
      rho: "ρ",
      rhov: "ϱ",
      RightAngleBracket: "⟩",
      RightArrow: "→",
      Rightarrow: "⇒",
      rightarrow: "→",
      RightArrowBar: "⇥",
      RightArrowLeftArrow: "⇄",
      rightarrowtail: "↣",
      RightCeiling: "⌉",
      RightDoubleBracket: "⟧",
      RightDownTeeVector: "⥝",
      RightDownVector: "⇂",
      RightDownVectorBar: "⥕",
      RightFloor: "⌋",
      rightharpoondown: "⇁",
      rightharpoonup: "⇀",
      rightleftarrows: "⇄",
      rightleftharpoons: "⇌",
      rightrightarrows: "⇉",
      rightsquigarrow: "↝",
      RightTee: "⊢",
      RightTeeArrow: "↦",
      RightTeeVector: "⥛",
      rightthreetimes: "⋌",
      RightTriangle: "⊳",
      RightTriangleBar: "⧐",
      RightTriangleEqual: "⊵",
      RightUpDownVector: "⥏",
      RightUpTeeVector: "⥜",
      RightUpVector: "↾",
      RightUpVectorBar: "⥔",
      RightVector: "⇀",
      RightVectorBar: "⥓",
      ring: "˚",
      risingdotseq: "≓",
      rlarr: "⇄",
      rlhar: "⇌",
      rlm: "‏",
      rmoust: "⎱",
      rmoustache: "⎱",
      rnmid: "⫮",
      roang: "⟭",
      roarr: "⇾",
      robrk: "⟧",
      ropar: "⦆",
      Ropf: "ℝ",
      ropf: "𝕣",
      roplus: "⨮",
      rotimes: "⨵",
      RoundImplies: "⥰",
      rpar: ")",
      rpargt: "⦔",
      rppolint: "⨒",
      rrarr: "⇉",
      Rrightarrow: "⇛",
      rsaquo: "›",
      Rscr: "ℛ",
      rscr: "𝓇",
      Rsh: "↱",
      rsh: "↱",
      rsqb: "]",
      rsquo: "’",
      rsquor: "’",
      rthree: "⋌",
      rtimes: "⋊",
      rtri: "▹",
      rtrie: "⊵",
      rtrif: "▸",
      rtriltri: "⧎",
      RuleDelayed: "⧴",
      ruluhar: "⥨",
      rx: "℞",
      Sacute: "Ś",
      sacute: "ś",
      sbquo: "‚",
      Sc: "⪼",
      sc: "≻",
      scap: "⪸",
      Scaron: "Š",
      scaron: "š",
      sccue: "≽",
      scE: "⪴",
      sce: "⪰",
      Scedil: "Ş",
      scedil: "ş",
      Scirc: "Ŝ",
      scirc: "ŝ",
      scnap: "⪺",
      scnE: "⪶",
      scnsim: "⋩",
      scpolint: "⨓",
      scsim: "≿",
      Scy: "С",
      scy: "с",
      sdot: "⋅",
      sdotb: "⊡",
      sdote: "⩦",
      searhk: "⤥",
      seArr: "⇘",
      searr: "↘",
      searrow: "↘",
      sect: "§",
      semi: ";",
      seswar: "⤩",
      setminus: "∖",
      setmn: "∖",
      sext: "✶",
      Sfr: "𝔖",
      sfr: "𝔰",
      sfrown: "⌢",
      sharp: "♯",
      SHCHcy: "Щ",
      shchcy: "щ",
      SHcy: "Ш",
      shcy: "ш",
      ShortDownArrow: "↓",
      ShortLeftArrow: "←",
      shortmid: "∣",
      shortparallel: "∥",
      ShortRightArrow: "→",
      ShortUpArrow: "↑",
      shy: "­",
      Sigma: "Σ",
      sigma: "σ",
      sigmaf: "ς",
      sigmav: "ς",
      sim: "∼",
      simdot: "⩪",
      sime: "≃",
      simeq: "≃",
      simg: "⪞",
      simgE: "⪠",
      siml: "⪝",
      simlE: "⪟",
      simne: "≆",
      simplus: "⨤",
      simrarr: "⥲",
      slarr: "←",
      SmallCircle: "∘",
      smallsetminus: "∖",
      smashp: "⨳",
      smeparsl: "⧤",
      smid: "∣",
      smile: "⌣",
      smt: "⪪",
      smte: "⪬",
      smtes: "⪬︀",
      SOFTcy: "Ь",
      softcy: "ь",
      sol: "/",
      solb: "⧄",
      solbar: "⌿",
      Sopf: "𝕊",
      sopf: "𝕤",
      spades: "♠",
      spadesuit: "♠",
      spar: "∥",
      sqcap: "⊓",
      sqcaps: "⊓︀",
      sqcup: "⊔",
      sqcups: "⊔︀",
      Sqrt: "√",
      sqsub: "⊏",
      sqsube: "⊑",
      sqsubset: "⊏",
      sqsubseteq: "⊑",
      sqsup: "⊐",
      sqsupe: "⊒",
      sqsupset: "⊐",
      sqsupseteq: "⊒",
      squ: "□",
      Square: "□",
      square: "□",
      SquareIntersection: "⊓",
      SquareSubset: "⊏",
      SquareSubsetEqual: "⊑",
      SquareSuperset: "⊐",
      SquareSupersetEqual: "⊒",
      SquareUnion: "⊔",
      squarf: "▪",
      squf: "▪",
      srarr: "→",
      Sscr: "𝒮",
      sscr: "𝓈",
      ssetmn: "∖",
      ssmile: "⌣",
      sstarf: "⋆",
      Star: "⋆",
      star: "☆",
      starf: "★",
      straightepsilon: "ϵ",
      straightphi: "ϕ",
      strns: "¯",
      Sub: "⋐",
      sub: "⊂",
      subdot: "⪽",
      subE: "⫅",
      sube: "⊆",
      subedot: "⫃",
      submult: "⫁",
      subnE: "⫋",
      subne: "⊊",
      subplus: "⪿",
      subrarr: "⥹",
      Subset: "⋐",
      subset: "⊂",
      subseteq: "⊆",
      subseteqq: "⫅",
      SubsetEqual: "⊆",
      subsetneq: "⊊",
      subsetneqq: "⫋",
      subsim: "⫇",
      subsub: "⫕",
      subsup: "⫓",
      succ: "≻",
      succapprox: "⪸",
      succcurlyeq: "≽",
      Succeeds: "≻",
      SucceedsEqual: "⪰",
      SucceedsSlantEqual: "≽",
      SucceedsTilde: "≿",
      succeq: "⪰",
      succnapprox: "⪺",
      succneqq: "⪶",
      succnsim: "⋩",
      succsim: "≿",
      SuchThat: "∋",
      Sum: "∑",
      sum: "∑",
      sung: "♪",
      Sup: "⋑",
      sup: "⊃",
      sup1: "¹",
      sup2: "²",
      sup3: "³",
      supdot: "⪾",
      supdsub: "⫘",
      supE: "⫆",
      supe: "⊇",
      supedot: "⫄",
      Superset: "⊃",
      SupersetEqual: "⊇",
      suphsol: "⟉",
      suphsub: "⫗",
      suplarr: "⥻",
      supmult: "⫂",
      supnE: "⫌",
      supne: "⊋",
      supplus: "⫀",
      Supset: "⋑",
      supset: "⊃",
      supseteq: "⊇",
      supseteqq: "⫆",
      supsetneq: "⊋",
      supsetneqq: "⫌",
      supsim: "⫈",
      supsub: "⫔",
      supsup: "⫖",
      swarhk: "⤦",
      swArr: "⇙",
      swarr: "↙",
      swarrow: "↙",
      swnwar: "⤪",
      szlig: "ß",
      Tab: "	",
      target: "⌖",
      Tau: "Τ",
      tau: "τ",
      tbrk: "⎴",
      Tcaron: "Ť",
      tcaron: "ť",
      Tcedil: "Ţ",
      tcedil: "ţ",
      Tcy: "Т",
      tcy: "т",
      tdot: "⃛",
      telrec: "⌕",
      Tfr: "𝔗",
      tfr: "𝔱",
      there4: "∴",
      Therefore: "∴",
      therefore: "∴",
      Theta: "Θ",
      theta: "θ",
      thetasym: "ϑ",
      thetav: "ϑ",
      thickapprox: "≈",
      thicksim: "∼",
      ThickSpace: "  ",
      thinsp: " ",
      ThinSpace: " ",
      thkap: "≈",
      thksim: "∼",
      THORN: "Þ",
      thorn: "þ",
      Tilde: "∼",
      tilde: "˜",
      TildeEqual: "≃",
      TildeFullEqual: "≅",
      TildeTilde: "≈",
      times: "×",
      timesb: "⊠",
      timesbar: "⨱",
      timesd: "⨰",
      tint: "∭",
      toea: "⤨",
      top: "⊤",
      topbot: "⌶",
      topcir: "⫱",
      Topf: "𝕋",
      topf: "𝕥",
      topfork: "⫚",
      tosa: "⤩",
      tprime: "‴",
      TRADE: "™",
      trade: "™",
      triangle: "▵",
      triangledown: "▿",
      triangleleft: "◃",
      trianglelefteq: "⊴",
      triangleq: "≜",
      triangleright: "▹",
      trianglerighteq: "⊵",
      tridot: "◬",
      trie: "≜",
      triminus: "⨺",
      TripleDot: "⃛",
      triplus: "⨹",
      trisb: "⧍",
      tritime: "⨻",
      trpezium: "⏢",
      Tscr: "𝒯",
      tscr: "𝓉",
      TScy: "Ц",
      tscy: "ц",
      TSHcy: "Ћ",
      tshcy: "ћ",
      Tstrok: "Ŧ",
      tstrok: "ŧ",
      twixt: "≬",
      twoheadleftarrow: "↞",
      twoheadrightarrow: "↠",
      Uacute: "Ú",
      uacute: "ú",
      Uarr: "↟",
      uArr: "⇑",
      uarr: "↑",
      Uarrocir: "⥉",
      Ubrcy: "Ў",
      ubrcy: "ў",
      Ubreve: "Ŭ",
      ubreve: "ŭ",
      Ucirc: "Û",
      ucirc: "û",
      Ucy: "У",
      ucy: "у",
      udarr: "⇅",
      Udblac: "Ű",
      udblac: "ű",
      udhar: "⥮",
      ufisht: "⥾",
      Ufr: "𝔘",
      ufr: "𝔲",
      Ugrave: "Ù",
      ugrave: "ù",
      uHar: "⥣",
      uharl: "↿",
      uharr: "↾",
      uhblk: "▀",
      ulcorn: "⌜",
      ulcorner: "⌜",
      ulcrop: "⌏",
      ultri: "◸",
      Umacr: "Ū",
      umacr: "ū",
      uml: "¨",
      UnderBar: "_",
      UnderBrace: "⏟",
      UnderBracket: "⎵",
      UnderParenthesis: "⏝",
      Union: "⋃",
      UnionPlus: "⊎",
      Uogon: "Ų",
      uogon: "ų",
      Uopf: "𝕌",
      uopf: "𝕦",
      UpArrow: "↑",
      Uparrow: "⇑",
      uparrow: "↑",
      UpArrowBar: "⤒",
      UpArrowDownArrow: "⇅",
      UpDownArrow: "↕",
      Updownarrow: "⇕",
      updownarrow: "↕",
      UpEquilibrium: "⥮",
      upharpoonleft: "↿",
      upharpoonright: "↾",
      uplus: "⊎",
      UpperLeftArrow: "↖",
      UpperRightArrow: "↗",
      Upsi: "ϒ",
      upsi: "υ",
      upsih: "ϒ",
      Upsilon: "Υ",
      upsilon: "υ",
      UpTee: "⊥",
      UpTeeArrow: "↥",
      upuparrows: "⇈",
      urcorn: "⌝",
      urcorner: "⌝",
      urcrop: "⌎",
      Uring: "Ů",
      uring: "ů",
      urtri: "◹",
      Uscr: "𝒰",
      uscr: "𝓊",
      utdot: "⋰",
      Utilde: "Ũ",
      utilde: "ũ",
      utri: "▵",
      utrif: "▴",
      uuarr: "⇈",
      Uuml: "Ü",
      uuml: "ü",
      uwangle: "⦧",
      vangrt: "⦜",
      varepsilon: "ϵ",
      varkappa: "ϰ",
      varnothing: "∅",
      varphi: "ϕ",
      varpi: "ϖ",
      varpropto: "∝",
      vArr: "⇕",
      varr: "↕",
      varrho: "ϱ",
      varsigma: "ς",
      varsubsetneq: "⊊︀",
      varsubsetneqq: "⫋︀",
      varsupsetneq: "⊋︀",
      varsupsetneqq: "⫌︀",
      vartheta: "ϑ",
      vartriangleleft: "⊲",
      vartriangleright: "⊳",
      Vbar: "⫫",
      vBar: "⫨",
      vBarv: "⫩",
      Vcy: "В",
      vcy: "в",
      VDash: "⊫",
      Vdash: "⊩",
      vDash: "⊨",
      vdash: "⊢",
      Vdashl: "⫦",
      Vee: "⋁",
      vee: "∨",
      veebar: "⊻",
      veeeq: "≚",
      vellip: "⋮",
      Verbar: "‖",
      verbar: "|",
      Vert: "‖",
      vert: "|",
      VerticalBar: "∣",
      VerticalLine: "|",
      VerticalSeparator: "❘",
      VerticalTilde: "≀",
      VeryThinSpace: " ",
      Vfr: "𝔙",
      vfr: "𝔳",
      vltri: "⊲",
      vnsub: "⊂⃒",
      vnsup: "⊃⃒",
      Vopf: "𝕍",
      vopf: "𝕧",
      vprop: "∝",
      vrtri: "⊳",
      Vscr: "𝒱",
      vscr: "𝓋",
      vsubnE: "⫋︀",
      vsubne: "⊊︀",
      vsupnE: "⫌︀",
      vsupne: "⊋︀",
      Vvdash: "⊪",
      vzigzag: "⦚",
      Wcirc: "Ŵ",
      wcirc: "ŵ",
      wedbar: "⩟",
      Wedge: "⋀",
      wedge: "∧",
      wedgeq: "≙",
      weierp: "℘",
      Wfr: "𝔚",
      wfr: "𝔴",
      Wopf: "𝕎",
      wopf: "𝕨",
      wp: "℘",
      wr: "≀",
      wreath: "≀",
      Wscr: "𝒲",
      wscr: "𝓌",
      xcap: "⋂",
      xcirc: "◯",
      xcup: "⋃",
      xdtri: "▽",
      Xfr: "𝔛",
      xfr: "𝔵",
      xhArr: "⟺",
      xharr: "⟷",
      Xi: "Ξ",
      xi: "ξ",
      xlArr: "⟸",
      xlarr: "⟵",
      xmap: "⟼",
      xnis: "⋻",
      xodot: "⨀",
      Xopf: "𝕏",
      xopf: "𝕩",
      xoplus: "⨁",
      xotime: "⨂",
      xrArr: "⟹",
      xrarr: "⟶",
      Xscr: "𝒳",
      xscr: "𝓍",
      xsqcup: "⨆",
      xuplus: "⨄",
      xutri: "△",
      xvee: "⋁",
      xwedge: "⋀",
      Yacute: "Ý",
      yacute: "ý",
      YAcy: "Я",
      yacy: "я",
      Ycirc: "Ŷ",
      ycirc: "ŷ",
      Ycy: "Ы",
      ycy: "ы",
      yen: "¥",
      Yfr: "𝔜",
      yfr: "𝔶",
      YIcy: "Ї",
      yicy: "ї",
      Yopf: "𝕐",
      yopf: "𝕪",
      Yscr: "𝒴",
      yscr: "𝓎",
      YUcy: "Ю",
      yucy: "ю",
      Yuml: "Ÿ",
      yuml: "ÿ",
      Zacute: "Ź",
      zacute: "ź",
      Zcaron: "Ž",
      zcaron: "ž",
      Zcy: "З",
      zcy: "з",
      Zdot: "Ż",
      zdot: "ż",
      zeetrf: "ℨ",
      ZeroWidthSpace: "​",
      Zeta: "Ζ",
      zeta: "ζ",
      Zfr: "ℨ",
      zfr: "𝔷",
      ZHcy: "Ж",
      zhcy: "ж",
      zigrarr: "⇝",
      Zopf: "ℤ",
      zopf: "𝕫",
      Zscr: "𝒵",
      zscr: "𝓏",
      zwj: "‍",
      zwnj: "‌"
    }), t.entityMap = t.HTML_ENTITIES;
  }(Of)), Of;
}
var ku = {}, Wg;
function M6() {
  if (Wg) return ku;
  Wg = 1;
  var t = $d().NAMESPACE, e = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, i = new RegExp("[\\-\\.0-9" + e.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), n = new RegExp("^" + e.source + i.source + "*(?::" + e.source + i.source + "*)?$"), s = 0, r = 1, a = 2, o = 3, l = 4, u = 5, d = 6, c = 7;
  function A(x, C) {
    this.message = x, this.locator = C, Error.captureStackTrace && Error.captureStackTrace(this, A);
  }
  A.prototype = new Error(), A.prototype.name = A.name;
  function m() {
  }
  m.prototype = {
    parse: function(x, C, L) {
      var V = this.domBuilder;
      V.startDocument(), D(C, C = {}), p(
        x,
        C,
        L,
        V,
        this.errorHandler
      ), V.endDocument();
    }
  };
  function p(x, C, L, V, H) {
    function O(Ge) {
      if (Ge > 65535) {
        Ge -= 65536;
        var ot = 55296 + (Ge >> 10), he = 56320 + (Ge & 1023);
        return String.fromCharCode(ot, he);
      } else
        return String.fromCharCode(Ge);
    }
    function X(Ge) {
      var ot = Ge.slice(1, -1);
      return Object.hasOwnProperty.call(L, ot) ? L[ot] : ot.charAt(0) === "#" ? O(parseInt(ot.substr(1).replace("x", "0x"))) : (H.error("entity not found:" + Ge), Ge);
    }
    function q(Ge) {
      if (Ge > ce) {
        var ot = x.substring(ce, Ge).replace(/&#?\w+;/g, X);
        $ && F(ce), V.characters(ot, 0, Ge - ce), ce = Ge;
      }
    }
    function F(Ge, ot) {
      for (; Ge >= j && (ot = oe.exec(x)); )
        W = ot.index, j = W + ot[0].length, $.lineNumber++;
      $.columnNumber = Ge - W + 1;
    }
    for (var W = 0, j = 0, oe = /.*(?:\r\n?|\n)|.*$/g, $ = V.locator, ye = [{ currentNSMap: C }], ae = {}, ce = 0; ; ) {
      try {
        var te = x.indexOf("<", ce);
        if (te < 0) {
          if (!x.substr(ce).match(/^\s*$/)) {
            var le = V.doc, B = le.createTextNode(x.substr(ce));
            le.appendChild(B), V.currentElement = B;
          }
          return;
        }
        switch (te > ce && q(te), x.charAt(te + 1)) {
          case "/":
            var Ie = x.indexOf(">", te + 3), ue = x.substring(te + 2, Ie).replace(/[ \t\n\r]+$/g, ""), Pe = ye.pop();
            Ie < 0 ? (ue = x.substring(te + 2).replace(/[\s<].*/, ""), H.error("end tag name: " + ue + " is not complete:" + Pe.tagName), Ie = te + 1 + ue.length) : ue.match(/\s</) && (ue = ue.replace(/[\s<].*/, ""), H.error("end tag name: " + ue + " maybe not complete"), Ie = te + 1 + ue.length);
            var nt = Pe.localNSMap, ge = Pe.tagName == ue, Qe = ge || Pe.tagName && Pe.tagName.toLowerCase() == ue.toLowerCase();
            if (Qe) {
              if (V.endElement(Pe.uri, Pe.localName, ue), nt)
                for (var Ee in nt)
                  Object.prototype.hasOwnProperty.call(nt, Ee) && V.endPrefixMapping(Ee);
              ge || H.fatalError("end tag name: " + ue + " is not match the current start tagName:" + Pe.tagName);
            } else
              ye.push(Pe);
            Ie++;
            break;
          // end elment
          case "?":
            $ && F(te), Ie = M(x, te, V);
            break;
          case "!":
            $ && F(te), Ie = I(x, te, V, H);
            break;
          default:
            $ && F(te);
            var xe = new _(), K = ye[ye.length - 1].currentNSMap, Ie = g(x, te, xe, K, X, H), Be = xe.length;
            if (!xe.closed && y(x, Ie, xe.tagName, ae) && (xe.closed = !0, L.nbsp || H.warning("unclosed xml attribute")), $ && Be) {
              for (var Me = h($, {}), Ke = 0; Ke < Be; Ke++) {
                var He = xe[Ke];
                F(He.offset), He.locator = h($, {});
              }
              V.locator = Me, w(xe, V, K) && ye.push(xe), V.locator = $;
            } else
              w(xe, V, K) && ye.push(xe);
            t.isHTML(xe.uri) && !xe.closed ? Ie = b(x, Ie, xe.tagName, X, V) : Ie++;
        }
      } catch (Ge) {
        if (Ge instanceof A)
          throw Ge;
        H.error("element parse error: " + Ge), Ie = -1;
      }
      Ie > ce ? ce = Ie : q(Math.max(te, ce) + 1);
    }
  }
  function h(x, C) {
    return C.lineNumber = x.lineNumber, C.columnNumber = x.columnNumber, C;
  }
  function g(x, C, L, V, H, O) {
    function X($, ye, ae) {
      L.attributeNames.hasOwnProperty($) && O.fatalError("Attribute " + $ + " redefined"), L.addValue(
        $,
        // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        ye.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, H),
        ae
      );
    }
    for (var q, F, W = ++C, j = s; ; ) {
      var oe = x.charAt(W);
      switch (oe) {
        case "=":
          if (j === r)
            q = x.slice(C, W), j = o;
          else if (j === a)
            j = o;
          else
            throw new Error("attribute equal must after attrName");
          break;
        case "'":
        case '"':
          if (j === o || j === r)
            if (j === r && (O.warning('attribute value must after "="'), q = x.slice(C, W)), C = W + 1, W = x.indexOf(oe, C), W > 0)
              F = x.slice(C, W), X(q, F, C - 1), j = u;
            else
              throw new Error("attribute value no end '" + oe + "' match");
          else if (j == l)
            F = x.slice(C, W), X(q, F, C), O.warning('attribute "' + q + '" missed start quot(' + oe + ")!!"), C = W + 1, j = u;
          else
            throw new Error('attribute value must after "="');
          break;
        case "/":
          switch (j) {
            case s:
              L.setTagName(x.slice(C, W));
            case u:
            case d:
            case c:
              j = c, L.closed = !0;
            case l:
            case r:
              break;
            case a:
              L.closed = !0;
              break;
            //case S_EQ:
            default:
              throw new Error("attribute invalid close char('/')");
          }
          break;
        case "":
          return O.error("unexpected end of input"), j == s && L.setTagName(x.slice(C, W)), W;
        case ">":
          switch (j) {
            case s:
              L.setTagName(x.slice(C, W));
            case u:
            case d:
            case c:
              break;
            //normal
            case l:
            //Compatible state
            case r:
              F = x.slice(C, W), F.slice(-1) === "/" && (L.closed = !0, F = F.slice(0, -1));
            case a:
              j === a && (F = q), j == l ? (O.warning('attribute "' + F + '" missed quot(")!'), X(q, F, C)) : ((!t.isHTML(V[""]) || !F.match(/^(?:disabled|checked|selected)$/i)) && O.warning('attribute "' + F + '" missed value!! "' + F + '" instead!!'), X(F, F, C));
              break;
            case o:
              throw new Error("attribute value missed!!");
          }
          return W;
        /*xml space '\x20' | #x9 | #xD | #xA; */
        case "":
          oe = " ";
        default:
          if (oe <= " ")
            switch (j) {
              case s:
                L.setTagName(x.slice(C, W)), j = d;
                break;
              case r:
                q = x.slice(C, W), j = a;
                break;
              case l:
                var F = x.slice(C, W);
                O.warning('attribute "' + F + '" missed quot(")!!'), X(q, F, C);
              case u:
                j = d;
                break;
            }
          else
            switch (j) {
              //case S_TAG:void();break;
              //case S_ATTR:void();break;
              //case S_ATTR_NOQUOT_VALUE:void();break;
              case a:
                L.tagName, (!t.isHTML(V[""]) || !q.match(/^(?:disabled|checked|selected)$/i)) && O.warning('attribute "' + q + '" missed value!! "' + q + '" instead2!!'), X(q, q, C), C = W, j = r;
                break;
              case u:
                O.warning('attribute space is required"' + q + '"!!');
              case d:
                j = r, C = W;
                break;
              case o:
                j = l, C = W;
                break;
              case c:
                throw new Error("elements closed character '/' and '>' must be connected to");
            }
      }
      W++;
    }
  }
  function w(x, C, L) {
    for (var V = x.tagName, H = null, oe = x.length; oe--; ) {
      var O = x[oe], X = O.qName, q = O.value, $ = X.indexOf(":");
      if ($ > 0)
        var F = O.prefix = X.slice(0, $), W = X.slice($ + 1), j = F === "xmlns" && W;
      else
        W = X, F = null, j = X === "xmlns" && "";
      O.localName = W, j !== !1 && (H == null && (H = {}, D(L, L = {})), L[j] = H[j] = q, O.uri = t.XMLNS, C.startPrefixMapping(j, q));
    }
    for (var oe = x.length; oe--; ) {
      O = x[oe];
      var F = O.prefix;
      F && (F === "xml" && (O.uri = t.XML), F !== "xmlns" && (O.uri = L[F || ""]));
    }
    var $ = V.indexOf(":");
    $ > 0 ? (F = x.prefix = V.slice(0, $), W = x.localName = V.slice($ + 1)) : (F = null, W = x.localName = V);
    var ye = x.uri = L[F || ""];
    if (C.startElement(ye, W, V, x), x.closed) {
      if (C.endElement(ye, W, V), H)
        for (F in H)
          Object.prototype.hasOwnProperty.call(H, F) && C.endPrefixMapping(F);
    } else
      return x.currentNSMap = L, x.localNSMap = H, !0;
  }
  function b(x, C, L, V, H) {
    if (/^(?:script|textarea)$/i.test(L)) {
      var O = x.indexOf("</" + L + ">", C), X = x.substring(C + 1, O);
      if (/[&<]/.test(X))
        return /^script$/i.test(L) ? (H.characters(X, 0, X.length), O) : (X = X.replace(/&#?\w+;/g, V), H.characters(X, 0, X.length), O);
    }
    return C + 1;
  }
  function y(x, C, L, V) {
    var H = V[L];
    return H == null && (H = x.lastIndexOf("</" + L + ">"), H < C && (H = x.lastIndexOf("</" + L)), V[L] = H), H < C;
  }
  function D(x, C) {
    for (var L in x)
      Object.prototype.hasOwnProperty.call(x, L) && (C[L] = x[L]);
  }
  function I(x, C, L, V) {
    var H = x.charAt(C + 2);
    switch (H) {
      case "-":
        if (x.charAt(C + 3) === "-") {
          var O = x.indexOf("-->", C + 4);
          return O > C ? (L.comment(x, C + 4, O - C - 4), O + 3) : (V.error("Unclosed comment"), -1);
        } else
          return -1;
      default:
        if (x.substr(C + 3, 6) == "CDATA[") {
          var O = x.indexOf("]]>", C + 9);
          return L.startCDATA(), L.characters(x, C + 9, O - C - 9), L.endCDATA(), O + 3;
        }
        var X = N(x, C), q = X.length;
        if (q > 1 && /!doctype/i.test(X[0][0])) {
          var F = X[1][0], W = !1, j = !1;
          q > 3 && (/^public$/i.test(X[2][0]) ? (W = X[3][0], j = q > 4 && X[4][0]) : /^system$/i.test(X[2][0]) && (j = X[3][0]));
          var oe = X[q - 1];
          return L.startDTD(F, W, j), L.endDTD(), oe.index + oe[0].length;
        }
    }
    return -1;
  }
  function M(x, C, L) {
    var V = x.indexOf("?>", C);
    if (V) {
      var H = x.substring(C, V).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
      return H ? (H[0].length, L.processingInstruction(H[1], H[2]), V + 2) : -1;
    }
    return -1;
  }
  function _() {
    this.attributeNames = {};
  }
  _.prototype = {
    setTagName: function(x) {
      if (!n.test(x))
        throw new Error("invalid tagName:" + x);
      this.tagName = x;
    },
    addValue: function(x, C, L) {
      if (!n.test(x))
        throw new Error("invalid attribute:" + x);
      this.attributeNames[x] = this.length, this[this.length++] = { qName: x, value: C, offset: L };
    },
    length: 0,
    getLocalName: function(x) {
      return this[x].localName;
    },
    getLocator: function(x) {
      return this[x].locator;
    },
    getQName: function(x) {
      return this[x].qName;
    },
    getURI: function(x) {
      return this[x].uri;
    },
    getValue: function(x) {
      return this[x].value;
    }
    //	,getIndex:function(uri, localName)){
    //		if(localName){
    //
    //		}else{
    //			var qName = uri
    //		}
    //	},
    //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
    //	getType:function(uri,localName){}
    //	getType:function(i){},
  };
  function N(x, C) {
    var L, V = [], H = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    for (H.lastIndex = C, H.exec(x); L = H.exec(x); )
      if (V.push(L), L[1]) return V;
  }
  return ku.XMLReader = m, ku.ParseError = A, ku;
}
var Yg;
function O6() {
  if (Yg) return jo;
  Yg = 1;
  var t = $d(), e = lb(), i = I6(), n = M6(), s = e.DOMImplementation, r = t.NAMESPACE, a = n.ParseError, o = n.XMLReader;
  function l(g) {
    return g.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
  }
  function u(g) {
    this.options = g || { locator: {} };
  }
  u.prototype.parseFromString = function(g, w) {
    var b = this.options, y = new o(), D = b.domBuilder || new c(), I = b.errorHandler, M = b.locator, _ = b.xmlns || {}, N = /\/x?html?$/.test(w), x = N ? i.HTML_ENTITIES : i.XML_ENTITIES;
    M && D.setDocumentLocator(M), y.errorHandler = d(I, D, M), y.domBuilder = b.domBuilder || D, N && (_[""] = r.HTML), _.xml = _.xml || r.XML;
    var C = b.normalizeLineEndings || l;
    return g && typeof g == "string" ? y.parse(
      C(g),
      _,
      x
    ) : y.errorHandler.error("invalid doc source"), D.doc;
  };
  function d(g, w, b) {
    if (!g) {
      if (w instanceof c)
        return w;
      g = w;
    }
    var y = {}, D = g instanceof Function;
    b = b || {};
    function I(M) {
      var _ = g[M];
      !_ && D && (_ = g.length == 2 ? function(N) {
        g(M, N);
      } : g), y[M] = _ && function(N) {
        _("[xmldom " + M + "]	" + N + m(b));
      } || function() {
      };
    }
    return I("warning"), I("error"), I("fatalError"), y;
  }
  function c() {
    this.cdata = !1;
  }
  function A(g, w) {
    w.lineNumber = g.lineNumber, w.columnNumber = g.columnNumber;
  }
  c.prototype = {
    startDocument: function() {
      this.doc = new s().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
    },
    startElement: function(g, w, b, y) {
      var D = this.doc, I = D.createElementNS(g, b || w), M = y.length;
      h(this, I), this.currentElement = I, this.locator && A(this.locator, I);
      for (var _ = 0; _ < M; _++) {
        var g = y.getURI(_), N = y.getValue(_), b = y.getQName(_), x = D.createAttributeNS(g, b);
        this.locator && A(y.getLocator(_), x), x.value = x.nodeValue = N, I.setAttributeNode(x);
      }
    },
    endElement: function(g, w, b) {
      var y = this.currentElement;
      y.tagName, this.currentElement = y.parentNode;
    },
    startPrefixMapping: function(g, w) {
    },
    endPrefixMapping: function(g) {
    },
    processingInstruction: function(g, w) {
      var b = this.doc.createProcessingInstruction(g, w);
      this.locator && A(this.locator, b), h(this, b);
    },
    ignorableWhitespace: function(g, w, b) {
    },
    characters: function(g, w, b) {
      if (g = p.apply(this, arguments), g) {
        if (this.cdata)
          var y = this.doc.createCDATASection(g);
        else
          var y = this.doc.createTextNode(g);
        this.currentElement ? this.currentElement.appendChild(y) : /^\s*$/.test(g) && this.doc.appendChild(y), this.locator && A(this.locator, y);
      }
    },
    skippedEntity: function(g) {
    },
    endDocument: function() {
      this.doc.normalize();
    },
    setDocumentLocator: function(g) {
      (this.locator = g) && (g.lineNumber = 0);
    },
    //LexicalHandler
    comment: function(g, w, b) {
      g = p.apply(this, arguments);
      var y = this.doc.createComment(g);
      this.locator && A(this.locator, y), h(this, y);
    },
    startCDATA: function() {
      this.cdata = !0;
    },
    endCDATA: function() {
      this.cdata = !1;
    },
    startDTD: function(g, w, b) {
      var y = this.doc.implementation;
      if (y && y.createDocumentType) {
        var D = y.createDocumentType(g, w, b);
        this.locator && A(this.locator, D), h(this, D), this.doc.doctype = D;
      }
    },
    /**
     * @see org.xml.sax.ErrorHandler
     * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
     */
    warning: function(g) {
      console.warn("[xmldom warning]	" + g, m(this.locator));
    },
    error: function(g) {
      console.error("[xmldom error]	" + g, m(this.locator));
    },
    fatalError: function(g) {
      throw new a(g, this.locator);
    }
  };
  function m(g) {
    if (g)
      return `
@` + (g.systemId || "") + "#[line:" + g.lineNumber + ",col:" + g.columnNumber + "]";
  }
  function p(g, w, b) {
    return typeof g == "string" ? g.substr(w, b) : g.length >= w + b || w ? new java.lang.String(g, w, b) + "" : g;
  }
  "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(g) {
    c.prototype[g] = function() {
      return null;
    };
  });
  function h(g, w) {
    g.currentElement ? g.currentElement.appendChild(w) : g.doc.appendChild(w);
  }
  return jo.__DOMHandler = c, jo.normalizeLineEndings = l, jo.DOMParser = u, jo;
}
var Xg;
function B6() {
  if (Xg) return Xo;
  Xg = 1;
  var t = lb();
  return Xo.DOMImplementation = t.DOMImplementation, Xo.XMLSerializer = t.XMLSerializer, Xo.DOMParser = O6().DOMParser, Xo;
}
var L6 = B6();
/*! @name mpd-parser @version 1.3.1 @license Apache-2.0 */
const jg = (t) => !!t && typeof t == "object", Di = (...t) => t.reduce((e, i) => (typeof i != "object" || Object.keys(i).forEach((n) => {
  Array.isArray(e[n]) && Array.isArray(i[n]) ? e[n] = e[n].concat(i[n]) : jg(e[n]) && jg(i[n]) ? e[n] = Di(e[n], i[n]) : e[n] = i[n];
}), e), {}), ub = (t) => Object.keys(t).map((e) => t[e]), N6 = (t, e) => {
  const i = [];
  for (let n = t; n < e; n++)
    i.push(n);
  return i;
}, so = (t) => t.reduce((e, i) => e.concat(i), []), db = (t) => {
  if (!t.length)
    return [];
  const e = [];
  for (let i = 0; i < t.length; i++)
    e.push(t[i]);
  return e;
}, R6 = (t, e) => t.reduce((i, n, s) => (n[e] && i.push(s), i), []), F6 = (t, e) => ub(t.reduce((i, n) => (n.forEach((s) => {
  i[e(s)] = s;
}), i), {}));
var ro = {
  INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
  DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
  DASH_INVALID_XML: "DASH_INVALID_XML",
  NO_BASE_URL: "NO_BASE_URL",
  SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
  UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
};
const _l = ({
  baseUrl: t = "",
  source: e = "",
  range: i = "",
  indexRange: n = ""
}) => {
  const s = {
    uri: e,
    resolvedUri: Jd(t || "", e)
  };
  if (i || n) {
    const a = (i || n).split("-");
    let o = ne.BigInt ? ne.BigInt(a[0]) : parseInt(a[0], 10), l = ne.BigInt ? ne.BigInt(a[1]) : parseInt(a[1], 10);
    o < Number.MAX_SAFE_INTEGER && typeof o == "bigint" && (o = Number(o)), l < Number.MAX_SAFE_INTEGER && typeof l == "bigint" && (l = Number(l));
    let u;
    typeof l == "bigint" || typeof o == "bigint" ? u = ne.BigInt(l) - ne.BigInt(o) + ne.BigInt(1) : u = l - o + 1, typeof u == "bigint" && u < Number.MAX_SAFE_INTEGER && (u = Number(u)), s.byterange = {
      length: u,
      offset: o
    };
  }
  return s;
}, z6 = (t) => {
  let e;
  return typeof t.offset == "bigint" || typeof t.length == "bigint" ? e = ne.BigInt(t.offset) + ne.BigInt(t.length) - ne.BigInt(1) : e = t.offset + t.length - 1, `${t.offset}-${e}`;
}, Gg = (t) => (t && typeof t != "number" && (t = parseInt(t, 10)), isNaN(t) ? null : t), U6 = {
  /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  static(t) {
    const {
      duration: e,
      timescale: i = 1,
      sourceDuration: n,
      periodDuration: s
    } = t, r = Gg(t.endNumber), a = e / i;
    return typeof r == "number" ? {
      start: 0,
      end: r
    } : typeof s == "number" ? {
      start: 0,
      end: s / a
    } : {
      start: 0,
      end: n / a
    };
  },
  /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  dynamic(t) {
    const {
      NOW: e,
      clientOffset: i,
      availabilityStartTime: n,
      timescale: s = 1,
      duration: r,
      periodStart: a = 0,
      minimumUpdatePeriod: o = 0,
      timeShiftBufferDepth: l = 1 / 0
    } = t, u = Gg(t.endNumber), d = (e + i) / 1e3, c = n + a, m = d + o - c, p = Math.ceil(m * s / r), h = Math.floor((d - c - l) * s / r), g = Math.floor((d - c) * s / r);
    return {
      start: Math.max(0, h),
      end: typeof u == "number" ? u : Math.min(p, g)
    };
  }
}, V6 = (t) => (e) => {
  const {
    duration: i,
    timescale: n = 1,
    periodStart: s,
    startNumber: r = 1
  } = t;
  return {
    number: r + e,
    duration: i / n,
    timeline: s,
    time: e * i
  };
}, Up = (t) => {
  const {
    type: e,
    duration: i,
    timescale: n = 1,
    periodDuration: s,
    sourceDuration: r
  } = t, {
    start: a,
    end: o
  } = U6[e](t), l = N6(a, o).map(V6(t));
  if (e === "static") {
    const u = l.length - 1, d = typeof s == "number" ? s : r;
    l[u].duration = d - i / n * u;
  }
  return l;
}, cb = (t) => {
  const {
    baseUrl: e,
    initialization: i = {},
    sourceDuration: n,
    indexRange: s = "",
    periodStart: r,
    presentationTime: a,
    number: o = 0,
    duration: l
  } = t;
  if (!e)
    throw new Error(ro.NO_BASE_URL);
  const u = _l({
    baseUrl: e,
    source: i.sourceURL,
    range: i.range
  }), d = _l({
    baseUrl: e,
    source: e,
    indexRange: s
  });
  if (d.map = u, l) {
    const c = Up(t);
    c.length && (d.duration = c[0].duration, d.timeline = c[0].timeline);
  } else n && (d.duration = n, d.timeline = r);
  return d.presentationTime = a || r, d.number = o, [d];
}, Vp = (t, e, i) => {
  const n = t.sidx.map ? t.sidx.map : null, s = t.sidx.duration, r = t.timeline || 0, a = t.sidx.byterange, o = a.offset + a.length, l = e.timescale, u = e.references.filter((g) => g.referenceType !== 1), d = [], c = t.endList ? "static" : "dynamic", A = t.sidx.timeline;
  let m = A, p = t.mediaSequence || 0, h;
  typeof e.firstOffset == "bigint" ? h = ne.BigInt(o) + e.firstOffset : h = o + e.firstOffset;
  for (let g = 0; g < u.length; g++) {
    const w = e.references[g], b = w.referencedSize, y = w.subsegmentDuration;
    let D;
    typeof h == "bigint" ? D = h + ne.BigInt(b) - ne.BigInt(1) : D = h + b - 1;
    const I = `${h}-${D}`, _ = cb({
      baseUrl: i,
      timescale: l,
      timeline: r,
      periodStart: A,
      presentationTime: m,
      number: p,
      duration: y,
      sourceDuration: s,
      indexRange: I,
      type: c
    })[0];
    n && (_.map = n), d.push(_), typeof h == "bigint" ? h += ne.BigInt(b) : h += b, m += y / l, p++;
  }
  return t.segments = d, t;
}, q6 = ["AUDIO", "SUBTITLES"], H6 = 1 / 60, fb = (t) => F6(t, ({
  timeline: e
}) => e).sort((e, i) => e.timeline > i.timeline ? 1 : -1), W6 = (t, e) => {
  for (let i = 0; i < t.length; i++)
    if (t[i].attributes.NAME === e)
      return t[i];
  return null;
}, Qg = (t) => {
  let e = [];
  return P6(t, q6, (i, n, s, r) => {
    e = e.concat(i.playlists || []);
  }), e;
}, Zg = ({
  playlist: t,
  mediaSequence: e
}) => {
  t.mediaSequence = e, t.segments.forEach((i, n) => {
    i.number = t.mediaSequence + n;
  });
}, Y6 = ({
  oldPlaylists: t,
  newPlaylists: e,
  timelineStarts: i
}) => {
  e.forEach((n) => {
    n.discontinuitySequence = i.findIndex(function({
      timeline: l
    }) {
      return l === n.timeline;
    });
    const s = W6(t, n.attributes.NAME);
    if (!s || n.sidx)
      return;
    const r = n.segments[0], a = s.segments.findIndex(function(l) {
      return Math.abs(l.presentationTime - r.presentationTime) < H6;
    });
    if (a === -1) {
      Zg({
        playlist: n,
        mediaSequence: s.mediaSequence + s.segments.length
      }), n.segments[0].discontinuity = !0, n.discontinuityStarts.unshift(0), (!s.segments.length && n.timeline > s.timeline || s.segments.length && n.timeline > s.segments[s.segments.length - 1].timeline) && n.discontinuitySequence--;
      return;
    }
    s.segments[a].discontinuity && !r.discontinuity && (r.discontinuity = !0, n.discontinuityStarts.unshift(0), n.discontinuitySequence--), Zg({
      playlist: n,
      mediaSequence: s.segments[a].number
    });
  });
}, X6 = ({
  oldManifest: t,
  newManifest: e
}) => {
  const i = t.playlists.concat(Qg(t)), n = e.playlists.concat(Qg(e));
  return e.timelineStarts = fb([t.timelineStarts, e.timelineStarts]), Y6({
    oldPlaylists: i,
    newPlaylists: n,
    timelineStarts: e.timelineStarts
  }), e;
}, ec = (t) => t && t.uri + "-" + z6(t.byterange), Bf = (t) => {
  const e = t.reduce(function(n, s) {
    return n[s.attributes.baseUrl] || (n[s.attributes.baseUrl] = []), n[s.attributes.baseUrl].push(s), n;
  }, {});
  let i = [];
  return Object.values(e).forEach((n) => {
    const s = ub(n.reduce((r, a) => {
      const o = a.attributes.id + (a.attributes.lang || "");
      return r[o] ? (a.segments && (a.segments[0] && (a.segments[0].discontinuity = !0), r[o].segments.push(...a.segments)), a.attributes.contentProtection && (r[o].attributes.contentProtection = a.attributes.contentProtection)) : (r[o] = a, r[o].attributes.timelineStarts = []), r[o].attributes.timelineStarts.push({
        // Although they represent the same number, it's important to have both to make it
        // compatible with HLS potentially having a similar attribute.
        start: a.attributes.periodStart,
        timeline: a.attributes.periodStart
      }), r;
    }, {}));
    i = i.concat(s);
  }), i.map((n) => (n.discontinuityStarts = R6(n.segments || [], "discontinuity"), n));
}, qp = (t, e) => {
  const i = ec(t.sidx), n = i && e[i] && e[i].sidx;
  return n && Vp(t, n, t.sidx.resolvedUri), t;
}, j6 = (t, e = {}) => {
  if (!Object.keys(e).length)
    return t;
  for (const i in t)
    t[i] = qp(t[i], e);
  return t;
}, G6 = ({
  attributes: t,
  segments: e,
  sidx: i,
  mediaSequence: n,
  discontinuitySequence: s,
  discontinuityStarts: r
}, a) => {
  const o = {
    attributes: {
      NAME: t.id,
      BANDWIDTH: t.bandwidth,
      CODECS: t.codecs,
      "PROGRAM-ID": 1
    },
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    targetDuration: t.duration,
    discontinuitySequence: s,
    discontinuityStarts: r,
    timelineStarts: t.timelineStarts,
    mediaSequence: n,
    segments: e
  };
  return t.contentProtection && (o.contentProtection = t.contentProtection), t.serviceLocation && (o.attributes.serviceLocation = t.serviceLocation), i && (o.sidx = i), a && (o.attributes.AUDIO = "audio", o.attributes.SUBTITLES = "subs"), o;
}, Q6 = ({
  attributes: t,
  segments: e,
  mediaSequence: i,
  discontinuityStarts: n,
  discontinuitySequence: s
}) => {
  typeof e > "u" && (e = [{
    uri: t.baseUrl,
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    duration: t.sourceDuration,
    number: 0
  }], t.duration = t.sourceDuration);
  const r = {
    NAME: t.id,
    BANDWIDTH: t.bandwidth,
    "PROGRAM-ID": 1
  };
  t.codecs && (r.CODECS = t.codecs);
  const a = {
    attributes: r,
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    targetDuration: t.duration,
    timelineStarts: t.timelineStarts,
    discontinuityStarts: n,
    discontinuitySequence: s,
    mediaSequence: i,
    segments: e
  };
  return t.serviceLocation && (a.attributes.serviceLocation = t.serviceLocation), a;
}, Z6 = (t, e = {}, i = !1) => {
  let n;
  const s = t.reduce((r, a) => {
    const o = a.attributes.role && a.attributes.role.value || "", l = a.attributes.lang || "";
    let u = a.attributes.label || "main";
    if (l && !a.attributes.label) {
      const c = o ? ` (${o})` : "";
      u = `${a.attributes.lang}${c}`;
    }
    r[u] || (r[u] = {
      language: l,
      autoselect: !0,
      default: o === "main",
      playlists: [],
      uri: ""
    });
    const d = qp(G6(a, i), e);
    return r[u].playlists.push(d), typeof n > "u" && o === "main" && (n = a, n.default = !0), r;
  }, {});
  if (!n) {
    const r = Object.keys(s)[0];
    s[r].default = !0;
  }
  return s;
}, K6 = (t, e = {}) => t.reduce((i, n) => {
  const s = n.attributes.label || n.attributes.lang || "text", r = n.attributes.lang || "und";
  return i[s] || (i[s] = {
    language: r,
    default: !1,
    autoselect: !1,
    playlists: [],
    uri: ""
  }), i[s].playlists.push(qp(Q6(n), e)), i;
}, {}), J6 = (t) => t.reduce((e, i) => (i && i.forEach((n) => {
  const {
    channel: s,
    language: r
  } = n;
  e[r] = {
    autoselect: !1,
    default: !1,
    instreamId: s,
    language: r
  }, n.hasOwnProperty("aspectRatio") && (e[r].aspectRatio = n.aspectRatio), n.hasOwnProperty("easyReader") && (e[r].easyReader = n.easyReader), n.hasOwnProperty("3D") && (e[r]["3D"] = n["3D"]);
}), e), {}), $6 = ({
  attributes: t,
  segments: e,
  sidx: i,
  discontinuityStarts: n
}) => {
  const s = {
    attributes: {
      NAME: t.id,
      AUDIO: "audio",
      SUBTITLES: "subs",
      RESOLUTION: {
        width: t.width,
        height: t.height
      },
      CODECS: t.codecs,
      BANDWIDTH: t.bandwidth,
      "PROGRAM-ID": 1
    },
    uri: "",
    endList: t.type === "static",
    timeline: t.periodStart,
    resolvedUri: t.baseUrl || "",
    targetDuration: t.duration,
    discontinuityStarts: n,
    timelineStarts: t.timelineStarts,
    segments: e
  };
  return t.frameRate && (s.attributes["FRAME-RATE"] = t.frameRate), t.contentProtection && (s.contentProtection = t.contentProtection), t.serviceLocation && (s.attributes.serviceLocation = t.serviceLocation), i && (s.sidx = i), s;
}, eR = ({
  attributes: t
}) => t.mimeType === "video/mp4" || t.mimeType === "video/webm" || t.contentType === "video", tR = ({
  attributes: t
}) => t.mimeType === "audio/mp4" || t.mimeType === "audio/webm" || t.contentType === "audio", iR = ({
  attributes: t
}) => t.mimeType === "text/vtt" || t.contentType === "text", nR = (t, e) => {
  t.forEach((i) => {
    i.mediaSequence = 0, i.discontinuitySequence = e.findIndex(function({
      timeline: n
    }) {
      return n === i.timeline;
    }), i.segments && i.segments.forEach((n, s) => {
      n.number = s;
    });
  });
}, Kg = (t) => t ? Object.keys(t).reduce((e, i) => {
  const n = t[i];
  return e.concat(n.playlists);
}, []) : [], sR = ({
  dashPlaylists: t,
  locations: e,
  contentSteering: i,
  sidxMapping: n = {},
  previousManifest: s,
  eventStream: r
}) => {
  if (!t.length)
    return {};
  const {
    sourceDuration: a,
    type: o,
    suggestedPresentationDelay: l,
    minimumUpdatePeriod: u
  } = t[0].attributes, d = Bf(t.filter(eR)).map($6), c = Bf(t.filter(tR)), A = Bf(t.filter(iR)), m = t.map((D) => D.attributes.captionServices).filter(Boolean), p = {
    allowCache: !0,
    discontinuityStarts: [],
    segments: [],
    endList: !0,
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: "",
    duration: a,
    playlists: j6(d, n)
  };
  u >= 0 && (p.minimumUpdatePeriod = u * 1e3), e && (p.locations = e), i && (p.contentSteering = i), o === "dynamic" && (p.suggestedPresentationDelay = l), r && r.length > 0 && (p.eventStream = r);
  const h = p.playlists.length === 0, g = c.length ? Z6(c, n, h) : null, w = A.length ? K6(A, n) : null, b = d.concat(Kg(g), Kg(w)), y = b.map(({
    timelineStarts: D
  }) => D);
  return p.timelineStarts = fb(y), nR(b, p.timelineStarts), g && (p.mediaGroups.AUDIO.audio = g), w && (p.mediaGroups.SUBTITLES.subs = w), m.length && (p.mediaGroups["CLOSED-CAPTIONS"].cc = J6(m)), s ? X6({
    oldManifest: s,
    newManifest: p
  }) : p;
}, rR = (t, e, i) => {
  const {
    NOW: n,
    clientOffset: s,
    availabilityStartTime: r,
    timescale: a = 1,
    periodStart: o = 0,
    minimumUpdatePeriod: l = 0
  } = t, u = (n + s) / 1e3, d = r + o, A = u + l - d;
  return Math.ceil((A * a - e) / i);
}, hb = (t, e) => {
  const {
    type: i,
    minimumUpdatePeriod: n = 0,
    media: s = "",
    sourceDuration: r,
    timescale: a = 1,
    startNumber: o = 1,
    periodStart: l
  } = t, u = [];
  let d = -1;
  for (let c = 0; c < e.length; c++) {
    const A = e[c], m = A.d, p = A.r || 0, h = A.t || 0;
    d < 0 && (d = h), h && h > d && (d = h);
    let g;
    if (p < 0) {
      const y = c + 1;
      y === e.length ? i === "dynamic" && n > 0 && s.indexOf("$Number$") > 0 ? g = rR(t, d, m) : g = (r * a - d) / m : g = (e[y].t - d) / m;
    } else
      g = p + 1;
    const w = o + u.length + g;
    let b = o + u.length;
    for (; b < w; )
      u.push({
        number: b,
        duration: m / a,
        time: d,
        timeline: l
      }), d += m, b++;
  }
  return u;
}, aR = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, oR = (t) => (e, i, n, s) => {
  if (e === "$$")
    return "$";
  if (typeof t[i] > "u")
    return e;
  const r = "" + t[i];
  return i === "RepresentationID" || (n ? s = parseInt(s, 10) : s = 1, r.length >= s) ? r : `${new Array(s - r.length + 1).join("0")}${r}`;
}, Jg = (t, e) => t.replace(aR, oR(e)), lR = (t, e) => !t.duration && !e ? [{
  number: t.startNumber || 1,
  duration: t.sourceDuration,
  time: 0,
  timeline: t.periodStart
}] : t.duration ? Up(t) : hb(t, e), uR = (t, e) => {
  const i = {
    RepresentationID: t.id,
    Bandwidth: t.bandwidth || 0
  }, {
    initialization: n = {
      sourceURL: "",
      range: ""
    }
  } = t, s = _l({
    baseUrl: t.baseUrl,
    source: Jg(n.sourceURL, i),
    range: n.range
  });
  return lR(t, e).map((a) => {
    i.Number = a.number, i.Time = a.time;
    const o = Jg(t.media || "", i), l = t.timescale || 1, u = t.presentationTimeOffset || 0, d = (
      // Even if the @t attribute is not specified for the segment, segment.time is
      // calculated in mpd-parser prior to this, so it's assumed to be available.
      t.periodStart + (a.time - u) / l
    );
    return {
      uri: o,
      timeline: a.timeline,
      duration: a.duration,
      resolvedUri: Jd(t.baseUrl || "", o),
      map: s,
      number: a.number,
      presentationTime: d
    };
  });
}, dR = (t, e) => {
  const {
    baseUrl: i,
    initialization: n = {}
  } = t, s = _l({
    baseUrl: i,
    source: n.sourceURL,
    range: n.range
  }), r = _l({
    baseUrl: i,
    source: e.media,
    range: e.mediaRange
  });
  return r.map = s, r;
}, cR = (t, e) => {
  const {
    duration: i,
    segmentUrls: n = [],
    periodStart: s
  } = t;
  if (!i && !e || i && e)
    throw new Error(ro.SEGMENT_TIME_UNSPECIFIED);
  const r = n.map((l) => dR(t, l));
  let a;
  return i && (a = Up(t)), e && (a = hb(t, e)), a.map((l, u) => {
    if (r[u]) {
      const d = r[u], c = t.timescale || 1, A = t.presentationTimeOffset || 0;
      return d.timeline = l.timeline, d.duration = l.duration, d.number = l.number, d.presentationTime = s + (l.time - A) / c, d;
    }
  }).filter((l) => l);
}, fR = ({
  attributes: t,
  segmentInfo: e
}) => {
  let i, n;
  e.template ? (n = uR, i = Di(t, e.template)) : e.base ? (n = cb, i = Di(t, e.base)) : e.list && (n = cR, i = Di(t, e.list));
  const s = {
    attributes: t
  };
  if (!n)
    return s;
  const r = n(i, e.segmentTimeline);
  if (i.duration) {
    const {
      duration: a,
      timescale: o = 1
    } = i;
    i.duration = a / o;
  } else r.length ? i.duration = r.reduce((a, o) => Math.max(a, Math.ceil(o.duration)), 0) : i.duration = 0;
  return s.attributes = i, s.segments = r, e.base && i.indexRange && (s.sidx = r[0], s.segments = []), s;
}, hR = (t) => t.map(fR), Kt = (t, e) => db(t.childNodes).filter(({
  tagName: i
}) => i === e), Yl = (t) => t.textContent.trim(), pR = (t) => parseFloat(t.split("/").reduce((e, i) => e / i)), Aa = (t) => {
  const o = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/.exec(t);
  if (!o)
    return 0;
  const [l, u, d, c, A, m] = o.slice(1);
  return parseFloat(l || 0) * 31536e3 + parseFloat(u || 0) * 2592e3 + parseFloat(d || 0) * 86400 + parseFloat(c || 0) * 3600 + parseFloat(A || 0) * 60 + parseFloat(m || 0);
}, mR = (t) => (/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(t) && (t += "Z"), Date.parse(t)), $g = {
  /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  mediaPresentationDuration(t) {
    return Aa(t);
  },
  /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */
  availabilityStartTime(t) {
    return mR(t) / 1e3;
  },
  /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  minimumUpdatePeriod(t) {
    return Aa(t);
  },
  /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  suggestedPresentationDelay(t) {
    return Aa(t);
  },
  /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */
  type(t) {
    return t;
  },
  /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  timeShiftBufferDepth(t) {
    return Aa(t);
  },
  /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  start(t) {
    return Aa(t);
  },
  /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */
  width(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */
  height(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */
  bandwidth(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */
  frameRate(t) {
    return pR(t);
  },
  /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  startNumber(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */
  timescale(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */
  presentationTimeOffset(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  duration(t) {
    const e = parseInt(t, 10);
    return isNaN(e) ? Aa(t) : e;
  },
  /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  d(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */
  t(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  r(t) {
    return parseInt(t, 10);
  },
  /**
   * Specifies the presentationTime.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTime
   */
  presentationTime(t) {
    return parseInt(t, 10);
  },
  /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */
  DEFAULT(t) {
    return t;
  }
}, yi = (t) => t && t.attributes ? db(t.attributes).reduce((e, i) => {
  const n = $g[i.name] || $g.DEFAULT;
  return e[i.name] = n(i.value), e;
}, {}) : {}, AR = {
  "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
  "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
  "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
  "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime",
  // ISO_IEC 23009-1_2022 5.8.5.2.2 The mp4 Protection Scheme
  "urn:mpeg:dash:mp4protection:2011": "mp4protection"
}, tc = (t, e) => e.length ? so(t.map(function(i) {
  return e.map(function(n) {
    const s = Yl(n), r = Jd(i.baseUrl, s), a = Di(yi(n), {
      baseUrl: r
    });
    return r !== s && !a.serviceLocation && i.serviceLocation && (a.serviceLocation = i.serviceLocation), a;
  });
})) : t, Hp = (t) => {
  const e = Kt(t, "SegmentTemplate")[0], i = Kt(t, "SegmentList")[0], n = i && Kt(i, "SegmentURL").map((c) => Di({
    tag: "SegmentURL"
  }, yi(c))), s = Kt(t, "SegmentBase")[0], r = i || e, a = r && Kt(r, "SegmentTimeline")[0], o = i || s || e, l = o && Kt(o, "Initialization")[0], u = e && yi(e);
  u && l ? u.initialization = l && yi(l) : u && u.initialization && (u.initialization = {
    sourceURL: u.initialization
  });
  const d = {
    template: u,
    segmentTimeline: a && Kt(a, "S").map((c) => yi(c)),
    list: i && Di(yi(i), {
      segmentUrls: n,
      initialization: yi(l)
    }),
    base: s && Di(yi(s), {
      initialization: yi(l)
    })
  };
  return Object.keys(d).forEach((c) => {
    d[c] || delete d[c];
  }), d;
}, gR = (t, e, i) => (n) => {
  const s = Kt(n, "BaseURL"), r = tc(e, s), a = Di(t, yi(n)), o = Hp(n);
  return r.map((l) => ({
    segmentInfo: Di(i, o),
    attributes: Di(a, l)
  }));
}, vR = (t) => t.reduce((e, i) => {
  const n = yi(i);
  n.schemeIdUri && (n.schemeIdUri = n.schemeIdUri.toLowerCase());
  const s = AR[n.schemeIdUri];
  if (s) {
    e[s] = {
      attributes: n
    };
    const r = Kt(i, "cenc:pssh")[0];
    if (r) {
      const a = Yl(r);
      e[s].pssh = a && ib(a);
    }
  }
  return e;
}, {}), yR = (t) => {
  if (t.schemeIdUri === "urn:scte:dash:cc:cea-608:2015")
    return (typeof t.value != "string" ? [] : t.value.split(";")).map((i) => {
      let n, s;
      return s = i, /^CC\d=/.test(i) ? [n, s] = i.split("=") : /^CC\d$/.test(i) && (n = i), {
        channel: n,
        language: s
      };
    });
  if (t.schemeIdUri === "urn:scte:dash:cc:cea-708:2015")
    return (typeof t.value != "string" ? [] : t.value.split(";")).map((i) => {
      const n = {
        // service or channel number 1-63
        channel: void 0,
        // language is a 3ALPHA per ISO 639.2/B
        // field is required
        language: void 0,
        // BIT 1/0 or ?
        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
        aspectRatio: 1,
        // BIT 1/0
        // easy reader flag indicated the text is tailed to the needs of beginning readers
        // default 0, or off
        easyReader: 0,
        // BIT 1/0
        // If 3d metadata is present (CEA-708.1) then 1
        // default 0
        "3D": 0
      };
      if (/=/.test(i)) {
        const [s, r = ""] = i.split("=");
        n.channel = s, n.language = i, r.split(",").forEach((a) => {
          const [o, l] = a.split(":");
          o === "lang" ? n.language = l : o === "er" ? n.easyReader = Number(l) : o === "war" ? n.aspectRatio = Number(l) : o === "3D" && (n["3D"] = Number(l));
        });
      } else
        n.language = i;
      return n.channel && (n.channel = "SERVICE" + n.channel), n;
    });
}, bR = (t) => so(Kt(t.node, "EventStream").map((e) => {
  const i = yi(e), n = i.schemeIdUri;
  return Kt(e, "Event").map((s) => {
    const r = yi(s), a = r.presentationTime || 0, o = i.timescale || 1, l = r.duration || 0, u = a / o + t.attributes.start;
    return {
      schemeIdUri: n,
      value: i.value,
      id: r.id,
      start: u,
      end: u + l / o,
      messageData: Yl(s) || r.messageData,
      contentEncoding: i.contentEncoding,
      presentationTimeOffset: i.presentationTimeOffset || 0
    };
  });
})), wR = (t, e, i) => (n) => {
  const s = yi(n), r = tc(e, Kt(n, "BaseURL")), a = Kt(n, "Role")[0], o = {
    role: yi(a)
  };
  let l = Di(t, s, o);
  const u = Kt(n, "Accessibility")[0], d = yR(yi(u));
  d && (l = Di(l, {
    captionServices: d
  }));
  const c = Kt(n, "Label")[0];
  if (c && c.childNodes.length) {
    const g = c.childNodes[0].nodeValue.trim();
    l = Di(l, {
      label: g
    });
  }
  const A = vR(Kt(n, "ContentProtection"));
  Object.keys(A).length && (l = Di(l, {
    contentProtection: A
  }));
  const m = Hp(n), p = Kt(n, "Representation"), h = Di(i, m);
  return so(p.map(gR(l, r, h)));
}, TR = (t, e) => (i, n) => {
  const s = tc(e, Kt(i.node, "BaseURL")), r = Di(t, {
    periodStart: i.attributes.start
  });
  typeof i.attributes.duration == "number" && (r.periodDuration = i.attributes.duration);
  const a = Kt(i.node, "AdaptationSet"), o = Hp(i.node);
  return so(a.map(wR(r, s, o)));
}, xR = (t, e) => {
  if (t.length > 1 && e({
    type: "warn",
    message: "The MPD manifest should contain no more than one ContentSteering tag"
  }), !t.length)
    return null;
  const i = Di({
    serverURL: Yl(t[0])
  }, yi(t[0]));
  return i.queryBeforeStart = i.queryBeforeStart === "true", i;
}, SR = ({
  attributes: t,
  priorPeriodAttributes: e,
  mpdType: i
}) => typeof t.start == "number" ? t.start : e && typeof e.start == "number" && typeof e.duration == "number" ? e.start + e.duration : !e && i === "static" ? 0 : null, CR = (t, e = {}) => {
  const {
    manifestUri: i = "",
    NOW: n = Date.now(),
    clientOffset: s = 0,
    // TODO: For now, we are expecting an eventHandler callback function
    // to be passed into the mpd parser as an option.
    // In the future, we should enable stream parsing by using the Stream class from vhs-utils.
    // This will support new features including a standardized event handler.
    // See the m3u8 parser for examples of how stream parsing is currently used for HLS parsing.
    // https://github.com/videojs/vhs-utils/blob/88d6e10c631e57a5af02c5a62bc7376cd456b4f5/src/stream.js#L9
    eventHandler: r = function() {
    }
  } = e, a = Kt(t, "Period");
  if (!a.length)
    throw new Error(ro.INVALID_NUMBER_OF_PERIOD);
  const o = Kt(t, "Location"), l = yi(t), u = tc([{
    baseUrl: i
  }], Kt(t, "BaseURL")), d = Kt(t, "ContentSteering");
  l.type = l.type || "static", l.sourceDuration = l.mediaPresentationDuration || 0, l.NOW = n, l.clientOffset = s, o.length && (l.locations = o.map(Yl));
  const c = [];
  return a.forEach((A, m) => {
    const p = yi(A), h = c[m - 1];
    p.start = SR({
      attributes: p,
      priorPeriodAttributes: h ? h.attributes : null,
      mpdType: l.type
    }), c.push({
      node: A,
      attributes: p
    });
  }), {
    locations: l.locations,
    contentSteeringInfo: xR(d, r),
    // TODO: There are occurences where this `representationInfo` array contains undesired
    // duplicates. This generally occurs when there are multiple BaseURL nodes that are
    // direct children of the MPD node. When we attempt to resolve URLs from a combination of the
    // parent BaseURL and a child BaseURL, and the value does not resolve,
    // we end up returning the child BaseURL multiple times.
    // We need to determine a way to remove these duplicates in a safe way.
    // See: https://github.com/videojs/mpd-parser/pull/17#discussion_r162750527
    representationInfo: so(c.map(TR(l, u))),
    eventStream: so(c.map(bR))
  };
}, pb = (t) => {
  if (t === "")
    throw new Error(ro.DASH_EMPTY_MANIFEST);
  const e = new L6.DOMParser();
  let i, n;
  try {
    i = e.parseFromString(t, "application/xml"), n = i && i.documentElement.tagName === "MPD" ? i.documentElement : null;
  } catch {
  }
  if (!n || n && n.getElementsByTagName("parsererror").length > 0)
    throw new Error(ro.DASH_INVALID_XML);
  return n;
}, ER = (t) => {
  const e = Kt(t, "UTCTiming")[0];
  if (!e)
    return null;
  const i = yi(e);
  switch (i.schemeIdUri) {
    case "urn:mpeg:dash:utc:http-head:2014":
    case "urn:mpeg:dash:utc:http-head:2012":
      i.method = "HEAD";
      break;
    case "urn:mpeg:dash:utc:http-xsdate:2014":
    case "urn:mpeg:dash:utc:http-iso:2014":
    case "urn:mpeg:dash:utc:http-xsdate:2012":
    case "urn:mpeg:dash:utc:http-iso:2012":
      i.method = "GET";
      break;
    case "urn:mpeg:dash:utc:direct:2014":
    case "urn:mpeg:dash:utc:direct:2012":
      i.method = "DIRECT", i.value = Date.parse(i.value);
      break;
    case "urn:mpeg:dash:utc:http-ntp:2014":
    case "urn:mpeg:dash:utc:ntp:2014":
    case "urn:mpeg:dash:utc:sntp:2014":
    default:
      throw new Error(ro.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return i;
}, DR = (t, e = {}) => {
  const i = CR(pb(t), e), n = hR(i.representationInfo);
  return sR({
    dashPlaylists: n,
    locations: i.locations,
    contentSteering: i.contentSteeringInfo,
    sidxMapping: e.sidxMapping,
    previousManifest: e.previousManifest,
    eventStream: i.eventStream
  });
}, _R = (t) => ER(pb(t));
var Lf, ev;
function kR() {
  if (ev) return Lf;
  ev = 1;
  var t = Math.pow(2, 32), e = function(i) {
    var n = new DataView(i.buffer, i.byteOffset, i.byteLength), s;
    return n.getBigUint64 ? (s = n.getBigUint64(0), s < Number.MAX_SAFE_INTEGER ? Number(s) : s) : n.getUint32(0) * t + n.getUint32(4);
  };
  return Lf = {
    getUint64: e,
    MAX_UINT32: t
  }, Lf;
}
var Nf, tv;
function PR() {
  if (tv) return Nf;
  tv = 1;
  var t = kR().getUint64, e = function(i) {
    var n = new DataView(i.buffer, i.byteOffset, i.byteLength), s = {
      version: i[0],
      flags: new Uint8Array(i.subarray(1, 4)),
      references: [],
      referenceId: n.getUint32(4),
      timescale: n.getUint32(8)
    }, r = 12;
    s.version === 0 ? (s.earliestPresentationTime = n.getUint32(r), s.firstOffset = n.getUint32(r + 4), r += 8) : (s.earliestPresentationTime = t(i.subarray(r)), s.firstOffset = t(i.subarray(r + 8)), r += 16), r += 2;
    var a = n.getUint16(r);
    for (r += 2; a > 0; r += 12, a--)
      s.references.push({
        referenceType: (i[r] & 128) >>> 7,
        referencedSize: n.getUint32(r) & 2147483647,
        subsegmentDuration: n.getUint32(r + 4),
        startsWithSap: !!(i[r + 8] & 128),
        sapType: (i[r + 8] & 112) >>> 4,
        sapDeltaTime: n.getUint32(r + 8) & 268435455
      });
    return s;
  };
  return Nf = e, Nf;
}
var IR = PR();
const MR = /* @__PURE__ */ Wl(IR);
var OR = it([73, 68, 51]), BR = function(e, i) {
  i === void 0 && (i = 0), e = it(e);
  var n = e[i + 5], s = e[i + 6] << 21 | e[i + 7] << 14 | e[i + 8] << 7 | e[i + 9], r = (n & 16) >> 4;
  return r ? s + 20 : s + 10;
}, nl = function t(e, i) {
  return i === void 0 && (i = 0), e = it(e), e.length - i < 10 || !Zt(e, OR, {
    offset: i
  }) ? i : (i += BR(e, i), t(e, i));
}, iv = function(e) {
  return typeof e == "string" ? ob(e) : e;
}, LR = function(e) {
  return Array.isArray(e) ? e.map(function(i) {
    return iv(i);
  }) : [iv(e)];
}, NR = function t(e, i, n) {
  n === void 0 && (n = !1), i = LR(i), e = it(e);
  var s = [];
  if (!i.length)
    return s;
  for (var r = 0; r < e.length; ) {
    var a = (e[r] << 24 | e[r + 1] << 16 | e[r + 2] << 8 | e[r + 3]) >>> 0, o = e.subarray(r + 4, r + 8);
    if (a === 0)
      break;
    var l = r + a;
    if (l > e.length) {
      if (n)
        break;
      l = e.length;
    }
    var u = e.subarray(r + 8, l);
    Zt(o, i[0]) && (i.length === 1 ? s.push(u) : s.push.apply(s, t(u, i.slice(1), n))), r = l;
  }
  return s;
}, Pu = {
  EBML: it([26, 69, 223, 163]),
  DocType: it([66, 130]),
  Segment: it([24, 83, 128, 103]),
  SegmentInfo: it([21, 73, 169, 102]),
  Tracks: it([22, 84, 174, 107]),
  Track: it([174]),
  TrackNumber: it([215]),
  DefaultDuration: it([35, 227, 131]),
  TrackEntry: it([174]),
  TrackType: it([131]),
  FlagDefault: it([136]),
  CodecID: it([134]),
  CodecPrivate: it([99, 162]),
  VideoTrack: it([224]),
  AudioTrack: it([225]),
  // Not used yet, but will be used for live webm/mkv
  // see https://www.matroska.org/technical/basics.html#block-structure
  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
  Cluster: it([31, 67, 182, 117]),
  Timestamp: it([231]),
  TimestampScale: it([42, 215, 177]),
  BlockGroup: it([160]),
  BlockDuration: it([155]),
  Block: it([161]),
  SimpleBlock: it([163])
}, Th = [128, 64, 32, 16, 8, 4, 2, 1], RR = function(e) {
  for (var i = 1, n = 0; n < Th.length && !(e & Th[n]); n++)
    i++;
  return i;
}, cd = function(e, i, n, s) {
  n === void 0 && (n = !0), s === void 0 && (s = !1);
  var r = RR(e[i]), a = e.subarray(i, i + r);
  return n && (a = Array.prototype.slice.call(e, i, i + r), a[0] ^= Th[r - 1]), {
    length: r,
    value: D6(a, {
      signed: s
    }),
    bytes: a
  };
}, nv = function t(e) {
  return typeof e == "string" ? e.match(/.{1,2}/g).map(function(i) {
    return t(i);
  }) : typeof e == "number" ? _6(e) : e;
}, FR = function(e) {
  return Array.isArray(e) ? e.map(function(i) {
    return nv(i);
  }) : [nv(e)];
}, zR = function t(e, i, n) {
  if (n >= i.length)
    return i.length;
  var s = cd(i, n, !1);
  if (Zt(e.bytes, s.bytes))
    return n;
  var r = cd(i, n + s.length);
  return t(e, i, n + r.length + r.value + s.length);
}, sv = function t(e, i) {
  i = FR(i), e = it(e);
  var n = [];
  if (!i.length)
    return n;
  for (var s = 0; s < e.length; ) {
    var r = cd(e, s, !1), a = cd(e, s + r.length), o = s + r.length + a.length;
    a.value === 127 && (a.value = zR(r, e, o), a.value !== e.length && (a.value -= o));
    var l = o + a.value > e.length ? e.length : o + a.value, u = e.subarray(o, l);
    Zt(i[0], r.bytes) && (i.length === 1 ? n.push(u) : n = n.concat(t(u, i.slice(1))));
    var d = r.length + a.length + u.length;
    s += d;
  }
  return n;
}, UR = it([0, 0, 0, 1]), VR = it([0, 0, 1]), qR = it([0, 0, 3]), HR = function(e) {
  for (var i = [], n = 1; n < e.length - 2; )
    Zt(e.subarray(n, n + 3), qR) && (i.push(n + 2), n++), n++;
  if (i.length === 0)
    return e;
  var s = e.length - i.length, r = new Uint8Array(s), a = 0;
  for (n = 0; n < s; a++, n++)
    a === i[0] && (a++, i.shift()), r[n] = e[a];
  return r;
}, mb = function(e, i, n, s) {
  e = it(e), n = [].concat(n);
  for (var r = 0, a, o = 0; r < e.length && (o < s || a); ) {
    var l = void 0;
    if (Zt(e.subarray(r), UR) ? l = 4 : Zt(e.subarray(r), VR) && (l = 3), !l) {
      r++;
      continue;
    }
    if (o++, a)
      return HR(e.subarray(a, r));
    var u = void 0;
    i === "h264" ? u = e[r + l] & 31 : i === "h265" && (u = e[r + l] >> 1 & 63), n.indexOf(u) !== -1 && (a = r + l), r += l + (i === "h264" ? 1 : 2);
  }
  return e.subarray(0, 0);
}, WR = function(e, i, n) {
  return mb(e, "h264", i, n);
}, YR = function(e, i, n) {
  return mb(e, "h265", i, n);
}, Zi = {
  // "webm" string literal in hex
  webm: it([119, 101, 98, 109]),
  // "matroska" string literal in hex
  matroska: it([109, 97, 116, 114, 111, 115, 107, 97]),
  // "fLaC" string literal in hex
  flac: it([102, 76, 97, 67]),
  // "OggS" string literal in hex
  ogg: it([79, 103, 103, 83]),
  // ac-3 sync byte, also works for ec-3 as that is simply a codec
  // of ac-3
  ac3: it([11, 119]),
  // "RIFF" string literal in hex used for wav and avi
  riff: it([82, 73, 70, 70]),
  // "AVI" string literal in hex
  avi: it([65, 86, 73]),
  // "WAVE" string literal in hex
  wav: it([87, 65, 86, 69]),
  // "ftyp3g" string literal in hex
  "3gp": it([102, 116, 121, 112, 51, 103]),
  // "ftyp" string literal in hex
  mp4: it([102, 116, 121, 112]),
  // "styp" string literal in hex
  fmp4: it([115, 116, 121, 112]),
  // "ftypqt" string literal in hex
  mov: it([102, 116, 121, 112, 113, 116]),
  // moov string literal in hex
  moov: it([109, 111, 111, 118]),
  // moof string literal in hex
  moof: it([109, 111, 111, 102])
}, ao = {
  aac: function(e) {
    var i = nl(e);
    return Zt(e, [255, 16], {
      offset: i,
      mask: [255, 22]
    });
  },
  mp3: function(e) {
    var i = nl(e);
    return Zt(e, [255, 2], {
      offset: i,
      mask: [255, 6]
    });
  },
  webm: function(e) {
    var i = sv(e, [Pu.EBML, Pu.DocType])[0];
    return Zt(i, Zi.webm);
  },
  mkv: function(e) {
    var i = sv(e, [Pu.EBML, Pu.DocType])[0];
    return Zt(i, Zi.matroska);
  },
  mp4: function(e) {
    if (ao["3gp"](e) || ao.mov(e))
      return !1;
    if (Zt(e, Zi.mp4, {
      offset: 4
    }) || Zt(e, Zi.fmp4, {
      offset: 4
    }) || Zt(e, Zi.moof, {
      offset: 4
    }) || Zt(e, Zi.moov, {
      offset: 4
    }))
      return !0;
  },
  mov: function(e) {
    return Zt(e, Zi.mov, {
      offset: 4
    });
  },
  "3gp": function(e) {
    return Zt(e, Zi["3gp"], {
      offset: 4
    });
  },
  ac3: function(e) {
    var i = nl(e);
    return Zt(e, Zi.ac3, {
      offset: i
    });
  },
  ts: function(e) {
    if (e.length < 189 && e.length >= 1)
      return e[0] === 71;
    for (var i = 0; i + 188 < e.length && i < 188; ) {
      if (e[i] === 71 && e[i + 188] === 71)
        return !0;
      i += 1;
    }
    return !1;
  },
  flac: function(e) {
    var i = nl(e);
    return Zt(e, Zi.flac, {
      offset: i
    });
  },
  ogg: function(e) {
    return Zt(e, Zi.ogg);
  },
  avi: function(e) {
    return Zt(e, Zi.riff) && Zt(e, Zi.avi, {
      offset: 8
    });
  },
  wav: function(e) {
    return Zt(e, Zi.riff) && Zt(e, Zi.wav, {
      offset: 8
    });
  },
  h264: function(e) {
    return WR(e, 7, 3).length;
  },
  h265: function(e) {
    return YR(e, [32, 33], 3).length;
  }
}, xh = Object.keys(ao).filter(function(t) {
  return t !== "ts" && t !== "h264" && t !== "h265";
}).concat(["ts", "h264", "h265"]);
xh.forEach(function(t) {
  var e = ao[t];
  ao[t] = function(i) {
    return e(it(i));
  };
});
var XR = ao, Wp = function(e) {
  e = it(e);
  for (var i = 0; i < xh.length; i++) {
    var n = xh[i];
    if (XR[n](e))
      return n;
  }
  return "";
}, jR = function(e) {
  return NR(e, ["moof"]).length > 0;
}, Rf, rv;
function GR() {
  if (rv) return Rf;
  rv = 1;
  var t = 9e4, e, i, n, s, r, a, o;
  return e = function(l) {
    return l * t;
  }, i = function(l, u) {
    return l * u;
  }, n = function(l) {
    return l / t;
  }, s = function(l, u) {
    return l / u;
  }, r = function(l, u) {
    return e(s(l, u));
  }, a = function(l, u) {
    return i(n(l), u);
  }, o = function(l, u, d) {
    return n(d ? l : l - u);
  }, Rf = {
    ONE_SECOND_IN_TS: t,
    secondsToVideoTs: e,
    secondsToAudioTs: i,
    videoTsToSeconds: n,
    audioTsToSeconds: s,
    audioTsToVideoTs: r,
    videoTsToAudioTs: a,
    metadataTsToSeconds: o
  }, Rf;
}
var Vr = GR();
/**
 * @license
 * Video.js 8.22.0 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */
var Sh = "8.22.0";
const Ns = {}, vr = function(t, e) {
  return Ns[t] = Ns[t] || [], e && (Ns[t] = Ns[t].concat(e)), Ns[t];
}, QR = function(t, e) {
  vr(t, e);
}, Ab = function(t, e) {
  const i = vr(t).indexOf(e);
  return i <= -1 ? !1 : (Ns[t] = Ns[t].slice(), Ns[t].splice(i, 1), !0);
}, ZR = function(t, e) {
  vr(t, [].concat(e).map((i) => {
    const n = (...s) => (Ab(t, n), i(...s));
    return n;
  }));
}, fd = {
  prefixed: !0
}, qu = [
  ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
  // WebKit
  ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"]
], av = qu[0];
let sl;
for (let t = 0; t < qu.length; t++)
  if (qu[t][1] in Ne) {
    sl = qu[t];
    break;
  }
if (sl) {
  for (let t = 0; t < sl.length; t++)
    fd[av[t]] = sl[t];
  fd.prefixed = sl[0] !== av[0];
}
let sn = [];
const KR = (t, e, i) => (n, s, r) => {
  const a = e.levels[s], o = new RegExp(`^(${a})$`);
  let l = t;
  if (n !== "log" && r.unshift(n.toUpperCase() + ":"), i && (l = `%c${t}`, r.unshift(i)), r.unshift(l + ":"), sn) {
    sn.push([].concat(r));
    const d = sn.length - 1e3;
    sn.splice(0, d > 0 ? d : 0);
  }
  if (!ne.console)
    return;
  let u = ne.console[n];
  !u && n === "debug" && (u = ne.console.info || ne.console.log), !(!u || !a || !o.test(n)) && u[Array.isArray(r) ? "apply" : "call"](ne.console, r);
};
function Ch(t, e = ":", i = "") {
  let n = "info", s;
  function r(...a) {
    s("log", n, a);
  }
  return s = KR(t, r, i), r.createLogger = (a, o, l) => {
    const u = o !== void 0 ? o : e, d = l !== void 0 ? l : i, c = `${t} ${u} ${a}`;
    return Ch(c, u, d);
  }, r.createNewLogger = (a, o, l) => Ch(a, o, l), r.levels = {
    all: "debug|log|warn|error",
    off: "",
    debug: "debug|log|warn|error",
    info: "log|warn|error",
    warn: "warn|error",
    error: "error",
    DEFAULT: n
  }, r.level = (a) => {
    if (typeof a == "string") {
      if (!r.levels.hasOwnProperty(a))
        throw new Error(`"${a}" in not a valid log level`);
      n = a;
    }
    return n;
  }, r.history = () => sn ? [].concat(sn) : [], r.history.filter = (a) => (sn || []).filter((o) => new RegExp(`.*${a}.*`).test(o[0])), r.history.clear = () => {
    sn && (sn.length = 0);
  }, r.history.disable = () => {
    sn !== null && (sn.length = 0, sn = null);
  }, r.history.enable = () => {
    sn === null && (sn = []);
  }, r.error = (...a) => s("error", n, a), r.warn = (...a) => s("warn", n, a), r.debug = (...a) => s("debug", n, a), r;
}
const pt = Ch("VIDEOJS"), gb = pt.createLogger, JR = Object.prototype.toString, vb = function(t) {
  return Ds(t) ? Object.keys(t) : [];
};
function Ba(t, e) {
  vb(t).forEach((i) => e(t[i], i));
}
function yb(t, e, i = 0) {
  return vb(t).reduce((n, s) => e(n, t[s], s), i);
}
function Ds(t) {
  return !!t && typeof t == "object";
}
function oo(t) {
  return Ds(t) && JR.call(t) === "[object Object]" && t.constructor === Object;
}
function Bt(...t) {
  const e = {};
  return t.forEach((i) => {
    i && Ba(i, (n, s) => {
      if (!oo(n)) {
        e[s] = n;
        return;
      }
      oo(e[s]) || (e[s] = {}), e[s] = Bt(e[s], n);
    });
  }), e;
}
function bb(t = {}) {
  const e = [];
  for (const i in t)
    if (t.hasOwnProperty(i)) {
      const n = t[i];
      e.push(n);
    }
  return e;
}
function ic(t, e, i, n = !0) {
  const s = (a) => Object.defineProperty(t, e, {
    value: a,
    enumerable: !0,
    writable: !0
  }), r = {
    configurable: !0,
    enumerable: !0,
    get() {
      const a = i();
      return s(a), a;
    }
  };
  return n && (r.set = s), Object.defineProperty(t, e, r);
}
var $R = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  each: Ba,
  reduce: yb,
  isObject: Ds,
  isPlain: oo,
  merge: Bt,
  values: bb,
  defineLazyProperty: ic
});
let Yp = !1, wb = null, rs = !1, Tb, xb = !1, La = !1, Na = !1, _s = !1, Xp = null, nc = null;
const eF = !!(ne.cast && ne.cast.framework && ne.cast.framework.CastReceiverContext);
let Sb = null, hd = !1, sc = !1, pd = !1, rc = !1, md = !1, Ad = !1, gd = !1;
const kl = !!(yo() && ("ontouchstart" in ne || ne.navigator.maxTouchPoints || ne.DocumentTouch && ne.document instanceof ne.DocumentTouch)), ir = ne.navigator && ne.navigator.userAgentData;
ir && ir.platform && ir.brands && (rs = ir.platform === "Android", La = !!ir.brands.find((t) => t.brand === "Microsoft Edge"), Na = !!ir.brands.find((t) => t.brand === "Chromium"), _s = !La && Na, Xp = nc = (ir.brands.find((t) => t.brand === "Chromium") || {}).version || null, sc = ir.platform === "Windows");
if (!Na) {
  const t = ne.navigator && ne.navigator.userAgent || "";
  Yp = /iPod/i.test(t), wb = function() {
    const e = t.match(/OS (\d+)_/i);
    return e && e[1] ? e[1] : null;
  }(), rs = /Android/i.test(t), Tb = function() {
    const e = t.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
    if (!e)
      return null;
    const i = e[1] && parseFloat(e[1]), n = e[2] && parseFloat(e[2]);
    return i && n ? parseFloat(e[1] + "." + e[2]) : i || null;
  }(), xb = /Firefox/i.test(t), La = /Edg/i.test(t), Na = /Chrome/i.test(t) || /CriOS/i.test(t), _s = !La && Na, Xp = nc = function() {
    const e = t.match(/(Chrome|CriOS)\/(\d+)/);
    return e && e[2] ? parseFloat(e[2]) : null;
  }(), Sb = function() {
    const e = /MSIE\s(\d+)\.\d/.exec(t);
    let i = e && parseFloat(e[1]);
    return !i && /Trident\/7.0/i.test(t) && /rv:11.0/.test(t) && (i = 11), i;
  }(), md = /Tizen/i.test(t), Ad = /Web0S/i.test(t), gd = md || Ad, hd = /Safari/i.test(t) && !_s && !rs && !La && !gd, sc = /Windows/i.test(t), pd = /iPad/i.test(t) || hd && kl && !/iPhone/i.test(t), rc = /iPhone/i.test(t) && !pd;
}
const Vi = rc || pd || Yp, ac = (hd || Vi) && !_s;
var Cb = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  get IS_IPOD() {
    return Yp;
  },
  get IOS_VERSION() {
    return wb;
  },
  get IS_ANDROID() {
    return rs;
  },
  get ANDROID_VERSION() {
    return Tb;
  },
  get IS_FIREFOX() {
    return xb;
  },
  get IS_EDGE() {
    return La;
  },
  get IS_CHROMIUM() {
    return Na;
  },
  get IS_CHROME() {
    return _s;
  },
  get CHROMIUM_VERSION() {
    return Xp;
  },
  get CHROME_VERSION() {
    return nc;
  },
  IS_CHROMECAST_RECEIVER: eF,
  get IE_VERSION() {
    return Sb;
  },
  get IS_SAFARI() {
    return hd;
  },
  get IS_WINDOWS() {
    return sc;
  },
  get IS_IPAD() {
    return pd;
  },
  get IS_IPHONE() {
    return rc;
  },
  get IS_TIZEN() {
    return md;
  },
  get IS_WEBOS() {
    return Ad;
  },
  get IS_SMART_TV() {
    return gd;
  },
  TOUCH_ENABLED: kl,
  IS_IOS: Vi,
  IS_ANY_SAFARI: ac
});
function ov(t) {
  return typeof t == "string" && !!t.trim();
}
function tF(t) {
  if (t.indexOf(" ") >= 0)
    throw new Error("class has illegal whitespace characters");
}
function yo() {
  return Ne === ne.document;
}
function bo(t) {
  return Ds(t) && t.nodeType === 1;
}
function Eb() {
  try {
    return ne.parent !== ne.self;
  } catch {
    return !0;
  }
}
function Db(t) {
  return function(e, i) {
    if (!ov(e))
      return Ne[t](null);
    ov(i) && (i = Ne.querySelector(i));
    const n = bo(i) ? i : Ne;
    return n[t] && n[t](e);
  };
}
function st(t = "div", e = {}, i = {}, n) {
  const s = Ne.createElement(t);
  return Object.getOwnPropertyNames(e).forEach(function(r) {
    const a = e[r];
    r === "textContent" ? Sr(s, a) : (s[r] !== a || r === "tabIndex") && (s[r] = a);
  }), Object.getOwnPropertyNames(i).forEach(function(r) {
    s.setAttribute(r, i[r]);
  }), n && jp(s, n), s;
}
function Sr(t, e) {
  return typeof t.textContent > "u" ? t.innerText = e : t.textContent = e, t;
}
function Eh(t, e) {
  e.firstChild ? e.insertBefore(t, e.firstChild) : e.appendChild(t);
}
function gl(t, e) {
  return tF(e), t.classList.contains(e);
}
function Gr(t, ...e) {
  return t.classList.add(...e.reduce((i, n) => i.concat(n.split(/\s+/)), [])), t;
}
function oc(t, ...e) {
  return t ? (t.classList.remove(...e.reduce((i, n) => i.concat(n.split(/\s+/)), [])), t) : (pt.warn("removeClass was called with an element that doesn't exist"), null);
}
function _b(t, e, i) {
  return typeof i == "function" && (i = i(t, e)), typeof i != "boolean" && (i = void 0), e.split(/\s+/).forEach((n) => t.classList.toggle(n, i)), t;
}
function kb(t, e) {
  Object.getOwnPropertyNames(e).forEach(function(i) {
    const n = e[i];
    n === null || typeof n > "u" || n === !1 ? t.removeAttribute(i) : t.setAttribute(i, n === !0 ? "" : n);
  });
}
function or(t) {
  const e = {}, i = ["autoplay", "controls", "playsinline", "loop", "muted", "default", "defaultMuted"];
  if (t && t.attributes && t.attributes.length > 0) {
    const n = t.attributes;
    for (let s = n.length - 1; s >= 0; s--) {
      const r = n[s].name;
      let a = n[s].value;
      i.includes(r) && (a = a !== null), e[r] = a;
    }
  }
  return e;
}
function Pb(t, e) {
  return t.getAttribute(e);
}
function lo(t, e, i) {
  t.setAttribute(e, i);
}
function lc(t, e) {
  t.removeAttribute(e);
}
function Ib() {
  Ne.body.focus(), Ne.onselectstart = function() {
    return !1;
  };
}
function Mb() {
  Ne.onselectstart = function() {
    return !0;
  };
}
function uo(t) {
  if (t && t.getBoundingClientRect && t.parentNode) {
    const e = t.getBoundingClientRect(), i = {};
    return ["bottom", "height", "left", "right", "top", "width"].forEach((n) => {
      e[n] !== void 0 && (i[n] = e[n]);
    }), i.height || (i.height = parseFloat(co(t, "height"))), i.width || (i.width = parseFloat(co(t, "width"))), i;
  }
}
function Pl(t) {
  if (!t || t && !t.offsetParent)
    return {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
  const e = t.offsetWidth, i = t.offsetHeight;
  let n = 0, s = 0;
  for (; t.offsetParent && t !== Ne[fd.fullscreenElement]; )
    n += t.offsetLeft, s += t.offsetTop, t = t.offsetParent;
  return {
    left: n,
    top: s,
    width: e,
    height: i
  };
}
function uc(t, e) {
  const i = {
    x: 0,
    y: 0
  };
  if (Vi) {
    let d = t;
    for (; d && d.nodeName.toLowerCase() !== "html"; ) {
      const c = co(d, "transform");
      if (/^matrix/.test(c)) {
        const A = c.slice(7, -1).split(/,\s/).map(Number);
        i.x += A[4], i.y += A[5];
      } else if (/^matrix3d/.test(c)) {
        const A = c.slice(9, -1).split(/,\s/).map(Number);
        i.x += A[12], i.y += A[13];
      }
      if (d.assignedSlot && d.assignedSlot.parentElement && ne.WebKitCSSMatrix) {
        const A = ne.getComputedStyle(d.assignedSlot.parentElement).transform, m = new ne.WebKitCSSMatrix(A);
        i.x += m.m41, i.y += m.m42;
      }
      d = d.parentNode || d.host;
    }
  }
  const n = {}, s = Pl(e.target), r = Pl(t), a = r.width, o = r.height;
  let l = e.offsetY - (r.top - s.top), u = e.offsetX - (r.left - s.left);
  return e.changedTouches && (u = e.changedTouches[0].pageX - r.left, l = e.changedTouches[0].pageY + r.top, Vi && (u -= i.x, l -= i.y)), n.y = 1 - Math.max(0, Math.min(1, l / o)), n.x = Math.max(0, Math.min(1, u / a)), n;
}
function Ob(t) {
  return Ds(t) && t.nodeType === 3;
}
function dc(t) {
  for (; t.firstChild; )
    t.removeChild(t.firstChild);
  return t;
}
function Bb(t) {
  return typeof t == "function" && (t = t()), (Array.isArray(t) ? t : [t]).map((e) => {
    if (typeof e == "function" && (e = e()), bo(e) || Ob(e))
      return e;
    if (typeof e == "string" && /\S/.test(e))
      return Ne.createTextNode(e);
  }).filter((e) => e);
}
function jp(t, e) {
  return Bb(e).forEach((i) => t.appendChild(i)), t;
}
function Lb(t, e) {
  return jp(dc(t), e);
}
function Il(t) {
  return t.button === void 0 && t.buttons === void 0 || t.button === 0 && t.buttons === void 0 || t.type === "mouseup" && t.button === 0 && t.buttons === 0 || t.type === "mousedown" && t.button === 0 && t.buttons === 0 ? !0 : !(t.button !== 0 || t.buttons !== 1);
}
const yr = Db("querySelector"), Nb = Db("querySelectorAll");
function co(t, e) {
  if (!t || !e)
    return "";
  if (typeof ne.getComputedStyle == "function") {
    let i;
    try {
      i = ne.getComputedStyle(t);
    } catch {
      return "";
    }
    return i ? i.getPropertyValue(e) || i[e] : "";
  }
  return "";
}
function Rb(t) {
  [...Ne.styleSheets].forEach((e) => {
    try {
      const i = [...e.cssRules].map((s) => s.cssText).join(""), n = Ne.createElement("style");
      n.textContent = i, t.document.head.appendChild(n);
    } catch {
      const n = Ne.createElement("link");
      n.rel = "stylesheet", n.type = e.type, n.media = e.media.mediaText, n.href = e.href, t.document.head.appendChild(n);
    }
  });
}
var Fb = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isReal: yo,
  isEl: bo,
  isInFrame: Eb,
  createEl: st,
  textContent: Sr,
  prependTo: Eh,
  hasClass: gl,
  addClass: Gr,
  removeClass: oc,
  toggleClass: _b,
  setAttributes: kb,
  getAttributes: or,
  getAttribute: Pb,
  setAttribute: lo,
  removeAttribute: lc,
  blockTextSelection: Ib,
  unblockTextSelection: Mb,
  getBoundingClientRect: uo,
  findPosition: Pl,
  getPointerPosition: uc,
  isTextNode: Ob,
  emptyEl: dc,
  normalizeContent: Bb,
  appendContent: jp,
  insertContent: Lb,
  isSingleLeftClick: Il,
  $: yr,
  $$: Nb,
  computedStyle: co,
  copyStyleSheetsToWindow: Rb
});
let zb = !1, Dh;
const iF = function() {
  if (Dh.options.autoSetup === !1)
    return;
  const t = Array.prototype.slice.call(Ne.getElementsByTagName("video")), e = Array.prototype.slice.call(Ne.getElementsByTagName("audio")), i = Array.prototype.slice.call(Ne.getElementsByTagName("video-js")), n = t.concat(e, i);
  if (n && n.length > 0)
    for (let s = 0, r = n.length; s < r; s++) {
      const a = n[s];
      if (a && a.getAttribute)
        a.player === void 0 && a.getAttribute("data-setup") !== null && Dh(a);
      else {
        _h(1);
        break;
      }
    }
  else zb || _h(1);
};
function _h(t, e) {
  yo() && (e && (Dh = e), ne.setTimeout(iF, t));
}
function kh() {
  zb = !0, ne.removeEventListener("load", kh);
}
yo() && (Ne.readyState === "complete" ? kh() : ne.addEventListener("load", kh));
const Ub = function(t) {
  const e = Ne.createElement("style");
  return e.className = t, e;
}, Vb = function(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.textContent = e;
};
var en = /* @__PURE__ */ new WeakMap();
const nF = 3;
let sF = nF;
function Bn() {
  return sF++;
}
function lv(t, e) {
  if (!en.has(t))
    return;
  const i = en.get(t);
  i.handlers[e].length === 0 && (delete i.handlers[e], t.removeEventListener ? t.removeEventListener(e, i.dispatcher, !1) : t.detachEvent && t.detachEvent("on" + e, i.dispatcher)), Object.getOwnPropertyNames(i.handlers).length <= 0 && (delete i.handlers, delete i.dispatcher, delete i.disabled), Object.getOwnPropertyNames(i).length === 0 && en.delete(t);
}
function Gp(t, e, i, n) {
  i.forEach(function(s) {
    t(e, s, n);
  });
}
function cc(t) {
  if (t.fixed_)
    return t;
  function e() {
    return !0;
  }
  function i() {
    return !1;
  }
  if (!t || !t.isPropagationStopped || !t.isImmediatePropagationStopped) {
    const n = t || ne.event;
    t = {};
    const s = ["layerX", "layerY", "keyLocation", "path", "webkitMovementX", "webkitMovementY", "mozPressure", "mozInputSource"];
    for (const r in n)
      s.includes(r) || r === "returnValue" && n.preventDefault || (t[r] = n[r]);
    if (t.target || (t.target = t.srcElement || Ne), t.relatedTarget || (t.relatedTarget = t.fromElement === t.target ? t.toElement : t.fromElement), t.preventDefault = function() {
      n.preventDefault && n.preventDefault(), t.returnValue = !1, n.returnValue = !1, t.defaultPrevented = !0;
    }, t.defaultPrevented = !1, t.stopPropagation = function() {
      n.stopPropagation && n.stopPropagation(), t.cancelBubble = !0, n.cancelBubble = !0, t.isPropagationStopped = e;
    }, t.isPropagationStopped = i, t.stopImmediatePropagation = function() {
      n.stopImmediatePropagation && n.stopImmediatePropagation(), t.isImmediatePropagationStopped = e, t.stopPropagation();
    }, t.isImmediatePropagationStopped = i, t.clientX !== null && t.clientX !== void 0) {
      const r = Ne.documentElement, a = Ne.body;
      t.pageX = t.clientX + (r && r.scrollLeft || a && a.scrollLeft || 0) - (r && r.clientLeft || a && a.clientLeft || 0), t.pageY = t.clientY + (r && r.scrollTop || a && a.scrollTop || 0) - (r && r.clientTop || a && a.clientTop || 0);
    }
    t.which = t.charCode || t.keyCode, t.button !== null && t.button !== void 0 && (t.button = t.button & 1 ? 0 : t.button & 4 ? 1 : t.button & 2 ? 2 : 0);
  }
  return t.fixed_ = !0, t;
}
let Iu;
const rF = function() {
  if (typeof Iu != "boolean") {
    Iu = !1;
    try {
      const t = Object.defineProperty({}, "passive", {
        get() {
          Iu = !0;
        }
      });
      ne.addEventListener("test", null, t), ne.removeEventListener("test", null, t);
    } catch {
    }
  }
  return Iu;
}, aF = ["touchstart", "touchmove"];
function xn(t, e, i) {
  if (Array.isArray(e))
    return Gp(xn, t, e, i);
  en.has(t) || en.set(t, {});
  const n = en.get(t);
  if (n.handlers || (n.handlers = {}), n.handlers[e] || (n.handlers[e] = []), i.guid || (i.guid = Bn()), n.handlers[e].push(i), n.dispatcher || (n.disabled = !1, n.dispatcher = function(s, r) {
    if (n.disabled)
      return;
    s = cc(s);
    const a = n.handlers[s.type];
    if (a) {
      const o = a.slice(0);
      for (let l = 0, u = o.length; l < u && !s.isImmediatePropagationStopped(); l++)
        try {
          o[l].call(t, s, r);
        } catch (d) {
          pt.error(d);
        }
    }
  }), n.handlers[e].length === 1)
    if (t.addEventListener) {
      let s = !1;
      rF() && aF.indexOf(e) > -1 && (s = {
        passive: !0
      }), t.addEventListener(e, n.dispatcher, s);
    } else t.attachEvent && t.attachEvent("on" + e, n.dispatcher);
}
function qi(t, e, i) {
  if (!en.has(t))
    return;
  const n = en.get(t);
  if (!n.handlers)
    return;
  if (Array.isArray(e))
    return Gp(qi, t, e, i);
  const s = function(a, o) {
    n.handlers[o] = [], lv(a, o);
  };
  if (e === void 0) {
    for (const a in n.handlers)
      Object.prototype.hasOwnProperty.call(n.handlers || {}, a) && s(t, a);
    return;
  }
  const r = n.handlers[e];
  if (r) {
    if (!i) {
      s(t, e);
      return;
    }
    if (i.guid)
      for (let a = 0; a < r.length; a++)
        r[a].guid === i.guid && r.splice(a--, 1);
    lv(t, e);
  }
}
function wo(t, e, i) {
  const n = en.has(t) ? en.get(t) : {}, s = t.parentNode || t.ownerDocument;
  if (typeof e == "string" ? e = {
    type: e,
    target: t
  } : e.target || (e.target = t), e = cc(e), n.dispatcher && n.dispatcher.call(t, e, i), s && !e.isPropagationStopped() && e.bubbles === !0)
    wo.call(null, s, e, i);
  else if (!s && !e.defaultPrevented && e.target && e.target[e.type]) {
    en.has(e.target) || en.set(e.target, {});
    const r = en.get(e.target);
    e.target[e.type] && (r.disabled = !0, typeof e.target[e.type] == "function" && e.target[e.type](), r.disabled = !1);
  }
  return !e.defaultPrevented;
}
function fc(t, e, i) {
  if (Array.isArray(e))
    return Gp(fc, t, e, i);
  const n = function() {
    qi(t, e, n), i.apply(this, arguments);
  };
  n.guid = i.guid = i.guid || Bn(), xn(t, e, n);
}
function Qp(t, e, i) {
  const n = function() {
    qi(t, e, n), i.apply(this, arguments);
  };
  n.guid = i.guid = i.guid || Bn(), xn(t, e, n);
}
var oF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fixEvent: cc,
  on: xn,
  off: qi,
  trigger: wo,
  one: fc,
  any: Qp
});
const Ln = 30, zt = function(t, e, i) {
  e.guid || (e.guid = Bn());
  const n = e.bind(t);
  return n.guid = i ? i + "_" + e.guid : e.guid, n;
}, ks = function(t, e) {
  let i = ne.performance.now();
  return function(...s) {
    const r = ne.performance.now();
    r - i >= e && (t(...s), i = r);
  };
}, qb = function(t, e, i, n = ne) {
  let s;
  const r = () => {
    n.clearTimeout(s), s = null;
  }, a = function() {
    const o = this, l = arguments;
    let u = function() {
      s = null, u = null, i || t.apply(o, l);
    };
    !s && i && t.apply(o, l), n.clearTimeout(s), s = n.setTimeout(u, e);
  };
  return a.cancel = r, a;
};
var lF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  UPDATE_REFRESH_INTERVAL: Ln,
  bind_: zt,
  throttle: ks,
  debounce: qb
});
let Go;
class Sn {
  /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */
  on(e, i) {
    const n = this.addEventListener;
    this.addEventListener = () => {
    }, xn(this, e, i), this.addEventListener = n;
  }
  /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to remove.
   */
  off(e, i) {
    qi(this, e, i);
  }
  /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  one(e, i) {
    const n = this.addEventListener;
    this.addEventListener = () => {
    }, fc(this, e, i), this.addEventListener = n;
  }
  /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  any(e, i) {
    const n = this.addEventListener;
    this.addEventListener = () => {
    }, Qp(this, e, i), this.addEventListener = n;
  }
  /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|EventTarget~Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   */
  trigger(e) {
    const i = e.type || e;
    typeof e == "string" && (e = {
      type: i
    }), e = cc(e), this.allowedEvents_[i] && this["on" + i] && this["on" + i](e), wo(this, e);
  }
  queueTrigger(e) {
    Go || (Go = /* @__PURE__ */ new Map());
    const i = e.type || e;
    let n = Go.get(this);
    n || (n = /* @__PURE__ */ new Map(), Go.set(this, n));
    const s = n.get(i);
    n.delete(i), ne.clearTimeout(s);
    const r = ne.setTimeout(() => {
      n.delete(i), n.size === 0 && (n = null, Go.delete(this)), this.trigger(e);
    }, 0);
    n.set(i, r);
  }
}
Sn.prototype.allowedEvents_ = {};
Sn.prototype.addEventListener = Sn.prototype.on;
Sn.prototype.removeEventListener = Sn.prototype.off;
Sn.prototype.dispatchEvent = Sn.prototype.trigger;
const hc = (t) => typeof t.name == "function" ? t.name() : typeof t.name == "string" ? t.name : t.name_ ? t.name_ : t.constructor && t.constructor.name ? t.constructor.name : typeof t, Us = (t) => t instanceof Sn || !!t.eventBusEl_ && ["on", "one", "off", "trigger"].every((e) => typeof t[e] == "function"), uF = (t, e) => {
  Us(t) ? e() : (t.eventedCallbacks || (t.eventedCallbacks = []), t.eventedCallbacks.push(e));
}, Ph = (t) => (
  // The regex here verifies that the `type` contains at least one non-
  // whitespace character.
  typeof t == "string" && /\S/.test(t) || Array.isArray(t) && !!t.length
), vd = (t, e, i) => {
  if (!t || !t.nodeName && !Us(t))
    throw new Error(`Invalid target for ${hc(e)}#${i}; must be a DOM node or evented object.`);
}, Hb = (t, e, i) => {
  if (!Ph(t))
    throw new Error(`Invalid event type for ${hc(e)}#${i}; must be a non-empty string or array.`);
}, Wb = (t, e, i) => {
  if (typeof t != "function")
    throw new Error(`Invalid listener for ${hc(e)}#${i}; must be a function.`);
}, Ff = (t, e, i) => {
  const n = e.length < 3 || e[0] === t || e[0] === t.eventBusEl_;
  let s, r, a;
  return n ? (s = t.eventBusEl_, e.length >= 3 && e.shift(), [r, a] = e) : (s = e[0], r = e[1], a = e[2]), vd(s, t, i), Hb(r, t, i), Wb(a, t, i), a = zt(t, a), {
    isTargetingSelf: n,
    target: s,
    type: r,
    listener: a
  };
}, Mr = (t, e, i, n) => {
  vd(t, t, e), t.nodeName ? oF[e](t, i, n) : t[e](i, n);
}, dF = {
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  on(...t) {
    const {
      isTargetingSelf: e,
      target: i,
      type: n,
      listener: s
    } = Ff(this, t, "on");
    if (Mr(i, "on", n, s), !e) {
      const r = () => this.off(i, n, s);
      r.guid = s.guid;
      const a = () => this.off("dispose", r);
      a.guid = s.guid, Mr(this, "on", "dispose", r), Mr(i, "on", "dispose", a);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  one(...t) {
    const {
      isTargetingSelf: e,
      target: i,
      type: n,
      listener: s
    } = Ff(this, t, "one");
    if (e)
      Mr(i, "one", n, s);
    else {
      const r = (...a) => {
        this.off(i, n, r), s.apply(null, a);
      };
      r.guid = s.guid, Mr(i, "one", n, r);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  any(...t) {
    const {
      isTargetingSelf: e,
      target: i,
      type: n,
      listener: s
    } = Ff(this, t, "any");
    if (e)
      Mr(i, "any", n, s);
    else {
      const r = (...a) => {
        this.off(i, n, r), s.apply(null, a);
      };
      r.guid = s.guid, Mr(i, "any", n, r);
    }
  },
  /**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */
  off(t, e, i) {
    if (!t || Ph(t))
      qi(this.eventBusEl_, t, e);
    else {
      const n = t, s = e;
      vd(n, this, "off"), Hb(s, this, "off"), Wb(i, this, "off"), i = zt(this, i), this.off("dispose", i), n.nodeName ? (qi(n, s, i), qi(n, "dispose", i)) : Us(n) && (n.off(s, i), n.off("dispose", i));
    }
  },
  /**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */
  trigger(t, e) {
    vd(this.eventBusEl_, this, "trigger");
    const i = t && typeof t != "string" ? t.type : t;
    if (!Ph(i))
      throw new Error(`Invalid event type for ${hc(this)}#trigger; must be a non-empty string or object with a type key that has a non-empty value.`);
    return wo(this.eventBusEl_, t, e);
  }
};
function Zp(t, e = {}) {
  const {
    eventBusKey: i
  } = e;
  if (i) {
    if (!t[i].nodeName)
      throw new Error(`The eventBusKey "${i}" does not refer to an element.`);
    t.eventBusEl_ = t[i];
  } else
    t.eventBusEl_ = st("span", {
      className: "vjs-event-bus"
    });
  return Object.assign(t, dF), t.eventedCallbacks && t.eventedCallbacks.forEach((n) => {
    n();
  }), t.on("dispose", () => {
    t.off(), [t, t.el_, t.eventBusEl_].forEach(function(n) {
      n && en.has(n) && en.delete(n);
    }), ne.setTimeout(() => {
      t.eventBusEl_ = null;
    }, 0);
  }), t;
}
const cF = {
  /**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */
  state: {},
  /**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */
  setState(t) {
    typeof t == "function" && (t = t());
    let e;
    return Ba(t, (i, n) => {
      this.state[n] !== i && (e = e || {}, e[n] = {
        from: this.state[n],
        to: i
      }), this.state[n] = i;
    }), e && Us(this) && this.trigger({
      changes: e,
      type: "statechanged"
    }), e;
  }
};
function Yb(t, e) {
  return Object.assign(t, cF), t.state = Object.assign({}, t.state, e), typeof t.handleStateChanged == "function" && Us(t) && t.on("statechanged", t.handleStateChanged), t;
}
const vl = function(t) {
  return typeof t != "string" ? t : t.replace(/./, (e) => e.toLowerCase());
}, oi = function(t) {
  return typeof t != "string" ? t : t.replace(/./, (e) => e.toUpperCase());
}, Xb = function(t, e) {
  return oi(t) === oi(e);
};
var fF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  toLowerCase: vl,
  toTitleCase: oi,
  titleCaseEquals: Xb
});
class be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of component options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to initialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   * @param {ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */
  constructor(e, i, n) {
    if (!e && this.play ? this.player_ = e = this : this.player_ = e, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = Bt({}, this.options_), i = this.options_ = Bt(this.options_, i), this.id_ = i.id || i.el && i.el.id, !this.id_) {
      const s = e && e.id && e.id() || "no_player";
      this.id_ = `${s}_component_${Bn()}`;
    }
    this.name_ = i.name || null, i.el ? this.el_ = i.el : i.createEl !== !1 && (this.el_ = this.createEl()), i.className && this.el_ && i.className.split(" ").forEach((s) => this.addClass(s)), ["on", "off", "one", "any", "trigger"].forEach((s) => {
      this[s] = void 0;
    }), i.evented !== !1 && (Zp(this, {
      eventBusKey: this.el_ ? "el_" : null
    }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), Yb(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = /* @__PURE__ */ new Set(), this.setIntervalIds_ = /* @__PURE__ */ new Set(), this.rafIds_ = /* @__PURE__ */ new Set(), this.namedRafs_ = /* @__PURE__ */ new Map(), this.clearingTimersOnDispose_ = !1, i.initChildren !== !1 && this.initChildren(), this.ready(n), i.reportTouchActivity !== !1 && this.enableTouchActivity();
  }
  // `on`, `off`, `one`, `any` and `trigger` are here so tsc includes them in definitions.
  // They are replaced or removed in the constructor
  /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */
  /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} [fn]
   *        The function to remove. If not specified, all listeners managed by Video.js will be removed.
   */
  /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * @param {Object} [hash]
   *        Optionally extra argument to pass through to an event listener
   */
  /**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   *
   * @param {Object} options
   * @param {Element} options.originalEl element with which to replace player element
   */
  dispose(e = {}) {
    if (!this.isDisposed_) {
      if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
        type: "dispose",
        bubbles: !1
      }), this.isDisposed_ = !0, this.children_)
        for (let i = this.children_.length - 1; i >= 0; i--)
          this.children_[i].dispose && this.children_[i].dispose();
      this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && (e.restoreEl ? this.el_.parentNode.replaceChild(e.restoreEl, this.el_) : this.el_.parentNode.removeChild(this.el_)), this.el_ = null), this.player_ = null;
    }
  }
  /**
   * Determine whether or not this component has been disposed.
   *
   * @return {boolean}
   *         If the component has been disposed, will be `true`. Otherwise, `false`.
   */
  isDisposed() {
    return !!this.isDisposed_;
  }
  /**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return {Player}
   *         The player that this `Component` has attached to.
   */
  player() {
    return this.player_;
  }
  /**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:obj.merge}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   */
  options(e) {
    return e ? (this.options_ = Bt(this.options_, e), this.options_) : this.options_;
  }
  /**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */
  el() {
    return this.el_;
  }
  /**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, i, n) {
    return st(e, i, n);
  }
  /**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */
  localize(e, i, n = e) {
    const s = this.player_.language && this.player_.language(), r = this.player_.languages && this.player_.languages(), a = r && r[s], o = s && s.split("-")[0], l = r && r[o];
    let u = n;
    return a && a[e] ? u = a[e] : l && l[e] && (u = l[e]), i && (u = u.replace(/\{(\d+)\}/g, function(d, c) {
      const A = i[c - 1];
      let m = A;
      return typeof A > "u" && (m = d), m;
    })), u;
  }
  /**
   * Handles language change for the player in components. Should be overridden by sub-components.
   *
   * @abstract
   */
  handleLanguagechange() {
  }
  /**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */
  contentEl() {
    return this.contentEl_ || this.el_;
  }
  /**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */
  id() {
    return this.id_;
  }
  /**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */
  name() {
    return this.name_;
  }
  /**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */
  children() {
    return this.children_;
  }
  /**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */
  getChildById(e) {
    return this.childIndex_[e];
  }
  /**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */
  getChild(e) {
    if (e)
      return this.childNameIndex_[e];
  }
  /**
   * Returns the descendant `Component` following the givent
   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
   * try to get 'foo' on the current component, 'bar' on the 'foo'
   * component and 'baz' on the 'bar' component and return undefined
   * if any of those don't exist.
   *
   * @param {...string[]|...string} names
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The descendant `Component` following the given descendant
   *         `names` or undefined.
   */
  getDescendant(...e) {
    e = e.reduce((n, s) => n.concat(s), []);
    let i = this;
    for (let n = 0; n < e.length; n++)
      if (i = i.getChild(e[n]), !i || !i.getChild)
        return;
    return i;
  }
  /**
   * Adds an SVG icon element to another element or component.
   *
   * @param {string} iconName
   *        The name of icon. A list of all the icon names can be found at 'sandbox/svg-icons.html'
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on. Defaults to the current Component's element.
   *
   * @return {Element}
   *        The newly created icon element.
   */
  setIcon(e, i = this.el()) {
    if (!this.player_.options_.experimentalSvgIcons)
      return;
    const n = "http://www.w3.org/2000/svg", s = st("span", {
      className: "vjs-icon-placeholder vjs-svg-icon"
    }, {
      "aria-hidden": "true"
    }), r = Ne.createElementNS(n, "svg");
    r.setAttributeNS(null, "viewBox", "0 0 512 512");
    const a = Ne.createElementNS(n, "use");
    return r.appendChild(a), a.setAttributeNS(null, "href", `#vjs-icon-${e}`), s.appendChild(r), this.iconIsSet_ ? i.replaceChild(s, i.querySelector(".vjs-icon-placeholder")) : i.appendChild(s), this.iconIsSet_ = !0, s;
  }
  /**
   * Add a child `Component` inside the current `Component`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */
  addChild(e, i = {}, n = this.children_.length) {
    let s, r;
    if (typeof e == "string") {
      r = oi(e);
      const a = i.componentClass || r;
      i.name = r;
      const o = be.getComponent(a);
      if (!o)
        throw new Error(`Component ${a} does not exist`);
      if (typeof o != "function")
        return null;
      s = new o(this.player_ || this, i);
    } else
      s = e;
    if (s.parentComponent_ && s.parentComponent_.removeChild(s), this.children_.splice(n, 0, s), s.parentComponent_ = this, typeof s.id == "function" && (this.childIndex_[s.id()] = s), r = r || s.name && oi(s.name()), r && (this.childNameIndex_[r] = s, this.childNameIndex_[vl(r)] = s), typeof s.el == "function" && s.el()) {
      let a = null;
      this.children_[n + 1] && (this.children_[n + 1].el_ ? a = this.children_[n + 1].el_ : bo(this.children_[n + 1]) && (a = this.children_[n + 1])), this.contentEl().insertBefore(s.el(), a);
    }
    return s;
  }
  /**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {Component} component
   *        The child `Component` to remove.
   */
  removeChild(e) {
    if (typeof e == "string" && (e = this.getChild(e)), !e || !this.children_)
      return;
    let i = !1;
    for (let s = this.children_.length - 1; s >= 0; s--)
      if (this.children_[s] === e) {
        i = !0, this.children_.splice(s, 1);
        break;
      }
    if (!i)
      return;
    e.parentComponent_ = null, this.childIndex_[e.id()] = null, this.childNameIndex_[oi(e.name())] = null, this.childNameIndex_[vl(e.name())] = null;
    const n = e.el();
    n && n.parentNode === this.contentEl() && this.contentEl().removeChild(e.el());
  }
  /**
   * Add and initialize default child `Component`s based upon options.
   */
  initChildren() {
    const e = this.options_.children;
    if (e) {
      const i = this.options_, n = (a) => {
        const o = a.name;
        let l = a.opts;
        if (i[o] !== void 0 && (l = i[o]), l === !1)
          return;
        l === !0 && (l = {}), l.playerOptions = this.options_.playerOptions;
        const u = this.addChild(o, l);
        u && (this[o] = u);
      };
      let s;
      const r = be.getComponent("Tech");
      Array.isArray(e) ? s = e : s = Object.keys(e), s.concat(Object.keys(this.options_).filter(function(a) {
        return !s.some(function(o) {
          return typeof o == "string" ? a === o : a === o.name;
        });
      })).map((a) => {
        let o, l;
        return typeof a == "string" ? (o = a, l = e[o] || this.options_[o] || {}) : (o = a.name, l = a), {
          name: o,
          opts: l
        };
      }).filter((a) => {
        const o = be.getComponent(a.opts.componentClass || oi(a.name));
        return o && !r.isTech(o);
      }).forEach(n);
    }
  }
  /**
   * Builds the default DOM class name. Should be overridden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */
  buildCSSClass() {
    return "";
  }
  /**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @param {ReadyCallback} fn
   *        Function that gets called when the `Component` is ready.
   */
  ready(e, i = !1) {
    if (e) {
      if (!this.isReady_) {
        this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(e);
        return;
      }
      i ? e.call(this) : this.setTimeout(e, 1);
    }
  }
  /**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */
  triggerReady() {
    this.isReady_ = !0, this.setTimeout(function() {
      const e = this.readyQueue_;
      this.readyQueue_ = [], e && e.length > 0 && e.forEach(function(i) {
        i.call(this);
      }, this), this.trigger("ready");
    }, 1);
  }
  /**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */
  $(e, i) {
    return yr(e, i || this.contentEl());
  }
  /**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */
  $$(e, i) {
    return Nb(e, i || this.contentEl());
  }
  /**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */
  hasClass(e) {
    return gl(this.el_, e);
  }
  /**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {...string} classesToAdd
   *        One or more CSS class name to add.
   */
  addClass(...e) {
    Gr(this.el_, ...e);
  }
  /**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {...string} classesToRemove
   *        One or more CSS class name to remove.
   */
  removeClass(...e) {
    oc(this.el_, ...e);
  }
  /**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove. Passed to DOMTokenList's toggle()
   *
   * @param  {boolean|Dom.PredicateCallback} [predicate]
   *         A boolean or function that returns a boolean. Passed to DOMTokenList's toggle().
   */
  toggleClass(e, i) {
    _b(this.el_, e, i);
  }
  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */
  show() {
    this.removeClass("vjs-hidden");
  }
  /**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */
  hide() {
    this.addClass("vjs-hidden");
  }
  /**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */
  lockShowing() {
    this.addClass("vjs-lock-showing");
  }
  /**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */
  unlockShowing() {
    this.removeClass("vjs-lock-showing");
  }
  /**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attribute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */
  getAttribute(e) {
    return Pb(this.el_, e);
  }
  /**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */
  setAttribute(e, i) {
    lo(this.el_, e, i);
  }
  /**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */
  removeAttribute(e) {
    lc(this.el_, e);
  }
  /**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The width when getting, zero if there is no width
   */
  width(e, i) {
    return this.dimension("width", e, i);
  }
  /**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The height when getting, zero if there is no height
   */
  height(e, i) {
    return this.dimension("height", e, i);
  }
  /**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */
  dimensions(e, i) {
    this.width(e, !0), this.height(i);
  }
  /**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number|undefined}
   *         The dimension when getting or 0 if unset
   */
  dimension(e, i, n) {
    if (i !== void 0) {
      (i === null || i !== i) && (i = 0), ("" + i).indexOf("%") !== -1 || ("" + i).indexOf("px") !== -1 ? this.el_.style[e] = i : i === "auto" ? this.el_.style[e] = "" : this.el_.style[e] = i + "px", n || this.trigger("componentresize");
      return;
    }
    if (!this.el_)
      return 0;
    const s = this.el_.style[e], r = s.indexOf("px");
    return parseInt(r !== -1 ? s.slice(0, r) : this.el_["offset" + oi(e)], 10);
  }
  /**
   * Get the computed width or the height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */
  currentDimension(e) {
    let i = 0;
    if (e !== "width" && e !== "height")
      throw new Error("currentDimension only accepts width or height value");
    if (i = co(this.el_, e), i = parseFloat(i), i === 0 || isNaN(i)) {
      const n = `offset${oi(e)}`;
      i = this.el_[n];
    }
    return i;
  }
  /**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */
  /**
   * Get an object that contains computed width and height values of the
   * component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {Component~DimensionObject}
   *         The computed dimensions of the component's element.
   */
  currentDimensions() {
    return {
      width: this.currentDimension("width"),
      height: this.currentDimension("height")
    };
  }
  /**
   * Get the computed width of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed width of the component's element.
   */
  currentWidth() {
    return this.currentDimension("width");
  }
  /**
   * Get the computed height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed height of the component's element.
   */
  currentHeight() {
    return this.currentDimension("height");
  }
  /**
   * Retrieves the position and size information of the component's element.
   *
   * @return {Object} An object with `boundingClientRect` and `center` properties.
   *         - `boundingClientRect`: An object with properties `x`, `y`, `width`,
   *           `height`, `top`, `right`, `bottom`, and `left`, representing
   *           the bounding rectangle of the element.
   *         - `center`: An object with properties `x` and `y`, representing
   *           the center point of the element. `width` and `height` are set to 0.
   */
  getPositions() {
    const e = this.el_.getBoundingClientRect(), i = {
      x: e.x,
      y: e.y,
      width: e.width,
      height: e.height,
      top: e.top,
      right: e.right,
      bottom: e.bottom,
      left: e.left
    }, n = {
      x: e.left + e.width / 2,
      y: e.top + e.height / 2,
      width: 0,
      height: 0,
      top: e.top + e.height / 2,
      right: e.left + e.width / 2,
      bottom: e.top + e.height / 2,
      left: e.left + e.width / 2
    };
    return {
      boundingClientRect: i,
      center: n
    };
  }
  /**
   * Set the focus to this component
   */
  focus() {
    this.el_.focus();
  }
  /**
   * Remove the focus from this component
   */
  blur() {
    this.el_.blur();
  }
  /**
   * When this Component receives a `keydown` event which it does not process,
   *  it passes the event to the Player for handling.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   */
  handleKeyDown(e) {
    this.player_ && (e.key !== "Tab" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled) && e.stopPropagation(), this.player_.handleKeyDown(e));
  }
  /**
   * Many components used to have a `handleKeyPress` method, which was poorly
   * named because it listened to a `keydown` event. This method name now
   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
   * will not see their method calls stop working.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to be called.
   */
  handleKeyPress(e) {
    this.handleKeyDown(e);
  }
  /**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @protected
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */
  emitTapEvents() {
    let e = 0, i = null;
    const n = 10, s = 200;
    let r;
    this.on("touchstart", function(o) {
      o.touches.length === 1 && (i = {
        pageX: o.touches[0].pageX,
        pageY: o.touches[0].pageY
      }, e = ne.performance.now(), r = !0);
    }), this.on("touchmove", function(o) {
      if (o.touches.length > 1)
        r = !1;
      else if (i) {
        const l = o.touches[0].pageX - i.pageX, u = o.touches[0].pageY - i.pageY;
        Math.sqrt(l * l + u * u) > n && (r = !1);
      }
    });
    const a = function() {
      r = !1;
    };
    this.on("touchleave", a), this.on("touchcancel", a), this.on("touchend", function(o) {
      i = null, r === !0 && ne.performance.now() - e < s && (o.preventDefault(), this.trigger("tap"));
    });
  }
  /**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */
  enableTouchActivity() {
    if (!this.player() || !this.player().reportUserActivity)
      return;
    const e = zt(this.player(), this.player().reportUserActivity);
    let i;
    this.on("touchstart", function() {
      e(), this.clearInterval(i), i = this.setInterval(e, 250);
    });
    const n = function(s) {
      e(), this.clearInterval(i);
    };
    this.on("touchmove", e), this.on("touchend", n), this.on("touchcancel", n);
  }
  /**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */
  /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */
  setTimeout(e, i) {
    var n;
    return e = zt(this, e), this.clearTimersOnDispose_(), n = ne.setTimeout(() => {
      this.setTimeoutIds_.has(n) && this.setTimeoutIds_.delete(n), e();
    }, i), this.setTimeoutIds_.add(n), n;
  }
  /**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */
  clearTimeout(e) {
    return this.setTimeoutIds_.has(e) && (this.setTimeoutIds_.delete(e), ne.clearTimeout(e)), e;
  }
  /**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */
  setInterval(e, i) {
    e = zt(this, e), this.clearTimersOnDispose_();
    const n = ne.setInterval(e, i);
    return this.setIntervalIds_.add(n), n;
  }
  /**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an interval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */
  clearInterval(e) {
    return this.setIntervalIds_.has(e) && (this.setIntervalIds_.delete(e), ne.clearInterval(e)), e;
  }
  /**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */
  requestAnimationFrame(e) {
    this.clearTimersOnDispose_();
    var i;
    return e = zt(this, e), i = ne.requestAnimationFrame(() => {
      this.rafIds_.has(i) && this.rafIds_.delete(i), e();
    }), this.rafIds_.add(i), i;
  }
  /**
   * Request an animation frame, but only one named animation
   * frame will be queued. Another will never be added until
   * the previous one finishes.
   *
   * @param {string} name
   *        The name to give this requestAnimationFrame
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   */
  requestNamedAnimationFrame(e, i) {
    this.namedRafs_.has(e) && this.cancelNamedAnimationFrame(e), this.clearTimersOnDispose_(), i = zt(this, i);
    const n = this.requestAnimationFrame(() => {
      i(), this.namedRafs_.has(e) && this.namedRafs_.delete(e);
    });
    return this.namedRafs_.set(e, n), e;
  }
  /**
   * Cancels a current named animation frame if it exists.
   *
   * @param {string} name
   *        The name of the requestAnimationFrame to cancel.
   */
  cancelNamedAnimationFrame(e) {
    this.namedRafs_.has(e) && (this.cancelAnimationFrame(this.namedRafs_.get(e)), this.namedRafs_.delete(e));
  }
  /**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */
  cancelAnimationFrame(e) {
    return this.rafIds_.has(e) && (this.rafIds_.delete(e), ne.cancelAnimationFrame(e)), e;
  }
  /**
   * A function to setup `requestAnimationFrame`, `setTimeout`,
   * and `setInterval`, clearing on dispose.
   *
   * > Previously each timer added and removed dispose listeners on it's own.
   * For better performance it was decided to batch them all, and use `Set`s
   * to track outstanding timer ids.
   *
   * @private
   */
  clearTimersOnDispose_() {
    this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", () => {
      [["namedRafs_", "cancelNamedAnimationFrame"], ["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(([e, i]) => {
        this[e].forEach((n, s) => this[i](s));
      }), this.clearingTimersOnDispose_ = !1;
    }));
  }
  /**
    * Decide whether an element is actually disabled or not.
    *
    * @function isActuallyDisabled
    * @param element {Node}
    * @return {boolean}
    *
    * @see {@link https://html.spec.whatwg.org/multipage/semantics-other.html#concept-element-disabled}
    */
  getIsDisabled() {
    return !!this.el_.disabled;
  }
  /**
    * Decide whether the element is expressly inert or not.
    *
    * @see {@link https://html.spec.whatwg.org/multipage/interaction.html#expressly-inert}
    * @function isExpresslyInert
    * @param element {Node}
    * @return {boolean}
    */
  getIsExpresslyInert() {
    return this.el_.inert && !this.el_.ownerDocument.documentElement.inert;
  }
  /**
   * Determine whether or not this component can be considered as focusable component.
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can be focused, will be `true`. Otherwise, `false`.
   */
  getIsFocusable(e) {
    return (e || this.el_).tabIndex >= 0 && !(this.getIsDisabled() || this.getIsExpresslyInert());
  }
  /**
   * Determine whether or not this component is currently visible/enabled/etc...
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can is currently visible & enabled, will be `true`. Otherwise, `false`.
   */
  getIsAvailableToBeFocused(e) {
    function i(r) {
      const a = ne.getComputedStyle(r, null), o = a.getPropertyValue("visibility");
      return a.getPropertyValue("display") !== "none" && !["hidden", "collapse"].includes(o);
    }
    function n(r) {
      return !(!i(r.parentElement) || !i(r) || r.style.opacity === "0" || ne.getComputedStyle(r).height === "0px" || ne.getComputedStyle(r).width === "0px");
    }
    function s(r) {
      if (r.offsetWidth + r.offsetHeight + r.getBoundingClientRect().height + r.getBoundingClientRect().width === 0)
        return !1;
      const a = {
        x: r.getBoundingClientRect().left + r.offsetWidth / 2,
        y: r.getBoundingClientRect().top + r.offsetHeight / 2
      };
      if (a.x < 0 || a.x > (Ne.documentElement.clientWidth || ne.innerWidth) || a.y < 0 || a.y > (Ne.documentElement.clientHeight || ne.innerHeight))
        return !1;
      let o = Ne.elementFromPoint(a.x, a.y);
      for (; o; ) {
        if (o === r)
          return !0;
        if (o.parentNode)
          o = o.parentNode;
        else
          return !1;
      }
    }
    return e || (e = this.el()), !!(s(e) && n(e) && (!e.parentElement || e.tabIndex >= 0));
  }
  /**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */
  static registerComponent(e, i) {
    if (typeof e != "string" || !e)
      throw new Error(`Illegal component name, "${e}"; must be a non-empty string.`);
    const n = be.getComponent("Tech"), s = n && n.isTech(i), r = be === i || be.prototype.isPrototypeOf(i.prototype);
    if (s || !r) {
      let o;
      throw s ? o = "techs must be registered using Tech.registerTech()" : o = "must be a Component subclass", new Error(`Illegal component, "${e}"; ${o}.`);
    }
    e = oi(e), be.components_ || (be.components_ = {});
    const a = be.getComponent("Player");
    if (e === "Player" && a && a.players) {
      const o = a.players, l = Object.keys(o);
      if (o && l.length > 0) {
        for (let u = 0; u < l.length; u++)
          if (o[l[u]] !== null)
            throw new Error("Can not register Player component after player has been created.");
      }
    }
    return be.components_[e] = i, be.components_[vl(e)] = i, i;
  }
  /**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {typeof Component}
   *         The `Component` that got registered under the given name.
   */
  static getComponent(e) {
    if (!(!e || !be.components_))
      return be.components_[e];
  }
}
be.registerComponent("Component", be);
function hF(t, e, i) {
  if (typeof e != "number" || e < 0 || e > i)
    throw new Error(`Failed to execute '${t}' on 'TimeRanges': The index provided (${e}) is non-numeric or out of bounds (0-${i}).`);
}
function uv(t, e, i, n) {
  return hF(t, n, i.length - 1), i[n][e];
}
function zf(t) {
  let e;
  return t === void 0 || t.length === 0 ? e = {
    length: 0,
    start() {
      throw new Error("This TimeRanges object is empty");
    },
    end() {
      throw new Error("This TimeRanges object is empty");
    }
  } : e = {
    length: t.length,
    start: uv.bind(null, "start", 0, t),
    end: uv.bind(null, "end", 1, t)
  }, ne.Symbol && ne.Symbol.iterator && (e[ne.Symbol.iterator] = () => (t || []).values()), e;
}
function ts(t, e) {
  return Array.isArray(t) ? zf(t) : t === void 0 || e === void 0 ? zf() : zf([[t, e]]);
}
const jb = function(t, e) {
  t = t < 0 ? 0 : t;
  let i = Math.floor(t % 60), n = Math.floor(t / 60 % 60), s = Math.floor(t / 3600);
  const r = Math.floor(e / 60 % 60), a = Math.floor(e / 3600);
  return (isNaN(t) || t === 1 / 0) && (s = n = i = "-"), s = s > 0 || a > 0 ? s + ":" : "", n = ((s || r >= 10) && n < 10 ? "0" + n : n) + ":", i = i < 10 ? "0" + i : i, s + n + i;
};
let Kp = jb;
function Gb(t) {
  Kp = t;
}
function Qb() {
  Kp = jb;
}
function ia(t, e = t) {
  return Kp(t, e);
}
var pF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTimeRanges: ts,
  createTimeRange: ts,
  setFormatTime: Gb,
  resetFormatTime: Qb,
  formatTime: ia
});
function Zb(t, e) {
  let i = 0, n, s;
  if (!e)
    return 0;
  (!t || !t.length) && (t = ts(0, 0));
  for (let r = 0; r < t.length; r++)
    n = t.start(r), s = t.end(r), s > e && (s = e), i += s - n;
  return i / e;
}
function si(t) {
  if (t instanceof si)
    return t;
  typeof t == "number" ? this.code = t : typeof t == "string" ? this.message = t : Ds(t) && (typeof t.code == "number" && (this.code = t.code), Object.assign(this, t)), this.message || (this.message = si.defaultMessages[this.code] || "");
}
si.prototype.code = 0;
si.prototype.message = "";
si.prototype.status = null;
si.prototype.metadata = null;
si.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"];
si.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail part-way.",
  3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
  4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
  5: "The media is encrypted and we do not have the keys to decrypt it."
};
si.MEDIA_ERR_CUSTOM = 0;
si.prototype.MEDIA_ERR_CUSTOM = 0;
si.MEDIA_ERR_ABORTED = 1;
si.prototype.MEDIA_ERR_ABORTED = 1;
si.MEDIA_ERR_NETWORK = 2;
si.prototype.MEDIA_ERR_NETWORK = 2;
si.MEDIA_ERR_DECODE = 3;
si.prototype.MEDIA_ERR_DECODE = 3;
si.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
si.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
si.MEDIA_ERR_ENCRYPTED = 5;
si.prototype.MEDIA_ERR_ENCRYPTED = 5;
function yl(t) {
  return t != null && typeof t.then == "function";
}
function vs(t) {
  yl(t) && t.then(null, (e) => {
  });
}
const Ih = function(t) {
  return ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce((i, n, s) => (t[n] && (i[n] = t[n]), i), {
    cues: t.cues && Array.prototype.map.call(t.cues, function(i) {
      return {
        startTime: i.startTime,
        endTime: i.endTime,
        text: i.text,
        id: i.id
      };
    })
  });
}, mF = function(t) {
  const e = t.$$("track"), i = Array.prototype.map.call(e, (s) => s.track);
  return Array.prototype.map.call(e, function(s) {
    const r = Ih(s.track);
    return s.src && (r.src = s.src), r;
  }).concat(Array.prototype.filter.call(t.textTracks(), function(s) {
    return i.indexOf(s) === -1;
  }).map(Ih));
}, AF = function(t, e) {
  return t.forEach(function(i) {
    const n = e.addRemoteTextTrack(i).track;
    !i.src && i.cues && i.cues.forEach((s) => n.addCue(s));
  }), e.textTracks();
};
var dv = {
  textTracksToJson: mF,
  jsonToTextTracks: AF,
  trackToJson_: Ih
};
const Uf = "vjs-modal-dialog";
class To extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.pauseOnOpen=true]
   *        If `true`, playback will will be paused if playing when
   *        the modal opens, and resumed when it closes.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */
  constructor(e, i) {
    super(e, i), this.handleKeyDown_ = (n) => this.handleKeyDown(n), this.close_ = (n) => this.close(n), this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = !1, this.closeable(!this.options_.uncloseable), this.content(this.options_.content), this.contentEl_ = st("div", {
      className: `${Uf}-content`
    }, {
      role: "document"
    }), this.descEl_ = st("p", {
      className: `${Uf}-description vjs-control-text`,
      id: this.el().getAttribute("aria-describedby")
    }), Sr(this.descEl_, this.description()), this.el_.appendChild(this.descEl_), this.el_.appendChild(this.contentEl_);
  }
  /**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      "aria-describedby": `${this.id()}_description`,
      "aria-hidden": "true",
      "aria-label": this.label(),
      role: "dialog",
      "aria-live": "polite"
    });
  }
  dispose() {
    this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, super.dispose();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `${Uf} vjs-hidden ${super.buildCSSClass()}`;
  }
  /**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */
  label() {
    return this.localize(this.options_.label || "Modal Window");
  }
  /**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */
  description() {
    let e = this.options_.description || this.localize("This is a modal window.");
    return this.closeable() && (e += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), e;
  }
  /**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */
  open() {
    if (this.opened_) {
      this.options_.fillAlways && this.fill();
      return;
    }
    const e = this.player();
    this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !e.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && e.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = e.controls(), e.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
  }
  /**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */
  opened(e) {
    return typeof e == "boolean" && this[e ? "open" : "close"](), this.opened_;
  }
  /**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */
  close() {
    if (!this.opened_)
      return;
    const e = this.player();
    this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && e.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && e.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger({
      type: "modalclose",
      bubbles: !0
    }), this.conditionalBlur_(), this.options_.temporary && this.dispose();
  }
  /**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */
  closeable(e) {
    if (typeof e == "boolean") {
      const i = this.closeable_ = !!e;
      let n = this.getChild("closeButton");
      if (i && !n) {
        const s = this.contentEl_;
        this.contentEl_ = this.el_, n = this.addChild("closeButton", {
          controlText: "Close Modal Dialog"
        }), this.contentEl_ = s, this.on(n, "close", this.close_);
      }
      !i && n && (this.off(n, "close", this.close_), this.removeChild(n), n.dispose());
    }
    return this.closeable_;
  }
  /**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */
  fill() {
    this.fillWith(this.content());
  }
  /**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param {ContentDescriptor} [content]
   *        The same rules apply to this as apply to the `content` option.
   */
  fillWith(e) {
    const i = this.contentEl(), n = i.parentNode, s = i.nextSibling;
    this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, n.removeChild(i), this.empty(), Lb(i, e), this.trigger("modalfill"), s ? n.insertBefore(i, s) : n.appendChild(i);
    const r = this.getChild("closeButton");
    r && n.appendChild(r.el_), this.trigger("aftermodalfill");
  }
  /**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */
  empty() {
    this.trigger("beforemodalempty"), dc(this.contentEl()), this.trigger("modalempty");
  }
  /**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  {ContentDescriptor} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return {ContentDescriptor}
   *         The current content of the modal dialog
   */
  content(e) {
    return typeof e < "u" && (this.content_ = e), this.content_;
  }
  /**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */
  conditionalFocus_() {
    const e = Ne.activeElement, i = this.player_.el_;
    this.previouslyActiveEl_ = null, (i.contains(e) || i === e) && (this.previouslyActiveEl_ = e, this.focus());
  }
  /**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */
  conditionalBlur_() {
    this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null);
  }
  /**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    if (this.trigger({
      type: "modalKeydown",
      originalEvent: e,
      target: this,
      bubbles: !0
    }), e.stopPropagation(), e.key === "Escape" && this.closeable()) {
      e.preventDefault(), this.close();
      return;
    }
    if (e.key !== "Tab")
      return;
    const i = this.focusableEls_(), n = this.el_.querySelector(":focus");
    let s;
    for (let r = 0; r < i.length; r++)
      if (n === i[r]) {
        s = r;
        break;
      }
    Ne.activeElement === this.el_ && (s = 0), e.shiftKey && s === 0 ? (i[i.length - 1].focus(), e.preventDefault()) : !e.shiftKey && s === i.length - 1 && (i[0].focus(), e.preventDefault());
  }
  /**
   * get all focusable elements
   *
   * @private
   */
  focusableEls_() {
    const e = this.el_.querySelectorAll("*");
    return Array.prototype.filter.call(e, (i) => (i instanceof ne.HTMLAnchorElement || i instanceof ne.HTMLAreaElement) && i.hasAttribute("href") || (i instanceof ne.HTMLInputElement || i instanceof ne.HTMLSelectElement || i instanceof ne.HTMLTextAreaElement || i instanceof ne.HTMLButtonElement) && !i.hasAttribute("disabled") || i instanceof ne.HTMLIFrameElement || i instanceof ne.HTMLObjectElement || i instanceof ne.HTMLEmbedElement || i.hasAttribute("tabindex") && i.getAttribute("tabindex") !== -1 || i.hasAttribute("contenteditable"));
  }
}
To.prototype.options_ = {
  pauseOnOpen: !0,
  temporary: !0
};
be.registerComponent("ModalDialog", To);
class fo extends Sn {
  /**
   * Create an instance of this class
   *
   * @param { Track[] } tracks
   *        A list of tracks to initialize the list with.
   *
   * @abstract
   */
  constructor(e = []) {
    super(), this.tracks_ = [], Object.defineProperty(this, "length", {
      get() {
        return this.tracks_.length;
      }
    });
    for (let i = 0; i < e.length; i++)
      this.addTrack(e[i]);
  }
  /**
   * Add a {@link Track} to the `TrackList`
   *
   * @param {Track} track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    const i = this.tracks_.length;
    "" + i in this || Object.defineProperty(this, i, {
      get() {
        return this.tracks_[i];
      }
    }), this.tracks_.indexOf(e) === -1 && (this.tracks_.push(e), this.trigger({
      track: e,
      type: "addtrack",
      target: this
    })), e.labelchange_ = () => {
      this.trigger({
        track: e,
        type: "labelchange",
        target: this
      });
    }, Us(e) && e.addEventListener("labelchange", e.labelchange_);
  }
  /**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param {Track} rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */
  removeTrack(e) {
    let i;
    for (let n = 0, s = this.length; n < s; n++)
      if (this[n] === e) {
        i = this[n], i.off && i.off(), this.tracks_.splice(n, 1);
        break;
      }
    i && this.trigger({
      track: i,
      type: "removetrack",
      target: this
    });
  }
  /**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {string} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */
  getTrackById(e) {
    let i = null;
    for (let n = 0, s = this.length; n < s; n++) {
      const r = this[n];
      if (r.id === e) {
        i = r;
        break;
      }
    }
    return i;
  }
}
fo.prototype.allowedEvents_ = {
  change: "change",
  addtrack: "addtrack",
  removetrack: "removetrack",
  labelchange: "labelchange"
};
for (const t in fo.prototype.allowedEvents_)
  fo.prototype["on" + t] = null;
const Vf = function(t, e) {
  for (let i = 0; i < t.length; i++)
    !Object.keys(t[i]).length || e.id === t[i].id || (t[i].enabled = !1);
};
class gF extends fo {
  /**
   * Create an instance of this class.
   *
   * @param {AudioTrack[]} [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */
  constructor(e = []) {
    for (let i = e.length - 1; i >= 0; i--)
      if (e[i].enabled) {
        Vf(e, e[i]);
        break;
      }
    super(e), this.changing_ = !1;
  }
  /**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param {AudioTrack} track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    e.enabled && Vf(this, e), super.addTrack(e), e.addEventListener && (e.enabledChange_ = () => {
      this.changing_ || (this.changing_ = !0, Vf(this, e), this.changing_ = !1, this.trigger("change"));
    }, e.addEventListener("enabledchange", e.enabledChange_));
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && e.enabledChange_ && (e.removeEventListener("enabledchange", e.enabledChange_), e.enabledChange_ = null);
  }
}
const qf = function(t, e) {
  for (let i = 0; i < t.length; i++)
    !Object.keys(t[i]).length || e.id === t[i].id || (t[i].selected = !1);
};
class vF extends fo {
  /**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */
  constructor(e = []) {
    for (let i = e.length - 1; i >= 0; i--)
      if (e[i].selected) {
        qf(e, e[i]);
        break;
      }
    super(e), this.changing_ = !1, Object.defineProperty(this, "selectedIndex", {
      get() {
        for (let i = 0; i < this.length; i++)
          if (this[i].selected)
            return i;
        return -1;
      },
      set() {
      }
    });
  }
  /**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param {VideoTrack} track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    e.selected && qf(this, e), super.addTrack(e), e.addEventListener && (e.selectedChange_ = () => {
      this.changing_ || (this.changing_ = !0, qf(this, e), this.changing_ = !1, this.trigger("change"));
    }, e.addEventListener("selectedchange", e.selectedChange_));
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && e.selectedChange_ && (e.removeEventListener("selectedchange", e.selectedChange_), e.selectedChange_ = null);
  }
}
class Kb extends fo {
  /**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param {TextTrack} track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    super.addTrack(e), this.queueChange_ || (this.queueChange_ = () => this.queueTrigger("change")), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = () => this.trigger("selectedlanguagechange")), e.addEventListener("modechange", this.queueChange_), ["metadata", "chapters"].indexOf(e.kind) === -1 && e.addEventListener("modechange", this.triggerSelectedlanguagechange_);
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && (this.queueChange_ && e.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && e.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
  }
}
class yF {
  /**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */
  constructor(e = []) {
    this.trackElements_ = [], Object.defineProperty(this, "length", {
      get() {
        return this.trackElements_.length;
      }
    });
    for (let i = 0, n = e.length; i < n; i++)
      this.addTrackElement_(e[i]);
  }
  /**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */
  addTrackElement_(e) {
    const i = this.trackElements_.length;
    "" + i in this || Object.defineProperty(this, i, {
      get() {
        return this.trackElements_[i];
      }
    }), this.trackElements_.indexOf(e) === -1 && this.trackElements_.push(e);
  }
  /**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */
  getTrackElementByTrack_(e) {
    let i;
    for (let n = 0, s = this.trackElements_.length; n < s; n++)
      if (e === this.trackElements_[n].track) {
        i = this.trackElements_[n];
        break;
      }
    return i;
  }
  /**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */
  removeTrackElement_(e) {
    for (let i = 0, n = this.trackElements_.length; i < n; i++)
      if (e === this.trackElements_[i]) {
        this.trackElements_[i].track && typeof this.trackElements_[i].track.off == "function" && this.trackElements_[i].track.off(), typeof this.trackElements_[i].off == "function" && this.trackElements_[i].off(), this.trackElements_.splice(i, 1);
        break;
      }
  }
}
class yd {
  /**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */
  constructor(e) {
    yd.prototype.setCues_.call(this, e), Object.defineProperty(this, "length", {
      get() {
        return this.length_;
      }
    });
  }
  /**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */
  setCues_(e) {
    const i = this.length || 0;
    let n = 0;
    const s = e.length;
    this.cues_ = e, this.length_ = e.length;
    const r = function(a) {
      "" + a in this || Object.defineProperty(this, "" + a, {
        get() {
          return this.cues_[a];
        }
      });
    };
    if (i < s)
      for (n = i; n < s; n++)
        r.call(this, n);
  }
  /**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */
  getCueById(e) {
    let i = null;
    for (let n = 0, s = this.length; n < s; n++) {
      const r = this[n];
      if (r.id === e) {
        i = r;
        break;
      }
    }
    return i;
  }
}
const bF = {
  alternative: "alternative",
  captions: "captions",
  main: "main",
  sign: "sign",
  subtitles: "subtitles",
  commentary: "commentary"
}, wF = {
  alternative: "alternative",
  descriptions: "descriptions",
  main: "main",
  "main-desc": "main-desc",
  translation: "translation",
  commentary: "commentary"
}, TF = {
  subtitles: "subtitles",
  captions: "captions",
  descriptions: "descriptions",
  chapters: "chapters",
  metadata: "metadata"
}, cv = {
  disabled: "disabled",
  hidden: "hidden",
  showing: "showing"
};
class Jp extends Sn {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */
  constructor(e = {}) {
    super();
    const i = {
      id: e.id || "vjs_track_" + Bn(),
      kind: e.kind || "",
      language: e.language || ""
    };
    let n = e.label || "";
    for (const s in i)
      Object.defineProperty(this, s, {
        get() {
          return i[s];
        },
        set() {
        }
      });
    Object.defineProperty(this, "label", {
      get() {
        return n;
      },
      set(s) {
        s !== n && (n = s, this.trigger("labelchange"));
      }
    });
  }
}
const $p = function(t) {
  return new URL(t, Ne.baseURI);
}, Jb = function(t) {
  return new URL(t, Ne.baseURI).href;
}, em = function(t) {
  if (typeof t == "string") {
    const i = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/.exec(t);
    if (i)
      return i.pop().toLowerCase();
  }
  return "";
}, pc = function(t, e = ne.location) {
  return $p(t).origin !== e.origin;
};
var xF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  parseUrl: $p,
  getAbsoluteURL: Jb,
  getFileExtension: em,
  isCrossOrigin: pc
});
const fv = function(t, e) {
  const i = new ne.WebVTT.Parser(ne, ne.vttjs, ne.WebVTT.StringDecoder()), n = [];
  i.oncue = function(s) {
    e.addCue(s);
  }, i.onparsingerror = function(s) {
    n.push(s);
  }, i.onflush = function() {
    e.trigger({
      type: "loadeddata",
      target: e
    });
  }, i.parse(t), n.length > 0 && (ne.console && ne.console.groupCollapsed && ne.console.groupCollapsed(`Text Track parsing errors for ${e.src}`), n.forEach((s) => pt.error(s)), ne.console && ne.console.groupEnd && ne.console.groupEnd()), i.flush();
}, hv = function(t, e) {
  const i = {
    uri: t
  }, n = pc(t);
  n && (i.cors = n);
  const s = e.tech_.crossOrigin() === "use-credentials";
  s && (i.withCredentials = s), tb(i, zt(this, function(r, a, o) {
    if (r)
      return pt.error(r, a);
    e.loaded_ = !0, typeof ne.WebVTT != "function" ? e.tech_ && e.tech_.any(["vttjsloaded", "vttjserror"], (l) => {
      if (l.type === "vttjserror") {
        pt.error(`vttjs failed to load, stopping trying to process ${e.src}`);
        return;
      }
      return fv(o, e);
    }) : fv(o, e);
  }));
};
class Xl extends Jp {
  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  constructor(e = {}) {
    if (!e.tech)
      throw new Error("A tech was not provided.");
    const i = Bt(e, {
      kind: TF[e.kind] || "subtitles",
      language: e.language || e.srclang || ""
    });
    let n = cv[i.mode] || "disabled";
    const s = i.default;
    (i.kind === "metadata" || i.kind === "chapters") && (n = "hidden"), super(i), this.tech_ = i.tech, this.cues_ = [], this.activeCues_ = [], this.preload_ = this.tech_.preloadTextTracks !== !1;
    const r = new yd(this.cues_), a = new yd(this.activeCues_);
    let o = !1;
    this.timeupdateHandler = zt(this, function(u = {}) {
      if (!this.tech_.isDisposed()) {
        if (!this.tech_.isReady_) {
          u.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
          return;
        }
        this.activeCues = this.activeCues, o && (this.trigger("cuechange"), o = !1), u.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
      }
    });
    const l = () => {
      this.stopTracking();
    };
    this.tech_.one("dispose", l), n !== "disabled" && this.startTracking(), Object.defineProperties(this, {
      /**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */
      default: {
        get() {
          return s;
        },
        set() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */
      mode: {
        get() {
          return n;
        },
        set(u) {
          cv[u] && n !== u && (n = u, !this.preload_ && n !== "disabled" && this.cues.length === 0 && hv(this.src, this), this.stopTracking(), n !== "disabled" && this.startTracking(), this.trigger("modechange"));
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */
      cues: {
        get() {
          return this.loaded_ ? r : null;
        },
        set() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */
      activeCues: {
        get() {
          if (!this.loaded_)
            return null;
          if (this.cues.length === 0)
            return a;
          const u = this.tech_.currentTime(), d = [];
          for (let c = 0, A = this.cues.length; c < A; c++) {
            const m = this.cues[c];
            m.startTime <= u && m.endTime >= u && d.push(m);
          }
          if (o = !1, d.length !== this.activeCues_.length)
            o = !0;
          else
            for (let c = 0; c < d.length; c++)
              this.activeCues_.indexOf(d[c]) === -1 && (o = !0);
          return this.activeCues_ = d, a.setCues_(this.activeCues_), a;
        },
        // /!\ Keep this setter empty (see the timeupdate handler above)
        set() {
        }
      }
    }), i.src ? (this.src = i.src, this.preload_ || (this.loaded_ = !0), (this.preload_ || i.kind !== "subtitles" && i.kind !== "captions") && hv(this.src, this)) : this.loaded_ = !0;
  }
  startTracking() {
    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler), this.tech_.on("timeupdate", this.timeupdateHandler);
  }
  stopTracking() {
    this.rvf_ && (this.tech_.cancelVideoFrameCallback(this.rvf_), this.rvf_ = void 0), this.tech_.off("timeupdate", this.timeupdateHandler);
  }
  /**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */
  addCue(e) {
    let i = e;
    if (!("getCueAsHTML" in i)) {
      i = new ne.vttjs.VTTCue(e.startTime, e.endTime, e.text);
      for (const s in e)
        s in i || (i[s] = e[s]);
      i.id = e.id, i.originalCue_ = e;
    }
    const n = this.tech_.textTracks();
    for (let s = 0; s < n.length; s++)
      n[s] !== this && n[s].removeCue(i);
    this.cues_.push(i), this.cues.setCues_(this.cues_);
  }
  /**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */
  removeCue(e) {
    let i = this.cues_.length;
    for (; i--; ) {
      const n = this.cues_[i];
      if (n === e || n.originalCue_ && n.originalCue_ === e) {
        this.cues_.splice(i, 1), this.cues.setCues_(this.cues_);
        break;
      }
    }
  }
}
Xl.prototype.allowedEvents_ = {
  cuechange: "cuechange"
};
class $b extends Jp {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */
  constructor(e = {}) {
    const i = Bt(e, {
      kind: wF[e.kind] || ""
    });
    super(i);
    let n = !1;
    Object.defineProperty(this, "enabled", {
      get() {
        return n;
      },
      set(s) {
        typeof s != "boolean" || s === n || (n = s, this.trigger("enabledchange"));
      }
    }), i.enabled && (this.enabled = i.enabled), this.loaded_ = !0;
  }
}
class ew extends Jp {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */
  constructor(e = {}) {
    const i = Bt(e, {
      kind: bF[e.kind] || ""
    });
    super(i);
    let n = !1;
    Object.defineProperty(this, "selected", {
      get() {
        return n;
      },
      set(s) {
        typeof s != "boolean" || s === n || (n = s, this.trigger("selectedchange"));
      }
    }), i.selected && (this.selected = i.selected);
  }
}
class Ys extends Sn {
  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  constructor(e = {}) {
    super();
    let i;
    const n = new Xl(e);
    this.kind = n.kind, this.src = n.src, this.srclang = n.language, this.label = n.label, this.default = n.default, Object.defineProperties(this, {
      /**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */
      readyState: {
        get() {
          return i;
        }
      },
      /**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */
      track: {
        get() {
          return n;
        }
      }
    }), i = Ys.NONE, n.addEventListener("loadeddata", () => {
      i = Ys.LOADED, this.trigger({
        type: "load",
        target: this
      });
    });
  }
}
Ys.prototype.allowedEvents_ = {
  load: "load"
};
Ys.NONE = 0;
Ys.LOADING = 1;
Ys.LOADED = 2;
Ys.ERROR = 3;
const On = {
  audio: {
    ListClass: gF,
    TrackClass: $b,
    capitalName: "Audio"
  },
  video: {
    ListClass: vF,
    TrackClass: ew,
    capitalName: "Video"
  },
  text: {
    ListClass: Kb,
    TrackClass: Xl,
    capitalName: "Text"
  }
};
Object.keys(On).forEach(function(t) {
  On[t].getterName = `${t}Tracks`, On[t].privateName = `${t}Tracks_`;
});
const ho = {
  remoteText: {
    ListClass: Kb,
    TrackClass: Xl,
    capitalName: "RemoteText",
    getterName: "remoteTextTracks",
    privateName: "remoteTextTracks_"
  },
  remoteTextEl: {
    ListClass: yF,
    TrackClass: Ys,
    capitalName: "RemoteTextTrackEls",
    getterName: "remoteTextTrackEls",
    privateName: "remoteTextTrackEls_"
  }
}, $i = Object.assign({}, On, ho);
ho.names = Object.keys(ho);
On.names = Object.keys(On);
$i.names = [].concat(ho.names).concat(On.names);
function SF(t, e, i, n, s = {}) {
  const r = t.textTracks();
  s.kind = e, i && (s.label = i), n && (s.language = n), s.tech = t;
  const a = new $i.text.TrackClass(s);
  return r.addTrack(a), a;
}
class ft extends be {
  /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */
  constructor(e = {}, i = function() {
  }) {
    e.reportTouchActivity = !1, super(null, e, i), this.onDurationChange_ = (n) => this.onDurationChange(n), this.trackProgress_ = (n) => this.trackProgress(n), this.trackCurrentTime_ = (n) => this.trackCurrentTime(n), this.stopTrackingCurrentTime_ = (n) => this.stopTrackingCurrentTime(n), this.disposeSourceHandler_ = (n) => this.disposeSourceHandler(n), this.queuedHanders_ = /* @__PURE__ */ new Set(), this.hasStarted_ = !1, this.on("playing", function() {
      this.hasStarted_ = !0;
    }), this.on("loadstart", function() {
      this.hasStarted_ = !1;
    }), $i.names.forEach((n) => {
      const s = $i[n];
      e && e[s.getterName] && (this[s.privateName] = e[s.getterName]);
    }), this.featuresProgressEvents || this.manualProgressOn(), this.featuresTimeupdateEvents || this.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach((n) => {
      e[`native${n}Tracks`] === !1 && (this[`featuresNative${n}Tracks`] = !1);
    }), e.nativeCaptions === !1 || e.nativeTextTracks === !1 ? this.featuresNativeTextTracks = !1 : (e.nativeCaptions === !0 || e.nativeTextTracks === !0) && (this.featuresNativeTextTracks = !0), this.featuresNativeTextTracks || this.emulateTextTracks(), this.preloadTextTracks = e.preloadTextTracks !== !1, this.autoRemoteTextTracks_ = new $i.text.ListClass(), this.initTrackListeners(), e.nativeControlsForTouch || this.emitTapEvents(), this.constructor && (this.name_ = this.constructor.name || "Unknown Tech");
  }
  /**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */
  triggerSourceset(e) {
    this.isReady_ || this.one("ready", () => this.setTimeout(() => this.triggerSourceset(e), 1)), this.trigger({
      src: e,
      type: "sourceset"
    });
  }
  /* Fallbacks for unsupported event types
  ================================================================================ */
  /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */
  manualProgressOn() {
    this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
  }
  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */
  manualProgressOff() {
    this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
  }
  /**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */
  trackProgress(e) {
    this.stopTrackingProgress(), this.progressInterval = this.setInterval(zt(this, function() {
      const i = this.bufferedPercent();
      this.bufferedPercent_ !== i && this.trigger("progress"), this.bufferedPercent_ = i, i === 1 && this.stopTrackingProgress();
    }), 500);
  }
  /**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */
  onDurationChange(e) {
    this.duration_ = this.duration();
  }
  /**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return {TimeRange}
   *         The time range object that was created.
   */
  buffered() {
    return ts(0, 0);
  }
  /**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */
  bufferedPercent() {
    return Zb(this.buffered(), this.duration_);
  }
  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */
  stopTrackingProgress() {
    this.clearInterval(this.progressInterval);
  }
  /**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */
  manualTimeUpdatesOn() {
    this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
  }
  /**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */
  manualTimeUpdatesOff() {
    this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
  }
  /**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */
  trackCurrentTime() {
    this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
      this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      });
    }, 250);
  }
  /**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */
  stopTrackingCurrentTime() {
    this.clearInterval(this.currentTimeInterval), this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */
  dispose() {
    this.clearTracks(On.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), super.dispose();
  }
  /**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */
  clearTracks(e) {
    e = [].concat(e), e.forEach((i) => {
      const n = this[`${i}Tracks`]() || [];
      let s = n.length;
      for (; s--; ) {
        const r = n[s];
        i === "text" && this.removeRemoteTextTrack(r), n.removeTrack(r);
      }
    });
  }
  /**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */
  cleanupAutoTextTracks() {
    const e = this.autoRemoteTextTracks_ || [];
    let i = e.length;
    for (; i--; ) {
      const n = e[i];
      this.removeRemoteTextTrack(n);
    }
  }
  /**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */
  reset() {
  }
  /**
   * Get the value of `crossOrigin` from the tech.
   *
   * @abstract
   *
   * @see {Html5#crossOrigin}
   */
  crossOrigin() {
  }
  /**
   * Set the value of `crossOrigin` on the tech.
   *
   * @abstract
   *
   * @param {string} crossOrigin the crossOrigin value
   * @see {Html5#setCrossOrigin}
   */
  setCrossOrigin() {
  }
  /**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */
  error(e) {
    return e !== void 0 && (this.error_ = new si(e), this.trigger("error")), this.error_;
  }
  /**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks whether the source has played at all or not.
   *
   * @return {TimeRange}
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */
  played() {
    return this.hasStarted_ ? ts(0, 0) : ts();
  }
  /**
   * Start playback
   *
   * @abstract
   *
   * @see {Html5#play}
   */
  play() {
  }
  /**
   * Set whether we are scrubbing or not
   *
   * @abstract
   * @param {boolean} _isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   *
   * @see {Html5#setScrubbing}
   */
  setScrubbing(e) {
  }
  /**
   * Get whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#scrubbing}
   */
  scrubbing() {
  }
  /**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @param {number} _seconds
   *        Set the current time of the media to this.
   * @fires Tech#timeupdate
   */
  setCurrentTime(e) {
    this.manualTimeUpdates && this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */
  initTrackListeners() {
    On.names.forEach((e) => {
      const i = On[e], n = () => {
        this.trigger(`${e}trackchange`);
      }, s = this[i.getterName]();
      s.addEventListener("removetrack", n), s.addEventListener("addtrack", n), this.on("dispose", () => {
        s.removeEventListener("removetrack", n), s.removeEventListener("addtrack", n);
      });
    });
  }
  /**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */
  addWebVttScript_() {
    if (!ne.WebVTT)
      if (Ne.body.contains(this.el())) {
        if (!this.options_["vtt.js"] && oo(Ng) && Object.keys(Ng).length > 0) {
          this.trigger("vttjsloaded");
          return;
        }
        const e = Ne.createElement("script");
        e.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", e.onload = () => {
          this.trigger("vttjsloaded");
        }, e.onerror = () => {
          this.trigger("vttjserror");
        }, this.on("dispose", () => {
          e.onload = null, e.onerror = null;
        }), ne.WebVTT = !0, this.el().parentNode.appendChild(e);
      } else
        this.ready(this.addWebVttScript_);
  }
  /**
   * Emulate texttracks
   *
   */
  emulateTextTracks() {
    const e = this.textTracks(), i = this.remoteTextTracks(), n = (o) => e.addTrack(o.track), s = (o) => e.removeTrack(o.track);
    i.on("addtrack", n), i.on("removetrack", s), this.addWebVttScript_();
    const r = () => this.trigger("texttrackchange"), a = () => {
      r();
      for (let o = 0; o < e.length; o++) {
        const l = e[o];
        l.removeEventListener("cuechange", r), l.mode === "showing" && l.addEventListener("cuechange", r);
      }
    };
    a(), e.addEventListener("change", a), e.addEventListener("addtrack", a), e.addEventListener("removetrack", a), this.on("dispose", function() {
      i.off("addtrack", n), i.off("removetrack", s), e.removeEventListener("change", a), e.removeEventListener("addtrack", a), e.removeEventListener("removetrack", a);
      for (let o = 0; o < e.length; o++)
        e[o].removeEventListener("cuechange", r);
    });
  }
  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */
  addTextTrack(e, i, n) {
    if (!e)
      throw new Error("TextTrack kind is required but was not provided");
    return SF(this, e, i, n);
  }
  /**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */
  createRemoteTextTrack(e) {
    const i = Bt(e, {
      tech: this
    });
    return new ho.remoteTextEl.TrackClass(i);
  }
  /**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=false]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   */
  addRemoteTextTrack(e = {}, i) {
    const n = this.createRemoteTextTrack(e);
    return typeof i != "boolean" && (i = !1), this.remoteTextTrackEls().addTrackElement_(n), this.remoteTextTracks().addTrack(n.track), i === !1 && this.ready(() => this.autoRemoteTextTracks_.addTrack(n.track)), n;
  }
  /**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */
  removeRemoteTextTrack(e) {
    const i = this.remoteTextTrackEls().getTrackElementByTrack_(e);
    this.remoteTextTrackEls().removeTrackElement_(i), this.remoteTextTracks().removeTrack(e), this.autoRemoteTextTracks_.removeTrack(e);
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */
  getVideoPlaybackQuality() {
    return {};
  }
  /**
   * Attempt to create a floating video window always on top of other windows
   * so that users may continue consuming media while they interact with other
   * content sites, or applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise|undefined}
   *         A promise with a Picture-in-Picture window if the browser supports
   *         Promises (or one was passed in as an option). It returns undefined
   *         otherwise.
   *
   * @abstract
   */
  requestPictureInPicture() {
    return Promise.reject();
  }
  /**
   * A method to check for the value of the 'disablePictureInPicture' <video> property.
   * Defaults to true, as it should be considered disabled if the tech does not support pip
   *
   * @abstract
   */
  disablePictureInPicture() {
    return !0;
  }
  /**
   * A method to set or unset the 'disablePictureInPicture' <video> property.
   *
   * @abstract
   */
  setDisablePictureInPicture() {
  }
  /**
   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
   *
   * @param {function} cb
   * @return {number} request id
   */
  requestVideoFrameCallback(e) {
    const i = Bn();
    return !this.isReady_ || this.paused() ? (this.queuedHanders_.add(i), this.one("playing", () => {
      this.queuedHanders_.has(i) && (this.queuedHanders_.delete(i), e());
    })) : this.requestNamedAnimationFrame(i, e), i;
  }
  /**
   * A fallback implementation of cancelVideoFrameCallback
   *
   * @param {number} id id of callback to be cancelled
   */
  cancelVideoFrameCallback(e) {
    this.queuedHanders_.has(e) ? this.queuedHanders_.delete(e) : this.cancelNamedAnimationFrame(e);
  }
  /**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */
  setPoster() {
  }
  /**
   * A method to check for the presence of the 'playsinline' <video> attribute.
   *
   * @abstract
   */
  playsinline() {
  }
  /**
   * A method to set or unset the 'playsinline' <video> attribute.
   *
   * @abstract
   */
  setPlaysinline() {
  }
  /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   *
   * @abstract
   */
  overrideNativeAudioTracks(e) {
  }
  /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   *
   * @abstract
   */
  overrideNativeVideoTracks(e) {
  }
  /**
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} _type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */
  canPlayType(e) {
    return "";
  }
  /**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} _type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */
  static canPlayType(e) {
    return "";
  }
  /**
   * Check if the tech can support the given source
   *
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */
  static canPlaySource(e, i) {
    return ft.canPlayType(e.type);
  }
  /*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */
  static isTech(e) {
    return e.prototype instanceof ft || e instanceof ft || e === ft;
  }
  /**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */
  static registerTech(e, i) {
    if (ft.techs_ || (ft.techs_ = {}), !ft.isTech(i))
      throw new Error(`Tech ${e} must be a Tech`);
    if (!ft.canPlayType)
      throw new Error("Techs must have a static canPlayType method on them");
    if (!ft.canPlaySource)
      throw new Error("Techs must have a static canPlaySource method on them");
    return e = oi(e), ft.techs_[e] = i, ft.techs_[vl(e)] = i, e !== "Tech" && ft.defaultTechOrder_.push(e), i;
  }
  /**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requested.
   */
  static getTech(e) {
    if (e) {
      if (ft.techs_ && ft.techs_[e])
        return ft.techs_[e];
      if (e = oi(e), ne && ne.videojs && ne.videojs[e])
        return pt.warn(`The ${e} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`), ne.videojs[e];
    }
  }
}
$i.names.forEach(function(t) {
  const e = $i[t];
  ft.prototype[e.getterName] = function() {
    return this[e.privateName] = this[e.privateName] || new e.ListClass(), this[e.privateName];
  };
});
ft.prototype.featuresVolumeControl = !0;
ft.prototype.featuresMuteControl = !0;
ft.prototype.featuresFullscreenResize = !1;
ft.prototype.featuresPlaybackRate = !1;
ft.prototype.featuresProgressEvents = !1;
ft.prototype.featuresSourceset = !1;
ft.prototype.featuresTimeupdateEvents = !1;
ft.prototype.featuresNativeTextTracks = !1;
ft.prototype.featuresVideoFrameCallback = !1;
ft.withSourceHandlers = function(t) {
  t.registerSourceHandler = function(i, n) {
    let s = t.sourceHandlers;
    s || (s = t.sourceHandlers = []), n === void 0 && (n = s.length), s.splice(n, 0, i);
  }, t.canPlayType = function(i) {
    const n = t.sourceHandlers || [];
    let s;
    for (let r = 0; r < n.length; r++)
      if (s = n[r].canPlayType(i), s)
        return s;
    return "";
  }, t.selectSourceHandler = function(i, n) {
    const s = t.sourceHandlers || [];
    let r;
    for (let a = 0; a < s.length; a++)
      if (r = s[a].canHandleSource(i, n), r)
        return s[a];
    return null;
  }, t.canPlaySource = function(i, n) {
    const s = t.selectSourceHandler(i, n);
    return s ? s.canHandleSource(i, n) : "";
  }, ["seekable", "seeking", "duration"].forEach(function(i) {
    const n = this[i];
    typeof n == "function" && (this[i] = function() {
      return this.sourceHandler_ && this.sourceHandler_[i] ? this.sourceHandler_[i].apply(this.sourceHandler_, arguments) : n.apply(this, arguments);
    });
  }, t.prototype), t.prototype.setSource = function(i) {
    let n = t.selectSourceHandler(i, this.options_);
    n || (t.nativeSourceHandler ? n = t.nativeSourceHandler : pt.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), n !== t.nativeSourceHandler && (this.currentSource_ = i), this.sourceHandler_ = n.handleSource(i, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
  }, t.prototype.disposeSourceHandler = function() {
    this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null);
  };
};
be.registerComponent("Tech", ft);
ft.registerTech("Tech", ft);
ft.defaultTechOrder_ = [];
const Qr = {}, bd = {}, wd = {};
function CF(t, e) {
  Qr[t] = Qr[t] || [], Qr[t].push(e);
}
function EF(t, e, i) {
  t.setTimeout(() => Rr(e, Qr[e.type], i, t), 1);
}
function DF(t, e) {
  t.forEach((i) => i.setTech && i.setTech(e));
}
function _F(t, e, i) {
  return t.reduceRight(tm(i), e[i]());
}
function kF(t, e, i, n) {
  return e[i](t.reduce(tm(i), n));
}
function pv(t, e, i, n = null) {
  const s = "call" + oi(i), r = t.reduce(tm(s), n), a = r === wd, o = a ? null : e[i](r);
  return MF(t, i, o, a), o;
}
const PF = {
  buffered: 1,
  currentTime: 1,
  duration: 1,
  muted: 1,
  played: 1,
  paused: 1,
  seekable: 1,
  volume: 1,
  ended: 1
}, IF = {
  setCurrentTime: 1,
  setMuted: 1,
  setVolume: 1
}, mv = {
  play: 1,
  pause: 1
};
function tm(t) {
  return (e, i) => e === wd ? wd : i[t] ? i[t](e) : e;
}
function MF(t, e, i, n) {
  for (let s = t.length - 1; s >= 0; s--) {
    const r = t[s];
    r[e] && r[e](n, i);
  }
}
function OF(t) {
  bd.hasOwnProperty(t.id()) && delete bd[t.id()];
}
function BF(t, e) {
  const i = bd[t.id()];
  let n = null;
  if (i == null)
    return n = e(t), bd[t.id()] = [[e, n]], n;
  for (let s = 0; s < i.length; s++) {
    const [r, a] = i[s];
    r === e && (n = a);
  }
  return n === null && (n = e(t), i.push([e, n])), n;
}
function Rr(t = {}, e = [], i, n, s = [], r = !1) {
  const [a, ...o] = e;
  if (typeof a == "string")
    Rr(t, Qr[a], i, n, s, r);
  else if (a) {
    const l = BF(n, a);
    if (!l.setSource)
      return s.push(l), Rr(t, o, i, n, s, r);
    l.setSource(Object.assign({}, t), function(u, d) {
      if (u)
        return Rr(t, o, i, n, s, r);
      s.push(l), Rr(d, t.type === d.type ? o : Qr[d.type], i, n, s, r);
    });
  } else o.length ? Rr(t, o, i, n, s, r) : r ? i(t, s) : Rr(t, Qr["*"], i, n, s, !0);
}
const LF = {
  opus: "video/ogg",
  ogv: "video/ogg",
  mp4: "video/mp4",
  mov: "video/mp4",
  m4v: "video/mp4",
  mkv: "video/x-matroska",
  m4a: "audio/mp4",
  mp3: "audio/mpeg",
  aac: "audio/aac",
  caf: "audio/x-caf",
  flac: "audio/flac",
  oga: "audio/ogg",
  wav: "audio/wav",
  m3u8: "application/x-mpegURL",
  mpd: "application/dash+xml",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  png: "image/png",
  svg: "image/svg+xml",
  webp: "image/webp"
}, Td = function(t = "") {
  const e = em(t);
  return LF[e.toLowerCase()] || "";
}, NF = (t, e) => {
  if (!e)
    return "";
  if (t.cache_.source.src === e && t.cache_.source.type)
    return t.cache_.source.type;
  const i = t.cache_.sources.filter((s) => s.src === e);
  if (i.length)
    return i[0].type;
  const n = t.$$("source");
  for (let s = 0; s < n.length; s++) {
    const r = n[s];
    if (r.type && r.src && r.src === e)
      return r.type;
  }
  return Td(e);
}, tw = function(t) {
  if (Array.isArray(t)) {
    let e = [];
    t.forEach(function(i) {
      i = tw(i), Array.isArray(i) ? e = e.concat(i) : Ds(i) && e.push(i);
    }), t = e;
  } else typeof t == "string" && t.trim() ? t = [Av({
    src: t
  })] : Ds(t) && typeof t.src == "string" && t.src && t.src.trim() ? t = [Av(t)] : t = [];
  return t;
};
function Av(t) {
  if (!t.type) {
    const e = Td(t.src);
    e && (t.type = e);
  }
  return t;
}
var RF = `<svg xmlns="http://www.w3.org/2000/svg">
  <defs>
    <symbol viewBox="0 0 48 48" id="vjs-icon-play">
      <path d="M16 10v28l22-14z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-pause">
      <path d="M12 38h8V10h-8v28zm16-28v28h8V10h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-audio">
      <path d="M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-captions">
      <path d="M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-subtitles">
      <path d="M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-enter">
      <path d="M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-exit">
      <path d="M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-play-circle">
      <path d="M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-mute">
      <path d="M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-low">
      <path d="M14 18v12h8l10 10V8L22 18h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-medium">
      <path d="M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-high">
      <path d="M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-spinner">
      <path d="M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z"></path>
    </symbol>
    <symbol viewBox="0 0 24 24" id="vjs-icon-hd">
      <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-chapters">
      <path d="M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z"></path>
    </symbol>
    <symbol viewBox="0 0 40 40" id="vjs-icon-downloading">
      <path d="M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download">
      <path d="M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-done">
      <path d="M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-off">
      <path d="M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-share">
      <path d="M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cog">
      <path d="M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-square">
      <path d="M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle">
      <circle cx="24" cy="24" r="20"></circle>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-outline">
      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-inner-circle">
      <path d="M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cancel">
      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-replay">
      <path d="M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-repeat">
      <path d="M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-5">
      <path d="M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-10">
      <path d="M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-30">
      <path d="M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-5">
      <path d="M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-10">
      <path d="M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-30">
      <path d="M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z"></path>
    </symbol>
    <symbol viewBox="0 0 512 512" id="vjs-icon-audio-description">
      <g fill-rule="evenodd"><path d="M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57"></path><path d="M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z"></path></g>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-next-item">
      <path d="M12 36l17-12-17-12v24zm20-24v24h4V12h-4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-previous-item">
      <path d="M12 12h4v24h-4zm7 12l17 12V12z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-shuffle">
      <path d="M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cast">
      <path d="M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-picture-in-picture-enter">
      <path d="M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z"></path>
    </symbol>
    <symbol viewBox="0 0 22 18" id="vjs-icon-picture-in-picture-exit">
      <path d="M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z"></path>
      <path fill="none" d="M-1-3h24v24H-1z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-facebook">
      <path d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-linkedin">
      <path d="M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z"></path>
    </symbol>
    <symbol viewBox="0 0 1200 1227" id="vjs-icon-twitter">
      <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"/>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-tumblr">
      <path d="M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-pinterest">
      <path d="M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z"></path>
    </symbol>
  </defs>
</svg>`;
const gv = md ? 10009 : Ad ? 461 : 8, ga = {
  codes: {
    play: 415,
    pause: 19,
    ff: 417,
    rw: 412,
    back: gv
  },
  names: {
    415: "play",
    19: "pause",
    417: "ff",
    412: "rw",
    [gv]: "back"
  },
  isEventKey(t, e) {
    return e = e.toLowerCase(), !!(this.names[t.keyCode] && this.names[t.keyCode] === e);
  },
  getEventName(t) {
    if (this.names[t.keyCode])
      return this.names[t.keyCode];
    if (this.codes[t.code]) {
      const e = this.codes[t.code];
      return this.names[e];
    }
    return null;
  }
}, vv = 5;
class FF extends Sn {
  /**
   * Constructs a SpatialNavigation instance with initial settings.
   * Sets up the player instance, and prepares the spatial navigation system.
   *
   * @class
   * @param {Player} player - The Video.js player instance to which the spatial navigation is attached.
   */
  constructor(e) {
    super(), this.player_ = e, this.focusableComponents = [], this.isListening_ = !1, this.isPaused_ = !1, this.onKeyDown_ = this.onKeyDown_.bind(this), this.lastFocusedComponent_ = null;
  }
  /**
   * Starts the spatial navigation by adding a keydown event listener to the video container.
   * This method ensures that the event listener is added only once.
   */
  start() {
    this.isListening_ || (this.player_.on("keydown", this.onKeyDown_), this.player_.on("modalKeydown", this.onKeyDown_), this.player_.on("loadedmetadata", () => {
      this.focus(this.updateFocusableComponents()[0]);
    }), this.player_.on("modalclose", () => {
      this.refocusComponent();
    }), this.player_.on("focusin", this.handlePlayerFocus_.bind(this)), this.player_.on("focusout", this.handlePlayerBlur_.bind(this)), this.isListening_ = !0, this.player_.errorDisplay && this.player_.errorDisplay.on("aftermodalfill", () => {
      this.updateFocusableComponents(), this.focusableComponents.length && (this.focusableComponents.length > 1 ? this.focusableComponents[1].focus() : this.focusableComponents[0].focus());
    }));
  }
  /**
   * Stops the spatial navigation by removing the keydown event listener from the video container.
   * Also sets the `isListening_` flag to false.
   */
  stop() {
    this.player_.off("keydown", this.onKeyDown_), this.isListening_ = !1;
  }
  /**
   * Responds to keydown events for spatial navigation and media control.
   *
   * Determines if spatial navigation or media control is active and handles key inputs accordingly.
   *
   * @param {KeyboardEvent} event - The keydown event to be handled.
   */
  onKeyDown_(e) {
    const i = e.originalEvent ? e.originalEvent : e;
    if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(i.key)) {
      if (this.isPaused_)
        return;
      i.preventDefault();
      const n = i.key.substring(5).toLowerCase();
      this.move(n);
    } else if (ga.isEventKey(i, "play") || ga.isEventKey(i, "pause") || ga.isEventKey(i, "ff") || ga.isEventKey(i, "rw")) {
      i.preventDefault();
      const n = ga.getEventName(i);
      this.performMediaAction_(n);
    } else ga.isEventKey(i, "Back") && e.target && typeof e.target.closeable == "function" && e.target.closeable() && (i.preventDefault(), e.target.close());
  }
  /**
   * Performs media control actions based on the given key input.
   *
   * Controls the playback and seeking functionalities of the media player.
   *
   * @param {string} key - The key representing the media action to be performed.
   *   Accepted keys: 'play', 'pause', 'ff' (fast-forward), 'rw' (rewind).
   */
  performMediaAction_(e) {
    if (this.player_)
      switch (e) {
        case "play":
          this.player_.paused() && this.player_.play();
          break;
        case "pause":
          this.player_.paused() || this.player_.pause();
          break;
        case "ff":
          this.userSeek_(this.player_.currentTime() + vv);
          break;
        case "rw":
          this.userSeek_(this.player_.currentTime() - vv);
          break;
      }
  }
  /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */
  userSeek_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
  }
  /**
   * Pauses the spatial navigation functionality.
   * This method sets a flag that can be used to temporarily disable the navigation logic.
   */
  pause() {
    this.isPaused_ = !0;
  }
  /**
   * Resumes the spatial navigation functionality if it has been paused.
   * This method resets the pause flag, re-enabling the navigation logic.
   */
  resume() {
    this.isPaused_ = !1;
  }
  /**
   * Handles Player Blur.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * Calls for handling of the Player Blur if:
   * *The next focused element is not a child of current focused element &
   * The next focused element is not a child of the Player.
   * *There is no next focused element
   */
  handlePlayerBlur_(e) {
    const i = e.relatedTarget;
    let n = null;
    const s = this.getCurrentComponent(e.target);
    i && (n = !!i.closest(".video-js"), i.classList.contains("vjs-text-track-settings") && !this.isPaused_ && this.searchForTrackSelect_()), (!e.currentTarget.contains(e.relatedTarget) && !n || !i) && (s && s.name() === "CloseButton" ? this.refocusComponent() : (this.pause(), s && s.el() && (this.lastFocusedComponent_ = s)));
  }
  /**
   * Handles the Player focus event.
   *
   * Calls for handling of the Player Focus if current element is focusable.
   */
  handlePlayerFocus_() {
    this.getCurrentComponent() && this.getCurrentComponent().getIsFocusable() && this.resume();
  }
  /**
   * Gets a set of focusable components.
   *
   * @return {Array}
   *         Returns an array of focusable components.
   */
  updateFocusableComponents() {
    const e = this.player_, i = [];
    function n(s) {
      for (const r of s)
        r.hasOwnProperty("el_") && r.getIsFocusable() && r.getIsAvailableToBeFocused(r.el()) && i.push(r), r.hasOwnProperty("children_") && r.children_.length > 0 && n(r.children_);
    }
    return e.children_.forEach((s) => {
      if (s.hasOwnProperty("el_"))
        if (s.getIsFocusable && s.getIsAvailableToBeFocused && s.getIsFocusable() && s.getIsAvailableToBeFocused(s.el())) {
          i.push(s);
          return;
        } else s.hasOwnProperty("children_") && s.children_.length > 0 ? n(s.children_) : s.hasOwnProperty("items") && s.items.length > 0 ? n(s.items) : this.findSuitableDOMChild(s) && i.push(s);
      if (s.name_ === "ErrorDisplay" && s.opened_) {
        const r = s.el_.querySelector(".vjs-errors-ok-button-container");
        r && r.querySelectorAll("button").forEach((o, l) => {
          i.push({
            name: () => "ModalButton" + (l + 1),
            el: () => o,
            getPositions: () => {
              const u = o.getBoundingClientRect(), d = {
                x: u.x,
                y: u.y,
                width: u.width,
                height: u.height,
                top: u.top,
                right: u.right,
                bottom: u.bottom,
                left: u.left
              }, c = {
                x: u.left + u.width / 2,
                y: u.top + u.height / 2,
                width: 0,
                height: 0,
                top: u.top + u.height / 2,
                right: u.left + u.width / 2,
                bottom: u.top + u.height / 2,
                left: u.left + u.width / 2
              };
              return {
                boundingClientRect: d,
                center: c
              };
            },
            // Asume that the following are always focusable
            getIsAvailableToBeFocused: () => !0,
            getIsFocusable: (u) => !0,
            focus: () => o.focus()
          });
        });
      }
    }), this.focusableComponents = i, this.focusableComponents;
  }
  /**
   * Finds a suitable child element within the provided component's DOM element.
   *
   * @param {Object} component - The component containing the DOM element to search within.
   * @return {HTMLElement|null} Returns the suitable child element if found, or null if not found.
   */
  findSuitableDOMChild(e) {
    function i(n) {
      if (e.getIsFocusable(n) && e.getIsAvailableToBeFocused(n))
        return n;
      for (let s = 0; s < n.children.length; s++) {
        const r = n.children[s], a = i(r);
        if (a)
          return a;
      }
      return null;
    }
    return e.el() ? i(e.el()) : null;
  }
  /**
   * Gets the currently focused component from the list of focusable components.
   * If a target element is provided, it uses that element to find the corresponding
   * component. If no target is provided, it defaults to using the document's currently
   * active element.
   *
   * @param {HTMLElement} [target] - The DOM element to check against the focusable components.
   *                                 If not provided, `document.activeElement` is used.
   * @return {Component|null} - Returns the focused component if found among the focusable components,
   *                            otherwise returns null if no matching component is found.
   */
  getCurrentComponent(e) {
    this.updateFocusableComponents();
    const i = e || document.activeElement;
    if (this.focusableComponents.length) {
      for (const n of this.focusableComponents)
        if (n.el() === i)
          return n;
    }
  }
  /**
   * Adds a component to the array of focusable components.
   *
   * @param {Component} component
   *        The `Component` to be added.
   */
  add(e) {
    const i = [...this.focusableComponents];
    e.hasOwnProperty("el_") && e.getIsFocusable() && e.getIsAvailableToBeFocused(e.el()) && i.push(e), this.focusableComponents = i, this.trigger({
      type: "focusableComponentsChanged",
      focusableComponents: this.focusableComponents
    });
  }
  /**
   * Removes component from the array of focusable components.
   *
   * @param {Component} component - The component to be removed from the focusable components array.
   */
  remove(e) {
    for (let i = 0; i < this.focusableComponents.length; i++)
      if (this.focusableComponents[i].name() === e.name()) {
        this.focusableComponents.splice(i, 1), this.trigger({
          type: "focusableComponentsChanged",
          focusableComponents: this.focusableComponents
        });
        return;
      }
  }
  /**
   * Clears array of focusable components.
   */
  clear() {
    this.focusableComponents.length > 0 && (this.focusableComponents = [], this.trigger({
      type: "focusableComponentsChanged",
      focusableComponents: this.focusableComponents
    }));
  }
  /**
   * Navigates to the next focusable component based on the specified direction.
   *
   * @param {string} direction 'up', 'down', 'left', 'right'
   */
  move(e) {
    const i = this.getCurrentComponent();
    if (!i)
      return;
    const n = i.getPositions(), s = this.focusableComponents.filter((a) => a !== i && this.isInDirection_(n.boundingClientRect, a.getPositions().boundingClientRect, e)), r = this.findBestCandidate_(n.center, s, e);
    r ? this.focus(r) : this.trigger({
      type: "endOfFocusableComponents",
      direction: e,
      focusedComponent: i
    });
  }
  /**
   * Finds the best candidate on the current center position,
   * the list of candidates, and the specified navigation direction.
   *
   * @param {Object} currentCenter The center position of the current focused component element.
   * @param {Array} candidates An array of candidate components to receive focus.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {Object|null} The component that is the best candidate for receiving focus.
   */
  findBestCandidate_(e, i, n) {
    let s = 1 / 0, r = null;
    for (const a of i) {
      const o = a.getPositions().center, l = this.calculateDistance_(e, o, n);
      l < s && (s = l, r = a);
    }
    return r;
  }
  /**
   * Determines if a target rectangle is in the specified navigation direction
   * relative to a source rectangle.
   *
   * @param {Object} srcRect The bounding rectangle of the source element.
   * @param {Object} targetRect The bounding rectangle of the target element.
   * @param {string} direction The navigation direction ('up', 'down', 'left', 'right').
   * @return {boolean} True if the target is in the specified direction relative to the source.
   */
  isInDirection_(e, i, n) {
    switch (n) {
      case "right":
        return i.left >= e.right;
      case "left":
        return i.right <= e.left;
      case "down":
        return i.top >= e.bottom;
      case "up":
        return i.bottom <= e.top;
      default:
        return !1;
    }
  }
  /**
   * Focus the last focused component saved before blur on player.
   */
  refocusComponent() {
    if (this.lastFocusedComponent_) {
      this.player_.userActive() || this.player_.userActive(!0), this.updateFocusableComponents();
      for (let e = 0; e < this.focusableComponents.length; e++)
        if (this.focusableComponents[e].name() === this.lastFocusedComponent_.name()) {
          this.focus(this.focusableComponents[e]);
          return;
        }
    } else
      this.focus(this.updateFocusableComponents()[0]);
  }
  /**
   * Focuses on a given component.
   * If the component is available to be focused, it focuses on the component.
   * If not, it attempts to find a suitable DOM child within the component and focuses on it.
   *
   * @param {Component} component - The component to be focused.
   */
  focus(e) {
    typeof e == "object" && (e.getIsAvailableToBeFocused(e.el()) ? e.focus() : this.findSuitableDOMChild(e) && this.findSuitableDOMChild(e).focus());
  }
  /**
   * Calculates the distance between two points, adjusting the calculation based on
   * the specified navigation direction.
   *
   * @param {Object} center1 The center point of the first element.
   * @param {Object} center2 The center point of the second element.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {number} The calculated distance between the two centers.
   */
  calculateDistance_(e, i, n) {
    const s = Math.abs(e.x - i.x), r = Math.abs(e.y - i.y);
    let a;
    switch (n) {
      case "right":
      case "left":
        a = s + r * 100;
        break;
      case "up":
        a = r * 2 + s * 0.5;
        break;
      case "down":
        a = r * 5 + s;
        break;
      default:
        a = s + r;
    }
    return a;
  }
  /**
   * This gets called by 'handlePlayerBlur_' if 'spatialNavigation' is enabled.
   * Searches for the first 'TextTrackSelect' inside of modal to focus.
   *
   * @private
   */
  searchForTrackSelect_() {
    const e = this;
    for (const i of e.updateFocusableComponents())
      if (i.constructor.name === "TextTrackSelect") {
        e.focus(i);
        break;
      }
  }
}
class zF extends be {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function that is run when this component is ready.
   */
  constructor(e, i, n) {
    const s = Bt({
      createEl: !1
    }, i);
    if (super(e, s, n), !i.playerOptions.sources || i.playerOptions.sources.length === 0)
      for (let r = 0, a = i.playerOptions.techOrder; r < a.length; r++) {
        const o = oi(a[r]);
        let l = ft.getTech(o);
        if (o || (l = be.getComponent(o)), l && l.isSupported()) {
          e.loadTech_(o);
          break;
        }
      }
    else
      e.src(i.playerOptions.sources);
  }
}
be.registerComponent("MediaLoader", zF);
class mc extends be {
  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of component options.
   *
   * @param  {function} [options.clickHandler]
   *         The function to call when the button is clicked / activated
   *
   * @param  {string} [options.controlText]
   *         The text to set on the button
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   */
  constructor(e, i) {
    super(e, i), this.options_.controlText && this.controlText(this.options_.controlText), this.handleMouseOver_ = (n) => this.handleMouseOver(n), this.handleMouseOut_ = (n) => this.handleMouseOut(n), this.handleClick_ = (n) => this.handleClick(n), this.handleKeyDown_ = (n) => this.handleKeyDown(n), this.emitTapEvents(), this.enable();
  }
  /**
   * Create the `ClickableComponent`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e = "div", i = {}, n = {}) {
    i = Object.assign({
      className: this.buildCSSClass(),
      tabIndex: 0
    }, i), e === "button" && pt.error(`Creating a ClickableComponent with an HTML element of ${e} is not supported; use a Button instead.`), n = Object.assign({
      role: "button"
    }, n), this.tabIndex_ = i.tabIndex;
    const s = st(e, i, n);
    return this.player_.options_.experimentalSvgIcons || s.appendChild(st("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(s), s;
  }
  dispose() {
    this.controlTextEl_ = null, super.dispose();
  }
  /**
   * Create a control text element on this `ClickableComponent`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */
  createControlTextEl(e) {
    return this.controlTextEl_ = st("span", {
      className: "vjs-control-text"
    }, {
      // let the screen reader user know that the text of the element may change
      "aria-live": "polite"
    }), e && e.appendChild(this.controlTextEl_), this.controlText(this.controlText_, e), this.controlTextEl_;
  }
  /**
   * Get or set the localize text to use for the controls on the `ClickableComponent`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */
  controlText(e, i = this.el()) {
    if (e === void 0)
      return this.controlText_ || "Need Text";
    const n = this.localize(e);
    this.controlText_ = e, Sr(this.controlTextEl_, n), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && i.setAttribute("title", n);
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-control vjs-button ${super.buildCSSClass()}`;
  }
  /**
   * Enable this `ClickableComponent`
   */
  enable() {
    this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), typeof this.tabIndex_ < "u" && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
  }
  /**
   * Disable this `ClickableComponent`
   */
  disable() {
    this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), typeof this.tabIndex_ < "u" && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
  }
  /**
   * Handles language change in ClickableComponent for the player in components
   *
   *
   */
  handleLanguagechange() {
    this.controlText(this.controlText_);
  }
  /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `click` or `tap` event.
   *
   * @param {Event} event
   *        The `tap` or `click` event that caused this function to be called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */
  handleClick(e) {
    this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
  }
  /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `keydown` event.
   *
   * By default, if the key is Space or Enter, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === " " || e.key === "Enter" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
  }
}
be.registerComponent("ClickableComponent", mc);
class Mh extends mc {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.update(), this.update_ = (n) => this.update(n), e.on("posterchange", this.update_);
  }
  /**
   * Clean up and dispose of the `PosterImage`.
   */
  dispose() {
    this.player().off("posterchange", this.update_), super.dispose();
  }
  /**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return st("div", {
      className: "vjs-poster"
    });
  }
  /**
   * Get or set the `PosterImage`'s crossOrigin option.
   *
   * @param {string|null} [value]
   *        The value to set the crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */
  crossOrigin(e) {
    if (typeof e > "u")
      return this.$("img") ? this.$("img").crossOrigin : this.player_.tech_ && this.player_.tech_.isReady_ ? this.player_.crossOrigin() : this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
    if (e !== null && e !== "anonymous" && e !== "use-credentials") {
      this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
      return;
    }
    this.$("img") && (this.$("img").crossOrigin = e);
  }
  /**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */
  update(e) {
    const i = this.player().poster();
    this.setSrc(i), i ? this.show() : this.hide();
  }
  /**
   * Set the source of the `PosterImage` depending on the display method. (Re)creates
   * the inner picture and img elementss when needed.
   *
   * @param {string} [url]
   *        The URL to the source for the `PosterImage`. If not specified or falsy,
   *        any source and ant inner picture/img are removed.
   */
  setSrc(e) {
    if (!e) {
      this.el_.textContent = "";
      return;
    }
    this.$("img") || this.el_.appendChild(st("picture", {
      className: "vjs-poster",
      // Don't want poster to be tabbable.
      tabIndex: -1
    }, {}, st("img", {
      loading: "lazy",
      crossOrigin: this.crossOrigin()
    }, {
      alt: ""
    }))), this.$("img").src = e;
  }
  /**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */
  handleClick(e) {
    this.player_.controls() && (this.player_.tech(!0) && this.player_.tech(!0).focus(), this.player_.paused() ? vs(this.player_.play()) : this.player_.pause());
  }
}
Mh.prototype.crossorigin = Mh.prototype.crossOrigin;
be.registerComponent("PosterImage", Mh);
const kn = "#222", yv = "#ccc", UF = {
  monospace: "monospace",
  sansSerif: "sans-serif",
  serif: "serif",
  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
  monospaceSerif: '"Courier New", monospace',
  proportionalSansSerif: "sans-serif",
  proportionalSerif: "serif",
  casual: '"Comic Sans MS", Impact, fantasy',
  script: '"Monotype Corsiva", cursive',
  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
function Hf(t, e) {
  let i;
  if (t.length === 4)
    i = t[1] + t[1] + t[2] + t[2] + t[3] + t[3];
  else if (t.length === 7)
    i = t.slice(1);
  else
    throw new Error("Invalid color code provided, " + t + "; must be formatted as e.g. #f0e or #f604e2.");
  return "rgba(" + parseInt(i.slice(0, 2), 16) + "," + parseInt(i.slice(2, 4), 16) + "," + parseInt(i.slice(4, 6), 16) + "," + e + ")";
}
function ds(t, e, i) {
  try {
    t.style[e] = i;
  } catch {
    return;
  }
}
function bv(t) {
  return t ? `${t}px` : "";
}
class VF extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */
  constructor(e, i, n) {
    super(e, i, n);
    const s = (a) => this.updateDisplay(a), r = (a) => {
      this.updateDisplayOverlay(), this.updateDisplay(a);
    };
    e.on("loadstart", (a) => this.toggleDisplay(a)), e.on("texttrackchange", s), e.on("loadedmetadata", (a) => {
      this.updateDisplayOverlay(), this.preselectTrack(a);
    }), e.ready(zt(this, function() {
      if (e.tech_ && e.tech_.featuresNativeTextTracks) {
        this.hide();
        return;
      }
      e.on("fullscreenchange", r), e.on("playerresize", r);
      const a = ne.screen.orientation || ne, o = ne.screen.orientation ? "change" : "orientationchange";
      a.addEventListener(o, r), e.on("dispose", () => a.removeEventListener(o, r));
      const l = this.options_.playerOptions.tracks || [];
      for (let u = 0; u < l.length; u++)
        this.player_.addRemoteTextTrack(l[u], !0);
      this.preselectTrack();
    }));
  }
  /**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */
  preselectTrack() {
    const e = {
      captions: 1,
      subtitles: 1
    }, i = this.player_.textTracks(), n = this.player_.cache_.selectedLanguage;
    let s, r, a;
    for (let o = 0; o < i.length; o++) {
      const l = i[o];
      n && n.enabled && n.language && n.language === l.language && l.kind in e ? l.kind === n.kind ? a = l : a || (a = l) : n && !n.enabled ? (a = null, s = null, r = null) : l.default && (l.kind === "descriptions" && !s ? s = l : l.kind in e && !r && (r = l));
    }
    a ? a.mode = "showing" : r ? r.mode = "showing" : s && (s.mode = "showing");
  }
  /**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */
  toggleDisplay() {
    this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
  }
  /**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-text-track-display"
    }, {
      translate: "yes",
      "aria-live": "off",
      "aria-atomic": "true"
    });
  }
  /**
   * Clear all displayed {@link TextTrack}s.
   */
  clearDisplay() {
    typeof ne.WebVTT == "function" && ne.WebVTT.processCues(ne, [], this.el_);
  }
  /**
   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
   * a {@link Player#fullscreenchange} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   */
  updateDisplay() {
    const e = this.player_.textTracks(), i = this.options_.allowMultipleShowingTracks;
    if (this.clearDisplay(), i) {
      const a = [];
      for (let o = 0; o < e.length; ++o) {
        const l = e[o];
        l.mode === "showing" && a.push(l);
      }
      this.updateForTrack(a);
      return;
    }
    let n = null, s = null, r = e.length;
    for (; r--; ) {
      const a = e[r];
      a.mode === "showing" && (a.kind === "descriptions" ? n = a : s = a);
    }
    if (s ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(s)) : n && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(n)), !ne.CSS.supports("inset", "10px")) {
      const a = this.el_, o = a.querySelectorAll(".vjs-text-track-cue"), l = this.player_.controlBar.el_.getBoundingClientRect().height, u = this.player_.el_.getBoundingClientRect().height;
      a.style = "", ds(a, "position", "relative"), ds(a, "height", u - l + "px"), ds(a, "top", "unset"), gd ? ds(a, "bottom", u + "px") : ds(a, "bottom", "0px"), o.length > 0 && o.forEach((d) => {
        if (d.style.inset) {
          const c = d.style.inset.split(" ");
          c.length === 3 && Object.assign(d.style, {
            top: c[0],
            right: c[1],
            bottom: c[2],
            left: "unset"
          });
        }
      });
    }
  }
  /**
   * Updates the displayed TextTrack to be sure it overlays the video when a either
   * a {@link Player#texttrackchange} or a {@link Player#fullscreenchange} is fired.
   */
  updateDisplayOverlay() {
    if (!this.player_.videoHeight() || !ne.CSS.supports("inset-inline: 10px"))
      return;
    const e = this.player_.currentWidth(), i = this.player_.currentHeight(), n = e / i, s = this.player_.videoWidth() / this.player_.videoHeight();
    let r = 0, a = 0;
    Math.abs(n - s) > 0.1 && (n > s ? r = Math.round((e - i * s) / 2) : a = Math.round((i - e / s) / 2)), ds(this.el_, "insetInline", bv(r)), ds(this.el_, "insetBlock", bv(a));
  }
  /**
   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
   *
   * @param {TextTrack} track
   *        Text track object containing active cues to style.
   */
  updateDisplayState(e) {
    const i = this.player_.textTrackSettings.getValues(), n = e.activeCues;
    let s = n.length;
    for (; s--; ) {
      const r = n[s];
      if (!r)
        continue;
      const a = r.displayState;
      if (i.color && (a.firstChild.style.color = i.color), i.textOpacity && ds(a.firstChild, "color", Hf(i.color || "#fff", i.textOpacity)), i.backgroundColor && (a.firstChild.style.backgroundColor = i.backgroundColor), i.backgroundOpacity && ds(a.firstChild, "backgroundColor", Hf(i.backgroundColor || "#000", i.backgroundOpacity)), i.windowColor && (i.windowOpacity ? ds(a, "backgroundColor", Hf(i.windowColor, i.windowOpacity)) : a.style.backgroundColor = i.windowColor), i.edgeStyle && (i.edgeStyle === "dropshadow" ? a.firstChild.style.textShadow = `2px 2px 3px ${kn}, 2px 2px 4px ${kn}, 2px 2px 5px ${kn}` : i.edgeStyle === "raised" ? a.firstChild.style.textShadow = `1px 1px ${kn}, 2px 2px ${kn}, 3px 3px ${kn}` : i.edgeStyle === "depressed" ? a.firstChild.style.textShadow = `1px 1px ${yv}, 0 1px ${yv}, -1px -1px ${kn}, 0 -1px ${kn}` : i.edgeStyle === "uniform" && (a.firstChild.style.textShadow = `0 0 4px ${kn}, 0 0 4px ${kn}, 0 0 4px ${kn}, 0 0 4px ${kn}`)), i.fontPercent && i.fontPercent !== 1) {
        const o = ne.parseFloat(a.style.fontSize);
        a.style.fontSize = o * i.fontPercent + "px", a.style.height = "auto", a.style.top = "auto";
      }
      i.fontFamily && i.fontFamily !== "default" && (i.fontFamily === "small-caps" ? a.firstChild.style.fontVariant = "small-caps" : a.firstChild.style.fontFamily = UF[i.fontFamily]);
    }
  }
  /**
   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack|TextTrack[]} tracks
   *        Text track object or text track array to be added to the list.
   */
  updateForTrack(e) {
    if (Array.isArray(e) || (e = [e]), typeof ne.WebVTT != "function" || e.every((n) => !n.activeCues))
      return;
    const i = [];
    for (let n = 0; n < e.length; ++n) {
      const s = e[n];
      for (let r = 0; r < s.activeCues.length; ++r)
        i.push(s.activeCues[r]);
    }
    ne.WebVTT.processCues(ne, i, this.el_);
    for (let n = 0; n < e.length; ++n) {
      const s = e[n];
      for (let r = 0; r < s.activeCues.length; ++r) {
        const a = s.activeCues[r].displayState;
        Gr(a, "vjs-text-track-cue", "vjs-text-track-cue-" + (s.language ? s.language : n)), s.language && lo(a, "lang", s.language);
      }
      this.player_.textTrackSettings && this.updateDisplayState(s);
    }
  }
}
be.registerComponent("TextTrackDisplay", VF);
class qF extends be {
  /**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */
  createEl() {
    const e = this.player_.isAudio(), i = this.localize(e ? "Audio Player" : "Video Player"), n = st("span", {
      className: "vjs-control-text",
      textContent: this.localize("{1} is loading.", [i])
    }), s = super.createEl("div", {
      className: "vjs-loading-spinner",
      dir: "ltr"
    });
    return s.appendChild(n), s;
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-control-text").textContent = this.localize("{1} is loading.", [this.player_.isAudio() ? "Audio Player" : "Video Player"]);
  }
}
be.registerComponent("LoadingSpinner", qF);
class Hi extends mc {
  /**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, i = {}, n = {}) {
    e = "button", i = Object.assign({
      className: this.buildCSSClass()
    }, i), n = Object.assign({
      // Necessary since the default button type is "submit"
      type: "button"
    }, n);
    const s = st(e, i, n);
    return this.player_.options_.experimentalSvgIcons || s.appendChild(st("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(s), s;
  }
  /**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */
  addChild(e, i = {}) {
    const n = this.constructor.name;
    return pt.warn(`Adding an actionable (user controllable) child to a Button (${n}) is not supported; use a ClickableComponent instead.`), be.prototype.addChild.call(this, e, i);
  }
  /**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */
  enable() {
    super.enable(), this.el_.removeAttribute("disabled");
  }
  /**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */
  disable() {
    super.disable(), this.el_.setAttribute("disabled", "disabled");
  }
  /**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    if (e.key === " " || e.key === "Enter") {
      e.stopPropagation();
      return;
    }
    super.handleKeyDown(e);
  }
}
be.registerComponent("Button", Hi);
class iw extends Hi {
  constructor(e, i) {
    super(e, i), this.mouseused_ = !1, this.setIcon("play"), this.on("mousedown", (n) => this.handleMouseDown(n));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */
  buildCSSClass() {
    return "vjs-big-play-button";
  }
  /**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {KeyboardEvent|MouseEvent|TouchEvent} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const i = this.player_.play();
    if (this.mouseused_ && "clientX" in e && "clientY" in e) {
      vs(i), this.player_.tech(!0) && this.player_.tech(!0).focus();
      return;
    }
    const n = this.player_.getChild("controlBar"), s = n && n.getChild("playToggle");
    if (!s) {
      this.player_.tech(!0).focus();
      return;
    }
    const r = () => s.focus();
    yl(i) ? i.then(r, () => {
    }) : this.setTimeout(r, 1);
  }
  /**
   * Event handler that is called when a `BigPlayButton` receives a
   * `keydown` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    this.mouseused_ = !1, super.handleKeyDown(e);
  }
  /**
   * Handle `mousedown` events on the `BigPlayButton`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    this.mouseused_ = !0;
  }
}
iw.prototype.controlText_ = "Play Video";
be.registerComponent("BigPlayButton", iw);
class HF extends Hi {
  /**
  * Creates an instance of the this class.
  *
  * @param  {Player} player
  *         The `Player` that this class should be attached to.
  *
  * @param  {Object} [options]
  *         The key/value store of player options.
  */
  constructor(e, i) {
    super(e, i), this.setIcon("cancel"), this.controlText(i && i.controlText || this.localize("Close"));
  }
  /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */
  buildCSSClass() {
    return `vjs-close-button ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when
   * this will be triggered
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */
  handleClick(e) {
    this.trigger({
      type: "close",
      bubbles: !1
    });
  }
  /**
   * Event handler that is called when a `CloseButton` receives a
   * `keydown` event.
   *
   * By default, if the key is Esc, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "Escape" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
  }
}
be.registerComponent("CloseButton", HF);
class nw extends Hi {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, i = {}) {
    super(e, i), i.replay = i.replay === void 0 || i.replay, this.setIcon("play"), this.on(e, "play", (n) => this.handlePlay(n)), this.on(e, "pause", (n) => this.handlePause(n)), i.replay && this.on(e, "ended", (n) => this.handleEnded(n));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-play-control ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.paused() ? vs(this.player_.play()) : this.player_.pause();
  }
  /**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */
  handleSeeked(e) {
    this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(e) : this.handlePlay(e);
  }
  /**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */
  handlePlay(e) {
    this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.setIcon("pause"), this.controlText("Pause");
  }
  /**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */
  handlePause(e) {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.setIcon("play"), this.controlText("Play");
  }
  /**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */
  handleEnded(e) {
    this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.setIcon("replay"), this.controlText("Replay"), this.one(this.player_, "seeked", (i) => this.handleSeeked(i));
  }
}
nw.prototype.controlText_ = "Play";
be.registerComponent("PlayToggle", nw);
class xo extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.on(e, ["timeupdate", "ended", "seeking"], (n) => this.update(n)), this.updateTextNode_();
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = this.buildCSSClass(), i = super.createEl("div", {
      className: `${e} vjs-time-control vjs-control`
    }), n = st("span", {
      className: "vjs-control-text",
      textContent: `${this.localize(this.labelText_)} `
    }, {
      role: "presentation"
    });
    return i.appendChild(n), this.contentEl_ = st("span", {
      className: `${e}-display`
    }, {
      // span elements have no implicit role, but some screen readers (notably VoiceOver)
      // treat them as a break between items in the DOM when using arrow keys
      // (or left-to-right swipes on iOS) to read contents of a page. Using
      // role='presentation' causes VoiceOver to NOT treat this span as a break.
      role: "presentation"
    }), i.appendChild(this.contentEl_), i;
  }
  dispose() {
    this.contentEl_ = null, this.textNode_ = null, super.dispose();
  }
  /**
   * Updates the displayed time according to the `updateContent` function which is defined in the child class.
   *
   * @param {Event} [event]
   *          The `timeupdate`, `ended` or `seeking` (if enableSmoothSeeking is true) event that caused this function to be called.
   */
  update(e) {
    !this.player_.options_.enableSmoothSeeking && e.type === "seeking" || this.updateContent(e);
  }
  /**
   * Updates the time display text node with a new time
   *
   * @param {number} [time=0] the time to update to
   *
   * @private
   */
  updateTextNode_(e = 0) {
    e = ia(e), this.formattedTime_ !== e && (this.formattedTime_ = e, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", () => {
      if (!this.contentEl_)
        return;
      let i = this.textNode_;
      i && this.contentEl_.firstChild !== i && (i = null, pt.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), this.textNode_ = Ne.createTextNode(this.formattedTime_), this.textNode_ && (i ? this.contentEl_.replaceChild(this.textNode_, i) : this.contentEl_.appendChild(this.textNode_));
    }));
  }
  /**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */
  updateContent(e) {
  }
}
xo.prototype.labelText_ = "Time";
xo.prototype.controlText_ = "Time";
be.registerComponent("TimeDisplay", xo);
class im extends xo {
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-current-time";
  }
  /**
   * Update current time display
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */
  updateContent(e) {
    let i;
    this.player_.ended() ? i = this.player_.duration() : i = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(i);
  }
}
im.prototype.labelText_ = "Current Time";
im.prototype.controlText_ = "Current Time";
be.registerComponent("CurrentTimeDisplay", im);
class nm extends xo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i);
    const n = (s) => this.updateContent(s);
    this.on(e, "durationchange", n), this.on(e, "loadstart", n), this.on(e, "loadedmetadata", n);
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-duration";
  }
  /**
   * Update duration time display.
   *
   * @param {Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */
  updateContent(e) {
    const i = this.player_.duration();
    this.updateTextNode_(i);
  }
}
nm.prototype.labelText_ = "Duration";
nm.prototype.controlText_ = "Duration";
be.registerComponent("DurationDisplay", nm);
class WF extends be {
  /**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-time-control vjs-time-divider"
    }, {
      // this element and its contents can be hidden from assistive techs since
      // it is made extraneous by the announcement of the control text
      // for the current time and duration displays
      "aria-hidden": !0
    }), i = super.createEl("div"), n = super.createEl("span", {
      textContent: "/"
    });
    return i.appendChild(n), e.appendChild(i), e;
  }
}
be.registerComponent("TimeDivider", WF);
class sm extends xo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.on(e, "durationchange", (n) => this.updateContent(n));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-remaining-time";
  }
  /**
   * Create the `Component`'s DOM element with the "minus" character prepend to the time
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl();
    return this.options_.displayNegative !== !1 && e.insertBefore(st("span", {}, {
      "aria-hidden": !0
    }, "-"), this.contentEl_), e;
  }
  /**
   * Update remaining time display.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */
  updateContent(e) {
    if (typeof this.player_.duration() != "number")
      return;
    let i;
    this.player_.ended() ? i = 0 : this.player_.remainingTimeDisplay ? i = this.player_.remainingTimeDisplay() : i = this.player_.remainingTime(), this.updateTextNode_(i);
  }
}
sm.prototype.labelText_ = "Remaining Time";
sm.prototype.controlText_ = "Remaining Time";
be.registerComponent("RemainingTimeDisplay", sm);
class YF extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.updateShowing(), this.on(this.player(), "durationchange", (n) => this.updateShowing(n));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-live-control vjs-control"
    });
    return this.contentEl_ = st("div", {
      className: "vjs-live-display"
    }, {
      "aria-live": "off"
    }), this.contentEl_.appendChild(st("span", {
      className: "vjs-control-text",
      textContent: `${this.localize("Stream Type")} `
    })), this.contentEl_.appendChild(Ne.createTextNode(this.localize("LIVE"))), e.appendChild(this.contentEl_), e;
  }
  dispose() {
    this.contentEl_ = null, super.dispose();
  }
  /**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */
  updateShowing(e) {
    this.player().duration() === 1 / 0 ? this.show() : this.hide();
  }
}
be.registerComponent("LiveDisplay", YF);
class sw extends Hi {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.updateLiveEdgeStatus(), this.player_.liveTracker && (this.updateLiveEdgeStatusHandler_ = (n) => this.updateLiveEdgeStatus(n), this.on(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("button", {
      className: "vjs-seek-to-live-control vjs-control"
    });
    return this.setIcon("circle", e), this.textEl_ = st("span", {
      className: "vjs-seek-to-live-text",
      textContent: this.localize("LIVE")
    }, {
      "aria-hidden": "true"
    }), e.appendChild(this.textEl_), e;
  }
  /**
   * Update the state of this button if we are at the live edge
   * or not
   */
  updateLiveEdgeStatus() {
    !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
  }
  /**
   * On click bring us as near to the live point as possible.
   * This requires that we wait for the next `live-seekable-change`
   * event which will happen every segment length seconds.
   */
  handleClick() {
    this.player_.liveTracker.seekToLiveEdge();
  }
  /**
   * Dispose of the element and stop tracking
   */
  dispose() {
    this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, super.dispose();
  }
}
sw.prototype.controlText_ = "Seek to live, currently playing live";
be.registerComponent("SeekToLive", sw);
function jl(t, e, i) {
  return t = Number(t), Math.min(i, Math.max(e, isNaN(t) ? e : t));
}
var XF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  clamp: jl
});
class rm extends be {
  /**
  * Create an instance of this class
  *
  * @param {Player} player
  *        The `Player` that this class should be attached to.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  */
  constructor(e, i) {
    super(e, i), this.handleMouseDown_ = (n) => this.handleMouseDown(n), this.handleMouseUp_ = (n) => this.handleMouseUp(n), this.handleKeyDown_ = (n) => this.handleKeyDown(n), this.handleClick_ = (n) => this.handleClick(n), this.handleMouseMove_ = (n) => this.handleMouseMove(n), this.update_ = (n) => this.update(n), this.bar = this.getChild(this.options_.barName), this.vertical(!!this.options_.vertical), this.enable();
  }
  /**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */
  enabled() {
    return this.enabled_;
  }
  /**
   * Enable controls for this slider if they are disabled
   */
  enable() {
    this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
  }
  /**
   * Disable controls for this slider if they are enabled
   */
  disable() {
    if (!this.enabled())
      return;
    const e = this.bar.el_.ownerDocument;
    this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(e, "mousemove", this.handleMouseMove_), this.off(e, "mouseup", this.handleMouseUp_), this.off(e, "touchmove", this.handleMouseMove_), this.off(e, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
  }
  /**
   * Create the `Slider`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, i = {}, n = {}) {
    return i.className = i.className + " vjs-slider", i = Object.assign({
      tabIndex: 0
    }, i), n = Object.assign({
      role: "slider",
      "aria-valuenow": 0,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    }, n), super.createEl(e, i, n);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */
  handleMouseDown(e) {
    const i = this.bar.el_.ownerDocument;
    e.type === "mousedown" && e.preventDefault(), e.type === "touchstart" && !_s && e.preventDefault(), Ib(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(i, "mousemove", this.handleMouseMove_), this.on(i, "mouseup", this.handleMouseUp_), this.on(i, "touchmove", this.handleMouseMove_), this.on(i, "touchend", this.handleMouseUp_), this.handleMouseMove(e, !0);
  }
  /**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {MouseEvent} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
   *
   * @listens mousemove
   * @listens touchmove
   */
  handleMouseMove(e) {
  }
  /**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */
  handleMouseUp(e) {
    const i = this.bar.el_.ownerDocument;
    Mb(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(i, "mousemove", this.handleMouseMove_), this.off(i, "mouseup", this.handleMouseUp_), this.off(i, "touchmove", this.handleMouseMove_), this.off(i, "touchend", this.handleMouseUp_), this.update();
  }
  /**
   * Update the progress bar of the `Slider`.
   *
   * @return {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */
  update() {
    if (!this.el_ || !this.bar)
      return;
    const e = this.getProgress();
    return e === this.progress_ || (this.progress_ = e, this.requestNamedAnimationFrame("Slider#update", () => {
      const i = this.vertical() ? "height" : "width";
      this.bar.el().style[i] = (e * 100).toFixed(2) + "%";
    })), e;
  }
  /**
   * Get the percentage of the bar that should be filled
   * but clamped and rounded.
   *
   * @return {number}
   *         percentage filled that the slider is
   */
  getProgress() {
    return Number(jl(this.getPercent(), 0, 1).toFixed(4));
  }
  /**
   * Calculate distance for slider
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - position.x for vertical `Slider`s
   *         - position.y for horizontal `Slider`s
   */
  calculateDistance(e) {
    const i = uc(this.el_, e);
    return this.vertical() ? i.y : i.x;
  }
  /**
   * Handle a `keydown` event on the `Slider`. Watches for left, right, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {KeyboardEvent} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const i = this.options_.playerOptions.spatialNavigation, n = i && i.enabled, s = i && i.horizontalSeek;
    n ? s && e.key === "ArrowLeft" || !s && e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : s && e.key === "ArrowRight" || !s && e.key === "ArrowUp" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : super.handleKeyDown(e) : e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : e.key === "ArrowUp" || e.key === "ArrowRight" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : super.handleKeyDown(e);
  }
  /**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */
  handleClick(e) {
    e.stopPropagation(), e.preventDefault();
  }
  /**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */
  vertical(e) {
    if (e === void 0)
      return this.vertical_ || !1;
    this.vertical_ = !!e, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
  }
}
be.registerComponent("Slider", rm);
const Wf = (t, e) => jl(t / e * 100, 0, 100).toFixed(2) + "%";
class jF extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.partEls_ = [], this.on(e, "progress", (n) => this.update(n));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-load-progress"
    }), i = st("span", {
      className: "vjs-control-text"
    }), n = st("span", {
      textContent: this.localize("Loaded")
    }), s = Ne.createTextNode(": ");
    return this.percentageEl_ = st("span", {
      className: "vjs-control-text-loaded-percentage",
      textContent: "0%"
    }), e.appendChild(i), i.appendChild(n), i.appendChild(s), i.appendChild(this.percentageEl_), e;
  }
  dispose() {
    this.partEls_ = null, this.percentageEl_ = null, super.dispose();
  }
  /**
   * Update progress bar
   *
   * @param {Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */
  update(e) {
    this.requestNamedAnimationFrame("LoadProgressBar#update", () => {
      const i = this.player_.liveTracker, n = this.player_.buffered(), s = i && i.isLive() ? i.seekableEnd() : this.player_.duration(), r = this.player_.bufferedEnd(), a = this.partEls_, o = Wf(r, s);
      this.percent_ !== o && (this.el_.style.width = o, Sr(this.percentageEl_, o), this.percent_ = o);
      for (let l = 0; l < n.length; l++) {
        const u = n.start(l), d = n.end(l);
        let c = a[l];
        c || (c = this.el_.appendChild(st()), a[l] = c), !(c.dataset.start === u && c.dataset.end === d) && (c.dataset.start = u, c.dataset.end = d, c.style.left = Wf(u, r), c.style.width = Wf(d - u, r));
      }
      for (let l = a.length; l > n.length; l--)
        this.el_.removeChild(a[l - 1]);
      a.length = n.length;
    });
  }
}
be.registerComponent("LoadProgressBar", jF);
class GF extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.update = ks(zt(this, this.update), Ln);
  }
  /**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-time-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, i, n) {
    const s = Pl(this.el_), r = uo(this.player_.el()), a = e.width * i;
    if (!r || !s)
      return;
    let o = e.left - r.left + a, l = e.width - a + (r.right - e.right);
    l || (l = e.width - a, o = a);
    let u = s.width / 2;
    o < u ? u += u - o : l < u && (u = l), u < 0 ? u = 0 : u > s.width && (u = s.width), u = Math.round(u), this.el_.style.right = `-${u}px`, this.write(n);
  }
  /**
   * Write the time to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted time for the tooltip.
   */
  write(e) {
    Sr(this.el_, e);
  }
  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {number} time
   *        The time to update the tooltip to, not used during live playback
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */
  updateTime(e, i, n, s) {
    this.requestNamedAnimationFrame("TimeTooltip#updateTime", () => {
      let r;
      const a = this.player_.duration();
      if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
        const o = this.player_.liveTracker.liveWindow(), l = o - i * o;
        r = (l < 1 ? "" : "-") + ia(l, o);
      } else
        r = ia(n, a);
      this.update(e, i, r), s && s();
    });
  }
}
be.registerComponent("TimeTooltip", GF);
class am extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.setIcon("circle"), this.update = ks(zt(this, this.update), Ln);
  }
  /**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-play-progress vjs-slider-bar"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, i) {
    const n = this.getChild("timeTooltip");
    if (!n)
      return;
    const s = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    n.updateTime(e, i, s);
  }
}
am.prototype.options_ = {
  children: []
};
!Vi && !rs && am.prototype.options_.children.push("timeTooltip");
be.registerComponent("PlayProgressBar", am);
class rw extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.update = ks(zt(this, this.update), Ln);
  }
  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-mouse-display"
    });
  }
  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, i) {
    const n = i * this.player_.duration();
    this.getChild("timeTooltip").updateTime(e, i, n, () => {
      this.el_.style.left = `${e.width * i}px`;
    });
  }
}
rw.prototype.options_ = {
  children: ["timeTooltip"]
};
be.registerComponent("MouseTimeDisplay", rw);
class Ac extends rm {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   * @param {number} [options.stepSeconds=5]
   *        The number of seconds to increment on keyboard control
   * @param {number} [options.pageMultiplier=12]
   *        The multiplier of stepSeconds that PgUp/PgDown move the timeline.
   */
  constructor(e, i) {
    i = Bt(Ac.prototype.options_, i), i.children = [...i.children];
    const n = e.options_.disableSeekWhileScrubbingOnMobile && (Vi || rs);
    (!Vi && !rs || n) && i.children.splice(1, 0, "mouseTimeDisplay"), super(e, i), this.shouldDisableSeekWhileScrubbingOnMobile_ = n, this.pendingSeekTime_ = null, this.setEventHandlers_();
  }
  /**
   * Sets the event handlers
   *
   * @private
   */
  setEventHandlers_() {
    this.update_ = zt(this, this.update), this.update = ks(this.update_, Ln), this.on(this.player_, ["durationchange", "timeupdate"], this.update), this.on(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = (e) => this.enableInterval_(e), this.disableIntervalHandler_ = (e) => this.disableInterval_(e), this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in Ne && "visibilityState" in Ne && this.on(Ne, "visibilitychange", this.toggleVisibility_);
  }
  toggleVisibility_(e) {
    Ne.visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(e)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
  }
  enableInterval_() {
    this.updateInterval || (this.updateInterval = this.setInterval(this.update, Ln));
  }
  disableInterval_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== "ended" || this.updateInterval && (this.clearInterval(this.updateInterval), this.updateInterval = null);
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-progress-holder"
    }, {
      "aria-label": this.localize("Progress Bar")
    });
  }
  /**
   * This function updates the play progress bar and accessibility
   * attributes to whatever is passed in.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @return {number}
   *          The current percent at a number from 0-1
   */
  update(e) {
    if (Ne.visibilityState === "hidden")
      return;
    const i = super.update();
    return this.requestNamedAnimationFrame("SeekBar#update", () => {
      const n = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_(), s = this.player_.liveTracker;
      let r = this.player_.duration();
      s && s.isLive() && (r = this.player_.liveTracker.liveCurrentTime()), this.percent_ !== i && (this.el_.setAttribute("aria-valuenow", (i * 100).toFixed(2)), this.percent_ = i), (this.currentTime_ !== n || this.duration_ !== r) && (this.el_.setAttribute("aria-valuetext", this.localize("progress bar timing: currentTime={1} duration={2}", [ia(n, r), ia(r, r)], "{1} of {2}")), this.currentTime_ = n, this.duration_ = r), this.bar && this.bar.update(uo(this.el()), this.getProgress());
    }), i;
  }
  /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */
  userSeek_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
  }
  /**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */
  getCurrentTime_() {
    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
  }
  /**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */
  getPercent() {
    if (this.pendingSeekTime_)
      return this.pendingSeekTime_ / this.player_.duration();
    const e = this.getCurrentTime_();
    let i;
    const n = this.player_.liveTracker;
    return n && n.isLive() ? (i = (e - n.seekableStart()) / n.liveWindow(), n.atLiveEdge() && (i = 1)) : i = e / this.player_.duration(), i;
  }
  /**
   * Handle mouse down on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    Il(e) && (e.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.shouldDisableSeekWhileScrubbingOnMobile_ || this.player_.pause(), super.handleMouseDown(e));
  }
  /**
   * Handle mouse move on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousemove` event that caused this to run.
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
   *
   * @listens mousemove
   */
  handleMouseMove(e, i = !1) {
    if (!Il(e) || isNaN(this.player_.duration()))
      return;
    !i && !this.player_.scrubbing() && this.player_.scrubbing(!0);
    let n;
    const s = this.calculateDistance(e), r = this.player_.liveTracker;
    if (!r || !r.isLive())
      n = s * this.player_.duration(), n === this.player_.duration() && (n = n - 0.1);
    else {
      if (s >= 0.99) {
        r.seekToLiveEdge();
        return;
      }
      const a = r.seekableStart(), o = r.liveCurrentTime();
      if (n = a + s * r.liveWindow(), n >= o && (n = o), n <= a && (n = a + 0.1), n === 1 / 0)
        return;
    }
    this.shouldDisableSeekWhileScrubbingOnMobile_ ? this.pendingSeekTime_ = n : this.userSeek_(n), this.player_.options_.enableSmoothSeeking && this.update();
  }
  enable() {
    super.enable();
    const e = this.getChild("mouseTimeDisplay");
    e && e.show();
  }
  disable() {
    super.disable();
    const e = this.getChild("mouseTimeDisplay");
    e && e.hide();
  }
  /**
   * Handle mouse up on seek bar
   *
   * @param {MouseEvent} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */
  handleMouseUp(e) {
    super.handleMouseUp(e), e && e.stopPropagation(), this.player_.scrubbing(!1), this.pendingSeekTime_ && (this.userSeek_(this.pendingSeekTime_), this.pendingSeekTime_ = null), this.player_.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    }), this.videoWasPlaying ? vs(this.player_.play()) : this.update_();
  }
  /**
   * Move more quickly fast forward for keyboard-only users
   */
  stepForward() {
    this.userSeek_(this.player_.currentTime() + this.options().stepSeconds);
  }
  /**
   * Move more quickly rewind for keyboard-only users
   */
  stepBack() {
    this.userSeek_(this.player_.currentTime() - this.options().stepSeconds);
  }
  /**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called
   *
   */
  handleAction(e) {
    this.player_.paused() ? this.player_.play() : this.player_.pause();
  }
  /**
   * Called when this SeekBar has focus and a key gets pressed down.
   * Supports the following keys:
   *
   *   Space or Enter key fire a click event
   *   Home key moves to start of the timeline
   *   End key moves to end of the timeline
   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
   *   PageDown key moves back a larger step than ArrowDown
   *   PageUp key moves forward a large step
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const i = this.player_.liveTracker;
    if (e.key === " " || e.key === "Enter")
      e.preventDefault(), e.stopPropagation(), this.handleAction(e);
    else if (e.key === "Home")
      e.preventDefault(), e.stopPropagation(), this.userSeek_(0);
    else if (e.key === "End")
      e.preventDefault(), e.stopPropagation(), i && i.isLive() ? this.userSeek_(i.liveCurrentTime()) : this.userSeek_(this.player_.duration());
    else if (/^[0-9]$/.test(e.key)) {
      e.preventDefault(), e.stopPropagation();
      const n = parseInt(e.key, 10) * 0.1;
      i && i.isLive() ? this.userSeek_(i.seekableStart() + i.liveWindow() * n) : this.userSeek_(this.player_.duration() * n);
    } else e.key === "PageDown" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() - this.options().stepSeconds * this.options().pageMultiplier)) : e.key === "PageUp" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() + this.options().stepSeconds * this.options().pageMultiplier)) : super.handleKeyDown(e);
  }
  dispose() {
    this.disableInterval_(), this.off(this.player_, ["durationchange", "timeupdate"], this.update), this.off(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in Ne && "visibilityState" in Ne && this.off(Ne, "visibilitychange", this.toggleVisibility_), super.dispose();
  }
}
Ac.prototype.options_ = {
  children: ["loadProgressBar", "playProgressBar"],
  barName: "playProgressBar",
  stepSeconds: 5,
  pageMultiplier: 12
};
be.registerComponent("SeekBar", Ac);
class aw extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.handleMouseMove = ks(zt(this, this.handleMouseMove), Ln), this.throttledHandleMouseSeek = ks(zt(this, this.handleMouseSeek), Ln), this.handleMouseUpHandler_ = (n) => this.handleMouseUp(n), this.handleMouseDownHandler_ = (n) => this.handleMouseDown(n), this.enable();
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-progress-control vjs-control"
    });
  }
  /**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */
  handleMouseMove(e) {
    const i = this.getChild("seekBar");
    if (!i)
      return;
    const n = i.getChild("playProgressBar"), s = i.getChild("mouseTimeDisplay");
    if (!n && !s)
      return;
    const r = i.el(), a = Pl(r);
    let o = uc(r, e).x;
    o = jl(o, 0, 1), s && s.update(a, o), n && n.update(a, i.getProgress());
  }
  /**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */
  /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */
  handleMouseSeek(e) {
    const i = this.getChild("seekBar");
    i && i.handleMouseMove(e);
  }
  /**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */
  enabled() {
    return this.enabled_;
  }
  /**
   * Disable all controls on the progress control and its children
   */
  disable() {
    if (this.children().forEach((e) => e.disable && e.disable()), !!this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
      const e = this.getChild("seekBar");
      this.player_.scrubbing(!1), e.videoWasPlaying && vs(this.player_.play());
    }
  }
  /**
   * Enable all controls on the progress control and its children
   */
  enable() {
    this.children().forEach((e) => e.enable && e.enable()), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, ["mousemove", "touchmove"], this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
  }
  /**
   * Cleanup listeners after the user finishes interacting with the progress controls
   */
  removeListenersAddedOnMousedownAndTouchstart() {
    const e = this.el_.ownerDocument;
    this.off(e, "mousemove", this.throttledHandleMouseSeek), this.off(e, "touchmove", this.throttledHandleMouseSeek), this.off(e, "mouseup", this.handleMouseUpHandler_), this.off(e, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseDown(e) {
    const i = this.el_.ownerDocument, n = this.getChild("seekBar");
    n && n.handleMouseDown(e), this.on(i, "mousemove", this.throttledHandleMouseSeek), this.on(i, "touchmove", this.throttledHandleMouseSeek), this.on(i, "mouseup", this.handleMouseUpHandler_), this.on(i, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */
  handleMouseUp(e) {
    const i = this.getChild("seekBar");
    i && i.handleMouseUp(e), this.removeListenersAddedOnMousedownAndTouchstart();
  }
}
aw.prototype.options_ = {
  children: ["seekBar"]
};
be.registerComponent("ProgressControl", aw);
class ow extends Hi {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */
  constructor(e, i) {
    super(e, i), this.setIcon("picture-in-picture-enter"), this.on(e, ["enterpictureinpicture", "leavepictureinpicture"], (n) => this.handlePictureInPictureChange(n)), this.on(e, ["disablepictureinpicturechanged", "loadedmetadata"], (n) => this.handlePictureInPictureEnabledChange(n)), this.on(e, ["loadedmetadata", "audioonlymodechange", "audiopostermodechange"], () => this.handlePictureInPictureAudioModeChange()), this.disable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
  }
  /**
   * Displays or hides the button depending on the audio mode detection.
   * Exits picture-in-picture if it is enabled when switching to audio mode.
   */
  handlePictureInPictureAudioModeChange() {
    if (!(this.player_.currentType().substring(0, 5) === "audio" || this.player_.audioPosterMode() || this.player_.audioOnlyMode())) {
      this.show();
      return;
    }
    this.player_.isInPictureInPicture() && this.player_.exitPictureInPicture(), this.hide();
  }
  /**
   * Enables or disables button based on availability of a Picture-In-Picture mode.
   *
   * Enabled if
   * - `player.options().enableDocumentPictureInPicture` is true and
   *   window.documentPictureInPicture is available; or
   * - `player.disablePictureInPicture()` is false and
   *   element.requestPictureInPicture is available
   */
  handlePictureInPictureEnabledChange() {
    Ne.pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 || this.player_.options_.enableDocumentPictureInPicture && "documentPictureInPicture" in ne ? this.enable() : this.disable();
  }
  /**
   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
   *        called.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */
  handlePictureInPictureChange(e) {
    this.player_.isInPictureInPicture() ? (this.setIcon("picture-in-picture-exit"), this.controlText("Exit Picture-in-Picture")) : (this.setIcon("picture-in-picture-enter"), this.controlText("Picture-in-Picture")), this.handlePictureInPictureEnabledChange();
  }
  /**
   * This gets called when an `PictureInPictureToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
  }
  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it only in browsers that support the Picture-in-Picture API.
   */
  show() {
    typeof Ne.exitPictureInPicture == "function" && super.show();
  }
}
ow.prototype.controlText_ = "Picture-in-Picture";
be.registerComponent("PictureInPictureToggle", ow);
class lw extends Hi {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.setIcon("fullscreen-enter"), this.on(e, "fullscreenchange", (n) => this.handleFullscreenChange(n)), Ne[e.fsApi_.fullscreenEnabled] === !1 && this.disable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-fullscreen-control ${super.buildCSSClass()}`;
  }
  /**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */
  handleFullscreenChange(e) {
    this.player_.isFullscreen() ? (this.controlText("Exit Fullscreen"), this.setIcon("fullscreen-exit")) : (this.controlText("Fullscreen"), this.setIcon("fullscreen-enter"));
  }
  /**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
  }
}
lw.prototype.controlText_ = "Fullscreen";
be.registerComponent("FullscreenToggle", lw);
const QF = function(t, e) {
  e.tech_ && !e.tech_.featuresVolumeControl && t.addClass("vjs-hidden"), t.on(e, "loadstart", function() {
    e.tech_.featuresVolumeControl ? t.removeClass("vjs-hidden") : t.addClass("vjs-hidden");
  });
};
class ZF extends be {
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-volume-level"
    });
    return this.setIcon("circle", e), e.appendChild(super.createEl("span", {
      className: "vjs-control-text"
    })), e;
  }
}
be.registerComponent("VolumeLevel", ZF);
class KF extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.update = ks(zt(this, this.update), Ln);
  }
  /**
   * Create the volume tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-volume-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Updates the position of the tooltip relative to the `VolumeBar` and
   * its content text.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */
  update(e, i, n, s) {
    if (!n) {
      const r = uo(this.el_), a = uo(this.player_.el()), o = e.width * i;
      if (!a || !r)
        return;
      const l = e.left - a.left + o, u = e.width - o + (a.right - e.right);
      let d = r.width / 2;
      l < d ? d += d - l : u < d && (d = u), d < 0 ? d = 0 : d > r.width && (d = r.width), this.el_.style.right = `-${d}px`;
    }
    this.write(`${s}%`);
  }
  /**
   * Write the volume to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted volume for the tooltip.
   */
  write(e) {
    Sr(this.el_, e);
  }
  /**
   * Updates the position of the volume tooltip relative to the `VolumeBar`.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   * @param {number} volume
   *        The volume level to update the tooltip to
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */
  updateVolume(e, i, n, s, r) {
    this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", () => {
      this.update(e, i, n, s.toFixed(0)), r && r();
    });
  }
}
be.registerComponent("VolumeLevelTooltip", KF);
class uw extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.update = ks(zt(this, this.update), Ln);
  }
  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-mouse-display"
    });
  }
  /**
   * Enquires updates to its own DOM as well as the DOM of its
   * {@link VolumeLevelTooltip} child.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */
  update(e, i, n) {
    const s = 100 * i;
    this.getChild("volumeLevelTooltip").updateVolume(e, i, n, s, () => {
      n ? this.el_.style.bottom = `${e.height * i}px` : this.el_.style.left = `${e.width * i}px`;
    });
  }
}
uw.prototype.options_ = {
  children: ["volumeLevelTooltip"]
};
be.registerComponent("MouseVolumeLevelDisplay", uw);
class gc extends rm {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.on("slideractive", (n) => this.updateLastVolume_(n)), this.on(e, "volumechange", (n) => this.updateARIAAttributes(n)), e.ready(() => this.updateARIAAttributes());
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-volume-bar vjs-slider-bar"
    }, {
      "aria-label": this.localize("Volume Level"),
      "aria-live": "polite"
    });
  }
  /**
   * Handle mouse down on volume bar
   *
   * @param {Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    Il(e) && super.handleMouseDown(e);
  }
  /**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */
  handleMouseMove(e) {
    const i = this.getChild("mouseVolumeLevelDisplay");
    if (i) {
      const n = this.el(), s = uo(n), r = this.vertical();
      let a = uc(n, e);
      a = r ? a.y : a.x, a = jl(a, 0, 1), i.update(s, a, r);
    }
    Il(e) && (this.checkMuted(), this.player_.volume(this.calculateDistance(e)));
  }
  /**
   * If the player is muted unmute it.
   */
  checkMuted() {
    this.player_.muted() && this.player_.muted(!1);
  }
  /**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */
  getPercent() {
    return this.player_.muted() ? 0 : this.player_.volume();
  }
  /**
   * Increase volume level for keyboard users
   */
  stepForward() {
    this.checkMuted(), this.player_.volume(this.player_.volume() + 0.1);
  }
  /**
   * Decrease volume level for keyboard users
   */
  stepBack() {
    this.checkMuted(), this.player_.volume(this.player_.volume() - 0.1);
  }
  /**
   * Update ARIA accessibility attributes
   *
   * @param {Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */
  updateARIAAttributes(e) {
    const i = this.player_.muted() ? 0 : this.volumeAsPercentage_();
    this.el_.setAttribute("aria-valuenow", i), this.el_.setAttribute("aria-valuetext", i + "%");
  }
  /**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */
  volumeAsPercentage_() {
    return Math.round(this.player_.volume() * 100);
  }
  /**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */
  updateLastVolume_() {
    const e = this.player_.volume();
    this.one("sliderinactive", () => {
      this.player_.volume() === 0 && this.player_.lastVolume_(e);
    });
  }
}
gc.prototype.options_ = {
  children: ["volumeLevel"],
  barName: "volumeLevel"
};
!Vi && !rs && gc.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay");
gc.prototype.playerEvent = "volumechange";
be.registerComponent("VolumeBar", gc);
class dw extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, i = {}) {
    i.vertical = i.vertical || !1, (typeof i.volumeBar > "u" || oo(i.volumeBar)) && (i.volumeBar = i.volumeBar || {}, i.volumeBar.vertical = i.vertical), super(e, i), QF(this, e), this.throttledHandleMouseMove = ks(zt(this, this.handleMouseMove), Ln), this.handleMouseUpHandler_ = (n) => this.handleMouseUp(n), this.on("mousedown", (n) => this.handleMouseDown(n)), this.on("touchstart", (n) => this.handleMouseDown(n)), this.on("mousemove", (n) => this.handleMouseMove(n)), this.on(this.volumeBar, ["focus", "slideractive"], () => {
      this.volumeBar.addClass("vjs-slider-active"), this.addClass("vjs-slider-active"), this.trigger("slideractive");
    }), this.on(this.volumeBar, ["blur", "sliderinactive"], () => {
      this.volumeBar.removeClass("vjs-slider-active"), this.removeClass("vjs-slider-active"), this.trigger("sliderinactive");
    });
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    let e = "vjs-volume-horizontal";
    return this.options_.vertical && (e = "vjs-volume-vertical"), super.createEl("div", {
      className: `vjs-volume-control vjs-control ${e}`
    });
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseDown(e) {
    const i = this.el_.ownerDocument;
    this.on(i, "mousemove", this.throttledHandleMouseMove), this.on(i, "touchmove", this.throttledHandleMouseMove), this.on(i, "mouseup", this.handleMouseUpHandler_), this.on(i, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */
  handleMouseUp(e) {
    const i = this.el_.ownerDocument;
    this.off(i, "mousemove", this.throttledHandleMouseMove), this.off(i, "touchmove", this.throttledHandleMouseMove), this.off(i, "mouseup", this.handleMouseUpHandler_), this.off(i, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseMove(e) {
    this.volumeBar.handleMouseMove(e);
  }
}
dw.prototype.options_ = {
  children: ["volumeBar"]
};
be.registerComponent("VolumeControl", dw);
const JF = function(t, e) {
  e.tech_ && !e.tech_.featuresMuteControl && t.addClass("vjs-hidden"), t.on(e, "loadstart", function() {
    e.tech_.featuresMuteControl ? t.removeClass("vjs-hidden") : t.addClass("vjs-hidden");
  });
};
class cw extends Hi {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), JF(this, e), this.on(e, ["loadstart", "volumechange"], (n) => this.update(n));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-mute-control ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const i = this.player_.volume(), n = this.player_.lastVolume_();
    if (i === 0) {
      const s = n < 0.1 ? 0.1 : n;
      this.player_.volume(s), this.player_.muted(!1);
    } else
      this.player_.muted(!this.player_.muted());
  }
  /**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */
  update(e) {
    this.updateIcon_(), this.updateControlText_();
  }
  /**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */
  updateIcon_() {
    const e = this.player_.volume();
    let i = 3;
    this.setIcon("volume-high"), Vi && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), e === 0 || this.player_.muted() ? (this.setIcon("volume-mute"), i = 0) : e < 0.33 ? (this.setIcon("volume-low"), i = 1) : e < 0.67 && (this.setIcon("volume-medium"), i = 2), oc(this.el_, [0, 1, 2, 3].reduce((n, s) => n + `${s ? " " : ""}vjs-vol-${s}`, "")), Gr(this.el_, `vjs-vol-${i}`);
  }
  /**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */
  updateControlText_() {
    const i = this.player_.muted() || this.player_.volume() === 0 ? "Unmute" : "Mute";
    this.controlText() !== i && this.controlText(i);
  }
}
cw.prototype.controlText_ = "Mute";
be.registerComponent("MuteToggle", cw);
class fw extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, i = {}) {
    typeof i.inline < "u" ? i.inline = i.inline : i.inline = !0, (typeof i.volumeControl > "u" || oo(i.volumeControl)) && (i.volumeControl = i.volumeControl || {}, i.volumeControl.vertical = !i.inline), super(e, i), this.handleKeyPressHandler_ = (n) => this.handleKeyPress(n), this.on(e, ["loadstart"], (n) => this.volumePanelState_(n)), this.on(this.muteToggle, "keyup", (n) => this.handleKeyPress(n)), this.on(this.volumeControl, "keyup", (n) => this.handleVolumeControlKeyUp(n)), this.on("keydown", (n) => this.handleKeyPress(n)), this.on("mouseover", (n) => this.handleMouseOver(n)), this.on("mouseout", (n) => this.handleMouseOut(n)), this.on(this.volumeControl, ["slideractive"], this.sliderActive_), this.on(this.volumeControl, ["sliderinactive"], this.sliderInactive_);
  }
  /**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */
  sliderActive_() {
    this.addClass("vjs-slider-active");
  }
  /**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */
  sliderInactive_() {
    this.removeClass("vjs-slider-active");
  }
  /**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */
  volumePanelState_() {
    this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    let e = "vjs-volume-panel-horizontal";
    return this.options_.inline || (e = "vjs-volume-panel-vertical"), super.createEl("div", {
      className: `vjs-volume-panel vjs-control ${e}`
    });
  }
  /**
   * Dispose of the `volume-panel` and all child components.
   */
  dispose() {
    this.handleMouseOut(), super.dispose();
  }
  /**
   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
   * the volume panel and sets focus on `MuteToggle`.
   *
   * @param {Event} event
   *        The `keyup` event that caused this function to be called.
   *
   * @listens keyup
   */
  handleVolumeControlKeyUp(e) {
    e.key === "Escape" && this.muteToggle.focus();
  }
  /**
   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
   * Turns on listening for `mouseover` event. When they happen it
   * calls `this.handleMouseOver`.
   *
   * @param {Event} event
   *        The `mouseover` event that caused this function to be called.
   *
   * @listens mouseover
   */
  handleMouseOver(e) {
    this.addClass("vjs-hover"), xn(Ne, "keyup", this.handleKeyPressHandler_);
  }
  /**
   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
   * Turns on listening for `mouseout` event. When they happen it
   * calls `this.handleMouseOut`.
   *
   * @param {Event} event
   *        The `mouseout` event that caused this function to be called.
   *
   * @listens mouseout
   */
  handleMouseOut(e) {
    this.removeClass("vjs-hover"), qi(Ne, "keyup", this.handleKeyPressHandler_);
  }
  /**
   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
   * looking for ESC, which hides the `VolumeControl`.
   *
   * @param {Event} event
   *        The keypress that triggered this event.
   *
   * @listens keydown | keyup
   */
  handleKeyPress(e) {
    e.key === "Escape" && this.handleMouseOut();
  }
}
fw.prototype.options_ = {
  children: ["muteToggle", "volumeControl"]
};
be.registerComponent("VolumePanel", fw);
class hw extends Hi {
  constructor(e, i) {
    super(e, i), this.validOptions = [5, 10, 30], this.skipTime = this.getSkipForwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`forward-${this.skipTime}`), this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
  }
  getSkipForwardTime() {
    const e = this.options_.playerOptions;
    return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.forward;
  }
  buildCSSClass() {
    return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
  }
  /**
   * On click, skips forward in the duration/seekable range by a configurable amount of seconds.
   * If the time left in the duration/seekable range is less than the configured 'skip forward' time,
   * skips to end of duration/seekable range.
   *
   * Handle a click on a `SkipForward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */
  handleClick(e) {
    if (isNaN(this.player_.duration()))
      return;
    const i = this.player_.currentTime(), n = this.player_.liveTracker, s = n && n.isLive() ? n.seekableEnd() : this.player_.duration();
    let r;
    i + this.skipTime <= s ? r = i + this.skipTime : r = s, this.player_.currentTime(r);
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime]));
  }
}
hw.prototype.controlText_ = "Skip Forward";
be.registerComponent("SkipForward", hw);
class pw extends Hi {
  constructor(e, i) {
    super(e, i), this.validOptions = [5, 10, 30], this.skipTime = this.getSkipBackwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`replay-${this.skipTime}`), this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
  }
  getSkipBackwardTime() {
    const e = this.options_.playerOptions;
    return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.backward;
  }
  buildCSSClass() {
    return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
  }
  /**
   * On click, skips backward in the video by a configurable amount of seconds.
   * If the current time in the video is less than the configured 'skip backward' time,
   * skips to beginning of video or seekable range.
   *
   * Handle a click on a `SkipBackward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */
  handleClick(e) {
    const i = this.player_.currentTime(), n = this.player_.liveTracker, s = n && n.isLive() && n.seekableStart();
    let r;
    s && i - this.skipTime <= s ? r = s : i >= this.skipTime ? r = i - this.skipTime : r = 0, this.player_.currentTime(r);
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime]));
  }
}
pw.prototype.controlText_ = "Skip Backward";
be.registerComponent("SkipBackward", pw);
class mw extends be {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */
  constructor(e, i) {
    super(e, i), i && (this.menuButton_ = i.menuButton), this.focusedChild_ = -1, this.on("keydown", (n) => this.handleKeyDown(n)), this.boundHandleBlur_ = (n) => this.handleBlur(n), this.boundHandleTapClick_ = (n) => this.handleTapClick(n);
  }
  /**
   * Add event listeners to the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to add listeners to.
   *
   */
  addEventListenerForItem(e) {
    e instanceof be && (this.on(e, "blur", this.boundHandleBlur_), this.on(e, ["tap", "click"], this.boundHandleTapClick_));
  }
  /**
   * Remove event listeners from the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to remove listeners.
   *
   */
  removeEventListenerForItem(e) {
    e instanceof be && (this.off(e, "blur", this.boundHandleBlur_), this.off(e, ["tap", "click"], this.boundHandleTapClick_));
  }
  /**
   * This method will be called indirectly when the component has been added
   * before the component adds to the new menu instance by `addItem`.
   * In this case, the original menu instance will remove the component
   * by calling `removeChild`.
   *
   * @param {Object} component
   *        The instance of the `MenuItem`
   */
  removeChild(e) {
    typeof e == "string" && (e = this.getChild(e)), this.removeEventListenerForItem(e), super.removeChild(e);
  }
  /**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */
  addItem(e) {
    const i = this.addChild(e);
    i && this.addEventListenerForItem(i);
  }
  /**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */
  createEl() {
    const e = this.options_.contentElType || "ul";
    this.contentEl_ = st(e, {
      className: "vjs-menu-content"
    }), this.contentEl_.setAttribute("role", "menu");
    const i = super.createEl("div", {
      append: this.contentEl_,
      className: "vjs-menu"
    });
    return i.appendChild(this.contentEl_), xn(i, "click", function(n) {
      n.preventDefault(), n.stopImmediatePropagation();
    }), i;
  }
  dispose() {
    this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, super.dispose();
  }
  /**
   * Called when a `MenuItem` loses focus.
   *
   * @param {Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */
  handleBlur(e) {
    const i = e.relatedTarget || Ne.activeElement;
    if (!this.children().some((n) => n.el() === i)) {
      const n = this.menuButton_;
      n && n.buttonPressed_ && i !== n.el().firstChild && n.unpressButton();
    }
  }
  /**
   * Called when a `MenuItem` gets clicked or tapped.
   *
   * @param {Event} event
   *        The `click` or `tap` event that caused this function to be called.
   *
   * @listens click,tap
   */
  handleTapClick(e) {
    if (this.menuButton_) {
      this.menuButton_.unpressButton();
      const i = this.children();
      if (!Array.isArray(i))
        return;
      const n = i.filter((s) => s.el() === e.target)[0];
      if (!n)
        return;
      n.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
    }
  }
  /**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {KeyboardEvent} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : (e.key === "ArrowRight" || e.key === "ArrowUp") && (e.preventDefault(), e.stopPropagation(), this.stepBack());
  }
  /**
   * Move to next (lower) menu item for keyboard users.
   */
  stepForward() {
    let e = 0;
    this.focusedChild_ !== void 0 && (e = this.focusedChild_ + 1), this.focus(e);
  }
  /**
   * Move to previous (higher) menu item for keyboard users.
   */
  stepBack() {
    let e = 0;
    this.focusedChild_ !== void 0 && (e = this.focusedChild_ - 1), this.focus(e);
  }
  /**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */
  focus(e = 0) {
    const i = this.children().slice();
    i.length && i[0].hasClass("vjs-menu-title") && i.shift(), i.length > 0 && (e < 0 ? e = 0 : e >= i.length && (e = i.length - 1), this.focusedChild_ = e, i[e].el_.focus());
  }
}
be.registerComponent("Menu", mw);
class om extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, i = {}) {
    super(e, i), this.menuButton_ = new Hi(e, i), this.menuButton_.controlText(this.controlText_), this.menuButton_.el_.setAttribute("aria-haspopup", "true");
    const n = Hi.prototype.buildCSSClass();
    this.menuButton_.el_.className = this.buildCSSClass() + " " + n, this.menuButton_.removeClass("vjs-control"), this.addChild(this.menuButton_), this.update(), this.enabled_ = !0;
    const s = (r) => this.handleClick(r);
    this.handleMenuKeyUp_ = (r) => this.handleMenuKeyUp(r), this.on(this.menuButton_, "tap", s), this.on(this.menuButton_, "click", s), this.on(this.menuButton_, "keydown", (r) => this.handleKeyDown(r)), this.on(this.menuButton_, "mouseenter", () => {
      this.addClass("vjs-hover"), this.menu.show(), xn(Ne, "keyup", this.handleMenuKeyUp_);
    }), this.on("mouseleave", (r) => this.handleMouseLeave(r)), this.on("keydown", (r) => this.handleSubmenuKeyDown(r));
  }
  /**
   * Update the menu based on the current state of its items.
   */
  update() {
    const e = this.createMenu();
    this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = e, this.addChild(e), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? (this.hide(), this.menu.contentEl_.removeAttribute("role")) : (this.show(), this.menu.contentEl_.setAttribute("role", "menu"));
  }
  /**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */
  createMenu() {
    const e = new mw(this.player_, {
      menuButton: this
    });
    if (this.hideThreshold_ = 0, this.options_.title) {
      const i = st("li", {
        className: "vjs-menu-title",
        textContent: oi(this.options_.title),
        tabIndex: -1
      }), n = new be(this.player_, {
        el: i
      });
      e.addItem(n);
    }
    if (this.items = this.createItems(), this.items)
      for (let i = 0; i < this.items.length; i++)
        e.addItem(this.items[i]);
    return e;
  }
  /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */
  createItems() {
  }
  /**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildWrapperCSSClass()
    }, {});
  }
  /**
   * Overwrites the `setIcon` method from `Component`.
   * In this case, we want the icon to be appended to the menuButton.
   *
   * @param {string} name
   *         The icon name to be added.
   */
  setIcon(e) {
    super.setIcon(e, this.menuButton_.el_);
  }
  /**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */
  buildWrapperCSSClass() {
    let e = "vjs-menu-button";
    this.options_.inline === !0 ? e += "-inline" : e += "-popup";
    const i = Hi.prototype.buildCSSClass();
    return `vjs-menu-button ${e} ${i} ${super.buildCSSClass()}`;
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    let e = "vjs-menu-button";
    return this.options_.inline === !0 ? e += "-inline" : e += "-popup", `vjs-menu-button ${e} ${super.buildCSSClass()}`;
  }
  /**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */
  controlText(e, i = this.menuButton_.el()) {
    return this.menuButton_.controlText(e, i);
  }
  /**
   * Dispose of the `menu-button` and all child components.
   */
  dispose() {
    this.handleMouseLeave(), super.dispose();
  }
  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.buttonPressed_ ? this.unpressButton() : this.pressButton();
  }
  /**
   * Handle `mouseleave` for `MenuButton`.
   *
   * @param {Event} event
   *        The `mouseleave` event that caused this function to be called.
   *
   * @listens mouseleave
   */
  handleMouseLeave(e) {
    this.removeClass("vjs-hover"), qi(Ne, "keyup", this.handleMenuKeyUp_);
  }
  /**
   * Set the focus to the actual button, not to this element
   */
  focus() {
    this.menuButton_.focus();
  }
  /**
   * Remove the focus from the actual button, not this element
   */
  blur() {
    this.menuButton_.blur();
  }
  /**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "Escape" || e.key === "Tab" ? (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus())) : (e.key === "Up" || e.key === "Down" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) && (this.buttonPressed_ || (e.preventDefault(), this.pressButton()));
  }
  /**
   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keyup
   */
  handleMenuKeyUp(e) {
    (e.key === "Escape" || e.key === "Tab") && this.removeClass("vjs-hover");
  }
  /**
   * This method name now delegates to `handleSubmenuKeyDown`. This means
   * anyone calling `handleSubmenuKeyPress` will not see their method calls
   * stop working.
   *
   * @param {Event} event
   *        The event that caused this function to be called.
   */
  handleSubmenuKeyPress(e) {
    this.handleSubmenuKeyDown(e);
  }
  /**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keydown
   */
  handleSubmenuKeyDown(e) {
    (e.key === "Escape" || e.key === "Tab") && (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus()));
  }
  /**
   * Put the current `MenuButton` into a pressed state.
   */
  pressButton() {
    if (this.enabled_) {
      if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), Vi && Eb())
        return;
      this.menu.focus();
    }
  }
  /**
   * Take the current `MenuButton` out of a pressed state.
   */
  unpressButton() {
    this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
  }
  /**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */
  disable() {
    this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
  }
  /**
   * Enable the `MenuButton`. Allow it to be clicked.
   */
  enable() {
    this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
  }
}
be.registerComponent("MenuButton", om);
class lm extends om {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    const n = i.tracks;
    if (super(e, i), this.items.length <= 1 && this.hide(), !n)
      return;
    const s = zt(this, this.update);
    n.addEventListener("removetrack", s), n.addEventListener("addtrack", s), n.addEventListener("labelchange", s), this.player_.on("ready", s), this.player_.on("dispose", function() {
      n.removeEventListener("removetrack", s), n.removeEventListener("addtrack", s), n.removeEventListener("labelchange", s);
    });
  }
}
be.registerComponent("TrackButton", lm);
class Gl extends mc {
  /**
   * Creates an instance of the this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */
  constructor(e, i) {
    super(e, i), this.selectable = i.selectable, this.isSelected_ = i.selected || !1, this.multiSelectable = i.multiSelectable, this.selected(this.isSelected_), this.selectable ? this.multiSelectable ? this.el_.setAttribute("role", "menuitemcheckbox") : this.el_.setAttribute("role", "menuitemradio") : this.el_.setAttribute("role", "menuitem");
  }
  /**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, i, n) {
    this.nonIconControl = !0;
    const s = super.createEl("li", Object.assign({
      className: "vjs-menu-item",
      tabIndex: -1
    }, i), n), r = st("span", {
      className: "vjs-menu-item-text",
      textContent: this.localize(this.options_.label)
    });
    return this.player_.options_.experimentalSvgIcons ? s.appendChild(r) : s.replaceChild(r, s.querySelector(".vjs-icon-placeholder")), s;
  }
  /**
   * Ignore keys which are used by the menu, but pass any other ones up. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    ["Tab", "Escape", "ArrowUp", "ArrowLeft", "ArrowRight", "ArrowDown"].includes(e.key) || super.handleKeyDown(e);
  }
  /**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.selected(!0);
  }
  /**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */
  selected(e) {
    this.selectable && (e ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
  }
}
be.registerComponent("MenuItem", Gl);
class Ql extends Gl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    const n = i.track, s = e.textTracks();
    i.label = n.label || n.language || "Unknown", i.selected = n.mode === "showing", super(e, i), this.track = n, this.kinds = (i.kinds || [i.kind || this.track.kind]).filter(Boolean);
    const r = (...o) => {
      this.handleTracksChange.apply(this, o);
    }, a = (...o) => {
      this.handleSelectedLanguageChange.apply(this, o);
    };
    if (e.on(["loadstart", "texttrackchange"], r), s.addEventListener("change", r), s.addEventListener("selectedlanguagechange", a), this.on("dispose", function() {
      e.off(["loadstart", "texttrackchange"], r), s.removeEventListener("change", r), s.removeEventListener("selectedlanguagechange", a);
    }), s.onchange === void 0) {
      let o;
      this.on(["tap", "click"], function() {
        if (typeof ne.Event != "object")
          try {
            o = new ne.Event("change");
          } catch {
          }
        o || (o = Ne.createEvent("Event"), o.initEvent("change", !0, !0)), s.dispatchEvent(o);
      });
    }
    this.handleTracksChange();
  }
  /**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const i = this.track, n = this.player_.textTracks();
    if (super.handleClick(e), !!n)
      for (let s = 0; s < n.length; s++) {
        const r = n[s];
        this.kinds.indexOf(r.kind) !== -1 && (r === i ? r.mode !== "showing" && (r.mode = "showing") : r.mode !== "disabled" && (r.mode = "disabled"));
      }
  }
  /**
   * Handle text track list change
   *
   * @param {Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */
  handleTracksChange(e) {
    const i = this.track.mode === "showing";
    i !== this.isSelected_ && this.selected(i);
  }
  handleSelectedLanguageChange(e) {
    if (this.track.mode === "showing") {
      const i = this.player_.cache_.selectedLanguage;
      if (i && i.enabled && i.language === this.track.language && i.kind !== this.track.kind)
        return;
      this.player_.cache_.selectedLanguage = {
        enabled: !0,
        language: this.track.language,
        kind: this.track.kind
      };
    }
  }
  dispose() {
    this.track = null, super.dispose();
  }
}
be.registerComponent("TextTrackMenuItem", Ql);
class Aw extends Ql {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    i.track = {
      player: e,
      // it is no longer necessary to store `kind` or `kinds` on the track itself
      // since they are now stored in the `kinds` property of all instances of
      // TextTrackMenuItem, but this will remain for backwards compatibility
      kind: i.kind,
      kinds: i.kinds,
      default: !1,
      mode: "disabled"
    }, i.kinds || (i.kinds = [i.kind]), i.label ? i.track.label = i.label : i.track.label = i.kinds.join(" and ") + " off", i.selectable = !0, i.multiSelectable = !1, super(e, i);
  }
  /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   */
  handleTracksChange(e) {
    const i = this.player().textTracks();
    let n = !0;
    for (let s = 0, r = i.length; s < r; s++) {
      const a = i[s];
      if (this.options_.kinds.indexOf(a.kind) > -1 && a.mode === "showing") {
        n = !1;
        break;
      }
    }
    n !== this.isSelected_ && this.selected(n);
  }
  handleSelectedLanguageChange(e) {
    const i = this.player().textTracks();
    let n = !0;
    for (let s = 0, r = i.length; s < r; s++) {
      const a = i[s];
      if (["captions", "descriptions", "subtitles"].indexOf(a.kind) > -1 && a.mode === "showing") {
        n = !1;
        break;
      }
    }
    n && (this.player_.cache_.selectedLanguage = {
      enabled: !1
    });
  }
  /**
   * Update control text and label on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.label), super.handleLanguagechange();
  }
}
be.registerComponent("OffTextTrackMenuItem", Aw);
class So extends lm {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, i = {}) {
    i.tracks = e.textTracks(), super(e, i);
  }
  /**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */
  createItems(e = [], i = Ql) {
    let n;
    this.label_ && (n = `${this.label_} off`), e.push(new Aw(this.player_, {
      kinds: this.kinds_,
      kind: this.kind_,
      label: n
    })), this.hideThreshold_ += 1;
    const s = this.player_.textTracks();
    Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
    for (let r = 0; r < s.length; r++) {
      const a = s[r];
      if (this.kinds_.indexOf(a.kind) > -1) {
        const o = new i(this.player_, {
          track: a,
          kinds: this.kinds_,
          kind: this.kind_,
          // MenuItem is selectable
          selectable: !0,
          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
          multiSelectable: !1
        });
        o.addClass(`vjs-${a.kind}-menu-item`), e.push(o);
      }
    }
    return e;
  }
}
be.registerComponent("TextTrackButton", So);
class gw extends Gl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    const n = i.track, s = i.cue, r = e.currentTime();
    i.selectable = !0, i.multiSelectable = !1, i.label = s.text, i.selected = s.startTime <= r && r < s.endTime, super(e, i), this.track = n, this.cue = s;
  }
  /**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    super.handleClick(), this.player_.currentTime(this.cue.startTime);
  }
}
be.registerComponent("ChaptersTrackMenuItem", gw);
class um extends So {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this function is ready.
   */
  constructor(e, i, n) {
    super(e, i, n), this.setIcon("chapters"), this.selectCurrentItem_ = () => {
      this.items.forEach((s) => {
        s.selected(this.track_.activeCues[0] === s.cue);
      });
    };
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-chapters-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Update the menu based on the current state of its items.
   *
   * @param {Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */
  update(e) {
    if (e && e.track && e.track.kind !== "chapters")
      return;
    const i = this.findChaptersTrack();
    i !== this.track_ ? (this.setTrack(i), super.update()) : (!this.items || i && i.cues && i.cues.length !== this.items.length) && super.update();
  }
  /**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */
  setTrack(e) {
    if (this.track_ !== e) {
      if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
        const i = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        i && i.removeEventListener("load", this.updateHandler_), this.track_.removeEventListener("cuechange", this.selectCurrentItem_), this.track_ = null;
      }
      if (this.track_ = e, this.track_) {
        this.track_.mode = "hidden";
        const i = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        i && i.addEventListener("load", this.updateHandler_), this.track_.addEventListener("cuechange", this.selectCurrentItem_);
      }
    }
  }
  /**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */
  findChaptersTrack() {
    const e = this.player_.textTracks() || [];
    for (let i = e.length - 1; i >= 0; i--) {
      const n = e[i];
      if (n.kind === this.kind_)
        return n;
    }
  }
  /**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */
  getMenuCaption() {
    return this.track_ && this.track_.label ? this.track_.label : this.localize(oi(this.kind_));
  }
  /**
   * Create menu from chapter track
   *
   * @return {Menu}
   *         New menu for the chapter buttons
   */
  createMenu() {
    return this.options_.title = this.getMenuCaption(), super.createMenu();
  }
  /**
   * Create a menu item for each text track
   *
   * @return  {TextTrackMenuItem[]}
   *         Array of menu items
   */
  createItems() {
    const e = [];
    if (!this.track_)
      return e;
    const i = this.track_.cues;
    if (!i)
      return e;
    for (let n = 0, s = i.length; n < s; n++) {
      const r = i[n], a = new gw(this.player_, {
        track: this.track_,
        cue: r
      });
      e.push(a);
    }
    return e;
  }
}
um.prototype.kind_ = "chapters";
um.prototype.controlText_ = "Chapters";
be.registerComponent("ChaptersButton", um);
class dm extends So {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, i, n) {
    super(e, i, n), this.setIcon("audio-description");
    const s = e.textTracks(), r = zt(this, this.handleTracksChange);
    s.addEventListener("change", r), this.on("dispose", function() {
      s.removeEventListener("change", r);
    });
  }
  /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */
  handleTracksChange(e) {
    const i = this.player().textTracks();
    let n = !1;
    for (let s = 0, r = i.length; s < r; s++) {
      const a = i[s];
      if (a.kind !== this.kind_ && a.mode === "showing") {
        n = !0;
        break;
      }
    }
    n ? this.disable() : this.enable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-descriptions-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
  }
}
dm.prototype.kind_ = "descriptions";
dm.prototype.controlText_ = "Descriptions";
be.registerComponent("DescriptionsButton", dm);
class cm extends So {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, i, n) {
    super(e, i, n), this.setIcon("subtitles");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-subtitles-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
  }
}
cm.prototype.kind_ = "subtitles";
cm.prototype.controlText_ = "Subtitles";
be.registerComponent("SubtitlesButton", cm);
class fm extends Ql {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    i.track = {
      player: e,
      kind: i.kind,
      label: i.kind + " settings",
      selectable: !1,
      default: !1,
      mode: "disabled"
    }, i.selectable = !1, i.name = "CaptionSettingsMenuItem", super(e, i), this.addClass("vjs-texttrack-settings"), this.controlText(", opens " + i.kind + " settings dialog");
  }
  /**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player().getChild("textTrackSettings").open();
  }
  /**
   * Update control text and label on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.kind + " settings"), super.handleLanguagechange();
  }
}
be.registerComponent("CaptionSettingsMenuItem", fm);
class hm extends So {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, i, n) {
    super(e, i, n), this.setIcon("captions");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-captions-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */
  createItems() {
    const e = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new fm(this.player_, {
      kind: this.kind_
    })), this.hideThreshold_ += 1), super.createItems(e);
  }
}
hm.prototype.kind_ = "captions";
hm.prototype.controlText_ = "Captions";
be.registerComponent("CaptionsButton", hm);
class vw extends Ql {
  createEl(e, i, n) {
    const s = super.createEl(e, i, n), r = s.querySelector(".vjs-menu-item-text");
    return this.options_.track.kind === "captions" && (this.player_.options_.experimentalSvgIcons ? this.setIcon("captions", s) : r.appendChild(st("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), r.appendChild(st("span", {
      className: "vjs-control-text",
      // space added as the text will visually flow with the
      // label
      textContent: ` ${this.localize("Captions")}`
    }))), s;
  }
}
be.registerComponent("SubsCapsMenuItem", vw);
class pm extends So {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, i = {}) {
    super(e, i), this.label_ = "subtitles", this.setIcon("subtitles"), ["en", "en-us", "en-ca", "fr-ca"].indexOf(this.player_.language_) > -1 && (this.label_ = "captions", this.setIcon("captions")), this.menuButton_.controlText(oi(this.label_));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-subs-caps-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */
  createItems() {
    let e = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new fm(this.player_, {
      kind: this.label_
    })), this.hideThreshold_ += 1), e = super.createItems(e, vw), e;
  }
}
pm.prototype.kinds_ = ["captions", "subtitles"];
pm.prototype.controlText_ = "Subtitles";
be.registerComponent("SubsCapsButton", pm);
class yw extends Gl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    const n = i.track, s = e.audioTracks();
    i.label = n.label || n.language || "Unknown", i.selected = n.enabled, super(e, i), this.track = n, this.addClass(`vjs-${n.kind}-menu-item`);
    const r = (...a) => {
      this.handleTracksChange.apply(this, a);
    };
    s.addEventListener("change", r), this.on("dispose", () => {
      s.removeEventListener("change", r);
    });
  }
  createEl(e, i, n) {
    const s = super.createEl(e, i, n), r = s.querySelector(".vjs-menu-item-text");
    return ["main-desc", "descriptions"].indexOf(this.options_.track.kind) >= 0 && (r.appendChild(st("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), r.appendChild(st("span", {
      className: "vjs-control-text",
      textContent: " " + this.localize("Descriptions")
    }))), s;
  }
  /**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    if (super.handleClick(e), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks) {
      const i = this.player_.audioTracks();
      for (let n = 0; n < i.length; n++) {
        const s = i[n];
        s !== this.track && (s.enabled = s === this.track);
      }
    }
  }
  /**
   * Handle any {@link AudioTrack} change.
   *
   * @param {Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */
  handleTracksChange(e) {
    this.selected(this.track.enabled);
  }
}
be.registerComponent("AudioTrackMenuItem", yw);
class bw extends lm {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, i = {}) {
    i.tracks = e.audioTracks(), super(e, i), this.setIcon("audio");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-audio-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */
  createItems(e = []) {
    this.hideThreshold_ = 1;
    const i = this.player_.audioTracks();
    for (let n = 0; n < i.length; n++) {
      const s = i[n];
      e.push(new yw(this.player_, {
        track: s,
        // MenuItem is selectable
        selectable: !0,
        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
        multiSelectable: !1
      }));
    }
    return e;
  }
}
bw.prototype.controlText_ = "Audio Track";
be.registerComponent("AudioTrackButton", bw);
class mm extends Gl {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    const n = i.rate, s = parseFloat(n, 10);
    i.label = n, i.selected = s === e.playbackRate(), i.selectable = !0, i.multiSelectable = !1, super(e, i), this.label = n, this.rate = s, this.on(e, "ratechange", (r) => this.update(r));
  }
  /**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    super.handleClick(), this.player().playbackRate(this.rate);
  }
  /**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */
  update(e) {
    this.selected(this.player().playbackRate() === this.rate);
  }
}
mm.prototype.contentElType = "button";
be.registerComponent("PlaybackRateMenuItem", mm);
class ww extends om {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.menuButton_.el_.setAttribute("aria-describedby", this.labelElId_), this.updateVisibility(), this.updateLabel(), this.on(e, "loadstart", (n) => this.updateVisibility(n)), this.on(e, "ratechange", (n) => this.updateLabel(n)), this.on(e, "playbackrateschange", (n) => this.handlePlaybackRateschange(n));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl();
    return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = st("div", {
      className: "vjs-playback-rate-value",
      id: this.labelElId_,
      textContent: "1x"
    }), e.appendChild(this.labelEl_), e;
  }
  dispose() {
    this.labelEl_ = null, super.dispose();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-playback-rate ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create the list of menu items. Specific to each subclass.
   *
   */
  createItems() {
    const e = this.playbackRates(), i = [];
    for (let n = e.length - 1; n >= 0; n--)
      i.push(new mm(this.player(), {
        rate: e[n] + "x"
      }));
    return i;
  }
  /**
   * On playbackrateschange, update the menu to account for the new items.
   *
   * @listens Player#playbackrateschange
   */
  handlePlaybackRateschange(e) {
    this.update();
  }
  /**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */
  playbackRates() {
    const e = this.player();
    return e.playbackRates && e.playbackRates() || [];
  }
  /**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */
  playbackRateSupported() {
    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
  }
  /**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */
  updateVisibility(e) {
    this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
  }
  /**
   * Update button label when rate changed
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */
  updateLabel(e) {
    this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
  }
}
ww.prototype.controlText_ = "Playback Rate";
be.registerComponent("PlaybackRateMenuButton", ww);
class Tw extends be {
  /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */
  buildCSSClass() {
    return `vjs-spacer ${super.buildCSSClass()}`;
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl(e = "div", i = {}, n = {}) {
    return i.className || (i.className = this.buildCSSClass()), super.createEl(e, i, n);
  }
}
be.registerComponent("Spacer", Tw);
class $F extends Tw {
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildCSSClass(),
      // No-flex/table-cell mode requires there be some content
      // in the cell to fill the remaining space of the table.
      textContent: " "
    });
  }
}
be.registerComponent("CustomControlSpacer", $F);
class xw extends be {
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-control-bar",
      dir: "ltr"
    });
  }
}
xw.prototype.options_ = {
  children: ["playToggle", "skipBackward", "skipForward", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "pictureInPictureToggle", "fullscreenToggle"]
};
be.registerComponent("ControlBar", xw);
class Sw extends To {
  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */
  constructor(e, i) {
    super(e, i), this.on(e, "error", (n) => {
      this.open(n);
    });
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */
  buildCSSClass() {
    return `vjs-error-display ${super.buildCSSClass()}`;
  }
  /**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */
  content() {
    const e = this.player().error();
    return e ? this.localize(e.message) : "";
  }
}
Sw.prototype.options_ = Object.assign({}, To.prototype.options_, {
  pauseOnOpen: !1,
  fillAlways: !0,
  temporary: !1,
  uncloseable: !0
});
be.registerComponent("ErrorDisplay", Sw);
class Cw extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements.
   */
  constructor(e, i = {}) {
    super(e, i), this.el_.setAttribute("aria-labelledby", this.selectLabelledbyIds);
  }
  /**
   * Create the `TextTrackSelect`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return this.selectLabelledbyIds = [this.options_.legendId, this.options_.labelId].join(" ").trim(), st("select", {
      id: this.options_.id
    }, {}, this.options_.SelectOptions.map((i) => {
      const n = (this.options_.labelId ? this.options_.labelId : `vjs-track-option-${Bn()}`) + "-" + i[1].replace(/\W+/g, ""), s = st("option", {
        id: n,
        value: this.localize(i[0]),
        textContent: this.localize(i[1])
      });
      return s.setAttribute("aria-labelledby", `${this.selectLabelledbyIds} ${n}`), s;
    }));
  }
}
be.registerComponent("TextTrackSelect", Cw);
class Zr extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.legendText]
   *        A text to use as the text content of the legend element.
   *
   * @param {Array} [options.selects]
   *        Array that contains the selects that are use to create 'selects'
   *        components.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements, it passes to 'TextTrackSelect'.
   *
   * @param {string} [options.type]
   *        Conditions if some DOM elements will be added to the fieldset
   *        component.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the selects configurations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        These properties are use to configure the 'TextTrackSelect' Component.
   */
  constructor(e, i = {}) {
    super(e, i);
    const n = st("legend", {
      textContent: this.localize(this.options_.legendText),
      id: this.options_.legendId
    });
    this.el().appendChild(n);
    const s = this.options_.selects;
    for (const r of s) {
      const a = this.options_.selectConfigs[r], o = a.className, l = a.id.replace("%s", this.options_.id_);
      let u = null;
      const d = `vjs_select_${Bn()}`;
      if (this.options_.type === "colors") {
        u = st("span", {
          className: o
        });
        const A = st("label", {
          id: l,
          className: "vjs-label",
          textContent: this.localize(a.label)
        });
        A.setAttribute("for", d), u.appendChild(A);
      }
      const c = new Cw(e, {
        SelectOptions: a.options,
        legendId: this.options_.legendId,
        id: d,
        labelId: l
      });
      this.addChild(c), this.options_.type === "colors" && (u.appendChild(c.el()), this.el().appendChild(u));
    }
  }
  /**
   * Create the `TextTrackFieldset`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return st("fieldset", {
      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: this.options_.className
    });
  }
}
be.registerComponent("TextTrackFieldset", Zr);
class Ew extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */
  constructor(e, i = {}) {
    super(e, i);
    const n = this.options_.textTrackComponentid, s = new Zr(e, {
      id_: n,
      legendId: `captions-text-legend-${n}`,
      legendText: this.localize("Text"),
      className: "vjs-fg vjs-track-setting",
      selects: this.options_.fieldSets[0],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(s);
    const r = new Zr(e, {
      id_: n,
      legendId: `captions-background-${n}`,
      legendText: this.localize("Text Background"),
      className: "vjs-bg vjs-track-setting",
      selects: this.options_.fieldSets[1],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(r);
    const a = new Zr(e, {
      id_: n,
      legendId: `captions-window-${n}`,
      legendText: this.localize("Caption Area Background"),
      className: "vjs-window vjs-track-setting",
      selects: this.options_.fieldSets[2],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(a);
  }
  /**
   * Create the `TextTrackSettingsColors`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return st("div", {
      className: "vjs-track-settings-colors"
    });
  }
}
be.registerComponent("TextTrackSettingsColors", Ew);
class Dw extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */
  constructor(e, i = {}) {
    super(e, i);
    const n = this.options_.textTrackComponentid, s = new Zr(e, {
      id_: n,
      legendId: `captions-font-size-${n}`,
      legendText: "Font Size",
      className: "vjs-font-percent vjs-track-setting",
      selects: this.options_.fieldSets[0],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(s);
    const r = new Zr(e, {
      id_: n,
      legendId: `captions-edge-style-${n}`,
      legendText: this.localize("Text Edge Style"),
      className: "vjs-edge-style vjs-track-setting",
      selects: this.options_.fieldSets[1],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(r);
    const a = new Zr(e, {
      id_: n,
      legendId: `captions-font-family-${n}`,
      legendText: this.localize("Font Family"),
      className: "vjs-font-family vjs-track-setting",
      selects: this.options_.fieldSets[2],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(a);
  }
  /**
   * Create the `TextTrackSettingsFont`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return st("div", {
      className: "vjs-track-settings-font"
    });
  }
}
be.registerComponent("TextTrackSettingsFont", Dw);
class _w extends be {
  constructor(e, i = {}) {
    super(e, i);
    const n = this.localize("restore all settings to the default values"), s = new Hi(e, {
      controlText: n,
      className: "vjs-default-button"
    });
    s.el().classList.remove("vjs-control", "vjs-button"), s.el().textContent = this.localize("Reset"), this.addChild(s);
    const r = new Hi(e, {
      controlText: n,
      className: "vjs-done-button"
    });
    r.el().classList.remove("vjs-control", "vjs-button"), r.el().textContent = this.localize("Done"), this.addChild(r);
  }
  /**
   * Create the `TrackSettingsControls`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return st("div", {
      className: "vjs-track-settings-controls"
    });
  }
}
be.registerComponent("TrackSettingsControls", _w);
const Yf = "vjs-text-track-settings", wv = ["#000", "Black"], Tv = ["#00F", "Blue"], xv = ["#0FF", "Cyan"], Sv = ["#0F0", "Green"], Cv = ["#F0F", "Magenta"], Ev = ["#F00", "Red"], Dv = ["#FFF", "White"], _v = ["#FF0", "Yellow"], Xf = ["1", "Opaque"], jf = ["0.5", "Semi-Transparent"], kv = ["0", "Transparent"], lr = {
  backgroundColor: {
    selector: ".vjs-bg-color > select",
    id: "captions-background-color-%s",
    label: "Color",
    options: [wv, Dv, Ev, Sv, Tv, _v, Cv, xv],
    className: "vjs-bg-color"
  },
  backgroundOpacity: {
    selector: ".vjs-bg-opacity > select",
    id: "captions-background-opacity-%s",
    label: "Opacity",
    options: [Xf, jf, kv],
    className: "vjs-bg-opacity vjs-opacity"
  },
  color: {
    selector: ".vjs-text-color > select",
    id: "captions-foreground-color-%s",
    label: "Color",
    options: [Dv, wv, Ev, Sv, Tv, _v, Cv, xv],
    className: "vjs-text-color"
  },
  edgeStyle: {
    selector: ".vjs-edge-style > select",
    id: "",
    label: "Text Edge Style",
    options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Drop shadow"]]
  },
  fontFamily: {
    selector: ".vjs-font-family > select",
    id: "",
    label: "Font Family",
    options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
  },
  fontPercent: {
    selector: ".vjs-font-percent > select",
    id: "",
    label: "Font Size",
    options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
    default: 2,
    parser: (t) => t === "1.00" ? null : Number(t)
  },
  textOpacity: {
    selector: ".vjs-text-opacity > select",
    id: "captions-foreground-opacity-%s",
    label: "Opacity",
    options: [Xf, jf],
    className: "vjs-text-opacity vjs-opacity"
  },
  // Options for this object are defined below.
  windowColor: {
    selector: ".vjs-window-color > select",
    id: "captions-window-color-%s",
    label: "Color",
    className: "vjs-window-color"
  },
  // Options for this object are defined below.
  windowOpacity: {
    selector: ".vjs-window-opacity > select",
    id: "captions-window-opacity-%s",
    label: "Opacity",
    options: [kv, jf, Xf],
    className: "vjs-window-opacity vjs-opacity"
  }
};
lr.windowColor.options = lr.backgroundColor.options;
function kw(t, e) {
  if (e && (t = e(t)), t && t !== "none")
    return t;
}
function ez(t, e) {
  const i = t.options[t.options.selectedIndex].value;
  return kw(i, e);
}
function tz(t, e, i) {
  if (e) {
    for (let n = 0; n < t.options.length; n++)
      if (kw(t.options[n].value, i) === e) {
        t.selectedIndex = n;
        break;
      }
  }
}
class iz extends To {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */
  constructor(e, i) {
    i.temporary = !1, super(e, i), this.updateDisplay = this.updateDisplay.bind(this), this.fill(), this.hasBeenOpened_ = this.hasBeenFilled_ = !0, this.renderModalComponents(e), this.endDialog = st("p", {
      className: "vjs-control-text",
      textContent: this.localize("End of dialog window.")
    }), this.el().appendChild(this.endDialog), this.setDefaults(), i.persistTextTrackSettings === void 0 && (this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings), this.bindFunctionsToSelectsAndButtons(), this.options_.persistTextTrackSettings && this.restoreSettings();
  }
  renderModalComponents(e) {
    const i = new Ew(e, {
      textTrackComponentid: this.id_,
      selectConfigs: lr,
      fieldSets: [["color", "textOpacity"], ["backgroundColor", "backgroundOpacity"], ["windowColor", "windowOpacity"]]
    });
    this.addChild(i);
    const n = new Dw(e, {
      textTrackComponentid: this.id_,
      selectConfigs: lr,
      fieldSets: [["fontPercent"], ["edgeStyle"], ["fontFamily"]]
    });
    this.addChild(n);
    const s = new _w(e);
    this.addChild(s);
  }
  bindFunctionsToSelectsAndButtons() {
    this.on(this.$(".vjs-done-button"), ["click", "tap"], () => {
      this.saveSettings(), this.close();
    }), this.on(this.$(".vjs-default-button"), ["click", "tap"], () => {
      this.setDefaults(), this.updateDisplay();
    }), Ba(lr, (e) => {
      this.on(this.$(e.selector), "change", this.updateDisplay);
    });
  }
  dispose() {
    this.endDialog = null, super.dispose();
  }
  label() {
    return this.localize("Caption Settings Dialog");
  }
  description() {
    return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
  }
  buildCSSClass() {
    return super.buildCSSClass() + " vjs-text-track-settings";
  }
  /**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */
  getValues() {
    return yb(lr, (e, i, n) => {
      const s = ez(this.$(i.selector), i.parser);
      return s !== void 0 && (e[n] = s), e;
    }, {});
  }
  /**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */
  setValues(e) {
    Ba(lr, (i, n) => {
      tz(this.$(i.selector), e[n], i.parser);
    });
  }
  /**
   * Sets all `<select>` elements to their default values.
   */
  setDefaults() {
    Ba(lr, (e) => {
      const i = e.hasOwnProperty("default") ? e.default : 0;
      this.$(e.selector).selectedIndex = i;
    });
  }
  /**
   * Restore texttrack settings from localStorage
   */
  restoreSettings() {
    let e;
    try {
      e = JSON.parse(ne.localStorage.getItem(Yf));
    } catch (i) {
      pt.warn(i);
    }
    e && this.setValues(e);
  }
  /**
   * Save text track settings to localStorage
   */
  saveSettings() {
    if (!this.options_.persistTextTrackSettings)
      return;
    const e = this.getValues();
    try {
      Object.keys(e).length ? ne.localStorage.setItem(Yf, JSON.stringify(e)) : ne.localStorage.removeItem(Yf);
    } catch (i) {
      pt.warn(i);
    }
  }
  /**
   * Update display of text track settings
   */
  updateDisplay() {
    const e = this.player_.getChild("textTrackDisplay");
    e && e.updateDisplay();
  }
  /**
   * Repopulate dialog with new localizations on languagechange
   */
  handleLanguagechange() {
    this.fill(), this.renderModalComponents(this.player_), this.bindFunctionsToSelectsAndButtons();
  }
}
be.registerComponent("TextTrackSettings", iz);
class nz extends be {
  /**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */
  constructor(e, i) {
    let n = i.ResizeObserver || ne.ResizeObserver;
    i.ResizeObserver === null && (n = !1);
    const s = Bt({
      createEl: !n,
      reportTouchActivity: !1
    }, i);
    super(e, s), this.ResizeObserver = i.ResizeObserver || ne.ResizeObserver, this.loadListener_ = null, this.resizeObserver_ = null, this.debouncedHandler_ = qb(() => {
      this.resizeHandler();
    }, 100, !1, this), n ? (this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_), this.resizeObserver_.observe(e.el())) : (this.loadListener_ = () => {
      if (!this.el_ || !this.el_.contentWindow)
        return;
      const r = this.debouncedHandler_;
      let a = this.unloadListener_ = function() {
        qi(this, "resize", r), qi(this, "unload", a), a = null;
      };
      xn(this.el_.contentWindow, "unload", a), xn(this.el_.contentWindow, "resize", r);
    }, this.one("load", this.loadListener_));
  }
  createEl() {
    return super.createEl("iframe", {
      className: "vjs-resize-manager",
      tabIndex: -1,
      title: this.localize("No content")
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */
  resizeHandler() {
    !this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
  }
  dispose() {
    this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, super.dispose();
  }
}
be.registerComponent("ResizeManager", nz);
const sz = {
  trackingThreshold: 20,
  liveTolerance: 15
};
class rz extends be {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {number} [options.trackingThreshold=20]
   *        Number of seconds of live window (seekableEnd - seekableStart) that
   *        media needs to have before the liveui will be shown.
   *
   * @param {number} [options.liveTolerance=15]
   *        Number of seconds behind live that we have to be
   *        before we will be considered non-live. Note that this will only
   *        be used when playing at the live edge. This allows large seekable end
   *        changes to not effect whether we are live or not.
   */
  constructor(e, i) {
    const n = Bt(sz, i, {
      createEl: !1
    });
    super(e, n), this.trackLiveHandler_ = () => this.trackLive_(), this.handlePlay_ = (s) => this.handlePlay(s), this.handleFirstTimeupdate_ = (s) => this.handleFirstTimeupdate(s), this.handleSeeked_ = (s) => this.handleSeeked(s), this.seekToLiveEdge_ = (s) => this.seekToLiveEdge(s), this.reset_(), this.on(this.player_, "durationchange", (s) => this.handleDurationchange(s)), this.on(this.player_, "canplay", () => this.toggleTracking());
  }
  /**
   * all the functionality for tracking when seek end changes
   * and for tracking how far past seek end we should be
   */
  trackLive_() {
    const e = this.player_.seekable();
    if (!e || !e.length)
      return;
    const i = Number(ne.performance.now().toFixed(4)), n = this.lastTime_ === -1 ? 0 : (i - this.lastTime_) / 1e3;
    this.lastTime_ = i, this.pastSeekEnd_ = this.pastSeekEnd() + n;
    const s = this.liveCurrentTime(), r = this.player_.currentTime();
    let a = this.player_.paused() || this.seekedBehindLive_ || Math.abs(s - r) > this.options_.liveTolerance;
    (!this.timeupdateSeen_ || s === 1 / 0) && (a = !1), a !== this.behindLiveEdge_ && (this.behindLiveEdge_ = a, this.trigger("liveedgechange"));
  }
  /**
   * handle a durationchange event on the player
   * and start/stop tracking accordingly.
   */
  handleDurationchange() {
    this.toggleTracking();
  }
  /**
   * start/stop tracking
   */
  toggleTracking() {
    this.player_.duration() === 1 / 0 && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
  }
  /**
   * start tracking live playback
   */
  startTracking() {
    this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, Ln), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
  }
  /**
   * handle the first timeupdate on the player if it wasn't already playing
   * when live tracker started tracking.
   */
  handleFirstTimeupdate() {
    this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
  }
  /**
   * Keep track of what time a seek starts, and listen for seeked
   * to find where a seek ends.
   */
  handleSeeked() {
    const e = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
    this.seekedBehindLive_ = this.nextSeekedFromUser_ && e > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
  }
  /**
   * handle the first play on the player, and make sure that we seek
   * right to the live edge.
   */
  handlePlay() {
    this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
  }
  /**
   * Stop tracking, and set all internal variables to
   * their initial value.
   */
  reset_() {
    this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
  }
  /**
   * The next seeked event is from the user. Meaning that any seek
   * > 2s behind live will be considered behind live for real and
   * liveTolerance will be ignored.
   */
  nextSeekedFromUser() {
    this.nextSeekedFromUser_ = !0;
  }
  /**
   * stop tracking live playback
   */
  stopTracking() {
    this.isTracking() && (this.reset_(), this.trigger("liveedgechange"));
  }
  /**
   * A helper to get the player seekable end
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The furthest seekable end or Infinity.
   */
  seekableEnd() {
    const e = this.player_.seekable(), i = [];
    let n = e ? e.length : 0;
    for (; n--; )
      i.push(e.end(n));
    return i.length ? i.sort()[i.length - 1] : 1 / 0;
  }
  /**
   * A helper to get the player seekable start
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The earliest seekable start or 0.
   */
  seekableStart() {
    const e = this.player_.seekable(), i = [];
    let n = e ? e.length : 0;
    for (; n--; )
      i.push(e.start(n));
    return i.length ? i.sort()[0] : 0;
  }
  /**
   * Get the live time window aka
   * the amount of time between seekable start and
   * live current time.
   *
   * @return {number}
   *         The amount of seconds that are seekable in
   *         the live video.
   */
  liveWindow() {
    const e = this.liveCurrentTime();
    return e === 1 / 0 ? 0 : e - this.seekableStart();
  }
  /**
   * Determines if the player is live, only checks if this component
   * is tracking live playback or not
   *
   * @return {boolean}
   *         Whether liveTracker is tracking
   */
  isLive() {
    return this.isTracking();
  }
  /**
   * Determines if currentTime is at the live edge and won't fall behind
   * on each seekableendchange
   *
   * @return {boolean}
   *         Whether playback is at the live edge
   */
  atLiveEdge() {
    return !this.behindLiveEdge();
  }
  /**
   * get what we expect the live current time to be
   *
   * @return {number}
   *         The expected live current time
   */
  liveCurrentTime() {
    return this.pastSeekEnd() + this.seekableEnd();
  }
  /**
   * The number of seconds that have occurred after seekable end
   * changed. This will be reset to 0 once seekable end changes.
   *
   * @return {number}
   *         Seconds past the current seekable end
   */
  pastSeekEnd() {
    const e = this.seekableEnd();
    return this.lastSeekEnd_ !== -1 && e !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = e, this.pastSeekEnd_;
  }
  /**
   * If we are currently behind the live edge, aka currentTime will be
   * behind on a seekableendchange
   *
   * @return {boolean}
   *         If we are behind the live edge
   */
  behindLiveEdge() {
    return this.behindLiveEdge_;
  }
  /**
   * Whether live tracker is currently tracking or not.
   */
  isTracking() {
    return typeof this.trackingInterval_ == "number";
  }
  /**
   * Seek to the live edge if we are behind the live edge
   */
  seekToLiveEdge() {
    this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
  }
  /**
   * Dispose of liveTracker
   */
  dispose() {
    this.stopTracking(), super.dispose();
  }
}
be.registerComponent("LiveTracker", rz);
class az extends be {
  constructor(e, i) {
    super(e, i), this.on("statechanged", (n) => this.updateDom_()), this.updateDom_();
  }
  /**
   * Create the `TitleBar`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return this.els = {
      title: st("div", {
        className: "vjs-title-bar-title",
        id: `vjs-title-bar-title-${Bn()}`
      }),
      description: st("div", {
        className: "vjs-title-bar-description",
        id: `vjs-title-bar-description-${Bn()}`
      })
    }, st("div", {
      className: "vjs-title-bar"
    }, {}, bb(this.els));
  }
  /**
   * Updates the DOM based on the component's state object.
   */
  updateDom_() {
    const e = this.player_.tech_, i = e && e.el_, n = {
      title: "aria-labelledby",
      description: "aria-describedby"
    };
    ["title", "description"].forEach((s) => {
      const r = this.state[s], a = this.els[s], o = n[s];
      dc(a), r && Sr(a, r), i && (i.removeAttribute(o), r && i.setAttribute(o, a.id));
    }), this.state.title || this.state.description ? this.show() : this.hide();
  }
  /**
   * Update the contents of the title bar component with new title and
   * description text.
   *
   * If both title and description are missing, the title bar will be hidden.
   *
   * If either title or description are present, the title bar will be visible.
   *
   * NOTE: Any previously set value will be preserved. To unset a previously
   * set value, you must pass an empty string or null.
   *
   * For example:
   *
   * ```
   * update({title: 'foo', description: 'bar'}) // title: 'foo', description: 'bar'
   * update({description: 'bar2'}) // title: 'foo', description: 'bar2'
   * update({title: ''}) // title: '', description: 'bar2'
   * update({title: 'foo', description: null}) // title: 'foo', description: null
   * ```
   *
   * @param  {Object} [options={}]
   *         An options object. When empty, the title bar will be hidden.
   *
   * @param  {string} [options.title]
   *         A title to display in the title bar.
   *
   * @param  {string} [options.description]
   *         A description to display in the title bar.
   */
  update(e) {
    this.setState(e);
  }
  /**
   * Dispose the component.
   */
  dispose() {
    const e = this.player_.tech_, i = e && e.el_;
    i && (i.removeAttribute("aria-labelledby"), i.removeAttribute("aria-describedby")), super.dispose(), this.els = null;
  }
}
be.registerComponent("TitleBar", az);
const oz = {
  initialDisplay: 4e3,
  position: [],
  takeFocus: !1
};
class lz extends Hi {
  /**
   * TransientButton constructor
   *
   * @param {Player} player The button's player
   * @param {TransientButtonOptions} options Options for the transient button
   */
  constructor(e, i) {
    i = Bt(oz, i), super(e, i), this.controlText(i.controlText), this.hide(), this.on(this.player_, ["useractive", "userinactive"], (n) => {
      this.removeClass("force-display");
    });
  }
  /**
   * Return CSS class including position classes
   *
   * @return {string} CSS class list
   */
  buildCSSClass() {
    return `vjs-transient-button focus-visible ${this.options_.position.map((e) => `vjs-${e}`).join(" ")}`;
  }
  /**
   * Create the button element
   *
   * @return {HTMLButtonElement} The button element
   */
  createEl() {
    const e = st("button", {}, {
      type: "button",
      class: this.buildCSSClass()
    }, st("span"));
    return this.controlTextEl_ = e.querySelector("span"), e;
  }
  /**
   * Show the button. The button will remain visible for the `initialDisplay` time, default 4s,
   * and when there is user activity.
   */
  show() {
    super.show(), this.addClass("force-display"), this.options_.takeFocus && this.el().focus({
      preventScroll: !0
    }), this.forceDisplayTimeout = this.player_.setTimeout(() => {
      this.removeClass("force-display");
    }, this.options_.initialDisplay);
  }
  /**
   * Hide the display, even if during the `initialDisplay` time.
   */
  hide() {
    this.removeClass("force-display"), super.hide();
  }
  /**
   * Dispose the component
   */
  dispose() {
    this.player_.clearTimeout(this.forceDisplayTimeout), super.dispose();
  }
}
be.registerComponent("TransientButton", lz);
const Oh = (t) => {
  const e = t.el();
  if (e.hasAttribute("src"))
    return t.triggerSourceset(e.src), !0;
  const i = t.$$("source"), n = [];
  let s = "";
  if (!i.length)
    return !1;
  for (let r = 0; r < i.length; r++) {
    const a = i[r].src;
    a && n.indexOf(a) === -1 && n.push(a);
  }
  return n.length ? (n.length === 1 && (s = n[0]), t.triggerSourceset(s), !0) : !1;
}, uz = Object.defineProperty({}, "innerHTML", {
  get() {
    return this.cloneNode(!0).innerHTML;
  },
  set(t) {
    const e = Ne.createElement(this.nodeName.toLowerCase());
    e.innerHTML = t;
    const i = Ne.createDocumentFragment();
    for (; e.childNodes.length; )
      i.appendChild(e.childNodes[0]);
    return this.innerText = "", ne.Element.prototype.appendChild.call(this, i), this.innerHTML;
  }
}), Pw = (t, e) => {
  let i = {};
  for (let n = 0; n < t.length && (i = Object.getOwnPropertyDescriptor(t[n], e), !(i && i.set && i.get)); n++)
    ;
  return i.enumerable = !0, i.configurable = !0, i;
}, dz = (t) => Pw([t.el(), ne.HTMLMediaElement.prototype, ne.Element.prototype, uz], "innerHTML"), Pv = function(t) {
  const e = t.el();
  if (e.resetSourceWatch_)
    return;
  const i = {}, n = dz(t), s = (r) => (...a) => {
    const o = r.apply(e, a);
    return Oh(t), o;
  };
  ["append", "appendChild", "insertAdjacentHTML"].forEach((r) => {
    e[r] && (i[r] = e[r], e[r] = s(i[r]));
  }), Object.defineProperty(e, "innerHTML", Bt(n, {
    set: s(n.set)
  })), e.resetSourceWatch_ = () => {
    e.resetSourceWatch_ = null, Object.keys(i).forEach((r) => {
      e[r] = i[r];
    }), Object.defineProperty(e, "innerHTML", n);
  }, t.one("sourceset", e.resetSourceWatch_);
}, cz = Object.defineProperty({}, "src", {
  get() {
    return this.hasAttribute("src") ? Jb(ne.Element.prototype.getAttribute.call(this, "src")) : "";
  },
  set(t) {
    return ne.Element.prototype.setAttribute.call(this, "src", t), t;
  }
}), fz = (t) => Pw([t.el(), ne.HTMLMediaElement.prototype, cz], "src"), hz = function(t) {
  if (!t.featuresSourceset)
    return;
  const e = t.el();
  if (e.resetSourceset_)
    return;
  const i = fz(t), n = e.setAttribute, s = e.load;
  Object.defineProperty(e, "src", Bt(i, {
    set: (r) => {
      const a = i.set.call(e, r);
      return t.triggerSourceset(e.src), a;
    }
  })), e.setAttribute = (r, a) => {
    const o = n.call(e, r, a);
    return /src/i.test(r) && t.triggerSourceset(e.src), o;
  }, e.load = () => {
    const r = s.call(e);
    return Oh(t) || (t.triggerSourceset(""), Pv(t)), r;
  }, e.currentSrc ? t.triggerSourceset(e.currentSrc) : Oh(t) || Pv(t), e.resetSourceset_ = () => {
    e.resetSourceset_ = null, e.load = s, e.setAttribute = n, Object.defineProperty(e, "src", i), e.resetSourceWatch_ && e.resetSourceWatch_();
  };
};
class Ye extends ft {
  /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */
  constructor(e, i) {
    super(e, i);
    const n = e.source;
    let s = !1;
    if (this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === "VIDEO", n && (this.el_.currentSrc !== n.src || e.tag && e.tag.initNetworkState_ === 3) ? this.setSource(n) : this.handleLateInit_(this.el_), e.enableSourceset && this.setupSourcesetHandling_(), this.isScrubbing_ = !1, this.el_.hasChildNodes()) {
      const r = this.el_.childNodes;
      let a = r.length;
      const o = [];
      for (; a--; ) {
        const l = r[a];
        l.nodeName.toLowerCase() === "track" && (this.featuresNativeTextTracks ? (this.remoteTextTrackEls().addTrackElement_(l), this.remoteTextTracks().addTrack(l.track), this.textTracks().addTrack(l.track), !s && !this.el_.hasAttribute("crossorigin") && pc(l.src) && (s = !0)) : o.push(l));
      }
      for (let l = 0; l < o.length; l++)
        this.el_.removeChild(o[l]);
    }
    this.proxyNativeTracks_(), this.featuresNativeTextTracks && s && pt.warn(`Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.
This may prevent text tracks from loading.`), this.restoreMetadataTracksInIOSNativePlayer_(), (kl || rc) && e.nativeControlsForTouch === !0 && this.setControls(!0), this.proxyWebkitFullscreen_(), this.triggerReady();
  }
  /**
   * Dispose of `HTML5` media element and remove all tracks.
   */
  dispose() {
    this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), Ye.disposeMediaElement(this.el_), this.options_ = null, super.dispose();
  }
  /**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */
  setupSourcesetHandling_() {
    hz(this);
  }
  /**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */
  restoreMetadataTracksInIOSNativePlayer_() {
    const e = this.textTracks();
    let i;
    const n = () => {
      i = [];
      for (let r = 0; r < e.length; r++) {
        const a = e[r];
        a.kind === "metadata" && i.push({
          track: a,
          storedMode: a.mode
        });
      }
    };
    n(), e.addEventListener("change", n), this.on("dispose", () => e.removeEventListener("change", n));
    const s = () => {
      for (let r = 0; r < i.length; r++) {
        const a = i[r];
        a.track.mode === "disabled" && a.track.mode !== a.storedMode && (a.track.mode = a.storedMode);
      }
      e.removeEventListener("change", s);
    };
    this.on("webkitbeginfullscreen", () => {
      e.removeEventListener("change", n), e.removeEventListener("change", s), e.addEventListener("change", s);
    }), this.on("webkitendfullscreen", () => {
      e.removeEventListener("change", n), e.addEventListener("change", n), e.removeEventListener("change", s);
    });
  }
  /**
   * Attempt to force override of tracks for the given type
   *
   * @param {string} type - Track type to override, possible values include 'Audio',
   * 'Video', and 'Text'.
   * @param {boolean} override - If set to true native audio/video will be overridden,
   * otherwise native audio/video will potentially be used.
   * @private
   */
  overrideNative_(e, i) {
    if (i !== this[`featuresNative${e}Tracks`])
      return;
    const n = e.toLowerCase();
    this[`${n}TracksListeners_`] && Object.keys(this[`${n}TracksListeners_`]).forEach((s) => {
      this.el()[`${n}Tracks`].removeEventListener(s, this[`${n}TracksListeners_`][s]);
    }), this[`featuresNative${e}Tracks`] = !i, this[`${n}TracksListeners_`] = null, this.proxyNativeTracksForType_(n);
  }
  /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   */
  overrideNativeAudioTracks(e) {
    this.overrideNative_("Audio", e);
  }
  /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   */
  overrideNativeVideoTracks(e) {
    this.overrideNative_("Video", e);
  }
  /**
   * Proxy native track list events for the given type to our track
   * lists if the browser we are playing in supports that type of track list.
   *
   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
   * @private
   */
  proxyNativeTracksForType_(e) {
    const i = On[e], n = this.el()[i.getterName], s = this[i.getterName]();
    if (!this[`featuresNative${i.capitalName}Tracks`] || !n || !n.addEventListener)
      return;
    const r = {
      change: (o) => {
        const l = {
          type: "change",
          target: s,
          currentTarget: s,
          srcElement: s
        };
        s.trigger(l), e === "text" && this[ho.remoteText.getterName]().trigger(l);
      },
      addtrack(o) {
        s.addTrack(o.track);
      },
      removetrack(o) {
        s.removeTrack(o.track);
      }
    }, a = function() {
      const o = [];
      for (let l = 0; l < s.length; l++) {
        let u = !1;
        for (let d = 0; d < n.length; d++)
          if (n[d] === s[l]) {
            u = !0;
            break;
          }
        u || o.push(s[l]);
      }
      for (; o.length; )
        s.removeTrack(o.shift());
    };
    this[i.getterName + "Listeners_"] = r, Object.keys(r).forEach((o) => {
      const l = r[o];
      n.addEventListener(o, l), this.on("dispose", (u) => n.removeEventListener(o, l));
    }), this.on("loadstart", a), this.on("dispose", (o) => this.off("loadstart", a));
  }
  /**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */
  proxyNativeTracks_() {
    On.names.forEach((e) => {
      this.proxyNativeTracksForType_(e);
    });
  }
  /**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    let e = this.options_.tag;
    if (!e || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
      if (e) {
        const n = e.cloneNode(!0);
        e.parentNode && e.parentNode.insertBefore(n, e), Ye.disposeMediaElement(e), e = n;
      } else {
        e = Ne.createElement("video");
        const n = this.options_.tag && or(this.options_.tag), s = Bt({}, n);
        (!kl || this.options_.nativeControlsForTouch !== !0) && delete s.controls, kb(e, Object.assign(s, {
          id: this.options_.techId,
          class: "vjs-tech"
        }));
      }
      e.playerId = this.options_.playerId;
    }
    typeof this.options_.preload < "u" && lo(e, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (e.disablePictureInPicture = this.options_.disablePictureInPicture);
    const i = ["loop", "muted", "playsinline", "autoplay"];
    for (let n = 0; n < i.length; n++) {
      const s = i[n], r = this.options_[s];
      typeof r < "u" && (r ? lo(e, s, s) : lc(e, s), e[s] = r);
    }
    return e;
  }
  /**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */
  handleLateInit_(e) {
    if (e.networkState === 0 || e.networkState === 3)
      return;
    if (e.readyState === 0) {
      let n = !1;
      const s = function() {
        n = !0;
      };
      this.on("loadstart", s);
      const r = function() {
        n || this.trigger("loadstart");
      };
      this.on("loadedmetadata", r), this.ready(function() {
        this.off("loadstart", s), this.off("loadedmetadata", r), n || this.trigger("loadstart");
      });
      return;
    }
    const i = ["loadstart"];
    i.push("loadedmetadata"), e.readyState >= 2 && i.push("loadeddata"), e.readyState >= 3 && i.push("canplay"), e.readyState >= 4 && i.push("canplaythrough"), this.ready(function() {
      i.forEach(function(n) {
        this.trigger(n);
      }, this);
    });
  }
  /**
   * Set whether we are scrubbing or not.
   * This is used to decide whether we should use `fastSeek` or not.
   * `fastSeek` is used to provide trick play on Safari browsers.
   *
   * @param {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */
  setScrubbing(e) {
    this.isScrubbing_ = e;
  }
  /**
   * Get whether we are scrubbing or not.
   *
   * @return {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */
  scrubbing() {
    return this.isScrubbing_;
  }
  /**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */
  setCurrentTime(e) {
    try {
      this.isScrubbing_ && this.el_.fastSeek && ac ? this.el_.fastSeek(e) : this.el_.currentTime = e;
    } catch (i) {
      pt(i, "Video is not ready. (Video.js)");
    }
  }
  /**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */
  duration() {
    if (this.el_.duration === 1 / 0 && rs && _s && this.el_.currentTime === 0) {
      const e = () => {
        this.el_.currentTime > 0 && (this.el_.duration === 1 / 0 && this.trigger("durationchange"), this.off("timeupdate", e));
      };
      return this.on("timeupdate", e), NaN;
    }
    return this.el_.duration || NaN;
  }
  /**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */
  width() {
    return this.el_.offsetWidth;
  }
  /**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The height of the HTML5 media element.
   */
  height() {
    return this.el_.offsetHeight;
  }
  /**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */
  proxyWebkitFullscreen_() {
    if (!("webkitDisplayingFullscreen" in this.el_))
      return;
    const e = function() {
      this.trigger("fullscreenchange", {
        isFullscreen: !1
      }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
    }, i = function() {
      "webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", e), this.trigger("fullscreenchange", {
        isFullscreen: !0,
        // set a flag in case another tech triggers fullscreenchange
        nativeIOSFullscreen: !0
      }));
    };
    this.on("webkitbeginfullscreen", i), this.on("dispose", () => {
      this.off("webkitbeginfullscreen", i), this.off("webkitendfullscreen", e);
    });
  }
  /**
   * Check if fullscreen is supported on the video el.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */
  supportsFullScreen() {
    return typeof this.el_.webkitEnterFullScreen == "function";
  }
  /**
   * Request that the `HTML5` Tech enter fullscreen.
   */
  enterFullScreen() {
    const e = this.el_;
    if (e.paused && e.networkState <= e.HAVE_METADATA)
      vs(this.el_.play()), this.setTimeout(function() {
        e.pause();
        try {
          e.webkitEnterFullScreen();
        } catch (i) {
          this.trigger("fullscreenerror", i);
        }
      }, 0);
    else
      try {
        e.webkitEnterFullScreen();
      } catch (i) {
        this.trigger("fullscreenerror", i);
      }
  }
  /**
   * Request that the `HTML5` Tech exit fullscreen.
   */
  exitFullScreen() {
    if (!this.el_.webkitDisplayingFullscreen) {
      this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
      return;
    }
    this.el_.webkitExitFullScreen();
  }
  /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */
  requestPictureInPicture() {
    return this.el_.requestPictureInPicture();
  }
  /**
   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
   * Needs to be checked later than the constructor
   * This will be a false positive for clear sources loaded after a Fairplay source
   *
   * @param {function} cb function to call
   * @return {number} id of request
   */
  requestVideoFrameCallback(e) {
    return this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.requestVideoFrameCallback(e) : super.requestVideoFrameCallback(e);
  }
  /**
   * Native or fallback requestVideoFrameCallback
   *
   * @param {number} id request id to cancel
   */
  cancelVideoFrameCallback(e) {
    this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.cancelVideoFrameCallback(e) : super.cancelVideoFrameCallback(e);
  }
  /**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */
  src(e) {
    if (e === void 0)
      return this.el_.src;
    this.setSrc(e);
  }
  /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */
  addSourceElement(e, i) {
    if (!e)
      return pt.error("Invalid source URL."), !1;
    const n = {
      src: e
    };
    i && (n.type = i);
    const s = st("source", {}, n);
    return this.el_.appendChild(s), !0;
  }
  /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */
  removeSourceElement(e) {
    if (!e)
      return pt.error("Source URL is required to remove the source element."), !1;
    const i = this.el_.querySelectorAll("source");
    for (const n of i)
      if (n.src === e)
        return this.el_.removeChild(n), !0;
    return pt.warn(`No matching source element found with src: ${e}`), !1;
  }
  /**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */
  reset() {
    Ye.resetMediaElement(this.el_);
  }
  /**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */
  currentSrc() {
    return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
  }
  /**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */
  setControls(e) {
    this.el_.controls = !!e;
  }
  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */
  addTextTrack(e, i, n) {
    return this.featuresNativeTextTracks ? this.el_.addTextTrack(e, i, n) : super.addTextTrack(e, i, n);
  }
  /**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label]
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */
  createRemoteTextTrack(e) {
    if (!this.featuresNativeTextTracks)
      return super.createRemoteTextTrack(e);
    const i = Ne.createElement("track");
    return e.kind && (i.kind = e.kind), e.label && (i.label = e.label), (e.language || e.srclang) && (i.srclang = e.language || e.srclang), e.default && (i.default = e.default), e.id && (i.id = e.id), e.src && (i.src = e.src), i;
  }
  /**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack
   * will not be removed from the TextTrackList and HtmlTrackElementList
   * after a source change
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   */
  addRemoteTextTrack(e, i) {
    const n = super.addRemoteTextTrack(e, i);
    return this.featuresNativeTextTracks && this.el().appendChild(n), n;
  }
  /**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */
  removeRemoteTextTrack(e) {
    if (super.removeRemoteTextTrack(e), this.featuresNativeTextTracks) {
      const i = this.$$("track");
      let n = i.length;
      for (; n--; )
        (e === i[n] || e === i[n].track) && this.el().removeChild(i[n]);
    }
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */
  getVideoPlaybackQuality() {
    if (typeof this.el().getVideoPlaybackQuality == "function")
      return this.el().getVideoPlaybackQuality();
    const e = {};
    return typeof this.el().webkitDroppedFrameCount < "u" && typeof this.el().webkitDecodedFrameCount < "u" && (e.droppedVideoFrames = this.el().webkitDroppedFrameCount, e.totalVideoFrames = this.el().webkitDecodedFrameCount), ne.performance && (e.creationTime = ne.performance.now()), e;
  }
}
ic(Ye, "TEST_VID", function() {
  if (!yo())
    return;
  const t = Ne.createElement("video"), e = Ne.createElement("track");
  return e.kind = "captions", e.srclang = "en", e.label = "English", t.appendChild(e), t;
});
Ye.isSupported = function() {
  try {
    Ye.TEST_VID.volume = 0.5;
  } catch {
    return !1;
  }
  return !!(Ye.TEST_VID && Ye.TEST_VID.canPlayType);
};
Ye.canPlayType = function(t) {
  return Ye.TEST_VID.canPlayType(t);
};
Ye.canPlaySource = function(t, e) {
  return Ye.canPlayType(t.type);
};
Ye.canControlVolume = function() {
  try {
    const t = Ye.TEST_VID.volume;
    Ye.TEST_VID.volume = t / 2 + 0.1;
    const e = t !== Ye.TEST_VID.volume;
    return e && Vi ? (ne.setTimeout(() => {
      Ye && Ye.prototype && (Ye.prototype.featuresVolumeControl = t !== Ye.TEST_VID.volume);
    }), !1) : e;
  } catch {
    return !1;
  }
};
Ye.canMuteVolume = function() {
  try {
    const t = Ye.TEST_VID.muted;
    return Ye.TEST_VID.muted = !t, Ye.TEST_VID.muted ? lo(Ye.TEST_VID, "muted", "muted") : lc(Ye.TEST_VID, "muted", "muted"), t !== Ye.TEST_VID.muted;
  } catch {
    return !1;
  }
};
Ye.canControlPlaybackRate = function() {
  if (rs && _s && nc < 58)
    return !1;
  try {
    const t = Ye.TEST_VID.playbackRate;
    return Ye.TEST_VID.playbackRate = t / 2 + 0.1, t !== Ye.TEST_VID.playbackRate;
  } catch {
    return !1;
  }
};
Ye.canOverrideAttributes = function() {
  try {
    const t = () => {
    };
    Object.defineProperty(Ne.createElement("video"), "src", {
      get: t,
      set: t
    }), Object.defineProperty(Ne.createElement("audio"), "src", {
      get: t,
      set: t
    }), Object.defineProperty(Ne.createElement("video"), "innerHTML", {
      get: t,
      set: t
    }), Object.defineProperty(Ne.createElement("audio"), "innerHTML", {
      get: t,
      set: t
    });
  } catch {
    return !1;
  }
  return !0;
};
Ye.supportsNativeTextTracks = function() {
  return ac || Vi && _s;
};
Ye.supportsNativeVideoTracks = function() {
  return !!(Ye.TEST_VID && Ye.TEST_VID.videoTracks);
};
Ye.supportsNativeAudioTracks = function() {
  return !!(Ye.TEST_VID && Ye.TEST_VID.audioTracks);
};
Ye.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"];
[["featuresMuteControl", "canMuteVolume"], ["featuresPlaybackRate", "canControlPlaybackRate"], ["featuresSourceset", "canOverrideAttributes"], ["featuresNativeTextTracks", "supportsNativeTextTracks"], ["featuresNativeVideoTracks", "supportsNativeVideoTracks"], ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]].forEach(function([t, e]) {
  ic(Ye.prototype, t, () => Ye[e](), !0);
});
Ye.prototype.featuresVolumeControl = Ye.canControlVolume();
Ye.prototype.movingMediaElementInDOM = !Vi;
Ye.prototype.featuresFullscreenResize = !0;
Ye.prototype.featuresProgressEvents = !0;
Ye.prototype.featuresTimeupdateEvents = !0;
Ye.prototype.featuresVideoFrameCallback = !!(Ye.TEST_VID && Ye.TEST_VID.requestVideoFrameCallback);
Ye.disposeMediaElement = function(t) {
  if (t) {
    for (t.parentNode && t.parentNode.removeChild(t); t.hasChildNodes(); )
      t.removeChild(t.firstChild);
    t.removeAttribute("src"), typeof t.load == "function" && function() {
      try {
        t.load();
      } catch {
      }
    }();
  }
};
Ye.resetMediaElement = function(t) {
  if (!t)
    return;
  const e = t.querySelectorAll("source");
  let i = e.length;
  for (; i--; )
    t.removeChild(e[i]);
  t.removeAttribute("src"), typeof t.load == "function" && function() {
    try {
      t.load();
    } catch {
    }
  }();
};
[
  /**
   * Get the value of `muted` from the media element. `muted` indicates
   * that the volume for the media should be set to silent. This does not actually change
   * the `volume` attribute.
   *
   * @method Html5#muted
   * @return {boolean}
   *         - True if the value of `volume` should be ignored and the audio set to silent.
   *         - False if the value of `volume` should be used.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
   * whether the media should start muted or not. Only changes the default state of the
   * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
   * current state.
   *
   * @method Html5#defaultMuted
   * @return {boolean}
   *         - The value of `defaultMuted` from the media element.
   *         - True indicates that the media should start muted.
   *         - False indicates that the media should not start muted
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Get the value of `autoplay` from the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#autoplay
   * @return {boolean}
   *         - The value of `autoplay` from the media element.
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Get the value of `controls` from the media element. `controls` indicates
   * whether the native media controls should be shown or hidden.
   *
   * @method Html5#controls
   * @return {boolean}
   *         - The value of `controls` from the media element.
   *         - True indicates that native controls should be showing.
   *         - False indicates that native controls should be hidden.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
   */
  "controls",
  /**
   * Get the value of `loop` from the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#loop
   * @return {boolean}
   *         - The value of `loop` from the media element.
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Get the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#playsinline
   * @return {boolean}
   *         - The value of `playsinline` from the media element.
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(t) {
  Ye.prototype[t] = function() {
    return this.el_[t] || this.el_.hasAttribute(t);
  };
});
[
  /**
   * Set the value of `muted` on the media element. `muted` indicates that the current
   * audio level should be silent.
   *
   * @method Html5#setMuted
   * @param {boolean} muted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
   * audio level should be silent, but will only effect the muted level on initial playback..
   *
   * @method Html5.prototype.setDefaultMuted
   * @param {boolean} defaultMuted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Set the value of `autoplay` on the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#setAutoplay
   * @param {boolean} autoplay
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Set the value of `loop` on the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#setLoop
   * @param {boolean} loop
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Set the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#setPlaysinline
   * @param {boolean} playsinline
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(t) {
  Ye.prototype["set" + oi(t)] = function(e) {
    this.el_[t] = e, e ? this.el_.setAttribute(t, t) : this.el_.removeAttribute(t);
  };
});
[
  /**
   * Get the value of `paused` from the media element. `paused` indicates whether the media element
   * is currently paused or not.
   *
   * @method Html5#paused
   * @return {boolean}
   *         The value of `paused` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
   */
  "paused",
  /**
   * Get the value of `currentTime` from the media element. `currentTime` indicates
   * the current second that the media is at in playback.
   *
   * @method Html5#currentTime
   * @return {number}
   *         The value of `currentTime` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
   */
  "currentTime",
  /**
   * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
   * object that represents the parts of the media that are already downloaded and
   * available for playback.
   *
   * @method Html5#buffered
   * @return {TimeRange}
   *         The value of `buffered` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
   */
  "buffered",
  /**
   * Get the value of `volume` from the media element. `volume` indicates
   * the current playback volume of audio for a media. `volume` will be a value from 0
   * (silent) to 1 (loudest and default).
   *
   * @method Html5#volume
   * @return {number}
   *         The value of `volume` from the media element. Value will be between 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Get the value of `poster` from the media element. `poster` indicates
   * that the url of an image file that can/will be shown when no media data is available.
   *
   * @method Html5#poster
   * @return {string}
   *         The value of `poster` from the media element. Value will be a url to an
   *         image.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
   */
  "poster",
  /**
   * Get the value of `preload` from the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#preload
   * @return {string}
   *         The value of `preload` from the media element. Will be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Get the value of the `error` from the media element. `error` indicates any
   * MediaError that may have occurred during playback. If error returns null there is no
   * current error.
   *
   * @method Html5#error
   * @return {MediaError|null}
   *         The value of `error` from the media element. Will be `MediaError` if there
   *         is a current error and null otherwise.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
   */
  "error",
  /**
   * Get the value of `seeking` from the media element. `seeking` indicates whether the
   * media is currently seeking to a new position or not.
   *
   * @method Html5#seeking
   * @return {boolean}
   *         - The value of `seeking` from the media element.
   *         - True indicates that the media is currently seeking to a new position.
   *         - False indicates that the media is not seeking to a new position at this time.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
   */
  "seeking",
  /**
   * Get the value of `seekable` from the media element. `seekable` returns a
   * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
   *
   * @method Html5#seekable
   * @return {TimeRange}
   *         The value of `seekable` from the media element. A `TimeRange` object
   *         indicating the current ranges of time that can be seeked to.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
   */
  "seekable",
  /**
   * Get the value of `ended` from the media element. `ended` indicates whether
   * the media has reached the end or not.
   *
   * @method Html5#ended
   * @return {boolean}
   *         - The value of `ended` from the media element.
   *         - True indicates that the media has ended.
   *         - False indicates that the media has not ended.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
   */
  "ended",
  /**
   * Get the value of `playbackRate` from the media element. `playbackRate` indicates
   * the rate at which the media is currently playing back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#playbackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
   * the rate at which the media is currently playing back. This value will not indicate the current
   * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
   *
   * Examples:
   *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
   *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.defaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "defaultPlaybackRate",
  /**
   * Get the value of 'disablePictureInPicture' from the video element.
   *
   * @method Html5#disablePictureInPicture
   * @return {boolean} value
   *         - The value of `disablePictureInPicture` from the video element.
   *         - True indicates that the video can't be played in Picture-In-Picture mode
   *         - False indicates that the video can be played in Picture-In-Picture mode
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Get the value of `played` from the media element. `played` returns a `TimeRange`
   * object representing points in the media timeline that have been played.
   *
   * @method Html5#played
   * @return {TimeRange}
   *         The value of `played` from the media element. A `TimeRange` object indicating
   *         the ranges of time that have been played.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
   */
  "played",
  /**
   * Get the value of `networkState` from the media element. `networkState` indicates
   * the current network state. It returns an enumeration from the following list:
   * - 0: NETWORK_EMPTY
   * - 1: NETWORK_IDLE
   * - 2: NETWORK_LOADING
   * - 3: NETWORK_NO_SOURCE
   *
   * @method Html5#networkState
   * @return {number}
   *         The value of `networkState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
   */
  "networkState",
  /**
   * Get the value of `readyState` from the media element. `readyState` indicates
   * the current state of the media element. It returns an enumeration from the
   * following list:
   * - 0: HAVE_NOTHING
   * - 1: HAVE_METADATA
   * - 2: HAVE_CURRENT_DATA
   * - 3: HAVE_FUTURE_DATA
   * - 4: HAVE_ENOUGH_DATA
   *
   * @method Html5#readyState
   * @return {number}
   *         The value of `readyState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
   */
  "readyState",
  /**
   * Get the value of `videoWidth` from the video element. `videoWidth` indicates
   * the current width of the video in css pixels.
   *
   * @method Html5#videoWidth
   * @return {number}
   *         The value of `videoWidth` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoWidth",
  /**
   * Get the value of `videoHeight` from the video element. `videoHeight` indicates
   * the current height of the video in css pixels.
   *
   * @method Html5#videoHeight
   * @return {number}
   *         The value of `videoHeight` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoHeight",
  /**
   * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#crossOrigin
   * @return {string}
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(t) {
  Ye.prototype[t] = function() {
    return this.el_[t];
  };
});
[
  /**
   * Set the value of `volume` on the media element. `volume` indicates the current
   * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
   * so on.
   *
   * @method Html5#setVolume
   * @param {number} percentAsDecimal
   *        The volume percent as a decimal. Valid range is from 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Set the value of `src` on the media element. `src` indicates the current
   * {@link Tech~SourceObject} for the media.
   *
   * @method Html5#setSrc
   * @param {Tech~SourceObject} src
   *        The source object to set as the current source.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
   */
  "src",
  /**
   * Set the value of `poster` on the media element. `poster` is the url to
   * an image file that can/will be shown when no media data is available.
   *
   * @method Html5#setPoster
   * @param {string} poster
   *        The url to an image that should be used as the `poster` for the media
   *        element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
   */
  "poster",
  /**
   * Set the value of `preload` on the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#setPreload
   * @param {string} preload
   *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Set the value of `playbackRate` on the media element. `playbackRate` indicates
   * the rate at which the media should play back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#setPlaybackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
   * the rate at which the media should play back upon initial startup. Changing this value
   * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
   *
   * Example Values:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.setDefaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
   */
  "defaultPlaybackRate",
  /**
   * Prevents the browser from suggesting a Picture-in-Picture context menu
   * or to request Picture-in-Picture automatically in some cases.
   *
   * @method Html5#setDisablePictureInPicture
   * @param {boolean} value
   *         The true value will disable Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#setCrossOrigin
   * @param {string} crossOrigin
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(t) {
  Ye.prototype["set" + oi(t)] = function(e) {
    this.el_[t] = e;
  };
});
[
  /**
   * A wrapper around the media elements `pause` function. This will call the `HTML5`
   * media elements `pause` function.
   *
   * @method Html5#pause
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
   */
  "pause",
  /**
   * A wrapper around the media elements `load` function. This will call the `HTML5`s
   * media element `load` function.
   *
   * @method Html5#load
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
   */
  "load",
  /**
   * A wrapper around the media elements `play` function. This will call the `HTML5`s
   * media element `play` function.
   *
   * @method Html5#play
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
   */
  "play"
].forEach(function(t) {
  Ye.prototype[t] = function() {
    return this.el_[t]();
  };
});
ft.withSourceHandlers(Ye);
Ye.nativeSourceHandler = {};
Ye.nativeSourceHandler.canPlayType = function(t) {
  try {
    return Ye.TEST_VID.canPlayType(t);
  } catch {
    return "";
  }
};
Ye.nativeSourceHandler.canHandleSource = function(t, e) {
  if (t.type)
    return Ye.nativeSourceHandler.canPlayType(t.type);
  if (t.src) {
    const i = em(t.src);
    return Ye.nativeSourceHandler.canPlayType(`video/${i}`);
  }
  return "";
};
Ye.nativeSourceHandler.handleSource = function(t, e, i) {
  e.setSrc(t.src);
};
Ye.nativeSourceHandler.dispose = function() {
};
Ye.registerSourceHandler(Ye.nativeSourceHandler);
ft.registerTech("Html5", Ye);
const Iw = [
  /**
   * Fired while the user agent is downloading media data.
   *
   * @event Player#progress
   * @type {Event}
   */
  /**
   * Retrigger the `progress` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechProgress_
   * @fires Player#progress
   * @listens Tech#progress
   */
  "progress",
  /**
   * Fires when the loading of an audio/video is aborted.
   *
   * @event Player#abort
   * @type {Event}
   */
  /**
   * Retrigger the `abort` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechAbort_
   * @fires Player#abort
   * @listens Tech#abort
   */
  "abort",
  /**
   * Fires when the browser is intentionally not getting media data.
   *
   * @event Player#suspend
   * @type {Event}
   */
  /**
   * Retrigger the `suspend` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechSuspend_
   * @fires Player#suspend
   * @listens Tech#suspend
   */
  "suspend",
  /**
   * Fires when the current playlist is empty.
   *
   * @event Player#emptied
   * @type {Event}
   */
  /**
   * Retrigger the `emptied` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechEmptied_
   * @fires Player#emptied
   * @listens Tech#emptied
   */
  "emptied",
  /**
   * Fires when the browser is trying to get media data, but data is not available.
   *
   * @event Player#stalled
   * @type {Event}
   */
  /**
   * Retrigger the `stalled` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechStalled_
   * @fires Player#stalled
   * @listens Tech#stalled
   */
  "stalled",
  /**
   * Fires when the browser has loaded meta data for the audio/video.
   *
   * @event Player#loadedmetadata
   * @type {Event}
   */
  /**
   * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoadedmetadata_
   * @fires Player#loadedmetadata
   * @listens Tech#loadedmetadata
   */
  "loadedmetadata",
  /**
   * Fires when the browser has loaded the current frame of the audio/video.
   *
   * @event Player#loadeddata
   * @type {event}
   */
  /**
   * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoaddeddata_
   * @fires Player#loadeddata
   * @listens Tech#loadeddata
   */
  "loadeddata",
  /**
   * Fires when the current playback position has changed.
   *
   * @event Player#timeupdate
   * @type {event}
   */
  /**
   * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTimeUpdate_
   * @fires Player#timeupdate
   * @listens Tech#timeupdate
   */
  "timeupdate",
  /**
   * Fires when the video's intrinsic dimensions change
   *
   * @event Player#resize
   * @type {event}
   */
  /**
   * Retrigger the `resize` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechResize_
   * @fires Player#resize
   * @listens Tech#resize
   */
  "resize",
  /**
   * Fires when the volume has been changed
   *
   * @event Player#volumechange
   * @type {event}
   */
  /**
   * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechVolumechange_
   * @fires Player#volumechange
   * @listens Tech#volumechange
   */
  "volumechange",
  /**
   * Fires when the text track has been changed
   *
   * @event Player#texttrackchange
   * @type {event}
   */
  /**
   * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTexttrackchange_
   * @fires Player#texttrackchange
   * @listens Tech#texttrackchange
   */
  "texttrackchange"
], Gf = {
  canplay: "CanPlay",
  canplaythrough: "CanPlayThrough",
  playing: "Playing",
  seeked: "Seeked"
}, Bh = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"], Hu = {};
Bh.forEach((t) => {
  const e = t.charAt(0) === "x" ? `x-${t.substring(1)}` : t;
  Hu[t] = `vjs-layout-${e}`;
});
const pz = {
  tiny: 210,
  xsmall: 320,
  small: 425,
  medium: 768,
  large: 1440,
  xlarge: 2560,
  huge: 1 / 0
};
class jt extends be {
  /**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {PlayerReadyCallback} [ready]
   *        Ready callback function.
   */
  constructor(e, i, n) {
    if (e.id = e.id || i.id || `vjs_video_${Bn()}`, i = Object.assign(jt.getTagSettings(e), i), i.initChildren = !1, i.createEl = !1, i.evented = !1, i.reportTouchActivity = !1, !i.language) {
      const a = e.closest("[lang]");
      a && (i.language = a.getAttribute("lang"));
    }
    if (super(null, i, n), this.boundDocumentFullscreenChange_ = (a) => this.documentFullscreenChange_(a), this.boundFullWindowOnEscKey_ = (a) => this.fullWindowOnEscKey(a), this.boundUpdateStyleEl_ = (a) => this.updateStyleEl_(a), this.boundApplyInitTime_ = (a) => this.applyInitTime_(a), this.boundUpdateCurrentBreakpoint_ = (a) => this.updateCurrentBreakpoint_(a), this.boundHandleTechClick_ = (a) => this.handleTechClick_(a), this.boundHandleTechDoubleClick_ = (a) => this.handleTechDoubleClick_(a), this.boundHandleTechTouchStart_ = (a) => this.handleTechTouchStart_(a), this.boundHandleTechTouchMove_ = (a) => this.handleTechTouchMove_(a), this.boundHandleTechTouchEnd_ = (a) => this.handleTechTouchEnd_(a), this.boundHandleTechTap_ = (a) => this.handleTechTap_(a), this.boundUpdatePlayerHeightOnAudioOnlyMode_ = (a) => this.updatePlayerHeightOnAudioOnlyMode_(a), this.isFullscreen_ = !1, this.log = gb(this.id_), this.fsApi_ = fd, this.isPosterFromTech_ = !1, this.queuedCallbacks_ = [], this.isReady_ = !1, this.hasStarted_ = !1, this.userActive_ = !1, this.debugEnabled_ = !1, this.audioOnlyMode_ = !1, this.audioPosterMode_ = !1, this.audioOnlyCache_ = {
      controlBarHeight: null,
      playerHeight: null,
      hiddenChildren: []
    }, !this.options_ || !this.options_.techOrder || !this.options_.techOrder.length)
      throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
    if (this.tag = e, this.tagAttributes = e && or(e), this.language(this.options_.language), i.languages) {
      const a = {};
      Object.getOwnPropertyNames(i.languages).forEach(function(o) {
        a[o.toLowerCase()] = i.languages[o];
      }), this.languages_ = a;
    } else
      this.languages_ = jt.prototype.options_.languages;
    this.resetCache_(), this.poster_ = i.poster || "", this.controls_ = !!i.controls, e.controls = !1, e.removeAttribute("controls"), this.changingSrc_ = !1, this.playCallbacks_ = [], this.playTerminatedQueue_ = [], e.hasAttribute("autoplay") ? this.autoplay(!0) : this.autoplay(this.options_.autoplay), i.plugins && Object.keys(i.plugins).forEach((a) => {
      if (typeof this[a] != "function")
        throw new Error(`plugin "${a}" does not exist`);
    }), this.scrubbing_ = !1, this.el_ = this.createEl(), Zp(this, {
      eventBusKey: "el_"
    }), this.fsApi_.requestFullscreen && (xn(Ne, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_)), this.fluid_ && this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
    const s = Bt(this.options_);
    if (i.plugins && Object.keys(i.plugins).forEach((a) => {
      this[a](i.plugins[a]);
    }), i.debug && this.debug(!0), this.options_.playerOptions = s, this.middleware_ = [], this.playbackRates(i.playbackRates), i.experimentalSvgIcons) {
      const o = new ne.DOMParser().parseFromString(RF, "image/svg+xml");
      if (o.querySelector("parsererror"))
        pt.warn("Failed to load SVG Icons. Falling back to Font Icons."), this.options_.experimentalSvgIcons = null;
      else {
        const u = o.documentElement;
        u.style.display = "none", this.el_.appendChild(u), this.addClass("vjs-svg-icons-enabled");
      }
    }
    this.initChildren(), this.isAudio(e.nodeName.toLowerCase() === "audio"), this.controls() ? this.addClass("vjs-controls-enabled") : this.addClass("vjs-controls-disabled"), this.el_.setAttribute("role", "region"), this.isAudio() ? this.el_.setAttribute("aria-label", this.localize("Audio Player")) : this.el_.setAttribute("aria-label", this.localize("Video Player")), this.isAudio() && this.addClass("vjs-audio"), i.spatialNavigation && i.spatialNavigation.enabled && (this.spatialNavigation = new FF(this), this.addClass("vjs-spatial-navigation-enabled")), kl && this.addClass("vjs-touch-enabled"), Vi || this.addClass("vjs-workinghover"), jt.players[this.id_] = this;
    const r = Sh.split(".")[0];
    this.addClass(`vjs-v${r}`), this.userActive(!0), this.reportUserActivity(), this.one("play", (a) => this.listenForUserActivity_(a)), this.on("keydown", (a) => this.handleKeyDown(a)), this.on("languagechange", (a) => this.handleLanguagechange(a)), this.breakpoints(this.options_.breakpoints), this.responsive(this.options_.responsive), this.on("ready", () => {
      this.audioPosterMode(this.options_.audioPosterMode), this.audioOnlyMode(this.options_.audioOnlyMode);
    });
  }
  /**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */
  dispose() {
    this.trigger("dispose"), this.off("dispose"), qi(Ne, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), qi(Ne, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), jt.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null), OF(this), $i.names.forEach((e) => {
      const i = $i[e], n = this[i.getterName]();
      n && n.off && n.off();
    }), super.dispose({
      restoreEl: this.options_.restoreEl
    });
  }
  /**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    let e = this.tag, i, n = this.playerElIngest_ = e.parentNode && e.parentNode.hasAttribute && e.parentNode.hasAttribute("data-vjs-player");
    const s = this.tag.tagName.toLowerCase() === "video-js";
    n ? i = this.el_ = e.parentNode : s || (i = this.el_ = super.createEl("div"));
    const r = or(e);
    if (s) {
      for (i = this.el_ = e, e = this.tag = Ne.createElement("video"); i.children.length; )
        e.appendChild(i.firstChild);
      gl(i, "video-js") || Gr(i, "video-js"), i.appendChild(e), n = this.playerElIngest_ = i, Object.keys(i).forEach((l) => {
        try {
          e[l] = i[l];
        } catch {
        }
      });
    }
    e.setAttribute("tabindex", "-1"), r.tabindex = "-1", _s && sc && (e.setAttribute("role", "application"), r.role = "application"), e.removeAttribute("width"), e.removeAttribute("height"), "width" in r && delete r.width, "height" in r && delete r.height, Object.getOwnPropertyNames(r).forEach(function(l) {
      s && l === "class" || i.setAttribute(l, r[l]), s && e.setAttribute(l, r[l]);
    }), e.playerId = e.id, e.id += "_html5_api", e.className = "vjs-tech", e.player = i.player = this, this.addClass("vjs-paused");
    const a = ["IS_SMART_TV", "IS_TIZEN", "IS_WEBOS", "IS_ANDROID", "IS_IPAD", "IS_IPHONE", "IS_CHROMECAST_RECEIVER"].filter((l) => Cb[l]).map((l) => "vjs-device-" + l.substring(3).toLowerCase().replace(/\_/g, "-"));
    if (this.addClass(...a), ne.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
      this.styleEl_ = Ub("vjs-styles-dimensions");
      const l = yr(".vjs-styles-defaults"), u = yr("head");
      u.insertBefore(this.styleEl_, l ? l.nextSibling : u.firstChild);
    }
    this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
    const o = e.getElementsByTagName("a");
    for (let l = 0; l < o.length; l++) {
      const u = o.item(l);
      Gr(u, "vjs-hidden"), u.setAttribute("hidden", "hidden");
    }
    return e.initNetworkState_ = e.networkState, e.parentNode && !n && e.parentNode.insertBefore(i, e), Eh(e, i), this.children_.unshift(e), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = i, i;
  }
  /**
   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
   * behavior.
   *
   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
   *
   * @param {string|null} [value]
   *        The value to set the `Player`'s crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null|undefined}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */
  crossOrigin(e) {
    if (typeof e > "u")
      return this.techGet_("crossOrigin");
    if (e !== null && e !== "anonymous" && e !== "use-credentials") {
      pt.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
      return;
    }
    this.techCall_("setCrossOrigin", e), this.posterImage && this.posterImage.crossOrigin(e);
  }
  /**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s width to.
   *
   * @return {number|undefined}
   *         - The current width of the `Player` when getting.
   *         - Nothing when setting
   */
  width(e) {
    return this.dimension("width", e);
  }
  /**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s height to.
   *
   * @return {number|undefined}
   *         - The current height of the `Player` when getting.
   *         - Nothing when setting
   */
  height(e) {
    return this.dimension("height", e);
  }
  /**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number|string} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */
  dimension(e, i) {
    const n = e + "_";
    if (i === void 0)
      return this[n] || 0;
    if (i === "" || i === "auto") {
      this[n] = void 0, this.updateStyleEl_();
      return;
    }
    const s = parseFloat(i);
    if (isNaN(s)) {
      pt.error(`Improper value "${i}" supplied for for ${e}`);
      return;
    }
    this[n] = s, this.updateStyleEl_();
  }
  /**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * Turning this on will turn off fill mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */
  fluid(e) {
    if (e === void 0)
      return !!this.fluid_;
    this.fluid_ = !!e, Us(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), e ? (this.addClass("vjs-fluid"), this.fill(!1), uF(this, () => {
      this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
    })) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
  }
  /**
   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
   *
   * Turning this on will turn off fluid mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */
  fill(e) {
    if (e === void 0)
      return !!this.fill_;
    this.fill_ = !!e, e ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
  }
  /**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */
  /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player`'s aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */
  aspectRatio(e) {
    if (e === void 0)
      return this.aspectRatio_;
    if (!/^\d+\:\d+$/.test(e))
      throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
    this.aspectRatio_ = e, this.fluid(!0), this.updateStyleEl_();
  }
  /**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */
  updateStyleEl_() {
    if (ne.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
      const o = typeof this.width_ == "number" ? this.width_ : this.options_.width, l = typeof this.height_ == "number" ? this.height_ : this.options_.height, u = this.tech_ && this.tech_.el();
      u && (o >= 0 && (u.width = o), l >= 0 && (u.height = l));
      return;
    }
    let e, i, n, s;
    this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? n = this.aspectRatio_ : this.videoWidth() > 0 ? n = this.videoWidth() + ":" + this.videoHeight() : n = "16:9";
    const r = n.split(":"), a = r[1] / r[0];
    this.width_ !== void 0 ? e = this.width_ : this.height_ !== void 0 ? e = this.height_ / a : e = this.videoWidth() || 300, this.height_ !== void 0 ? i = this.height_ : i = e * a, /^[^a-zA-Z]/.test(this.id()) ? s = "dimensions-" + this.id() : s = this.id() + "-dimensions", this.addClass(s), Vb(this.styleEl_, `
      .${s} {
        width: ${e}px;
        height: ${i}px;
      }

      .${s}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${a * 100}%;
      }
    `);
  }
  /**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */
  loadTech_(e, i) {
    this.tech_ && this.unloadTech_();
    const n = oi(e), s = e.charAt(0).toLowerCase() + e.slice(1);
    n !== "Html5" && this.tag && (ft.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = n, this.isReady_ = !1;
    let r = this.autoplay();
    (typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (r = !1);
    const a = {
      source: i,
      autoplay: r,
      nativeControlsForTouch: this.options_.nativeControlsForTouch,
      playerId: this.id(),
      techId: `${this.id()}_${s}_api`,
      playsinline: this.options_.playsinline,
      preload: this.options_.preload,
      loop: this.options_.loop,
      disablePictureInPicture: this.options_.disablePictureInPicture,
      muted: this.options_.muted,
      poster: this.poster(),
      language: this.language(),
      playerElIngest: this.playerElIngest_ || !1,
      "vtt.js": this.options_["vtt.js"],
      canOverridePoster: !!this.options_.techCanOverridePoster,
      enableSourceset: this.options_.enableSourceset
    };
    $i.names.forEach((l) => {
      const u = $i[l];
      a[u.getterName] = this[u.privateName];
    }), Object.assign(a, this.options_[n]), Object.assign(a, this.options_[s]), Object.assign(a, this.options_[e.toLowerCase()]), this.tag && (a.tag = this.tag), i && i.src === this.cache_.src && this.cache_.currentTime > 0 && (a.startTime = this.cache_.currentTime);
    const o = ft.getTech(e);
    if (!o)
      throw new Error(`No Tech named '${n}' exists! '${n}' should be registered using videojs.registerTech()'`);
    this.tech_ = new o(a), this.tech_.ready(zt(this, this.handleTechReady_), !0), dv.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), Iw.forEach((l) => {
      this.on(this.tech_, l, (u) => this[`handleTech${oi(l)}_`](u));
    }), Object.keys(Gf).forEach((l) => {
      this.on(this.tech_, l, (u) => {
        if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
          this.queuedCallbacks_.push({
            callback: this[`handleTech${Gf[l]}_`].bind(this),
            event: u
          });
          return;
        }
        this[`handleTech${Gf[l]}_`](u);
      });
    }), this.on(this.tech_, "loadstart", (l) => this.handleTechLoadStart_(l)), this.on(this.tech_, "sourceset", (l) => this.handleTechSourceset_(l)), this.on(this.tech_, "waiting", (l) => this.handleTechWaiting_(l)), this.on(this.tech_, "ended", (l) => this.handleTechEnded_(l)), this.on(this.tech_, "seeking", (l) => this.handleTechSeeking_(l)), this.on(this.tech_, "play", (l) => this.handleTechPlay_(l)), this.on(this.tech_, "pause", (l) => this.handleTechPause_(l)), this.on(this.tech_, "durationchange", (l) => this.handleTechDurationChange_(l)), this.on(this.tech_, "fullscreenchange", (l, u) => this.handleTechFullscreenChange_(l, u)), this.on(this.tech_, "fullscreenerror", (l, u) => this.handleTechFullscreenError_(l, u)), this.on(this.tech_, "enterpictureinpicture", (l) => this.handleTechEnterPictureInPicture_(l)), this.on(this.tech_, "leavepictureinpicture", (l) => this.handleTechLeavePictureInPicture_(l)), this.on(this.tech_, "error", (l) => this.handleTechError_(l)), this.on(this.tech_, "posterchange", (l) => this.handleTechPosterChange_(l)), this.on(this.tech_, "textdata", (l) => this.handleTechTextData_(l)), this.on(this.tech_, "ratechange", (l) => this.handleTechRateChange_(l)), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (n !== "Html5" || !this.tag) && Eh(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null);
  }
  /**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */
  unloadTech_() {
    $i.names.forEach((e) => {
      const i = $i[e];
      this[i.privateName] = this[i.getterName]();
    }), this.textTracksJson_ = dv.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
  }
  /**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */
  tech(e) {
    return e === void 0 && pt.warn(`Using the tech directly can be dangerous. I hope you know what you're doing.
See https://github.com/videojs/video.js/issues/2617 for more info.
`), this.tech_;
  }
  /**
   * An object that contains Video.js version.
   *
   * @typedef {Object} PlayerVersion
   *
   * @property {string} 'video.js' - Video.js version
   */
  /**
   * Returns an object with Video.js version.
   *
   * @return {PlayerVersion}
   *          An object with Video.js version.
   */
  version() {
    return {
      "video.js": Sh
    };
  }
  /**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */
  addTechControlsListeners_() {
    this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
  }
  /**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */
  removeTechControlsListeners_() {
    this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
  }
  /**
   * Player waits for the tech to be ready
   *
   * @private
   */
  handleTechReady_() {
    this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
  }
  /**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}.
   *
   * @fires Player#loadstart
   * @listens Tech#loadstart
   * @private
   */
  handleTechLoadStart_() {
    this.removeClass("vjs-ended", "vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : this.trigger("loadstart"), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
  }
  /**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */
  manualAutoplay_(e) {
    if (!this.tech_ || typeof e != "string")
      return;
    const i = () => {
      const s = this.muted();
      this.muted(!0);
      const r = () => {
        this.muted(s);
      };
      this.playTerminatedQueue_.push(r);
      const a = this.play();
      if (yl(a))
        return a.catch((o) => {
          throw r(), new Error(`Rejection at manualAutoplay. Restoring muted value. ${o || ""}`);
        });
    };
    let n;
    if (e === "any" && !this.muted() ? (n = this.play(), yl(n) && (n = n.catch(i))) : e === "muted" && !this.muted() ? n = i() : n = this.play(), !!yl(n))
      return n.then(() => {
        this.trigger({
          type: "autoplay-success",
          autoplay: e
        });
      }).catch(() => {
        this.trigger({
          type: "autoplay-failure",
          autoplay: e
        });
      });
  }
  /**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */
  updateSourceCaches_(e = "") {
    let i = e, n = "";
    typeof i != "string" && (i = e.src, n = e.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], i && !n && (n = NF(this, i)), this.cache_.source = Bt({}, e, {
      src: i,
      type: n
    });
    const s = this.cache_.sources.filter((l) => l.src && l.src === i), r = [], a = this.$$("source"), o = [];
    for (let l = 0; l < a.length; l++) {
      const u = or(a[l]);
      r.push(u), u.src && u.src === i && o.push(u.src);
    }
    o.length && !s.length ? this.cache_.sources = r : s.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = i;
  }
  /**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */
  /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */
  handleTechSourceset_(e) {
    if (!this.changingSrc_) {
      let i = (r) => this.updateSourceCaches_(r);
      const n = this.currentSource().src, s = e.src;
      n && !/^blob:/.test(n) && /^blob:/.test(s) && (!this.lastSource_ || this.lastSource_.tech !== s && this.lastSource_.player !== n) && (i = () => {
      }), i(s), e.src || this.tech_.any(["sourceset", "loadstart"], (r) => {
        if (r.type === "sourceset")
          return;
        const a = this.techGet_("currentSrc");
        this.lastSource_.tech = a, this.updateSourceCaches_(a);
      });
    }
    this.lastSource_ = {
      player: this.currentSource().src,
      tech: e.src
    }, this.trigger({
      src: e.src,
      type: "sourceset"
    });
  }
  /**
   * Add/remove the vjs-has-started class
   *
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */
  hasStarted(e) {
    if (e === void 0)
      return this.hasStarted_;
    e !== this.hasStarted_ && (this.hasStarted_ = e, this.hasStarted_ ? this.addClass("vjs-has-started") : this.removeClass("vjs-has-started"));
  }
  /**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */
  handleTechPlay_() {
    this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
  }
  /**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */
  handleTechRateChange_() {
    this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach((e) => e.callback(e.event)), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
  }
  /**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */
  handleTechWaiting_() {
    this.addClass("vjs-waiting"), this.trigger("waiting");
    const e = this.currentTime(), i = () => {
      e !== this.currentTime() && (this.removeClass("vjs-waiting"), this.off("timeupdate", i));
    };
    this.on("timeupdate", i);
  }
  /**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */
  handleTechCanPlay_() {
    this.removeClass("vjs-waiting"), this.trigger("canplay");
  }
  /**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */
  handleTechCanPlayThrough_() {
    this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
  }
  /**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */
  handleTechPlaying_() {
    this.removeClass("vjs-waiting"), this.trigger("playing");
  }
  /**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */
  handleTechSeeking_() {
    this.addClass("vjs-seeking"), this.trigger("seeking");
  }
  /**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */
  handleTechSeeked_() {
    this.removeClass("vjs-seeking", "vjs-ended"), this.trigger("seeked");
  }
  /**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */
  handleTechPause_() {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
  }
  /**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */
  handleTechEnded_() {
    this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
  }
  /**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */
  handleTechDurationChange_() {
    this.duration(this.techGet_("duration"));
  }
  /**
   * Handle a click on the media element to play/pause
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#click
   * @private
   */
  handleTechClick_(e) {
    this.controls_ && (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, e) : this.paused() ? vs(this.play()) : this.pause());
  }
  /**
   * Handle a double-click on the media element to enter/exit fullscreen,
   * or exit documentPictureInPicture mode
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#dblclick
   * @private
   */
  handleTechDoubleClick_(e) {
    if (!this.controls_)
      return;
    Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), (n) => n.contains(e.target)) || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, e) : this.isInPictureInPicture() && !Ne.pictureInPictureElement ? this.exitPictureInPicture() : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen());
  }
  /**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */
  handleTechTap_() {
    this.userActive(!this.userActive());
  }
  /**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */
  handleTechTouchStart_() {
    this.userWasActive = this.userActive();
  }
  /**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */
  handleTechTouchMove_() {
    this.userWasActive && this.reportUserActivity();
  }
  /**
   * Handle touch to end
   *
   * @param {Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */
  handleTechTouchEnd_(e) {
    e.cancelable && e.preventDefault();
  }
  /**
   * @private
   */
  toggleFullscreenClass_() {
    this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
  }
  /**
   * when the document fschange event triggers it calls this
   */
  documentFullscreenChange_(e) {
    const i = e.target.player;
    if (i && i !== this)
      return;
    const n = this.el();
    let s = Ne[this.fsApi_.fullscreenElement] === n;
    !s && n.matches && (s = n.matches(":" + this.fsApi_.fullscreen)), this.isFullscreen(s);
  }
  /**
   * Handle Tech Fullscreen Change
   *
   * @param {Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */
  handleTechFullscreenChange_(e, i) {
    i && (i.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", () => {
      this.removeClass("vjs-ios-native-fs");
    })), this.isFullscreen(i.isFullscreen));
  }
  handleTechFullscreenError_(e, i) {
    this.trigger("fullscreenerror", i);
  }
  /**
   * @private
   */
  togglePictureInPictureClass_() {
    this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
  }
  /**
   * Handle Tech Enter Picture-in-Picture.
   *
   * @param {Event} event
   *        the enterpictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#enterpictureinpicture
   */
  handleTechEnterPictureInPicture_(e) {
    this.isInPictureInPicture(!0);
  }
  /**
   * Handle Tech Leave Picture-in-Picture.
   *
   * @param {Event} event
   *        the leavepictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#leavepictureinpicture
   */
  handleTechLeavePictureInPicture_(e) {
    this.isInPictureInPicture(!1);
  }
  /**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */
  handleTechError_() {
    const e = this.tech_.error();
    e && this.error(e);
  }
  /**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */
  handleTechTextData_() {
    let e = null;
    arguments.length > 1 && (e = arguments[1]), this.trigger("textdata", e);
  }
  /**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */
  getCache() {
    return this.cache_;
  }
  /**
   * Resets the internal cache object.
   *
   * Using this function outside the player constructor or reset method may
   * have unintended side-effects.
   *
   * @private
   */
  resetCache_() {
    this.cache_ = {
      // Right now, the currentTime is not _really_ cached because it is always
      // retrieved from the tech (see: currentTime). However, for completeness,
      // we set it to zero here to ensure that if we do start actually caching
      // it, we reset it along with everything else.
      currentTime: 0,
      initTime: 0,
      inactivityTimeout: this.options_.inactivityTimeout,
      duration: NaN,
      lastVolume: 1,
      lastPlaybackRate: this.defaultPlaybackRate(),
      media: null,
      src: "",
      source: {},
      sources: [],
      playbackRates: [],
      volume: 1
    };
  }
  /**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} [arg]
   *        the argument to pass
   *
   * @private
   */
  techCall_(e, i) {
    this.ready(function() {
      if (e in IF)
        return kF(this.middleware_, this.tech_, e, i);
      if (e in mv)
        return pv(this.middleware_, this.tech_, e, i);
      try {
        this.tech_ && this.tech_[e](i);
      } catch (n) {
        throw pt(n), n;
      }
    }, !0);
  }
  /**
   * Mediate attempt to call playback tech method
   * and return the value of the method called.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {*}
   *         Value returned by the tech method called, undefined if tech
   *         is not ready or tech method is not present
   *
   * @private
   */
  techGet_(e) {
    if (!(!this.tech_ || !this.tech_.isReady_)) {
      if (e in PF)
        return _F(this.middleware_, this.tech_, e);
      if (e in mv)
        return pv(this.middleware_, this.tech_, e);
      try {
        return this.tech_[e]();
      } catch (i) {
        throw this.tech_[e] === void 0 ? (pt(`Video.js: ${e} method not defined for ${this.techName_} playback technology.`, i), i) : i.name === "TypeError" ? (pt(`Video.js: ${e} unavailable on ${this.techName_} playback technology element.`, i), this.tech_.isReady_ = !1, i) : (pt(i), i);
      }
    }
  }
  /**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */
  play() {
    return new Promise((e) => {
      this.play_(e);
    });
  }
  /**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */
  play_(e = vs) {
    this.playCallbacks_.push(e);
    const i = !!(!this.changingSrc_ && (this.src() || this.currentSrc())), n = !!(ac || Vi);
    if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !i) {
      this.waitToPlay_ = (a) => {
        this.play_();
      }, this.one(["ready", "loadstart"], this.waitToPlay_), !i && n && this.load();
      return;
    }
    const s = this.techGet_("play");
    n && this.hasClass("vjs-ended") && this.resetProgressBar_(), s === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(s);
  }
  /**
   * These functions will be run when if play is terminated. If play
   * runPlayCallbacks_ is run these function will not be run. This allows us
   * to differentiate between a terminated play and an actual call to play.
   */
  runPlayTerminatedQueue_() {
    const e = this.playTerminatedQueue_.slice(0);
    this.playTerminatedQueue_ = [], e.forEach(function(i) {
      i();
    });
  }
  /**
   * When a callback to play is delayed we have to run these
   * callbacks when play is actually called on the tech. This function
   * runs the callbacks that were delayed and accepts the return value
   * from the tech.
   *
   * @param {undefined|Promise} val
   *        The return value from the tech.
   */
  runPlayCallbacks_(e) {
    const i = this.playCallbacks_.slice(0);
    this.playCallbacks_ = [], this.playTerminatedQueue_ = [], i.forEach(function(n) {
      n(e);
    });
  }
  /**
   * Pause the video playback
   */
  pause() {
    this.techCall_("pause");
  }
  /**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */
  paused() {
    return this.techGet_("paused") !== !1;
  }
  /**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return {TimeRange}
   *         A time range object that represents all the increments of time that have
   *         been played.
   */
  played() {
    return this.techGet_("played") || ts(0, 0);
  }
  /**
   * Sets or returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        whether the user is or is not scrubbing
   *
   * @return {boolean|undefined}
   *         - The value of scrubbing when getting
   *         - Nothing when setting
   */
  scrubbing(e) {
    if (typeof e > "u")
      return this.scrubbing_;
    this.scrubbing_ = !!e, this.techCall_("setScrubbing", this.scrubbing_), e ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
  }
  /**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number|undefined}
   *         - the current time in seconds when getting
   *         - Nothing when setting
   */
  currentTime(e) {
    if (e === void 0)
      return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
    if (e < 0 && (e = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
      this.cache_.initTime = e, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
      return;
    }
    this.techCall_("setCurrentTime", e), this.cache_.initTime = 0, isFinite(e) && (this.cache_.currentTime = Number(e));
  }
  /**
   * Apply the value of initTime stored in cache as currentTime.
   *
   * @private
   */
  applyInitTime_() {
    this.currentTime(this.cache_.initTime);
  }
  /**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and depending on preload behaviour may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number|undefined}
   *         - The duration of the video in seconds when getting
   *         - Nothing when setting
   */
  duration(e) {
    if (e === void 0)
      return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
    e = parseFloat(e), e < 0 && (e = 1 / 0), e !== this.cache_.duration && (this.cache_.duration = e, e === 1 / 0 ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(e) || this.trigger("durationchange"));
  }
  /**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */
  remainingTime() {
    return this.duration() - this.currentTime();
  }
  /**
   * A remaining time function that is intended to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */
  remainingTimeDisplay() {
    return Math.floor(this.duration()) - Math.floor(this.currentTime());
  }
  //
  // Kind of like an array of portions of the video that have been downloaded.
  /**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */
  buffered() {
    let e = this.techGet_("buffered");
    return (!e || !e.length) && (e = ts(0, 0)), e;
  }
  /**
   * Get the TimeRanges of the media that are currently available
   * for seeking to.
   *
   * @see [Seekable Spec]{@link https://html.spec.whatwg.org/multipage/media.html#dom-media-seekable}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */
  seekable() {
    let e = this.techGet_("seekable");
    return (!e || !e.length) && (e = ts(0, 0)), e;
  }
  /**
   * Returns whether the player is in the "seeking" state.
   *
   * @return {boolean} True if the player is in the seeking state, false if not.
   */
  seeking() {
    return this.techGet_("seeking");
  }
  /**
   * Returns whether the player is in the "ended" state.
   *
   * @return {boolean} True if the player is in the ended state, false if not.
   */
  ended() {
    return this.techGet_("ended");
  }
  /**
   * Returns the current state of network activity for the element, from
   * the codes in the list below.
   * - NETWORK_EMPTY (numeric value 0)
   *   The element has not yet been initialised. All attributes are in
   *   their initial states.
   * - NETWORK_IDLE (numeric value 1)
   *   The element's resource selection algorithm is active and has
   *   selected a resource, but it is not actually using the network at
   *   this time.
   * - NETWORK_LOADING (numeric value 2)
   *   The user agent is actively trying to download data.
   * - NETWORK_NO_SOURCE (numeric value 3)
   *   The element's resource selection algorithm is active, but it has
   *   not yet found a resource to use.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
   * @return {number} the current network activity state
   */
  networkState() {
    return this.techGet_("networkState");
  }
  /**
   * Returns a value that expresses the current state of the element
   * with respect to rendering the current playback position, from the
   * codes in the list below.
   * - HAVE_NOTHING (numeric value 0)
   *   No information regarding the media resource is available.
   * - HAVE_METADATA (numeric value 1)
   *   Enough of the resource has been obtained that the duration of the
   *   resource is available.
   * - HAVE_CURRENT_DATA (numeric value 2)
   *   Data for the immediate current playback position is available.
   * - HAVE_FUTURE_DATA (numeric value 3)
   *   Data for the immediate current playback position is available, as
   *   well as enough data for the user agent to advance the current
   *   playback position in the direction of playback.
   * - HAVE_ENOUGH_DATA (numeric value 4)
   *   The user agent estimates that enough data is available for
   *   playback to proceed uninterrupted.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
   * @return {number} the current playback rendering state
   */
  readyState() {
    return this.techGet_("readyState");
  }
  /**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is buffered 0 being 0% and 1 being 100%
   */
  bufferedPercent() {
    return Zb(this.buffered(), this.duration());
  }
  /**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */
  bufferedEnd() {
    const e = this.buffered(), i = this.duration();
    let n = e.end(e.length - 1);
    return n > i && (n = i), n;
  }
  /**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         The current volume as a percent when getting
   */
  volume(e) {
    let i;
    if (e !== void 0) {
      i = Math.max(0, Math.min(1, e)), this.cache_.volume = i, this.techCall_("setVolume", i), i > 0 && this.lastVolume_(i);
      return;
    }
    return i = parseFloat(this.techGet_("volume")), isNaN(i) ? 1 : i;
  }
  /**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   *         - nothing if setting
   */
  muted(e) {
    if (e !== void 0) {
      this.techCall_("setMuted", e);
      return;
    }
    return this.techGet_("muted") || !1;
  }
  /**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on initial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - Nothing when setting
   */
  defaultMuted(e) {
    return e !== void 0 && this.techCall_("setDefaultMuted", e), this.techGet_("defaultMuted") || !1;
  }
  /**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         - The current value of lastVolume as a percent when getting
   *         - Nothing when setting
   *
   * @private
   */
  lastVolume_(e) {
    if (e !== void 0 && e !== 0) {
      this.cache_.lastVolume = e;
      return;
    }
    return this.cache_.lastVolume;
  }
  /**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */
  supportsFullScreen() {
    return this.techGet_("supportsFullScreen") || !1;
  }
  /**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean|undefined}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   *         - Nothing when setting
   */
  isFullscreen(e) {
    if (e !== void 0) {
      const i = this.isFullscreen_;
      this.isFullscreen_ = !!e, this.isFullscreen_ !== i && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
      return;
    }
    return this.isFullscreen_;
  }
  /**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @param  {Object} [fullscreenOptions]
   *         Override the player fullscreen options
   *
   * @fires Player#fullscreenchange
   */
  requestFullscreen(e) {
    this.isInPictureInPicture() && this.exitPictureInPicture();
    const i = this;
    return new Promise((n, s) => {
      function r() {
        i.off("fullscreenerror", o), i.off("fullscreenchange", a);
      }
      function a() {
        r(), n();
      }
      function o(u, d) {
        r(), s(d);
      }
      i.one("fullscreenchange", a), i.one("fullscreenerror", o);
      const l = i.requestFullscreenHelper_(e);
      l && (l.then(r, r), l.then(n, s));
    });
  }
  requestFullscreenHelper_(e) {
    let i;
    if (this.fsApi_.prefixed || (i = this.options_.fullscreen && this.options_.fullscreen.options || {}, e !== void 0 && (i = e)), this.fsApi_.requestFullscreen) {
      const n = this.el_[this.fsApi_.requestFullscreen](i);
      return n && n.then(() => this.isFullscreen(!0), () => this.isFullscreen(!1)), n;
    } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
  }
  /**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */
  exitFullscreen() {
    const e = this;
    return new Promise((i, n) => {
      function s() {
        e.off("fullscreenerror", a), e.off("fullscreenchange", r);
      }
      function r() {
        s(), i();
      }
      function a(l, u) {
        s(), n(u);
      }
      e.one("fullscreenchange", r), e.one("fullscreenerror", a);
      const o = e.exitFullscreenHelper_();
      o && (o.then(s, s), o.then(i, n));
    });
  }
  exitFullscreenHelper_() {
    if (this.fsApi_.requestFullscreen) {
      const e = Ne[this.fsApi_.exitFullscreen]();
      return e && vs(e.then(() => this.isFullscreen(!1))), e;
    } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
  }
  /**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */
  enterFullWindow() {
    this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = Ne.documentElement.style.overflow, xn(Ne, "keydown", this.boundFullWindowOnEscKey_), Ne.documentElement.style.overflow = "hidden", Gr(Ne.body, "vjs-full-window"), this.trigger("enterFullWindow");
  }
  /**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */
  fullWindowOnEscKey(e) {
    e.key === "Escape" && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
  }
  /**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */
  exitFullWindow() {
    this.isFullscreen(!1), this.isFullWindow = !1, qi(Ne, "keydown", this.boundFullWindowOnEscKey_), Ne.documentElement.style.overflow = this.docOrigOverflow, oc(Ne.body, "vjs-full-window"), this.trigger("exitFullWindow");
  }
  /**
   * Get or set disable Picture-in-Picture mode.
   *
   * @param {boolean} [value]
   *                  - true will disable Picture-in-Picture mode
   *                  - false will enable Picture-in-Picture mode
   */
  disablePictureInPicture(e) {
    if (e === void 0)
      return this.techGet_("disablePictureInPicture");
    this.techCall_("setDisablePictureInPicture", e), this.options_.disablePictureInPicture = e, this.trigger("disablepictureinpicturechanged");
  }
  /**
   * Check if the player is in Picture-in-Picture mode or tell the player that it
   * is or is not in Picture-in-Picture mode.
   *
   * @param  {boolean} [isPiP]
   *         Set the players current Picture-in-Picture state
   *
   * @return {boolean|undefined}
   *         - true if Picture-in-Picture is on and getting
   *         - false if Picture-in-Picture is off and getting
   *         - nothing if setting
   */
  isInPictureInPicture(e) {
    if (e !== void 0) {
      this.isInPictureInPicture_ = !!e, this.togglePictureInPictureClass_();
      return;
    }
    return !!this.isInPictureInPicture_;
  }
  /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * This can use document picture-in-picture or element picture in picture
   *
   * Set `enableDocumentPictureInPicture` to `true` to use docPiP on a supported browser
   * Else set `disablePictureInPicture` to `false` to disable elPiP on a supported browser
   *
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/}
   * @see [Spec]{@link https://wicg.github.io/document-picture-in-picture/}
   *
   * @fires Player#enterpictureinpicture
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */
  requestPictureInPicture() {
    if (this.options_.enableDocumentPictureInPicture && ne.documentPictureInPicture) {
      const e = Ne.createElement(this.el().tagName);
      return e.classList = this.el().classList, e.classList.add("vjs-pip-container"), this.posterImage && e.appendChild(this.posterImage.el().cloneNode(!0)), this.titleBar && e.appendChild(this.titleBar.el().cloneNode(!0)), e.appendChild(st("p", {
        className: "vjs-pip-text"
      }, {}, this.localize("Playing in picture-in-picture"))), ne.documentPictureInPicture.requestWindow({
        // The aspect ratio won't be correct, Chrome bug https://crbug.com/1407629
        width: this.videoWidth(),
        height: this.videoHeight()
      }).then((i) => (Rb(i), this.el_.parentNode.insertBefore(e, this.el_), i.document.body.appendChild(this.el_), i.document.body.classList.add("vjs-pip-window"), this.player_.isInPictureInPicture(!0), this.player_.trigger({
        type: "enterpictureinpicture",
        pipWindow: i
      }), i.addEventListener("pagehide", (n) => {
        const s = n.target.querySelector(".video-js");
        e.parentNode.replaceChild(s, e), this.player_.isInPictureInPicture(!1), this.player_.trigger("leavepictureinpicture");
      }), i));
    }
    return "pictureInPictureEnabled" in Ne && this.disablePictureInPicture() === !1 ? this.techGet_("requestPictureInPicture") : Promise.reject("No PiP mode is available");
  }
  /**
   * Exit Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#leavepictureinpicture
   *
   * @return {Promise}
   *         A promise.
   */
  exitPictureInPicture() {
    if (ne.documentPictureInPicture && ne.documentPictureInPicture.window)
      return ne.documentPictureInPicture.window.close(), Promise.resolve();
    if ("pictureInPictureEnabled" in Ne)
      return Ne.exitPictureInPicture();
  }
  /**
   * Called when this Player has focus and a key gets pressed down, or when
   * any Component of this player receives a key press that it doesn't handle.
   * This allows player-wide hotkeys (either as defined below, or optionally
   * by an external function).
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const {
      userActions: i
    } = this.options_;
    !i || !i.hotkeys || ((s) => {
      const r = s.tagName.toLowerCase();
      if (s.isContentEditable)
        return !0;
      const a = ["button", "checkbox", "hidden", "radio", "reset", "submit"];
      return r === "input" ? a.indexOf(s.type) === -1 : ["textarea"].indexOf(r) !== -1;
    })(this.el_.ownerDocument.activeElement) || (typeof i.hotkeys == "function" ? i.hotkeys.call(this, e) : this.handleHotkeys(e));
  }
  /**
   * Called when this Player receives a hotkey keydown event.
   * Supported player-wide hotkeys are:
   *
   *   f          - toggle fullscreen
   *   m          - toggle mute
   *   k or Space - toggle play/pause
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   */
  handleHotkeys(e) {
    const i = this.options_.userActions ? this.options_.userActions.hotkeys : {}, {
      fullscreenKey: n = (a) => e.key.toLowerCase() === "f",
      muteKey: s = (a) => e.key.toLowerCase() === "m",
      playPauseKey: r = (a) => e.key.toLowerCase() === "k" || e.key.toLowerCase() === " "
    } = i;
    if (n.call(this, e)) {
      e.preventDefault(), e.stopPropagation();
      const a = be.getComponent("FullscreenToggle");
      Ne[this.fsApi_.fullscreenEnabled] !== !1 && a.prototype.handleClick.call(this, e);
    } else s.call(this, e) ? (e.preventDefault(), e.stopPropagation(), be.getComponent("MuteToggle").prototype.handleClick.call(this, e)) : r.call(this, e) && (e.preventDefault(), e.stopPropagation(), be.getComponent("PlayToggle").prototype.handleClick.call(this, e));
  }
  /**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */
  canPlayType(e) {
    let i;
    for (let n = 0, s = this.options_.techOrder; n < s.length; n++) {
      const r = s[n];
      let a = ft.getTech(r);
      if (a || (a = be.getComponent(r)), !a) {
        pt.error(`The "${r}" tech is undefined. Skipped browser support check for that tech.`);
        continue;
      }
      if (a.isSupported() && (i = a.canPlayType(e), i))
        return i;
    }
    return "";
  }
  /**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */
  selectSource(e) {
    const i = this.options_.techOrder.map((o) => [o, ft.getTech(o)]).filter(([o, l]) => l ? l.isSupported() : (pt.error(`The "${o}" tech is undefined. Skipped browser support check for that tech.`), !1)), n = function(o, l, u) {
      let d;
      return o.some((c) => l.some((A) => {
        if (d = u(c, A), d)
          return !0;
      })), d;
    };
    let s;
    const r = (o) => (l, u) => o(u, l), a = ([o, l], u) => {
      if (l.canPlaySource(u, this.options_[o.toLowerCase()]))
        return {
          source: u,
          tech: o
        };
    };
    return this.options_.sourceOrder ? s = n(e, i, r(a)) : s = n(i, e, a), s || !1;
  }
  /**
   * Executes source setting and getting logic
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   * @param {boolean} [isRetry]
   *        Indicates whether this is being called internally as a result of a retry
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */
  handleSrc_(e, i) {
    if (typeof e > "u")
      return this.cache_.src || "";
    this.resetRetryOnError_ && this.resetRetryOnError_();
    const n = tw(e);
    if (!n.length) {
      this.setTimeout(function() {
        this.error({
          code: 4,
          message: this.options_.notSupportedMessage
        });
      }, 0);
      return;
    }
    if (this.changingSrc_ = !0, i || (this.cache_.sources = n), this.updateSourceCaches_(n[0]), EF(this, n[0], (s, r) => {
      if (this.middleware_ = r, i || (this.cache_.sources = n), this.updateSourceCaches_(s), this.src_(s)) {
        if (n.length > 1)
          return this.handleSrc_(n.slice(1));
        this.changingSrc_ = !1, this.setTimeout(function() {
          this.error({
            code: 4,
            message: this.options_.notSupportedMessage
          });
        }, 0), this.triggerReady();
        return;
      }
      DF(r, this.tech_);
    }), n.length > 1) {
      const s = () => {
        this.error(null), this.handleSrc_(n.slice(1), !0);
      }, r = () => {
        this.off("error", s);
      };
      this.one("error", s), this.one("playing", r), this.resetRetryOnError_ = () => {
        this.off("error", s), this.off("playing", r);
      };
    }
  }
  /**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */
  src(e) {
    return this.handleSrc_(e, !1);
  }
  /**
   * Set the source object on the tech, returns a boolean that indicates whether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */
  src_(e) {
    const i = this.selectSource([e]);
    return i ? Xb(i.tech, this.techName_) ? (this.ready(function() {
      this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", e) : this.techCall_("src", e.src), this.changingSrc_ = !1;
    }, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(i.tech, i.source), this.tech_.ready(() => {
      this.changingSrc_ = !1;
    }), !1) : !0;
  }
  /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */
  addSourceElement(e, i) {
    return this.tech_ ? this.tech_.addSourceElement(e, i) : !1;
  }
  /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */
  removeSourceElement(e) {
    return this.tech_ ? this.tech_.removeSourceElement(e) : !1;
  }
  /**
   * Begin loading the src data.
   */
  load() {
    if (this.tech_ && this.tech_.vhs) {
      this.src(this.currentSource());
      return;
    }
    this.techCall_("load");
  }
  /**
   * Reset the player. Loads the first tech in the techOrder,
   * removes all the text tracks in the existing `tech`,
   * and calls `reset` on the `tech`.
   */
  reset() {
    if (this.paused())
      this.doReset_();
    else {
      const e = this.play();
      vs(e.then(() => this.doReset_()));
    }
  }
  doReset_() {
    this.tech_ && this.tech_.clearTracks("text"), this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), this.error(null), this.titleBar && this.titleBar.update({
      title: void 0,
      description: void 0
    }), Us(this) && this.trigger("playerreset");
  }
  /**
   * Reset Control Bar's UI by calling sub-methods that reset
   * all of Control Bar's components
   */
  resetControlBarUI_() {
    this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
  }
  /**
   * Reset tech's progress so progress bar is reset in the UI
   */
  resetProgressBar_() {
    this.currentTime(0);
    const {
      currentTimeDisplay: e,
      durationDisplay: i,
      progressControl: n,
      remainingTimeDisplay: s
    } = this.controlBar || {}, {
      seekBar: r
    } = n || {};
    e && e.updateContent(), i && i.updateContent(), s && s.updateContent(), r && (r.update(), r.loadProgressBar && r.loadProgressBar.update());
  }
  /**
   * Reset Playback ratio
   */
  resetPlaybackRate_() {
    this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
  }
  /**
   * Reset Volume bar
   */
  resetVolumeBar_() {
    this.volume(1), this.trigger("volumechange");
  }
  /**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */
  currentSources() {
    const e = this.currentSource(), i = [];
    return Object.keys(e).length !== 0 && i.push(e), this.cache_.sources || i;
  }
  /**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */
  currentSource() {
    return this.cache_.source || {};
  }
  /**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */
  currentSrc() {
    return this.currentSource() && this.currentSource().src || "";
  }
  /**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */
  currentType() {
    return this.currentSource() && this.currentSource().type || "";
  }
  /**
   * Get or set the preload attribute
   *
   * @param {'none'|'auto'|'metadata'} [value]
   *        Preload mode to pass to tech
   *
   * @return {string|undefined}
   *         - The preload attribute value when getting
   *         - Nothing when setting
   */
  preload(e) {
    if (e !== void 0) {
      this.techCall_("setPreload", e), this.options_.preload = e;
      return;
    }
    return this.techGet_("preload");
  }
  /**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|'play'|'muted'|'any'} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string|undefined}
   *         - The current value of autoplay when getting
   *         - Nothing when setting
   */
  autoplay(e) {
    if (e === void 0)
      return this.options_.autoplay || !1;
    let i;
    typeof e == "string" && /(any|play|muted)/.test(e) || e === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = e, this.manualAutoplay_(typeof e == "string" ? e : "play"), i = !1) : e ? this.options_.autoplay = !0 : this.options_.autoplay = !1, i = typeof i > "u" ? this.options_.autoplay : i, this.tech_ && this.techCall_("setAutoplay", i);
  }
  /**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|undefined}
   *         - the current value of playsinline
   *         - Nothing when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  playsinline(e) {
    return e !== void 0 && (this.techCall_("setPlaysinline", e), this.options_.playsinline = e), this.techGet_("playsinline");
  }
  /**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {boolean|undefined}
   *         - The current value of loop when getting
   *         - Nothing when setting
   */
  loop(e) {
    if (e !== void 0) {
      this.techCall_("setLoop", e), this.options_.loop = e;
      return;
    }
    return this.techGet_("loop");
  }
  /**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string|undefined}
   *         - The current value of poster when getting
   *         - Nothing when setting
   */
  poster(e) {
    if (e === void 0)
      return this.poster_;
    e || (e = ""), e !== this.poster_ && (this.poster_ = e, this.techCall_("setPoster", e), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
  }
  /**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */
  handleTechPosterChange_() {
    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
      const e = this.tech_.poster() || "";
      e !== this.poster_ && (this.poster_ = e, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
    }
  }
  /**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean|undefined}
   *         - The current value of controls when getting
   *         - Nothing when setting
   */
  controls(e) {
    if (e === void 0)
      return !!this.controls_;
    e = !!e, this.controls_ !== e && (this.controls_ = e, this.usingNativeControls() && this.techCall_("setControls", e), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
  }
  /**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls) or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean|undefined}
   *         - The current value of native controls when getting
   *         - Nothing when setting
   */
  usingNativeControls(e) {
    if (e === void 0)
      return !!this.usingNativeControls_;
    e = !!e, this.usingNativeControls_ !== e && (this.usingNativeControls_ = e, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
  }
  /**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null|undefined}
   *         - The current MediaError when getting (or null)
   *         - Nothing when setting
   */
  error(e) {
    if (e === void 0)
      return this.error_ || null;
    if (vr("beforeerror").forEach((i) => {
      const n = i(this, e);
      if (!(Ds(n) && !Array.isArray(n) || typeof n == "string" || typeof n == "number" || n === null)) {
        this.log.error("please return a value that MediaError expects in beforeerror hooks");
        return;
      }
      e = n;
    }), this.options_.suppressNotSupportedError && e && e.code === 4) {
      const i = function() {
        this.error(e);
      };
      this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], i), this.one("loadstart", function() {
        this.off(["click", "touchstart"], i);
      });
      return;
    }
    if (e === null) {
      this.error_ = null, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
      return;
    }
    this.error_ = new si(e), this.addClass("vjs-error"), pt.error(`(CODE:${this.error_.code} ${si.errorTypes[this.error_.code]})`, this.error_.message, this.error_), this.trigger("error"), vr("error").forEach((i) => i(this, this.error_));
  }
  /**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */
  reportUserActivity(e) {
    this.userActivity_ = !0;
  }
  /**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean|undefined}
   *         - The current value of userActive when getting
   *         - Nothing when setting
   */
  userActive(e) {
    if (e === void 0)
      return this.userActive_;
    if (e = !!e, e !== this.userActive_) {
      if (this.userActive_ = e, this.userActive_) {
        this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
        return;
      }
      this.tech_ && this.tech_.one("mousemove", function(i) {
        i.stopPropagation(), i.preventDefault();
      }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
    }
  }
  /**
   * Listen for user activity based on timeout value
   *
   * @private
   */
  listenForUserActivity_() {
    let e, i, n;
    const s = zt(this, this.reportUserActivity), r = function(c) {
      (c.screenX !== i || c.screenY !== n) && (i = c.screenX, n = c.screenY, s());
    }, a = function() {
      s(), this.clearInterval(e), e = this.setInterval(s, 250);
    }, o = function(c) {
      s(), this.clearInterval(e);
    };
    this.on("mousedown", a), this.on("mousemove", r), this.on("mouseup", o), this.on("mouseleave", o);
    const l = this.getChild("controlBar");
    l && !Vi && !rs && (l.on("mouseenter", function(c) {
      this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
    }), l.on("mouseleave", function(c) {
      this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
    })), this.on("keydown", s), this.on("keyup", s);
    let u;
    const d = function() {
      if (!this.userActivity_)
        return;
      this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(u);
      const c = this.options_.inactivityTimeout;
      c <= 0 || (u = this.setTimeout(function() {
        this.userActivity_ || this.userActive(!1);
      }, c));
    };
    this.setInterval(d, 250);
  }
  /**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number|undefined}
   *         - The current playback rate when getting or 1.0
   *         - Nothing when setting
   */
  playbackRate(e) {
    if (e !== void 0) {
      this.techCall_("setPlaybackRate", e);
      return;
    }
    return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
  }
  /**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|undefined}
   *         - The default playback rate when getting or 1.0
   *         - Nothing when setting
   */
  defaultPlaybackRate(e) {
    return e !== void 0 ? this.techCall_("setDefaultPlaybackRate", e) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1;
  }
  /**
   * Gets or sets the audio flag
   *
   * @param {boolean} [bool]
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean|undefined}
   *         - The current value of isAudio when getting
   *         - Nothing when setting
   */
  isAudio(e) {
    if (e !== void 0) {
      this.isAudio_ = !!e;
      return;
    }
    return !!this.isAudio_;
  }
  updatePlayerHeightOnAudioOnlyMode_() {
    const e = this.getChild("ControlBar");
    !e || this.audioOnlyCache_.controlBarHeight === e.currentHeight() || (this.audioOnlyCache_.controlBarHeight = e.currentHeight(), this.height(this.audioOnlyCache_.controlBarHeight));
  }
  enableAudioOnlyUI_() {
    this.addClass("vjs-audio-only-mode");
    const e = this.children(), i = this.getChild("ControlBar"), n = i && i.currentHeight();
    e.forEach((s) => {
      s !== i && s.el_ && !s.hasClass("vjs-hidden") && (s.hide(), this.audioOnlyCache_.hiddenChildren.push(s));
    }), this.audioOnlyCache_.playerHeight = this.currentHeight(), this.audioOnlyCache_.controlBarHeight = n, this.on("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.height(n), this.trigger("audioonlymodechange");
  }
  disableAudioOnlyUI_() {
    this.removeClass("vjs-audio-only-mode"), this.off("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.audioOnlyCache_.hiddenChildren.forEach((e) => e.show()), this.height(this.audioOnlyCache_.playerHeight), this.trigger("audioonlymodechange");
  }
  /**
   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
   *
   * Setting this to `true` will hide all player components except the control bar,
   * as well as control bar components needed only for video.
   *
   * @param {boolean} [value]
   *         The value to set audioOnlyMode to.
   *
   * @return {Promise|boolean}
   *        A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */
  audioOnlyMode(e) {
    if (typeof e != "boolean" || e === this.audioOnlyMode_)
      return this.audioOnlyMode_;
    if (this.audioOnlyMode_ = e, e) {
      const i = [];
      return this.isInPictureInPicture() && i.push(this.exitPictureInPicture()), this.isFullscreen() && i.push(this.exitFullscreen()), this.audioPosterMode() && i.push(this.audioPosterMode(!1)), Promise.all(i).then(() => this.enableAudioOnlyUI_());
    }
    return Promise.resolve().then(() => this.disableAudioOnlyUI_());
  }
  enablePosterModeUI_() {
    (this.tech_ && this.tech_).hide(), this.addClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }
  disablePosterModeUI_() {
    (this.tech_ && this.tech_).show(), this.removeClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }
  /**
   * Get the current audioPosterMode state or set audioPosterMode to true or false
   *
   * @param {boolean} [value]
   *         The value to set audioPosterMode to.
   *
   * @return {Promise|boolean}
   *         A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */
  audioPosterMode(e) {
    return typeof e != "boolean" || e === this.audioPosterMode_ ? this.audioPosterMode_ : (this.audioPosterMode_ = e, e ? this.audioOnlyMode() ? this.audioOnlyMode(!1).then(() => {
      this.enablePosterModeUI_();
    }) : Promise.resolve().then(() => {
      this.enablePosterModeUI_();
    }) : Promise.resolve().then(() => {
      this.disablePosterModeUI_();
    }));
  }
  /**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */
  addTextTrack(e, i, n) {
    if (this.tech_)
      return this.tech_.addTextTrack(e, i, n);
  }
  /**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack will not be removed
   *                                        from the TextTrackList and HtmlTrackElementList
   *                                        after a source change
   *
   * @return {HtmlTrackElement}
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   */
  addRemoteTextTrack(e, i) {
    if (this.tech_)
      return this.tech_.addRemoteTextTrack(e, i);
  }
  /**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */
  removeRemoteTextTrack(e = {}) {
    let {
      track: i
    } = e;
    if (i || (i = e), this.tech_)
      return this.tech_.removeRemoteTextTrack(i);
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */
  getVideoPlaybackQuality() {
    return this.techGet_("getVideoPlaybackQuality");
  }
  /**
   * Get video width
   *
   * @return {number}
   *         current video width
   */
  videoWidth() {
    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
  }
  /**
   * Get video height
   *
   * @return {number}
   *         current video height
   */
  videoHeight() {
    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
  }
  /**
   * Set or get the player's language code.
   *
   * Changing the language will trigger
   * [languagechange]{@link Player#event:languagechange}
   * which Components can use to update control text.
   * ClickableComponent will update its control text by default on
   * [languagechange]{@link Player#event:languagechange}.
   *
   * @fires Player#languagechange
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string|undefined}
   *         - The current language code when getting
   *         - Nothing when setting
   */
  language(e) {
    if (e === void 0)
      return this.language_;
    this.language_ !== String(e).toLowerCase() && (this.language_ = String(e).toLowerCase(), Us(this) && this.trigger("languagechange"));
  }
  /**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */
  languages() {
    return Bt(jt.prototype.options_.languages, this.languages_);
  }
  /**
   * returns a JavaScript object representing the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */
  toJSON() {
    const e = Bt(this.options_), i = e.tracks;
    e.tracks = [];
    for (let n = 0; n < i.length; n++) {
      let s = i[n];
      s = Bt(s), s.player = void 0, e.tracks[n] = s;
    }
    return e;
  }
  /**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */
  createModal(e, i) {
    i = i || {}, i.content = e || "";
    const n = new To(this, i);
    return this.addChild(n), n.on("dispose", () => {
      this.removeChild(n);
    }), n.open(), n;
  }
  /**
   * Change breakpoint classes when the player resizes.
   *
   * @private
   */
  updateCurrentBreakpoint_() {
    if (!this.responsive())
      return;
    const e = this.currentBreakpoint(), i = this.currentWidth();
    for (let n = 0; n < Bh.length; n++) {
      const s = Bh[n], r = this.breakpoints_[s];
      if (i <= r) {
        if (e === s)
          return;
        e && this.removeClass(Hu[e]), this.addClass(Hu[s]), this.breakpoint_ = s;
        break;
      }
    }
  }
  /**
   * Removes the current breakpoint.
   *
   * @private
   */
  removeCurrentBreakpoint_() {
    const e = this.currentBreakpointClass();
    this.breakpoint_ = "", e && this.removeClass(e);
  }
  /**
   * Get or set breakpoints on the player.
   *
   * Calling this method with an object or `true` will remove any previous
   * custom breakpoints and start from the defaults again.
   *
   * @param  {Object|boolean} [breakpoints]
   *         If an object is given, it can be used to provide custom
   *         breakpoints. If `true` is given, will set default breakpoints.
   *         If this argument is not given, will simply return the current
   *         breakpoints.
   *
   * @param  {number} [breakpoints.tiny]
   *         The maximum width for the "vjs-layout-tiny" class.
   *
   * @param  {number} [breakpoints.xsmall]
   *         The maximum width for the "vjs-layout-x-small" class.
   *
   * @param  {number} [breakpoints.small]
   *         The maximum width for the "vjs-layout-small" class.
   *
   * @param  {number} [breakpoints.medium]
   *         The maximum width for the "vjs-layout-medium" class.
   *
   * @param  {number} [breakpoints.large]
   *         The maximum width for the "vjs-layout-large" class.
   *
   * @param  {number} [breakpoints.xlarge]
   *         The maximum width for the "vjs-layout-x-large" class.
   *
   * @param  {number} [breakpoints.huge]
   *         The maximum width for the "vjs-layout-huge" class.
   *
   * @return {Object}
   *         An object mapping breakpoint names to maximum width values.
   */
  breakpoints(e) {
    return e === void 0 ? Object.assign(this.breakpoints_) : (this.breakpoint_ = "", this.breakpoints_ = Object.assign({}, pz, e), this.updateCurrentBreakpoint_(), Object.assign(this.breakpoints_));
  }
  /**
   * Get or set a flag indicating whether or not this player should adjust
   * its UI based on its dimensions.
   *
   * @param  {boolean} [value]
   *         Should be `true` if the player should adjust its UI based on its
   *         dimensions; otherwise, should be `false`.
   *
   * @return {boolean|undefined}
   *         Will be `true` if this player should adjust its UI based on its
   *         dimensions; otherwise, will be `false`.
   *         Nothing if setting
   */
  responsive(e) {
    if (e === void 0)
      return this.responsive_;
    e = !!e;
    const i = this.responsive_;
    if (e !== i)
      return this.responsive_ = e, e ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), e;
  }
  /**
   * Get current breakpoint name, if any.
   *
   * @return {string}
   *         If there is currently a breakpoint set, returns a the key from the
   *         breakpoints object matching it. Otherwise, returns an empty string.
   */
  currentBreakpoint() {
    return this.breakpoint_;
  }
  /**
   * Get the current breakpoint class name.
   *
   * @return {string}
   *         The matching class name (e.g. `"vjs-layout-tiny"` or
   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
   *         there is no current breakpoint.
   */
  currentBreakpointClass() {
    return Hu[this.breakpoint_] || "";
  }
  /**
   * An object that describes a single piece of media.
   *
   * Properties that are not part of this type description will be retained; so,
   * this can be viewed as a generic metadata storage mechanism as well.
   *
   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
   * @typedef  {Object} Player~MediaObject
   *
   * @property {string} [album]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {string} [artist]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [artwork]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API. If not specified, will be populated via the `poster`, if
   *           available.
   *
   * @property {string} [poster]
   *           URL to an image that will display before playback.
   *
   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
   *           A single source object, an array of source objects, or a string
   *           referencing a URL to a media source. It is _highly recommended_
   *           that an object or array of objects is used here, so that source
   *           selection algorithms can take the `type` into account.
   *
   * @property {string} [title]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [textTracks]
   *           An array of objects to be used to create text tracks, following
   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
   *           For ease of removal, these will be created as "remote" text
   *           tracks and set to automatically clean up on source changes.
   *
   *           These objects may have properties like `src`, `kind`, `label`,
   *           and `language`, see {@link Tech#createRemoteTextTrack}.
   */
  /**
   * Populate the player using a {@link Player~MediaObject|MediaObject}.
   *
   * @param  {Player~MediaObject} media
   *         A media object.
   *
   * @param  {Function} ready
   *         A callback to be called when the player is ready.
   */
  loadMedia(e, i) {
    if (!e || typeof e != "object")
      return;
    const n = this.crossOrigin();
    this.reset(), this.cache_.media = Bt(e);
    const {
      artist: s,
      artwork: r,
      description: a,
      poster: o,
      src: l,
      textTracks: u,
      title: d
    } = this.cache_.media;
    !r && o && (this.cache_.media.artwork = [{
      src: o,
      type: Td(o)
    }]), n && this.crossOrigin(n), l && this.src(l), o && this.poster(o), Array.isArray(u) && u.forEach((c) => this.addRemoteTextTrack(c, !1)), this.titleBar && this.titleBar.update({
      title: d,
      description: a || s || ""
    }), this.ready(i);
  }
  /**
   * Get a clone of the current {@link Player~MediaObject} for this player.
   *
   * If the `loadMedia` method has not been used, will attempt to return a
   * {@link Player~MediaObject} based on the current state of the player.
   *
   * @return {Player~MediaObject}
   */
  getMedia() {
    if (!this.cache_.media) {
      const e = this.poster(), i = this.currentSources(), n = Array.prototype.map.call(this.remoteTextTracks(), (r) => ({
        kind: r.kind,
        label: r.label,
        language: r.language,
        src: r.src
      })), s = {
        src: i,
        textTracks: n
      };
      return e && (s.poster = e, s.artwork = [{
        src: s.poster,
        type: Td(s.poster)
      }]), s;
    }
    return Bt(this.cache_.media);
  }
  /**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */
  static getTagSettings(e) {
    const i = {
      sources: [],
      tracks: []
    }, n = or(e), s = n["data-setup"];
    if (gl(e, "vjs-fill") && (n.fill = !0), gl(e, "vjs-fluid") && (n.fluid = !0), s !== null)
      try {
        Object.assign(n, JSON.parse(s || "{}"));
      } catch (r) {
        pt.error("data-setup", r);
      }
    if (Object.assign(i, n), e.hasChildNodes()) {
      const r = e.childNodes;
      for (let a = 0, o = r.length; a < o; a++) {
        const l = r[a], u = l.nodeName.toLowerCase();
        u === "source" ? i.sources.push(or(l)) : u === "track" && i.tracks.push(or(l));
      }
    }
    return i;
  }
  /**
   * Set debug mode to enable/disable logs at info level.
   *
   * @param {boolean} enabled
   * @fires Player#debugon
   * @fires Player#debugoff
   * @return {boolean|undefined}
   */
  debug(e) {
    if (e === void 0)
      return this.debugEnabled_;
    e ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
  }
  /**
   * Set or get current playback rates.
   * Takes an array and updates the playback rates menu with the new items.
   * Pass in an empty array to hide the menu.
   * Values other than arrays are ignored.
   *
   * @fires Player#playbackrateschange
   * @param {number[]} [newRates]
   *                   The new rates that the playback rates menu should update to.
   *                   An empty array will hide the menu
   * @return {number[]} When used as a getter will return the current playback rates
   */
  playbackRates(e) {
    if (e === void 0)
      return this.cache_.playbackRates;
    Array.isArray(e) && e.every((i) => typeof i == "number") && (this.cache_.playbackRates = e, this.trigger("playbackrateschange"));
  }
  /**
   * Reports whether or not a player has a plugin available.
   *
   * This does not report whether or not the plugin has ever been initialized
   * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
   *
   * @method hasPlugin
   * @param  {string}  name
   *         The name of a plugin.
   *
   * @return {boolean}
   *         Whether or not this player has the requested plugin available.
   */
  /**
   * Reports whether or not a player is using a plugin by name.
   *
   * For basic plugins, this only reports whether the plugin has _ever_ been
   * initialized on this player.
   *
   * @method Player#usingPlugin
   * @param  {string} name
   *         The name of a plugin.
   *
   * @return {boolean}
   *         Whether or not this player is using the requested plugin.
   */
}
$i.names.forEach(function(t) {
  const e = $i[t];
  jt.prototype[e.getterName] = function() {
    return this.tech_ ? this.tech_[e.getterName]() : (this[e.privateName] = this[e.privateName] || new e.ListClass(), this[e.privateName]);
  };
});
jt.prototype.crossorigin = jt.prototype.crossOrigin;
jt.players = {};
const Qo = ne.navigator;
jt.prototype.options_ = {
  // Default order of fallback technology
  techOrder: ft.defaultTechOrder_,
  html5: {},
  // enable sourceset by default
  enableSourceset: !0,
  // default inactivity timeout
  inactivityTimeout: 2e3,
  // default playback rates
  playbackRates: [],
  // Add playback rate selection by adding rates
  // 'playbackRates': [0.5, 1, 1.5, 2],
  liveui: !1,
  // Included control sets
  children: ["mediaLoader", "posterImage", "titleBar", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
  language: Qo && (Qo.languages && Qo.languages[0] || Qo.userLanguage || Qo.language) || "en",
  // locales and their language translations
  languages: {},
  // Default message to show when a video cannot be played.
  notSupportedMessage: "No compatible source was found for this media.",
  normalizeAutoplay: !1,
  fullscreen: {
    options: {
      navigationUI: "hide"
    }
  },
  breakpoints: {},
  responsive: !1,
  audioOnlyMode: !1,
  audioPosterMode: !1,
  spatialNavigation: {
    enabled: !1,
    horizontalSeek: !1
  },
  // Default smooth seeking to false
  enableSmoothSeeking: !1,
  disableSeekWhileScrubbingOnMobile: !1
};
Iw.forEach(function(t) {
  jt.prototype[`handleTech${oi(t)}_`] = function() {
    return this.trigger(t);
  };
});
be.registerComponent("Player", jt);
const xd = "plugin", Ra = "activePlugins_", Ca = {}, Sd = (t) => Ca.hasOwnProperty(t), Wu = (t) => Sd(t) ? Ca[t] : void 0, Mw = (t, e) => {
  t[Ra] = t[Ra] || {}, t[Ra][e] = !0;
}, Cd = (t, e, i) => {
  const n = (i ? "before" : "") + "pluginsetup";
  t.trigger(n, e), t.trigger(n + ":" + e.name, e);
}, mz = function(t, e) {
  const i = function() {
    Cd(this, {
      name: t,
      plugin: e,
      instance: null
    }, !0);
    const n = e.apply(this, arguments);
    return Mw(this, t), Cd(this, {
      name: t,
      plugin: e,
      instance: n
    }), n;
  };
  return Object.keys(e).forEach(function(n) {
    i[n] = e[n];
  }), i;
}, Iv = (t, e) => (e.prototype.name = t, function(...i) {
  Cd(this, {
    name: t,
    plugin: e,
    instance: null
  }, !0);
  const n = new e(this, ...i);
  return this[t] = () => n, Cd(this, n.getEventHash()), n;
});
class dn {
  /**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */
  constructor(e) {
    if (this.constructor === dn)
      throw new Error("Plugin must be sub-classed; not directly instantiated.");
    this.player = e, this.log || (this.log = this.player.log.createLogger(this.name)), Zp(this), delete this.trigger, Yb(this, this.constructor.defaultState), Mw(e, this.name), this.dispose = this.dispose.bind(this), e.on("dispose", this.dispose);
  }
  /**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */
  version() {
    return this.constructor.VERSION;
  }
  /**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @return {PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */
  getEventHash(e = {}) {
    return e.name = this.name, e.plugin = this.constructor, e.instance = this, e;
  }
  /**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link PluginEventHash|PluginEventHash}.
   *
   * @return {boolean}
   *          Whether or not default was prevented.
   */
  trigger(e, i = {}) {
    return wo(this.eventBusEl_, e, this.getEventHash(i));
  }
  /**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */
  handleStateChanged(e) {
  }
  /**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */
  dispose() {
    const {
      name: e,
      player: i
    } = this;
    this.trigger("dispose"), this.off(), i.off("dispose", this.dispose), i[Ra][e] = !1, this.player = this.state = null, i[e] = Iv(e, Ca[e]);
  }
  /**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @return {boolean}
   *          Whether or not a plugin is a basic plugin.
   */
  static isBasic(e) {
    const i = typeof e == "string" ? Wu(e) : e;
    return typeof i == "function" && !dn.prototype.isPrototypeOf(i.prototype);
  }
  /**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {typeof Plugin|Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @return {typeof Plugin|Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */
  static registerPlugin(e, i) {
    if (typeof e != "string")
      throw new Error(`Illegal plugin name, "${e}", must be a string, was ${typeof e}.`);
    if (Sd(e))
      pt.warn(`A plugin named "${e}" already exists. You may want to avoid re-registering plugins!`);
    else if (jt.prototype.hasOwnProperty(e))
      throw new Error(`Illegal plugin name, "${e}", cannot share a name with an existing player method!`);
    if (typeof i != "function")
      throw new Error(`Illegal plugin for "${e}", must be a function, was ${typeof i}.`);
    return Ca[e] = i, e !== xd && (dn.isBasic(i) ? jt.prototype[e] = mz(e, i) : jt.prototype[e] = Iv(e, i)), i;
  }
  /**
   * De-register a Video.js plugin.
   *
   * @param  {string} name
   *         The name of the plugin to be de-registered. Must be a string that
   *         matches an existing plugin.
   *
   * @throws {Error}
   *         If an attempt is made to de-register the base plugin.
   */
  static deregisterPlugin(e) {
    if (e === xd)
      throw new Error("Cannot de-register base plugin.");
    Sd(e) && (delete Ca[e], delete jt.prototype[e]);
  }
  /**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @return {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */
  static getPlugins(e = Object.keys(Ca)) {
    let i;
    return e.forEach((n) => {
      const s = Wu(n);
      s && (i = i || {}, i[n] = s);
    }), i;
  }
  /**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @return {string}
   *          The plugin's version or an empty string.
   */
  static getPluginVersion(e) {
    const i = Wu(e);
    return i && i.VERSION || "";
  }
}
dn.getPlugin = Wu;
dn.BASE_PLUGIN_NAME = xd;
dn.registerPlugin(xd, dn);
jt.prototype.usingPlugin = function(t) {
  return !!this[Ra] && this[Ra][t] === !0;
};
jt.prototype.hasPlugin = function(t) {
  return !!Sd(t);
};
function Az(t, e) {
  let i = !1;
  return function(...n) {
    return i || pt.warn(t), i = !0, e.apply(this, n);
  };
}
function os(t, e, i, n) {
  return Az(`${e} is deprecated and will be removed in ${t}.0; please use ${i} instead.`, n);
}
var gz = {
  NetworkBadStatus: "networkbadstatus",
  NetworkRequestFailed: "networkrequestfailed",
  NetworkRequestAborted: "networkrequestaborted",
  NetworkRequestTimeout: "networkrequesttimeout",
  NetworkBodyParserFailed: "networkbodyparserfailed",
  StreamingHlsPlaylistParserError: "streaminghlsplaylistparsererror",
  StreamingDashManifestParserError: "streamingdashmanifestparsererror",
  StreamingContentSteeringParserError: "streamingcontentsteeringparsererror",
  StreamingVttParserError: "streamingvttparsererror",
  StreamingFailedToSelectNextSegment: "streamingfailedtoselectnextsegment",
  StreamingFailedToDecryptSegment: "streamingfailedtodecryptsegment",
  StreamingFailedToTransmuxSegment: "streamingfailedtotransmuxsegment",
  StreamingFailedToAppendSegment: "streamingfailedtoappendsegment",
  StreamingCodecsChangeError: "streamingcodecschangeerror"
};
const Ow = (t) => t.indexOf("#") === 0 ? t.slice(1) : t;
function Ae(t, e, i) {
  let n = Ae.getPlayer(t);
  if (n)
    return e && pt.warn(`Player "${t}" is already initialised. Options will not be applied.`), i && n.ready(i), n;
  const s = typeof t == "string" ? yr("#" + Ow(t)) : t;
  if (!bo(s))
    throw new TypeError("The element or ID supplied is not valid. (videojs)");
  const a = ("getRootNode" in s ? s.getRootNode() instanceof ne.ShadowRoot : !1) ? s.getRootNode() : s.ownerDocument.body;
  (!s.ownerDocument.defaultView || !a.contains(s)) && pt.warn("The element supplied is not included in the DOM"), e = e || {}, e.restoreEl === !0 && (e.restoreEl = (s.parentNode && s.parentNode.hasAttribute && s.parentNode.hasAttribute("data-vjs-player") ? s.parentNode : s).cloneNode(!0)), vr("beforesetup").forEach((l) => {
    const u = l(s, Bt(e));
    if (!Ds(u) || Array.isArray(u)) {
      pt.error("please return an object in beforesetup hooks");
      return;
    }
    e = Bt(e, u);
  });
  const o = be.getComponent("Player");
  return n = new o(s, e, i), vr("setup").forEach((l) => l(n)), n;
}
Ae.hooks_ = Ns;
Ae.hooks = vr;
Ae.hook = QR;
Ae.hookOnce = ZR;
Ae.removeHook = Ab;
if (ne.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && yo()) {
  let t = yr(".vjs-styles-defaults");
  if (!t) {
    t = Ub("vjs-styles-defaults");
    const e = yr("head");
    e && e.insertBefore(t, e.firstChild), Vb(t, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
  }
}
_h(1, Ae);
Ae.VERSION = Sh;
Ae.options = jt.prototype.options_;
Ae.getPlayers = () => jt.players;
Ae.getPlayer = (t) => {
  const e = jt.players;
  let i;
  if (typeof t == "string") {
    const n = Ow(t), s = e[n];
    if (s)
      return s;
    i = yr("#" + n);
  } else
    i = t;
  if (bo(i)) {
    const {
      player: n,
      playerId: s
    } = i;
    if (n || e[s])
      return n || e[s];
  }
};
Ae.getAllPlayers = () => (
  // Disposed players leave a key with a `null` value, so we need to make sure
  // we filter those out.
  Object.keys(jt.players).map((t) => jt.players[t]).filter(Boolean)
);
Ae.players = jt.players;
Ae.getComponent = be.getComponent;
Ae.registerComponent = (t, e) => (ft.isTech(e) && pt.warn(`The ${t} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`), be.registerComponent.call(be, t, e));
Ae.getTech = ft.getTech;
Ae.registerTech = ft.registerTech;
Ae.use = CF;
Object.defineProperty(Ae, "middleware", {
  value: {},
  writeable: !1,
  enumerable: !0
});
Object.defineProperty(Ae.middleware, "TERMINATOR", {
  value: wd,
  writeable: !1,
  enumerable: !0
});
Ae.browser = Cb;
Ae.obj = $R;
Ae.mergeOptions = os(9, "videojs.mergeOptions", "videojs.obj.merge", Bt);
Ae.defineLazyProperty = os(9, "videojs.defineLazyProperty", "videojs.obj.defineLazyProperty", ic);
Ae.bind = os(9, "videojs.bind", "native Function.prototype.bind", zt);
Ae.registerPlugin = dn.registerPlugin;
Ae.deregisterPlugin = dn.deregisterPlugin;
Ae.plugin = (t, e) => (pt.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), dn.registerPlugin(t, e));
Ae.getPlugins = dn.getPlugins;
Ae.getPlugin = dn.getPlugin;
Ae.getPluginVersion = dn.getPluginVersion;
Ae.addLanguage = function(t, e) {
  return t = ("" + t).toLowerCase(), Ae.options.languages = Bt(Ae.options.languages, {
    [t]: e
  }), Ae.options.languages[t];
};
Ae.log = pt;
Ae.createLogger = gb;
Ae.time = pF;
Ae.createTimeRange = os(9, "videojs.createTimeRange", "videojs.time.createTimeRanges", ts);
Ae.createTimeRanges = os(9, "videojs.createTimeRanges", "videojs.time.createTimeRanges", ts);
Ae.formatTime = os(9, "videojs.formatTime", "videojs.time.formatTime", ia);
Ae.setFormatTime = os(9, "videojs.setFormatTime", "videojs.time.setFormatTime", Gb);
Ae.resetFormatTime = os(9, "videojs.resetFormatTime", "videojs.time.resetFormatTime", Qb);
Ae.parseUrl = os(9, "videojs.parseUrl", "videojs.url.parseUrl", $p);
Ae.isCrossOrigin = os(9, "videojs.isCrossOrigin", "videojs.url.isCrossOrigin", pc);
Ae.EventTarget = Sn;
Ae.any = Qp;
Ae.on = xn;
Ae.one = fc;
Ae.off = qi;
Ae.trigger = wo;
Ae.xhr = tb;
Ae.TextTrack = Xl;
Ae.AudioTrack = $b;
Ae.VideoTrack = ew;
["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach((t) => {
  Ae[t] = function() {
    return pt.warn(`videojs.${t}() is deprecated; use videojs.dom.${t}() instead`), Fb[t].apply(null, arguments);
  };
});
Ae.computedStyle = os(9, "videojs.computedStyle", "videojs.dom.computedStyle", co);
Ae.dom = Fb;
Ae.fn = lF;
Ae.num = XF;
Ae.str = fF;
Ae.url = xF;
Ae.Error = gz;
/*! @name videojs-contrib-quality-levels @version 4.1.0 @license Apache-2.0 */
class vz {
  /**
   * Creates a QualityLevel
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   */
  constructor(e) {
    let i = this;
    return i.id = e.id, i.label = i.id, i.width = e.width, i.height = e.height, i.bitrate = e.bandwidth, i.frameRate = e.frameRate, i.enabled_ = e.enabled, Object.defineProperty(i, "enabled", {
      /**
       * Get whether the QualityLevel is enabled.
       *
       * @return {boolean} True if the QualityLevel is enabled.
       */
      get() {
        return i.enabled_();
      },
      /**
       * Enable or disable the QualityLevel.
       *
       * @param {boolean} enable true to enable QualityLevel, false to disable.
       */
      set(n) {
        i.enabled_(n);
      }
    }), i;
  }
}
class Ed extends Ae.EventTarget {
  /**
   * Creates a QualityLevelList.
   */
  constructor() {
    super();
    let e = this;
    return e.levels_ = [], e.selectedIndex_ = -1, Object.defineProperty(e, "selectedIndex", {
      get() {
        return e.selectedIndex_;
      }
    }), Object.defineProperty(e, "length", {
      get() {
        return e.levels_.length;
      }
    }), e[Symbol.iterator] = () => e.levels_.values(), e;
  }
  /**
   * Adds a quality level to the list.
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   * @return {QualityLevel} the QualityLevel added to the list
   * @method addQualityLevel
   */
  addQualityLevel(e) {
    let i = this.getQualityLevelById(e.id);
    if (i)
      return i;
    const n = this.levels_.length;
    return i = new vz(e), "" + n in this || Object.defineProperty(this, n, {
      get() {
        return this.levels_[n];
      }
    }), this.levels_.push(i), this.trigger({
      qualityLevel: i,
      type: "addqualitylevel"
    }), i;
  }
  /**
   * Removes a quality level from the list.
   *
   * @param {QualityLevel} qualityLevel The QualityLevel to remove from the list.
   * @return {QualityLevel|null} the QualityLevel removed or null if nothing removed
   * @method removeQualityLevel
   */
  removeQualityLevel(e) {
    let i = null;
    for (let n = 0, s = this.length; n < s; n++)
      if (this[n] === e) {
        i = this.levels_.splice(n, 1)[0], this.selectedIndex_ === n ? this.selectedIndex_ = -1 : this.selectedIndex_ > n && this.selectedIndex_--;
        break;
      }
    return i && this.trigger({
      qualityLevel: e,
      type: "removequalitylevel"
    }), i;
  }
  /**
   * Searches for a QualityLevel with the given id.
   *
   * @param {string} id The id of the QualityLevel to find.
   * @return {QualityLevel|null} The QualityLevel with id, or null if not found.
   * @method getQualityLevelById
   */
  getQualityLevelById(e) {
    for (let i = 0, n = this.length; i < n; i++) {
      const s = this[i];
      if (s.id === e)
        return s;
    }
    return null;
  }
  /**
   * Resets the list of QualityLevels to empty
   *
   * @method dispose
   */
  dispose() {
    this.selectedIndex_ = -1, this.levels_.length = 0;
  }
}
Ed.prototype.allowedEvents_ = {
  change: "change",
  addqualitylevel: "addqualitylevel",
  removequalitylevel: "removequalitylevel"
};
for (const t in Ed.prototype.allowedEvents_)
  Ed.prototype["on" + t] = null;
var Bw = "4.1.0";
const yz = function(t, e) {
  const i = t.qualityLevels, n = new Ed(), s = function() {
    n.dispose(), t.qualityLevels = i, t.off("dispose", s);
  };
  return t.on("dispose", s), t.qualityLevels = () => n, t.qualityLevels.VERSION = Bw, n;
}, Lw = function(t) {
  return yz(this, Ae.obj.merge({}, t));
};
Ae.registerPlugin("qualityLevels", Lw);
Lw.VERSION = Bw;
/*! @name @videojs/http-streaming @version 3.17.0 @license Apache-2.0 */
const rn = Jd, Dd = (t, e) => e && e.responseURL && t !== e.responseURL ? e.responseURL : t, Fn = (t) => Ae.log.debug ? Ae.log.debug.bind(Ae, "VHS:", `${t} >`) : function() {
};
function _t(...t) {
  const e = Ae.obj || Ae;
  return (e.merge || e.mergeOptions).apply(e, t);
}
function ki(...t) {
  const e = Ae.time || Ae;
  return (e.createTimeRanges || e.createTimeRanges).apply(e, t);
}
function bz(t) {
  if (t.length === 0)
    return "Buffered Ranges are empty";
  let e = `Buffered Ranges: 
`;
  for (let i = 0; i < t.length; i++) {
    const n = t.start(i), s = t.end(i);
    e += `${n} --> ${s}. Duration (${s - n})
`;
  }
  return e;
}
const ys = 1 / 30, bs = ys * 3, Nw = function(t, e) {
  const i = [];
  let n;
  if (t && t.length)
    for (n = 0; n < t.length; n++)
      e(t.start(n), t.end(n)) && i.push([t.start(n), t.end(n)]);
  return ki(i);
}, Ea = function(t, e) {
  return Nw(t, function(i, n) {
    return i - bs <= e && n + bs >= e;
  });
}, Mu = function(t, e) {
  return Nw(t, function(i) {
    return i - ys >= e;
  });
}, wz = function(t) {
  if (t.length < 2)
    return ki();
  const e = [];
  for (let i = 1; i < t.length; i++) {
    const n = t.end(i - 1), s = t.start(i);
    e.push([n, s]);
  }
  return ki(e);
}, Tz = function(t, e) {
  let i = null, n = null, s = 0;
  const r = [], a = [];
  if (!t || !t.length || !e || !e.length)
    return ki();
  let o = t.length;
  for (; o--; )
    r.push({
      time: t.start(o),
      type: "start"
    }), r.push({
      time: t.end(o),
      type: "end"
    });
  for (o = e.length; o--; )
    r.push({
      time: e.start(o),
      type: "start"
    }), r.push({
      time: e.end(o),
      type: "end"
    });
  for (r.sort(function(l, u) {
    return l.time - u.time;
  }), o = 0; o < r.length; o++)
    r[o].type === "start" ? (s++, s === 2 && (i = r[o].time)) : r[o].type === "end" && (s--, s === 1 && (n = r[o].time)), i !== null && n !== null && (a.push([i, n]), i = null, n = null);
  return ki(a);
}, Rw = (t) => {
  const e = [];
  if (!t || !t.length)
    return "";
  for (let i = 0; i < t.length; i++)
    e.push(t.start(i) + " => " + t.end(i));
  return e.join(", ");
}, xz = function(t, e, i = 1) {
  return ((t.length ? t.end(t.length - 1) : 0) - e) / i;
}, qr = (t) => {
  const e = [];
  for (let i = 0; i < t.length; i++)
    e.push({
      start: t.start(i),
      end: t.end(i)
    });
  return e;
}, Sz = function(t, e) {
  if (t === e)
    return !1;
  if (!t && e || !e && t || t.length !== e.length)
    return !0;
  for (let i = 0; i < t.length; i++)
    if (t.start(i) !== e.start(i) || t.end(i) !== e.end(i))
      return !0;
  return !1;
}, Qf = function(t) {
  if (!(!t || !t.length || !t.end))
    return t.end(t.length - 1);
}, Am = function(t, e) {
  let i = 0;
  if (!t || !t.length)
    return i;
  for (let n = 0; n < t.length; n++) {
    const s = t.start(n), r = t.end(n);
    if (!(e > r)) {
      if (e > s && e <= r) {
        i += r - e;
        continue;
      }
      i += r - s;
    }
  }
  return i;
}, gm = (t, e) => {
  if (!e.preload)
    return e.duration;
  let i = 0;
  return (e.parts || []).forEach(function(n) {
    i += n.duration;
  }), (e.preloadHints || []).forEach(function(n) {
    n.type === "PART" && (i += t.partTargetDuration);
  }), i;
}, Lh = (t) => (t.segments || []).reduce((e, i, n) => (i.parts ? i.parts.forEach(function(s, r) {
  e.push({
    duration: s.duration,
    segmentIndex: n,
    partIndex: r,
    part: s,
    segment: i
  });
}) : e.push({
  duration: i.duration,
  segmentIndex: n,
  partIndex: null,
  segment: i,
  part: null
}), e), []), Fw = (t) => {
  const e = t.segments && t.segments.length && t.segments[t.segments.length - 1];
  return e && e.parts || [];
}, zw = ({
  preloadSegment: t
}) => {
  if (!t)
    return;
  const {
    parts: e,
    preloadHints: i
  } = t;
  let n = (i || []).reduce((s, r) => s + (r.type === "PART" ? 1 : 0), 0);
  return n += e && e.length ? e.length : 0, n;
}, Uw = (t, e) => {
  if (e.endList)
    return 0;
  if (t && t.suggestedPresentationDelay)
    return t.suggestedPresentationDelay;
  const i = Fw(e).length > 0;
  return i && e.serverControl && e.serverControl.partHoldBack ? e.serverControl.partHoldBack : i && e.partTargetDuration ? e.partTargetDuration * 3 : e.serverControl && e.serverControl.holdBack ? e.serverControl.holdBack : e.targetDuration ? e.targetDuration * 3 : 0;
}, Cz = function(t, e) {
  let i = 0, n = e - t.mediaSequence, s = t.segments[n];
  if (s) {
    if (typeof s.start < "u")
      return {
        result: s.start,
        precise: !0
      };
    if (typeof s.end < "u")
      return {
        result: s.end - s.duration,
        precise: !0
      };
  }
  for (; n--; ) {
    if (s = t.segments[n], typeof s.end < "u")
      return {
        result: i + s.end,
        precise: !0
      };
    if (i += gm(t, s), typeof s.start < "u")
      return {
        result: i + s.start,
        precise: !0
      };
  }
  return {
    result: i,
    precise: !1
  };
}, Ez = function(t, e) {
  let i = 0, n, s = e - t.mediaSequence;
  for (; s < t.segments.length; s++) {
    if (n = t.segments[s], typeof n.start < "u")
      return {
        result: n.start - i,
        precise: !0
      };
    if (i += gm(t, n), typeof n.end < "u")
      return {
        result: n.end - i,
        precise: !0
      };
  }
  return {
    result: -1,
    precise: !1
  };
}, Vw = function(t, e, i) {
  if (typeof e > "u" && (e = t.mediaSequence + t.segments.length), e < t.mediaSequence)
    return 0;
  const n = Cz(t, e);
  if (n.precise)
    return n.result;
  const s = Ez(t, e);
  return s.precise ? s.result : n.result + i;
}, qw = function(t, e, i) {
  if (!t)
    return 0;
  if (typeof i != "number" && (i = 0), typeof e > "u") {
    if (t.totalDuration)
      return t.totalDuration;
    if (!t.endList)
      return ne.Infinity;
  }
  return Vw(t, e, i);
}, bl = function({
  defaultDuration: t,
  durationList: e,
  startIndex: i,
  endIndex: n
}) {
  let s = 0;
  if (i > n && ([i, n] = [n, i]), i < 0) {
    for (let r = i; r < Math.min(0, n); r++)
      s += t;
    i = 0;
  }
  for (let r = i; r < n; r++)
    s += e[r].duration;
  return s;
}, Hw = function(t, e, i, n) {
  if (!t || !t.segments)
    return null;
  if (t.endList)
    return qw(t);
  if (e === null)
    return null;
  e = e || 0;
  let s = Vw(t, t.mediaSequence + t.segments.length, e);
  return i && (n = typeof n == "number" ? n : Uw(null, t), s -= n), Math.max(0, s);
}, Dz = function(t, e, i) {
  const s = e || 0;
  let r = Hw(t, e, !0, i);
  return r === null ? ki() : (r < s && (r = s), ki(s, r));
}, _z = function({
  playlist: t,
  currentTime: e,
  startingSegmentIndex: i,
  startingPartIndex: n,
  startTime: s,
  exactManifestTimings: r
}) {
  let a = e - s;
  const o = Lh(t);
  let l = 0;
  for (let u = 0; u < o.length; u++) {
    const d = o[u];
    if (i === d.segmentIndex && !(typeof n == "number" && typeof d.partIndex == "number" && n !== d.partIndex)) {
      l = u;
      break;
    }
  }
  if (a < 0) {
    if (l > 0)
      for (let u = l - 1; u >= 0; u--) {
        const d = o[u];
        if (a += d.duration, r) {
          if (a < 0)
            continue;
        } else if (a + ys <= 0)
          continue;
        return {
          partIndex: d.partIndex,
          segmentIndex: d.segmentIndex,
          startTime: s - bl({
            defaultDuration: t.targetDuration,
            durationList: o,
            startIndex: l,
            endIndex: u
          })
        };
      }
    return {
      partIndex: o[0] && o[0].partIndex || null,
      segmentIndex: o[0] && o[0].segmentIndex || 0,
      startTime: e
    };
  }
  if (l < 0) {
    for (let u = l; u < 0; u++)
      if (a -= t.targetDuration, a < 0)
        return {
          partIndex: o[0] && o[0].partIndex || null,
          segmentIndex: o[0] && o[0].segmentIndex || 0,
          startTime: e
        };
    l = 0;
  }
  for (let u = l; u < o.length; u++) {
    const d = o[u];
    a -= d.duration;
    const c = d.duration > ys, A = a === 0, m = c && a + ys >= 0;
    if (!((A || m) && u !== o.length - 1)) {
      if (r) {
        if (a > 0)
          continue;
      } else if (a - ys >= 0)
        continue;
      return {
        partIndex: d.partIndex,
        segmentIndex: d.segmentIndex,
        startTime: s + bl({
          defaultDuration: t.targetDuration,
          durationList: o,
          startIndex: l,
          endIndex: u
        })
      };
    }
  }
  return {
    segmentIndex: o[o.length - 1].segmentIndex,
    partIndex: o[o.length - 1].partIndex,
    startTime: e
  };
}, Ww = function(t) {
  return t.excludeUntil && t.excludeUntil > Date.now();
}, vm = function(t) {
  return t.excludeUntil && t.excludeUntil === 1 / 0;
}, vc = function(t) {
  const e = Ww(t);
  return !t.disabled && !e;
}, kz = function(t) {
  return t.disabled;
}, Pz = function(t) {
  for (let e = 0; e < t.segments.length; e++)
    if (t.segments[e].key)
      return !0;
  return !1;
}, Yw = function(t, e) {
  return e.attributes && e.attributes[t];
}, Iz = function(t, e, i, n = 0) {
  return Yw("BANDWIDTH", i) ? (t * i.attributes.BANDWIDTH - n * 8) / e : NaN;
}, Nh = (t, e) => {
  if (t.playlists.length === 1)
    return !0;
  const i = e.attributes.BANDWIDTH || Number.MAX_VALUE;
  return t.playlists.filter((n) => vc(n) ? (n.attributes.BANDWIDTH || 0) < i : !1).length === 0;
}, ym = (t, e) => !t && !e || !t && e || t && !e ? !1 : !!(t === e || t.id && e.id && t.id === e.id || t.resolvedUri && e.resolvedUri && t.resolvedUri === e.resolvedUri || t.uri && e.uri && t.uri === e.uri), Mv = function(t, e) {
  const i = t && t.mediaGroups && t.mediaGroups.AUDIO || {};
  let n = !1;
  for (const s in i) {
    for (const r in i[s])
      if (n = e(i[s][r]), n)
        break;
    if (n)
      break;
  }
  return !!n;
}, Zl = (t) => {
  if (!t || !t.playlists || !t.playlists.length)
    return Mv(t, (i) => i.playlists && i.playlists.length || i.uri);
  for (let e = 0; e < t.playlists.length; e++) {
    const i = t.playlists[e], n = i.attributes && i.attributes.CODECS;
    if (!(n && n.split(",").every((r) => sb(r)) || Mv(t, (r) => ym(i, r))))
      return !1;
  }
  return !0;
};
var on = {
  liveEdgeDelay: Uw,
  duration: qw,
  seekable: Dz,
  getMediaInfoForTime: _z,
  isEnabled: vc,
  isDisabled: kz,
  isExcluded: Ww,
  isIncompatible: vm,
  playlistEnd: Hw,
  isAes: Pz,
  hasAttribute: Yw,
  estimateSegmentRequestTime: Iz,
  isLowestEnabledRendition: Nh,
  isAudioOnly: Zl,
  playlistMatch: ym,
  segmentDurationWithParts: gm
};
const {
  log: Xw
} = Ae, Fa = (t, e) => `${t}-${e}`, jw = (t, e, i) => `placeholder-uri-${t}-${e}-${i}`, Mz = ({
  onwarn: t,
  oninfo: e,
  manifestString: i,
  customTagParsers: n = [],
  customTagMappers: s = [],
  llhls: r
}) => {
  const a = new g6();
  t && a.on("warn", t), e && a.on("info", e), n.forEach((u) => a.addParser(u)), s.forEach((u) => a.addTagMapper(u)), a.push(i), a.end();
  const o = a.manifest;
  if (r || (["preloadSegment", "skip", "serverControl", "renditionReports", "partInf", "partTargetDuration"].forEach(function(u) {
    o.hasOwnProperty(u) && delete o[u];
  }), o.segments && o.segments.forEach(function(u) {
    ["parts", "preloadHints"].forEach(function(d) {
      u.hasOwnProperty(d) && delete u[d];
    });
  })), !o.targetDuration) {
    let u = 10;
    o.segments && o.segments.length && (u = o.segments.reduce((d, c) => Math.max(d, c.duration), 0)), t && t({
      message: `manifest has no targetDuration defaulting to ${u}`
    }), o.targetDuration = u;
  }
  const l = Fw(o);
  if (l.length && !o.partTargetDuration) {
    const u = l.reduce((d, c) => Math.max(d, c.duration), 0);
    t && (t({
      message: `manifest has no partTargetDuration defaulting to ${u}`
    }), Xw.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.")), o.partTargetDuration = u;
  }
  return o;
}, Co = (t, e) => {
  t.mediaGroups && ["AUDIO", "SUBTITLES"].forEach((i) => {
    if (t.mediaGroups[i])
      for (const n in t.mediaGroups[i])
        for (const s in t.mediaGroups[i][n]) {
          const r = t.mediaGroups[i][n][s];
          e(r, i, n, s);
        }
  });
}, Gw = ({
  playlist: t,
  uri: e,
  id: i
}) => {
  t.id = i, t.playlistErrors_ = 0, e && (t.uri = e), t.attributes = t.attributes || {};
}, Oz = (t) => {
  let e = t.playlists.length;
  for (; e--; ) {
    const i = t.playlists[e];
    Gw({
      playlist: i,
      id: Fa(e, i.uri)
    }), i.resolvedUri = rn(t.uri, i.uri), t.playlists[i.id] = i, t.playlists[i.uri] = i, i.attributes.BANDWIDTH || Xw.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
  }
}, Bz = (t) => {
  Co(t, (e) => {
    e.uri && (e.resolvedUri = rn(t.uri, e.uri));
  });
}, Lz = (t, e) => {
  const i = Fa(0, e), n = {
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: ne.location.href,
    resolvedUri: ne.location.href,
    playlists: [{
      uri: e,
      id: i,
      resolvedUri: e,
      // m3u8-parser does not attach an attributes property to media playlists so make
      // sure that the property is attached to avoid undefined reference errors
      attributes: {}
    }]
  };
  return n.playlists[i] = n.playlists[0], n.playlists[e] = n.playlists[0], n;
}, Qw = (t, e, i = jw) => {
  t.uri = e;
  for (let s = 0; s < t.playlists.length; s++)
    if (!t.playlists[s].uri) {
      const r = `placeholder-uri-${s}`;
      t.playlists[s].uri = r;
    }
  const n = Zl(t);
  Co(t, (s, r, a, o) => {
    if (!s.playlists || !s.playlists.length) {
      if (n && r === "AUDIO" && !s.uri)
        for (let l = 0; l < t.playlists.length; l++) {
          const u = t.playlists[l];
          if (u.attributes && u.attributes.AUDIO && u.attributes.AUDIO === a)
            return;
        }
      s.playlists = [pi({}, s)];
    }
    s.playlists.forEach(function(l, u) {
      const d = i(r, a, o, l), c = Fa(u, d);
      l.uri ? l.resolvedUri = l.resolvedUri || rn(t.uri, l.uri) : (l.uri = u === 0 ? d : c, l.resolvedUri = l.uri), l.id = l.id || c, l.attributes = l.attributes || {}, t.playlists[l.id] = l, t.playlists[l.uri] = l;
    });
  }), Oz(t), Bz(t);
};
class Ov {
  constructor() {
    this.offset_ = null, this.pendingDateRanges_ = /* @__PURE__ */ new Map(), this.processedDateRanges_ = /* @__PURE__ */ new Map();
  }
  setOffset(e = []) {
    if (this.offset_ !== null || !e.length)
      return;
    const [i] = e;
    i.programDateTime !== void 0 && (this.offset_ = i.programDateTime / 1e3);
  }
  setPendingDateRanges(e = []) {
    if (!e.length)
      return;
    const [i] = e, n = i.startDate.getTime();
    this.trimProcessedDateRanges_(n), this.pendingDateRanges_ = e.reduce((s, r) => (s.set(r.id, r), s), /* @__PURE__ */ new Map());
  }
  processDateRange(e) {
    this.pendingDateRanges_.delete(e.id), this.processedDateRanges_.set(e.id, e);
  }
  getDateRangesToProcess() {
    if (this.offset_ === null)
      return [];
    const e = {}, i = [];
    this.pendingDateRanges_.forEach((n, s) => {
      if (!this.processedDateRanges_.has(s) && (n.startTime = n.startDate.getTime() / 1e3 - this.offset_, n.processDateRange = () => this.processDateRange(n), i.push(n), !!n.class))
        if (e[n.class]) {
          const r = e[n.class].push(n);
          n.classListIndex = r - 1;
        } else
          e[n.class] = [n], n.classListIndex = 0;
    });
    for (const n of i) {
      const s = e[n.class] || [];
      n.endDate ? n.endTime = n.endDate.getTime() / 1e3 - this.offset_ : n.endOnNext && s[n.classListIndex + 1] ? n.endTime = s[n.classListIndex + 1].startTime : n.duration ? n.endTime = n.startTime + n.duration : n.plannedDuration ? n.endTime = n.startTime + n.plannedDuration : n.endTime = n.startTime;
    }
    return i;
  }
  trimProcessedDateRanges_(e) {
    new Map(this.processedDateRanges_).forEach((n, s) => {
      n.startDate.getTime() < e && this.processedDateRanges_.delete(s);
    });
  }
}
const Zw = 22, Kr = ({
  requestType: t,
  request: e,
  error: i,
  parseFailure: n
}) => {
  const s = e.status < 200 || e.status > 299, r = e.status >= 400 && e.status <= 499, a = {
    uri: e.uri,
    requestType: t
  }, o = s && !r || n;
  if (i && r)
    a.error = pi({}, i), a.errorType = Ae.Error.NetworkRequestFailed;
  else if (e.aborted)
    a.errorType = Ae.Error.NetworkRequestAborted;
  else if (e.timedout)
    a.erroType = Ae.Error.NetworkRequestTimeout;
  else if (o) {
    const l = n ? Ae.Error.NetworkBodyParserFailed : Ae.Error.NetworkBadStatus;
    a.errorType = l, a.status = e.status, a.headers = e.headers;
  }
  return a;
}, Nz = Fn("CodecUtils"), Kw = function(t) {
  const e = t.attributes || {};
  if (e.CODECS)
    return cs(e.CODECS);
}, Jw = (t, e) => {
  const i = e.attributes || {};
  return t && t.mediaGroups && t.mediaGroups.AUDIO && i.AUDIO && t.mediaGroups.AUDIO[i.AUDIO];
}, Rz = (t, e) => {
  if (!Jw(t, e))
    return !0;
  const i = e.attributes || {}, n = t.mediaGroups.AUDIO[i.AUDIO];
  for (const s in n)
    if (!n[s].uri && !n[s].playlists)
      return !0;
  return !1;
}, Ml = function(t) {
  const e = {};
  return t.forEach(({
    mediaType: i,
    type: n,
    details: s
  }) => {
    e[i] = e[i] || [], e[i].push(nb(`${n}${s}`));
  }), Object.keys(e).forEach(function(i) {
    if (e[i].length > 1) {
      Nz(`multiple ${i} codecs found as attributes: ${e[i].join(", ")}. Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.`), e[i] = null;
      return;
    }
    e[i] = e[i][0];
  }), e;
}, Bv = function(t) {
  let e = 0;
  return t.audio && e++, t.video && e++, e;
}, wl = function(t, e) {
  const i = e.attributes || {}, n = Ml(Kw(e) || []);
  if (Jw(t, e) && !n.audio && !Rz(t, e)) {
    const s = Ml(y6(t, i.AUDIO) || []);
    s.audio && (n.audio = s.audio);
  }
  return n;
}, {
  EventTarget: Fz
} = Ae, zz = (t, e) => {
  if (e.endList || !e.serverControl)
    return t;
  const i = {};
  if (e.serverControl.canBlockReload) {
    const {
      preloadSegment: n
    } = e;
    let s = e.mediaSequence + e.segments.length;
    if (n) {
      const r = n.parts || [], a = zw(e) - 1;
      a > -1 && a !== r.length - 1 && (i._HLS_part = a), (a > -1 || r.length) && s--;
    }
    i._HLS_msn = s;
  }
  if (e.serverControl && e.serverControl.canSkipUntil && (i._HLS_skip = e.serverControl.canSkipDateranges ? "v2" : "YES"), Object.keys(i).length) {
    const n = new ne.URL(t);
    ["_HLS_skip", "_HLS_msn", "_HLS_part"].forEach(function(s) {
      i.hasOwnProperty(s) && n.searchParams.set(s, i[s]);
    }), t = n.toString();
  }
  return t;
}, Uz = (t, e) => {
  if (!t)
    return e;
  const i = _t(t, e);
  if (t.preloadHints && !e.preloadHints && delete i.preloadHints, t.parts && !e.parts)
    delete i.parts;
  else if (t.parts && e.parts)
    for (let n = 0; n < e.parts.length; n++)
      t.parts && t.parts[n] && (i.parts[n] = _t(t.parts[n], e.parts[n]));
  return !t.skipped && e.skipped && (i.skipped = !1), t.preload && !e.preload && (i.preload = !1), i;
}, Vz = (t, e, i) => {
  const n = t.slice(), s = e.slice();
  i = i || 0;
  const r = [];
  let a;
  for (let o = 0; o < s.length; o++) {
    const l = n[o + i], u = s[o];
    l ? (a = l.map || a, r.push(Uz(l, u))) : (a && !u.map && (u.map = a), r.push(u));
  }
  return r;
}, $w = (t, e) => {
  !t.resolvedUri && t.uri && (t.resolvedUri = rn(e, t.uri)), t.key && !t.key.resolvedUri && (t.key.resolvedUri = rn(e, t.key.uri)), t.map && !t.map.resolvedUri && (t.map.resolvedUri = rn(e, t.map.uri)), t.map && t.map.key && !t.map.key.resolvedUri && (t.map.key.resolvedUri = rn(e, t.map.key.uri)), t.parts && t.parts.length && t.parts.forEach((i) => {
    i.resolvedUri || (i.resolvedUri = rn(e, i.uri));
  }), t.preloadHints && t.preloadHints.length && t.preloadHints.forEach((i) => {
    i.resolvedUri || (i.resolvedUri = rn(e, i.uri));
  });
}, e1 = function(t) {
  const e = t.segments || [], i = t.preloadSegment;
  if (i && i.parts && i.parts.length) {
    if (i.preloadHints) {
      for (let n = 0; n < i.preloadHints.length; n++)
        if (i.preloadHints[n].type === "MAP")
          return e;
    }
    i.duration = t.targetDuration, i.preload = !0, e.push(i);
  }
  return e;
}, t1 = (t, e) => t === e || t.segments && e.segments && t.segments.length === e.segments.length && t.endList === e.endList && t.mediaSequence === e.mediaSequence && t.preloadSegment === e.preloadSegment, Rh = (t, e, i = t1) => {
  const n = _t(t, {}), s = n.playlists[e.id];
  if (!s || i(s, e))
    return null;
  e.segments = e1(e);
  const r = _t(s, e);
  if (r.preloadSegment && !e.preloadSegment && delete r.preloadSegment, s.segments) {
    if (e.skip) {
      e.segments = e.segments || [];
      for (let a = 0; a < e.skip.skippedSegments; a++)
        e.segments.unshift({
          skipped: !0
        });
    }
    r.segments = Vz(s.segments, e.segments, e.mediaSequence - s.mediaSequence);
  }
  r.segments.forEach((a) => {
    $w(a, r.resolvedUri);
  });
  for (let a = 0; a < n.playlists.length; a++)
    n.playlists[a].id === e.id && (n.playlists[a] = r);
  return n.playlists[e.id] = r, n.playlists[e.uri] = r, Co(t, (a, o, l, u) => {
    if (a.playlists)
      for (let d = 0; d < a.playlists.length; d++)
        e.id === a.playlists[d].id && (a.playlists[d] = r);
  }), n;
}, Fh = (t, e) => {
  const i = t.segments || [], n = i[i.length - 1], s = n && n.parts && n.parts[n.parts.length - 1], r = s && s.duration || n && n.duration;
  return e && r ? r * 1e3 : (t.partTargetDuration || t.targetDuration || 10) * 500;
}, Lv = (t, e, i) => {
  if (!t)
    return;
  const n = [];
  return t.forEach((s) => {
    if (!s.attributes)
      return;
    const {
      BANDWIDTH: r,
      RESOLUTION: a,
      CODECS: o
    } = s.attributes;
    n.push({
      id: s.id,
      bandwidth: r,
      resolution: a,
      codecs: o
    });
  }), {
    type: e,
    isLive: i,
    renditions: n
  };
};
class Da extends Fz {
  constructor(e, i, n = {}) {
    if (super(), !e)
      throw new Error("A non-empty playlist URL or object is required");
    this.logger_ = Fn("PlaylistLoader");
    const {
      withCredentials: s = !1
    } = n;
    this.src = e, this.vhs_ = i, this.withCredentials = s, this.addDateRangesToTextTrack_ = n.addDateRangesToTextTrack;
    const r = i.options_;
    this.customTagParsers = r && r.customTagParsers || [], this.customTagMappers = r && r.customTagMappers || [], this.llhls = r && r.llhls, this.dateRangesStorage_ = new Ov(), this.state = "HAVE_NOTHING", this.handleMediaupdatetimeout_ = this.handleMediaupdatetimeout_.bind(this), this.on("mediaupdatetimeout", this.handleMediaupdatetimeout_), this.on("loadedplaylist", this.handleLoadedPlaylist_.bind(this));
  }
  handleLoadedPlaylist_() {
    const e = this.media();
    if (!e)
      return;
    this.dateRangesStorage_.setOffset(e.segments), this.dateRangesStorage_.setPendingDateRanges(e.dateRanges);
    const i = this.dateRangesStorage_.getDateRangesToProcess();
    !i.length || !this.addDateRangesToTextTrack_ || this.addDateRangesToTextTrack_(i);
  }
  handleMediaupdatetimeout_() {
    if (this.state !== "HAVE_METADATA")
      return;
    const e = this.media();
    let i = rn(this.main.uri, e.uri);
    this.llhls && (i = zz(i, e)), this.state = "HAVE_CURRENT_METADATA", this.request = this.vhs_.xhr({
      uri: i,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (n, s) => {
      if (this.request) {
        if (n)
          return this.playlistRequestError(this.request, this.media(), "HAVE_METADATA");
        this.haveMetadata({
          playlistString: this.request.responseText,
          url: this.media().uri,
          id: this.media().id
        });
      }
    });
  }
  playlistRequestError(e, i, n) {
    const {
      uri: s,
      id: r
    } = i;
    this.request = null, n && (this.state = n), this.error = {
      playlist: this.main.playlists[r],
      status: e.status,
      message: `HLS playlist request error at URL: ${s}.`,
      responseText: e.responseText,
      code: e.status >= 500 ? 4 : 2,
      metadata: Kr({
        requestType: e.requestType,
        request: e,
        error: e.error
      })
    }, this.trigger("error");
  }
  parseManifest_({
    url: e,
    manifestString: i
  }) {
    try {
      const n = Mz({
        onwarn: ({
          message: s
        }) => this.logger_(`m3u8-parser warn for ${e}: ${s}`),
        oninfo: ({
          message: s
        }) => this.logger_(`m3u8-parser info for ${e}: ${s}`),
        manifestString: i,
        customTagParsers: this.customTagParsers,
        customTagMappers: this.customTagMappers,
        llhls: this.llhls
      });
      return !n.playlists || !n.playlists.length || this.excludeAudioOnlyVariants(n.playlists), n;
    } catch (n) {
      this.error = n, this.error.metadata = {
        errorType: Ae.Error.StreamingHlsPlaylistParserError,
        error: n
      };
    }
  }
  excludeAudioOnlyVariants(e) {
    const i = (n) => {
      const s = n.attributes || {}, {
        width: r,
        height: a
      } = s.RESOLUTION || {};
      if (r && a)
        return !0;
      const o = Kw(n) || [];
      return !!Ml(o).video;
    };
    e.some(i) && e.forEach((n) => {
      i(n) || (n.excludeUntil = 1 / 0);
    });
  }
  /**
   * Update the playlist loader's state in response to a new or updated playlist.
   *
   * @param {string} [playlistString]
   *        Playlist string (if playlistObject is not provided)
   * @param {Object} [playlistObject]
   *        Playlist object (if playlistString is not provided)
   * @param {string} url
   *        URL of playlist
   * @param {string} id
   *        ID to use for playlist
   */
  haveMetadata({
    playlistString: e,
    playlistObject: i,
    url: n,
    id: s
  }) {
    this.request = null, this.state = "HAVE_METADATA";
    const r = {
      playlistInfo: {
        type: "media",
        uri: n
      }
    };
    this.trigger({
      type: "playlistparsestart",
      metadata: r
    });
    const a = i || this.parseManifest_({
      url: n,
      manifestString: e
    });
    a.lastRequest = Date.now(), Gw({
      playlist: a,
      uri: n,
      id: s
    });
    const o = Rh(this.main, a);
    this.targetDuration = a.partTargetDuration || a.targetDuration, this.pendingMedia_ = null, o ? (this.main = o, this.media_ = this.main.playlists[s]) : this.trigger("playlistunchanged"), this.updateMediaUpdateTimeout_(Fh(this.media(), !!o)), r.parsedPlaylist = Lv(this.main.playlists, r.playlistInfo.type, !this.media_.endList), this.trigger({
      type: "playlistparsecomplete",
      metadata: r
    }), this.trigger("loadedplaylist");
  }
  /**
    * Abort any outstanding work and clean up.
    */
  dispose() {
    this.trigger("dispose"), this.stopRequest(), ne.clearTimeout(this.mediaUpdateTimeout), ne.clearTimeout(this.finalRenditionTimeout), this.dateRangesStorage_ = new Ov(), this.off();
  }
  stopRequest() {
    if (this.request) {
      const e = this.request;
      this.request = null, e.onreadystatechange = null, e.abort();
    }
  }
  /**
    * When called without any arguments, returns the currently
    * active media playlist. When called with a single argument,
    * triggers the playlist loader to asynchronously switch to the
    * specified media playlist. Calling this method while the
    * loader is in the HAVE_NOTHING causes an error to be emitted
    * but otherwise has no effect.
    *
    * @param {Object=} playlist the parsed media playlist
    * object to switch to
    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
    *
    * @return {Playlist} the current loaded media
    */
  media(e, i) {
    if (!e)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    if (typeof e == "string") {
      if (!this.main.playlists[e])
        throw new Error("Unknown playlist URI: " + e);
      e = this.main.playlists[e];
    }
    if (ne.clearTimeout(this.finalRenditionTimeout), i) {
      const o = (e.partTargetDuration || e.targetDuration) / 2 * 1e3 || 5e3;
      this.finalRenditionTimeout = ne.setTimeout(this.media.bind(this, e, !1), o);
      return;
    }
    const n = this.state, s = !this.media_ || e.id !== this.media_.id, r = this.main.playlists[e.id];
    if (r && r.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
    // media playlist or, for the case of demuxed audio, a resolved audio media group)
    e.endList && e.segments.length) {
      this.request && (this.request.onreadystatechange = null, this.request.abort(), this.request = null), this.state = "HAVE_METADATA", this.media_ = e, s && (this.trigger("mediachanging"), n === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange"));
      return;
    }
    if (this.updateMediaUpdateTimeout_(Fh(e, !0)), !s)
      return;
    if (this.state = "SWITCHING_MEDIA", this.request) {
      if (e.resolvedUri === this.request.url)
        return;
      this.request.onreadystatechange = null, this.request.abort(), this.request = null;
    }
    this.media_ && this.trigger("mediachanging"), this.pendingMedia_ = e;
    const a = {
      playlistInfo: {
        type: "media",
        uri: e.uri
      }
    };
    this.trigger({
      type: "playlistrequeststart",
      metadata: a
    }), this.request = this.vhs_.xhr({
      uri: e.resolvedUri,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (o, l) => {
      if (this.request) {
        if (e.lastRequest = Date.now(), e.resolvedUri = Dd(e.resolvedUri, l), o)
          return this.playlistRequestError(this.request, e, n);
        this.trigger({
          type: "playlistrequestcomplete",
          metadata: a
        }), this.haveMetadata({
          playlistString: l.responseText,
          url: e.uri,
          id: e.id
        }), n === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
      }
    });
  }
  /**
   * pause loading of the playlist
   */
  pause() {
    this.mediaUpdateTimeout && (ne.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), this.stopRequest(), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MAIN_MANIFEST" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
  }
  /**
   * start loading of the playlist
   */
  load(e) {
    this.mediaUpdateTimeout && (ne.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null);
    const i = this.media();
    if (e) {
      const n = i ? (i.partTargetDuration || i.targetDuration) / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = ne.setTimeout(() => {
        this.mediaUpdateTimeout = null, this.load();
      }, n);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    i && !i.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
  }
  updateMediaUpdateTimeout_(e) {
    this.mediaUpdateTimeout && (ne.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), !(!this.media() || this.media().endList) && (this.mediaUpdateTimeout = ne.setTimeout(() => {
      this.mediaUpdateTimeout = null, this.trigger("mediaupdatetimeout"), this.updateMediaUpdateTimeout_(e);
    }, e));
  }
  /**
   * start loading of the playlist
   */
  start() {
    if (this.started = !0, typeof this.src == "object") {
      this.src.uri || (this.src.uri = ne.location.href), this.src.resolvedUri = this.src.uri, setTimeout(() => {
        this.setupInitialPlaylist(this.src);
      }, 0);
      return;
    }
    const e = {
      playlistInfo: {
        type: "multivariant",
        uri: this.src
      }
    };
    this.trigger({
      type: "playlistrequeststart",
      metadata: e
    }), this.request = this.vhs_.xhr({
      uri: this.src,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (i, n) => {
      if (!this.request)
        return;
      if (this.request = null, i)
        return this.error = {
          status: n.status,
          message: `HLS playlist request error at URL: ${this.src}.`,
          responseText: n.responseText,
          // MEDIA_ERR_NETWORK
          code: 2,
          metadata: Kr({
            requestType: n.requestType,
            request: n,
            error: i
          })
        }, this.state === "HAVE_NOTHING" && (this.started = !1), this.trigger("error");
      this.trigger({
        type: "playlistrequestcomplete",
        metadata: e
      }), this.src = Dd(this.src, n), this.trigger({
        type: "playlistparsestart",
        metadata: e
      });
      const s = this.parseManifest_({
        manifestString: n.responseText,
        url: this.src
      });
      e.parsedPlaylist = Lv(s.playlists, e.playlistInfo.type, !1), this.trigger({
        type: "playlistparsecomplete",
        metadata: e
      }), this.setupInitialPlaylist(s);
    });
  }
  srcUri() {
    return typeof this.src == "string" ? this.src : this.src.uri;
  }
  /**
   * Given a manifest object that's either a main or media playlist, trigger the proper
   * events and set the state of the playlist loader.
   *
   * If the manifest object represents a main playlist, `loadedplaylist` will be
   * triggered to allow listeners to select a playlist. If none is selected, the loader
   * will default to the first one in the playlists array.
   *
   * If the manifest object represents a media playlist, `loadedplaylist` will be
   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
   *
   * In the case of a media playlist, a main playlist object wrapper with one playlist
   * will be created so that all logic can handle playlists in the same fashion (as an
   * assumed manifest object schema).
   *
   * @param {Object} manifest
   *        The parsed manifest object
   */
  setupInitialPlaylist(e) {
    if (this.state = "HAVE_MAIN_MANIFEST", e.playlists) {
      this.main = e, Qw(this.main, this.srcUri()), e.playlists.forEach((n) => {
        n.segments = e1(n), n.segments.forEach((s) => {
          $w(s, n.resolvedUri);
        });
      }), this.trigger("loadedplaylist"), this.request || this.media(this.main.playlists[0]);
      return;
    }
    const i = this.srcUri() || ne.location.href;
    this.main = Lz(e, i), this.haveMetadata({
      playlistObject: e,
      url: i,
      id: this.main.playlists[0].id
    }), this.trigger("loadedmetadata");
  }
  /**
   * Updates or deletes a preexisting pathway clone.
   * Ensures that all playlists related to the old pathway clone are
   * either updated or deleted.
   *
   * @param {Object} clone On update, the pathway clone object for the newly updated pathway clone.
   *        On delete, the old pathway clone object to be deleted.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */
  updateOrDeleteClone(e, i) {
    const n = this.main, s = e.ID;
    let r = n.playlists.length;
    for (; r--; ) {
      const a = n.playlists[r];
      if (a.attributes["PATHWAY-ID"] === s) {
        const o = a.resolvedUri, l = a.id;
        if (i) {
          const u = this.createCloneURI_(a.resolvedUri, e), d = Fa(s, u), c = this.createCloneAttributes_(s, a.attributes), A = this.createClonePlaylist_(a, d, e, c);
          n.playlists[r] = A, n.playlists[d] = A, n.playlists[u] = A;
        } else
          n.playlists.splice(r, 1);
        delete n.playlists[l], delete n.playlists[o];
      }
    }
    this.updateOrDeleteCloneMedia(e, i);
  }
  /**
   * Updates or deletes media data based on the pathway clone object.
   * Due to the complexity of the media groups and playlists, in all cases
   * we remove all of the old media groups and playlists.
   * On updates, we then create new media groups and playlists based on the
   * new pathway clone object.
   *
   * @param {Object} clone The pathway clone object for the newly updated pathway clone.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */
  updateOrDeleteCloneMedia(e, i) {
    const n = this.main, s = e.ID;
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((r) => {
      if (!(!n.mediaGroups[r] || !n.mediaGroups[r][s])) {
        for (const a in n.mediaGroups[r])
          if (a === s) {
            for (const o in n.mediaGroups[r][a])
              n.mediaGroups[r][a][o].playlists.forEach((u, d) => {
                const c = n.playlists[u.id], A = c.id, m = c.resolvedUri;
                delete n.playlists[A], delete n.playlists[m];
              });
            delete n.mediaGroups[r][a];
          }
      }
    }), i && this.createClonedMediaGroups_(e);
  }
  /**
   * Given a pathway clone object, clones all necessary playlists.
   *
   * @param {Object} clone The pathway clone object.
   * @param {Object} basePlaylist The original playlist to clone from.
   */
  addClonePathway(e, i = {}) {
    const n = this.main, s = n.playlists.length, r = this.createCloneURI_(i.resolvedUri, e), a = Fa(e.ID, r), o = this.createCloneAttributes_(e.ID, i.attributes), l = this.createClonePlaylist_(i, a, e, o);
    n.playlists[s] = l, n.playlists[a] = l, n.playlists[r] = l, this.createClonedMediaGroups_(e);
  }
  /**
   * Given a pathway clone object we create clones of all media.
   * In this function, all necessary information and updated playlists
   * are added to the `mediaGroup` object.
   * Playlists are also added to the `playlists` array so the media groups
   * will be properly linked.
   *
   * @param {Object} clone The pathway clone object.
   */
  createClonedMediaGroups_(e) {
    const i = e.ID, n = e["BASE-ID"], s = this.main;
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((r) => {
      if (!(!s.mediaGroups[r] || s.mediaGroups[r][i]))
        for (const a in s.mediaGroups[r]) {
          if (a === n)
            s.mediaGroups[r][i] = {};
          else
            continue;
          for (const o in s.mediaGroups[r][a]) {
            const l = s.mediaGroups[r][a][o];
            s.mediaGroups[r][i][o] = pi({}, l);
            const u = s.mediaGroups[r][i][o], d = this.createCloneURI_(l.resolvedUri, e);
            u.resolvedUri = d, u.uri = d, u.playlists = [], l.playlists.forEach((c, A) => {
              const m = s.playlists[c.id], p = jw(r, i, o), h = Fa(i, p);
              if (m && !s.playlists[h]) {
                const g = this.createClonePlaylist_(m, h, e), w = g.resolvedUri;
                s.playlists[h] = g, s.playlists[w] = g;
              }
              u.playlists[A] = this.createClonePlaylist_(c, h, e);
            });
          }
        }
    });
  }
  /**
   * Using the original playlist to be cloned, and the pathway clone object
   * information, we create a new playlist.
   *
   * @param {Object} basePlaylist  The original playlist to be cloned from.
   * @param {string} id The desired id of the newly cloned playlist.
   * @param {Object} clone The pathway clone object.
   * @param {Object} attributes An optional object to populate the `attributes` property in the playlist.
   *
   * @return {Object} The combined cloned playlist.
   */
  createClonePlaylist_(e, i, n, s) {
    const r = this.createCloneURI_(e.resolvedUri, n), a = {
      resolvedUri: r,
      uri: r,
      id: i
    };
    return e.segments && (a.segments = []), s && (a.attributes = s), _t(e, a);
  }
  /**
   * Generates an updated URI for a cloned pathway based on the original
   * pathway's URI and the paramaters from the pathway clone object in the
   * content steering server response.
   *
   * @param {string} baseUri URI to be updated in the cloned pathway.
   * @param {Object} clone The pathway clone object.
   *
   * @return {string} The updated URI for the cloned pathway.
   */
  createCloneURI_(e, i) {
    const n = new URL(e);
    n.hostname = i["URI-REPLACEMENT"].HOST;
    const s = i["URI-REPLACEMENT"].PARAMS;
    for (const r of Object.keys(s))
      n.searchParams.set(r, s[r]);
    return n.href;
  }
  /**
   * Helper function to create the attributes needed for the new clone.
   * This mainly adds the necessary media attributes.
   *
   * @param {string} id The pathway clone object ID.
   * @param {Object} oldAttributes The old attributes to compare to.
   * @return {Object} The new attributes to add to the playlist.
   */
  createCloneAttributes_(e, i) {
    const n = {
      "PATHWAY-ID": e
    };
    return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((s) => {
      i[s] && (n[s] = e);
    }), n;
  }
  /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */
  getKeyIdSet(e) {
    if (e.contentProtection) {
      const i = /* @__PURE__ */ new Set();
      for (const n in e.contentProtection) {
        const s = e.contentProtection[n].attributes.keyId;
        s && i.add(s.toLowerCase());
      }
      return i;
    }
  }
}
const zh = function(t, e, i, n) {
  const s = t.responseType === "arraybuffer" ? t.response : t.responseText;
  !e && s && (t.responseTime = Date.now(), t.roundTripTime = t.responseTime - t.requestTime, t.bytesReceived = s.byteLength || s.length, t.bandwidth || (t.bandwidth = Math.floor(t.bytesReceived / t.roundTripTime * 8 * 1e3))), i.headers && (t.responseHeaders = i.headers), e && e.code === "ETIMEDOUT" && (t.timedout = !0), !e && !t.aborted && i.statusCode !== 200 && i.statusCode !== 206 && i.statusCode !== 0 && (e = new Error("XHR Failed with a response of: " + (t && (s || t.responseText)))), n(e, t);
}, qz = (t, e) => {
  if (!t || !t.size)
    return;
  let i = e;
  return t.forEach((n) => {
    i = n(i);
  }), i;
}, Hz = (t, e, i, n) => {
  !t || !t.size || t.forEach((s) => {
    s(e, i, n);
  });
}, i1 = function() {
  const t = function e(i, n) {
    i = _t({
      timeout: 45e3
    }, i);
    const s = e.beforeRequest || Ae.Vhs.xhr.beforeRequest, r = e._requestCallbackSet || Ae.Vhs.xhr._requestCallbackSet || /* @__PURE__ */ new Set(), a = e._responseCallbackSet || Ae.Vhs.xhr._responseCallbackSet;
    s && typeof s == "function" && (Ae.log.warn("beforeRequest is deprecated, use onRequest instead."), r.add(s));
    const o = Ae.Vhs.xhr.original === !0 ? Ae.xhr : Ae.Vhs.xhr, l = qz(r, i);
    r.delete(s);
    const u = o(l || i, function(c, A) {
      return Hz(a, u, c, A), zh(u, c, A, n);
    }), d = u.abort;
    return u.abort = function() {
      return u.aborted = !0, d.apply(u, arguments);
    }, u.uri = i.uri, u.requestType = i.requestType, u.requestTime = Date.now(), u;
  };
  return t.original = !0, t;
}, Wz = function(t) {
  let e;
  const i = t.offset;
  return typeof t.offset == "bigint" || typeof t.length == "bigint" ? e = ne.BigInt(t.offset) + ne.BigInt(t.length) - ne.BigInt(1) : e = t.offset + t.length - 1, "bytes=" + i + "-" + e;
}, Uh = function(t) {
  const e = {};
  return t.byterange && (e.Range = Wz(t.byterange)), e;
}, Yz = function(t, e) {
  return t.start(e) + "-" + t.end(e);
}, Xz = function(t, e) {
  const i = t.toString(16);
  return "00".substring(0, 2 - i.length) + i + (e % 2 ? " " : "");
}, jz = function(t) {
  return t >= 32 && t < 126 ? String.fromCharCode(t) : ".";
}, n1 = function(t) {
  const e = {};
  return Object.keys(t).forEach((i) => {
    const n = t[i];
    ab(n) ? e[i] = {
      bytes: n.buffer,
      byteOffset: n.byteOffset,
      byteLength: n.byteLength
    } : e[i] = n;
  }), e;
}, _d = function(t) {
  const e = t.byterange || {
    length: 1 / 0,
    offset: 0
  };
  return [e.length, e.offset, t.resolvedUri].join(",");
}, s1 = function(t) {
  return t.resolvedUri;
}, r1 = (t) => {
  const e = Array.prototype.slice.call(t), i = 16;
  let n = "", s, r;
  for (let a = 0; a < e.length / i; a++)
    s = e.slice(a * i, a * i + i).map(Xz).join(""), r = e.slice(a * i, a * i + i).map(jz).join(""), n += s + " " + r + `
`;
  return n;
}, Gz = ({
  bytes: t
}) => r1(t), Qz = (t) => {
  let e = "", i;
  for (i = 0; i < t.length; i++)
    e += Yz(t, i) + " ";
  return e;
};
var Zz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTransferableMessage: n1,
  initSegmentId: _d,
  segmentKeyId: s1,
  hexDump: r1,
  tagDump: Gz,
  textRanges: Qz
});
const a1 = 0.25, Kz = (t, e) => {
  if (!e.dateTimeObject)
    return null;
  const i = e.videoTimingInfo.transmuxerPrependedSeconds, s = e.videoTimingInfo.transmuxedPresentationStart + i, r = t - s;
  return new Date(e.dateTimeObject.getTime() + r * 1e3);
}, Jz = (t) => t.transmuxedPresentationEnd - t.transmuxedPresentationStart - t.transmuxerPrependedSeconds, $z = (t, e) => {
  let i;
  try {
    i = new Date(t);
  } catch {
    return null;
  }
  if (!e || !e.segments || e.segments.length === 0)
    return null;
  let n = e.segments[0];
  if (i < new Date(n.dateTimeObject))
    return null;
  for (let l = 0; l < e.segments.length - 1; l++) {
    n = e.segments[l];
    const u = new Date(e.segments[l + 1].dateTimeObject);
    if (i < u)
      break;
  }
  const s = e.segments[e.segments.length - 1], r = s.dateTimeObject, a = s.videoTimingInfo ? Jz(s.videoTimingInfo) : s.duration + s.duration * a1, o = new Date(r.getTime() + a * 1e3);
  return i > o ? null : (i > new Date(r) && (n = s), {
    segment: n,
    estimatedStart: n.videoTimingInfo ? n.videoTimingInfo.transmuxedPresentationStart : on.duration(e, e.mediaSequence + e.segments.indexOf(n)),
    // Although, given that all segments have accurate date time objects, the segment
    // selected should be accurate, unless the video has been transmuxed at some point
    // (determined by the presence of the videoTimingInfo object), the segment's "player
    // time" (the start time in the player) can't be considered accurate.
    type: n.videoTimingInfo ? "accurate" : "estimate"
  });
}, eU = (t, e) => {
  if (!e || !e.segments || e.segments.length === 0)
    return null;
  let i = 0, n;
  for (let r = 0; r < e.segments.length && (n = e.segments[r], i = n.videoTimingInfo ? n.videoTimingInfo.transmuxedPresentationEnd : i + n.duration, !(t <= i)); r++)
    ;
  const s = e.segments[e.segments.length - 1];
  if (s.videoTimingInfo && s.videoTimingInfo.transmuxedPresentationEnd < t)
    return null;
  if (t > i) {
    if (t > i + s.duration * a1)
      return null;
    n = s;
  }
  return {
    segment: n,
    estimatedStart: n.videoTimingInfo ? n.videoTimingInfo.transmuxedPresentationStart : i - n.duration,
    // Because videoTimingInfo is only set after transmux, it is the only way to get
    // accurate timing values.
    type: n.videoTimingInfo ? "accurate" : "estimate"
  };
}, tU = (t, e) => {
  let i, n;
  try {
    i = new Date(t), n = new Date(e);
  } catch {
  }
  const s = i.getTime();
  return (n.getTime() - s) / 1e3;
}, iU = (t) => {
  if (!t.segments || t.segments.length === 0)
    return !1;
  for (let e = 0; e < t.segments.length; e++)
    if (!t.segments[e].dateTimeObject)
      return !1;
  return !0;
}, nU = ({
  playlist: t,
  time: e = void 0,
  callback: i
}) => {
  if (!i)
    throw new Error("getProgramTime: callback must be provided");
  if (!t || e === void 0)
    return i({
      message: "getProgramTime: playlist and time must be provided"
    });
  const n = eU(e, t);
  if (!n)
    return i({
      message: "valid programTime was not found"
    });
  if (n.type === "estimate")
    return i({
      message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
      seekTime: n.estimatedStart
    });
  const s = {
    mediaSeconds: e
  }, r = Kz(e, n.segment);
  return r && (s.programDateTime = r.toISOString()), i(null, s);
}, o1 = ({
  programTime: t,
  playlist: e,
  retryCount: i = 2,
  seekTo: n,
  pauseAfterSeek: s = !0,
  tech: r,
  callback: a
}) => {
  if (!a)
    throw new Error("seekToProgramTime: callback must be provided");
  if (typeof t > "u" || !e || !n)
    return a({
      message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
  if (!e.endList && !r.hasStarted_)
    return a({
      message: "player must be playing a live stream to start buffering"
    });
  if (!iU(e))
    return a({
      message: "programDateTime tags must be provided in the manifest " + e.resolvedUri
    });
  const o = $z(t, e);
  if (!o)
    return a({
      message: `${t} was not found in the stream`
    });
  const l = o.segment, u = tU(l.dateTimeObject, t);
  if (o.type === "estimate") {
    if (i === 0)
      return a({
        message: `${t} is not buffered yet. Try again`
      });
    n(o.estimatedStart + u), r.one("seeked", () => {
      o1({
        programTime: t,
        playlist: e,
        retryCount: i - 1,
        seekTo: n,
        pauseAfterSeek: s,
        tech: r,
        callback: a
      });
    });
    return;
  }
  const d = l.start + u, c = () => a(null, r.currentTime());
  r.one("seeked", c), s && r.pause(), n(d);
}, Zf = (t, e) => {
  if (t.readyState === 4)
    return e();
}, sU = (t, e, i, n) => {
  let s = [], r, a = !1;
  const o = function(c, A, m, p) {
    return A.abort(), a = !0, i(c, A, m, p);
  }, l = function(c, A) {
    if (a)
      return;
    if (c)
      return c.metadata = Kr({
        requestType: n,
        request: A,
        error: c
      }), o(c, A, "", s);
    const m = A.responseText.substring(s && s.byteLength || 0, A.responseText.length);
    if (s = k6(s, ob(m, !0)), r = r || nl(s), s.length < 10 || r && s.length < r + 2)
      return Zf(A, () => o(c, A, "", s));
    const p = Wp(s);
    return p === "ts" && s.length < 188 ? Zf(A, () => o(c, A, "", s)) : !p && s.length < 376 ? Zf(A, () => o(c, A, "", s)) : o(null, A, p, s);
  }, d = e({
    uri: t,
    beforeSend(c) {
      c.overrideMimeType("text/plain; charset=x-user-defined"), c.addEventListener("progress", function({
        total: A,
        loaded: m
      }) {
        return zh(c, null, {
          statusCode: c.status
        }, l);
      });
    }
  }, function(c, A) {
    return zh(d, c, A, l);
  });
  return d;
}, {
  EventTarget: rU
} = Ae, Nv = function(t, e) {
  if (!t1(t, e) || t.sidx && e.sidx && (t.sidx.offset !== e.sidx.offset || t.sidx.length !== e.sidx.length))
    return !1;
  if (!t.sidx && e.sidx || t.sidx && !e.sidx || t.segments && !e.segments || !t.segments && e.segments)
    return !1;
  if (!t.segments && !e.segments)
    return !0;
  for (let i = 0; i < t.segments.length; i++) {
    const n = t.segments[i], s = e.segments[i];
    if (n.uri !== s.uri)
      return !1;
    if (!n.byterange && !s.byterange)
      continue;
    const r = n.byterange, a = s.byterange;
    if (r && !a || !r && a || r.offset !== a.offset || r.length !== a.length)
      return !1;
  }
  return !0;
}, aU = (t, e, i, n) => {
  const s = n.attributes.NAME || i;
  return `placeholder-uri-${t}-${e}-${s}`;
}, oU = ({
  mainXml: t,
  srcUrl: e,
  clientOffset: i,
  sidxMapping: n,
  previousManifest: s
}) => {
  const r = DR(t, {
    manifestUri: e,
    clientOffset: i,
    sidxMapping: n,
    previousManifest: s
  });
  return Qw(r, e, aU), r;
}, lU = (t, e) => {
  Co(t, (i, n, s, r) => {
    (!e.mediaGroups[n][s] || !(r in e.mediaGroups[n][s])) && delete t.mediaGroups[n][s][r];
  });
}, uU = (t, e, i) => {
  let n = !0, s = _t(t, {
    // These are top level properties that can be updated
    duration: e.duration,
    minimumUpdatePeriod: e.minimumUpdatePeriod,
    timelineStarts: e.timelineStarts
  });
  for (let r = 0; r < e.playlists.length; r++) {
    const a = e.playlists[r];
    if (a.sidx) {
      const l = ec(a.sidx);
      i && i[l] && i[l].sidx && Vp(a, i[l].sidx, a.sidx.resolvedUri);
    }
    const o = Rh(s, a, Nv);
    o && (s = o, n = !1);
  }
  return Co(e, (r, a, o, l) => {
    if (r.playlists && r.playlists.length) {
      const u = r.playlists[0].id, d = Rh(s, r.playlists[0], Nv);
      d && (s = d, l in s.mediaGroups[a][o] || (s.mediaGroups[a][o][l] = r), s.mediaGroups[a][o][l].playlists[0] = s.playlists[u], n = !1);
    }
  }), lU(s, e), e.minimumUpdatePeriod !== t.minimumUpdatePeriod && (n = !1), n ? null : s;
}, dU = (t, e) => (!t.map && !e.map || !!(t.map && e.map && t.map.byterange.offset === e.map.byterange.offset && t.map.byterange.length === e.map.byterange.length)) && t.uri === e.uri && t.byterange.offset === e.byterange.offset && t.byterange.length === e.byterange.length, Rv = (t, e) => {
  const i = {};
  for (const n in t) {
    const r = t[n].sidx;
    if (r) {
      const a = ec(r);
      if (!e[a])
        break;
      const o = e[a].sidxInfo;
      dU(o, r) && (i[a] = e[a]);
    }
  }
  return i;
}, cU = (t, e) => {
  let n = Rv(t.playlists, e);
  return Co(t, (s, r, a, o) => {
    if (s.playlists && s.playlists.length) {
      const l = s.playlists;
      n = _t(n, Rv(l, e));
    }
  }), n;
};
class Vh extends rU {
  // DashPlaylistLoader must accept either a src url or a playlist because subsequent
  // playlist loader setups from media groups will expect to be able to pass a playlist
  // (since there aren't external URLs to media playlists with DASH)
  constructor(e, i, n = {}, s) {
    super(), this.isPaused_ = !0, this.mainPlaylistLoader_ = s || this, s || (this.isMain_ = !0);
    const {
      withCredentials: r = !1
    } = n;
    if (this.vhs_ = i, this.withCredentials = r, this.addMetadataToTextTrack = n.addMetadataToTextTrack, !e)
      throw new Error("A non-empty playlist URL or object is required");
    this.on("minimumUpdatePeriod", () => {
      this.refreshXml_();
    }), this.on("mediaupdatetimeout", () => {
      this.refreshMedia_(this.media().id);
    }), this.state = "HAVE_NOTHING", this.loadedPlaylists_ = {}, this.logger_ = Fn("DashPlaylistLoader"), this.isMain_ ? (this.mainPlaylistLoader_.srcUrl = e, this.mainPlaylistLoader_.sidxMapping_ = {}) : this.childPlaylist_ = e;
  }
  get isPaused() {
    return this.isPaused_;
  }
  requestErrored_(e, i, n) {
    if (!this.request)
      return !0;
    if (this.request = null, e)
      return this.error = typeof e == "object" && !(e instanceof Error) ? e : {
        status: i.status,
        message: "DASH request error at URL: " + i.uri,
        response: i.response,
        // MEDIA_ERR_NETWORK
        code: 2,
        metadata: e.metadata
      }, n && (this.state = n), this.trigger("error"), !0;
  }
  /**
   * Verify that the container of the sidx segment can be parsed
   * and if it can, get and parse that segment.
   */
  addSidxSegments_(e, i, n) {
    const s = e.sidx && ec(e.sidx);
    if (!e.sidx || !s || this.mainPlaylistLoader_.sidxMapping_[s]) {
      ne.clearTimeout(this.mediaRequest_), this.mediaRequest_ = ne.setTimeout(() => n(!1), 0);
      return;
    }
    const r = Dd(e.sidx.resolvedUri), a = (l, u) => {
      if (this.requestErrored_(l, u, i))
        return;
      const d = this.mainPlaylistLoader_.sidxMapping_, {
        requestType: c
      } = u;
      let A;
      try {
        A = MR(it(u.response).subarray(8));
      } catch (m) {
        m.metadata = Kr({
          requestType: c,
          request: u,
          parseFailure: !0
        }), this.requestErrored_(m, u, i);
        return;
      }
      return d[s] = {
        sidxInfo: e.sidx,
        sidx: A
      }, Vp(e, A, e.sidx.resolvedUri), n(!0);
    }, o = "dash-sidx";
    this.request = sU(r, this.vhs_.xhr, (l, u, d, c) => {
      if (l)
        return a(l, u);
      if (!d || d !== "mp4") {
        const p = d || "unknown";
        return a({
          status: u.status,
          message: `Unsupported ${p} container type for sidx segment at URL: ${r}`,
          // response is just bytes in this case
          // but we really don't want to return that.
          response: "",
          playlist: e,
          internal: !0,
          playlistExclusionDuration: 1 / 0,
          // MEDIA_ERR_NETWORK
          code: 2
        }, u);
      }
      const {
        offset: A,
        length: m
      } = e.sidx.byterange;
      if (c.length >= m + A)
        return a(l, {
          response: c.subarray(A, A + m),
          status: u.status,
          uri: u.uri
        });
      this.request = this.vhs_.xhr({
        uri: r,
        responseType: "arraybuffer",
        requestType: "dash-sidx",
        headers: Uh({
          byterange: e.sidx.byterange
        })
      }, a);
    }, o);
  }
  dispose() {
    this.isPaused_ = !0, this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, ne.clearTimeout(this.minimumUpdatePeriodTimeout_), ne.clearTimeout(this.mediaRequest_), ne.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.off();
  }
  hasPendingRequest() {
    return this.request || this.mediaRequest_;
  }
  stopRequest() {
    if (this.request) {
      const e = this.request;
      this.request = null, e.onreadystatechange = null, e.abort();
    }
  }
  media(e) {
    if (!e)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    const i = this.state;
    if (typeof e == "string") {
      if (!this.mainPlaylistLoader_.main.playlists[e])
        throw new Error("Unknown playlist URI: " + e);
      e = this.mainPlaylistLoader_.main.playlists[e];
    }
    const n = !this.media_ || e.id !== this.media_.id;
    if (n && this.loadedPlaylists_[e.id] && this.loadedPlaylists_[e.id].endList) {
      this.state = "HAVE_METADATA", this.media_ = e, n && (this.trigger("mediachanging"), this.trigger("mediachange"));
      return;
    }
    n && (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(e, i, (s) => {
      this.haveMetadata({
        startingState: i,
        playlist: e
      });
    }));
  }
  haveMetadata({
    startingState: e,
    playlist: i
  }) {
    this.state = "HAVE_METADATA", this.loadedPlaylists_[i.id] = i, ne.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null, this.refreshMedia_(i.id), e === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
  }
  pause() {
    this.isPaused_ = !0, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), ne.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.isMain_ && (ne.clearTimeout(this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_), this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_ = null), this.state === "HAVE_NOTHING" && (this.started = !1);
  }
  load(e) {
    this.isPaused_ = !1, ne.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
    const i = this.media();
    if (e) {
      const n = i ? i.targetDuration / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = ne.setTimeout(() => this.load(), n);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    i && !i.endList ? (this.isMain_ && !this.minimumUpdatePeriodTimeout_ && (this.trigger("minimumUpdatePeriod"), this.updateMinimumUpdatePeriodTimeout_()), this.trigger("mediaupdatetimeout")) : this.trigger("loadedplaylist");
  }
  start() {
    if (this.started = !0, !this.isMain_) {
      ne.clearTimeout(this.mediaRequest_), this.mediaRequest_ = ne.setTimeout(() => this.haveMain_(), 0);
      return;
    }
    this.requestMain_((e, i) => {
      this.haveMain_(), !this.hasPendingRequest() && !this.media_ && this.media(this.mainPlaylistLoader_.main.playlists[0]);
    });
  }
  requestMain_(e) {
    const i = {
      manifestInfo: {
        uri: this.mainPlaylistLoader_.srcUrl
      }
    };
    this.trigger({
      type: "manifestrequeststart",
      metadata: i
    }), this.request = this.vhs_.xhr({
      uri: this.mainPlaylistLoader_.srcUrl,
      withCredentials: this.withCredentials,
      requestType: "dash-manifest"
    }, (n, s) => {
      if (n) {
        const {
          requestType: a
        } = s;
        n.metadata = Kr({
          requestType: a,
          request: s,
          error: n
        });
      }
      if (this.requestErrored_(n, s)) {
        this.state === "HAVE_NOTHING" && (this.started = !1);
        return;
      }
      this.trigger({
        type: "manifestrequestcomplete",
        metadata: i
      });
      const r = s.responseText !== this.mainPlaylistLoader_.mainXml_;
      if (this.mainPlaylistLoader_.mainXml_ = s.responseText, s.responseHeaders && s.responseHeaders.date ? this.mainLoaded_ = Date.parse(s.responseHeaders.date) : this.mainLoaded_ = Date.now(), this.mainPlaylistLoader_.srcUrl = Dd(this.mainPlaylistLoader_.srcUrl, s), r) {
        this.handleMain_(), this.syncClientServerClock_(() => e(s, r));
        return;
      }
      return e(s, r);
    });
  }
  /**
   * Parses the main xml for UTCTiming node to sync the client clock to the server
   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
   *
   * @param {Function} done
   *        Function to call when clock sync has completed
   */
  syncClientServerClock_(e) {
    const i = _R(this.mainPlaylistLoader_.mainXml_);
    if (i === null)
      return this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
    if (i.method === "DIRECT")
      return this.mainPlaylistLoader_.clientOffset_ = i.value - Date.now(), e();
    this.request = this.vhs_.xhr({
      uri: rn(this.mainPlaylistLoader_.srcUrl, i.value),
      method: i.method,
      withCredentials: this.withCredentials,
      requestType: "dash-clock-sync"
    }, (n, s) => {
      if (!this.request)
        return;
      if (n) {
        const {
          requestType: a
        } = s;
        return this.error.metadata = Kr({
          requestType: a,
          request: s,
          error: n
        }), this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
      }
      let r;
      i.method === "HEAD" ? !s.responseHeaders || !s.responseHeaders.date ? r = this.mainLoaded_ : r = Date.parse(s.responseHeaders.date) : r = Date.parse(s.responseText), this.mainPlaylistLoader_.clientOffset_ = r - Date.now(), e();
    });
  }
  haveMain_() {
    this.state = "HAVE_MAIN_MANIFEST", this.isMain_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_);
  }
  handleMain_() {
    ne.clearTimeout(this.mediaRequest_), this.mediaRequest_ = null;
    const e = this.mainPlaylistLoader_.main, i = {
      manifestInfo: {
        uri: this.mainPlaylistLoader_.srcUrl
      }
    };
    this.trigger({
      type: "manifestparsestart",
      metadata: i
    });
    let n;
    try {
      n = oU({
        mainXml: this.mainPlaylistLoader_.mainXml_,
        srcUrl: this.mainPlaylistLoader_.srcUrl,
        clientOffset: this.mainPlaylistLoader_.clientOffset_,
        sidxMapping: this.mainPlaylistLoader_.sidxMapping_,
        previousManifest: e
      });
    } catch (r) {
      this.error = r, this.error.metadata = {
        errorType: Ae.Error.StreamingDashManifestParserError,
        error: r
      }, this.trigger("error");
    }
    e && (n = uU(e, n, this.mainPlaylistLoader_.sidxMapping_)), this.mainPlaylistLoader_.main = n || e;
    const s = this.mainPlaylistLoader_.main.locations && this.mainPlaylistLoader_.main.locations[0];
    if (s && s !== this.mainPlaylistLoader_.srcUrl && (this.mainPlaylistLoader_.srcUrl = s), (!e || n && n.minimumUpdatePeriod !== e.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), this.addEventStreamToMetadataTrack_(n), n) {
      const {
        duration: r,
        endList: a
      } = n, o = [];
      n.playlists.forEach((u) => {
        o.push({
          id: u.id,
          bandwidth: u.attributes.BANDWIDTH,
          resolution: u.attributes.RESOLUTION,
          codecs: u.attributes.CODECS
        });
      });
      const l = {
        duration: r,
        isLive: !a,
        renditions: o
      };
      i.parsedManifest = l, this.trigger({
        type: "manifestparsecomplete",
        metadata: i
      });
    }
    return !!n;
  }
  updateMinimumUpdatePeriodTimeout_() {
    const e = this.mainPlaylistLoader_;
    e.createMupOnMedia_ && (e.off("loadedmetadata", e.createMupOnMedia_), e.createMupOnMedia_ = null), e.minimumUpdatePeriodTimeout_ && (ne.clearTimeout(e.minimumUpdatePeriodTimeout_), e.minimumUpdatePeriodTimeout_ = null);
    let i = e.main && e.main.minimumUpdatePeriod;
    if (i === 0 && (e.media() ? i = e.media().targetDuration * 1e3 : (e.createMupOnMedia_ = e.updateMinimumUpdatePeriodTimeout_, e.one("loadedmetadata", e.createMupOnMedia_))), typeof i != "number" || i <= 0) {
      i < 0 && this.logger_(`found invalid minimumUpdatePeriod of ${i}, not setting a timeout`);
      return;
    }
    this.createMUPTimeout_(i);
  }
  createMUPTimeout_(e) {
    const i = this.mainPlaylistLoader_;
    i.minimumUpdatePeriodTimeout_ = ne.setTimeout(() => {
      i.minimumUpdatePeriodTimeout_ = null, i.trigger("minimumUpdatePeriod"), i.createMUPTimeout_(e);
    }, e);
  }
  /**
   * Sends request to refresh the main xml and updates the parsed main manifest
   */
  refreshXml_() {
    this.requestMain_((e, i) => {
      i && (this.media_ && (this.media_ = this.mainPlaylistLoader_.main.playlists[this.media_.id]), this.mainPlaylistLoader_.sidxMapping_ = cU(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.sidxMapping_), this.addSidxSegments_(this.media(), this.state, (n) => {
        this.refreshMedia_(this.media().id);
      }));
    });
  }
  /**
   * Refreshes the media playlist by re-parsing the main xml and updating playlist
   * references. If this is an alternate loader, the updated parsed manifest is retrieved
   * from the main loader.
   */
  refreshMedia_(e) {
    if (!e)
      throw new Error("refreshMedia_ must take a media id");
    this.media_ && this.isMain_ && this.handleMain_();
    const i = this.mainPlaylistLoader_.main.playlists, n = !this.media_ || this.media_ !== i[e];
    if (n ? this.media_ = i[e] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
      const s = () => {
        this.media().endList || (this.mediaUpdateTimeout = ne.setTimeout(() => {
          this.trigger("mediaupdatetimeout"), s();
        }, Fh(this.media(), !!n)));
      };
      s();
    }
    this.trigger("loadedplaylist");
  }
  /**
   * Takes eventstream data from a parsed DASH manifest and adds it to the metadata text track.
   *
   * @param {manifest} newMain the newly parsed manifest
   */
  addEventStreamToMetadataTrack_(e) {
    if (e && this.mainPlaylistLoader_.main.eventStream) {
      const i = this.mainPlaylistLoader_.main.eventStream.map((n) => ({
        cueTime: n.start,
        frames: [{
          data: n.messageData
        }]
      }));
      this.addMetadataToTextTrack("EventStream", i, this.mainPlaylistLoader_.main.duration);
    }
  }
  /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */
  getKeyIdSet(e) {
    if (e.contentProtection) {
      const i = /* @__PURE__ */ new Set();
      for (const n in e.contentProtection) {
        const s = e.contentProtection[n].attributes["cenc:default_KID"];
        s && i.add(s.replace(/-/g, "").toLowerCase());
      }
      return i;
    }
  }
}
var Si = {
  GOAL_BUFFER_LENGTH: 30,
  MAX_GOAL_BUFFER_LENGTH: 60,
  BACK_BUFFER_LENGTH: 30,
  GOAL_BUFFER_LENGTH_RATE: 1,
  // 0.5 MB/s
  INITIAL_BANDWIDTH: 4194304,
  // A fudge factor to apply to advertised playlist bitrates to account for
  // temporary flucations in client bandwidth
  BANDWIDTH_VARIANCE: 1.2,
  // How much of the buffer must be filled before we consider upswitching
  BUFFER_LOW_WATER_LINE: 0,
  MAX_BUFFER_LOW_WATER_LINE: 30,
  // TODO: Remove this when experimentalBufferBasedABR is removed
  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
  BUFFER_LOW_WATER_LINE_RATE: 1,
  // If the buffer is greater than the high water line, we won't switch down
  BUFFER_HIGH_WATER_LINE: 30
};
const fU = (t) => {
  const e = new Uint8Array(new ArrayBuffer(t.length));
  for (let i = 0; i < t.length; i++)
    e[i] = t.charCodeAt(i);
  return e.buffer;
}, l1 = function(t) {
  return t.on = t.addEventListener, t.off = t.removeEventListener, t;
}, hU = function(t) {
  try {
    return URL.createObjectURL(new Blob([t], {
      type: "application/javascript"
    }));
  } catch {
    const i = new BlobBuilder();
    return i.append(t), URL.createObjectURL(i.getBlob());
  }
}, u1 = function(t) {
  return function() {
    const e = hU(t), i = l1(new Worker(e));
    i.objURL = e;
    const n = i.terminate;
    return i.on = i.addEventListener, i.off = i.removeEventListener, i.terminate = function() {
      return URL.revokeObjectURL(e), n.call(this);
    }, i;
  };
}, d1 = function(t) {
  return `var browserWorkerPolyFill = ${l1.toString()};
browserWorkerPolyFill(self);
` + t;
}, c1 = function(t) {
  return t.toString().replace(/^function.+?{/, "").slice(0, -1);
}, pU = d1(c1(function() {
  var t = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, e = function() {
    this.init = function() {
      var f = {};
      this.on = function(v, S) {
        f[v] || (f[v] = []), f[v] = f[v].concat(S);
      }, this.off = function(v, S) {
        var T;
        return f[v] ? (T = f[v].indexOf(S), f[v] = f[v].slice(), f[v].splice(T, 1), T > -1) : !1;
      }, this.trigger = function(v) {
        var S, T, E, P;
        if (S = f[v], !!S)
          if (arguments.length === 2)
            for (E = S.length, T = 0; T < E; ++T)
              S[T].call(this, arguments[1]);
          else {
            for (P = [], T = arguments.length, T = 1; T < arguments.length; ++T)
              P.push(arguments[T]);
            for (E = S.length, T = 0; T < E; ++T)
              S[T].apply(this, P);
          }
      }, this.dispose = function() {
        f = {};
      };
    };
  };
  e.prototype.pipe = function(f) {
    return this.on("data", function(v) {
      f.push(v);
    }), this.on("done", function(v) {
      f.flush(v);
    }), this.on("partialdone", function(v) {
      f.partialFlush(v);
    }), this.on("endedtimeline", function(v) {
      f.endTimeline(v);
    }), this.on("reset", function(v) {
      f.reset(v);
    }), f;
  }, e.prototype.push = function(f) {
    this.trigger("data", f);
  }, e.prototype.flush = function(f) {
    this.trigger("done", f);
  }, e.prototype.partialFlush = function(f) {
    this.trigger("partialdone", f);
  }, e.prototype.endTimeline = function(f) {
    this.trigger("endedtimeline", f);
  }, e.prototype.reset = function(f) {
    this.trigger("reset", f);
  };
  var i = e, n = Math.pow(2, 32), s = function(f) {
    var v = new DataView(f.buffer, f.byteOffset, f.byteLength), S;
    return v.getBigUint64 ? (S = v.getBigUint64(0), S < Number.MAX_SAFE_INTEGER ? Number(S) : S) : v.getUint32(0) * n + v.getUint32(4);
  }, r = {
    getUint64: s,
    MAX_UINT32: n
  }, a = r.MAX_UINT32, o, l, u, d, c, A, m, p, h, g, w, b, y, D, I, M, _, N, x, C, L, V, H, O, X, q, F, W, j, oe, $, ye, ae, ce, te, le;
  (function() {
    var f;
    if (H = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      // codingname
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      smhd: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      styp: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: []
    }, !(typeof Uint8Array > "u")) {
      for (f in H)
        H.hasOwnProperty(f) && (H[f] = [f.charCodeAt(0), f.charCodeAt(1), f.charCodeAt(2), f.charCodeAt(3)]);
      O = new Uint8Array([105, 115, 111, 109]), q = new Uint8Array([97, 118, 99, 49]), X = new Uint8Array([0, 0, 0, 1]), F = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        118,
        105,
        100,
        101,
        // handler_type: 'vide'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        86,
        105,
        100,
        101,
        111,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'VideoHandler'
      ]), W = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        115,
        111,
        117,
        110,
        // handler_type: 'soun'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'SoundHandler'
      ]), j = {
        video: F,
        audio: W
      }, ye = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1,
        // entry_count
        0,
        0,
        0,
        12,
        // entry_size
        117,
        114,
        108,
        32,
        // 'url' type
        0,
        // version 0
        0,
        0,
        1
        // entry_flags
      ]), $ = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        // balance, 0 means centered
        0,
        0
        // reserved
      ]), ae = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0
        // entry_count
      ]), ce = ae, te = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // sample_size
        0,
        0,
        0,
        0
        // sample_count
      ]), le = ae, oe = new Uint8Array([
        0,
        // version
        0,
        0,
        1,
        // flags
        0,
        0,
        // graphicsmode
        0,
        0,
        0,
        0,
        0,
        0
        // opcolor
      ]);
    }
  })(), o = function(f) {
    var v = [], S = 0, T, E, P;
    for (T = 1; T < arguments.length; T++)
      v.push(arguments[T]);
    for (T = v.length; T--; )
      S += v[T].byteLength;
    for (E = new Uint8Array(S + 8), P = new DataView(E.buffer, E.byteOffset, E.byteLength), P.setUint32(0, E.byteLength), E.set(f, 4), T = 0, S = 8; T < v.length; T++)
      E.set(v[T], S), S += v[T].byteLength;
    return E;
  }, l = function() {
    return o(H.dinf, o(H.dref, ye));
  }, u = function(f) {
    return o(H.esds, new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      // ES_Descriptor
      3,
      // tag, ES_DescrTag
      25,
      // length
      0,
      0,
      // ES_ID
      0,
      // streamDependenceFlag, URL_flag, reserved, streamPriority
      // DecoderConfigDescriptor
      4,
      // tag, DecoderConfigDescrTag
      17,
      // length
      64,
      // object type
      21,
      // streamType
      0,
      6,
      0,
      // bufferSizeDB
      0,
      0,
      218,
      192,
      // maxBitrate
      0,
      0,
      218,
      192,
      // avgBitrate
      // DecoderSpecificInfo
      5,
      // tag, DecoderSpecificInfoTag
      2,
      // length
      // ISO/IEC 14496-3, AudioSpecificConfig
      // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
      f.audioobjecttype << 3 | f.samplingfrequencyindex >>> 1,
      f.samplingfrequencyindex << 7 | f.channelcount << 3,
      6,
      1,
      2
      // GASpecificConfig
    ]));
  }, d = function() {
    return o(H.ftyp, O, X, O, q);
  }, M = function(f) {
    return o(H.hdlr, j[f]);
  }, c = function(f) {
    return o(H.mdat, f);
  }, I = function(f) {
    var v = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      3,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      f.duration >>> 24 & 255,
      f.duration >>> 16 & 255,
      f.duration >>> 8 & 255,
      f.duration & 255,
      // duration
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]);
    return f.samplerate && (v[12] = f.samplerate >>> 24 & 255, v[13] = f.samplerate >>> 16 & 255, v[14] = f.samplerate >>> 8 & 255, v[15] = f.samplerate & 255), o(H.mdhd, v);
  }, D = function(f) {
    return o(H.mdia, I(f), M(f.type), m(f));
  }, A = function(f) {
    return o(H.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      (f & 4278190080) >> 24,
      (f & 16711680) >> 16,
      (f & 65280) >> 8,
      f & 255
      // sequence_number
    ]));
  }, m = function(f) {
    return o(H.minf, f.type === "video" ? o(H.vmhd, oe) : o(H.smhd, $), l(), N(f));
  }, p = function(f, v) {
    for (var S = [], T = v.length; T--; )
      S[T] = C(v[T]);
    return o.apply(null, [H.moof, A(f)].concat(S));
  }, h = function(f) {
    for (var v = f.length, S = []; v--; )
      S[v] = b(f[v]);
    return o.apply(null, [H.moov, w(4294967295)].concat(S).concat(g(f)));
  }, g = function(f) {
    for (var v = f.length, S = []; v--; )
      S[v] = L(f[v]);
    return o.apply(null, [H.mvex].concat(S));
  }, w = function(f) {
    var v = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // creation_time
      0,
      0,
      0,
      2,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      (f & 4278190080) >> 24,
      (f & 16711680) >> 16,
      (f & 65280) >> 8,
      f & 255,
      // duration
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return o(H.mvhd, v);
  }, _ = function(f) {
    var v = f.samples || [], S = new Uint8Array(4 + v.length), T, E;
    for (E = 0; E < v.length; E++)
      T = v[E].flags, S[E + 4] = T.dependsOn << 4 | T.isDependedOn << 2 | T.hasRedundancy;
    return o(H.sdtp, S);
  }, N = function(f) {
    return o(H.stbl, x(f), o(H.stts, le), o(H.stsc, ce), o(H.stsz, te), o(H.stco, ae));
  }, function() {
    var f, v;
    x = function(S) {
      return o(H.stsd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1
      ]), S.type === "video" ? f(S) : v(S));
    }, f = function(S) {
      var T = S.sps || [], E = S.pps || [], P = [], G = [], Z, ee;
      for (Z = 0; Z < T.length; Z++)
        P.push((T[Z].byteLength & 65280) >>> 8), P.push(T[Z].byteLength & 255), P = P.concat(Array.prototype.slice.call(T[Z]));
      for (Z = 0; Z < E.length; Z++)
        G.push((E[Z].byteLength & 65280) >>> 8), G.push(E[Z].byteLength & 255), G = G.concat(Array.prototype.slice.call(E[Z]));
      if (ee = [H.avc1, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        (S.width & 65280) >> 8,
        S.width & 255,
        // width
        (S.height & 65280) >> 8,
        S.height & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        19,
        118,
        105,
        100,
        101,
        111,
        106,
        115,
        45,
        99,
        111,
        110,
        116,
        114,
        105,
        98,
        45,
        104,
        108,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
        // pre_defined = -1
      ]), o(H.avcC, new Uint8Array([
        1,
        // configurationVersion
        S.profileIdc,
        // AVCProfileIndication
        S.profileCompatibility,
        // profile_compatibility
        S.levelIdc,
        // AVCLevelIndication
        255
        // lengthSizeMinusOne, hard-coded to 4 bytes
      ].concat(
        [T.length],
        // numOfSequenceParameterSets
        P,
        // "SPS"
        [E.length],
        // numOfPictureParameterSets
        G
        // "PPS"
      ))), o(H.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
        // avgBitrate
      ]))], S.sarRatio) {
        var se = S.sarRatio[0], fe = S.sarRatio[1];
        ee.push(o(H.pasp, new Uint8Array([(se & 4278190080) >> 24, (se & 16711680) >> 16, (se & 65280) >> 8, se & 255, (fe & 4278190080) >> 24, (fe & 16711680) >> 16, (fe & 65280) >> 8, fe & 255])));
      }
      return o.apply(null, ee);
    }, v = function(S) {
      return o(H.mp4a, new Uint8Array([
        // SampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        // AudioSampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        (S.channelcount & 65280) >> 8,
        S.channelcount & 255,
        // channelcount
        (S.samplesize & 65280) >> 8,
        S.samplesize & 255,
        // samplesize
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        (S.samplerate & 65280) >> 8,
        S.samplerate & 255,
        0,
        0
        // samplerate, 16.16
        // MP4AudioSampleEntry, ISO/IEC 14496-14
      ]), u(S));
    };
  }(), y = function(f) {
    var v = new Uint8Array([
      0,
      // version 0
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      // creation_time
      0,
      0,
      0,
      0,
      // modification_time
      (f.id & 4278190080) >> 24,
      (f.id & 16711680) >> 16,
      (f.id & 65280) >> 8,
      f.id & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      (f.duration & 4278190080) >> 24,
      (f.duration & 16711680) >> 16,
      (f.duration & 65280) >> 8,
      f.duration & 255,
      // duration
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      1,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      (f.width & 65280) >> 8,
      f.width & 255,
      0,
      0,
      // width
      (f.height & 65280) >> 8,
      f.height & 255,
      0,
      0
      // height
    ]);
    return o(H.tkhd, v);
  }, C = function(f) {
    var v, S, T, E, P, G, Z;
    return v = o(H.tfhd, new Uint8Array([
      0,
      // version 0
      0,
      0,
      58,
      // flags
      (f.id & 4278190080) >> 24,
      (f.id & 16711680) >> 16,
      (f.id & 65280) >> 8,
      f.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      0,
      0,
      0
      // default_sample_flags
    ])), G = Math.floor(f.baseMediaDecodeTime / a), Z = Math.floor(f.baseMediaDecodeTime % a), S = o(H.tfdt, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      // baseMediaDecodeTime
      G >>> 24 & 255,
      G >>> 16 & 255,
      G >>> 8 & 255,
      G & 255,
      Z >>> 24 & 255,
      Z >>> 16 & 255,
      Z >>> 8 & 255,
      Z & 255
    ])), P = 92, f.type === "audio" ? (T = V(f, P), o(H.traf, v, S, T)) : (E = _(f), T = V(f, E.length + P), o(H.traf, v, S, T, E));
  }, b = function(f) {
    return f.duration = f.duration || 4294967295, o(H.trak, y(f), D(f));
  }, L = function(f) {
    var v = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      (f.id & 4278190080) >> 24,
      (f.id & 16711680) >> 16,
      (f.id & 65280) >> 8,
      f.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]);
    return f.type !== "video" && (v[v.length - 1] = 0), o(H.trex, v);
  }, function() {
    var f, v, S;
    S = function(T, E) {
      var P = 0, G = 0, Z = 0, ee = 0;
      return T.length && (T[0].duration !== void 0 && (P = 1), T[0].size !== void 0 && (G = 2), T[0].flags !== void 0 && (Z = 4), T[0].compositionTimeOffset !== void 0 && (ee = 8)), [
        0,
        // version 0
        0,
        P | G | Z | ee,
        1,
        // flags
        (T.length & 4278190080) >>> 24,
        (T.length & 16711680) >>> 16,
        (T.length & 65280) >>> 8,
        T.length & 255,
        // sample_count
        (E & 4278190080) >>> 24,
        (E & 16711680) >>> 16,
        (E & 65280) >>> 8,
        E & 255
        // data_offset
      ];
    }, v = function(T, E) {
      var P, G, Z, ee, se, fe;
      for (ee = T.samples || [], E += 20 + 16 * ee.length, Z = S(ee, E), G = new Uint8Array(Z.length + ee.length * 16), G.set(Z), P = Z.length, fe = 0; fe < ee.length; fe++)
        se = ee[fe], G[P++] = (se.duration & 4278190080) >>> 24, G[P++] = (se.duration & 16711680) >>> 16, G[P++] = (se.duration & 65280) >>> 8, G[P++] = se.duration & 255, G[P++] = (se.size & 4278190080) >>> 24, G[P++] = (se.size & 16711680) >>> 16, G[P++] = (se.size & 65280) >>> 8, G[P++] = se.size & 255, G[P++] = se.flags.isLeading << 2 | se.flags.dependsOn, G[P++] = se.flags.isDependedOn << 6 | se.flags.hasRedundancy << 4 | se.flags.paddingValue << 1 | se.flags.isNonSyncSample, G[P++] = se.flags.degradationPriority & 61440, G[P++] = se.flags.degradationPriority & 15, G[P++] = (se.compositionTimeOffset & 4278190080) >>> 24, G[P++] = (se.compositionTimeOffset & 16711680) >>> 16, G[P++] = (se.compositionTimeOffset & 65280) >>> 8, G[P++] = se.compositionTimeOffset & 255;
      return o(H.trun, G);
    }, f = function(T, E) {
      var P, G, Z, ee, se, fe;
      for (ee = T.samples || [], E += 20 + 8 * ee.length, Z = S(ee, E), P = new Uint8Array(Z.length + ee.length * 8), P.set(Z), G = Z.length, fe = 0; fe < ee.length; fe++)
        se = ee[fe], P[G++] = (se.duration & 4278190080) >>> 24, P[G++] = (se.duration & 16711680) >>> 16, P[G++] = (se.duration & 65280) >>> 8, P[G++] = se.duration & 255, P[G++] = (se.size & 4278190080) >>> 24, P[G++] = (se.size & 16711680) >>> 16, P[G++] = (se.size & 65280) >>> 8, P[G++] = se.size & 255;
      return o(H.trun, P);
    }, V = function(T, E) {
      return T.type === "audio" ? f(T, E) : v(T, E);
    };
  }();
  var B = {
    ftyp: d,
    mdat: c,
    moof: p,
    moov: h,
    initSegment: function(f) {
      var v = d(), S = h(f), T;
      return T = new Uint8Array(v.byteLength + S.byteLength), T.set(v), T.set(S, v.byteLength), T;
    }
  }, ue = function(f) {
    var v, S, T = [], E = [];
    for (E.byteLength = 0, E.nalCount = 0, E.duration = 0, T.byteLength = 0, v = 0; v < f.length; v++)
      S = f[v], S.nalUnitType === "access_unit_delimiter_rbsp" ? (T.length && (T.duration = S.dts - T.dts, E.byteLength += T.byteLength, E.nalCount += T.length, E.duration += T.duration, E.push(T)), T = [S], T.byteLength = S.data.byteLength, T.pts = S.pts, T.dts = S.dts) : (S.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (T.keyFrame = !0), T.duration = S.dts - T.dts, T.byteLength += S.data.byteLength, T.push(S));
    return E.length && (!T.duration || T.duration <= 0) && (T.duration = E[E.length - 1].duration), E.byteLength += T.byteLength, E.nalCount += T.length, E.duration += T.duration, E.push(T), E;
  }, Pe = function(f) {
    var v, S, T = [], E = [];
    for (T.byteLength = 0, T.nalCount = 0, T.duration = 0, T.pts = f[0].pts, T.dts = f[0].dts, E.byteLength = 0, E.nalCount = 0, E.duration = 0, E.pts = f[0].pts, E.dts = f[0].dts, v = 0; v < f.length; v++)
      S = f[v], S.keyFrame ? (T.length && (E.push(T), E.byteLength += T.byteLength, E.nalCount += T.nalCount, E.duration += T.duration), T = [S], T.nalCount = S.length, T.byteLength = S.byteLength, T.pts = S.pts, T.dts = S.dts, T.duration = S.duration) : (T.duration += S.duration, T.nalCount += S.length, T.byteLength += S.byteLength, T.push(S));
    return E.length && T.duration <= 0 && (T.duration = E[E.length - 1].duration), E.byteLength += T.byteLength, E.nalCount += T.nalCount, E.duration += T.duration, E.push(T), E;
  }, nt = function(f) {
    var v;
    return !f[0][0].keyFrame && f.length > 1 && (v = f.shift(), f.byteLength -= v.byteLength, f.nalCount -= v.nalCount, f[0][0].dts = v.dts, f[0][0].pts = v.pts, f[0][0].duration += v.duration), f;
  }, ge = function() {
    return {
      size: 0,
      flags: {
        isLeading: 0,
        dependsOn: 1,
        isDependedOn: 0,
        hasRedundancy: 0,
        degradationPriority: 0,
        isNonSyncSample: 1
      }
    };
  }, Qe = function(f, v) {
    var S = ge();
    return S.dataOffset = v, S.compositionTimeOffset = f.pts - f.dts, S.duration = f.duration, S.size = 4 * f.length, S.size += f.byteLength, f.keyFrame && (S.flags.dependsOn = 2, S.flags.isNonSyncSample = 0), S;
  }, Ee = function(f, v) {
    var S, T, E, P, G, Z = v || 0, ee = [];
    for (S = 0; S < f.length; S++)
      for (P = f[S], T = 0; T < P.length; T++)
        G = P[T], E = Qe(G, Z), Z += E.size, ee.push(E);
    return ee;
  }, xe = function(f) {
    var v, S, T, E, P, G, Z = 0, ee = f.byteLength, se = f.nalCount, fe = ee + 4 * se, ve = new Uint8Array(fe), Ve = new DataView(ve.buffer);
    for (v = 0; v < f.length; v++)
      for (E = f[v], S = 0; S < E.length; S++)
        for (P = E[S], T = 0; T < P.length; T++)
          G = P[T], Ve.setUint32(Z, G.data.byteLength), Z += 4, ve.set(G.data, Z), Z += G.data.byteLength;
    return ve;
  }, K = function(f, v) {
    var S, T = v || 0, E = [];
    return S = Qe(f, T), E.push(S), E;
  }, Ie = function(f) {
    var v, S, T = 0, E = f.byteLength, P = f.length, G = E + 4 * P, Z = new Uint8Array(G), ee = new DataView(Z.buffer);
    for (v = 0; v < f.length; v++)
      S = f[v], ee.setUint32(T, S.data.byteLength), T += 4, Z.set(S.data, T), T += S.data.byteLength;
    return Z;
  }, Be = {
    groupNalsIntoFrames: ue,
    groupFramesIntoGops: Pe,
    extendFirstKeyFrame: nt,
    generateSampleTable: Ee,
    concatenateNalData: xe,
    generateSampleTableForFrame: K,
    concatenateNalDataForFrame: Ie
  }, Me = [33, 16, 5, 32, 164, 27], Ke = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252], He = function(f) {
    for (var v = []; f--; )
      v.push(0);
    return v;
  }, Ge = function(f) {
    return Object.keys(f).reduce(function(v, S) {
      return v[S] = new Uint8Array(f[S].reduce(function(T, E) {
        return T.concat(E);
      }, [])), v;
    }, {});
  }, ot, he = function() {
    if (!ot) {
      var f = {
        96e3: [Me, [227, 64], He(154), [56]],
        88200: [Me, [231], He(170), [56]],
        64e3: [Me, [248, 192], He(240), [56]],
        48e3: [Me, [255, 192], He(268), [55, 148, 128], He(54), [112]],
        44100: [Me, [255, 192], He(268), [55, 163, 128], He(84), [112]],
        32e3: [Me, [255, 192], He(268), [55, 234], He(226), [112]],
        24e3: [Me, [255, 192], He(268), [55, 255, 128], He(268), [111, 112], He(126), [224]],
        16e3: [Me, [255, 192], He(268), [55, 255, 128], He(268), [111, 255], He(269), [223, 108], He(195), [1, 192]],
        12e3: [Ke, He(268), [3, 127, 248], He(268), [6, 255, 240], He(268), [13, 255, 224], He(268), [27, 253, 128], He(259), [56]],
        11025: [Ke, He(268), [3, 127, 248], He(268), [6, 255, 240], He(268), [13, 255, 224], He(268), [27, 255, 192], He(268), [55, 175, 128], He(108), [112]],
        8e3: [Ke, He(268), [3, 121, 16], He(47), [7]]
      };
      ot = Ge(f);
    }
    return ot;
  }, Re = 9e4, dt, St, Rt, je, Et, Mi, zn;
  dt = function(f) {
    return f * Re;
  }, St = function(f, v) {
    return f * v;
  }, Rt = function(f) {
    return f / Re;
  }, je = function(f, v) {
    return f / v;
  }, Et = function(f, v) {
    return dt(je(f, v));
  }, Mi = function(f, v) {
    return St(Rt(f), v);
  }, zn = function(f, v, S) {
    return Rt(S ? f : f - v);
  };
  var xt = {
    ONE_SECOND_IN_TS: Re,
    secondsToVideoTs: dt,
    secondsToAudioTs: St,
    videoTsToSeconds: Rt,
    audioTsToSeconds: je,
    audioTsToVideoTs: Et,
    videoTsToAudioTs: Mi,
    metadataTsToSeconds: zn
  }, Gs = he, Un = xt, Qs = function(f) {
    var v, S, T = 0;
    for (v = 0; v < f.length; v++)
      S = f[v], T += S.data.byteLength;
    return T;
  }, Ps = function(f, v, S, T) {
    var E, P = 0, G = 0, Z = 0, ee = 0, se, fe, ve;
    if (v.length && (E = Un.audioTsToVideoTs(f.baseMediaDecodeTime, f.samplerate), P = Math.ceil(Un.ONE_SECOND_IN_TS / (f.samplerate / 1024)), S && T && (G = E - Math.max(S, T), Z = Math.floor(G / P), ee = Z * P), !(Z < 1 || ee > Un.ONE_SECOND_IN_TS / 2))) {
      for (se = Gs()[f.samplerate], se || (se = v[0].data), fe = 0; fe < Z; fe++)
        ve = v[0], v.splice(0, 0, {
          data: se,
          dts: ve.dts - P,
          pts: ve.pts - P
        });
      return f.baseMediaDecodeTime -= Math.floor(Un.videoTsToAudioTs(ee, f.samplerate)), ee;
    }
  }, Cn = function(f, v, S) {
    return v.minSegmentDts >= S ? f : (v.minSegmentDts = 1 / 0, f.filter(function(T) {
      return T.dts >= S ? (v.minSegmentDts = Math.min(v.minSegmentDts, T.dts), v.minSegmentPts = v.minSegmentDts, !0) : !1;
    }));
  }, me = function(f) {
    var v, S, T = [];
    for (v = 0; v < f.length; v++)
      S = f[v], T.push({
        size: S.data.byteLength,
        duration: 1024
        // For AAC audio, all samples contain 1024 samples
      });
    return T;
  }, Le = function(f) {
    var v, S, T = 0, E = new Uint8Array(Qs(f));
    for (v = 0; v < f.length; v++)
      S = f[v], E.set(S.data, T), T += S.data.byteLength;
    return E;
  }, Je = {
    prefixWithSilence: Ps,
    trimAdtsFramesByEarliestDts: Cn,
    generateSampleTable: me,
    concatenateFrameData: Le
  }, z = xt.ONE_SECOND_IN_TS, R = function(f, v) {
    typeof v.pts == "number" && (f.timelineStartInfo.pts === void 0 && (f.timelineStartInfo.pts = v.pts), f.minSegmentPts === void 0 ? f.minSegmentPts = v.pts : f.minSegmentPts = Math.min(f.minSegmentPts, v.pts), f.maxSegmentPts === void 0 ? f.maxSegmentPts = v.pts : f.maxSegmentPts = Math.max(f.maxSegmentPts, v.pts)), typeof v.dts == "number" && (f.timelineStartInfo.dts === void 0 && (f.timelineStartInfo.dts = v.dts), f.minSegmentDts === void 0 ? f.minSegmentDts = v.dts : f.minSegmentDts = Math.min(f.minSegmentDts, v.dts), f.maxSegmentDts === void 0 ? f.maxSegmentDts = v.dts : f.maxSegmentDts = Math.max(f.maxSegmentDts, v.dts));
  }, Q = function(f) {
    delete f.minSegmentDts, delete f.maxSegmentDts, delete f.minSegmentPts, delete f.maxSegmentPts;
  }, de = function(f, v) {
    var S, T, E = f.minSegmentDts;
    return v || (E -= f.timelineStartInfo.dts), S = f.timelineStartInfo.baseMediaDecodeTime, S += E, S = Math.max(0, S), f.type === "audio" && (T = f.samplerate / z, S *= T, S = Math.floor(S)), S;
  }, Fe = {
    clearDtsInfo: Q,
    calculateTrackBaseMediaDecodeTime: de,
    collectDtsInfo: R
  }, Ze = 4, bt = 128, Vt = function(f) {
    for (var v = 0, S = {
      payloadType: -1,
      payloadSize: 0
    }, T = 0, E = 0; v < f.byteLength && f[v] !== bt; ) {
      for (; f[v] === 255; )
        T += 255, v++;
      for (T += f[v++]; f[v] === 255; )
        E += 255, v++;
      if (E += f[v++], !S.payload && T === Ze) {
        var P = String.fromCharCode(f[v + 3], f[v + 4], f[v + 5], f[v + 6]);
        if (P === "GA94") {
          S.payloadType = T, S.payloadSize = E, S.payload = f.subarray(v, v + E);
          break;
        } else
          S.payload = void 0;
      }
      v += E, T = 0, E = 0;
    }
    return S;
  }, Xi = function(f) {
    return f.payload[0] !== 181 || (f.payload[1] << 8 | f.payload[2]) !== 49 || String.fromCharCode(f.payload[3], f.payload[4], f.payload[5], f.payload[6]) !== "GA94" || f.payload[7] !== 3 ? null : f.payload.subarray(8, f.payload.length - 1);
  }, En = function(f, v) {
    var S = [], T, E, P, G;
    if (!(v[0] & 64))
      return S;
    for (E = v[0] & 31, T = 0; T < E; T++)
      P = T * 3, G = {
        type: v[P + 2] & 3,
        pts: f
      }, v[P + 2] & 4 && (G.ccData = v[P + 3] << 8 | v[P + 4], S.push(G));
    return S;
  }, Vn = function(f) {
    for (var v = f.byteLength, S = [], T = 1, E, P; T < v - 2; )
      f[T] === 0 && f[T + 1] === 0 && f[T + 2] === 3 ? (S.push(T + 2), T += 2) : T++;
    if (S.length === 0)
      return f;
    E = v - S.length, P = new Uint8Array(E);
    var G = 0;
    for (T = 0; T < E; G++, T++)
      G === S[0] && (G++, S.shift()), P[T] = f[G];
    return P;
  }, ls = {
    parseSei: Vt,
    parseUserData: Xi,
    parseCaptionPackets: En,
    discardEmulationPreventionBytes: Vn,
    USER_DATA_REGISTERED_ITU_T_T35: Ze
  }, qn = i, Dn = ls, qt = function(f) {
    f = f || {}, qt.prototype.init.call(this), this.parse708captions_ = typeof f.parse708captions == "boolean" ? f.parse708captions : !0, this.captionPackets_ = [], this.ccStreams_ = [
      new Gt(0, 0),
      // eslint-disable-line no-use-before-define
      new Gt(0, 1),
      // eslint-disable-line no-use-before-define
      new Gt(1, 0),
      // eslint-disable-line no-use-before-define
      new Gt(1, 1)
      // eslint-disable-line no-use-before-define
    ], this.parse708captions_ && (this.cc708Stream_ = new Dt({
      captionServices: f.captionServices
    })), this.reset(), this.ccStreams_.forEach(function(v) {
      v.on("data", this.trigger.bind(this, "data")), v.on("partialdone", this.trigger.bind(this, "partialdone")), v.on("done", this.trigger.bind(this, "done"));
    }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
  };
  qt.prototype = new qn(), qt.prototype.push = function(f) {
    var v, S, T;
    if (f.nalUnitType === "sei_rbsp" && (v = Dn.parseSei(f.escapedRBSP), !!v.payload && v.payloadType === Dn.USER_DATA_REGISTERED_ITU_T_T35 && (S = Dn.parseUserData(v), !!S))) {
      if (f.dts < this.latestDts_) {
        this.ignoreNextEqualDts_ = !0;
        return;
      } else if (f.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
        this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
        return;
      }
      T = Dn.parseCaptionPackets(f.pts, S), this.captionPackets_ = this.captionPackets_.concat(T), this.latestDts_ !== f.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = f.dts;
    }
  }, qt.prototype.flushCCStreams = function(f) {
    this.ccStreams_.forEach(function(v) {
      return f === "flush" ? v.flush() : v.partialFlush();
    }, this);
  }, qt.prototype.flushStream = function(f) {
    if (!this.captionPackets_.length) {
      this.flushCCStreams(f);
      return;
    }
    this.captionPackets_.forEach(function(v, S) {
      v.presortIndex = S;
    }), this.captionPackets_.sort(function(v, S) {
      return v.pts === S.pts ? v.presortIndex - S.presortIndex : v.pts - S.pts;
    }), this.captionPackets_.forEach(function(v) {
      v.type < 2 ? this.dispatchCea608Packet(v) : this.dispatchCea708Packet(v);
    }, this), this.captionPackets_.length = 0, this.flushCCStreams(f);
  }, qt.prototype.flush = function() {
    return this.flushStream("flush");
  }, qt.prototype.partialFlush = function() {
    return this.flushStream("partialFlush");
  }, qt.prototype.reset = function() {
    this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(f) {
      f.reset();
    });
  }, qt.prototype.dispatchCea608Packet = function(f) {
    this.setsTextOrXDSActive(f) ? this.activeCea608Channel_[f.type] = null : this.setsChannel1Active(f) ? this.activeCea608Channel_[f.type] = 0 : this.setsChannel2Active(f) && (this.activeCea608Channel_[f.type] = 1), this.activeCea608Channel_[f.type] !== null && this.ccStreams_[(f.type << 1) + this.activeCea608Channel_[f.type]].push(f);
  }, qt.prototype.setsChannel1Active = function(f) {
    return (f.ccData & 30720) === 4096;
  }, qt.prototype.setsChannel2Active = function(f) {
    return (f.ccData & 30720) === 6144;
  }, qt.prototype.setsTextOrXDSActive = function(f) {
    return (f.ccData & 28928) === 256 || (f.ccData & 30974) === 4138 || (f.ccData & 30974) === 6186;
  }, qt.prototype.dispatchCea708Packet = function(f) {
    this.parse708captions_ && this.cc708Stream_.push(f);
  };
  var Is = {
    127: 9834,
    // ♪
    4128: 32,
    // Transparent Space
    4129: 160,
    // Nob-breaking Transparent Space
    4133: 8230,
    // …
    4138: 352,
    // Š
    4140: 338,
    // Œ
    4144: 9608,
    // █
    4145: 8216,
    // ‘
    4146: 8217,
    // ’
    4147: 8220,
    // “
    4148: 8221,
    // ”
    4149: 8226,
    // •
    4153: 8482,
    // ™
    4154: 353,
    // š
    4156: 339,
    // œ
    4157: 8480,
    // ℠
    4159: 376,
    // Ÿ
    4214: 8539,
    // ⅛
    4215: 8540,
    // ⅜
    4216: 8541,
    // ⅝
    4217: 8542,
    // ⅞
    4218: 9168,
    // ⏐
    4219: 9124,
    // ⎤
    4220: 9123,
    // ⎣
    4221: 9135,
    // ⎯
    4222: 9126,
    // ⎦
    4223: 9121,
    // ⎡
    4256: 12600
    // ㄸ (CC char)
  }, Cr = function(f) {
    var v = Is[f] || f;
    return f & 4096 && f === v ? "" : String.fromCharCode(v);
  }, di = function(f) {
    return 32 <= f && f <= 127 || 160 <= f && f <= 255;
  }, _n = function(f) {
    this.windowNum = f, this.reset();
  };
  _n.prototype.reset = function() {
    this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
  }, _n.prototype.getText = function() {
    return this.rows.join(`
`);
  }, _n.prototype.clearText = function() {
    this.rows = [""], this.rowIdx = 0;
  }, _n.prototype.newLine = function(f) {
    for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(f), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount; )
      this.rows.shift(), this.rowIdx--;
  }, _n.prototype.isEmpty = function() {
    return this.rows.length === 0 ? !0 : this.rows.length === 1 ? this.rows[0] === "" : !1;
  }, _n.prototype.addText = function(f) {
    this.rows[this.rowIdx] += f;
  }, _n.prototype.backspace = function() {
    if (!this.isEmpty()) {
      var f = this.rows[this.rowIdx];
      this.rows[this.rowIdx] = f.substr(0, f.length - 1);
    }
  };
  var Hn = function(f, v, S) {
    this.serviceNum = f, this.text = "", this.currentWindow = new _n(-1), this.windows = [], this.stream = S, typeof v == "string" && this.createTextDecoder(v);
  };
  Hn.prototype.init = function(f, v) {
    this.startPts = f;
    for (var S = 0; S < 8; S++)
      this.windows[S] = new _n(S), typeof v == "function" && (this.windows[S].beforeRowOverflow = v);
  }, Hn.prototype.setCurrentWindow = function(f) {
    this.currentWindow = this.windows[f];
  }, Hn.prototype.createTextDecoder = function(f) {
    if (typeof TextDecoder > "u")
      this.stream.trigger("log", {
        level: "warn",
        message: "The `encoding` option is unsupported without TextDecoder support"
      });
    else
      try {
        this.textDecoder_ = new TextDecoder(f);
      } catch (v) {
        this.stream.trigger("log", {
          level: "warn",
          message: "TextDecoder could not be created with " + f + " encoding. " + v
        });
      }
  };
  var Dt = function(f) {
    f = f || {}, Dt.prototype.init.call(this);
    var v = this, S = f.captionServices || {}, T = {}, E;
    Object.keys(S).forEach((P) => {
      E = S[P], /^SERVICE/.test(P) && (T[P] = E.encoding);
    }), this.serviceEncodings = T, this.current708Packet = null, this.services = {}, this.push = function(P) {
      P.type === 3 ? (v.new708Packet(), v.add708Bytes(P)) : (v.current708Packet === null && v.new708Packet(), v.add708Bytes(P));
    };
  };
  Dt.prototype = new qn(), Dt.prototype.new708Packet = function() {
    this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
      data: [],
      ptsVals: []
    };
  }, Dt.prototype.add708Bytes = function(f) {
    var v = f.ccData, S = v >>> 8, T = v & 255;
    this.current708Packet.ptsVals.push(f.pts), this.current708Packet.data.push(S), this.current708Packet.data.push(T);
  }, Dt.prototype.push708Packet = function() {
    var f = this.current708Packet, v = f.data, S = null, T = null, E = 0, P = v[E++];
    for (f.seq = P >> 6, f.sizeCode = P & 63; E < v.length; E++)
      P = v[E++], S = P >> 5, T = P & 31, S === 7 && T > 0 && (P = v[E++], S = P), this.pushServiceBlock(S, E, T), T > 0 && (E += T - 1);
  }, Dt.prototype.pushServiceBlock = function(f, v, S) {
    var T, E = v, P = this.current708Packet.data, G = this.services[f];
    for (G || (G = this.initService(f, E)); E < v + S && E < P.length; E++)
      T = P[E], di(T) ? E = this.handleText(E, G) : T === 24 ? E = this.multiByteCharacter(E, G) : T === 16 ? E = this.extendedCommands(E, G) : 128 <= T && T <= 135 ? E = this.setCurrentWindow(E, G) : 152 <= T && T <= 159 ? E = this.defineWindow(E, G) : T === 136 ? E = this.clearWindows(E, G) : T === 140 ? E = this.deleteWindows(E, G) : T === 137 ? E = this.displayWindows(E, G) : T === 138 ? E = this.hideWindows(E, G) : T === 139 ? E = this.toggleWindows(E, G) : T === 151 ? E = this.setWindowAttributes(E, G) : T === 144 ? E = this.setPenAttributes(E, G) : T === 145 ? E = this.setPenColor(E, G) : T === 146 ? E = this.setPenLocation(E, G) : T === 143 ? G = this.reset(E, G) : T === 8 ? G.currentWindow.backspace() : T === 12 ? G.currentWindow.clearText() : T === 13 ? G.currentWindow.pendingNewLine = !0 : T === 14 ? G.currentWindow.clearText() : T === 141 && E++;
  }, Dt.prototype.extendedCommands = function(f, v) {
    var S = this.current708Packet.data, T = S[++f];
    return di(T) && (f = this.handleText(f, v, {
      isExtended: !0
    })), f;
  }, Dt.prototype.getPts = function(f) {
    return this.current708Packet.ptsVals[Math.floor(f / 2)];
  }, Dt.prototype.initService = function(f, v) {
    var T = "SERVICE" + f, S = this, T, E;
    return T in this.serviceEncodings && (E = this.serviceEncodings[T]), this.services[f] = new Hn(f, E, S), this.services[f].init(this.getPts(v), function(P) {
      S.flushDisplayed(P, S.services[f]);
    }), this.services[f];
  }, Dt.prototype.handleText = function(f, v, S) {
    var T = S && S.isExtended, E = S && S.isMultiByte, P = this.current708Packet.data, G = T ? 4096 : 0, Z = P[f], ee = P[f + 1], se = v.currentWindow, fe, ve;
    function Ve(Te) {
      return Te.map(($e) => ("0" + ($e & 255).toString(16)).slice(-2)).join("");
    }
    if (E ? (ve = [Z, ee], f++) : ve = [Z], v.textDecoder_ && !T)
      fe = v.textDecoder_.decode(new Uint8Array(ve));
    else if (E) {
      const Te = Ve(ve);
      fe = String.fromCharCode(parseInt(Te, 16));
    } else
      fe = Cr(G | Z);
    return se.pendingNewLine && !se.isEmpty() && se.newLine(this.getPts(f)), se.pendingNewLine = !1, se.addText(fe), f;
  }, Dt.prototype.multiByteCharacter = function(f, v) {
    var S = this.current708Packet.data, T = S[f + 1], E = S[f + 2];
    return di(T) && di(E) && (f = this.handleText(++f, v, {
      isMultiByte: !0
    })), f;
  }, Dt.prototype.setCurrentWindow = function(f, v) {
    var S = this.current708Packet.data, T = S[f], E = T & 7;
    return v.setCurrentWindow(E), f;
  }, Dt.prototype.defineWindow = function(f, v) {
    var S = this.current708Packet.data, T = S[f], E = T & 7;
    v.setCurrentWindow(E);
    var P = v.currentWindow;
    return T = S[++f], P.visible = (T & 32) >> 5, P.rowLock = (T & 16) >> 4, P.columnLock = (T & 8) >> 3, P.priority = T & 7, T = S[++f], P.relativePositioning = (T & 128) >> 7, P.anchorVertical = T & 127, T = S[++f], P.anchorHorizontal = T, T = S[++f], P.anchorPoint = (T & 240) >> 4, P.rowCount = T & 15, T = S[++f], P.columnCount = T & 63, T = S[++f], P.windowStyle = (T & 56) >> 3, P.penStyle = T & 7, P.virtualRowCount = P.rowCount + 1, f;
  }, Dt.prototype.setWindowAttributes = function(f, v) {
    var S = this.current708Packet.data, T = S[f], E = v.currentWindow.winAttr;
    return T = S[++f], E.fillOpacity = (T & 192) >> 6, E.fillRed = (T & 48) >> 4, E.fillGreen = (T & 12) >> 2, E.fillBlue = T & 3, T = S[++f], E.borderType = (T & 192) >> 6, E.borderRed = (T & 48) >> 4, E.borderGreen = (T & 12) >> 2, E.borderBlue = T & 3, T = S[++f], E.borderType += (T & 128) >> 5, E.wordWrap = (T & 64) >> 6, E.printDirection = (T & 48) >> 4, E.scrollDirection = (T & 12) >> 2, E.justify = T & 3, T = S[++f], E.effectSpeed = (T & 240) >> 4, E.effectDirection = (T & 12) >> 2, E.displayEffect = T & 3, f;
  }, Dt.prototype.flushDisplayed = function(f, v) {
    for (var S = [], T = 0; T < 8; T++)
      v.windows[T].visible && !v.windows[T].isEmpty() && S.push(v.windows[T].getText());
    v.endPts = f, v.text = S.join(`

`), this.pushCaption(v), v.startPts = f;
  }, Dt.prototype.pushCaption = function(f) {
    f.text !== "" && (this.trigger("data", {
      startPts: f.startPts,
      endPts: f.endPts,
      text: f.text,
      stream: "cc708_" + f.serviceNum
    }), f.text = "", f.startPts = f.endPts);
  }, Dt.prototype.displayWindows = function(f, v) {
    var S = this.current708Packet.data, T = S[++f], E = this.getPts(f);
    this.flushDisplayed(E, v);
    for (var P = 0; P < 8; P++)
      T & 1 << P && (v.windows[P].visible = 1);
    return f;
  }, Dt.prototype.hideWindows = function(f, v) {
    var S = this.current708Packet.data, T = S[++f], E = this.getPts(f);
    this.flushDisplayed(E, v);
    for (var P = 0; P < 8; P++)
      T & 1 << P && (v.windows[P].visible = 0);
    return f;
  }, Dt.prototype.toggleWindows = function(f, v) {
    var S = this.current708Packet.data, T = S[++f], E = this.getPts(f);
    this.flushDisplayed(E, v);
    for (var P = 0; P < 8; P++)
      T & 1 << P && (v.windows[P].visible ^= 1);
    return f;
  }, Dt.prototype.clearWindows = function(f, v) {
    var S = this.current708Packet.data, T = S[++f], E = this.getPts(f);
    this.flushDisplayed(E, v);
    for (var P = 0; P < 8; P++)
      T & 1 << P && v.windows[P].clearText();
    return f;
  }, Dt.prototype.deleteWindows = function(f, v) {
    var S = this.current708Packet.data, T = S[++f], E = this.getPts(f);
    this.flushDisplayed(E, v);
    for (var P = 0; P < 8; P++)
      T & 1 << P && v.windows[P].reset();
    return f;
  }, Dt.prototype.setPenAttributes = function(f, v) {
    var S = this.current708Packet.data, T = S[f], E = v.currentWindow.penAttr;
    return T = S[++f], E.textTag = (T & 240) >> 4, E.offset = (T & 12) >> 2, E.penSize = T & 3, T = S[++f], E.italics = (T & 128) >> 7, E.underline = (T & 64) >> 6, E.edgeType = (T & 56) >> 3, E.fontStyle = T & 7, f;
  }, Dt.prototype.setPenColor = function(f, v) {
    var S = this.current708Packet.data, T = S[f], E = v.currentWindow.penColor;
    return T = S[++f], E.fgOpacity = (T & 192) >> 6, E.fgRed = (T & 48) >> 4, E.fgGreen = (T & 12) >> 2, E.fgBlue = T & 3, T = S[++f], E.bgOpacity = (T & 192) >> 6, E.bgRed = (T & 48) >> 4, E.bgGreen = (T & 12) >> 2, E.bgBlue = T & 3, T = S[++f], E.edgeRed = (T & 48) >> 4, E.edgeGreen = (T & 12) >> 2, E.edgeBlue = T & 3, f;
  }, Dt.prototype.setPenLocation = function(f, v) {
    var S = this.current708Packet.data, T = S[f], E = v.currentWindow.penLoc;
    return v.currentWindow.pendingNewLine = !0, T = S[++f], E.row = T & 15, T = S[++f], E.column = T & 63, f;
  }, Dt.prototype.reset = function(f, v) {
    var S = this.getPts(f);
    return this.flushDisplayed(S, v), this.initService(v.serviceNum, f);
  };
  var z1 = {
    42: 225,
    // á
    92: 233,
    // é
    94: 237,
    // í
    95: 243,
    // ó
    96: 250,
    // ú
    123: 231,
    // ç
    124: 247,
    // ÷
    125: 209,
    // Ñ
    126: 241,
    // ñ
    127: 9608,
    // █
    304: 174,
    // ®
    305: 176,
    // °
    306: 189,
    // ½
    307: 191,
    // ¿
    308: 8482,
    // ™
    309: 162,
    // ¢
    310: 163,
    // £
    311: 9834,
    // ♪
    312: 224,
    // à
    313: 160,
    //
    314: 232,
    // è
    315: 226,
    // â
    316: 234,
    // ê
    317: 238,
    // î
    318: 244,
    // ô
    319: 251,
    // û
    544: 193,
    // Á
    545: 201,
    // É
    546: 211,
    // Ó
    547: 218,
    // Ú
    548: 220,
    // Ü
    549: 252,
    // ü
    550: 8216,
    // ‘
    551: 161,
    // ¡
    552: 42,
    // *
    553: 39,
    // '
    554: 8212,
    // —
    555: 169,
    // ©
    556: 8480,
    // ℠
    557: 8226,
    // •
    558: 8220,
    // “
    559: 8221,
    // ”
    560: 192,
    // À
    561: 194,
    // Â
    562: 199,
    // Ç
    563: 200,
    // È
    564: 202,
    // Ê
    565: 203,
    // Ë
    566: 235,
    // ë
    567: 206,
    // Î
    568: 207,
    // Ï
    569: 239,
    // ï
    570: 212,
    // Ô
    571: 217,
    // Ù
    572: 249,
    // ù
    573: 219,
    // Û
    574: 171,
    // «
    575: 187,
    // »
    800: 195,
    // Ã
    801: 227,
    // ã
    802: 205,
    // Í
    803: 204,
    // Ì
    804: 236,
    // ì
    805: 210,
    // Ò
    806: 242,
    // ò
    807: 213,
    // Õ
    808: 245,
    // õ
    809: 123,
    // {
    810: 125,
    // }
    811: 92,
    // \
    812: 94,
    // ^
    813: 95,
    // _
    814: 124,
    // |
    815: 126,
    // ~
    816: 196,
    // Ä
    817: 228,
    // ä
    818: 214,
    // Ö
    819: 246,
    // ö
    820: 223,
    // ß
    821: 165,
    // ¥
    822: 164,
    // ¤
    823: 9474,
    // │
    824: 197,
    // Å
    825: 229,
    // å
    826: 216,
    // Ø
    827: 248,
    // ø
    828: 9484,
    // ┌
    829: 9488,
    // ┐
    830: 9492,
    // └
    831: 9496
    // ┘
  }, Kl = function(f) {
    return f === null ? "" : (f = z1[f] || f, String.fromCharCode(f));
  }, Jl = 14, U1 = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152], Er = function() {
    for (var f = [], v = Jl + 1; v--; )
      f.push({
        text: "",
        indent: 0,
        offset: 0
      });
    return f;
  }, Gt = function(f, v) {
    Gt.prototype.init.call(this), this.field_ = f || 0, this.dataChannel_ = v || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(S) {
      var T, E, P, G, Z;
      if (T = S.ccData & 32639, T === this.lastControlCode_) {
        this.lastControlCode_ = null;
        return;
      }
      if ((T & 61440) === 4096 ? this.lastControlCode_ = T : T !== this.PADDING_ && (this.lastControlCode_ = null), P = T >>> 8, G = T & 255, T !== this.PADDING_)
        if (T === this.RESUME_CAPTION_LOADING_)
          this.mode_ = "popOn";
        else if (T === this.END_OF_CAPTION_)
          this.mode_ = "popOn", this.clearFormatting(S.pts), this.flushDisplayed(S.pts), E = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = E, this.startPts_ = S.pts;
        else if (T === this.ROLL_UP_2_ROWS_)
          this.rollUpRows_ = 2, this.setRollUp(S.pts);
        else if (T === this.ROLL_UP_3_ROWS_)
          this.rollUpRows_ = 3, this.setRollUp(S.pts);
        else if (T === this.ROLL_UP_4_ROWS_)
          this.rollUpRows_ = 4, this.setRollUp(S.pts);
        else if (T === this.CARRIAGE_RETURN_)
          this.clearFormatting(S.pts), this.flushDisplayed(S.pts), this.shiftRowsUp_(), this.startPts_ = S.pts;
        else if (T === this.BACKSPACE_)
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
        else if (T === this.ERASE_DISPLAYED_MEMORY_)
          this.flushDisplayed(S.pts), this.displayed_ = Er();
        else if (T === this.ERASE_NON_DISPLAYED_MEMORY_)
          this.nonDisplayed_ = Er();
        else if (T === this.RESUME_DIRECT_CAPTIONING_)
          this.mode_ !== "paintOn" && (this.flushDisplayed(S.pts), this.displayed_ = Er()), this.mode_ = "paintOn", this.startPts_ = S.pts;
        else if (this.isSpecialCharacter(P, G))
          P = (P & 3) << 8, Z = Kl(P | G), this[this.mode_](S.pts, Z), this.column_++;
        else if (this.isExtCharacter(P, G))
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1), P = (P & 3) << 8, Z = Kl(P | G), this[this.mode_](S.pts, Z), this.column_++;
        else if (this.isMidRowCode(P, G))
          this.clearFormatting(S.pts), this[this.mode_](S.pts, " "), this.column_++, (G & 14) === 14 && this.addFormatting(S.pts, ["i"]), (G & 1) === 1 && this.addFormatting(S.pts, ["u"]);
        else if (this.isOffsetControlCode(P, G)) {
          const se = G & 3;
          this.nonDisplayed_[this.row_].offset = se, this.column_ += se;
        } else if (this.isPAC(P, G)) {
          var ee = U1.indexOf(T & 7968);
          if (this.mode_ === "rollUp" && (ee - this.rollUpRows_ + 1 < 0 && (ee = this.rollUpRows_ - 1), this.setRollUp(S.pts, ee)), ee !== this.row_ && ee >= 0 && ee <= 14 && (this.clearFormatting(S.pts), this.row_ = ee), G & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(S.pts, ["u"]), (T & 16) === 16) {
            const se = (T & 14) >> 1;
            this.column_ = se * 4, this.nonDisplayed_[this.row_].indent += se;
          }
          this.isColorPAC(G) && (G & 14) === 14 && this.addFormatting(S.pts, ["i"]);
        } else this.isNormalChar(P) && (G === 0 && (G = null), Z = Kl(P), Z += Kl(G), this[this.mode_](S.pts, Z), this.column_ += Z.length);
    };
  };
  Gt.prototype = new qn(), Gt.prototype.flushDisplayed = function(f) {
    const v = (T) => {
      this.trigger("log", {
        level: "warn",
        message: "Skipping a malformed 608 caption at index " + T + "."
      });
    }, S = [];
    this.displayed_.forEach((T, E) => {
      if (T && T.text && T.text.length) {
        try {
          T.text = T.text.trim();
        } catch {
          v(E);
        }
        T.text.length && S.push({
          // The text to be displayed in the caption from this specific row, with whitespace removed.
          text: T.text,
          // Value between 1 and 15 representing the PAC row used to calculate line height.
          line: E + 1,
          // A number representing the indent position by percentage (CEA-608 PAC indent code).
          // The value will be a number between 10 and 80. Offset is used to add an aditional
          // value to the position if necessary.
          position: 10 + Math.min(70, T.indent * 10) + T.offset * 2.5
        });
      } else T == null && v(E);
    }), S.length && this.trigger("data", {
      startPts: this.startPts_,
      endPts: f,
      content: S,
      stream: this.name_
    });
  }, Gt.prototype.reset = function() {
    this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = Er(), this.nonDisplayed_ = Er(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = Jl, this.rollUpRows_ = 2, this.formatting_ = [];
  }, Gt.prototype.setConstants = function() {
    this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
  }, Gt.prototype.isSpecialCharacter = function(f, v) {
    return f === this.EXT_ && v >= 48 && v <= 63;
  }, Gt.prototype.isExtCharacter = function(f, v) {
    return (f === this.EXT_ + 1 || f === this.EXT_ + 2) && v >= 32 && v <= 63;
  }, Gt.prototype.isMidRowCode = function(f, v) {
    return f === this.EXT_ && v >= 32 && v <= 47;
  }, Gt.prototype.isOffsetControlCode = function(f, v) {
    return f === this.OFFSET_ && v >= 33 && v <= 35;
  }, Gt.prototype.isPAC = function(f, v) {
    return f >= this.BASE_ && f < this.BASE_ + 8 && v >= 64 && v <= 127;
  }, Gt.prototype.isColorPAC = function(f) {
    return f >= 64 && f <= 79 || f >= 96 && f <= 127;
  }, Gt.prototype.isNormalChar = function(f) {
    return f >= 32 && f <= 127;
  }, Gt.prototype.setRollUp = function(f, v) {
    if (this.mode_ !== "rollUp" && (this.row_ = Jl, this.mode_ = "rollUp", this.flushDisplayed(f), this.nonDisplayed_ = Er(), this.displayed_ = Er()), v !== void 0 && v !== this.row_)
      for (var S = 0; S < this.rollUpRows_; S++)
        this.displayed_[v - S] = this.displayed_[this.row_ - S], this.displayed_[this.row_ - S] = {
          text: "",
          indent: 0,
          offset: 0
        };
    v === void 0 && (v = this.row_), this.topRow_ = v - this.rollUpRows_ + 1;
  }, Gt.prototype.addFormatting = function(f, v) {
    this.formatting_ = this.formatting_.concat(v);
    var S = v.reduce(function(T, E) {
      return T + "<" + E + ">";
    }, "");
    this[this.mode_](f, S);
  }, Gt.prototype.clearFormatting = function(f) {
    if (this.formatting_.length) {
      var v = this.formatting_.reverse().reduce(function(S, T) {
        return S + "</" + T + ">";
      }, "");
      this.formatting_ = [], this[this.mode_](f, v);
    }
  }, Gt.prototype.popOn = function(f, v) {
    var S = this.nonDisplayed_[this.row_].text;
    S += v, this.nonDisplayed_[this.row_].text = S;
  }, Gt.prototype.rollUp = function(f, v) {
    var S = this.displayed_[this.row_].text;
    S += v, this.displayed_[this.row_].text = S;
  }, Gt.prototype.shiftRowsUp_ = function() {
    var f;
    for (f = 0; f < this.topRow_; f++)
      this.displayed_[f] = {
        text: "",
        indent: 0,
        offset: 0
      };
    for (f = this.row_ + 1; f < Jl + 1; f++)
      this.displayed_[f] = {
        text: "",
        indent: 0,
        offset: 0
      };
    for (f = this.topRow_; f < this.row_; f++)
      this.displayed_[f] = this.displayed_[f + 1];
    this.displayed_[this.row_] = {
      text: "",
      indent: 0,
      offset: 0
    };
  }, Gt.prototype.paintOn = function(f, v) {
    var S = this.displayed_[this.row_].text;
    S += v, this.displayed_[this.row_].text = S;
  };
  var Tm = {
    CaptionStream: qt,
    Cea608Stream: Gt,
    Cea708Stream: Dt
  }, $l = {
    H264_STREAM_TYPE: 27,
    ADTS_STREAM_TYPE: 15,
    METADATA_STREAM_TYPE: 21
  }, V1 = i, q1 = 8589934592, H1 = 4294967296, xm = "shared", yc = function(f, v) {
    var S = 1;
    for (f > v && (S = -1); Math.abs(v - f) > H1; )
      f += S * q1;
    return f;
  }, bc = function(f) {
    var v, S;
    bc.prototype.init.call(this), this.type_ = f || xm, this.push = function(T) {
      if (T.type === "metadata") {
        this.trigger("data", T);
        return;
      }
      this.type_ !== xm && T.type !== this.type_ || (S === void 0 && (S = T.dts), T.dts = yc(T.dts, S), T.pts = yc(T.pts, S), v = T.dts, this.trigger("data", T));
    }, this.flush = function() {
      S = v, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.discontinuity = function() {
      S = void 0, v = void 0;
    }, this.reset = function() {
      this.discontinuity(), this.trigger("reset");
    };
  };
  bc.prototype = new V1();
  var Sm = {
    TimestampRolloverStream: bc,
    handleRollover: yc
  }, W1 = (f, v, S) => {
    if (!f)
      return -1;
    for (var T = S; T < f.length; T++)
      if (f[T] === v)
        return T;
    return -1;
  }, Y1 = {
    typedArrayIndexOf: W1
  }, eu = Y1.typedArrayIndexOf, tu = {
    // UTF-16BE encoded Unicode, without BOM, terminated with \0\0
    Utf8: 3
    // UTF-8 encoded Unicode, terminated with \0
  }, Cm = function(f, v, S) {
    var T, E = "";
    for (T = v; T < S; T++)
      E += "%" + ("00" + f[T].toString(16)).slice(-2);
    return E;
  }, Eo = function(f, v, S) {
    return decodeURIComponent(Cm(f, v, S));
  }, Do = function(f, v, S) {
    return unescape(Cm(f, v, S));
  }, _o = function(f) {
    return f[0] << 21 | f[1] << 14 | f[2] << 7 | f[3];
  }, ko = {
    APIC: function(f) {
      var v = 1, S, T, E = "-->";
      f.data[0] === tu.Utf8 && (S = eu(f.data, 0, v), !(S < 0) && (f.mimeType = Do(f.data, v, S), v = S + 1, f.pictureType = f.data[v], v++, T = eu(f.data, 0, v), !(T < 0) && (f.description = Eo(f.data, v, T), v = T + 1, f.mimeType === E ? f.url = Do(f.data, v, f.data.length) : f.pictureData = f.data.subarray(v, f.data.length))));
    },
    "T*": function(f) {
      f.data[0] === tu.Utf8 && (f.value = Eo(f.data, 1, f.data.length).replace(/\0*$/, ""), f.values = f.value.split("\0"));
    },
    TXXX: function(f) {
      var v;
      f.data[0] === tu.Utf8 && (v = eu(f.data, 0, 1), v !== -1 && (f.description = Eo(f.data, 1, v), f.value = Eo(f.data, v + 1, f.data.length).replace(/\0*$/, ""), f.data = f.value));
    },
    "W*": function(f) {
      f.url = Do(f.data, 0, f.data.length).replace(/\0.*$/, "");
    },
    WXXX: function(f) {
      var v;
      f.data[0] === tu.Utf8 && (v = eu(f.data, 0, 1), v !== -1 && (f.description = Eo(f.data, 1, v), f.url = Do(f.data, v + 1, f.data.length).replace(/\0.*$/, "")));
    },
    PRIV: function(f) {
      var v;
      for (v = 0; v < f.data.length; v++)
        if (f.data[v] === 0) {
          f.owner = Do(f.data, 0, v);
          break;
        }
      f.privateData = f.data.subarray(v + 1), f.data = f.privateData;
    }
  }, X1 = function(f) {
    var v, S, T = 10, E = 0, P = [];
    if (!(f.length < 10 || f[0] !== 73 || f[1] !== 68 || f[2] !== 51)) {
      E = _o(f.subarray(6, 10)), E += 10;
      var G = f[5] & 64;
      G && (T += 4, T += _o(f.subarray(10, 14)), E -= _o(f.subarray(16, 20)));
      do {
        if (v = _o(f.subarray(T + 4, T + 8)), v < 1)
          break;
        S = String.fromCharCode(f[T], f[T + 1], f[T + 2], f[T + 3]);
        var Z = {
          id: S,
          data: f.subarray(T + 10, T + v + 10)
        };
        Z.key = Z.id, ko[Z.id] ? ko[Z.id](Z) : Z.id[0] === "T" ? ko["T*"](Z) : Z.id[0] === "W" && ko["W*"](Z), P.push(Z), T += 10, T += v;
      } while (T < E);
      return P;
    }
  }, Em = {
    parseId3Frames: X1,
    parseSyncSafeInteger: _o,
    frameParsers: ko
  }, j1 = i, G1 = $l, Zs = Em, iu;
  iu = function(f) {
    var v = {
      // the bytes of the program-level descriptor field in MP2T
      // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
      // program element descriptors"
      descriptor: f && f.descriptor
    }, S = 0, T = [], E = 0, P;
    if (iu.prototype.init.call(this), this.dispatchType = G1.METADATA_STREAM_TYPE.toString(16), v.descriptor)
      for (P = 0; P < v.descriptor.length; P++)
        this.dispatchType += ("00" + v.descriptor[P].toString(16)).slice(-2);
    this.push = function(G) {
      var Z, ee, se, fe, ve, Ve;
      if (G.type === "timed-metadata") {
        if (G.dataAlignmentIndicator && (E = 0, T.length = 0), T.length === 0 && (G.data.length < 10 || G.data[0] !== 73 || G.data[1] !== 68 || G.data[2] !== 51)) {
          this.trigger("log", {
            level: "warn",
            message: "Skipping unrecognized metadata packet"
          });
          return;
        }
        if (T.push(G), E += G.data.byteLength, T.length === 1 && (S = Zs.parseSyncSafeInteger(G.data.subarray(6, 10)), S += 10), !(E < S)) {
          for (Z = {
            data: new Uint8Array(S),
            frames: [],
            pts: T[0].pts,
            dts: T[0].dts
          }, ve = 0; ve < S; )
            Z.data.set(T[0].data.subarray(0, S - ve), ve), ve += T[0].data.byteLength, E -= T[0].data.byteLength, T.shift();
          ee = 10, Z.data[5] & 64 && (ee += 4, ee += Zs.parseSyncSafeInteger(Z.data.subarray(10, 14)), S -= Zs.parseSyncSafeInteger(Z.data.subarray(16, 20)));
          do {
            if (se = Zs.parseSyncSafeInteger(Z.data.subarray(ee + 4, ee + 8)), se < 1) {
              this.trigger("log", {
                level: "warn",
                message: "Malformed ID3 frame encountered. Skipping remaining metadata parsing."
              });
              break;
            }
            if (Ve = String.fromCharCode(Z.data[ee], Z.data[ee + 1], Z.data[ee + 2], Z.data[ee + 3]), fe = {
              id: Ve,
              data: Z.data.subarray(ee + 10, ee + se + 10)
            }, fe.key = fe.id, Zs.frameParsers[fe.id] ? Zs.frameParsers[fe.id](fe) : fe.id[0] === "T" ? Zs.frameParsers["T*"](fe) : fe.id[0] === "W" && Zs.frameParsers["W*"](fe), fe.owner === "com.apple.streaming.transportStreamTimestamp") {
              var Te = fe.data, $e = (Te[3] & 1) << 30 | Te[4] << 22 | Te[5] << 14 | Te[6] << 6 | Te[7] >>> 2;
              $e *= 4, $e += Te[7] & 3, fe.timeStamp = $e, Z.pts === void 0 && Z.dts === void 0 && (Z.pts = fe.timeStamp, Z.dts = fe.timeStamp), this.trigger("timestamp", fe);
            }
            Z.frames.push(fe), ee += 10, ee += se;
          } while (ee < S);
          this.trigger("data", Z);
        }
      }
    };
  }, iu.prototype = new j1();
  var Q1 = iu, wc = i, Tc = Tm, Wn = $l, Z1 = Sm.TimestampRolloverStream, nu, Po, su, ua = 188, xc = 71;
  nu = function() {
    var f = new Uint8Array(ua), v = 0;
    nu.prototype.init.call(this), this.push = function(S) {
      var T = 0, E = ua, P;
      for (v ? (P = new Uint8Array(S.byteLength + v), P.set(f.subarray(0, v)), P.set(S, v), v = 0) : P = S; E < P.byteLength; ) {
        if (P[T] === xc && P[E] === xc) {
          this.trigger("data", P.subarray(T, E)), T += ua, E += ua;
          continue;
        }
        T++, E++;
      }
      T < P.byteLength && (f.set(P.subarray(T), 0), v = P.byteLength - T);
    }, this.flush = function() {
      v === ua && f[0] === xc && (this.trigger("data", f), v = 0), this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.reset = function() {
      v = 0, this.trigger("reset");
    };
  }, nu.prototype = new wc(), Po = function() {
    var f, v, S, T;
    Po.prototype.init.call(this), T = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, f = function(E, P) {
      var G = 0;
      P.payloadUnitStartIndicator && (G += E[G] + 1), P.type === "pat" ? v(E.subarray(G), P) : S(E.subarray(G), P);
    }, v = function(E, P) {
      P.section_number = E[7], P.last_section_number = E[8], T.pmtPid = (E[10] & 31) << 8 | E[11], P.pmtPid = T.pmtPid;
    }, S = function(E, P) {
      var G, Z, ee, se;
      if (E[5] & 1) {
        for (T.programMapTable = {
          video: null,
          audio: null,
          "timed-metadata": {}
        }, G = (E[1] & 15) << 8 | E[2], Z = 3 + G - 4, ee = (E[10] & 15) << 8 | E[11], se = 12 + ee; se < Z; ) {
          var fe = E[se], ve = (E[se + 1] & 31) << 8 | E[se + 2];
          fe === Wn.H264_STREAM_TYPE && T.programMapTable.video === null ? T.programMapTable.video = ve : fe === Wn.ADTS_STREAM_TYPE && T.programMapTable.audio === null ? T.programMapTable.audio = ve : fe === Wn.METADATA_STREAM_TYPE && (T.programMapTable["timed-metadata"][ve] = fe), se += ((E[se + 3] & 15) << 8 | E[se + 4]) + 5;
        }
        P.programMapTable = T.programMapTable;
      }
    }, this.push = function(E) {
      var P = {}, G = 4;
      if (P.payloadUnitStartIndicator = !!(E[1] & 64), P.pid = E[1] & 31, P.pid <<= 8, P.pid |= E[2], (E[3] & 48) >>> 4 > 1 && (G += E[G] + 1), P.pid === 0)
        P.type = "pat", f(E.subarray(G), P), this.trigger("data", P);
      else if (P.pid === this.pmtPid)
        for (P.type = "pmt", f(E.subarray(G), P), this.trigger("data", P); this.packetsWaitingForPmt.length; )
          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
      else this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([E, G, P]) : this.processPes_(E, G, P);
    }, this.processPes_ = function(E, P, G) {
      G.pid === this.programMapTable.video ? G.streamType = Wn.H264_STREAM_TYPE : G.pid === this.programMapTable.audio ? G.streamType = Wn.ADTS_STREAM_TYPE : G.streamType = this.programMapTable["timed-metadata"][G.pid], G.type = "pes", G.data = E.subarray(P), this.trigger("data", G);
    };
  }, Po.prototype = new wc(), Po.STREAM_TYPES = {
    h264: 27,
    adts: 15
  }, su = function() {
    var f = this, v = !1, S = {
      data: [],
      size: 0
    }, T = {
      data: [],
      size: 0
    }, E = {
      data: [],
      size: 0
    }, P, G = function(ee, se) {
      var fe;
      const ve = ee[0] << 16 | ee[1] << 8 | ee[2];
      se.data = new Uint8Array(), ve === 1 && (se.packetLength = 6 + (ee[4] << 8 | ee[5]), se.dataAlignmentIndicator = (ee[6] & 4) !== 0, fe = ee[7], fe & 192 && (se.pts = (ee[9] & 14) << 27 | (ee[10] & 255) << 20 | (ee[11] & 254) << 12 | (ee[12] & 255) << 5 | (ee[13] & 254) >>> 3, se.pts *= 4, se.pts += (ee[13] & 6) >>> 1, se.dts = se.pts, fe & 64 && (se.dts = (ee[14] & 14) << 27 | (ee[15] & 255) << 20 | (ee[16] & 254) << 12 | (ee[17] & 255) << 5 | (ee[18] & 254) >>> 3, se.dts *= 4, se.dts += (ee[18] & 6) >>> 1)), se.data = ee.subarray(9 + ee[8]));
    }, Z = function(ee, se, fe) {
      var ve = new Uint8Array(ee.size), Ve = {
        type: se
      }, Te = 0, $e = 0, ht = !1, Ti;
      if (!(!ee.data.length || ee.size < 9)) {
        for (Ve.trackId = ee.data[0].pid, Te = 0; Te < ee.data.length; Te++)
          Ti = ee.data[Te], ve.set(Ti.data, $e), $e += Ti.data.byteLength;
        G(ve, Ve), ht = se === "video" || Ve.packetLength <= ee.size, (fe || ht) && (ee.size = 0, ee.data.length = 0), ht && f.trigger("data", Ve);
      }
    };
    su.prototype.init.call(this), this.push = function(ee) {
      ({
        pat: function() {
        },
        pes: function() {
          var se, fe;
          switch (ee.streamType) {
            case Wn.H264_STREAM_TYPE:
              se = S, fe = "video";
              break;
            case Wn.ADTS_STREAM_TYPE:
              se = T, fe = "audio";
              break;
            case Wn.METADATA_STREAM_TYPE:
              se = E, fe = "timed-metadata";
              break;
            default:
              return;
          }
          ee.payloadUnitStartIndicator && Z(se, fe, !0), se.data.push(ee), se.size += ee.data.byteLength;
        },
        pmt: function() {
          var se = {
            type: "metadata",
            tracks: []
          };
          P = ee.programMapTable, P.video !== null && se.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +P.video,
            codec: "avc",
            type: "video"
          }), P.audio !== null && se.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +P.audio,
            codec: "adts",
            type: "audio"
          }), v = !0, f.trigger("data", se);
        }
      })[ee.type]();
    }, this.reset = function() {
      S.size = 0, S.data.length = 0, T.size = 0, T.data.length = 0, this.trigger("reset");
    }, this.flushStreams_ = function() {
      Z(S, "video"), Z(T, "audio"), Z(E, "timed-metadata");
    }, this.flush = function() {
      if (!v && P) {
        var ee = {
          type: "metadata",
          tracks: []
        };
        P.video !== null && ee.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +P.video,
          codec: "avc",
          type: "video"
        }), P.audio !== null && ee.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +P.audio,
          codec: "adts",
          type: "audio"
        }), f.trigger("data", ee);
      }
      v = !1, this.flushStreams_(), this.trigger("done");
    };
  }, su.prototype = new wc();
  var Dm = {
    PAT_PID: 0,
    MP2T_PACKET_LENGTH: ua,
    TransportPacketStream: nu,
    TransportParseStream: Po,
    ElementaryStream: su,
    TimestampRolloverStream: Z1,
    CaptionStream: Tc.CaptionStream,
    Cea608Stream: Tc.Cea608Stream,
    Cea708Stream: Tc.Cea708Stream,
    MetadataStream: Q1
  };
  for (var Sc in Wn)
    Wn.hasOwnProperty(Sc) && (Dm[Sc] = Wn[Sc]);
  var K1 = Dm, J1 = i, $1 = xt.ONE_SECOND_IN_TS, ru, _m = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  ru = function(f) {
    var v, S = 0;
    ru.prototype.init.call(this), this.skipWarn_ = function(T, E) {
      this.trigger("log", {
        level: "warn",
        message: `adts skiping bytes ${T} to ${E} in frame ${S} outside syncword`
      });
    }, this.push = function(T) {
      var E = 0, P, G, Z, ee, se;
      if (f || (S = 0), T.type === "audio") {
        v && v.length ? (Z = v, v = new Uint8Array(Z.byteLength + T.data.byteLength), v.set(Z), v.set(T.data, Z.byteLength)) : v = T.data;
        for (var fe; E + 7 < v.length; ) {
          if (v[E] !== 255 || (v[E + 1] & 246) !== 240) {
            typeof fe != "number" && (fe = E), E++;
            continue;
          }
          if (typeof fe == "number" && (this.skipWarn_(fe, E), fe = null), G = (~v[E + 1] & 1) * 2, P = (v[E + 3] & 3) << 11 | v[E + 4] << 3 | (v[E + 5] & 224) >> 5, ee = ((v[E + 6] & 3) + 1) * 1024, se = ee * $1 / _m[(v[E + 2] & 60) >>> 2], v.byteLength - E < P)
            break;
          this.trigger("data", {
            pts: T.pts + S * se,
            dts: T.dts + S * se,
            sampleCount: ee,
            audioobjecttype: (v[E + 2] >>> 6 & 3) + 1,
            channelcount: (v[E + 2] & 1) << 2 | (v[E + 3] & 192) >>> 6,
            samplerate: _m[(v[E + 2] & 60) >>> 2],
            samplingfrequencyindex: (v[E + 2] & 60) >>> 2,
            // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
            samplesize: 16,
            // data is the frame without it's header
            data: v.subarray(E + 7 + G, E + P)
          }), S++, E += P;
        }
        typeof fe == "number" && (this.skipWarn_(fe, E), fe = null), v = v.subarray(E);
      }
    }, this.flush = function() {
      S = 0, this.trigger("done");
    }, this.reset = function() {
      v = void 0, this.trigger("reset");
    }, this.endTimeline = function() {
      v = void 0, this.trigger("endedtimeline");
    };
  }, ru.prototype = new J1();
  var eT = ru, km;
  km = function(f) {
    var v = f.byteLength, S = 0, T = 0;
    this.length = function() {
      return 8 * v;
    }, this.bitsAvailable = function() {
      return 8 * v + T;
    }, this.loadWord = function() {
      var E = f.byteLength - v, P = new Uint8Array(4), G = Math.min(4, v);
      if (G === 0)
        throw new Error("no bytes available");
      P.set(f.subarray(E, E + G)), S = new DataView(P.buffer).getUint32(0), T = G * 8, v -= G;
    }, this.skipBits = function(E) {
      var P;
      T > E ? (S <<= E, T -= E) : (E -= T, P = Math.floor(E / 8), E -= P * 8, v -= P, this.loadWord(), S <<= E, T -= E);
    }, this.readBits = function(E) {
      var P = Math.min(T, E), G = S >>> 32 - P;
      return T -= P, T > 0 ? S <<= P : v > 0 && this.loadWord(), P = E - P, P > 0 ? G << P | this.readBits(P) : G;
    }, this.skipLeadingZeros = function() {
      var E;
      for (E = 0; E < T; ++E)
        if ((S & 2147483648 >>> E) !== 0)
          return S <<= E, T -= E, E;
      return this.loadWord(), E + this.skipLeadingZeros();
    }, this.skipUnsignedExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.skipExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.readUnsignedExpGolomb = function() {
      var E = this.skipLeadingZeros();
      return this.readBits(E + 1) - 1;
    }, this.readExpGolomb = function() {
      var E = this.readUnsignedExpGolomb();
      return 1 & E ? 1 + E >>> 1 : -1 * (E >>> 1);
    }, this.readBoolean = function() {
      return this.readBits(1) === 1;
    }, this.readUnsignedByte = function() {
      return this.readBits(8);
    }, this.loadWord();
  };
  var tT = km, Pm = i, iT = tT, au, ou, Im;
  ou = function() {
    var f = 0, v, S;
    ou.prototype.init.call(this), this.push = function(T) {
      var E;
      S ? (E = new Uint8Array(S.byteLength + T.data.byteLength), E.set(S), E.set(T.data, S.byteLength), S = E) : S = T.data;
      for (var P = S.byteLength; f < P - 3; f++)
        if (S[f + 2] === 1) {
          v = f + 5;
          break;
        }
      for (; v < P; )
        switch (S[v]) {
          case 0:
            if (S[v - 1] !== 0) {
              v += 2;
              break;
            } else if (S[v - 2] !== 0) {
              v++;
              break;
            }
            f + 3 !== v - 2 && this.trigger("data", S.subarray(f + 3, v - 2));
            do
              v++;
            while (S[v] !== 1 && v < P);
            f = v - 2, v += 3;
            break;
          case 1:
            if (S[v - 1] !== 0 || S[v - 2] !== 0) {
              v += 3;
              break;
            }
            this.trigger("data", S.subarray(f + 3, v - 2)), f = v - 2, v += 3;
            break;
          default:
            v += 3;
            break;
        }
      S = S.subarray(f), v -= f, f = 0;
    }, this.reset = function() {
      S = null, f = 0, this.trigger("reset");
    }, this.flush = function() {
      S && S.byteLength > 3 && this.trigger("data", S.subarray(f + 3)), S = null, f = 0, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    };
  }, ou.prototype = new Pm(), Im = {
    100: !0,
    110: !0,
    122: !0,
    244: !0,
    44: !0,
    83: !0,
    86: !0,
    118: !0,
    128: !0,
    // TODO: the three profiles below don't
    // appear to have sps data in the specificiation anymore?
    138: !0,
    139: !0,
    134: !0
  }, au = function() {
    var f = new ou(), v, S, T, E, P, G, Z;
    au.prototype.init.call(this), v = this, this.push = function(ee) {
      ee.type === "video" && (S = ee.trackId, T = ee.pts, E = ee.dts, f.push(ee));
    }, f.on("data", function(ee) {
      var se = {
        trackId: S,
        pts: T,
        dts: E,
        data: ee,
        nalUnitTypeCode: ee[0] & 31
      };
      switch (se.nalUnitTypeCode) {
        case 5:
          se.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
          break;
        case 6:
          se.nalUnitType = "sei_rbsp", se.escapedRBSP = P(ee.subarray(1));
          break;
        case 7:
          se.nalUnitType = "seq_parameter_set_rbsp", se.escapedRBSP = P(ee.subarray(1)), se.config = G(se.escapedRBSP);
          break;
        case 8:
          se.nalUnitType = "pic_parameter_set_rbsp";
          break;
        case 9:
          se.nalUnitType = "access_unit_delimiter_rbsp";
          break;
      }
      v.trigger("data", se);
    }), f.on("done", function() {
      v.trigger("done");
    }), f.on("partialdone", function() {
      v.trigger("partialdone");
    }), f.on("reset", function() {
      v.trigger("reset");
    }), f.on("endedtimeline", function() {
      v.trigger("endedtimeline");
    }), this.flush = function() {
      f.flush();
    }, this.partialFlush = function() {
      f.partialFlush();
    }, this.reset = function() {
      f.reset();
    }, this.endTimeline = function() {
      f.endTimeline();
    }, Z = function(ee, se) {
      var fe = 8, ve = 8, Ve, Te;
      for (Ve = 0; Ve < ee; Ve++)
        ve !== 0 && (Te = se.readExpGolomb(), ve = (fe + Te + 256) % 256), fe = ve === 0 ? fe : ve;
    }, P = function(ee) {
      for (var se = ee.byteLength, fe = [], ve = 1, Ve, Te; ve < se - 2; )
        ee[ve] === 0 && ee[ve + 1] === 0 && ee[ve + 2] === 3 ? (fe.push(ve + 2), ve += 2) : ve++;
      if (fe.length === 0)
        return ee;
      Ve = se - fe.length, Te = new Uint8Array(Ve);
      var $e = 0;
      for (ve = 0; ve < Ve; $e++, ve++)
        $e === fe[0] && ($e++, fe.shift()), Te[ve] = ee[$e];
      return Te;
    }, G = function(ee) {
      var se = 0, fe = 0, ve = 0, Ve = 0, Te, $e, ht, Ti, cn, Js, Ro, Fo, zo, Uo, yu, Ht = [1, 1], Vo, Xn;
      if (Te = new iT(ee), $e = Te.readUnsignedByte(), Ti = Te.readUnsignedByte(), ht = Te.readUnsignedByte(), Te.skipUnsignedExpGolomb(), Im[$e] && (cn = Te.readUnsignedExpGolomb(), cn === 3 && Te.skipBits(1), Te.skipUnsignedExpGolomb(), Te.skipUnsignedExpGolomb(), Te.skipBits(1), Te.readBoolean()))
        for (yu = cn !== 3 ? 8 : 12, Xn = 0; Xn < yu; Xn++)
          Te.readBoolean() && (Xn < 6 ? Z(16, Te) : Z(64, Te));
      if (Te.skipUnsignedExpGolomb(), Js = Te.readUnsignedExpGolomb(), Js === 0)
        Te.readUnsignedExpGolomb();
      else if (Js === 1)
        for (Te.skipBits(1), Te.skipExpGolomb(), Te.skipExpGolomb(), Ro = Te.readUnsignedExpGolomb(), Xn = 0; Xn < Ro; Xn++)
          Te.skipExpGolomb();
      if (Te.skipUnsignedExpGolomb(), Te.skipBits(1), Fo = Te.readUnsignedExpGolomb(), zo = Te.readUnsignedExpGolomb(), Uo = Te.readBits(1), Uo === 0 && Te.skipBits(1), Te.skipBits(1), Te.readBoolean() && (se = Te.readUnsignedExpGolomb(), fe = Te.readUnsignedExpGolomb(), ve = Te.readUnsignedExpGolomb(), Ve = Te.readUnsignedExpGolomb()), Te.readBoolean() && Te.readBoolean()) {
        switch (Vo = Te.readUnsignedByte(), Vo) {
          case 1:
            Ht = [1, 1];
            break;
          case 2:
            Ht = [12, 11];
            break;
          case 3:
            Ht = [10, 11];
            break;
          case 4:
            Ht = [16, 11];
            break;
          case 5:
            Ht = [40, 33];
            break;
          case 6:
            Ht = [24, 11];
            break;
          case 7:
            Ht = [20, 11];
            break;
          case 8:
            Ht = [32, 11];
            break;
          case 9:
            Ht = [80, 33];
            break;
          case 10:
            Ht = [18, 11];
            break;
          case 11:
            Ht = [15, 11];
            break;
          case 12:
            Ht = [64, 33];
            break;
          case 13:
            Ht = [160, 99];
            break;
          case 14:
            Ht = [4, 3];
            break;
          case 15:
            Ht = [3, 2];
            break;
          case 16:
            Ht = [2, 1];
            break;
          case 255: {
            Ht = [Te.readUnsignedByte() << 8 | Te.readUnsignedByte(), Te.readUnsignedByte() << 8 | Te.readUnsignedByte()];
            break;
          }
        }
        Ht && Ht[0] / Ht[1];
      }
      return {
        profileIdc: $e,
        levelIdc: ht,
        profileCompatibility: Ti,
        width: (Fo + 1) * 16 - se * 2 - fe * 2,
        height: (2 - Uo) * (zo + 1) * 16 - ve * 2 - Ve * 2,
        // sar is sample aspect ratio
        sarRatio: Ht
      };
    };
  }, au.prototype = new Pm();
  var nT = {
    H264Stream: au
  }, sT = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], Mm = function(f, v) {
    var S = f[v + 6] << 21 | f[v + 7] << 14 | f[v + 8] << 7 | f[v + 9], T = f[v + 5], E = (T & 16) >> 4;
    return S = S >= 0 ? S : 0, E ? S + 20 : S + 10;
  }, Om = function(f, v) {
    return f.length - v < 10 || f[v] !== 73 || f[v + 1] !== 68 || f[v + 2] !== 51 ? v : (v += Mm(f, v), Om(f, v));
  }, rT = function(f) {
    var v = Om(f, 0);
    return f.length >= v + 2 && (f[v] & 255) === 255 && (f[v + 1] & 240) === 240 && // verify that the 2 layer bits are 0, aka this
    // is not mp3 data but aac data.
    (f[v + 1] & 22) === 16;
  }, Bm = function(f) {
    return f[0] << 21 | f[1] << 14 | f[2] << 7 | f[3];
  }, aT = function(f, v, S) {
    var T, E = "";
    for (T = v; T < S; T++)
      E += "%" + ("00" + f[T].toString(16)).slice(-2);
    return E;
  }, oT = function(f, v, S) {
    return unescape(aT(f, v, S));
  }, lT = function(f, v) {
    var S = (f[v + 5] & 224) >> 5, T = f[v + 4] << 3, E = f[v + 3] & 6144;
    return E | T | S;
  }, uT = function(f, v) {
    return f[v] === 73 && f[v + 1] === 68 && f[v + 2] === 51 ? "timed-metadata" : f[v] & !0 && (f[v + 1] & 240) === 240 ? "audio" : null;
  }, dT = function(f) {
    for (var v = 0; v + 5 < f.length; ) {
      if (f[v] !== 255 || (f[v + 1] & 246) !== 240) {
        v++;
        continue;
      }
      return sT[(f[v + 2] & 60) >>> 2];
    }
    return null;
  }, cT = function(f) {
    var v, S, T, E;
    v = 10, f[5] & 64 && (v += 4, v += Bm(f.subarray(10, 14)));
    do {
      if (S = Bm(f.subarray(v + 4, v + 8)), S < 1)
        return null;
      if (E = String.fromCharCode(f[v], f[v + 1], f[v + 2], f[v + 3]), E === "PRIV") {
        T = f.subarray(v + 10, v + S + 10);
        for (var P = 0; P < T.byteLength; P++)
          if (T[P] === 0) {
            var G = oT(T, 0, P);
            if (G === "com.apple.streaming.transportStreamTimestamp") {
              var Z = T.subarray(P + 1), ee = (Z[3] & 1) << 30 | Z[4] << 22 | Z[5] << 14 | Z[6] << 6 | Z[7] >>> 2;
              return ee *= 4, ee += Z[7] & 3, ee;
            }
            break;
          }
      }
      v += 10, v += S;
    } while (v < f.byteLength);
    return null;
  }, Cc = {
    isLikelyAacData: rT,
    parseId3TagSize: Mm,
    parseAdtsSize: lT,
    parseType: uT,
    parseSampleRate: dT,
    parseAacTimestamp: cT
  }, fT = i, Lm = Cc, lu;
  lu = function() {
    var f = new Uint8Array(), v = 0;
    lu.prototype.init.call(this), this.setTimestamp = function(S) {
      v = S;
    }, this.push = function(S) {
      var T = 0, E = 0, P, G, Z, ee;
      for (f.length ? (ee = f.length, f = new Uint8Array(S.byteLength + ee), f.set(f.subarray(0, ee)), f.set(S, ee)) : f = S; f.length - E >= 3; ) {
        if (f[E] === 73 && f[E + 1] === 68 && f[E + 2] === 51) {
          if (f.length - E < 10 || (T = Lm.parseId3TagSize(f, E), E + T > f.length))
            break;
          G = {
            type: "timed-metadata",
            data: f.subarray(E, E + T)
          }, this.trigger("data", G), E += T;
          continue;
        } else if ((f[E] & 255) === 255 && (f[E + 1] & 240) === 240) {
          if (f.length - E < 7 || (T = Lm.parseAdtsSize(f, E), E + T > f.length))
            break;
          Z = {
            type: "audio",
            data: f.subarray(E, E + T),
            pts: v,
            dts: v
          }, this.trigger("data", Z), E += T;
          continue;
        }
        E++;
      }
      P = f.length - E, P > 0 ? f = f.subarray(E) : f = new Uint8Array();
    }, this.reset = function() {
      f = new Uint8Array(), this.trigger("reset");
    }, this.endTimeline = function() {
      f = new Uint8Array(), this.trigger("endedtimeline");
    };
  }, lu.prototype = new fT();
  var hT = lu, pT = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"], mT = pT, AT = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"], gT = AT, uu = i, Io = B, Mo = Be, du = Je, Yn = Fe, Ms = K1, cu = xt, Nm = eT, vT = nT.H264Stream, yT = hT, bT = Cc.isLikelyAacData, wT = xt.ONE_SECOND_IN_TS, Rm = mT, Fm = gT, fu, Oo, hu, Dr, TT = function(f, v) {
    v.stream = f, this.trigger("log", v);
  }, zm = function(f, v) {
    for (var S = Object.keys(v), T = 0; T < S.length; T++) {
      var E = S[T];
      E === "headOfPipeline" || !v[E].on || v[E].on("log", TT.bind(f, E));
    }
  }, Um = function(f, v) {
    var S;
    if (f.length !== v.length)
      return !1;
    for (S = 0; S < f.length; S++)
      if (f[S] !== v[S])
        return !1;
    return !0;
  }, Vm = function(f, v, S, T, E, P) {
    var G = S - v, Z = T - v, ee = E - S;
    return {
      start: {
        dts: f,
        pts: f + G
      },
      end: {
        dts: f + Z,
        pts: f + ee
      },
      prependedContentDuration: P,
      baseMediaDecodeTime: f
    };
  };
  Oo = function(f, v) {
    var S = [], T, E = 0, P = 0, G = 1 / 0;
    v = v || {}, T = v.firstSequenceNumber || 0, Oo.prototype.init.call(this), this.push = function(Z) {
      Yn.collectDtsInfo(f, Z), f && Rm.forEach(function(ee) {
        f[ee] = Z[ee];
      }), S.push(Z);
    }, this.setEarliestDts = function(Z) {
      E = Z;
    }, this.setVideoBaseMediaDecodeTime = function(Z) {
      G = Z;
    }, this.setAudioAppendStart = function(Z) {
      P = Z;
    }, this.flush = function() {
      var Z, ee, se, fe, ve, Ve, Te;
      if (S.length === 0) {
        this.trigger("done", "AudioSegmentStream");
        return;
      }
      Z = du.trimAdtsFramesByEarliestDts(S, f, E), f.baseMediaDecodeTime = Yn.calculateTrackBaseMediaDecodeTime(f, v.keepOriginalTimestamps), Te = du.prefixWithSilence(f, Z, P, G), f.samples = du.generateSampleTable(Z), se = Io.mdat(du.concatenateFrameData(Z)), S = [], ee = Io.moof(T, [f]), fe = new Uint8Array(ee.byteLength + se.byteLength), T++, fe.set(ee), fe.set(se, ee.byteLength), Yn.clearDtsInfo(f), ve = Math.ceil(wT * 1024 / f.samplerate), Z.length && (Ve = Z.length * ve, this.trigger("segmentTimingInfo", Vm(
        // The audio track's baseMediaDecodeTime is in audio clock cycles, but the
        // frame info is in video clock cycles. Convert to match expectation of
        // listeners (that all timestamps will be based on video clock cycles).
        cu.audioTsToVideoTs(f.baseMediaDecodeTime, f.samplerate),
        // frame times are already in video clock, as is segment duration
        Z[0].dts,
        Z[0].pts,
        Z[0].dts + Ve,
        Z[0].pts + Ve,
        Te || 0
      )), this.trigger("timingInfo", {
        start: Z[0].pts,
        end: Z[0].pts + Ve
      })), this.trigger("data", {
        track: f,
        boxes: fe
      }), this.trigger("done", "AudioSegmentStream");
    }, this.reset = function() {
      Yn.clearDtsInfo(f), S = [], this.trigger("reset");
    };
  }, Oo.prototype = new uu(), fu = function(f, v) {
    var S, T = [], E = [], P, G;
    v = v || {}, S = v.firstSequenceNumber || 0, fu.prototype.init.call(this), delete f.minPTS, this.gopCache_ = [], this.push = function(Z) {
      Yn.collectDtsInfo(f, Z), Z.nalUnitType === "seq_parameter_set_rbsp" && !P && (P = Z.config, f.sps = [Z.data], Fm.forEach(function(ee) {
        f[ee] = P[ee];
      }, this)), Z.nalUnitType === "pic_parameter_set_rbsp" && !G && (G = Z.data, f.pps = [Z.data]), T.push(Z);
    }, this.flush = function() {
      for (var Z, ee, se, fe, ve, Ve, Te = 0, $e, ht; T.length && T[0].nalUnitType !== "access_unit_delimiter_rbsp"; )
        T.shift();
      if (T.length === 0) {
        this.resetStream_(), this.trigger("done", "VideoSegmentStream");
        return;
      }
      if (Z = Mo.groupNalsIntoFrames(T), se = Mo.groupFramesIntoGops(Z), se[0][0].keyFrame || (ee = this.getGopForFusion_(T[0], f), ee ? (Te = ee.duration, se.unshift(ee), se.byteLength += ee.byteLength, se.nalCount += ee.nalCount, se.pts = ee.pts, se.dts = ee.dts, se.duration += ee.duration) : se = Mo.extendFirstKeyFrame(se)), E.length) {
        var Ti;
        if (v.alignGopsAtEnd ? Ti = this.alignGopsAtEnd_(se) : Ti = this.alignGopsAtStart_(se), !Ti) {
          this.gopCache_.unshift({
            gop: se.pop(),
            pps: f.pps,
            sps: f.sps
          }), this.gopCache_.length = Math.min(6, this.gopCache_.length), T = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
          return;
        }
        Yn.clearDtsInfo(f), se = Ti;
      }
      Yn.collectDtsInfo(f, se), f.samples = Mo.generateSampleTable(se), ve = Io.mdat(Mo.concatenateNalData(se)), f.baseMediaDecodeTime = Yn.calculateTrackBaseMediaDecodeTime(f, v.keepOriginalTimestamps), this.trigger("processedGopsInfo", se.map(function(cn) {
        return {
          pts: cn.pts,
          dts: cn.dts,
          byteLength: cn.byteLength
        };
      })), $e = se[0], ht = se[se.length - 1], this.trigger("segmentTimingInfo", Vm(f.baseMediaDecodeTime, $e.dts, $e.pts, ht.dts + ht.duration, ht.pts + ht.duration, Te)), this.trigger("timingInfo", {
        start: se[0].pts,
        end: se[se.length - 1].pts + se[se.length - 1].duration
      }), this.gopCache_.unshift({
        gop: se.pop(),
        pps: f.pps,
        sps: f.sps
      }), this.gopCache_.length = Math.min(6, this.gopCache_.length), T = [], this.trigger("baseMediaDecodeTime", f.baseMediaDecodeTime), this.trigger("timelineStartInfo", f.timelineStartInfo), fe = Io.moof(S, [f]), Ve = new Uint8Array(fe.byteLength + ve.byteLength), S++, Ve.set(fe), Ve.set(ve, fe.byteLength), this.trigger("data", {
        track: f,
        boxes: Ve
      }), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
    }, this.reset = function() {
      this.resetStream_(), T = [], this.gopCache_.length = 0, E.length = 0, this.trigger("reset");
    }, this.resetStream_ = function() {
      Yn.clearDtsInfo(f), P = void 0, G = void 0;
    }, this.getGopForFusion_ = function(Z) {
      var ee = 45e3, se = 1 / 0, fe, ve, Ve, Te, $e;
      for ($e = 0; $e < this.gopCache_.length; $e++)
        Te = this.gopCache_[$e], Ve = Te.gop, !(!(f.pps && Um(f.pps[0], Te.pps[0])) || !(f.sps && Um(f.sps[0], Te.sps[0]))) && (Ve.dts < f.timelineStartInfo.dts || (fe = Z.dts - Ve.dts - Ve.duration, fe >= -1e4 && fe <= ee && (!ve || se > fe) && (ve = Te, se = fe)));
      return ve ? ve.gop : null;
    }, this.alignGopsAtStart_ = function(Z) {
      var ee, se, fe, ve, Ve, Te, $e, ht;
      for (Ve = Z.byteLength, Te = Z.nalCount, $e = Z.duration, ee = se = 0; ee < E.length && se < Z.length && (fe = E[ee], ve = Z[se], fe.pts !== ve.pts); ) {
        if (ve.pts > fe.pts) {
          ee++;
          continue;
        }
        se++, Ve -= ve.byteLength, Te -= ve.nalCount, $e -= ve.duration;
      }
      return se === 0 ? Z : se === Z.length ? null : (ht = Z.slice(se), ht.byteLength = Ve, ht.duration = $e, ht.nalCount = Te, ht.pts = ht[0].pts, ht.dts = ht[0].dts, ht);
    }, this.alignGopsAtEnd_ = function(Z) {
      var ee, se, fe, ve, Ve, Te;
      for (ee = E.length - 1, se = Z.length - 1, Ve = null, Te = !1; ee >= 0 && se >= 0; ) {
        if (fe = E[ee], ve = Z[se], fe.pts === ve.pts) {
          Te = !0;
          break;
        }
        if (fe.pts > ve.pts) {
          ee--;
          continue;
        }
        ee === E.length - 1 && (Ve = se), se--;
      }
      if (!Te && Ve === null)
        return null;
      var $e;
      if (Te ? $e = se : $e = Ve, $e === 0)
        return Z;
      var ht = Z.slice($e), Ti = ht.reduce(function(cn, Js) {
        return cn.byteLength += Js.byteLength, cn.duration += Js.duration, cn.nalCount += Js.nalCount, cn;
      }, {
        byteLength: 0,
        duration: 0,
        nalCount: 0
      });
      return ht.byteLength = Ti.byteLength, ht.duration = Ti.duration, ht.nalCount = Ti.nalCount, ht.pts = ht[0].pts, ht.dts = ht[0].dts, ht;
    }, this.alignGopsWith = function(Z) {
      E = Z;
    };
  }, fu.prototype = new uu(), Dr = function(f, v) {
    this.numberOfTracks = 0, this.metadataStream = v, f = f || {}, typeof f.remux < "u" ? this.remuxTracks = !!f.remux : this.remuxTracks = !0, typeof f.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = f.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, Dr.prototype.init.call(this), this.push = function(S) {
      if (S.content || S.text)
        return this.pendingCaptions.push(S);
      if (S.frames)
        return this.pendingMetadata.push(S);
      this.pendingTracks.push(S.track), this.pendingBytes += S.boxes.byteLength, S.track.type === "video" && (this.videoTrack = S.track, this.pendingBoxes.push(S.boxes)), S.track.type === "audio" && (this.audioTrack = S.track, this.pendingBoxes.unshift(S.boxes));
    };
  }, Dr.prototype = new uu(), Dr.prototype.flush = function(f) {
    var v = 0, S = {
      captions: [],
      captionStreams: {},
      metadata: [],
      info: {}
    }, T, E, P, G = 0, Z;
    if (this.pendingTracks.length < this.numberOfTracks) {
      if (f !== "VideoSegmentStream" && f !== "AudioSegmentStream")
        return;
      if (this.remuxTracks)
        return;
      if (this.pendingTracks.length === 0) {
        this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
        return;
      }
    }
    if (this.videoTrack ? (G = this.videoTrack.timelineStartInfo.pts, Fm.forEach(function(ee) {
      S.info[ee] = this.videoTrack[ee];
    }, this)) : this.audioTrack && (G = this.audioTrack.timelineStartInfo.pts, Rm.forEach(function(ee) {
      S.info[ee] = this.audioTrack[ee];
    }, this)), this.videoTrack || this.audioTrack) {
      for (this.pendingTracks.length === 1 ? S.type = this.pendingTracks[0].type : S.type = "combined", this.emittedTracks += this.pendingTracks.length, P = Io.initSegment(this.pendingTracks), S.initSegment = new Uint8Array(P.byteLength), S.initSegment.set(P), S.data = new Uint8Array(this.pendingBytes), Z = 0; Z < this.pendingBoxes.length; Z++)
        S.data.set(this.pendingBoxes[Z], v), v += this.pendingBoxes[Z].byteLength;
      for (Z = 0; Z < this.pendingCaptions.length; Z++)
        T = this.pendingCaptions[Z], T.startTime = cu.metadataTsToSeconds(T.startPts, G, this.keepOriginalTimestamps), T.endTime = cu.metadataTsToSeconds(T.endPts, G, this.keepOriginalTimestamps), S.captionStreams[T.stream] = !0, S.captions.push(T);
      for (Z = 0; Z < this.pendingMetadata.length; Z++)
        E = this.pendingMetadata[Z], E.cueTime = cu.metadataTsToSeconds(E.pts, G, this.keepOriginalTimestamps), S.metadata.push(E);
      for (S.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", S), Z = 0; Z < S.captions.length; Z++)
        T = S.captions[Z], this.trigger("caption", T);
      for (Z = 0; Z < S.metadata.length; Z++)
        E = S.metadata[Z], this.trigger("id3Frame", E);
    }
    this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
  }, Dr.prototype.setRemux = function(f) {
    this.remuxTracks = f;
  }, hu = function(f) {
    var v = this, S = !0, T, E;
    hu.prototype.init.call(this), f = f || {}, this.baseMediaDecodeTime = f.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
      var P = {};
      this.transmuxPipeline_ = P, P.type = "aac", P.metadataStream = new Ms.MetadataStream(), P.aacStream = new yT(), P.audioTimestampRolloverStream = new Ms.TimestampRolloverStream("audio"), P.timedMetadataTimestampRolloverStream = new Ms.TimestampRolloverStream("timed-metadata"), P.adtsStream = new Nm(), P.coalesceStream = new Dr(f, P.metadataStream), P.headOfPipeline = P.aacStream, P.aacStream.pipe(P.audioTimestampRolloverStream).pipe(P.adtsStream), P.aacStream.pipe(P.timedMetadataTimestampRolloverStream).pipe(P.metadataStream).pipe(P.coalesceStream), P.metadataStream.on("timestamp", function(G) {
        P.aacStream.setTimestamp(G.timeStamp);
      }), P.aacStream.on("data", function(G) {
        G.type !== "timed-metadata" && G.type !== "audio" || P.audioSegmentStream || (E = E || {
          timelineStartInfo: {
            baseMediaDecodeTime: v.baseMediaDecodeTime
          },
          codec: "adts",
          type: "audio"
        }, P.coalesceStream.numberOfTracks++, P.audioSegmentStream = new Oo(E, f), P.audioSegmentStream.on("log", v.getLogTrigger_("audioSegmentStream")), P.audioSegmentStream.on("timingInfo", v.trigger.bind(v, "audioTimingInfo")), P.adtsStream.pipe(P.audioSegmentStream).pipe(P.coalesceStream), v.trigger("trackinfo", {
          hasAudio: !!E,
          hasVideo: !!T
        }));
      }), P.coalesceStream.on("data", this.trigger.bind(this, "data")), P.coalesceStream.on("done", this.trigger.bind(this, "done")), zm(this, P);
    }, this.setupTsPipeline = function() {
      var P = {};
      this.transmuxPipeline_ = P, P.type = "ts", P.metadataStream = new Ms.MetadataStream(), P.packetStream = new Ms.TransportPacketStream(), P.parseStream = new Ms.TransportParseStream(), P.elementaryStream = new Ms.ElementaryStream(), P.timestampRolloverStream = new Ms.TimestampRolloverStream(), P.adtsStream = new Nm(), P.h264Stream = new vT(), P.captionStream = new Ms.CaptionStream(f), P.coalesceStream = new Dr(f, P.metadataStream), P.headOfPipeline = P.packetStream, P.packetStream.pipe(P.parseStream).pipe(P.elementaryStream).pipe(P.timestampRolloverStream), P.timestampRolloverStream.pipe(P.h264Stream), P.timestampRolloverStream.pipe(P.adtsStream), P.timestampRolloverStream.pipe(P.metadataStream).pipe(P.coalesceStream), P.h264Stream.pipe(P.captionStream).pipe(P.coalesceStream), P.elementaryStream.on("data", function(G) {
        var Z;
        if (G.type === "metadata") {
          for (Z = G.tracks.length; Z--; )
            !T && G.tracks[Z].type === "video" ? (T = G.tracks[Z], T.timelineStartInfo.baseMediaDecodeTime = v.baseMediaDecodeTime) : !E && G.tracks[Z].type === "audio" && (E = G.tracks[Z], E.timelineStartInfo.baseMediaDecodeTime = v.baseMediaDecodeTime);
          T && !P.videoSegmentStream && (P.coalesceStream.numberOfTracks++, P.videoSegmentStream = new fu(T, f), P.videoSegmentStream.on("log", v.getLogTrigger_("videoSegmentStream")), P.videoSegmentStream.on("timelineStartInfo", function(ee) {
            E && !f.keepOriginalTimestamps && (E.timelineStartInfo = ee, P.audioSegmentStream.setEarliestDts(ee.dts - v.baseMediaDecodeTime));
          }), P.videoSegmentStream.on("processedGopsInfo", v.trigger.bind(v, "gopInfo")), P.videoSegmentStream.on("segmentTimingInfo", v.trigger.bind(v, "videoSegmentTimingInfo")), P.videoSegmentStream.on("baseMediaDecodeTime", function(ee) {
            E && P.audioSegmentStream.setVideoBaseMediaDecodeTime(ee);
          }), P.videoSegmentStream.on("timingInfo", v.trigger.bind(v, "videoTimingInfo")), P.h264Stream.pipe(P.videoSegmentStream).pipe(P.coalesceStream)), E && !P.audioSegmentStream && (P.coalesceStream.numberOfTracks++, P.audioSegmentStream = new Oo(E, f), P.audioSegmentStream.on("log", v.getLogTrigger_("audioSegmentStream")), P.audioSegmentStream.on("timingInfo", v.trigger.bind(v, "audioTimingInfo")), P.audioSegmentStream.on("segmentTimingInfo", v.trigger.bind(v, "audioSegmentTimingInfo")), P.adtsStream.pipe(P.audioSegmentStream).pipe(P.coalesceStream)), v.trigger("trackinfo", {
            hasAudio: !!E,
            hasVideo: !!T
          });
        }
      }), P.coalesceStream.on("data", this.trigger.bind(this, "data")), P.coalesceStream.on("id3Frame", function(G) {
        G.dispatchType = P.metadataStream.dispatchType, v.trigger("id3Frame", G);
      }), P.coalesceStream.on("caption", this.trigger.bind(this, "caption")), P.coalesceStream.on("done", this.trigger.bind(this, "done")), zm(this, P);
    }, this.setBaseMediaDecodeTime = function(P) {
      var G = this.transmuxPipeline_;
      f.keepOriginalTimestamps || (this.baseMediaDecodeTime = P), E && (E.timelineStartInfo.dts = void 0, E.timelineStartInfo.pts = void 0, Yn.clearDtsInfo(E), G.audioTimestampRolloverStream && G.audioTimestampRolloverStream.discontinuity()), T && (G.videoSegmentStream && (G.videoSegmentStream.gopCache_ = []), T.timelineStartInfo.dts = void 0, T.timelineStartInfo.pts = void 0, Yn.clearDtsInfo(T), G.captionStream.reset()), G.timestampRolloverStream && G.timestampRolloverStream.discontinuity();
    }, this.setAudioAppendStart = function(P) {
      E && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(P);
    }, this.setRemux = function(P) {
      var G = this.transmuxPipeline_;
      f.remux = P, G && G.coalesceStream && G.coalesceStream.setRemux(P);
    }, this.alignGopsWith = function(P) {
      T && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(P);
    }, this.getLogTrigger_ = function(P) {
      var G = this;
      return function(Z) {
        Z.stream = P, G.trigger("log", Z);
      };
    }, this.push = function(P) {
      if (S) {
        var G = bT(P);
        G && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !G && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), S = !1;
      }
      this.transmuxPipeline_.headOfPipeline.push(P);
    }, this.flush = function() {
      S = !0, this.transmuxPipeline_.headOfPipeline.flush();
    }, this.endTimeline = function() {
      this.transmuxPipeline_.headOfPipeline.endTimeline();
    }, this.reset = function() {
      this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
    }, this.resetCaptions = function() {
      this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
    };
  }, hu.prototype = new uu();
  var xT = {
    Transmuxer: hu
  }, ST = function(f) {
    return f >>> 0;
  }, CT = function(f) {
    return ("00" + f.toString(16)).slice(-2);
  }, pu = {
    toUnsigned: ST,
    toHexString: CT
  }, ET = function(f) {
    var v = "";
    return v += String.fromCharCode(f[0]), v += String.fromCharCode(f[1]), v += String.fromCharCode(f[2]), v += String.fromCharCode(f[3]), v;
  }, qm = ET, DT = pu.toUnsigned, _T = qm, Hm = function(f, v) {
    var S = [], T, E, P, G, Z;
    if (!v.length)
      return null;
    for (T = 0; T < f.byteLength; )
      E = DT(f[T] << 24 | f[T + 1] << 16 | f[T + 2] << 8 | f[T + 3]), P = _T(f.subarray(T + 4, T + 8)), G = E > 1 ? T + E : f.byteLength, P === v[0] && (v.length === 1 ? S.push(f.subarray(T + 8, G)) : (Z = Hm(f.subarray(T + 8, G), v.slice(1)), Z.length && (S = S.concat(Z)))), T = G;
    return S;
  }, Ec = Hm, kT = pu.toUnsigned, PT = r.getUint64, IT = function(f) {
    var v = {
      version: f[0],
      flags: new Uint8Array(f.subarray(1, 4))
    };
    return v.version === 1 ? v.baseMediaDecodeTime = PT(f.subarray(4)) : v.baseMediaDecodeTime = kT(f[4] << 24 | f[5] << 16 | f[6] << 8 | f[7]), v;
  }, Dc = IT, MT = function(f) {
    var v = new DataView(f.buffer, f.byteOffset, f.byteLength), S = {
      version: f[0],
      flags: new Uint8Array(f.subarray(1, 4)),
      trackId: v.getUint32(4)
    }, T = S.flags[2] & 1, E = S.flags[2] & 2, P = S.flags[2] & 8, G = S.flags[2] & 16, Z = S.flags[2] & 32, ee = S.flags[0] & 65536, se = S.flags[0] & 131072, fe;
    return fe = 8, T && (fe += 4, S.baseDataOffset = v.getUint32(12), fe += 4), E && (S.sampleDescriptionIndex = v.getUint32(fe), fe += 4), P && (S.defaultSampleDuration = v.getUint32(fe), fe += 4), G && (S.defaultSampleSize = v.getUint32(fe), fe += 4), Z && (S.defaultSampleFlags = v.getUint32(fe)), ee && (S.durationIsEmpty = !0), !T && se && (S.baseDataOffsetIsMoof = !0), S;
  }, Wm = MT, OT = function(f) {
    return {
      isLeading: (f[0] & 12) >>> 2,
      dependsOn: f[0] & 3,
      isDependedOn: (f[1] & 192) >>> 6,
      hasRedundancy: (f[1] & 48) >>> 4,
      paddingValue: (f[1] & 14) >>> 1,
      isNonSyncSample: f[1] & 1,
      degradationPriority: f[2] << 8 | f[3]
    };
  }, BT = OT, Ym = BT, LT = function(f) {
    var v = {
      version: f[0],
      flags: new Uint8Array(f.subarray(1, 4)),
      samples: []
    }, S = new DataView(f.buffer, f.byteOffset, f.byteLength), T = v.flags[2] & 1, E = v.flags[2] & 4, P = v.flags[1] & 1, G = v.flags[1] & 2, Z = v.flags[1] & 4, ee = v.flags[1] & 8, se = S.getUint32(4), fe = 8, ve;
    for (T && (v.dataOffset = S.getInt32(fe), fe += 4), E && se && (ve = {
      flags: Ym(f.subarray(fe, fe + 4))
    }, fe += 4, P && (ve.duration = S.getUint32(fe), fe += 4), G && (ve.size = S.getUint32(fe), fe += 4), ee && (v.version === 1 ? ve.compositionTimeOffset = S.getInt32(fe) : ve.compositionTimeOffset = S.getUint32(fe), fe += 4), v.samples.push(ve), se--); se--; )
      ve = {}, P && (ve.duration = S.getUint32(fe), fe += 4), G && (ve.size = S.getUint32(fe), fe += 4), Z && (ve.flags = Ym(f.subarray(fe, fe + 4)), fe += 4), ee && (v.version === 1 ? ve.compositionTimeOffset = S.getInt32(fe) : ve.compositionTimeOffset = S.getUint32(fe), fe += 4), v.samples.push(ve);
    return v;
  }, Xm = LT, jm = {
    tfdt: Dc,
    trun: Xm
  }, Gm = {
    parseTfdt: jm.tfdt,
    parseTrun: jm.trun
  }, NT = function(f) {
    for (var v = 0, S = String.fromCharCode(f[v]), T = ""; S !== "\0"; )
      T += S, v++, S = String.fromCharCode(f[v]);
    return T += S, T;
  }, RT = {
    uint8ToCString: NT
  }, mu = RT.uint8ToCString, FT = r.getUint64, zT = function(f) {
    var v = 4, S = f[0], T, E, P, G, Z, ee, se, fe;
    if (S === 0) {
      T = mu(f.subarray(v)), v += T.length, E = mu(f.subarray(v)), v += E.length;
      var ve = new DataView(f.buffer);
      P = ve.getUint32(v), v += 4, Z = ve.getUint32(v), v += 4, ee = ve.getUint32(v), v += 4, se = ve.getUint32(v), v += 4;
    } else if (S === 1) {
      var ve = new DataView(f.buffer);
      P = ve.getUint32(v), v += 4, G = FT(f.subarray(v)), v += 8, ee = ve.getUint32(v), v += 4, se = ve.getUint32(v), v += 4, T = mu(f.subarray(v)), v += T.length, E = mu(f.subarray(v)), v += E.length;
    }
    fe = new Uint8Array(f.subarray(v, f.byteLength));
    var Ve = {
      scheme_id_uri: T,
      value: E,
      // if timescale is undefined or 0 set to 1 
      timescale: P || 1,
      presentation_time: G,
      presentation_time_delta: Z,
      event_duration: ee,
      id: se,
      message_data: fe
    };
    return VT(S, Ve) ? Ve : void 0;
  }, UT = function(f, v, S, T) {
    return f || f === 0 ? f / v : T + S / v;
  }, VT = function(f, v) {
    var S = v.scheme_id_uri !== "\0", T = f === 0 && Qm(v.presentation_time_delta) && S, E = f === 1 && Qm(v.presentation_time) && S;
    return !(f > 1) && T || E;
  }, Qm = function(f) {
    return f !== void 0 || f !== null;
  }, qT = {
    parseEmsgBox: zT,
    scaleTime: UT
  }, Bo;
  typeof window < "u" ? Bo = window : typeof t < "u" ? Bo = t : typeof self < "u" ? Bo = self : Bo = {};
  var Zm = Bo, Au = pu.toUnsigned, Lo = pu.toHexString, ci = Ec, da = qm, _c = qT, HT = Wm, WT = Xm, YT = Dc, XT = r.getUint64, Km, Jm, $m, eA, tA, kc, iA, Pc = Zm, jT = Em.parseId3Frames;
  Km = function(f) {
    var v = {}, S = ci(f, ["moov", "trak"]);
    return S.reduce(function(T, E) {
      var P, G, Z, ee, se;
      return P = ci(E, ["tkhd"])[0], !P || (G = P[0], Z = G === 0 ? 12 : 20, ee = Au(P[Z] << 24 | P[Z + 1] << 16 | P[Z + 2] << 8 | P[Z + 3]), se = ci(E, ["mdia", "mdhd"])[0], !se) ? null : (G = se[0], Z = G === 0 ? 12 : 20, T[ee] = Au(se[Z] << 24 | se[Z + 1] << 16 | se[Z + 2] << 8 | se[Z + 3]), T);
    }, v);
  }, Jm = function(f, v) {
    var S;
    S = ci(v, ["moof", "traf"]);
    var T = S.reduce(function(E, P) {
      var G = ci(P, ["tfhd"])[0], Z = Au(G[4] << 24 | G[5] << 16 | G[6] << 8 | G[7]), ee = f[Z] || 9e4, se = ci(P, ["tfdt"])[0], fe = new DataView(se.buffer, se.byteOffset, se.byteLength), ve;
      se[0] === 1 ? ve = XT(se.subarray(4, 12)) : ve = fe.getUint32(4);
      let Ve;
      return typeof ve == "bigint" ? Ve = ve / Pc.BigInt(ee) : typeof ve == "number" && !isNaN(ve) && (Ve = ve / ee), Ve < Number.MAX_SAFE_INTEGER && (Ve = Number(Ve)), Ve < E && (E = Ve), E;
    }, 1 / 0);
    return typeof T == "bigint" || isFinite(T) ? T : 0;
  }, $m = function(f, v) {
    var S = ci(v, ["moof", "traf"]), T = 0, E = 0, P;
    if (S && S.length) {
      var G = ci(S[0], ["tfhd"])[0], Z = ci(S[0], ["trun"])[0], ee = ci(S[0], ["tfdt"])[0];
      if (G) {
        var se = HT(G);
        P = se.trackId;
      }
      if (ee) {
        var fe = YT(ee);
        T = fe.baseMediaDecodeTime;
      }
      if (Z) {
        var ve = WT(Z);
        ve.samples && ve.samples.length && (E = ve.samples[0].compositionTimeOffset || 0);
      }
    }
    var Ve = f[P] || 9e4;
    typeof T == "bigint" && (E = Pc.BigInt(E), Ve = Pc.BigInt(Ve));
    var Te = (T + E) / Ve;
    return typeof Te == "bigint" && Te < Number.MAX_SAFE_INTEGER && (Te = Number(Te)), Te;
  }, eA = function(f) {
    var v = ci(f, ["moov", "trak"]), S = [];
    return v.forEach(function(T) {
      var E = ci(T, ["mdia", "hdlr"]), P = ci(T, ["tkhd"]);
      E.forEach(function(G, Z) {
        var ee = da(G.subarray(8, 12)), se = P[Z], fe, ve, Ve;
        ee === "vide" && (fe = new DataView(se.buffer, se.byteOffset, se.byteLength), ve = fe.getUint8(0), Ve = ve === 0 ? fe.getUint32(12) : fe.getUint32(20), S.push(Ve));
      });
    }), S;
  }, kc = function(f) {
    var v = f[0], S = v === 0 ? 12 : 20;
    return Au(f[S] << 24 | f[S + 1] << 16 | f[S + 2] << 8 | f[S + 3]);
  }, tA = function(f) {
    var v = ci(f, ["moov", "trak"]), S = [];
    return v.forEach(function(T) {
      var E = {}, P = ci(T, ["tkhd"])[0], G, Z;
      P && (G = new DataView(P.buffer, P.byteOffset, P.byteLength), Z = G.getUint8(0), E.id = Z === 0 ? G.getUint32(12) : G.getUint32(20));
      var ee = ci(T, ["mdia", "hdlr"])[0];
      if (ee) {
        var se = da(ee.subarray(8, 12));
        se === "vide" ? E.type = "video" : se === "soun" ? E.type = "audio" : E.type = se;
      }
      var fe = ci(T, ["mdia", "minf", "stbl", "stsd"])[0];
      if (fe) {
        var ve = fe.subarray(8);
        E.codec = da(ve.subarray(4, 8));
        var Ve = ci(ve, [E.codec])[0], Te, $e;
        Ve && (/^[asm]vc[1-9]$/i.test(E.codec) ? (Te = Ve.subarray(78), $e = da(Te.subarray(4, 8)), $e === "avcC" && Te.length > 11 ? (E.codec += ".", E.codec += Lo(Te[9]), E.codec += Lo(Te[10]), E.codec += Lo(Te[11])) : E.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(E.codec) ? (Te = Ve.subarray(28), $e = da(Te.subarray(4, 8)), $e === "esds" && Te.length > 20 && Te[19] !== 0 ? (E.codec += "." + Lo(Te[19]), E.codec += "." + Lo(Te[20] >>> 2 & 63).replace(/^0/, "")) : E.codec = "mp4a.40.2") : E.codec = E.codec.toLowerCase());
      }
      var ht = ci(T, ["mdia", "mdhd"])[0];
      ht && (E.timescale = kc(ht)), S.push(E);
    }), S;
  }, iA = function(f, v = 0) {
    var S = ci(f, ["emsg"]);
    return S.map((T) => {
      var E = _c.parseEmsgBox(new Uint8Array(T)), P = jT(E.message_data);
      return {
        cueTime: _c.scaleTime(E.presentation_time, E.timescale, E.presentation_time_delta, v),
        duration: _c.scaleTime(E.event_duration, E.timescale),
        frames: P
      };
    });
  };
  var No = {
    // export mp4 inspector's findBox and parseType for backwards compatibility
    findBox: ci,
    parseType: da,
    timescale: Km,
    startTime: Jm,
    compositionStartTime: $m,
    videoTrackIds: eA,
    tracks: tA,
    getTimescaleFromMediaHeader: kc,
    getEmsgID3: iA
  };
  const {
    parseTrun: GT
  } = Gm, {
    findBox: nA
  } = No;
  var sA = Zm, QT = function(f) {
    var v = nA(f, ["moof", "traf"]), S = nA(f, ["mdat"]), T = [];
    return S.forEach(function(E, P) {
      var G = v[P];
      T.push({
        mdat: E,
        traf: G
      });
    }), T;
  }, ZT = function(f, v, S) {
    var T = v, E = S.defaultSampleDuration || 0, P = S.defaultSampleSize || 0, G = S.trackId, Z = [];
    return f.forEach(function(ee) {
      var se = GT(ee), fe = se.samples;
      fe.forEach(function(ve) {
        ve.duration === void 0 && (ve.duration = E), ve.size === void 0 && (ve.size = P), ve.trackId = G, ve.dts = T, ve.compositionTimeOffset === void 0 && (ve.compositionTimeOffset = 0), typeof T == "bigint" ? (ve.pts = T + sA.BigInt(ve.compositionTimeOffset), T += sA.BigInt(ve.duration)) : (ve.pts = T + ve.compositionTimeOffset, T += ve.duration);
      }), Z = Z.concat(fe);
    }), Z;
  }, rA = {
    getMdatTrafPairs: QT,
    parseSamples: ZT
  }, KT = ls.discardEmulationPreventionBytes, JT = Tm.CaptionStream, Ic = Ec, $T = Dc, e2 = Wm, {
    getMdatTrafPairs: t2,
    parseSamples: i2
  } = rA, n2 = function(f, v) {
    for (var S = f, T = 0; T < v.length; T++) {
      var E = v[T];
      if (S < E.size)
        return E;
      S -= E.size;
    }
    return null;
  }, s2 = function(f, v, S) {
    var T = new DataView(f.buffer, f.byteOffset, f.byteLength), E = {
      logs: [],
      seiNals: []
    }, P, G, Z, ee;
    for (G = 0; G + 4 < f.length; G += Z)
      if (Z = T.getUint32(G), G += 4, !(Z <= 0))
        switch (f[G] & 31) {
          case 6:
            var se = f.subarray(G + 1, G + 1 + Z), fe = n2(G, v);
            if (P = {
              nalUnitType: "sei_rbsp",
              size: Z,
              data: se,
              escapedRBSP: KT(se),
              trackId: S
            }, fe)
              P.pts = fe.pts, P.dts = fe.dts, ee = fe;
            else if (ee)
              P.pts = ee.pts, P.dts = ee.dts;
            else {
              E.logs.push({
                level: "warn",
                message: "We've encountered a nal unit without data at " + G + " for trackId " + S + ". See mux.js#223."
              });
              break;
            }
            E.seiNals.push(P);
            break;
        }
    return E;
  }, r2 = function(f, v) {
    var S = {}, T = t2(f);
    return T.forEach(function(E) {
      var P = E.mdat, G = E.traf, Z = Ic(G, ["tfhd"]), ee = e2(Z[0]), se = ee.trackId, fe = Ic(G, ["tfdt"]), ve = fe.length > 0 ? $T(fe[0]).baseMediaDecodeTime : 0, Ve = Ic(G, ["trun"]), Te, $e;
      v === se && Ve.length > 0 && (Te = i2(Ve, ve, ee), $e = s2(P, Te, se), S[se] || (S[se] = {
        seiNals: [],
        logs: []
      }), S[se].seiNals = S[se].seiNals.concat($e.seiNals), S[se].logs = S[se].logs.concat($e.logs));
    }), S;
  }, a2 = function(f, v, S) {
    var T;
    if (v === null)
      return null;
    T = r2(f, v);
    var E = T[v] || {};
    return {
      seiNals: E.seiNals,
      logs: E.logs,
      timescale: S
    };
  }, o2 = function() {
    var f = !1, v, S, T, E, P, G;
    this.isInitialized = function() {
      return f;
    }, this.init = function(Z) {
      v = new JT(), f = !0, G = Z ? Z.isPartial : !1, v.on("data", function(ee) {
        ee.startTime = ee.startPts / E, ee.endTime = ee.endPts / E, P.captions.push(ee), P.captionStreams[ee.stream] = !0;
      }), v.on("log", function(ee) {
        P.logs.push(ee);
      });
    }, this.isNewInit = function(Z, ee) {
      return Z && Z.length === 0 || ee && typeof ee == "object" && Object.keys(ee).length === 0 ? !1 : T !== Z[0] || E !== ee[T];
    }, this.parse = function(Z, ee, se) {
      var fe;
      if (this.isInitialized()) {
        if (!ee || !se)
          return null;
        if (this.isNewInit(ee, se))
          T = ee[0], E = se[T];
        else if (T === null || !E)
          return S.push(Z), null;
      } else return null;
      for (; S.length > 0; ) {
        var ve = S.shift();
        this.parse(ve, ee, se);
      }
      return fe = a2(Z, T, E), fe && fe.logs && (P.logs = P.logs.concat(fe.logs)), fe === null || !fe.seiNals ? P.logs.length ? {
        logs: P.logs,
        captions: [],
        captionStreams: []
      } : null : (this.pushNals(fe.seiNals), this.flushStream(), P);
    }, this.pushNals = function(Z) {
      if (!this.isInitialized() || !Z || Z.length === 0)
        return null;
      Z.forEach(function(ee) {
        v.push(ee);
      });
    }, this.flushStream = function() {
      if (!this.isInitialized())
        return null;
      G ? v.partialFlush() : v.flush();
    }, this.clearParsedCaptions = function() {
      P.captions = [], P.captionStreams = {}, P.logs = [];
    }, this.resetCaptionStream = function() {
      if (!this.isInitialized())
        return null;
      v.reset();
    }, this.clearAllCaptions = function() {
      this.clearParsedCaptions(), this.resetCaptionStream();
    }, this.reset = function() {
      S = [], T = null, E = null, P ? this.clearParsedCaptions() : P = {
        captions: [],
        // CC1, CC2, CC3, CC4
        captionStreams: {},
        logs: []
      }, this.resetCaptionStream();
    }, this.reset();
  }, l2 = o2;
  const {
    parseTfdt: u2
  } = Gm, Ks = Ec, {
    getTimescaleFromMediaHeader: d2
  } = No, {
    parseSamples: c2,
    getMdatTrafPairs: f2
  } = rA;
  var aA = function() {
    let f = 9e4;
    this.init = function(v) {
      const S = Ks(v, ["moov", "trak", "mdia", "mdhd"])[0];
      S && (f = d2(S));
    }, this.parseSegment = function(v) {
      const S = [], T = f2(v);
      let E = 0;
      return T.forEach(function(P) {
        const G = P.mdat, Z = P.traf, ee = Ks(Z, ["tfdt"])[0], se = Ks(Z, ["tfhd"])[0], fe = Ks(Z, ["trun"]);
        if (ee && (E = u2(ee).baseMediaDecodeTime), fe.length && se) {
          const ve = c2(fe, E, se);
          let Ve = 0;
          ve.forEach(function(Te) {
            const $e = "utf-8", ht = new TextDecoder($e), Ti = G.slice(Ve, Ve + Te.size);
            if (Ks(Ti, ["vtte"])[0]) {
              Ve += Te.size;
              return;
            }
            Ks(Ti, ["vttc"]).forEach(function(Ro) {
              const Fo = Ks(Ro, ["payl"])[0], zo = Ks(Ro, ["sttg"])[0], Uo = Te.pts / f, yu = (Te.pts + Te.duration) / f;
              let Ht, Vo;
              if (Fo)
                try {
                  Ht = ht.decode(Fo);
                } catch (Xn) {
                  console.error(Xn);
                }
              if (zo)
                try {
                  Vo = ht.decode(zo);
                } catch (Xn) {
                  console.error(Xn);
                }
              Te.duration && Ht && S.push({
                cueText: Ht,
                start: Uo,
                end: yu,
                settings: Vo
              });
            }), Ve += Te.size;
          });
        }
      }), S;
    };
  }, Mc = $l, oA = function(f) {
    var v = f[1] & 31;
    return v <<= 8, v |= f[2], v;
  }, gu = function(f) {
    return !!(f[1] & 64);
  }, vu = function(f) {
    var v = 0;
    return (f[3] & 48) >>> 4 > 1 && (v += f[4] + 1), v;
  }, h2 = function(f, v) {
    var S = oA(f);
    return S === 0 ? "pat" : S === v ? "pmt" : v ? "pes" : null;
  }, p2 = function(f) {
    var v = gu(f), S = 4 + vu(f);
    return v && (S += f[S] + 1), (f[S + 10] & 31) << 8 | f[S + 11];
  }, m2 = function(f) {
    var v = {}, S = gu(f), T = 4 + vu(f);
    if (S && (T += f[T] + 1), !!(f[T + 5] & 1)) {
      var E, P, G;
      E = (f[T + 1] & 15) << 8 | f[T + 2], P = 3 + E - 4, G = (f[T + 10] & 15) << 8 | f[T + 11];
      for (var Z = 12 + G; Z < P; ) {
        var ee = T + Z;
        v[(f[ee + 1] & 31) << 8 | f[ee + 2]] = f[ee], Z += ((f[ee + 3] & 15) << 8 | f[ee + 4]) + 5;
      }
      return v;
    }
  }, A2 = function(f, v) {
    var S = oA(f), T = v[S];
    switch (T) {
      case Mc.H264_STREAM_TYPE:
        return "video";
      case Mc.ADTS_STREAM_TYPE:
        return "audio";
      case Mc.METADATA_STREAM_TYPE:
        return "timed-metadata";
      default:
        return null;
    }
  }, g2 = function(f) {
    var v = gu(f);
    if (!v)
      return null;
    var S = 4 + vu(f);
    if (S >= f.byteLength)
      return null;
    var T = null, E;
    return E = f[S + 7], E & 192 && (T = {}, T.pts = (f[S + 9] & 14) << 27 | (f[S + 10] & 255) << 20 | (f[S + 11] & 254) << 12 | (f[S + 12] & 255) << 5 | (f[S + 13] & 254) >>> 3, T.pts *= 4, T.pts += (f[S + 13] & 6) >>> 1, T.dts = T.pts, E & 64 && (T.dts = (f[S + 14] & 14) << 27 | (f[S + 15] & 255) << 20 | (f[S + 16] & 254) << 12 | (f[S + 17] & 255) << 5 | (f[S + 18] & 254) >>> 3, T.dts *= 4, T.dts += (f[S + 18] & 6) >>> 1)), T;
  }, Oc = function(f) {
    switch (f) {
      case 5:
        return "slice_layer_without_partitioning_rbsp_idr";
      case 6:
        return "sei_rbsp";
      case 7:
        return "seq_parameter_set_rbsp";
      case 8:
        return "pic_parameter_set_rbsp";
      case 9:
        return "access_unit_delimiter_rbsp";
      default:
        return null;
    }
  }, v2 = function(f) {
    for (var v = 4 + vu(f), S = f.subarray(v), T = 0, E = 0, P = !1, G; E < S.byteLength - 3; E++)
      if (S[E + 2] === 1) {
        T = E + 5;
        break;
      }
    for (; T < S.byteLength; )
      switch (S[T]) {
        case 0:
          if (S[T - 1] !== 0) {
            T += 2;
            break;
          } else if (S[T - 2] !== 0) {
            T++;
            break;
          }
          E + 3 !== T - 2 && (G = Oc(S[E + 3] & 31), G === "slice_layer_without_partitioning_rbsp_idr" && (P = !0));
          do
            T++;
          while (S[T] !== 1 && T < S.length);
          E = T - 2, T += 3;
          break;
        case 1:
          if (S[T - 1] !== 0 || S[T - 2] !== 0) {
            T += 3;
            break;
          }
          G = Oc(S[E + 3] & 31), G === "slice_layer_without_partitioning_rbsp_idr" && (P = !0), E = T - 2, T += 3;
          break;
        default:
          T += 3;
          break;
      }
    return S = S.subarray(E), T -= E, E = 0, S && S.byteLength > 3 && (G = Oc(S[E + 3] & 31), G === "slice_layer_without_partitioning_rbsp_idr" && (P = !0)), P;
  }, y2 = {
    parseType: h2,
    parsePat: p2,
    parsePmt: m2,
    parsePayloadUnitStartIndicator: gu,
    parsePesType: A2,
    parsePesTime: g2,
    videoPacketContainsKeyFrame: v2
  }, lA = $l, ca = Sm.handleRollover, Mt = {};
  Mt.ts = y2, Mt.aac = Cc;
  var _r = xt.ONE_SECOND_IN_TS, ji = 188, us = 71, b2 = function(f, v) {
    for (var S = 0, T = ji, E, P; T < f.byteLength; ) {
      if (f[S] === us && f[T] === us) {
        switch (E = f.subarray(S, T), P = Mt.ts.parseType(E, v.pid), P) {
          case "pat":
            v.pid = Mt.ts.parsePat(E);
            break;
          case "pmt":
            var G = Mt.ts.parsePmt(E);
            v.table = v.table || {}, Object.keys(G).forEach(function(Z) {
              v.table[Z] = G[Z];
            });
            break;
        }
        S += ji, T += ji;
        continue;
      }
      S++, T++;
    }
  }, uA = function(f, v, S) {
    for (var T = 0, E = ji, P, G, Z, ee, se, fe = !1; E <= f.byteLength; ) {
      if (f[T] === us && (f[E] === us || E === f.byteLength)) {
        switch (P = f.subarray(T, E), G = Mt.ts.parseType(P, v.pid), G) {
          case "pes":
            Z = Mt.ts.parsePesType(P, v.table), ee = Mt.ts.parsePayloadUnitStartIndicator(P), Z === "audio" && ee && (se = Mt.ts.parsePesTime(P), se && (se.type = "audio", S.audio.push(se), fe = !0));
            break;
        }
        if (fe)
          break;
        T += ji, E += ji;
        continue;
      }
      T++, E++;
    }
    for (E = f.byteLength, T = E - ji, fe = !1; T >= 0; ) {
      if (f[T] === us && (f[E] === us || E === f.byteLength)) {
        switch (P = f.subarray(T, E), G = Mt.ts.parseType(P, v.pid), G) {
          case "pes":
            Z = Mt.ts.parsePesType(P, v.table), ee = Mt.ts.parsePayloadUnitStartIndicator(P), Z === "audio" && ee && (se = Mt.ts.parsePesTime(P), se && (se.type = "audio", S.audio.push(se), fe = !0));
            break;
        }
        if (fe)
          break;
        T -= ji, E -= ji;
        continue;
      }
      T--, E--;
    }
  }, w2 = function(f, v, S) {
    for (var T = 0, E = ji, P, G, Z, ee, se, fe, ve, Ve, Te = !1, $e = {
      data: [],
      size: 0
    }; E < f.byteLength; ) {
      if (f[T] === us && f[E] === us) {
        switch (P = f.subarray(T, E), G = Mt.ts.parseType(P, v.pid), G) {
          case "pes":
            if (Z = Mt.ts.parsePesType(P, v.table), ee = Mt.ts.parsePayloadUnitStartIndicator(P), Z === "video" && (ee && !Te && (se = Mt.ts.parsePesTime(P), se && (se.type = "video", S.video.push(se), Te = !0)), !S.firstKeyFrame)) {
              if (ee && $e.size !== 0) {
                for (fe = new Uint8Array($e.size), ve = 0; $e.data.length; )
                  Ve = $e.data.shift(), fe.set(Ve, ve), ve += Ve.byteLength;
                if (Mt.ts.videoPacketContainsKeyFrame(fe)) {
                  var ht = Mt.ts.parsePesTime(fe);
                  ht ? (S.firstKeyFrame = ht, S.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                }
                $e.size = 0;
              }
              $e.data.push(P), $e.size += P.byteLength;
            }
            break;
        }
        if (Te && S.firstKeyFrame)
          break;
        T += ji, E += ji;
        continue;
      }
      T++, E++;
    }
    for (E = f.byteLength, T = E - ji, Te = !1; T >= 0; ) {
      if (f[T] === us && f[E] === us) {
        switch (P = f.subarray(T, E), G = Mt.ts.parseType(P, v.pid), G) {
          case "pes":
            Z = Mt.ts.parsePesType(P, v.table), ee = Mt.ts.parsePayloadUnitStartIndicator(P), Z === "video" && ee && (se = Mt.ts.parsePesTime(P), se && (se.type = "video", S.video.push(se), Te = !0));
            break;
        }
        if (Te)
          break;
        T -= ji, E -= ji;
        continue;
      }
      T--, E--;
    }
  }, T2 = function(f, v) {
    if (f.audio && f.audio.length) {
      var S = v;
      (typeof S > "u" || isNaN(S)) && (S = f.audio[0].dts), f.audio.forEach(function(P) {
        P.dts = ca(P.dts, S), P.pts = ca(P.pts, S), P.dtsTime = P.dts / _r, P.ptsTime = P.pts / _r;
      });
    }
    if (f.video && f.video.length) {
      var T = v;
      if ((typeof T > "u" || isNaN(T)) && (T = f.video[0].dts), f.video.forEach(function(P) {
        P.dts = ca(P.dts, T), P.pts = ca(P.pts, T), P.dtsTime = P.dts / _r, P.ptsTime = P.pts / _r;
      }), f.firstKeyFrame) {
        var E = f.firstKeyFrame;
        E.dts = ca(E.dts, T), E.pts = ca(E.pts, T), E.dtsTime = E.dts / _r, E.ptsTime = E.pts / _r;
      }
    }
  }, x2 = function(f) {
    for (var v = !1, S = 0, T = null, E = null, P = 0, G = 0, Z; f.length - G >= 3; ) {
      var ee = Mt.aac.parseType(f, G);
      switch (ee) {
        case "timed-metadata":
          if (f.length - G < 10) {
            v = !0;
            break;
          }
          if (P = Mt.aac.parseId3TagSize(f, G), P > f.length) {
            v = !0;
            break;
          }
          E === null && (Z = f.subarray(G, G + P), E = Mt.aac.parseAacTimestamp(Z)), G += P;
          break;
        case "audio":
          if (f.length - G < 7) {
            v = !0;
            break;
          }
          if (P = Mt.aac.parseAdtsSize(f, G), P > f.length) {
            v = !0;
            break;
          }
          T === null && (Z = f.subarray(G, G + P), T = Mt.aac.parseSampleRate(Z)), S++, G += P;
          break;
        default:
          G++;
          break;
      }
      if (v)
        return null;
    }
    if (T === null || E === null)
      return null;
    var se = _r / T, fe = {
      audio: [{
        type: "audio",
        dts: E,
        pts: E
      }, {
        type: "audio",
        dts: E + S * 1024 * se,
        pts: E + S * 1024 * se
      }]
    };
    return fe;
  }, S2 = function(f) {
    var v = {
      pid: null,
      table: null
    }, S = {};
    b2(f, v);
    for (var T in v.table)
      if (v.table.hasOwnProperty(T)) {
        var E = v.table[T];
        switch (E) {
          case lA.H264_STREAM_TYPE:
            S.video = [], w2(f, v, S), S.video.length === 0 && delete S.video;
            break;
          case lA.ADTS_STREAM_TYPE:
            S.audio = [], uA(f, v, S), S.audio.length === 0 && delete S.audio;
            break;
        }
      }
    return S;
  }, C2 = function(f, v) {
    var S = Mt.aac.isLikelyAacData(f), T;
    return S ? T = x2(f) : T = S2(f), !T || !T.audio && !T.video ? null : (T2(T, v), T);
  }, E2 = {
    inspect: C2,
    parseAudioPes_: uA
  };
  const D2 = function(f, v) {
    v.on("data", function(S) {
      const T = S.initSegment;
      S.initSegment = {
        data: T.buffer,
        byteOffset: T.byteOffset,
        byteLength: T.byteLength
      };
      const E = S.data;
      S.data = E.buffer, f.postMessage({
        action: "data",
        segment: S,
        byteOffset: E.byteOffset,
        byteLength: E.byteLength
      }, [S.data]);
    }), v.on("done", function(S) {
      f.postMessage({
        action: "done"
      });
    }), v.on("gopInfo", function(S) {
      f.postMessage({
        action: "gopInfo",
        gopInfo: S
      });
    }), v.on("videoSegmentTimingInfo", function(S) {
      const T = {
        start: {
          decode: xt.videoTsToSeconds(S.start.dts),
          presentation: xt.videoTsToSeconds(S.start.pts)
        },
        end: {
          decode: xt.videoTsToSeconds(S.end.dts),
          presentation: xt.videoTsToSeconds(S.end.pts)
        },
        baseMediaDecodeTime: xt.videoTsToSeconds(S.baseMediaDecodeTime)
      };
      S.prependedContentDuration && (T.prependedContentDuration = xt.videoTsToSeconds(S.prependedContentDuration)), f.postMessage({
        action: "videoSegmentTimingInfo",
        videoSegmentTimingInfo: T
      });
    }), v.on("audioSegmentTimingInfo", function(S) {
      const T = {
        start: {
          decode: xt.videoTsToSeconds(S.start.dts),
          presentation: xt.videoTsToSeconds(S.start.pts)
        },
        end: {
          decode: xt.videoTsToSeconds(S.end.dts),
          presentation: xt.videoTsToSeconds(S.end.pts)
        },
        baseMediaDecodeTime: xt.videoTsToSeconds(S.baseMediaDecodeTime)
      };
      S.prependedContentDuration && (T.prependedContentDuration = xt.videoTsToSeconds(S.prependedContentDuration)), f.postMessage({
        action: "audioSegmentTimingInfo",
        audioSegmentTimingInfo: T
      });
    }), v.on("id3Frame", function(S) {
      f.postMessage({
        action: "id3Frame",
        id3Frame: S
      });
    }), v.on("caption", function(S) {
      f.postMessage({
        action: "caption",
        caption: S
      });
    }), v.on("trackinfo", function(S) {
      f.postMessage({
        action: "trackinfo",
        trackInfo: S
      });
    }), v.on("audioTimingInfo", function(S) {
      f.postMessage({
        action: "audioTimingInfo",
        audioTimingInfo: {
          start: xt.videoTsToSeconds(S.start),
          end: xt.videoTsToSeconds(S.end)
        }
      });
    }), v.on("videoTimingInfo", function(S) {
      f.postMessage({
        action: "videoTimingInfo",
        videoTimingInfo: {
          start: xt.videoTsToSeconds(S.start),
          end: xt.videoTsToSeconds(S.end)
        }
      });
    }), v.on("log", function(S) {
      f.postMessage({
        action: "log",
        log: S
      });
    });
  };
  class dA {
    constructor(v, S) {
      this.options = S || {}, this.self = v, this.init();
    }
    /**
     * initialize our web worker and wire all the events.
     */
    init() {
      this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new xT.Transmuxer(this.options), D2(this.self, this.transmuxer);
    }
    pushMp4Captions(v) {
      this.captionParser || (this.captionParser = new l2(), this.captionParser.init());
      const S = new Uint8Array(v.data, v.byteOffset, v.byteLength), T = this.captionParser.parse(S, v.trackIds, v.timescales);
      this.self.postMessage({
        action: "mp4Captions",
        captions: T && T.captions || [],
        logs: T && T.logs || [],
        data: S.buffer
      }, [S.buffer]);
    }
    /**
     * Initializes the WebVttParser and passes the init segment.
     *
     * @param {Uint8Array} data mp4 boxed WebVTT init segment data
     */
    initMp4WebVttParser(v) {
      this.webVttParser || (this.webVttParser = new aA());
      const S = new Uint8Array(v.data, v.byteOffset, v.byteLength);
      this.webVttParser.init(S);
    }
    /**
     * Parse an mp4 encapsulated WebVTT segment and return an array of cues.
     *
     * @param {Uint8Array} data a text/webvtt segment
     * @return {Object[]} an array of parsed cue objects
     */
    getMp4WebVttText(v) {
      this.webVttParser || (this.webVttParser = new aA());
      const S = new Uint8Array(v.data, v.byteOffset, v.byteLength), T = this.webVttParser.parseSegment(S);
      this.self.postMessage({
        action: "getMp4WebVttText",
        mp4VttCues: T || [],
        data: S.buffer
      }, [S.buffer]);
    }
    probeMp4StartTime({
      timescales: v,
      data: S
    }) {
      const T = No.startTime(v, S);
      this.self.postMessage({
        action: "probeMp4StartTime",
        startTime: T,
        data: S
      }, [S.buffer]);
    }
    probeMp4Tracks({
      data: v
    }) {
      const S = No.tracks(v);
      this.self.postMessage({
        action: "probeMp4Tracks",
        tracks: S,
        data: v
      }, [v.buffer]);
    }
    /**
     * Probes an mp4 segment for EMSG boxes containing ID3 data.
     * https://aomediacodec.github.io/id3-emsg/
     *
     * @param {Uint8Array} data segment data
     * @param {number} offset segment start time
     * @return {Object[]} an array of ID3 frames
     */
    probeEmsgID3({
      data: v,
      offset: S
    }) {
      const T = No.getEmsgID3(v, S);
      this.self.postMessage({
        action: "probeEmsgID3",
        id3Frames: T,
        emsgData: v
      }, [v.buffer]);
    }
    /**
     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
     * internal "media time," as well as whether it contains video and/or audio.
     *
     * @private
     * @param {Uint8Array} bytes - segment bytes
     * @param {number} baseStartTime
     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
     *        This value should be in seconds, as it's converted to a 90khz clock within the
     *        function body.
     * @return {Object} The start time of the current segment in "media time" as well as
     *                  whether it contains video and/or audio
     */
    probeTs({
      data: v,
      baseStartTime: S
    }) {
      const T = typeof S == "number" && !isNaN(S) ? S * xt.ONE_SECOND_IN_TS : void 0, E = E2.inspect(v, T);
      let P = null;
      E && (P = {
        // each type's time info comes back as an array of 2 times, start and end
        hasVideo: E.video && E.video.length === 2 || !1,
        hasAudio: E.audio && E.audio.length === 2 || !1
      }, P.hasVideo && (P.videoStart = E.video[0].ptsTime), P.hasAudio && (P.audioStart = E.audio[0].ptsTime)), this.self.postMessage({
        action: "probeTs",
        result: P,
        data: v
      }, [v.buffer]);
    }
    clearAllMp4Captions() {
      this.captionParser && this.captionParser.clearAllCaptions();
    }
    clearParsedMp4Captions() {
      this.captionParser && this.captionParser.clearParsedCaptions();
    }
    /**
     * Adds data (a ts segment) to the start of the transmuxer pipeline for
     * processing.
     *
     * @param {ArrayBuffer} data data to push into the muxer
     */
    push(v) {
      const S = new Uint8Array(v.data, v.byteOffset, v.byteLength);
      this.transmuxer.push(S);
    }
    /**
     * Recreate the transmuxer so that the next segment added via `push`
     * start with a fresh transmuxer.
     */
    reset() {
      this.transmuxer.reset();
    }
    /**
     * Set the value that will be used as the `baseMediaDecodeTime` time for the
     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
     * set relative to the first based on the PTS values.
     *
     * @param {Object} data used to set the timestamp offset in the muxer
     */
    setTimestampOffset(v) {
      const S = v.timestampOffset || 0;
      this.transmuxer.setBaseMediaDecodeTime(Math.round(xt.secondsToVideoTs(S)));
    }
    setAudioAppendStart(v) {
      this.transmuxer.setAudioAppendStart(Math.ceil(xt.secondsToVideoTs(v.appendStart)));
    }
    setRemux(v) {
      this.transmuxer.setRemux(v.remux);
    }
    /**
     * Forces the pipeline to finish processing the last segment and emit it's
     * results.
     *
     * @param {Object} data event data, not really used
     */
    flush(v) {
      this.transmuxer.flush(), self.postMessage({
        action: "done",
        type: "transmuxed"
      });
    }
    endTimeline() {
      this.transmuxer.endTimeline(), self.postMessage({
        action: "endedtimeline",
        type: "transmuxed"
      });
    }
    alignGopsWith(v) {
      this.transmuxer.alignGopsWith(v.gopsToAlignWith.slice());
    }
  }
  self.onmessage = function(f) {
    if (f.data.action === "init" && f.data.options) {
      this.messageHandlers = new dA(self, f.data.options);
      return;
    }
    this.messageHandlers || (this.messageHandlers = new dA(self)), f.data && f.data.action && f.data.action !== "init" && this.messageHandlers[f.data.action] && this.messageHandlers[f.data.action](f.data);
  };
}));
var mU = u1(pU);
const AU = (t, e, i) => {
  const {
    type: n,
    initSegment: s,
    captions: r,
    captionStreams: a,
    metadata: o,
    videoFrameDtsTime: l,
    videoFramePtsTime: u
  } = t.data.segment;
  e.buffer.push({
    captions: r,
    captionStreams: a,
    metadata: o
  });
  const d = t.data.segment.boxes || {
    data: t.data.segment.data
  }, c = {
    type: n,
    // cast ArrayBuffer to TypedArray
    data: new Uint8Array(d.data, d.data.byteOffset, d.data.byteLength),
    initSegment: new Uint8Array(s.data, s.byteOffset, s.byteLength)
  };
  typeof l < "u" && (c.videoFrameDtsTime = l), typeof u < "u" && (c.videoFramePtsTime = u), i(c);
}, gU = ({
  transmuxedData: t,
  callback: e
}) => {
  t.buffer = [], e(t);
}, vU = (t, e) => {
  e.gopInfo = t.data.gopInfo;
}, f1 = (t) => {
  const {
    transmuxer: e,
    bytes: i,
    audioAppendStart: n,
    gopsToAlignWith: s,
    remux: r,
    onData: a,
    onTrackInfo: o,
    onAudioTimingInfo: l,
    onVideoTimingInfo: u,
    onVideoSegmentTimingInfo: d,
    onAudioSegmentTimingInfo: c,
    onId3: A,
    onCaptions: m,
    onDone: p,
    onEndedTimeline: h,
    onTransmuxerLog: g,
    isEndOfTimeline: w,
    segment: b,
    triggerSegmentEventFn: y
  } = t, D = {
    buffer: []
  };
  let I = w;
  const M = (N) => {
    e.currentTransmux === t && (N.data.action === "data" && AU(N, D, a), N.data.action === "trackinfo" && o(N.data.trackInfo), N.data.action === "gopInfo" && vU(N, D), N.data.action === "audioTimingInfo" && l(N.data.audioTimingInfo), N.data.action === "videoTimingInfo" && u(N.data.videoTimingInfo), N.data.action === "videoSegmentTimingInfo" && d(N.data.videoSegmentTimingInfo), N.data.action === "audioSegmentTimingInfo" && c(N.data.audioSegmentTimingInfo), N.data.action === "id3Frame" && A([N.data.id3Frame], N.data.id3Frame.dispatchType), N.data.action === "caption" && m(N.data.caption), N.data.action === "endedtimeline" && (I = !1, h()), N.data.action === "log" && g(N.data.log), N.data.type === "transmuxed" && (I || (e.onmessage = null, gU({
      transmuxedData: D,
      callback: p
    }), h1(e))));
  }, _ = () => {
    const N = {
      message: "Received an error message from the transmuxer worker",
      metadata: {
        errorType: Ae.Error.StreamingFailedToTransmuxSegment,
        segmentInfo: zr({
          segment: b
        })
      }
    };
    p(null, N);
  };
  if (e.onmessage = M, e.onerror = _, n && e.postMessage({
    action: "setAudioAppendStart",
    appendStart: n
  }), Array.isArray(s) && e.postMessage({
    action: "alignGopsWith",
    gopsToAlignWith: s
  }), typeof r < "u" && e.postMessage({
    action: "setRemux",
    remux: r
  }), i.byteLength) {
    const N = i instanceof ArrayBuffer ? i : i.buffer, x = i instanceof ArrayBuffer ? 0 : i.byteOffset;
    y({
      type: "segmenttransmuxingstart",
      segment: b
    }), e.postMessage({
      action: "push",
      // Send the typed-array of data as an ArrayBuffer so that
      // it can be sent as a "Transferable" and avoid the costly
      // memory copy
      data: N,
      // To recreate the original typed-array, we need information
      // about what portion of the ArrayBuffer it was a view into
      byteOffset: x,
      byteLength: i.byteLength
    }, [N]);
  }
  w && e.postMessage({
    action: "endTimeline"
  }), e.postMessage({
    action: "flush"
  });
}, h1 = (t) => {
  t.currentTransmux = null, t.transmuxQueue.length && (t.currentTransmux = t.transmuxQueue.shift(), typeof t.currentTransmux == "function" ? t.currentTransmux() : f1(t.currentTransmux));
}, Fv = (t, e) => {
  t.postMessage({
    action: e
  }), h1(t);
}, p1 = (t, e) => {
  if (!e.currentTransmux) {
    e.currentTransmux = t, Fv(e, t);
    return;
  }
  e.transmuxQueue.push(Fv.bind(null, e, t));
}, yU = (t) => {
  p1("reset", t);
}, bU = (t) => {
  p1("endTimeline", t);
}, m1 = (t) => {
  if (!t.transmuxer.currentTransmux) {
    t.transmuxer.currentTransmux = t, f1(t);
    return;
  }
  t.transmuxer.transmuxQueue.push(t);
}, wU = (t) => {
  const e = new mU();
  e.currentTransmux = null, e.transmuxQueue = [];
  const i = e.terminate;
  return e.terminate = () => (e.currentTransmux = null, e.transmuxQueue.length = 0, i.call(e)), e.postMessage({
    action: "init",
    options: t
  }), e;
};
var Kf = {
  reset: yU,
  endTimeline: bU,
  transmux: m1,
  createTransmuxer: wU
};
const za = function(t) {
  const e = t.transmuxer, i = t.endAction || t.action, n = t.callback, s = pi({}, t, {
    endAction: null,
    transmuxer: null,
    callback: null
  }), r = (a) => {
    a.data.action === i && (e.removeEventListener("message", r), a.data.data && (a.data.data = new Uint8Array(a.data.data, t.byteOffset || 0, t.byteLength || a.data.data.byteLength), t.data && (t.data = a.data.data)), n(a.data));
  };
  if (e.addEventListener("message", r), t.data) {
    const a = t.data instanceof ArrayBuffer;
    s.byteOffset = a ? 0 : t.data.byteOffset, s.byteLength = t.data.byteLength;
    const o = [a ? t.data : t.data.buffer];
    e.postMessage(s, o);
  } else
    e.postMessage(s);
}, ws = {
  FAILURE: 2,
  TIMEOUT: -101,
  ABORTED: -102
}, A1 = "wvtt", qh = (t) => {
  t.forEach((e) => {
    e.abort();
  });
}, TU = (t) => ({
  bandwidth: t.bandwidth,
  bytesReceived: t.bytesReceived || 0,
  roundTripTime: t.roundTripTime || 0
}), xU = (t) => {
  const e = t.target, n = {
    bandwidth: 1 / 0,
    bytesReceived: 0,
    roundTripTime: Date.now() - e.requestTime || 0
  };
  return n.bytesReceived = t.loaded, n.bandwidth = Math.floor(n.bytesReceived / n.roundTripTime * 8 * 1e3), n;
}, bm = (t, e) => {
  const {
    requestType: i
  } = e, n = Kr({
    requestType: i,
    request: e,
    error: t
  });
  return e.timedout ? {
    status: e.status,
    message: "HLS request timed-out at URL: " + e.uri,
    code: ws.TIMEOUT,
    xhr: e,
    metadata: n
  } : e.aborted ? {
    status: e.status,
    message: "HLS request aborted at URL: " + e.uri,
    code: ws.ABORTED,
    xhr: e,
    metadata: n
  } : t ? {
    status: e.status,
    message: "HLS request errored at URL: " + e.uri,
    code: ws.FAILURE,
    xhr: e,
    metadata: n
  } : e.responseType === "arraybuffer" && e.response.byteLength === 0 ? {
    status: e.status,
    message: "Empty HLS response at URL: " + e.uri,
    code: ws.FAILURE,
    xhr: e,
    metadata: n
  } : null;
}, zv = (t, e, i, n) => (s, r) => {
  const a = r.response, o = bm(s, r);
  if (o)
    return i(o, t);
  if (a.byteLength !== 16)
    return i({
      status: r.status,
      message: "Invalid HLS key at URL: " + r.uri,
      code: ws.FAILURE,
      xhr: r
    }, t);
  const l = new DataView(a), u = new Uint32Array([l.getUint32(0), l.getUint32(4), l.getUint32(8), l.getUint32(12)]);
  for (let c = 0; c < e.length; c++)
    e[c].bytes = u;
  const d = {
    uri: r.uri
  };
  return n({
    type: "segmentkeyloadcomplete",
    segment: t,
    keyInfo: d
  }), i(null, t);
}, SU = (t, e) => {
  e === A1 && t.transmuxer.postMessage({
    action: "initMp4WebVttParser",
    data: t.map.bytes
  });
}, CU = (t, e, i) => {
  e === A1 && za({
    action: "getMp4WebVttText",
    data: t.bytes,
    transmuxer: t.transmuxer,
    callback: ({
      data: n,
      mp4VttCues: s
    }) => {
      t.bytes = n, i(null, t, {
        mp4VttCues: s
      });
    }
  });
}, g1 = (t, e) => {
  const i = Wp(t.map.bytes);
  if (i !== "mp4") {
    const n = t.map.resolvedUri || t.map.uri, s = i || "unknown";
    return e({
      internal: !0,
      message: `Found unsupported ${s} container for initialization segment at URL: ${n}`,
      code: ws.FAILURE,
      metadata: {
        mediaType: s
      }
    });
  }
  za({
    action: "probeMp4Tracks",
    data: t.map.bytes,
    transmuxer: t.transmuxer,
    callback: ({
      tracks: n,
      data: s
    }) => (t.map.bytes = s, n.forEach(function(r) {
      t.map.tracks = t.map.tracks || {}, !t.map.tracks[r.type] && (t.map.tracks[r.type] = r, typeof r.id == "number" && r.timescale && (t.map.timescales = t.map.timescales || {}, t.map.timescales[r.id] = r.timescale), r.type === "text" && SU(t, r.codec));
    }), e(null))
  });
}, EU = ({
  segment: t,
  finishProcessingFn: e,
  triggerSegmentEventFn: i
}) => (n, s) => {
  const r = bm(n, s);
  if (r)
    return e(r, t);
  const a = new Uint8Array(s.response);
  if (i({
    type: "segmentloaded",
    segment: t
  }), t.map.key)
    return t.map.encryptedBytes = a, e(null, t);
  t.map.bytes = a, g1(t, function(o) {
    if (o)
      return o.xhr = s, o.status = s.status, e(o, t);
    e(null, t);
  });
}, DU = ({
  segment: t,
  finishProcessingFn: e,
  responseType: i,
  triggerSegmentEventFn: n
}) => (s, r) => {
  const a = bm(s, r);
  if (a)
    return e(a, t);
  n({
    type: "segmentloaded",
    segment: t
  });
  const o = (
    // although responseText "should" exist, this guard serves to prevent an error being
    // thrown for two primary cases:
    // 1. the mime type override stops working, or is not implemented for a specific
    //    browser
    // 2. when using mock XHR libraries like sinon that do not allow the override behavior
    i === "arraybuffer" || !r.responseText ? r.response : fU(r.responseText.substring(t.lastReachedChar || 0))
  );
  return t.stats = TU(r), t.key ? t.encryptedBytes = new Uint8Array(o) : t.bytes = new Uint8Array(o), e(null, t);
}, _U = ({
  segment: t,
  bytes: e,
  trackInfoFn: i,
  timingInfoFn: n,
  videoSegmentTimingInfoFn: s,
  audioSegmentTimingInfoFn: r,
  id3Fn: a,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: u,
  dataFn: d,
  doneFn: c,
  onTransmuxerLog: A,
  triggerSegmentEventFn: m
}) => {
  const p = t.map && t.map.tracks || {}, h = !!(p.audio && p.video);
  let g = n.bind(null, t, "audio", "start");
  const w = n.bind(null, t, "audio", "end");
  let b = n.bind(null, t, "video", "start");
  const y = n.bind(null, t, "video", "end"), D = () => m1({
    bytes: e,
    transmuxer: t.transmuxer,
    audioAppendStart: t.audioAppendStart,
    gopsToAlignWith: t.gopsToAlignWith,
    remux: h,
    onData: (I) => {
      I.type = I.type === "combined" ? "video" : I.type, d(t, I);
    },
    onTrackInfo: (I) => {
      i && (h && (I.isMuxed = !0), i(t, I));
    },
    onAudioTimingInfo: (I) => {
      g && typeof I.start < "u" && (g(I.start), g = null), w && typeof I.end < "u" && w(I.end);
    },
    onVideoTimingInfo: (I) => {
      b && typeof I.start < "u" && (b(I.start), b = null), y && typeof I.end < "u" && y(I.end);
    },
    onVideoSegmentTimingInfo: (I) => {
      const M = {
        pts: {
          start: I.start.presentation,
          end: I.end.presentation
        },
        dts: {
          start: I.start.decode,
          end: I.end.decode
        }
      };
      m({
        type: "segmenttransmuxingtiminginfoavailable",
        segment: t,
        timingInfo: M
      }), s(I);
    },
    onAudioSegmentTimingInfo: (I) => {
      const M = {
        pts: {
          start: I.start.pts,
          end: I.end.pts
        },
        dts: {
          start: I.start.dts,
          end: I.end.dts
        }
      };
      m({
        type: "segmenttransmuxingtiminginfoavailable",
        segment: t,
        timingInfo: M
      }), r(I);
    },
    onId3: (I, M) => {
      a(t, I, M);
    },
    onCaptions: (I) => {
      o(t, [I]);
    },
    isEndOfTimeline: l,
    onEndedTimeline: () => {
      u();
    },
    onTransmuxerLog: A,
    onDone: (I, M) => {
      c && (I.type = I.type === "combined" ? "video" : I.type, m({
        type: "segmenttransmuxingcomplete",
        segment: t
      }), c(M, t, I));
    },
    segment: t,
    triggerSegmentEventFn: m
  });
  za({
    action: "probeTs",
    transmuxer: t.transmuxer,
    data: e,
    baseStartTime: t.baseStartTime,
    callback: (I) => {
      t.bytes = e = I.data;
      const M = I.result;
      M && (i(t, {
        hasAudio: M.hasAudio,
        hasVideo: M.hasVideo,
        isMuxed: h
      }), i = null), D();
    }
  });
}, v1 = ({
  segment: t,
  bytes: e,
  trackInfoFn: i,
  timingInfoFn: n,
  videoSegmentTimingInfoFn: s,
  audioSegmentTimingInfoFn: r,
  id3Fn: a,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: u,
  dataFn: d,
  doneFn: c,
  onTransmuxerLog: A,
  triggerSegmentEventFn: m
}) => {
  let p = new Uint8Array(e);
  if (jR(p)) {
    t.isFmp4 = !0;
    const {
      tracks: h
    } = t.map;
    if (h.text && (!h.audio || !h.video)) {
      d(t, {
        data: p,
        type: "text"
      }), CU(t, h.text.codec, c);
      return;
    }
    const w = {
      isFmp4: !0,
      hasVideo: !!h.video,
      hasAudio: !!h.audio
    };
    h.audio && h.audio.codec && h.audio.codec !== "enca" && (w.audioCodec = h.audio.codec), h.video && h.video.codec && h.video.codec !== "encv" && (w.videoCodec = h.video.codec), h.video && h.audio && (w.isMuxed = !0), i(t, w);
    const b = (y, D) => {
      d(t, {
        data: p,
        type: w.hasAudio && !w.isMuxed ? "audio" : "video"
      }), D && D.length && a(t, D), y && y.length && o(t, y), c(null, t, {});
    };
    za({
      action: "probeMp4StartTime",
      timescales: t.map.timescales,
      data: p,
      transmuxer: t.transmuxer,
      callback: ({
        data: y,
        startTime: D
      }) => {
        e = y.buffer, t.bytes = p = y, w.hasAudio && !w.isMuxed && n(t, "audio", "start", D), w.hasVideo && n(t, "video", "start", D), za({
          action: "probeEmsgID3",
          data: p,
          transmuxer: t.transmuxer,
          offset: D,
          callback: ({
            emsgData: I,
            id3Frames: M
          }) => {
            if (e = I.buffer, t.bytes = p = I, !h.video || !I.byteLength || !t.transmuxer) {
              b(void 0, M);
              return;
            }
            za({
              action: "pushMp4Captions",
              endAction: "mp4Captions",
              transmuxer: t.transmuxer,
              data: p,
              timescales: t.map.timescales,
              trackIds: [h.video.id],
              callback: (_) => {
                e = _.data.buffer, t.bytes = p = _.data, _.logs.forEach(function(N) {
                  A(_t(N, {
                    stream: "mp4CaptionParser"
                  }));
                }), b(_.captions, M);
              }
            });
          }
        });
      }
    });
    return;
  }
  if (!t.transmuxer) {
    c(null, t, {});
    return;
  }
  if (typeof t.container > "u" && (t.container = Wp(p)), t.container !== "ts" && t.container !== "aac") {
    i(t, {
      hasAudio: !1,
      hasVideo: !1
    }), c(null, t, {});
    return;
  }
  _U({
    segment: t,
    bytes: e,
    trackInfoFn: i,
    timingInfoFn: n,
    videoSegmentTimingInfoFn: s,
    audioSegmentTimingInfoFn: r,
    id3Fn: a,
    captionsFn: o,
    isEndOfTimeline: l,
    endedTimelineFn: u,
    dataFn: d,
    doneFn: c,
    onTransmuxerLog: A,
    triggerSegmentEventFn: m
  });
}, y1 = function({
  id: t,
  key: e,
  encryptedBytes: i,
  decryptionWorker: n,
  segment: s,
  doneFn: r
}, a) {
  const o = (u) => {
    if (u.data.source === t) {
      n.removeEventListener("message", o);
      const d = u.data.decrypted;
      a(new Uint8Array(d.bytes, d.byteOffset, d.byteLength));
    }
  };
  n.onerror = () => {
    const u = "An error occurred in the decryption worker", d = zr({
      segment: s
    }), c = {
      message: u,
      metadata: {
        error: new Error(u),
        errorType: Ae.Error.StreamingFailedToDecryptSegment,
        segmentInfo: d,
        keyInfo: {
          uri: s.key.resolvedUri || s.map.key.resolvedUri
        }
      }
    };
    r(c, s);
  }, n.addEventListener("message", o);
  let l;
  e.bytes.slice ? l = e.bytes.slice() : l = new Uint32Array(Array.prototype.slice.call(e.bytes)), n.postMessage(n1({
    source: t,
    encrypted: i,
    key: l,
    iv: e.iv
  }), [i.buffer, l.buffer]);
}, kU = ({
  decryptionWorker: t,
  segment: e,
  trackInfoFn: i,
  timingInfoFn: n,
  videoSegmentTimingInfoFn: s,
  audioSegmentTimingInfoFn: r,
  id3Fn: a,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: u,
  dataFn: d,
  doneFn: c,
  onTransmuxerLog: A,
  triggerSegmentEventFn: m
}) => {
  m({
    type: "segmentdecryptionstart"
  }), y1({
    id: e.requestId,
    key: e.key,
    encryptedBytes: e.encryptedBytes,
    decryptionWorker: t,
    segment: e,
    doneFn: c
  }, (p) => {
    e.bytes = p, m({
      type: "segmentdecryptioncomplete",
      segment: e
    }), v1({
      segment: e,
      bytes: e.bytes,
      trackInfoFn: i,
      timingInfoFn: n,
      videoSegmentTimingInfoFn: s,
      audioSegmentTimingInfoFn: r,
      id3Fn: a,
      captionsFn: o,
      isEndOfTimeline: l,
      endedTimelineFn: u,
      dataFn: d,
      doneFn: c,
      onTransmuxerLog: A,
      triggerSegmentEventFn: m
    });
  });
}, PU = ({
  activeXhrs: t,
  decryptionWorker: e,
  trackInfoFn: i,
  timingInfoFn: n,
  videoSegmentTimingInfoFn: s,
  audioSegmentTimingInfoFn: r,
  id3Fn: a,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: u,
  dataFn: d,
  doneFn: c,
  onTransmuxerLog: A,
  triggerSegmentEventFn: m
}) => {
  let p = 0, h = !1;
  return (g, w) => {
    if (!h) {
      if (g)
        return h = !0, qh(t), c(g, w);
      if (p += 1, p === t.length) {
        const b = function() {
          if (w.encryptedBytes)
            return kU({
              decryptionWorker: e,
              segment: w,
              trackInfoFn: i,
              timingInfoFn: n,
              videoSegmentTimingInfoFn: s,
              audioSegmentTimingInfoFn: r,
              id3Fn: a,
              captionsFn: o,
              isEndOfTimeline: l,
              endedTimelineFn: u,
              dataFn: d,
              doneFn: c,
              onTransmuxerLog: A,
              triggerSegmentEventFn: m
            });
          v1({
            segment: w,
            bytes: w.bytes,
            trackInfoFn: i,
            timingInfoFn: n,
            videoSegmentTimingInfoFn: s,
            audioSegmentTimingInfoFn: r,
            id3Fn: a,
            captionsFn: o,
            isEndOfTimeline: l,
            endedTimelineFn: u,
            dataFn: d,
            doneFn: c,
            onTransmuxerLog: A,
            triggerSegmentEventFn: m
          });
        };
        if (w.endOfAllRequests = Date.now(), w.map && w.map.encryptedBytes && !w.map.bytes)
          return m({
            type: "segmentdecryptionstart",
            segment: w
          }), y1({
            decryptionWorker: e,
            // add -init to the "id" to differentiate between segment
            // and init segment decryption, just in case they happen
            // at the same time at some point in the future.
            id: w.requestId + "-init",
            encryptedBytes: w.map.encryptedBytes,
            key: w.map.key,
            segment: w,
            doneFn: c
          }, (y) => {
            w.map.bytes = y, m({
              type: "segmentdecryptioncomplete",
              segment: w
            }), g1(w, (D) => {
              if (D)
                return qh(t), c(D, w);
              b();
            });
          });
        b();
      }
    }
  };
}, IU = ({
  loadendState: t,
  abortFn: e
}) => (i) => {
  i.target.aborted && e && !t.calledAbortFn && (e(), t.calledAbortFn = !0);
}, MU = ({
  segment: t,
  progressFn: e,
  trackInfoFn: i,
  timingInfoFn: n,
  videoSegmentTimingInfoFn: s,
  audioSegmentTimingInfoFn: r,
  id3Fn: a,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: u,
  dataFn: d
}) => (c) => {
  if (!c.target.aborted)
    return t.stats = _t(t.stats, xU(c)), !t.stats.firstBytesReceivedAt && t.stats.bytesReceived && (t.stats.firstBytesReceivedAt = Date.now()), e(c, t);
}, OU = ({
  xhr: t,
  xhrOptions: e,
  decryptionWorker: i,
  segment: n,
  abortFn: s,
  progressFn: r,
  trackInfoFn: a,
  timingInfoFn: o,
  videoSegmentTimingInfoFn: l,
  audioSegmentTimingInfoFn: u,
  id3Fn: d,
  captionsFn: c,
  isEndOfTimeline: A,
  endedTimelineFn: m,
  dataFn: p,
  doneFn: h,
  onTransmuxerLog: g,
  triggerSegmentEventFn: w
}) => {
  const b = [], y = PU({
    activeXhrs: b,
    decryptionWorker: i,
    trackInfoFn: a,
    timingInfoFn: o,
    videoSegmentTimingInfoFn: l,
    audioSegmentTimingInfoFn: u,
    id3Fn: d,
    captionsFn: c,
    isEndOfTimeline: A,
    endedTimelineFn: m,
    dataFn: p,
    doneFn: h,
    onTransmuxerLog: g,
    triggerSegmentEventFn: w
  });
  if (n.key && !n.key.bytes) {
    const N = [n.key];
    n.map && !n.map.bytes && n.map.key && n.map.key.resolvedUri === n.key.resolvedUri && N.push(n.map.key);
    const x = _t(e, {
      uri: n.key.resolvedUri,
      responseType: "arraybuffer",
      requestType: "segment-key"
    }), C = zv(n, N, y, w), L = {
      uri: n.key.resolvedUri
    };
    w({
      type: "segmentkeyloadstart",
      segment: n,
      keyInfo: L
    });
    const V = t(x, C);
    b.push(V);
  }
  if (n.map && !n.map.bytes) {
    if (n.map.key && (!n.key || n.key.resolvedUri !== n.map.key.resolvedUri)) {
      const V = _t(e, {
        uri: n.map.key.resolvedUri,
        responseType: "arraybuffer",
        requestType: "segment-key"
      }), H = zv(n, [n.map.key], y, w), O = {
        uri: n.map.key.resolvedUri
      };
      w({
        type: "segmentkeyloadstart",
        segment: n,
        keyInfo: O
      });
      const X = t(V, H);
      b.push(X);
    }
    const x = _t(e, {
      uri: n.map.resolvedUri,
      responseType: "arraybuffer",
      headers: Uh(n.map),
      requestType: "segment-media-initialization"
    }), C = EU({
      segment: n,
      finishProcessingFn: y,
      triggerSegmentEventFn: w
    });
    w({
      type: "segmentloadstart",
      segment: n
    });
    const L = t(x, C);
    b.push(L);
  }
  const D = _t(e, {
    uri: n.part && n.part.resolvedUri || n.resolvedUri,
    responseType: "arraybuffer",
    headers: Uh(n),
    requestType: "segment"
  }), I = DU({
    segment: n,
    finishProcessingFn: y,
    responseType: D.responseType,
    triggerSegmentEventFn: w
  });
  w({
    type: "segmentloadstart",
    segment: n
  });
  const M = t(D, I);
  M.addEventListener("progress", MU({
    segment: n,
    progressFn: r,
    trackInfoFn: a,
    timingInfoFn: o,
    videoSegmentTimingInfoFn: l,
    audioSegmentTimingInfoFn: u,
    id3Fn: d,
    captionsFn: c,
    isEndOfTimeline: A,
    endedTimelineFn: m,
    dataFn: p
  })), b.push(M);
  const _ = {};
  return b.forEach((N) => {
    N.addEventListener("loadend", IU({
      loadendState: _,
      abortFn: s
    }));
  }), () => qh(b);
}, Ou = Fn("PlaylistSelector"), Uv = function(t) {
  if (!t || !t.playlist)
    return;
  const e = t.playlist;
  return JSON.stringify({
    id: e.id,
    bandwidth: t.bandwidth,
    width: t.width,
    height: t.height,
    codecs: e.attributes && e.attributes.CODECS || ""
  });
}, Ua = function(t, e) {
  if (!t)
    return "";
  const i = ne.getComputedStyle(t);
  return i ? i[e] : "";
}, Va = function(t, e) {
  const i = t.slice();
  t.sort(function(n, s) {
    const r = e(n, s);
    return r === 0 ? i.indexOf(n) - i.indexOf(s) : r;
  });
}, wm = function(t, e) {
  let i, n;
  return t.attributes.BANDWIDTH && (i = t.attributes.BANDWIDTH), i = i || ne.Number.MAX_VALUE, e.attributes.BANDWIDTH && (n = e.attributes.BANDWIDTH), n = n || ne.Number.MAX_VALUE, i - n;
}, BU = function(t, e) {
  let i, n;
  return t.attributes.RESOLUTION && t.attributes.RESOLUTION.width && (i = t.attributes.RESOLUTION.width), i = i || ne.Number.MAX_VALUE, e.attributes.RESOLUTION && e.attributes.RESOLUTION.width && (n = e.attributes.RESOLUTION.width), n = n || ne.Number.MAX_VALUE, i === n && t.attributes.BANDWIDTH && e.attributes.BANDWIDTH ? t.attributes.BANDWIDTH - e.attributes.BANDWIDTH : i - n;
};
let b1 = function(t) {
  const {
    main: e,
    bandwidth: i,
    playerWidth: n,
    playerHeight: s,
    playerObjectFit: r,
    limitRenditionByPlayerDimensions: a,
    playlistController: o
  } = t;
  if (!e)
    return;
  const l = {
    bandwidth: i,
    width: n,
    height: s,
    limitRenditionByPlayerDimensions: a
  };
  let u = e.playlists;
  on.isAudioOnly(e) && (u = o.getAudioTrackPlaylists_(), l.audioOnly = !0);
  let d = u.map((_) => {
    let N;
    const x = _.attributes && _.attributes.RESOLUTION && _.attributes.RESOLUTION.width, C = _.attributes && _.attributes.RESOLUTION && _.attributes.RESOLUTION.height;
    return N = _.attributes && _.attributes.BANDWIDTH, N = N || ne.Number.MAX_VALUE, {
      bandwidth: N,
      width: x,
      height: C,
      playlist: _
    };
  });
  Va(d, (_, N) => _.bandwidth - N.bandwidth), d = d.filter((_) => !on.isIncompatible(_.playlist));
  let c = d.filter((_) => on.isEnabled(_.playlist));
  c.length || (c = d.filter((_) => !on.isDisabled(_.playlist)));
  const A = c.filter((_) => _.bandwidth * Si.BANDWIDTH_VARIANCE < i);
  let m = A[A.length - 1];
  const p = A.filter((_) => _.bandwidth === m.bandwidth)[0];
  if (a === !1) {
    const _ = p || c[0] || d[0];
    if (_ && _.playlist) {
      let N = "sortedPlaylistReps";
      return p && (N = "bandwidthBestRep"), c[0] && (N = "enabledPlaylistReps"), Ou(`choosing ${Uv(_)} using ${N} with options`, l), _.playlist;
    }
    return Ou("could not choose a playlist with options", l), null;
  }
  const h = A.filter((_) => _.width && _.height);
  Va(h, (_, N) => _.width - N.width);
  const g = h.filter((_) => _.width === n && _.height === s);
  m = g[g.length - 1];
  const w = g.filter((_) => _.bandwidth === m.bandwidth)[0];
  let b, y, D;
  w || (b = h.filter((_) => r === "cover" ? _.width > n && _.height > s : _.width > n || _.height > s), y = b.filter((_) => _.width === b[0].width && _.height === b[0].height), m = y[y.length - 1], D = y.filter((_) => _.bandwidth === m.bandwidth)[0]);
  let I;
  if (o.leastPixelDiffSelector) {
    const _ = h.map((N) => (N.pixelDiff = Math.abs(N.width - n) + Math.abs(N.height - s), N));
    Va(_, (N, x) => N.pixelDiff === x.pixelDiff ? x.bandwidth - N.bandwidth : N.pixelDiff - x.pixelDiff), I = _[0];
  }
  const M = I || D || w || p || c[0] || d[0];
  if (M && M.playlist) {
    let _ = "sortedPlaylistReps";
    return I ? _ = "leastPixelDiffRep" : D ? _ = "resolutionPlusOneRep" : w ? _ = "resolutionBestRep" : p ? _ = "bandwidthBestRep" : c[0] && (_ = "enabledPlaylistReps"), Ou(`choosing ${Uv(M)} using ${_} with options`, l), M.playlist;
  }
  return Ou("could not choose a playlist with options", l), null;
};
const Vv = function() {
  let t = this.useDevicePixelRatio && ne.devicePixelRatio || 1;
  return isNaN(this.customPixelRatio) || (t = this.customPixelRatio), b1({
    main: this.playlists.main,
    bandwidth: this.systemBandwidth,
    playerWidth: parseInt(Ua(this.tech_.el(), "width"), 10) * t,
    playerHeight: parseInt(Ua(this.tech_.el(), "height"), 10) * t,
    playerObjectFit: this.usePlayerObjectFit ? Ua(this.tech_.el(), "objectFit") : "",
    limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
    playlistController: this.playlistController_
  });
}, LU = function(t) {
  let e = -1, i = -1;
  if (t < 0 || t > 1)
    throw new Error("Moving average bandwidth decay must be between 0 and 1.");
  return function() {
    let n = this.useDevicePixelRatio && ne.devicePixelRatio || 1;
    return isNaN(this.customPixelRatio) || (n = this.customPixelRatio), e < 0 && (e = this.systemBandwidth, i = this.systemBandwidth), this.systemBandwidth > 0 && this.systemBandwidth !== i && (e = t * this.systemBandwidth + (1 - t) * e, i = this.systemBandwidth), b1({
      main: this.playlists.main,
      bandwidth: e,
      playerWidth: parseInt(Ua(this.tech_.el(), "width"), 10) * n,
      playerHeight: parseInt(Ua(this.tech_.el(), "height"), 10) * n,
      playerObjectFit: this.usePlayerObjectFit ? Ua(this.tech_.el(), "objectFit") : "",
      limitRenditionByPlayerDimensions: this.limitRenditionByPlayerDimensions,
      playlistController: this.playlistController_
    });
  };
}, NU = function(t) {
  const {
    main: e,
    currentTime: i,
    bandwidth: n,
    duration: s,
    segmentDuration: r,
    timeUntilRebuffer: a,
    currentTimeline: o,
    syncController: l
  } = t, u = e.playlists.filter((p) => !on.isIncompatible(p));
  let d = u.filter(on.isEnabled);
  d.length || (d = u.filter((p) => !on.isDisabled(p)));
  const A = d.filter(on.hasAttribute.bind(null, "BANDWIDTH")).map((p) => {
    const g = l.getSyncPoint(p, s, o, i) ? 1 : 2, b = on.estimateSegmentRequestTime(r, n, p) * g - a;
    return {
      playlist: p,
      rebufferingImpact: b
    };
  }), m = A.filter((p) => p.rebufferingImpact <= 0);
  return Va(m, (p, h) => wm(h.playlist, p.playlist)), m.length ? m[0] : (Va(A, (p, h) => p.rebufferingImpact - h.rebufferingImpact), A[0] || null);
}, RU = function() {
  const t = this.playlists.main.playlists.filter(on.isEnabled);
  return Va(t, (i, n) => wm(i, n)), t.filter((i) => !!wl(this.playlists.main, i).video)[0] || null;
}, FU = (t) => {
  let e = 0, i;
  return t.bytes && (i = new Uint8Array(t.bytes), t.segments.forEach((n) => {
    i.set(n, e), e += n.byteLength;
  })), i;
};
function w1(t) {
  try {
    return new URL(t).pathname.split("/").slice(-2).join("/");
  } catch {
    return "";
  }
}
const zU = function(t, e, i) {
  if (!t[i]) {
    e.trigger({
      type: "usage",
      name: "vhs-608"
    });
    let n = i;
    /^cc708_/.test(i) && (n = "SERVICE" + i.split("_")[1]);
    const s = e.textTracks().getTrackById(n);
    if (s)
      t[i] = s;
    else {
      const r = e.options_.vhs && e.options_.vhs.captionServices || {};
      let a = i, o = i, l = !1;
      const u = r[n];
      u && (a = u.label, o = u.language, l = u.default), t[i] = e.addRemoteTextTrack({
        kind: "captions",
        id: n,
        // TODO: investigate why this doesn't seem to turn the caption on by default
        default: l,
        label: a,
        language: o
      }, !1).track;
    }
  }
}, UU = function({
  inbandTextTracks: t,
  captionArray: e,
  timestampOffset: i
}) {
  if (!e)
    return;
  const n = ne.WebKitDataCue || ne.VTTCue;
  e.forEach((s) => {
    const r = s.stream;
    s.content ? s.content.forEach((a) => {
      const o = new n(s.startTime + i, s.endTime + i, a.text);
      o.line = a.line, o.align = "left", o.position = a.position, o.positionAlign = "line-left", t[r].addCue(o);
    }) : t[r].addCue(new n(s.startTime + i, s.endTime + i, s.text));
  });
}, VU = function(t) {
  Object.defineProperties(t.frame, {
    id: {
      get() {
        return Ae.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), t.value.key;
      }
    },
    value: {
      get() {
        return Ae.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), t.value.data;
      }
    },
    privateData: {
      get() {
        return Ae.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), t.value.data;
      }
    }
  });
}, qU = ({
  inbandTextTracks: t,
  metadataArray: e,
  timestampOffset: i,
  videoDuration: n
}) => {
  if (!e)
    return;
  const s = ne.WebKitDataCue || ne.VTTCue, r = t.metadataTrack_;
  if (!r || (e.forEach((d) => {
    const c = d.cueTime + i;
    typeof c != "number" || ne.isNaN(c) || c < 0 || !(c < 1 / 0) || !d.frames || !d.frames.length || d.frames.forEach((A) => {
      const m = new s(c, c, A.value || A.url || A.data || "");
      m.frame = A, m.value = A, VU(m), r.addCue(m);
    });
  }), !r.cues || !r.cues.length))
    return;
  const a = r.cues, o = [];
  for (let d = 0; d < a.length; d++)
    a[d] && o.push(a[d]);
  const l = o.reduce((d, c) => {
    const A = d[c.startTime] || [];
    return A.push(c), d[c.startTime] = A, d;
  }, {}), u = Object.keys(l).sort((d, c) => Number(d) - Number(c));
  u.forEach((d, c) => {
    const A = l[d], m = isFinite(n) ? n : d, p = Number(u[c + 1]) || m;
    A.forEach((h) => {
      h.endTime = p;
    });
  });
}, HU = {
  id: "ID",
  class: "CLASS",
  startDate: "START-DATE",
  duration: "DURATION",
  endDate: "END-DATE",
  endOnNext: "END-ON-NEXT",
  plannedDuration: "PLANNED-DURATION",
  scte35Out: "SCTE35-OUT",
  scte35In: "SCTE35-IN"
}, WU = /* @__PURE__ */ new Set(["id", "class", "startDate", "duration", "endDate", "endOnNext", "startTime", "endTime", "processDateRange"]), YU = ({
  inbandTextTracks: t,
  dateRanges: e
}) => {
  const i = t.metadataTrack_;
  if (!i)
    return;
  const n = ne.WebKitDataCue || ne.VTTCue;
  e.forEach((s) => {
    for (const r of Object.keys(s)) {
      if (WU.has(r))
        continue;
      const a = new n(s.startTime, s.endTime, "");
      a.id = s.id, a.type = "com.apple.quicktime.HLS", a.value = {
        key: HU[r],
        data: s[r]
      }, (r === "scte35Out" || r === "scte35In") && (a.value.data = new Uint8Array(a.value.data.match(/[\da-f]{2}/gi)).buffer), i.addCue(a);
    }
    s.processDateRange();
  });
}, qv = (t, e, i) => {
  t.metadataTrack_ || (t.metadataTrack_ = i.addRemoteTextTrack({
    kind: "metadata",
    label: "Timed Metadata"
  }, !1).track, Ae.browser.IS_ANY_SAFARI || (t.metadataTrack_.inBandMetadataTrackDispatchType = e));
}, rl = function(t, e, i) {
  let n, s;
  if (i && i.cues)
    for (n = i.cues.length; n--; )
      s = i.cues[n], s.startTime >= t && s.endTime <= e && i.removeCue(s);
}, XU = function(t) {
  const e = t.cues;
  if (!e)
    return;
  const i = {};
  for (let n = e.length - 1; n >= 0; n--) {
    const s = e[n], r = `${s.startTime}-${s.endTime}-${s.text}`;
    i[r] ? t.removeCue(s) : i[r] = s;
  }
}, jU = (t, e, i) => {
  if (typeof e > "u" || e === null || !t.length)
    return [];
  const n = Math.ceil((e - i + 3) * Vr.ONE_SECOND_IN_TS);
  let s;
  for (s = 0; s < t.length && !(t[s].pts > n); s++)
    ;
  return t.slice(s);
}, GU = (t, e, i) => {
  if (!e.length)
    return t;
  if (i)
    return e.slice();
  const n = e[0].pts;
  let s = 0;
  for (s; s < t.length && !(t[s].pts >= n); s++)
    ;
  return t.slice(0, s).concat(e);
}, QU = (t, e, i, n) => {
  const s = Math.ceil((e - n) * Vr.ONE_SECOND_IN_TS), r = Math.ceil((i - n) * Vr.ONE_SECOND_IN_TS), a = t.slice();
  let o = t.length;
  for (; o-- && !(t[o].pts <= r); )
    ;
  if (o === -1)
    return a;
  let l = o + 1;
  for (; l-- && !(t[l].pts <= s); )
    ;
  return l = Math.max(l, 0), a.splice(l, o - l + 1), a;
}, ZU = function(t, e) {
  if (!t && !e || !t && e || t && !e)
    return !1;
  if (t === e)
    return !0;
  const i = Object.keys(t).sort(), n = Object.keys(e).sort();
  if (i.length !== n.length)
    return !1;
  for (let s = 0; s < i.length; s++) {
    const r = i[s];
    if (r !== n[s] || t[r] !== e[r])
      return !1;
  }
  return !0;
}, KU = function(t, e, i) {
  e = e || [];
  const n = [];
  let s = 0;
  for (let r = 0; r < e.length; r++) {
    const a = e[r];
    if (t === a.timeline && (n.push(r), s += a.duration, s > i))
      return r;
  }
  return n.length === 0 ? 0 : n[n.length - 1];
}, Zo = 1, JU = 500, Hv = (t) => typeof t == "number" && isFinite(t), Bu = 1 / 60, $U = (t, e, i) => t !== "main" || !e || !i ? null : !i.hasAudio && !i.hasVideo ? "Neither audio nor video found in segment." : e.hasVideo && !i.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !e.hasVideo && i.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null, eV = (t, e, i) => {
  let n = e - Si.BACK_BUFFER_LENGTH;
  t.length && (n = Math.max(n, t.start(0)));
  const s = e - i;
  return Math.min(s, n);
}, va = (t) => {
  const {
    startOfSegment: e,
    duration: i,
    segment: n,
    part: s,
    playlist: {
      mediaSequence: r,
      id: a,
      segments: o = []
    },
    mediaIndex: l,
    partIndex: u,
    timeline: d
  } = t, c = o.length - 1;
  let A = "mediaIndex/partIndex increment";
  t.getMediaInfoForTime ? A = `getMediaInfoForTime (${t.getMediaInfoForTime})` : t.isSyncRequest && (A = "getSyncSegmentCandidate (isSyncRequest)"), t.independent && (A += ` with independent ${t.independent}`);
  const m = typeof u == "number", p = t.segment.uri ? "segment" : "pre-segment", h = m ? zw({
    preloadSegment: n
  }) - 1 : 0;
  return `${p} [${r + l}/${r + c}]` + (m ? ` part [${u}/${h}]` : "") + ` segment start/end [${n.start} => ${n.end}]` + (m ? ` part start/end [${s.start} => ${s.end}]` : "") + ` startOfSegment [${e}] duration [${i}] timeline [${d}] selected by [${A}] playlist [${a}]`;
}, Wv = (t) => `${t}TimingInfo`, tV = ({
  segmentTimeline: t,
  currentTimeline: e,
  startOfSegment: i,
  buffered: n,
  overrideCheck: s
}) => !s && t === e ? null : t < e ? i : n.length ? n.end(n.length - 1) : i, Hh = ({
  timelineChangeController: t,
  currentTimeline: e,
  segmentTimeline: i,
  loaderType: n,
  audioDisabled: s
}) => {
  if (e === i)
    return !1;
  if (n === "audio") {
    const r = t.lastTimelineChange({
      type: "main"
    });
    return !r || r.to !== i;
  }
  if (n === "main" && s) {
    const r = t.pendingTimelineChange({
      type: "audio"
    });
    return !(r && r.to === i);
  }
  return !1;
}, iV = (t) => {
  if (!t)
    return !1;
  const e = t.pendingTimelineChange({
    type: "audio"
  }), i = t.pendingTimelineChange({
    type: "main"
  }), n = e && i, s = n && e.to !== i.to;
  return !!(n && e.from !== -1 && i.from !== -1 && s);
}, nV = (t) => {
  const e = t.timelineChangeController_.pendingTimelineChange({
    type: "audio"
  }), i = t.timelineChangeController_.pendingTimelineChange({
    type: "main"
  });
  return e && i && e.to < i.to;
}, nr = (t) => {
  const e = t.pendingSegment_;
  if (!e)
    return;
  if (Hh({
    timelineChangeController: t.timelineChangeController_,
    currentTimeline: t.currentTimeline_,
    segmentTimeline: e.timeline,
    loaderType: t.loaderType_,
    audioDisabled: t.audioDisabled_
  }) && iV(t.timelineChangeController_)) {
    if (nV(t)) {
      t.timelineChangeController_.trigger("audioTimelineBehind");
      return;
    }
    t.timelineChangeController_.trigger("fixBadTimelineChange");
  }
}, sV = (t) => {
  let e = 0;
  return ["video", "audio"].forEach(function(i) {
    const n = t[`${i}TimingInfo`];
    if (!n)
      return;
    const {
      start: s,
      end: r
    } = n;
    let a;
    typeof s == "bigint" || typeof r == "bigint" ? a = ne.BigInt(r) - ne.BigInt(s) : typeof s == "number" && typeof r == "number" && (a = r - s), typeof a < "u" && a > e && (e = a);
  }), typeof e == "bigint" && e < Number.MAX_SAFE_INTEGER && (e = Number(e)), e;
}, Yv = ({
  segmentDuration: t,
  maxDuration: e
}) => t ? Math.round(t) > e + ys : !1, rV = (t, e) => {
  if (e !== "hls")
    return null;
  const i = sV({
    audioTimingInfo: t.audioTimingInfo,
    videoTimingInfo: t.videoTimingInfo
  });
  if (!i)
    return null;
  const n = t.playlist.targetDuration, s = Yv({
    segmentDuration: i,
    maxDuration: n * 2
  }), r = Yv({
    segmentDuration: i,
    maxDuration: n
  }), a = `Segment with index ${t.mediaIndex} from playlist ${t.playlist.id} has a duration of ${i} when the reported duration is ${t.duration} and the target duration is ${n}. For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1`;
  return s || r ? {
    severity: s ? "warn" : "info",
    message: a
  } : null;
}, zr = ({
  type: t,
  segment: e
}) => {
  if (!e)
    return;
  const i = !!(e.key || e.map && e.map.ke), n = !!(e.map && !e.map.bytes), s = e.startOfSegment === void 0 ? e.start : e.startOfSegment;
  return {
    type: t || e.type,
    uri: e.resolvedUri || e.uri,
    start: s,
    duration: e.duration,
    isEncrypted: i,
    isMediaInitialization: n
  };
};
class Wh extends Ae.EventTarget {
  constructor(e, i = {}) {
    if (super(), !e)
      throw new TypeError("Initialization settings are required");
    if (typeof e.currentTime != "function")
      throw new TypeError("No currentTime getter specified");
    if (!e.mediaSource)
      throw new TypeError("No MediaSource specified");
    this.bandwidth = e.bandwidth, this.throughput = {
      rate: 0,
      count: 0
    }, this.roundTrip = NaN, this.resetStats_(), this.mediaIndex = null, this.partIndex = null, this.hasPlayed_ = e.hasPlayed, this.currentTime_ = e.currentTime, this.seekable_ = e.seekable, this.seeking_ = e.seeking, this.duration_ = e.duration, this.mediaSource_ = e.mediaSource, this.vhs_ = e.vhs, this.loaderType_ = e.loaderType, this.currentMediaInfo_ = void 0, this.startingMediaInfo_ = void 0, this.segmentMetadataTrack_ = e.segmentMetadataTrack, this.goalBufferLength_ = e.goalBufferLength, this.sourceType_ = e.sourceType, this.sourceUpdater_ = e.sourceUpdater, this.inbandTextTracks_ = e.inbandTextTracks, this.state_ = "INIT", this.timelineChangeController_ = e.timelineChangeController, this.shouldSaveSegmentTimingInfo_ = !0, this.parse708captions_ = e.parse708captions, this.useDtsForTimestampOffset_ = e.useDtsForTimestampOffset, this.captionServices_ = e.captionServices, this.exactManifestTimings = e.exactManifestTimings, this.addMetadataToTextTrack = e.addMetadataToTextTrack, this.checkBufferTimeout_ = null, this.error_ = void 0, this.currentTimeline_ = -1, this.shouldForceTimestampOffsetAfterResync_ = !1, this.pendingSegment_ = null, this.xhrOptions_ = null, this.pendingSegments_ = [], this.audioDisabled_ = !1, this.isPendingTimestampOffset_ = !1, this.gopBuffer_ = [], this.timeMapping_ = 0, this.safeAppend_ = !1, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.playlistOfLastInitSegment_ = {
      audio: null,
      video: null
    }, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_ = {
      id3: [],
      caption: []
    }, this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = null, this.activeInitSegmentId_ = null, this.initSegments_ = {}, this.cacheEncryptionKeys_ = e.cacheEncryptionKeys, this.keyCache_ = {}, this.decrypter_ = e.decrypter, this.syncController_ = e.syncController, this.syncPoint_ = {
      segmentIndex: 0,
      time: 0
    }, this.transmuxer_ = this.createTransmuxer_(), this.triggerSyncInfoUpdate_ = () => this.trigger("syncinfoupdate"), this.syncController_.on("syncinfoupdate", this.triggerSyncInfoUpdate_), this.mediaSource_.addEventListener("sourceopen", () => {
      this.isEndOfStream_() || (this.ended_ = !1);
    }), this.fetchAtBuffer_ = !1, this.logger_ = Fn(`SegmentLoader[${this.loaderType_}]`), Object.defineProperty(this, "state", {
      get() {
        return this.state_;
      },
      set(n) {
        n !== this.state_ && (this.logger_(`${this.state_} -> ${n}`), this.state_ = n, this.trigger("statechange"));
      }
    }), this.sourceUpdater_.on("ready", () => {
      this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : nr(this);
    }), this.sourceUpdater_.on("codecschange", (n) => {
      this.trigger(pi({
        type: "codecschange"
      }, n));
    }), this.loaderType_ === "main" && this.timelineChangeController_.on("pendingtimelinechange", () => {
      this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : nr(this);
    }), this.loaderType_ === "audio" && this.timelineChangeController_.on("timelinechange", (n) => {
      this.trigger(pi({
        type: "timelinechange"
      }, n)), this.hasEnoughInfoToLoad_() ? this.processLoadQueue_() : nr(this), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : nr(this);
    });
  }
  /**
   * TODO: Current sync controller consists of many hls-specific strategies
   * media sequence sync is also hls-specific, and we would like to be protocol-agnostic on this level
   * this should be a part of the sync-controller and sync controller should expect different strategy list based on the protocol.
   *
   * @return {MediaSequenceSync|null}
   * @private
   */
  get mediaSequenceSync_() {
    return this.syncController_.getMediaSequenceSync(this.loaderType_);
  }
  createTransmuxer_() {
    return Kf.createTransmuxer({
      remux: !1,
      alignGopsAtEnd: this.safeAppend_,
      keepOriginalTimestamps: !0,
      parse708captions: this.parse708captions_,
      captionServices: this.captionServices_
    });
  }
  /**
   * reset all of our media stats
   *
   * @private
   */
  resetStats_() {
    this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0, this.mediaAppends = 0;
  }
  /**
   * dispose of the SegmentLoader and reset to the default state
   */
  dispose() {
    this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && ne.clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off();
  }
  setAudio(e) {
    this.audioDisabled_ = !e, e ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_());
  }
  /**
   * abort anything that is currently doing on with the SegmentLoader
   * and reset to a default state
   */
  abort() {
    if (this.state !== "WAITING") {
      this.pendingSegment_ && (this.pendingSegment_ = null), this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
      return;
    }
    this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
  }
  /**
   * abort all pending xhr requests and null any pending segements
   *
   * @private
   */
  abort_() {
    this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, ne.clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null;
  }
  checkForAbort_(e) {
    return this.state === "APPENDING" && !this.pendingSegment_ ? (this.state = "READY", !0) : !this.pendingSegment_ || this.pendingSegment_.requestId !== e;
  }
  /**
   * set an error on the segment loader and null out any pending segements
   *
   * @param {Error} error the error to set on the SegmentLoader
   * @return {Error} the error that was set or that is currently set
   */
  error(e) {
    return typeof e < "u" && (this.logger_("error occurred:", e), this.error_ = e), this.pendingSegment_ = null, this.error_;
  }
  endOfStream() {
    this.ended_ = !0, this.transmuxer_ && Kf.reset(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended");
  }
  /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */
  buffered_() {
    const e = this.getMediaInfo_();
    if (!this.sourceUpdater_ || !e)
      return ki();
    if (this.loaderType_ === "main") {
      const {
        hasAudio: i,
        hasVideo: n,
        isMuxed: s
      } = e;
      if (n && i && !this.audioDisabled_ && !s)
        return this.sourceUpdater_.buffered();
      if (n)
        return this.sourceUpdater_.videoBuffered();
    }
    return this.sourceUpdater_.audioBuffered();
  }
  /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */
  initSegmentForMap(e, i = !1) {
    if (!e)
      return null;
    const n = _d(e);
    let s = this.initSegments_[n];
    return i && !s && e.bytes && (this.initSegments_[n] = s = {
      resolvedUri: e.resolvedUri,
      byterange: e.byterange,
      bytes: e.bytes,
      tracks: e.tracks,
      timescales: e.timescales
    }), s || e;
  }
  /**
   * Gets and sets key for the provided key
   *
   * @param {Object} key
   *        The key object representing the key to get or set
   * @param {boolean=} set
   *        If true, the key for the provided key should be saved
   * @return {Object}
   *         Key object for desired key
   */
  segmentKey(e, i = !1) {
    if (!e)
      return null;
    const n = s1(e);
    let s = this.keyCache_[n];
    this.cacheEncryptionKeys_ && i && !s && e.bytes && (this.keyCache_[n] = s = {
      resolvedUri: e.resolvedUri,
      bytes: e.bytes
    });
    const r = {
      resolvedUri: (s || e).resolvedUri
    };
    return s && (r.bytes = s.bytes), r;
  }
  /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */
  couldBeginLoading_() {
    return this.playlist_ && !this.paused();
  }
  /**
   * load a playlist and start to fill the buffer
   */
  load() {
    if (this.monitorBuffer_(), !!this.playlist_) {
      if (this.state === "INIT" && this.couldBeginLoading_())
        return this.init_();
      !this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
    }
  }
  /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */
  init_() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }
  /**
   * set a playlist on the segment loader
   *
   * @param {PlaylistLoader} media the playlist to set on the segment loader
   */
  playlist(e, i = {}) {
    if (!e || this.playlist_ && this.playlist_.endList && e.endList && this.playlist_.uri === e.uri)
      return;
    const n = this.playlist_, s = this.pendingSegment_;
    this.playlist_ = e, this.xhrOptions_ = i, this.state === "INIT" && (e.syncInfo = {
      mediaSequence: e.mediaSequence,
      time: 0
    }, this.loaderType_ === "main" && this.syncController_.setDateTimeMappingForStart(e));
    let r = null;
    if (n && (n.id ? r = n.id : n.uri && (r = n.uri)), this.logger_(`playlist update [${r} => ${e.id || e.uri}]`), this.mediaSequenceSync_ && (this.mediaSequenceSync_.update(e, this.currentTime_()), this.logger_(`Playlist update:
currentTime: ${this.currentTime_()}
bufferedEnd: ${Qf(this.buffered_())}
`, this.mediaSequenceSync_.diagnostics)), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_())
      return this.init_();
    if (!n || n.uri !== e.uri) {
      this.mediaIndex !== null && (!e.endList && typeof e.partTargetDuration == "number" ? this.resetLoader() : this.resyncLoader()), this.currentMediaInfo_ = void 0, this.trigger("playlistupdate");
      return;
    }
    const a = e.mediaSequence - n.mediaSequence;
    if (this.logger_(`live window shift [${a}]`), this.mediaIndex !== null)
      if (this.mediaIndex -= a, this.mediaIndex < 0)
        this.mediaIndex = null, this.partIndex = null;
      else {
        const o = this.playlist_.segments[this.mediaIndex];
        if (this.partIndex && (!o.parts || !o.parts.length || !o.parts[this.partIndex])) {
          const l = this.mediaIndex;
          this.logger_(`currently processing part (index ${this.partIndex}) no longer exists.`), this.resetLoader(), this.mediaIndex = l;
        }
      }
    s && (s.mediaIndex -= a, s.mediaIndex < 0 ? (s.mediaIndex = null, s.partIndex = null) : (s.mediaIndex >= 0 && (s.segment = e.segments[s.mediaIndex]), s.partIndex >= 0 && s.segment.parts && (s.part = s.segment.parts[s.partIndex]))), this.syncController_.saveExpiredSegmentInfo(n, e);
  }
  /**
   * Prevent the loader from fetching additional segments. If there
   * is a segment request outstanding, it will finish processing
   * before the loader halts. A segment loader can be unpaused by
   * calling load().
   */
  pause() {
    this.checkBufferTimeout_ && (ne.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = null);
  }
  /**
   * Returns whether the segment loader is fetching additional
   * segments when given the opportunity. This property can be
   * modified through calls to pause() and load().
   */
  paused() {
    return this.checkBufferTimeout_ === null;
  }
  /**
   * Delete all the buffered data and reset the SegmentLoader
   *
   * @param {Function} [done] an optional callback to be executed when the remove
   * operation is complete
   */
  resetEverything(e) {
    this.ended_ = !1, this.activeInitSegmentId_ = null, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.resetLoader(), this.remove(0, 1 / 0, e), this.transmuxer_ && (this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), this.transmuxer_.postMessage({
      action: "reset"
    }));
  }
  /**
   * Force the SegmentLoader to resync and start loading around the currentTime instead
   * of starting at the end of the buffer
   *
   * Useful for fast quality changes
   */
  resetLoader() {
    this.fetchAtBuffer_ = !1, this.mediaSequenceSync_ && this.mediaSequenceSync_.resetAppendedStatus(), this.resyncLoader();
  }
  /**
   * Force the SegmentLoader to restart synchronization and make a conservative guess
   * before returning to the simple walk-forward method
   */
  resyncLoader() {
    this.transmuxer_ && Kf.reset(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1;
    const e = this.currentMediaInfo_ && this.currentMediaInfo_.isFmp4;
    this.sourceType_ === "hls" && !e && (this.shouldForceTimestampOffsetAfterResync_ = !0), this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }
  /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   * @param {Function} [done] - an optional callback to be executed when the remove
   * @param {boolean} force - force all remove operations to happen
   * operation is complete
   */
  remove(e, i, n = () => {
  }, s = !1) {
    if (i === 1 / 0 && (i = this.duration_()), i <= e) {
      this.logger_("skipping remove because end ${end} is <= start ${start}");
      return;
    }
    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
      this.logger_("skipping remove because no source updater or starting media info");
      return;
    }
    let r = 1;
    const a = () => {
      r--, r === 0 && n();
    };
    (s || !this.audioDisabled_) && (r++, this.sourceUpdater_.removeAudio(e, i, a)), (s || this.loaderType_ === "main") && (this.gopBuffer_ = QU(this.gopBuffer_, e, i, this.timeMapping_), r++, this.sourceUpdater_.removeVideo(e, i, a));
    for (const o in this.inbandTextTracks_)
      rl(e, i, this.inbandTextTracks_[o]);
    rl(e, i, this.segmentMetadataTrack_), a();
  }
  /**
   * (re-)schedule monitorBufferTick_ to run as soon as possible
   *
   * @private
   */
  monitorBuffer_() {
    this.checkBufferTimeout_ && ne.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = ne.setTimeout(this.monitorBufferTick_.bind(this), 1);
  }
  /**
   * As long as the SegmentLoader is in the READY state, periodically
   * invoke fillBuffer_().
   *
   * @private
   */
  monitorBufferTick_() {
    this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && ne.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = ne.setTimeout(this.monitorBufferTick_.bind(this), JU);
  }
  /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */
  fillBuffer_() {
    if (this.sourceUpdater_.updating())
      return;
    const e = this.chooseNextRequest_();
    if (!e)
      return;
    const i = {
      segmentInfo: zr({
        type: this.loaderType_,
        segment: e
      })
    };
    this.trigger({
      type: "segmentselected",
      metadata: i
    }), typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !1, this.timelineChangeController_.pendingTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: e.timeline
    })), this.loadSegment_(e);
  }
  /**
   * Determines if we should call endOfStream on the media source based
   * on the state of the buffer or if appened segment was the final
   * segment in the playlist.
   *
   * @param {number} [mediaIndex] the media index of segment we last appended
   * @param {Object} [playlist] a media playlist object
   * @return {boolean} do we need to call endOfStream on the MediaSource
   */
  isEndOfStream_(e = this.mediaIndex, i = this.playlist_, n = this.partIndex) {
    if (!i || !this.mediaSource_)
      return !1;
    const s = typeof e == "number" && i.segments[e], r = e + 1 === i.segments.length, a = !s || !s.parts || n + 1 === s.parts.length;
    return i.endList && this.mediaSource_.readyState === "open" && r && a;
  }
  /**
   * Determines what request should be made given current segment loader state.
   *
   * @return {Object} a request object that describes the segment/part to load
   */
  chooseNextRequest_() {
    const e = this.buffered_(), i = Qf(e) || 0, n = Am(e, this.currentTime_()), s = !this.hasPlayed_() && n >= 1, r = n >= this.goalBufferLength_(), a = this.playlist_.segments;
    if (!a.length || s || r)
      return null;
    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_(), this.loaderType_);
    const o = {
      partIndex: null,
      mediaIndex: null,
      startOfSegment: null,
      playlist: this.playlist_,
      isSyncRequest: !this.syncPoint_
    };
    if (o.isSyncRequest)
      o.mediaIndex = KU(this.currentTimeline_, a, i), this.logger_(`choose next request. Can not find sync point. Fallback to media Index: ${o.mediaIndex}`);
    else if (this.mediaIndex !== null) {
      const A = a[this.mediaIndex], m = typeof this.partIndex == "number" ? this.partIndex : -1;
      o.startOfSegment = A.end ? A.end : i, A.parts && A.parts[m + 1] ? (o.mediaIndex = this.mediaIndex, o.partIndex = m + 1) : o.mediaIndex = this.mediaIndex + 1;
    } else {
      let A, m, p;
      const h = this.fetchAtBuffer_ ? i : this.currentTime_();
      if (this.mediaSequenceSync_ && this.logger_(`chooseNextRequest_ request after Quality Switch:
For TargetTime: ${h}.
CurrentTime: ${this.currentTime_()}
BufferedEnd: ${i}
Fetch At Buffer: ${this.fetchAtBuffer_}
`, this.mediaSequenceSync_.diagnostics), this.mediaSequenceSync_ && this.mediaSequenceSync_.isReliable) {
        const g = this.getSyncInfoFromMediaSequenceSync_(h);
        if (!g) {
          const w = "No sync info found while using media sequence sync";
          return this.error({
            message: w,
            metadata: {
              errorType: Ae.Error.StreamingFailedToSelectNextSegment,
              error: new Error(w)
            }
          }), this.logger_("chooseNextRequest_ - no sync info found using media sequence sync"), null;
        }
        this.logger_(`chooseNextRequest_ mediaSequence syncInfo (${g.start} --> ${g.end})`), A = g.segmentIndex, m = g.partIndex, p = g.start;
      } else {
        this.logger_("chooseNextRequest_ - fallback to a regular segment selection algorithm, based on a syncPoint.");
        const g = on.getMediaInfoForTime({
          exactManifestTimings: this.exactManifestTimings,
          playlist: this.playlist_,
          currentTime: h,
          startingPartIndex: this.syncPoint_.partIndex,
          startingSegmentIndex: this.syncPoint_.segmentIndex,
          startTime: this.syncPoint_.time
        });
        A = g.segmentIndex, m = g.partIndex, p = g.startTime;
      }
      o.getMediaInfoForTime = this.fetchAtBuffer_ ? `bufferedEnd ${h}` : `currentTime ${h}`, o.mediaIndex = A, o.startOfSegment = p, o.partIndex = m, this.logger_(`choose next request. Playlist switched and we have a sync point. Media Index: ${o.mediaIndex} `);
    }
    const l = a[o.mediaIndex];
    let u = l && typeof o.partIndex == "number" && l.parts && l.parts[o.partIndex];
    if (!l || typeof o.partIndex == "number" && !u)
      return null;
    typeof o.partIndex != "number" && l.parts && (o.partIndex = 0, u = l.parts[0]);
    const d = this.vhs_.playlists && this.vhs_.playlists.main && this.vhs_.playlists.main.independentSegments || this.playlist_.independentSegments;
    if (!n && u && !d && !u.independent)
      if (o.partIndex === 0) {
        const A = a[o.mediaIndex - 1], m = A.parts && A.parts.length && A.parts[A.parts.length - 1];
        m && m.independent && (o.mediaIndex -= 1, o.partIndex = A.parts.length - 1, o.independent = "previous segment");
      } else l.parts[o.partIndex - 1].independent && (o.partIndex -= 1, o.independent = "previous part");
    const c = this.mediaSource_ && this.mediaSource_.readyState === "ended";
    return o.mediaIndex >= a.length - 1 && c && !this.seeking_() ? null : (this.shouldForceTimestampOffsetAfterResync_ && (this.shouldForceTimestampOffsetAfterResync_ = !1, o.forceTimestampOffset = !0, this.logger_("choose next request. Force timestamp offset after loader resync")), this.generateSegmentInfo_(o));
  }
  getSyncInfoFromMediaSequenceSync_(e) {
    if (!this.mediaSequenceSync_)
      return null;
    const i = Math.max(e, this.mediaSequenceSync_.start);
    e !== i && this.logger_(`getSyncInfoFromMediaSequenceSync_. Pulled target time from ${e} to ${i}`);
    const n = this.mediaSequenceSync_.getSyncInfoForTime(i);
    if (!n)
      return null;
    if (!n.isAppended)
      return n;
    const s = this.mediaSequenceSync_.getSyncInfoForTime(n.end);
    return s ? (s.isAppended && this.logger_("getSyncInfoFromMediaSequenceSync_: We encounter unexpected scenario where next media sequence sync info is also appended!"), s) : null;
  }
  generateSegmentInfo_(e) {
    const {
      independent: i,
      playlist: n,
      mediaIndex: s,
      startOfSegment: r,
      isSyncRequest: a,
      partIndex: o,
      forceTimestampOffset: l,
      getMediaInfoForTime: u
    } = e, d = n.segments[s], c = typeof o == "number" && d.parts[o], A = {
      requestId: "segment-loader-" + Math.random(),
      // resolve the segment URL relative to the playlist
      uri: c && c.resolvedUri || d.resolvedUri,
      // the segment's mediaIndex at the time it was requested
      mediaIndex: s,
      partIndex: c ? o : null,
      // whether or not to update the SegmentLoader's state with this
      // segment's mediaIndex
      isSyncRequest: a,
      startOfSegment: r,
      // the segment's playlist
      playlist: n,
      // unencrypted bytes of the segment
      bytes: null,
      // when a key is defined for this segment, the encrypted bytes
      encryptedBytes: null,
      // The target timestampOffset for this segment when we append it
      // to the source buffer
      timestampOffset: null,
      // The timeline that the segment is in
      timeline: d.timeline,
      // The expected duration of the segment in seconds
      duration: c && c.duration || d.duration,
      // retain the segment in case the playlist updates while doing an async process
      segment: d,
      part: c,
      byteLength: 0,
      transmuxer: this.transmuxer_,
      // type of getMediaInfoForTime that was used to get this segment
      getMediaInfoForTime: u,
      independent: i
    }, m = typeof l < "u" ? l : this.isPendingTimestampOffset_;
    A.timestampOffset = this.timestampOffsetForSegment_({
      segmentTimeline: d.timeline,
      currentTimeline: this.currentTimeline_,
      startOfSegment: r,
      buffered: this.buffered_(),
      overrideCheck: m
    });
    const p = Qf(this.sourceUpdater_.audioBuffered());
    return typeof p == "number" && (A.audioAppendStart = p - this.sourceUpdater_.audioTimestampOffset()), this.sourceUpdater_.videoBuffered().length && (A.gopsToAlignWith = jU(
      this.gopBuffer_,
      // since the transmuxer is using the actual timing values, but the time is
      // adjusted by the timestmap offset, we must adjust the value here
      this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(),
      this.timeMapping_
    )), A;
  }
  // get the timestampoffset for a segment,
  // added so that vtt segment loader can override and prevent
  // adding timestamp offsets.
  timestampOffsetForSegment_(e) {
    return tV(e);
  }
  /**
   * Determines if the network has enough bandwidth to complete the current segment
   * request in a timely manner. If not, the request will be aborted early and bandwidth
   * updated to trigger a playlist switch.
   *
   * @param {Object} stats
   *        Object containing stats about the request timing and size
   * @private
   */
  earlyAbortWhenNeeded_(e) {
    if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
    // TODO: Replace using timeout with a boolean indicating whether this playlist is
    //       the lowestEnabledRendition.
    !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
    !this.playlist_.attributes.BANDWIDTH || Date.now() - (e.firstBytesReceivedAt || Date.now()) < 1e3)
      return;
    const i = this.currentTime_(), n = e.bandwidth, s = this.pendingSegment_.duration, r = on.estimateSegmentRequestTime(s, n, this.playlist_, e.bytesReceived), a = xz(this.buffered_(), i, this.vhs_.tech_.playbackRate()) - 1;
    if (r <= a)
      return;
    const o = NU({
      main: this.vhs_.playlists.main,
      currentTime: i,
      bandwidth: n,
      duration: this.duration_(),
      segmentDuration: s,
      timeUntilRebuffer: a,
      currentTimeline: this.currentTimeline_,
      syncController: this.syncController_
    });
    if (!o)
      return;
    const u = r - a - o.rebufferingImpact;
    let d = 0.5;
    a <= ys && (d = 1), !(!o.playlist || o.playlist.uri === this.playlist_.uri || u < d) && (this.bandwidth = o.playlist.attributes.BANDWIDTH * Si.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"));
  }
  handleAbort_(e) {
    this.logger_(`Aborting ${va(e)}`), this.mediaRequestsAborted += 1;
  }
  /**
   * XHR `progress` event handler
   *
   * @param {Event}
   *        The XHR `progress` event
   * @param {Object} simpleSegment
   *        A simplified segment object copy
   * @private
   */
  handleProgress_(e, i) {
    this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId) && this.trigger("progress");
  }
  handleTrackInfo_(e, i) {
    const {
      hasAudio: n,
      hasVideo: s
    } = i, r = {
      segmentInfo: zr({
        type: this.loaderType_,
        segment: e
      }),
      trackInfo: {
        hasAudio: n,
        hasVideo: s
      }
    };
    this.trigger({
      type: "segmenttransmuxingtrackinfoavailable",
      metadata: r
    }), this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId) && (this.checkForIllegalMediaSwitch(i) || (i = i || {}, ZU(this.currentMediaInfo_, i) || (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.startingMediaInfo_ = i, this.currentMediaInfo_ = i, this.logger_("trackinfo update", i), this.trigger("trackinfo")), !this.checkForAbort_(e.requestId) && (this.pendingSegment_.trackInfo = i, this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : nr(this))));
  }
  handleTimingInfo_(e, i, n, s) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    const r = this.pendingSegment_, a = Wv(i);
    r[a] = r[a] || {}, r[a][n] = s, this.logger_(`timinginfo: ${i} - ${n} - ${s}`), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : nr(this);
  }
  handleCaptions_(e, i) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (i.length === 0) {
      this.logger_("SegmentLoader received no captions from a caption event");
      return;
    }
    if (!this.pendingSegment_.hasAppendedData_) {
      this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, e, i));
      return;
    }
    const s = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(), r = {};
    i.forEach((a) => {
      r[a.stream] = r[a.stream] || {
        // Infinity, as any other value will be less than this
        startTime: 1 / 0,
        captions: [],
        // 0 as an other value will be more than this
        endTime: 0
      };
      const o = r[a.stream];
      o.startTime = Math.min(o.startTime, a.startTime + s), o.endTime = Math.max(o.endTime, a.endTime + s), o.captions.push(a);
    }), Object.keys(r).forEach((a) => {
      const {
        startTime: o,
        endTime: l,
        captions: u
      } = r[a], d = this.inbandTextTracks_;
      this.logger_(`adding cues from ${o} -> ${l} for ${a}`), zU(d, this.vhs_.tech_, a), rl(o, l, d[a]), UU({
        captionArray: u,
        inbandTextTracks: d,
        timestampOffset: s
      });
    }), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }
  handleId3_(e, i, n) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (!this.pendingSegment_.hasAppendedData_) {
      this.metadataQueue_.id3.push(this.handleId3_.bind(this, e, i, n));
      return;
    }
    this.addMetadataToTextTrack(n, i, this.duration_());
  }
  processMetadataQueue_() {
    this.metadataQueue_.id3.forEach((e) => e()), this.metadataQueue_.caption.forEach((e) => e()), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [];
  }
  processCallQueue_() {
    const e = this.callQueue_;
    this.callQueue_ = [], e.forEach((i) => i());
  }
  processLoadQueue_() {
    const e = this.loadQueue_;
    this.loadQueue_ = [], e.forEach((i) => i());
  }
  /**
   * Determines whether the loader has enough info to load the next segment.
   *
   * @return {boolean}
   *         Whether or not the loader has enough info to load the next segment
   */
  hasEnoughInfoToLoad_() {
    if (this.loaderType_ !== "audio")
      return !0;
    const e = this.pendingSegment_;
    return e ? this.getCurrentMediaInfo_() ? (
      // Technically, instead of waiting to load a segment on timeline changes, a segment
      // can be requested and downloaded and only wait before it is transmuxed or parsed.
      // But in practice, there are a few reasons why it is better to wait until a loader
      // is ready to append that segment before requesting and downloading:
      //
      // 1. Because audio and main loaders cross discontinuities together, if this loader
      //    is waiting for the other to catch up, then instead of requesting another
      //    segment and using up more bandwidth, by not yet loading, more bandwidth is
      //    allotted to the loader currently behind.
      // 2. media-segment-request doesn't have to have logic to consider whether a segment
      // is ready to be processed or not, isolating the queueing behavior to the loader.
      // 3. The audio loader bases some of its segment properties on timing information
      //    provided by the main loader, meaning that, if the logic for waiting on
      //    processing was in media-segment-request, then it would also need to know how
      //    to re-generate the segment information after the main loader caught up.
      !Hh({
        timelineChangeController: this.timelineChangeController_,
        currentTimeline: this.currentTimeline_,
        segmentTimeline: e.timeline,
        loaderType: this.loaderType_,
        audioDisabled: this.audioDisabled_
      })
    ) : !0 : !1;
  }
  getCurrentMediaInfo_(e = this.pendingSegment_) {
    return e && e.trackInfo || this.currentMediaInfo_;
  }
  getMediaInfo_(e = this.pendingSegment_) {
    return this.getCurrentMediaInfo_(e) || this.startingMediaInfo_;
  }
  getPendingSegmentPlaylist() {
    return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
  }
  hasEnoughInfoToAppend_() {
    if (!this.sourceUpdater_.ready() || this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_)
      return !1;
    const e = this.pendingSegment_, i = this.getCurrentMediaInfo_();
    if (!e || !i)
      return !1;
    const {
      hasAudio: n,
      hasVideo: s,
      isMuxed: r
    } = i;
    return !(s && !e.videoTimingInfo || n && !this.audioDisabled_ && !r && !e.audioTimingInfo || Hh({
      timelineChangeController: this.timelineChangeController_,
      currentTimeline: this.currentTimeline_,
      segmentTimeline: e.timeline,
      loaderType: this.loaderType_,
      audioDisabled: this.audioDisabled_
    }));
  }
  handleData_(e, i) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
      nr(this), this.callQueue_.push(this.handleData_.bind(this, e, i));
      return;
    }
    const n = this.pendingSegment_;
    if (this.setTimeMapping_(n.timeline), this.updateMediaSecondsLoaded_(n.part || n.segment), this.mediaSource_.readyState !== "closed") {
      if (e.map && (e.map = this.initSegmentForMap(e.map, !0), n.segment.map = e.map), e.key && this.segmentKey(e.key, !0), n.isFmp4 = e.isFmp4, n.timingInfo = n.timingInfo || {}, n.isFmp4)
        this.trigger("fmp4"), n.timingInfo.start = n[Wv(i.type)].start;
      else {
        const s = this.getCurrentMediaInfo_(), r = this.loaderType_ === "main" && s && s.hasVideo;
        let a;
        r && (a = n.videoTimingInfo.start), n.timingInfo.start = this.trueSegmentStart_({
          currentStart: n.timingInfo.start,
          playlist: n.playlist,
          mediaIndex: n.mediaIndex,
          currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
          useVideoTimingInfo: r,
          firstVideoFrameTimeForData: a,
          videoTimingInfo: n.videoTimingInfo,
          audioTimingInfo: n.audioTimingInfo
        });
      }
      if (this.updateAppendInitSegmentStatus(n, i.type), this.updateSourceBufferTimestampOffset_(n), n.isSyncRequest) {
        this.updateTimingInfoEnd_(n), this.syncController_.saveSegmentTimingInfo({
          segmentInfo: n,
          shouldSaveTimelineMapping: this.loaderType_ === "main"
        });
        const s = this.chooseNextRequest_();
        if (s.mediaIndex !== n.mediaIndex || s.partIndex !== n.partIndex) {
          this.logger_("sync segment was incorrect, not appending");
          return;
        }
        this.logger_("sync segment was correct, appending");
      }
      n.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(n, i);
    }
  }
  updateAppendInitSegmentStatus(e, i) {
    this.loaderType_ === "main" && typeof e.timestampOffset == "number" && // in the case that we're handling partial data, we don't want to append an init
    // segment for each chunk
    !e.changedTimestampOffset && (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }), this.playlistOfLastInitSegment_[i] !== e.playlist && (this.appendInitSegment_[i] = !0);
  }
  getInitSegmentAndUpdateState_({
    type: e,
    initSegment: i,
    map: n,
    playlist: s
  }) {
    if (n) {
      const r = _d(n);
      if (this.activeInitSegmentId_ === r)
        return null;
      i = this.initSegmentForMap(n, !0).bytes, this.activeInitSegmentId_ = r;
    }
    return i && this.appendInitSegment_[e] ? (this.playlistOfLastInitSegment_[e] = s, this.appendInitSegment_[e] = !1, this.activeInitSegmentId_ = null, i) : null;
  }
  handleQuotaExceededError_({
    segmentInfo: e,
    type: i,
    bytes: n
  }, s) {
    const r = this.sourceUpdater_.audioBuffered(), a = this.sourceUpdater_.videoBuffered();
    r.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + qr(r).join(", ")), a.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + qr(a).join(", "));
    const o = r.length ? r.start(0) : 0, l = r.length ? r.end(r.length - 1) : 0, u = a.length ? a.start(0) : 0, d = a.length ? a.end(a.length - 1) : 0;
    if (l - o <= Zo && d - u <= Zo) {
      this.logger_(`On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. Appended byte length: ${n.byteLength}, audio buffer: ${qr(r).join(", ")}, video buffer: ${qr(a).join(", ")}, `), this.error({
        message: "Quota exceeded error with append of a single segment of content",
        excludeUntil: 1 / 0
      }), this.trigger("error");
      return;
    }
    this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
      segmentInfo: e,
      type: i,
      bytes: n
    }));
    const A = this.currentTime_() - Zo;
    this.logger_(`On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to ${A}`), this.remove(0, A, () => {
      this.logger_(`On QUOTA_EXCEEDED_ERR, retrying append in ${Zo}s`), this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = ne.setTimeout(() => {
        this.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), this.quotaExceededErrorRetryTimeout_ = null, this.processCallQueue_();
      }, Zo * 1e3);
    }, !0);
  }
  handleAppendError_({
    segmentInfo: e,
    type: i,
    bytes: n
  }, s) {
    if (s) {
      if (s.code === Zw) {
        this.handleQuotaExceededError_({
          segmentInfo: e,
          type: i,
          bytes: n
        });
        return;
      }
      this.logger_("Received non QUOTA_EXCEEDED_ERR on append", s), this.error({
        message: `${i} append of ${n.length}b failed for segment #${e.mediaIndex} in playlist ${e.playlist.id}`,
        metadata: {
          errorType: Ae.Error.StreamingFailedToAppendSegment
        }
      }), this.trigger("appenderror");
    }
  }
  appendToSourceBuffer_({
    segmentInfo: e,
    type: i,
    initSegment: n,
    data: s,
    bytes: r
  }) {
    if (!r) {
      const o = [s];
      let l = s.byteLength;
      n && (o.unshift(n), l += n.byteLength), r = FU({
        bytes: l,
        segments: o
      });
    }
    const a = {
      segmentInfo: zr({
        type: this.loaderType_,
        segment: e
      })
    };
    this.trigger({
      type: "segmentappendstart",
      metadata: a
    }), this.sourceUpdater_.appendBuffer({
      segmentInfo: e,
      type: i,
      bytes: r
    }, this.handleAppendError_.bind(this, {
      segmentInfo: e,
      type: i,
      bytes: r
    }));
  }
  handleSegmentTimingInfo_(e, i, n) {
    if (!this.pendingSegment_ || i !== this.pendingSegment_.requestId)
      return;
    const s = this.pendingSegment_.segment, r = `${e}TimingInfo`;
    s[r] || (s[r] = {}), s[r].transmuxerPrependedSeconds = n.prependedContentDuration || 0, s[r].transmuxedPresentationStart = n.start.presentation, s[r].transmuxedDecodeStart = n.start.decode, s[r].transmuxedPresentationEnd = n.end.presentation, s[r].transmuxedDecodeEnd = n.end.decode, s[r].baseMediaDecodeTime = n.baseMediaDecodeTime;
  }
  appendData_(e, i) {
    const {
      type: n,
      data: s
    } = i;
    if (!s || !s.byteLength || n === "audio" && this.audioDisabled_)
      return;
    const r = this.getInitSegmentAndUpdateState_({
      type: n,
      initSegment: i.initSegment,
      playlist: e.playlist,
      map: e.isFmp4 ? e.segment.map : null
    });
    this.appendToSourceBuffer_({
      segmentInfo: e,
      type: n,
      initSegment: r,
      data: s
    });
  }
  /**
   * load a specific segment from a request into the buffer
   *
   * @private
   */
  loadSegment_(e) {
    if (this.state = "WAITING", this.pendingSegment_ = e, this.trimBackBuffer_(e), typeof e.timestampOffset == "number" && this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), !this.hasEnoughInfoToLoad_()) {
      nr(this), this.loadQueue_.push(() => {
        const i = pi({}, e, {
          forceTimestampOffset: !0
        });
        pi(e, this.generateSegmentInfo_(i)), this.isPendingTimestampOffset_ = !1, this.updateTransmuxerAndRequestSegment_(e);
      });
      return;
    }
    this.updateTransmuxerAndRequestSegment_(e);
  }
  updateTransmuxerAndRequestSegment_(e) {
    this.shouldUpdateTransmuxerTimestampOffset_(e.timestampOffset) && (this.gopBuffer_.length = 0, e.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({
      action: "reset"
    }), this.transmuxer_.postMessage({
      action: "setTimestampOffset",
      timestampOffset: e.timestampOffset
    }));
    const i = this.createSimplifiedSegmentObj_(e), n = this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex), s = this.mediaIndex !== null, r = e.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
    // the first timeline
    e.timeline > 0, a = n || s && r;
    this.logger_(`Requesting
${w1(e.uri)}
${va(e)}`), i.map && !i.map.bytes && (this.logger_("going to request init segment."), this.appendInitSegment_ = {
      video: !0,
      audio: !0
    }), e.abortRequests = OU({
      xhr: this.vhs_.xhr,
      xhrOptions: this.xhrOptions_,
      decryptionWorker: this.decrypter_,
      segment: i,
      abortFn: this.handleAbort_.bind(this, e),
      progressFn: this.handleProgress_.bind(this),
      trackInfoFn: this.handleTrackInfo_.bind(this),
      timingInfoFn: this.handleTimingInfo_.bind(this),
      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", e.requestId),
      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", e.requestId),
      captionsFn: this.handleCaptions_.bind(this),
      isEndOfTimeline: a,
      endedTimelineFn: () => {
        this.logger_("received endedtimeline callback");
      },
      id3Fn: this.handleId3_.bind(this),
      dataFn: this.handleData_.bind(this),
      doneFn: this.segmentRequestFinished_.bind(this),
      onTransmuxerLog: ({
        message: o,
        level: l,
        stream: u
      }) => {
        this.logger_(`${va(e)} logged from transmuxer stream ${u} as a ${l}: ${o}`);
      },
      triggerSegmentEventFn: ({
        type: o,
        segment: l,
        keyInfo: u,
        trackInfo: d,
        timingInfo: c
      }) => {
        const m = {
          segmentInfo: zr({
            segment: l
          })
        };
        u && (m.keyInfo = u), d && (m.trackInfo = d), c && (m.timingInfo = c), this.trigger({
          type: o,
          metadata: m
        });
      }
    });
  }
  /**
   * trim the back buffer so that we don't have too much data
   * in the source buffer
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   */
  trimBackBuffer_(e) {
    const i = eV(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
    i > 0 && this.remove(0, i);
  }
  /**
   * created a simplified copy of the segment object with just the
   * information necessary to perform the XHR and decryption
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   * @return {Object} a simplified segment object copy
   */
  createSimplifiedSegmentObj_(e) {
    const i = e.segment, n = e.part, s = e.segment.key || e.segment.map && e.segment.map.key, r = e.segment.map && !e.segment.map.bytes, a = {
      resolvedUri: n ? n.resolvedUri : i.resolvedUri,
      byterange: n ? n.byterange : i.byterange,
      requestId: e.requestId,
      transmuxer: e.transmuxer,
      audioAppendStart: e.audioAppendStart,
      gopsToAlignWith: e.gopsToAlignWith,
      part: e.part,
      type: this.loaderType_,
      start: e.startOfSegment,
      duration: e.duration,
      isEncrypted: s,
      isMediaInitialization: r
    }, o = e.playlist.segments[e.mediaIndex - 1];
    if (o && o.timeline === i.timeline && (o.videoTimingInfo ? a.baseStartTime = o.videoTimingInfo.transmuxedDecodeEnd : o.audioTimingInfo && (a.baseStartTime = o.audioTimingInfo.transmuxedDecodeEnd)), i.key) {
      const l = i.key.iv || new Uint32Array([0, 0, 0, e.mediaIndex + e.playlist.mediaSequence]);
      a.key = this.segmentKey(i.key), a.key.iv = l;
    }
    return i.map && (a.map = this.initSegmentForMap(i.map)), a;
  }
  saveTransferStats_(e) {
    this.mediaRequests += 1, e && (this.mediaBytesTransferred += e.bytesReceived, this.mediaTransferDuration += e.roundTripTime);
  }
  saveBandwidthRelatedStats_(e, i) {
    if (this.pendingSegment_.byteLength = i.bytesReceived, e < Bu) {
      this.logger_(`Ignoring segment's bandwidth because its duration of ${e} is less than the min to record ${Bu}`);
      return;
    }
    const n = {
      bandwidthInfo: {
        from: this.bandwidth,
        to: i.bandwidth
      }
    };
    this.trigger({
      type: "bandwidthupdated",
      metadata: n
    }), this.bandwidth = i.bandwidth, this.roundTrip = i.roundTripTime;
  }
  handleTimeout_() {
    this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate"), this.trigger("timeout");
  }
  /**
   * Handle the callback from the segmentRequest function and set the
   * associated SegmentLoader state and errors if necessary
   *
   * @private
   */
  segmentRequestFinished_(e, i, n) {
    if (this.callQueue_.length) {
      this.callQueue_.push(this.segmentRequestFinished_.bind(this, e, i, n));
      return;
    }
    if (this.saveTransferStats_(i.stats), !this.pendingSegment_ || i.requestId !== this.pendingSegment_.requestId)
      return;
    if (e) {
      if (this.pendingSegment_ = null, this.state = "READY", e.code === ws.ABORTED)
        return;
      if (this.pause(), e.code === ws.TIMEOUT) {
        this.handleTimeout_();
        return;
      }
      this.mediaRequestsErrored += 1, this.error(e), this.trigger("error");
      return;
    }
    const s = this.pendingSegment_;
    this.saveBandwidthRelatedStats_(s.duration, i.stats), s.endOfAllRequests = i.endOfAllRequests, n.gopInfo && (this.gopBuffer_ = GU(this.gopBuffer_, n.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(s);
  }
  setTimeMapping_(e) {
    const i = this.syncController_.mappingForTimeline(e);
    i !== null && (this.timeMapping_ = i);
  }
  updateMediaSecondsLoaded_(e) {
    typeof e.start == "number" && typeof e.end == "number" ? this.mediaSecondsLoaded += e.end - e.start : this.mediaSecondsLoaded += e.duration;
  }
  shouldUpdateTransmuxerTimestampOffset_(e) {
    return e === null ? !1 : this.loaderType_ === "main" && e !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && e !== this.sourceUpdater_.audioTimestampOffset();
  }
  trueSegmentStart_({
    currentStart: e,
    playlist: i,
    mediaIndex: n,
    firstVideoFrameTimeForData: s,
    currentVideoTimestampOffset: r,
    useVideoTimingInfo: a,
    videoTimingInfo: o,
    audioTimingInfo: l
  }) {
    if (typeof e < "u")
      return e;
    if (!a)
      return l.start;
    const u = i.segments[n - 1];
    return n === 0 || !u || typeof u.start > "u" || u.end !== s + r ? s : o.start;
  }
  waitForAppendsToComplete_(e) {
    const i = this.getCurrentMediaInfo_(e);
    if (!i) {
      this.error({
        message: "No starting media returned, likely due to an unsupported media format.",
        playlistExclusionDuration: 1 / 0
      }), this.trigger("error");
      return;
    }
    const {
      hasAudio: n,
      hasVideo: s,
      isMuxed: r
    } = i, a = this.loaderType_ === "main" && s, o = !this.audioDisabled_ && n && !r;
    if (e.waitingOnAppends = 0, !e.hasAppendedData_) {
      !e.timingInfo && typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !0), e.timingInfo = {
        start: 0
      }, e.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(e), this.processMetadataQueue_()), this.checkAppendsDone_(e);
      return;
    }
    a && e.waitingOnAppends++, o && e.waitingOnAppends++, a && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, e)), o && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, e));
  }
  checkAppendsDone_(e) {
    this.checkForAbort_(e.requestId) || (e.waitingOnAppends--, e.waitingOnAppends === 0 && this.handleAppendsDone_());
  }
  checkForIllegalMediaSwitch(e) {
    const i = $U(this.loaderType_, this.getCurrentMediaInfo_(), e);
    return i ? (this.error({
      message: i,
      playlistExclusionDuration: 1 / 0
    }), this.trigger("error"), !0) : !1;
  }
  updateSourceBufferTimestampOffset_(e) {
    if (e.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
    // priority, timing-wise, so we must wait
    typeof e.timingInfo.start != "number" || // already updated the timestamp offset for this segment
    e.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
    this.loaderType_ !== "main")
      return;
    let i = !1;
    e.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
      videoTimingInfo: e.segment.videoTimingInfo,
      audioTimingInfo: e.segment.audioTimingInfo,
      timingInfo: e.timingInfo
    }), e.changedTimestampOffset = !0, e.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(e.timestampOffset), i = !0), e.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(e.timestampOffset), i = !0), i && this.trigger("timestampoffset");
  }
  getSegmentStartTimeForTimestampOffsetCalculation_({
    videoTimingInfo: e,
    audioTimingInfo: i,
    timingInfo: n
  }) {
    return this.useDtsForTimestampOffset_ ? e && typeof e.transmuxedDecodeStart == "number" ? e.transmuxedDecodeStart : i && typeof i.transmuxedDecodeStart == "number" ? i.transmuxedDecodeStart : n.start : n.start;
  }
  updateTimingInfoEnd_(e) {
    e.timingInfo = e.timingInfo || {};
    const i = this.getMediaInfo_(), s = this.loaderType_ === "main" && i && i.hasVideo && e.videoTimingInfo ? e.videoTimingInfo : e.audioTimingInfo;
    s && (e.timingInfo.end = typeof s.end == "number" ? (
      // End time may not exist in a case where we aren't parsing the full segment (one
      // current example is the case of fmp4), so use the rough duration to calculate an
      // end time.
      s.end
    ) : s.start + e.duration);
  }
  /**
   * callback to run when appendBuffer is finished. detects if we are
   * in a good state to do things with the data we got, or if we need
   * to wait for more
   *
   * @private
   */
  handleAppendsDone_() {
    if (this.pendingSegment_) {
      const l = {
        segmentInfo: zr({
          type: this.loaderType_,
          segment: this.pendingSegment_
        })
      };
      this.trigger({
        type: "appendsdone",
        metadata: l
      });
    }
    if (!this.pendingSegment_) {
      this.state = "READY", this.paused() || this.monitorBuffer_();
      return;
    }
    const e = this.pendingSegment_;
    e.part && e.part.syncInfo ? e.part.syncInfo.markAppended() : e.segment.syncInfo && e.segment.syncInfo.markAppended(), this.updateTimingInfoEnd_(e), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
      segmentInfo: e,
      shouldSaveTimelineMapping: this.loaderType_ === "main"
    });
    const i = rV(e, this.sourceType_);
    if (i && (i.severity === "warn" ? Ae.log.warn(i.message) : this.logger_(i.message)), this.recordThroughput_(e), this.pendingSegment_ = null, this.state = "READY", e.isSyncRequest && (this.trigger("syncinfoupdate"), !e.hasAppendedData_)) {
      this.logger_(`Throwing away un-appended sync request ${va(e)}`);
      return;
    }
    this.logger_(`Appended ${va(e)}`), this.addSegmentMetadataCue_(e), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== e.timeline && (this.timelineChangeController_.lastTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: e.timeline
    }), this.loaderType_ === "main" && !this.audioDisabled_ && this.timelineChangeController_.lastTimelineChange({
      type: "audio",
      from: this.currentTimeline_,
      to: e.timeline
    })), this.currentTimeline_ = e.timeline, this.trigger("syncinfoupdate");
    const n = e.segment, s = e.part, r = n.end && this.currentTime_() - n.end > e.playlist.targetDuration * 3, a = s && s.end && this.currentTime_() - s.end > e.playlist.partTargetDuration * 3;
    if (r || a) {
      this.logger_(`bad ${r ? "segment" : "part"} ${va(e)}`), this.resetEverything();
      return;
    }
    this.mediaIndex !== null && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = e.mediaIndex, this.partIndex = e.partIndex, this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex) && this.endOfStream(), this.trigger("appended"), e.hasAppendedData_ && this.mediaAppends++, this.paused() || this.monitorBuffer_();
  }
  /**
   * Records the current throughput of the decrypt, transmux, and append
   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
   * moving average of the throughput. `throughput.count` is the number of
   * data points in the average.
   *
   * @private
   * @param {Object} segmentInfo the object returned by loadSegment
   */
  recordThroughput_(e) {
    if (e.duration < Bu) {
      this.logger_(`Ignoring segment's throughput because its duration of ${e.duration} is less than the min to record ${Bu}`);
      return;
    }
    const i = this.throughput.rate, n = Date.now() - e.endOfAllRequests + 1, s = Math.floor(e.byteLength / n * 8 * 1e3);
    this.throughput.rate += (s - i) / ++this.throughput.count;
  }
  /**
   * Adds a cue to the segment-metadata track with some metadata information about the
   * segment
   *
   * @private
   * @param {Object} segmentInfo
   *        the object returned by loadSegment
   * @method addSegmentMetadataCue_
   */
  addSegmentMetadataCue_(e) {
    if (!this.segmentMetadataTrack_)
      return;
    const i = e.segment, n = i.start, s = i.end;
    if (!Hv(n) || !Hv(s))
      return;
    rl(n, s, this.segmentMetadataTrack_);
    const r = ne.WebKitDataCue || ne.VTTCue, a = {
      custom: i.custom,
      dateTimeObject: i.dateTimeObject,
      dateTimeString: i.dateTimeString,
      programDateTime: i.programDateTime,
      bandwidth: e.playlist.attributes.BANDWIDTH,
      resolution: e.playlist.attributes.RESOLUTION,
      codecs: e.playlist.attributes.CODECS,
      byteLength: e.byteLength,
      uri: e.uri,
      timeline: e.timeline,
      playlist: e.playlist.id,
      start: n,
      end: s
    }, o = JSON.stringify(a), l = new r(n, s, o);
    l.value = a, this.segmentMetadataTrack_.addCue(l);
  }
}
function Rs() {
}
const T1 = function(t) {
  return typeof t != "string" ? t : t.replace(/./, (e) => e.toUpperCase());
}, aV = ["video", "audio"], Yh = (t, e) => {
  const i = e[`${t}Buffer`];
  return i && i.updating || e.queuePending[t];
}, oV = (t, e) => {
  for (let i = 0; i < e.length; i++) {
    const n = e[i];
    if (n.type === "mediaSource")
      return null;
    if (n.type === t)
      return i;
  }
  return null;
}, qa = (t, e) => {
  if (e.queue.length === 0)
    return;
  let i = 0, n = e.queue[i];
  if (n.type === "mediaSource") {
    !e.updating() && e.mediaSource.readyState !== "closed" && (e.queue.shift(), n.action(e), n.doneFn && n.doneFn(), qa("audio", e), qa("video", e));
    return;
  }
  if (t !== "mediaSource" && !(!e.ready() || e.mediaSource.readyState === "closed" || Yh(t, e))) {
    if (n.type !== t) {
      if (i = oV(t, e.queue), i === null)
        return;
      n = e.queue[i];
    }
    if (e.queue.splice(i, 1), e.queuePending[t] = n, n.action(t, e), !n.doneFn) {
      e.queuePending[t] = null, qa(t, e);
      return;
    }
  }
}, x1 = (t, e) => {
  const i = e[`${t}Buffer`], n = T1(t);
  i && (i.removeEventListener("updateend", e[`on${n}UpdateEnd_`]), i.removeEventListener("error", e[`on${n}Error_`]), e.codecs[t] = null, e[`${t}Buffer`] = null);
}, fs = (t, e) => t && e && Array.prototype.indexOf.call(t.sourceBuffers, e) !== -1, fn = {
  appendBuffer: (t, e, i) => (n, s) => {
    const r = s[`${n}Buffer`];
    if (fs(s.mediaSource, r)) {
      s.logger_(`Appending segment ${e.mediaIndex}'s ${t.length} bytes to ${n}Buffer`);
      try {
        r.appendBuffer(t);
      } catch (a) {
        s.logger_(`Error with code ${a.code} ` + (a.code === Zw ? "(QUOTA_EXCEEDED_ERR) " : "") + `when appending segment ${e.mediaIndex} to ${n}Buffer`), s.queuePending[n] = null, i(a);
      }
    }
  },
  remove: (t, e) => (i, n) => {
    const s = n[`${i}Buffer`];
    if (fs(n.mediaSource, s)) {
      n.logger_(`Removing ${t} to ${e} from ${i}Buffer`);
      try {
        s.remove(t, e);
      } catch {
        n.logger_(`Remove ${t} to ${e} from ${i}Buffer failed`);
      }
    }
  },
  timestampOffset: (t) => (e, i) => {
    const n = i[`${e}Buffer`];
    fs(i.mediaSource, n) && (i.logger_(`Setting ${e}timestampOffset to ${t}`), n.timestampOffset = t);
  },
  callback: (t) => (e, i) => {
    t();
  },
  endOfStream: (t) => (e) => {
    if (e.mediaSource.readyState === "open") {
      e.logger_(`Calling mediaSource endOfStream(${t || ""})`);
      try {
        e.mediaSource.endOfStream(t);
      } catch (i) {
        Ae.log.warn("Failed to call media source endOfStream", i);
      }
    }
  },
  duration: (t) => (e) => {
    e.logger_(`Setting mediaSource duration to ${t}`);
    try {
      e.mediaSource.duration = t;
    } catch (i) {
      Ae.log.warn("Failed to set media source duration", i);
    }
  },
  abort: () => (t, e) => {
    if (e.mediaSource.readyState !== "open")
      return;
    const i = e[`${t}Buffer`];
    if (fs(e.mediaSource, i)) {
      e.logger_(`calling abort on ${t}Buffer`);
      try {
        i.abort();
      } catch (n) {
        Ae.log.warn(`Failed to abort on ${t}Buffer`, n);
      }
    }
  },
  addSourceBuffer: (t, e) => (i) => {
    const n = T1(t), s = no(e);
    i.logger_(`Adding ${t}Buffer with codec ${e} to mediaSource`);
    const r = i.mediaSource.addSourceBuffer(s);
    r.addEventListener("updateend", i[`on${n}UpdateEnd_`]), r.addEventListener("error", i[`on${n}Error_`]), i.codecs[t] = e, i[`${t}Buffer`] = r;
  },
  removeSourceBuffer: (t) => (e) => {
    const i = e[`${t}Buffer`];
    if (x1(t, e), !!fs(e.mediaSource, i)) {
      e.logger_(`Removing ${t}Buffer with codec ${e.codecs[t]} from mediaSource`);
      try {
        e.mediaSource.removeSourceBuffer(i);
      } catch (n) {
        Ae.log.warn(`Failed to removeSourceBuffer ${t}Buffer`, n);
      }
    }
  },
  changeType: (t) => (e, i) => {
    const n = i[`${e}Buffer`], s = no(t);
    if (!fs(i.mediaSource, n))
      return;
    const r = t.substring(0, t.indexOf(".")), a = i.codecs[e];
    if (a.substring(0, a.indexOf(".")) === r)
      return;
    const l = {
      codecsChangeInfo: {
        from: a,
        to: t
      }
    };
    i.trigger({
      type: "codecschange",
      metadata: l
    }), i.logger_(`changing ${e}Buffer codec from ${a} to ${t}`);
    try {
      n.changeType(s), i.codecs[e] = t;
    } catch (u) {
      l.errorType = Ae.Error.StreamingCodecsChangeError, l.error = u, u.metadata = l, i.error_ = u, i.trigger("error"), Ae.log.warn(`Failed to changeType on ${e}Buffer`, u);
    }
  }
}, hn = ({
  type: t,
  sourceUpdater: e,
  action: i,
  doneFn: n,
  name: s
}) => {
  e.queue.push({
    type: t,
    action: i,
    doneFn: n,
    name: s
  }), qa(t, e);
}, Xv = (t, e) => (i) => {
  const n = e[`${t}Buffered`](), s = bz(n);
  if (e.logger_(`received "updateend" event for ${t} Source Buffer: `, s), e.queuePending[t]) {
    const r = e.queuePending[t].doneFn;
    e.queuePending[t] = null, r && r(e[`${t}Error_`]);
  }
  qa(t, e);
};
class S1 extends Ae.EventTarget {
  constructor(e) {
    super(), this.mediaSource = e, this.sourceopenListener_ = () => qa("mediaSource", this), this.mediaSource.addEventListener("sourceopen", this.sourceopenListener_), this.logger_ = Fn("SourceUpdater"), this.audioTimestampOffset_ = 0, this.videoTimestampOffset_ = 0, this.queue = [], this.queuePending = {
      audio: null,
      video: null
    }, this.delayedAudioAppendQueue_ = [], this.videoAppendQueued_ = !1, this.codecs = {}, this.onVideoUpdateEnd_ = Xv("video", this), this.onAudioUpdateEnd_ = Xv("audio", this), this.onVideoError_ = (i) => {
      this.videoError_ = i;
    }, this.onAudioError_ = (i) => {
      this.audioError_ = i;
    }, this.createdSourceBuffers_ = !1, this.initializedEme_ = !1, this.triggeredReady_ = !1;
  }
  initializedEme() {
    this.initializedEme_ = !0, this.triggerReady();
  }
  hasCreatedSourceBuffers() {
    return this.createdSourceBuffers_;
  }
  hasInitializedAnyEme() {
    return this.initializedEme_;
  }
  ready() {
    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
  }
  createSourceBuffers(e) {
    this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(e), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady());
  }
  triggerReady() {
    this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"));
  }
  /**
   * Add a type of source buffer to the media source.
   *
   * @param {string} type
   *        The type of source buffer to add.
   *
   * @param {string} codec
   *        The codec to add the source buffer with.
   */
  addSourceBuffer(e, i) {
    hn({
      type: "mediaSource",
      sourceUpdater: this,
      action: fn.addSourceBuffer(e, i),
      name: "addSourceBuffer"
    });
  }
  /**
   * call abort on a source buffer.
   *
   * @param {string} type
   *        The type of source buffer to call abort on.
   */
  abort(e) {
    hn({
      type: e,
      sourceUpdater: this,
      action: fn.abort(e),
      name: "abort"
    });
  }
  /**
   * Call removeSourceBuffer and remove a specific type
   * of source buffer on the mediaSource.
   *
   * @param {string} type
   *        The type of source buffer to remove.
   */
  removeSourceBuffer(e) {
    if (!this.canRemoveSourceBuffer()) {
      Ae.log.error("removeSourceBuffer is not supported!");
      return;
    }
    hn({
      type: "mediaSource",
      sourceUpdater: this,
      action: fn.removeSourceBuffer(e),
      name: "removeSourceBuffer"
    });
  }
  /**
   * Whether or not the removeSourceBuffer function is supported
   * on the mediaSource.
   *
   * @return {boolean}
   *          if removeSourceBuffer can be called.
   */
  canRemoveSourceBuffer() {
    return !Ae.browser.IS_FIREFOX && ne.MediaSource && ne.MediaSource.prototype && typeof ne.MediaSource.prototype.removeSourceBuffer == "function";
  }
  /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */
  static canChangeType() {
    return ne.SourceBuffer && ne.SourceBuffer.prototype && typeof ne.SourceBuffer.prototype.changeType == "function";
  }
  /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */
  canChangeType() {
    return this.constructor.canChangeType();
  }
  /**
   * Call the changeType function on a source buffer, given the code and type.
   *
   * @param {string} type
   *        The type of source buffer to call changeType on.
   *
   * @param {string} codec
   *        The codec string to change type with on the source buffer.
   */
  changeType(e, i) {
    if (!this.canChangeType()) {
      Ae.log.error("changeType is not supported!");
      return;
    }
    hn({
      type: e,
      sourceUpdater: this,
      action: fn.changeType(i),
      name: "changeType"
    });
  }
  /**
   * Add source buffers with a codec or, if they are already created,
   * call changeType on source buffers using changeType.
   *
   * @param {Object} codecs
   *        Codecs to switch to
   */
  addOrChangeSourceBuffers(e) {
    if (!e || typeof e != "object" || Object.keys(e).length === 0)
      throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
    Object.keys(e).forEach((i) => {
      const n = e[i];
      if (!this.hasCreatedSourceBuffers())
        return this.addSourceBuffer(i, n);
      this.canChangeType() && this.changeType(i, n);
    });
  }
  /**
   * Queue an update to append an ArrayBuffer.
   *
   * @param {MediaObject} object containing audioBytes and/or videoBytes
   * @param {Function} done the function to call when done
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
   */
  appendBuffer(e, i) {
    const {
      segmentInfo: n,
      type: s,
      bytes: r
    } = e;
    if (this.processedAppend_ = !0, s === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
      this.delayedAudioAppendQueue_.push([e, i]), this.logger_(`delayed audio append of ${r.length} until video append`);
      return;
    }
    const a = i;
    if (hn({
      type: s,
      sourceUpdater: this,
      action: fn.appendBuffer(r, n || {
        mediaIndex: -1
      }, a),
      doneFn: i,
      name: "appendBuffer"
    }), s === "video") {
      if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length)
        return;
      const o = this.delayedAudioAppendQueue_.slice();
      this.logger_(`queuing delayed audio ${o.length} appendBuffers`), this.delayedAudioAppendQueue_.length = 0, o.forEach((l) => {
        this.appendBuffer.apply(this, l);
      });
    }
  }
  /**
   * Get the audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The audio buffer's buffered time range
   */
  audioBuffered() {
    return fs(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : ki();
  }
  /**
   * Get the video buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The video buffer's buffered time range
   */
  videoBuffered() {
    return fs(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : ki();
  }
  /**
   * Get a combined video/audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         the combined time range
   */
  buffered() {
    const e = fs(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null, i = fs(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
    return i && !e ? this.audioBuffered() : e && !i ? this.videoBuffered() : Tz(this.audioBuffered(), this.videoBuffered());
  }
  /**
   * Add a callback to the queue that will set duration on the mediaSource.
   *
   * @param {number} duration
   *        The duration to set
   *
   * @param {Function} [doneFn]
   *        function to run after duration has been set.
   */
  setDuration(e, i = Rs) {
    hn({
      type: "mediaSource",
      sourceUpdater: this,
      action: fn.duration(e),
      name: "duration",
      doneFn: i
    });
  }
  /**
   * Add a mediaSource endOfStream call to the queue
   *
   * @param {Error} [error]
   *        Call endOfStream with an error
   *
   * @param {Function} [doneFn]
   *        A function that should be called when the
   *        endOfStream call has finished.
   */
  endOfStream(e = null, i = Rs) {
    typeof e != "string" && (e = void 0), hn({
      type: "mediaSource",
      sourceUpdater: this,
      action: fn.endOfStream(e),
      name: "endOfStream",
      doneFn: i
    });
  }
  /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */
  removeAudio(e, i, n = Rs) {
    if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
      n();
      return;
    }
    hn({
      type: "audio",
      sourceUpdater: this,
      action: fn.remove(e, i),
      doneFn: n,
      name: "remove"
    });
  }
  /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */
  removeVideo(e, i, n = Rs) {
    if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
      n();
      return;
    }
    hn({
      type: "video",
      sourceUpdater: this,
      action: fn.remove(e, i),
      doneFn: n,
      name: "remove"
    });
  }
  /**
   * Whether the underlying sourceBuffer is updating or not
   *
   * @return {boolean} the updating status of the SourceBuffer
   */
  updating() {
    return !!(Yh("audio", this) || Yh("video", this));
  }
  /**
   * Set/get the timestampoffset on the audio SourceBuffer
   *
   * @return {number} the timestamp offset
   */
  audioTimestampOffset(e) {
    return typeof e < "u" && this.audioBuffer && // no point in updating if it's the same
    this.audioTimestampOffset_ !== e && (hn({
      type: "audio",
      sourceUpdater: this,
      action: fn.timestampOffset(e),
      name: "timestampOffset"
    }), this.audioTimestampOffset_ = e), this.audioTimestampOffset_;
  }
  /**
   * Set/get the timestampoffset on the video SourceBuffer
   *
   * @return {number} the timestamp offset
   */
  videoTimestampOffset(e) {
    return typeof e < "u" && this.videoBuffer && // no point in updating if it's the same
    this.videoTimestampOffset_ !== e && (hn({
      type: "video",
      sourceUpdater: this,
      action: fn.timestampOffset(e),
      name: "timestampOffset"
    }), this.videoTimestampOffset_ = e), this.videoTimestampOffset_;
  }
  /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the audio queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */
  audioQueueCallback(e) {
    this.audioBuffer && hn({
      type: "audio",
      sourceUpdater: this,
      action: fn.callback(e),
      name: "callback"
    });
  }
  /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the video queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */
  videoQueueCallback(e) {
    this.videoBuffer && hn({
      type: "video",
      sourceUpdater: this,
      action: fn.callback(e),
      name: "callback"
    });
  }
  /**
   * dispose of the source updater and the underlying sourceBuffer
   */
  dispose() {
    this.trigger("dispose"), aV.forEach((e) => {
      this.abort(e), this.canRemoveSourceBuffer() ? this.removeSourceBuffer(e) : this[`${e}QueueCallback`](() => x1(e, this));
    }), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off();
  }
}
const jv = (t) => decodeURIComponent(escape(String.fromCharCode.apply(null, t))), lV = (t) => {
  const e = new Uint8Array(t);
  return Array.from(e).map((i) => i.toString(16).padStart(2, "0")).join("");
}, Gv = new Uint8Array(`

`.split("").map((t) => t.charCodeAt(0)));
class uV extends Error {
  constructor() {
    super("Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.");
  }
}
class dV extends Wh {
  constructor(e, i = {}) {
    super(e, i), this.mediaSource_ = null, this.subtitlesTrack_ = null, this.featuresNativeTextTracks_ = e.featuresNativeTextTracks, this.loadVttJs = e.loadVttJs, this.shouldSaveSegmentTimingInfo_ = !1;
  }
  /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */
  buffered_() {
    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length)
      return ki();
    const e = this.subtitlesTrack_.cues, i = e[0].startTime, n = e[e.length - 1].startTime;
    return ki([[i, n]]);
  }
  /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */
  initSegmentForMap(e, i = !1) {
    if (!e)
      return null;
    const n = _d(e);
    let s = this.initSegments_[n];
    if (i && !s && e.bytes) {
      const r = Gv.byteLength + e.bytes.byteLength, a = new Uint8Array(r);
      a.set(e.bytes), a.set(Gv, e.bytes.byteLength), this.initSegments_[n] = s = {
        resolvedUri: e.resolvedUri,
        byterange: e.byterange,
        bytes: a
      };
    }
    return s || e;
  }
  /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */
  couldBeginLoading_() {
    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
  }
  /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */
  init_() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }
  /**
   * Set a subtitle track on the segment loader to add subtitles to
   *
   * @param {TextTrack=} track
   *        The text track to add loaded subtitles to
   * @return {TextTrack}
   *        Returns the subtitles track
   */
  track(e) {
    return typeof e > "u" ? this.subtitlesTrack_ : (this.subtitlesTrack_ = e, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
  }
  /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   */
  remove(e, i) {
    rl(e, i, this.subtitlesTrack_);
  }
  /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */
  fillBuffer_() {
    const e = this.chooseNextRequest_();
    if (e) {
      if (this.syncController_.timestampOffsetForTimeline(e.timeline) === null) {
        const i = () => {
          this.state = "READY", this.paused() || this.monitorBuffer_();
        };
        this.syncController_.one("timestampoffset", i), this.state = "WAITING_ON_TIMELINE";
        return;
      }
      this.loadSegment_(e);
    }
  }
  // never set a timestamp offset for vtt segments.
  timestampOffsetForSegment_() {
    return null;
  }
  chooseNextRequest_() {
    return this.skipEmptySegments_(super.chooseNextRequest_());
  }
  /**
   * Prevents the segment loader from requesting segments we know contain no subtitles
   * by walking forward until we find the next segment that we don't know whether it is
   * empty or not.
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @return {Object}
   *         a segment info object that describes the current segment
   */
  skipEmptySegments_(e) {
    for (; e && e.segment.empty; ) {
      if (e.mediaIndex + 1 >= e.playlist.segments.length) {
        e = null;
        break;
      }
      e = this.generateSegmentInfo_({
        playlist: e.playlist,
        mediaIndex: e.mediaIndex + 1,
        startOfSegment: e.startOfSegment + e.duration,
        isSyncRequest: e.isSyncRequest
      });
    }
    return e;
  }
  stopForError(e) {
    this.error(e), this.state = "READY", this.pause(), this.trigger("error");
  }
  /**
   * append a decrypted segement to the SourceBuffer through a SourceUpdater
   *
   * @private
   */
  segmentRequestFinished_(e, i, n) {
    if (!this.subtitlesTrack_) {
      this.state = "READY";
      return;
    }
    if (this.saveTransferStats_(i.stats), !this.pendingSegment_) {
      this.state = "READY", this.mediaRequestsAborted += 1;
      return;
    }
    if (e) {
      e.code === ws.TIMEOUT && this.handleTimeout_(), e.code === ws.ABORTED ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, this.stopForError(e);
      return;
    }
    const s = this.pendingSegment_, r = n.mp4VttCues && n.mp4VttCues.length;
    r && (s.mp4VttCues = n.mp4VttCues), this.saveBandwidthRelatedStats_(s.duration, i.stats), i.key && this.segmentKey(i.key, !0), this.state = "APPENDING", this.trigger("appending");
    const a = s.segment;
    if (a.map && (a.map.bytes = i.map.bytes), s.bytes = i.bytes, typeof ne.WebVTT != "function" && typeof this.loadVttJs == "function") {
      this.state = "WAITING_ON_VTTJS", this.loadVttJs().then(() => this.segmentRequestFinished_(e, i, n), () => this.stopForError({
        message: "Error loading vtt.js"
      }));
      return;
    }
    a.requested = !0;
    try {
      this.parseVTTCues_(s);
    } catch (o) {
      this.stopForError({
        message: o.message,
        metadata: {
          errorType: Ae.Error.StreamingVttParserError,
          error: o
        }
      });
      return;
    }
    if (r || this.updateTimeMapping_(s, this.syncController_.timelines[s.timeline], this.playlist_), s.cues.length ? s.timingInfo = {
      start: s.cues[0].startTime,
      end: s.cues[s.cues.length - 1].endTime
    } : s.timingInfo = {
      start: s.startOfSegment,
      end: s.startOfSegment + s.duration
    }, s.isSyncRequest) {
      this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
      return;
    }
    s.byteLength = s.bytes.byteLength, this.mediaSecondsLoaded += a.duration, s.cues.forEach((o) => {
      this.subtitlesTrack_.addCue(this.featuresNativeTextTracks_ ? new ne.VTTCue(o.startTime, o.endTime, o.text) : o);
    }), XU(this.subtitlesTrack_), this.handleAppendsDone_();
  }
  handleData_(e, i) {
    const n = e && e.type === "vtt", s = i && i.type === "text";
    n && s && super.handleData_(e, i);
  }
  updateTimingInfoEnd_() {
  }
  /**
   * Utility function for converting mp4 webvtt cue objects into VTTCues.
   *
   * @param {Object} segmentInfo with mp4 webvtt cues for parsing into VTTCue objecs
   */
  parseMp4VttCues_(e) {
    const i = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
    e.mp4VttCues.forEach((n) => {
      const s = n.start + i, r = n.end + i, a = new ne.VTTCue(s, r, n.cueText);
      n.settings && n.settings.split(" ").forEach((o) => {
        const l = o.split(":"), u = l[0], d = l[1];
        a[u] = isNaN(d) ? d : Number(d);
      }), e.cues.push(a);
    });
  }
  /**
   * Uses the WebVTT parser to parse the segment response
   *
   * @throws NoVttJsError
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @private
   */
  parseVTTCues_(e) {
    let i, n = !1;
    if (typeof ne.WebVTT != "function")
      throw new uV();
    if (e.cues = [], e.timestampmap = {
      MPEGTS: 0,
      LOCAL: 0
    }, e.mp4VttCues) {
      this.parseMp4VttCues_(e);
      return;
    }
    typeof ne.TextDecoder == "function" ? i = new ne.TextDecoder("utf8") : (i = ne.WebVTT.StringDecoder(), n = !0);
    const s = new ne.WebVTT.Parser(ne, ne.vttjs, i);
    if (s.oncue = e.cues.push.bind(e.cues), s.ontimestampmap = (a) => {
      e.timestampmap = a;
    }, s.onparsingerror = (a) => {
      Ae.log.warn("Error encountered when parsing cues: " + a.message);
    }, e.segment.map) {
      let a = e.segment.map.bytes;
      n && (a = jv(a)), s.parse(a);
    }
    let r = e.bytes;
    n && (r = jv(r)), s.parse(r), s.flush();
  }
  /**
   * Updates the start and end times of any cues parsed by the WebVTT parser using
   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
   * from the SyncController
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @param {Object} mappingObj
   *        object containing a mapping from TS to media time
   * @param {Object} playlist
   *        the playlist object containing the segment
   * @private
   */
  updateTimeMapping_(e, i, n) {
    const s = e.segment;
    if (!i)
      return;
    if (!e.cues.length) {
      s.empty = !0;
      return;
    }
    const {
      MPEGTS: r,
      LOCAL: a
    } = e.timestampmap, l = r / Vr.ONE_SECOND_IN_TS - a + i.mapping;
    if (e.cues.forEach((u) => {
      const d = u.endTime - u.startTime, c = this.handleRollover_(u.startTime + l, i.time);
      u.startTime = Math.max(c, 0), u.endTime = Math.max(c + d, 0);
    }), !n.syncInfo) {
      const u = e.cues[0].startTime, d = e.cues[e.cues.length - 1].startTime;
      n.syncInfo = {
        mediaSequence: n.mediaSequence + e.mediaIndex,
        time: Math.min(u, d - s.duration)
      };
    }
  }
  /**
   * MPEG-TS PES timestamps are limited to 2^33.
   * Once they reach 2^33, they roll over to 0.
   * mux.js handles PES timestamp rollover for the following scenarios:
   * [forward rollover(right)] ->
   *    PES timestamps monotonically increase, and once they reach 2^33, they roll over to 0
   * [backward rollover(left)] -->
   *    we seek back to position before rollover.
   *
   * According to the HLS SPEC:
   * When synchronizing WebVTT with PES timestamps, clients SHOULD account
   * for cases where the 33-bit PES timestamps have wrapped and the WebVTT
   * cue times have not.  When the PES timestamp wraps, the WebVTT Segment
   * SHOULD have a X-TIMESTAMP-MAP header that maps the current WebVTT
   * time to the new (low valued) PES timestamp.
   *
   * So we want to handle rollover here and align VTT Cue start/end time to the player's time.
   */
  handleRollover_(e, i) {
    if (i === null)
      return e;
    let n = e * Vr.ONE_SECOND_IN_TS;
    const s = i * Vr.ONE_SECOND_IN_TS;
    let r;
    for (s < n ? r = -8589934592 : r = 8589934592; Math.abs(n - s) > 4294967296; )
      n += r;
    return n / Vr.ONE_SECOND_IN_TS;
  }
}
const cV = function(t, e) {
  const i = t.cues;
  for (let n = 0; n < i.length; n++) {
    const s = i[n];
    if (e >= s.adStartTime && e <= s.adEndTime)
      return s;
  }
  return null;
}, fV = function(t, e, i = 0) {
  if (!t.segments)
    return;
  let n = i, s;
  for (let r = 0; r < t.segments.length; r++) {
    const a = t.segments[r];
    if (s || (s = cV(e, n + a.duration / 2)), s) {
      if ("cueIn" in a) {
        s.endTime = n, s.adEndTime = n, n += a.duration, s = null;
        continue;
      }
      if (n < s.endTime) {
        n += a.duration;
        continue;
      }
      s.endTime += a.duration;
    } else if ("cueOut" in a && (s = new ne.VTTCue(n, n + a.duration, a.cueOut), s.adStartTime = n, s.adEndTime = n + parseFloat(a.cueOut), e.addCue(s)), "cueOutCont" in a) {
      const [o, l] = a.cueOutCont.split("/").map(parseFloat);
      s = new ne.VTTCue(n, n + a.duration, ""), s.adStartTime = n - o, s.adEndTime = s.adStartTime + l, e.addCue(s);
    }
    n += a.duration;
  }
};
class Qv {
  /**
   * @param {number} start - media sequence start
   * @param {number} end - media sequence end
   * @param {number} segmentIndex - index for associated segment
   * @param {number|null} [partIndex] - index for associated part
   * @param {boolean} [appended] - appended indicator
   *
   */
  constructor({
    start: e,
    end: i,
    segmentIndex: n,
    partIndex: s = null,
    appended: r = !1
  }) {
    this.start_ = e, this.end_ = i, this.segmentIndex_ = n, this.partIndex_ = s, this.appended_ = r;
  }
  isInRange(e) {
    return e >= this.start && e < this.end;
  }
  markAppended() {
    this.appended_ = !0;
  }
  resetAppendedStatus() {
    this.appended_ = !1;
  }
  get isAppended() {
    return this.appended_;
  }
  get start() {
    return this.start_;
  }
  get end() {
    return this.end_;
  }
  get segmentIndex() {
    return this.segmentIndex_;
  }
  get partIndex() {
    return this.partIndex_;
  }
}
class hV {
  /**
   *
   * @param {SyncInfo} segmentSyncInfo - sync info for a given segment
   * @param {Array<SyncInfo>} [partsSyncInfo] - sync infos for a list of parts for a given segment
   */
  constructor(e, i = []) {
    this.segmentSyncInfo_ = e, this.partsSyncInfo_ = i;
  }
  get segmentSyncInfo() {
    return this.segmentSyncInfo_;
  }
  get partsSyncInfo() {
    return this.partsSyncInfo_;
  }
  get hasPartsSyncInfo() {
    return this.partsSyncInfo_.length > 0;
  }
  resetAppendStatus() {
    this.segmentSyncInfo_.resetAppendedStatus(), this.partsSyncInfo_.forEach((e) => e.resetAppendedStatus());
  }
}
class C1 {
  constructor() {
    this.storage_ = /* @__PURE__ */ new Map(), this.diagnostics_ = "", this.isReliable_ = !1, this.start_ = -1 / 0, this.end_ = 1 / 0;
  }
  get start() {
    return this.start_;
  }
  get end() {
    return this.end_;
  }
  get diagnostics() {
    return this.diagnostics_;
  }
  get isReliable() {
    return this.isReliable_;
  }
  resetAppendedStatus() {
    this.storage_.forEach((e) => e.resetAppendStatus());
  }
  /**
   * update sync storage
   *
   * @param {Object} playlist
   * @param {number} currentTime
   *
   * @return {void}
   */
  update(e, i) {
    const {
      mediaSequence: n,
      segments: s
    } = e;
    if (this.isReliable_ = this.isReliablePlaylist_(n, s), !!this.isReliable_)
      return this.updateStorage_(s, n, this.calculateBaseTime_(n, s, i));
  }
  /**
   * @param {number} targetTime
   * @return {SyncInfo|null}
   */
  getSyncInfoForTime(e) {
    for (const {
      segmentSyncInfo: i,
      partsSyncInfo: n
    } of this.storage_.values())
      if (n.length) {
        for (const s of n)
          if (s.isInRange(e))
            return s;
      } else if (i.isInRange(e))
        return i;
    return null;
  }
  getSyncInfoForMediaSequence(e) {
    return this.storage_.get(e);
  }
  updateStorage_(e, i, n) {
    const s = /* @__PURE__ */ new Map();
    let r = `
`, a = n, o = i;
    this.start_ = a, e.forEach((l, u) => {
      const d = this.storage_.get(o), c = a, A = c + l.duration, m = !!(d && d.segmentSyncInfo && d.segmentSyncInfo.isAppended), p = new Qv({
        start: c,
        end: A,
        appended: m,
        segmentIndex: u
      });
      l.syncInfo = p;
      let h = a;
      const g = (l.parts || []).map((w, b) => {
        const y = h, D = h + w.duration, I = !!(d && d.partsSyncInfo && d.partsSyncInfo[b] && d.partsSyncInfo[b].isAppended), M = new Qv({
          start: y,
          end: D,
          appended: I,
          segmentIndex: u,
          partIndex: b
        });
        return h = D, r += `Media Sequence: ${o}.${b} | Range: ${y} --> ${D} | Appended: ${I}
`, w.syncInfo = M, M;
      });
      s.set(o, new hV(p, g)), r += `${w1(l.resolvedUri)} | Media Sequence: ${o} | Range: ${c} --> ${A} | Appended: ${m}
`, o++, a = A;
    }), this.end_ = a, this.storage_ = s, this.diagnostics_ = r;
  }
  calculateBaseTime_(e, i, n) {
    if (!this.storage_.size)
      return 0;
    if (this.storage_.has(e))
      return this.storage_.get(e).segmentSyncInfo.start;
    const s = Math.min(...this.storage_.keys());
    if (e < s) {
      const r = s - e;
      let a = this.storage_.get(s).segmentSyncInfo.start;
      for (let o = 0; o < r; o++) {
        const l = i[o];
        a -= l.duration;
      }
      return a;
    }
    return n;
  }
  isReliablePlaylist_(e, i) {
    return e != null && Array.isArray(i) && i.length;
  }
}
class Zv extends C1 {
  constructor(e) {
    super(), this.parent_ = e;
  }
  calculateBaseTime_(e, i, n) {
    if (!this.storage_.size) {
      const s = this.parent_.getSyncInfoForMediaSequence(e);
      return s ? s.segmentSyncInfo.start : 0;
    }
    return super.calculateBaseTime_(e, i, n);
  }
}
const pV = 86400, Jf = [
  // Stategy "VOD": Handle the VOD-case where the sync-point is *always*
  //                the equivalence display-time 0 === segment-index 0
  {
    name: "VOD",
    run: (t, e, i, n, s) => i !== 1 / 0 ? {
      time: 0,
      segmentIndex: 0,
      partIndex: null
    } : null
  },
  {
    name: "MediaSequence",
    /**
     * run media sequence strategy
     *
     * @param {SyncController} syncController
     * @param {Object} playlist
     * @param {number} duration
     * @param {number} currentTimeline
     * @param {number} currentTime
     * @param {string} type
     */
    run: (t, e, i, n, s, r) => {
      const a = t.getMediaSequenceSync(r);
      if (!a || !a.isReliable)
        return null;
      const o = a.getSyncInfoForTime(s);
      return o ? {
        time: o.start,
        partIndex: o.partIndex,
        segmentIndex: o.segmentIndex
      } : null;
    }
  },
  // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
  {
    name: "ProgramDateTime",
    run: (t, e, i, n, s) => {
      if (!Object.keys(t.timelineToDatetimeMappings).length)
        return null;
      let r = null, a = null;
      const o = Lh(e);
      s = s || 0;
      for (let l = 0; l < o.length; l++) {
        const u = e.endList || s === 0 ? l : o.length - (l + 1), d = o[u], c = d.segment, A = t.timelineToDatetimeMappings[c.timeline];
        if (!A || !c.dateTimeObject)
          continue;
        let p = c.dateTimeObject.getTime() / 1e3 + A;
        if (c.parts && typeof d.partIndex == "number")
          for (let g = 0; g < d.partIndex; g++)
            p += c.parts[g].duration;
        const h = Math.abs(s - p);
        if (a !== null && (h === 0 || a < h))
          break;
        a = h, r = {
          time: p,
          segmentIndex: d.segmentIndex,
          partIndex: d.partIndex
        };
      }
      return r;
    }
  },
  // Stategy "Segment": We have a known time mapping for a timeline and a
  //                    segment in the current timeline with timing data
  {
    name: "Segment",
    run: (t, e, i, n, s) => {
      let r = null, a = null;
      s = s || 0;
      const o = Lh(e);
      for (let l = 0; l < o.length; l++) {
        const u = e.endList || s === 0 ? l : o.length - (l + 1), d = o[u], c = d.segment, A = d.part && d.part.start || c && c.start;
        if (c.timeline === n && typeof A < "u") {
          const m = Math.abs(s - A);
          if (a !== null && a < m)
            break;
          (!r || a === null || a >= m) && (a = m, r = {
            time: A,
            segmentIndex: d.segmentIndex,
            partIndex: d.partIndex
          });
        }
      }
      return r;
    }
  },
  // Stategy "Discontinuity": We have a discontinuity with a known
  //                          display-time
  {
    name: "Discontinuity",
    run: (t, e, i, n, s) => {
      let r = null;
      if (s = s || 0, e.discontinuityStarts && e.discontinuityStarts.length) {
        let a = null;
        for (let o = 0; o < e.discontinuityStarts.length; o++) {
          const l = e.discontinuityStarts[o], u = e.discontinuitySequence + o + 1, d = t.discontinuities[u];
          if (d) {
            const c = Math.abs(s - d.time);
            if (a !== null && a < c)
              break;
            (!r || a === null || a >= c) && (a = c, r = {
              time: d.time,
              segmentIndex: l,
              partIndex: null
            });
          }
        }
      }
      return r;
    }
  },
  // Stategy "Playlist": We have a playlist with a known mapping of
  //                     segment index to display time
  {
    name: "Playlist",
    run: (t, e, i, n, s) => e.syncInfo ? {
      time: e.syncInfo.time,
      segmentIndex: e.syncInfo.mediaSequence - e.mediaSequence,
      partIndex: null
    } : null
  }
];
class mV extends Ae.EventTarget {
  constructor(e = {}) {
    super(), this.timelines = [], this.discontinuities = [], this.timelineToDatetimeMappings = {};
    const i = new C1(), n = new Zv(i), s = new Zv(i);
    this.mediaSequenceStorage_ = {
      main: i,
      audio: n,
      vtt: s
    }, this.logger_ = Fn("SyncController");
  }
  /**
   *
   * @param {string} loaderType
   * @return {MediaSequenceSync|null}
   */
  getMediaSequenceSync(e) {
    return this.mediaSequenceStorage_[e] || null;
  }
  /**
   * Find a sync-point for the playlist specified
   *
   * A sync-point is defined as a known mapping from display-time to
   * a segment-index in the current playlist.
   *
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinite if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Object}
   *          A sync-point object
   */
  getSyncPoint(e, i, n, s, r) {
    if (i !== 1 / 0)
      return Jf.find(({
        name: l
      }) => l === "VOD").run(this, e, i);
    const a = this.runStrategies_(e, i, n, s, r);
    if (!a.length)
      return null;
    for (const o of a) {
      const {
        syncPoint: l,
        strategy: u
      } = o, {
        segmentIndex: d,
        time: c
      } = l;
      if (d < 0)
        continue;
      const A = e.segments[d], m = c, p = m + A.duration;
      if (this.logger_(`Strategy: ${u}. Current time: ${s}. selected segment: ${d}. Time: [${m} -> ${p}]}`), s >= m && s < p)
        return this.logger_("Found sync point with exact match: ", l), l;
    }
    return this.selectSyncPoint_(a, {
      key: "time",
      value: s
    });
  }
  /**
   * Calculate the amount of time that has expired off the playlist during playback
   *
   * @param {Playlist} playlist
   *        Playlist object to calculate expired from
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playling a live source)
   * @return {number|null}
   *          The amount of time that has expired off the playlist during playback. Null
   *          if no sync-points for the playlist can be found.
   */
  getExpiredTime(e, i) {
    if (!e || !e.segments)
      return null;
    const n = this.runStrategies_(e, i, e.discontinuitySequence, 0);
    if (!n.length)
      return null;
    const s = this.selectSyncPoint_(n, {
      key: "segmentIndex",
      value: 0
    });
    return s.segmentIndex > 0 && (s.time *= -1), Math.abs(s.time + bl({
      defaultDuration: e.targetDuration,
      durationList: e.segments,
      startIndex: s.segmentIndex,
      endIndex: 0
    }));
  }
  /**
   * Runs each sync-point strategy and returns a list of sync-points returned by the
   * strategies
   *
   * @private
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Array}
   *          A list of sync-point objects
   */
  runStrategies_(e, i, n, s, r) {
    const a = [];
    for (let o = 0; o < Jf.length; o++) {
      const l = Jf[o], u = l.run(this, e, i, n, s, r);
      u && (u.strategy = l.name, a.push({
        strategy: l.name,
        syncPoint: u
      }));
    }
    return a;
  }
  /**
   * Selects the sync-point nearest the specified target
   *
   * @private
   * @param {Array} syncPoints
   *        List of sync-points to select from
   * @param {Object} target
   *        Object specifying the property and value we are targeting
   * @param {string} target.key
   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
   * @param {number} target.value
   *        The value to target for the specified key.
   * @return {Object}
   *          The sync-point nearest the target
   */
  selectSyncPoint_(e, i) {
    let n = e[0].syncPoint, s = Math.abs(e[0].syncPoint[i.key] - i.value), r = e[0].strategy;
    for (let a = 1; a < e.length; a++) {
      const o = Math.abs(e[a].syncPoint[i.key] - i.value);
      o < s && (s = o, n = e[a].syncPoint, r = e[a].strategy);
    }
    return this.logger_(`syncPoint for [${i.key}: ${i.value}] chosen with strategy [${r}]: [time:${n.time}, segmentIndex:${n.segmentIndex}` + (typeof n.partIndex == "number" ? `,partIndex:${n.partIndex}` : "") + "]"), n;
  }
  /**
   * Save any meta-data present on the segments when segments leave
   * the live window to the playlist to allow for synchronization at the
   * playlist level later.
   *
   * @param {Playlist} oldPlaylist - The previous active playlist
   * @param {Playlist} newPlaylist - The updated and most current playlist
   */
  saveExpiredSegmentInfo(e, i) {
    const n = i.mediaSequence - e.mediaSequence;
    if (n > pV) {
      Ae.log.warn(`Not saving expired segment info. Media sequence gap ${n} is too large.`);
      return;
    }
    for (let s = n - 1; s >= 0; s--) {
      const r = e.segments[s];
      if (r && typeof r.start < "u") {
        i.syncInfo = {
          mediaSequence: e.mediaSequence + s,
          time: r.start
        }, this.logger_(`playlist refresh sync: [time:${i.syncInfo.time}, mediaSequence: ${i.syncInfo.mediaSequence}]`), this.trigger("syncinfoupdate");
        break;
      }
    }
  }
  /**
   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
   * before segments start to load.
   *
   * @param {Playlist} playlist - The currently active playlist
   */
  setDateTimeMappingForStart(e) {
    if (this.timelineToDatetimeMappings = {}, e.segments && e.segments.length && e.segments[0].dateTimeObject) {
      const i = e.segments[0], n = i.dateTimeObject.getTime() / 1e3;
      this.timelineToDatetimeMappings[i.timeline] = -n;
    }
  }
  /**
   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
   * based on the latest timing information.
   *
   * @param {Object} options
   *        Options object
   * @param {SegmentInfo} options.segmentInfo
   *        The current active request information
   * @param {boolean} options.shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved for timeline mapping and program date time mappings.
   */
  saveSegmentTimingInfo({
    segmentInfo: e,
    shouldSaveTimelineMapping: i
  }) {
    const n = this.calculateSegmentTimeMapping_(e, e.timingInfo, i), s = e.segment;
    n && (this.saveDiscontinuitySyncInfo_(e), e.playlist.syncInfo || (e.playlist.syncInfo = {
      mediaSequence: e.playlist.mediaSequence + e.mediaIndex,
      time: s.start
    }));
    const r = s.dateTimeObject;
    s.discontinuity && i && r && (this.timelineToDatetimeMappings[s.timeline] = -(r.getTime() / 1e3));
  }
  timestampOffsetForTimeline(e) {
    return typeof this.timelines[e] > "u" ? null : this.timelines[e].time;
  }
  mappingForTimeline(e) {
    return typeof this.timelines[e] > "u" ? null : this.timelines[e].mapping;
  }
  /**
   * Use the "media time" for a segment to generate a mapping to "display time" and
   * save that display time to the segment.
   *
   * @private
   * @param {SegmentInfo} segmentInfo
   *        The current active request information
   * @param {Object} timingInfo
   *        The start and end time of the current segment in "media time"
   * @param {boolean} shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved in timelines.
   * @return {boolean}
   *          Returns false if segment time mapping could not be calculated
   */
  calculateSegmentTimeMapping_(e, i, n) {
    const s = e.segment, r = e.part;
    let a = this.timelines[e.timeline], o, l;
    if (typeof e.timestampOffset == "number")
      a = {
        time: e.startOfSegment,
        mapping: e.startOfSegment - i.start
      }, n && (this.timelines[e.timeline] = a, this.trigger("timestampoffset"), this.logger_(`time mapping for timeline ${e.timeline}: [time: ${a.time}] [mapping: ${a.mapping}]`)), o = e.startOfSegment, l = i.end + a.mapping;
    else if (a)
      o = i.start + a.mapping, l = i.end + a.mapping;
    else
      return !1;
    return r && (r.start = o, r.end = l), (!s.start || o < s.start) && (s.start = o), s.end = l, !0;
  }
  /**
   * Each time we have discontinuity in the playlist, attempt to calculate the location
   * in display of the start of the discontinuity and save that. We also save an accuracy
   * value so that we save values with the most accuracy (closest to 0.)
   *
   * @private
   * @param {SegmentInfo} segmentInfo - The current active request information
   */
  saveDiscontinuitySyncInfo_(e) {
    const i = e.playlist, n = e.segment;
    if (n.discontinuity)
      this.discontinuities[n.timeline] = {
        time: n.start,
        accuracy: 0
      };
    else if (i.discontinuityStarts && i.discontinuityStarts.length)
      for (let s = 0; s < i.discontinuityStarts.length; s++) {
        const r = i.discontinuityStarts[s], a = i.discontinuitySequence + s + 1, o = r - e.mediaIndex, l = Math.abs(o);
        if (!this.discontinuities[a] || this.discontinuities[a].accuracy > l) {
          let u;
          o < 0 ? u = n.start - bl({
            defaultDuration: i.targetDuration,
            durationList: i.segments,
            startIndex: e.mediaIndex,
            endIndex: r
          }) : u = n.end + bl({
            defaultDuration: i.targetDuration,
            durationList: i.segments,
            startIndex: e.mediaIndex + 1,
            endIndex: r
          }), this.discontinuities[a] = {
            time: u,
            accuracy: l
          };
        }
      }
  }
  dispose() {
    this.trigger("dispose"), this.off();
  }
}
class AV extends Ae.EventTarget {
  constructor() {
    super(), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {};
  }
  clearPendingTimelineChange(e) {
    this.pendingTimelineChanges_[e] = null, this.trigger("pendingtimelinechange");
  }
  pendingTimelineChange({
    type: e,
    from: i,
    to: n
  }) {
    return typeof i == "number" && typeof n == "number" && (this.pendingTimelineChanges_[e] = {
      type: e,
      from: i,
      to: n
    }, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[e];
  }
  lastTimelineChange({
    type: e,
    from: i,
    to: n
  }) {
    if (typeof i == "number" && typeof n == "number") {
      this.lastTimelineChanges_[e] = {
        type: e,
        from: i,
        to: n
      }, delete this.pendingTimelineChanges_[e];
      const s = {
        timelineChangeInfo: {
          from: i,
          to: n
        }
      };
      this.trigger({
        type: "timelinechange",
        metadata: s
      });
    }
    return this.lastTimelineChanges_[e];
  }
  dispose() {
    this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off();
  }
}
const gV = d1(c1(function() {
  var t = /* @__PURE__ */ function() {
    function h() {
      this.listeners = {};
    }
    var g = h.prototype;
    return g.on = function(b, y) {
      this.listeners[b] || (this.listeners[b] = []), this.listeners[b].push(y);
    }, g.off = function(b, y) {
      if (!this.listeners[b])
        return !1;
      var D = this.listeners[b].indexOf(y);
      return this.listeners[b] = this.listeners[b].slice(0), this.listeners[b].splice(D, 1), D > -1;
    }, g.trigger = function(b) {
      var y = this.listeners[b];
      if (y)
        if (arguments.length === 2)
          for (var D = y.length, I = 0; I < D; ++I)
            y[I].call(this, arguments[1]);
        else
          for (var M = Array.prototype.slice.call(arguments, 1), _ = y.length, N = 0; N < _; ++N)
            y[N].apply(this, M);
    }, g.dispose = function() {
      this.listeners = {};
    }, g.pipe = function(b) {
      this.on("data", function(y) {
        b.push(y);
      });
    }, h;
  }();
  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
  function e(h) {
    return h.subarray(0, h.byteLength - h[h.byteLength - 1]);
  }
  /*! @name aes-decrypter @version 4.0.2 @license Apache-2.0 */
  const i = function() {
    const h = [[[], [], [], [], []], [[], [], [], [], []]], g = h[0], w = h[1], b = g[4], y = w[4];
    let D, I, M;
    const _ = [], N = [];
    let x, C, L, V, H, O;
    for (D = 0; D < 256; D++)
      N[(_[D] = D << 1 ^ (D >> 7) * 283) ^ D] = D;
    for (I = M = 0; !b[I]; I ^= x || 1, M = N[M] || 1)
      for (V = M ^ M << 1 ^ M << 2 ^ M << 3 ^ M << 4, V = V >> 8 ^ V & 255 ^ 99, b[I] = V, y[V] = I, L = _[C = _[x = _[I]]], O = L * 16843009 ^ C * 65537 ^ x * 257 ^ I * 16843008, H = _[V] * 257 ^ V * 16843008, D = 0; D < 4; D++)
        g[D][I] = H = H << 24 ^ H >>> 8, w[D][V] = O = O << 24 ^ O >>> 8;
    for (D = 0; D < 5; D++)
      g[D] = g[D].slice(0), w[D] = w[D].slice(0);
    return h;
  };
  let n = null;
  class s {
    constructor(g) {
      n || (n = i()), this._tables = [[n[0][0].slice(), n[0][1].slice(), n[0][2].slice(), n[0][3].slice(), n[0][4].slice()], [n[1][0].slice(), n[1][1].slice(), n[1][2].slice(), n[1][3].slice(), n[1][4].slice()]];
      let w, b, y;
      const D = this._tables[0][4], I = this._tables[1], M = g.length;
      let _ = 1;
      if (M !== 4 && M !== 6 && M !== 8)
        throw new Error("Invalid aes key size");
      const N = g.slice(0), x = [];
      for (this._key = [N, x], w = M; w < 4 * M + 28; w++)
        y = N[w - 1], (w % M === 0 || M === 8 && w % M === 4) && (y = D[y >>> 24] << 24 ^ D[y >> 16 & 255] << 16 ^ D[y >> 8 & 255] << 8 ^ D[y & 255], w % M === 0 && (y = y << 8 ^ y >>> 24 ^ _ << 24, _ = _ << 1 ^ (_ >> 7) * 283)), N[w] = N[w - M] ^ y;
      for (b = 0; w; b++, w--)
        y = N[b & 3 ? w : w - 4], w <= 4 || b < 4 ? x[b] = y : x[b] = I[0][D[y >>> 24]] ^ I[1][D[y >> 16 & 255]] ^ I[2][D[y >> 8 & 255]] ^ I[3][D[y & 255]];
    }
    /**
     * Decrypt 16 bytes, specified as four 32-bit words.
     *
     * @param {number} encrypted0 the first word to decrypt
     * @param {number} encrypted1 the second word to decrypt
     * @param {number} encrypted2 the third word to decrypt
     * @param {number} encrypted3 the fourth word to decrypt
     * @param {Int32Array} out the array to write the decrypted words
     * into
     * @param {number} offset the offset into the output array to start
     * writing results
     * @return {Array} The plaintext.
     */
    decrypt(g, w, b, y, D, I) {
      const M = this._key[1];
      let _ = g ^ M[0], N = y ^ M[1], x = b ^ M[2], C = w ^ M[3], L, V, H;
      const O = M.length / 4 - 2;
      let X, q = 4;
      const F = this._tables[1], W = F[0], j = F[1], oe = F[2], $ = F[3], ye = F[4];
      for (X = 0; X < O; X++)
        L = W[_ >>> 24] ^ j[N >> 16 & 255] ^ oe[x >> 8 & 255] ^ $[C & 255] ^ M[q], V = W[N >>> 24] ^ j[x >> 16 & 255] ^ oe[C >> 8 & 255] ^ $[_ & 255] ^ M[q + 1], H = W[x >>> 24] ^ j[C >> 16 & 255] ^ oe[_ >> 8 & 255] ^ $[N & 255] ^ M[q + 2], C = W[C >>> 24] ^ j[_ >> 16 & 255] ^ oe[N >> 8 & 255] ^ $[x & 255] ^ M[q + 3], q += 4, _ = L, N = V, x = H;
      for (X = 0; X < 4; X++)
        D[(3 & -X) + I] = ye[_ >>> 24] << 24 ^ ye[N >> 16 & 255] << 16 ^ ye[x >> 8 & 255] << 8 ^ ye[C & 255] ^ M[q++], L = _, _ = N, N = x, x = C, C = L;
    }
  }
  class r extends t {
    constructor() {
      super(t), this.jobs = [], this.delay = 1, this.timeout_ = null;
    }
    /**
     * process an async job
     *
     * @private
     */
    processJob_() {
      this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
    }
    /**
     * push a job into the stream
     *
     * @param {Function} job the job to push into the stream
     */
    push(g) {
      this.jobs.push(g), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay));
    }
  }
  const a = function(h) {
    return h << 24 | (h & 65280) << 8 | (h & 16711680) >> 8 | h >>> 24;
  }, o = function(h, g, w) {
    const b = new Int32Array(h.buffer, h.byteOffset, h.byteLength >> 2), y = new s(Array.prototype.slice.call(g)), D = new Uint8Array(h.byteLength), I = new Int32Array(D.buffer);
    let M, _, N, x, C, L, V, H, O;
    for (M = w[0], _ = w[1], N = w[2], x = w[3], O = 0; O < b.length; O += 4)
      C = a(b[O]), L = a(b[O + 1]), V = a(b[O + 2]), H = a(b[O + 3]), y.decrypt(C, L, V, H, I, O), I[O] = a(I[O] ^ M), I[O + 1] = a(I[O + 1] ^ _), I[O + 2] = a(I[O + 2] ^ N), I[O + 3] = a(I[O + 3] ^ x), M = C, _ = L, N = V, x = H;
    return D;
  };
  class l {
    constructor(g, w, b, y) {
      const D = l.STEP, I = new Int32Array(g.buffer), M = new Uint8Array(g.byteLength);
      let _ = 0;
      for (this.asyncStream_ = new r(), this.asyncStream_.push(this.decryptChunk_(I.subarray(_, _ + D), w, b, M)), _ = D; _ < I.length; _ += D)
        b = new Uint32Array([a(I[_ - 4]), a(I[_ - 3]), a(I[_ - 2]), a(I[_ - 1])]), this.asyncStream_.push(this.decryptChunk_(I.subarray(_, _ + D), w, b, M));
      this.asyncStream_.push(function() {
        y(null, e(M));
      });
    }
    /**
     * a getter for step the maximum number of bytes to process at one time
     *
     * @return {number} the value of step 32000
     */
    static get STEP() {
      return 32e3;
    }
    /**
     * @private
     */
    decryptChunk_(g, w, b, y) {
      return function() {
        const D = o(g, w, b);
        y.set(D, g.byteOffset);
      };
    }
  }
  var u = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, d;
  typeof window < "u" ? d = window : typeof u < "u" ? d = u : typeof self < "u" ? d = self : d = {};
  var c = d, A = function(g) {
    return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(g) : g && g.buffer instanceof ArrayBuffer;
  }, m = c.BigInt || Number;
  m("0x1"), m("0x100"), m("0x10000"), m("0x1000000"), m("0x100000000"), m("0x10000000000"), m("0x1000000000000"), m("0x100000000000000"), m("0x10000000000000000"), function() {
    var h = new Uint16Array([65484]), g = new Uint8Array(h.buffer, h.byteOffset, h.byteLength);
    return g[0] === 255 ? "big" : g[0] === 204 ? "little" : "unknown";
  }();
  const p = function(h) {
    const g = {};
    return Object.keys(h).forEach((w) => {
      const b = h[w];
      A(b) ? g[w] = {
        bytes: b.buffer,
        byteOffset: b.byteOffset,
        byteLength: b.byteLength
      } : g[w] = b;
    }), g;
  };
  self.onmessage = function(h) {
    const g = h.data, w = new Uint8Array(g.encrypted.bytes, g.encrypted.byteOffset, g.encrypted.byteLength), b = new Uint32Array(g.key.bytes, g.key.byteOffset, g.key.byteLength / 4), y = new Uint32Array(g.iv.bytes, g.iv.byteOffset, g.iv.byteLength / 4);
    new l(w, b, y, function(D, I) {
      self.postMessage(p({
        source: g.source,
        decrypted: I
      }), [I.buffer]);
    });
  };
}));
var vV = u1(gV);
const yV = (t) => {
  let e = t.default ? "main" : "alternative";
  return t.characteristics && t.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (e = "main-desc"), e;
}, E1 = (t, e) => {
  t.abort(), t.pause(), e && e.activePlaylistLoader && (e.activePlaylistLoader.pause(), e.activePlaylistLoader = null);
}, Xh = (t, e) => {
  e.activePlaylistLoader = t, t.load();
}, bV = (t, e) => () => {
  const {
    segmentLoaders: {
      [t]: i,
      main: n
    },
    mediaTypes: {
      [t]: s
    }
  } = e, r = s.activeTrack(), a = s.getActiveGroup(), o = s.activePlaylistLoader, l = s.lastGroup_;
  if (!(a && l && a.id === l.id) && (s.lastGroup_ = a, s.lastTrack_ = r, E1(i, s), !(!a || a.isMainPlaylist))) {
    if (!a.playlistLoader) {
      o && n.resetEverything();
      return;
    }
    i.resyncLoader(), Xh(a.playlistLoader, s);
  }
}, wV = (t, e) => () => {
  const {
    segmentLoaders: {
      [t]: i
    },
    mediaTypes: {
      [t]: n
    }
  } = e;
  n.lastGroup_ = null, i.abort(), i.pause();
}, TV = (t, e) => () => {
  const {
    mainPlaylistLoader: i,
    segmentLoaders: {
      [t]: n,
      main: s
    },
    mediaTypes: {
      [t]: r
    }
  } = e, a = r.activeTrack(), o = r.getActiveGroup(), l = r.activePlaylistLoader, u = r.lastTrack_;
  if (!(u && a && u.id === a.id) && (r.lastGroup_ = o, r.lastTrack_ = a, E1(n, r), !!o)) {
    if (o.isMainPlaylist) {
      if (!a || !u || a.id === u.id)
        return;
      const d = e.vhs.playlistController_, c = d.selectPlaylist();
      if (d.media() === c)
        return;
      r.logger_(`track change. Switching main audio from ${u.id} to ${a.id}`), i.pause(), s.resetEverything(), d.fastQualityChange_(c);
      return;
    }
    if (t === "AUDIO") {
      if (!o.playlistLoader) {
        s.setAudio(!0), s.resetEverything();
        return;
      }
      n.setAudio(!0), s.setAudio(!1);
    }
    if (l === o.playlistLoader) {
      Xh(o.playlistLoader, r);
      return;
    }
    n.track && n.track(a), n.resetEverything(), Xh(o.playlistLoader, r);
  }
}, kd = {
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is excluded) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */
  AUDIO: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: i
      },
      excludePlaylist: n
    } = e, s = i.activeTrack(), r = i.activeGroup(), a = (r.filter((l) => l.default)[0] || r[0]).id, o = i.tracks[a];
    if (s === o) {
      n({
        error: {
          message: "Problem encountered loading the default audio track."
        }
      });
      return;
    }
    Ae.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
    for (const l in i.tracks)
      i.tracks[l].enabled = i.tracks[l] === o;
    i.onTrackChanged();
  },
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */
  SUBTITLES: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: i
      }
    } = e;
    Ae.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
    const n = i.activeTrack();
    n && (n.mode = "disabled"), i.onTrackChanged();
  }
}, Kv = {
  /**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */
  AUDIO: (t, e, i) => {
    if (!e)
      return;
    const {
      tech: n,
      requestOptions: s,
      segmentLoaders: {
        [t]: r
      }
    } = i;
    e.on("loadedmetadata", () => {
      const a = e.media();
      r.playlist(a, s), (!n.paused() || a.endList && n.preload() !== "none") && r.load();
    }), e.on("loadedplaylist", () => {
      r.playlist(e.media(), s), n.paused() || r.load();
    }), e.on("error", kd[t](t, i));
  },
  /**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */
  SUBTITLES: (t, e, i) => {
    const {
      tech: n,
      requestOptions: s,
      segmentLoaders: {
        [t]: r
      },
      mediaTypes: {
        [t]: a
      }
    } = i;
    e.on("loadedmetadata", () => {
      const o = e.media();
      r.playlist(o, s), r.track(a.activeTrack()), (!n.paused() || o.endList && n.preload() !== "none") && r.load();
    }), e.on("loadedplaylist", () => {
      r.playlist(e.media(), s), n.paused() || r.load();
    }), e.on("error", kd[t](t, i));
  }
}, xV = {
  /**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */
  AUDIO: (t, e) => {
    const {
      vhs: i,
      sourceType: n,
      segmentLoaders: {
        [t]: s
      },
      requestOptions: r,
      main: {
        mediaGroups: a
      },
      mediaTypes: {
        [t]: {
          groups: o,
          tracks: l,
          logger_: u
        }
      },
      mainPlaylistLoader: d
    } = e, c = Zl(d.main);
    (!a[t] || Object.keys(a[t]).length === 0) && (a[t] = {
      main: {
        default: {
          default: !0
        }
      }
    }, c && (a[t].main.default.playlists = d.main.playlists));
    for (const A in a[t]) {
      o[A] || (o[A] = []);
      for (const m in a[t][A]) {
        let p = a[t][A][m], h;
        if (c ? (u(`AUDIO group '${A}' label '${m}' is a main playlist`), p.isMainPlaylist = !0, h = null) : n === "vhs-json" && p.playlists ? h = new Da(p.playlists[0], i, r) : p.resolvedUri ? h = new Da(p.resolvedUri, i, r) : p.playlists && n === "dash" ? h = new Vh(p.playlists[0], i, r, d) : h = null, p = _t({
          id: m,
          playlistLoader: h
        }, p), Kv[t](t, p.playlistLoader, e), o[A].push(p), typeof l[m] > "u") {
          const g = new Ae.AudioTrack({
            id: m,
            kind: yV(p),
            enabled: !1,
            language: p.language,
            default: p.default,
            label: m
          });
          l[m] = g;
        }
      }
    }
    s.on("error", kd[t](t, e));
  },
  /**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */
  SUBTITLES: (t, e) => {
    const {
      tech: i,
      vhs: n,
      sourceType: s,
      segmentLoaders: {
        [t]: r
      },
      requestOptions: a,
      main: {
        mediaGroups: o
      },
      mediaTypes: {
        [t]: {
          groups: l,
          tracks: u
        }
      },
      mainPlaylistLoader: d
    } = e;
    for (const c in o[t]) {
      l[c] || (l[c] = []);
      for (const A in o[t][c]) {
        if (!n.options_.useForcedSubtitles && o[t][c][A].forced)
          continue;
        let m = o[t][c][A], p;
        if (s === "hls")
          p = new Da(m.resolvedUri, n, a);
        else if (s === "dash") {
          if (!m.playlists.filter((g) => g.excludeUntil !== 1 / 0).length)
            return;
          p = new Vh(m.playlists[0], n, a, d);
        } else s === "vhs-json" && (p = new Da(
          // if the vhs-json object included the media playlist, use the media playlist
          // as provided, otherwise use the resolved URI to load the playlist
          m.playlists ? m.playlists[0] : m.resolvedUri,
          n,
          a
        ));
        if (m = _t({
          id: A,
          playlistLoader: p
        }, m), Kv[t](t, m.playlistLoader, e), l[c].push(m), typeof u[A] > "u") {
          const h = i.addRemoteTextTrack({
            id: A,
            kind: "subtitles",
            default: m.default && m.autoselect,
            language: m.language,
            label: A
          }, !1).track;
          u[A] = h;
        }
      }
    }
    r.on("error", kd[t](t, e));
  },
  /**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */
  "CLOSED-CAPTIONS": (t, e) => {
    const {
      tech: i,
      main: {
        mediaGroups: n
      },
      mediaTypes: {
        [t]: {
          groups: s,
          tracks: r
        }
      }
    } = e;
    for (const a in n[t]) {
      s[a] || (s[a] = []);
      for (const o in n[t][a]) {
        const l = n[t][a][o];
        if (!/^(?:CC|SERVICE)/.test(l.instreamId))
          continue;
        const u = i.options_.vhs && i.options_.vhs.captionServices || {};
        let d = {
          label: o,
          language: l.language,
          instreamId: l.instreamId,
          default: l.default && l.autoselect
        };
        if (u[d.instreamId] && (d = _t(d, u[d.instreamId])), d.default === void 0 && delete d.default, s[a].push(_t({
          id: o
        }, l)), typeof r[o] > "u") {
          const c = i.addRemoteTextTrack({
            id: d.instreamId,
            kind: "captions",
            default: d.default,
            language: d.language,
            label: d.label
          }, !1).track;
          r[o] = c;
        }
      }
    }
  }
}, D1 = (t, e) => {
  for (let i = 0; i < t.length; i++)
    if (ym(e, t[i]) || t[i].playlists && D1(t[i].playlists, e))
      return !0;
  return !1;
}, SV = (t, e) => (i) => {
  const {
    mainPlaylistLoader: n,
    mediaTypes: {
      [t]: {
        groups: s
      }
    }
  } = e, r = n.media();
  if (!r)
    return null;
  let a = null;
  r.attributes[t] && (a = s[r.attributes[t]]);
  const o = Object.keys(s);
  if (!a)
    if (t === "AUDIO" && o.length > 1 && Zl(e.main))
      for (let l = 0; l < o.length; l++) {
        const u = s[o[l]];
        if (D1(u, r)) {
          a = u;
          break;
        }
      }
    else s.main ? a = s.main : o.length === 1 && (a = s[o[0]]);
  return typeof i > "u" ? a : i === null || !a ? null : a.filter((l) => l.id === i.id)[0] || null;
}, CV = {
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */
  AUDIO: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: {
          tracks: i
        }
      }
    } = e;
    for (const n in i)
      if (i[n].enabled)
        return i[n];
    return null;
  },
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */
  SUBTITLES: (t, e) => () => {
    const {
      mediaTypes: {
        [t]: {
          tracks: i
        }
      }
    } = e;
    for (const n in i)
      if (i[n].mode === "showing" || i[n].mode === "hidden")
        return i[n];
    return null;
  }
}, EV = (t, {
  mediaTypes: e
}) => () => {
  const i = e[t].activeTrack();
  return i ? e[t].activeGroup(i) : null;
}, DV = (t) => {
  ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((u) => {
    xV[u](u, t);
  });
  const {
    mediaTypes: e,
    mainPlaylistLoader: i,
    tech: n,
    vhs: s,
    segmentLoaders: {
      ["AUDIO"]: r,
      main: a
    }
  } = t;
  ["AUDIO", "SUBTITLES"].forEach((u) => {
    e[u].activeGroup = SV(u, t), e[u].activeTrack = CV[u](u, t), e[u].onGroupChanged = bV(u, t), e[u].onGroupChanging = wV(u, t), e[u].onTrackChanged = TV(u, t), e[u].getActiveGroup = EV(u, t);
  });
  const o = e.AUDIO.activeGroup();
  if (o) {
    const u = (o.filter((c) => c.default)[0] || o[0]).id;
    e.AUDIO.tracks[u].enabled = !0, e.AUDIO.onGroupChanged(), e.AUDIO.onTrackChanged(), e.AUDIO.getActiveGroup().playlistLoader ? (a.setAudio(!1), r.setAudio(!0)) : a.setAudio(!0);
  }
  i.on("mediachange", () => {
    ["AUDIO", "SUBTITLES"].forEach((u) => e[u].onGroupChanged());
  }), i.on("mediachanging", () => {
    ["AUDIO", "SUBTITLES"].forEach((u) => e[u].onGroupChanging());
  });
  const l = () => {
    e.AUDIO.onTrackChanged(), n.trigger({
      type: "usage",
      name: "vhs-audio-change"
    });
  };
  n.audioTracks().addEventListener("change", l), n.remoteTextTracks().addEventListener("change", e.SUBTITLES.onTrackChanged), s.on("dispose", () => {
    n.audioTracks().removeEventListener("change", l), n.remoteTextTracks().removeEventListener("change", e.SUBTITLES.onTrackChanged);
  }), n.clearTracks("audio");
  for (const u in e.AUDIO.tracks)
    n.audioTracks().addTrack(e.AUDIO.tracks[u]);
}, _V = () => {
  const t = {};
  return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((e) => {
    t[e] = {
      groups: {},
      tracks: {},
      activePlaylistLoader: null,
      activeGroup: Rs,
      activeTrack: Rs,
      getActiveGroup: Rs,
      onGroupChanged: Rs,
      onTrackChanged: Rs,
      lastTrack_: null,
      logger_: Fn(`MediaGroups[${e}]`)
    };
  }), t;
};
class Jv {
  constructor() {
    this.priority_ = [], this.pathwayClones_ = /* @__PURE__ */ new Map();
  }
  set version(e) {
    e === 1 && (this.version_ = e);
  }
  set ttl(e) {
    this.ttl_ = e || 300;
  }
  set reloadUri(e) {
    e && (this.reloadUri_ = rn(this.reloadUri_, e));
  }
  set priority(e) {
    e && e.length && (this.priority_ = e);
  }
  set pathwayClones(e) {
    e && e.length && (this.pathwayClones_ = new Map(e.map((i) => [i.ID, i])));
  }
  get version() {
    return this.version_;
  }
  get ttl() {
    return this.ttl_;
  }
  get reloadUri() {
    return this.reloadUri_;
  }
  get priority() {
    return this.priority_;
  }
  get pathwayClones() {
    return this.pathwayClones_;
  }
}
class kV extends Ae.EventTarget {
  constructor(e, i) {
    super(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = !1, this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new Jv(), this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.currentPathwayClones = /* @__PURE__ */ new Map(), this.nextPathwayClones = /* @__PURE__ */ new Map(), this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.logger_ = Fn("Content Steering"), this.xhr_ = e, this.getBandwidth_ = i;
  }
  /**
   * Assigns the content steering tag properties to the steering controller
   *
   * @param {string} baseUrl the baseURL from the main manifest for resolving the steering manifest url
   * @param {Object} steeringTag the content steering tag from the main manifest
   */
  assignTagProperties(e, i) {
    this.manifestType_ = i.serverUri ? "HLS" : "DASH";
    const n = i.serverUri || i.serverURL;
    if (!n) {
      this.logger_(`steering manifest URL is ${n}, cannot request steering manifest.`), this.trigger("error");
      return;
    }
    if (n.startsWith("data:")) {
      this.decodeDataUriManifest_(n.substring(n.indexOf(",") + 1));
      return;
    }
    this.steeringManifest.reloadUri = rn(e, n), this.defaultPathway = i.pathwayId || i.defaultServiceLocation, this.queryBeforeStart = i.queryBeforeStart, this.proxyServerUrl_ = i.proxyServerURL, this.defaultPathway && !this.queryBeforeStart && this.trigger("content-steering");
  }
  /**
   * Requests the content steering manifest and parse the response. This should only be called after
   * assignTagProperties was called with a content steering tag.
   *
   * @param {string} initialUri The optional uri to make the request with.
   *    If set, the request should be made with exactly what is passed in this variable.
   *    This scenario should only happen once on initalization.
   */
  requestSteeringManifest(e) {
    const i = this.steeringManifest.reloadUri;
    if (!i)
      return;
    const n = e ? i : this.getRequestURI(i);
    if (!n) {
      this.logger_("No valid content steering manifest URIs. Stopping content steering."), this.trigger("error"), this.dispose();
      return;
    }
    const s = {
      contentSteeringInfo: {
        uri: n
      }
    };
    this.trigger({
      type: "contentsteeringloadstart",
      metadata: s
    }), this.request_ = this.xhr_({
      uri: n,
      requestType: "content-steering-manifest"
    }, (r, a) => {
      if (r) {
        if (a.status === 410) {
          this.logger_(`manifest request 410 ${r}.`), this.logger_(`There will be no more content steering requests to ${n} this session.`), this.excludedSteeringManifestURLs.add(n);
          return;
        }
        if (a.status === 429) {
          const u = a.responseHeaders["retry-after"];
          this.logger_(`manifest request 429 ${r}.`), this.logger_(`content steering will retry in ${u} seconds.`), this.startTTLTimeout_(parseInt(u, 10));
          return;
        }
        this.logger_(`manifest failed to load ${r}.`), this.startTTLTimeout_();
        return;
      }
      this.trigger({
        type: "contentsteeringloadcomplete",
        metadata: s
      });
      let o;
      try {
        o = JSON.parse(this.request_.responseText);
      } catch (u) {
        const d = {
          errorType: Ae.Error.StreamingContentSteeringParserError,
          error: u
        };
        this.trigger({
          type: "error",
          metadata: d
        });
      }
      this.assignSteeringProperties_(o);
      const l = {
        contentSteeringInfo: s.contentSteeringInfo,
        contentSteeringManifest: {
          version: this.steeringManifest.version,
          reloadUri: this.steeringManifest.reloadUri,
          priority: this.steeringManifest.priority
        }
      };
      this.trigger({
        type: "contentsteeringparsed",
        metadata: l
      }), this.startTTLTimeout_();
    });
  }
  /**
   * Set the proxy server URL and add the steering manifest url as a URI encoded parameter.
   *
   * @param {string} steeringUrl the steering manifest url
   * @return the steering manifest url to a proxy server with all parameters set
   */
  setProxyServerUrl_(e) {
    const i = new ne.URL(e), n = new ne.URL(this.proxyServerUrl_);
    return n.searchParams.set("url", encodeURI(i.toString())), this.setSteeringParams_(n.toString());
  }
  /**
   * Decodes and parses the data uri encoded steering manifest
   *
   * @param {string} dataUri the data uri to be decoded and parsed.
   */
  decodeDataUriManifest_(e) {
    const i = JSON.parse(ne.atob(e));
    this.assignSteeringProperties_(i);
  }
  /**
   * Set the HLS or DASH content steering manifest request query parameters. For example:
   * _HLS_pathway="<CURRENT-PATHWAY-ID>" and _HLS_throughput=<THROUGHPUT>
   * _DASH_pathway and _DASH_throughput
   *
   * @param {string} uri to add content steering server parameters to.
   * @return a new uri as a string with the added steering query parameters.
   */
  setSteeringParams_(e) {
    const i = new ne.URL(e), n = this.getPathway(), s = this.getBandwidth_();
    if (n) {
      const r = `_${this.manifestType_}_pathway`;
      i.searchParams.set(r, n);
    }
    if (s) {
      const r = `_${this.manifestType_}_throughput`;
      i.searchParams.set(r, s);
    }
    return i.toString();
  }
  /**
   * Assigns the current steering manifest properties and to the SteeringManifest object
   *
   * @param {Object} steeringJson the raw JSON steering manifest
   */
  assignSteeringProperties_(e) {
    if (this.steeringManifest.version = e.VERSION, !this.steeringManifest.version) {
      this.logger_(`manifest version is ${e.VERSION}, which is not supported.`), this.trigger("error");
      return;
    }
    this.steeringManifest.ttl = e.TTL, this.steeringManifest.reloadUri = e["RELOAD-URI"], this.steeringManifest.priority = e["PATHWAY-PRIORITY"] || e["SERVICE-LOCATION-PRIORITY"], this.steeringManifest.pathwayClones = e["PATHWAY-CLONES"], this.nextPathwayClones = this.steeringManifest.pathwayClones, this.availablePathways_.size || (this.logger_("There are no available pathways for content steering. Ending content steering."), this.trigger("error"), this.dispose());
    const n = ((s) => {
      for (const r of s)
        if (this.availablePathways_.has(r))
          return r;
      return [...this.availablePathways_][0];
    })(this.steeringManifest.priority);
    this.currentPathway !== n && (this.currentPathway = n, this.trigger("content-steering"));
  }
  /**
   * Returns the pathway to use for steering decisions
   *
   * @return {string} returns the current pathway or the default
   */
  getPathway() {
    return this.currentPathway || this.defaultPathway;
  }
  /**
   * Chooses the manifest request URI based on proxy URIs and server URLs.
   * Also accounts for exclusion on certain manifest URIs.
   *
   * @param {string} reloadUri the base uri before parameters
   *
   * @return {string} the final URI for the request to the manifest server.
   */
  getRequestURI(e) {
    if (!e)
      return null;
    const i = (s) => this.excludedSteeringManifestURLs.has(s);
    if (this.proxyServerUrl_) {
      const s = this.setProxyServerUrl_(e);
      if (!i(s))
        return s;
    }
    const n = this.setSteeringParams_(e);
    return i(n) ? null : n;
  }
  /**
   * Start the timeout for re-requesting the steering manifest at the TTL interval.
   *
   * @param {number} ttl time in seconds of the timeout. Defaults to the
   *        ttl interval in the steering manifest
   */
  startTTLTimeout_(e = this.steeringManifest.ttl) {
    const i = e * 1e3;
    this.ttlTimeout_ = ne.setTimeout(() => {
      this.requestSteeringManifest();
    }, i);
  }
  /**
   * Clear the TTL timeout if necessary.
   */
  clearTTLTimeout_() {
    ne.clearTimeout(this.ttlTimeout_), this.ttlTimeout_ = null;
  }
  /**
   * aborts any current steering xhr and sets the current request object to null
   */
  abort() {
    this.request_ && this.request_.abort(), this.request_ = null;
  }
  /**
   * aborts steering requests clears the ttl timeout and resets all properties.
   */
  dispose() {
    this.off("content-steering"), this.off("error"), this.abort(), this.clearTTLTimeout_(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = null, this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new Jv();
  }
  /**
   * adds a pathway to the available pathways set
   *
   * @param {string} pathway the pathway string to add
   */
  addAvailablePathway(e) {
    e && this.availablePathways_.add(e);
  }
  /**
   * Clears all pathways from the available pathways set
   */
  clearAvailablePathways() {
    this.availablePathways_.clear();
  }
  /**
   * Removes a pathway from the available pathways set.
   */
  excludePathway(e) {
    return this.availablePathways_.delete(e);
  }
  /**
   * Checks the refreshed DASH manifest content steering tag for changes.
   *
   * @param {string} baseURL new steering tag on DASH manifest refresh
   * @param {Object} newTag the new tag to check for changes
   * @return a true or false whether the new tag has different values
   */
  didDASHTagChange(e, i) {
    return !i && this.steeringManifest.reloadUri || i && (rn(e, i.serverURL) !== this.steeringManifest.reloadUri || i.defaultServiceLocation !== this.defaultPathway || i.queryBeforeStart !== this.queryBeforeStart || i.proxyServerURL !== this.proxyServerUrl_);
  }
  getAvailablePathways() {
    return this.availablePathways_;
  }
}
const PV = (t, e) => {
  let i = null;
  return (...n) => {
    clearTimeout(i), i = setTimeout(() => {
      t.apply(null, n);
    }, e);
  };
}, IV = 10;
let sr;
const MV = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred", "mediaAppends"], OV = function(t) {
  return this.audioSegmentLoader_[t] + this.mainSegmentLoader_[t];
}, BV = function({
  currentPlaylist: t,
  buffered: e,
  currentTime: i,
  nextPlaylist: n,
  bufferLowWaterLine: s,
  bufferHighWaterLine: r,
  duration: a,
  bufferBasedABR: o,
  log: l
}) {
  if (!n)
    return Ae.log.warn("We received no playlist to switch to. Please check your stream."), !1;
  const u = `allowing switch ${t && t.id || "null"} -> ${n.id}`;
  if (!t)
    return l(`${u} as current playlist is not set`), !0;
  if (n.id === t.id)
    return !1;
  const d = !!Ea(e, i).length;
  if (!t.endList)
    return !d && typeof t.partTargetDuration == "number" ? (l(`not ${u} as current playlist is live llhls, but currentTime isn't in buffered.`), !1) : (l(`${u} as current playlist is live`), !0);
  const c = Am(e, i), A = o ? Si.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : Si.MAX_BUFFER_LOW_WATER_LINE;
  if (a < A)
    return l(`${u} as duration < max low water line (${a} < ${A})`), !0;
  const m = n.attributes.BANDWIDTH, p = t.attributes.BANDWIDTH;
  if (m < p && (!o || c < r)) {
    let h = `${u} as next bandwidth < current bandwidth (${m} < ${p})`;
    return o && (h += ` and forwardBuffer < bufferHighWaterLine (${c} < ${r})`), l(h), !0;
  }
  if ((!o || m > p) && c >= s) {
    let h = `${u} as forwardBuffer >= bufferLowWaterLine (${c} >= ${s})`;
    return o && (h += ` and next bandwidth > current bandwidth (${m} > ${p})`), l(h), !0;
  }
  return l(`not ${u} as no switching criteria met`), !1;
};
class LV extends Ae.EventTarget {
  constructor(e) {
    super(), this.fastQualityChange_ = PV(this.fastQualityChange_.bind(this), 100);
    const {
      src: i,
      withCredentials: n,
      tech: s,
      bandwidth: r,
      externVhs: a,
      useCueTags: o,
      playlistExclusionDuration: l,
      enableLowInitialPlaylist: u,
      sourceType: d,
      cacheEncryptionKeys: c,
      bufferBasedABR: A,
      leastPixelDiffSelector: m,
      captionServices: p,
      experimentalUseMMS: h
    } = e;
    if (!i)
      throw new Error("A non-empty playlist URL or JSON manifest string is required");
    let {
      maxPlaylistRetries: g
    } = e;
    (g === null || typeof g > "u") && (g = 1 / 0), sr = a, this.bufferBasedABR = !!A, this.leastPixelDiffSelector = !!m, this.withCredentials = n, this.tech_ = s, this.vhs_ = s.vhs, this.player_ = e.player_, this.sourceType_ = d, this.useCueTags_ = o, this.playlistExclusionDuration = l, this.maxPlaylistRetries = g, this.enableLowInitialPlaylist = u, this.usingManagedMediaSource_ = !1, this.useCueTags_ && (this.cueTagsTrack_ = this.tech_.addTextTrack("metadata", "ad-cues"), this.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), this.requestOptions_ = {
      withCredentials: n,
      maxPlaylistRetries: g,
      timeout: null
    }, this.on("error", this.pauseLoading), this.mediaTypes_ = _V(), h && ne.ManagedMediaSource ? (this.tech_.el_.disableRemotePlayback = !0, this.mediaSource = new ne.ManagedMediaSource(), this.usingManagedMediaSource_ = !0, Ae.log("Using ManagedMediaSource")) : ne.MediaSource && (this.mediaSource = new ne.MediaSource()), this.handleDurationChange_ = this.handleDurationChange_.bind(this), this.handleSourceOpen_ = this.handleSourceOpen_.bind(this), this.handleSourceEnded_ = this.handleSourceEnded_.bind(this), this.load = this.load.bind(this), this.pause = this.pause.bind(this), this.mediaSource.addEventListener("durationchange", this.handleDurationChange_), this.mediaSource.addEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.addEventListener("sourceended", this.handleSourceEnded_), this.mediaSource.addEventListener("startstreaming", this.load), this.mediaSource.addEventListener("endstreaming", this.pause), this.seekable_ = ki(), this.hasPlayed_ = !1, this.syncController_ = new mV(e), this.segmentMetadataTrack_ = s.addRemoteTextTrack({
      kind: "metadata",
      label: "segment-metadata"
    }, !1).track, this.segmentMetadataTrack_.mode = "hidden", this.decrypter_ = new vV(), this.sourceUpdater_ = new S1(this.mediaSource), this.inbandTextTracks_ = {}, this.timelineChangeController_ = new AV(), this.keyStatusMap_ = /* @__PURE__ */ new Map();
    const w = {
      vhs: this.vhs_,
      parse708captions: e.parse708captions,
      useDtsForTimestampOffset: e.useDtsForTimestampOffset,
      captionServices: p,
      mediaSource: this.mediaSource,
      currentTime: this.tech_.currentTime.bind(this.tech_),
      seekable: () => this.seekable(),
      seeking: () => this.tech_.seeking(),
      duration: () => this.duration(),
      hasPlayed: () => this.hasPlayed_,
      goalBufferLength: () => this.goalBufferLength(),
      bandwidth: r,
      syncController: this.syncController_,
      decrypter: this.decrypter_,
      sourceType: this.sourceType_,
      inbandTextTracks: this.inbandTextTracks_,
      cacheEncryptionKeys: c,
      sourceUpdater: this.sourceUpdater_,
      timelineChangeController: this.timelineChangeController_,
      exactManifestTimings: e.exactManifestTimings,
      addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
    };
    this.mainPlaylistLoader_ = this.sourceType_ === "dash" ? new Vh(i, this.vhs_, _t(this.requestOptions_, {
      addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
    })) : new Da(i, this.vhs_, _t(this.requestOptions_, {
      addDateRangesToTextTrack: this.addDateRangesToTextTrack_.bind(this)
    })), this.setupMainPlaylistLoaderListeners_(), this.mainSegmentLoader_ = new Wh(_t(w, {
      segmentMetadataTrack: this.segmentMetadataTrack_,
      loaderType: "main"
    }), e), this.audioSegmentLoader_ = new Wh(_t(w, {
      loaderType: "audio"
    }), e), this.subtitleSegmentLoader_ = new dV(_t(w, {
      loaderType: "vtt",
      featuresNativeTextTracks: this.tech_.featuresNativeTextTracks,
      loadVttJs: () => new Promise((D, I) => {
        function M() {
          s.off("vttjserror", _), D();
        }
        function _() {
          s.off("vttjsloaded", M), I();
        }
        s.one("vttjsloaded", M), s.one("vttjserror", _), s.addWebVttScript_();
      })
    }), e);
    const b = () => this.mainSegmentLoader_.bandwidth;
    this.contentSteeringController_ = new kV(this.vhs_.xhr, b), this.setupSegmentLoaderListeners_(), this.bufferBasedABR && (this.mainPlaylistLoader_.one("loadedplaylist", () => this.startABRTimer_()), this.tech_.on("pause", () => this.stopABRTimer_()), this.tech_.on("play", () => this.startABRTimer_())), MV.forEach((D) => {
      this[D + "_"] = OV.bind(this, D);
    }), this.logger_ = Fn("pc"), this.triggeredFmp4Usage = !1, this.tech_.preload() === "none" ? (this.loadOnPlay_ = () => {
      this.loadOnPlay_ = null, this.mainPlaylistLoader_.load();
    }, this.tech_.one("play", this.loadOnPlay_)) : this.mainPlaylistLoader_.load(), this.timeToLoadedData__ = -1, this.mainAppendsToLoadedData__ = -1, this.audioAppendsToLoadedData__ = -1;
    const y = this.tech_.preload() === "none" ? "play" : "loadstart";
    this.tech_.one(y, () => {
      const D = Date.now();
      this.tech_.one("loadeddata", () => {
        this.timeToLoadedData__ = Date.now() - D, this.mainAppendsToLoadedData__ = this.mainSegmentLoader_.mediaAppends, this.audioAppendsToLoadedData__ = this.audioSegmentLoader_.mediaAppends;
      });
    });
  }
  mainAppendsToLoadedData_() {
    return this.mainAppendsToLoadedData__;
  }
  audioAppendsToLoadedData_() {
    return this.audioAppendsToLoadedData__;
  }
  appendsToLoadedData_() {
    const e = this.mainAppendsToLoadedData_(), i = this.audioAppendsToLoadedData_();
    return e === -1 || i === -1 ? -1 : e + i;
  }
  timeToLoadedData_() {
    return this.timeToLoadedData__;
  }
  /**
   * Run selectPlaylist and switch to the new playlist if we should
   *
   * @param {string} [reason=abr] a reason for why the ABR check is made
   * @private
   */
  checkABR_(e = "abr") {
    const i = this.selectPlaylist();
    i && this.shouldSwitchToMedia_(i) && this.switchMedia_(i, e);
  }
  switchMedia_(e, i, n) {
    const s = this.media(), r = s && (s.id || s.uri), a = e && (e.id || e.uri);
    if (r && r !== a) {
      this.logger_(`switch media ${r} -> ${a} from ${i}`);
      const o = {
        renditionInfo: {
          id: a,
          bandwidth: e.attributes.BANDWIDTH,
          resolution: e.attributes.RESOLUTION,
          codecs: e.attributes.CODECS
        },
        cause: i
      };
      this.trigger({
        type: "renditionselected",
        metadata: o
      }), this.tech_.trigger({
        type: "usage",
        name: `vhs-rendition-change-${i}`
      });
    }
    this.mainPlaylistLoader_.media(e, n);
  }
  /**
   * A function that ensures we switch our playlists inside of `mediaTypes`
   * to match the current `serviceLocation` provided by the contentSteering controller.
   * We want to check media types of `AUDIO`, `SUBTITLES`, and `CLOSED-CAPTIONS`.
   *
   * This should only be called on a DASH playback scenario while using content steering.
   * This is necessary due to differences in how media in HLS manifests are generally tied to
   * a video playlist, where in DASH that is not always the case.
   */
  switchMediaForDASHContentSteering_() {
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((e) => {
      const i = this.mediaTypes_[e], n = i ? i.activeGroup() : null, s = this.contentSteeringController_.getPathway();
      if (n && s) {
        const a = (n.length ? n[0].playlists : n.playlists).filter((o) => o.attributes.serviceLocation === s);
        a.length && this.mediaTypes_[e].activePlaylistLoader.media(a[0]);
      }
    });
  }
  /**
   * Start a timer that periodically calls checkABR_
   *
   * @private
   */
  startABRTimer_() {
    this.stopABRTimer_(), this.abrTimer_ = ne.setInterval(() => this.checkABR_(), 250);
  }
  /**
   * Stop the timer that periodically calls checkABR_
   *
   * @private
   */
  stopABRTimer_() {
    this.tech_.scrubbing && this.tech_.scrubbing() || (ne.clearInterval(this.abrTimer_), this.abrTimer_ = null);
  }
  /**
   * Get a list of playlists for the currently selected audio playlist
   *
   * @return {Array} the array of audio playlists
   */
  getAudioTrackPlaylists_() {
    const e = this.main(), i = e && e.playlists || [];
    if (!e || !e.mediaGroups || !e.mediaGroups.AUDIO)
      return i;
    const n = e.mediaGroups.AUDIO, s = Object.keys(n);
    let r;
    if (Object.keys(this.mediaTypes_.AUDIO.groups).length)
      r = this.mediaTypes_.AUDIO.activeTrack();
    else {
      const o = n.main || s.length && n[s[0]];
      for (const l in o)
        if (o[l].default) {
          r = {
            label: l
          };
          break;
        }
    }
    if (!r)
      return i;
    const a = [];
    for (const o in n)
      if (n[o][r.label]) {
        const l = n[o][r.label];
        if (l.playlists && l.playlists.length)
          a.push.apply(a, l.playlists);
        else if (l.uri)
          a.push(l);
        else if (e.playlists.length)
          for (let u = 0; u < e.playlists.length; u++) {
            const d = e.playlists[u];
            d.attributes && d.attributes.AUDIO && d.attributes.AUDIO === o && a.push(d);
          }
      }
    return a.length ? a : i;
  }
  /**
   * Register event handlers on the main playlist loader. A helper
   * function for construction time.
   *
   * @private
   */
  setupMainPlaylistLoaderListeners_() {
    this.mainPlaylistLoader_.on("loadedmetadata", () => {
      const i = this.mainPlaylistLoader_.media(), n = i.targetDuration * 1.5 * 1e3;
      Nh(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = n, i.endList && this.tech_.preload() !== "none" && (this.mainSegmentLoader_.playlist(i, this.requestOptions_), this.mainSegmentLoader_.load()), DV({
        sourceType: this.sourceType_,
        segmentLoaders: {
          AUDIO: this.audioSegmentLoader_,
          SUBTITLES: this.subtitleSegmentLoader_,
          main: this.mainSegmentLoader_
        },
        tech: this.tech_,
        requestOptions: this.requestOptions_,
        mainPlaylistLoader: this.mainPlaylistLoader_,
        vhs: this.vhs_,
        main: this.main(),
        mediaTypes: this.mediaTypes_,
        excludePlaylist: this.excludePlaylist.bind(this)
      }), this.triggerPresenceUsage_(this.main(), i), this.setupFirstPlay(), !this.mediaTypes_.AUDIO.activePlaylistLoader || this.mediaTypes_.AUDIO.activePlaylistLoader.media() ? this.trigger("selectedinitialmedia") : this.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", () => {
        this.trigger("selectedinitialmedia");
      });
    }), this.mainPlaylistLoader_.on("loadedplaylist", () => {
      this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_);
      let i = this.mainPlaylistLoader_.media();
      if (!i) {
        this.attachContentSteeringListeners_(), this.initContentSteeringController_(), this.excludeUnsupportedVariants_();
        let n;
        if (this.enableLowInitialPlaylist && (n = this.selectInitialPlaylist()), n || (n = this.selectPlaylist()), !n || !this.shouldSwitchToMedia_(n) || (this.initialMedia_ = n, this.switchMedia_(this.initialMedia_, "initial"), !(this.sourceType_ === "vhs-json" && this.initialMedia_.segments)))
          return;
        i = this.initialMedia_;
      }
      this.handleUpdatedMediaPlaylist(i);
    }), this.mainPlaylistLoader_.on("error", () => {
      const i = this.mainPlaylistLoader_.error;
      this.excludePlaylist({
        playlistToExclude: i.playlist,
        error: i
      });
    }), this.mainPlaylistLoader_.on("mediachanging", () => {
      this.mainSegmentLoader_.abort(), this.mainSegmentLoader_.pause();
    }), this.mainPlaylistLoader_.on("mediachange", () => {
      const i = this.mainPlaylistLoader_.media(), n = i.targetDuration * 1.5 * 1e3;
      Nh(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = n, this.sourceType_ === "dash" && this.mainPlaylistLoader_.isPaused && this.mainPlaylistLoader_.load(), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(i, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ ? this.runFastQualitySwitch_() : this.mainSegmentLoader_.load(), this.tech_.trigger({
        type: "mediachange",
        bubbles: !0
      });
    }), this.mainPlaylistLoader_.on("playlistunchanged", () => {
      const i = this.mainPlaylistLoader_.media();
      if (i.lastExcludeReason_ === "playlist-unchanged")
        return;
      this.stuckAtPlaylistEnd_(i) && (this.excludePlaylist({
        error: {
          message: "Playlist no longer updating.",
          reason: "playlist-unchanged"
        }
      }), this.tech_.trigger("playliststuck"));
    }), this.mainPlaylistLoader_.on("renditiondisabled", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-disabled"
      });
    }), this.mainPlaylistLoader_.on("renditionenabled", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-enabled"
      });
    }), ["manifestrequeststart", "manifestrequestcomplete", "manifestparsestart", "manifestparsecomplete", "playlistrequeststart", "playlistrequestcomplete", "playlistparsestart", "playlistparsecomplete", "renditiondisabled", "renditionenabled"].forEach((i) => {
      this.mainPlaylistLoader_.on(i, (n) => {
        this.player_.trigger(pi({}, n));
      });
    });
  }
  /**
   * Given an updated media playlist (whether it was loaded for the first time, or
   * refreshed for live playlists), update any relevant properties and state to reflect
   * changes in the media that should be accounted for (e.g., cues and duration).
   *
   * @param {Object} updatedPlaylist the updated media playlist object
   *
   * @private
   */
  handleUpdatedMediaPlaylist(e) {
    this.useCueTags_ && this.updateAdCues_(e), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ && this.runFastQualitySwitch_(), this.updateDuration(!e.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load());
  }
  /**
   * A helper function for triggerring presence usage events once per source
   *
   * @private
   */
  triggerPresenceUsage_(e, i) {
    const n = e.mediaGroups || {};
    let s = !0;
    const r = Object.keys(n.AUDIO);
    for (const a in n.AUDIO)
      for (const o in n.AUDIO[a])
        n.AUDIO[a][o].uri || (s = !1);
    s && this.tech_.trigger({
      type: "usage",
      name: "vhs-demuxed"
    }), Object.keys(n.SUBTITLES).length && this.tech_.trigger({
      type: "usage",
      name: "vhs-webvtt"
    }), sr.Playlist.isAes(i) && this.tech_.trigger({
      type: "usage",
      name: "vhs-aes"
    }), r.length && Object.keys(n.AUDIO[r[0]]).length > 1 && this.tech_.trigger({
      type: "usage",
      name: "vhs-alternate-audio"
    }), this.useCueTags_ && this.tech_.trigger({
      type: "usage",
      name: "vhs-playlist-cue-tags"
    });
  }
  shouldSwitchToMedia_(e) {
    const i = this.mainPlaylistLoader_.media() || this.mainPlaylistLoader_.pendingMedia_, n = this.tech_.currentTime(), s = this.bufferLowWaterLine(), r = this.bufferHighWaterLine(), a = this.tech_.buffered();
    return BV({
      buffered: a,
      currentTime: n,
      currentPlaylist: i,
      nextPlaylist: e,
      bufferLowWaterLine: s,
      bufferHighWaterLine: r,
      duration: this.duration(),
      bufferBasedABR: this.bufferBasedABR,
      log: this.logger_
    });
  }
  /**
   * Register event handlers on the segment loaders. A helper function
   * for construction time.
   *
   * @private
   */
  setupSegmentLoaderListeners_() {
    this.mainSegmentLoader_.on("bandwidthupdate", () => {
      this.checkABR_("bandwidthupdate"), this.tech_.trigger("bandwidthupdate");
    }), this.mainSegmentLoader_.on("timeout", () => {
      this.bufferBasedABR && this.mainSegmentLoader_.load();
    }), this.bufferBasedABR || this.mainSegmentLoader_.on("progress", () => {
      this.trigger("progress");
    }), this.mainSegmentLoader_.on("error", () => {
      const n = this.mainSegmentLoader_.error();
      this.excludePlaylist({
        playlistToExclude: n.playlist,
        error: n
      });
    }), this.mainSegmentLoader_.on("appenderror", () => {
      this.error = this.mainSegmentLoader_.error_, this.trigger("error");
    }), this.mainSegmentLoader_.on("syncinfoupdate", () => {
      this.onSyncInfoUpdate_();
    }), this.mainSegmentLoader_.on("timestampoffset", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-timestamp-offset"
      });
    }), this.audioSegmentLoader_.on("syncinfoupdate", () => {
      this.onSyncInfoUpdate_();
    }), this.audioSegmentLoader_.on("appenderror", () => {
      this.error = this.audioSegmentLoader_.error_, this.trigger("error");
    }), this.mainSegmentLoader_.on("ended", () => {
      this.logger_("main segment loader ended"), this.onEndOfStream();
    }), this.timelineChangeController_.on("audioTimelineBehind", () => {
      const n = this.audioSegmentLoader_.pendingSegment_;
      if (!n || !n.segment || !n.segment.syncInfo)
        return;
      const s = n.segment.syncInfo.end + 0.01;
      this.tech_.setCurrentTime(s);
    }), this.timelineChangeController_.on("fixBadTimelineChange", () => {
      this.logger_("Fix bad timeline change. Restarting al segment loaders..."), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
    }), this.mainSegmentLoader_.on("earlyabort", (n) => {
      this.bufferBasedABR || (this.delegateLoaders_("all", ["abort"]), this.excludePlaylist({
        error: {
          message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
        },
        playlistExclusionDuration: IV
      }));
    });
    const e = () => {
      if (!this.sourceUpdater_.hasCreatedSourceBuffers())
        return this.tryToCreateSourceBuffers_();
      const n = this.getCodecsOrExclude_();
      n && this.sourceUpdater_.addOrChangeSourceBuffers(n);
    };
    this.mainSegmentLoader_.on("trackinfo", e), this.audioSegmentLoader_.on("trackinfo", e), this.mainSegmentLoader_.on("fmp4", () => {
      this.triggeredFmp4Usage || (this.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), this.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("fmp4", () => {
      this.triggeredFmp4Usage || (this.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), this.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("ended", () => {
      this.logger_("audioSegmentLoader ended"), this.onEndOfStream();
    }), ["segmentselected", "segmentloadstart", "segmentloaded", "segmentkeyloadstart", "segmentkeyloadcomplete", "segmentdecryptionstart", "segmentdecryptioncomplete", "segmenttransmuxingstart", "segmenttransmuxingcomplete", "segmenttransmuxingtrackinfoavailable", "segmenttransmuxingtiminginfoavailable", "segmentappendstart", "appendsdone", "bandwidthupdated", "timelinechange", "codecschange"].forEach((n) => {
      this.mainSegmentLoader_.on(n, (s) => {
        this.player_.trigger(pi({}, s));
      }), this.audioSegmentLoader_.on(n, (s) => {
        this.player_.trigger(pi({}, s));
      }), this.subtitleSegmentLoader_.on(n, (s) => {
        this.player_.trigger(pi({}, s));
      });
    });
  }
  mediaSecondsLoaded_() {
    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
  }
  /**
   * Call load on our SegmentLoaders
   */
  load() {
    this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
  }
  /**
   * Call pause on our SegmentLoaders
   */
  pause() {
    this.mainSegmentLoader_.pause(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.pause(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.pause();
  }
  /**
   * Re-tune playback quality level for the current player
   * conditions. This method will perform destructive actions like removing
   * already buffered content in order to readjust the currently active
   * playlist quickly. This is good for manual quality changes
   *
   * @private
   */
  fastQualityChange_(e = this.selectPlaylist()) {
    if (e && e === this.mainPlaylistLoader_.media()) {
      this.logger_("skipping fastQualityChange because new media is same as old");
      return;
    }
    this.switchMedia_(e, "fast-quality"), this.waitingForFastQualityPlaylistReceived_ = !0;
  }
  runFastQualitySwitch_() {
    this.waitingForFastQualityPlaylistReceived_ = !1, this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
  }
  /**
   * Begin playback.
   */
  play() {
    if (this.setupFirstPlay())
      return;
    this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
    const e = this.tech_.seekable();
    if (this.tech_.duration() === 1 / 0 && this.tech_.currentTime() < e.start(0))
      return this.tech_.setCurrentTime(e.end(e.length - 1));
  }
  /**
   * Seek to the latest media position if this is a live video and the
   * player and video are loaded and initialized.
   */
  setupFirstPlay() {
    const e = this.mainPlaylistLoader_.media();
    if (!e || this.tech_.paused() || this.hasPlayed_)
      return !1;
    if (!e.endList || e.start) {
      const i = this.seekable();
      if (!i.length)
        return !1;
      const n = i.end(0);
      let s = n;
      if (e.start) {
        const r = e.start.timeOffset;
        r < 0 ? s = Math.max(n + r, i.start(0)) : s = Math.min(n, r);
      }
      this.trigger("firstplay"), this.tech_.setCurrentTime(s);
    }
    return this.hasPlayed_ = !0, this.load(), !0;
  }
  /**
   * handle the sourceopen event on the MediaSource
   *
   * @private
   */
  handleSourceOpen_() {
    if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
      const e = this.tech_.play();
      typeof e < "u" && typeof e.then == "function" && e.then(null, (i) => {
      });
    }
    this.trigger("sourceopen");
  }
  /**
   * handle the sourceended event on the MediaSource
   *
   * @private
   */
  handleSourceEnded_() {
    if (!this.inbandTextTracks_.metadataTrack_)
      return;
    const e = this.inbandTextTracks_.metadataTrack_.cues;
    if (!e || !e.length)
      return;
    const i = this.duration();
    e[e.length - 1].endTime = isNaN(i) || Math.abs(i) === 1 / 0 ? Number.MAX_VALUE : i;
  }
  /**
   * handle the durationchange event on the MediaSource
   *
   * @private
   */
  handleDurationChange_() {
    this.tech_.trigger("durationchange");
  }
  /**
   * Calls endOfStream on the media source when all active stream types have called
   * endOfStream
   *
   * @param {string} streamType
   *        Stream type of the segment loader that called endOfStream
   * @private
   */
  onEndOfStream() {
    let e = this.mainSegmentLoader_.ended_;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      const i = this.mainSegmentLoader_.getCurrentMediaInfo_();
      !i || i.hasVideo ? e = e && this.audioSegmentLoader_.ended_ : e = this.audioSegmentLoader_.ended_;
    }
    e && (this.stopABRTimer_(), this.sourceUpdater_.endOfStream());
  }
  /**
   * Check if a playlist has stopped being updated
   *
   * @param {Object} playlist the media playlist object
   * @return {boolean} whether the playlist has stopped being updated or not
   */
  stuckAtPlaylistEnd_(e) {
    if (!this.seekable().length)
      return !1;
    const n = this.syncController_.getExpiredTime(e, this.duration());
    if (n === null)
      return !1;
    const s = sr.Playlist.playlistEnd(e, n), r = this.tech_.currentTime(), a = this.tech_.buffered();
    if (!a.length)
      return s - r <= bs;
    const o = a.end(a.length - 1);
    return o - r <= bs && s - o <= bs;
  }
  /**
   * Exclude a playlist for a set amount of time, making it unavailable for selection by
   * the rendition selection algorithm, then force a new playlist (rendition) selection.
   *
   * @param {Object=} playlistToExclude
   *                  the playlist to exclude, defaults to the currently selected playlist
   * @param {Object=} error
   *                  an optional error
   * @param {number=} playlistExclusionDuration
   *                  an optional number of seconds to exclude the playlist
   */
  excludePlaylist({
    playlistToExclude: e = this.mainPlaylistLoader_.media(),
    error: i = {},
    playlistExclusionDuration: n
  }) {
    if (e = e || this.mainPlaylistLoader_.media(), n = n || i.playlistExclusionDuration || this.playlistExclusionDuration, !e) {
      this.error = i, this.mediaSource.readyState !== "open" ? this.trigger("error") : this.sourceUpdater_.endOfStream("network");
      return;
    }
    e.playlistErrors_++;
    const s = this.mainPlaylistLoader_.main.playlists, r = s.filter(vc), a = r.length === 1 && r[0] === e;
    if (s.length === 1 && n !== 1 / 0)
      return Ae.log.warn(`Problem encountered with playlist ${e.id}. Trying again since it is the only playlist.`), this.tech_.trigger("retryplaylist"), this.mainPlaylistLoader_.load(a);
    if (a) {
      if (this.main().contentSteering) {
        const p = this.pathwayAttribute_(e), h = this.contentSteeringController_.steeringManifest.ttl * 1e3;
        this.contentSteeringController_.excludePathway(p), this.excludeThenChangePathway_(), setTimeout(() => {
          this.contentSteeringController_.addAvailablePathway(p);
        }, h);
        return;
      }
      let m = !1;
      s.forEach((p) => {
        if (p === e)
          return;
        const h = p.excludeUntil;
        typeof h < "u" && h !== 1 / 0 && (m = !0, delete p.excludeUntil);
      }), m && (Ae.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"));
    }
    let o;
    e.playlistErrors_ > this.maxPlaylistRetries ? o = 1 / 0 : o = Date.now() + n * 1e3, e.excludeUntil = o, i.reason && (e.lastExcludeReason_ = i.reason), this.tech_.trigger("excludeplaylist"), this.tech_.trigger({
      type: "usage",
      name: "vhs-rendition-excluded"
    });
    const l = this.selectPlaylist();
    if (!l) {
      this.error = "Playback cannot continue. No available working or supported playlists.", this.trigger("error");
      return;
    }
    const u = i.internal ? this.logger_ : Ae.log.warn, d = i.message ? " " + i.message : "";
    u(`${i.internal ? "Internal problem" : "Problem"} encountered with playlist ${e.id}.${d} Switching to playlist ${l.id}.`), l.attributes.AUDIO !== e.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), l.attributes.SUBTITLES !== e.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
    const c = l.targetDuration / 2 * 1e3 || 5 * 1e3, A = typeof l.lastRequest == "number" && Date.now() - l.lastRequest <= c;
    return this.switchMedia_(l, "exclude", a || A);
  }
  /**
   * Pause all segment/playlist loaders
   */
  pauseLoading() {
    this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_();
  }
  /**
   * Call a set of functions in order on playlist loaders, segment loaders,
   * or both types of loaders.
   *
   * @param {string} filter
   *        Filter loaders that should call fnNames using a string. Can be:
   *        * all - run on all loaders
   *        * audio - run on all audio loaders
   *        * subtitle - run on all subtitle loaders
   *        * main - run on the main loaders
   *
   * @param {Array|string} fnNames
   *        A string or array of function names to call.
   */
  delegateLoaders_(e, i) {
    const n = [], s = e === "all";
    (s || e === "main") && n.push(this.mainPlaylistLoader_);
    const r = [];
    (s || e === "audio") && r.push("AUDIO"), (s || e === "subtitle") && (r.push("CLOSED-CAPTIONS"), r.push("SUBTITLES")), r.forEach((a) => {
      const o = this.mediaTypes_[a] && this.mediaTypes_[a].activePlaylistLoader;
      o && n.push(o);
    }), ["main", "audio", "subtitle"].forEach((a) => {
      const o = this[`${a}SegmentLoader_`];
      o && (e === a || e === "all") && n.push(o);
    }), n.forEach((a) => i.forEach((o) => {
      typeof a[o] == "function" && a[o]();
    }));
  }
  /**
   * set the current time on all segment loaders
   *
   * @param {TimeRange} currentTime the current time to set
   * @return {TimeRange} the current time
   */
  setCurrentTime(e) {
    const i = Ea(this.tech_.buffered(), e);
    if (!(this.mainPlaylistLoader_ && this.mainPlaylistLoader_.media()) || !this.mainPlaylistLoader_.media().segments)
      return 0;
    if (i && i.length)
      return e;
    this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
  }
  /**
   * get the current duration
   *
   * @return {TimeRange} the duration
   */
  duration() {
    if (!this.mainPlaylistLoader_)
      return 0;
    const e = this.mainPlaylistLoader_.media();
    return e ? e.endList ? this.mediaSource ? this.mediaSource.duration : sr.Playlist.duration(e) : 1 / 0 : 0;
  }
  /**
   * check the seekable range
   *
   * @return {TimeRange} the seekable range
   */
  seekable() {
    return this.seekable_;
  }
  getSeekableRange_(e, i) {
    const n = e.media();
    if (!n)
      return null;
    const s = this.syncController_.getMediaSequenceSync(i);
    if (s && s.isReliable) {
      const o = s.start, l = s.end;
      if (!isFinite(o) || !isFinite(l))
        return null;
      const u = sr.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, n), d = Math.max(o, l - u);
      return ki([[o, d]]);
    }
    const r = this.syncController_.getExpiredTime(n, this.duration());
    if (r === null)
      return null;
    const a = sr.Playlist.seekable(n, r, sr.Playlist.liveEdgeDelay(this.mainPlaylistLoader_.main, n));
    return a.length ? a : null;
  }
  computeFinalSeekable_(e, i) {
    if (!i)
      return e;
    const n = e.start(0), s = e.end(0), r = i.start(0), a = i.end(0);
    return r > s || n > a ? e : ki([[Math.max(n, r), Math.min(s, a)]]);
  }
  onSyncInfoUpdate_() {
    if (!this.mainPlaylistLoader_)
      return;
    const e = this.getSeekableRange_(this.mainPlaylistLoader_, "main");
    if (!e)
      return;
    let i;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader && (i = this.getSeekableRange_(this.mediaTypes_.AUDIO.activePlaylistLoader, "audio"), !i))
      return;
    const n = this.seekable_;
    if (this.seekable_ = this.computeFinalSeekable_(e, i), !this.seekable_ || n && n.length && this.seekable_.length && n.start(0) === this.seekable_.start(0) && n.end(0) === this.seekable_.end(0))
      return;
    this.logger_(`seekable updated [${Rw(this.seekable_)}]`);
    const s = {
      seekableRanges: this.seekable_
    };
    this.trigger({
      type: "seekablerangeschanged",
      metadata: s
    }), this.tech_.trigger("seekablechanged");
  }
  /**
   * Update the player duration
   */
  updateDuration(e) {
    if (this.updateDuration_ && (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.updateDuration_ = null), this.mediaSource.readyState !== "open") {
      this.updateDuration_ = this.updateDuration.bind(this, e), this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
      return;
    }
    if (e) {
      const s = this.seekable();
      if (!s.length)
        return;
      (isNaN(this.mediaSource.duration) || this.mediaSource.duration < s.end(s.length - 1)) && this.sourceUpdater_.setDuration(s.end(s.length - 1));
      return;
    }
    const i = this.tech_.buffered();
    let n = sr.Playlist.duration(this.mainPlaylistLoader_.media());
    i.length > 0 && (n = Math.max(n, i.end(i.length - 1))), this.mediaSource.duration !== n && this.sourceUpdater_.setDuration(n);
  }
  /**
   * dispose of the PlaylistController and everything
   * that it controls
   */
  dispose() {
    this.trigger("dispose"), this.decrypter_.terminate(), this.mainPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.contentSteeringController_.dispose(), this.keyStatusMap_.clear(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach((e) => {
      const i = this.mediaTypes_[e].groups;
      for (const n in i)
        i[n].forEach((s) => {
          s.playlistLoader && s.playlistLoader.dispose();
        });
    }), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off();
  }
  /**
   * return the main playlist object if we have one
   *
   * @return {Object} the main playlist object that we parsed
   */
  main() {
    return this.mainPlaylistLoader_.main;
  }
  /**
   * return the currently selected playlist
   *
   * @return {Object} the currently selected playlist object that we parsed
   */
  media() {
    return this.mainPlaylistLoader_.media() || this.initialMedia_;
  }
  areMediaTypesKnown_() {
    const e = !!this.mediaTypes_.AUDIO.activePlaylistLoader, i = !!this.mainSegmentLoader_.getCurrentMediaInfo_(), n = e ? !!this.audioSegmentLoader_.getCurrentMediaInfo_() : !0;
    return !(!i || !n);
  }
  // find from and to for codec switch event
  getCodecsOrExclude_() {
    const e = {
      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
    }, i = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media();
    e.video = e.main;
    const n = wl(this.main(), i), s = {}, r = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
    if (e.main.hasVideo && (s.video = n.video || e.main.videoCodec || w6), e.main.isMuxed && (s.video += `,${n.audio || e.main.audioCodec || Ug}`), (e.main.hasAudio && !e.main.isMuxed || e.audio.hasAudio || r) && (s.audio = n.audio || e.main.audioCodec || e.audio.audioCodec || Ug, e.audio.isFmp4 = e.main.hasAudio && !e.main.isMuxed ? e.main.isFmp4 : e.audio.isFmp4), !s.audio && !s.video) {
      this.excludePlaylist({
        playlistToExclude: i,
        error: {
          message: "Could not determine codecs for playlist."
        },
        playlistExclusionDuration: 1 / 0
      });
      return;
    }
    const a = (u, d) => u ? Al(d, this.usingManagedMediaSource_) : Mf(d), o = {};
    let l;
    if (["video", "audio"].forEach(function(u) {
      if (s.hasOwnProperty(u) && !a(e[u].isFmp4, s[u])) {
        const d = e[u].isFmp4 ? "browser" : "muxer";
        o[d] = o[d] || [], o[d].push(s[u]), u === "audio" && (l = d);
      }
    }), r && l && i.attributes.AUDIO) {
      const u = i.attributes.AUDIO;
      this.main().playlists.forEach((d) => {
        (d.attributes && d.attributes.AUDIO) === u && d !== i && (d.excludeUntil = 1 / 0);
      }), this.logger_(`excluding audio group ${u} as ${l} does not support codec(s): "${s.audio}"`);
    }
    if (Object.keys(o).length) {
      const u = Object.keys(o).reduce((d, c) => (d && (d += ", "), d += `${c} does not support codec(s): "${o[c].join(",")}"`, d), "") + ".";
      this.excludePlaylist({
        playlistToExclude: i,
        error: {
          internal: !0,
          message: u
        },
        playlistExclusionDuration: 1 / 0
      });
      return;
    }
    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
      const u = [];
      if (["video", "audio"].forEach((d) => {
        const c = (cs(this.sourceUpdater_.codecs[d] || "")[0] || {}).type, A = (cs(s[d] || "")[0] || {}).type;
        c && A && c.toLowerCase() !== A.toLowerCase() && u.push(`"${this.sourceUpdater_.codecs[d]}" -> "${s[d]}"`);
      }), u.length) {
        this.excludePlaylist({
          playlistToExclude: i,
          error: {
            message: `Codec switching not supported: ${u.join(", ")}.`,
            internal: !0
          },
          playlistExclusionDuration: 1 / 0
        });
        return;
      }
    }
    return s;
  }
  /**
   * Create source buffers and exlude any incompatible renditions.
   *
   * @private
   */
  tryToCreateSourceBuffers_() {
    if (this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers() || !this.areMediaTypesKnown_())
      return;
    const e = this.getCodecsOrExclude_();
    if (!e)
      return;
    this.sourceUpdater_.createSourceBuffers(e);
    const i = [e.video, e.audio].filter(Boolean).join(",");
    this.excludeIncompatibleVariants_(i);
  }
  /**
   * Excludes playlists with codecs that are unsupported by the muxer and browser.
   */
  excludeUnsupportedVariants_() {
    const e = this.main().playlists, i = [];
    Object.keys(e).forEach((n) => {
      const s = e[n];
      if (i.indexOf(s.id) !== -1)
        return;
      i.push(s.id);
      const r = wl(this.main, s), a = [];
      r.audio && !Mf(r.audio) && !Al(r.audio, this.usingManagedMediaSource_) && a.push(`audio codec ${r.audio}`), r.video && !Mf(r.video) && !Al(r.video, this.usingManagedMediaSource_) && a.push(`video codec ${r.video}`), r.text && r.text === "stpp.ttml.im1t" && a.push(`text codec ${r.text}`), a.length && (s.excludeUntil = 1 / 0, this.logger_(`excluding ${s.id} for unsupported: ${a.join(", ")}`));
    });
  }
  /**
   * Exclude playlists that are known to be codec or
   * stream-incompatible with the SourceBuffer configuration. For
   * instance, Media Source Extensions would cause the video element to
   * stall waiting for video data if you switched from a variant with
   * video and audio to an audio-only one.
   *
   * @param {Object} media a media playlist compatible with the current
   * set of SourceBuffers. Variants in the current main playlist that
   * do not appear to have compatible codec or stream configurations
   * will be excluded from the default playlist selection algorithm
   * indefinitely.
   * @private
   */
  excludeIncompatibleVariants_(e) {
    const i = [], n = this.main().playlists, s = Ml(cs(e)), r = Bv(s), a = s.video && cs(s.video)[0] || null, o = s.audio && cs(s.audio)[0] || null;
    Object.keys(n).forEach((l) => {
      const u = n[l];
      if (i.indexOf(u.id) !== -1 || u.excludeUntil === 1 / 0)
        return;
      i.push(u.id);
      const d = [], c = wl(this.mainPlaylistLoader_.main, u), A = Bv(c);
      if (!(!c.audio && !c.video)) {
        if (A !== r && d.push(`codec count "${A}" !== "${r}"`), !this.sourceUpdater_.canChangeType()) {
          const m = c.video && cs(c.video)[0] || null, p = c.audio && cs(c.audio)[0] || null;
          m && a && m.type.toLowerCase() !== a.type.toLowerCase() && d.push(`video codec "${m.type}" !== "${a.type}"`), p && o && p.type.toLowerCase() !== o.type.toLowerCase() && d.push(`audio codec "${p.type}" !== "${o.type}"`);
        }
        d.length && (u.excludeUntil = 1 / 0, this.logger_(`excluding ${u.id}: ${d.join(" && ")}`));
      }
    });
  }
  updateAdCues_(e) {
    let i = 0;
    const n = this.seekable();
    n.length && (i = n.start(0)), fV(e, this.cueTagsTrack_, i);
  }
  /**
   * Calculates the desired forward buffer length based on current time
   *
   * @return {number} Desired forward buffer length in seconds
   */
  goalBufferLength() {
    const e = this.tech_.currentTime(), i = Si.GOAL_BUFFER_LENGTH, n = Si.GOAL_BUFFER_LENGTH_RATE, s = Math.max(i, Si.MAX_GOAL_BUFFER_LENGTH);
    return Math.min(i + e * n, s);
  }
  /**
   * Calculates the desired buffer low water line based on current time
   *
   * @return {number} Desired buffer low water line in seconds
   */
  bufferLowWaterLine() {
    const e = this.tech_.currentTime(), i = Si.BUFFER_LOW_WATER_LINE, n = Si.BUFFER_LOW_WATER_LINE_RATE, s = Math.max(i, Si.MAX_BUFFER_LOW_WATER_LINE), r = Math.max(i, Si.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
    return Math.min(i + e * n, this.bufferBasedABR ? r : s);
  }
  bufferHighWaterLine() {
    return Si.BUFFER_HIGH_WATER_LINE;
  }
  addDateRangesToTextTrack_(e) {
    qv(this.inbandTextTracks_, "com.apple.streaming", this.tech_), YU({
      inbandTextTracks: this.inbandTextTracks_,
      dateRanges: e
    });
  }
  addMetadataToTextTrack(e, i, n) {
    const s = this.sourceUpdater_.videoBuffer ? this.sourceUpdater_.videoTimestampOffset() : this.sourceUpdater_.audioTimestampOffset();
    qv(this.inbandTextTracks_, e, this.tech_), qU({
      inbandTextTracks: this.inbandTextTracks_,
      metadataArray: i,
      timestampOffset: s,
      videoDuration: n
    });
  }
  /**
   * Utility for getting the pathway or service location from an HLS or DASH playlist.
   *
   * @param {Object} playlist for getting pathway from.
   * @return the pathway attribute of a playlist
   */
  pathwayAttribute_(e) {
    return e.attributes["PATHWAY-ID"] || e.attributes.serviceLocation;
  }
  /**
   * Initialize available pathways and apply the tag properties.
   */
  initContentSteeringController_() {
    const e = this.main();
    if (e.contentSteering) {
      for (const i of e.playlists)
        this.contentSteeringController_.addAvailablePathway(this.pathwayAttribute_(i));
      if (this.contentSteeringController_.assignTagProperties(e.uri, e.contentSteering), this.contentSteeringController_.queryBeforeStart) {
        this.contentSteeringController_.requestSteeringManifest(!0);
        return;
      }
      this.tech_.one("canplay", () => {
        this.contentSteeringController_.requestSteeringManifest();
      });
    }
  }
  /**
   * Reset the content steering controller and re-init.
   */
  resetContentSteeringController_() {
    this.contentSteeringController_.clearAvailablePathways(), this.contentSteeringController_.dispose(), this.initContentSteeringController_();
  }
  /**
   * Attaches the listeners for content steering.
   */
  attachContentSteeringListeners_() {
    this.contentSteeringController_.on("content-steering", this.excludeThenChangePathway_.bind(this)), ["contentsteeringloadstart", "contentsteeringloadcomplete", "contentsteeringparsed"].forEach((i) => {
      this.contentSteeringController_.on(i, (n) => {
        this.trigger(pi({}, n));
      });
    }), this.sourceType_ === "dash" && this.mainPlaylistLoader_.on("loadedplaylist", () => {
      const i = this.main();
      (this.contentSteeringController_.didDASHTagChange(i.uri, i.contentSteering) || (() => {
        const r = this.contentSteeringController_.getAvailablePathways(), a = [];
        for (const o of i.playlists) {
          const l = o.attributes.serviceLocation;
          if (l && (a.push(l), !r.has(l)))
            return !0;
        }
        return !!(!a.length && r.size);
      })()) && this.resetContentSteeringController_();
    });
  }
  /**
   * Simple exclude and change playlist logic for content steering.
   */
  excludeThenChangePathway_() {
    const e = this.contentSteeringController_.getPathway();
    if (!e)
      return;
    this.handlePathwayClones_();
    const n = this.main().playlists, s = /* @__PURE__ */ new Set();
    let r = !1;
    Object.keys(n).forEach((a) => {
      const o = n[a], l = this.pathwayAttribute_(o), u = l && e !== l;
      o.excludeUntil === 1 / 0 && o.lastExcludeReason_ === "content-steering" && !u && (delete o.excludeUntil, delete o.lastExcludeReason_, r = !0);
      const c = !o.excludeUntil && o.excludeUntil !== 1 / 0;
      !s.has(o.id) && u && c && (s.add(o.id), o.excludeUntil = 1 / 0, o.lastExcludeReason_ = "content-steering", this.logger_(`excluding ${o.id} for ${o.lastExcludeReason_}`));
    }), this.contentSteeringController_.manifestType_ === "DASH" && Object.keys(this.mediaTypes_).forEach((a) => {
      const o = this.mediaTypes_[a];
      if (o.activePlaylistLoader) {
        const l = o.activePlaylistLoader.media_;
        l && l.attributes.serviceLocation !== e && (r = !0);
      }
    }), r && this.changeSegmentPathway_();
  }
  /**
   * Add, update, or delete playlists and media groups for
   * the pathway clones for HLS Content Steering.
   *
   * See https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/
   *
   * NOTE: Pathway cloning does not currently support the `PER_VARIANT_URIS` and
   * `PER_RENDITION_URIS` as we do not handle `STABLE-VARIANT-ID` or
   * `STABLE-RENDITION-ID` values.
   */
  handlePathwayClones_() {
    const i = this.main().playlists, n = this.contentSteeringController_.currentPathwayClones, s = this.contentSteeringController_.nextPathwayClones;
    if (n && n.size || s && s.size) {
      for (const [a, o] of n.entries())
        s.get(a) || (this.mainPlaylistLoader_.updateOrDeleteClone(o), this.contentSteeringController_.excludePathway(a));
      for (const [a, o] of s.entries()) {
        const l = n.get(a);
        if (!l) {
          i.filter((d) => d.attributes["PATHWAY-ID"] === o["BASE-ID"]).forEach((d) => {
            this.mainPlaylistLoader_.addClonePathway(o, d);
          }), this.contentSteeringController_.addAvailablePathway(a);
          continue;
        }
        this.equalPathwayClones_(l, o) || (this.mainPlaylistLoader_.updateOrDeleteClone(o, !0), this.contentSteeringController_.addAvailablePathway(a));
      }
      this.contentSteeringController_.currentPathwayClones = new Map(JSON.parse(JSON.stringify([...s])));
    }
  }
  /**
   * Determines whether two pathway clone objects are equivalent.
   *
   * @param {Object} a The first pathway clone object.
   * @param {Object} b The second pathway clone object.
   * @return {boolean} True if the pathway clone objects are equal, false otherwise.
   */
  equalPathwayClones_(e, i) {
    if (e["BASE-ID"] !== i["BASE-ID"] || e.ID !== i.ID || e["URI-REPLACEMENT"].HOST !== i["URI-REPLACEMENT"].HOST)
      return !1;
    const n = e["URI-REPLACEMENT"].PARAMS, s = i["URI-REPLACEMENT"].PARAMS;
    for (const r in n)
      if (n[r] !== s[r])
        return !1;
    for (const r in s)
      if (n[r] !== s[r])
        return !1;
    return !0;
  }
  /**
   * Changes the current playlists for audio, video and subtitles after a new pathway
   * is chosen from content steering.
   */
  changeSegmentPathway_() {
    const e = this.selectPlaylist();
    this.pauseLoading(), this.contentSteeringController_.manifestType_ === "DASH" && this.switchMediaForDASHContentSteering_(), this.switchMedia_(e, "content-steering");
  }
  /**
   * Iterates through playlists and check their keyId set and compare with the
   * keyStatusMap, only enable playlists that have a usable key. If the playlist
   * has no keyId leave it enabled by default.
   */
  excludeNonUsablePlaylistsByKeyId_() {
    if (!this.mainPlaylistLoader_ || !this.mainPlaylistLoader_.main)
      return;
    let e = 0;
    const i = "non-usable";
    this.mainPlaylistLoader_.main.playlists.forEach((n) => {
      const s = this.mainPlaylistLoader_.getKeyIdSet(n);
      !s || !s.size || s.forEach((r) => {
        const a = "usable", o = this.keyStatusMap_.has(r) && this.keyStatusMap_.get(r) === a, l = n.lastExcludeReason_ === i && n.excludeUntil === 1 / 0;
        o ? o && l && (delete n.excludeUntil, delete n.lastExcludeReason_, this.logger_(`enabling playlist ${n.id} because key ID ${r} is ${a}`)) : (n.excludeUntil !== 1 / 0 && n.lastExcludeReason_ !== i && (n.excludeUntil = 1 / 0, n.lastExcludeReason_ = i, this.logger_(`excluding playlist ${n.id} because the key ID ${r} doesn't exist in the keyStatusMap or is not ${a}`)), e++);
      });
    }), e >= this.mainPlaylistLoader_.main.playlists.length && this.mainPlaylistLoader_.main.playlists.forEach((n) => {
      const s = n && n.attributes && n.attributes.RESOLUTION && n.attributes.RESOLUTION.height < 720, r = n.excludeUntil === 1 / 0 && n.lastExcludeReason_ === i;
      s && r && (delete n.excludeUntil, Ae.log.warn(`enabling non-HD playlist ${n.id} because all playlists were excluded due to ${i} key IDs`));
    });
  }
  /**
   * Adds a keystatus to the keystatus map, tries to convert to string if necessary.
   *
   * @param {any} keyId the keyId to add a status for
   * @param {string} status the status of the keyId
   */
  addKeyStatus_(e, i) {
    const r = (typeof e == "string" ? e : lV(e)).slice(0, 32).toLowerCase();
    this.logger_(`KeyStatus '${i}' with key ID ${r} added to the keyStatusMap`), this.keyStatusMap_.set(r, i);
  }
  /**
   * Utility function for adding key status to the keyStatusMap and filtering usable encrypted playlists.
   *
   * @param {any} keyId the keyId from the keystatuschange event
   * @param {string} status the key status string
   */
  updatePlaylistByKeyStatus(e, i) {
    this.addKeyStatus_(e, i), this.waitingForFastQualityPlaylistReceived_ || this.excludeNonUsableThenChangePlaylist_(), this.mainPlaylistLoader_.off("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this)), this.mainPlaylistLoader_.on("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this));
  }
  excludeNonUsableThenChangePlaylist_() {
    this.excludeNonUsablePlaylistsByKeyId_(), this.fastQualityChange_();
  }
}
const NV = (t, e, i) => (n) => {
  const s = t.main.playlists[e], r = vm(s), a = vc(s);
  if (typeof n > "u")
    return a;
  n ? delete s.disabled : s.disabled = !0;
  const o = {
    renditionInfo: {
      id: e,
      bandwidth: s.attributes.BANDWIDTH,
      resolution: s.attributes.RESOLUTION,
      codecs: s.attributes.CODECS
    },
    cause: "fast-quality"
  };
  return n !== a && !r && (n ? (i(s), t.trigger({
    type: "renditionenabled",
    metadata: o
  })) : t.trigger({
    type: "renditiondisabled",
    metadata: o
  })), n;
};
class RV {
  constructor(e, i, n) {
    const {
      playlistController_: s
    } = e, r = s.fastQualityChange_.bind(s);
    if (i.attributes) {
      const a = i.attributes.RESOLUTION;
      this.width = a && a.width, this.height = a && a.height, this.bandwidth = i.attributes.BANDWIDTH, this.frameRate = i.attributes["FRAME-RATE"];
    }
    this.codecs = wl(s.main(), i), this.playlist = i, this.id = n, this.enabled = NV(e.playlists, i.id, r);
  }
}
const FV = function(t) {
  t.representations = () => {
    const e = t.playlistController_.main(), i = Zl(e) ? t.playlistController_.getAudioTrackPlaylists_() : e.playlists;
    return i ? i.filter((n) => !vm(n)).map((n, s) => new RV(t, n, n.id)) : [];
  };
}, $v = ["seeking", "seeked", "pause", "playing", "error"];
class zV extends Ae.EventTarget {
  /**
   * Represents an PlaybackWatcher object.
   *
   * @class
   * @param {Object} options an object that includes the tech and settings
   */
  constructor(e) {
    super(), this.playlistController_ = e.playlistController, this.tech_ = e.tech, this.seekable = e.seekable, this.allowSeeksWithinUnsafeLiveWindow = e.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = e.liveRangeSafeTimeDelta, this.media = e.media, this.playedRanges_ = [], this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = Fn("PlaybackWatcher"), this.logger_("initialize");
    const i = () => this.monitorCurrentTime_(), n = () => this.monitorCurrentTime_(), s = () => this.techWaiting_(), r = () => this.resetTimeUpdate_(), a = this.playlistController_, o = ["main", "subtitle", "audio"], l = {};
    o.forEach((d) => {
      l[d] = {
        reset: () => this.resetSegmentDownloads_(d),
        updateend: () => this.checkSegmentDownloads_(d)
      }, a[`${d}SegmentLoader_`].on("appendsdone", l[d].updateend), a[`${d}SegmentLoader_`].on("playlistupdate", l[d].reset), this.tech_.on(["seeked", "seeking"], l[d].reset);
    });
    const u = (d) => {
      ["main", "audio"].forEach((c) => {
        a[`${c}SegmentLoader_`][d]("appended", this.seekingAppendCheck_);
      });
    };
    this.seekingAppendCheck_ = () => {
      this.fixesBadSeeks_() && (this.consecutiveUpdates = 0, this.lastRecordedTime = this.tech_.currentTime(), u("off"));
    }, this.clearSeekingAppendCheck_ = () => u("off"), this.watchForBadSeeking_ = () => {
      this.clearSeekingAppendCheck_(), u("on");
    }, this.tech_.on("seeked", this.clearSeekingAppendCheck_), this.tech_.on("seeking", this.watchForBadSeeking_), this.tech_.on("waiting", s), this.tech_.on($v, r), this.tech_.on("canplay", n), this.tech_.one("play", i), this.dispose = () => {
      this.clearSeekingAppendCheck_(), this.logger_("dispose"), this.tech_.off("waiting", s), this.tech_.off($v, r), this.tech_.off("canplay", n), this.tech_.off("play", i), this.tech_.off("seeking", this.watchForBadSeeking_), this.tech_.off("seeked", this.clearSeekingAppendCheck_), o.forEach((d) => {
        a[`${d}SegmentLoader_`].off("appendsdone", l[d].updateend), a[`${d}SegmentLoader_`].off("playlistupdate", l[d].reset), this.tech_.off(["seeked", "seeking"], l[d].reset);
      }), this.checkCurrentTimeTimeout_ && ne.clearTimeout(this.checkCurrentTimeTimeout_), this.resetTimeUpdate_();
    };
  }
  /**
   * Periodically check current time to see if playback stopped
   *
   * @private
   */
  monitorCurrentTime_() {
    this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && ne.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = ne.setTimeout(this.monitorCurrentTime_.bind(this), 250);
  }
  /**
   * Reset stalled download stats for a specific type of loader
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#playlistupdate
   * @listens Tech#seeking
   * @listens Tech#seeked
   */
  resetSegmentDownloads_(e) {
    const i = this.playlistController_[`${e}SegmentLoader_`];
    this[`${e}StalledDownloads_`] > 0 && this.logger_(`resetting possible stalled download count for ${e} loader`), this[`${e}StalledDownloads_`] = 0, this[`${e}Buffered_`] = i.buffered_();
  }
  /**
   * Checks on every segment `appendsdone` to see
   * if segment appends are making progress. If they are not
   * and we are still downloading bytes. We exclude the playlist.
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#appendsdone
   */
  checkSegmentDownloads_(e) {
    const i = this.playlistController_, n = i[`${e}SegmentLoader_`], s = n.buffered_(), r = Sz(this[`${e}Buffered_`], s);
    if (this[`${e}Buffered_`] = s, r) {
      const a = {
        bufferedRanges: s
      };
      i.trigger({
        type: "bufferedrangeschanged",
        metadata: a
      }), this.resetSegmentDownloads_(e);
      return;
    }
    this[`${e}StalledDownloads_`]++, this.logger_(`found #${this[`${e}StalledDownloads_`]} ${e} appends that did not increase buffer (possible stalled download)`, {
      playlistId: n.playlist_ && n.playlist_.id,
      buffered: qr(s)
    }), !(this[`${e}StalledDownloads_`] < 10) && (this.logger_(`${e} loader stalled download exclusion`), this.resetSegmentDownloads_(e), this.tech_.trigger({
      type: "usage",
      name: `vhs-${e}-download-exclusion`
    }), e !== "subtitle" && i.excludePlaylist({
      error: {
        message: `Excessive ${e} segment downloading detected.`
      },
      playlistExclusionDuration: 1 / 0
    }));
  }
  /**
   * The purpose of this function is to emulate the "waiting" event on
   * browsers that do not emit it when they are waiting for more
   * data to continue playback
   *
   * @private
   */
  checkCurrentTime_() {
    if (this.tech_.paused() || this.tech_.seeking())
      return;
    const e = this.tech_.currentTime(), i = this.tech_.buffered();
    if (this.lastRecordedTime === e && (!i.length || e + bs >= i.end(i.length - 1)))
      return this.techWaiting_();
    if (this.consecutiveUpdates >= 5 && e === this.lastRecordedTime)
      this.consecutiveUpdates++, this.waiting_();
    else if (e === this.lastRecordedTime)
      this.consecutiveUpdates++;
    else {
      this.playedRanges_.push(ki([this.lastRecordedTime, e]));
      const n = {
        playedRanges: this.playedRanges_
      };
      this.playlistController_.trigger({
        type: "playedrangeschanged",
        metadata: n
      }), this.consecutiveUpdates = 0, this.lastRecordedTime = e;
    }
  }
  /**
   * Resets the 'timeupdate' mechanism designed to detect that we are stalled
   *
   * @private
   */
  resetTimeUpdate_() {
    this.consecutiveUpdates = 0;
  }
  /**
   * Fixes situations where there's a bad seek
   *
   * @return {boolean} whether an action was taken to fix the seek
   * @private
   */
  fixesBadSeeks_() {
    if (!this.tech_.seeking())
      return !1;
    const i = this.seekable(), n = this.tech_.currentTime(), s = this.afterSeekableWindow_(i, n, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
    let r;
    if (s && (r = i.end(i.length - 1)), this.beforeSeekableWindow_(i, n)) {
      const p = i.start(0);
      r = p + // if the playlist is too short and the seekable range is an exact time (can
      // happen in live with a 3 segment playlist), then don't use a time delta
      (p === i.end(0) ? 0 : bs);
    }
    if (typeof r < "u")
      return this.logger_(`Trying to seek outside of seekable at time ${n} with seekable range ${Rw(i)}. Seeking to ${r}.`), this.tech_.setCurrentTime(r), !0;
    const a = this.playlistController_.sourceUpdater_, o = this.tech_.buffered(), l = a.audioBuffer ? a.audioBuffered() : null, u = a.videoBuffer ? a.videoBuffered() : null, d = this.media(), c = d.partTargetDuration ? d.partTargetDuration : (d.targetDuration - ys) * 2, A = [l, u];
    for (let p = 0; p < A.length; p++) {
      if (!A[p])
        continue;
      if (Am(A[p], n) < c)
        return !1;
    }
    const m = Mu(o, n);
    return m.length === 0 ? !1 : (r = m.start(0) + bs, this.logger_(`Buffered region starts (${m.start(0)})  just beyond seek point (${n}). Seeking to ${r}.`), this.tech_.setCurrentTime(r), !0);
  }
  /**
   * Handler for situations when we determine the player is waiting.
   *
   * @private
   */
  waiting_() {
    if (this.techWaiting_())
      return;
    const e = this.tech_.currentTime(), i = this.tech_.buffered(), n = Ea(i, e);
    if (n.length && e + 3 <= n.end(0)) {
      this.resetTimeUpdate_(), this.tech_.setCurrentTime(e), this.logger_(`Stopped at ${e} while inside a buffered region [${n.start(0)} -> ${n.end(0)}]. Attempting to resume playback by seeking to the current time.`), this.tech_.trigger({
        type: "usage",
        name: "vhs-unknown-waiting"
      });
      return;
    }
  }
  /**
   * Handler for situations when the tech fires a `waiting` event
   *
   * @return {boolean}
   *         True if an action (or none) was needed to correct the waiting. False if no
   *         checks passed
   * @private
   */
  techWaiting_() {
    const e = this.seekable(), i = this.tech_.currentTime();
    if (this.tech_.seeking())
      return !0;
    if (this.beforeSeekableWindow_(e, i)) {
      const o = e.end(e.length - 1);
      return this.logger_(`Fell out of live window at time ${i}. Seeking to live point (seekable end) ${o}`), this.resetTimeUpdate_(), this.tech_.setCurrentTime(o), this.tech_.trigger({
        type: "usage",
        name: "vhs-live-resync"
      }), !0;
    }
    const n = this.tech_.vhs.playlistController_.sourceUpdater_, s = this.tech_.buffered();
    if (this.videoUnderflow_({
      audioBuffered: n.audioBuffered(),
      videoBuffered: n.videoBuffered(),
      currentTime: i
    }))
      return this.resetTimeUpdate_(), this.tech_.setCurrentTime(i), this.tech_.trigger({
        type: "usage",
        name: "vhs-video-underflow"
      }), !0;
    const a = Mu(s, i);
    return a.length > 0 ? (this.logger_(`Stopped at ${i} and seeking to ${a.start(0)}`), this.resetTimeUpdate_(), this.skipTheGap_(i), !0) : !1;
  }
  afterSeekableWindow_(e, i, n, s = !1) {
    if (!e.length)
      return !1;
    let r = e.end(e.length - 1) + bs;
    const a = !n.endList, o = typeof n.partTargetDuration == "number";
    return a && (o || s) && (r = e.end(e.length - 1) + n.targetDuration * 3), i > r;
  }
  beforeSeekableWindow_(e, i) {
    return !!(e.length && // can't fall before 0 and 0 seekable start identifies VOD stream
    e.start(0) > 0 && i < e.start(0) - this.liveRangeSafeTimeDelta);
  }
  videoUnderflow_({
    videoBuffered: e,
    audioBuffered: i,
    currentTime: n
  }) {
    if (!e)
      return;
    let s;
    if (e.length && i.length) {
      const r = Ea(e, n - 3), a = Ea(e, n), o = Ea(i, n);
      o.length && !a.length && r.length && (s = {
        start: r.end(0),
        end: o.end(0)
      });
    } else
      Mu(e, n).length || (s = this.gapFromVideoUnderflow_(e, n));
    return s ? (this.logger_(`Encountered a gap in video from ${s.start} to ${s.end}. Seeking to current time ${n}`), !0) : !1;
  }
  /**
   * Timer callback. If playback still has not proceeded, then we seek
   * to the start of the next buffered region.
   *
   * @private
   */
  skipTheGap_(e) {
    const i = this.tech_.buffered(), n = this.tech_.currentTime(), s = Mu(i, n);
    if (this.resetTimeUpdate_(), s.length === 0 || n !== e)
      return;
    this.logger_("skipTheGap_:", "currentTime:", n, "scheduled currentTime:", e, "nextRange start:", s.start(0)), this.tech_.setCurrentTime(s.start(0) + ys);
    const r = {
      gapInfo: {
        from: n,
        to: s.start(0)
      }
    };
    this.playlistController_.trigger({
      type: "gapjumped",
      metadata: r
    }), this.tech_.trigger({
      type: "usage",
      name: "vhs-gap-skip"
    });
  }
  gapFromVideoUnderflow_(e, i) {
    const n = wz(e);
    for (let s = 0; s < n.length; s++) {
      const r = n.start(s), a = n.end(s);
      if (i - r < 4 && i - r > 2)
        return {
          start: r,
          end: a
        };
    }
    return null;
  }
}
const UV = {
  errorInterval: 30,
  getSource(t) {
    const i = this.tech({
      IWillNotUseThisInPlugins: !0
    }).currentSource_ || this.currentSource();
    return t(i);
  }
}, _1 = function(t, e) {
  let i = 0, n = 0;
  const s = _t(UV, e);
  t.ready(() => {
    t.trigger({
      type: "usage",
      name: "vhs-error-reload-initialized"
    });
  });
  const r = function() {
    n && t.currentTime(n);
  }, a = function(d) {
    d != null && (n = t.duration() !== 1 / 0 && t.currentTime() || 0, t.one("loadedmetadata", r), t.src(d), t.trigger({
      type: "usage",
      name: "vhs-error-reload"
    }), t.play());
  }, o = function() {
    if (Date.now() - i < s.errorInterval * 1e3) {
      t.trigger({
        type: "usage",
        name: "vhs-error-reload-canceled"
      });
      return;
    }
    if (!s.getSource || typeof s.getSource != "function") {
      Ae.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
      return;
    }
    return i = Date.now(), s.getSource.call(t, a);
  }, l = function() {
    t.off("loadedmetadata", r), t.off("error", o), t.off("dispose", l);
  }, u = function(d) {
    l(), _1(t, d);
  };
  t.on("error", o), t.on("dispose", l), t.reloadSourceOnError = u;
}, VV = function(t) {
  _1(this, t);
};
var k1 = "3.17.0", qV = "7.1.0", HV = "1.3.1", WV = "7.2.0", YV = "4.0.2";
const ni = {
  PlaylistLoader: Da,
  Playlist: on,
  utils: Zz,
  STANDARD_PLAYLIST_SELECTOR: Vv,
  INITIAL_PLAYLIST_SELECTOR: RU,
  lastBandwidthSelector: Vv,
  movingAverageBandwidthSelector: LU,
  comparePlaylistBandwidth: wm,
  comparePlaylistResolution: BU,
  xhr: i1()
};
Object.keys(Si).forEach((t) => {
  Object.defineProperty(ni, t, {
    get() {
      return Ae.log.warn(`using Vhs.${t} is UNSAFE be sure you know what you are doing`), Si[t];
    },
    set(e) {
      if (Ae.log.warn(`using Vhs.${t} is UNSAFE be sure you know what you are doing`), typeof e != "number" || e < 0) {
        Ae.log.warn(`value of Vhs.${t} must be greater than or equal to 0`);
        return;
      }
      Si[t] = e;
    }
  });
});
const P1 = "videojs-vhs", I1 = function(t, e) {
  const i = e.media();
  let n = -1;
  for (let s = 0; s < t.length; s++)
    if (t[s].id === i.id) {
      n = s;
      break;
    }
  t.selectedIndex_ = n, t.trigger({
    selectedIndex: n,
    type: "change"
  });
}, XV = function(t, e) {
  e.representations().forEach((i) => {
    t.addQualityLevel(i);
  }), I1(t, e.playlists);
};
ni.canPlaySource = function() {
  return Ae.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
const jV = (t, e, i) => {
  if (!t)
    return t;
  let n = {};
  e && e.attributes && e.attributes.CODECS && (n = Ml(cs(e.attributes.CODECS))), i && i.attributes && i.attributes.CODECS && (n.audio = i.attributes.CODECS);
  const s = no(n.video), r = no(n.audio), a = {};
  for (const o in t)
    a[o] = {}, r && (a[o].audioContentType = r), s && (a[o].videoContentType = s), e.contentProtection && e.contentProtection[o] && e.contentProtection[o].pssh && (a[o].pssh = e.contentProtection[o].pssh), typeof t[o] == "string" && (a[o].url = t[o]);
  return _t(t, a);
}, GV = (t, e) => t.reduce((i, n) => {
  if (!n.contentProtection)
    return i;
  const s = e.reduce((r, a) => {
    const o = n.contentProtection[a];
    return o && o.pssh && (r[a] = {
      pssh: o.pssh
    }), r;
  }, {});
  return Object.keys(s).length && i.push(s), i;
}, []), QV = ({
  player: t,
  sourceKeySystems: e,
  audioMedia: i,
  mainPlaylists: n
}) => {
  if (!t.eme.initializeMediaKeys)
    return Promise.resolve();
  const s = i ? n.concat([i]) : n, r = GV(s, Object.keys(e)), a = [], o = [];
  return r.forEach((l) => {
    o.push(new Promise((u, d) => {
      t.tech_.one("keysessioncreated", u);
    })), a.push(new Promise((u, d) => {
      t.eme.initializeMediaKeys({
        keySystems: l
      }, (c) => {
        if (c) {
          d(c);
          return;
        }
        u();
      });
    }));
  }), Promise.race([
    // If a session was previously created, these will all finish resolving without
    // creating a new session, otherwise it will take until the end of all license
    // requests, which is why the key session check is used (to make setup much faster).
    Promise.all(a),
    // Once a single session is created, the browser knows DRM will be used.
    Promise.race(o)
  ]);
}, ZV = ({
  player: t,
  sourceKeySystems: e,
  media: i,
  audioMedia: n
}) => {
  const s = jV(e, i, n);
  return s ? (t.currentSource().keySystems = s, s && !t.eme ? (Ae.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1) : !0) : !1;
}, M1 = () => {
  if (!ne.localStorage)
    return null;
  const t = ne.localStorage.getItem(P1);
  if (!t)
    return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}, KV = (t) => {
  if (!ne.localStorage)
    return !1;
  let e = M1();
  e = e ? _t(e, t) : t;
  try {
    ne.localStorage.setItem(P1, JSON.stringify(e));
  } catch {
    return !1;
  }
  return e;
}, JV = (t) => t.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0 ? JSON.parse(t.substring(t.indexOf(",") + 1)) : t, O1 = (t, e) => {
  t._requestCallbackSet || (t._requestCallbackSet = /* @__PURE__ */ new Set()), t._requestCallbackSet.add(e);
}, B1 = (t, e) => {
  t._responseCallbackSet || (t._responseCallbackSet = /* @__PURE__ */ new Set()), t._responseCallbackSet.add(e);
}, L1 = (t, e) => {
  t._requestCallbackSet && (t._requestCallbackSet.delete(e), t._requestCallbackSet.size || delete t._requestCallbackSet);
}, N1 = (t, e) => {
  t._responseCallbackSet && (t._responseCallbackSet.delete(e), t._responseCallbackSet.size || delete t._responseCallbackSet);
};
ni.supportsNativeHls = function() {
  if (!Ne || !Ne.createElement)
    return !1;
  const t = Ne.createElement("video");
  return Ae.getTech("Html5").isSupported() ? [
    // Apple santioned
    "application/vnd.apple.mpegurl",
    // Apple sanctioned for backwards compatibility
    "audio/mpegurl",
    // Very common
    "audio/x-mpegurl",
    // Very common
    "application/x-mpegurl",
    // Included for completeness
    "video/x-mpegurl",
    "video/mpegurl",
    "application/mpegurl"
  ].some(function(i) {
    return /maybe|probably/i.test(t.canPlayType(i));
  }) : !1;
}();
ni.supportsNativeDash = function() {
  return !Ne || !Ne.createElement || !Ae.getTech("Html5").isSupported() ? !1 : /maybe|probably/i.test(Ne.createElement("video").canPlayType("application/dash+xml"));
}();
ni.supportsTypeNatively = (t) => t === "hls" ? ni.supportsNativeHls : t === "dash" ? ni.supportsNativeDash : !1;
ni.isSupported = function() {
  return Ae.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
ni.xhr.onRequest = function(t) {
  O1(ni.xhr, t);
};
ni.xhr.onResponse = function(t) {
  B1(ni.xhr, t);
};
ni.xhr.offRequest = function(t) {
  L1(ni.xhr, t);
};
ni.xhr.offResponse = function(t) {
  N1(ni.xhr, t);
};
const $V = Ae.getComponent("Component");
class R1 extends $V {
  constructor(e, i, n) {
    if (super(i, n.vhs), typeof n.initialBandwidth == "number" && (this.options_.bandwidth = n.initialBandwidth), this.logger_ = Fn("VhsHandler"), i.options_ && i.options_.playerId) {
      const s = Ae.getPlayer(i.options_.playerId);
      this.player_ = s;
    }
    if (this.tech_ = i, this.source_ = e, this.stats = {}, this.ignoreNextSeekingEvent_ = !1, this.setOptions_(), this.options_.overrideNative && i.overrideNativeAudioTracks && i.overrideNativeVideoTracks)
      i.overrideNativeAudioTracks(!0), i.overrideNativeVideoTracks(!0);
    else if (this.options_.overrideNative && (i.featuresNativeVideoTracks || i.featuresNativeAudioTracks))
      throw new Error("Overriding native VHS requires emulated tracks. See https://git.io/vMpjB");
    this.on(Ne, ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], (s) => {
      const r = Ne.fullscreenElement || Ne.webkitFullscreenElement || Ne.mozFullScreenElement || Ne.msFullscreenElement;
      r && r.contains(this.tech_.el()) ? this.playlistController_.fastQualityChange_() : this.playlistController_.checkABR_();
    }), this.on(this.tech_, "seeking", function() {
      if (this.ignoreNextSeekingEvent_) {
        this.ignoreNextSeekingEvent_ = !1;
        return;
      }
      this.setCurrentTime(this.tech_.currentTime());
    }), this.on(this.tech_, "error", function() {
      this.tech_.error() && this.playlistController_ && this.playlistController_.pauseLoading();
    }), this.on(this.tech_, "play", this.play);
  }
  /**
   * Set VHS options based on options from configuration, as well as partial
   * options to be passed at a later time.
   *
   * @param {Object} options A partial chunk of config options
   */
  setOptions_(e = {}) {
    if (this.options_ = _t(this.options_, e), this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.usePlayerObjectFit = this.options_.usePlayerObjectFit || !1, this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage < "u" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || !1, this.options_.useForcedSubtitles = this.options_.useForcedSubtitles || !1, this.options_.useNetworkInformationApi = typeof this.options_.useNetworkInformationApi < "u" ? this.options_.useNetworkInformationApi : !0, this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, this.options_.llhls = this.options_.llhls !== !1, this.options_.bufferBasedABR = this.options_.bufferBasedABR || !1, typeof this.options_.playlistExclusionDuration != "number" && (this.options_.playlistExclusionDuration = 60), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
      const n = M1();
      n && n.bandwidth && (this.options_.bandwidth = n.bandwidth, this.tech_.trigger({
        type: "usage",
        name: "vhs-bandwidth-from-local-storage"
      })), n && n.throughput && (this.options_.throughput = n.throughput, this.tech_.trigger({
        type: "usage",
        name: "vhs-throughput-from-local-storage"
      }));
    }
    typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = Si.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Si.INITIAL_BANDWIDTH, ["withCredentials", "useDevicePixelRatio", "usePlayerObjectFit", "customPixelRatio", "limitRenditionByPlayerDimensions", "bandwidth", "customTagParsers", "customTagMappers", "cacheEncryptionKeys", "playlistSelector", "initialPlaylistSelector", "bufferBasedABR", "liveRangeSafeTimeDelta", "llhls", "useForcedSubtitles", "useNetworkInformationApi", "useDtsForTimestampOffset", "exactManifestTimings", "leastPixelDiffSelector"].forEach((n) => {
      typeof this.source_[n] < "u" && (this.options_[n] = this.source_[n]);
    }), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio, this.usePlayerObjectFit = this.options_.usePlayerObjectFit;
    const i = this.options_.customPixelRatio;
    typeof i == "number" && i >= 0 && (this.customPixelRatio = i);
  }
  // alias for public method to set options
  setOptions(e = {}) {
    this.setOptions_(e);
  }
  /**
   * called when player.src gets called, handle a new source
   *
   * @param {Object} src the source object to handle
   */
  src(e, i) {
    if (!e)
      return;
    this.setOptions_(), this.options_.src = JV(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = ni, this.options_.sourceType = rb(i), this.options_.seekTo = (r) => {
      this.tech_.setCurrentTime(r);
    }, this.options_.player_ = this.player_, this.playlistController_ = new LV(this.options_);
    const n = _t({
      liveRangeSafeTimeDelta: bs
    }, this.options_, {
      seekable: () => this.seekable(),
      media: () => this.playlistController_.media(),
      playlistController: this.playlistController_
    });
    this.playbackWatcher_ = new zV(n), this.attachStreamingEventListeners_(), this.playlistController_.on("error", () => {
      const r = Ae.players[this.tech_.options_.playerId];
      let a = this.playlistController_.error;
      typeof a == "object" && !a.code ? a.code = 3 : typeof a == "string" && (a = {
        message: a,
        code: 3
      }), r.error(a);
    });
    const s = this.options_.bufferBasedABR ? ni.movingAverageBandwidthSelector(0.55) : ni.STANDARD_PLAYLIST_SELECTOR;
    this.playlistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : s.bind(this), this.playlistController_.selectInitialPlaylist = ni.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.playlistController_.mainPlaylistLoader_, this.mediaSource = this.playlistController_.mediaSource, Object.defineProperties(this, {
      selectPlaylist: {
        get() {
          return this.playlistController_.selectPlaylist;
        },
        set(r) {
          this.playlistController_.selectPlaylist = r.bind(this);
        }
      },
      throughput: {
        get() {
          return this.playlistController_.mainSegmentLoader_.throughput.rate;
        },
        set(r) {
          this.playlistController_.mainSegmentLoader_.throughput.rate = r, this.playlistController_.mainSegmentLoader_.throughput.count = 1;
        }
      },
      bandwidth: {
        get() {
          let r = this.playlistController_.mainSegmentLoader_.bandwidth;
          const a = ne.navigator.connection || ne.navigator.mozConnection || ne.navigator.webkitConnection, o = 1e7;
          if (this.options_.useNetworkInformationApi && a) {
            const l = a.downlink * 1e3 * 1e3;
            l >= o && r >= o ? r = Math.max(r, l) : r = l;
          }
          return r;
        },
        set(r) {
          this.playlistController_.mainSegmentLoader_.bandwidth = r, this.playlistController_.mainSegmentLoader_.throughput = {
            rate: 0,
            count: 0
          };
        }
      },
      /**
       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
       * the entire process after that - decryption, transmuxing, and appending - provided
       * by `throughput`.
       *
       * Since the two process are serial, the overall system bandwidth is given by:
       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
       */
      systemBandwidth: {
        get() {
          const r = 1 / (this.bandwidth || 1);
          let a;
          return this.throughput > 0 ? a = 1 / this.throughput : a = 0, Math.floor(1 / (r + a));
        },
        set() {
          Ae.log.error('The "systemBandwidth" property is read-only');
        }
      }
    }), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
      bandwidth: {
        get: () => this.bandwidth || 0,
        enumerable: !0
      },
      mediaRequests: {
        get: () => this.playlistController_.mediaRequests_() || 0,
        enumerable: !0
      },
      mediaRequestsAborted: {
        get: () => this.playlistController_.mediaRequestsAborted_() || 0,
        enumerable: !0
      },
      mediaRequestsTimedout: {
        get: () => this.playlistController_.mediaRequestsTimedout_() || 0,
        enumerable: !0
      },
      mediaRequestsErrored: {
        get: () => this.playlistController_.mediaRequestsErrored_() || 0,
        enumerable: !0
      },
      mediaTransferDuration: {
        get: () => this.playlistController_.mediaTransferDuration_() || 0,
        enumerable: !0
      },
      mediaBytesTransferred: {
        get: () => this.playlistController_.mediaBytesTransferred_() || 0,
        enumerable: !0
      },
      mediaSecondsLoaded: {
        get: () => this.playlistController_.mediaSecondsLoaded_() || 0,
        enumerable: !0
      },
      mediaAppends: {
        get: () => this.playlistController_.mediaAppends_() || 0,
        enumerable: !0
      },
      mainAppendsToLoadedData: {
        get: () => this.playlistController_.mainAppendsToLoadedData_() || 0,
        enumerable: !0
      },
      audioAppendsToLoadedData: {
        get: () => this.playlistController_.audioAppendsToLoadedData_() || 0,
        enumerable: !0
      },
      appendsToLoadedData: {
        get: () => this.playlistController_.appendsToLoadedData_() || 0,
        enumerable: !0
      },
      timeToLoadedData: {
        get: () => this.playlistController_.timeToLoadedData_() || 0,
        enumerable: !0
      },
      buffered: {
        get: () => qr(this.tech_.buffered()),
        enumerable: !0
      },
      currentTime: {
        get: () => this.tech_.currentTime(),
        enumerable: !0
      },
      currentSource: {
        get: () => this.tech_.currentSource_,
        enumerable: !0
      },
      currentTech: {
        get: () => this.tech_.name_,
        enumerable: !0
      },
      duration: {
        get: () => this.tech_.duration(),
        enumerable: !0
      },
      main: {
        get: () => this.playlists.main,
        enumerable: !0
      },
      playerDimensions: {
        get: () => this.tech_.currentDimensions(),
        enumerable: !0
      },
      seekable: {
        get: () => qr(this.tech_.seekable()),
        enumerable: !0
      },
      timestamp: {
        get: () => Date.now(),
        enumerable: !0
      },
      videoPlaybackQuality: {
        get: () => this.tech_.getVideoPlaybackQuality(),
        enumerable: !0
      }
    }), this.tech_.one("canplay", this.playlistController_.setupFirstPlay.bind(this.playlistController_)), this.tech_.on("bandwidthupdate", () => {
      this.options_.useBandwidthFromLocalStorage && KV({
        bandwidth: this.bandwidth,
        throughput: Math.round(this.throughput)
      });
    }), this.playlistController_.on("selectedinitialmedia", () => {
      FV(this);
    }), this.playlistController_.sourceUpdater_.on("createdsourcebuffers", () => {
      this.setupEme_();
    }), this.on(this.playlistController_, "progress", function() {
      this.tech_.trigger("progress");
    }), this.on(this.playlistController_, "firstplay", function() {
      this.ignoreNextSeekingEvent_ = !0;
    }), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = ne.URL.createObjectURL(this.playlistController_.mediaSource), (Ae.browser.IS_ANY_SAFARI || Ae.browser.IS_IOS) && this.options_.overrideNative && this.options_.sourceType === "hls" && typeof this.tech_.addSourceElement == "function" ? (this.tech_.addSourceElement(this.mediaSourceUrl_), this.tech_.addSourceElement(this.source_.src)) : this.tech_.src(this.mediaSourceUrl_));
  }
  createKeySessions_() {
    const e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
    this.logger_("waiting for EME key session creation"), QV({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      audioMedia: e && e.media(),
      mainPlaylists: this.playlists.main.playlists
    }).then(() => {
      this.logger_("created EME key session"), this.playlistController_.sourceUpdater_.initializedEme();
    }).catch((i) => {
      this.logger_("error while creating EME key session", i), this.player_.error({
        message: "Failed to initialize media keys for EME",
        code: 3
      });
    });
  }
  handleWaitingForKey_() {
    this.logger_("waitingforkey fired, attempting to create any new key sessions"), this.createKeySessions_();
  }
  /**
   * If necessary and EME is available, sets up EME options and waits for key session
   * creation.
   *
   * This function also updates the source updater so taht it can be used, as for some
   * browsers, EME must be configured before content is appended (if appending unencrypted
   * content before encrypted content).
   */
  setupEme_() {
    const e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader, i = ZV({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      media: this.playlists.media(),
      audioMedia: e && e.media()
    });
    if (this.player_.tech_.on("keystatuschange", (n) => {
      this.playlistController_.updatePlaylistByKeyStatus(n.keyId, n.status);
    }), this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this), this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_), !i) {
      this.playlistController_.sourceUpdater_.initializedEme();
      return;
    }
    this.createKeySessions_();
  }
  /**
   * Initializes the quality levels and sets listeners to update them.
   *
   * @method setupQualityLevels_
   * @private
   */
  setupQualityLevels_() {
    const e = Ae.players[this.tech_.options_.playerId];
    !e || !e.qualityLevels || this.qualityLevels_ || (this.qualityLevels_ = e.qualityLevels(), this.playlistController_.on("selectedinitialmedia", () => {
      XV(this.qualityLevels_, this);
    }), this.playlists.on("mediachange", () => {
      I1(this.qualityLevels_, this.playlists);
    }));
  }
  /**
   * return the version
   */
  static version() {
    return {
      "@videojs/http-streaming": k1,
      "mux.js": qV,
      "mpd-parser": HV,
      "m3u8-parser": WV,
      "aes-decrypter": YV
    };
  }
  /**
   * return the version
   */
  version() {
    return this.constructor.version();
  }
  canChangeType() {
    return S1.canChangeType();
  }
  /**
   * Begin playing the video.
   */
  play() {
    this.playlistController_.play();
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  setCurrentTime(e) {
    this.playlistController_.setCurrentTime(e);
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  duration() {
    return this.playlistController_.duration();
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  seekable() {
    return this.playlistController_.seekable();
  }
  /**
   * Abort all outstanding work and cleanup.
   */
  dispose() {
    this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.playlistController_ && this.playlistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.mediaSourceUrl_ && ne.URL.revokeObjectURL && (ne.URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), this.tech_ && this.tech_.off("waitingforkey", this.handleWaitingForKey_), super.dispose();
  }
  convertToProgramTime(e, i) {
    return nU({
      playlist: this.playlistController_.media(),
      time: e,
      callback: i
    });
  }
  // the player must be playing before calling this
  seekToProgramTime(e, i, n = !0, s = 2) {
    return o1({
      programTime: e,
      playlist: this.playlistController_.media(),
      retryCount: s,
      pauseAfterSeek: n,
      seekTo: this.options_.seekTo,
      tech: this.options_.tech,
      callback: i
    });
  }
  /**
   * Adds the onRequest, onResponse, offRequest and offResponse functions
   * to the VhsHandler xhr Object.
   */
  setupXhrHooks_() {
    this.xhr.onRequest = (e) => {
      O1(this.xhr, e);
    }, this.xhr.onResponse = (e) => {
      B1(this.xhr, e);
    }, this.xhr.offRequest = (e) => {
      L1(this.xhr, e);
    }, this.xhr.offResponse = (e) => {
      N1(this.xhr, e);
    }, this.player_.trigger("xhr-hooks-ready");
  }
  attachStreamingEventListeners_() {
    const e = ["seekablerangeschanged", "bufferedrangeschanged", "contentsteeringloadstart", "contentsteeringloadcomplete", "contentsteeringparsed"], i = ["gapjumped", "playedrangeschanged"];
    e.forEach((n) => {
      this.playlistController_.on(n, (s) => {
        this.player_.trigger(pi({}, s));
      });
    }), i.forEach((n) => {
      this.playbackWatcher_.on(n, (s) => {
        this.player_.trigger(pi({}, s));
      });
    });
  }
}
const Pd = {
  name: "videojs-http-streaming",
  VERSION: k1,
  canHandleSource(t, e = {}) {
    const i = _t(Ae.options, e);
    return !i.vhs.experimentalUseMMS && !Al("avc1.4d400d,mp4a.40.2", !1) ? !1 : Pd.canPlayType(t.type, i);
  },
  handleSource(t, e, i = {}) {
    const n = _t(Ae.options, i);
    return e.vhs = new R1(t, e, n), e.vhs.xhr = i1(), e.vhs.setupXhrHooks_(), e.vhs.src(t.src, t.type), e.vhs;
  },
  canPlayType(t, e) {
    const i = rb(t);
    if (!i)
      return "";
    const n = Pd.getOverrideNative(e);
    return !ni.supportsTypeNatively(i) || n ? "maybe" : "";
  },
  getOverrideNative(t = {}) {
    const {
      vhs: e = {}
    } = t, i = !(Ae.browser.IS_ANY_SAFARI || Ae.browser.IS_IOS), {
      overrideNative: n = i
    } = e;
    return n;
  }
}, eq = () => Al("avc1.4d400d,mp4a.40.2", !0);
eq() && Ae.getTech("Html5").registerSourceHandler(Pd, 0);
Ae.VhsHandler = R1;
Ae.VhsSourceHandler = Pd;
Ae.Vhs = ni;
Ae.use || Ae.registerComponent("Vhs", ni);
Ae.options.vhs = Ae.options.vhs || {};
(!Ae.getPlugin || !Ae.getPlugin("reloadSourceOnError")) && Ae.registerPlugin("reloadSourceOnError", VV);
const F1 = /* @__PURE__ */ qe({
  __name: "UiGalleryVideo",
  props: {
    files: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    const e = t, i = pe(null), n = pe(null);
    return It(() => {
      i.value instanceof HTMLVideoElement && e.files && e.files.length && (n.value = Ae(
        i.value,
        {
          controls: !0,
          preload: "auto",
          sources: e.files
        }
      ));
    }), Ol(() => {
      n.value && n.value.dispose();
    }), (s, r) => (k(), U("video", {
      ref_key: "videoPlayerRef",
      ref: i,
      class: "video-js",
      "data-setup": { nativeControlsForTouch: !0 }
    }, r[0] || (r[0] = [
      re("p", { class: "vjs-no-js" }, " Для просмотра этого видео, включите JavaScript, или используйте другой браузер. ", -1)
    ]), 512));
  }
}), tq = ["alt", "src"], iq = ["innerHTML"], nq = /* @__PURE__ */ qe({
  __name: "UiGalleryContent",
  props: {
    slide: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    return (e, i) => (k(), U("swiper-slide", {
      class: we(["ui-gallery-content", { "swiper-no-swiping": Y(Fp)(t.slide) }])
    }, [
      Y($y)(t.slide) ? (k(), U("img", {
        key: 0,
        alt: t.slide.alt,
        src: t.slide.preview
      }, null, 8, tq)) : Y(Np)(t.slide) ? (k(), U("div", {
        key: 1,
        innerHTML: t.slide.iframe
      }, null, 8, iq)) : Y(Rp)(t.slide) ? (k(), Ce(F1, {
        key: 2,
        files: t.slide.files
      }, null, 8, ["files"])) : ie("", !0)
    ], 2));
  }
}), sq = { class: "ui-gallery-miniature" }, rq = ["src"], aq = /* @__PURE__ */ qe({
  __name: "UiGalleryMiniature",
  props: {
    miniature: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    return (e, i) => (k(), U("swiper-slide", sq, [
      re("div", {
        class: we(["ui-gallery-miniature__box", {
          "ui-gallery-miniature__box_media": Y(X5)(t.miniature)
        }])
      }, [
        t.miniature.preview ? (k(), U("img", {
          key: 0,
          alt: "miniature picture",
          src: t.miniature.preview
        }, null, 8, rq)) : ie("", !0)
      ], 2),
      Y(Fp)(t.miniature) ? (k(), Ce(Y(sC), { key: 0 })) : ie("", !0)
    ]));
  }
}), oq = {
  navigation: {
    nextEl: ".swiper-button_next",
    prevEl: ".swiper-button_prev"
  },
  effect: "fade",
  fadeEffect: {
    crossFade: !0
  },
  spaceBetween: 30,
  thumbs: {
    swiper: ".ui-gallery__thumb"
  },
  noSwipingClass: "swiper-no-swiping"
}, lq = {
  freeMode: !0,
  watchSlidesProgress: !0,
  slidesPerView: "auto",
  spaceBetween: 4,
  slidesOffsetBefore: 32,
  slidesOffsetAfter: 32,
  centerInsufficientSlides: !0
}, uq = { class: "ui-gallery" }, dq = { class: "ui-gallery__header" }, cq = { class: "ui-gallery__container" }, fq = {
  slot: "container-start",
  class: "swiper-button swiper-button_prev"
}, hq = { class: "swiper-button__box" }, pq = ["initial-slide"], mq = {
  slot: "container-start",
  class: "swiper-button swiper-button_next"
}, Aq = { class: "swiper-button__box" }, gq = { class: "ui-gallery__thumb-container" }, vq = /* @__PURE__ */ qe({
  name: "UiGallery",
  __name: "UiGallery",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    initialSlide: {
      type: Number,
      default: 0
    }
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const i = t, n = e, s = pe(null), r = pe(null), a = J(
      () => i.items.filter(
        ({ type: o }) => o === "image" || o === "iframe" || o === "video"
      )
    );
    return L2(() => {
      Jy();
    }), Ol(() => {
      var o, l;
      (o = s.value) == null || o.swiper.destroy(), (l = r.value) == null || l.swiper.destroy();
    }), (o, l) => (k(), Ce(br, { to: "body" }, [
      re("div", uq, [
        re("div", dq, [
          re("button", {
            type: "button",
            onClick: l[0] || (l[0] = (u) => n("close"))
          }, [
            ke(Y(na))
          ])
        ]),
        re("div", cq, [
          re("div", fq, [
            re("div", hq, [
              l[1] || (l[1] = re("div", { class: "swiper-button__background" }, null, -1)),
              ke(Y(Bd))
            ])
          ]),
          re("swiper-container", Ut({
            ref_key: "swiperContentRef",
            ref: s
          }, Y(oq), {
            "initial-slide": i.initialSlide
          }), [
            (k(!0), U(Xe, null, ut(a.value, (u, d) => (k(), Ce(nq, {
              key: d,
              slide: u
            }, null, 8, ["slide"]))), 128))
          ], 16, pq),
          re("div", mq, [
            re("div", Aq, [
              l[2] || (l[2] = re("div", { class: "swiper-button__background" }, null, -1)),
              ke(Y(Bl))
            ])
          ])
        ]),
        re("div", gq, [
          re("swiper-container", Ut({
            ref_key: "swiperThumbsRes",
            ref: r,
            class: "ui-gallery__thumb"
          }, Y(lq)), [
            (k(!0), U(Xe, null, ut(a.value, (u, d) => (k(), Ce(aq, {
              key: d,
              miniature: u
            }, null, 8, ["miniature"]))), 128))
          ], 16)
        ])
      ])
    ]));
  }
}), yq = { class: "ui-carousel-item" }, bq = ["alt", "src"], wq = ["innerHTML"], Tq = /* @__PURE__ */ qe({
  name: "UiCarouselItem",
  __name: "UiCarouselItem",
  props: {
    slide: {
      type: Object,
      default: null
    }
  },
  emits: ["openGallery"],
  setup(t, { emit: e }) {
    const i = e, n = () => {
      i("openGallery");
    }, s = s0("isGallery");
    return (r, a) => (k(), U("swiper-slide", yq, [
      Se(r.$slots, "default"),
      t.slide ? (k(), U(Xe, { key: 0 }, [
        Y($y)(t.slide) ? (k(), U("img", {
          key: 0,
          alt: t.slide.alt,
          src: t.slide.preview
        }, null, 8, bq)) : Y(Np)(t.slide) ? (k(), U("div", {
          key: 1,
          innerHTML: t.slide.iframe
        }, null, 8, wq)) : Y(Rp)(t.slide) ? (k(), Ce(F1, {
          key: 2,
          files: t.slide.files
        }, null, 8, ["files"])) : ie("", !0)
      ], 64)) : ie("", !0),
      Y(s) ? (k(), U("div", {
        key: 1,
        class: "ui-carousel-item__layer layer",
        onClick: n
      }, [
        a[0] || (a[0] = re("div", { class: "layer__shadow" }, null, -1)),
        ke(Y(wx), { class: "layer__icon" })
      ])) : ie("", !0)
    ]));
  }
}), xq = { class: "ui-carousel" }, Sq = { class: "ui-carousel__container" }, Cq = {
  slot: "container-start",
  class: "swiper-button swiper-button_prev"
}, Eq = {
  slot: "container-start",
  class: "swiper-button swiper-button_next"
}, Dq = 16, lH = /* @__PURE__ */ qe({
  name: "UiCarousel",
  __name: "UiCarousel",
  props: {
    height: {
      type: Number,
      default: 300
    },
    autoPlay: {
      type: Boolean,
      default: !1
    },
    autoPlayDelay: {
      type: Number,
      default: 5e3
    },
    speed: {
      type: Number,
      default: 4e3
    },
    gallery: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    Md((w) => ({
      "0896604d": a.value,
      "48942ca4": h.value
    }));
    const e = t, i = pe(!1), n = pe(0), { gallery: s } = jh(e), r = Yi(), a = J(() => `${e.height}px`);
    Jy();
    const o = pe(null), l = (w) => {
      i.value = w ?? !i.value;
    }, u = (w) => {
      o.value.swiper.params.autoplay.delay = w;
    }, d = (w) => {
      w ? (u(e.autoPlayDelay), c(e.speed), o.value.swiper.autoplay.start()) : o.value.swiper.autoplay.stop();
    }, c = (w) => {
      o.value.swiper.params.speed = w;
    }, A = (w) => {
      o.value && (w(), o.value.swiper.update());
    }, m = (w) => {
      n.value = w, l(!0);
    }, p = {
      rewind: !0,
      navigation: {
        nextEl: ".swiper-button_next",
        prevEl: ".swiper-button_prev"
      },
      pagination: {
        el: ".swiper-custom-pagination",
        clickable: !0,
        renderBullet: (w, b) => `
        <div class='swiper-custom-pagination__button ${b}'>
          <div class='swiper-custom-pagination__line-box'>
            <div class='swiper-custom-pagination__line'></div>
            <div class='swiper-custom-pagination__line-animate'></div>
          </div>
        </div>
      `
      },
      spaceBetween: Dq,
      injectStyles: ["swiper/element/css/navigation"]
    };
    mt(
      () => e.autoPlay,
      (w) => {
        A(() => d(w));
      }
    ), mt(
      () => e.autoPlayDelay,
      (w) => {
        A(() => u(w));
      },
      { immediate: !0 }
    ), mt(
      () => e.speed,
      (w) => {
        A(() => c(w));
      }
    ), It(() => {
      o.value && (Object.assign(o.value, p), o.value.initialize());
    }), Ol(() => {
      var w, b;
      o.value && ((b = (w = o.value) == null ? void 0 : w.swiper) == null || b.destroy());
    });
    const h = J(() => `${e.autoPlayDelay}ms`), g = J(() => !!r.default);
    return N2("isGallery", s), (w, b) => (k(), U(Xe, null, [
      re("div", xq, [
        re("div", Sq, [
          re("swiper-container", {
            ref_key: "swiperRef",
            ref: o,
            init: !1
          }, [
            g.value ? Se(w.$slots, "default", { key: 0 }) : (k(!0), U(Xe, { key: 1 }, ut(t.items, (y, D) => (k(), Ce(Tq, {
              key: D,
              slide: y,
              onOpenGallery: (I) => m(D)
            }, null, 8, ["slide", "onOpenGallery"]))), 128))
          ], 512),
          re("div", Cq, [
            ke(Y(Bd))
          ]),
          re("div", Eq, [
            ke(Y(Bl))
          ])
        ]),
        re("div", {
          slot: "container-end",
          class: we(["swiper-custom-pagination", { "swiper-custom-pagination_autoplay": t.autoPlay }])
        }, null, 2)
      ]),
      i.value ? (k(), Ce(vq, {
        key: 0,
        items: t.items,
        "initial-slide": n.value,
        onClose: b[0] || (b[0] = (y) => l(!1))
      }, null, 8, ["items", "initial-slide"])) : ie("", !0)
    ], 64));
  }
}), uH = {
  mounted(t, { value: e }) {
    var a;
    const i = document.createElement("div");
    i.style.position = "relative", i.style.display = "block";
    const n = {
      position: t.style.position,
      visibility: t.style.visibility,
      opacity: t.style.opacity,
      pointerEvents: t.style.pointerEvents
    };
    (a = t.parentNode) == null || a.insertBefore(i, t), i.appendChild(t);
    const s = () => {
      const o = ke(RB, {
        type: "card",
        style: {
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          zIndex: 1
        }
      }), l = document.createElement("div");
      return l.style.position = "absolute", l.style.inset = "0", $f(o, l), l;
    };
    t._skeleton = s(), i.appendChild(t._skeleton), t._resizeObserver = new ResizeObserver(() => {
      if (t._skeleton) {
        const o = t.getBoundingClientRect();
        t._skeleton.style.width = `${o.width}px`, t._skeleton.style.height = `${o.height}px`;
      }
    }), ((o) => {
      o ? (t.style.opacity = "0", t.style.pointerEvents = "none", t._skeleton.style.display = "block") : (t.style.opacity = "1", t.style.pointerEvents = "auto", t._skeleton.style.display = "none");
    })(e), t._resizeObserver.observe(t), t._wrapper = i, t._originalStyles = n;
  },
  updated(t, { value: e }) {
    t.style.opacity = e ? "0" : "1", t.style.pointerEvents = e ? "none" : "auto", t._skeleton.style.display = e ? "block" : "none";
  },
  unmounted(t) {
    var e;
    if (t._wrapper) {
      const i = t._wrapper.parentNode;
      i == null || i.insertBefore(t, t._wrapper), i == null || i.removeChild(t._wrapper);
    }
    (e = t._resizeObserver) == null || e.disconnect(), delete t._skeleton, delete t._wrapper;
  }
};
export {
  oH as TransitionOpacity,
  nH as UiAccordion,
  Iq as UiAppButton,
  qq as UiAvatar,
  f_ as UiBadge,
  op as UiBottomSheet,
  $r as UiButton,
  lH as UiCarousel,
  Tq as UiCarouselItem,
  mA as UiCheckbox,
  c0 as UiChip,
  B0 as UiCloseButton,
  Oq as UiCounter,
  sH as UiDatePicker,
  $q as UiDrawer,
  Rl as UiDropdown,
  OA as UiDropdownItem,
  eH as UiDropzone,
  tH as UiFile,
  Gq as UiFileCard,
  vq as UiGallery,
  Fd as UiHint,
  EA as UiIconButton,
  iH as UiImageUploader,
  zd as UiInput,
  Hq as UiInputPhone,
  Wq as UiInputSearch,
  Bq as UiLink,
  Jq as UiList,
  Ud as UiLocalButton,
  Qq as UiModal,
  Mq as UiMultipleCheckbox,
  aH as UiMultipleSelect,
  Kq as UiNotFoundPage,
  Lq as UiNotification,
  Yq as UiPagination,
  II as UiProgressBar,
  Nq as UiRadioButton,
  Rq as UiSegmentedControl,
  rH as UiSelect,
  RB as UiSkeleton,
  Vq as UiSlider,
  DI as UiSnackbar,
  Xq as UiSnackbarGroup,
  Zq as UiStepper,
  Fq as UiSwitch,
  IP as UiTab,
  zq as UiTabs,
  ja as UiTextButton,
  Uq as UiTextarea,
  aa as UiTooltip,
  uH as vSkeleton
};
